(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/ 	function hotDisposeChunk(chunkId) {
/******/ 		delete installedChunks[chunkId];
/******/ 	}
/******/ 	var parentHotUpdateCallback = window["webpackHotUpdate"];
/******/ 	window["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	} ;
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		;
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(requestTimeout) { // eslint-disable-line no-unused-vars
/******/ 		requestTimeout = requestTimeout || 10000;
/******/ 		return new Promise(function(resolve, reject) {
/******/ 			if(typeof XMLHttpRequest === "undefined")
/******/ 				return reject(new Error("No browser support"));
/******/ 			try {
/******/ 				var request = new XMLHttpRequest();
/******/ 				var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 				request.open("GET", requestPath, true);
/******/ 				request.timeout = requestTimeout;
/******/ 				request.send(null);
/******/ 			} catch(err) {
/******/ 				return reject(err);
/******/ 			}
/******/ 			request.onreadystatechange = function() {
/******/ 				if(request.readyState !== 4) return;
/******/ 				if(request.status === 0) {
/******/ 					// timeout
/******/ 					reject(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 				} else if(request.status === 404) {
/******/ 					// no update available
/******/ 					resolve();
/******/ 				} else if(request.status !== 200 && request.status !== 304) {
/******/ 					// other failure
/******/ 					reject(new Error("Manifest request to " + requestPath + " failed."));
/******/ 				} else {
/******/ 					// success
/******/ 					try {
/******/ 						var update = JSON.parse(request.responseText);
/******/ 					} catch(e) {
/******/ 						reject(e);
/******/ 						return;
/******/ 					}
/******/ 					resolve(update);
/******/ 				}
/******/ 			};
/******/ 		});
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "ab01c84a4291907f41a4"; // eslint-disable-line no-unused-vars
/******/ 	var hotRequestTimeout = 10000;
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentChildModule; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParentsTemp = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 				} else {
/******/ 					hotCurrentParents = [moduleId];
/******/ 					hotCurrentChildModule = request;
/******/ 				}
/******/ 				if(me.children.indexOf(request) < 0)
/******/ 					me.children.push(request);
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		var ObjectFactory = function ObjectFactory(name) {
/******/ 			return {
/******/ 				configurable: true,
/******/ 				enumerable: true,
/******/ 				get: function() {
/******/ 					return __webpack_require__[name];
/******/ 				},
/******/ 				set: function(value) {
/******/ 					__webpack_require__[name] = value;
/******/ 				}
/******/ 			};
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name) && name !== "e") {
/******/ 				Object.defineProperty(fn, name, ObjectFactory(name));
/******/ 			}
/******/ 		}
/******/ 		fn.e = function(chunkId) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			return __webpack_require__.e(chunkId).then(finishChunkLoading, function(err) {
/******/ 				finishChunkLoading();
/******/ 				throw err;
/******/ 			});
/******/ 	
/******/ 			function finishChunkLoading() {
/******/ 				hotChunksLoading--;
/******/ 				if(hotStatus === "prepare") {
/******/ 					if(!hotWaitingFilesMap[chunkId]) {
/******/ 						hotEnsureUpdateChunk(chunkId);
/******/ 					}
/******/ 					if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 						hotUpdateDownloaded();
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 			_main: hotCurrentChildModule !== moduleId,
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback || function() {};
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback || function() {};
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 				else
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		hotCurrentChildModule = undefined;
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailableFilesMap = {};
/******/ 	var hotDeferred;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		hotApplyOnUpdate = apply;
/******/ 		hotSetStatus("check");
/******/ 		return hotDownloadManifest(hotRequestTimeout).then(function(update) {
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				return null;
/******/ 			}
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			hotAvailableFilesMap = update.c;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			var promise = new Promise(function(resolve, reject) {
/******/ 				hotDeferred = {
/******/ 					resolve: resolve,
/******/ 					reject: reject
/******/ 				};
/******/ 			});
/******/ 			hotUpdate = {};
/******/ 			for(var chunkId in installedChunks)
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 			return promise;
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailableFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailableFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var deferred = hotDeferred;
/******/ 		hotDeferred = null;
/******/ 		if(!deferred) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			// Wrap deferred object in Promise to mark it as a well-handled Promise to
/******/ 			// avoid triggering uncaught exception warning in Chrome.
/******/ 			// See https://bugs.chromium.org/p/chromium/issues/detail?id=465666
/******/ 			Promise.resolve().then(function() {
/******/ 				return hotApply(hotApplyOnUpdate);
/******/ 			}).then(
/******/ 				function(result) {
/******/ 					deferred.resolve(result);
/******/ 				},
/******/ 				function(err) {
/******/ 					deferred.reject(err);
/******/ 				}
/******/ 			);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			deferred.resolve(outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		options = options || {};
/******/ 	
/******/ 		var cb;
/******/ 		var i;
/******/ 		var j;
/******/ 		var module;
/******/ 		var moduleId;
/******/ 	
/******/ 		function getAffectedStuff(updateModuleId) {
/******/ 			var outdatedModules = [updateModuleId];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice().map(function(id) {
/******/ 				return {
/******/ 					chain: [id],
/******/ 					id: id
/******/ 				};
/******/ 			});
/******/ 			while(queue.length > 0) {
/******/ 				var queueItem = queue.pop();
/******/ 				var moduleId = queueItem.id;
/******/ 				var chain = queueItem.chain;
/******/ 				module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return {
/******/ 						type: "self-declined",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				if(module.hot._main) {
/******/ 					return {
/******/ 						type: "unaccepted",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(!parent) continue;
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return {
/******/ 							type: "declined",
/******/ 							chain: chain.concat([parentId]),
/******/ 							moduleId: moduleId,
/******/ 							parentId: parentId
/******/ 						};
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push({
/******/ 						chain: chain.concat([parentId]),
/******/ 						id: parentId
/******/ 					});
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return {
/******/ 				type: "accepted",
/******/ 				moduleId: updateModuleId,
/******/ 				outdatedModules: outdatedModules,
/******/ 				outdatedDependencies: outdatedDependencies
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 	
/******/ 		var warnUnexpectedRequire = function warnUnexpectedRequire() {
/******/ 			console.warn("[HMR] unexpected require(" + result.moduleId + ") to disposed module");
/******/ 		};
/******/ 	
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				moduleId = toModuleId(id);
/******/ 				var result;
/******/ 				if(hotUpdate[id]) {
/******/ 					result = getAffectedStuff(moduleId);
/******/ 				} else {
/******/ 					result = {
/******/ 						type: "disposed",
/******/ 						moduleId: id
/******/ 					};
/******/ 				}
/******/ 				var abortError = false;
/******/ 				var doApply = false;
/******/ 				var doDispose = false;
/******/ 				var chainInfo = "";
/******/ 				if(result.chain) {
/******/ 					chainInfo = "\nUpdate propagation: " + result.chain.join(" -> ");
/******/ 				}
/******/ 				switch(result.type) {
/******/ 					case "self-declined":
/******/ 						if(options.onDeclined)
/******/ 							options.onDeclined(result);
/******/ 						if(!options.ignoreDeclined)
/******/ 							abortError = new Error("Aborted because of self decline: " + result.moduleId + chainInfo);
/******/ 						break;
/******/ 					case "declined":
/******/ 						if(options.onDeclined)
/******/ 							options.onDeclined(result);
/******/ 						if(!options.ignoreDeclined)
/******/ 							abortError = new Error("Aborted because of declined dependency: " + result.moduleId + " in " + result.parentId + chainInfo);
/******/ 						break;
/******/ 					case "unaccepted":
/******/ 						if(options.onUnaccepted)
/******/ 							options.onUnaccepted(result);
/******/ 						if(!options.ignoreUnaccepted)
/******/ 							abortError = new Error("Aborted because " + moduleId + " is not accepted" + chainInfo);
/******/ 						break;
/******/ 					case "accepted":
/******/ 						if(options.onAccepted)
/******/ 							options.onAccepted(result);
/******/ 						doApply = true;
/******/ 						break;
/******/ 					case "disposed":
/******/ 						if(options.onDisposed)
/******/ 							options.onDisposed(result);
/******/ 						doDispose = true;
/******/ 						break;
/******/ 					default:
/******/ 						throw new Error("Unexception type " + result.type);
/******/ 				}
/******/ 				if(abortError) {
/******/ 					hotSetStatus("abort");
/******/ 					return Promise.reject(abortError);
/******/ 				}
/******/ 				if(doApply) {
/******/ 					appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 					addAllToSet(outdatedModules, result.outdatedModules);
/******/ 					for(moduleId in result.outdatedDependencies) {
/******/ 						if(Object.prototype.hasOwnProperty.call(result.outdatedDependencies, moduleId)) {
/******/ 							if(!outdatedDependencies[moduleId])
/******/ 								outdatedDependencies[moduleId] = [];
/******/ 							addAllToSet(outdatedDependencies[moduleId], result.outdatedDependencies[moduleId]);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 				if(doDispose) {
/******/ 					addAllToSet(outdatedModules, [result.moduleId]);
/******/ 					appliedUpdate[moduleId] = warnUnexpectedRequire;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(i = 0; i < outdatedModules.length; i++) {
/******/ 			moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		Object.keys(hotAvailableFilesMap).forEach(function(chunkId) {
/******/ 			if(hotAvailableFilesMap[chunkId] === false) {
/******/ 				hotDisposeChunk(chunkId);
/******/ 			}
/******/ 		});
/******/ 	
/******/ 		var idx;
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			moduleId = queue.pop();
/******/ 			module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(j = 0; j < disposeHandlers.length; j++) {
/******/ 				cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// when disposing there is no need to call dispose handler
/******/ 			delete outdatedDependencies[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		var dependency;
/******/ 		var moduleOutdatedDependencies;
/******/ 		for(moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				module = installedModules[moduleId];
/******/ 				if(module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					for(j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 						dependency = moduleOutdatedDependencies[j];
/******/ 						idx = module.children.indexOf(dependency);
/******/ 						if(idx >= 0) module.children.splice(idx, 1);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				module = installedModules[moduleId];
/******/ 				if(module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					var callbacks = [];
/******/ 					for(i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 						dependency = moduleOutdatedDependencies[i];
/******/ 						cb = module.hot._acceptedDependencies[dependency];
/******/ 						if(cb) {
/******/ 							if(callbacks.indexOf(cb) >= 0) continue;
/******/ 							callbacks.push(cb);
/******/ 						}
/******/ 					}
/******/ 					for(i = 0; i < callbacks.length; i++) {
/******/ 						cb = callbacks[i];
/******/ 						try {
/******/ 							cb(moduleOutdatedDependencies);
/******/ 						} catch(err) {
/******/ 							if(options.onErrored) {
/******/ 								options.onErrored({
/******/ 									type: "accept-errored",
/******/ 									moduleId: moduleId,
/******/ 									dependencyId: moduleOutdatedDependencies[i],
/******/ 									error: err
/******/ 								});
/******/ 							}
/******/ 							if(!options.ignoreErrored) {
/******/ 								if(!error)
/******/ 									error = err;
/******/ 							}
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err2) {
/******/ 						if(options.onErrored) {
/******/ 							options.onErrored({
/******/ 								type: "self-accept-error-handler-errored",
/******/ 								moduleId: moduleId,
/******/ 								error: err2,
/******/ 								orginalError: err, // TODO remove in webpack 4
/******/ 								originalError: err
/******/ 							});
/******/ 						}
/******/ 						if(!options.ignoreErrored) {
/******/ 							if(!error)
/******/ 								error = err2;
/******/ 						}
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else {
/******/ 					if(options.onErrored) {
/******/ 						options.onErrored({
/******/ 							type: "self-accept-errored",
/******/ 							moduleId: moduleId,
/******/ 							error: err
/******/ 						});
/******/ 					}
/******/ 					if(!options.ignoreErrored) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return Promise.reject(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		return new Promise(function(resolve) {
/******/ 			resolve(outdatedModules);
/******/ 		});
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		32: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {},
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: (hotCurrentParentsTemp = hotCurrentParents, hotCurrentParents = [], hotCurrentParentsTemp),
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "chunk-" + chunkId + "." + hotCurrentHash + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/@catalytic/pushbot-web/1.23.901/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(856)(__webpack_require__.s = 856);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(82);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(94);
var hide = __webpack_require__(44);
var redefine = __webpack_require__(45);
var ctx = __webpack_require__(72);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _server = __webpack_require__(1341);

var _server2 = _interopRequireDefault(_server);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _toString = function _toString(component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _server2['default'].renderToStaticMarkup((0, _react.createElement)(component, props)).replace(/[\r\n]+/g, '');
};

// https://codepen.io/tigt/post/optimizing-svgs-in-data-uris
var _toDataURI = function _toDataURI(component, props) {
  return 'data:image/svg+xml,' + encodeURIComponent(
  // encode URL-unsafe characters
  _toString(component, props) // render to static markup
  .replace(/\n+/g, '') // remove newlines
  .replace(/%20/g, ' ') // put spaces back in
  .replace(/%3D/g, '=') // ditto equals signs
  .replace(/%3A/g, ':') // ditto colons
  .replace(/%2F/g, '/') // ditto slashes
  .replace(/%22/g, "'") // replace quotes with apostrophes (may break certain SVGs)
  );
};

// Possible improvements:
//   * Lowercase the hex-escapes for better gzipping
//   * Replace stuff like `fill="%23000"` with `fill="black"`

var _toURL = function _toURL(component, props) {
  return 'url(\'' + _toDataURI(component, props) + '\')';
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SvgIcon', function (theme) {
  return {
    svgIcon: {
      display: 'inline-block',
      color: 'currentColor',
      fill: 'currentColor',
      height: '1em',
      width: '1em',
      userSelect: 'none',
      transition: theme.transitions.create(['color', 'fill'])
    },
    highlight: {
      color: theme.typography.highlight.color,
      fill: theme.typography.highlight.color
    },
    disabled: {
      color: theme.typography.disabled.color,
      fill: theme.typography.disabled.color
    },
    error: {
      color: theme.typography.error.color,
      fill: theme.typography.error.color
    },
    success: {
      color: theme.typography.success.color,
      fill: theme.typography.success.color
    },
    secondary: {
      color: theme.typography.secondary.color,
      fill: theme.typography.secondary.color
    }
  };
});

// eslint-disable-next-line react/display-name
var SvgIcon = (_temp = _class = function (_PureComponent) {
  _inherits(SvgIcon, _PureComponent);

  function SvgIcon() {
    _classCallCheck(this, SvgIcon);

    return _possibleConstructorReturn(this, (SvgIcon.__proto__ || Object.getPrototypeOf(SvgIcon)).apply(this, arguments));
  }

  _createClass(SvgIcon, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            classNameProp = _props.className,
            disabled = _props.disabled,
            error = _props.error,
            success = _props.success,
            highlight = _props.highlight,
            secondary = _props.secondary,
            viewBox = _props.viewBox,
            other = _objectWithoutProperties(_props, ['children', 'className', 'disabled', 'error', 'success', 'highlight', 'secondary', 'viewBox']);

        var _ref = this.context || {},
            styleManager = _ref.styleManager;

        var classPicker = {};

        if (styleManager) {
          var _classPicker;

          var classes = styleManager.render(styleSheet);
          classPicker = (_classPicker = {}, _defineProperty(_classPicker, classes.svgIcon, true), _defineProperty(_classPicker, classes.secondary, secondary), _defineProperty(_classPicker, classes.highlight, highlight), _defineProperty(_classPicker, classes.disabled, disabled), _defineProperty(_classPicker, classes.error, error), _defineProperty(_classPicker, classes.success, success), _classPicker);
        }

        var className = (0, _classnames2['default'])(classPicker, classNameProp);

        return _react2['default'].createElement(
          'svg',
          _extends({
            className: className,
            preserveAspectRatio: 'xMinYMid',
            viewBox: viewBox,
            xmlns: 'http://www.w3.org/2000/svg'
          }, other),
          children
        );
      }

      return render;
    }()
  }], [{
    key: 'toString',
    value: function () {
      function toString(props) {
        return _toString(this, props);
      }

      return toString;
    }()
  }, {
    key: 'toDataURI',
    value: function () {
      function toDataURI(props) {
        return _toDataURI(this, props);
      }

      return toDataURI;
    }()
  }, {
    key: 'toURL',
    value: function () {
      function toURL(props) {
        return _toURL(this, props);
      }

      return toURL;
    }()
  }]);

  return SvgIcon;
}(_react.PureComponent), _class.muiName = 'SvgIcon', _class.propTypes = {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the icon will use the theme's disabled color.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's success color.
   */
  success: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's highlight color.
   */
  highlight: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Allows you to redefine what the coordinates without units mean inside an svg element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the svg will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _PropTypes2['default'].string
}, _class.defaultProps = {
  disabled: false,
  error: false,
  highlight: false,
  secondary: false,
  success: false,
  viewBox: '0 0 24 24'
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager
}, _temp);
exports['default'] = SvgIcon;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _manager = __webpack_require__(560);

var _theme = __webpack_require__(336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = Object.assign({
  deprecate: function () {
    function deprecate(propType, message) {
      if (true) return propType;

      var _warn = function () {
        function warn(props, propName, displayName) {
          if (!props[propName]) return;
          console.warn('Deprecation:', message || 'Deprecation: Prop \'' + displayName + '.' + propName + '\' is no longer used.');
          _warn = function () {
            function warn() {}

            return warn;
          }();
        }

        return warn;
      }();

      return function (props, propName, displayName) {
        _warn(props, propName, displayName);
        return propType.apply(this, arguments);
      };
    }

    return deprecate;
  }(),
  styleManager: _propTypes2['default'].instanceOf(_manager.StyleManager),
  theme: _propTypes2['default'].instanceOf(_theme.Theme),
  origin: _propTypes2['default'].shape({
    vertical: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].func, _propTypes2['default'].oneOf(['top', 'center', 'bottom'])]),
    horizontal: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].func, _propTypes2['default'].oneOf(['left', 'center', 'right'])])
  }),
  childrenOfComponentType: function () {
    function childrenOfComponentType(expectedComponent) {
      return function (props, propName, componentName) {
        var error = null;
        _react2['default'].Children.forEach(props[propName], function (child) {
          if (!error && child.type !== expectedComponent) {
            var expectedName = expectedComponent.name;
            error = new Error('Invalid prop ' + propName + ' supplied to ' + componentName + '. Expected ' + (expectedName ? '"' + expectedName + '"' : 'a different') + ' component type.');
          }
        });
        return error;
      };
    }

    return childrenOfComponentType;
  }()
}, _propTypes2['default']);

exports['default'] = PropTypes;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1321)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styleManager = __webpack_require__(561);

Object.defineProperty(exports, 'createStyleManager', {
  enumerable: true,
  get: function get() {
    return _styleManager.createStyleManager;
  }
});

var _styleSheet = __webpack_require__(1345);

Object.defineProperty(exports, 'createStyleSheet', {
  enumerable: true,
  get: function get() {
    return _styleSheet.createStyleSheet;
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fetch = __webpack_require__(502);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

var _normalizr = __webpack_require__(132);

var _env3 = __webpack_require__(253);

var _url = __webpack_require__(83);

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isJSON = function isJSON(type) {
  return type && type.indexOf('application/json') !== -1;
};
var isText = function isText(type) {
  return type && type.indexOf('text/') !== -1;
};
var passthrough = function passthrough(input) {
  return input;
};
var GET_TRANSACTION = 'GET_TRANSACTION';
var INVALIDATION_ERROR = /(Unauthorized|Forbidden|No user found|Missing x-user-key")/i;

var API = exports.API = function (_Fetch) {
  _inherits(API, _Fetch);

  function API(basepath) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, API);

    var _this = _possibleConstructorReturn(this, (API.__proto__ || Object.getPrototypeOf(API)).call(this, basepath, defaults, options));

    _this.buildTransactionTypes();
    return _this;
  }

  _createClass(API, [{
    key: 'buildTransactionTypes',
    value: function buildTransactionTypes() {
      var _buildTypes = this.buildTypes(GET_TRANSACTION),
          _buildTypes2 = _slicedToArray(_buildTypes, 4),
          t = _buildTypes2[0],
          r = _buildTypes2[1],
          s = _buildTypes2[2],
          f = _buildTypes2[3];

      this.GET_TRANSACTION = t;
      this.GET_TRANSACTION_REQUEST = r;
      this.GET_TRANSACTION_SUCCESS = s;
      this.GET_TRANSACTION_FAILURE = f;
    }
  }, {
    key: 'getTransaction',
    value: function getTransaction(transactionID, schema) {
      return {
        type: this.GET_TRANSACTION,
        payload: {
          url: '/await/' + encodeURIComponent(transactionID),
          schema: schema
        }
      };
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'before',
    value: function before(action, states, next) {
      var _action$payload = action.payload;
      _action$payload = _action$payload === undefined ? {} : _action$payload;
      var _action$payload$json = _action$payload.json,
          json = _action$payload$json === undefined ? true : _action$payload$json,
          _action$payload$optio = _action$payload.options;
      _action$payload$optio = _action$payload$optio === undefined ? {} : _action$payload$optio;
      var body = _action$payload$optio.body;

      var nextAction = _extends({}, action);
      if (json && body !== undefined) {
        nextAction.payload.options.body = JSON.stringify(body);
      }

      return Promise.resolve(nextAction);
    }
  }, {
    key: 'after',
    value: function after(action, states, next, store) {
      var _this2 = this;

      var payload = action.payload,
          response = action.response;

      var type = response.headers.get('content-type');

      var makeError = function makeError(responseBody) {
        var method = _this2.getRequestMethod(action);
        var err = new Error(method + ' ' + response.url + ' returned ' + response.status + ': ' + responseBody);
        err.response = response;
        err.status = response.status;

        return err;
      };

      var maybeInvalidateAuth = function maybeInvalidateAuth(message) {
        if (response.status === 403 || INVALIDATION_ERROR.test(message)) {
          store.dispatch({ type: 'AUTHENTICATION_INVALIDATE' });
        }
      };

      return isJSON(type) ? response.json().then(function (data) {
        maybeInvalidateAuth(data && data.message);
        return data;
      }).then(function (data) {
        if (!response.ok || data && data.errorMessage) {
          // eslint-disable-next-line no-unused-vars
          var method = (payload.options || {}).method || 'GET';
          var err = makeError(JSON.stringify(data));
          err.responseJSON = data;
          throw err;
        }

        var _payload$transform = payload.transform,
            transform = _payload$transform === undefined ? passthrough : _payload$transform;

        return transform(data);
      }).then(function (data) {
        if (!data) {
          return _extends({}, action, {
            response: null // we should be returning the actual response here!
          });
        }

        var schema = payload.schema;

        var transactionID = (data.transaction || {}).id;

        var transaction = void 0;
        if ((transactionID || transactionID === 0) && schema) {
          transaction = store.dispatch(_this2.getTransaction(transactionID, schema));
        }

        var json = data;
        var requestUrl = _url2.default.parse(payload.url || '/', true);

        var PAGING_ENDPOINTS = ['tasks', 'processes', 'credentials'];

        // API will be transitioning to mandatory paging for all list endpoints, but for now it's only enabled
        // on tasks and processes and credentials
        var usingPaging = requestUrl.query.limit || PAGING_ENDPOINTS.some(function (endpoint) {
          return requestUrl.pathname.endsWith('/' + endpoint);
        });

        var searching = requestUrl.pathname.endsWith('/search');
        var tableRows = requestUrl.pathname.endsWith('/rows');

        var pagingAPI = data && data.items && usingPaging && !searching;
        if (pagingAPI) {
          json = data.items;
        } else if (tableRows && data.results) {
          json = data.results;
        }

        var result = !schema || (typeof json === 'undefined' ? 'undefined' : _typeof(json)) !== 'object' ? json : (0, _normalizr.normalize)(json, schema);

        if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
          if (pagingAPI) {
            result.nextPageKey = data.nextPageKey;
          } else if (searching) {
            result.nextPageKey = data.pageToken;
            result.result = data.results.map(function (r) {
              return {
                id: r.id,
                schema: r.type
              };
            });
            result.total = data.total;
          } else if (tableRows) {
            result.pageToken = data.pageToken;
            result.total = data.total;
          }
        }

        var response = _extends({}, action, {
          response: result
        });
        if (transaction) {
          response.transaction = transaction;
        }

        return response;
      }) : isText(type) ? response.text().then(function (data) {
        maybeInvalidateAuth(data);
        return data;
      }).then(function (data) {
        if (!response.ok) {
          var err = makeError(data);
          err.responseText = data;
          throw err;
        }

        var _payload$transform2 = payload.transform,
            transform = _payload$transform2 === undefined ? passthrough : _payload$transform2;

        return transform(data);
      }).then(function (response) {
        return _extends({}, action, { response: response });
      }) : response.blob().then(function (data) {
        maybeInvalidateAuth(data);
        return data;
      }).then(function (data) {
        if (!response.ok) {
          var err = makeError('');
          err.responseBlob = data;
          throw err;
        }

        var _payload$transform3 = payload.transform,
            transform = _payload$transform3 === undefined ? passthrough : _payload$transform3;

        return transform(data);
      }).then(function (response) {
        return _extends({}, action, { response: response });
      });
    }
  }, {
    key: 'getRequestMethod',
    value: function getRequestMethod(action) {
      var _action$payload2 = action.payload,
          payload = _action$payload2 === undefined ? {} : _action$payload2;

      return (payload.options || {}).method || 'GET';
    }
  }, {
    key: 'actionCanBeRetried',
    value: function actionCanBeRetried(action) {
      var _action$payload3 = action.payload,
          payload = _action$payload3 === undefined ? {} : _action$payload3;

      var retryOption = (payload.options || {}).retry || false;
      return ['GET', 'HEAD', 'OPTIONS'].indexOf(this.getRequestMethod(action)) !== -1 || retryOption;
    }
  }, {
    key: 'maxRetries',
    value: function maxRetries(action, response) {
      if (this.actionCanBeRetried(action) && response.status >= 500) {
        return 3;
      }
      return 0;
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'error',
    value: function error(action, states, next, store) {
      var _states = _slicedToArray(states, 3),
          FAILURE = _states[2];

      next(_extends({}, action, { type: FAILURE }));
      return Promise.reject(action.error);
    }
  }]);

  return API;
}(_fetch.Fetch);

var api = new API((0, _env3.url)(_env2.default), {
  headers: _extends({
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }, _env2.default.PUSHBOT_API_KEY ? {
    'x-api-key': _env2.default.PUSHBOT_API_KEY
  } : {}),
  method: 'GET'
}, { prefix: 'API' });

exports.default = api;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH = exports.FILTER_LIST = exports.FILTER = exports.WEBHOOK_LIST = exports.WEBHOOK = exports.USER_LIST = exports.USER = exports.TRIGGER_LIST = exports.TRIGGER = exports.TRAINING_LIST = exports.TRAINING = exports.RUN_LIST = exports.RUN = exports.THREAD_LIST = exports.THREAD = exports.TEAM_LIST = exports.TEAM = exports.TASK_LIST = exports.TASK = exports.TABLE_ROW_LIST = exports.TABLE_ROW = exports.TABLE_LIST = exports.TABLE = exports.REMINDER_LIST = exports.REMINDER = exports.PROCESS_LIST = exports.PROCESS = exports.PREDICTOR_LIST = exports.PREDICTOR = exports.STEP_LIST = exports.STEP = exports.NOTIFICATION_LIST = exports.NOTIFICATION = exports.MESSAGE_LIST = exports.MESSAGE = exports.INVITE_LIST = exports.INVITE = exports.INTEGRATION_LIST = exports.INTEGRATION = exports.GROUP_LIST = exports.GROUP = exports.FILE_LIST = exports.FILE = exports.CREDENTIAL_LIST = exports.CREDENTIAL = exports.VISIBLE_FIELD_LIST = exports.VISIBLE_FIELD = exports.FIELD_LIST = exports.FIELD = exports.CONTACT_LIST = exports.CONTACT = exports.AUTH_INFO = exports.APP_LIST = exports.APP = exports.getEntityByID = exports.mapEntitiesByID = exports.getIDFromSchema = exports.getID = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _normalizr = __webpack_require__(132);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var entities = function entities(key) {
  var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var entity = new _normalizr.schema.Entity(key, definition, options);
  var idAttribute = options.idAttribute || 'id';
  entity.getIdAttribute = function () {
    return idAttribute;
  };
  return [entity, [entity]];
};

var processStrategy = function processStrategy(entity) {
  var id = entity.id,
      item = entity.item,
      score = entity.score,
      type = entity.type;

  return item ? _extends({}, item, { id: id, score: score, type: type }) : entity;
};

var getID = exports.getID = function getID(idAttribute, entity) {
  return typeof idAttribute === 'function' ? idAttribute(entity) : entity[idAttribute];
};

var getIDFromSchema = exports.getIDFromSchema = function getIDFromSchema(schema, entity) {
  return getID(schema.getIdAttribute(), entity);
};

var mapEntitiesByID = exports.mapEntitiesByID = function mapEntitiesByID(array) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return array.reduce(function (o, v) {
    return _extends({}, o, _defineProperty({}, getID(id, v), v));
  }, {});
};

var getEntityByID = exports.getEntityByID = function getEntityByID(entityMap, schema, entity) {
  return entityMap[getIDFromSchema(schema, entity)];
};

var _entities = entities('apps', {}, { idAttribute: 'appID' }),
    _entities2 = _slicedToArray(_entities, 2);

var APP = _entities2[0],
    APP_LIST = _entities2[1];
exports.APP = APP;
exports.APP_LIST = APP_LIST;

var _entities3 = entities('auth_info', {}, { idAttribute: 'method' }),
    _entities4 = _slicedToArray(_entities3, 1);

var AUTH_INFO = _entities4[0];
exports.AUTH_INFO = AUTH_INFO;

var _entities5 = entities('contacts'),
    _entities6 = _slicedToArray(_entities5, 2);

var CONTACT = _entities6[0],
    CONTACT_LIST = _entities6[1];
exports.CONTACT = CONTACT;
exports.CONTACT_LIST = CONTACT_LIST;

var _entities7 = entities('fields', {}, { idAttribute: 'path' }),
    _entities8 = _slicedToArray(_entities7, 2);

var FIELD = _entities8[0],
    FIELD_LIST = _entities8[1];
exports.FIELD = FIELD;
exports.FIELD_LIST = FIELD_LIST;

var _entities9 = entities('visibleFields', {}, { idAttribute: 'fieldID' }),
    _entities10 = _slicedToArray(_entities9, 2);

var VISIBLE_FIELD = _entities10[0],
    VISIBLE_FIELD_LIST = _entities10[1];
exports.VISIBLE_FIELD = VISIBLE_FIELD;
exports.VISIBLE_FIELD_LIST = VISIBLE_FIELD_LIST;

var _entities11 = entities('credentials', {}, {
  idAttribute: function idAttribute(entity) {
    return entity.item ? entity.item.credentialID : entity.credentialID;
  }
}),
    _entities12 = _slicedToArray(_entities11, 2);

var CREDENTIAL = _entities12[0],
    CREDENTIAL_LIST = _entities12[1];
exports.CREDENTIAL = CREDENTIAL;
exports.CREDENTIAL_LIST = CREDENTIAL_LIST;

var _entities13 = entities('files', {}, { idAttribute: 'fileID' }),
    _entities14 = _slicedToArray(_entities13, 2);

var FILE = _entities14[0],
    FILE_LIST = _entities14[1];
exports.FILE = FILE;
exports.FILE_LIST = FILE_LIST;

var _entities15 = entities('groups', {}, { idAttribute: 'userID' }),
    _entities16 = _slicedToArray(_entities15, 2);

var GROUP = _entities16[0],
    GROUP_LIST = _entities16[1];
exports.GROUP = GROUP;
exports.GROUP_LIST = GROUP_LIST;

var _entities17 = entities('integrations', {}, { idAttribute: 'userID' }),
    _entities18 = _slicedToArray(_entities17, 2);

var INTEGRATION = _entities18[0],
    INTEGRATION_LIST = _entities18[1];
exports.INTEGRATION = INTEGRATION;
exports.INTEGRATION_LIST = INTEGRATION_LIST;

var _entities19 = entities('invites', {}, { idAttribute: 'inviteID' }),
    _entities20 = _slicedToArray(_entities19, 2);

var INVITE = _entities20[0],
    INVITE_LIST = _entities20[1];
exports.INVITE = INVITE;
exports.INVITE_LIST = INVITE_LIST;

var _entities21 = entities('messages', {}, { idAttribute: 'messageID' }),
    _entities22 = _slicedToArray(_entities21, 2);

var MESSAGE = _entities22[0],
    MESSAGE_LIST = _entities22[1];
exports.MESSAGE = MESSAGE;
exports.MESSAGE_LIST = MESSAGE_LIST;

var _entities23 = entities('notifications', {}, { idAttribute: 'notificationID' }),
    _entities24 = _slicedToArray(_entities23, 2);

var NOTIFICATION = _entities24[0],
    NOTIFICATION_LIST = _entities24[1];
exports.NOTIFICATION = NOTIFICATION;
exports.NOTIFICATION_LIST = NOTIFICATION_LIST;

var _entities25 = entities('steps', {}, { idAttribute: function idAttribute(step) {
    return step.processID + ':' + step.stepName;
  } }),
    _entities26 = _slicedToArray(_entities25, 2);

var STEP = _entities26[0],
    STEP_LIST = _entities26[1];
exports.STEP = STEP;
exports.STEP_LIST = STEP_LIST;

var _entities27 = entities('predictors', {}, { idAttribute: 'predictorID' }),
    _entities28 = _slicedToArray(_entities27, 2);

var PREDICTOR = _entities28[0],
    PREDICTOR_LIST = _entities28[1];
exports.PREDICTOR = PREDICTOR;
exports.PREDICTOR_LIST = PREDICTOR_LIST;

var _entities29 = entities('processes', { steps: STEP_LIST, fields: FIELD_LIST }, {
  idAttribute: function idAttribute(entity) {
    return entity.item ? entity.item.processID : entity.processID;
  },
  processStrategy: processStrategy
}),
    _entities30 = _slicedToArray(_entities29, 2);

var PROCESS = _entities30[0],
    PROCESS_LIST = _entities30[1];
exports.PROCESS = PROCESS;
exports.PROCESS_LIST = PROCESS_LIST;

var _entities31 = entities('reminders', {}, { idAttribute: 'reminderID' }),
    _entities32 = _slicedToArray(_entities31, 2);

var REMINDER = _entities32[0],
    REMINDER_LIST = _entities32[1];
exports.REMINDER = REMINDER;
exports.REMINDER_LIST = REMINDER_LIST;

var _entities33 = entities('tables', { columns: FIELD_LIST }, {
  idAttribute: function idAttribute(entity) {
    return entity.item ? entity.item.tableID : entity.tableID;
  },
  processStrategy: processStrategy
}),
    _entities34 = _slicedToArray(_entities33, 2);

var TABLE = _entities34[0],
    TABLE_LIST = _entities34[1];
exports.TABLE = TABLE;
exports.TABLE_LIST = TABLE_LIST;

var _entities35 = entities('tableRows', { fields: FIELD_LIST }, { idAttribute: 'rowID' }),
    _entities36 = _slicedToArray(_entities35, 2);

var TABLE_ROW = _entities36[0],
    TABLE_ROW_LIST = _entities36[1];
exports.TABLE_ROW = TABLE_ROW;
exports.TABLE_ROW_LIST = TABLE_ROW_LIST;

var _entities37 = entities('tasks', { fields: FIELD_LIST }, {
  idAttribute: function idAttribute(entity) {
    return entity.item ? entity.item.taskID : entity.taskID;
  },
  processStrategy: processStrategy
}),
    _entities38 = _slicedToArray(_entities37, 2);

var TASK = _entities38[0],
    TASK_LIST = _entities38[1];
exports.TASK = TASK;
exports.TASK_LIST = TASK_LIST;

var _entities39 = entities('teams', {}, { idAttribute: 'teamName' }),
    _entities40 = _slicedToArray(_entities39, 2);

var TEAM = _entities40[0],
    TEAM_LIST = _entities40[1];
exports.TEAM = TEAM;
exports.TEAM_LIST = TEAM_LIST;

var _entities41 = entities('threads', { messages: MESSAGE_LIST }, {
  idAttribute: 'threadID'
}),
    _entities42 = _slicedToArray(_entities41, 2);

var THREAD = _entities42[0],
    THREAD_LIST = _entities42[1];
exports.THREAD = THREAD;
exports.THREAD_LIST = THREAD_LIST;

var _entities43 = entities('runs', { tasks: TASK_LIST, threadID: THREAD, fields: FIELD_LIST }, {
  idAttribute: function idAttribute(entity) {
    return entity.item ? entity.item.runID : entity.runID;
  },
  processStrategy: processStrategy
}),
    _entities44 = _slicedToArray(_entities43, 2);

var RUN = _entities44[0],
    RUN_LIST = _entities44[1];
exports.RUN = RUN;
exports.RUN_LIST = RUN_LIST;

var _entities45 = entities('trainings', {}, { idAttribute: 'trainingID' }),
    _entities46 = _slicedToArray(_entities45, 2);

var TRAINING = _entities46[0],
    TRAINING_LIST = _entities46[1];
exports.TRAINING = TRAINING;
exports.TRAINING_LIST = TRAINING_LIST;

var _entities47 = entities('triggers', {}, { idAttribute: 'triggerID' }),
    _entities48 = _slicedToArray(_entities47, 2);

var TRIGGER = _entities48[0],
    TRIGGER_LIST = _entities48[1];
exports.TRIGGER = TRIGGER;
exports.TRIGGER_LIST = TRIGGER_LIST;

var _entities49 = entities('users', {}, { idAttribute: 'userID' }),
    _entities50 = _slicedToArray(_entities49, 2);

var USER = _entities50[0],
    USER_LIST = _entities50[1];
exports.USER = USER;
exports.USER_LIST = USER_LIST;

var _entities51 = entities('webhooks', {}, { idAttribute: 'webhookID' }),
    _entities52 = _slicedToArray(_entities51, 2);

var WEBHOOK = _entities52[0],
    WEBHOOK_LIST = _entities52[1];
exports.WEBHOOK = WEBHOOK;
exports.WEBHOOK_LIST = WEBHOOK_LIST;

var _entities53 = entities('filters', {}, { idAttribute: 'filterID' }),
    _entities54 = _slicedToArray(_entities53, 2);

var FILTER = _entities54[0],
    FILTER_LIST = _entities54[1];
exports.FILTER = FILTER;
exports.FILTER_LIST = FILTER_LIST;


var RESULT_LIST = new _normalizr.schema.Array({
  processes: PROCESS,
  runs: RUN,
  tables: TABLE,
  tasks: TASK
}, function (entity) {
  return entity.type;
});

var SEARCH = exports.SEARCH = new _normalizr.schema.Entity('searches', { results: RESULT_LIST }, { idAttribute: 'searchID' });

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellPosition */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_CellRenderer */
/* unused harmony export bpfrpt_proptype_CellCache */
/* unused harmony export bpfrpt_proptype_StyleCache */
/* unused harmony export bpfrpt_proptype_CellRangeRendererParams */
/* unused harmony export bpfrpt_proptype_CellRangeRenderer */
/* unused harmony export bpfrpt_proptype_CellSizeGetter */
/* unused harmony export bpfrpt_proptype_CellSize */
/* unused harmony export bpfrpt_proptype_NoContentRenderer */
/* unused harmony export bpfrpt_proptype_Scroll */
/* unused harmony export bpfrpt_proptype_ScrollbarPresenceChange */
/* unused harmony export bpfrpt_proptype_RenderedSection */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetterParams */
/* unused harmony export bpfrpt_proptype_OverscanIndices */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony export bpfrpt_proptype_Alignment */
/* unused harmony export bpfrpt_proptype_VisibleCellRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_CellPosition =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellCache =  true ? null : PropTypes.objectOf(PropTypes.node.isRequired);
var bpfrpt_proptype_StyleCache =  true ? null : PropTypes.objectOf(PropTypes.object.isRequired);
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: PropTypes.objectOf(PropTypes.node.isRequired).isRequired,
  cellRenderer: PropTypes.func.isRequired,
  columnSizeAndPositionManager: function columnSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  deferredMeasurementCache: PropTypes.object,
  horizontalOffsetAdjustment: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isScrollingOptOut: PropTypes.bool.isRequired,
  parent: PropTypes.object.isRequired,
  rowSizeAndPositionManager: function rowSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  styleCache: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
  verticalOffsetAdjustment: PropTypes.number.isRequired,
  visibleColumnIndices: PropTypes.object.isRequired,
  visibleRowIndices: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRangeRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSizeGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSize =  true ? null : PropTypes.oneOfType([PropTypes.func, PropTypes.number]);
var bpfrpt_proptype_NoContentRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  clientWidth: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  scrollWidth: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: PropTypes.bool.isRequired,
  vertical: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired
};
var bpfrpt_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: PropTypes.number.isRequired,
  columnOverscanStopIndex: PropTypes.number.isRequired,
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  rowOverscanStartIndex: PropTypes.number.isRequired,
  rowOverscanStopIndex: PropTypes.number.isRequired,
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: PropTypes.oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: PropTypes.number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: PropTypes.number.isRequired,


  // Begin of range of visible cells
  startIndex: PropTypes.number.isRequired,


  // End of range of visible cells
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_Alignment =  true ? null : PropTypes.oneOf(['auto', 'end', 'start', 'center']);
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  start: PropTypes.number,
  stop: PropTypes.number
};




















/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(48);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(201)('wks');
var uid = __webpack_require__(96);
var Symbol = __webpack_require__(13).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var DOMProperty = __webpack_require__(129);
var ReactDOMComponentFlags = __webpack_require__(461);

var invariant = __webpack_require__(9);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(659);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(14)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(432);
var toPrimitive = __webpack_require__(63);
var dP = Object.defineProperty;

exports.f = __webpack_require__(24) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(73);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1038);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;

	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }
	            this._mode = modeCreator.call(mode, this, iv && iv.words);
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileUrl = exports.formatSearch = exports.parseSearch = exports.parse = exports.default = exports.format = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = __webpack_require__(83);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_url).default;
  }
});
Object.defineProperty(exports, 'parse', {
  enumerable: true,
  get: function get() {
    return _url.parse;
  }
});

var _omitBy = __webpack_require__(755);

var _omitBy2 = _interopRequireDefault(_omitBy);

var _isNil = __webpack_require__(795);

var _isNil2 = _interopRequireDefault(_isNil);

var _searchQueryParser = __webpack_require__(533);

var _searchQueryParser2 = _interopRequireDefault(_searchQueryParser);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var format = function format(_ref) {
  var _ref$query = _ref.query,
      query = _ref$query === undefined ? {} : _ref$query,
      options = _objectWithoutProperties(_ref, ['query']);

  return (0, _url.format)(_extends({}, options, { query: (0, _omitBy2.default)(query, _isNil2.default) }));
};

exports.format = format;
var parseSearch = function parseSearch(search) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var terms = _searchQueryParser2.default.parse(search, options);
  if (typeof terms === 'string') {
    return {
      text: terms,
      offsets: [{ text: terms, offsetStart: 0, offsetEnd: search.length }]
    };
  } else {
    var exclude = terms.exclude,
        offsets = terms.offsets,
        others = _objectWithoutProperties(terms, ['exclude', 'offsets']);

    var entries = Object.entries(others);
    return entries.length ? _extends({}, Object.assign.apply(Object, _toConsumableArray(entries.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          k = _ref3[0],
          v = _ref3[1];

      return _defineProperty({}, k, Array.isArray(v) ? v.join(',') : v);
    }))), {
      exclude: exclude,
      offsets: offsets
    }) : terms;
  }
};

exports.parseSearch = parseSearch;
var isExcluded = function isExcluded(k, v) {
  var excluded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return excluded[k] && excluded[k].indexOf(v) !== -1;
};

var createToken = function createToken(keyword, value) {
  var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return keyword === 'text' ? { text: value, exclude: exclude } : typeof value === 'string' ? { keyword: keyword, value: value, exclude: exclude } : value instanceof Array ? { keyword: keyword, value: value.join(','), exclude: exclude } : { keyword: keyword, value: value.from + '-' + value.to, exclude: exclude };
};

var tokenizeTerms = function tokenizeTerms() {
  var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Object.keys(terms).map(function (k) {
    return createToken(k, terms[k], exclude);
  });
};

var formatSearch = function formatSearch() {
  var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var useOffsets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var offsets = terms.offsets,
      excluded = terms.exclude,
      props = _objectWithoutProperties(terms, ['offsets', 'exclude']);

  var tokens = offsets && useOffsets ? offsets : [].concat(_toConsumableArray(tokenizeTerms(props)), _toConsumableArray(tokenizeTerms(excluded, true)));
  return tokens
  // eslint-disable-next-line no-unused-vars, (offsetStart)
  .map(function (_ref5) {
    var exclude = _ref5.exclude,
        _ref5$text = _ref5.text,
        text = _ref5$text === undefined ? '' : _ref5$text,
        value = _ref5.value,
        keyword = _ref5.keyword,
        offsetStart = _ref5.offsetStart;

    var v = keyword && value ? keyword + ':' + (value.indexOf(' ') !== -1 ? JSON.stringify(value) : value) : text.trim();
    var x = keyword ? exclude || isExcluded(keyword, value, excluded) : false;
    return '' + (x ? '-' : '') + v;
  }).join(' ').trim();
};

exports.formatSearch = formatSearch;
var getFileUrl = exports.getFileUrl = function getFileUrl(teamName) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _env2.default.PUSHBOT_API_PATH + '/teams/' + teamName + '/files/' + fileName + '/download';
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(64);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */

var _context = void 0;

try {
  _context = window;
} catch (e) {
  _context = global;
}

var context = _context;

exports.default = context;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global ENV */


var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var env = _extends({}, {"PUSHBOT_EMBEDDED_MODE":false,"PUSHBOT_EMBEDDED_PATHNAME":"^.*$","PUSHBOT_EMBEDDED_REFERRER":"/","PUSHBOT_CONFIGURATION":"local","PUSHBOT_ENV":"staging","PUSHBOT_VERSION":"1.23.901","PUSHBOT_NAME":"@catalytic/pushbot-web-build","PUSHBOT_WEB_PATH":"/@catalytic/pushbot-web/1.23.901/","PUSHBOT_API_PROTOCOL":"https:","PUSHBOT_LAUNCHDARKLY_ID":"5940055cc654e40c83327a43","PUSHBOT_NEWRELIC_KEY":"5c90b51bff","PUSHBOT_NEWRELIC_ID":"54545427","PUSHBOT_OAUTH_REDIRECT_URL":"http://localhost:6150/oauth","PUSHBOT_LOG_LEVEL":"log","PUSHBOT_VERBOSE":1,"PUSHBOT_USER_SESSION_PATH":"session","PUSHBOT_REDUX_DEVTOOLS":1,"PUSHBOT_SLACK_CLIENT_ID":"4056875606.77226325253","PUSHBOT_API_PORT":null}, _context2.default.__ENV__ || {});

if (env.PUSHBOT_VERBOSE) {
  console.groupCollapsed('environment', env.PUSHBOT_CONFIGURATION + '@' + env.PUSHBOT_VERSION);
  Object.keys(env).forEach(function (k) {
    return console.log('%c' + k + '%c: %c' + JSON.stringify(env[k]), 'color: #93c', 'color: #999', 'color: #d13');
  });
  console.groupEnd();
}

exports.default = env;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1749), __esModule: true };

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(660);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1755);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1759);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(660);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(357)('wks');
var uid = __webpack_require__(234);
var Symbol = __webpack_require__(49).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(1778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(11);
/* unused harmony reexport bpfrpt_proptype_NoContentRenderer */
/* unused harmony reexport bpfrpt_proptype_Alignment */
/* unused harmony reexport bpfrpt_proptype_CellPosition */
/* unused harmony reexport bpfrpt_proptype_CellSize */
/* unused harmony reexport bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony reexport bpfrpt_proptype_RenderedSection */
/* unused harmony reexport bpfrpt_proptype_CellRendererParams */
/* unused harmony reexport bpfrpt_proptype_Scroll */

























/***/ }),
/* 43 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var createDesc = __webpack_require__(95);
module.exports = __webpack_require__(24) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var hide = __webpack_require__(44);
var has = __webpack_require__(43);
var SRC = __webpack_require__(96)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(94).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(14);
var defined = __webpack_require__(64);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.2
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(1567)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.2';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(190)(module)))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(157);
var defined = __webpack_require__(64);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(158);
var createDesc = __webpack_require__(95);
var toIObject = __webpack_require__(52);
var toPrimitive = __webpack_require__(63);
var has = __webpack_require__(43);
var IE8_DOM_DEFINE = __webpack_require__(432);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(24) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(43);
var toObject = __webpack_require__(32);
var IE_PROTO = __webpack_require__(269)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Code = exports.Menugroup = exports.Caption = exports.Body2 = exports.Body1 = exports.Subheading = exports.Title = exports.Headline = exports.Display4 = exports.Display3 = exports.Display2 = exports.Display1 = exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2, _class3, _temp3, _class4, _temp4, _class5, _temp5, _class6, _temp6, _class7, _temp7, _class8, _temp8, _class9, _temp9, _class10, _temp10, _class11, _temp11, _class12, _temp12, _class13, _temp13;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Text', function (theme) {
  var mixins = theme.mixins,
      typography = theme.typography;

  return {
    root: { margin: 0 },
    body1: typography.body1,
    body2: typography.body2,
    caption: typography.caption,
    code: typography.code,
    headline: typography.headline,
    menugroup: typography.menugroup,
    title: typography.title,
    subheading: typography.subheading,
    display1: typography.display1,
    display2: typography.display2,
    display3: typography.display3,
    display4: typography.display4,
    highlight: typography.highlight,
    disabled: typography.disabled,
    error: typography.error,
    success: typography.success,
    paragraph: typography.paragraph,
    secondary: typography.secondary,
    gutters: mixins.gutters(1),
    colorInherit: { color: 'inherit' },
    noWrap: theme.mixins.truncate()
  };
});

var types = {
  body1: {},
  body2: {},
  caption: {},
  code: { component: 'code' },
  display1: { component: 'div' },
  display2: { component: 'div' },
  display3: { component: 'div' },
  display4: { component: 'div' },
  heading6: { component: 'h6' },
  headline: { component: 'h2' },
  menugroup: {},
  subheading: { component: 'div' },
  title: { component: 'h1' }
};
// eslint-disable-next-line react/display-name
var Text = (_temp = _class = function (_PureComponent) {
  _inherits(Text, _PureComponent);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }

  _createClass(Text, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _types$props$type$pro = Object.assign({}, types[this.props.type], this.props),
            children = _types$props$type$pro.children,
            classNameProp = _types$props$type$pro.className,
            colorInherit = _types$props$type$pro.colorInherit,
            component = _types$props$type$pro.component,
            componentRef = _types$props$type$pro.componentRef,
            disabled = _types$props$type$pro.disabled,
            error = _types$props$type$pro.error,
            gutters = _types$props$type$pro.gutters,
            highlight = _types$props$type$pro.highlight,
            noWrap = _types$props$type$pro.noWrap,
            paragraph = _types$props$type$pro.paragraph,
            secondary = _types$props$type$pro.secondary,
            success = _types$props$type$pro.success,
            type = _types$props$type$pro.type,
            props = _objectWithoutProperties(_types$props$type$pro, ['children', 'className', 'colorInherit', 'component', 'componentRef', 'disabled', 'error', 'gutters', 'highlight', 'noWrap', 'paragraph', 'secondary', 'success', 'type']);

        var classes = this.context.styleManager.render(styleSheet);

        var className = (0, _classnames2['default'])(classes.root, classes[type], (_classNames = {}, _defineProperty(_classNames, classes.secondary, secondary), _defineProperty(_classNames, classes.highlight, highlight), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.gutters, gutters), _defineProperty(_classNames, classes.paragraph, paragraph), _defineProperty(_classNames, classes.error, error), _defineProperty(_classNames, classes.success, success), _defineProperty(_classNames, classes.colorInherit, colorInherit), _defineProperty(_classNames, classes.noWrap, noWrap), _classNames), classNameProp);

        var ref = typeof componentRef === 'function' && {
          ref: function () {
            function ref(c) {
              return componentRef(c);
            }

            return ref;
          }()
        };

        return _react2['default'].createElement(component, Object.assign({}, props, ref, {
          disabled: disabled,
          className: className
        }), children);
      }

      return render;
    }()
  }]);

  return Text;
}(_react.PureComponent), _class.propTypes = {
  /**
   * If `true`, the text will use the parent element's color.
   */
  colorInherit: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's disabled color.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's success color.
   */
  success: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use default gutters.
   */
  gutters: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's highlight color.
   */
  highlight: _PropTypes2['default'].bool,
  /**
   * If `false`, the text will wrap
   */
  noWrap: _PropTypes2['default'].bool,
  /**
   * If `true`, padding will be added to the bottom of the container
   */
  paragraph: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Type of text area
   */
  type: _PropTypes2['default'].oneOf(Object.keys(types))
}, _class.defaultProps = {
  colorInherit: false,
  component: 'p',
  disabled: false,
  error: false,
  highlight: false,
  noWrap: false,
  paragraph: false,
  secondary: false,
  success: false,
  type: 'body1'
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = Text;
var Display1 = exports.Display1 = (_temp2 = _class2 = function (_Text) {
  _inherits(Display1, _Text);

  function Display1() {
    _classCallCheck(this, Display1);

    return _possibleConstructorReturn(this, (Display1.__proto__ || Object.getPrototypeOf(Display1)).apply(this, arguments));
  }

  return Display1;
}(Text), _class2.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display1'
}), _temp2);
var Display2 = exports.Display2 = (_temp3 = _class3 = function (_Text2) {
  _inherits(Display2, _Text2);

  function Display2() {
    _classCallCheck(this, Display2);

    return _possibleConstructorReturn(this, (Display2.__proto__ || Object.getPrototypeOf(Display2)).apply(this, arguments));
  }

  return Display2;
}(Text), _class3.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display2'
}), _temp3);
var Display3 = exports.Display3 = (_temp4 = _class4 = function (_Text3) {
  _inherits(Display3, _Text3);

  function Display3() {
    _classCallCheck(this, Display3);

    return _possibleConstructorReturn(this, (Display3.__proto__ || Object.getPrototypeOf(Display3)).apply(this, arguments));
  }

  return Display3;
}(Text), _class4.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display3'
}), _temp4);
var Display4 = exports.Display4 = (_temp5 = _class5 = function (_Text4) {
  _inherits(Display4, _Text4);

  function Display4() {
    _classCallCheck(this, Display4);

    return _possibleConstructorReturn(this, (Display4.__proto__ || Object.getPrototypeOf(Display4)).apply(this, arguments));
  }

  return Display4;
}(Text), _class5.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display4'
}), _temp5);
var Headline = exports.Headline = (_temp6 = _class6 = function (_Text5) {
  _inherits(Headline, _Text5);

  function Headline() {
    _classCallCheck(this, Headline);

    return _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).apply(this, arguments));
  }

  return Headline;
}(Text), _class6.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'headline'
}), _temp6);
var Title = exports.Title = (_temp7 = _class7 = function (_Text6) {
  _inherits(Title, _Text6);

  function Title() {
    _classCallCheck(this, Title);

    return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
  }

  return Title;
}(Text), _class7.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'title'
}), _temp7);
var Subheading = exports.Subheading = (_temp8 = _class8 = function (_Text7) {
  _inherits(Subheading, _Text7);

  function Subheading() {
    _classCallCheck(this, Subheading);

    return _possibleConstructorReturn(this, (Subheading.__proto__ || Object.getPrototypeOf(Subheading)).apply(this, arguments));
  }

  return Subheading;
}(Text), _class8.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'subheading'
}), _temp8);
var Body1 = exports.Body1 = (_temp9 = _class9 = function (_Text8) {
  _inherits(Body1, _Text8);

  function Body1() {
    _classCallCheck(this, Body1);

    return _possibleConstructorReturn(this, (Body1.__proto__ || Object.getPrototypeOf(Body1)).apply(this, arguments));
  }

  return Body1;
}(Text), _class9.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'body1'
}), _temp9);
var Body2 = exports.Body2 = (_temp10 = _class10 = function (_Text9) {
  _inherits(Body2, _Text9);

  function Body2() {
    _classCallCheck(this, Body2);

    return _possibleConstructorReturn(this, (Body2.__proto__ || Object.getPrototypeOf(Body2)).apply(this, arguments));
  }

  return Body2;
}(Text), _class10.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'body2'
}), _temp10);
var Caption = exports.Caption = (_temp11 = _class11 = function (_Text10) {
  _inherits(Caption, _Text10);

  function Caption() {
    _classCallCheck(this, Caption);

    return _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).apply(this, arguments));
  }

  return Caption;
}(Text), _class11.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'caption'
}), _temp11);
var Menugroup = exports.Menugroup = (_temp12 = _class12 = function (_Text11) {
  _inherits(Menugroup, _Text11);

  function Menugroup() {
    _classCallCheck(this, Menugroup);

    return _possibleConstructorReturn(this, (Menugroup.__proto__ || Object.getPrototypeOf(Menugroup)).apply(this, arguments));
  }

  return Menugroup;
}(Text), _class12.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'menugroup'
}), _temp12);
var Code = exports.Code = (_temp13 = _class13 = function (_Text12) {
  _inherits(Code, _Text12);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(Text), _class13.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'code'
}), _temp13);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1213),
    baseMatchesProperty = __webpack_require__(1220),
    identity = __webpack_require__(318),
    isArray = __webpack_require__(27),
    property = __webpack_require__(1224);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(14);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(18);

var CallbackQueue = __webpack_require__(466);
var PooledClass = __webpack_require__(105);
var ReactFeatureFlags = __webpack_require__(467);
var ReactReconciler = __webpack_require__(106);
var Transaction = __webpack_require__(211);

var invariant = __webpack_require__(9);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var core = __webpack_require__(26);
var ctx = __webpack_require__(139);
var hide = __webpack_require__(111);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styleManager = __webpack_require__(1570);

Object.defineProperty(exports, 'createStyleManager', {
  enumerable: true,
  get: function get() {
    return _styleManager.createStyleManager;
  }
});

var _styleSheet = __webpack_require__(772);

Object.defineProperty(exports, 'createStyleSheet', {
  enumerable: true,
  get: function get() {
    return _styleSheet.createStyleSheet;
  }
});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(94);
var fails = __webpack_require__(14);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(72);
var IObject = __webpack_require__(157);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(28);
var asc = __webpack_require__(945);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(112);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(662);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchListItem = exports.makeSortable = exports.makeSelectable = exports.ListSubheader = exports.ListItemText = exports.ListItemSecondaryAction = exports.ListItemIcon = exports.ListItem = exports.ListGroup = exports.InputListItem = exports.InfiniteScroll = exports.InfiniteList = exports.CollapsedListItem = exports.ActivityListItemSecondaryAction = exports.ActivityListItemIcon = exports.ActivityListItemHeader = exports.ActivityListItemFooter = exports.ActivityListItemContainer = exports.ActivityListItemAvatar = exports.ActivityListItem = exports['default'] = undefined;

var _List = __webpack_require__(1672);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_List)['default'];
    }

    return get;
  }()
});

var _ActivityListItem2 = __webpack_require__(718);

var _ActivityListItem3 = _interopRequireDefault(_ActivityListItem2);

var _ActivityListItemAvatar2 = __webpack_require__(739);

var _ActivityListItemAvatar3 = _interopRequireDefault(_ActivityListItemAvatar2);

var _ActivityListItemContainer2 = __webpack_require__(747);

var _ActivityListItemContainer3 = _interopRequireDefault(_ActivityListItemContainer2);

var _ActivityListItemFooter2 = __webpack_require__(748);

var _ActivityListItemFooter3 = _interopRequireDefault(_ActivityListItemFooter2);

var _ActivityListItemHeader2 = __webpack_require__(719);

var _ActivityListItemHeader3 = _interopRequireDefault(_ActivityListItemHeader2);

var _ActivityListItemIcon2 = __webpack_require__(720);

var _ActivityListItemIcon3 = _interopRequireDefault(_ActivityListItemIcon2);

var _ActivityListItemSecondaryAction2 = __webpack_require__(730);

var _ActivityListItemSecondaryAction3 = _interopRequireDefault(_ActivityListItemSecondaryAction2);

var _CollapsedListItem2 = __webpack_require__(641);

var _CollapsedListItem3 = _interopRequireDefault(_CollapsedListItem2);

var _InfiniteList2 = __webpack_require__(1747);

var _InfiniteList3 = _interopRequireDefault(_InfiniteList2);

var _InfiniteScroll2 = __webpack_require__(684);

var _InfiniteScroll3 = _interopRequireDefault(_InfiniteScroll2);

var _InputListItem2 = __webpack_require__(1823);

var _InputListItem3 = _interopRequireDefault(_InputListItem2);

var _ListGroup2 = __webpack_require__(1824);

var _ListGroup3 = _interopRequireDefault(_ListGroup2);

var _ListItem2 = __webpack_require__(369);

var _ListItem3 = _interopRequireDefault(_ListItem2);

var _ListItemIcon2 = __webpack_require__(1852);

var _ListItemIcon3 = _interopRequireDefault(_ListItemIcon2);

var _ListItemSecondaryAction2 = __webpack_require__(639);

var _ListItemSecondaryAction3 = _interopRequireDefault(_ListItemSecondaryAction2);

var _ListItemText2 = __webpack_require__(740);

var _ListItemText3 = _interopRequireDefault(_ListItemText2);

var _ListSubheader2 = __webpack_require__(640);

var _ListSubheader3 = _interopRequireDefault(_ListSubheader2);

var _makeSelectable2 = __webpack_require__(1853);

var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);

var _makeSortable2 = __webpack_require__(642);

var _makeSortable3 = _interopRequireDefault(_makeSortable2);

var _SearchListItem2 = __webpack_require__(255);

var _SearchListItem3 = _interopRequireDefault(_SearchListItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.ActivityListItem = _ActivityListItem3['default'];
exports.ActivityListItemAvatar = _ActivityListItemAvatar3['default'];
exports.ActivityListItemContainer = _ActivityListItemContainer3['default'];
exports.ActivityListItemFooter = _ActivityListItemFooter3['default'];
exports.ActivityListItemHeader = _ActivityListItemHeader3['default'];
exports.ActivityListItemIcon = _ActivityListItemIcon3['default'];
exports.ActivityListItemSecondaryAction = _ActivityListItemSecondaryAction3['default'];
exports.CollapsedListItem = _CollapsedListItem3['default'];
exports.InfiniteList = _InfiniteList3['default'];
exports.InfiniteScroll = _InfiniteScroll3['default'];
exports.InputListItem = _InputListItem3['default'];
exports.ListGroup = _ListGroup3['default'];
exports.ListItem = _ListItem3['default'];
exports.ListItemIcon = _ListItemIcon3['default'];
exports.ListItemSecondaryAction = _ListItemSecondaryAction3['default'];
exports.ListItemText = _ListItemText3['default'];
exports.ListSubheader = _ListSubheader3['default'];
exports.makeSelectable = _makeSelectable3['default'];
exports.makeSortable = _makeSortable3['default'];
exports.SearchListItem = _SearchListItem3['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(46);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(24)) {
  var LIBRARY = __webpack_require__(97);
  var global = __webpack_require__(13);
  var fails = __webpack_require__(14);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(209);
  var $buffer = __webpack_require__(292);
  var ctx = __webpack_require__(72);
  var anInstance = __webpack_require__(103);
  var propertyDesc = __webpack_require__(95);
  var hide = __webpack_require__(44);
  var redefineAll = __webpack_require__(104);
  var toInteger = __webpack_require__(73);
  var toLength = __webpack_require__(28);
  var toIndex = __webpack_require__(455);
  var toAbsoluteIndex = __webpack_require__(99);
  var toPrimitive = __webpack_require__(63);
  var has = __webpack_require__(43);
  var classof = __webpack_require__(159);
  var isObject = __webpack_require__(17);
  var toObject = __webpack_require__(32);
  var isArrayIter = __webpack_require__(284);
  var create = __webpack_require__(100);
  var getPrototypeOf = __webpack_require__(54);
  var gOPN = __webpack_require__(101).f;
  var getIterFn = __webpack_require__(286);
  var uid = __webpack_require__(96);
  var wks = __webpack_require__(19);
  var createArrayMethod = __webpack_require__(66);
  var createArrayIncludes = __webpack_require__(202);
  var speciesConstructor = __webpack_require__(289);
  var ArrayIterators = __webpack_require__(288);
  var Iterators = __webpack_require__(125);
  var $iterDetect = __webpack_require__(205);
  var setSpecies = __webpack_require__(102);
  var arrayFill = __webpack_require__(287);
  var arrayCopyWithin = __webpack_require__(447);
  var $DP = __webpack_require__(25);
  var $GOPD = __webpack_require__(53);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(415);
var $export = __webpack_require__(1);
var shared = __webpack_require__(201)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(453))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var PooledClass = __webpack_require__(105);

var emptyFunction = __webpack_require__(48);
var warning = __webpack_require__(16);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var lowerCase = __webpack_require__(169)

var NON_WORD_REGEXP = __webpack_require__(1231)
var CAMEL_CASE_REGEXP = __webpack_require__(1232)
var CAMEL_CASE_UPPER_REGEXP = __webpack_require__(1233)

/**
 * Sentence case a string.
 *
 * @param  {string} str
 * @param  {string} locale
 * @param  {string} replacement
 * @return {string}
 */
module.exports = function (str, locale, replacement) {
  if (str == null) {
    return ''
  }

  replacement = typeof replacement !== 'string' ? ' ' : replacement

  function replace (match, index, value) {
    if (index === 0 || index === (value.length - match.length)) {
      return ''
    }

    return replacement
  }

  str = String(str)
    // Support camel case ("camelCase" -> "camel Case").
    .replace(CAMEL_CASE_REGEXP, '$1 $2')
    // Support odd camel case ("CAMELCase" -> "CAMEL Case").
    .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
    // Remove all non-word characters and replace with a single space.
    .replace(NON_WORD_REGEXP, replace)

  // Lower case the entire string.
  return lowerCase(str, locale)
}


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(67);
var IE8_DOM_DEFINE = __webpack_require__(604);
var toPrimitive = __webpack_require__(353);
var dP = Object.defineProperty;

exports.f = __webpack_require__(88) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(96)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(43);
var setDesc = __webpack_require__(25).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(14)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var ReactBaseClasses = __webpack_require__(476);
var ReactChildren = __webpack_require__(1073);
var ReactDOMFactories = __webpack_require__(1076);
var ReactElement = __webpack_require__(131);
var ReactPropTypes = __webpack_require__(1077);
var ReactVersion = __webpack_require__(1078);

var createReactClass = __webpack_require__(1079);
var onlyChild = __webpack_require__(1081);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1130);
var util = __webpack_require__(1131);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(193);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1147);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */
var LANGUAGES = {
  tr: {
    regexp: /[\u0069]/g,
    map: {
      '\u0069': '\u0130'
    }
  },
  az: {
    regexp: /[\u0069]/g,
    map: {
      '\u0069': '\u0130'
    }
  },
  lt: {
    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
    map: {
      '\u0069\u0307': '\u0049',
      '\u006A\u0307': '\u004A',
      '\u012F\u0307': '\u012E',
      '\u0069\u0307\u0300': '\u00CC',
      '\u0069\u0307\u0301': '\u00CD',
      '\u0069\u0307\u0303': '\u0128'
    }
  }
}

/**
 * Upper case a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  var lang = LANGUAGES[locale]

  str = str == null ? '' : String(str)

  if (lang) {
    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
  }

  return str.toUpperCase()
}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(140)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(1504);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(1505);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = __webpack_require__(1646);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_IconButton)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fileObject = __webpack_require__(1891);

var _fileObject2 = _interopRequireDefault(_fileObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  accessRestricted: bool,
  cipherText: string,
  conditionCode: string,
  contentType: string,
  createdBy: string,
  createdDate: string,
  description: oneOfType([string, arrayOf(string)]),
  displayName: string,
  displayOnly: bool,
  encryptionKeyID: string,
  example: string,
  fieldID: string,
  fieldName: string,
  hints: string,
  intent: string,
  isCreatedByApp: bool,
  isRequired: bool,
  isSensitive: bool,
  items: bool,
  nextVersion: string,
  path: string,
  predictedBy: string,
  previousVersion: string,
  processID: string,
  processName: string,
  restrictions: shape({
    choices: arrayOf(string),
    max: number,
    min: number,
    multiple: bool,
    pattern: string,
    schema: oneOfType([objectOf(string), string])
  }),
  runID: string,
  tableID: string,
  teamName: string,
  type: string,
  userID: string,
  value: oneOfType([arrayOf(_fileObject2.default), arrayOf(string), bool, _fileObject2.default, number, _propTypes2.default.any, string]),
  visibility: string,
  visibleToUsers: arrayOf(string)
});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAuthStatus = exports.CHECK_AUTH_STATUS_FAILURE = exports.CHECK_AUTH_STATUS_SUCCESS = exports.CHECK_AUTH_STATUS_REQUEST = exports.CHECK_AUTH_STATUS = exports.getMagicLink = exports.GET_MAGIC_LINK_FAILURE = exports.GET_MAGIC_LINK_SUCCESS = exports.GET_MAGIC_LINK_REQUEST = exports.GET_MAGIC_LINK = exports.getAuthenticationToken = exports.GET_AUTHENTICATION_TOKEN_FAILURE = exports.GET_AUTHENTICATION_TOKEN_SUCCESS = exports.GET_AUTHENTICATION_TOKEN_REQUEST = exports.GET_AUTHENTICATION_TOKEN = exports.logout = exports.invalidate = exports.authenticateByToken = exports.authenticateSudoer = exports.authenticate = exports.AUTHENTICATION_INVALIDATE = exports.LOGOUT_FAILURE = exports.LOGOUT_SUCCESS = exports.LOGOUT_REQUEST = exports.LOGOUT = exports.AUTHENTICATION_FAILURE = exports.AUTHENTICATION_SUCCESS = exports.AUTHENTICATION_REQUEST = exports.AUTHENTICATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _api$buildTypes = _api2.default.buildTypes('AUTHENTICATION'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var AUTHENTICATION = _api$buildTypes2[0],
    AUTHENTICATION_REQUEST = _api$buildTypes2[1],
    AUTHENTICATION_SUCCESS = _api$buildTypes2[2],
    AUTHENTICATION_FAILURE = _api$buildTypes2[3];
exports.AUTHENTICATION = AUTHENTICATION;
exports.AUTHENTICATION_REQUEST = AUTHENTICATION_REQUEST;
exports.AUTHENTICATION_SUCCESS = AUTHENTICATION_SUCCESS;
exports.AUTHENTICATION_FAILURE = AUTHENTICATION_FAILURE;

var _api$buildTypes3 = _api2.default.buildTypes('LOGOUT'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var LOGOUT = _api$buildTypes4[0],
    LOGOUT_REQUEST = _api$buildTypes4[1],
    LOGOUT_SUCCESS = _api$buildTypes4[2],
    LOGOUT_FAILURE = _api$buildTypes4[3];
exports.LOGOUT = LOGOUT;
exports.LOGOUT_REQUEST = LOGOUT_REQUEST;
exports.LOGOUT_SUCCESS = LOGOUT_SUCCESS;
exports.LOGOUT_FAILURE = LOGOUT_FAILURE;
var AUTHENTICATION_INVALIDATE = exports.AUTHENTICATION_INVALIDATE = 'AUTHENTICATION_INVALIDATE';

var authenticate = function authenticate(_ref) {
  var teamName = _ref.teamName,
      _ref$username = _ref.username,
      username = _ref$username === undefined ? '' : _ref$username,
      password = _ref.password;

  var _api$defaults$headers = _api2.default.defaults.headers,
      xUserKey = _api$defaults$headers['x-user-key'],
      others = _objectWithoutProperties(_api$defaults$headers, ['x-user-key']);

  return {
    type: AUTHENTICATION,
    payload: {
      url: '/teams/' + teamName + '/auth',
      schema: _schemas.USER,
      options: {
        method: 'POST',
        headers: _extends({}, others),
        body: {
          username: username.toLowerCase(),
          password: password
        }
      }
    }
  };
};

exports.authenticate = authenticate;
var authenticateSudoer = function authenticateSudoer(_ref2) {
  var teamName = _ref2.teamName,
      _ref2$sudoeeUsername = _ref2.sudoeeUsername,
      sudoeeUsername = _ref2$sudoeeUsername === undefined ? '' : _ref2$sudoeeUsername,
      _ref2$sudoerUsername = _ref2.sudoerUsername,
      sudoerUsername = _ref2$sudoerUsername === undefined ? '' : _ref2$sudoerUsername,
      sudoerPassword = _ref2.sudoerPassword;

  var _api$defaults$headers2 = _api2.default.defaults.headers,
      xUserKey = _api$defaults$headers2['x-user-key'],
      others = _objectWithoutProperties(_api$defaults$headers2, ['x-user-key']);

  return {
    type: AUTHENTICATION,
    payload: {
      url: '/teams/' + teamName + '/auth',
      schema: _schemas.USER,
      options: {
        method: 'POST',
        headers: _extends({}, others),
        body: {
          sudoeeUsername: sudoeeUsername.toLowerCase(),
          sudoerUsername: sudoerUsername.toLowerCase(),
          sudoerPassword: sudoerPassword
        }
      }
    }
  };
};

exports.authenticateSudoer = authenticateSudoer;
var authenticateByToken = exports.authenticateByToken = function authenticateByToken(_ref3) {
  var teamName = _ref3.teamName,
      username = _ref3.username,
      token = _ref3.token;
  return {
    type: AUTHENTICATION,
    payload: {
      url: '/teams/' + teamName + '/users/' + username.toLowerCase() + '/auth?token=' + token,
      schema: _schemas.USER
    }
  };
};

var invalidate = exports.invalidate = function invalidate() {
  return {
    type: AUTHENTICATION_INVALIDATE
  };
};

var logout = exports.logout = function logout(_ref4) {
  var teamName = _ref4.teamName,
      username = _ref4.username;
  return {
    type: LOGOUT,
    payload: {
      url: '/teams/' + teamName + '/users/' + username.toLowerCase() + '/logout',
      schema: {},
      options: {
        method: 'POST'
      }
    }
  };
};

var _api$buildTypes5 = _api2.default.buildTypes('GET_AUTHENTICATION_TOKEN'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var GET_AUTHENTICATION_TOKEN = _api$buildTypes6[0],
    GET_AUTHENTICATION_TOKEN_REQUEST = _api$buildTypes6[1],
    GET_AUTHENTICATION_TOKEN_SUCCESS = _api$buildTypes6[2],
    GET_AUTHENTICATION_TOKEN_FAILURE = _api$buildTypes6[3];
exports.GET_AUTHENTICATION_TOKEN = GET_AUTHENTICATION_TOKEN;
exports.GET_AUTHENTICATION_TOKEN_REQUEST = GET_AUTHENTICATION_TOKEN_REQUEST;
exports.GET_AUTHENTICATION_TOKEN_SUCCESS = GET_AUTHENTICATION_TOKEN_SUCCESS;
exports.GET_AUTHENTICATION_TOKEN_FAILURE = GET_AUTHENTICATION_TOKEN_FAILURE;
var getAuthenticationToken = exports.getAuthenticationToken = function getAuthenticationToken(_ref5) {
  var teamName = _ref5.teamName,
      username = _ref5.username;
  return {
    type: GET_AUTHENTICATION_TOKEN,
    payload: {
      url: '/teams/' + teamName + '/users/' + username.toLowerCase() + '/auth',
      schema: _schemas.USER
    }
  };
};

var _api$buildTypes7 = _api2.default.buildTypes('GET_MAGIC_LINK'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var GET_MAGIC_LINK = _api$buildTypes8[0],
    GET_MAGIC_LINK_REQUEST = _api$buildTypes8[1],
    GET_MAGIC_LINK_SUCCESS = _api$buildTypes8[2],
    GET_MAGIC_LINK_FAILURE = _api$buildTypes8[3];
exports.GET_MAGIC_LINK = GET_MAGIC_LINK;
exports.GET_MAGIC_LINK_REQUEST = GET_MAGIC_LINK_REQUEST;
exports.GET_MAGIC_LINK_SUCCESS = GET_MAGIC_LINK_SUCCESS;
exports.GET_MAGIC_LINK_FAILURE = GET_MAGIC_LINK_FAILURE;
var getMagicLink = function getMagicLink(_ref6) {
  var teamName = _ref6.teamName,
      username = _ref6.username;

  var _api$defaults$headers3 = _api2.default.defaults.headers,
      xUserKey = _api$defaults$headers3['x-user-key'],
      others = _objectWithoutProperties(_api$defaults$headers3, ['x-user-key']);

  return {
    type: GET_MAGIC_LINK,
    payload: {
      url: '/teams/' + teamName + '/users/' + username.toLowerCase() + '/auth',
      schema: _schemas.USER,
      options: {
        method: 'GET',
        headers: _extends({}, others)
      }
    }
  };
};

exports.getMagicLink = getMagicLink;

var _api$buildTypes9 = _api2.default.buildTypes('CHECK_AUTH_STATUS'),
    _api$buildTypes10 = _slicedToArray(_api$buildTypes9, 4);

var CHECK_AUTH_STATUS = _api$buildTypes10[0],
    CHECK_AUTH_STATUS_REQUEST = _api$buildTypes10[1],
    CHECK_AUTH_STATUS_SUCCESS = _api$buildTypes10[2],
    CHECK_AUTH_STATUS_FAILURE = _api$buildTypes10[3];
exports.CHECK_AUTH_STATUS = CHECK_AUTH_STATUS;
exports.CHECK_AUTH_STATUS_REQUEST = CHECK_AUTH_STATUS_REQUEST;
exports.CHECK_AUTH_STATUS_SUCCESS = CHECK_AUTH_STATUS_SUCCESS;
exports.CHECK_AUTH_STATUS_FAILURE = CHECK_AUTH_STATUS_FAILURE;
var checkAuthStatus = exports.checkAuthStatus = function checkAuthStatus() {
  return {
    type: CHECK_AUTH_STATUS,
    payload: {
      url: '/auth/session/active',
      schema: {}
    }
  };
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */

var _context = void 0;

try {
  _context = window;
} catch (e) {
  _context = global;
}

var context = _context;

exports["default"] = context;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 94 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(434);
var enumBugKeys = __webpack_require__(270);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(10);
var dPs = __webpack_require__(435);
var enumBugKeys = __webpack_require__(270);
var IE_PROTO = __webpack_require__(269)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(267)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(272).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(434);
var hiddenKeys = __webpack_require__(270).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var dP = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(24);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(45);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(1045);
var ReactInstrumentation = __webpack_require__(55);

var warning = __webpack_require__(16);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(317),
    baseAssignValue = __webpack_require__(198);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(86);

var _Actions = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(79);
var createDesc = __webpack_require__(174);
module.exports = __webpack_require__(88) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(607);
var defined = __webpack_require__(351);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newlyAuthenticatedSSO = exports.newlyAuthenticated = exports.isAdminOrOwner = exports.isTeamAdmin = exports.inviteID = exports.isTeamOwner = exports.userThumbnail = exports.slack = exports.fullName = exports.email = exports.username = exports.phone = exports.experience = exports.notificationPreference = exports.user = exports.userKey = exports.userID = exports.teamName = exports.isSessionAdminOrOwner = exports.session = undefined;

var _reselect = __webpack_require__(33);

var _config = __webpack_require__(752);

var _entities = __webpack_require__(184);

var _url = __webpack_require__(31);

// Returns user session if valid, undefined if not
var session = exports.session = function session() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$session = _ref.session,
      session = _ref$session === undefined ? {} : _ref$session;

  return session.userID ? session : undefined;
};

var isSessionAdminOrOwner = exports.isSessionAdminOrOwner = (0, _reselect.createSelector)(session, function () {
  var session = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return session.isTeamOwner || session.isTeamAdmin;
});

var teamName = exports.teamName = (0, _reselect.createSelector)(session, _config.teamName, function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      teamName = _ref2.teamName;

  var teamNameSelect = arguments[1];
  return teamName || teamNameSelect;
});

var userID = exports.userID = (0, _reselect.createSelector)(session, function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      userID = _ref3.userID;

  return userID;
});

var userKey = exports.userKey = (0, _reselect.createSelector)(session, function () {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      userKey = _ref4.userKey;

  return userKey;
});

var user = exports.user = (0, _reselect.createSelector)([_entities.users, userID], function () {
  var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userID = arguments[1];
  return users[userID] || {};
});

var notificationPreference = exports.notificationPreference = (0, _reselect.createSelector)(user, function () {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return user.notificationPreference;
});

var experience = exports.experience = (0, _reselect.createSelector)(user, function () {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return user.experience;
});

var phone = exports.phone = (0, _reselect.createSelector)(user, function () {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return user.phone;
});

var username = exports.username = (0, _reselect.createSelector)(session, function () {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      username = _ref5.username;

  return username;
});

var email = exports.email = (0, _reselect.createSelector)(user, function (_ref6) {
  var email = _ref6.email;
  return email;
});

var fullName = exports.fullName = (0, _reselect.createSelector)(user, function (_ref7) {
  var fullName = _ref7.fullName;
  return fullName;
});

var slack = exports.slack = (0, _reselect.createSelector)(user, function (_ref8) {
  var slackUsername = _ref8.slackUsername;
  return slackUsername;
});

var userThumbnail = exports.userThumbnail = (0, _reselect.createSelector)(user, teamName, function (_ref9, teamName) {
  var userThumbnail = _ref9.userThumbnail;
  return !userThumbnail ? userThumbnail : (0, _url.getFileUrl)(teamName, userThumbnail);
});

var isTeamOwner = exports.isTeamOwner = (0, _reselect.createSelector)(user, function (_ref10) {
  var isTeamOwner = _ref10.isTeamOwner;
  return isTeamOwner;
});

var inviteID = exports.inviteID = (0, _reselect.createSelector)(session, function (_ref11) {
  var inviteID = _ref11.inviteID;
  return inviteID;
});

var isTeamAdmin = exports.isTeamAdmin = (0, _reselect.createSelector)(user, function () {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return user.isTeamAdmin;
});

var isAdminOrOwner = exports.isAdminOrOwner = (0, _reselect.createSelector)(isTeamOwner, isTeamAdmin, function (owner, admin) {
  return owner || admin;
});

var newlyAuthenticated = exports.newlyAuthenticated = (0, _reselect.createSelector)(session, function () {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      newlyAuthenticated = _ref12.newlyAuthenticated;

  return !!newlyAuthenticated;
});

var newlyAuthenticatedSSO = exports.newlyAuthenticatedSSO = (0, _reselect.createSelector)(session, function () {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      newlyAuthenticatedSSO = _ref13.newlyAuthenticatedSSO;

  return !!newlyAuthenticatedSSO;
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_AUTH_INFO_FAILURE = exports.GET_AUTH_INFO_SUCCESS = exports.GET_AUTH_INFO_REQUEST = exports.GET_AUTH_INFO = exports.GET_SERVICE_PROVIDER_METADATA_FAILURE = exports.GET_SERVICE_PROVIDER_METADATA_SUCCESS = exports.GET_SERVICE_PROVIDER_METADATA_REQUEST = exports.GET_SERVICE_PROVIDER_METADATA = exports.UPDATE_TEAM_FAILURE = exports.UPDATE_TEAM_SUCCESS = exports.UPDATE_TEAM_REQUEST = exports.UPDATE_TEAM = exports.GET_TEAM_FAILURE = exports.GET_TEAM_SUCCESS = exports.GET_TEAM_REQUEST = exports.GET_TEAM = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTeam = getTeam;
exports.updateTeam = updateTeam;
exports.getServiceProviderMetadata = getServiceProviderMetadata;
exports.getAuthInfo = getAuthInfo;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_TEAM'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TEAM = _api$buildTypes2[0],
    GET_TEAM_REQUEST = _api$buildTypes2[1],
    GET_TEAM_SUCCESS = _api$buildTypes2[2],
    GET_TEAM_FAILURE = _api$buildTypes2[3];
exports.GET_TEAM = GET_TEAM;
exports.GET_TEAM_REQUEST = GET_TEAM_REQUEST;
exports.GET_TEAM_SUCCESS = GET_TEAM_SUCCESS;
exports.GET_TEAM_FAILURE = GET_TEAM_FAILURE;
function getTeam(_ref) {
  var teamName = _ref.teamName;

  return {
    type: GET_TEAM,
    payload: {
      url: '/teams/' + teamName,
      schema: _schemas.TEAM
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('UPDATE_TEAM'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var UPDATE_TEAM = _api$buildTypes4[0],
    UPDATE_TEAM_REQUEST = _api$buildTypes4[1],
    UPDATE_TEAM_SUCCESS = _api$buildTypes4[2],
    UPDATE_TEAM_FAILURE = _api$buildTypes4[3];
exports.UPDATE_TEAM = UPDATE_TEAM;
exports.UPDATE_TEAM_REQUEST = UPDATE_TEAM_REQUEST;
exports.UPDATE_TEAM_SUCCESS = UPDATE_TEAM_SUCCESS;
exports.UPDATE_TEAM_FAILURE = UPDATE_TEAM_FAILURE;
function updateTeam(_ref2) {
  var teamName = _ref2.teamName,
      updatedData = _ref2.updatedData;

  return {
    type: UPDATE_TEAM,
    payload: {
      url: '/teams/' + teamName,
      schema: _schemas.TEAM,
      options: {
        method: 'PUT',
        body: updatedData
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('GET_SERVICE_PROVIDER_METADATA'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var GET_SERVICE_PROVIDER_METADATA = _api$buildTypes6[0],
    GET_SERVICE_PROVIDER_METADATA_REQUEST = _api$buildTypes6[1],
    GET_SERVICE_PROVIDER_METADATA_SUCCESS = _api$buildTypes6[2],
    GET_SERVICE_PROVIDER_METADATA_FAILURE = _api$buildTypes6[3];
exports.GET_SERVICE_PROVIDER_METADATA = GET_SERVICE_PROVIDER_METADATA;
exports.GET_SERVICE_PROVIDER_METADATA_REQUEST = GET_SERVICE_PROVIDER_METADATA_REQUEST;
exports.GET_SERVICE_PROVIDER_METADATA_SUCCESS = GET_SERVICE_PROVIDER_METADATA_SUCCESS;
exports.GET_SERVICE_PROVIDER_METADATA_FAILURE = GET_SERVICE_PROVIDER_METADATA_FAILURE;
function getServiceProviderMetadata(_ref3) {
  var teamName = _ref3.teamName;

  return {
    type: GET_SERVICE_PROVIDER_METADATA,
    payload: {
      url: '/teams/' + teamName + '/saml/serviceProviderMetadata'
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('GET_AUTH_INFO'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var GET_AUTH_INFO = _api$buildTypes8[0],
    GET_AUTH_INFO_REQUEST = _api$buildTypes8[1],
    GET_AUTH_INFO_SUCCESS = _api$buildTypes8[2],
    GET_AUTH_INFO_FAILURE = _api$buildTypes8[3];
exports.GET_AUTH_INFO = GET_AUTH_INFO;
exports.GET_AUTH_INFO_REQUEST = GET_AUTH_INFO_REQUEST;
exports.GET_AUTH_INFO_SUCCESS = GET_AUTH_INFO_SUCCESS;
exports.GET_AUTH_INFO_FAILURE = GET_AUTH_INFO_FAILURE;
function getAuthInfo(_ref4) {
  var teamName = _ref4.teamName;

  return {
    type: GET_AUTH_INFO,
    payload: {
      url: '/teams/' + teamName + '/authinfo',
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = exports.easing = undefined;

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-param-reassign */

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easingInternal = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0.0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
  // For snackbar and associated fab transforms.
  snackbar: 'ease-out'
};

// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
var durationInternal = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // Most basic recommended timing.
  standard: 300,
  // This is to be used in complex animations.
  complex: 375,
  // Recommended when something is entering screen.
  enteringScreen: 225,
  // Recommended when something is leaving screen.
  leavingScreen: 195,
  // For snackbar and associated fab transforms.
  snackbar: 400
};

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};

/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */
exports['default'] = {
  easing: easingInternal,

  duration: durationInternal,

  create: function () {
    function create() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _ref$duration = _ref.duration,
          duration = _ref$duration === undefined ? durationInternal.short : _ref$duration,
          _ref$easing = _ref.easing,
          easing = _ref$easing === undefined ? easingInternal.easeInOut : _ref$easing,
          _ref$delay = _ref.delay,
          delay = _ref$delay === undefined ? 0 : _ref$delay,
          other = _objectWithoutProperties(_ref, ['duration', 'easing', 'delay']);

      (0, _warning2['default'])(typeof props === 'string' || Array.isArray(props), 'argument "props" must be a string or Array');
      (0, _warning2['default'])(isNumber(duration), 'argument "duration" must be a number');
      (0, _warning2['default'])(typeof easing === 'string', 'argument "easing" must be a string');
      (0, _warning2['default'])(isNumber(delay), 'argument "delay" must be a string');
      (0, _warning2['default'])(Object.keys(other).length === 0, 'unrecognized argument(s) [' + Object.keys(other).join(',') + ']');

      return (Array.isArray(props) ? props : [props]).map(function (value) {
        return value + ' ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
      }).join(',');
    }

    return create;
  }(),
  getAutoHeightDuration: function () {
    function getAutoHeightDuration(height) {
      if (!height) {
        return 0;
      }

      var constant = height / 36;
      var duration = (4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10;

      return Math.round(duration);
    }

    return getAutoHeightDuration;
  }()
};

/**
 * @deprecated Will be removed, please access via theme.transitions.easing
 */

var easing = exports.easing = easingInternal;
/**
 * @deprecated Will be removed, please access via theme.transitions.duration
 */
var duration = exports.duration = durationInternal;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(115);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(25).f;
var has = __webpack_require__(43);
var TAG = __webpack_require__(19)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(64);
var fails = __webpack_require__(14);
var spaces = __webpack_require__(274);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(19)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(44)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(72);
var call = __webpack_require__(445);
var isArrayIter = __webpack_require__(284);
var anObject = __webpack_require__(10);
var toLength = __webpack_require__(28);
var getIterFn = __webpack_require__(286);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(301);
var setInnerHTML = __webpack_require__(213);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(302);
var setTextContent = __webpack_require__(471);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var ReactCurrentOwner = __webpack_require__(77);

var warning = __webpack_require__(16);
var canDefineProperty = __webpack_require__(478);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(479);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = exports.schema = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Entity = __webpack_require__(1154);

var _Entity2 = _interopRequireDefault(_Entity);

var _Union = __webpack_require__(1155);

var _Union2 = _interopRequireDefault(_Union);

var _Values = __webpack_require__(1156);

var _Values2 = _interopRequireDefault(_Values);

var _Array = __webpack_require__(1157);

var ArrayUtils = _interopRequireWildcard(_Array);

var _Object = __webpack_require__(1158);

var ObjectUtils = _interopRequireWildcard(_Object);

var _ImmutableUtils = __webpack_require__(320);

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var visit = function visit(value, parent, key, schema, addEntity) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || !value) {
    return value;
  }

  if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
    var method = Array.isArray(schema) ? ArrayUtils.normalize : ObjectUtils.normalize;
    return method(schema, value, parent, key, visit, addEntity);
  }

  return schema.normalize(value, parent, key, visit, addEntity);
};

var addEntities = function addEntities(entities) {
  return function (schema, processedEntity, value, parent, key) {
    var schemaKey = schema.key;
    var id = schema.getId(value, parent, key);
    if (!(schemaKey in entities)) {
      entities[schemaKey] = {};
    }

    var existingEntity = entities[schemaKey][id];
    if (existingEntity) {
      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
    } else {
      entities[schemaKey][id] = processedEntity;
    }
  };
};

var schema = exports.schema = {
  Array: ArrayUtils.default,
  Entity: _Entity2.default,
  Object: ObjectUtils.default,
  Union: _Union2.default,
  Values: _Values2.default
};

var normalize = exports.normalize = function normalize(input, schema) {
  if (!input || (typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') {
    throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + '".');
  }

  var entities = {};
  var addEntity = addEntities(entities);

  var result = visit(input, input, null, schema, addEntity);
  return { entities: entities, result: result };
};

var unvisitEntity = function unvisitEntity(input, schema, unvisit, getEntity, cache) {
  var entity = getEntity(input, schema);
  if ((typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) !== 'object' || entity === null) {
    return entity;
  }

  var id = schema.getId(entity);

  if (!cache[schema.key]) {
    cache[schema.key] = {};
  }

  if (!cache[schema.key][id]) {
    // Ensure we don't mutate it non-immutable objects
    var entityCopy = ImmutableUtils.isImmutable(entity) ? entity : _extends({}, entity);

    // Need to set this first so that if it is referenced further within the
    // denormalization the reference will already exist.
    cache[schema.key][id] = entityCopy;
    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
  }

  return cache[schema.key][id];
};

var getUnvisit = function getUnvisit(entities) {
  var cache = {};
  var getEntity = getEntities(entities);

  return function unvisit(input, schema) {
    if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
      var method = Array.isArray(schema) ? ArrayUtils.denormalize : ObjectUtils.denormalize;
      return method(schema, input, unvisit);
    }

    if (input === undefined || input === null) {
      return input;
    }

    if (schema instanceof _Entity2.default) {
      return unvisitEntity(input, schema, unvisit, getEntity, cache);
    }

    return schema.denormalize(input, unvisit);
  };
};

var getEntities = function getEntities(entities) {
  var isImmutable = ImmutableUtils.isImmutable(entities);

  return function (entityOrId, schema) {
    var schemaKey = schema.key;

    if ((typeof entityOrId === 'undefined' ? 'undefined' : _typeof(entityOrId)) === 'object') {
      return entityOrId;
    }

    return isImmutable ? entities.getIn([schemaKey, entityOrId.toString()]) : entities[schemaKey][entityOrId];
  };
};

var denormalize = exports.denormalize = function denormalize(input, schema, entities) {
  if (!input) {
    return input;
  }

  return getUnvisit(entities)(input, schema);
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(322), __webpack_require__(323));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(27),
    isKey = __webpack_require__(326),
    stringToPath = __webpack_require__(530),
    toString = __webpack_require__(328);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(233);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_Index */
/* unused harmony export bpfrpt_proptype_PositionInfo */
/* unused harmony export bpfrpt_proptype_ScrollPosition */
/* unused harmony export bpfrpt_proptype_SizeAndPositionInfo */
/* unused harmony export bpfrpt_proptype_SizeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_Index =  true ? null : {
  index: PropTypes.number.isRequired
};
var bpfrpt_proptype_PositionInfo =  true ? null : {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollPosition =  true ? null : {
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};







/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workDoneBetterNavigationEnabled = exports.webformsV2Enabled = exports.watchListEnabled = exports.urlParametersEnabled = exports.timelineChartEnabled = exports.tasksQueryEnabled = exports.tablePermissionsEnabled = exports.splitPaneEnabled = exports.runPermissionsEnabled = exports.runDetailV2Enabled = exports.pushbotCommentEnabled = exports.manualReportingEnabled = exports.passwordComplexityEnabled = exports.includeDraftApps = exports.frontEndPerformanceMonitoringEnabled = exports.FRONT_END_PERFORMANCE_MONITORING = exports.friendlyFieldsEnabled = exports.formInstructionsEnabled = exports.embeddedModeEnabled = exports.editPushbotEnabled = exports.dataTableFieldEnabled = exports.categoryFilterEnabled = exports.aiModelEnabled = exports.adHocEnabled = exports.createFeatureSelector = exports.feature = exports.reset = exports.identify = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reselect = __webpack_require__(33);

var _launchdarkly = __webpack_require__(525);

var _session = __webpack_require__(117);

var _helpers = __webpack_require__(706);

var _changeCase = __webpack_require__(256);

var identify = exports.identify = (0, _reselect.createSelector)(_session.session, function (session) {
  if (!session) return null;
  var key = session.userID,
      experience = session.experience,
      username = session.username,
      teamName = session.teamName;

  return {
    type: _launchdarkly.LAUNCHDARKLY_IDENTIFY,
    payload: {
      key: key,
      anonymous: false,
      custom: {
        experience: experience,
        teamName: teamName,
        username: username
      }
    }
  };
});

var reset = exports.reset = (0, _reselect.createSelector)(_session.session, function (session) {
  return session ? null : {
    type: _launchdarkly.LAUNCHDARKLY_IDENTIFY,
    payload: _launchdarkly.LAUNCHDARKLY_ANONYMOUS
  };
});

var feature = exports.feature = function feature() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$feature = _ref.feature,
      feature = _ref$feature === undefined ? {} : _ref$feature;

  return feature;
};

var createFeatureSelector = exports.createFeatureSelector = function createFeatureSelector(name) {
  return (0, _reselect.createSelector)((0, _helpers.createPropertySelector)(feature, (0, _changeCase.camelCase)(name)), function (value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null ? value.current : value;
  });
};

var adHocEnabled = exports.adHocEnabled = createFeatureSelector('ad-hoc-tasks');
var aiModelEnabled = exports.aiModelEnabled = createFeatureSelector('ai-model');
var categoryFilterEnabled = exports.categoryFilterEnabled = createFeatureSelector('category-filter');
var dataTableFieldEnabled = exports.dataTableFieldEnabled = createFeatureSelector('data-table-field');
var editPushbotEnabled = exports.editPushbotEnabled = createFeatureSelector('edit-pushbot');
var embeddedModeEnabled = exports.embeddedModeEnabled = createFeatureSelector('pushbot-web-embedded');
var formInstructionsEnabled = exports.formInstructionsEnabled = createFeatureSelector('form-instructions');
var friendlyFieldsEnabled = exports.friendlyFieldsEnabled = createFeatureSelector('friendly-fields');
var FRONT_END_PERFORMANCE_MONITORING = exports.FRONT_END_PERFORMANCE_MONITORING = 'front-end-performance-monitoring';
var frontEndPerformanceMonitoringEnabled = exports.frontEndPerformanceMonitoringEnabled = createFeatureSelector(FRONT_END_PERFORMANCE_MONITORING);
var includeDraftApps = exports.includeDraftApps = createFeatureSelector('draft-apps');
var passwordComplexityEnabled = exports.passwordComplexityEnabled = createFeatureSelector('password-complexity');
var manualReportingEnabled = exports.manualReportingEnabled = createFeatureSelector('manual-reporting');
var pushbotCommentEnabled = exports.pushbotCommentEnabled = createFeatureSelector('pushbot-comment');
var runDetailV2Enabled = exports.runDetailV2Enabled = createFeatureSelector('run-detail-v2');
var runPermissionsEnabled = exports.runPermissionsEnabled = createFeatureSelector('run-permissions');
var splitPaneEnabled = exports.splitPaneEnabled = createFeatureSelector('split-pane');
var tablePermissionsEnabled = exports.tablePermissionsEnabled = createFeatureSelector('data-table-permissions');
var tasksQueryEnabled = exports.tasksQueryEnabled = createFeatureSelector('tasks-query');
var timelineChartEnabled = exports.timelineChartEnabled = createFeatureSelector('timeline-chart');
var urlParametersEnabled = exports.urlParametersEnabled = createFeatureSelector('url-parameters');
var watchListEnabled = exports.watchListEnabled = createFeatureSelector('watch-list');
var webformsV2Enabled = exports.webformsV2Enabled = createFeatureSelector('webforms-v-2');
var workDoneBetterNavigationEnabled = exports.workDoneBetterNavigationEnabled = createFeatureSelector('work-done-better-navigation');

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMenu = exports.MenuList = exports.MenuItem = exports['default'] = undefined;

var _Menu = __webpack_require__(1668);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Menu)['default'];
    }

    return get;
  }()
});

var _MenuItem2 = __webpack_require__(1670);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

var _MenuList2 = __webpack_require__(1671);

var _MenuList3 = _interopRequireDefault(_MenuList2);

var _IconMenu2 = __webpack_require__(721);

var _IconMenu3 = _interopRequireDefault(_IconMenu2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.MenuItem = _MenuItem3['default'];
exports.MenuList = _MenuList3['default'];
exports.IconMenu = _IconMenu3['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(1486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(1493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(1494);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(1495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(1496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(1498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(582);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(1499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(1500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(1501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(581);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paper = exports['default'] = undefined;

var _Paper2 = __webpack_require__(1617);

var _Paper3 = _interopRequireDefault(_Paper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Paper3['default']; /* eslint-disable flowtype/require-valid-file-annotation */

exports.Paper = _Paper3['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(315),
    isLength = __webpack_require__(512);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(216);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = exports.verticalRhythmByUnit = exports.verticalScaledRhythmByPixel = exports.verticalRhythmByPixel = exports.radiusByUnit = exports.radiusByPixel = exports.scaledRhythmByPixel = exports.rhythmByUnit = exports.rhythmByPixel = exports.createVerticalRhythm = exports.createRhythmByUnit = exports.createRhythmByPixel = exports.RADIUS = exports.SCALE = exports.STEP = undefined;
exports['default'] = createTypography;

var _deprecate = __webpack_require__(1339);

var _deprecate2 = _interopRequireDefault(_deprecate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var STEP = exports.STEP = 8;
var SCALE = exports.SCALE = 1.2; // Minor Third
var RADIUS = exports.RADIUS = 0.2;

var createRhythmByPixel = exports.createRhythmByPixel = function createRhythmByPixel(h) {
  return function (v) {
    var r = Math.ceil(v / h) * h;
    return (r === v ? r + h : r) + 'px';
  };
};

var createRhythmByUnit = exports.createRhythmByUnit = function createRhythmByUnit(h) {
  return function (u) {
    return Math.round(parseFloat(u) * h) + 'px';
  };
};

var createVerticalRhythm = exports.createVerticalRhythm = function createVerticalRhythm(fn) {
  return function (v) {
    return {
      fontSize: v,
      lineHeight: fn(v)
    };
  };
};

var rhythmByPixel = exports.rhythmByPixel = createRhythmByPixel(STEP);
var rhythmByUnit = exports.rhythmByUnit = createRhythmByUnit(STEP);
// Used to account for font ascendors and descendors when determining font line height
var scaledRhythmByPixel = exports.scaledRhythmByPixel = function scaledRhythmByPixel(u) {
  return rhythmByPixel(u * SCALE);
};

var radiusByPixel = exports.radiusByPixel = function radiusByPixel(u) {
  return parseInt(rhythmByPixel(u)) * RADIUS + 'px';
};
var radiusByUnit = exports.radiusByUnit = function radiusByUnit(u) {
  return parseInt(rhythmByUnit(u)) * RADIUS + 'px';
};

var verticalRhythmByPixel = exports.verticalRhythmByPixel = createVerticalRhythm(rhythmByPixel);
var verticalScaledRhythmByPixel = exports.verticalScaledRhythmByPixel = createVerticalRhythm(scaledRhythmByPixel);
var verticalRhythmByUnit = exports.verticalRhythmByUnit = createVerticalRhythm(rhythmByUnit);

var deprecateVerticalRhythm = (0, _deprecate2['default'])('verticalRhythm will be removed. Use verticalRhythmByPixel instead.', verticalRhythmByPixel);

var fonts = exports.fonts = {
  monospace: Object.assign({
    fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightHeavy: 600
  }, verticalScaledRhythmByPixel(13)),
  sansSerif: Object.assign({
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightHeavy: 600,
    letterSpacing: 0
  }, verticalScaledRhythmByPixel(13)),
  serif: Object.assign({
    fontFamily: 'Georgia, Times, "Times New Roman", serif',
    fontWeightLight: 100,
    fontWeightRegular: 300,
    fontWeightMedium: 500,
    fontWeightHeavy: 700
  }, verticalScaledRhythmByPixel(13))
};

var defaultConstants = fonts.sansSerif;

function createTypography(palette) {
  var constants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConstants;

  return Object.assign({}, constants, {
    display4: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightLight,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(112)),
    display3: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(56)),
    display2: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(45)),
    display1: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(22)),
    title: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(20)),
    headline: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightMedium,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(15)),
    subheading: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(12)),
    body1: {
      fontSize: fonts.sansSerif.fontSize,
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary,
      lineHeight: fonts.sansSerif.lineHeight
    },
    body2: {
      fontSize: fonts.serif.fontSize,
      fontWeight: fonts.sansSerif.fontWeightMedium,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary,
      lineHeight: fonts.serif.lineHeight
    },
    menugroup: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary,
      textTransform: 'uppercase'
    }, verticalScaledRhythmByPixel(11)),
    caption: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(10)),
    description: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(12)),
    paragraph: {
      marginBottom: rhythmByUnit(1)
    },
    code: Object.assign({}, fonts.monospace, {
      color: palette.text.primary
    }),
    materialIcon: {
      fontFamily: 'Material Icons',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontSize: 24,
      display: 'inline-block',
      lineHeight: 1,
      textTransform: 'none'
    },
    highlight: {
      color: palette.text.highlight
    },
    disabled: {
      color: palette.text.disabled
    },
    error: {
      fontStyle: 'normal',
      color: palette.text.error
    },
    success: {
      color: palette.text.success
    },
    primary: {
      color: palette.text.primary
    },
    secondary: {
      color: palette.text.secondary
    },
    radiusByPixel: radiusByPixel,
    radiusByUnit: radiusByUnit,
    rhythmByPixel: rhythmByPixel,
    rhythmByUnit: rhythmByUnit,
    verticalRhythmByPixel: verticalRhythmByPixel,
    verticalScaledRhythmByPixel: verticalScaledRhythmByPixel,
    verticalRhythmByUnit: verticalRhythmByUnit,
    verticalRhythm: deprecateVerticalRhythm
  });
}

/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(58);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(58);
var TAG = __webpack_require__(19)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(161);
var EventPluginUtils = __webpack_require__(295);

var accumulateInto = __webpack_require__(463);
var forEachAccumulated = __webpack_require__(464);
var warning = __webpack_require__(16);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var EventPluginRegistry = __webpack_require__(294);
var EventPluginUtils = __webpack_require__(295);
var ReactErrorUtils = __webpack_require__(296);

var accumulateInto = __webpack_require__(463);
var forEachAccumulated = __webpack_require__(464);
var invariant = __webpack_require__(9);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(76);

var getEventTarget = __webpack_require__(297);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    getPrototype = __webpack_require__(505),
    isObjectLike = __webpack_require__(107);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */
var LANGUAGES = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      '\u0130': '\u0069',
      '\u0049': '\u0131',
      '\u0049\u0307': '\u0069'
    }
  },
  az: {
    regexp: /[\u0130]/g,
    map: {
      '\u0130': '\u0069',
      '\u0049': '\u0131',
      '\u0049\u0307': '\u0069'
    }
  },
  lt: {
    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
    map: {
      '\u0049': '\u0069\u0307',
      '\u004A': '\u006A\u0307',
      '\u012E': '\u012F\u0307',
      '\u00CC': '\u0069\u0307\u0300',
      '\u00CD': '\u0069\u0307\u0301',
      '\u0128': '\u0069\u0307\u0303'
    }
  }
}

/**
 * Lowercase a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  var lang = LANGUAGES[locale]

  str = str == null ? '' : String(str)

  if (lang) {
    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
  }

  return str.toLowerCase()
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var func = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
    object = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
    arrayOf = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType,
    element = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element,
    shape = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape,
    string = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string;


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = oneOfType([func, string]);
var components = oneOfType([component, object]);
var route = oneOfType([object, element]);
var routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1574)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(603)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(606);
var enumBugKeys = __webpack_require__(358);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(351);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestAnimationTimeout; });
/* unused harmony export bpfrpt_proptype_AnimationTimeoutId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animationFrame__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  id: PropTypes.number.isRequired
};


var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["a" /* caf */])(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = void 0;
  // wait for end of processing current event handler, because event handler may be long
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout)
  };

  return frame;
};



/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellDataGetterParams */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRowRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRendererParams */
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellDataGetterParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  cellData: PropTypes.any,
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_HeaderRendererParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  disableSort: PropTypes.bool,
  label: PropTypes.any,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string
};
var bpfrpt_proptype_RowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onRowMouseOver: PropTypes.func,
  onRowMouseOut: PropTypes.func,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};







/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_intl_format_cache__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */








// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var locales = Array.isArray(data) ? data : [data];

    locales.forEach(function (localeData) {
        if (localeData && localeData.locale) {
            __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
            __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
        }
    });
}

function hasLocaleData(locale) {
    var localeParts = (locale || '').split('-');

    while (localeParts.length > 0) {
        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
            return true;
        }

        localeParts.pop();
    }

    return false;
}

function hasIMFAndIRFLocaleData(locale) {
    var normalizedLocale = locale && locale.toLowerCase();

    return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].bool;
var number = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].number;
var string = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].string;
var func = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].func;
var object = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].shape;
var any = __WEBPACK_IMPORTED_MODULE_3_react__["PropTypes"].any;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
    locale: string,
    formats: object,
    messages: object,
    textComponent: any,

    defaultLocale: string,
    defaultFormats: object
};

var intlFormatPropTypes = {
    formatDate: funcReq,
    formatTime: funcReq,
    formatRelative: funcReq,
    formatNumber: funcReq,
    formatPlural: funcReq,
    formatMessage: funcReq,
    formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
    formatters: object,
    now: funcReq
}));

var messageDescriptorPropTypes = {
    id: string.isRequired,
    description: string,
    defaultMessage: string
};

var dateTimeFormatPropTypes = {
    localeMatcher: localeMatcher,
    formatMatcher: oneOf(['basic', 'best fit']),

    timeZone: string,
    hour12: bool,

    weekday: narrowShortLong,
    era: narrowShortLong,
    year: numeric2digit,
    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
    day: numeric2digit,
    hour: numeric2digit,
    minute: numeric2digit,
    second: numeric2digit,
    timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
    localeMatcher: localeMatcher,

    style: oneOf(['decimal', 'currency', 'percent']),
    currency: string,
    currencyDisplay: oneOf(['symbol', 'code', 'name']),
    useGrouping: bool,

    minimumIntegerDigits: number,
    minimumFractionDigits: number,
    maximumFractionDigits: number,
    minimumSignificantDigits: number,
    maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
    style: oneOf(['best fit', 'numeric']),
    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
    style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
    '&': '&amp;',
    '>': '&gt;',
    '<': '&lt;',
    '"': '&quot;',
    '\'': '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
        return ESCAPED_CHARS[match];
    });
}

function filterProps(props, whitelist) {
    var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return whitelist.reduce(function (filtered, name) {
        if (props.hasOwnProperty(name)) {
            filtered[name] = props[name];
        } else if (defaults$$1.hasOwnProperty(name)) {
            filtered[name] = defaults$$1[name];
        }

        return filtered;
    }, {});
}

function invariantIntlContext() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        intl = _ref.intl;

    __WEBPACK_IMPORTED_MODULE_4_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
    if (objA === objB) {
        return true;
    }

    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < keysA.length; i++) {
        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
        }
    }

    return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
    var props = _ref2.props,
        state = _ref2.state,
        _ref2$context = _ref2.context,
        context = _ref2$context === undefined ? {} : _ref2$context;
    var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _context$intl = context.intl,
        intl = _context$intl === undefined ? {} : _context$intl;
    var _nextContext$intl = nextContext.intl,
        nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
    return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$intlPropName = options.intlPropName,
        intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
        _options$withRef = options.withRef,
        withRef = _options$withRef === undefined ? false : _options$withRef;

    var InjectIntl = function (_Component) {
        inherits(InjectIntl, _Component);

        function InjectIntl(props, context) {
            classCallCheck(this, InjectIntl);

            var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

            invariantIntlContext(context);
            return _this;
        }

        createClass(InjectIntl, [{
            key: 'getWrappedInstance',
            value: function getWrappedInstance() {
                __WEBPACK_IMPORTED_MODULE_4_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

                return this.refs.wrappedInstance;
            }
        }, {
            key: 'render',
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
                    ref: withRef ? 'wrappedInstance' : null
                }));
            }
        }]);
        return InjectIntl;
    }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
    InjectIntl.contextTypes = {
        intl: intlShape
    };
    InjectIntl.WrappedComponent = WrappedComponent;


    return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlPluralFormat);

    var useOrdinal = options.style === 'ordinal';
    var pluralFn = findPluralFunction(resolveLocale(locales));

    this.format = function (value) {
        return pluralFn(value, useOrdinal);
    };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
    second: 60, // seconds to minute
    minute: 60, // minutes to hour
    hour: 24, // hours to day
    day: 30, // days to month
    month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
    var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
    thresholds.second = newThresholds.second;
    thresholds.minute = newThresholds.minute;
    thresholds.hour = newThresholds.hour;
    thresholds.day = newThresholds.day;
    thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
    var format = formats && formats[type] && formats[type][name];
    if (format) {
        return format;
    }

    if (false) {
        console.error('[React Intl] No ' + type + ' format named: ' + name);
    }
}

function formatDate(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'date', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting date.\n' + e);
        }
    }

    return String(date);
}

function formatTime(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'time', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
    }

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting time.\n' + e);
        }
    }

    return String(date);
}

function formatRelative(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var now = new Date(options.now);
    var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

    // Capture the current threshold values, then temporarily override them with
    // specific values just for this render.
    var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

    try {
        return state.getRelativeFormat(locale, filteredOptions).format(date, {
            now: isFinite(now) ? now : state.now()
        });
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting relative time.\n' + e);
        }
    } finally {
        updateRelativeFormatThresholds(oldThresholds);
    }

    return String(date);
}

function formatNumber(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var defaults$$1 = format && getNamedFormat(formats, 'number', format);
    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getNumberFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting number.\n' + e);
        }
    }

    return String(value);
}

function formatPlural(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale;


    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

    try {
        return state.getPluralFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting plural.\n' + e);
        }
    }

    return 'other';
}

function formatMessage(config, state) {
    var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats,
        messages = config.messages,
        defaultLocale = config.defaultLocale,
        defaultFormats = config.defaultFormats;
    var id = messageDescriptor.id,
        defaultMessage = messageDescriptor.defaultMessage;

    // `id` is a required field of a Message Descriptor.

    __WEBPACK_IMPORTED_MODULE_4_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

    var message = messages && messages[id];
    var hasValues = Object.keys(values).length > 0;

    // Avoid expensive message formatting for simple messages without values. In
    // development messages will always be formatted in case of missing values.
    if (!hasValues && "production" === 'production') {
        return message || defaultMessage || id;
    }

    var formattedMessage = void 0;

    if (message) {
        try {
            var formatter = state.getMessageFormat(message, locale, formats);

            formattedMessage = formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
            }
        }
    } else {
        if (false) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale, and a default message is in the source.
            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {

                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
            }
        }
    }

    if (!formattedMessage && defaultMessage) {
        try {
            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

            formattedMessage = _formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
            }
        }
    }

    if (!formattedMessage) {
        if (false) {
            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
        }
    }

    return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
    var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // Process all the values before they are used when formatting the ICU
    // Message string. Since the formatted message might be injected via
    // `innerHTML`, all String-based values need to be HTML-escaped.
    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
        var value = rawValues[name];
        escaped[name] = typeof value === 'string' ? escape(value) : value;
        return escaped;
    }, {});

    return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
    formats: {},
    messages: {},
    textComponent: 'span',

    defaultLocale: 'en',
    defaultFormats: {}
};

var IntlProvider = function (_Component) {
    inherits(IntlProvider, _Component);

    function IntlProvider(props) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        classCallCheck(this, IntlProvider);

        var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

        __WEBPACK_IMPORTED_MODULE_4_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

        var intlContext = context.intl;

        // Used to stabilize time when performing an initial rendering so that
        // all relative times use the same reference "now" time.

        var initialNow = void 0;
        if (isFinite(props.initialNow)) {
            initialNow = Number(props.initialNow);
        } else {
            // When an `initialNow` isn't provided via `props`, look to see an
            // <IntlProvider> exists in the ancestry and call its `now()`
            // function to propagate its value for "now".
            initialNow = intlContext ? intlContext.now() : Date.now();
        }

        // Creating `Intl*` formatters is expensive. If there's a parent
        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
        // memoize the `Intl*` constructors and cache them for the lifecycle of
        // this IntlProvider instance.

        var _ref = intlContext || {},
            _ref$formatters = _ref.formatters,
            formatters = _ref$formatters === undefined ? {
            getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(Intl.DateTimeFormat),
            getNumberFormat: __WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(Intl.NumberFormat),
            getMessageFormat: __WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
            getRelativeFormat: __WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
            getPluralFormat: __WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(IntlPluralFormat)
        } : _ref$formatters;

        _this.state = _extends({}, formatters, {

            // Wrapper to provide stable "now" time for initial render.
            now: function now() {
                return _this._didDisplay ? Date.now() : initialNow;
            }
        });
        return _this;
    }

    createClass(IntlProvider, [{
        key: 'getConfig',
        value: function getConfig() {
            var intlContext = this.context.intl;

            // Build a whitelisted config object from `props`, defaults, and
            // `context.intl`, if an <IntlProvider> exists in the ancestry.

            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

            // Apply default props. This must be applied last after the props have
            // been resolved and inherited from any <IntlProvider> in the ancestry.
            // This matches how React resolves `defaultProps`.
            for (var propName in defaultProps) {
                if (config[propName] === undefined) {
                    config[propName] = defaultProps[propName];
                }
            }

            if (!hasLocaleData(config.locale)) {
                var _config = config,
                    locale = _config.locale,
                    defaultLocale = _config.defaultLocale,
                    defaultFormats = _config.defaultFormats;


                if (false) {
                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
                }

                // Since there's no registered locale data for `locale`, this will
                // fallback to the `defaultLocale` to make sure things can render.
                // The `messages` are overridden to the `defaultProps` empty object
                // to maintain referential equality across re-renders. It's assumed
                // each <FormattedMessage> contains a `defaultMessage` prop.
                config = _extends({}, config, {
                    locale: defaultLocale,
                    formats: defaultFormats,
                    messages: defaultProps.messages
                });
            }

            return config;
        }
    }, {
        key: 'getBoundFormatFns',
        value: function getBoundFormatFns(config, state) {
            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
                boundFormatFns[name] = format[name].bind(null, config, state);
                return boundFormatFns;
            }, {});
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            var config = this.getConfig();

            // Bind intl factories and current config to the format functions.
            var boundFormatFns = this.getBoundFormatFns(config, this.state);

            var _state = this.state,
                now = _state.now,
                formatters = objectWithoutProperties(_state, ['now']);


            return {
                intl: _extends({}, config, boundFormatFns, {
                    formatters: formatters,
                    now: now
                })
            };
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._didDisplay = true;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_3_react__["Children"].only(this.props.children);
        }
    }]);
    return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
    intl: intlShape
};
IntlProvider.childContextTypes = {
    intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
    children: PropTypes.element.isRequired,
    initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
    inherits(FormattedDate, _Component);

    function FormattedDate(props, context) {
        classCallCheck(this, FormattedDate);

        var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedDate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatDate = _context$intl.formatDate,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedDate = formatDate(value, this.props);

            if (typeof children === 'function') {
                return children(formattedDate);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                Text,
                null,
                formattedDate
            );
        }
    }]);
    return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
    intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
    inherits(FormattedTime, _Component);

    function FormattedTime(props, context) {
        classCallCheck(this, FormattedTime);

        var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedTime, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatTime = _context$intl.formatTime,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedTime = formatTime(value, this.props);

            if (typeof children === 'function') {
                return children(formattedTime);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                Text,
                null,
                formattedTime
            );
        }
    }]);
    return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
    intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
    var absDelta = Math.abs(delta);

    if (absDelta < MINUTE) {
        return 'second';
    }

    if (absDelta < HOUR) {
        return 'minute';
    }

    if (absDelta < DAY) {
        return 'hour';
    }

    // The maximum scheduled delay will be measured in days since the maximum
    // timer delay is less than the number of milliseconds in 25 days.
    return 'day';
}

function getUnitDelay(units) {
    switch (units) {
        case 'second':
            return SECOND;
        case 'minute':
            return MINUTE;
        case 'hour':
            return HOUR;
        case 'day':
            return DAY;
        default:
            return MAX_TIMER_DELAY;
    }
}

function isSameDate(a, b) {
    if (a === b) {
        return true;
    }

    var aTime = new Date(a).getTime();
    var bTime = new Date(b).getTime();

    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
    inherits(FormattedRelative, _Component);

    function FormattedRelative(props, context) {
        classCallCheck(this, FormattedRelative);

        var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

        invariantIntlContext(context);

        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

        // `now` is stored as state so that `render()` remains a function of
        // props + state, instead of accessing `Date.now()` inside `render()`.
        _this.state = { now: now };
        return _this;
    }

    createClass(FormattedRelative, [{
        key: 'scheduleNextUpdate',
        value: function scheduleNextUpdate(props, state) {
            var _this2 = this;

            var updateInterval = props.updateInterval;

            // If the `updateInterval` is falsy, including `0`, then auto updates
            // have been turned off, so we bail and skip scheduling an update.

            if (!updateInterval) {
                return;
            }

            var time = new Date(props.value).getTime();
            var delta = time - state.now;
            var units = props.units || selectUnits(delta);

            var unitDelay = getUnitDelay(units);
            var unitRemainder = Math.abs(delta % unitDelay);

            // We want the largest possible timer delay which will still display
            // accurate information while reducing unnecessary re-renders. The delay
            // should be until the next "interesting" moment, like a tick from
            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

            clearTimeout(this._timer);

            this._timer = setTimeout(function () {
                _this2.setState({ now: _this2.context.intl.now() });
            }, delay);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scheduleNextUpdate(this.props, this.state);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var nextValue = _ref.value;

            // When the `props.value` date changes, `state.now` needs to be updated,
            // and the next update can be rescheduled.
            if (!isSameDate(nextValue, this.props.value)) {
                this.setState({ now: this.context.intl.now() });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            this.scheduleNextUpdate(nextProps, nextState);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this._timer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatRelative = _context$intl.formatRelative,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

            if (typeof children === 'function') {
                return children(formattedRelative);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                Text,
                null,
                formattedRelative
            );
        }
    }]);
    return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
    intl: intlShape
};
FormattedRelative.defaultProps = {
    updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    updateInterval: PropTypes.number,
    initialNow: PropTypes.any,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
    inherits(FormattedNumber, _Component);

    function FormattedNumber(props, context) {
        classCallCheck(this, FormattedNumber);

        var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedNumber, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatNumber = _context$intl.formatNumber,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedNumber = formatNumber(value, this.props);

            if (typeof children === 'function') {
                return children(formattedNumber);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                Text,
                null,
                formattedNumber
            );
        }
    }]);
    return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
    intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
    inherits(FormattedPlural, _Component);

    function FormattedPlural(props, context) {
        classCallCheck(this, FormattedPlural);

        var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedPlural, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatPlural = _context$intl.formatPlural,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                other = _props.other,
                children = _props.children;


            var pluralCategory = formatPlural(value, this.props);
            var formattedPlural = this.props[pluralCategory] || other;

            if (typeof children === 'function') {
                return children(formattedPlural);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                Text,
                null,
                formattedPlural
            );
        }
    }]);
    return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
    intl: intlShape
};
FormattedPlural.defaultProps = {
    style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
    value: PropTypes.any.isRequired,

    other: PropTypes.node.isRequired,
    zero: PropTypes.node,
    one: PropTypes.node,
    two: PropTypes.node,
    few: PropTypes.node,
    many: PropTypes.node,

    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
    inherits(FormattedMessage, _Component);

    function FormattedMessage(props, context) {
        classCallCheck(this, FormattedMessage);

        var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatMessage = _context$intl.formatMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                values = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var tokenDelimiter = void 0;
            var tokenizedValues = void 0;
            var elements = void 0;

            var hasValues = values && Object.keys(values).length > 0;
            if (hasValues) {
                (function () {
                    // Creates a token with a random UID that should not be guessable or
                    // conflict with other parts of the `message` string.
                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

                    var generateToken = function () {
                        var counter = 0;
                        return function () {
                            return 'ELEMENT-' + uid + '-' + (counter += 1);
                        };
                    }();

                    // Splitting with a delimiter to support IE8. When using a regex
                    // with a capture group IE8 does not include the capture group in
                    // the resulting array.
                    tokenDelimiter = '@__' + uid + '__@';
                    tokenizedValues = {};
                    elements = {};

                    // Iterates over the `props` to keep track of any React Element
                    // values so they can be represented by the `token` as a placeholder
                    // when the `message` is formatted. This allows the formatted
                    // message to then be broken-up into parts with references to the
                    // React Elements inserted back in.
                    Object.keys(values).forEach(function (name) {
                        var value = values[name];

                        if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(value)) {
                            var token = generateToken();
                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
                            elements[token] = value;
                        } else {
                            tokenizedValues[name] = value;
                        }
                    });
                })();
            }

            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

            var nodes = void 0;

            var hasElements = elements && Object.keys(elements).length > 0;
            if (hasElements) {
                // Split the message into parts so the React Element values captured
                // above can be inserted back into the rendered message. This
                // approach allows messages to render with React Elements while
                // keeping React's virtual diffing working properly.
                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
                    return !!part;
                }).map(function (part) {
                    return elements[part] || part;
                });
            } else {
                nodes = [formattedMessage];
            }

            if (typeof children === 'function') {
                return children.apply(undefined, toConsumableArray(nodes));
            }

            // Needs to use `createElement()` instead of JSX, otherwise React will
            // warn about a missing `key` prop with rich-text message formatting.
            return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
        }
    }]);
    return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
    intl: intlShape
};
FormattedMessage.defaultProps = {
    values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
    inherits(FormattedHTMLMessage, _Component);

    function FormattedHTMLMessage(props, context) {
        classCallCheck(this, FormattedHTMLMessage);

        var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedHTMLMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatHTMLMessage = _context$intl.formatHTMLMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                rawValues = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

            if (typeof children === 'function') {
                return children(formattedHTMLMessage);
            }

            // Since the message presumably has HTML in it, we need to set
            // `innerHTML` in order for it to be rendered and not escaped by React.
            // To be safe, all string prop values were escaped when formatting the
            // message. It is assumed that the message is not UGC, and came from the
            // developer making it more like a template.
            //
            // Note: There's a perf impact of using this component since there's no
            // way for React to do its virtual DOM diffing.
            var html = { __html: formattedHTMLMessage };
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
        }
    }]);
    return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
    intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
    values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _history = __webpack_require__(1479);

var _reactRouter = __webpack_require__(148);

var _useEmbeddedPathname = __webpack_require__(1502);

var _useEmbeddedPathname2 = _interopRequireDefault(_useEmbeddedPathname);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRouter.useRouterHistory)((0, _useEmbeddedPathname2.default)(_history.createHistory))();

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toast = toast;
exports.clearToast = clearToast;
var START_TOAST = exports.START_TOAST = 'START_TOAST';
var CLEAR_TOAST = exports.CLEAR_TOAST = 'CLEAR_TOAST';

function toast(_ref) {
  var _ref$action = _ref.action,
      action = _ref$action === undefined ? '' : _ref$action,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? '' : _ref$message,
      _ref$onActionClick = _ref.onActionClick,
      onActionClick = _ref$onActionClick === undefined ? function () {} : _ref$onActionClick,
      error = _ref.error,
      autoHideDuration = _ref.autoHideDuration;

  return {
    type: START_TOAST,
    action: action,
    message: message,
    onActionClick: onActionClick,
    error: error,
    autoHideDuration: autoHideDuration
  };
}

function clearToast() {
  return {
    type: CLEAR_TOAST
  };
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchesDeep = exports.createCredentialsTransformSelector = exports.credentialsListDeep = exports.credentialsDeep = exports.credentialsList = exports.credentials = exports.createFiltersTransformSelector = exports.filtersListDeep = exports.filtersDeep = exports.filtersList = exports.filters = exports.createVisibleFieldsTransformSelector = exports.visibleFieldsListDeep = exports.visibleFieldsDeep = exports.visibleFieldsList = exports.visibleFields = exports.createFilesTransformSelector = exports.fileListDeep = exports.filesDeep = exports.filesList = exports.files = exports.createWebhooksTransformSelector = exports.webhooksListDeep = exports.webhooksDeep = exports.webhooksList = exports.webhooks = exports.createUsersTransformSelector = exports.usersListDeep = exports.usersDeep = exports.usersList = exports.users = exports.createTriggersTransformSelector = exports.triggersListDeep = exports.triggersDeep = exports.triggersList = undefined;
exports.triggers = exports.createThreadsTransformSelector = exports.threadsListDeep = exports.threadsDeep = exports.threadsList = exports.threads = exports.createTeamsTransformSelector = exports.teamsListDeep = exports.teamsDeep = exports.teamsList = exports.teams = exports.createTableRowsTransformSelector = exports.tableRowsListDeep = exports.tableRowsDeep = exports.tableRowsList = exports.tableRows = exports.createTablesTransformSelector = exports.tablesListDeep = exports.tablesDeep = exports.tablesList = exports.tables = exports.createStepTransformSelector = exports.stepsListDeep = exports.stepsDeep = exports.stepsList = exports.steps = exports.createTasksTransformSelector = exports.tasksListDeep = exports.tasksDeep = exports.tasksList = exports.tasks = exports.createRunsTransformSelector = exports.runsListDeep = exports.runsDeep = exports.runsList = exports.runs = exports.createRunBaseTransformSelector = exports.runBaseListDeep = exports.runBaseDeep = exports.runBaseList = exports.runBase = exports.createProcessesTransformSelector = exports.processesListDeep = exports.processesDeep = exports.processesList = exports.processes = exports.createPredictorsTransformSelector = exports.predictorsListDeep = exports.predictorsDeep = exports.predictorsList = exports.predictors = exports.createNotificationsTransformSelector = exports.notificationsListDeep = exports.notificationsDeep = exports.notificationsList = exports.notifications = exports.createCommentsTransformSelector = exports.commentsListDeep = exports.commentsDeep = exports.commentsList = exports.comments = exports.createMessagesTransformSelector = exports.messagesListDeep = exports.messagesDeep = exports.messagesList = exports.messages = exports.createInvitesTransformSelector = exports.invitesListDeep = exports.invitesDeep = exports.invitesList = exports.invites = exports.createIntegrationsTransformSelector = exports.integrationsListDeep = exports.integrationsDeep = exports.integrationsList = exports.integrations = exports.createGroupsTransformSelector = exports.groupsListDeep = exports.groupsDeep = exports.groupsList = exports.groups = exports.createFieldsTransformSelector = exports.fieldsListDeep = exports.fieldsDeep = exports.fieldsList = exports.fields = exports.createContactsTransformSelector = exports.contactsListDeep = exports.contactsDeep = exports.contactsList = exports.contacts = exports.createAppsTransformSelector = exports.appsListDeep = exports.appsDeep = exports.appsList = exports.apps = exports.createTypeSelector = exports.createTransformSelector = exports.entities = exports.PUSHBOT_COMMENTS_DATE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _reselect = __webpack_require__(33);

var _normalizr = __webpack_require__(132);

var _schemas = __webpack_require__(8);

var schemas = _interopRequireWildcard(_schemas);

var _selectors = __webpack_require__(1204);

var _username = __webpack_require__(754);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Only display pushbot comments after July 11, 2018
// following deployment of @catalytic/pushbot-api#5397
var PUSHBOT_COMMENTS_DATE = exports.PUSHBOT_COMMENTS_DATE = new Date(2018, 6, 11);

var entities = exports.entities = function entities() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$entities = _ref.entities,
      entities = _ref$entities === undefined ? {} : _ref$entities;

  return entities;
};

// Helpers
var toList = function toList(obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var getTree = function getTree(name) {
  var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : entities;
  return (0, _selectors.createPropertyEqualSelector)(name)(tree, function () {
    var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return tree;
  });
};
var getType = function getType(name) {
  var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : entities;
  return (0, _reselect.createSelector)(tree, function () {
    var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return tree[name];
  });
};
var getTypeAsList = function getTypeAsList(selector) {
  return (0, _selectors.createDeepEqualSelector)(selector, function (results) {
    return !results ? results : toList(results);
  });
};
var getTypeDeepAsList = function getTypeDeepAsList(selector, schema) {
  var tree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : entities;

  return (0, _reselect.createSelector)(tree, selector, function () {
    var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var entities = arguments[1];

    return !entities ? entities : entities.map(function (entity) {
      return (0, _normalizr.denormalize)(entity, schema, tree);
    });
  });
};
var getTypeDeep = function getTypeDeep(selector) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return (0, _reselect.createSelector)(selector, function (results) {
    return !results ? results : schemas.mapEntitiesByID(results, id);
  });
};

var createTransformSelector = exports.createTransformSelector = function createTransformSelector(id, type, typeList, typeDeep, typeDeepList) {
  return function (transform) {
    var select = (0, _reselect.createSelector)(type, function (values) {
      return !values ? values : schemas.mapEntitiesByID(transform(toList(values)), id);
    });
    var selectList = (0, _reselect.createSelector)(typeList, function (values) {
      return !values ? values : transform(values);
    });
    var selectDeep = (0, _reselect.createSelector)(typeDeep, function (values) {
      return !values ? values : schemas.mapEntitiesByID(transform(toList(values)), id);
    });
    var selectDeepList = (0, _reselect.createSelector)(typeDeepList, function (values) {
      return !values ? values : transform(values);
    });
    return [select, selectList, selectDeep, selectDeepList, createTransformSelector(id, select, selectList, selectDeep, selectDeepList)];
  };
};

var createTypeSelector = exports.createTypeSelector = function createTypeSelector(schema) {
  var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : entities;

  var name = schema.key;
  var id = schema.getIdAttribute();
  var typeTree = getTree(name, tree);
  var type = getType(name, typeTree);
  var typeList = getTypeAsList(type, id);
  var typeDeepList = getTypeDeepAsList(typeList, schema, typeTree, id);
  var typeDeep = getTypeDeep(typeDeepList, id);
  return [type, typeList, typeDeep, typeDeepList, createTransformSelector(id, type, typeList, typeDeep, typeDeepList)];
};

var _createTypeSelector = createTypeSelector(schemas.APP),
    _createTypeSelector2 = _slicedToArray(_createTypeSelector, 5);

var apps = _createTypeSelector2[0],
    appsList = _createTypeSelector2[1],
    appsDeep = _createTypeSelector2[2],
    appsListDeep = _createTypeSelector2[3],
    createAppsTransformSelector = _createTypeSelector2[4];
exports.apps = apps;
exports.appsList = appsList;
exports.appsDeep = appsDeep;
exports.appsListDeep = appsListDeep;
exports.createAppsTransformSelector = createAppsTransformSelector;

var _createTypeSelector3 = createTypeSelector(schemas.CONTACT),
    _createTypeSelector4 = _slicedToArray(_createTypeSelector3, 5);

var contacts = _createTypeSelector4[0],
    contactsList = _createTypeSelector4[1],
    contactsDeep = _createTypeSelector4[2],
    contactsListDeep = _createTypeSelector4[3],
    createContactsTransformSelector = _createTypeSelector4[4];
exports.contacts = contacts;
exports.contactsList = contactsList;
exports.contactsDeep = contactsDeep;
exports.contactsListDeep = contactsListDeep;
exports.createContactsTransformSelector = createContactsTransformSelector;

var _createTypeSelector5 = createTypeSelector(schemas.FIELD),
    _createTypeSelector6 = _slicedToArray(_createTypeSelector5, 5);

var fields = _createTypeSelector6[0],
    fieldsList = _createTypeSelector6[1],
    fieldsDeep = _createTypeSelector6[2],
    fieldsListDeep = _createTypeSelector6[3],
    createFieldsTransformSelector = _createTypeSelector6[4];
exports.fields = fields;
exports.fieldsList = fieldsList;
exports.fieldsDeep = fieldsDeep;
exports.fieldsListDeep = fieldsListDeep;
exports.createFieldsTransformSelector = createFieldsTransformSelector;

var _createTypeSelector7 = createTypeSelector(schemas.GROUP),
    _createTypeSelector8 = _slicedToArray(_createTypeSelector7, 5);

var groups = _createTypeSelector8[0],
    groupsList = _createTypeSelector8[1],
    groupsDeep = _createTypeSelector8[2],
    groupsListDeep = _createTypeSelector8[3],
    createGroupsTransformSelector = _createTypeSelector8[4];
exports.groups = groups;
exports.groupsList = groupsList;
exports.groupsDeep = groupsDeep;
exports.groupsListDeep = groupsListDeep;
exports.createGroupsTransformSelector = createGroupsTransformSelector;

var _createTypeSelector9 = createTypeSelector(schemas.INTEGRATION),
    _createTypeSelector10 = _slicedToArray(_createTypeSelector9, 5);

var integrations = _createTypeSelector10[0],
    integrationsList = _createTypeSelector10[1],
    integrationsDeep = _createTypeSelector10[2],
    integrationsListDeep = _createTypeSelector10[3],
    createIntegrationsTransformSelector = _createTypeSelector10[4];
exports.integrations = integrations;
exports.integrationsList = integrationsList;
exports.integrationsDeep = integrationsDeep;
exports.integrationsListDeep = integrationsListDeep;
exports.createIntegrationsTransformSelector = createIntegrationsTransformSelector;

var _createTypeSelector11 = createTypeSelector(schemas.INVITE),
    _createTypeSelector12 = _slicedToArray(_createTypeSelector11, 5);

var invites = _createTypeSelector12[0],
    invitesList = _createTypeSelector12[1],
    invitesDeep = _createTypeSelector12[2],
    invitesListDeep = _createTypeSelector12[3],
    createInvitesTransformSelector = _createTypeSelector12[4];
exports.invites = invites;
exports.invitesList = invitesList;
exports.invitesDeep = invitesDeep;
exports.invitesListDeep = invitesListDeep;
exports.createInvitesTransformSelector = createInvitesTransformSelector;

var _createTypeSelector13 = createTypeSelector(schemas.MESSAGE),
    _createTypeSelector14 = _slicedToArray(_createTypeSelector13, 5);

var messages = _createTypeSelector14[0],
    messagesList = _createTypeSelector14[1],
    messagesDeep = _createTypeSelector14[2],
    messagesListDeep = _createTypeSelector14[3],
    createMessagesTransformSelector = _createTypeSelector14[4];
exports.messages = messages;
exports.messagesList = messagesList;
exports.messagesDeep = messagesDeep;
exports.messagesListDeep = messagesListDeep;
exports.createMessagesTransformSelector = createMessagesTransformSelector;

var _createMessagesTransf = createMessagesTransformSelector(function (entities) {
  return entities.filter(function (_ref2) {
    var username = _ref2.username,
        timestamp = _ref2.timestamp;
    return !(0, _username.isReservedName)(username) || username === 'public' || username === 'pushbot' && new Date(timestamp) > PUSHBOT_COMMENTS_DATE;
  });
}),
    _createMessagesTransf2 = _slicedToArray(_createMessagesTransf, 5);

var comments = _createMessagesTransf2[0],
    commentsList = _createMessagesTransf2[1],
    commentsDeep = _createMessagesTransf2[2],
    commentsListDeep = _createMessagesTransf2[3],
    createCommentsTransformSelector = _createMessagesTransf2[4];
exports.comments = comments;
exports.commentsList = commentsList;
exports.commentsDeep = commentsDeep;
exports.commentsListDeep = commentsListDeep;
exports.createCommentsTransformSelector = createCommentsTransformSelector;

var _createTypeSelector15 = createTypeSelector(schemas.NOTIFICATION),
    _createTypeSelector16 = _slicedToArray(_createTypeSelector15, 5);

var notifications = _createTypeSelector16[0],
    notificationsList = _createTypeSelector16[1],
    notificationsDeep = _createTypeSelector16[2],
    notificationsListDeep = _createTypeSelector16[3],
    createNotificationsTransformSelector = _createTypeSelector16[4];
exports.notifications = notifications;
exports.notificationsList = notificationsList;
exports.notificationsDeep = notificationsDeep;
exports.notificationsListDeep = notificationsListDeep;
exports.createNotificationsTransformSelector = createNotificationsTransformSelector;

var _createTypeSelector17 = createTypeSelector(schemas.PREDICTOR),
    _createTypeSelector18 = _slicedToArray(_createTypeSelector17, 5);

var predictors = _createTypeSelector18[0],
    predictorsList = _createTypeSelector18[1],
    predictorsDeep = _createTypeSelector18[2],
    predictorsListDeep = _createTypeSelector18[3],
    createPredictorsTransformSelector = _createTypeSelector18[4];
exports.predictors = predictors;
exports.predictorsList = predictorsList;
exports.predictorsDeep = predictorsDeep;
exports.predictorsListDeep = predictorsListDeep;
exports.createPredictorsTransformSelector = createPredictorsTransformSelector;

var _createTypeSelector19 = createTypeSelector(schemas.PROCESS),
    _createTypeSelector20 = _slicedToArray(_createTypeSelector19, 5);

var processes = _createTypeSelector20[0],
    processesList = _createTypeSelector20[1],
    processesDeep = _createTypeSelector20[2],
    processesListDeep = _createTypeSelector20[3],
    createProcessesTransformSelector = _createTypeSelector20[4];
exports.processes = processes;
exports.processesList = processesList;
exports.processesDeep = processesDeep;
exports.processesListDeep = processesListDeep;
exports.createProcessesTransformSelector = createProcessesTransformSelector;

var _createTypeSelector21 = createTypeSelector(schemas.RUN),
    _createTypeSelector22 = _slicedToArray(_createTypeSelector21, 5);

var runBase = _createTypeSelector22[0],
    runBaseList = _createTypeSelector22[1],
    runBaseDeep = _createTypeSelector22[2],
    runBaseListDeep = _createTypeSelector22[3],
    createRunBaseTransformSelector = _createTypeSelector22[4];
exports.runBase = runBase;
exports.runBaseList = runBaseList;
exports.runBaseDeep = runBaseDeep;
exports.runBaseListDeep = runBaseListDeep;
exports.createRunBaseTransformSelector = createRunBaseTransformSelector;

var _createRunBaseTransfo = createRunBaseTransformSelector(function (entities) {
  return entities.map(function (entity) {
    var _entity$threadID = entity.threadID,
        threadID = _entity$threadID === undefined ? {} : _entity$threadID;


    if ((typeof threadID === 'undefined' ? 'undefined' : _typeof(threadID)) !== 'object') {
      return _extends({
        commentCount: 0
      }, entity);
    }

    var _threadID$messages = threadID.messages,
        messages = _threadID$messages === undefined ? [] : _threadID$messages;

    var commentCount = messages.filter(function (_ref3) {
      var username = _ref3.username;
      return !(0, _username.isReservedName)(username);
    }).length;
    return _extends({
      commentCount: commentCount
    }, entity);
  });
}),
    _createRunBaseTransfo2 = _slicedToArray(_createRunBaseTransfo, 5);

var runs = _createRunBaseTransfo2[0],
    runsList = _createRunBaseTransfo2[1],
    runsDeep = _createRunBaseTransfo2[2],
    runsListDeep = _createRunBaseTransfo2[3],
    createRunsTransformSelector = _createRunBaseTransfo2[4];
exports.runs = runs;
exports.runsList = runsList;
exports.runsDeep = runsDeep;
exports.runsListDeep = runsListDeep;
exports.createRunsTransformSelector = createRunsTransformSelector;

var _createTypeSelector23 = createTypeSelector(schemas.TASK),
    _createTypeSelector24 = _slicedToArray(_createTypeSelector23, 5);

var tasks = _createTypeSelector24[0],
    tasksList = _createTypeSelector24[1],
    tasksDeep = _createTypeSelector24[2],
    tasksListDeep = _createTypeSelector24[3],
    createTasksTransformSelector = _createTypeSelector24[4];
exports.tasks = tasks;
exports.tasksList = tasksList;
exports.tasksDeep = tasksDeep;
exports.tasksListDeep = tasksListDeep;
exports.createTasksTransformSelector = createTasksTransformSelector;

var _createTypeSelector25 = createTypeSelector(schemas.STEP),
    _createTypeSelector26 = _slicedToArray(_createTypeSelector25, 5);

var steps = _createTypeSelector26[0],
    stepsList = _createTypeSelector26[1],
    stepsDeep = _createTypeSelector26[2],
    stepsListDeep = _createTypeSelector26[3],
    createStepTransformSelector = _createTypeSelector26[4];
exports.steps = steps;
exports.stepsList = stepsList;
exports.stepsDeep = stepsDeep;
exports.stepsListDeep = stepsListDeep;
exports.createStepTransformSelector = createStepTransformSelector;

var _createTypeSelector27 = createTypeSelector(schemas.TABLE),
    _createTypeSelector28 = _slicedToArray(_createTypeSelector27, 5);

var tables = _createTypeSelector28[0],
    tablesList = _createTypeSelector28[1],
    tablesDeep = _createTypeSelector28[2],
    tablesListDeep = _createTypeSelector28[3],
    createTablesTransformSelector = _createTypeSelector28[4];
exports.tables = tables;
exports.tablesList = tablesList;
exports.tablesDeep = tablesDeep;
exports.tablesListDeep = tablesListDeep;
exports.createTablesTransformSelector = createTablesTransformSelector;

var _createTypeSelector29 = createTypeSelector(schemas.TABLE_ROW),
    _createTypeSelector30 = _slicedToArray(_createTypeSelector29, 5);

var tableRows = _createTypeSelector30[0],
    tableRowsList = _createTypeSelector30[1],
    tableRowsDeep = _createTypeSelector30[2],
    tableRowsListDeep = _createTypeSelector30[3],
    createTableRowsTransformSelector = _createTypeSelector30[4];
exports.tableRows = tableRows;
exports.tableRowsList = tableRowsList;
exports.tableRowsDeep = tableRowsDeep;
exports.tableRowsListDeep = tableRowsListDeep;
exports.createTableRowsTransformSelector = createTableRowsTransformSelector;

var _createTypeSelector31 = createTypeSelector(schemas.TEAM),
    _createTypeSelector32 = _slicedToArray(_createTypeSelector31, 5);

var teams = _createTypeSelector32[0],
    teamsList = _createTypeSelector32[1],
    teamsDeep = _createTypeSelector32[2],
    teamsListDeep = _createTypeSelector32[3],
    createTeamsTransformSelector = _createTypeSelector32[4];
exports.teams = teams;
exports.teamsList = teamsList;
exports.teamsDeep = teamsDeep;
exports.teamsListDeep = teamsListDeep;
exports.createTeamsTransformSelector = createTeamsTransformSelector;

var _createTypeSelector33 = createTypeSelector(schemas.THREAD),
    _createTypeSelector34 = _slicedToArray(_createTypeSelector33, 5);

var threads = _createTypeSelector34[0],
    threadsList = _createTypeSelector34[1],
    threadsDeep = _createTypeSelector34[2],
    threadsListDeep = _createTypeSelector34[3],
    createThreadsTransformSelector = _createTypeSelector34[4];
exports.threads = threads;
exports.threadsList = threadsList;
exports.threadsDeep = threadsDeep;
exports.threadsListDeep = threadsListDeep;
exports.createThreadsTransformSelector = createThreadsTransformSelector;

var _createTypeSelector35 = createTypeSelector(schemas.TRIGGER),
    _createTypeSelector36 = _slicedToArray(_createTypeSelector35, 5);

var triggers = _createTypeSelector36[0],
    triggersList = _createTypeSelector36[1],
    triggersDeep = _createTypeSelector36[2],
    triggersListDeep = _createTypeSelector36[3],
    createTriggersTransformSelector = _createTypeSelector36[4];
exports.triggers = triggers;
exports.triggersList = triggersList;
exports.triggersDeep = triggersDeep;
exports.triggersListDeep = triggersListDeep;
exports.createTriggersTransformSelector = createTriggersTransformSelector;

var _createTypeSelector37 = createTypeSelector(schemas.USER),
    _createTypeSelector38 = _slicedToArray(_createTypeSelector37, 5);

var users = _createTypeSelector38[0],
    usersList = _createTypeSelector38[1],
    usersDeep = _createTypeSelector38[2],
    usersListDeep = _createTypeSelector38[3],
    createUsersTransformSelector = _createTypeSelector38[4];
exports.users = users;
exports.usersList = usersList;
exports.usersDeep = usersDeep;
exports.usersListDeep = usersListDeep;
exports.createUsersTransformSelector = createUsersTransformSelector;

var _createTypeSelector39 = createTypeSelector(schemas.WEBHOOK),
    _createTypeSelector40 = _slicedToArray(_createTypeSelector39, 5);

var webhooks = _createTypeSelector40[0],
    webhooksList = _createTypeSelector40[1],
    webhooksDeep = _createTypeSelector40[2],
    webhooksListDeep = _createTypeSelector40[3],
    createWebhooksTransformSelector = _createTypeSelector40[4];
exports.webhooks = webhooks;
exports.webhooksList = webhooksList;
exports.webhooksDeep = webhooksDeep;
exports.webhooksListDeep = webhooksListDeep;
exports.createWebhooksTransformSelector = createWebhooksTransformSelector;

var _createTypeSelector41 = createTypeSelector(schemas.FILE),
    _createTypeSelector42 = _slicedToArray(_createTypeSelector41, 5);

var files = _createTypeSelector42[0],
    filesList = _createTypeSelector42[1],
    filesDeep = _createTypeSelector42[2],
    fileListDeep = _createTypeSelector42[3],
    createFilesTransformSelector = _createTypeSelector42[4];
exports.files = files;
exports.filesList = filesList;
exports.filesDeep = filesDeep;
exports.fileListDeep = fileListDeep;
exports.createFilesTransformSelector = createFilesTransformSelector;

var _createTypeSelector43 = createTypeSelector(schemas.VISIBLE_FIELD),
    _createTypeSelector44 = _slicedToArray(_createTypeSelector43, 5);

var visibleFields = _createTypeSelector44[0],
    visibleFieldsList = _createTypeSelector44[1],
    visibleFieldsDeep = _createTypeSelector44[2],
    visibleFieldsListDeep = _createTypeSelector44[3],
    createVisibleFieldsTransformSelector = _createTypeSelector44[4];
exports.visibleFields = visibleFields;
exports.visibleFieldsList = visibleFieldsList;
exports.visibleFieldsDeep = visibleFieldsDeep;
exports.visibleFieldsListDeep = visibleFieldsListDeep;
exports.createVisibleFieldsTransformSelector = createVisibleFieldsTransformSelector;

var _createTypeSelector45 = createTypeSelector(schemas.FILTER),
    _createTypeSelector46 = _slicedToArray(_createTypeSelector45, 5);

var filters = _createTypeSelector46[0],
    filtersList = _createTypeSelector46[1],
    filtersDeep = _createTypeSelector46[2],
    filtersListDeep = _createTypeSelector46[3],
    createFiltersTransformSelector = _createTypeSelector46[4];

// TODO this will be deprecated after https://github.com/catalyticlabs/pushbot-api/pull/6643

exports.filters = filters;
exports.filtersList = filtersList;
exports.filtersDeep = filtersDeep;
exports.filtersListDeep = filtersListDeep;
exports.createFiltersTransformSelector = createFiltersTransformSelector;

var _createTypeSelector47 = createTypeSelector(schemas.CREDENTIAL),
    _createTypeSelector48 = _slicedToArray(_createTypeSelector47, 5);

var credentials = _createTypeSelector48[0],
    credentialsList = _createTypeSelector48[1],
    credentialsDeep = _createTypeSelector48[2],
    credentialsListDeep = _createTypeSelector48[3],
    createCredentialsTransformSelector = _createTypeSelector48[4];
exports.credentials = credentials;
exports.credentialsList = credentialsList;
exports.credentialsDeep = credentialsDeep;
exports.credentialsListDeep = credentialsListDeep;
exports.createCredentialsTransformSelector = createCredentialsTransformSelector;
var searchesDeep = exports.searchesDeep = (0, _reselect.createSelector)(processesDeep, runsDeep, tablesDeep, tasksDeep, function (processes, runs, tables, tasks) {
  return { processes: processes, runs: runs, tables: tables, tasks: tasks };
});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRun = exports.UPDATE_RUN_FAILURE = exports.UPDATE_RUN_SUCCESS = exports.UPDATE_RUN_REQUEST = exports.UPDATE_RUN = exports.ADD_RUN_FAILURE = exports.ADD_RUN_SUCCESS = exports.ADD_RUN_REQUEST = exports.ADD_RUN = exports.GET_RUN_FAILURE = exports.GET_RUN_SUCCESS = exports.GET_RUN_REQUEST = exports.GET_RUN = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // eslint-disable-line no-unused-vars


exports.getRun = getRun;
exports.getRunProgress = getRunProgress;
exports.addRun = addRun;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _normalizr = __webpack_require__(132);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_RUN'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_RUN = _api$buildTypes2[0],
    GET_RUN_REQUEST = _api$buildTypes2[1],
    GET_RUN_SUCCESS = _api$buildTypes2[2],
    GET_RUN_FAILURE = _api$buildTypes2[3];
exports.GET_RUN = GET_RUN;
exports.GET_RUN_REQUEST = GET_RUN_REQUEST;
exports.GET_RUN_SUCCESS = GET_RUN_SUCCESS;
exports.GET_RUN_FAILURE = GET_RUN_FAILURE;


function runUrl(teamName, runID, withChildren) {
  var url = '/teams/' + teamName + '/runs/' + runID;
  if (withChildren) {
    url += '?includeChildren=true&includeDownloadUrls=true';
  }
  return url;
}

function getRun(_ref) {
  var teamName = _ref.teamName,
      runID = _ref.runID,
      _ref$withChildren = _ref.withChildren,
      withChildren = _ref$withChildren === undefined ? false : _ref$withChildren;

  return {
    type: GET_RUN,
    payload: {
      url: runUrl(teamName, runID, withChildren),
      schema: _schemas.RUN,
      options: {
        method: 'GET'
      }
    }
  };
}

function getRunProgress(_ref2) {
  var teamName = _ref2.teamName,
      runID = _ref2.runID,
      progressSecret = _ref2.progressSecret;

  return {
    type: GET_RUN,
    payload: {
      url: 'teams/' + teamName + '/runs/' + runID + '/progress/' + progressSecret,
      schema: _schemas.RUN,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_RUN'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_RUN = _api$buildTypes4[0],
    ADD_RUN_REQUEST = _api$buildTypes4[1],
    ADD_RUN_SUCCESS = _api$buildTypes4[2],
    ADD_RUN_FAILURE = _api$buildTypes4[3];
exports.ADD_RUN = ADD_RUN;
exports.ADD_RUN_REQUEST = ADD_RUN_REQUEST;
exports.ADD_RUN_SUCCESS = ADD_RUN_SUCCESS;
exports.ADD_RUN_FAILURE = ADD_RUN_FAILURE;
function addRun(_ref3) {
  var teamName = _ref3.teamName,
      data = _ref3.data;

  return {
    type: ADD_RUN,
    payload: {
      url: '/teams/' + teamName + '/runs/',
      schema: _schemas.RUN,
      options: {
        method: 'POST',
        body: data
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_RUN'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_RUN = _api$buildTypes6[0],
    UPDATE_RUN_REQUEST = _api$buildTypes6[1],
    UPDATE_RUN_SUCCESS = _api$buildTypes6[2],
    UPDATE_RUN_FAILURE = _api$buildTypes6[3];
exports.UPDATE_RUN = UPDATE_RUN;
exports.UPDATE_RUN_REQUEST = UPDATE_RUN_REQUEST;
exports.UPDATE_RUN_SUCCESS = UPDATE_RUN_SUCCESS;
exports.UPDATE_RUN_FAILURE = UPDATE_RUN_FAILURE;
var updateRun = exports.updateRun = function updateRun(_ref4) {
  var teamName = _ref4.teamName,
      runID = _ref4.runID,
      _ref4$run = _ref4.run,
      run = _ref4$run === undefined ? {} : _ref4$run,
      _ref4$withChildren = _ref4.withChildren,
      withChildren = _ref4$withChildren === undefined ? false : _ref4$withChildren;
  return {
    type: UPDATE_RUN,
    payload: {
      url: runUrl(teamName, runID, withChildren),
      schema: _schemas.RUN,
      options: {
        method: 'PUT',
        body: run
      }
    }
  };
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = exports.FormControl = exports.FormLabel = exports.FormGroup = exports['default'] = undefined;

var _Form2 = __webpack_require__(1634);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Form2)['default'];
    }

    return get;
  }()
});

var _FormGroup2 = __webpack_require__(826);

var _FormGroup3 = _interopRequireDefault(_FormGroup2);

var _FormLabel2 = __webpack_require__(1636);

var _FormLabel3 = _interopRequireDefault(_FormLabel2);

var _FormControl2 = __webpack_require__(827);

var _FormControl3 = _interopRequireDefault(_FormControl2);

var _Form3 = _interopRequireDefault(_Form2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.FormGroup = _FormGroup3['default'];
exports.FormLabel = _FormLabel3['default'];
exports.FormControl = _FormControl3['default'];
exports.Form = _Form3['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNLOCK_USER_FAILURE = exports.UNLOCK_USER_SUCCESS = exports.UNLOCK_USER_REQUEST = exports.UNLOCK_USER = exports.DELETE_USER_FAILURE = exports.DELETE_USER_SUCCESS = exports.DELETE_USER_REQUEST = exports.DELETE_USER = exports.UPDATE_USER_FAILURE = exports.UPDATE_USER_SUCCESS = exports.UPDATE_USER_REQUEST = exports.UPDATE_USER = exports.GET_USER_FAILURE = exports.GET_USER_SUCCESS = exports.GET_USER_REQUEST = exports.GET_USER = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getUser = getUser;
exports.updateUser = updateUser;
exports.deleteUser = deleteUser;
exports.unlockUser = unlockUser;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_USER'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_USER = _api$buildTypes2[0],
    GET_USER_REQUEST = _api$buildTypes2[1],
    GET_USER_SUCCESS = _api$buildTypes2[2],
    GET_USER_FAILURE = _api$buildTypes2[3];
exports.GET_USER = GET_USER;
exports.GET_USER_REQUEST = GET_USER_REQUEST;
exports.GET_USER_SUCCESS = GET_USER_SUCCESS;
exports.GET_USER_FAILURE = GET_USER_FAILURE;
function getUser(_ref) {
  var teamName = _ref.teamName,
      _ref$username = _ref.username,
      username = _ref$username === undefined ? 'me' : _ref$username;

  return {
    type: GET_USER,
    payload: {
      url: '/teams/' + teamName + '/users/' + username,
      schema: _schemas.USER
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('UPDATE_USER'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var UPDATE_USER = _api$buildTypes4[0],
    UPDATE_USER_REQUEST = _api$buildTypes4[1],
    UPDATE_USER_SUCCESS = _api$buildTypes4[2],
    UPDATE_USER_FAILURE = _api$buildTypes4[3];
exports.UPDATE_USER = UPDATE_USER;
exports.UPDATE_USER_REQUEST = UPDATE_USER_REQUEST;
exports.UPDATE_USER_SUCCESS = UPDATE_USER_SUCCESS;
exports.UPDATE_USER_FAILURE = UPDATE_USER_FAILURE;
function updateUser(_ref2) {
  var teamName = _ref2.teamName,
      userData = _ref2.userData,
      _ref2$username = _ref2.username,
      username = _ref2$username === undefined ? 'me' : _ref2$username;

  return {
    type: UPDATE_USER,
    payload: {
      url: '/teams/' + teamName + '/users/' + username,
      schema: _schemas.USER,
      options: {
        method: 'PUT',
        body: userData
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('DELETE_USER'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var DELETE_USER = _api$buildTypes6[0],
    DELETE_USER_REQUEST = _api$buildTypes6[1],
    DELETE_USER_SUCCESS = _api$buildTypes6[2],
    DELETE_USER_FAILURE = _api$buildTypes6[3];
exports.DELETE_USER = DELETE_USER;
exports.DELETE_USER_REQUEST = DELETE_USER_REQUEST;
exports.DELETE_USER_SUCCESS = DELETE_USER_SUCCESS;
exports.DELETE_USER_FAILURE = DELETE_USER_FAILURE;
function deleteUser(_ref3) {
  var teamName = _ref3.teamName,
      _ref3$username = _ref3.username,
      username = _ref3$username === undefined ? 'me' : _ref3$username;

  return {
    type: DELETE_USER,
    payload: {
      url: '/teams/' + teamName + '/users/' + username,
      schema: _schemas.USER,
      options: {
        method: 'DELETE'
      }
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('UNLOCK_USER'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var UNLOCK_USER = _api$buildTypes8[0],
    UNLOCK_USER_REQUEST = _api$buildTypes8[1],
    UNLOCK_USER_SUCCESS = _api$buildTypes8[2],
    UNLOCK_USER_FAILURE = _api$buildTypes8[3];
exports.UNLOCK_USER = UNLOCK_USER;
exports.UNLOCK_USER_REQUEST = UNLOCK_USER_REQUEST;
exports.UNLOCK_USER_SUCCESS = UNLOCK_USER_SUCCESS;
exports.UNLOCK_USER_FAILURE = UNLOCK_USER_FAILURE;
function unlockUser(_ref4) {
  var teamName = _ref4.teamName,
      username = _ref4.username;

  return {
    type: UNLOCK_USER,
    payload: {
      url: '/teams/' + teamName + '/users/' + username + '/login-lock',
      schema: _schemas.USER,
      options: {
        method: 'DELETE'
      }
    }
  };
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_AD_HOC_TASK_FAILURE = exports.ADD_AD_HOC_TASK_SUCCESS = exports.ADD_AD_HOC_TASK_REQUEST = exports.ADD_AD_HOC_TASK = exports.reopenTask = exports.REOPEN_TASK_FAILURE = exports.REOPEN_TASK_SUCCESS = exports.REOPEN_TASK_REQUEST = exports.REOPEN_TASK = exports.updateTaskRole = exports.waitTask = exports.rejectTask = exports.skipTask = exports.completeTask = exports.COMPLETE_TASK_FAILURE = exports.COMPLETE_TASK_SUCCESS = exports.COMPLETE_TASK_REQUEST = exports.COMPLETE_TASK = exports.updateTask = exports.UPDATE_TASK_FAILURE = exports.UPDATE_TASK_SUCCESS = exports.UPDATE_TASK_REQUEST = exports.UPDATE_TASK = exports.ADD_TASK_FAILURE = exports.ADD_TASK_SUCCESS = exports.ADD_TASK_REQUEST = exports.ADD_TASK = exports.GET_TASK_FAILURE = exports.GET_TASK_SUCCESS = exports.GET_TASK_REQUEST = exports.GET_TASK = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTask = getTask;
exports.getTaskByID = getTaskByID;
exports.addTask = addTask;
exports.createAdHocTask = createAdHocTask;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _url = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _api$buildTypes = _api2.default.buildTypes('GET_TASK'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TASK = _api$buildTypes2[0],
    GET_TASK_REQUEST = _api$buildTypes2[1],
    GET_TASK_SUCCESS = _api$buildTypes2[2],
    GET_TASK_FAILURE = _api$buildTypes2[3];
exports.GET_TASK = GET_TASK;
exports.GET_TASK_REQUEST = GET_TASK_REQUEST;
exports.GET_TASK_SUCCESS = GET_TASK_SUCCESS;
exports.GET_TASK_FAILURE = GET_TASK_FAILURE;
function getTask(_ref) {
  var teamName = _ref.teamName,
      runID = _ref.runID,
      taskName = _ref.taskName;

  return {
    type: GET_TASK,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/tasks/' + taskName,
      schema: _schemas.TASK,
      options: {
        method: 'GET'
      }
    }
  };
}

function getTaskByID(_ref2) {
  var teamName = _ref2.teamName,
      taskID = _ref2.taskID;

  return {
    type: GET_TASK,
    payload: {
      url: '/teams/' + teamName + '/tasks/' + taskID,
      schema: _schemas.TASK,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_TASK'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_TASK = _api$buildTypes4[0],
    ADD_TASK_REQUEST = _api$buildTypes4[1],
    ADD_TASK_SUCCESS = _api$buildTypes4[2],
    ADD_TASK_FAILURE = _api$buildTypes4[3];
exports.ADD_TASK = ADD_TASK;
exports.ADD_TASK_REQUEST = ADD_TASK_REQUEST;
exports.ADD_TASK_SUCCESS = ADD_TASK_SUCCESS;
exports.ADD_TASK_FAILURE = ADD_TASK_FAILURE;
function addTask(_ref3) {
  var teamName = _ref3.teamName,
      runID = _ref3.runID,
      _ref3$task = _ref3.task,
      task = _ref3$task === undefined ? {} : _ref3$task;

  return {
    type: ADD_TASK,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/tasks',
      schema: _schemas.TASK,
      options: {
        method: 'POST',
        body: task
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_TASK'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_TASK = _api$buildTypes6[0],
    UPDATE_TASK_REQUEST = _api$buildTypes6[1],
    UPDATE_TASK_SUCCESS = _api$buildTypes6[2],
    UPDATE_TASK_FAILURE = _api$buildTypes6[3];
exports.UPDATE_TASK = UPDATE_TASK;
exports.UPDATE_TASK_REQUEST = UPDATE_TASK_REQUEST;
exports.UPDATE_TASK_SUCCESS = UPDATE_TASK_SUCCESS;
exports.UPDATE_TASK_FAILURE = UPDATE_TASK_FAILURE;
var updateTask = exports.updateTask = function updateTask(_ref4) {
  var teamName = _ref4.teamName,
      runID = _ref4.runID,
      taskName = _ref4.taskName,
      _ref4$task = _ref4.task,
      task = _ref4$task === undefined ? {} : _ref4$task;
  return {
    type: UPDATE_TASK,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/tasks/' + taskName,
      schema: _schemas.TASK,
      options: {
        method: 'PUT',
        body: task
      }
    }
  };
};

var _api$buildTypes7 = _api2.default.buildTypes('COMPLETE_TASK'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var COMPLETE_TASK = _api$buildTypes8[0],
    COMPLETE_TASK_REQUEST = _api$buildTypes8[1],
    COMPLETE_TASK_SUCCESS = _api$buildTypes8[2],
    COMPLETE_TASK_FAILURE = _api$buildTypes8[3];
exports.COMPLETE_TASK = COMPLETE_TASK;
exports.COMPLETE_TASK_REQUEST = COMPLETE_TASK_REQUEST;
exports.COMPLETE_TASK_SUCCESS = COMPLETE_TASK_SUCCESS;
exports.COMPLETE_TASK_FAILURE = COMPLETE_TASK_FAILURE;
var completeTask = exports.completeTask = function completeTask(_ref5) {
  var teamName = _ref5.teamName,
      runID = _ref5.runID,
      taskName = _ref5.taskName,
      body = _ref5.body;
  return {
    type: COMPLETE_TASK,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/tasks/' + taskName + '/complete',
      schema: _schemas.TASK,
      options: {
        method: 'POST',
        body: body
      }
    }
  };
};

var skipTask = function skipTask(_ref6) {
  var _ref6$task = _ref6.task,
      task = _ref6$task === undefined ? {} : _ref6$task,
      options = _objectWithoutProperties(_ref6, ['task']);

  return updateTask(_extends({}, options, {
    task: _extends({}, task, { status: 'skipped' })
  }));
};

exports.skipTask = skipTask;
var rejectTask = function rejectTask(_ref7, reason) {
  var _ref7$task = _ref7.task,
      task = _ref7$task === undefined ? {} : _ref7$task,
      options = _objectWithoutProperties(_ref7, ['task']);

  return updateTask(_extends({}, options, {
    task: _extends({}, task, { status: 'rejected', reason: reason })
  }));
};

exports.rejectTask = rejectTask;
var waitTask = function waitTask(_ref8, requiredPreviousTasks) {
  var _ref8$task = _ref8.task,
      task = _ref8$task === undefined ? {} : _ref8$task,
      options = _objectWithoutProperties(_ref8, ['task']);

  return updateTask(_extends({}, options, {
    task: _extends({}, task, { status: 'waiting', requiredPreviousTasks: requiredPreviousTasks })
  }));
};

exports.waitTask = waitTask;
var updateTaskRole = exports.updateTaskRole = function updateTaskRole(_ref9) {
  var teamName = _ref9.teamName,
      runID = _ref9.runID,
      taskName = _ref9.taskName,
      _ref9$role = _ref9.role,
      role = _ref9$role === undefined ? {} : _ref9$role;
  return {
    type: UPDATE_TASK,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/tasks/' + taskName + '/role',
      options: {
        method: 'PUT',
        body: role
      }
    }
  };
};

var _api$buildTypes9 = _api2.default.buildTypes('REOPEN_TASK'),
    _api$buildTypes10 = _slicedToArray(_api$buildTypes9, 4);

var REOPEN_TASK = _api$buildTypes10[0],
    REOPEN_TASK_REQUEST = _api$buildTypes10[1],
    REOPEN_TASK_SUCCESS = _api$buildTypes10[2],
    REOPEN_TASK_FAILURE = _api$buildTypes10[3];
exports.REOPEN_TASK = REOPEN_TASK;
exports.REOPEN_TASK_REQUEST = REOPEN_TASK_REQUEST;
exports.REOPEN_TASK_SUCCESS = REOPEN_TASK_SUCCESS;
exports.REOPEN_TASK_FAILURE = REOPEN_TASK_FAILURE;
var reopenTask = exports.reopenTask = function reopenTask(_ref10) {
  var teamName = _ref10.teamName,
      runID = _ref10.runID,
      task = _ref10.task;

  var url = (0, _url.format)({
    pathname: '/teams/' + teamName + '/runs/' + runID + '/reopen',
    query: {
      includeSkipped: true,
      optional: true
    }
  });
  return {
    type: REOPEN_TASK,
    payload: {
      url: url,
      schema: _schemas.RUN,
      options: {
        method: 'POST',
        body: { tasks: [task] }
      }
    }
  };
};

var _api$buildTypes11 = _api2.default.buildTypes('ADD_AD_HOC_TASK'),
    _api$buildTypes12 = _slicedToArray(_api$buildTypes11, 4);

var ADD_AD_HOC_TASK = _api$buildTypes12[0],
    ADD_AD_HOC_TASK_REQUEST = _api$buildTypes12[1],
    ADD_AD_HOC_TASK_SUCCESS = _api$buildTypes12[2],
    ADD_AD_HOC_TASK_FAILURE = _api$buildTypes12[3];
exports.ADD_AD_HOC_TASK = ADD_AD_HOC_TASK;
exports.ADD_AD_HOC_TASK_REQUEST = ADD_AD_HOC_TASK_REQUEST;
exports.ADD_AD_HOC_TASK_SUCCESS = ADD_AD_HOC_TASK_SUCCESS;
exports.ADD_AD_HOC_TASK_FAILURE = ADD_AD_HOC_TASK_FAILURE;
function createAdHocTask(_ref11) {
  var teamName = _ref11.teamName,
      _ref11$task = _ref11.task,
      task = _ref11$task === undefined ? {} : _ref11$task;

  return {
    type: ADD_AD_HOC_TASK,
    payload: {
      url: '/teams/' + teamName + '/tasks',
      schema: _schemas.TASK,
      options: {
        method: 'POST',
        body: task
      }
    }
  };
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape; // eslint-disable-line no-unused-vars

exports.default = oneOfType([bool, shape({
  current: bool,
  previous: bool
})]);

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(318),
    overRest = __webpack_require__(515),
    setToString = __webpack_require__(516);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = /*#__PURE__*/__webpack_require__(260);

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
module.exports = _curry1;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1132);
exports.encode = exports.stringify = __webpack_require__(1133);


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1277),
    isFlattenable = __webpack_require__(1278);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(122);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _reactDom = __webpack_require__(29);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _keycode = __webpack_require__(147);

var _keycode2 = _interopRequireDefault(_keycode);

var _keyboardFocus = __webpack_require__(1638);

var _Ripple = __webpack_require__(1639);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ButtonBase', function () {
  return {
    buttonBase: {
      position: 'relative',
      WebkitTapHighlightColor: 'rgba(0,0,0,0.0)',
      outline: 'none',
      border: 0,
      cursor: 'pointer',
      userSelect: 'none',
      appearance: 'none',
      textDecoration: 'none'
    },
    disabled: {
      cursor: 'not-allowed'
    }
  };
});

var ButtonBase = (_temp2 = _class = function (_Component) {
  _inherits(ButtonBase, _Component);

  function ButtonBase() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ButtonBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonBase.__proto__ || Object.getPrototypeOf(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      keyboardFocused: false
    }, _this.ripple = undefined, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = undefined, _this.focus = function () {
      return _this.button.focus();
    }, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;

      var key = (0, _keycode2['default'])(event);

      // Check if key is already down to avoid repeats being counted as multiple activations
      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && key === 'space') {
        _this.keyDown = true;
        event.persist();
        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      }

      // Keyboard accessibility for non interactive elements
      if (event.target === _this.button && onClick && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode2['default'])(event) === 'space' && _this.state.keyboardFocused) {
        _this.keyDown = false;
        event.persist();
        _this.ripple.stop(event, function () {
          return _this.ripple.pulsate(event);
        });
      }
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    }, _this.handleMouseDown = (0, _Ripple.createRippleHandler)(_this, 'MouseDown', 'start', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      if (_this.state.keyboardFocused) {
        _this.setState({ keyboardFocused: false });
      }
    }), _this.handleMouseUp = (0, _Ripple.createRippleHandler)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _Ripple.createRippleHandler)(_this, 'MouseLeave', 'stop', function (event) {
      if (_this.state.keyboardFocused) {
        event.preventDefault();
      }
    }), _this.handleTouchStart = (0, _Ripple.createRippleHandler)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _Ripple.createRippleHandler)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _Ripple.createRippleHandler)(_this, 'Blur', 'stop', function () {
      _this.setState({ keyboardFocused: false });
    }), _this.isDisabled = function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          disabled = _this$props2.disabled;

      return typeof disabled === 'boolean' ? disabled : type === 'submit' && _this.hasErrors();
    }, _this.handleFocus = function (event) {
      if (_this.isDisabled()) {
        return;
      }

      event.persist();

      (0, _keyboardFocus.detectKeyboardFocus)(_this, (0, _reactDom.findDOMNode)(_this.button), // eslint-disable-line react/no-find-dom-node
      function () {
        _this.keyDown = false;
        _this.setState({ keyboardFocused: true });

        if (_this.props.onKeyboardFocus) {
          _this.props.onKeyboardFocus(event);
        }
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.hasErrors = function () {
      var _this$context$muiForm = _this.context.muiForm;
      _this$context$muiForm = _this$context$muiForm === undefined ? {} : _this$context$muiForm;
      var _this$context$muiForm2 = _this$context$muiForm.hasErrors,
          hasErrors = _this$context$muiForm2 === undefined ? function () {
        return false;
      } : _this$context$muiForm2;

      return hasErrors();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ButtonBase, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        (0, _keyboardFocus.listenForFocusKeys)();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(nextProps, nextState) {
        if (this.props.focusRipple) {
          if (nextState.keyboardFocused && !this.state.keyboardFocused) {
            if (this.ripple) {
              this.ripple.pulsate();
            }
          }
        }
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        clearTimeout(this.keyboardFocusTimeout);
      }

      return componentWillUnmount;
    }() // Used to help track keyboard activation keyDown

  }, {
    key: 'renderRipple',
    value: function () {
      function renderRipple(ripple, center) {
        var _this2 = this;

        if (ripple === true && !this.isDisabled()) {
          return _react2['default'].createElement(_Ripple.TouchRipple, {
            ref: function () {
              function ref(c) {
                _this2.ripple = c;
              }

              return ref;
            }(),
            center: center
          });
        }

        return null;
      }

      return renderRipple;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames,
            _this3 = this;

        var _props = this.props,
            centerRipple = _props.centerRipple,
            children = _props.children,
            classNameProp = _props.className,
            component = _props.component,
            disabled = _props.disabled,
            focusRipple = _props.focusRipple,
            keyboardFocusedClassName = _props.keyboardFocusedClassName,
            onBlur = _props.onBlur,
            onFocus = _props.onFocus,
            onKeyDown = _props.onKeyDown,
            onKeyUp = _props.onKeyUp,
            onMouseDown = _props.onMouseDown,
            onMouseLeave = _props.onMouseLeave,
            onMouseUp = _props.onMouseUp,
            onTouchEnd = _props.onTouchEnd,
            onTouchStart = _props.onTouchStart,
            ripple = _props.ripple,
            tabIndex = _props.tabIndex,
            type = _props.type,
            other = _objectWithoutProperties(_props, ['centerRipple', 'children', 'className', 'component', 'disabled', 'focusRipple', 'keyboardFocusedClassName', 'onBlur', 'onFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchStart', 'ripple', 'tabIndex', 'type']);

        var classes = this.context.styleManager.render(styleSheet);

        var className = (0, _classnames2['default'])(classes.buttonBase, (_classNames = {}, _defineProperty(_classNames, classes.disabled, this.isDisabled()), _defineProperty(_classNames, keyboardFocusedClassName, keyboardFocusedClassName && this.state.keyboardFocused), _classNames), classNameProp);

        var buttonProps = Object.assign({
          ref: function () {
            function ref(c) {
              _this3.button = c;
            }

            return ref;
          }(),
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onMouseUp: this.handleMouseUp,
          onTouchEnd: this.handleTouchEnd,
          onTouchStart: this.handleTouchStart,
          tabIndex: this.isDisabled() ? '-1' : tabIndex,
          className: className
        }, other);

        var Element = component;

        if (other.href) {
          Element = 'a';
        }

        if (Element === 'button') {
          buttonProps.type = type;
          buttonProps.disabled = this.isDisabled();
        } else if (Element !== 'a') {
          buttonProps.role = this.props.hasOwnProperty('role') ? this.props.role : 'button';
        }

        return _react2['default'].createElement(
          Element,
          buttonProps,
          children,
          this.renderRipple(ripple, centerRipple)
        );
      }

      return render;
    }()
  }]);

  return ButtonBase;
}(_react.Component), _class.propTypes = {
  centerRipple: _PropTypes2['default'].bool,
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The element or component used for the root node.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `ripple` must also be true.
   */
  focusRipple: _PropTypes2['default'].bool,
  keyboardFocusedClassName: _PropTypes2['default'].string,
  onBlur: _PropTypes2['default'].func,
  onClick: _PropTypes2['default'].func,
  onFocus: _PropTypes2['default'].func,
  onKeyboardFocus: _PropTypes2['default'].func,
  onKeyDown: _PropTypes2['default'].func,
  onKeyUp: _PropTypes2['default'].func,
  onMouseDown: _PropTypes2['default'].func,
  onMouseLeave: _PropTypes2['default'].func,
  onMouseUp: _PropTypes2['default'].func,
  onTouchEnd: _PropTypes2['default'].func,
  onTouchStart: _PropTypes2['default'].func,
  /**
   * If `true`, the base button will have a ripple.
   */
  ripple: _PropTypes2['default'].oneOfType([_PropTypes2['default'].bool, _PropTypes2['default'].func]),
  role: _PropTypes2['default'].string,
  tabIndex: _PropTypes2['default'].string,
  type: _PropTypes2['default'].string
}, _class.defaultProps = {
  centerRipple: false,
  component: 'button',
  focusRipple: false,
  ripple: false,
  tabIndex: '0',
  type: 'button'
}, _class.contextTypes = {
  muiForm: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = ButtonBase;


ButtonBase.displayName = 'ButtonBase';

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1143);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(52);
var toLength = __webpack_require__(28);
var toAbsoluteIndex = __webpack_require__(99);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(17);
var cof = __webpack_require__(58);
var MATCH = __webpack_require__(19)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(19)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(10);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(44);
var redefine = __webpack_require__(45);
var fails = __webpack_require__(14);
var defined = __webpack_require__(64);
var wks = __webpack_require__(19);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(45);
var redefineAll = __webpack_require__(104);
var meta = __webpack_require__(81);
var forOf = __webpack_require__(127);
var anInstance = __webpack_require__(103);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(14);
var $iterDetect = __webpack_require__(205);
var setToStringTag = __webpack_require__(123);
var inheritIfRequired = __webpack_require__(275);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var hide = __webpack_require__(44);
var uid = __webpack_require__(96);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(97) || !__webpack_require__(14)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(13)[K];
});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(162);
var ViewportMetrics = __webpack_require__(470);

var getEventModifierState = __webpack_require__(299);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(40);
var DOMNamespaces = __webpack_require__(301);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(302);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var EventPluginRegistry = __webpack_require__(294);
var ReactEventEmitterMixin = __webpack_require__(1066);
var ViewportMetrics = __webpack_require__(470);

var getVendorPrefixedEventName = __webpack_require__(1067);
var isEventSupported = __webpack_require__(298);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1138),
    listCacheDelete = __webpack_require__(1139),
    listCacheGet = __webpack_require__(1140),
    listCacheHas = __webpack_require__(1141),
    listCacheSet = __webpack_require__(1142);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(314);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.File = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fetch = __webpack_require__(502);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

var _normalizr = __webpack_require__(132);

var _env3 = __webpack_require__(253);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isJSON = function isJSON(type) {
  return type && type.indexOf('application/json') !== -1;
};
var isText = function isText(type) {
  return type && type.indexOf('text/') !== -1;
};

var File = exports.File = function (_Fetch) {
  _inherits(File, _Fetch);

  function File() {
    _classCallCheck(this, File);

    return _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).apply(this, arguments));
  }

  _createClass(File, [{
    key: 'before',

    // eslint-disable-next-line no-unused-vars
    value: function before(action, states, next) {
      var _action$payload = action.payload;
      _action$payload = _action$payload === undefined ? {} : _action$payload;
      var _action$payload$json = _action$payload.json,
          json = _action$payload$json === undefined ? true : _action$payload$json,
          _action$payload$optio = _action$payload.options;
      _action$payload$optio = _action$payload$optio === undefined ? {} : _action$payload$optio;
      var body = _action$payload$optio.body;

      var nextAction = _extends({}, action);
      if (json && body !== undefined) {
        nextAction.payload.options.body = JSON.stringify(body);
      }

      return Promise.resolve(nextAction);
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'after',
    value: function after(action, states, next) {
      var payload = action.payload,
          response = action.response;

      var type = response.headers.get('content-type');
      return isJSON(type) ? response.json().then(function (data) {
        if (!response.ok) throw response.statusText;
        return data;
      }).then(function (data) {
        if (data.errorMessage) throw data.errorMessage;
        return data;
      }).then(function (data) {
        var schema = payload.schema;

        return !schema || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' ? data : (0, _normalizr.normalize)(data, schema);
      }).then(function (response) {
        return _extends({}, action, { response: response });
      }) : isText(type) ? response.text().then(function (data) {
        if (!response.ok) throw data || response.statusText;
        return data;
      }).then(function (response) {
        return _extends({}, action, { response: response });
      }) : response.blob().then(function (data) {
        if (!response.ok) throw response.statusText;
        return data;
      }).then(function (response) {
        return _extends({}, action, { response: response });
      });
    }
  }]);

  return File;
}(_fetch.Fetch);

var file = new File((0, _env3.url)(_env2.default), {
  headers: {
    Accept: 'application/json'
  },
  method: 'GET'
}, { prefix: 'File' });

exports.default = file;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Base64 = __webpack_require__(1196);

// See http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
function btoa(s) {
  return Base64.btoa(unescape(encodeURIComponent(s)));
}

function base64URLEncode(s) {
  return btoa(s)
  .replace(/=/g, '')
  .replace(/\+/g, '-')
  .replace(/\//g, '_');
}

function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function modifications(oldObj, newObj) {
  var mods = {};
  if (!oldObj || !newObj) { return {}; }
  for (var prop in oldObj) {
    if (oldObj.hasOwnProperty(prop)) {
      if (newObj[prop] !== oldObj[prop]) {
        mods[prop] = {previous: oldObj[prop], current: newObj[prop]};
      }
    }
  }
  
  return mods;
}

module.exports = {
  btoa: btoa,
  base64URLEncode: base64URLEncode,
  clone: clone,
  modifications: modifications
};


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(136),
    toKey = __webpack_require__(109);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(217),
    arrayEach = __webpack_require__(542),
    assignValue = __webpack_require__(317),
    baseAssign = __webpack_require__(543),
    baseAssignIn = __webpack_require__(1262),
    cloneBuffer = __webpack_require__(508),
    copyArray = __webpack_require__(194),
    copySymbols = __webpack_require__(1263),
    copySymbolsIn = __webpack_require__(1265),
    getAllKeys = __webpack_require__(527),
    getAllKeysIn = __webpack_require__(329),
    getTag = __webpack_require__(225),
    initCloneArray = __webpack_require__(1267),
    initCloneByTag = __webpack_require__(1268),
    initCloneObject = __webpack_require__(509),
    isArray = __webpack_require__(27),
    isBuffer = __webpack_require__(220),
    isMap = __webpack_require__(1269),
    isObject = __webpack_require__(71),
    isSet = __webpack_require__(1270),
    keys = __webpack_require__(154);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(798),
    overRest = __webpack_require__(515),
    setToString = __webpack_require__(516);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(510),
    isObject = __webpack_require__(71);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(79).f;
var has = __webpack_require__(113);
var TAG = __webpack_require__(41)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1586);
var global = __webpack_require__(49);
var hide = __webpack_require__(111);
var Iterators = __webpack_require__(141);
var TO_STRING_TAG = __webpack_require__(41)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(115);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(831);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(242);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(1675);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(1744);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(1745);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(1685);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* unused harmony export bpfrpt_proptype_RowRenderer */
/* unused harmony export bpfrpt_proptype_RenderedRows */
/* unused harmony export bpfrpt_proptype_Scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


var bpfrpt_proptype_RowRendererParams =  true ? null : {
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_RowRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};






/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(1650);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Input)['default'];
    }

    return get;
  }()
});
Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Input)['default'];
    }

    return get;
  }()
});
Object.defineProperty(exports, 'ValidationEvent', {
  enumerable: true,
  get: function () {
    function get() {
      return _Input.ValidationEvent;
    }

    return get;
  }()
});

var _InputDataList = __webpack_require__(638);

Object.defineProperty(exports, 'InputDataList', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_InputDataList)['default'];
    }

    return get;
  }()
});

var _InputLabel = __webpack_require__(1854);

Object.defineProperty(exports, 'InputLabel', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_InputLabel)['default'];
    }

    return get;
  }()
});

var _InputDescription = __webpack_require__(1855);

Object.defineProperty(exports, 'InputDescription', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_InputDescription)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_FILE_FAILURE = exports.DELETE_FILE_SUCCESS = exports.DELETE_FILE_REQUEST = exports.DELETE_FILE = exports.ADD_FILE_FAILURE = exports.ADD_FILE_SUCCESS = exports.ADD_FILE_REQUEST = exports.ADD_FILE = exports.GET_FILE_FAILURE = exports.GET_FILE_SUCCESS = exports.GET_FILE_REQUEST = exports.GET_FILE = exports.GET_FILE_OBJECT_FAILURE = exports.GET_FILE_OBJECT_SUCCESS = exports.GET_FILE_OBJECT_REQUEST = exports.GET_FILE_OBJECT = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getFileObject = getFileObject;
exports.getFile = getFile;
exports.addFile = addFile;
exports.deleteFile = deleteFile;

var _file = __webpack_require__(222);

var _file2 = _interopRequireDefault(_file);

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _querystring = __webpack_require__(193);

var _querystring2 = _interopRequireDefault(_querystring);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_FILE_OBJECT'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_FILE_OBJECT = _api$buildTypes2[0],
    GET_FILE_OBJECT_REQUEST = _api$buildTypes2[1],
    GET_FILE_OBJECT_SUCCESS = _api$buildTypes2[2],
    GET_FILE_OBJECT_FAILURE = _api$buildTypes2[3];
exports.GET_FILE_OBJECT = GET_FILE_OBJECT;
exports.GET_FILE_OBJECT_REQUEST = GET_FILE_OBJECT_REQUEST;
exports.GET_FILE_OBJECT_SUCCESS = GET_FILE_OBJECT_SUCCESS;
exports.GET_FILE_OBJECT_FAILURE = GET_FILE_OBJECT_FAILURE;
function getFileObject(_ref) {
  var teamName = _ref.teamName,
      fileID = _ref.fileID;

  return {
    type: GET_FILE_OBJECT,
    payload: {
      url: '/teams/' + teamName + '/files/' + fileID,
      schema: _schemas.FILE
    }
  };
}

var _file$buildTypes = _file2.default.buildTypes('GET_FILE'),
    _file$buildTypes2 = _slicedToArray(_file$buildTypes, 4);

var GET_FILE = _file$buildTypes2[0],
    GET_FILE_REQUEST = _file$buildTypes2[1],
    GET_FILE_SUCCESS = _file$buildTypes2[2],
    GET_FILE_FAILURE = _file$buildTypes2[3];
exports.GET_FILE = GET_FILE;
exports.GET_FILE_REQUEST = GET_FILE_REQUEST;
exports.GET_FILE_SUCCESS = GET_FILE_SUCCESS;
exports.GET_FILE_FAILURE = GET_FILE_FAILURE;
function getFile(_ref2) {
  var teamName = _ref2.teamName,
      fileID = _ref2.fileID;

  return {
    type: GET_FILE,
    payload: {
      url: '/teams/' + teamName + '/files/' + fileID,
      schema: _schemas.FILE
    }
  };
}

var _file$buildTypes3 = _file2.default.buildTypes('ADD_FILE'),
    _file$buildTypes4 = _slicedToArray(_file$buildTypes3, 4);

var ADD_FILE = _file$buildTypes4[0],
    ADD_FILE_REQUEST = _file$buildTypes4[1],
    ADD_FILE_SUCCESS = _file$buildTypes4[2],
    ADD_FILE_FAILURE = _file$buildTypes4[3];
exports.ADD_FILE = ADD_FILE;
exports.ADD_FILE_REQUEST = ADD_FILE_REQUEST;
exports.ADD_FILE_SUCCESS = ADD_FILE_SUCCESS;
exports.ADD_FILE_FAILURE = ADD_FILE_FAILURE;
function addFile(_ref3) {
  var teamName = _ref3.teamName,
      _ref3$files = _ref3.files,
      files = _ref3$files === undefined ? [] : _ref3$files,
      _ref3$params = _ref3.params,
      params = _ref3$params === undefined ? {} : _ref3$params;

  var url = '/teams/' + teamName;
  var processID = params.processID || params.processName;
  if (params.runID) {
    url += '/runs/' + params.runID;
    if (params.taskName) {
      url += '/tasks/' + params.taskName;
    }
  } else if (processID) {
    url += '/processes/' + processID;
    if (params.stepName) {
      url += '/steps/' + params.stepName;
    }
  }
  url += '/files';

  if (!files.length) throw new Error('File add must be called with files');

  // form data gets saved after the run is saved
  // this preps the files for saving as formData.
  var formData = files.reduce(function (f, file) {
    f.append('files[]', file, file.name);
    return f;
  }, new _context2.default.FormData());

  return {
    type: ADD_FILE,
    payload: {
      json: false,
      url: params ? url + '?' + _querystring2.default.stringify(params) : url,
      schema: _schemas.FILE_LIST,
      options: {
        method: 'POST',
        body: formData
      }
    }
  };
}

var _file$buildTypes5 = _file2.default.buildTypes('DELETE_FILE'),
    _file$buildTypes6 = _slicedToArray(_file$buildTypes5, 4);

var DELETE_FILE = _file$buildTypes6[0],
    DELETE_FILE_REQUEST = _file$buildTypes6[1],
    DELETE_FILE_SUCCESS = _file$buildTypes6[2],
    DELETE_FILE_FAILURE = _file$buildTypes6[3];
exports.DELETE_FILE = DELETE_FILE;
exports.DELETE_FILE_REQUEST = DELETE_FILE_REQUEST;
exports.DELETE_FILE_SUCCESS = DELETE_FILE_SUCCESS;
exports.DELETE_FILE_FAILURE = DELETE_FILE_FAILURE;
function deleteFile(_ref4) {
  var teamName = _ref4.teamName,
      fileID = _ref4.fileID;

  return {
    type: DELETE_FILE,
    payload: {
      url: '/teams/' + teamName + '/files/' + fileID,
      schema: _schemas.FILE,
      options: {
        method: 'DELETE'
      }
    }
  };
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(192);

var _isPlaceholder = /*#__PURE__*/__webpack_require__(260);

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}
module.exports = _curry2;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_WEBHOOK_FAILURE = exports.DELETE_WEBHOOK_SUCCESS = exports.DELETE_WEBHOOK_REQUEST = exports.DELETE_WEBHOOK = exports.UPDATE_WEBHOOK_FAILURE = exports.UPDATE_WEBHOOK_SUCCESS = exports.UPDATE_WEBHOOK_REQUEST = exports.UPDATE_WEBHOOK = exports.CREATE_WEBHOOK_FAILURE = exports.CREATE_WEBHOOK_SUCCESS = exports.CREATE_WEBHOOK_REQUEST = exports.CREATE_WEBHOOK = exports.POST_WEBHOOK_FAILURE = exports.POST_WEBHOOK_SUCCESS = exports.POST_WEBHOOK_REQUEST = exports.POST_WEBHOOK = exports.GET_WEBHOOK_FAILURE = exports.GET_WEBHOOK_SUCCESS = exports.GET_WEBHOOK_REQUEST = exports.GET_WEBHOOK = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getWebhook = getWebhook;
exports.postWebhook = postWebhook;
exports.createWebhook = createWebhook;
exports.updateWebhook = updateWebhook;
exports.deleteWebhook = deleteWebhook;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _file = __webpack_require__(222);

var _file2 = _interopRequireDefault(_file);

var _schemas = __webpack_require__(8);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_WEBHOOK'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_WEBHOOK = _api$buildTypes2[0],
    GET_WEBHOOK_REQUEST = _api$buildTypes2[1],
    GET_WEBHOOK_SUCCESS = _api$buildTypes2[2],
    GET_WEBHOOK_FAILURE = _api$buildTypes2[3];
exports.GET_WEBHOOK = GET_WEBHOOK;
exports.GET_WEBHOOK_REQUEST = GET_WEBHOOK_REQUEST;
exports.GET_WEBHOOK_SUCCESS = GET_WEBHOOK_SUCCESS;
exports.GET_WEBHOOK_FAILURE = GET_WEBHOOK_FAILURE;
function getWebhook(_ref) {
  var webhookID = _ref.webhookID;

  return {
    type: GET_WEBHOOK,
    payload: {
      url: '/webhooks/' + webhookID,
      schema: _schemas.WEBHOOK
    }
  };
}

var _file$buildTypes = _file2.default.buildTypes('POST_WEBHOOK'),
    _file$buildTypes2 = _slicedToArray(_file$buildTypes, 4);

var POST_WEBHOOK = _file$buildTypes2[0],
    POST_WEBHOOK_REQUEST = _file$buildTypes2[1],
    POST_WEBHOOK_SUCCESS = _file$buildTypes2[2],
    POST_WEBHOOK_FAILURE = _file$buildTypes2[3];
exports.POST_WEBHOOK = POST_WEBHOOK;
exports.POST_WEBHOOK_REQUEST = POST_WEBHOOK_REQUEST;
exports.POST_WEBHOOK_SUCCESS = POST_WEBHOOK_SUCCESS;
exports.POST_WEBHOOK_FAILURE = POST_WEBHOOK_FAILURE;
function postWebhook(_ref2) {
  var webhookID = _ref2.webhookID,
      _ref2$fields = _ref2.fields,
      fields = _ref2$fields === undefined ? [] : _ref2$fields;

  var url = '/webhooks/' + webhookID;
  var formData = new _context2.default.FormData();

  fields.forEach(function (field) {
    if (!field.hasOwnProperty('value') || field.value == null) {
      if (field.type === 'string') {
        field.value = '';
      } else {
        return;
      }
    }
    if (Array.isArray(field.value)) {
      field.value.forEach(function (val) {
        formData.append(field.fieldName, val);
      });
    } else {
      formData.append(field.fieldName, field.value);
    }
  });

  return {
    type: POST_WEBHOOK,
    payload: {
      json: false,
      url: url,
      schema: _schemas.WEBHOOK,
      options: {
        method: 'POST',
        body: formData
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('CREATE_WEBHOOK'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var CREATE_WEBHOOK = _api$buildTypes4[0],
    CREATE_WEBHOOK_REQUEST = _api$buildTypes4[1],
    CREATE_WEBHOOK_SUCCESS = _api$buildTypes4[2],
    CREATE_WEBHOOK_FAILURE = _api$buildTypes4[3];
exports.CREATE_WEBHOOK = CREATE_WEBHOOK;
exports.CREATE_WEBHOOK_REQUEST = CREATE_WEBHOOK_REQUEST;
exports.CREATE_WEBHOOK_SUCCESS = CREATE_WEBHOOK_SUCCESS;
exports.CREATE_WEBHOOK_FAILURE = CREATE_WEBHOOK_FAILURE;
function createWebhook(_ref3) {
  var webhook = _ref3.webhook,
      teamName = _ref3.teamName;

  var url = 'teams/' + teamName + '/webhooks';

  return {
    type: CREATE_WEBHOOK,
    payload: {
      url: url,
      schema: _schemas.WEBHOOK,
      options: {
        method: 'POST',
        body: webhook
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_WEBHOOK'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_WEBHOOK = _api$buildTypes6[0],
    UPDATE_WEBHOOK_REQUEST = _api$buildTypes6[1],
    UPDATE_WEBHOOK_SUCCESS = _api$buildTypes6[2],
    UPDATE_WEBHOOK_FAILURE = _api$buildTypes6[3];
exports.UPDATE_WEBHOOK = UPDATE_WEBHOOK;
exports.UPDATE_WEBHOOK_REQUEST = UPDATE_WEBHOOK_REQUEST;
exports.UPDATE_WEBHOOK_SUCCESS = UPDATE_WEBHOOK_SUCCESS;
exports.UPDATE_WEBHOOK_FAILURE = UPDATE_WEBHOOK_FAILURE;
function updateWebhook(_ref4) {
  var webhook = _ref4.webhook,
      teamName = _ref4.teamName;

  var url = 'teams/' + teamName + '/webhooks/' + webhook.webhookID;

  return {
    type: UPDATE_WEBHOOK,
    payload: {
      url: url,
      schema: _schemas.WEBHOOK,
      options: {
        method: 'PUT',
        body: webhook
      }
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('DELETE_WEBHOOK'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var DELETE_WEBHOOK = _api$buildTypes8[0],
    DELETE_WEBHOOK_REQUEST = _api$buildTypes8[1],
    DELETE_WEBHOOK_SUCCESS = _api$buildTypes8[2],
    DELETE_WEBHOOK_FAILURE = _api$buildTypes8[3];
exports.DELETE_WEBHOOK = DELETE_WEBHOOK;
exports.DELETE_WEBHOOK_REQUEST = DELETE_WEBHOOK_REQUEST;
exports.DELETE_WEBHOOK_SUCCESS = DELETE_WEBHOOK_SUCCESS;
exports.DELETE_WEBHOOK_FAILURE = DELETE_WEBHOOK_FAILURE;
function deleteWebhook(_ref5) {
  var teamName = _ref5.teamName,
      webhookID = _ref5.webhookID;

  return {
    type: DELETE_WEBHOOK,
    payload: {
      url: 'teams/' + teamName + '/webhooks/' + webhookID,
      schema: _schemas.WEBHOOK,
      options: {
        method: 'DELETE'
      }
    }
  };
}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(152),
    isObjectLike = __webpack_require__(107);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.url = url;

var _url = __webpack_require__(83);

// Determine the url from the current environment
function url() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pathname = env.PUSHBOT_API_PATH,
      apiPort = env.PUSHBOT_API_PORT,
      apiProtocol = env.PUSHBOT_API_PROTOCOL,
      _env$PUSHBOT_API_HOST = env.PUSHBOT_API_HOSTNAME,
      apiHostname = _env$PUSHBOT_API_HOST === undefined ? 'localhost' : _env$PUSHBOT_API_HOST,
      webPort = env.PUSHBOT_WEB_PORT;


  var inferredPort = !apiPort || apiPort === webPort && apiHostname === 'localhost' || apiProtocol === 'https:' && (apiPort || '').toString() === '443' || apiProtocol === 'http:' && (apiPort || '').toString() === '80';

  var port = inferredPort ? null : apiPort;
  var isRelative = inferredPort && apiHostname === 'localhost';
  var hostname = isRelative ? null : apiHostname;
  var protocol = isRelative ? null : apiProtocol;
  return (0, _url.format)({ pathname: pathname, port: port, protocol: protocol, hostname: hostname });
}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ = __webpack_require__(69);

var _Placeholder = __webpack_require__(779);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Text = __webpack_require__(56);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _typography = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('SearchListItem', function (theme) {
  var _Object$assign;

  return Object.assign({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      overflow: 'hidden',
      paddingBottom: theme.typography.rhythmByUnit(1),
      paddingTop: theme.typography.rhythmByUnit(1)
    },
    content: {
      minHeight: theme.typography.rhythmByUnit(6)
    },
    contentWrap: {
      marginBottom: theme.typography.rhythmByUnit(1)
    },
    contentColumn: {
      display: 'flex',
      justifyContent: 'center'
    },
    iconBox: {
      flex: '0 0 ' + theme.typography.rhythmByUnit(4),
      marginRight: theme.typography.rhythmByUnit(2),
      fontSize: theme.typography.rhythmByUnit(4),
      display: 'inline-flex',
      alignItems: 'center',
      textAlign: 'center'
    },
    dense: {
      paddingBottom: 0,
      paddingTop: 0
    },
    icon: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      height: theme.typography.rhythmByUnit(6),
      minWidth: theme.typography.rhythmByUnit(6),
      width: theme.typography.rhythmByUnit(6)
    },
    iconLabelBox: {
      flex: '0 0 ' + theme.typography.rhythmByUnit(13),
      flexDirection: 'column',
      marginRight: theme.typography.rhythmByUnit(2)
    },
    contentBox: {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      minHeight: theme.typography.rhythmByUnit(6),
      overflow: 'hidden'
    },
    primaryText: {
      flex: '1 1 auto',
      overflow: 'hidden',
      alignSelf: 'center'
    },
    primary: {
      flex: '1 0 auto'
    },
    secondary: {},
    actionsBox: {
      display: 'flex',
      flex: '0 0 auto'
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      overflow: 'hidden',
      marginBottom: theme.typography.rhythmByUnit(1),
      '& > *': {
        marginRight: theme.typography.rhythmByUnit(1)
      }
    },
    dash: Object.assign({
      alignSelf: 'center'
    }, theme.typography.body1),
    truncate: theme.mixins.truncate(),
    skeletonRoot: theme.mixins.skeletonRandom(),
    skeletonIcon: Object.assign({
      borderRadius: theme.variables.borderRadius,
      color: 'transparent'
    }, theme.mixins.skeleton()),
    skeletonPrimary: Object.assign({
      height: theme.typography.fontSize
    }, theme.mixins.skeleton()),
    skeletonSecondary: Object.assign({
      marginBottom: theme.typography.rhythmByUnit(1),
      height: theme.typography.fontSize
    }, theme.mixins.skeleton())
  }, theme.animations.skeleton(), (_Object$assign = {}, _defineProperty(_Object$assign, theme.breakpoints.up('sm'), {
    detail: {
      marginTop: theme.typography.rhythmByUnit(-1)
    }
  }), _defineProperty(_Object$assign, theme.breakpoints.down('sm'), {
    iconLabelBox: {
      display: 'none'
    },
    dash: {
      display: 'none'
    },
    primaryText: {
      flexDirection: 'column',
      display: 'flex'
    }
  }), _Object$assign));
});

var SearchListItem = (_temp = _class = function (_PureComponent) {
  _inherits(SearchListItem, _PureComponent);

  function SearchListItem() {
    _classCallCheck(this, SearchListItem);

    return _possibleConstructorReturn(this, (SearchListItem.__proto__ || Object.getPrototypeOf(SearchListItem)).apply(this, arguments));
  }

  _createClass(SearchListItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames4, _classNames5, _classNames6;

        var _props = this.props,
            actions = _props.actions,
            chipHeight = _props.chipHeight,
            chips = _props.chips,
            className = _props.className,
            dense = _props.dense,
            detailPrimary = _props.detailPrimary,
            detailSecondary = _props.detailSecondary,
            detailTertiary = _props.detailTertiary,
            icon = _props.icon,
            iconIsAvatar = _props.iconIsAvatar,
            iconLabel = _props.iconLabel,
            iconStyle = _props.iconStyle,
            primary = _props.primary,
            secondary = _props.secondary,
            skeleton = _props.skeleton,
            style = _props.style,
            wrap = _props.wrap,
            other = _objectWithoutProperties(_props, ['actions', 'chipHeight', 'chips', 'className', 'dense', 'detailPrimary', 'detailSecondary', 'detailTertiary', 'icon', 'iconIsAvatar', 'iconLabel', 'iconStyle', 'primary', 'secondary', 'skeleton', 'style', 'wrap']);

        if (skeleton) {
          actions = [];
          icon = _react2['default'].createElement(_Placeholder2['default'], null);
          iconLabel = undefined;
          primary = ' ';
          secondary = undefined;
          detailPrimary = ' ';
          detailSecondary = undefined;
          detailTertiary = undefined;
          chips = [];
        }

        var hasActions = actions && (actions.length || (0, _react.isValidElement)(actions));
        var classes = this.context.styleManager.render(styleSheet);

        var iconBoxClass = (0, _classnames2['default'])(classes.iconBox, _defineProperty({}, classes.skeletonIcon, skeleton), classes.contentColumn);
        var iconLabelBoxClass = (0, _classnames2['default'])(classes.iconLabelBox, classes.contentColumn);
        var primaryContentClass = (0, _classnames2['default'])(classes.content, _defineProperty({}, classes.contentWrap, wrap), classes.contentColumn);
        var primaryClass = (0, _classnames2['default'])(classes.primary);
        var secondaryClass = (0, _classnames2['default'])(_defineProperty({}, classes.truncate, !wrap), classes.secondary);
        var contentBoxClass = (0, _classnames2['default'])(classes.contentBox, classes.contentColumn);
        var primaryTextClass = (0, _classnames2['default'])((_classNames4 = {}, _defineProperty(_classNames4, classes.truncate, !wrap), _defineProperty(_classNames4, classes.skeletonPrimary, skeleton), _classNames4), classes.primaryText);
        var detailTextClass = (0, _classnames2['default'])((_classNames5 = {}, _defineProperty(_classNames5, classes.truncate, !wrap), _defineProperty(_classNames5, classes.skeletonSecondary, skeleton), _classNames5));
        var rootClassName = (0, _classnames2['default'])(classes.root, (_classNames6 = {}, _defineProperty(_classNames6, classes.dense, dense), _defineProperty(_classNames6, classes.skeletonRoot, skeleton), _classNames6), className);

        var iconComponent = !icon ? null : _react2['default'].cloneElement(icon, {
          className: (0, _classnames2['default'])(iconBoxClass, icon.props.className)
        });
        var iconLabelComponent = !iconLabel || !icon ? null : _react2['default'].createElement(
          'div',
          { className: iconLabelBoxClass },
          (0, _react.isValidElement)(iconLabel) ? _react2['default'].cloneElement(iconLabel, {
            className: (0, _classnames2['default'])(_defineProperty({}, classes.truncate, !wrap), iconLabel.props.className)
          }) : _react2['default'].createElement(
            _Text.Body2,
            { className: (0, _classnames2['default'])(_defineProperty({}, classes.truncate, !wrap)) },
            iconLabel
          )
        );
        var primaryComponent = !primary ? null : (0, _react.isValidElement)(primary) ? _react2['default'].cloneElement(primary, {
          className: (0, _classnames2['default'])(primaryClass, primary.props.className)
        }) : _react2['default'].createElement(
          _Text.Body2,
          {
            component: 'span',
            className: (0, _classnames2['default'])(primaryClass, _defineProperty({}, classes.truncate, !wrap))
          },
          primary
        );
        var secondaryComponent = !secondary ? null : (0, _react.isValidElement)(secondary) ? _react2['default'].cloneElement(secondary, {
          className: (0, _classnames2['default'])(secondaryClass, secondary.props.className)
        }) : _react2['default'].createElement(
          _Text.Body1,
          { component: 'span', className: secondaryClass },
          secondary
        );
        var primaryContentComponent = !primary && !secondary && !hasActions ? null : _react2['default'].createElement(
          'div',
          { className: primaryContentClass },
          _react2['default'].createElement(
            'div',
            { className: primaryTextClass },
            primaryComponent,
            primaryComponent && secondaryComponent && _react2['default'].createElement(
              'span',
              { className: classes.dash },
              '\xA0\u2014\xA0'
            ),
            secondaryComponent
          ),
          hasActions && _react2['default'].createElement(
            'div',
            { className: classes.actionsBox },
            actions
          )
        );
        var detailPrimaryComponent = !detailPrimary ? null : (0, _react.isValidElement)(detailPrimary) ? _react2['default'].cloneElement(detailPrimary, {
          className: (0, _classnames2['default'])(detailTextClass, detailPrimary.props.className)
        }) : _react2['default'].createElement(
          'div',
          { className: detailTextClass },
          detailPrimary
        );
        var detailSecondaryComponent = !detailSecondary ? null : (0, _react.isValidElement)(detailSecondary) ? _react2['default'].cloneElement(detailSecondary, {
          className: (0, _classnames2['default'])(detailTextClass, detailSecondary.props.className)
        }) : _react2['default'].createElement(
          'div',
          { className: detailTextClass },
          detailSecondary
        );
        var detailTertiaryComponent = !detailTertiary ? null : (0, _react.isValidElement)(detailTertiary) ? _react2['default'].cloneElement(detailTertiary, {
          className: (0, _classnames2['default'])(detailTextClass, detailTertiary.props.className)
        }) : _react2['default'].createElement(
          'div',
          { className: detailTextClass },
          detailTertiary
        );
        var chipsComponent = !chips.length ? null : _react2['default'].createElement(
          'div',
          { className: classes.chips, style: { height: chipHeight } },
          chips
        );

        return _react2['default'].createElement(
          _.ListItem,
          _extends({
            className: rootClassName,
            divider: true
          }, Object.assign({ dense: dense, style: style }, other)),
          icon && _react2['default'].createElement(
            'div',
            { className: classes.icon },
            iconComponent,
            iconLabelComponent
          ),
          _react2['default'].createElement(
            'div',
            { className: contentBoxClass },
            primaryContentComponent,
            (detailPrimaryComponent || detailSecondaryComponent || detailTertiaryComponent) && _react2['default'].createElement(
              _Text.Body1,
              {
                component: 'div',
                paragraph: true,
                secondary: true,
                className: classes.detail
              },
              detailPrimaryComponent,
              detailSecondaryComponent,
              detailTertiaryComponent
            ),
            chipsComponent
          )
        );
      }

      return render;
    }()
  }]);

  return SearchListItem;
}(_react.PureComponent), _class.propTypes = {
  /**
   * icon node
   */
  icon: _PropTypes2['default'].node,
  /**
   * inline icon style
   */
  iconStyle: _PropTypes2['default'].object,
  /**
   * icon label text/node
   */
  iconLabel: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  use a larger icon with a rounded border
   */
  iconIsAvatar: _PropTypes2['default'].deprecate(_PropTypes2['default'].bool),
  /**
   * primary text/node
   */
  primary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   * secondary text/node
   */
  secondary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  detail primary text/node
   */
  detailPrimary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  detail secondary text/node
   */
  detailSecondary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  detail tertiary text/node
   */
  detailTertiary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  array of action buttons
   */
  actions: _PropTypes2['default'].oneOfType([_PropTypes2['default'].node, _PropTypes2['default'].arrayOf(_PropTypes2['default'].node)]),
  /**
   *  array of chips
   */
  chips: _PropTypes2['default'].arrayOf(_PropTypes2['default'].node),
  /**
   *  chip height (necessary to properly hide overflow chips); defaults to default chip height
   */
  chipHeight: _PropTypes2['default'].string,
  /**
   *  class name to apply to the root element
   */
  className: _PropTypes2['default'].string,
  /**
   *  use more space around each list item
   */
  dense: _PropTypes2['default'].bool,
  /**
   *  Use skeleton styling
   */
  skeleton: _PropTypes2['default'].bool,
  /**
   *  Override the inline-styles of the root element.
   */
  style: _PropTypes2['default'].object,
  /**
   *  whether text will wrap inside SearchListItem
   */
  wrap: _PropTypes2['default'].bool
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.defaultProps = {
  iconStyle: {},
  actions: [],
  chips: [],
  chipHeight: (0, _typography.rhythmByUnit)(4),
  iconIsAvatar: false,
  dense: true,
  wrap: false
}, _class.muiName = 'SearchListItem', _temp);
exports['default'] = SearchListItem;


SearchListItem.displayName = 'SearchListItem';

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

exports.no = exports.noCase = __webpack_require__(78)
exports.dot = exports.dotCase = __webpack_require__(1234)
exports.swap = exports.swapCase = __webpack_require__(1235)
exports.path = exports.pathCase = __webpack_require__(1236)
exports.upper = exports.upperCase = __webpack_require__(85)
exports.lower = exports.lowerCase = __webpack_require__(169)
exports.camel = exports.camelCase = __webpack_require__(534)
exports.snake = exports.snakeCase = __webpack_require__(535)
exports.title = exports.titleCase = __webpack_require__(1237)
exports.param = exports.paramCase = __webpack_require__(1238)
exports.header = exports.headerCase = __webpack_require__(1239)
exports.pascal = exports.pascalCase = __webpack_require__(1240)
exports.constant = exports.constantCase = __webpack_require__(1241)
exports.sentence = exports.sentenceCase = __webpack_require__(1242)
exports.isUpper = exports.isUpperCase = __webpack_require__(1243)
exports.isLower = exports.isLowerCase = __webpack_require__(1244)
exports.ucFirst = exports.upperCaseFirst = __webpack_require__(330)
exports.lcFirst = exports.lowerCaseFirst = __webpack_require__(1245)


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCEPT_INVITE_FAILURE = exports.ACCEPT_INVITE_SUCCESS = exports.ACCEPT_INVITE_REQUEST = exports.ACCEPT_INVITE = exports.GET_INVITE_FAILURE = exports.GET_INVITE_SUCCESS = exports.GET_INVITE_REQUEST = exports.GET_INVITE = exports.ADD_INVITE_FAILURE = exports.ADD_INVITE_SUCCESS = exports.ADD_INVITE_REQUEST = exports.ADD_INVITE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.addInvite = addInvite;
exports.getInvite = getInvite;
exports.acceptInvite = acceptInvite;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _normalizr = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// eslint-disable-line no-unused-vars

var _api$buildTypes = _api2.default.buildTypes('ADD_INVITE'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var ADD_INVITE = _api$buildTypes2[0],
    ADD_INVITE_REQUEST = _api$buildTypes2[1],
    ADD_INVITE_SUCCESS = _api$buildTypes2[2],
    ADD_INVITE_FAILURE = _api$buildTypes2[3];
exports.ADD_INVITE = ADD_INVITE;
exports.ADD_INVITE_REQUEST = ADD_INVITE_REQUEST;
exports.ADD_INVITE_SUCCESS = ADD_INVITE_SUCCESS;
exports.ADD_INVITE_FAILURE = ADD_INVITE_FAILURE;
function addInvite(_ref) {
  var teamName = _ref.teamName,
      email = _ref.email,
      message = _ref.message,
      notificationPreference = _ref.notificationPreference,
      phone = _ref.phone,
      isAdmin = _ref.isAdmin,
      isRestricted = _ref.isRestricted;

  return {
    type: ADD_INVITE,
    payload: {
      url: '/teams/' + teamName + '/invites',
      transform: function transform(input) {
        var inviteID = input.inviteToken,
            options = _objectWithoutProperties(input, ['inviteToken']);

        return _extends({ inviteID: inviteID }, options);
      },
      schema: _schemas.INVITE,
      options: {
        method: 'POST',
        body: {
          email: email,
          message: message,
          phone: phone,
          notificationPreference: notificationPreference,
          isAdmin: isAdmin,
          isRestricted: isRestricted
        }
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('GET_INVITE'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var GET_INVITE = _api$buildTypes4[0],
    GET_INVITE_REQUEST = _api$buildTypes4[1],
    GET_INVITE_SUCCESS = _api$buildTypes4[2],
    GET_INVITE_FAILURE = _api$buildTypes4[3];
exports.GET_INVITE = GET_INVITE;
exports.GET_INVITE_REQUEST = GET_INVITE_REQUEST;
exports.GET_INVITE_SUCCESS = GET_INVITE_SUCCESS;
exports.GET_INVITE_FAILURE = GET_INVITE_FAILURE;
function getInvite(_ref2) {
  var teamName = _ref2.teamName,
      id = _ref2.id;

  return {
    type: GET_INVITE,
    payload: {
      url: '/teams/' + teamName + '/invites/' + id,
      transform: function transform(input) {
        return _extends({ inviteID: id }, input);
      },
      schema: _schemas.INVITE,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('ACCEPT_INVITE'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var ACCEPT_INVITE = _api$buildTypes6[0],
    ACCEPT_INVITE_REQUEST = _api$buildTypes6[1],
    ACCEPT_INVITE_SUCCESS = _api$buildTypes6[2],
    ACCEPT_INVITE_FAILURE = _api$buildTypes6[3];
exports.ACCEPT_INVITE = ACCEPT_INVITE;
exports.ACCEPT_INVITE_REQUEST = ACCEPT_INVITE_REQUEST;
exports.ACCEPT_INVITE_SUCCESS = ACCEPT_INVITE_SUCCESS;
exports.ACCEPT_INVITE_FAILURE = ACCEPT_INVITE_FAILURE;
function acceptInvite(_ref3) {
  var teamName = _ref3.teamName,
      id = _ref3.id,
      userData = _ref3.userData,
      usingSamlSso = _ref3.usingSamlSso;
  var email = userData.email,
      username = userData.username,
      fullName = userData.fullName,
      password = userData.password;

  return {
    type: ACCEPT_INVITE,
    payload: {
      url: '/teams/' + teamName + '/invites/' + id,
      transform: function transform(input) {
        return _extends({ inviteID: id }, input);
      },
      schema: _schemas.INVITE,
      options: {
        method: 'POST',
        body: {
          email: email,
          username: username,
          fullName: fullName,
          password: password,
          usingSamlSso: usingSamlSso
        }
      }
    }
  };
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_INTEGRATION_FAILURE = exports.DELETE_INTEGRATION_SUCCESS = exports.DELETE_INTEGRATION_REQUEST = exports.DELETE_INTEGRATION = exports.UPDATE_INTEGRATION_FAILURE = exports.UPDATE_INTEGRATION_SUCCESS = exports.UPDATE_INTEGRATION_REQUEST = exports.UPDATE_INTEGRATION = exports.ADD_INTEGRATION_FAILURE = exports.ADD_INTEGRATION_SUCCESS = exports.ADD_INTEGRATION_REQUEST = exports.ADD_INTEGRATION = exports.GET_INTEGRATION_FAILURE = exports.GET_INTEGRATION_SUCCESS = exports.GET_INTEGRATION_REQUEST = exports.GET_INTEGRATION = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getIntegration = getIntegration;
exports.addIntegration = addIntegration;
exports.updateIntegration = updateIntegration;
exports.deleteIntegration = deleteIntegration;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _api$buildTypes = _api2.default.buildTypes('GET_INTEGRATION'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_INTEGRATION = _api$buildTypes2[0],
    GET_INTEGRATION_REQUEST = _api$buildTypes2[1],
    GET_INTEGRATION_SUCCESS = _api$buildTypes2[2],
    GET_INTEGRATION_FAILURE = _api$buildTypes2[3];
exports.GET_INTEGRATION = GET_INTEGRATION;
exports.GET_INTEGRATION_REQUEST = GET_INTEGRATION_REQUEST;
exports.GET_INTEGRATION_SUCCESS = GET_INTEGRATION_SUCCESS;
exports.GET_INTEGRATION_FAILURE = GET_INTEGRATION_FAILURE;
function getIntegration(_ref) {
  var teamName = _ref.teamName,
      intName = _ref.intName;

  return {
    type: GET_INTEGRATION,
    payload: {
      url: '/teams/' + teamName + '/integrations/' + intName,
      schema: _schemas.INTEGRATION
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_INTEGRATION'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_INTEGRATION = _api$buildTypes4[0],
    ADD_INTEGRATION_REQUEST = _api$buildTypes4[1],
    ADD_INTEGRATION_SUCCESS = _api$buildTypes4[2],
    ADD_INTEGRATION_FAILURE = _api$buildTypes4[3];
exports.ADD_INTEGRATION = ADD_INTEGRATION;
exports.ADD_INTEGRATION_REQUEST = ADD_INTEGRATION_REQUEST;
exports.ADD_INTEGRATION_SUCCESS = ADD_INTEGRATION_SUCCESS;
exports.ADD_INTEGRATION_FAILURE = ADD_INTEGRATION_FAILURE;
function addIntegration(_ref2) {
  var teamName = _ref2.teamName,
      appCredentials = _ref2.appCredentials,
      nickname = _ref2.nickname,
      appID = _ref2.appID,
      appName = _ref2.appName,
      appVersion = _ref2.appVersion,
      appState = _ref2.appState,
      isIntegration = _ref2.isIntegration,
      _ref2$isShared = _ref2.isShared,
      isShared = _ref2$isShared === undefined ? true : _ref2$isShared,
      username = _ref2.username;

  return {
    type: ADD_INTEGRATION,
    payload: {
      url: '/teams/' + teamName + '/integrations',
      schema: _schemas.INTEGRATION,
      options: {
        method: 'POST',
        body: {
          appCredentials: appCredentials,
          nickname: nickname,
          appID: appID,
          appName: appName,
          appVersion: appVersion,
          isIntegration: isIntegration,
          isShared: isShared,
          username: username,
          appState: appState
        }
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_INTEGRATION'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_INTEGRATION = _api$buildTypes6[0],
    UPDATE_INTEGRATION_REQUEST = _api$buildTypes6[1],
    UPDATE_INTEGRATION_SUCCESS = _api$buildTypes6[2],
    UPDATE_INTEGRATION_FAILURE = _api$buildTypes6[3];
exports.UPDATE_INTEGRATION = UPDATE_INTEGRATION;
exports.UPDATE_INTEGRATION_REQUEST = UPDATE_INTEGRATION_REQUEST;
exports.UPDATE_INTEGRATION_SUCCESS = UPDATE_INTEGRATION_SUCCESS;
exports.UPDATE_INTEGRATION_FAILURE = UPDATE_INTEGRATION_FAILURE;
function updateIntegration(_ref3) {
  var teamName = _ref3.teamName,
      intName = _ref3.intName,
      other = _objectWithoutProperties(_ref3, ['teamName', 'intName']);

  return {
    type: UPDATE_INTEGRATION,
    payload: {
      url: '/teams/' + teamName + '/integrations/' + intName,
      schema: _schemas.INTEGRATION,
      options: {
        method: 'PUT',
        body: other
      }
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('DELETE_INTEGRATION'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var DELETE_INTEGRATION = _api$buildTypes8[0],
    DELETE_INTEGRATION_REQUEST = _api$buildTypes8[1],
    DELETE_INTEGRATION_SUCCESS = _api$buildTypes8[2],
    DELETE_INTEGRATION_FAILURE = _api$buildTypes8[3];
exports.DELETE_INTEGRATION = DELETE_INTEGRATION;
exports.DELETE_INTEGRATION_REQUEST = DELETE_INTEGRATION_REQUEST;
exports.DELETE_INTEGRATION_SUCCESS = DELETE_INTEGRATION_SUCCESS;
exports.DELETE_INTEGRATION_FAILURE = DELETE_INTEGRATION_FAILURE;
function deleteIntegration(_ref4) {
  var teamName = _ref4.teamName,
      intName = _ref4.intName;

  return {
    type: DELETE_INTEGRATION,
    payload: {
      url: '/teams/' + teamName + '/integrations/' + intName,
      schema: _schemas.INTEGRATION,
      options: {
        method: 'DELETE'
      }
    }
  };
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rollbar = __webpack_require__(293);

var _rollbar2 = _interopRequireDefault(_rollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mockRollbar = {
  critical: console.error,
  error: console.error,
  warning: console.warn,
  warn: console.warn, // Rollbar supports both warning and warn
  info: console.log,
  debug: console.log
};

function wrap(level) {
  return function () {
    var log = (0, _rollbar2.default)() || mockRollbar;
    log[level].apply(log, arguments);
  };
}

exports.default = ['critical', 'error', 'warning', 'warn', 'info', 'debug'].reduce(function (logs, level) {
  logs[level] = wrap(level);
  return logs;
}, {});

/***/ }),
/* 260 */
/***/ (function(module, exports) {

function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = _isPlaceholder;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(27);

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(254);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;
/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _properties = __webpack_require__(627);

var _properties2 = _interopRequireDefault(_properties);

var _on = __webpack_require__(625);

var _on2 = _interopRequireDefault(_on);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionEndEvent = _properties2['default'].end;

var UNMOUNTED = exports.UNMOUNTED = 0;
var EXITED = exports.EXITED = 1;
var ENTERING = exports.ENTERING = 2;
var ENTERED = exports.ENTERED = 3;
var EXITING = exports.EXITING = 4;

/**
 * A helper function that calls back when any pending animations have started This is needed as the
 * callback hooks might be setting some style properties that needs a frame to take effect.
 */
function requestAnimationStart(callback) {
  // Feature detect rAF, fallback to setTimeout
  if (window.requestAnimationFrame) {
    // Chrome and Safari have a bug where calling rAF once returns the current
    // frame instead of the next frame, so we need to call a double rAF here.
    // See https://crbug.com/675795 for more.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(callback);
    });
  } else {
    setTimeout(callback, 0);
  }
}

/**
 * @ignore - internal component.
 *
 * Drawn from https://raw.githubusercontent.com/react-bootstrap/react-overlays/master/src/Transition.js
 *
 * The Transition component lets you define and run CSS transitions with a simple declarative api.
 * It works similarly to React's own CSSTransitionGroup
 * but is specifically optimized for transitioning a single child "in" or "out".
 *
 * You don't even need to use class based CSS transitions if you don't want to (but it is easiest).
 * The extensive set of lifecyle callbacks means you have control over
 * the transitioning now at each step of the way.
 */
var Transition = (_temp2 = _class = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Transition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Transition.__proto__ || Object.getPrototypeOf(Transition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      status: UNMOUNTED
    }, _this.nextCallback = null, _this.needsUpdate = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Transition, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        var status = void 0;

        if (this.props['in']) {
          // Start enter transition in componentDidMount.
          status = this.props.transitionAppear ? EXITED : ENTERED;
        } else {
          status = this.props.unmountOnExit ? UNMOUNTED : EXITED;
        }

        this.setState({ status: status });
        this.nextCallback = null;
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (this.props.transitionAppear && this.props['in']) {
          this.performEnter(this.props);
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        if (nextProps['in'] && this.props.unmountOnExit) {
          if (this.state.status === UNMOUNTED) {
            // Start enter transition in componentDidUpdate.
            this.setState({ status: EXITED });
          }
        } else {
          this.needsUpdate = true;
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        if (this.props['in'] && this.state.status === EXITED && this.state.status === nextState.status) {
          return false;
        }

        return true;
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var status = this.state.status;

        if (this.props.unmountOnExit && status === EXITED) {
          // EXITED is always a transitional state to either ENTERING or UNMOUNTED
          // when using unmountOnExit.
          if (this.props['in']) {
            this.performEnter(this.props);
          } else {
            this.setState({ status: UNMOUNTED }); // eslint-disable-line react/no-did-update-set-state
          }

          return;
        }

        // guard ensures we are only responding to prop changes
        if (this.needsUpdate) {
          this.needsUpdate = false;

          if (this.props['in']) {
            if (status === EXITING) {
              this.performEnter(this.props);
            } else if (status === EXITED) {
              this.performEnter(this.props);
            }
            // Otherwise we're already entering or entered.
          } else if (status === ENTERING || status === ENTERED) {
            this.performExit(this.props);
          }
          // Otherwise we're already exited or exiting.
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.cancelNextCallback();
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'performEnter',
    value: function () {
      function performEnter(props) {
        this.cancelNextCallback();
        var node = _reactDom2['default'].findDOMNode(this); // eslint-disable-line react/no-find-dom-node
        if (node instanceof HTMLElement) {
          if (props.onEnter) {
            props.onEnter(node);
          }
          this.performEntering(node);
        }
      }

      return performEnter;
    }()
  }, {
    key: 'performEntering',
    value: function () {
      function performEntering(element) {
        var _this2 = this;

        this.safeSetState({ status: ENTERING }, function () {
          if (_this2.props.onEntering) {
            _this2.props.onEntering(element);
          }

          _this2.onTransitionEnd(element, function () {
            _this2.safeSetState({ status: ENTERED }, function () {
              if (_this2.props.onEntered) {
                _this2.props.onEntered(element);
              }
            });
          });
        });
      }

      return performEntering;
    }()
  }, {
    key: 'performExit',
    value: function () {
      function performExit(props) {
        var _this3 = this;

        this.cancelNextCallback();
        var node = _reactDom2['default'].findDOMNode(this); // eslint-disable-line react/no-find-dom-node
        if (node instanceof HTMLElement) {
          // Not this.props, because we might be about to receive new props.
          if (props.onExit) {
            props.onExit(node);
          }

          this.safeSetState({ status: EXITING }, function () {
            if (_this3.props.onExiting) {
              _this3.props.onExiting(node);
            }

            _this3.onTransitionEnd(node, function () {
              _this3.safeSetState({ status: EXITED }, function () {
                if (_this3.props.onExited) {
                  _this3.props.onExited(node);
                }
              });
            });
          });
        }
      }

      return performExit;
    }()
  }, {
    key: 'cancelNextCallback',
    value: function () {
      function cancelNextCallback() {
        if (this.nextCallback !== null) {
          this.nextCallback.cancel();
          this.nextCallback = null;
        }
      }

      return cancelNextCallback;
    }()
  }, {
    key: 'safeSetState',
    value: function () {
      function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        this.setState(nextState, this.setNextCallback(callback));
      }

      return safeSetState;
    }()
  }, {
    key: 'setNextCallback',
    value: function () {
      function setNextCallback(callback) {
        var _this4 = this;

        var active = true;

        // FIXME: These next two blocks are a real enigma for flow typing outside of weak mode.
        // FIXME: I suggest we refactor - rosskevin
        this.nextCallback = function (event) {
          requestAnimationStart(function () {
            if (active) {
              active = false;
              _this4.nextCallback = null;

              callback(event);
            }
          });
        };

        this.nextCallback.cancel = function () {
          active = false;
        };

        return this.nextCallback;
      }

      return setNextCallback;
    }()
  }, {
    key: 'onTransitionEnd',
    value: function () {
      function onTransitionEnd(element, handler) {
        var _this5 = this;

        this.setNextCallback(handler);

        if (element) {
          (0, _on2['default'])(element, transitionEndEvent, function (event) {
            if (event.target === element && _this5.nextCallback) {
              _this5.nextCallback();
            }
          });
          setTimeout(this.nextCallback, this.getTimeout(element)); // eslint-disable-line flowtype-errors/show-errors
        } else {
          setTimeout(this.nextCallback, 0); // eslint-disable-line flowtype-errors/show-errors
        }
      }

      return onTransitionEnd;
    }()
  }, {
    key: 'getTimeout',
    value: function () {
      function getTimeout(element) {
        var timeout = void 0;

        if (this.props.onRequestTimeout && element instanceof HTMLElement) {
          timeout = this.props.onRequestTimeout(element);
        }

        if (typeof timeout !== 'number') {
          timeout = this.props.timeout;
        }

        return timeout;
      }

      return getTimeout;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var status = this.state.status;

        if (status === UNMOUNTED) {
          return null;
        }

        var _props = this.props,
            children = _props.children,
            className = _props.className,
            inProp = _props['in'],
            enteredClassName = _props.enteredClassName,
            enteringClassName = _props.enteringClassName,
            exitedClassName = _props.exitedClassName,
            exitingClassName = _props.exitingClassName,
            onEnter = _props.onEnter,
            onEntering = _props.onEntering,
            onEntered = _props.onEntered,
            onExit = _props.onExit,
            onExiting = _props.onExiting,
            onExited = _props.onExited,
            onRequestTimeout = _props.onRequestTimeout,
            timeout = _props.timeout,
            transitionAppear = _props.transitionAppear,
            unmountOnExit = _props.unmountOnExit,
            other = _objectWithoutProperties(_props, ['children', 'className', 'in', 'enteredClassName', 'enteringClassName', 'exitedClassName', 'exitingClassName', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'onRequestTimeout', 'timeout', 'transitionAppear', 'unmountOnExit']);

        var transitionClassName = void 0;
        if (status === EXITED) {
          transitionClassName = this.props.exitedClassName;
        } else if (status === ENTERING) {
          transitionClassName = this.props.enteringClassName;
        } else if (status === ENTERED) {
          transitionClassName = this.props.enteredClassName;
        } else if (status === EXITING) {
          transitionClassName = this.props.exitingClassName;
        }

        var child = _react2['default'].Children.only(children);
        return _react2['default'].cloneElement(child, Object.assign({
          className: (0, _classnames2['default'])(child.props.className, className, transitionClassName)
        }, other));
      }

      return render;
    }()
  }]);

  return Transition;
}(_react2['default'].Component), _class.defaultProps = {
  'in': false,
  unmountOnExit: false,
  transitionAppear: false,
  timeout: 5000
}, _temp2);
exports['default'] = Transition;


Transition.displayName = 'Transition';

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(834),
    isLength = __webpack_require__(637);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(13).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(94);
var LIBRARY = __webpack_require__(97);
var wksExt = __webpack_require__(433);
var defineProperty = __webpack_require__(25).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(201)('keys');
var uid = __webpack_require__(96);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 270 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(58);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(13).document;
module.exports = document && document.documentElement;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(10);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(72)(Function.call, __webpack_require__(53).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var setPrototypeOf = __webpack_require__(273).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(73);
var defined = __webpack_require__(64);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 278 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var defined = __webpack_require__(64);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(97);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(45);
var hide = __webpack_require__(44);
var has = __webpack_require__(43);
var Iterators = __webpack_require__(125);
var $iterCreate = __webpack_require__(281);
var setToStringTag = __webpack_require__(123);
var getPrototypeOf = __webpack_require__(54);
var ITERATOR = __webpack_require__(19)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(100);
var descriptor = __webpack_require__(95);
var setToStringTag = __webpack_require__(123);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(44)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(204);
var defined = __webpack_require__(64);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(19)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(125);
var ITERATOR = __webpack_require__(19)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(25);
var createDesc = __webpack_require__(95);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(159);
var ITERATOR = __webpack_require__(19)('iterator');
var Iterators = __webpack_require__(125);
module.exports = __webpack_require__(94).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(99);
var toLength = __webpack_require__(28);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(126);
var step = __webpack_require__(448);
var Iterators = __webpack_require__(125);
var toIObject = __webpack_require__(52);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(280)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(46);
var SPECIES = __webpack_require__(19)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(72);
var invoke = __webpack_require__(439);
var html = __webpack_require__(272);
var cel = __webpack_require__(267);
var global = __webpack_require__(13);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(58)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var macrotask = __webpack_require__(290).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(58)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(24);
var LIBRARY = __webpack_require__(97);
var $typed = __webpack_require__(209);
var hide = __webpack_require__(44);
var redefineAll = __webpack_require__(104);
var fails = __webpack_require__(14);
var anInstance = __webpack_require__(103);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(28);
var toIndex = __webpack_require__(455);
var gOPN = __webpack_require__(101).f;
var dP = __webpack_require__(25).f;
var arrayFill = __webpack_require__(287);
var setToStringTag = __webpack_require__(123);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRollbar;

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

var _rollbarUmd = __webpack_require__(1036);

var _rollbarUmd2 = _interopRequireDefault(_rollbarUmd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// global Rollbar instance
var rollbar = void 0;

// Initialize Rollbar if config is available
if ((_env2.default || {}).PUSHBOT_ROLLBAR_KEY) {
  var locRegex = /^(https?):\/\/[a-zA-Z0-9._-]+\.pushbot\.(com|io)(.*)/;
  rollbar = new _rollbarUmd2.default({
    accessToken: _env2.default.PUSHBOT_ROLLBAR_KEY,
    captureUncaught: true,
    captureUnhandledRejections: true,
    transform: function transform(payload) {
      var trace = ((payload || {}).body || {}).trace || {};
      if (!trace.frames) {
        return;
      }

      trace.frames = trace.frames.map(function (frame) {
        if (!frame.filename) return frame;
        var m = frame.filename.match(locRegex);
        if (!m) return frame;
        frame.filename = m[1] + '://dynamichost' + m[3];
        return frame;
      });
    },

    payload: {
      environment: _env2.default.PUSHBOT_ENV,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: _env2.default.PUSHBOT_VERSION,
          guess_uncaught_frames: true
        }
      }
    }
  });
  // eslint-disable-next-line no-unused-vars, (promise)
  rollbar.handleUnhandledRejection = function (reason, promise) {
    reason = reason || {}; // reason is null in some browsers

    var message = 'Unhandled rejection';
    if (reason.message) {
      message += ': ' + reason.message;
    }

    var status = reason.status || (reason.response || {}).status;
    if (status && status >= 400 && status < 500) {
      return this.warn(reason, message);
    }

    return this.error(reason, message);
  };
}

function getRollbar() {
  return rollbar;
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var ReactErrorUtils = __webpack_require__(296);

var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(40);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(130);
var Danger = __webpack_require__(1051);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(55);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(302);
var setInnerHTML = __webpack_require__(213);
var setTextContent = __webpack_require__(471);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(1069);
var propTypesFactory = __webpack_require__(304);

var React = __webpack_require__(82);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1070);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(18);

var ReactCompositeComponent = __webpack_require__(1086);
var ReactEmptyComponent = __webpack_require__(484);
var ReactHostComponent = __webpack_require__(485);

var getNextDebugID = __webpack_require__(1087);
var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(163);

var ReactCurrentOwner = __webpack_require__(77);

var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(77);
var ReactInstanceMap = __webpack_require__(165);
var ReactInstrumentation = __webpack_require__(55);
var ReactUpdates = __webpack_require__(60);

var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var emptyFunction = __webpack_require__(48);
var warning = __webpack_require__(16);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(80);

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _file = __webpack_require__(222);

var _file2 = _interopRequireDefault(_file);

var _userSessionCookie = __webpack_require__(517);

var _userSessionCookie2 = _interopRequireDefault(_userSessionCookie);

var _logger = __webpack_require__(1184);

var _logger2 = _interopRequireDefault(_logger);

var _errorLogger = __webpack_require__(1190);

var _errorLogger2 = _interopRequireDefault(_errorLogger);

var _analytics = __webpack_require__(1191);

var _analytics2 = _interopRequireDefault(_analytics);

var _debugging = __webpack_require__(1249);

var _debugging2 = _interopRequireDefault(_debugging);

var _feature = __webpack_require__(1251);

var _feature2 = _interopRequireDefault(_feature);

var _localStorage = __webpack_require__(1252);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _reducers = __webpack_require__(1258);

var _reducers2 = _interopRequireDefault(_reducers);

var _compose = __webpack_require__(1476);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

var _subdomain = __webpack_require__(570);

var _subdomain2 = _interopRequireDefault(_subdomain);

var _reduxThunk = __webpack_require__(1477);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var composeEnhanced = (0, _compose.composeBuilder)(_context2.default);

function createStore() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _redux.createStore)(_reducers2.default, state, composeEnhanced((0, _redux.applyMiddleware)(_reduxThunk2.default, _api2.default.middleware, _file2.default.middleware, _logger2.default, _errorLogger2.default, _feature2.default, _analytics2.default, // must come after API, so calls are tracked
  _debugging2.default), _userSessionCookie2.default.enhancer, _localStorage2.default));
}

var store = createStore({
  config: {
    teamName: (0, _subdomain2.default)()
  }
});

exports.default = store;

/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isObject = __webpack_require__(71);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(198),
    eq = __webpack_require__(314);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImmutable = isImmutable;
exports.denormalizeImmutable = denormalizeImmutable;
/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */

/**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */
function isImmutable(object) {
  return !!(object && (object.hasOwnProperty('__ownerID') || // Immutable.Map
  object._map && object._map.hasOwnProperty('__ownerID') // Immutable.Record
  ));
}

/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */
function denormalizeImmutable(schema, input, unvisit) {
  return Object.keys(schema).reduce(function (object, key) {
    // Immutable maps cast keys to strings on write so we need to ensure
    // we're accessing them using string keys.
    var stringKey = '' + key;

    if (object.has(stringKey)) {
      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
    } else {
      return object;
    }
  }, input);
}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PolymorphicSchema = function () {
  function PolymorphicSchema(definition, schemaAttribute) {
    _classCallCheck(this, PolymorphicSchema);

    if (schemaAttribute) {
      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
        return input[schemaAttribute];
      } : schemaAttribute;
    }
    this.define(definition);
  }

  _createClass(PolymorphicSchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = definition;
    }
  }, {
    key: 'getSchemaAttribute',
    value: function getSchemaAttribute(input, parent, key) {
      return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
    }
  }, {
    key: 'inferSchema',
    value: function inferSchema(input, parent, key) {
      if (this.isSingleSchema) {
        return this.schema;
      }

      var attr = this.getSchemaAttribute(input, parent, key);
      return this.schema[attr];
    }
  }, {
    key: 'normalizeValue',
    value: function normalizeValue(value, parent, key, visit, addEntity) {
      var schema = this.inferSchema(value, parent, key);
      if (!schema) {
        return value;
      }
      var normalizedValue = visit(value, parent, key, schema, addEntity);
      return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : { id: normalizedValue, schema: this.getSchemaAttribute(value, parent, key) };
    }
  }, {
    key: 'denormalizeValue',
    value: function denormalizeValue(value, unvisit) {
      if (!this.isSingleSchema && !value.schema) {
        return value;
      }
      var schema = this.isSingleSchema ? this.schema : this.schema[value.schema];
      return unvisit(value.id || value, schema);
    }
  }, {
    key: 'isSingleSchema',
    get: function get() {
      return !this._schemaAttribute;
    }
  }]);

  return PolymorphicSchema;
}();

exports.default = PolymorphicSchema;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 324 */
/***/ (function(module, exports) {

function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = _has;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1215),
    isObjectLike = __webpack_require__(107);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(27),
    isSymbol = __webpack_require__(327);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var upperCase = __webpack_require__(85)

/**
 * Upper case the first character of a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  if (str == null) {
    return ''
  }

  str = String(str)

  return upperCase(str.charAt(0), locale) + str.substr(1)
}


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(537);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(538);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1246);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1247);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1287),
    createBind = __webpack_require__(1288),
    createCurry = __webpack_require__(1289),
    createHybrid = __webpack_require__(548),
    createPartial = __webpack_require__(1294),
    getData = __webpack_require__(555),
    mergeData = __webpack_require__(1295),
    setData = __webpack_require__(551),
    setWrapToString = __webpack_require__(552),
    toInteger = __webpack_require__(153);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(1322);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  return function (rule) {
    if (rule.type === 'keyframe') {
      rule.selector = '@' + vendor.prefix.css + rule.selector.substr(1);
      return;
    }

    if (rule.type !== 'regular') return;

    for (var prop in rule.style) {
      var value = rule.style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete rule.style[prop];
        rule.style[supportedProp || prop] = supportedValue || value;
      }
    }
  };
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(335);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = undefined;
exports['default'] = createTheme;

var _animations = __webpack_require__(1327);

var _animations2 = _interopRequireDefault(_animations);

var _breakpoints = __webpack_require__(1328);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _mixins = __webpack_require__(1329);

var _mixins2 = _interopRequireDefault(_mixins);

var _palette = __webpack_require__(563);

var _palette2 = _interopRequireDefault(_palette);

var _shadows = __webpack_require__(1338);

var _shadows2 = _interopRequireDefault(_shadows);

var _transitions = __webpack_require__(120);

var _transitions2 = _interopRequireDefault(_transitions);

var _typography = __webpack_require__(155);

var _typography2 = _interopRequireDefault(_typography);

var _variables = __webpack_require__(766);

var _variables2 = _interopRequireDefault(_variables);

var _zIndex = __webpack_require__(1340);

var _zIndex2 = _interopRequireDefault(_zIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = exports.Theme = function () {
  function Theme() {
    _classCallCheck(this, Theme);
  }

  return Theme;
}();

function createTheme() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _config$breakpoints = config.breakpoints,
      breakpoints = _config$breakpoints === undefined ? (0, _breakpoints2['default'])() : _config$breakpoints,
      _config$palette = config.palette,
      palette = _config$palette === undefined ? (0, _palette2['default'])() : _config$palette,
      _config$typography = config.typography,
      typography = _config$typography === undefined ? (0, _typography2['default'])(palette) : _config$typography,
      _config$mixins = config.mixins,
      mixins = _config$mixins === undefined ? (0, _mixins2['default'])(breakpoints, palette, typography, _variables2['default']) : _config$mixins,
      options = _objectWithoutProperties(config, ['breakpoints', 'palette', 'typography', 'mixins']);

  var theme = Object.assign({
    animations: _animations2['default'],
    breakpoints: breakpoints,
    dir: 'ltr',
    mixins: mixins,
    palette: palette,
    shadows: _shadows2['default'],
    spacing: { unit: _typography.STEP },
    transitions: _transitions2['default'],
    typography: typography,
    variables: _variables2['default'],
    zIndex: _zIndex2['default']
  }, options);

  Object.setPrototypeOf(theme, new Theme());

  return theme;
}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(110);

var _DOMUtils = __webpack_require__(171);

var _DOMStateStorage = __webpack_require__(572);

var _PathUtils = __webpack_require__(86);

var _ExecutionEnvironment = __webpack_require__(231);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(1481);

var _PathUtils = __webpack_require__(86);

var _runTransitionHook = __webpack_require__(339);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(170);

var _LocationUtils = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(339);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(1484);

var _runTransitionHook = __webpack_require__(339);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(110);

var _PathUtils = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getRouteParams__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextUtils__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(87);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };








var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes,
    array = _React$PropTypes.array,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createClass({
  displayName: 'RouterContext',


  mixins: [Object(__WEBPACK_IMPORTED_MODULE_3__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_2__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var func = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
    object = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
    shape = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape,
    string = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string;


var routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(590);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(348);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RulesContainer = function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  function RulesContainer(options) {
    _classCallCheck(this, RulesContainer);

    this.map = Object.create(null);
    this.index = [];

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.


  _createClass(RulesContainer, [{
    key: 'add',
    value: function add(name, style, options) {
      var _options = this.options,
          parent = _options.parent,
          sheet = _options.sheet,
          jss = _options.jss,
          Renderer = _options.Renderer,
          generateClassName = _options.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.className) options.className = this.classes[name];

      var rule = (0, _createRule2['default'])(name, style, options);
      this.register(rule);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);
      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule) {
      if (rule.name) this.map[rule.name] = rule;
      if (rule.className && rule.name) this.classes[rule.name] = rule.className;
      if (rule.selector) this.map[rule.selector] = rule;
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.name];
      delete this.map[rule.selector];
      delete this.classes[rule.name];
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(data) {
      this.index.forEach(function (rule) {
        var style = rule.originalStyle;
        for (var prop in style) {
          var value = style[prop];
          if (typeof value === 'function') {
            var computedValue = value(data);
            rule.prop(prop, computedValue);
          }
        }
        if (rule.rules instanceof RulesContainer) {
          rule.rules.update(data);
        }
      });
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RulesContainer;
}();

exports['default'] = RulesContainer;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _RegularRule = __webpack_require__(1538);

var _RegularRule2 = _interopRequireDefault(_RegularRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule(name) {
  var decl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments[2];
  var jss = options.jss;

  if (jss) {
    var rule = jss.plugins.onCreateRule(name, decl, options);
    if (rule) return rule;
  }

  // It is an at-rule and it has no instance.
  if (name && name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _RegularRule2['default'](name, decl, options);
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(591);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  var result = '';

  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    }
    // Object syntax {fallbacks: {prop: value}}
    else {
        for (var _prop in fallbacks) {
          var _value = fallbacks[_prop];
          if (_value != null) {
            result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
          }
        }
      }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  if (!result) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 351 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(112);
var document = __webpack_require__(49).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(112);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(67);
var dPs = __webpack_require__(1576);
var enumBugKeys = __webpack_require__(358);
var IE_PROTO = __webpack_require__(356)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(352)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(608).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(350);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(357)('keys');
var uid = __webpack_require__(234);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(360);
var ITERATOR = __webpack_require__(41)('iterator');
var Iterators = __webpack_require__(141);
module.exports = __webpack_require__(26).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(176);
var TAG = __webpack_require__(41)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 361 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(41);


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var core = __webpack_require__(26);
var LIBRARY = __webpack_require__(232);
var wksExt = __webpack_require__(362);
var defineProperty = __webpack_require__(79).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(236);
var createDesc = __webpack_require__(174);
var toIObject = __webpack_require__(114);
var toPrimitive = __webpack_require__(353);
var has = __webpack_require__(113);
var IE8_DOM_DEFINE = __webpack_require__(604);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(88) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(61);
var core = __webpack_require__(26);
var fails = __webpack_require__(140);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _initialiseProps;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _keycode = __webpack_require__(147);

var _keycode2 = _interopRequireDefault(_keycode);

var _inDOM = __webpack_require__(115);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _contains = __webpack_require__(121);

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = __webpack_require__(196);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = __webpack_require__(122);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _addEventListener = __webpack_require__(624);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _helpers = __webpack_require__(735);

var _Fade = __webpack_require__(626);

var _Fade2 = _interopRequireDefault(_Fade);

var _modalManager = __webpack_require__(1622);

var _Backdrop = __webpack_require__(824);

var _Backdrop2 = _interopRequireDefault(_Backdrop);

var _Portal = __webpack_require__(1632);

var _Portal2 = _interopRequireDefault(_Portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Modals don't open on the server
// so this won't break concurrency
// ...........Could also put this on context....
var modalManager = (0, _modalManager.createModalManager)();

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Modal', function (theme) {
  return {
    modal: {
      display: 'flex',
      width: '100%',
      height: '100%',
      position: 'fixed',
      zIndex: theme.zIndex.dialog,
      top: 0,
      left: 0
    }
  };
});

var Modal = (_temp2 = _class = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        if (!this.props.show) {
          this.setState({ exited: true });
        }
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.mounted = true;
        if (this.props.show === true) {
          this.handleShow();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        if (nextProps.show && this.state.exited) {
          this.setState({ exited: false });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(nextProps) {
        if (!this.props.show && nextProps.show) {
          this.checkForFocus();
        }
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
          this.handleShow();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (this.props.show || !this.state.exited) {
          this.handleHide();
        }
        this.mounted = false;
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'checkForFocus',
    value: function () {
      function checkForFocus() {
        if (_inDOM2['default']) {
          this.lastFocus = (0, _activeElement2['default'])();
        }
      }

      return checkForFocus;
    }()
  }, {
    key: 'focus',
    value: function () {
      function focus() {
        var currentFocus = (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(this)) // eslint-disable-line react/no-find-dom-node
        );
        var modalContent = this.modal && this.modal.lastChild;
        var focusInModal = modalContent && currentFocus && (0, _contains2['default'])(modalContent, currentFocus);

        if (modalContent && !focusInModal) {
          this.lastFocus = currentFocus;

          if (!modalContent.hasAttribute('tabIndex')) {
            modalContent.setAttribute('tabIndex', -1);
            (0, _warning2['default'])(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".');
          }

          modalContent.focus();
        }
      }

      return focus;
    }()
  }, {
    key: 'restoreLastFocus',
    value: function () {
      function restoreLastFocus() {
        if (this.lastFocus && this.lastFocus.focus) {
          this.lastFocus.focus();
          this.lastFocus = undefined;
        }
      }

      return restoreLastFocus;
    }()
  }, {
    key: 'handleShow',
    value: function () {
      function handleShow() {
        var doc = (0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(this)); // eslint-disable-line react/no-find-dom-node
        this.props.modalManager.add(this);
        this.onDocumentKeyUpListener = (0, _addEventListener2['default'])(doc, 'keyup', this.handleDocumentKeyUp);
        this.onFocusListener = (0, _addEventListener2['default'])(doc, 'focus', this.handleFocusListener, true);
        this.focus();
      }

      return handleShow;
    }()
  }, {
    key: 'handleHide',
    value: function () {
      function handleHide() {
        this.props.modalManager.remove(this);
        this.onDocumentKeyUpListener.remove();
        this.onFocusListener.remove();
        this.restoreLastFocus();
      }

      return handleHide;
    }()
  }, {
    key: 'renderBackdrop',
    value: function () {
      function renderBackdrop() {
        var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _props = this.props,
            backdropComponent = _props.backdropComponent,
            backdropClassName = _props.backdropClassName,
            backdropTransitionDuration = _props.backdropTransitionDuration,
            backdropVisible = _props.backdropVisible,
            show = _props.show;


        return _react2['default'].createElement(
          _Fade2['default'],
          _extends({
            enterTransitionDuration: backdropTransitionDuration,
            'in': show,
            leaveTransitionDuration: backdropTransitionDuration,
            timeout: backdropTransitionDuration + 20,
            transitionAppear: true
          }, other),
          _react2['default'].createElement(backdropComponent, {
            className: backdropClassName,
            onMouseDown: this.handleBackdropClick,
            visible: backdropVisible
          })
        );
      }

      return renderBackdrop;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            backdrop = _props2.backdrop,
            backdropClassName = _props2.backdropClassName,
            backdropComponent = _props2.backdropComponent,
            backdropTransitionDuration = _props2.backdropTransitionDuration,
            backdropVisible = _props2.backdropVisible,
            children = _props2.children,
            className = _props2.className,
            container = _props2.container,
            hideOnBackdropClick = _props2.hideOnBackdropClick,
            hideOnEscapeKeyUp = _props2.hideOnEscapeKeyUp,
            modalManagerProp = _props2.modalManager,
            onBackdropClick = _props2.onBackdropClick,
            onEnter = _props2.onEnter,
            onEntered = _props2.onEntered,
            onEntering = _props2.onEntering,
            onEscapeKeyUp = _props2.onEscapeKeyUp,
            onExit = _props2.onExit,
            onExited = _props2.onExited,
            onExiting = _props2.onExiting,
            onRequestClose = _props2.onRequestClose,
            show = _props2.show,
            other = _objectWithoutProperties(_props2, ['backdrop', 'backdropClassName', 'backdropComponent', 'backdropTransitionDuration', 'backdropVisible', 'children', 'className', 'container', 'hideOnBackdropClick', 'hideOnEscapeKeyUp', 'modalManager', 'onBackdropClick', 'onEnter', 'onEntered', 'onEntering', 'onEscapeKeyUp', 'onExit', 'onExited', 'onExiting', 'onRequestClose', 'show']);

        var classes = this.context.styleManager.render(styleSheet);
        var mount = show || !this.state.exited;

        if (!mount) {
          return null;
        }

        var transitionCallbacks = {
          onEnter: onEnter,
          onEntered: onEntered,
          onEntering: onEntering,
          onExit: onExit,
          onExited: this.handleTransitionExited,
          onExiting: onExiting
        };

        var modalChild = _react2['default'].Children.only(children);

        var _modalChild$props = modalChild.props,
            role = _modalChild$props.role,
            tabIndex = _modalChild$props.tabIndex;


        var childProps = {};
        var backdropProps = void 0;

        if (role === undefined) {
          childProps.role = role === undefined ? 'document' : role;
        }

        if (tabIndex === undefined) {
          childProps.tabIndex = tabIndex == null ? '-1' : tabIndex;
        }

        if (!backdropVisible && modalChild.props.hasOwnProperty('in')) {
          Object.keys(transitionCallbacks).forEach(function (key) {
            var transitionCb = transitionCallbacks[key];
            var modalChildCb = modalChild.props[key];

            if (transitionCb || modalChildCb) {
              childProps[key] = (0, _helpers.createChainedFunction)(transitionCb, modalChildCb);
            }
          });
        } else {
          backdropProps = transitionCallbacks;
        }

        if (Object.keys(childProps).length) {
          modalChild = _react2['default'].cloneElement(modalChild, childProps);
        }

        return _react2['default'].createElement(
          _Portal2['default'],
          _extends({
            open: true,
            ref: function () {
              function ref(c) {
                return _this2.mountNode = c ? c.getLayer() : c;
              }

              return ref;
            }()
          }, { container: container }),
          _react2['default'].createElement(
            'div',
            _extends({
              className: (0, _classnames2['default'])(classes.modal, className),
              'data-mui-test': 'Modal',
              ref: function () {
                function ref(c) {
                  return _this2.modal = c;
                }

                return ref;
              }()
            }, other),
            backdrop && this.renderBackdrop(backdropProps),
            modalChild
          )
        );
      }

      return render;
    }()
  }]);

  return Modal;
}(_react.Component), _class.propTypes = {
  /**
   * Set to false to disable the backdrop, or true to enable it.
   */
  backdrop: _PropTypes2['default'].bool,
  backdropClassName: _PropTypes2['default'].string,
  /**
   * Pass a component class to use as the backdrop.
   */
  backdropComponent: _PropTypes2['default'].func,
  backdropTransitionDuration: _PropTypes2['default'].number,
  /**
   * If `true`, the backdrop will visibly darken the background
   */
  backdropVisible: _PropTypes2['default'].bool,
  /**
   * Can be used, for instance, to render a letter inside the avatar.
   */
  children: _PropTypes2['default'].element,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The container of the portal.
   */
  container: _PropTypes2['default'].object,
  /**
   * If `true`, clicking the backdrop will fire the `onRequestClose` callback.
   */
  hideOnBackdropClick: _PropTypes2['default'].bool,
  /**
   * If `true`, hitting escape will fire the `onRequestClose` callback.
   */
  hideOnEscapeKeyUp: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  modalManager: _PropTypes2['default'].object,
  /**
   * Callback fires when the backdrop is clicked on.
   */
  onBackdropClick: _PropTypes2['default'].func,
  /**
   * Callback fired before the modal is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the modal is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the modal has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fires when the escape key is pressed and the modal is in focus.
   */
  onEscapeKeyUp: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the modal is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the modal is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the modal has exited.
   */
  onExited: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired when the modal requests to be closed.
   */
  onRequestClose: _PropTypes2['default'].func,
  show: _PropTypes2['default'].bool
}, _class.defaultProps = {
  backdrop: true,
  backdropComponent: _Backdrop2['default'],
  backdropTransitionDuration: 300,
  backdropVisible: true,
  hideOnBackdropClick: true,
  hideOnEscapeKeyUp: true,
  modalManager: modalManager,
  show: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    exited: false
  };
  this.lastFocus = undefined;
  this.modal = null;
  this.mounted = false;
  this.mountNode = null;
  this.onDocumentKeyUpListener = undefined;
  this.onFocusListener = undefined;

  this.handleFocusListener = function () {
    if (!_this3.mounted || !_this3.props.modalManager.isTopModal(_this3)) {
      return;
    }

    var currentFocus = (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(_this3)) // eslint-disable-line react/no-find-dom-node
    );
    var modalContent = _this3.modal && _this3.modal.lastChild;

    if (modalContent && modalContent !== currentFocus && !(0, _contains2['default'])(modalContent, currentFocus)) {
      modalContent.focus();
    }
  };

  this.handleDocumentKeyUp = function (event) {
    if (!_this3.mounted || !_this3.props.modalManager.isTopModal(_this3)) {
      return;
    }

    if ((0, _keycode2['default'])(event) === 'esc') {
      var modalContent = _this3.modal && _this3.modal.lastChild;
      var currentFocus = (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(_this3)) // eslint-disable-line react/no-find-dom-node
      );

      if (currentFocus !== modalContent && currentFocus !== document.body) {
        currentFocus.blur();
      } else {
        var _props3 = _this3.props,
            onEscapeKeyUp = _props3.onEscapeKeyUp,
            onRequestClose = _props3.onRequestClose,
            hideOnEscapeKeyUp = _props3.hideOnEscapeKeyUp;


        if (onEscapeKeyUp) {
          onEscapeKeyUp(event);
        }

        if (onRequestClose && hideOnEscapeKeyUp) {
          onRequestClose(event);
        }
      }
    }
  };

  this.handleBackdropClick = function (event) {
    var modalContent = _this3.modal && _this3.modal.lastChild;
    var currentFocus = (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(_this3)) // eslint-disable-line react/no-find-dom-node
    );

    if (currentFocus !== modalContent && currentFocus !== document.body) {
      modalContent.blur();
    } else {
      if (event.target !== event.currentTarget) {
        return;
      }

      var _props4 = _this3.props,
          onBackdropClick = _props4.onBackdropClick,
          onRequestClose = _props4.onRequestClose,
          hideOnBackdropClick = _props4.hideOnBackdropClick;


      if (onBackdropClick) {
        onBackdropClick(event);
      }

      if (onRequestClose && hideOnBackdropClick) {
        onRequestClose(event);
      }
    }
  };

  this.handleTransitionExited = function () {
    _this3.setState({ exited: true });
    _this3.handleHide();
    if (_this3.props.onExited) {
      var _props5;

      (_props5 = _this3.props).onExited.apply(_props5, arguments);
    }
  };
}, _temp2);
exports['default'] = Modal;


Modal.displayName = 'Modal';

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toolbar = __webpack_require__(1633);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Toolbar)['default'];
    }

    return get;
  }()
});
Object.defineProperty(exports, 'Toolbar', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Toolbar)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1651),
    isObjectLike = __webpack_require__(426);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = exports.ListSubheader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ButtonBase = __webpack_require__(197);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _Progress = __webpack_require__(397);

var _Progress2 = _interopRequireDefault(_Progress);

var _ListItemSecondaryAction = __webpack_require__(639);

var _ListItemSecondaryAction2 = _interopRequireDefault(_ListItemSecondaryAction);

var _ListSubheader2 = __webpack_require__(640);

var _ListSubheader3 = _interopRequireDefault(_ListSubheader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.ListSubheader = _ListSubheader3['default'];
var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListItem', function (theme) {
  return {
    listItemContainer: {
      position: 'relative'
    },
    listItem: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.text.primary,
      position: 'relative',
      textDecoration: 'none'
    },
    gutters: theme.mixins.gutters(2),
    divider: {
      borderBottom: '1px solid ' + theme.palette.text.lightDivider
    },
    disabled: {
      opacity: 0.5
    },
    button: {
      cursor: 'pointer',
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.text.lightDivider,
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    },
    keyboardFocused: {
      background: theme.palette.text.divider
    },
    'default': {
      paddingTop: theme.typography.rhythmByUnit(2),
      paddingBottom: theme.typography.rhythmByUnit(2)
    },
    dense: {
      paddingTop: theme.typography.rhythmByUnit(1),
      paddingBottom: theme.typography.rhythmByUnit(1)
    },
    margin: {
      marginBottom: theme.typography.rhythmByUnit(2)
    }
  };
});

var ListItem = (_temp = _class = function (_Component) {
  _inherits(ListItem, _Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props = this.props,
            button = _props.button,
            childrenProp = _props.children,
            classNameProp = _props.className,
            componentProp = _props.component,
            dense = _props.dense,
            disabled = _props.disabled,
            divider = _props.divider,
            gutters = _props.gutters,
            margin = _props.margin,
            progress = _props.progress,
            other = _objectWithoutProperties(_props, ['button', 'children', 'className', 'component', 'dense', 'disabled', 'divider', 'gutters', 'margin', 'progress']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.listItem, (_classNames = {}, _defineProperty(_classNames, classes.gutters, gutters), _defineProperty(_classNames, classes.divider, divider), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.button, button), _defineProperty(_classNames, dense ? classes.dense : classes['default'], true), _defineProperty(_classNames, classes.margin, margin), _classNames), classNameProp);

        var listItemProps = Object.assign({ className: className, disabled: disabled }, other);
        var ComponentMain = componentProp;

        if (button || this.props.onClick) {
          ComponentMain = _ButtonBase2['default'];
          listItemProps.component = componentProp || 'div';
          listItemProps.keyboardFocusedClassName = classes.keyboardFocused;
        }

        var children = _react2['default'].Children.toArray(childrenProp);
        if (children.length && children[children.length - 1].type && children[children.length - 1].type.muiName === _ListItemSecondaryAction2['default'].muiName) {
          var secondaryAction = children.pop();
          return _react2['default'].createElement(
            'div',
            { className: classes.listItemContainer },
            progress && _react2['default'].createElement(_Progress2['default'], null),
            _react2['default'].createElement(
              ComponentMain,
              listItemProps,
              children
            ),
            secondaryAction
          );
        }

        return _react2['default'].createElement(
          ComponentMain,
          listItemProps,
          children
        );
      }

      return render;
    }()
  }]);

  return ListItem;
}(_react.Component), _class.propTypes = {
  button: _PropTypes2['default'].bool,
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  dense: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If true, element will have a bottom divider
   */
  divider: _PropTypes2['default'].bool,
  /**
   * If true, element will have left and right padding
   */
  gutters: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  onClick: _PropTypes2['default'].func,
  /**
   * If true, indeterminate meter will be displayed.
   */
  progress: _PropTypes2['default'].bool,
  /**
   * If true, element will have a bottom margin
   */
  margin: _PropTypes2['default'].bool
}, _class.defaultProps = {
  button: false,
  component: 'div',
  dense: false,
  disabled: false,
  divider: false,
  gutters: true,
  margin: false,
  progress: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.muiName = 'ListItem', _temp);
exports['default'] = ListItem;


ListItem.displayName = 'ListItem';

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1681),
    baseMatchesProperty = __webpack_require__(1703),
    identity = __webpack_require__(373),
    isArray = __webpack_require__(116),
    property = __webpack_require__(1712);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(646);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(116),
    isSymbol = __webpack_require__(652);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1715),
    isLength = __webpack_require__(654);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(11);









/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);




/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(233);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* unused harmony export bpfrpt_proptype_CellMeasurerCache */
/* unused harmony export bpfrpt_proptype_Positioner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PositionCache__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













var emptyObject = {};

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Masonry, _React$PureComponent);

  function Masonry() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Masonry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Masonry.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Masonry)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isScrolling: false,
      scrollTop: 0
    }, _this._invalidateOnUpdateStartIndex = null, _this._invalidateOnUpdateStopIndex = null, _this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */](), _this._startIndex = null, _this._startIndexMemoized = null, _this._stopIndex = null, _this._stopIndexMemoized = null, _this._debounceResetIsScrollingCallback = function () {
      _this.setState({
        isScrolling: false
      });
    }, _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    }, _this._onScroll = function (event) {
      var height = _this.props.height;


      var eventScrollTop = event.target.scrollTop;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);

      // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
      if (eventScrollTop !== scrollTop) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._debounceResetIsScrolling();

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Masonry, [{
    key: 'clearCellPositions',
    value: function clearCellPositions() {
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this.forceUpdate();
    }

    // HACK This method signature was intended for Grid

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var index = _ref2.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: 'recomputeCellPositions',
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;

      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoHeight = _props.autoHeight,
          cellCount = _props.cellCount,
          cellMeasurerCache = _props.cellMeasurerCache,
          cellRenderer = _props.cellRenderer,
          className = _props.className,
          height = _props.height,
          id = _props.id,
          keyMapper = _props.keyMapper,
          overscanByPixels = _props.overscanByPixels,
          role = _props.role,
          style = _props.style,
          tabIndex = _props.tabIndex,
          width = _props.width,
          rowDirection = _props.rowDirection;
      var _state = this.state,
          isScrolling = _state.isScrolling,
          scrollTop = _state.scrollTop;


      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;

      var startIndex = 0;
      var stopIndex = void 0;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, rowDirection === 'ltr' ? 'left' : 'right', left), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'position', 'absolute'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'top', top), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'width', cellMeasurerCache.getWidth(index)), _style)
        }));
      });

      // We need to measure additional cells for this layout
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;

          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Masonry', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            boxSizing: 'border-box',
            direction: 'ltr',
            height: autoHeight ? 'auto' : height,
            overflowX: 'hidden',
            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
            position: 'relative',
            width: width,
            WebkitOverflowScrolling: 'touch',
            willChange: 'transform'
          }, style),
          tabIndex: tabIndex },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Masonry__innerScrollContainer',
            style: {
              width: '100%',
              height: estimateTotalHeight,
              maxWidth: '100%',
              maxHeight: estimateTotalHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            } },
          children
        )
      );
    }
  }, {
    key: '_checkInvalidateOnUpdate',
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var _startIndex = this._invalidateOnUpdateStartIndex;
        var _stopIndex = this._invalidateOnUpdateStopIndex;

        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;

        // Query external layout logic for position of newly-measured cells
        this._populatePositionCache(_startIndex, _stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: '_debounceResetIsScrolling',
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_getEstimatedTotalHeight',
    value: function _getEstimatedTotalHeight() {
      var _props2 = this.props,
          cellCount = _props2.cellCount,
          cellMeasurerCache = _props2.cellMeasurerCache,
          width = _props2.width;


      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));

      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: '_invokeOnScrollCallback',
    value: function _invokeOnScrollCallback() {
      var _props3 = this.props,
          height = _props3.height,
          onScroll = _props3.onScroll;
      var scrollTop = this.state.scrollTop;


      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });

        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: '_invokeOnCellsRenderedCallback',
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var _onCellsRendered = this.props.onCellsRendered;


        _onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });

        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: '_populatePositionCache',
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _props4 = this.props,
          cellMeasurerCache = _props4.cellMeasurerCache,
          cellPositioner = _props4.cellPositioner;


      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            _left = _cellPositioner.left,
            _top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Masonry.defaultProps = {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
};
Masonry.propTypes =  true ? null : {
  autoHeight: PropTypes.bool.isRequired,
  cellCount: PropTypes.number.isRequired,
  cellMeasurerCache: function cellMeasurerCache() {
    return (typeof CellMeasurerCache === 'function' ? PropTypes.instanceOf(CellMeasurerCache).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellPositioner: function cellPositioner() {
    return (typeof Positioner === 'function' ? PropTypes.instanceOf(Positioner).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellRenderer: function cellRenderer() {
    return (typeof CellRenderer === 'function' ? PropTypes.instanceOf(CellRenderer).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  id: PropTypes.string,
  keyMapper: function keyMapper() {
    return (typeof KeyMapper === 'function' ? PropTypes.instanceOf(KeyMapper).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  onCellsRendered: function onCellsRendered() {
    return (typeof OnCellsRenderedCallback === 'function' ? PropTypes.instanceOf(OnCellsRenderedCallback) : PropTypes.any).apply(this, arguments);
  },
  onScroll: function onScroll() {
    return (typeof OnScrollCallback === 'function' ? PropTypes.instanceOf(OnScrollCallback) : PropTypes.any).apply(this, arguments);
  },
  overscanByPixels: PropTypes.number.isRequired,
  role: PropTypes.string.isRequired,
  scrollingResetTimeInterval: PropTypes.number.isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  tabIndex: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  rowDirection: PropTypes.string.isRequired
};


function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : {
  defaultHeight: PropTypes.number.isRequired,
  defaultWidth: PropTypes.number.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["a" /* polyfill */])(Masonry);

/* harmony default export */ __webpack_exports__["a"] = (Masonry);

var bpfrpt_proptype_Positioner =  true ? null : PropTypes.func;





/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(70),
    isSymbol = __webpack_require__(429);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  teamName: string,
  fileID: string,
  fileName: string,
  filePath: string,
  contentType: string,
  size: number,
  displaySize: string,
  isPublic: bool,
  createdBy: string,
  MD5Hash: string,
  ETag: string,
  createdDate: string,
  previousVersion: string,
  nextVersion: string,
  originalFile: string,
  tags: arrayOf(string),
  color: string,
  uploadUrl: string,
  downloadUrl: string,
  isUploaded: bool,
  copyOf: string,
  processID: string,
  stepName: string,
  runID: string,
  taskName: string,
  threadID: string,
  messageID: string
});

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(1637);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Button)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepName = exports.appID = exports.escapeAppID = exports.unescapeAppID = exports.parentPathname = exports.routeParts = exports.routes = exports.params = exports.route = exports.searchStatus = exports.searchText = exports.status = exports.parseQ = exports.createSearchSelector = exports.search = exports.createQuerySelector = exports.query = exports.referrerSearch = exports.referrerPathname = exports.referrer = exports.state = exports.pathname = exports.location = exports.routing = undefined;

var _reselect = __webpack_require__(33);

var _searchQueryParser = __webpack_require__(533);

var _searchQueryParser2 = _interopRequireDefault(_searchQueryParser);

var _path = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var routing = exports.routing = function routing(state) {
  return state.routing;
};

var location = exports.location = (0, _reselect.createSelector)(routing, function () {
  var routing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return routing.locationBeforeTransitions || {};
});

var pathname = exports.pathname = (0, _reselect.createSelector)(location, function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      pathname = _ref.pathname;

  return pathname;
});

var state = exports.state = (0, _reselect.createSelector)(location, function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      state = _ref2.state;

  return state;
});

var referrer = exports.referrer = (0, _reselect.createSelector)(state, function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      referrer = _ref3.referrer;

  return referrer;
});

var referrerPathname = exports.referrerPathname = (0, _reselect.createSelector)(referrer, function (referrer) {
  return referrer && referrer.pathname ? referrer.pathname : '/';
});

var referrerSearch = exports.referrerSearch = (0, _reselect.createSelector)(referrer, function (referrer) {
  return referrer && referrer.search ? referrer.search : '';
});

var query = exports.query = (0, _reselect.createSelector)(location, function () {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return location.query;
});

var createQuerySelector = exports.createQuerySelector = function createQuerySelector(key) {
  return (0, _reselect.createSelector)(query, function () {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return query[key];
  });
};

var search = exports.search = createQuerySelector('q');

var createSearchSelector = exports.createSearchSelector = function createSearchSelector() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _reselect.createSelector)(search, function (q) {
    return parseQ(q, keywords);
  });
};

var parseQ = exports.parseQ = function parseQ(q, keywords) {
  // Always return an object
  var parsed = _searchQueryParser2.default.parse(q, { keywords: keywords });
  return typeof parsed === 'string' ? { text: parsed } : parsed;
};

var status = exports.status = createSearchSelector(['status']);

var searchText = exports.searchText = (0, _reselect.createSelector)(status, function (parsed) {
  return parsed.text;
});

var searchStatus = exports.searchStatus = (0, _reselect.createSelector)(status, function (parsed) {
  return parsed.status;
});

var route = exports.route = function route(state) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      route = _ref4.route;

  return route;
};
var params = exports.params = function params(state) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      params = _ref5.params;

  return params;
};
var routes = exports.routes = function routes(state) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      routes = _ref6.routes;

  return routes;
};
var PARAM_PATH = /(^|\/):([^\/]+)/g; // eslint-disable-line no-useless-escape

var buildParamsReplacer = function buildParamsReplacer(params) {
  return function (m, p, k) {
    return '' + p + params[k];
  };
};

var routeParts = exports.routeParts = (0, _reselect.createSelector)(routes, params, function () {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var replaceParams = buildParamsReplacer(params);
  return routes.filter(function (r) {
    return r.path;
  }).map(function (r) {
    return PARAM_PATH.test(r.path) ? r.path.replace(PARAM_PATH, replaceParams) : r.path;
  });
});

var parentPathname = exports.parentPathname = (0, _reselect.createSelector)(routeParts, function () {
  var parts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _path.join.apply(undefined, ['/'].concat(_toConsumableArray(parts.slice(0, -1))));
});

var lastPathname = function lastPathname(pathname) {
  if (pathname.charAt(pathname.length - 1) === '/') pathname = pathname.slice(0, -1);
  return pathname.slice(pathname.lastIndexOf('/') + 1);
};

var unescapeAppID = exports.unescapeAppID = function unescapeAppID(pathname) {
  return pathname.split('%2F').join('/');
};

var escapeAppID = exports.escapeAppID = function escapeAppID(appID) {
  return appID.replace(/[/]/g, '%2F');
};

var appID = exports.appID = (0, _reselect.createSelector)(pathname, function (pathname) {
  var lastPath = lastPathname(pathname);
  var lastPathIndex = pathname.indexOf(lastPath);
  var correctPrecedingPath = 'action';
  var actualPreceding = pathname.slice(lastPathIndex - correctPrecedingPath.length - 1, lastPathIndex - 1);
  if (actualPreceding === correctPrecedingPath) return unescapeAppID(lastPath);
});

var stepName = exports.stepName = (0, _reselect.createSelector)(params, function (params) {
  return params.stepName;
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_USERS_FAILURE = exports.GET_USERS_SUCCESS = exports.GET_USERS_REQUEST = exports.GET_USERS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getUsers = getUsers;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_USERS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_USERS = _api$buildTypes2[0],
    GET_USERS_REQUEST = _api$buildTypes2[1],
    GET_USERS_SUCCESS = _api$buildTypes2[2],
    GET_USERS_FAILURE = _api$buildTypes2[3];
exports.GET_USERS = GET_USERS;
exports.GET_USERS_REQUEST = GET_USERS_REQUEST;
exports.GET_USERS_SUCCESS = GET_USERS_SUCCESS;
exports.GET_USERS_FAILURE = GET_USERS_FAILURE;
function getUsers(_ref) {
  var teamName = _ref.teamName;

  return {
    type: GET_USERS,
    payload: {
      url: '/teams/' + teamName + '/users',
      schema: _schemas.USER_LIST
    }
  };
}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_symbol_observable__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formattedLastLoginMessage = exports.formatUserDisplayName = exports.getUserThumbnailAltText = exports.getUserThumbnailUrl = exports.getUserDisplayName = undefined;

var _url = __webpack_require__(31);

var _moment = __webpack_require__(50);

var _moment2 = _interopRequireDefault(_moment);

var _Login = __webpack_require__(1568);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserDisplayName = exports.getUserDisplayName = function getUserDisplayName(user) {
  return user.fullName ? user.fullName : user.username;
};

var getUserThumbnailUrl = exports.getUserThumbnailUrl = function getUserThumbnailUrl(user) {
  return user && user.userThumbnail && (0, _url.getFileUrl)(user.teamName, user.userThumbnail);
};

var getUserThumbnailAltText = exports.getUserThumbnailAltText = function getUserThumbnailAltText(user) {
  if (!user || !getUserDisplayName(user)) {
    return '';
  }

  return getUserDisplayName(user).slice(0, 1).toUpperCase();
};

var formatUserDisplayName = exports.formatUserDisplayName = function formatUserDisplayName() {
  var userish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fullNameProp = userish.fullName,
      username = userish.username,
      email = userish.email,
      fieldName = userish.fieldName,
      nickname = userish.nickname;

  var fullName = (fullNameProp || '').trim();

  if (fullName) {
    return fullName;
  }
  if (nickname) {
    return nickname;
  }
  if (username) {
    return '@' + username;
  }
  if (email) {
    return email;
  }
  if (fieldName) {
    return '{{' + fieldName + '}}';
  } else {
    return typeof userish === 'string' ? userish : '';
  }
};

var formattedLastLoginMessage = exports.formattedLastLoginMessage = function formattedLastLoginMessage(lastLogin, formatMessage) {
  if (!lastLogin) {
    return '';
  }
  var loginDate = (0, _moment2.default)(lastLogin.loginDate).format('MMM D');
  var loginTime = (0, _moment2.default)(lastLogin.loginDate).format('h:mmA');

  if (lastLogin.isCurrentIP) {
    return formatMessage(_Login.LastLogin.message.currentIP, {
      loginDate: loginDate,
      loginTime: loginTime
    });
  } else {
    return formatMessage(_Login.LastLogin.message.differentIP, {
      loginDate: loginDate,
      loginTime: loginTime,
      ipAddress: lastLogin.ipAddress
    });
  }
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_PROCESS_PARENT_PROCESSES_FAILURE = exports.GET_PROCESS_PARENT_PROCESSES_SUCCESS = exports.GET_PROCESS_PARENT_PROCESSES_REQUEST = exports.GET_PROCESS_PARENT_PROCESSES = exports.unlinkProcessParentProcess = exports.UNLINK_PROCESS_PARENT_PROCESS_FAILURE = exports.UNLINK_PROCESS_PARENT_PROCESS_SUCCESS = exports.UNLINK_PROCESS_PARENT_PROCESS_REQUEST = exports.UNLINK_PROCESS_PARENT_PROCESS = exports.linkProcessParentProcess = exports.LINK_PROCESS_PARENT_PROCESS_FAILURE = exports.LINK_PROCESS_PARENT_PROCESS_SUCCESS = exports.LINK_PROCESS_PARENT_PROCESS_REQUEST = exports.LINK_PROCESS_PARENT_PROCESS = exports.unlinkProcessPredictor = exports.UNLINK_PROCESS_PREDICTOR_FAILURE = exports.UNLINK_PROCESS_PREDICTOR_SUCCESS = exports.UNLINK_PROCESS_PREDICTOR_REQUEST = exports.UNLINK_PROCESS_PREDICTOR = exports.linkProcessPredictor = exports.LINK_PROCESS_PREDICTOR_FAILURE = exports.LINK_PROCESS_PREDICTOR_SUCCESS = exports.LINK_PROCESS_PREDICTOR_REQUEST = exports.LINK_PROCESS_PREDICTOR = exports.unlinkProcessTable = exports.UNLINK_PROCESS_TABLE_FAILURE = exports.UNLINK_PROCESS_TABLE_SUCCESS = exports.UNLINK_PROCESS_TABLE_REQUEST = exports.UNLINK_PROCESS_TABLE = exports.linkProcessTable = exports.LINK_PROCESS_TABLE_FAILURE = exports.LINK_PROCESS_TABLE_SUCCESS = exports.LINK_PROCESS_TABLE_REQUEST = exports.LINK_PROCESS_TABLE = exports.UPDATE_PROCESS_FAILURE = exports.UPDATE_PROCESS_SUCCESS = exports.UPDATE_PROCESS_REQUEST = exports.UPDATE_PROCESS = exports.ADD_PROCESS_FAILURE = exports.ADD_PROCESS_SUCCESS = exports.ADD_PROCESS_REQUEST = exports.ADD_PROCESS = exports.GET_PROCESS_FAILURE = exports.GET_PROCESS_SUCCESS = exports.GET_PROCESS_REQUEST = exports.GET_PROCESS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getProcess = getProcess;
exports.addProcess = addProcess;
exports.updateProcess = updateProcess;
exports.getProcessParentProcesses = getProcessParentProcesses;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _url = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_PROCESS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_PROCESS = _api$buildTypes2[0],
    GET_PROCESS_REQUEST = _api$buildTypes2[1],
    GET_PROCESS_SUCCESS = _api$buildTypes2[2],
    GET_PROCESS_FAILURE = _api$buildTypes2[3];
exports.GET_PROCESS = GET_PROCESS;
exports.GET_PROCESS_REQUEST = GET_PROCESS_REQUEST;
exports.GET_PROCESS_SUCCESS = GET_PROCESS_SUCCESS;
exports.GET_PROCESS_FAILURE = GET_PROCESS_FAILURE;
function getProcess(_ref) {
  var teamName = _ref.teamName,
      processID = _ref.processID,
      _ref$includeChildren = _ref.includeChildren,
      includeChildren = _ref$includeChildren === undefined ? false : _ref$includeChildren;

  return {
    type: GET_PROCESS,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '?includeChildren=' + includeChildren,
      schema: _schemas.PROCESS,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_PROCESS'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_PROCESS = _api$buildTypes4[0],
    ADD_PROCESS_REQUEST = _api$buildTypes4[1],
    ADD_PROCESS_SUCCESS = _api$buildTypes4[2],
    ADD_PROCESS_FAILURE = _api$buildTypes4[3];
exports.ADD_PROCESS = ADD_PROCESS;
exports.ADD_PROCESS_REQUEST = ADD_PROCESS_REQUEST;
exports.ADD_PROCESS_SUCCESS = ADD_PROCESS_SUCCESS;
exports.ADD_PROCESS_FAILURE = ADD_PROCESS_FAILURE;
function addProcess(_ref2) {
  var teamName = _ref2.teamName,
      data = _ref2.data;

  return {
    type: ADD_PROCESS,
    payload: {
      url: '/teams/' + teamName + '/processes',
      schema: _schemas.PROCESS,
      options: {
        method: 'POST',
        body: data
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_PROCESS'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_PROCESS = _api$buildTypes6[0],
    UPDATE_PROCESS_REQUEST = _api$buildTypes6[1],
    UPDATE_PROCESS_SUCCESS = _api$buildTypes6[2],
    UPDATE_PROCESS_FAILURE = _api$buildTypes6[3];
exports.UPDATE_PROCESS = UPDATE_PROCESS;
exports.UPDATE_PROCESS_REQUEST = UPDATE_PROCESS_REQUEST;
exports.UPDATE_PROCESS_SUCCESS = UPDATE_PROCESS_SUCCESS;
exports.UPDATE_PROCESS_FAILURE = UPDATE_PROCESS_FAILURE;
function updateProcess(_ref3) {
  var teamName = _ref3.teamName,
      processID = _ref3.processID,
      data = _ref3.data;

  var url = (0, _url.format)({
    pathname: '/teams/' + teamName + '/processes/' + processID,
    query: { retroactive: data.retroactive }
  });
  return {
    type: UPDATE_PROCESS,
    payload: {
      url: url,
      schema: _schemas.PROCESS,
      options: {
        method: 'PUT',
        body: data
      }
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('LINK_PROCESS_TABLE'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var LINK_PROCESS_TABLE = _api$buildTypes8[0],
    LINK_PROCESS_TABLE_REQUEST = _api$buildTypes8[1],
    LINK_PROCESS_TABLE_SUCCESS = _api$buildTypes8[2],
    LINK_PROCESS_TABLE_FAILURE = _api$buildTypes8[3];
exports.LINK_PROCESS_TABLE = LINK_PROCESS_TABLE;
exports.LINK_PROCESS_TABLE_REQUEST = LINK_PROCESS_TABLE_REQUEST;
exports.LINK_PROCESS_TABLE_SUCCESS = LINK_PROCESS_TABLE_SUCCESS;
exports.LINK_PROCESS_TABLE_FAILURE = LINK_PROCESS_TABLE_FAILURE;
var linkProcessTable = exports.linkProcessTable = function linkProcessTable(_ref4) {
  var teamName = _ref4.teamName,
      processID = _ref4.processID,
      tableID = _ref4.tableID;
  return {
    type: LINK_PROCESS_TABLE,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/tables/' + tableID,
      schema: {},
      options: {
        method: 'POST'
      }
    }
  };
};

var _api$buildTypes9 = _api2.default.buildTypes('UNLINK_PROCESS_TABLE'),
    _api$buildTypes10 = _slicedToArray(_api$buildTypes9, 4);

var UNLINK_PROCESS_TABLE = _api$buildTypes10[0],
    UNLINK_PROCESS_TABLE_REQUEST = _api$buildTypes10[1],
    UNLINK_PROCESS_TABLE_SUCCESS = _api$buildTypes10[2],
    UNLINK_PROCESS_TABLE_FAILURE = _api$buildTypes10[3];
exports.UNLINK_PROCESS_TABLE = UNLINK_PROCESS_TABLE;
exports.UNLINK_PROCESS_TABLE_REQUEST = UNLINK_PROCESS_TABLE_REQUEST;
exports.UNLINK_PROCESS_TABLE_SUCCESS = UNLINK_PROCESS_TABLE_SUCCESS;
exports.UNLINK_PROCESS_TABLE_FAILURE = UNLINK_PROCESS_TABLE_FAILURE;
var unlinkProcessTable = exports.unlinkProcessTable = function unlinkProcessTable(_ref5) {
  var teamName = _ref5.teamName,
      processID = _ref5.processID,
      tableID = _ref5.tableID;
  return {
    type: UNLINK_PROCESS_TABLE,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/tables/' + tableID,
      schema: {},
      options: {
        method: 'DELETE'
      }
    }
  };
};

var _api$buildTypes11 = _api2.default.buildTypes('LINK_PROCESS_PREDICTOR'),
    _api$buildTypes12 = _slicedToArray(_api$buildTypes11, 4);

var LINK_PROCESS_PREDICTOR = _api$buildTypes12[0],
    LINK_PROCESS_PREDICTOR_REQUEST = _api$buildTypes12[1],
    LINK_PROCESS_PREDICTOR_SUCCESS = _api$buildTypes12[2],
    LINK_PROCESS_PREDICTOR_FAILURE = _api$buildTypes12[3];
exports.LINK_PROCESS_PREDICTOR = LINK_PROCESS_PREDICTOR;
exports.LINK_PROCESS_PREDICTOR_REQUEST = LINK_PROCESS_PREDICTOR_REQUEST;
exports.LINK_PROCESS_PREDICTOR_SUCCESS = LINK_PROCESS_PREDICTOR_SUCCESS;
exports.LINK_PROCESS_PREDICTOR_FAILURE = LINK_PROCESS_PREDICTOR_FAILURE;
var linkProcessPredictor = exports.linkProcessPredictor = function linkProcessPredictor(_ref6) {
  var teamName = _ref6.teamName,
      processID = _ref6.processID,
      predictorID = _ref6.predictorID;
  return {
    type: LINK_PROCESS_PREDICTOR,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/predictors/' + predictorID,
      schema: {},
      options: {
        method: 'POST'
      }
    }
  };
};

var _api$buildTypes13 = _api2.default.buildTypes('UNLINK_PROCESS_PREDICTOR'),
    _api$buildTypes14 = _slicedToArray(_api$buildTypes13, 4);

var UNLINK_PROCESS_PREDICTOR = _api$buildTypes14[0],
    UNLINK_PROCESS_PREDICTOR_REQUEST = _api$buildTypes14[1],
    UNLINK_PROCESS_PREDICTOR_SUCCESS = _api$buildTypes14[2],
    UNLINK_PROCESS_PREDICTOR_FAILURE = _api$buildTypes14[3];
exports.UNLINK_PROCESS_PREDICTOR = UNLINK_PROCESS_PREDICTOR;
exports.UNLINK_PROCESS_PREDICTOR_REQUEST = UNLINK_PROCESS_PREDICTOR_REQUEST;
exports.UNLINK_PROCESS_PREDICTOR_SUCCESS = UNLINK_PROCESS_PREDICTOR_SUCCESS;
exports.UNLINK_PROCESS_PREDICTOR_FAILURE = UNLINK_PROCESS_PREDICTOR_FAILURE;
var unlinkProcessPredictor = exports.unlinkProcessPredictor = function unlinkProcessPredictor(_ref7) {
  var teamName = _ref7.teamName,
      processID = _ref7.processID,
      predictorID = _ref7.predictorID;
  return {
    type: UNLINK_PROCESS_PREDICTOR,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/predictors/' + predictorID,
      schema: {},
      options: {
        method: 'DELETE'
      }
    }
  };
};

var _api$buildTypes15 = _api2.default.buildTypes('LINK_PROCESS_PARENT_PROCESS'),
    _api$buildTypes16 = _slicedToArray(_api$buildTypes15, 4);

var LINK_PROCESS_PARENT_PROCESS = _api$buildTypes16[0],
    LINK_PROCESS_PARENT_PROCESS_REQUEST = _api$buildTypes16[1],
    LINK_PROCESS_PARENT_PROCESS_SUCCESS = _api$buildTypes16[2],
    LINK_PROCESS_PARENT_PROCESS_FAILURE = _api$buildTypes16[3];
exports.LINK_PROCESS_PARENT_PROCESS = LINK_PROCESS_PARENT_PROCESS;
exports.LINK_PROCESS_PARENT_PROCESS_REQUEST = LINK_PROCESS_PARENT_PROCESS_REQUEST;
exports.LINK_PROCESS_PARENT_PROCESS_SUCCESS = LINK_PROCESS_PARENT_PROCESS_SUCCESS;
exports.LINK_PROCESS_PARENT_PROCESS_FAILURE = LINK_PROCESS_PARENT_PROCESS_FAILURE;
var linkProcessParentProcess = exports.linkProcessParentProcess = function linkProcessParentProcess(_ref8) {
  var teamName = _ref8.teamName,
      processID = _ref8.processID,
      parentProcessID = _ref8.parentProcessID;
  return {
    type: LINK_PROCESS_PARENT_PROCESS,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/parentprocesses/' + parentProcessID,
      schema: {},
      options: {
        method: 'POST'
      }
    }
  };
};

var _api$buildTypes17 = _api2.default.buildTypes('UNLINK_PROCESS_PARENT_PROCESS'),
    _api$buildTypes18 = _slicedToArray(_api$buildTypes17, 4);

var UNLINK_PROCESS_PARENT_PROCESS = _api$buildTypes18[0],
    UNLINK_PROCESS_PARENT_PROCESS_REQUEST = _api$buildTypes18[1],
    UNLINK_PROCESS_PARENT_PROCESS_SUCCESS = _api$buildTypes18[2],
    UNLINK_PROCESS_PARENT_PROCESS_FAILURE = _api$buildTypes18[3];
exports.UNLINK_PROCESS_PARENT_PROCESS = UNLINK_PROCESS_PARENT_PROCESS;
exports.UNLINK_PROCESS_PARENT_PROCESS_REQUEST = UNLINK_PROCESS_PARENT_PROCESS_REQUEST;
exports.UNLINK_PROCESS_PARENT_PROCESS_SUCCESS = UNLINK_PROCESS_PARENT_PROCESS_SUCCESS;
exports.UNLINK_PROCESS_PARENT_PROCESS_FAILURE = UNLINK_PROCESS_PARENT_PROCESS_FAILURE;
var unlinkProcessParentProcess = exports.unlinkProcessParentProcess = function unlinkProcessParentProcess(_ref9) {
  var teamName = _ref9.teamName,
      processID = _ref9.processID,
      parentProcessID = _ref9.parentProcessID;
  return {
    type: UNLINK_PROCESS_PARENT_PROCESS,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/parentprocesses/' + parentProcessID,
      schema: {},
      options: {
        method: 'DELETE'
      }
    }
  };
};

var _api$buildTypes19 = _api2.default.buildTypes('GET_PROCESS_PARENT_PROCESSES'),
    _api$buildTypes20 = _slicedToArray(_api$buildTypes19, 4);

var GET_PROCESS_PARENT_PROCESSES = _api$buildTypes20[0],
    GET_PROCESS_PARENT_PROCESSES_REQUEST = _api$buildTypes20[1],
    GET_PROCESS_PARENT_PROCESSES_SUCCESS = _api$buildTypes20[2],
    GET_PROCESS_PARENT_PROCESSES_FAILURE = _api$buildTypes20[3];
exports.GET_PROCESS_PARENT_PROCESSES = GET_PROCESS_PARENT_PROCESSES;
exports.GET_PROCESS_PARENT_PROCESSES_REQUEST = GET_PROCESS_PARENT_PROCESSES_REQUEST;
exports.GET_PROCESS_PARENT_PROCESSES_SUCCESS = GET_PROCESS_PARENT_PROCESSES_SUCCESS;
exports.GET_PROCESS_PARENT_PROCESSES_FAILURE = GET_PROCESS_PARENT_PROCESSES_FAILURE;
function getProcessParentProcesses(_ref10) {
  var teamName = _ref10.teamName,
      processID = _ref10.processID;

  return {
    type: GET_PROCESS_PARENT_PROCESSES,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/parentprocesses',
      schema: _schemas.PROCESS_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldOriginIcon = exports.getFieldOriginStep = exports.getReferencedPaths = exports.createConditionalFieldChangeHandler = exports.createConditionalFieldUpdateHandler = exports.createConditionalFieldUpdater = exports.collapseFieldsByFieldName = exports.findFieldByDisplayName = exports.getAllFieldVersionsForField = exports.filterFieldsToLatestFieldVersion = exports.getMostRecentAvailableFieldVersion = exports.getFileIDFromField = exports.getFieldValue = exports.fieldValueIsUndefined = exports.sortByWritableFields = exports.filterAndSortByWritableFields = exports.fieldIsFile = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(763);

var _debounce2 = _interopRequireDefault(_debounce);

var _differenceBy = __webpack_require__(402);

var _differenceBy2 = _interopRequireDefault(_differenceBy);

var _isPlainObject = __webpack_require__(167);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isArray = __webpack_require__(27);

var _isArray2 = _interopRequireDefault(_isArray);

var _pick = __webpack_require__(412);

var _pick2 = _interopRequireDefault(_pick);

var _unionBy = __webpack_require__(1311);

var _unionBy2 = _interopRequireDefault(_unionBy);

var _find = __webpack_require__(712);

var _find2 = _interopRequireDefault(_find);

var _uniq = __webpack_require__(392);

var _uniq2 = _interopRequireDefault(_uniq);

var _orderBy = __webpack_require__(1317);

var _orderBy2 = _interopRequireDefault(_orderBy);

var _Tasks = __webpack_require__(765);

var _Tasks2 = _interopRequireDefault(_Tasks);

var _NavTemplates = __webpack_require__(566);

var _NavTemplates2 = _interopRequireDefault(_NavTemplates);

var _ProcessOutline = __webpack_require__(405);

var _ProcessOutline2 = _interopRequireDefault(_ProcessOutline);

var _errorLog = __webpack_require__(259);

var _errorLog2 = _interopRequireDefault(_errorLog);

var _integrations = __webpack_require__(702);

var _implicitRunFields = __webpack_require__(811);

var _implicitRunFields2 = _interopRequireDefault(_implicitRunFields);

var _fields = __webpack_require__(400);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMPLICIT_RUN_FIELD_NAMES = _implicitRunFields2.default.map(function (f) {
  return f.fieldName;
});

var FILE_TYPES = ['file', 'photo'];

var fieldIsFile = exports.fieldIsFile = function fieldIsFile(field) {
  return FILE_TYPES.indexOf(field.type) !== -1;
};

var filterAndSortByWritableFields = exports.filterAndSortByWritableFields = function filterAndSortByWritableFields(fields, writableFields) {
  if (!fields || !writableFields) return [];
  return (0, _uniq2.default)(writableFields).map(function (fieldName) {
    return fields.find(function (field) {
      return field && field.fieldName === fieldName;
    });
  }).filter(function (f) {
    return f;
  });
};

// Currently has no opinion on order of fields not included in writableFields
var sortByWritableFields = exports.sortByWritableFields = function sortByWritableFields(fields, writableFields) {
  if (Array.isArray(writableFields)) {
    var cleanWritableFields = (0, _uniq2.default)(writableFields).filter(function (f) {
      return f;
    });
    return (0, _orderBy2.default)(fields, function (field) {
      return cleanWritableFields.indexOf(field.fieldName);
    });
  } else {
    return fields;
  }
};

var fieldValueIsUndefined = exports.fieldValueIsUndefined = function fieldValueIsUndefined(field) {
  return field.value == null || field.value === ''; // false and 0 are not (none)
};

var getFieldValue = exports.getFieldValue = function getFieldValue(field) {
  var value = field.value;

  if (fieldValueIsUndefined(field)) {
    value = '(none)';
  } else if (Array.isArray(field.value) && field.value.every(function (i) {
    return typeof i === 'string';
  })) {
    value = field.value.join(', ');
  } else if ((0, _isPlainObject2.default)(field.value)) {
    value = JSON.stringify(field.value);
  }

  return '' + value;
};

var getFileIDFromField = exports.getFileIDFromField = function getFileIDFromField(field) {
  if ((0, _isArray2.default)(field.value) && field.value.length) {
    // report old-style array file fields as a warning so we know to clean up
    if (field.value.length > 1) {
      _errorLog2.default.warning('Encountered field with value length > 1', (0, _pick2.default)(field, ['teamName', 'fieldID']));
    }
    if (_typeof(field.value[0]) === 'object') {
      return field.value[0].fileID;
    }
    return field.value[0];
  }

  return getFieldValue(field);
};

function findPreviousFieldVersion(field, fields) {
  return (0, _find2.default)(fields, function (_field) {
    return _field.fieldID === field.previousVersion;
  });
}

function findNextFieldVersion(field, fields) {
  return (0, _find2.default)(fields, function (_field) {
    return _field.previousVersion === field.fieldID;
  });
}

var getMostRecentAvailableFieldVersion = exports.getMostRecentAvailableFieldVersion = function getMostRecentAvailableFieldVersion(field, fields) {
  var nextField = findNextFieldVersion(field, fields);
  if (nextField && nextField.fieldID !== field.fieldID) {
    return getMostRecentAvailableFieldVersion(nextField, fields);
  } else {
    return field;
  }
};

var filterFieldsToLatestFieldVersion = exports.filterFieldsToLatestFieldVersion = function filterFieldsToLatestFieldVersion(fields) {
  return (0, _uniq2.default)(fields.map(function (field) {
    return getMostRecentAvailableFieldVersion(field, fields);
  }));
};

var getAllFieldVersionsForField = exports.getAllFieldVersionsForField = function getAllFieldVersionsForField(field, fields) {
  var mostRecentVersion = getMostRecentAvailableFieldVersion(field, fields);
  return _getAllFieldVersionsForFieldRecurse(mostRecentVersion, fields);
};

function _getAllFieldVersionsForFieldRecurse(field, fields) {
  var previousField = findPreviousFieldVersion(field, fields);
  if (previousField && previousField.fieldID !== field.fieldID) {
    return [field].concat(_getAllFieldVersionsForFieldRecurse(previousField, fields));
  } else {
    return [field];
  }
}

var findFieldByDisplayName = exports.findFieldByDisplayName = function findFieldByDisplayName(field, fields) {
  var _ref = field || {},
      displayName = _ref.displayName;

  if (displayName) {
    return fields.find(function (_ref2) {
      var candidateDisplayName = _ref2.displayName;
      return candidateDisplayName && candidateDisplayName.toUpperCase() === displayName.toUpperCase();
    });
  }
};

var collapseFieldsByFieldName = exports.collapseFieldsByFieldName = function collapseFieldsByFieldName(fields) {
  return Object.values((fields || []).reduce(function (o, nextField) {
    var key = nextField.fieldName;
    var lastField = o[key];
    o[key] = lastField !== undefined ? (0, _orderBy2.default)([lastField, nextField], ['runID', 'createdDate'], [true, true])[0] : nextField;
    return o;
  }, {}));
};

var createConditionalFieldUpdater = exports.createConditionalFieldUpdater = function createConditionalFieldUpdater(getIsConditionalFieldsEnabled, getIsLoading, toggleLoading, getIsValidFieldLoadState, setFields, handleError, getLatestFieldState) {
  return function (_updatedFields) {
    var _this = this;

    var _props = this.props,
        conditionalFieldsEnabled = _props.conditionalFieldsEnabled,
        masterFieldList = _props.fields,
        getVisibleFields = _props.getVisibleFields,
        writableFields = _props.writableFields,
        processID = _props.processID,
        runID = _props.runID,
        teamName = _props.teamName;


    var updatedFields = _updatedFields || masterFieldList;

    if (!conditionalFieldsEnabled || !getIsValidFieldLoadState()) {
      if (getIsLoading()) {
        toggleLoading(false);
      }

      setFields(sortByWritableFields(updatedFields, writableFields));
      return Promise.resolve();
    }

    var fields = (0, _unionBy2.default)(updatedFields, masterFieldList, 'fieldName');

    // TODO: Remove trust in the client's `field.conditionCode` (this saves API calls though)
    if (!getIsConditionalFieldsEnabled()) {
      if (getIsLoading()) {
        toggleLoading(false);
      }
      setFields(filterAndSortByWritableFields(fields, writableFields));
      return Promise.resolve();
    }

    // TODO: Don't tie to `StartPushbot` implementation
    var owner = this.state && this.state.runOwner && this.state.runOwner[0];

    return getVisibleFields({
      fields: fields,
      owner: owner,
      processID: processID,
      runID: runID,
      teamName: teamName
    }).then(function () {
      var hiddenFields = _this.props.hiddenFields;


      if (getLatestFieldState) {
        fields = (0, _unionBy2.default)(getLatestFieldState(), fields, 'fieldName');
      }

      var visibleFields = filterAndSortByWritableFields((0, _differenceBy2.default)(fields, hiddenFields, 'fieldName'), writableFields);

      setFields(visibleFields);
    }).catch(handleError).then(function () {
      return toggleLoading(false);
    });
  };
};

var createConditionalFieldUpdateHandler = exports.createConditionalFieldUpdateHandler = function createConditionalFieldUpdateHandler(updateFieldsFunction, isConditionalFieldsEnabled) {
  return isConditionalFieldsEnabled ? (0, _debounce2.default)(updateFieldsFunction, _fields.GET_VISIBLE_FIELDS_DEBOUNCE_AMOUNT, {
    trailing: true
  }).bind(this) // Ensure this is bound correctly in consumer component!
  : updateFieldsFunction;
};

var createConditionalFieldChangeHandler = exports.createConditionalFieldChangeHandler = function createConditionalFieldChangeHandler(getIsConditionalFieldsEnabled, handleFieldsUpdate, getIsLoading, toggleLoading) {
  return function (fields) {
    handleFieldsUpdate(fields);

    if (getIsConditionalFieldsEnabled() && !getIsLoading()) {
      toggleLoading(true);
    }
  };
};

// https://github.com/catalyticlabs/pushbot-api/blob/master/lib/util/handlebars-helper.js#L6
var HANDLEBARS_REGEX = /{{([^(){}!]+?)}}/g;

var getReferencedPaths = exports.getReferencedPaths = function getReferencedPaths(template) {
  return ((template || '').match(HANDLEBARS_REGEX) || []).map(function (match) {
    return match.slice(2, -2);
  }).map(function (match) {
    return match.trim();
  });
};

var getFieldOriginStep = exports.getFieldOriginStep = function getFieldOriginStep(field, process) {
  if (!process || !field) {
    return null;
  }

  var steps = process.steps || [];
  var originStep = steps.sort(function (a, b) {
    return a.stepNumber - b.stepNumber;
  }).find(function () {
    var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var stepWritableFields = step.writableFields || [];
    return stepWritableFields.indexOf(field.fieldName) !== -1;
  });

  return originStep || null;
};

var getFieldOriginIcon = exports.getFieldOriginIcon = function getFieldOriginIcon(field, process) {
  if (!field) {
    return null;
  }

  if (IMPLICIT_RUN_FIELD_NAMES.indexOf(field.fieldName) !== -1) {
    return _react2.default.createElement(_ProcessOutline2.default, null);
  }

  if (field.appName) {
    var Icon = (0, _integrations.appNameToIcon)(field.appName, field.appID);
    return _react2.default.createElement(Icon, null);
  }

  if (!process) {
    return null;
  }

  var originStep = getFieldOriginStep(field, process);
  if (originStep) {
    var appStep = originStep.appStep;
    if (appStep && appStep.appName) {
      var _Icon = (0, _integrations.appNameToIcon)(appStep.appName, appStep.appID);
      return _react2.default.createElement(_Icon, null);
    } else {
      // the default viewBox makes the icon visibly smaller than other icons
      return _react2.default.createElement(_Tasks2.default, { viewBox: '8 8 28 28' });
    }
  }

  return _react2.default.createElement(_NavTemplates2.default, null);
};

getFieldOriginIcon.displayName = 'Field Origin Icon';

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SEARCH_RESULTS_FAILURE = exports.GET_SEARCH_RESULTS_SUCCESS = exports.GET_SEARCH_RESULTS_REQUEST = exports.GET_SEARCH_RESULTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getSearchResultList = getSearchResultList;

var _url = __webpack_require__(83);

var _url2 = _interopRequireDefault(_url);

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _url3 = __webpack_require__(31);

var _search = __webpack_require__(703);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_SEARCH_RESULTS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_SEARCH_RESULTS = _api$buildTypes2[0],
    GET_SEARCH_RESULTS_REQUEST = _api$buildTypes2[1],
    GET_SEARCH_RESULTS_SUCCESS = _api$buildTypes2[2],
    GET_SEARCH_RESULTS_FAILURE = _api$buildTypes2[3];
exports.GET_SEARCH_RESULTS = GET_SEARCH_RESULTS;
exports.GET_SEARCH_RESULTS_REQUEST = GET_SEARCH_RESULTS_REQUEST;
exports.GET_SEARCH_RESULTS_SUCCESS = GET_SEARCH_RESULTS_SUCCESS;
exports.GET_SEARCH_RESULTS_FAILURE = GET_SEARCH_RESULTS_FAILURE;
function getSearchResultList(_ref) {
  var pageKey = _ref.pageKey,
      assignedTo = _ref.assignedTo,
      category = _ref.category,
      editableBy = _ref.editableBy,
      includeFields = _ref.includeFields,
      isArchived = _ref.isArchived,
      limit = _ref.limit,
      manuallyStartable = _ref.manuallyStartable,
      owner = _ref.owner,
      processID = _ref.processID,
      q = _ref.q,
      sort = _ref.sort,
      status = _ref.status,
      tableType = _ref.tableType,
      teamName = _ref.teamName,
      type = _ref.type,
      viewableBy = _ref.viewableBy,
      participatingUsers = _ref.participatingUsers,
      searchID = _ref.searchID,
      _ref$universalSearch = _ref.universalSearch,
      universalSearch = _ref$universalSearch === undefined ? false : _ref$universalSearch,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? '' : _ref$text,
      _ref$schema = _ref.schema,
      schema = _ref$schema === undefined ? _schemas.SEARCH : _ref$schema;

  var query = void 0;

  if (universalSearch) {
    query = _extends({}, (0, _search.transformSearchQuery)(text), {
      pageToken: pageKey
    });
  } else {
    query = _extends({}, pageKey && { pageToken: pageKey }, assignedTo && {
      assignedTo: Array.isArray(assignedTo) ? assignedTo.join(',') : assignedTo
    }, category !== undefined && { category: category }, editableBy !== undefined && {
      editableBy: Array.isArray(editableBy) ? editableBy.join(',') : editableBy
    }, includeFields && { includeFields: includeFields }, isArchived !== undefined && { isArchived: isArchived }, limit && { limit: limit }, manuallyStartable !== undefined && { manuallyStartable: manuallyStartable }, owner && { owner: owner }, processID && { processID: processID }, q && { q: q }, sort && { sort: sort }, status && status !== 'all' && { status: status }, tableType && { tableType: tableType }, type && { types: type }, viewableBy !== undefined && {
      viewableBy: Array.isArray(viewableBy) ? viewableBy.join(',') : viewableBy
    }, participatingUsers !== undefined && {
      participatingUsers: Array.isArray(participatingUsers) ? participatingUsers.join(',') : participatingUsers
    });
  }

  var payloadUrl = (0, _url3.format)({
    pathname: '/teams/' + teamName + '/search',
    query: query
  });

  return {
    type: GET_SEARCH_RESULTS,
    payload: {
      url: payloadUrl,
      schema: schema,
      transform: function transform(v) {
        return _extends({}, v, {
          searchID: searchID || _url2.default.parse(payloadUrl, true).search
        });
      },
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_APPS_FAILURE = exports.GET_APPS_SUCCESS = exports.GET_APPS_REQUEST = exports.GET_APPS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getApps = getApps;
exports.getAppByAppName = getAppByAppName;
exports.getAuthableApps = getAuthableApps;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_APPS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_APPS = _api$buildTypes2[0],
    GET_APPS_REQUEST = _api$buildTypes2[1],
    GET_APPS_SUCCESS = _api$buildTypes2[2],
    GET_APPS_FAILURE = _api$buildTypes2[3];
exports.GET_APPS = GET_APPS;
exports.GET_APPS_REQUEST = GET_APPS_REQUEST;
exports.GET_APPS_SUCCESS = GET_APPS_SUCCESS;
exports.GET_APPS_FAILURE = GET_APPS_FAILURE;
function getApps(_ref) {
  var teamName = _ref.teamName,
      action = _ref.action,
      integrationDefinition = _ref.integrationDefinition,
      _ref$includeSharedApp = _ref.includeSharedApps,
      includeSharedApps = _ref$includeSharedApp === undefined ? true : _ref$includeSharedApp,
      _ref$includeDraftApps = _ref.includeDraftApps,
      includeDraftApps = _ref$includeDraftApps === undefined ? false : _ref$includeDraftApps;

  var url = '/teams/' + teamName + '/apps?includeSharedApps=' + includeSharedApps;
  if (includeDraftApps) {
    url += '&includeDrafts=true';
  }
  if (integrationDefinition) {
    url += '&integrationDefinition=true';
  }
  if (action) {
    url += '&action=' + action;
  }
  return {
    type: GET_APPS,
    payload: {
      url: url,
      schema: _schemas.APP_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

function getAppByAppName(_ref2) {
  var teamName = _ref2.teamName,
      appName = _ref2.appName;

  var url = '/teams/' + teamName + '/apps/' + appName;
  return {
    type: GET_APPS,
    payload: {
      url: url,
      schema: _schemas.APP_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

function getAuthableApps(_ref3) {
  var teamName = _ref3.teamName,
      includeDraftApps = _ref3.includeDraftApps;

  return getApps({
    teamName: teamName,
    integrationDefinition: true,
    includeSharedApps: true,
    includeDraftApps: includeDraftApps
  });
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = exports['default'] = undefined;

var _Avatar = __webpack_require__(1673);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Avatar)['default'];
    }

    return get;
  }()
});

var _UserAvatar2 = __webpack_require__(778);

var _UserAvatar3 = _interopRequireDefault(_UserAvatar2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.UserAvatar = _UserAvatar3['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(421);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userLogin = __webpack_require__(690);

var _userLogin2 = _interopRequireDefault(_userLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  appCredentials: oneOfType([string, shape({})]),
  appName: string,
  appState: oneOfType([string, shape({})]),
  appVersion: oneOfType([number, string]),
  createdBy: string,
  createdDate: string,
  email: string,
  experience: string,
  fullName: string,
  includeCalendarAttachmentsOnEmails: bool,
  isArchived: bool,
  isGroup: bool,
  isIntegration: bool,
  isRestricted: bool,
  isShared: bool,
  isTeamAdmin: bool,
  isTeamOwner: bool,
  isSudoer: bool,
  lastLogin: _userLogin2.default,
  isLockedOut: bool,
  members: arrayOf(string),
  notificationPreference: shape({
    assignment: oneOfType([string, bool]),
    dailySummary: oneOfType([bool, string, shape({
      email: bool
    })]),
    email: shape({
      enabled: bool.isRequired
    }).isRequired,
    reminders: oneOfType([string, bool]),
    runCompletion: oneOfType([string, bool]),
    sms: shape({
      enabled: bool.isRequired
    }),
    updates: oneOfType([string, bool]),
    weeklyTeamOwner: oneOfType([bool, string, shape({
      email: bool
    })])
  }),
  phone: string,
  slackUsername: string,
  teamName: string,
  token: string,
  userID: string,
  userKey: string,
  username: string,
  userThumbnail: string
});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_STEP_TEST_FAILURE = exports.START_STEP_TEST_SUCCESS = exports.START_STEP_TEST_REQUEST = exports.START_STEP_TEST = exports.GET_STEP_TEST_FIELDS_FAILURE = exports.GET_STEP_TEST_FIELDS_SUCCESS = exports.GET_STEP_TEST_FIELDS_REQUEST = exports.GET_STEP_TEST_FIELDS = exports.deleteStep = exports.DELETE_STEP_FAILURE = exports.DELETE_STEP_SUCCESS = exports.DELETE_STEP_REQUEST = exports.DELETE_STEP = exports.updateStep = exports.UPDATE_STEP_FAILURE = exports.UPDATE_STEP_SUCCESS = exports.UPDATE_STEP_REQUEST = exports.UPDATE_STEP = exports.ADD_STEP_FAILURE = exports.ADD_STEP_SUCCESS = exports.ADD_STEP_REQUEST = exports.ADD_STEP = exports.GET_STEP_FAILURE = exports.GET_STEP_SUCCESS = exports.GET_STEP_REQUEST = exports.GET_STEP = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getStep = getStep;
exports.addStep = addStep;
exports.getStepTestFields = getStepTestFields;
exports.startStepTest = startStepTest;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_STEP'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_STEP = _api$buildTypes2[0],
    GET_STEP_REQUEST = _api$buildTypes2[1],
    GET_STEP_SUCCESS = _api$buildTypes2[2],
    GET_STEP_FAILURE = _api$buildTypes2[3];
exports.GET_STEP = GET_STEP;
exports.GET_STEP_REQUEST = GET_STEP_REQUEST;
exports.GET_STEP_SUCCESS = GET_STEP_SUCCESS;
exports.GET_STEP_FAILURE = GET_STEP_FAILURE;
function getStep(_ref) {
  var teamName = _ref.teamName,
      processName = _ref.processName,
      stepName = _ref.stepName;

  return {
    processID: processName,
    type: GET_STEP,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processName + '/steps/' + stepName,
      schema: _schemas.STEP,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_STEP'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_STEP = _api$buildTypes4[0],
    ADD_STEP_REQUEST = _api$buildTypes4[1],
    ADD_STEP_SUCCESS = _api$buildTypes4[2],
    ADD_STEP_FAILURE = _api$buildTypes4[3];
exports.ADD_STEP = ADD_STEP;
exports.ADD_STEP_REQUEST = ADD_STEP_REQUEST;
exports.ADD_STEP_SUCCESS = ADD_STEP_SUCCESS;
exports.ADD_STEP_FAILURE = ADD_STEP_FAILURE;
function addStep(_ref2) {
  var teamName = _ref2.teamName,
      processName = _ref2.processName,
      _ref2$step = _ref2.step,
      step = _ref2$step === undefined ? {} : _ref2$step;

  return {
    processID: processName,
    type: ADD_STEP,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processName + '/steps',
      schema: _schemas.STEP,
      options: {
        method: 'POST',
        body: step
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_STEP'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_STEP = _api$buildTypes6[0],
    UPDATE_STEP_REQUEST = _api$buildTypes6[1],
    UPDATE_STEP_SUCCESS = _api$buildTypes6[2],
    UPDATE_STEP_FAILURE = _api$buildTypes6[3];
exports.UPDATE_STEP = UPDATE_STEP;
exports.UPDATE_STEP_REQUEST = UPDATE_STEP_REQUEST;
exports.UPDATE_STEP_SUCCESS = UPDATE_STEP_SUCCESS;
exports.UPDATE_STEP_FAILURE = UPDATE_STEP_FAILURE;
var updateStep = exports.updateStep = function updateStep(_ref3) {
  var teamName = _ref3.teamName,
      processName = _ref3.processName,
      stepName = _ref3.stepName,
      _ref3$step = _ref3.step,
      step = _ref3$step === undefined ? {} : _ref3$step;
  return {
    type: UPDATE_STEP,
    payload: {
      processID: processName,
      url: '/teams/' + teamName + '/processes/' + processName + '/steps/' + stepName,
      schema: _schemas.STEP,
      options: {
        method: 'PUT',
        body: step
      }
    }
  };
};

var _api$buildTypes7 = _api2.default.buildTypes('DELETE_STEP'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var DELETE_STEP = _api$buildTypes8[0],
    DELETE_STEP_REQUEST = _api$buildTypes8[1],
    DELETE_STEP_SUCCESS = _api$buildTypes8[2],
    DELETE_STEP_FAILURE = _api$buildTypes8[3];
exports.DELETE_STEP = DELETE_STEP;
exports.DELETE_STEP_REQUEST = DELETE_STEP_REQUEST;
exports.DELETE_STEP_SUCCESS = DELETE_STEP_SUCCESS;
exports.DELETE_STEP_FAILURE = DELETE_STEP_FAILURE;
var deleteStep = exports.deleteStep = function deleteStep(_ref4) {
  var teamName = _ref4.teamName,
      processName = _ref4.processName,
      stepName = _ref4.stepName;
  return {
    type: DELETE_STEP,
    payload: {
      processID: processName,
      stepName: stepName,
      url: '/teams/' + teamName + '/processes/' + processName + '/steps/' + stepName,
      schema: _schemas.STEP,
      options: {
        method: 'DELETE'
      }
    }
  };
};

var _api$buildTypes9 = _api2.default.buildTypes('GET_STEP_TEST_FIELDS'),
    _api$buildTypes10 = _slicedToArray(_api$buildTypes9, 4);

var GET_STEP_TEST_FIELDS = _api$buildTypes10[0],
    GET_STEP_TEST_FIELDS_REQUEST = _api$buildTypes10[1],
    GET_STEP_TEST_FIELDS_SUCCESS = _api$buildTypes10[2],
    GET_STEP_TEST_FIELDS_FAILURE = _api$buildTypes10[3];
exports.GET_STEP_TEST_FIELDS = GET_STEP_TEST_FIELDS;
exports.GET_STEP_TEST_FIELDS_REQUEST = GET_STEP_TEST_FIELDS_REQUEST;
exports.GET_STEP_TEST_FIELDS_SUCCESS = GET_STEP_TEST_FIELDS_SUCCESS;
exports.GET_STEP_TEST_FIELDS_FAILURE = GET_STEP_TEST_FIELDS_FAILURE;
function getStepTestFields(_ref5) {
  var teamName = _ref5.teamName,
      processName = _ref5.processName,
      stepName = _ref5.stepName;

  return {
    processID: processName,
    type: GET_STEP_TEST_FIELDS,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processName + '/steps/' + stepName + '/test',
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes11 = _api2.default.buildTypes('START_STEP_TEST'),
    _api$buildTypes12 = _slicedToArray(_api$buildTypes11, 4);

var START_STEP_TEST = _api$buildTypes12[0],
    START_STEP_TEST_REQUEST = _api$buildTypes12[1],
    START_STEP_TEST_SUCCESS = _api$buildTypes12[2],
    START_STEP_TEST_FAILURE = _api$buildTypes12[3];
exports.START_STEP_TEST = START_STEP_TEST;
exports.START_STEP_TEST_REQUEST = START_STEP_TEST_REQUEST;
exports.START_STEP_TEST_SUCCESS = START_STEP_TEST_SUCCESS;
exports.START_STEP_TEST_FAILURE = START_STEP_TEST_FAILURE;
function startStepTest(_ref6) {
  var teamName = _ref6.teamName,
      processName = _ref6.processName,
      stepName = _ref6.stepName,
      fields = _ref6.fields;

  return {
    processID: processName,
    type: START_STEP_TEST,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processName + '/steps/' + stepName + '/test',
      options: {
        method: 'POST',
        body: fields
      }
    }
  };
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_INTEGRATIONS_FAILURE = exports.GET_INTEGRATIONS_SUCCESS = exports.GET_INTEGRATIONS_REQUEST = exports.GET_INTEGRATIONS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getIntegrations = getIntegrations;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_INTEGRATIONS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_INTEGRATIONS = _api$buildTypes2[0],
    GET_INTEGRATIONS_REQUEST = _api$buildTypes2[1],
    GET_INTEGRATIONS_SUCCESS = _api$buildTypes2[2],
    GET_INTEGRATIONS_FAILURE = _api$buildTypes2[3];
exports.GET_INTEGRATIONS = GET_INTEGRATIONS;
exports.GET_INTEGRATIONS_REQUEST = GET_INTEGRATIONS_REQUEST;
exports.GET_INTEGRATIONS_SUCCESS = GET_INTEGRATIONS_SUCCESS;
exports.GET_INTEGRATIONS_FAILURE = GET_INTEGRATIONS_FAILURE;
function getIntegrations(_ref) {
  var teamName = _ref.teamName,
      _ref$appName = _ref.appName,
      appName = _ref$appName === undefined ? '' : _ref$appName;

  return {
    type: GET_INTEGRATIONS,
    payload: {
      url: '/teams/' + teamName + '/integrations?appName=' + appName,
      schema: _schemas.INTEGRATION_LIST
    }
  };
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(1283),
    util = __webpack_require__(1285);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PieProgress = exports.SegmentedProgress = exports.LinearProgress = exports.CircularProgress = exports['default'] = undefined;

var _LinearProgress2 = __webpack_require__(1647);

var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);

var _CircularProgress2 = __webpack_require__(1648);

var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);

var _SegmentedProgress2 = __webpack_require__(736);

var _SegmentedProgress3 = _interopRequireDefault(_SegmentedProgress2);

var _PieProgress2 = __webpack_require__(633);

var _PieProgress3 = _interopRequireDefault(_PieProgress2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _LinearProgress3['default'];
exports.CircularProgress = _CircularProgress3['default'];
exports.LinearProgress = _LinearProgress3['default'];
exports.SegmentedProgress = _SegmentedProgress3['default'];
exports.PieProgress = _PieProgress3['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.properties = undefined;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _field = __webpack_require__(91);

var _field2 = _interopRequireDefault(_field);

var _file = __webpack_require__(381);

var _file2 = _interopRequireDefault(_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars
var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;
var properties = exports.properties = {
  appStep: shape({
    appID: string.isRequired,
    params: objectOf(string)
  }),
  deadline: string,
  assignedTo: string,
  conditionCode: string,
  conditions: arrayOf(string),
  createdBy: string,
  description: string,
  displayName: string,
  descriptionPieces: oneOfType([string, shape({
    sourceText: string,
    fieldMap: objectOf(_field2.default)
  })]),
  endDate: string,
  fields: arrayOf(_field2.default),
  files: arrayOf(_file2.default),
  fieldCount: number,
  isOverdue: bool,
  isTerminal: bool,
  maximumDuration: string,
  nextVersion: string,
  priority: string,
  processID: string,
  runID: string,
  taskID: string,
  taskName: string,
  processDisplayName: string,
  runDisplayName: string,
  requiredPreviousTasks: arrayOf(string),
  previousTasks: arrayOf(string),
  previousVersion: string,
  rejectedReason: string,
  roleID: string,
  role: shape({
    users: arrayOf(string),
    fields: arrayOf(string)
  }),
  startDate: string,
  status: string,
  taskNumber: number,
  teamName: string,
  webhookID: string
};

exports.default = shape(properties);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Clear = function (_SvgIcon) {
  _inherits(Clear, _SvgIcon);

  function Clear() {
    _classCallCheck(this, Clear);

    return _possibleConstructorReturn(this, (Clear.__proto__ || Object.getPrototypeOf(Clear)).apply(this, arguments));
  }

  _createClass(Clear, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' }),
          _react2['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
        );
      }

      return render;
    }()
  }]);

  return Clear;
}(_SvgIcon3['default']);

exports['default'] = Clear;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_VISIBLE_FIELDS_DEBOUNCE_AMOUNT = exports.GET_VISIBLE_FIELDS_FAILURE = exports.GET_VISIBLE_FIELDS_SUCCESS = exports.GET_VISIBLE_FIELDS_REQUEST = exports.GET_VISIBLE_FIELDS = exports.GET_PROCESS_FIELDS_FAILURE = exports.GET_PROCESS_FIELDS_SUCCESS = exports.GET_PROCESS_FIELDS_REQUEST = exports.GET_PROCESS_FIELDS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // eslint-disable-line import/named

exports.getProcessFields = getProcessFields;
exports.getVisibleFields = getVisibleFields;

var _pick = __webpack_require__(412);

var _pick2 = _interopRequireDefault(_pick);

var _isBoolean = __webpack_require__(1306);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _url = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_PROCESS_FIELDS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_PROCESS_FIELDS = _api$buildTypes2[0],
    GET_PROCESS_FIELDS_REQUEST = _api$buildTypes2[1],
    GET_PROCESS_FIELDS_SUCCESS = _api$buildTypes2[2],
    GET_PROCESS_FIELDS_FAILURE = _api$buildTypes2[3];
exports.GET_PROCESS_FIELDS = GET_PROCESS_FIELDS;
exports.GET_PROCESS_FIELDS_REQUEST = GET_PROCESS_FIELDS_REQUEST;
exports.GET_PROCESS_FIELDS_SUCCESS = GET_PROCESS_FIELDS_SUCCESS;
exports.GET_PROCESS_FIELDS_FAILURE = GET_PROCESS_FIELDS_FAILURE;
function getProcessFields(_ref) {
  var teamName = _ref.teamName,
      processID = _ref.processID;

  var pathname = '/teams/' + teamName + '/processes/' + processID + '/fields';
  var query = { eval: true };
  return {
    type: GET_PROCESS_FIELDS,
    payload: {
      processID: processID,
      url: (0, _url.format)({ pathname: pathname, query: query }),
      schema: _schemas.FIELDS_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('GET_VISIBLE_FIELDS'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var GET_VISIBLE_FIELDS = _api$buildTypes4[0],
    GET_VISIBLE_FIELDS_REQUEST = _api$buildTypes4[1],
    GET_VISIBLE_FIELDS_SUCCESS = _api$buildTypes4[2],
    GET_VISIBLE_FIELDS_FAILURE = _api$buildTypes4[3];
exports.GET_VISIBLE_FIELDS = GET_VISIBLE_FIELDS;
exports.GET_VISIBLE_FIELDS_REQUEST = GET_VISIBLE_FIELDS_REQUEST;
exports.GET_VISIBLE_FIELDS_SUCCESS = GET_VISIBLE_FIELDS_SUCCESS;
exports.GET_VISIBLE_FIELDS_FAILURE = GET_VISIBLE_FIELDS_FAILURE;
var GET_VISIBLE_FIELDS_DEBOUNCE_AMOUNT = exports.GET_VISIBLE_FIELDS_DEBOUNCE_AMOUNT = 540; // ms

function getVisibleFields(_ref2) {
  var _ref2$fields = _ref2.fields,
      fields = _ref2$fields === undefined ? [] : _ref2$fields,
      owner = _ref2.owner,
      processID = _ref2.processID,
      runID = _ref2.runID,
      teamName = _ref2.teamName,
      includeIgnored = _ref2.includeIgnored;

  var query = {};
  var pathname = runID ? '/teams/' + teamName + '/runs/' + runID + '/visibility' // `runID` must be used over `processID` if both are supplied
  : '/teams/' + teamName + '/processes/' + processID + '/visibility';

  if ((0, _isBoolean2.default)(includeIgnored)) {
    query.includeIgnored = includeIgnored;
  }

  var url = (0, _url.format)({ pathname: pathname, query: query });

  var body = {
    fields: fields.map(function (f) {
      if (f.type !== 'file') {
        return f;
      }
      // this is to ensure we don't actually overwrite the file field
      // used for form submission
      var fileFieldForVisibility = Object.assign({}, f, {
        value: f.value && Array.isArray(f.value) ? f.value.map(function (v) {
          return v.basename;
        }) : f.value
      });
      return fileFieldForVisibility;
    }).map(function (f) {
      return (0, _pick2.default)(f, ['fieldName', 'fieldID', 'value']);
    })
  };

  if (owner) {
    body.owner = owner;
  }

  return {
    type: GET_VISIBLE_FIELDS,
    payload: {
      runID: runID,
      processID: processID,
      url: url,
      schema: _schemas.FIELDS_LIST,
      options: {
        method: 'POST',
        body: body,
        retry: true
      }
    }
  };
}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(228);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(764),
    baseFlatten = __webpack_require__(195),
    baseIteratee = __webpack_require__(57),
    baseRest = __webpack_require__(191),
    isArrayLikeObject = __webpack_require__(252),
    last = __webpack_require__(263);

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function(array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2))
    : [];
});

module.exports = differenceBy;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.READ_NOTIFICATION_FAILURE = exports.READ_NOTIFICATION_SUCCESS = exports.READ_NOTIFICATION_REQUEST = exports.READ_NOTIFICATION = exports.UPDATE_NOTIFICATION_FAILURE = exports.UPDATE_NOTIFICATION_SUCCESS = exports.UPDATE_NOTIFICATION_REQUEST = exports.UPDATE_NOTIFICATION = exports.GET_NOTIFICATIONS_FAILURE = exports.GET_NOTIFICATIONS_SUCCESS = exports.GET_NOTIFICATIONS_REQUEST = exports.GET_NOTIFICATIONS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getNotifications = getNotifications;
exports.updateNotification = updateNotification;
exports.readNotification = readNotification;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_NOTIFICATIONS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_NOTIFICATIONS = _api$buildTypes2[0],
    GET_NOTIFICATIONS_REQUEST = _api$buildTypes2[1],
    GET_NOTIFICATIONS_SUCCESS = _api$buildTypes2[2],
    GET_NOTIFICATIONS_FAILURE = _api$buildTypes2[3];
exports.GET_NOTIFICATIONS = GET_NOTIFICATIONS;
exports.GET_NOTIFICATIONS_REQUEST = GET_NOTIFICATIONS_REQUEST;
exports.GET_NOTIFICATIONS_SUCCESS = GET_NOTIFICATIONS_SUCCESS;
exports.GET_NOTIFICATIONS_FAILURE = GET_NOTIFICATIONS_FAILURE;
function getNotifications(_ref) {
  var teamName = _ref.teamName,
      username = _ref.username,
      read = _ref.read;

  return {
    type: GET_NOTIFICATIONS,
    payload: {
      url: 'teams/' + teamName + '/users/' + username + '/notifications?read=' + read,
      schema: _schemas.NOTIFICATION_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('UPDATE_NOTIFICATION'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var UPDATE_NOTIFICATION = _api$buildTypes4[0],
    UPDATE_NOTIFICATION_REQUEST = _api$buildTypes4[1],
    UPDATE_NOTIFICATION_SUCCESS = _api$buildTypes4[2],
    UPDATE_NOTIFICATION_FAILURE = _api$buildTypes4[3];
exports.UPDATE_NOTIFICATION = UPDATE_NOTIFICATION;
exports.UPDATE_NOTIFICATION_REQUEST = UPDATE_NOTIFICATION_REQUEST;
exports.UPDATE_NOTIFICATION_SUCCESS = UPDATE_NOTIFICATION_SUCCESS;
exports.UPDATE_NOTIFICATION_FAILURE = UPDATE_NOTIFICATION_FAILURE;
function updateNotification(_ref2) {
  var teamName = _ref2.teamName,
      username = _ref2.username,
      notificationID = _ref2.notificationID,
      notification = _ref2.notification;

  return {
    type: UPDATE_NOTIFICATION,
    payload: {
      url: 'teams/' + teamName + '/users/' + username + '/notifications/' + notificationID,
      schema: _schemas.NOTIFICATION,
      options: {
        method: 'PUT',
        body: notification
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('READ_NOTIFICATION'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var READ_NOTIFICATION = _api$buildTypes6[0],
    READ_NOTIFICATION_REQUEST = _api$buildTypes6[1],
    READ_NOTIFICATION_SUCCESS = _api$buildTypes6[2],
    READ_NOTIFICATION_FAILURE = _api$buildTypes6[3];
exports.READ_NOTIFICATION = READ_NOTIFICATION;
exports.READ_NOTIFICATION_REQUEST = READ_NOTIFICATION_REQUEST;
exports.READ_NOTIFICATION_SUCCESS = READ_NOTIFICATION_SUCCESS;
exports.READ_NOTIFICATION_FAILURE = READ_NOTIFICATION_FAILURE;
function readNotification(_ref3) {
  var teamName = _ref3.teamName,
      username = _ref3.username,
      notificationID = _ref3.notificationID;

  return {
    type: READ_NOTIFICATION,
    payload: {
      url: 'teams/' + teamName + '/users/' + username + '/notifications/' + notificationID,
      schema: _schemas.NOTIFICATION,
      options: {
        method: 'PUT',
        body: { read: true }
      }
    }
  };
}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProcessOutline = (_temp = _class = function (_SvgIcon) {
  _inherits(ProcessOutline, _SvgIcon);

  function ProcessOutline() {
    _classCallCheck(this, ProcessOutline);

    return _possibleConstructorReturn(this, (ProcessOutline.__proto__ || Object.getPrototypeOf(ProcessOutline)).apply(this, arguments));
  }

  _createClass(ProcessOutline, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M16,0H2C0.9,0,0,0.9,0,2v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V2C18,0.9,17.1,0,16,0z M16.5,16.5l-15,0l0-15h15l0,13c0,0,0,0,0,0L16.5,16.5z M11,7.1H7.7c-0.5,0-0.9-0.5-0.9-1c0-0.5,0.4-0.9,0.9-0.9H11c0.5,0,1,0.4,1,0.9C12,6.7,11.6,7.1,11,7.1C11.1,7.1,11.1,7.1,11,7.1L11,7.1z M12.8,13.1H7.7c-0.5,0-0.9-0.5-0.9-1c0-0.5,0.4-0.9,0.9-0.9h5.1c0.5,0,1,0.4,1,0.9C13.8,12.7,13.4,13.1,12.8,13.1C12.8,13.1,12.8,13.1,12.8,13.1z M9.3,10.1H7.7c-0.5,0-0.9-0.5-0.9-1c0-0.5,0.4-0.9,0.9-0.9h1.6c0.5,0,0.9,0.4,0.9,0.9S9.8,10.1,9.3,10.1z M4.7,11.2c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1s-1-0.4-1-1C3.7,11.6,4.1,11.2,4.7,11.2z M4.7,8.2c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1s-1-0.4-1-1C3.7,8.6,4.1,8.2,4.7,8.2z M4.7,5.2c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S4.1,5.2,4.7,5.2z' })
        );
      }

      return render;
    }()
  }]);

  return ProcessOutline;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 18 18'
}, _temp);
exports['default'] = ProcessOutline;

/***/ }),
/* 406 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(223), __webpack_require__(1160), __webpack_require__(1161), __webpack_require__(133), __webpack_require__(134), __webpack_require__(322), __webpack_require__(519), __webpack_require__(1162), __webpack_require__(520), __webpack_require__(1163), __webpack_require__(1164), __webpack_require__(1165), __webpack_require__(323), __webpack_require__(1166), __webpack_require__(135), __webpack_require__(30), __webpack_require__(1167), __webpack_require__(1168), __webpack_require__(1169), __webpack_require__(1170), __webpack_require__(1171), __webpack_require__(1172), __webpack_require__(1173), __webpack_require__(1174), __webpack_require__(1175), __webpack_require__(1176), __webpack_require__(1177), __webpack_require__(1178), __webpack_require__(1179), __webpack_require__(1180), __webpack_require__(1181), __webpack_require__(1182));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(249);

var _equals = /*#__PURE__*/__webpack_require__(1205);

/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */


var equals = /*#__PURE__*/_curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});
module.exports = equals;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(757),
    createBaseEach = __webpack_require__(1273);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_FILTER_FAILURE = exports.DELETE_FILTER_SUCCESS = exports.DELETE_FILTER_REQUEST = exports.DELETE_FILTER = exports.ADD_FILTER_FAILURE = exports.ADD_FILTER_SUCCESS = exports.ADD_FILTER_REQUEST = exports.ADD_FILTER = exports.GET_FILTERS_FAILURE = exports.GET_FILTERS_SUCCESS = exports.GET_FILTERS_REQUEST = exports.GET_FILTERS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getFilters = getFilters;
exports.addFilter = addFilter;
exports.deleteFilter = deleteFilter;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_FILTERS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_FILTERS = _api$buildTypes2[0],
    GET_FILTERS_REQUEST = _api$buildTypes2[1],
    GET_FILTERS_SUCCESS = _api$buildTypes2[2],
    GET_FILTERS_FAILURE = _api$buildTypes2[3];
exports.GET_FILTERS = GET_FILTERS;
exports.GET_FILTERS_REQUEST = GET_FILTERS_REQUEST;
exports.GET_FILTERS_SUCCESS = GET_FILTERS_SUCCESS;
exports.GET_FILTERS_FAILURE = GET_FILTERS_FAILURE;
function getFilters(_ref) {
  var teamName = _ref.teamName,
      _ref$username = _ref.username,
      username = _ref$username === undefined ? 'me' : _ref$username;

  return {
    type: GET_FILTERS,
    payload: {
      url: '/teams/' + teamName + '/users/' + username + '/filters',
      schema: { filters: [_schemas.FILTER] },
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_FILTER'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_FILTER = _api$buildTypes4[0],
    ADD_FILTER_REQUEST = _api$buildTypes4[1],
    ADD_FILTER_SUCCESS = _api$buildTypes4[2],
    ADD_FILTER_FAILURE = _api$buildTypes4[3];
exports.ADD_FILTER = ADD_FILTER;
exports.ADD_FILTER_REQUEST = ADD_FILTER_REQUEST;
exports.ADD_FILTER_SUCCESS = ADD_FILTER_SUCCESS;
exports.ADD_FILTER_FAILURE = ADD_FILTER_FAILURE;
function addFilter(_ref2) {
  var teamName = _ref2.teamName,
      filterData = _ref2.filterData,
      _ref2$username = _ref2.username,
      username = _ref2$username === undefined ? 'me' : _ref2$username;

  return {
    type: ADD_FILTER,
    payload: {
      url: '/teams/' + teamName + '/users/' + username + '/filters',
      schema: _schemas.FILTER,
      options: {
        method: 'POST',
        body: filterData
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('DELETE_FILTER'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var DELETE_FILTER = _api$buildTypes6[0],
    DELETE_FILTER_REQUEST = _api$buildTypes6[1],
    DELETE_FILTER_SUCCESS = _api$buildTypes6[2],
    DELETE_FILTER_FAILURE = _api$buildTypes6[3];
exports.DELETE_FILTER = DELETE_FILTER;
exports.DELETE_FILTER_REQUEST = DELETE_FILTER_REQUEST;
exports.DELETE_FILTER_SUCCESS = DELETE_FILTER_SUCCESS;
exports.DELETE_FILTER_FAILURE = DELETE_FILTER_FAILURE;
function deleteFilter(_ref3) {
  var teamName = _ref3.teamName,
      filterID = _ref3.filterID,
      _ref3$username = _ref3.username,
      username = _ref3$username === undefined ? 'me' : _ref3$username;

  return {
    type: DELETE_FILTER,
    paylod: {
      url: '/teams/' + teamName + '/users/' + username + '/filters/' + filterID,
      schema: _schemas.FILTER,
      options: {
        method: 'DELETE'
      }
    }
  };
}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_WEBFORM_FAILURE = exports.UPDATE_WEBFORM_SUCCESS = exports.UPDATE_WEBFORM_REQUEST = exports.UPDATE_WEBFORM = exports.CREATE_WEBFORM_FAILURE = exports.CREATE_WEBFORM_SUCCESS = exports.CREATE_WEBFORM_REQUEST = exports.CREATE_WEBFORM = exports.GET_WEBFORM_FAILURE = exports.GET_WEBFORM_SUCCESS = exports.GET_WEBFORM_REQUEST = exports.GET_WEBFORM = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getWebform = getWebform;
exports.createWebform = createWebform;
exports.updateWebform = updateWebform;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_WEBFORM'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_WEBFORM = _api$buildTypes2[0],
    GET_WEBFORM_REQUEST = _api$buildTypes2[1],
    GET_WEBFORM_SUCCESS = _api$buildTypes2[2],
    GET_WEBFORM_FAILURE = _api$buildTypes2[3];
exports.GET_WEBFORM = GET_WEBFORM;
exports.GET_WEBFORM_REQUEST = GET_WEBFORM_REQUEST;
exports.GET_WEBFORM_SUCCESS = GET_WEBFORM_SUCCESS;
exports.GET_WEBFORM_FAILURE = GET_WEBFORM_FAILURE;
function getWebform(_ref) {
  var teamName = _ref.teamName,
      webhookname = _ref.webhookname;

  return {
    type: GET_WEBFORM,
    payload: {
      url: 'teams/' + teamName + '/forms/' + webhookname,
      schema: _schemas.WEBHOOK
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('CREATE_WEBFORM'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var CREATE_WEBFORM = _api$buildTypes4[0],
    CREATE_WEBFORM_REQUEST = _api$buildTypes4[1],
    CREATE_WEBFORM_SUCCESS = _api$buildTypes4[2],
    CREATE_WEBFORM_FAILURE = _api$buildTypes4[3];
exports.CREATE_WEBFORM = CREATE_WEBFORM;
exports.CREATE_WEBFORM_REQUEST = CREATE_WEBFORM_REQUEST;
exports.CREATE_WEBFORM_SUCCESS = CREATE_WEBFORM_SUCCESS;
exports.CREATE_WEBFORM_FAILURE = CREATE_WEBFORM_FAILURE;
function createWebform(_ref2) {
  var webform = _ref2.webform,
      teamName = _ref2.teamName;

  var url = 'teams/' + teamName + '/webhooks';

  var webhook = Object.assign({}, webform, {
    appID: 'triggers/on-web-form/v1'
  });

  return {
    type: CREATE_WEBFORM,
    payload: {
      url: url,
      schema: _schemas.WEBHOOK,
      options: {
        method: 'POST',
        body: webhook
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_WEBFORM'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_WEBFORM = _api$buildTypes6[0],
    UPDATE_WEBFORM_REQUEST = _api$buildTypes6[1],
    UPDATE_WEBFORM_SUCCESS = _api$buildTypes6[2],
    UPDATE_WEBFORM_FAILURE = _api$buildTypes6[3];
exports.UPDATE_WEBFORM = UPDATE_WEBFORM;
exports.UPDATE_WEBFORM_REQUEST = UPDATE_WEBFORM_REQUEST;
exports.UPDATE_WEBFORM_SUCCESS = UPDATE_WEBFORM_SUCCESS;
exports.UPDATE_WEBFORM_FAILURE = UPDATE_WEBFORM_FAILURE;
function updateWebform(_ref3) {
  var webform = _ref3.webform,
      teamName = _ref3.teamName;

  var webhook = Object.assign({}, webform, {
    appID: 'triggers/on-web-form/v1'
  });

  return {
    type: UPDATE_WEBFORM,
    payload: {
      url: 'teams/' + teamName + '/webhooks/' + webhook.webhookID,
      schema: _schemas.WEBHOOK,
      options: {
        method: 'PUT',
        body: webhook
      }
    }
  };
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1305),
    flatRest = __webpack_require__(229);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_PHONE_FAILURE = exports.DELETE_PHONE_SUCCESS = exports.DELETE_PHONE_REQUEST = exports.DELETE_PHONE = exports.VERIFY_PHONE_FAILURE = exports.VERIFY_PHONE_SUCCESS = exports.VERIFY_PHONE_REQUEST = exports.VERIFY_PHONE = exports.POST_PHONE_FAILURE = exports.POST_PHONE_SUCCESS = exports.POST_PHONE_REQUEST = exports.POST_PHONE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.postPhone = postPhone;
exports.verifyPhone = verifyPhone;
exports.deletePhone = deletePhone;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line import/named

var _api$buildTypes = _api2.default.buildTypes('POST_PHONE'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var POST_PHONE = _api$buildTypes2[0],
    POST_PHONE_REQUEST = _api$buildTypes2[1],
    POST_PHONE_SUCCESS = _api$buildTypes2[2],
    POST_PHONE_FAILURE = _api$buildTypes2[3];
exports.POST_PHONE = POST_PHONE;
exports.POST_PHONE_REQUEST = POST_PHONE_REQUEST;
exports.POST_PHONE_SUCCESS = POST_PHONE_SUCCESS;
exports.POST_PHONE_FAILURE = POST_PHONE_FAILURE;
function postPhone(_ref) {
  var teamName = _ref.teamName,
      username = _ref.username,
      phone = _ref.phone;

  return {
    type: POST_PHONE,
    payload: {
      url: 'teams/' + teamName + '/users/' + username + '/phones/' + phone + '/verification',
      schema: _schemas.PHONE,
      options: {
        method: 'POST'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('VERIFY_PHONE'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var VERIFY_PHONE = _api$buildTypes4[0],
    VERIFY_PHONE_REQUEST = _api$buildTypes4[1],
    VERIFY_PHONE_SUCCESS = _api$buildTypes4[2],
    VERIFY_PHONE_FAILURE = _api$buildTypes4[3];
exports.VERIFY_PHONE = VERIFY_PHONE;
exports.VERIFY_PHONE_REQUEST = VERIFY_PHONE_REQUEST;
exports.VERIFY_PHONE_SUCCESS = VERIFY_PHONE_SUCCESS;
exports.VERIFY_PHONE_FAILURE = VERIFY_PHONE_FAILURE;
function verifyPhone(_ref2) {
  var teamName = _ref2.teamName,
      username = _ref2.username,
      phone = _ref2.phone,
      code = _ref2.code;

  return {
    type: VERIFY_PHONE,
    payload: {
      url: 'teams/' + teamName + '/users/' + username + '/phones/' + phone + '/verification/' + code,
      schema: _schemas.PHONE,
      options: {
        method: 'PUT'
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('DELETE_PHONE'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var DELETE_PHONE = _api$buildTypes6[0],
    DELETE_PHONE_REQUEST = _api$buildTypes6[1],
    DELETE_PHONE_SUCCESS = _api$buildTypes6[2],
    DELETE_PHONE_FAILURE = _api$buildTypes6[3];
exports.DELETE_PHONE = DELETE_PHONE;
exports.DELETE_PHONE_REQUEST = DELETE_PHONE_REQUEST;
exports.DELETE_PHONE_SUCCESS = DELETE_PHONE_SUCCESS;
exports.DELETE_PHONE_FAILURE = DELETE_PHONE_FAILURE;
function deletePhone(_ref3) {
  var teamName = _ref3.teamName,
      username = _ref3.username,
      phone = _ref3.phone;

  return {
    type: DELETE_PHONE,
    payload: {
      url: 'teams/' + teamName + '/users/' + username + '/phones/' + phone,
      schema: _schemas.PHONE,
      options: {
        method: 'DELETE'
      }
    }
  };
}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(240);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(451);
var validate = __webpack_require__(128);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(208)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 416 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceClearMeasures = exports.performanceClearMarks = exports.performanceMeasure = exports.performanceMark = exports.isMonitoringEnabled = exports.canUsePerformanceObserver = exports.canUsePerformanceMeasure = exports.canUsePerformanceMark = undefined;

var _once = __webpack_require__(523);

var _once2 = _interopRequireDefault(_once);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

var _feature = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warnOncePerformanceMark = (0, _once2.default)(console.warn);
var warnOncePerformanceMeasure = (0, _once2.default)(console.warn);
var warnOncePerformanceClearMarks = (0, _once2.default)(console.warn);
var warnOncePerformanceClearMeasures = (0, _once2.default)(console.warn);

var canUsePerformanceMark = exports.canUsePerformanceMark = function canUsePerformanceMark() {
  return typeof _context2.default.performance !== 'undefined' && typeof _context2.default.performance.mark === 'function' && typeof _context2.default.performance.clearMarks === 'function';
};

var canUsePerformanceMeasure = exports.canUsePerformanceMeasure = function canUsePerformanceMeasure() {
  return typeof _context2.default.performance !== 'undefined' && typeof _context2.default.performance.measure === 'function' && typeof _context2.default.performance.clearMeasures === 'function';
};

var canUsePerformanceObserver = exports.canUsePerformanceObserver = function canUsePerformanceObserver() {
  return typeof _context2.default.PerformanceObserver !== 'undefined';
};

var isMonitoringEnabled = exports.isMonitoringEnabled = function isMonitoringEnabled(store) {
  return canUsePerformanceObserver() && (0, _feature.frontEndPerformanceMonitoringEnabled)(store.getState());
};

var performanceMark = exports.performanceMark = function performanceMark(name) {
  if (canUsePerformanceMark()) {
    try {
      _context2.default.performance.mark(name);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceMark('Unable to monitor performance: The performance.mark method from the User Timing API is not available in this context.');
  }
};

var performanceMeasure = exports.performanceMeasure = function performanceMeasure(name, startMarkName, endMarkName) {
  if (canUsePerformanceMeasure()) {
    try {
      _context2.default.performance.measure(name, startMarkName, endMarkName);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceMeasure('Unable to monitor performance: The performance.measure method from the User Timing API is not available in this context.');
  }
};

var performanceClearMarks = exports.performanceClearMarks = function performanceClearMarks(name) {
  if (canUsePerformanceMark()) {
    try {
      _context2.default.performance.clearMarks(name);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceClearMarks('Unable to monitor performance: The performance.clearMarks method from the User Timing API is not available in this context.');
  }
};

var performanceClearMeasures = exports.performanceClearMeasures = function performanceClearMeasures(name) {
  if (canUsePerformanceMeasure()) {
    try {
      _context2.default.performance.clearMeasures(name);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceClearMeasures('Unable to monitor performance: The performance.clearMeasures method from the User Timing API is not available in this context.');
  }
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(226);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(254);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(261),
    arrayIncludes = __webpack_require__(419),
    arrayIncludesWith = __webpack_require__(420),
    cacheHas = __webpack_require__(262),
    createSet = __webpack_require__(1312),
    setToArray = __webpack_require__(1313);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
var TASK_REASSIGN_INITIALIZE = exports.TASK_REASSIGN_INITIALIZE = 'PAGE_TASK_REASSIGN_INITIALIZE';

function initialize() {
  return {
    type: TASK_REASSIGN_INITIALIZE
  };
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1652),
    listCacheDelete = __webpack_require__(1653),
    listCacheGet = __webpack_require__(1654),
    listCacheHas = __webpack_require__(1655),
    listCacheSet = __webpack_require__(1656);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 426 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1827),
    baseMatchesProperty = __webpack_require__(1830),
    identity = __webpack_require__(430),
    isArray = __webpack_require__(70),
    property = __webpack_require__(1835);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 431 */,
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(24) && !__webpack_require__(14)(function () {
  return Object.defineProperty(__webpack_require__(267)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(19);


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(43);
var toIObject = __webpack_require__(52);
var arrayIndexOf = __webpack_require__(202)(false);
var IE_PROTO = __webpack_require__(269)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var anObject = __webpack_require__(10);
var getKeys = __webpack_require__(98);

module.exports = __webpack_require__(24) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(52);
var gOPN = __webpack_require__(101).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(98);
var gOPS = __webpack_require__(203);
var pIE = __webpack_require__(158);
var toObject = __webpack_require__(32);
var IObject = __webpack_require__(157);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(14)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(46);
var isObject = __webpack_require__(17);
var invoke = __webpack_require__(439);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 439 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(13).parseInt;
var $trim = __webpack_require__(124).trim;
var ws = __webpack_require__(274);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(13).parseFloat;
var $trim = __webpack_require__(124).trim;

module.exports = 1 / $parseFloat(__webpack_require__(274) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(58);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(17);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(10);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(46);
var toObject = __webpack_require__(32);
var IObject = __webpack_require__(157);
var toLength = __webpack_require__(28);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(99);
var toLength = __webpack_require__(28);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(24) && /./g.flags != 'g') __webpack_require__(25).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(206)
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(46);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(25).f;
var create = __webpack_require__(100);
var redefineAll = __webpack_require__(104);
var ctx = __webpack_require__(72);
var anInstance = __webpack_require__(103);
var forOf = __webpack_require__(127);
var $iterDefine = __webpack_require__(280);
var step = __webpack_require__(448);
var setSpecies = __webpack_require__(102);
var DESCRIPTORS = __webpack_require__(24);
var fastKey = __webpack_require__(81).fastKey;
var validate = __webpack_require__(128);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(451);
var validate = __webpack_require__(128);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(208)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(66)(0);
var redefine = __webpack_require__(45);
var meta = __webpack_require__(81);
var assign = __webpack_require__(437);
var weak = __webpack_require__(454);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(14);
var validate = __webpack_require__(128);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(208)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(104);
var getWeak = __webpack_require__(81).getWeak;
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);
var anInstance = __webpack_require__(103);
var forOf = __webpack_require__(127);
var createArrayMethod = __webpack_require__(66);
var $has = __webpack_require__(43);
var validate = __webpack_require__(128);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(28);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(101);
var gOPS = __webpack_require__(203);
var anObject = __webpack_require__(10);
var Reflect = __webpack_require__(13).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(28);
var repeat = __webpack_require__(276);
var defined = __webpack_require__(64);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(98);
var toIObject = __webpack_require__(52);
var isEnum = __webpack_require__(158).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(159);
var from = __webpack_require__(460);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(127);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(1039);
var BeforeInputEventPlugin = __webpack_require__(1040);
var ChangeEventPlugin = __webpack_require__(1044);
var DefaultEventPluginOrder = __webpack_require__(1047);
var EnterLeaveEventPlugin = __webpack_require__(1048);
var HTMLDOMPropertyConfig = __webpack_require__(1049);
var ReactComponentBrowserEnvironment = __webpack_require__(1050);
var ReactDOMComponent = __webpack_require__(1056);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMEmptyComponent = __webpack_require__(1092);
var ReactDOMTreeTraversal = __webpack_require__(1093);
var ReactDOMTextComponent = __webpack_require__(1094);
var ReactDefaultBatchingStrategy = __webpack_require__(488);
var ReactEventListener = __webpack_require__(1095);
var ReactInjection = __webpack_require__(1097);
var ReactReconcileTransaction = __webpack_require__(1098);
var SVGDOMPropertyConfig = __webpack_require__(1104);
var SelectEventPlugin = __webpack_require__(1105);
var SimpleEventPlugin = __webpack_require__(1106);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(40);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(105);

var invariant = __webpack_require__(9);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(21);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(40);
var escapeTextContentForBrowser = __webpack_require__(214);
var setInnerHTML = __webpack_require__(213);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(129);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(55);

var quoteAttributeValueForBrowser = __webpack_require__(1065);
var warning = __webpack_require__(16);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(163),
    _assign = __webpack_require__(18);

var ReactNoopUpdateQueue = __webpack_require__(477);

var canDefineProperty = __webpack_require__(478);
var emptyObject = __webpack_require__(164);
var invariant = __webpack_require__(9);
var lowPriorityWarning = __webpack_require__(1072);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(16);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(163);

var ReactCurrentOwner = __webpack_require__(77);
var REACT_ELEMENT_TYPE = __webpack_require__(479);

var getIteratorFn = __webpack_require__(1075);
var invariant = __webpack_require__(9);
var KeyEscapeUtils = __webpack_require__(481);
var warning = __webpack_require__(16);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var LinkedValueUtils = __webpack_require__(303);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(60);

var warning = __webpack_require__(16);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var React = __webpack_require__(82);

var invariant = __webpack_require__(9);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(77);
var REACT_ELEMENT_TYPE = __webpack_require__(1088);

var getIteratorFn = __webpack_require__(1089);
var invariant = __webpack_require__(9);
var KeyEscapeUtils = __webpack_require__(308);
var warning = __webpack_require__(16);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var PooledClass = __webpack_require__(105);
var Transaction = __webpack_require__(211);
var ReactInstrumentation = __webpack_require__(55);
var ReactServerUpdateQueue = __webpack_require__(1091);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var ReactUpdates = __webpack_require__(60);
var Transaction = __webpack_require__(211);

var emptyFunction = __webpack_require__(48);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(48);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(1099);

var containsNode = __webpack_require__(1101);
var focusNode = __webpack_require__(472);
var getActiveElement = __webpack_require__(491);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var DOMLazyTree = __webpack_require__(130);
var DOMProperty = __webpack_require__(129);
var React = __webpack_require__(82);
var ReactBrowserEventEmitter = __webpack_require__(215);
var ReactCurrentOwner = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMContainerInfo = __webpack_require__(493);
var ReactDOMFeatureFlags = __webpack_require__(1116);
var ReactFeatureFlags = __webpack_require__(467);
var ReactInstanceMap = __webpack_require__(165);
var ReactInstrumentation = __webpack_require__(55);
var ReactMarkupChecksum = __webpack_require__(494);
var ReactReconciler = __webpack_require__(106);
var ReactUpdateQueue = __webpack_require__(310);
var ReactUpdates = __webpack_require__(60);

var emptyObject = __webpack_require__(164);
var instantiateReactComponent = __webpack_require__(306);
var invariant = __webpack_require__(9);
var setInnerHTML = __webpack_require__(213);
var shouldUpdateReactComponent = __webpack_require__(307);
var warning = __webpack_require__(16);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(311);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(1117);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(483);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1123);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1124);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fetch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

exports.default = fetch;

var _isomorphicFetch = __webpack_require__(503);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _path = __webpack_require__(149);

var _path2 = _interopRequireDefault(_path);

var _url = __webpack_require__(83);

var _errorLog = __webpack_require__(259);

var _errorLog2 = _interopRequireDefault(_errorLog);

var _base2 = __webpack_require__(504);

var _base3 = _interopRequireDefault(_base2);

var _detectBrowser = __webpack_require__(1152);

var _detectBrowser2 = _interopRequireDefault(_detectBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var urlBuilder = function urlBuilder(base) {
  var _parse = (0, _url.parse)(base),
      pathname = _parse.pathname,
      host = _parse.host,
      protocol = _parse.protocol,
      auth = _parse.auth;

  var baseUrl = (0, _url.format)({ host: host, protocol: protocol, auth: auth });
  return function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return '' + baseUrl + _path2.default.join(pathname || '', url || '');
  };
};

var Fetch = (_temp = _class = function (_Base) {
  _inherits(Fetch, _Base);

  function Fetch(basepath) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Fetch);

    var _this = _possibleConstructorReturn(this, (Fetch.__proto__ || Object.getPrototypeOf(Fetch)).call(this, defaults, options));

    var _options$fetch = options.fetch,
        fetch = _options$fetch === undefined ? _isomorphicFetch2.default : _options$fetch;

    _this.basepath = basepath;
    _this.buildUrl = urlBuilder(_this.basepath);
    _this.fetch = fetch;
    return _this;
  }

  _createClass(Fetch, [{
    key: 'isRequest',
    value: function isRequest(type) {
      var _constructor$STATES = _slicedToArray(this.constructor.STATES, 1),
          REQUEST = _constructor$STATES[0];

      return this.isState(type, REQUEST);
    }
  }, {
    key: 'isSuccess',
    value: function isSuccess(type) {
      var _constructor$STATES2 = _slicedToArray(this.constructor.STATES, 2),
          SUCCESS = _constructor$STATES2[1];

      return this.isState(type, SUCCESS);
    }
  }, {
    key: 'isFailure',
    value: function isFailure(type) {
      var _constructor$STATES3 = _slicedToArray(this.constructor.STATES, 3),
          FAILURE = _constructor$STATES3[2];

      return this.isState(type, FAILURE);
    }
  }, {
    key: 'base',
    value: function base() {
      var _base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.basepath;

      this.buildUrl = urlBuilder(_base);
      return this.basepath = _base;
    }
  }, {
    key: 'buildAction',
    value: function buildAction(action) {
      var next = _get(Fetch.prototype.__proto__ || Object.getPrototypeOf(Fetch.prototype), 'buildAction', this).call(this, action);
      next.payload.url = this.buildUrl((action.payload || {}).url);
      return next;
    }
  }, {
    key: 'end',
    value: function end(action, states, next, store // eslint-disable-line no-unused-vars
    ) {
      var _states = _slicedToArray(states, 2),
          SUCCESS = _states[1];

      next(_extends({}, action, { type: SUCCESS }));
    }
  }, {
    key: 'main',
    value: function main(action, states, next, store // eslint-disable-line no-unused-vars
    ) {
      var _states2 = _slicedToArray(states, 3),
          REQUEST = _states2[0],
          SUCCESS = _states2[1],
          FAILURE = _states2[2]; // eslint-disable-line no-unused-vars


      var url = this.getRequestURL(action);
      next(_extends({}, action, { type: REQUEST }));
      return this.fetchWithRetry(url, action);
    }
  }, {
    key: 'getRequestURL',
    value: function getRequestURL(action) {
      var _action$payload = action.payload,
          payload = _action$payload === undefined ? {} : _action$payload;
      var urlTemp = payload.url;


      var url = urlTemp;
      if (!_detectBrowser2.default || _detectBrowser2.default.name === 'ie') {
        var parsedURL = (0, _url.parse)(urlTemp, true);
        parsedURL.query['_'] = Math.floor(Math.random() * 9999999999999) + '';
        delete parsedURL.search;
        url = (0, _url.format)(parsedURL);
      }
      return url;
    }
  }, {
    key: 'fetchWithRetry',
    value: function fetchWithRetry(url, action) {
      var _action$payload2 = action.payload,
          payload = _action$payload2 === undefined ? {} : _action$payload2;
      var _payload$options = payload.options,
          options = _payload$options === undefined ? {} : _payload$options;


      var self = this;
      options.credentials = 'same-origin';
      var retries = 0;
      var issueFetch = function issueFetch() {
        return self.fetch(url, options);
      };
      var handleResponse = function handleResponse(response) {
        if (retries < self.maxRetries(action, response)) {
          var retryPromise = self.waitMillis(self.retryDelayMillis(action, response, ++retries)).then(function () {
            return issueFetch();
          }).then(handleResponse);

          _errorLog2.default.warning('Retrying after receiving ' + response.status + ' from ' + response.url);
          return retryPromise;
        }
        return Promise.resolve(_extends({}, action, { response: response }));
      };

      return issueFetch().then(handleResponse);
    }
  }, {
    key: 'maxRetries',
    value: function maxRetries(action, response // eslint-disable-line no-unused-vars
    ) {
      return 0;
    }
  }, {
    key: 'retryDelayMillis',
    value: function retryDelayMillis(action, response, retryNumber) {
      if (retryNumber < 2) {
        return 0;
      }
      return Math.min(Math.pow(2, retryNumber - 1) * 100, 2000);
    }
  }, {
    key: 'waitMillis',
    value: function waitMillis(millis) {
      return new Promise(function (resolve) {
        setTimeout(resolve, millis);
      });
    }
  }, {
    key: 'error',
    value: function error(action, states, next, store // eslint-disable-line no-unused-vars
    ) {
      var _states3 = _slicedToArray(states, 3),
          FAILURE = _states3[2];

      next(_extends({}, action, { type: FAILURE }));
      return Promise.resolve(action);
    }
  }]);

  return Fetch;
}(_base3.default), _class.PREFIX = '@@fetch', _class.STATES = ['REQUEST', 'SUCCESS', 'FAILURE'], _temp);
exports.Fetch = Fetch;
function fetch(prefix, basepath, defaults, options) {
  return new Fetch(basepath, defaults, _extends({}, options, { prefix: prefix }));
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(1129);
module.exports = self.fetch.bind(self);


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.buildPrefix = buildPrefix;

var _isPlainObject = __webpack_require__(167);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isNull = __webpack_require__(1134);

var _isNull2 = _interopRequireDefault(_isNull);

var _isUndefined = __webpack_require__(1135);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _merge = __webpack_require__(1136);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function buildPrefix(major, minor) {
  return major + '/' + minor;
}
var omitDeep = function omitDeep(o, test) {
  return Object.keys(o).filter(function (k) {
    return !test(o[k]);
  }).reduce(function (result, k) {
    return _extends({}, result, _defineProperty({}, k, (0, _isPlainObject2.default)(o[k]) ? omitDeep(o[k], test) : o[k]));
  }, {});
};

var Base = (_temp = _class = function () {
  function Base() {
    var _this = this;

    var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Base);

    var prefix = options.prefix || this.constructor.name;
    this.defaults = defaults;
    this.PREFIX = buildPrefix(this.constructor.PREFIX, prefix);
    this.INITIALIZE = this.PREFIX + '_' + this.constructor.INITIALIZE;
    this.enhancer = this.enhancer.bind(this);
    this.middleware = this.middleware.bind(this);
    this.initialize = function (dispatch) {
      _this.initialize = function () {};
      dispatch({ type: _this.INITIALIZE });
    };
  }

  _createClass(Base, [{
    key: 'prefix',
    value: function prefix() {
      return this.PREFIX;
    }
  }, {
    key: 'isType',
    value: function isType(type) {
      return type.startsWith(this.PREFIX + '/');
    }
  }, {
    key: 'isInit',
    value: function isInit(type) {
      return type === this.INITIALIZE;
    }
  }, {
    key: 'isState',
    value: function isState(type, state) {
      return this.isType(type) && type.endsWith('_' + state);
    }
  }, {
    key: 'configure',
    value: function configure(defaults) {
      this.defaults = omitDeep(_extends({}, defaults || this.defaults), _isNull2.default);
      return _extends({}, this.defaults);
    }
  }, {
    key: 'update',
    value: function update() {
      var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.configure((0, _merge2.default)({}, _extends({}, this.defaults), defaults));
    }
  }, {
    key: 'buildStateTypes',
    value: function buildStateTypes(type) {
      return this.constructor.STATES.map(function (state) {
        return type + '_' + state;
      });
    }
  }, {
    key: 'buildTypes',
    value: function buildTypes(type) {
      return [this.PREFIX + '/' + type].concat(_toConsumableArray(this.buildStateTypes(this.PREFIX + '/' + type)));
    }
  }, {
    key: 'buildAction',
    value: function buildAction(action) {
      var _action$payload = action.payload,
          payload = _action$payload === undefined ? {} : _action$payload;

      var nextAction = omitDeep(_extends({}, action, {
        payload: _extends({}, (0, _merge2.default)({}, { options: _extends({}, this.defaults) }, payload))
      }), _isUndefined2.default);
      if (payload.options && payload.options.headers) {
        nextAction.payload.options.headers = payload.options.headers;
      }
      return nextAction;
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'before',
    value: function before(action, states, next, store) {
      return Promise.resolve(action);
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'after',
    value: function after(action, states, next, store) {
      return Promise.resolve(action);
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'main',
    value: function main(action, states, next, store) {
      return Promise.resolve(action);
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'error',
    value: function error(action, states, next, store) {
      return Promise.resolve(action);
    }
  }, {
    key: 'getError',
    value: function getError() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var error = action.error;

      return error;
    }
  }, {
    key: 'hasError',
    value: function hasError(action) {
      return !!this.getError(action);
    }
  }, {
    key: 'read',
    value: function read() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return _extends({}, state);
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'write',
    value: function write() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    }
    // eslint-disable-next-line no-unused-vars

  }, {
    key: 'end',
    value: function end(action, states, next, store) {}
  }, {
    key: 'enhancer',
    value: function enhancer(next) {
      var _this2 = this;

      return function (reducer, initialState, enhancer) {
        if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
          enhancer = initialState;
          initialState = undefined;
        }
        var store = next(reducer, _this2.read(initialState), enhancer);
        store.subscribe(function () {
          _this2.write(store.getState());
          _this2.initialize(store.dispatch);
        });
        return store;
      };
    }
  }, {
    key: 'middleware',
    value: function middleware(store) {
      var _this3 = this;

      return function (next) {
        return function (action) {
          _this3.initialize(next);

          if (!_this3.isType(action.type)) return next(action);

          var actionState = _this3.buildAction(action);
          var states = _this3.buildStateTypes(actionState.type);

          return _this3.before(actionState, states, next, store).then(function (action) {
            return _this3.main(actionState = action, states, next, store);
          }).then(function (action) {
            return _this3.after(actionState = action, states, next, store);
          }).then(function (action) {
            _this3.end(action, states, next, store);
            return action;
          }, function (error) {
            return _this3.error(_extends({}, actionState, { error: error }), states, next, store);
          });
        };
      };
    }
  }]);

  return Base;
}(), _class.PREFIX = '@@base', _class.INITIALIZE = 'INIT', _class.STATES = [], _temp);
exports.default = Base;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(216);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(198),
    eq = __webpack_require__(314);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1145);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(84);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(190)(module)))

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(510),
    getPrototype = __webpack_require__(505),
    isPrototype = __webpack_require__(511);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(71);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(191),
    isIterateeCall = __webpack_require__(416);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(319);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 516 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookie = __webpack_require__(1159);

var _cookie2 = _interopRequireDefault(_cookie);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userSessionCookie = new _cookie2.default(_env2.default.PUSHBOT_USER_SESSION_PATH, { options: { expires: 7 } }, { prefix: 'UserSession', paths: ['feature'] });

exports.default = userSessionCookie;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					attributes.path ? '; path=' + attributes.path : '',
					attributes.domain ? '; domain=' + attributes.domain : '',
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(223));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var repeat = exports.repeat = function repeat(str, times) {
  return new Array(times + 1).join(str);
};

var pad = exports.pad = function pad(num, maxLength) {
  return repeat("0", maxLength - num.toString().length) + num;
};

var formatTime = exports.formatTime = function formatTime(time) {
  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
};

// Use performance API if it's available in order to get better precision
var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isObjectLike = __webpack_require__(107),
    isPlainObject = __webpack_require__(167);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var before = __webpack_require__(1193);

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

module.exports = once;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PERFORMANCE_MEASURE = exports.PERFORMANCE_MEASURE = 'PERFORMANCE_MEASURE';

var reportMeasureEntry = exports.reportMeasureEntry = function reportMeasureEntry() {
  var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: PERFORMANCE_MEASURE,
    payload: {
      event: PERFORMANCE_MEASURE,
      properties: entry
    }
  };
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = exports.LAUNCHDARKLY_IDENTIFY = exports.LAUNCHDARKLY_ANONYMOUS = exports.LAUNCHDARKLY_ALL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTracker;

var _feature = __webpack_require__(526);

var _ldclientJs = __webpack_require__(1194);

var _ldclientJs2 = _interopRequireDefault(_ldclientJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAUNCHDARKLY_ALL = exports.LAUNCHDARKLY_ALL = 'LAUNCHDARKLY_ALL';
var LAUNCHDARKLY_ANONYMOUS = exports.LAUNCHDARKLY_ANONYMOUS = {
  anonymous: true,
  key: Math.random().toString(36).substring(7)
};
var LAUNCHDARKLY_IDENTIFY = exports.LAUNCHDARKLY_IDENTIFY = 'LAUNCHDARKLY_IDENTIFY';

var createDispatcher = function createDispatcher(store, client) {
  var isReady = false;

  var init = function init() {
    if (isReady) return;
    store.dispatch((0, _feature.ready)());
    store.dispatch((0, _feature.initialize)(client.allFlags()));
    isReady = true;
  };

  client.on('ready', init);

  client.on('change', function (settings) {
    return store.dispatch((0, _feature.update)(settings));
  });

  return function () // eslint-disable-line no-unused-vars
  {
    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ref = action || {},
        type = _ref.type,
        _ref$payload = _ref.payload,
        payload = _ref$payload === undefined ? {} : _ref$payload;

    switch (type) {
      case LAUNCHDARKLY_IDENTIFY:
        client.identify(payload);
        store.dispatch((0, _feature.identify)(payload));
        if (isReady) store.dispatch((0, _feature.initialize)(client.allFlags()));
      default:
    }
  };
};

var createClient = exports.createClient = function createClient(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var user = _extends({}, LAUNCHDARKLY_ANONYMOUS, options);

  return _ldclientJs2.default.initialize(id, user);
};

function createTracker(middleware, client) {
  return function (store) {
    var dispatch = createDispatcher(store, client);
    return function (next) {
      return function (action) {
        middleware(dispatch, store.getState(), action);
        return next(action);
      };
    };
  };
}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FEATURE_UPDATE = exports.FEATURE_UPDATE = 'FEATURE_UPDATE';
var FEATURE_IDENTIFY = exports.FEATURE_IDENTIFY = 'FEATURE_IDENTIFY';
var FEATURE_INITIALIZE = exports.FEATURE_INITIALIZE = 'FEATURE_INITIALIZE';
var FEATURE_READY = exports.FEATURE_READY = 'FEATURE_READY';

var update = exports.update = function update() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: FEATURE_UPDATE,
    payload: features
  };
};

var identify = exports.identify = function identify(user) {
  return {
    type: FEATURE_IDENTIFY,
    payload: user
  };
};

var initialize = exports.initialize = function initialize() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: FEATURE_INITIALIZE,
    payload: features
  };
};

var ready = exports.ready = function ready() {
  return {
    type: FEATURE_READY
  };
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(216);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(71);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1221);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1222),
    hasPath = __webpack_require__(1223);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(226),
    baseSet = __webpack_require__(1229),
    castPath = __webpack_require__(136);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1230);


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var upperCase = __webpack_require__(85)
var noCase = __webpack_require__(78)

/**
 * Camel case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale, mergeNumbers) {
  var result = noCase(value, locale)

  // Replace periods between numeric entities with an underscore.
  if (!mergeNumbers) {
    result = result.replace(/ (?=\d)/g, '_')
  }

  // Replace spaces between words with an upper cased character.
  return result.replace(/ (.)/g, function (m, $1) {
    return upperCase($1, locale)
  })
}


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var noCase = __webpack_require__(78)

/**
 * Snake case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '_')
}


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACK = exports.RESET = exports.PAGE = exports.IDENTIFY = exports.GROUP = exports.ALIAS = exports.NS = undefined;
exports.default = createTracker;

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NS = exports.NS = '@@segment';
var ALIAS = exports.ALIAS = NS + '/alias';
var GROUP = exports.GROUP = NS + '/group';
var IDENTIFY = exports.IDENTIFY = NS + '/identify';
var PAGE = exports.PAGE = NS + '/page';
var RESET = exports.RESET = NS + '/reset';
var TRACK = exports.TRACK = NS + '/track';

var dispatch = function dispatch() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var analytics = opts.analytics || _context2.default.analytics;
  if (!analytics) return;

  var _ref = action || {},
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  var category = payload.category,
      name = payload.name,
      userId = payload.userId,
      groupId = payload.groupId,
      previousId = payload.previousId,
      traits = payload.traits,
      options = payload.options,
      properties = payload.properties,
      event = payload.event;


  switch (type) {
    case ALIAS:
      return analytics.alias(userId, previousId, options);
    case GROUP:
      return analytics.group(groupId, traits, options);
    case IDENTIFY:
      return analytics.identify(userId, traits, options);
    case PAGE:
      return analytics.page(category, name, properties, options);
    case RESET:
      return analytics.reset();
    case TRACK:
      return analytics.track(event, properties, options);
    default:
  }
};

function createTracker(middleware) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (store) {
    if (options.config) options.config(store);
    return function (next) {
      return function (action) {
        middleware(dispatch, store.getState(), action);
        return next(action);
      };
    };
  };
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESET = exports.IDENTIFY = exports.NS = undefined;
exports.default = createTracker;

var _rollbar = __webpack_require__(293);

var _rollbar2 = _interopRequireDefault(_rollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NS = exports.NS = '@@rollbar';
var IDENTIFY = exports.IDENTIFY = NS + '/identify';
var RESET = exports.RESET = NS + '/reset';

var dispatch = function dispatch() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var instance = opts.rollbar || (0, _rollbar2.default)();
  if (!instance) return;

  var _ref = action || {},
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  var _payload$person = payload.person,
      person = _payload$person === undefined ? {} : _payload$person;


  switch (type) {
    case IDENTIFY:
      return instance.configure({
        payload: { person: person }
      });
    case RESET:
      return instance.configure({ payload: { person: null } });
    default:
  }
};

function createTracker(middleware) // eslint-disable-line no-unused-vars
{
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (store) {
    return function (next) {
      return function (action) {
        middleware(dispatch, store.getState(), action);
        return next(action);
      };
    };
  };
}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.update = update;
exports.store = store;
exports.navigate = navigate;
var APP_UPDATE = exports.APP_UPDATE = 'APP_UPDATE';
var APP_STORE = exports.APP_STORE = 'APP_STORE';
var APP_NAVIGATE = exports.APP_NAVIGATE = 'APP_NAVIGATE';

function update(payload) {
  var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var path = arguments[2];

  return {
    type: APP_UPDATE,
    payload: payload,
    path: path,
    merge: merge
  };
}

function store(payload) {
  var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var path = arguments[2];

  return {
    type: APP_STORE,
    payload: payload,
    path: path,
    merge: merge
  };
}

function navigate() {
  return {
    type: APP_NAVIGATE
  };
}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(228);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    keys = __webpack_require__(154);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(136),
    last = __webpack_require__(263),
    parent = __webpack_require__(1275),
    toKey = __webpack_require__(109);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.merge = merge;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function merge(current, next) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

  // next is missing, return current state
  if (next === undefined) return current;

  // current is missing, return next state
  if (current === undefined) return next;

  var currentType = typeof current === 'undefined' ? 'undefined' : _typeof(current);
  var nextType = typeof next === 'undefined' ? 'undefined' : _typeof(next);

  // only same types should be merged
  var isSameType = currentType === nextType;

  // only plain objects should be merged
  var isPlainObject = nextType === 'object' && current !== null && next !== null && !Array.isArray(next);

  // do not merge if type has changed, object is not mergable, or
  // depth limit has been reached
  if (!isSameType || !isPlainObject || depth === 0) return next;

  return Array.from(new Set([].concat(_toConsumableArray(Object.keys(current)), _toConsumableArray(Object.keys(next))))).reduce(function mergeReducer(o, k) {
    return _extends({}, o, _defineProperty({}, k, merge(current[k], next[k], --depth)));
  }, {});
}

exports.default = merge;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_WEBHOOKS_FAILURE = exports.GET_WEBHOOKS_SUCCESS = exports.GET_WEBHOOKS_REQUEST = exports.GET_WEBHOOKS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getWebhooks = getWebhooks;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_WEBHOOKS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_WEBHOOKS = _api$buildTypes2[0],
    GET_WEBHOOKS_REQUEST = _api$buildTypes2[1],
    GET_WEBHOOKS_SUCCESS = _api$buildTypes2[2],
    GET_WEBHOOKS_FAILURE = _api$buildTypes2[3];
exports.GET_WEBHOOKS = GET_WEBHOOKS;
exports.GET_WEBHOOKS_REQUEST = GET_WEBHOOKS_REQUEST;
exports.GET_WEBHOOKS_SUCCESS = GET_WEBHOOKS_SUCCESS;
exports.GET_WEBHOOKS_FAILURE = GET_WEBHOOKS_FAILURE;
function getWebhooks(_ref) {
  var teamName = _ref.teamName;

  return {
    type: GET_WEBHOOKS,
    payload: {
      url: 'teams/' + teamName + '/webhooks',
      schema: _schemas.WEBHOOK_LIST
    }
  };
}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1290),
    composeArgsRight = __webpack_require__(1291),
    countHolders = __webpack_require__(1292),
    createCtor = __webpack_require__(230),
    createRecurry = __webpack_require__(549),
    getHolder = __webpack_require__(553),
    reorder = __webpack_require__(1293),
    replaceHolders = __webpack_require__(554),
    root = __webpack_require__(84);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(550),
    setData = __webpack_require__(551),
    setWrapToString = __webpack_require__(552);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 553 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(216);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_RUNS_FAILURE = exports.GET_RUNS_SUCCESS = exports.GET_RUNS_REQUEST = exports.GET_RUNS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getRunList = getRunList;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _url2 = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_RUNS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_RUNS = _api$buildTypes2[0],
    GET_RUNS_REQUEST = _api$buildTypes2[1],
    GET_RUNS_SUCCESS = _api$buildTypes2[2],
    GET_RUNS_FAILURE = _api$buildTypes2[3];
exports.GET_RUNS = GET_RUNS;
exports.GET_RUNS_REQUEST = GET_RUNS_REQUEST;
exports.GET_RUNS_SUCCESS = GET_RUNS_SUCCESS;
exports.GET_RUNS_FAILURE = GET_RUNS_FAILURE;
function getRunList(_ref) {
  var search = _ref.search,
      teamName = _ref.teamName,
      assignedToMe = _ref.assignedToMe,
      owner = _ref.owner,
      status = _ref.status,
      includeChildren = _ref.includeChildren,
      limit = _ref.limit,
      after = _ref.after,
      q = _ref.q,
      sort = _ref.sort;

  if (assignedToMe != null || includeChildren != null || search !== true) {
    // Use legacy endpoint for backwards compatibility.
    // This can be removed once we establish that the /search endpoint is stable enough for all traffic.
    var baseUrl = '/teams/' + teamName;
    var pathname = assignedToMe ? baseUrl + '/users/me/runs' : baseUrl + '/runs';
    var _url = (0, _url2.format)({ pathname: pathname, query: { status: status, includeChildren: includeChildren } });

    return {
      type: GET_RUNS,
      payload: {
        url: _url,
        schema: _schemas.RUN_LIST,
        options: {
          method: 'GET'
        }
      }
    };
  }

  var query = {
    types: 'runs'
  };
  if (status && status !== 'all') {
    query.status = status;
  }
  if (owner) {
    query.owner = owner;
  }
  if (limit) {
    query.limit = limit;
  }
  if (after) {
    query.pageToken = after;
  }
  if (q) {
    query.q = q;
  }
  if (sort) {
    query.sort = sort;
  }

  var url = (0, _url2.format)({
    pathname: '/teams/' + teamName + '/search',
    query: query
  });

  return {
    type: GET_RUNS,
    payload: {
      url: url,
      schema: _schemas.RUN_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(119),
    baseIteratee = __webpack_require__(57),
    baseMap = __webpack_require__(559),
    baseSortBy = __webpack_require__(1318),
    baseUnary = __webpack_require__(404),
    compareMultiple = __webpack_require__(1319),
    identity = __webpack_require__(318);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(409),
    isArrayLike = __webpack_require__(152);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleManager = undefined;
exports.createStyleManager = createStyleManager;

var _styleManager = __webpack_require__(561);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleManager = exports.StyleManager = function () {
  function StyleManager() {
    _classCallCheck(this, StyleManager);
  }

  return StyleManager;
}();

function createStyleManager() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var styleManager = (0, _styleManager.createStyleManager)(options);
  Object.setPrototypeOf(styleManager, new StyleManager());
  return styleManager;
}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.createStyleManager = createStyleManager;

var _jssVendorPrefixer = __webpack_require__(333);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _murmurhash3_gc = __webpack_require__(562);

var _murmurhash3_gc2 = _interopRequireDefault(_murmurhash3_gc);

var _utils = __webpack_require__(1326);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var prefixRule = (0, _jssVendorPrefixer2.default)();

/**
 * Creates a new styleManager
 */
function createStyleManager() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      jss = _ref.jss,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme;

  if (!jss) {
    throw new Error('No JSS instance provided');
  }

  var sheetMap = [];
  var sheetOrder = void 0;

  // Register custom jss generateClassName function
  jss.options.generateClassName = generateClassName;

  function generateClassName(str, rule) {
    var hash = (0, _murmurhash3_gc2.default)(str);
    str = rule.name ? rule.name + '-' + hash : hash;

    // Simplify after next release with new method signature
    if (rule.options.sheet && rule.options.sheet.options.name) {
      return rule.options.sheet.options.name + '-' + str;
    }
    return str;
  }

  /**
   * styleManager
   */
  var styleManager = {
    get sheetMap() {
      return sheetMap;
    },
    get sheetOrder() {
      return sheetOrder;
    },
    setSheetOrder: setSheetOrder,
    jss: jss,
    theme: theme,
    render: render,
    reset: reset,
    rerender: rerender,
    getClasses: getClasses,
    updateTheme: updateTheme,
    prepareInline: prepareInline,
    sheetsToString: sheetsToString
  };

  updateTheme(theme, false);

  function render(styleSheet) {
    var index = getMappingIndex(styleSheet.name);

    if (index === -1) {
      return renderNew(styleSheet);
    }

    var mapping = sheetMap[index];

    if (mapping.styleSheet !== styleSheet) {
      jss.removeStyleSheet(sheetMap[index].jssStyleSheet);
      sheetMap.splice(index, 1);

      return renderNew(styleSheet);
    }

    return mapping.classes;
  }

  /**
   * Get classes for a given styleSheet object
   */
  function getClasses(styleSheet) {
    var mapping = (0, _utils.find)(sheetMap, { styleSheet: styleSheet });
    return mapping ? mapping.classes : null;
  }

  /**
   * @private
   */
  function renderNew(styleSheet) {
    var name = styleSheet.name,
        createRules = styleSheet.createRules,
        options = styleSheet.options;

    var sheetMeta = name + '-' + styleManager.theme.id;

    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object') {
      var element = document.querySelector('style[data-jss][data-meta="' + sheetMeta + '"]');
      if (element) {
        options.element = element;
      }
    }

    var rules = createRules(styleManager.theme);
    var jssOptions = _extends({
      name: name,
      meta: sheetMeta
    }, options);

    if (sheetOrder && !jssOptions.hasOwnProperty('index')) {
      var index = sheetOrder.indexOf(name);
      if (index === -1) {
        jssOptions.index = sheetOrder.length;
      } else {
        jssOptions.index = index;
      }
    }

    var jssStyleSheet = jss.createStyleSheet(rules, jssOptions);

    var _jssStyleSheet$attach = jssStyleSheet.attach(),
        classes = _jssStyleSheet$attach.classes;

    sheetMap.push({ name: name, classes: classes, styleSheet: styleSheet, jssStyleSheet: jssStyleSheet });

    return classes;
  }

  /**
   * @private
   */
  function getMappingIndex(name) {
    var index = (0, _utils.findIndex)(sheetMap, function (obj) {
      if (!obj.hasOwnProperty('name') || obj.name !== name) {
        return false;
      }

      return true;
    });

    return index;
  }

  /**
   * Set DOM rendering order by sheet names.
   */
  function setSheetOrder(sheetNames) {
    sheetOrder = sheetNames;
  }

  /**
   * Replace the current theme with a new theme
   */
  function updateTheme(newTheme) {
    var shouldUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    styleManager.theme = newTheme;
    if (!styleManager.theme.id) {
      styleManager.theme.id = (0, _murmurhash3_gc2.default)(JSON.stringify(styleManager.theme));
    }
    if (shouldUpdate) {
      rerender();
    }
  }

  /**
   * Reset JSS registry, remove sheets and empty the styleManager.
   */
  function reset() {
    sheetMap.forEach(function (_ref2) {
      var jssStyleSheet = _ref2.jssStyleSheet;
      jssStyleSheet.detach();
    });
    sheetMap = [];
  }

  /**
   * Reset and update all existing stylesheets
   *
   * @memberOf module:styleManager~styleManager
   */
  function rerender() {
    var sheets = [].concat(_toConsumableArray(sheetMap));
    reset();
    sheets.forEach(function (n) {
      render(n.styleSheet);
    });
  }

  /**
   * Prepare inline styles using Theme Reactor
   */
  function prepareInline(declaration) {
    if (typeof declaration === 'function') {
      declaration = declaration(theme);
    }

    var rule = {
      type: 'regular',
      style: declaration
    };

    prefixRule(rule);

    return rule.style;
  }

  /**
   * Render sheets to an HTML string
   */
  function sheetsToString() {
    return sheetMap.sort(function (a, b) {
      if (a.jssStyleSheet.options.index < b.jssStyleSheet.options.index) {
        return -1;
      }
      if (a.jssStyleSheet.options.index > b.jssStyleSheet.options.index) {
        return 1;
      }
      return 0;
    }).map(function (sheet) {
      return sheet.jssStyleSheet.toString();
    }).join('\n');
  }

  return styleManager;
}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
 * 
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 * 
 * @param {string} key ASCII only
 * @param {number} seed Positive integer only
 * @return {number} 32-bit positive integer hash 
 */

function murmurhash3_32_gc(key, seed) {
	var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;
	
	remainder = key.length & 3; // key.length % 4
	bytes = key.length - remainder;
	h1 = seed;
	c1 = 0xcc9e2d51;
	c2 = 0x1b873593;
	i = 0;
	
	while (i < bytes) {
	  	k1 = 
	  	  ((key.charCodeAt(i) & 0xff)) |
	  	  ((key.charCodeAt(++i) & 0xff) << 8) |
	  	  ((key.charCodeAt(++i) & 0xff) << 16) |
	  	  ((key.charCodeAt(++i) & 0xff) << 24);
		++i;
		
		k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
		k1 = (k1 << 15) | (k1 >>> 17);
		k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

		h1 ^= k1;
        h1 = (h1 << 13) | (h1 >>> 19);
		h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
		h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
	}
	
	k1 = 0;
	
	switch (remainder) {
		case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
		case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
		case 1: k1 ^= (key.charCodeAt(i) & 0xff);
		
		k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
		k1 = (k1 << 15) | (k1 >>> 17);
		k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
		h1 ^= k1;
	}
	
	h1 ^= key.length;

	h1 ^= h1 >>> 16;
	h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
	h1 ^= h1 >>> 13;
	h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
	h1 ^= h1 >>> 16;

	return h1 >>> 0;
}

if(true) {
  module.exports = murmurhash3_32_gc
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContrastText = exports.isDark = exports.shades = exports.dark = exports.light = undefined;
exports['default'] = createPalette;

var _colors = __webpack_require__(564);

var _colorManipulator = __webpack_require__(264);

var light = exports.light = {
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.26)'
  },
  background: {
    appBar: _colors.grey[100],
    contentFrame: _colors.grey[200],
    'default': _colors.navy[50],
    detailPane: _colors.grey[25],
    forms: 'rgba(200, 200, 200, 0.1)',
    highlight: _colors.marine[50],
    paper: _colors.white,
    searchInput: _colors.grey[25],
    status: _colors.grey[300]
  },
  drawer: {
    background: {
      primary: _colors.grey[25],
      active: _colors.grey[100]
    },
    icon: {
      primary: _colors.marine[500],
      active: _colors.marine[500]
    },
    text: {
      primary: _colors.navy[500],
      active: _colors.navy[500]
    }
  },
  forms: {
    primary: _colors.lightGrey,
    active: _colors.lighterGrey
  },
  text: {
    disabled: _colors.navy[100],
    divider: _colors.grey[200],
    error: _colors.red[500],
    highlight: _colors.marine[500],
    lighterDivider: _colors.grey[50],
    lightDivider: _colors.grey[100],
    primary: _colors.navy[500],
    secondary: _colors.navy[300],
    success: _colors.green[500]
  }
};

var dark = exports.dark = {
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.26)'
  },
  background: {
    appBar: _colors.grey[100],
    contentFrame: _colors.grey[200],
    detailPane: _colors.grey[25],
    forms: 'rgba(200, 200, 200, 0.1)',
    'default': _colors.navy[50],
    highlight: _colors.marine[50],
    paper: _colors.white,
    searchInput: _colors.grey[25],
    status: _colors.grey[300]
  },
  drawer: {
    background: {
      primary: _colors.navy[500],
      active: _colors.marine[500]
    },
    icon: {
      primary: _colors.grey[200],
      active: _colors.white
    },
    text: {
      primary: _colors.grey[200],
      active: _colors.white
    }
  },
  forms: {
    primary: _colors.lightGrey,
    active: _colors.lighterGrey
  },
  text: {
    disabled: _colors.navy[100],
    divider: _colors.grey[200],
    error: _colors.red[500],
    highlight: _colors.marine[500],
    lighterDivider: _colors.grey[50],
    lightDivider: _colors.grey[100],
    primary: _colors.navy[500],
    secondary: _colors.navy[300],
    success: _colors.green[500]
  }
};

var shades = exports.shades = { light: light, dark: dark };

var isDark = exports.isDark = function isDark(color) {
  return (0, _colorManipulator.getContrastRatio)(color, _colors.black) < 7;
};

var getContrastText = exports.getContrastText = function getContrastText(color) {
  return isDark(color) ? _colors.navy[50] : _colors.navy[500];
};

function createPalette() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$accent = _ref.accent,
      accent = _ref$accent === undefined ? _colors.marine : _ref$accent,
      _ref$error = _ref.error,
      error = _ref$error === undefined ? _colors.red : _ref$error,
      _ref$primary = _ref.primary,
      primary = _ref$primary === undefined ? _colors.navy : _ref$primary,
      _ref$success = _ref.success,
      success = _ref$success === undefined ? _colors.green : _ref$success,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'dark' : _ref$type;

  return {
    accent: accent,
    action: shades[type].action,
    background: shades[type].background,
    drawer: shades[type].drawer,
    error: error,
    forms: shades[type].forms,
    getContrastText: getContrastText,
    grey: _colors.grey,
    isDark: isDark,
    primary: primary,
    shades: shades,
    success: success,
    text: shades[type].text,
    type: type
  };
}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blue = exports.orange = exports.green = exports.yellow = exports.red = exports.lighterGrey = exports.lightGrey = exports.grey = exports.marine = exports.navy = exports.white = exports.lightBlack = exports.black = undefined;

var _color = __webpack_require__(1330);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var swatch = function swatch(value) // eslint-disable-line no-unused-vars
{
  var contrast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dark';

  var c = (0, _color2['default'])(value);
  var w = (0, _color2['default'])('white');
  var b = (0, _color2['default'])('black');
  return {
    25: c.mix(w, 0.05).hex(),
    50: c.mix(w, 0.1).hex(),
    100: c.mix(w, 0.2).hex(),
    200: c.mix(w, 0.4).hex(),
    300: c.mix(w, 0.6).hex(),
    400: c.mix(w, 0.8).hex(),
    500: c.hex(),
    600: c.mix(b, 0.8).hex(),
    700: c.mix(b, 0.6).hex(),
    800: c.mix(b, 0.4).hex(),
    900: c.mix(b, 0.2).hex(),
    A100: c.mix(w, 0.2).hex(),
    A200: c.mix(w, 0.4).hex(),
    A400: c.mix(w, 0.8).hex(),
    A700: c.mix(b, 0.6).hex(),
    contrastDefaultColor: 'dark'
  };
};

var black = exports.black = '#000000';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var white = exports.white = '#ffffff';
var navy = exports.navy = swatch('#3e4158', 'light');
var marine = exports.marine = swatch('#44b6b7');
var grey = exports.grey = swatch('#808080');
var lightGrey = exports.lightGrey = '#d4d9e2';
var lighterGrey = exports.lighterGrey = '#8C96A9';
var red = exports.red = swatch('#db5656', 'light');
var yellow = exports.yellow = swatch('#ffc51e');
var green = exports.green = swatch('#65b568', 'light');
var orange = exports.orange = swatch('#f16c37', 'light');
var blue = exports.blue = swatch('#617fe2', 'light');

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(1336);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTemplates = (_temp = _class = function (_SvgIcon) {
  _inherits(NavTemplates, _SvgIcon);

  function NavTemplates() {
    _classCallCheck(this, NavTemplates);

    return _possibleConstructorReturn(this, (NavTemplates.__proto__ || Object.getPrototypeOf(NavTemplates)).apply(this, arguments));
  }

  _createClass(NavTemplates, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M10 5h1v22.023h-1z', opacity: '.4' }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '21',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '16',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '11',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('path', {
            fillRule: 'evenodd',
            d: 'M26 4c-.003-1.104-.897-1.997-2-2-.003-1.105-.9-2-2.005-2H2.005C.897 0 0 .898 0 2.005v19.99C0 23.1.895 23.997 2 24c.003 1.104.897 1.997 2 2 .003 1.105.9 2 2.005 2h19.99C27.103 28 28 27.102 28 25.995V6.005C28 4.9 27.105 4.003 26 4zM2 4.005V23c-.552-.004-1-.453-1-1.005V2.005C1 1.45 1.45 1 2.005 1h19.99c.552 0 1 .448 1.004 1H4.004C2.897 2 2 2.898 2 4.005zm2 2V25c-.55-.004-.996-.45-1-1V4.005C3 3.45 3.45 3 4.005 3H24c.55.004.996.45 1 1H6.004C4.897 4 4 4.898 4 6.005zM25.995 26L6 25.993l.004-20.118H26l-.002 4.732-.484.29c-.154.092-.345.1-.505.018-.273-.14-.557-.258-.853-.353-.17-.054-.302-.194-.345-.368l-.27-1.076c-.057-.232-.264-.394-.503-.394h-1.267c-.24 0-.446.162-.504.394L21 10.194c-.043.174-.174.314-.345.368-.296.095-.58.213-.853.353-.16.082-.35.075-.505-.017l-.95-.57c-.205-.122-.466-.09-.635.078l-.895.896c-.168.168-.2.43-.078.634l.57.95c.09.154.098.345.017.504-.14.273-.258.558-.353.854-.055.17-.195.3-.37.345l-1.075.268c-.233.058-.394.265-.394.503v1.268c0 .238.16.446.392.504l1.077.27c.174.043.314.173.37.344.094.296.21.58.35.853.083.158.076.35-.016.503l-.57.95c-.124.205-.09.467.077.635l.895.896c.17.17.43.2.635.078l.95-.57c.154-.092.346-.1.505-.017.272.14.557.257.852.352.172.055.302.195.346.37l.27 1.075c.056.232.264.394.502.394h1.268c.238 0 .446-.162.503-.394l.27-1.076c.043-.174.174-.314.345-.37.295-.094.58-.212.852-.35.16-.083.35-.076.505.016l.48.29v1.987c0-.02.005-.04.005-.06L25.995 26zm-1.122-10.135c0 1.435-1.162 2.597-2.597 2.597-1.434 0-2.596-1.162-2.596-2.597 0-1.434 1.162-2.597 2.596-2.597 1.435 0 2.597 1.163 2.597 2.597z',
            clipRule: 'evenodd'
          })
        );
      }

      return render;
    }()
  }]);

  return NavTemplates;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 28 28'
}, _temp);
exports['default'] = NavTemplates;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavData = (_temp = _class = function (_SvgIcon) {
  _inherits(NavData, _SvgIcon);

  function NavData() {
    _classCallCheck(this, NavData);

    return _possibleConstructorReturn(this, (NavData.__proto__ || Object.getPrototypeOf(NavData)).apply(this, arguments));
  }

  _createClass(NavData, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M32.22.18C17.35.18 2.3 4.59 2.3 13v37.57C2.3 59 17.35 63.4 32.22 63.4S62.14 59 62.14 50.57V13C62.14 4.59 47.09.18 32.22.18zM57.8 43.7v6.87c0 4-10.94 8.5-25.58 8.5s-25.59-4.48-25.59-8.5V43.7l.43.3.36.26a3.13 3.13 0 0 0 .3.2c.34.23.71.44 1.09.66h.08c.48.26 1 .5 1.51.74l.48.21q.67.3 1.41.57l.38.14c.61.22 1.24.43 1.89.62l.45.13c.53.16 1.07.3 1.62.44l.57.14c.7.16 1.41.32 2.13.46.72.13 1.45.26 2.19.37l.62.09c.61.09 1.23.17 1.85.24l.49.06c.76.08 1.53.16 2.31.21h.52l1.88.1h6l1.88-.1h.52c.77-.05 1.54-.13 2.31-.21l.49-.06c.62-.07 1.23-.15 1.84-.24l.62-.09c.75-.11 1.48-.24 2.2-.37.73-.14 1.44-.3 2.14-.46l.61-.11c.56-.14 1.1-.28 1.63-.44l.45-.13c.65-.19 1.28-.4 1.89-.62l.38-.14q.72-.27 1.41-.57l.44-.2c.52-.24 1-.48 1.51-.74h.08c.38-.22.74-.43 1.09-.66l.29-.2c.13-.08.25-.17.37-.26zm0-25v6.87a3.4 3.4 0 0 1-1.08 2.25C53.62 31.05 44.15 34 32.22 34s-21.41-3-24.5-6.25a3.37 3.37 0 0 1-1.09-2.25v-6.84l.43.3.36.26a3.13 3.13 0 0 0 .3.2c.34.23.71.44 1.09.65l.08.05c.48.26 1 .5 1.51.74l.48.21q.67.3 1.41.57l.38.14c.61.22 1.24.43 1.89.62l.45.13 1.62.44.57.14c.7.16 1.41.32 2.13.46s1.45.27 2.19.38l.62.09c.61.09 1.23.17 1.85.24l.49.06q1.14.12 2.31.21h.52l1.88.1h6l1.88-.1h.52q1.16-.09 2.31-.21l.49-.06c.62-.07 1.23-.15 1.84-.24l.62-.09c.75-.11 1.48-.24 2.2-.38.73-.14 1.44-.3 2.14-.46l.61-.11c.56-.14 1.1-.29 1.63-.44l.45-.13c.65-.19 1.28-.4 1.89-.62l.38-.14q.72-.27 1.41-.57l.48-.21c.52-.24 1-.48 1.51-.74l.08-.05c.38-.21.74-.42 1.09-.65l.29-.2c.13-.08.25-.17.37-.26zm0 12.52v6.87a3.38 3.38 0 0 1-1.08 2.25c-3.1 3.27-12.57 6.25-24.5 6.25s-21.41-3-24.5-6.25a3.35 3.35 0 0 1-1.09-2.25v-6.91l.43.3.36.26a3.13 3.13 0 0 0 .3.2c.34.23.71.44 1.09.65h.08c.48.26 1 .5 1.51.74l.48.21q.67.3 1.41.57l.38.14c.61.22 1.24.43 1.89.62l.45.13 1.62.44.57.14c.7.16 1.41.32 2.13.46s1.45.27 2.19.38l.62.09c.61.09 1.23.17 1.85.24l.49.06q1.14.12 2.31.21h.52l1.88.1h.65c.78 0 1.57.05 2.35.05s1.56 0 2.34-.05h.66l1.88-.1h.52l2.31-.21.49-.06c.62-.07 1.23-.15 1.84-.24l.62-.09c.75-.11 1.48-.24 2.2-.38.73-.14 1.44-.3 2.14-.46l.56-.14c.56-.14 1.1-.29 1.63-.44l.45-.13c.65-.19 1.28-.4 1.89-.62l.38-.14q.72-.27 1.41-.57l.48-.21c.52-.24 1-.48 1.51-.74h.08c.38-.21.74-.42 1.09-.65l.29-.2c.13-.08.25-.17.37-.26z' })
        );
      }

      return render;
    }()
  }]);

  return NavData;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = NavData;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWelcome = setWelcome;
exports.resetNewlyAuthenticated = resetNewlyAuthenticated;
var SET_WELCOME = exports.SET_WELCOME = 'SET_WELCOME';
var RESET_NEWLY_AUTHENTICATED = exports.RESET_NEWLY_AUTHENTICATED = 'RESET_NEWLY_AUTHENTICATED';

function setWelcome(isWelcome) {
  return {
    type: SET_WELCOME,
    isWelcome: isWelcome
  };
}
// eslint-disable-next-line no-unused-vars
function resetNewlyAuthenticated(newlyAuthenticated) {
  return {
    type: RESET_NEWLY_AUTHENTICATED
  };
}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = subdomain;

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function subdomain() {
  var _context$location$hos = _context2.default.location.hostname.split('.'),
      _context$location$hos2 = _slicedToArray(_context$location$hos, 1),
      sub = _context$location$hos2[0];

  return sub.toLowerCase();
}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(231);

var _BrowserProtocol = __webpack_require__(337);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1480);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(171);

var _createHistory = __webpack_require__(338);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(231);

var _DOMUtils = __webpack_require__(171);

var _HashProtocol = __webpack_require__(1482);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(338);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(110);

var _PathUtils = __webpack_require__(86);

var _createHistory = __webpack_require__(338);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(1491);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["c" /* runLeaveHooks */])(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* runChangeHooks */])(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["b" /* runEnterHooks */])(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PropTypes__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextUtils__ = __webpack_require__(344);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes,
    bool = _React$PropTypes.bool,
    object = _React$PropTypes.object,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'Link',


  mixins: [Object(__WEBPACK_IMPORTED_MODULE_3__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_2__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: oneOfType([string, object, func]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PatternUtils__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(172);






var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */

var Redirect = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'Redirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_2__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_3__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_3__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: string,
    from: string, // Alias for path
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(582);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* harmony default export */ __webpack_exports__["a"] = (function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

exports["default"] = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  getState: _react.PropTypes.func.isRequired
});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1514)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1521);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.sheets = exports.RulesContainer = exports.SheetsRegistry = exports.getDynamicStyles = undefined;

var _Jss = __webpack_require__(1533);

var _Jss2 = _interopRequireDefault(_Jss);

var _SheetsRegistry = __webpack_require__(590);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

var _RulesContainer = __webpack_require__(347);

var _RulesContainer2 = _interopRequireDefault(_RulesContainer);

var _sheets = __webpack_require__(346);

var _sheets2 = _interopRequireDefault(_sheets);

var _getDynamicStyles = __webpack_require__(1548);

var _getDynamicStyles2 = _interopRequireDefault(_getDynamicStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Extracts a styles object with only rules that contain function values.
 */
exports.getDynamicStyles = _getDynamicStyles2['default'];

/**
 * SheetsRegistry for SSR.
 */

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Slobodskoi 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

exports.SheetsRegistry = _SheetsRegistry2['default'];

/**
 * RulesContainer for plugins.
 */

exports.RulesContainer = _RulesContainer2['default'];

/**
 * Default global SheetsRegistry instance.
 */

exports.sheets = _sheets2['default'];

/**
 * Creates a new instance of Jss.
 */

var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = findRenderer;

var _isInBrowser = __webpack_require__(1535);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _DomRenderer = __webpack_require__(1536);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(1537);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Find proper renderer.
 * Option `virtual` is used to force use of VirtualRenderer even if DOM is
 * detected, used for testing only.
 */
function findRenderer() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (options.Renderer) return options.Renderer;
  var useVirtual = options.virtual || !_isInBrowser2['default'];
  return useVirtual ? _VirtualRenderer2['default'] : _DomRenderer2['default'];
}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (!registry.length || index >= registry[registry.length - 1].options.index) {
        registry.push(sheet);
        return;
      }

      for (var i = 0; i < registry.length; i++) {
        var options = registry[i].options;

        if (options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var joinWithSpace = function joinWithSpace(value) {
  return value.join(' ');
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 */
function toCssValue(value) {
  if (!Array.isArray(value)) return value;

  // Support space separated values.
  if (Array.isArray(value[0])) {
    return toCssValue(value.map(joinWithSpace));
  }

  return value.join(', ');
}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish(United State) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(50)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY H:mm',
        LLLL : 'dddd, MMMM [de] D [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(232);
var $export = __webpack_require__(61);
var redefine = __webpack_require__(605);
var hide = __webpack_require__(111);
var has = __webpack_require__(113);
var Iterators = __webpack_require__(141);
var $iterCreate = __webpack_require__(1575);
var setToStringTag = __webpack_require__(235);
var getPrototypeOf = __webpack_require__(609);
var ITERATOR = __webpack_require__(41)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(88) && !__webpack_require__(140)(function () {
  return Object.defineProperty(__webpack_require__(352)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(111);


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(113);
var toIObject = __webpack_require__(114);
var arrayIndexOf = __webpack_require__(1577)(false);
var IE_PROTO = __webpack_require__(356)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(176);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(49).document;
module.exports = document && document.documentElement;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(113);
var toObject = __webpack_require__(177);
var IE_PROTO = __webpack_require__(356)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(67);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(141);
var ITERATOR = __webpack_require__(41)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(41)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(614);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(615), __esModule: true };

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1583);
module.exports = __webpack_require__(26).Object.assign;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1585);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1589);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
__webpack_require__(237);
module.exports = __webpack_require__(362).f('iterator');


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1590);
__webpack_require__(620);
__webpack_require__(1595);
__webpack_require__(1596);
module.exports = __webpack_require__(26).Symbol;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(606);
var hiddenKeys = __webpack_require__(358).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 620 */
/***/ (function(module, exports) {



/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(622), __esModule: true };

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1598);
module.exports = __webpack_require__(26).Object.keys;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppBar = __webpack_require__(1616);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_AppBar)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (node, event, handler, options) {
  (0, _on2['default'])(node, event, handler, options);
  return {
    remove: function () {
      function remove() {
        (0, _off2['default'])(node, event, handler, options);
      }

      return remove;
    }()
  };
};

var _on = __webpack_require__(625);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(1621);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(115);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; //  weak

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(265);

var _Transition2 = _interopRequireDefault(_Transition);

var _transitions = __webpack_require__(120);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Fade = (_temp2 = _class = function (_Component) {
  _inherits(Fade, _Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Fade.__proto__ || Object.getPrototypeOf(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (element) {
      element.style.opacity = 0;
      var transitions = _this.context.theme.transitions;

      element.style.transition = transitions.create('opacity', {
        duration: _this.props.enterTransitionDuration
      });
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleEntering = function (element) {
      element.style.opacity = 1;
      if (_this.props.onEntering) {
        _this.props.onEntering(element);
      }
    }, _this.handleExit = function (element) {
      var transitions = _this.context.theme.transitions;

      element.style.transition = transitions.create('opacity', {
        duration: _this.props.leaveTransitionDuration
      });
      element.style.opacity = 0;
      if (_this.props.onExit) {
        _this.props.onExit(element);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Fade, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            enterTransitionDuration = _props.enterTransitionDuration,
            leaveTransitionDuration = _props.leaveTransitionDuration,
            onEnter = _props.onEnter,
            onEntering = _props.onEntering,
            onExit = _props.onExit,
            other = _objectWithoutProperties(_props, ['children', 'enterTransitionDuration', 'leaveTransitionDuration', 'onEnter', 'onEntering', 'onExit']);

        return _react2['default'].createElement(
          _Transition2['default'],
          _extends({
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onExit: this.handleExit
          }, other),
          children
        );
      }

      return render;
    }()
  }]);

  return Fade;
}(_react.Component), _class.propTypes = {
  children: _PropTypes2['default'].node,
  /**
   * Set to true to transition in.
   */
  'in': _PropTypes2['default'].bool,
  /**
   * Duration of the animation when the element is entering the screen.
   */
  enterTransitionDuration: _PropTypes2['default'].number, // eslint-disable-line react/sort-prop-types
  /**
   * Duration of the animation when the element is leaving the screen.
   */
  leaveTransitionDuration: _PropTypes2['default'].number,
  /**
   * Callback fired before the component is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the component is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the component has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the component is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the component has exited.
   */
  onExited: _PropTypes2['default'].func // eslint-disable-line react/sort-prop-types
}, _class.defaultProps = {
  'in': false,
  enterTransitionDuration: _transitions.duration.enteringScreen,
  leaveTransitionDuration: _transitions.duration.leavingScreen
}, _class.contextTypes = {
  theme: _PropTypes2['default'].object
}, _temp2);
exports['default'] = Fade;


Fade.displayName = 'Fade';

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(115);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(1624);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logo = (_temp = _class = function (_SvgIcon) {
  _inherits(Logo, _SvgIcon);

  function Logo() {
    _classCallCheck(this, Logo);

    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
  }

  _createClass(Logo, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', {
              d: 'M122.91 107.37l-29.93 17.28-29.93-17.28V72.81l29.93-17.28 29.93 17.28z',
              fill: '#ff804f'
            })
          ),
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', {
              d: 'M63.05 3.7l29.93 17.28v34.55L63.05 72.81 33.12 55.53V20.98z',
              fill: '#ffd04d'
            })
          ),
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', {
              d: 'M3.2 107.37V72.81l29.92-17.28 29.93 17.28v34.56l-29.93 17.28z',
              fill: '#4ecdc4'
            })
          ),
          _react2['default'].createElement(
            'g',
            { fill: '#333' },
            _react2['default'].createElement('path', { d: 'M79.72 89.66l4.94-2.8V65.27l-4.94 2.8z' }),
            _react2['default'].createElement('path', { d: 'M45 58.51l4.9 2.87 19.5-11.3-4.9-2.87z' }),
            _react2['default'].createElement('path', { d: 'M40 84.92l19.53 11.24.03-5.68-19.52-11.24z' }),
            _react2['default'].createElement('path', { d: 'M96.2 53.69V19.14L63.05 0 29.91 19.14V53.7L0 70.97v38.27l33.14 19.14 29.91-17.28 29.92 17.28 33.15-19.14V70.97zm-6.45-3.72L63.03 34.55 36.34 49.97V22.85L63.05 7.43l26.71 15.42v27.12zm.03 38.25l-26.73 15.44-26.7-15.41V57.37l26.7-15.42 26.72 15.42zM56.6 107.41l-23.47 13.53-26.71-15.42V74.69L29.9 61.13v30.88zm63.1-32.72v30.84L93 120.95l-23.49-13.56 26.71-15.43V61.13z' })
          )
        );
      }

      return render;
    }()
  }]);

  return Logo;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 126.12 128.38'
}, _temp);
exports['default'] = Logo;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; //  weak

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _transitions = __webpack_require__(120);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Ripple', function () {
  return {
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute',
      borderRadius: '50%',
      background: 'currentColor'
    },
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: 'mui-ripple-enter 550ms ' + _transitions.easing.easeInOut
    },
    rippleFast: {
      animationDuration: '200ms'
    },
    container: {
      opacity: 1
    },
    containerLeaving: {
      opacity: 0,
      animation: 'mui-ripple-exit 550ms ' + _transitions.easing.easeInOut
    },
    containerPulsating: {
      position: 'absolute',
      left: 0,
      top: 0,
      display: 'block',
      width: '100%',
      height: '100%',
      animation: 'mui-ripple-pulsate 1500ms ' + _transitions.easing.easeInOut + ' 200ms infinite',
      rippleVisible: {
        opacity: 0.2
      }
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.9)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
});

var Ripple = (_temp2 = _class = function (_Component) {
  _inherits(Ripple, _Component);

  function Ripple() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Ripple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Ripple.__proto__ || Object.getPrototypeOf(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rippleVisible: false
    }, _this.ripple = null, _this.leaveTimer = undefined, _this.start = function (callback) {
      _this.setState(
      // eslint-disable-next-line flowtype-errors/show-errors
      {
        rippleVisible: true
      }, callback);
    }, _this.stop = function (callback) {
      _this.setState(
      // eslint-disable-next-line flowtype-errors/show-errors
      {
        rippleLeaving: true
      }, callback);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Ripple, [{
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        clearTimeout(this.leaveTimer);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'componentWillEnter',
    value: function () {
      function componentWillEnter(callback) {
        this.start(callback);
      }

      return componentWillEnter;
    }()
  }, {
    key: 'componentWillLeave',
    value: function () {
      function componentWillLeave(callback) {
        var _this2 = this;

        this.stop(function () {
          _this2.leaveTimer = setTimeout(function () {
            callback();
          }, 550);
        });
      }

      return componentWillLeave;
    }()
  }, {
    key: 'getRippleStyles',
    value: function () {
      function getRippleStyles() {
        var _props = this.props,
            rippleSize = _props.rippleSize,
            rippleX = _props.rippleX,
            rippleY = _props.rippleY;


        var rippleStyles = {
          width: rippleSize,
          height: rippleSize,
          top: -(rippleSize / 2) + rippleY,
          left: -(rippleSize / 2) + rippleX
        };

        return rippleStyles;
      }

      return getRippleStyles;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames2;

        var _props2 = this.props,
            className = _props2.className,
            pulsate = _props2.pulsate;
        var _state = this.state,
            rippleVisible = _state.rippleVisible,
            rippleLeaving = _state.rippleLeaving;

        var classes = this.context.styleManager.render(styleSheet);

        var rippleClassName = (0, _classnames2['default'])(classes.ripple, (_classNames = {}, _defineProperty(_classNames, classes.rippleVisible, rippleVisible), _defineProperty(_classNames, classes.rippleFast, pulsate), _classNames), className);

        var containerClasses = (0, _classnames2['default'])(classes.container, (_classNames2 = {}, _defineProperty(_classNames2, classes.containerLeaving, rippleLeaving), _defineProperty(_classNames2, classes.containerPulsating, pulsate), _classNames2));

        var rippleStyles = this.getRippleStyles();

        return _react2['default'].createElement(
          'span',
          { className: containerClasses },
          _react2['default'].createElement('span', { className: rippleClassName, style: rippleStyles })
        );
      }

      return render;
    }()
  }]);

  return Ripple;
}(_react.Component), _class.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  pulsate: _PropTypes2['default'].bool,
  rippleSize: _PropTypes2['default'].number.isRequired,
  rippleX: _PropTypes2['default'].number.isRequired,
  rippleY: _PropTypes2['default'].number.isRequired
}, _class.defaultProps = {
  pulsate: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Ripple;


Ripple.displayName = 'Ripple';

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('DialogActions', function (theme) {
  var unit = parseInt(theme.typography.rhythmByUnit(1));
  var halfUnit = unit / 2;
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      margin: theme.typography.rhythmByUnit(1) + ' ' + theme.typography.rhythmByUnit(2),
      flex: '0 0 auto'
    },
    action: {
      margin: '0 ' + halfUnit + 'px',
      '&:last-child': {
        marginRight: 0
      }
    }
  };
});

var DialogActions = (_temp2 = _class = function (_Component) {
  _inherits(DialogActions, _Component);

  function DialogActions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DialogActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DialogActions.__proto__ || Object.getPrototypeOf(DialogActions)).call.apply(_ref, [this].concat(args))), _this), _this.classes = {}, _this.renderButton = function (button) {
      if (button) {
        return _react2['default'].createElement(
          'div',
          { className: _this.classes.action },
          _react2['default'].cloneElement(button, {
            className: button.props.className
          })
        );
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DialogActions, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            classNameProp = _props.className,
            closeConfirmation = _props.closeConfirmation,
            other = _objectWithoutProperties(_props, ['children', 'className', 'closeConfirmation']);

        this.classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(this.classes.root, classNameProp);

        return _react2['default'].createElement(
          'div',
          _extends({ 'data-mui-test': 'DialogActions', className: className }, other),
          closeConfirmation,
          children && _react2['default'].Children.map(children, this.renderButton)
        );
      }

      return render;
    }()
  }]);

  return DialogActions;
}(_react.Component), _class.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  closeConfirmation: _PropTypes2['default'].node
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = DialogActions;


DialogActions.displayName = 'DialogActions';

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _Text = __webpack_require__(56);

var _Toolbar = __webpack_require__(367);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _IconButton = __webpack_require__(90);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Paper = __webpack_require__(150);

var _Paper2 = _interopRequireDefault(_Paper);

var _Clear = __webpack_require__(399);

var _Clear2 = _interopRequireDefault(_Clear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('DialogTitle', function (theme) {
  var _ref;

  return _ref = {
    root: {
      margin: 0,
      padding: theme.typography.rhythmByUnit(3) + ' ' + theme.typography.rhythmByUnit(2),
      height: 'auto',
      flex: '1',
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.getContrastText(theme.palette.background.paper),
      maxWidth: '100%',
      boxSizing: 'border-box'
    },
    primary: {
      backgroundColor: theme.palette.primary[500],
      color: theme.palette.getContrastText(theme.palette.primary[500])
    },
    secondary: {
      backgroundColor: theme.palette.primary[100],
      color: theme.palette.getContrastText(theme.palette.primary[100])
    },
    accent: {
      backgroundColor: theme.palette.accent.A200,
      color: theme.palette.getContrastText(theme.palette.accent.A200)
    },
    error: {
      backgroundColor: theme.palette.error.A200,
      color: theme.palette.getContrastText(theme.palette.error.A200)
    },
    close: {
      display: 'none'
    },
    paper: {
      boxShadow: 'none'
    },
    paperFullscreen: {
      display: 'flex',
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: theme.zIndex.dialog
    }
  }, _defineProperty(_ref, theme.breakpoints.down('sm'), {
    toolbarFullscreen: {
      height: theme.typography.rhythmByUnit(8),
      padding: '0 0 0 ' + theme.typography.rhythmByUnit(1)
    }
  }), _defineProperty(_ref, theme.breakpoints.up('sm'), {
    closeFullscreen: {
      display: 'none'
    },
    fullScreen: {
      backgroundColor: 'initial',
      color: theme.palette.primary[500]
    },
    paperFullscreen: {
      boxShadow: 'none',
      position: 'static'
    }
  }), _ref;
});

var DialogTitle = (_temp = _class = function (_Component) {
  _inherits(DialogTitle, _Component);

  function DialogTitle() {
    _classCallCheck(this, DialogTitle);

    return _possibleConstructorReturn(this, (DialogTitle.__proto__ || Object.getPrototypeOf(DialogTitle)).apply(this, arguments));
  }

  _createClass(DialogTitle, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames2, _classNames3;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            classNameProp = _props.className,
            closeClassNameProp = _props.closeClassName,
            Close = _props.closeComponent,
            CloseIcon = _props.closeIconComponent,
            error = _props.error,
            fullScreen = _props.fullScreen,
            onCloseClick = _props.onCloseClick,
            paperClassNameProp = _props.paperClassName,
            primary = _props.primary,
            secondary = _props.secondary,
            Toolbar = _props.toolBarComponent,
            other = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'closeClassName', 'closeComponent', 'closeIconComponent', 'error', 'fullScreen', 'onCloseClick', 'paperClassName', 'primary', 'secondary', 'toolBarComponent']);

        var classes = this.context.styleManager.render(styleSheet);

        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.fullScreen, fullScreen), _defineProperty(_classNames, classes.primary, fullScreen && primary && !(secondary || accent || error)), _defineProperty(_classNames, classes.secondary, fullScreen && secondary && !(accent || error)), _defineProperty(_classNames, classes.accent, fullScreen && accent && !error), _defineProperty(_classNames, classes.error, fullScreen && error), _defineProperty(_classNames, classes.toolbarFullscreen, fullScreen), _classNames), classNameProp);

        var closeClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, classes.closeFullscreen, fullScreen), _defineProperty(_classNames2, classes.close, !fullScreen), _classNames2), closeClassNameProp);

        var paperClassName = (0, _classnames2['default'])((_classNames3 = {}, _defineProperty(_classNames3, classes.paperFullscreen, fullScreen), _defineProperty(_classNames3, classes.paper, !fullScreen), _classNames3), paperClassNameProp);

        return _react2['default'].createElement(
          _Paper2['default'],
          { rounded: false, elevation: 1, className: paperClassName },
          _react2['default'].createElement(
            Toolbar,
            _extends({ 'data-mui-test': 'DialogTitle', className: className }, other),
            _react2['default'].createElement(
              Close,
              { className: closeClassName, onClick: onCloseClick },
              _react2['default'].createElement(CloseIcon, null)
            ),
            typeof children === 'string' ? _react2['default'].createElement(
              _Text.Title,
              { colorInherit: true },
              children
            ) : children
          )
        );
      }

      return render;
    }()
  }]);

  return DialogTitle;
}(_react.Component), _class.propTypes = {
  /**
   * If `true`, the text will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The CSS class name of the close element.
   */
  closeClassName: _PropTypes2['default'].string,
  /**
   * Component to be used as the close element
   */
  closeComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Component to be used as the close element
   */
  closeIconComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, The dialog will be full-screen.
   */
  fullScreen: _PropTypes2['default'].bool,
  /**
   * Callback fires when the close icon is clicked on.
   */
  onCloseClick: _PropTypes2['default'].func,
  /**
   * The CSS class name of the paper element.
   */
  paperClassName: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Component to be used as the confirmation action node
   */
  toolBarComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func])
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.defaultProps = {
  closeComponent: _IconButton2['default'],
  closeIconComponent: _Clear2['default'],
  toolBarComponent: _Toolbar2['default']
}, _temp);
exports['default'] = DialogTitle;


DialogTitle.displayName = 'DialogTitle';

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PieChart = __webpack_require__(829);

var _PieChart2 = _interopRequireDefault(_PieChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('PieProgress', function () {
  return {
    root: {
      color: 'currentColor'
    }
  };
});

var PieProgress = (_temp = _class = function (_Component) {
  _inherits(PieProgress, _Component);

  function PieProgress() {
    _classCallCheck(this, PieProgress);

    return _possibleConstructorReturn(this, (PieProgress.__proto__ || Object.getPrototypeOf(PieProgress)).apply(this, arguments));
  }

  _createClass(PieProgress, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            segmentSizeProp = _props.segmentSize,
            valueProp = _props.value,
            valuemax = _props.valuemax,
            other = _objectWithoutProperties(_props, ['className', 'segmentSize', 'value', 'valuemax']);

        var segmentSize = valuemax / segmentSizeProp;
        var value = valueProp > 0 && valueProp < segmentSize ? segmentSize : Math.floor(valueProp / segmentSize) * segmentSize;
        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);

        return _react2['default'].createElement(_PieChart2['default'], _extends({
          'aria-valuemax': '' + valuemax // eslint-disable-line jsx-a11y/aria-proptypes
          , 'aria-valuemin': '0',
          'aria-valuenow': '' + valueProp // eslint-disable-line jsx-a11y/aria-proptypes
          , role: 'progressbar'
        }, Object.assign({ className: className, value: value }, other)));
      }

      return render;
    }()
  }]);

  return PieProgress;
}(_react.Component), _class.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The number of segments.
   */
  segmentSize: _PropTypes2['default'].number,
  /**
   * The value of progress.
   */
  value: _PropTypes2['default'].number,
  /**
   * The max value of progress.
   */
  valuemax: _PropTypes2['default'].number
}, _class.defaultProps = {
  segmentSize: 12,
  value: 0,
  valuemax: 100
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = PieProgress;


PieProgress.displayName = 'PieProgress';

/***/ }),
/* 634 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 636 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 637 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _typography = __webpack_require__(155);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Menu = __webpack_require__(146);

var _Menu2 = _interopRequireDefault(_Menu);

var _fuse = __webpack_require__(844);

var _fuse2 = _interopRequireDefault(_fuse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createFuse = function createFuse() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var caseSensitive = props.caseSensitive,
      children = props.children,
      distance = props.distance,
      _props$indices = props.indices,
      indices = _props$indices === undefined ? [] : _props$indices,
      location = props.location,
      minMatchCharLength = props.minMatchCharLength,
      shouldSort = props.shouldSort,
      threshold = props.threshold,
      tokenize = props.tokenize;

  return new _fuse2['default'](_react.Children.toArray(children), {
    keys: indices.map(function (k) {
      return 'props.' + k;
    }),
    includeMatches: true,
    includeScore: true,
    caseSensitive: caseSensitive,
    distance: distance,
    location: location,
    minMatchCharLength: minMatchCharLength,
    shouldSort: shouldSort,
    threshold: threshold,
    tokenize: tokenize
  });
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputDataList', function (theme) {
  return {
    root: {},
    closed: {
      position: 'absolute',
      width: '1px',
      padding: 0,
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0
    },
    popover: {
      position: 'fixed',
      marginTop: theme.variables.borderWidthFocused
    }
  };
});

var InputDataList = (_temp2 = _class = function (_Component) {
  _inherits(InputDataList, _Component);

  function InputDataList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputDataList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputDataList.__proto__ || Object.getPrototypeOf(InputDataList)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          child = _ref2.item;

      var key = child.props.value ? { key: child.props.value } : {};

      return _react2['default'].cloneElement(child, Object.assign({}, key, child.props));
    }, _this.fuse = createFuse(_this.props), _this.getValue = function (element) {
      var el = element || _this.getContentAnchorEl();
      return el.hasAttribute('value') ? el.getAttribute('value') : el.textContent;
    }, _this.handleSelectItem = function (e) {
      var onSelectItem = _this.props.onSelectItem;

      onSelectItem(_this.getValue(e.target));
    }, _this.getContentAnchorEl = function () {
      return _this.menu.getContentAnchorEl();
    }, _this.isDirty = function () {
      return _this.props.value && _this.props.value.length > 0;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputDataList, [{
    key: 'shouldUpdateFuse',
    value: function () {
      function shouldUpdateFuse(props) {
        var _this2 = this;

        var keys = ['indices', 'minMatchCharLength', 'shouldSort', 'threshold'];
        return !keys.every(function (k) {
          return props[k] === _this2.props[k];
        });
      }

      return shouldUpdateFuse;
    }()
  }, {
    key: 'shouldUpdateCollection',
    value: function () {
      function shouldUpdateCollection(props) {
        var _this3 = this;

        var keys = ['children'];
        return !keys.every(function (k) {
          return props[k] === _this3.props[k];
        });
      }

      return shouldUpdateCollection;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(props) {
        var updateFuse = this.shouldUpdateFuse(props);
        var updateCollection = this.shouldUpdateCollection(props);

        if (updateFuse) {
          this.fuse = createFuse(props);
          return;
        }
        if (updateCollection) this.fuse.setCollection(_react.Children.toArray(props.children));
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'selectItem',
    value: function () {
      function selectItem(element) {
        var el = element || this.getContentAnchorEl();
        if (el) el.focus();
      }

      return selectItem;
    }()
  }, {
    key: 'selectNextItem',
    value: function () {
      function selectNextItem(element) {
        var el = element || this.getContentAnchorEl();
        if (el.nextElementSibling) el.nextElementSibling.focus();
      }

      return selectNextItem;
    }()
  }, {
    key: 'selectPreviousItem',
    value: function () {
      function selectPreviousItem(element) {
        var el = element || this.getContentAnchorEl();
        if (el.previousElementSibling) el.previousElementSibling.focus();
      }

      return selectPreviousItem;
    }()
  }, {
    key: 'search',
    value: function () {
      function search(value) {
        var children = this.fuse.search(value);

        return children.length !== 0 ? children : _react.Children.toArray(this.props.children).map(function (item) {
          return {
            item: item,
            matches: []
          };
        });
      }

      return search;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var _props = this.props,
            anchorEl = _props.anchorEl,
            bindEl = _props.bindEl,
            caseSensitive = _props.caseSensitive,
            childrenProp = _props.children,
            classNameProp = _props.className,
            Menu = _props.component,
            distance = _props.distance,
            indices = _props.indices,
            MenuItemProp = _props.itemComponent,
            location = _props.location,
            minMatchCharLength = _props.minMatchCharLength,
            onSelectItem = _props.onSelectItem,
            open = _props.open,
            shouldSort = _props.shouldSort,
            threshold = _props.threshold,
            tokenize = _props.tokenize,
            value = _props.value,
            props = _objectWithoutProperties(_props, ['anchorEl', 'bindEl', 'caseSensitive', 'children', 'className', 'component', 'distance', 'indices', 'itemComponent', 'location', 'minMatchCharLength', 'onSelectItem', 'open', 'shouldSort', 'threshold', 'tokenize', 'value']);

        var style = {};

        var classes = this.context.styleManager.render(styleSheet);
        var children = this.search(value).map(this.renderItem);

        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.closed, !open), classNameProp);

        if (anchorEl) {
          var anchorElOnViewPort = {
            bottom: anchorEl.getBoundingClientRect().top + anchorEl.getBoundingClientRect().height,
            top: window.innerHeight - anchorEl.getBoundingClientRect().top
          };

          var itemList = {
            minPadding: (0, _typography.rhythmByUnit)(2),
            itemHeight: this.menu.menuList.list.getBoundingClientRect().height
          };

          var isOffViewPort = anchorElOnViewPort.bottom + parseInt(itemList.minPadding) + parseInt(itemList.itemHeight) > window.innerHeight;

          if (isOffViewPort) {
            style = {
              bottom: anchorElOnViewPort.top
            };
          } else {
            style = {
              top: anchorElOnViewPort.bottom
            };
          }
        }

        return _react2['default'].createElement(Menu, _extends({
          ref: function () {
            function ref(c) {
              return _this4.menu = c;
            }

            return ref;
          }()
        }, Object.assign({}, props, {
          children: children,
          className: className,
          onSelectItem: this.handleSelectItem,
          popoverClassName: classes.popover,
          popoverProps: { style: style },
          tabIndex: -1
        })));
      }

      return render;
    }()
  }]);

  return InputDataList;
}(_react.Component), _class.propTypes = {
  /**
   * This is the DOM element that will be
   * used to set the position of the menu.
   */
  anchorEl: _PropTypes2['default'].object,
  /**
   * If false, `Menu` won't pass `this.getContentAnchorEl` to `Popover`
   */
  anchorInnerElement: _PropTypes2['default'].bool,
  /**
   * If `true`, the menu is part of an AutoComplete component
   */
  autoComplete: _PropTypes2['default'].bool,
  /**
   * If `true`, the menu will autofocus its contents upon entering
   */
  autoFocus: _PropTypes2['default'].bool,
  /**
   * bindEl: This is the input DOM element that will be associated with the data list.
   */
  bindEl: _PropTypes2['default'].func,
  /**
   * Indicates whether comparisons should be case sensitive.
   */
  caseSensitive: _PropTypes2['default'].bool,
  /**
   * The element or component used for the root node.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Menu contents, should be menu items.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, there will be no maxHeight applied
   */
  disableMaxHeight: _PropTypes2['default'].bool,
  /**
   * Determines how close the match must be to the fuzzy location (specified by location).
   */
  distance: _PropTypes2['default'].number,
  /**
   * @ignore
   */
  fullWidth: _PropTypes2['default'].bool,
  /**
   * Child properties to filter results by
   */
  indices: _PropTypes2['default'].arrayOf(_PropTypes2['default'].string),
  /**
   * The element or component used for the first unmatched child.
   */
  itemComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Determines approximately where in the text is the pattern expected to be found.
   */
  location: _PropTypes2['default'].number,
  /**
   * When set to include matches, only the matches whose length
   * exceeds this value will be returned. (For instance, if you want
   * to ignore single character index returns, set to 2)
   */
  minMatchCharLength: _PropTypes2['default'].number,
  /**
   * Callback fired before the Menu is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the Menu is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback function fired when the menu is requested to be closed.
   *
   * @param {event} event The event that triggered the close request
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onSelectItem: _PropTypes2['default'].func,
  /**
   * If `true`, the menu is visible.
   */
  open: _PropTypes2['default'].bool,
  /**
   * Boolean toggling the use of a modal for the menu's popover
   */
  modal: _PropTypes2['default'].bool,
  /**
   * Whether to sort the result list, by score
   */
  shouldSort: _PropTypes2['default'].bool,
  /**
   * At what point does the match algorithm give up. A threshold of
   * `0.0` requires a perfect match (of both letters and location),
   * a threshold of `1.0`` would match anything.
   */
  threshold: _PropTypes2['default'].number,
  /**
   * When true, the algorithm will search individual words and the full string,
   * computing the final score as a function of both. In this case, the threshold,
   * distance, and location are inconsequential for individual tokens, and are thus ignored.
   */
  tokenize: _PropTypes2['default'].bool,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _PropTypes2['default'].oneOfType([_PropTypes2['default'].number, _PropTypes2['default'].string]),
  /**
   * The input value to filter results with
   */
  value: _PropTypes2['default'].string
}, _class.defaultProps = {
  autoComplete: true,
  autoFocus: false,
  caseSensitive: false,
  component: _Menu2['default'],
  distance: 1000,
  indices: ['value', 'children'],
  itemComponent: _Menu.MenuItem,
  location: 1,
  minMatchCharLength: 1,
  modal: false,
  threshold: 0.1,
  tokenize: true
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = InputDataList;


InputDataList.displayName = 'InputDataList';

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;
exports['default'] = ListItemSecondaryAction;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListItemSecondaryAction', function (theme) {
  return {
    secondaryAction: {
      position: 'absolute',
      right: 4,
      top: '50%',
      marginTop: '-' + theme.typography.rhythmByUnit(3)
    }
  };
});

function ListItemSecondaryAction(props, context) {
  var children = props.children,
      classNameProp = props.className;

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.secondaryAction, classNameProp);

  return _react2['default'].createElement(
    'div',
    { className: className },
    children
  );
}

ListItemSecondaryAction.displayName = 'ListItemSecondaryAction';

ListItemSecondaryAction.propTypes = {
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
};

ListItemSecondaryAction.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = ListSubheader;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListSubheader', function (theme) {
  var typography = theme.typography;


  return {
    root: Object.assign({
      boxSizing: 'border-box',
      paddingTop: typography.rhythmByUnit(3.5),
      paddingLeft: typography.rhythmByUnit(2)
    }, typography.menugroup),
    primary: typography.primary,
    secondary: typography.secondary,
    accent: typography.highlight,
    error: typography.error,
    disabled: typography.disabled,
    inset: {
      paddingLeft: typography.rhythmByUnit(9)
    }
  };
});

ListSubheader.propTypes = {
  /**
   * The content of the ListSubheader.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the ListSubheader will be indented.
   */
  inset: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * If true, will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If false, the ripple effect will be disabled.
   */
  ripple: _PropTypes2['default'].bool
};

ListSubheader.defaultProps = {
  inset: false,
  primary: false,
  secondary: false,
  accent: false,
  disabled: false,
  error: false
};

ListSubheader.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

function ListSubheader(props, context) {
  var _classNames;

  var classNameProp = props.className,
      primary = props.primary,
      secondary = props.secondary,
      accent = props.accent,
      disabled = props.disabled,
      error = props.error,
      inset = props.inset,
      children = props.children,
      other = _objectWithoutProperties(props, ['className', 'primary', 'secondary', 'accent', 'disabled', 'error', 'inset', 'children']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.primary, primary && !(secondary || accent || error || disabled)), _defineProperty(_classNames, classes.secondary, secondary && !(accent || error || disabled)), _defineProperty(_classNames, classes.accent, accent && !(error || disabled)), _defineProperty(_classNames, classes.error, error && !disabled), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.inset, inset), _classNames), classNameProp);

  return _react2['default'].createElement(
    'div',
    _extends({ className: className }, other),
    children
  );
}

ListSubheader.displayName = 'ListSubheader';

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ = __webpack_require__(69);

var _Text = __webpack_require__(56);

var _Avatar = __webpack_require__(391);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('CollapsedListItem', function (theme) {
  var mixins = theme.mixins,
      palette = theme.palette,
      spacing = theme.spacing,
      typography = theme.typography,
      variables = theme.variables,
      zIndex = theme.zIndex;

  var height = spacing.unit / 2;

  return {
    root: {
      padding: 0,
      marginTop: typography.rhythmByUnit(-1),
      marginBottom: typography.rhythmByUnit(-1),
      height: typography.rhythmByUnit(7),
      backgroundColor: palette.background.paper,
      zIndex: zIndex.baseIndex,
      position: 'relative',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      }
    },
    avatar: {
      backgroundColor: palette.background.paper,
      color: palette.text.divider,
      borderWidth: variables.borderWidth,
      borderStyle: 'solid',
      borderColor: palette.text.divider,
      borderRadius: '50%',
      top: parseInt(typography.rhythmByUnit(2)) - variables.borderWidth - height,
      left: typography.rhythmByUnit(2),
      position: 'absolute'
    },
    box: {
      borderTop: '1px solid ' + palette.text.divider,
      borderBottom: '1px solid ' + palette.text.divider,
      width: '100%',
      height: height
    },
    label: mixins.truncate({
      display: 'inline-block',
      position: 'relative',
      top: '-1em',
      marginLeft: '5em',
      padding: '0.4em',
      backgroundColor: palette.background.paper
    })
  };
});

var CollapsedListItem = (_temp = _class = function (_PureComponent) {
  _inherits(CollapsedListItem, _PureComponent);

  function CollapsedListItem() {
    _classCallCheck(this, CollapsedListItem);

    return _possibleConstructorReturn(this, (CollapsedListItem.__proto__ || Object.getPrototypeOf(CollapsedListItem)).apply(this, arguments));
  }

  _createClass(CollapsedListItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            count = _props.count,
            label = _props.label,
            _onClick = _props.onClick;

        var classes = this.context.styleManager.render(styleSheet);
        return _react2['default'].createElement(
          _.ListItem,
          {
            className: classes.root,
            onClick: function () {
              function onClick(e) {
                return _onClick(e, _this2.props);
              }

              return onClick;
            }(),
            dense: true
          },
          _react2['default'].createElement(
            _.ListItemIcon,
            null,
            _react2['default'].createElement(
              _Avatar2['default'],
              { className: classes.avatar },
              _react2['default'].createElement(
                _Text.Body1,
                null,
                count
              )
            )
          ),
          _react2['default'].createElement(
            'div',
            { resource: 'expand', className: classes.box },
            label && _react2['default'].createElement(
              _Text.Body1,
              { className: classes.label },
              label
            )
          )
        );
      }

      return render;
    }()
  }]);

  return CollapsedListItem;
}(_react.PureComponent), _class.propTypes = {
  /**
   * Number of collapsed list items represented by CollapsedListItem.
   */
  count: _PropTypes2['default'].number,
  /**
   * Function called when CollapsedListItem is clicked;
   * should be wired in List to display hidden list items.
   */
  onClick: _PropTypes2['default'].func,
  /**
   * Beginning index of parent List's children represented by CollapsedListItem.
   */
  startIdx: _PropTypes2['default'].number,
  /**
   * Label to show in the collapsed section beside number
   */
  label: _PropTypes2['default'].string
}, _class.defaultProps = {
  count: 0
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = CollapsedListItem;


CollapsedListItem.displayName = 'CollapsedListItem';

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableHandle = exports.SortableElement = exports.SortableContainer = exports.SortableList = exports['default'] = undefined;

var _SortableList2 = __webpack_require__(1674);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_SortableList2)['default'];
    }

    return get;
  }()
});

var _SortableList3 = _interopRequireDefault(_SortableList2);

var _SortableContainer2 = __webpack_require__(655);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(656);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(657);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.SortableList = _SortableList3['default'];
exports.SortableContainer = _SortableContainer3['default'];
exports.SortableElement = _SortableElement3['default'];
exports.SortableHandle = _SortableHandle3['default'];

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1676)();
}


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1683),
    listCacheDelete = __webpack_require__(1684),
    listCacheGet = __webpack_require__(1686),
    listCacheHas = __webpack_require__(1687),
    listCacheSet = __webpack_require__(1688);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1689),
    isObjectLike = __webpack_require__(1701);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 646 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(648);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 648 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(651),
    toKey = __webpack_require__(244);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(116),
    isKey = __webpack_require__(372),
    stringToPath = __webpack_require__(1705),
    toString = __webpack_require__(1707);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 652 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _reactSortableHoc = __webpack_require__(241);

var _SortableElement = __webpack_require__(656);

var _SortableElement2 = _interopRequireDefault(_SortableElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports['default'] = (0, _reactSortableHoc.SortableContainer)((_temp = _class = function (_PureComponent) {
  _inherits(SortableContainer, _PureComponent);

  function SortableContainer() {
    _classCallCheck(this, SortableContainer);

    return _possibleConstructorReturn(this, (SortableContainer.__proto__ || Object.getPrototypeOf(SortableContainer)).apply(this, arguments));
  }

  _createClass(SortableContainer, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            items = _props.items,
            Component = _props.component,
            other = _objectWithoutProperties(_props, ['items', 'component']);

        return _react2['default'].createElement(
          Component,
          other,
          items.map(function (element, index) {
            return _react2['default'].createElement(_SortableElement2['default'], _extends({ key: 'item-' + index }, { index: index, element: element }));
          })
        );
      }

      return render;
    }()
  }]);

  return SortableContainer;
}(_react.PureComponent), _class.propTypes = {
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  items: _PropTypes2['default'].array
}, _class.defaultProps = {
  component: 'div',
  items: []
}, _class.displayName = 'SortableContainer', _temp), {
  withRef: true
});

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSortableHoc = __webpack_require__(241);

var _SortableHandle = __webpack_require__(657);

var _SortableHandle2 = _interopRequireDefault(_SortableHandle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SortableElement', function (theme) {
  return {
    sortableElement: {
      '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
      paddingRight: theme.typography.rhythmByUnit(6),
      userSelect: 'none',
      cursor: 'grab',
      fallbacks: {
        cursor: 'move'
      }
    }
  };
});

exports['default'] = (0, _reactSortableHoc.SortableElement)((_temp = _class = function (_PureComponent) {
  _inherits(SortableElement, _PureComponent);

  function SortableElement() {
    _classCallCheck(this, SortableElement);

    return _possibleConstructorReturn(this, (SortableElement.__proto__ || Object.getPrototypeOf(SortableElement)).apply(this, arguments));
  }

  _createClass(SortableElement, [{
    key: 'render',
    value: function () {
      function render() {
        var classes = this.context.styleManager.render(styleSheet);
        var elementProp = this.props.element;
        var _elementProp$props = elementProp.props;
        _elementProp$props = _elementProp$props === undefined ? {} : _elementProp$props;
        var className = _elementProp$props.className,
            _elementProp$type = elementProp.type;
        _elementProp$type = _elementProp$type === undefined ? {} : _elementProp$type;
        var _elementProp$type$pro = _elementProp$type.propTypes;
        _elementProp$type$pro = _elementProp$type$pro === undefined ? {} : _elementProp$type$pro;
        var actionsPropType = _elementProp$type$pro.actions;

        var element = _react2['default'].cloneElement(elementProp, Object.assign({}, actionsPropType && {
          actions: _react2['default'].createElement(_SortableHandle2['default'], null)
        }, {
          button: false,
          className: (0, _classnames2['default'])(classes.sortableElement, className, 'cursorGrabbing')
        }));
        return _react2['default'].createElement(
          'div',
          null,
          element
        );
      }

      return render;
    }()
  }]);

  return SortableElement;
}(_react.PureComponent), _class.propTypes = {
  element: _PropTypes2['default'].node
}, _class.displayName = 'SortableElement', _class.defaultProps = {
  element: null
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp), {
  withRef: true
});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSortableHoc = __webpack_require__(241);

var _IconButton = __webpack_require__(90);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Drag = __webpack_require__(837);

var _Drag2 = _interopRequireDefault(_Drag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SortableHandle', function () {
  return {
    sortableHandle: {
      position: 'absolute',
      top: '50%',
      right: 0,
      bottom: 0,
      height: '100%',
      borderRadius: 0,
      transform: 'translateY(-50%)',
      cursor: 'grab',
      fallbacks: {
        cursor: 'move'
      }
    }
  };
});

exports['default'] = (0, _reactSortableHoc.SortableHandle)((_temp = _class = function (_PureComponent) {
  _inherits(SortableHandle, _PureComponent);

  function SortableHandle() {
    _classCallCheck(this, SortableHandle);

    return _possibleConstructorReturn(this, (SortableHandle.__proto__ || Object.getPrototypeOf(SortableHandle)).apply(this, arguments));
  }

  _createClass(SortableHandle, [{
    key: 'render',
    value: function () {
      function render() {
        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          _IconButton2['default'],
          {
            className: (0, _classnames2['default'])(classes.sortableHandle, 'cursorGrabbing'),
            'data-sortableHandle': true,
            tabIndex: '-1'
          },
          _react2['default'].createElement(_Drag2['default'], null)
        );
      }

      return render;
    }()
  }]);

  return SortableHandle;
}(_react.PureComponent), _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.displayName = 'SortableHandle', _temp), {
  withRef: true
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollToColumn: 0,
      scrollToRow: 0
    }, _this._columnStartIndex = 0, _this._columnStopIndex = 0, _this._rowStartIndex = 0, _this._rowStopIndex = 0, _this._onKeyDown = function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;


      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }, _this._onSectionRendered = function (_ref2) {
      var columnStartIndex = _ref2.columnStartIndex,
          columnStopIndex = _ref2.columnStopIndex,
          rowStartIndex = _ref2.rowStartIndex,
          rowStopIndex = _ref2.rowStopIndex;

      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'setScrollIndexes',
    value: function setScrollIndexes(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;

      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;

      var _getScrollState2 = this._getScrollState(),
          scrollToColumn = _getScrollState2.scrollToColumn,
          scrollToRow = _getScrollState2.scrollToRow;

      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](
        'div',
        { className: className, onKeyDown: this._onKeyDown },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: '_getScrollState',
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: '_updateScrollState',
    value: function _updateScrollState(_ref4) {
      var scrollToColumn = _ref4.scrollToColumn,
          scrollToRow = _ref4.scrollToRow;
      var _props2 = this.props,
          isControlled = _props2.isControlled,
          onScrollToChange = _props2.onScrollToChange;


      if (typeof onScrollToChange === 'function') {
        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }

      if (!isControlled) {
        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return null;
      }

      if (nextProps.scrollToColumn !== prevState.scrollToColumn || nextProps.scrollToRow !== prevState.scrollToRow) {
        return {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow
        };
      }

      return null;
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
ArrowKeyStepper.propTypes =  true ? null : {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  isControlled: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['cells', 'edges']).isRequired,
  onScrollToChange: PropTypes.func,
  rowCount: PropTypes.number.isRequired,
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["a" /* polyfill */])(ArrowKeyStepper);

/* harmony default export */ __webpack_exports__["a"] = (ArrowKeyStepper);




/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1751), __esModule: true };

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1753);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1754);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);



















/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props));

    _this._onGridRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;
    _this._styleCache = {};
    _this._cellCache = {};

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      // isScrolling is used to determine if we reset styleCache
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    var columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });

    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,

        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,

        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,

      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: 'getTotalRowsHeight',
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }

    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: 'getTotalColumnsWidth',
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;
      var instanceProps = this.state.instanceProps;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;
      var instanceProps = this.state.instanceProps;

      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;
      var instanceProps = this.state.instanceProps;


      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._styleCache = {};
      this._cellCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;
      var instanceProps = this.state.instanceProps;

      // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prevState, { needToResetStyleCache: false });
          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }

      // refs don't work in `react-test-renderer`
      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop,
          instanceProps = _state.instanceProps;
      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          autoContainerWidth = _props6.autoContainerWidth,
          autoHeight = _props6.autoHeight,
          autoWidth = _props6.autoWidth,
          className = _props6.className,
          containerProps = _props6.containerProps,
          containerRole = _props6.containerRole,
          containerStyle = _props6.containerStyle,
          height = _props6.height,
          id = _props6.id,
          noContentRenderer = _props6.noContentRenderer,
          role = _props6.role,
          style = _props6.style,
          tabIndex = _props6.tabIndex,
          width = _props6.width;
      var _state2 = this.state,
          instanceProps = _state2.instanceProps,
          needToResetStyleCache = _state2.needToResetStyleCache;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      }

      // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }

      // calculate children to render here
      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
        'div',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;


      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });

        // update the indices
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_handleInvalidatedGridSize',


    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props7 = _this3.props,
              height = _props7.height,
              onScroll = _props7.onScroll,
              width = _props7.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;

        // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps;

      // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });

      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, {
          isScrolling: false
        });
      }

      var maybeStateA = void 0;
      var maybeStateB = void 0;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });

      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;

      // getting scrollBarSize (moved from componentWillMount)
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, newState, maybeStateA, maybeStateB);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_getScrollToPositionStateUpdate',


    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }
      return null;
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;

        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollLeftForScrollToColumnStateUpdate',
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return null;
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollTopForScrollToRowStateUpdate',
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return null;
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize___default.a,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
};
Grid.propTypes =  true ? null : {
  "aria-label": PropTypes.string.isRequired,
  "aria-readonly": PropTypes.bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: PropTypes.bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: PropTypes.bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: function cellRenderer() {
    return (typeof bpfrpt_proptype_CellRenderer === 'function' ? bpfrpt_proptype_CellRenderer.isRequired ? bpfrpt_proptype_CellRenderer.isRequired : bpfrpt_proptype_CellRenderer : PropTypes.shape(bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: function cellRangeRenderer() {
    return (typeof bpfrpt_proptype_CellRangeRenderer === 'function' ? bpfrpt_proptype_CellRangeRenderer.isRequired ? bpfrpt_proptype_CellRangeRenderer.isRequired : bpfrpt_proptype_CellRangeRenderer : PropTypes.shape(bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: PropTypes.string,


  /** Number of columns in grid.  */
  columnCount: PropTypes.number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: function columnWidth() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Unfiltered props for the Grid container. */
  containerProps: PropTypes.object,


  /** ARIA role for the cell-container.  */
  containerRole: PropTypes.string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: PropTypes.object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: PropTypes.object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: PropTypes.number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: PropTypes.func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: PropTypes.number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: PropTypes.string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: PropTypes.bool,


  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  isScrollingOptOut: PropTypes.bool.isRequired,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: function noContentRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: PropTypes.func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: PropTypes.func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: PropTypes.number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** ARIA role for the grid element.  */
  role: PropTypes.string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Number of rows in grid.  */
  rowCount: PropTypes.number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Horizontal offset. */
  scrollLeft: PropTypes.number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: PropTypes.number.isRequired,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__["a" /* polyfill */])(Grid);
/* harmony default export */ __webpack_exports__["a"] = (Grid);
















/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(615), __esModule: true };

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(622), __esModule: true };

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}



/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(67);
var aFunction = __webpack_require__(233);
var SPECIES = __webpack_require__(41)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(139);
var invoke = __webpack_require__(1771);
var html = __webpack_require__(608);
var cel = __webpack_require__(352);
var global = __webpack_require__(49);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(176)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(67);
var isObject = __webpack_require__(112);
var newPromiseCapability = __webpack_require__(378);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_ScrollIndices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_ScrollIndices =  true ? null : {
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};



/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var AutoSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        {
          className: className,
          ref: this._setRef,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: PropTypes.func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: PropTypes.string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: PropTypes.number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: PropTypes.number,


  /** Disable dynamic :height property */
  disableHeight: PropTypes.bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: PropTypes.bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: PropTypes.string,


  /** Callback to be invoked on-resize */
  onResize: PropTypes.func.isRequired,


  /** Optional inline style */
  style: PropTypes.object
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51)))

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__ = __webpack_require__(1781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__["a"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a" /* default */]);


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellMeasureCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellMeasureCache =  true ? null : {
  hasFixedWidth: PropTypes.func.isRequired,
  hasFixedHeight: PropTypes.func.isRequired,
  has: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};



/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);











/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_7__Grid__["b" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": PropTypes.string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /** Optional CSS class name */
  className: PropTypes.string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: PropTypes.number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: function noRowsRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: PropTypes.func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: function rowRenderer() {
    return (typeof bpfrpt_proptype_RowRenderer === 'function' ? bpfrpt_proptype_RowRenderer.isRequired ? bpfrpt_proptype_RowRenderer.isRequired : bpfrpt_proptype_RowRenderer : PropTypes.shape(bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },


  /** Number of rows in list. */
  rowCount: PropTypes.number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of list */
  width: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (List);













/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(180);


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(180);


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'div',
    { className: className, role: 'row', style: style },
    columns
  );
}
defaultHeaderRowRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRowRendererParams;



/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: label },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], { key: 'SortIndicator', sortDirection: sortDirection }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRendererParams;



/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortDirection__ = __webpack_require__(246);





/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](
    'svg',
    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
    sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

SortIndicator.propTypes =  false ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;

  var a11yProps = {};

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({ event: event, index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      role: 'row',
      style: style }),
    columns
  );
}
defaultRowRenderer.propTypes =  true ? null : bpfrpt_proptype_RowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_RowRendererParams;



/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SortDirection__ = __webpack_require__(246);











/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _React$Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__["a" /* default */],
  defaultSortDirection: __WEBPACK_IMPORTED_MODULE_9__SortDirection__["a" /* default */].ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Column);
Column.propTypes =  false ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,

  /** Optional id to set on the column header */
  id: PropTypes.string,

  /** Header label for this column */
  label: PropTypes.node,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);












/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }), _this._registerChild = function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }
      _this._child = element;
      _this.updatePosition();
    }, _this._onChildScroll = function (_ref2) {
      var scrollTop = _ref2.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    }, _this._registerResizeListener = function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    }, _this._unregisterResizeListener = function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    }, _this._onResize = function () {
      _this.updatePosition();
    }, _this.__handleWindowScrollEvent = function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;


      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        var scrollOffset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollOffset */])(scrollElement);
        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });

        onScroll({
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });
      }
    }, _this.__resetIsScrolling = function () {
      _this.setState({
        isScrolling: false
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _state = this.state,
          height = _state.height,
          width = _state.width;


      var thisNode = this._child || __WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"](this);
      if (thisNode instanceof Element && scrollElement) {
        var offset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionOffset */])(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(scrollElement, this.props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;

      this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__["a" /* default */])();

      this.updatePosition(scrollElement);

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);
        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;


      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);

        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, prevScrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);
        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;
      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollTop = _state2.scrollTop,
          scrollLeft = _state2.scrollLeft,
          height = _state2.height,
          width = _state2.width;


      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }

    // Referenced by utils/onScroll


    // Referenced by utils/onScroll

  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
};
WindowScroller.propTypes =  true ? null : {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,


  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: PropTypes.func.isRequired,


  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
  onScroll: PropTypes.func.isRequired,


  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: PropTypes.oneOfType([PropTypes.any, function () {
    return (typeof Element === 'function' ? PropTypes.instanceOf(Element) : PropTypes.any).apply(this, arguments);
  }]),

  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Height used for server-side rendering */
  serverHeight: PropTypes.number.isRequired,


  /** Width used for server-side rendering */
  serverWidth: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = exports.Loader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _context = __webpack_require__(93);

var _context2 = _interopRequireDefault(_context);

var _events = __webpack_require__(1821);

var events = _interopRequireWildcard(_events);

var _deprecateComponent = __webpack_require__(1822);

var _deprecateComponent2 = _interopRequireDefault(_deprecateComponent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bind = events.createEventBinding('scroll', 'resize');

// https://material.io/guidelines/components/progress-activity.html#progress-activity-behavior
var Loader = exports.Loader = function Loader(_ref) {
  var className = _ref.className;
  return _react2['default'].createElement(
    'div',
    { className: className },
    'Loading...'
  );
};

Loader.displayName = 'Loader';
Loader.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InfiniteScroll', function (theme) {
  return {
    progress: {
      display: 'inline-block',
      paddingTop: theme.typography.rhythmByUnit(4),
      paddingBottom: theme.typography.rhythmByUnit(6),
      width: '100%',
      textAlign: 'center'
    }
  };
});

var InfiniteScroll = (_temp2 = _class = function (_PureComponent) {
  _inherits(InfiniteScroll, _PureComponent);

  function InfiniteScroll() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, InfiniteScroll);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call.apply(_ref2, [this].concat(args))), _this), _this.removeListener = function () {}, _this.addListener = function () {
      var scrollEl = _this.props.scrollEl;

      _this.removeListener();
      if (!scrollEl) return;
      _this.removeListener = bind(scrollEl, _this.scrollListener, {
        passive: true
      });
    }, _this.scrollListener = function () {
      var _this$props = _this.props,
          hasMore = _this$props.hasMore,
          loadMore = _this$props.loadMore,
          scrollEl = _this$props.scrollEl,
          threshold = _this$props.threshold,
          waitingForLoad = _this$props.waitingForLoad;

      // don't load more if there are no more items to load or we are
      // waiting

      if (!scrollEl || !hasMore || waitingForLoad) return;

      var offset = _this.getOffset();

      if (offset <= _this.getFullThreshold()) return;

      setTimeout(loadMore, 0);
      _this.removeListener();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.scrollListener();
        this.addListener();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.removeListener();
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var prevScrollEl = prevProps.scrollEL;
        var scrollEl = this.props.scrollEl;

        // same element, so move on

        if (prevScrollEl === scrollEl) return;

        // new scroll element add, so initialize
        if (!prevScrollEl) {
          this.scrollListener();
        }

        this.addListener();
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'getOffset',
    value: function () {
      function getOffset() {
        var scrollEl = this.props.scrollEl;

        return scrollEl !== _context2['default'] ? scrollEl.scrollTop + scrollEl.clientHeight : _context2['default'].scrollY + _context2['default'].innerHeight;
      }

      return getOffset;
    }()
  }, {
    key: 'getFullThreshold',
    value: function () {
      function getFullThreshold() {
        var _props = this.props,
            scrollEl = _props.scrollEl,
            threshold = _props.threshold;

        return scrollEl !== _context2['default'] ? scrollEl.scrollHeight - threshold : this.container ? this.container.clientHeight - threshold : Infinity;
      }

      return getFullThreshold;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            children = _props2.children,
            hasMore = _props2.hasMore,
            Loader = _props2.loader,
            loadMore = _props2.loadMore,
            scrollEl = _props2.scrollEl,
            threshold = _props2.threshold,
            waitingForLoad = _props2.waitingForLoad,
            other = _objectWithoutProperties(_props2, ['children', 'hasMore', 'loader', 'loadMore', 'scrollEl', 'threshold', 'waitingForLoad']);

        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          'div',
          _extends({}, other, { ref: function () {
              function ref(c) {
                return _this2.container = c;
              }

              return ref;
            }() }),
          children,
          hasMore && _react2['default'].createElement(Loader, { className: classes.progress, ref: function () {
              function ref(c) {
                return _this2.loader = c;
              }

              return ref;
            }() })
        );
      }

      return render;
    }()
  }]);

  return InfiniteScroll;
}(_react.PureComponent), _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * boolean indicating whether or not there is more content to be loaded
   */
  hasMore: _PropTypes2['default'].bool,
  /**
   * function called when more data is needed
   */
  loadMore: _PropTypes2['default'].func.isRequired,
  /**
   * the DOM reference of the container that needs infinite scrolling, if window isn't scrolling
   */
  scrollEl: _PropTypes2['default'].object,
  /**
   * the distance from the bottom of the container (in px) at which to call `loadMore`
   */
  threshold: _PropTypes2['default'].number,
  /**
   * the component to use as the loading indicator at the bottom of the list
   */
  loader: _PropTypes2['default'].func,
  /**
   * boolean indicating whether or not `loadMore` should be called
   */
  waitingForLoad: _PropTypes2['default'].bool
}, _class.defaultProps = {
  hasMore: false,
  threshold: 250,
  loader: Loader,
  scrollEl: _context2['default']
}, _temp2);


InfiniteScroll.displayName = 'InfiniteScroll';

exports['default'] = (0, _deprecateComponent2['default'])(InfiniteScroll, 'InfiniteScroll is deprecated, use InfiniteList instead');

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(406);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 686 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(688),
    toKey = __webpack_require__(199);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(70),
    isKey = __webpack_require__(380),
    stringToPath = __webpack_require__(840),
    toString = __webpack_require__(841);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1839),
    createBaseEach = __webpack_require__(1842);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var bool = _propTypes2.default.bool,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;
exports.default = shape({
  loginDate: string,
  ipAddress: string,
  currentIP: bool
});

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    objectOf = _propTypes2.default.objectOf;
exports.default = shape({
  action: string.isRequired,
  authUser: string,
  createdBy: string,
  createdDate: string,
  description: string,
  displayName: string.isRequired,
  eventData: objectOf(string).isRequired,
  eventType: string,
  recurring: objectOf(string),
  recurringDescription: string,
  schedule: string.isRequired,
  scheduleID: string,
  teamName: string,
  timezone: string,
  upcomingID: string
});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  trainingID: string,
  type: string,
  dependentFieldName: string,
  independentFieldNames: arrayOf(string),
  startDate: string,
  endDate: string,
  requestedBy: string,
  status: string
});

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserWatchListContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(89);

var _search = __webpack_require__(389);

var _session = __webpack_require__(117);

var _index = __webpack_require__(1899);

var _UserWatchListSelectors = __webpack_require__(1904);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_NUMBER_OF_RUNS_TO_SHOW = 5;

var UserWatchListContainer = exports.UserWatchListContainer = (_temp = _class = function (_PureComponent) {
  _inherits(UserWatchListContainer, _PureComponent);

  function UserWatchListContainer() {
    _classCallCheck(this, UserWatchListContainer);

    return _possibleConstructorReturn(this, (UserWatchListContainer.__proto__ || Object.getPrototypeOf(UserWatchListContainer)).apply(this, arguments));
  }

  _createClass(UserWatchListContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          getSearchResultList = _props.getSearchResultList,
          teamName = _props.teamName,
          username = _props.username;

      if (!UserWatchListContainer.HAS_COMPONENT_BEEN_LOADED) {
        getSearchResultList({
          teamName: teamName,
          username: username,
          limit: 300,
          participatingUsers: username,
          searchID: 'userWatchList',
          status: 'running',
          sort: 'displayName',
          type: 'runs'
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return !UserWatchListContainer.CACHED_USER_WATCH_LIST;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          onClick = _props2.onClick,
          userWatchListItems = _props2.userWatchListItems;


      if (UserWatchListContainer.CACHED_USER_WATCH_LIST) {
        return UserWatchListContainer.CACHED_USER_WATCH_LIST;
      }

      if (userWatchListItems) {
        UserWatchListContainer.HAS_COMPONENT_BEEN_LOADED = true;
        UserWatchListContainer.CACHED_USER_WATCH_LIST = this.renderUserWatchList(userWatchListItems, className, onClick);
        return UserWatchListContainer.CACHED_USER_WATCH_LIST;
      }

      return null;
    }
  }, {
    key: 'renderUserWatchList',
    value: function renderUserWatchList(userWatchListItems, className, onClick) {
      var _this2 = this;

      var userWatchListGroups = [];
      Object.values(userWatchListItems).forEach(function (process) {
        userWatchListGroups.push(_this2.renderWatchListForProcess(process, className, onClick));
      });
      return _react2.default.createElement(
        _index.UserWatchList,
        null,
        userWatchListGroups
      );
    }
  }, {
    key: 'renderWatchListForProcess',
    value: function renderWatchListForProcess(process, className, onClick) {
      var processDisplayName = process.processDisplayName,
          processID = process.processID,
          runsProp = process.runs;

      var numberOfRuns = Object.keys(runsProp).length;
      var numberOfRunsToShow = Math.min(numberOfRuns, MAX_NUMBER_OF_RUNS_TO_SHOW);
      var runs = Object.values(runsProp);

      return _react2.default.createElement(
        'div',
        { key: 'watchListProcess-' + processID },
        _react2.default.createElement(_index.UserWatchListProcessItem, _extends({
          href: encodeURI('/search?q=type:run ' + processDisplayName)
        }, { className: className, onClick: onClick, processDisplayName: processDisplayName })),
        runs.slice(0, numberOfRunsToShow).map(function (_ref, i) {
          var displayName = _ref.displayName,
              percentComplete = _ref.percentComplete,
              runID = _ref.runID;
          return _react2.default.createElement(_index.UserWatchListRunItem, _extends({
            href: '/pushbots/' + runID,
            key: 'watchListRun-' + runID,
            margin: i === numberOfRuns - 1,
            percentComplete: Math.floor(percentComplete * 100),
            runDisplayName: displayName
          }, { className: className, onClick: onClick }));
        }),
        numberOfRuns > MAX_NUMBER_OF_RUNS_TO_SHOW && _react2.default.createElement(_index.UserWatchListMoreItem, _extends({
          href: encodeURI('/search?q=type:run ' + processID)
        }, { className: className, onClick: onClick }))
      );
    }
  }]);

  return UserWatchListContainer;
}(_react.PureComponent), _class.displayName = 'UserWatchListContainer', _class.propTypes = {
  /**
   * Class to apply to the list items in the filter list
   */
  className: _react.PropTypes.string,
  /**
   *  Action to list the runs that a user is involved in
   */
  getSearchResultList: _react.PropTypes.func,
  /**
   * Click event to apply to the list items in the filter list
   */
  onClick: _react.PropTypes.func,
  /**
   * Current team name.
   */
  teamName: _react.PropTypes.string,
  /**
   * Current authed user's username.
   */
  username: _react.PropTypes.string,
  /**
   *  List Item for watch list child nodes
   */
  userWatchListItems: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    processDisplayName: _react.PropTypes.string,
    processID: _react.PropTypes.string,
    runs: _react.PropTypes.objectOf(_react.PropTypes.shape({
      displayName: _react.PropTypes.string,
      percentComplete: _react.PropTypes.number,
      runID: _react.PropTypes.string
    }))
  }))
}, _class.contextTypes = {
  styleManager: _react.PropTypes.object.isRequired
}, _class.HAS_COMPONENT_BEEN_LOADED = false, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    teamName: (0, _session.teamName)(state),
    username: (0, _session.username)(state),
    userWatchListItems: (0, _UserWatchListSelectors.userWatchListItemsSelector)(state)
  };
};

var mapDispatchToProps = {
  getSearchResultList: _search.getSearchResultList
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserWatchListContainer);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionRedirect = exports.releasePath = exports.redirectReferrer = exports.parseAuthenticationToken = exports.loggedIn = exports.loadRoute = exports.errorLoadingRoute = exports.createUrlFormatter = exports.checkAuthMethod = exports.authenticateUser = exports.authenticate = exports.anonymous = exports.isLoggedIn = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.Noop = Noop;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isomorphicFetch = __webpack_require__(503);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _path = __webpack_require__(149);

var _path2 = _interopRequireDefault(_path);

var _url = __webpack_require__(83);

var _url2 = _interopRequireDefault(_url);

var _browserHistory = __webpack_require__(182);

var _browserHistory2 = _interopRequireDefault(_browserHistory);

var _env = __webpack_require__(253);

var _subdomain = __webpack_require__(570);

var _subdomain2 = _interopRequireDefault(_subdomain);

var _env2 = __webpack_require__(35);

var _env3 = _interopRequireDefault(_env2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoggedIn = exports.isLoggedIn = function isLoggedIn(next, replace, done) {
  loggedIn().then(function (isLoggedIn) {
    if (!isLoggedIn) {
      var embeddedMode = JSON.parse(_env3.default.PUSHBOT_EMBEDDED_MODE);
      var pathname = embeddedMode ? '/auth' : '/login';
      _browserHistory2.default.push(pathname);
      return done();
    }
    done();
  });
};

var anonymous = exports.anonymous = isLoggedIn;

var authenticate = exports.authenticate = isLoggedIn;

var authenticateUser = exports.authenticateUser = isLoggedIn;

var checkAuthMethod = exports.checkAuthMethod = function checkAuthMethod(baseUrl, teamName, done) {
  // Fetch rather than dispatching the request to the store as
  // dispatching here causes the page to not load in a testing environment
  (0, _isomorphicFetch2.default)(baseUrl + '/teams/' + teamName + '/authinfo', {
    credentials: 'same-origin'
  }).then(function (response) {
    return response.json().then(function (data) {
      return done(null, data.method);
    }, function (err) {
      return done(err);
    });
  }, function (err) {
    return done(err);
  });
};

// eslint-disable-next-line no-unused-vars
var createUrlFormatter = exports.createUrlFormatter = function createUrlFormatter(userExp) {
  return function () {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var pathname = path.replace(/^\/alpha/, '').replace(/^\//, '');
    var urlObj = { search: search };
    return _url2.default.format(_extends({}, urlObj, { pathname: pathname }));
  };
};

var errorLoadingRoute = exports.errorLoadingRoute = function errorLoadingRoute(err) {
  console.error('Error loading a dynamic route', err);
};

var loadRoute = exports.loadRoute = function loadRoute(cb) {
  return function (module) {
    return cb(null, module.default);
  };
};

var loggedIn = exports.loggedIn = function loggedIn() {
  var teamName = (0, _subdomain2.default)();
  var baseUrl = (0, _env.url)(_env3.default);
  return (0, _isomorphicFetch2.default)(baseUrl + '/teams/' + teamName + '/users/me', {
    credentials: 'same-origin'
  }).then(function (response) {
    return response.ok;
  });
};

function Noop(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'container-fluid' },
    children
  );
}

Noop.displayName = 'Noop';

Noop.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

var parseAuthenticationToken = exports.parseAuthenticationToken = function parseAuthenticationToken() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$query = _ref2.query;

  _ref2$query = _ref2$query === undefined ? {} : _ref2$query;
  var username = _ref2$query.username,
      token = _ref2$query.token,
      action = _ref2.hash;
  return username && token ? { username: username, token: token } : {};
};

var redirectReferrer = exports.redirectReferrer = function redirectReferrer() {
  var basepath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  return function (next, replace) {
    var _next$location = next.location,
        location = _next$location === undefined ? {} : _next$location;
    var _location$query = location.query;
    _location$query = _location$query === undefined ? {} : _location$query;
    var _location$query$refer = _location$query.referrer,
        referrer = _location$query$refer === undefined ? '/' : _location$query$refer;

    replace({
      pathname: _path2.default.join(basepath, referrer),
      state: { referrer: location }
    });
  };
};

var releasePath = exports.releasePath = _env3.default.PUSHBOT_WEB_PATH !== '/' ? _env3.default.PUSHBOT_WEB_PATH : undefined;

var versionRedirect = exports.versionRedirect = function versionRedirect(_ref3, replace) {
  var pathname = _ref3.pathname,
      search = _ref3.search,
      userExp = _ref3.userExp;

  var createUrl = createUrlFormatter(userExp);

  var targetUrl = '' + pathname + search;
  var formattedUrl = createUrl(pathname, search);

  if (targetUrl !== formattedUrl) {
    replace(formattedUrl);
  }
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(727);

Object.defineProperty(exports, 'app', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_app).default;
  }
});

var _credential = __webpack_require__(788);

Object.defineProperty(exports, 'credential', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_credential).default;
  }
});

var _field = __webpack_require__(91);

Object.defineProperty(exports, 'field', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_field).default;
  }
});

var _file = __webpack_require__(381);

Object.defineProperty(exports, 'file', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_file).default;
  }
});

var _filter = __webpack_require__(1892);

Object.defineProperty(exports, 'filter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_filter).default;
  }
});

var _integration = __webpack_require__(789);

Object.defineProperty(exports, 'integration', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_integration).default;
  }
});

var _message = __webpack_require__(1893);

Object.defineProperty(exports, 'message', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_message).default;
  }
});

var _process = __webpack_require__(751);

Object.defineProperty(exports, 'process', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_process).default;
  }
});

var _step = __webpack_require__(722);

Object.defineProperty(exports, 'step', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_step).default;
  }
});

var _upcoming = __webpack_require__(691);

Object.defineProperty(exports, 'upcoming', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_upcoming).default;
  }
});

var _user = __webpack_require__(393);

Object.defineProperty(exports, 'user', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_user).default;
  }
});

var _userLogin = __webpack_require__(690);

Object.defineProperty(exports, 'userLogin', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_userLogin).default;
  }
});

var _table = __webpack_require__(1894);

Object.defineProperty(exports, 'table', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_table).default;
  }
});

var _tableRow = __webpack_require__(1895);

Object.defineProperty(exports, 'tableRow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tableRow).default;
  }
});

var _task = __webpack_require__(398);

Object.defineProperty(exports, 'task', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_task).default;
  }
});

var _team = __webpack_require__(1896);

Object.defineProperty(exports, 'team', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_team).default;
  }
});

var _run = __webpack_require__(790);

Object.defineProperty(exports, 'run', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_run).default;
  }
});

var _group = __webpack_require__(1897);

Object.defineProperty(exports, 'group', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_group).default;
  }
});

var _training = __webpack_require__(692);

Object.defineProperty(exports, 'training', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_training).default;
  }
});

var _predictor = __webpack_require__(1898);

Object.defineProperty(exports, 'predictor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_predictor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTitle = exports.DialogContentText = exports.DialogContent = exports.DialogActions = exports['default'] = undefined;

var _Dialog = __webpack_require__(773);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Dialog)['default'];
    }

    return get;
  }()
});

var _DialogActions2 = __webpack_require__(631);

var _DialogActions3 = _interopRequireDefault(_DialogActions2);

var _DialogContent2 = __webpack_require__(830);

var _DialogContent3 = _interopRequireDefault(_DialogContent2);

var _DialogContentText2 = __webpack_require__(1649);

var _DialogContentText3 = _interopRequireDefault(_DialogContentText2);

var _DialogTitle2 = __webpack_require__(632);

var _DialogTitle3 = _interopRequireDefault(_DialogTitle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.DialogActions = _DialogActions3['default'];
exports.DialogContent = _DialogContent3['default'];
exports.DialogContentText = _DialogContentText3['default'];
exports.DialogTitle = _DialogTitle3['default'];

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSideEffect = __webpack_require__(1602);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(1609);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__(18);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(1612);

var _PlainComponent = __webpack_require__(1613);

var _PlainComponent2 = _interopRequireDefault(_PlainComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HELMET_ATTRIBUTE = "data-react-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, _deepEqual2.default)(this.props, nextProps);
            }
        }, {
            key: "render",
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }], [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
            /**
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {String} title: "Title"
             * @param {String} defaultTitle: "Default Title"
             * @param {String} titleTemplate: "MySite.com - %s"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             */

        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        htmlAttributes: _react2.default.PropTypes.object,
        title: _react2.default.PropTypes.string,
        defaultTitle: _react2.default.PropTypes.string,
        titleTemplate: _react2.default.PropTypes.string,
        titleAttributes: _react2.default.PropTypes.object,
        base: _react2.default.PropTypes.object,
        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        onChangeClientState: _react2.default.PropTypes.func
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;


    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(_PlainComponent2.default);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDescriptor = exports.buildDescriptorMethod = exports.PropType = exports.Component = exports.NAMESPACE = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.findPropType = findPropType;
exports.describeComponent = describeComponent;
exports.content = content;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RDFTypes = __webpack_require__(1905);

var _reselect = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAMESPACE = exports.NAMESPACE = 'pb';

function findPropType(fn) {
  var propTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _propTypes2.default;

  for (var name in propTypes) {
    if (fn === propTypes[name]) {
      return { name: name, required: false };
    }
    if (fn === propTypes[name].isRequired) {
      return { name: name, required: true };
    }
  }
  return { name: fn.name || 'anonymous', required: false };
}

var Component = exports.Component = function (_Resource) {
  _inherits(Component, _Resource);

  function Component(name, options) {
    _classCallCheck(this, Component);

    var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, name, options));

    _this.typeOf(NAMESPACE + ':component');
    return _this;
  }

  return Component;
}(_RDFTypes.Resource);

var PropType = exports.PropType = function (_Resource2) {
  _inherits(PropType, _Resource2);

  function PropType(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PropType);

    var _this2 = _possibleConstructorReturn(this, (PropType.__proto__ || Object.getPrototypeOf(PropType)).call(this, name, options));

    var _options$fn = options.fn,
        fn = _options$fn === undefined ? function () {} : _options$fn,
        propTypes = options.propTypes;

    var _findPropType = findPropType(fn, propTypes),
        propName = _findPropType.name;

    _this2.property(name);
    _this2.typeOf(NAMESPACE + ':' + propName);
    return _this2;
  }

  return PropType;
}(_RDFTypes.Resource);

var buildDescriptorMethod = function buildDescriptorMethod(resource) {
  return function (method) {
    return (0, _reselect.createSelector)((0, _reselect.createSelector)(function (content) {
      return content;
    }, function (content, options) {
      return options;
    }, function (content, options) {
      return _extends({}, typeof options === 'function' ? { fn: options } : options, (typeof content === 'undefined' ? 'undefined' : _typeof(content)) !== 'object' ? { content: content } : content);
    }), function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var content = _ref.content,
          fn = _ref.fn,
          options = _objectWithoutProperties(_ref, ['content', 'fn']);

      return resource.clone().content(content)[method](fn, options);
    } // eslint-disable-line no-unexpected-multiline
    );
  };
};

exports.buildDescriptorMethod = buildDescriptorMethod;
var buildDescriptor = exports.buildDescriptor = function buildDescriptor(resource) {
  var builder = buildDescriptorMethod(resource);

  var fn = builder('toProps');
  fn.selector = builder('toSelector');
  fn.triple = builder('toTriple');
  return fn;
};

var mapPropTypes = function mapPropTypes(propTypes, options) {
  return Object.keys(propTypes).map(function (k) {
    return new PropType(k, _extends({
      fn: propTypes[k]
    }, options));
  }).reduce(function (o, p) {
    return _extends({}, o, _defineProperty({}, p.getName(), buildDescriptor(p)));
  }, {});
};

function describeComponent(name) {
  var propTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var component = new Component(name);

  var _options$meta = options.meta,
      meta = _options$meta === undefined ? {} : _options$meta,
      propTypeOptions = _objectWithoutProperties(options, ['meta']);

  return Object.assign(buildDescriptor(component), {
    props: mapPropTypes(_extends({}, propTypes, meta), propTypeOptions)
  });
}

function content(options) {
  return function (Component) {
    var _class, _temp;

    if (typeof Component !== 'function') {
      console.error('Expected Component to be a function, but recieved a ' + (typeof Component === 'undefined' ? 'undefined' : _typeof(Component)));
    }

    var displayName = Component.displayName || Component.name;

    if (typeof displayName !== 'string' || displayName.length === 0) {
      console.error('Expected displayName to be a string, but recieved a ' + (typeof displayName === 'undefined' ? 'undefined' : _typeof(displayName)));
    }

    var propTypes = Component.propTypes;

    var Content = (_temp = _class = function (_Component) {
      _inherits(Content, _Component);

      function Content() {
        _classCallCheck(this, Content);

        return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
      }

      return Content;
    }(Component), _class.contentTypes = describeComponent(displayName, propTypes, options), _temp);


    Content.displayName = displayName;

    return Content;
  };
}

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultValidators = exports.exactMatch = exports.pattern = exports.length = exports.boolean = exports.email = exports.required = exports.useValue = exports.validator = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.createValidators = createValidators;
exports.normalizeValidators = normalizeValidators;
exports.validate = validate;
exports.selectValidators = selectValidators;
exports.combinedValidators = combinedValidators;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isBoolean = __webpack_require__(1661);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isEmail = __webpack_require__(1662);

var _isEmail2 = _interopRequireDefault(_isEmail);

var _isEmpty = __webpack_require__(738);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isLength = __webpack_require__(1665);

var _isLength2 = _interopRequireDefault(_isLength);

var _isNil = __webpack_require__(777);

var _isNil2 = _interopRequireDefault(_isNil);

var _isPlainObject = __webpack_require__(1666);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _matches = __webpack_require__(1667);

var _matches2 = _interopRequireDefault(_matches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var passthrough = function passthrough(v) {
  return v;
};

var createErrorMessage = function createErrorMessage(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return typeof message === 'function' ? message(options) : message.toString();
};

var validator = function validator(fn, defaultMessage) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _options$message = options.message,
        message = _options$message === undefined ? defaultMessage : _options$message,
        others = _objectWithoutProperties(options, ['message']);

    var error = void 0;
    try {
      error = !fn(others);
    } catch (e) {
      message = message || e.toString();
      error = e;
    }
    return Object.assign({
      error: error,
      options: options
    }, error ? {
      errorMessage: createErrorMessage(message, others)
    } : {});
  };
};

exports.validator = validator;
var useValue = exports.useValue = function useValue(fn) {
  return function (_ref) {
    var value = _ref.value;
    return fn(value);
  };
};

var required = exports.required = validator(function (_ref2) {
  var required = _ref2.required,
      value = _ref2.value;
  return !required || required && (typeof value === 'string' ? !(0, _isEmpty2['default'])(value.trim()) : !(0, _isEmpty2['default'])(value));
}, 'Please enter a value');

var email = exports.email = validator(function (_ref3) {
  var value = _ref3.value;
  return value === '' || (0, _isEmail2['default'])(value);
}, 'Please enter a valid email address');

var boolean = exports.boolean = validator(useValue(function (v) {
  return (0, _isNil2['default'])(v) ? false : (0, _isBoolean2['default'])(v.toString());
}), 'Please enter a valid boolean value');

var length = exports.length = validator(function (_ref4) {
  var value = _ref4.value,
      min = _ref4.min,
      max = _ref4.max;
  return (0, _isLength2['default'])(value, { min: min, max: max });
}, function (_ref5) {
  var min = _ref5.min,
      max = _ref5.max;
  return (0, _isNil2['default'])(min) ? 'Please enter a value with a length of ' + max + ' or less' : (0, _isNil2['default'])(max) ? 'Please enter a value with a length of ' + min + ' or more' : 'Please enter a value with a length between ' + min + ' and ' + max;
});

var pattern = exports.pattern = validator(function (_ref6) {
  var pattern = _ref6.pattern,
      value = _ref6.value;
  return (0, _isNil2['default'])(pattern) ? true : (0, _matches2['default'])(value, pattern);
}, function (_ref7) {
  var pattern = _ref7.pattern;
  return 'Must match ' + pattern.toString();
});

var exactMatch = exports.exactMatch = validator(function (_ref8) {
  var exactMatch = _ref8.exactMatch,
      _ref8$children = _ref8.children,
      children = _ref8$children === undefined ? [] : _ref8$children,
      value = _ref8.value;

  if ((0, _isNil2['default'])(exactMatch) || exactMatch === false || (0, _isEmpty2['default'])(value)) return true;

  var values = _react2['default'].Children.map(children, function (_ref9) {
    var _ref9$props = _ref9.props;
    _ref9$props = _ref9$props === undefined ? {} : _ref9$props;
    var value = _ref9$props.value;
    return value;
  }).filter(function (value) {
    return !(0, _isNil2['default'])(value);
  });

  return values.length === 0 ? true : values.indexOf(value) !== -1;
}, useValue(function (value) {
  return value + ' is not a valid entry';
}));

var defaultValidators = exports.defaultValidators = {
  boolean: boolean,
  exactMatch: exactMatch,
  email: email,
  length: length,
  pattern: pattern,
  required: required
};

function createValidators() {
  var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : passthrough;

  var validators = cb(defaultValidators);

  if (!(0, _isPlainObject2['default'])(validators)) {
    throw 'Create validator must return an Object'; // eslint-disable-line no-throw-literal
  }

  Object.keys(validators).forEach(function (k) {
    if (typeof validators[k] !== 'function') throw 'Can not create validator ' + k + ', since it is not a function.'; // eslint-disable-line no-throw-literal
  });

  return validators;
}

function normalizeValidators(validators) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return args.filter(function (v) {
    return v !== undefined;
  }).reduce(function (o, v) {
    if (typeof v === 'function') return [].concat(_toConsumableArray(o), [v]);
    if (typeof v === 'string' && !!validators[v]) return [].concat(_toConsumableArray(o), [validators[v]]);
    if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) !== 'object') throw 'Unknown validator ' + v.toString(); // eslint-disable-line no-throw-literal
    if (v instanceof Array) return [].concat(_toConsumableArray(o), _toConsumableArray(normalizeValidators.apply(undefined, [validators].concat(_toConsumableArray(v)))));
    return [].concat(_toConsumableArray(o), _toConsumableArray(normalizeValidators.apply(undefined, [validators].concat(_toConsumableArray(Object.keys(v).filter(function (k) {
      return v[k];
    }))))));
  }, []);
}

function validate(validators, props) {
  var results = validators.reduce(function (o, fn) {
    var r = fn(props);
    return r instanceof Array ? [].concat(_toConsumableArray(o), _toConsumableArray(r)) : [].concat(_toConsumableArray(o), [r]);
  }, []);
  return results.filter(function (result) {
    return result.error;
  }).map(function (result) {
    return result.errorMessage;
  });
}

function selectValidators(validators) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var results = normalizeValidators.apply(undefined, [validators].concat(args));
  return function (props) {
    return validate(results, props);
  };
}

function combinedValidators() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var validators = normalizeValidators.apply(undefined, [{}].concat(args));
  return function (props) {
    return validators.map(function (v) {
      return v(props);
    });
  };
}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEmptyField = exports.isLiteralType = exports.isFileType = exports.TYPE = undefined;

__webpack_require__(745);

var TYPE = exports.TYPE = {
  ARRAY: 'array',
  BOOL: 'bool',
  BOOLEAN: 'boolean',
  CHOICE: 'choice',
  DATE: 'date',
  DATETIME: 'datetime',
  EMAIL: 'email',
  FILE: 'file',
  FLOAT: 'float',
  INT: 'int',
  LATLONG: 'latlong',
  JSON: 'json',
  MANY: 'many',
  NUMBER: 'number',
  OBJECT: 'object',
  PHOTO: 'photo',
  STRING: 'string',
  TABLE: 'table'
};

var isFileType = exports.isFileType = function isFileType(fieldType) {
  return fieldType === TYPE.FILE || fieldType === TYPE.PHOTO;
};

var isLiteralType = exports.isLiteralType = function isLiteralType(fieldType) {
  return fieldType === TYPE.BOOLEAN || fieldType === TYPE.NUMBER || fieldType === TYPE.STRING;
};

var createEmptyField = exports.createEmptyField = function createEmptyField() {
  return {
    type: TYPE.STRING
  };
};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_GROUPS_FAILURE = exports.GET_GROUPS_SUCCESS = exports.GET_GROUPS_REQUEST = exports.GET_GROUPS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getGroups = getGroups;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _url = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_GROUPS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_GROUPS = _api$buildTypes2[0],
    GET_GROUPS_REQUEST = _api$buildTypes2[1],
    GET_GROUPS_SUCCESS = _api$buildTypes2[2],
    GET_GROUPS_FAILURE = _api$buildTypes2[3];
exports.GET_GROUPS = GET_GROUPS;
exports.GET_GROUPS_REQUEST = GET_GROUPS_REQUEST;
exports.GET_GROUPS_SUCCESS = GET_GROUPS_SUCCESS;
exports.GET_GROUPS_FAILURE = GET_GROUPS_FAILURE;
function getGroups(_ref) {
  var teamName = _ref.teamName,
      _ref$archived = _ref.archived,
      archived = _ref$archived === undefined ? 'all' : _ref$archived,
      _ref$username = _ref.username,
      username = _ref$username === undefined ? null : _ref$username;

  var url = (0, _url.format)({
    pathname: '/teams/' + teamName + '/groups',
    query: { archived: archived, username: username }
  });

  return {
    type: GET_GROUPS,
    payload: {
      url: url,
      schema: _schemas.GROUP_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appNameFromAppID = undefined;
exports.appNameToIcon = appNameToIcon;
exports.makeConsistentName = makeConsistentName;

var _upperFirst = __webpack_require__(767);

var _upperFirst2 = _interopRequireDefault(_upperFirst);

var _isString = __webpack_require__(743);

var _isString2 = _interopRequireDefault(_isString);

var _Api = __webpack_require__(803);

var _Api2 = _interopRequireDefault(_Api);

var _Assignment = __webpack_require__(713);

var _Assignment2 = _interopRequireDefault(_Assignment);

var _Autodesk = __webpack_require__(1352);

var _Autodesk2 = _interopRequireDefault(_Autodesk);

var _AutomationAnywhere = __webpack_require__(1353);

var _AutomationAnywhere2 = _interopRequireDefault(_AutomationAnywhere);

var _Box = __webpack_require__(1354);

var _Box2 = _interopRequireDefault(_Box);

var _Brain = __webpack_require__(1355);

var _Brain2 = _interopRequireDefault(_Brain);

var _Calendar = __webpack_require__(734);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _CircleCI = __webpack_require__(1356);

var _CircleCI2 = _interopRequireDefault(_CircleCI);

var _Coupa = __webpack_require__(1357);

var _Coupa2 = _interopRequireDefault(_Coupa);

var _Company = __webpack_require__(1358);

var _Company2 = _interopRequireDefault(_Company);

var _CloudDownload = __webpack_require__(1359);

var _CloudDownload2 = _interopRequireDefault(_CloudDownload);

var _CloudUpload = __webpack_require__(1360);

var _CloudUpload2 = _interopRequireDefault(_CloudUpload);

var _CSV = __webpack_require__(1361);

var _CSV2 = _interopRequireDefault(_CSV);

var _Dayforce = __webpack_require__(1362);

var _Dayforce2 = _interopRequireDefault(_Dayforce);

var _DocuSign = __webpack_require__(1363);

var _DocuSign2 = _interopRequireDefault(_DocuSign);

var _Dropbox = __webpack_require__(1364);

var _Dropbox2 = _interopRequireDefault(_Dropbox);

var _Excel = __webpack_require__(1365);

var _Excel2 = _interopRequireDefault(_Excel);

var _Ephesoft = __webpack_require__(1366);

var _Ephesoft2 = _interopRequireDefault(_Ephesoft);

var _Eye = __webpack_require__(1367);

var _Eye2 = _interopRequireDefault(_Eye);

var _Face = __webpack_require__(804);

var _Face2 = _interopRequireDefault(_Face);

var _Fieldglass = __webpack_require__(1368);

var _Fieldglass2 = _interopRequireDefault(_Fieldglass);

var _File = __webpack_require__(1369);

var _File2 = _interopRequireDefault(_File);

var _Github = __webpack_require__(805);

var _Github2 = _interopRequireDefault(_Github);

var _Gmail = __webpack_require__(1370);

var _Gmail2 = _interopRequireDefault(_Gmail);

var _GoogleAnalytics = __webpack_require__(1371);

var _GoogleAnalytics2 = _interopRequireDefault(_GoogleAnalytics);

var _BigQuery = __webpack_require__(1372);

var _BigQuery2 = _interopRequireDefault(_BigQuery);

var _GoogleCalendar = __webpack_require__(1373);

var _GoogleCalendar2 = _interopRequireDefault(_GoogleCalendar);

var _GoogleDrive = __webpack_require__(1374);

var _GoogleDrive2 = _interopRequireDefault(_GoogleDrive);

var _GoogleSheets = __webpack_require__(1375);

var _GoogleSheets2 = _interopRequireDefault(_GoogleSheets);

var _Quickbooks = __webpack_require__(1376);

var _Quickbooks2 = _interopRequireDefault(_Quickbooks);

var _I9Advantage = __webpack_require__(1377);

var _I9Advantage2 = _interopRequireDefault(_I9Advantage);

var _Jira = __webpack_require__(1378);

var _Jira2 = _interopRequireDefault(_Jira);

var _JobDiva = __webpack_require__(1379);

var _JobDiva2 = _interopRequireDefault(_JobDiva);

var _Images = __webpack_require__(1380);

var _Images2 = _interopRequireDefault(_Images);

var _Invoices = __webpack_require__(1381);

var _Invoices2 = _interopRequireDefault(_Invoices);

var _Kafka = __webpack_require__(1382);

var _Kafka2 = _interopRequireDefault(_Kafka);

var _FormatListBulleted = __webpack_require__(806);

var _FormatListBulleted2 = _interopRequireDefault(_FormatListBulleted);

var _Lever = __webpack_require__(1383);

var _Lever2 = _interopRequireDefault(_Lever);

var _LocationOn = __webpack_require__(807);

var _LocationOn2 = _interopRequireDefault(_LocationOn);

var _Mail = __webpack_require__(808);

var _Mail2 = _interopRequireDefault(_Mail);

var _ManualStart = __webpack_require__(768);

var _ManualStart2 = _interopRequireDefault(_ManualStart);

var _MediaoceanPrisma = __webpack_require__(1384);

var _MediaoceanPrisma2 = _interopRequireDefault(_MediaoceanPrisma);

var _Message = __webpack_require__(1385);

var _Message2 = _interopRequireDefault(_Message);

var _Microsoft = __webpack_require__(1386);

var _Microsoft2 = _interopRequireDefault(_Microsoft);

var _MicrosoftDynamics = __webpack_require__(1387);

var _MicrosoftDynamics2 = _interopRequireDefault(_MicrosoftDynamics);

var _NavDataMagnetic = __webpack_require__(568);

var _NavDataMagnetic2 = _interopRequireDefault(_NavDataMagnetic);

var _Netsuite = __webpack_require__(1388);

var _Netsuite2 = _interopRequireDefault(_Netsuite);

var _Numbers = __webpack_require__(1389);

var _Numbers2 = _interopRequireDefault(_Numbers);

var _Okta = __webpack_require__(1390);

var _Okta2 = _interopRequireDefault(_Okta);

var _OracleSalesCloud = __webpack_require__(1391);

var _OracleSalesCloud2 = _interopRequireDefault(_OracleSalesCloud);

var _Oracle = __webpack_require__(1392);

var _Oracle2 = _interopRequireDefault(_Oracle);

var _Outlook = __webpack_require__(1393);

var _Outlook2 = _interopRequireDefault(_Outlook);

var _Paylocity = __webpack_require__(1394);

var _Paylocity2 = _interopRequireDefault(_Paylocity);

var _Pdf = __webpack_require__(1395);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _PipeDrive = __webpack_require__(1396);

var _PipeDrive2 = _interopRequireDefault(_PipeDrive);

var _PowerBI = __webpack_require__(1397);

var _PowerBI2 = _interopRequireDefault(_PowerBI);

var _PowerPoint = __webpack_require__(1398);

var _PowerPoint2 = _interopRequireDefault(_PowerPoint);

var _Pushbot = __webpack_require__(1399);

var _Pushbot2 = _interopRequireDefault(_Pushbot);

var _Public = __webpack_require__(809);

var _Public2 = _interopRequireDefault(_Public);

var _S = __webpack_require__(1400);

var _S2 = _interopRequireDefault(_S);

var _SalesForce = __webpack_require__(1401);

var _SalesForce2 = _interopRequireDefault(_SalesForce);

var _Sentiment = __webpack_require__(1402);

var _Sentiment2 = _interopRequireDefault(_Sentiment);

var _ServiceNow = __webpack_require__(1403);

var _ServiceNow2 = _interopRequireDefault(_ServiceNow);

var _Sharepoint = __webpack_require__(1404);

var _Sharepoint2 = _interopRequireDefault(_Sharepoint);

var _SlackMarkWeb = __webpack_require__(1405);

var _SlackMarkWeb2 = _interopRequireDefault(_SlackMarkWeb);

var _Sterling = __webpack_require__(1406);

var _Sterling2 = _interopRequireDefault(_Sterling);

var _Stripe = __webpack_require__(1407);

var _Stripe2 = _interopRequireDefault(_Stripe);

var _SuccessFactors = __webpack_require__(1408);

var _SuccessFactors2 = _interopRequireDefault(_SuccessFactors);

var _Sso = __webpack_require__(1409);

var _Sso2 = _interopRequireDefault(_Sso);

var _Text = __webpack_require__(810);

var _Text2 = _interopRequireDefault(_Text);

var _Trello = __webpack_require__(1410);

var _Trello2 = _interopRequireDefault(_Trello);

var _Trigger = __webpack_require__(1411);

var _Trigger2 = _interopRequireDefault(_Trigger);

var _UiPath = __webpack_require__(1412);

var _UiPath2 = _interopRequireDefault(_UiPath);

var _Web = __webpack_require__(769);

var _Web2 = _interopRequireDefault(_Web);

var _Word = __webpack_require__(1413);

var _Word2 = _interopRequireDefault(_Word);

var _Workday = __webpack_require__(1414);

var _Workday2 = _interopRequireDefault(_Workday);

var _Wrike = __webpack_require__(1415);

var _Wrike2 = _interopRequireDefault(_Wrike);

var _Xml = __webpack_require__(1416);

var _Xml2 = _interopRequireDefault(_Xml);

var _YouTube = __webpack_require__(1417);

var _YouTube2 = _interopRequireDefault(_YouTube);

var _Zendesk = __webpack_require__(1418);

var _Zendesk2 = _interopRequireDefault(_Zendesk);

var _Zoom = __webpack_require__(1419);

var _Zoom2 = _interopRequireDefault(_Zoom);

var _Handlebars = __webpack_require__(744);

var _Handlebars2 = _interopRequireDefault(_Handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO API should return associated icon data
function appNameToIcon(appName, appID) {
  if ((0, _isString2.default)(appID) && !appName) {
    appName = appID.split('/')[0];
  }
  switch (appName) {
    case 'automation-anywhere':
      return _AutomationAnywhere2.default;
    case 'autodesk':
      return _Autodesk2.default;
    case 'aws':
      return _Assignment2.default;
    case 'azure':
    case 'azure-blobstorage':
      return _Microsoft2.default;
    case 'box':
      return _Box2.default;
    case 'circleci':
      return _CircleCI2.default;
    case 'cognitive':
      return _Brain2.default;
    case 'coupa':
      return _Coupa2.default;
    case 'csv':
      return _CSV2.default;
    case 'dates':
      return _Calendar2.default;
    case 'dayforce':
      return _Dayforce2.default;
    case 'docusign':
      return _DocuSign2.default;
    case 'dropbox':
      return _Dropbox2.default;
    case 'email':
      return _Mail2.default;
    case 'ephesoft':
      return _Ephesoft2.default;
    case 'excel':
      return _Excel2.default;
    case 'field':
      return _Handlebars2.default;
    case 'fieldglass':
      return _Fieldglass2.default;
    case 'files':
      return _File2.default;
    case 'fullcontact':
      switch (appID) {
        case 'fullcontact/company-lookup/v1':
          return _Company2.default;
        default:
          return _Face2.default;
      }
    case 'github':
      return _Github2.default;
    case 'gmail':
      return _Gmail2.default;
    case 'google-api':
      switch (appID) {
        case 'google-api/detect-language/v1':
          return _Public2.default;
        case 'google-api/sentiment/v1':
          return _Sentiment2.default;
        case 'google-api/vision/v1':
          return _Eye2.default;
        case 'google-api/vision/v2':
          return _Eye2.default;
        default:
          return _Trigger2.default;
      }
    case 'google-analytics':
      return _GoogleAnalytics2.default;
    case 'google-bigquery':
      return _BigQuery2.default;
    case 'google-calendar':
      return _GoogleCalendar2.default;
    case 'google':
      switch (appID) {
        case 'google-sheets/append/v1':
        case 'google/append/v1':
          return _GoogleSheets2.default;
        case 'google/detect-language/v1':
          return _Public2.default;
        case 'google/sentiment/v1':
          return _Sentiment2.default;
        case 'google/vision/v1':
          return _Eye2.default;
        default:
          return _GoogleDrive2.default;
      }
    case 'i9-advantage':
      return _I9Advantage2.default;
    case 'jira':
      return _Jira2.default;
    case 'jobdiva':
      return _JobDiva2.default;
    case 'images':
      return _Images2.default;
    case 'invoices':
      return _Invoices2.default;
    case 'kafka':
      return _Kafka2.default;
    case 'lever':
      return _Lever2.default;
    case 'list':
      return _FormatListBulleted2.default;
    case 'mediaocean-prisma':
      return _MediaoceanPrisma2.default;
    case 'netsuite':
      return _Netsuite2.default;
    case 'numbers':
      return _Numbers2.default;
    case 'okta':
      return _Okta2.default;
    case 'oracle':
      return _Oracle2.default;
    case 'oracle-sales-cloud':
      return _OracleSalesCloud2.default;
    case 'outlook':
      return _Outlook2.default;
    case 'dynamics':
      return _MicrosoftDynamics2.default;
    case 'parse':
      return _LocationOn2.default;
    case 'paylocity':
      return _Paylocity2.default;
    case 'pdf':
      return _Pdf2.default;
    case 'pipedrive':
      return _PipeDrive2.default;
    case 'powerpoint':
      return _PowerPoint2.default;
    case 'powerbi':
      return _PowerBI2.default;
    case 'pushbot':
      switch (appID) {
        case 'pushbot/make-prediction/v1':
          return _Handlebars2.default;
        case 'pushbot/set-text-field/v1':
          return _Handlebars2.default;
        case 'pushbot/set-decimal-value/v1':
          return _Handlebars2.default;
        case 'pushbot/set-integer-value/v1':
          return _Handlebars2.default;
        default:
          return _Pushbot2.default;
      }
    case 'quickbooks':
      return _Quickbooks2.default;
    case 's3':
      return _S2.default;
    case 'salesforce':
      return _SalesForce2.default;
    case 'sap-successfactors':
      return _SuccessFactors2.default;
    case 'sftp':
      switch (appID) {
        case 'sftp/upload/v1':
        case 'sftp/upload/v2':
          return _CloudUpload2.default;
        case 'sftp/download/v1':
        case 'sftp/download/v2':
          return _CloudDownload2.default;
        default:
          return _CloudUpload2.default;
      }
    case 'service-now':
      return _ServiceNow2.default;
    case 'singleSignOn':
      return _Sso2.default;
    case 'slack':
      return _SlackMarkWeb2.default;
    case 'sharepoint':
      return _Sharepoint2.default;
    case 'sms':
      return _Message2.default;
    case 'sterling':
      return _Sterling2.default;
    case 'stripe':
      return _Stripe2.default;
    case 'table':
      return _NavDataMagnetic2.default;
    case 'tables':
      return _NavDataMagnetic2.default;
    case 'text':
      return _Text2.default;
    case 'trello':
      return _Trello2.default;
    case 'uipath':
      return _UiPath2.default;
    case 'web-api':
      return _Api2.default;
    case 'word':
      return _Word2.default;
    case 'workday':
      return _Workday2.default;
    case 'xml':
      return _Xml2.default;
    case 'youtube':
      return _YouTube2.default;
    case 'zendesk':
      return _Zendesk2.default;
    case 'zoom':
      return _Zoom2.default;
    case 'scheduled':
      return _Calendar2.default;
    case 'web':
      return _Public2.default;
    case 'webhook':
      return _Api2.default;
    case 'wrike':
      return _Wrike2.default;
    case 'webform':
    case 'triggers': // TODO: Clean this up, should only be "webform"
    case 'browser-automation':
      return _Web2.default;
    case 'manual':
      return _ManualStart2.default;
    default:
      return _Trigger2.default;
  }
}

var appNameFromAppID = exports.appNameFromAppID = function appNameFromAppID(appID) {
  return appID.slice(0, appID.indexOf('/'));
};

function makeConsistentName(appName, displayName) {
  return displayName.indexOf(': ') !== -1 ? displayName : (0, _upperFirst2.default)(appName) + ': ' + displayName;
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformSearchQuery = exports.transformSearch = exports.omitSurroundingQuotes = exports.UNIVERSAL_SEARCH_OPERATORS = exports.SEARCH_STATUS = exports.SEARCH_TYPE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pipe = __webpack_require__(759);

var _pipe2 = _interopRequireDefault(_pipe);

var _url = __webpack_require__(31);

var _status = __webpack_require__(724);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SEARCH_TYPE = exports.SEARCH_TYPE = {
  process: 'processes',
  run: 'runs',
  table: 'tables',
  task: 'tasks'
};

// Pending api support
var SEARCH_STATUS = exports.SEARCH_STATUS = {
  incomplete: _status.INCOMPLETE_STATUSES.join(','),
  complete: _status.COMPLETE_STATUSES.join(',')
};

var UNIVERSAL_SEARCH_OPERATORS = exports.UNIVERSAL_SEARCH_OPERATORS = ['assignee', 'category', 'is', 'owner', 'pageKey', 'participatingUsers', 'sort', 'type'].concat(_toConsumableArray(Object.keys(SEARCH_TYPE)));

/**
 * Helper functions
 */

var joinIfArray = function joinIfArray(v) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  return Array.isArray(v) ? v.join(separator) : v;
};

// Creates a function that takes an object and renames a key when the key is present
// Performs Array.join when value is an array
var aliasOrJoinProperty = function aliasOrJoinProperty(key) {
  var newKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : key;
  return function (obj) {
    var value = obj[key],
        rest = _objectWithoutProperties(obj, [key]);

    if (value === undefined) {
      return obj;
    } else {
      return _extends({}, rest, _defineProperty({}, newKey, joinIfArray(value)));
    }
  };
};

var omitSurroundingQuotes = exports.omitSurroundingQuotes = function omitSurroundingQuotes(s) {
  var last = s.length - 1;
  return s.charAt(0) === '"' && s.charAt(last) === '"' ? s.slice(1, last) : s;
};

/**
 * Search transform functions
 */

var transformSort = function transformSort(_ref) {
  var sort = _ref.sort,
      search = _objectWithoutProperties(_ref, ['sort']);

  if (sort) {
    return _extends({}, search, {
      sort: joinIfArray(sort).replace(/-/g, ':')
    });
  } else {
    return search;
  }
};

var transformExplicitType = function transformExplicitType(_ref2) {
  var typeProp = _ref2.type,
      search = _objectWithoutProperties(_ref2, ['type']);

  if (typeProp) {
    return _extends({}, search, {
      types: typeProp.indexOf(',') !== -1 ? typeProp.split(',').map(function (type) {
        return SEARCH_TYPE[type];
      }).join(',') : SEARCH_TYPE[typeProp]
    });
  } else {
    return search;
  }
};

var transformImplicitType = function transformImplicitType(search) {
  return Object.keys(SEARCH_TYPE).reduce(function (search, type) {
    if (search.hasOwnProperty(type)) {
      var typeText = search[type],
          rest = _objectWithoutProperties(search, [type]);

      return _extends({}, rest, {
        types: [search.types, SEARCH_TYPE[type]].filter(Boolean).join(','),
        q: [search.q, typeText].filter(Boolean).join(' ')
      });
    } else {
      return search;
    }
  }, search);
};

var transformText = function transformText(_ref3) {
  var textProp = _ref3.text,
      search = _objectWithoutProperties(_ref3, ['text']);

  if (textProp) {
    var text = search.type || search.types ? omitSurroundingQuotes(textProp) : textProp;
    return _extends({}, search, {
      q: [search.q, text].filter(Boolean).join(' ')
    });
  } else {
    return search;
  }
};

var transformType = (0, _pipe2.default)(transformExplicitType, transformImplicitType);
var transformAssignee = aliasOrJoinProperty('assignee', 'assignedTo');
var transformIs = aliasOrJoinProperty('is', 'status');
var transformPageKey = aliasOrJoinProperty('pageKey', 'pageToken');
var transformOwner = aliasOrJoinProperty('owner');
var omitUnneededProps = function omitUnneededProps(_ref4) {
  var exclude = _ref4.exclude,
      offsets = _ref4.offsets,
      search = _objectWithoutProperties(_ref4, ['exclude', 'offsets']);

  return search;
};
var maybeUseArgument = function maybeUseArgument(o) {
  return o == null ? {} : o;
};

var transformSearch = exports.transformSearch = (0, _pipe2.default)(maybeUseArgument, omitUnneededProps, transformPageKey, transformIs, transformAssignee, transformOwner, transformType, transformSort, transformText);

var parseSearch = function parseSearch(search) {
  return (0, _url.parseSearch)(search, { keywords: UNIVERSAL_SEARCH_OPERATORS });
};

var transformSearchQuery = exports.transformSearchQuery = (0, _pipe2.default)(parseSearch, transformSearch);

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withEmbeddedMode;

var _recompose = __webpack_require__(385);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * If embedded mode is enabled call map function
 */
function withEmbeddedMode(map) {
  return (0, _recompose.withProps)(function (props) {
    try {
      var embeddedMode = JSON.parse(_env2.default.PUSHBOT_EMBEDDED_MODE);
      return embeddedMode ? map(props) : props;
    } catch (e) {
      return props;
    }
  });
}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_TRIGGERS_FOR_PROCESS_FAILURE = exports.GET_TRIGGERS_FOR_PROCESS_SUCCESS = exports.GET_TRIGGERS_FOR_PROCESS_REQUEST = exports.GET_TRIGGERS_FOR_PROCESS = exports.GET_TRIGGERS_FAILURE = exports.GET_TRIGGERS_SUCCESS = exports.GET_TRIGGERS_REQUEST = exports.GET_TRIGGERS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTriggers = getTriggers;
exports.getTriggersForProcess = getTriggersForProcess;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_TRIGGERS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TRIGGERS = _api$buildTypes2[0],
    GET_TRIGGERS_REQUEST = _api$buildTypes2[1],
    GET_TRIGGERS_SUCCESS = _api$buildTypes2[2],
    GET_TRIGGERS_FAILURE = _api$buildTypes2[3];
exports.GET_TRIGGERS = GET_TRIGGERS;
exports.GET_TRIGGERS_REQUEST = GET_TRIGGERS_REQUEST;
exports.GET_TRIGGERS_SUCCESS = GET_TRIGGERS_SUCCESS;
exports.GET_TRIGGERS_FAILURE = GET_TRIGGERS_FAILURE;
function getTriggers(_ref) {
  var teamName = _ref.teamName;

  return {
    type: GET_TRIGGERS,
    payload: {
      url: '/teams/' + teamName + '/triggers',
      schema: _schemas.TRIGGER_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('GET_TRIGGERS_FOR_PROCESS'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var GET_TRIGGERS_FOR_PROCESS = _api$buildTypes4[0],
    GET_TRIGGERS_FOR_PROCESS_REQUEST = _api$buildTypes4[1],
    GET_TRIGGERS_FOR_PROCESS_SUCCESS = _api$buildTypes4[2],
    GET_TRIGGERS_FOR_PROCESS_FAILURE = _api$buildTypes4[3];
exports.GET_TRIGGERS_FOR_PROCESS = GET_TRIGGERS_FOR_PROCESS;
exports.GET_TRIGGERS_FOR_PROCESS_REQUEST = GET_TRIGGERS_FOR_PROCESS_REQUEST;
exports.GET_TRIGGERS_FOR_PROCESS_SUCCESS = GET_TRIGGERS_FOR_PROCESS_SUCCESS;
exports.GET_TRIGGERS_FOR_PROCESS_FAILURE = GET_TRIGGERS_FOR_PROCESS_FAILURE;
function getTriggersForProcess(_ref2) {
  var teamName = _ref2.teamName,
      processID = _ref2.processID;

  return {
    type: GET_TRIGGERS_FOR_PROCESS,
    payload: {
      url: '/teams/' + teamName + '/processes/' + processID + '/triggers',
      schema: _schemas.TRIGGER_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFlattenSelector = exports.flattenFormat = exports.createReducerSelector = exports.createPropertySelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reselect = __webpack_require__(33);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var asFunction = function asFunction(v) {
  return typeof v === 'function' ? v : function () {
    return v;
  };
};
var isArray = function isArray(v) {
  return v instanceof Array;
};
var asArray = function asArray(v) {
  return isArray(v) ? v : v === undefined ? [] : [v];
};
var safeSelect = function safeSelect() {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var k = arguments[1];
  return o !== null ? o[k] : undefined;
};

/**
 * Provides a safe way to select a property from a selector that returns an object
 */
var createPropertySelector = exports.createPropertySelector = function createPropertySelector(obj, prop) {
  return (0, _reselect.createSelector)(obj, asFunction(prop), function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var prop = arguments[1];

    var result = safeSelect(asArray(obj).reduce(function (o, obj) {
      var v = safeSelect(obj, prop);
      if (v !== undefined) {
        o[prop] = [].concat(_toConsumableArray(asArray(o[prop])), [v]);
      }
      return o;
    }, {}), prop);
    return result === undefined || isArray(obj) ? result : result.shift();
  });
};

/**
 * Provides a safe way to map a list by a property
 */
var createReducerSelector = exports.createReducerSelector = function createReducerSelector(obj, prop) {
  return (0, _reselect.createSelector)(obj, asFunction(prop), function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var prop = arguments[1];
    return asArray(obj).reduce(function (o, obj) {
      try {
        if (obj === undefined || obj[prop] === undefined) return o;
        o[obj[prop]] = obj;
      } catch (e) {}
      return o;
    }, {});
  });
};

var safeKey = function safeKey(key) {
  return (/\W/.test(key) ? '[' + JSON.stringify(key) + ']' : isNaN(parseInt(key)) ? '.' + key : '[' + key + ']'
  );
};

var flattenFormat = exports.flattenFormat = function flattenFormat(key, parent) {
  return parent ? '' + parent + safeKey(key) : key;
};
var flatten = function flatten(object) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$formatter = _ref.formatter,
      formatter = _ref$formatter === undefined ? flattenFormat : _ref$formatter,
      _ref$parent = _ref.parent,
      parent = _ref$parent === undefined ? false : _ref$parent,
      _ref$filter = _ref.filter,
      filter = _ref$filter === undefined ? function () {
    return true;
  } : _ref$filter;

  return !object || (typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object' ? {} : Object.keys(object).reduce(function (o, k) {
    return _extends({}, o, filter(object[k], k, parent) ? _defineProperty({}, formatter(k, parent), object[k]) : {}, _typeof(object[k]) === 'object' ? flatten(object[k], {
      formatter: formatter,
      filter: filter,
      parent: formatter(k, parent)
    }) : {});
  }, {});
};

var createFlattenSelector = exports.createFlattenSelector = function createFlattenSelector(selector, options) {
  return (0, _reselect.createSelector)(selector, function () {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return flatten(values, options);
  });
};

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(325);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_TABLE_PROCESSES_FAILURE = exports.GET_TABLE_PROCESSES_SUCCESS = exports.GET_TABLE_PROCESSES_REQUEST = exports.GET_TABLE_PROCESSES = exports.ADD_TABLE_COLUMN_FAILURE = exports.ADD_TABLE_COLUMN_SUCCESS = exports.ADD_TABLE_COLUMN_REQUEST = exports.ADD_TABLE_COLUMN = exports.APPEND_TO_TABLE_FAILURE = exports.APPEND_TO_TABLE_SUCCESS = exports.APPEND_TO_TABLE_REQUEST = exports.APPEND_TO_TABLE = exports.REPLACE_TABLE_FAILURE = exports.REPLACE_TABLE_SUCCESS = exports.REPLACE_TABLE_REQUEST = exports.REPLACE_TABLE = exports.EXPORT_TABLE_FAILURE = exports.EXPORT_TABLE_SUCCESS = exports.EXPORT_TABLE_REQUEST = exports.EXPORT_TABLE = exports.IMPORT_TABLE_FAILURE = exports.IMPORT_TABLE_SUCCESS = exports.IMPORT_TABLE_REQUEST = exports.IMPORT_TABLE = exports.updateTable = exports.UPDATE_TABLE_FAILURE = exports.UPDATE_TABLE_SUCCESS = exports.UPDATE_TABLE_REQUEST = exports.UPDATE_TABLE = exports.ADD_TABLE_FAILURE = exports.ADD_TABLE_SUCCESS = exports.ADD_TABLE_REQUEST = exports.ADD_TABLE = exports.GET_TABLE_FAILURE = exports.GET_TABLE_SUCCESS = exports.GET_TABLE_REQUEST = exports.GET_TABLE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTable = getTable;
exports.addTable = addTable;
exports.importTable = importTable;
exports.exportTable = exportTable;
exports.replaceTable = replaceTable;
exports.appendToTable = appendToTable;
exports.addTableColumn = addTableColumn;
exports.getTableProcesses = getTableProcesses;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_TABLE'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TABLE = _api$buildTypes2[0],
    GET_TABLE_REQUEST = _api$buildTypes2[1],
    GET_TABLE_SUCCESS = _api$buildTypes2[2],
    GET_TABLE_FAILURE = _api$buildTypes2[3];
exports.GET_TABLE = GET_TABLE;
exports.GET_TABLE_REQUEST = GET_TABLE_REQUEST;
exports.GET_TABLE_SUCCESS = GET_TABLE_SUCCESS;
exports.GET_TABLE_FAILURE = GET_TABLE_FAILURE;
function getTable(_ref) {
  var teamName = _ref.teamName,
      tableID = _ref.tableID;

  return {
    type: GET_TABLE,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID,
      schema: _schemas.TABLE,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_TABLE'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_TABLE = _api$buildTypes4[0],
    ADD_TABLE_REQUEST = _api$buildTypes4[1],
    ADD_TABLE_SUCCESS = _api$buildTypes4[2],
    ADD_TABLE_FAILURE = _api$buildTypes4[3];
exports.ADD_TABLE = ADD_TABLE;
exports.ADD_TABLE_REQUEST = ADD_TABLE_REQUEST;
exports.ADD_TABLE_SUCCESS = ADD_TABLE_SUCCESS;
exports.ADD_TABLE_FAILURE = ADD_TABLE_FAILURE;
function addTable(_ref2) {
  var teamName = _ref2.teamName,
      _ref2$table = _ref2.table,
      table = _ref2$table === undefined ? {} : _ref2$table;

  return {
    type: ADD_TABLE,
    payload: {
      url: '/teams/' + teamName + '/tables',
      schema: _schemas.TABLE,
      options: {
        method: 'POST',
        body: table
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_TABLE'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_TABLE = _api$buildTypes6[0],
    UPDATE_TABLE_REQUEST = _api$buildTypes6[1],
    UPDATE_TABLE_SUCCESS = _api$buildTypes6[2],
    UPDATE_TABLE_FAILURE = _api$buildTypes6[3];
exports.UPDATE_TABLE = UPDATE_TABLE;
exports.UPDATE_TABLE_REQUEST = UPDATE_TABLE_REQUEST;
exports.UPDATE_TABLE_SUCCESS = UPDATE_TABLE_SUCCESS;
exports.UPDATE_TABLE_FAILURE = UPDATE_TABLE_FAILURE;
var updateTable = exports.updateTable = function updateTable(_ref3) {
  var teamName = _ref3.teamName,
      tableID = _ref3.tableID,
      _ref3$table = _ref3.table,
      table = _ref3$table === undefined ? {} : _ref3$table;
  return {
    type: UPDATE_TABLE,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID,
      schema: _schemas.TABLE,
      options: {
        method: 'PUT',
        body: table
      }
    }
  };
};

var _api$buildTypes7 = _api2.default.buildTypes('IMPORT_TABLE'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var IMPORT_TABLE = _api$buildTypes8[0],
    IMPORT_TABLE_REQUEST = _api$buildTypes8[1],
    IMPORT_TABLE_SUCCESS = _api$buildTypes8[2],
    IMPORT_TABLE_FAILURE = _api$buildTypes8[3];
exports.IMPORT_TABLE = IMPORT_TABLE;
exports.IMPORT_TABLE_REQUEST = IMPORT_TABLE_REQUEST;
exports.IMPORT_TABLE_SUCCESS = IMPORT_TABLE_SUCCESS;
exports.IMPORT_TABLE_FAILURE = IMPORT_TABLE_FAILURE;
function importTable(_ref4) {
  var teamName = _ref4.teamName,
      body = _ref4.body;

  return {
    type: IMPORT_TABLE,
    payload: {
      url: '/teams/' + teamName + '/tables/import',
      schema: _schemas.TABLE,
      options: {
        method: 'POST',
        body: body
      }
    }
  };
}

var _api$buildTypes9 = _api2.default.buildTypes('EXPORT_TABLE'),
    _api$buildTypes10 = _slicedToArray(_api$buildTypes9, 4);

var EXPORT_TABLE = _api$buildTypes10[0],
    EXPORT_TABLE_REQUEST = _api$buildTypes10[1],
    EXPORT_TABLE_SUCCESS = _api$buildTypes10[2],
    EXPORT_TABLE_FAILURE = _api$buildTypes10[3];
exports.EXPORT_TABLE = EXPORT_TABLE;
exports.EXPORT_TABLE_REQUEST = EXPORT_TABLE_REQUEST;
exports.EXPORT_TABLE_SUCCESS = EXPORT_TABLE_SUCCESS;
exports.EXPORT_TABLE_FAILURE = EXPORT_TABLE_FAILURE;
function exportTable(_ref5) {
  var teamName = _ref5.teamName,
      tableID = _ref5.tableID,
      exportType = _ref5.exportType;

  return {
    type: EXPORT_TABLE,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID + '/export',
      schema: _schemas.FILE,
      options: {
        method: 'POST',
        body: { exportType: exportType }
      }
    }
  };
}

var _api$buildTypes11 = _api2.default.buildTypes('REPLACE_TABLE'),
    _api$buildTypes12 = _slicedToArray(_api$buildTypes11, 4);

var REPLACE_TABLE = _api$buildTypes12[0],
    REPLACE_TABLE_REQUEST = _api$buildTypes12[1],
    REPLACE_TABLE_SUCCESS = _api$buildTypes12[2],
    REPLACE_TABLE_FAILURE = _api$buildTypes12[3];
exports.REPLACE_TABLE = REPLACE_TABLE;
exports.REPLACE_TABLE_REQUEST = REPLACE_TABLE_REQUEST;
exports.REPLACE_TABLE_SUCCESS = REPLACE_TABLE_SUCCESS;
exports.REPLACE_TABLE_FAILURE = REPLACE_TABLE_FAILURE;
function replaceTable(_ref6) {
  var teamName = _ref6.teamName,
      tableID = _ref6.tableID,
      body = _ref6.body;

  return {
    type: REPLACE_TABLE,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID + '/replace',
      schema: _schemas.TABLE,
      options: {
        method: 'POST',
        body: body
      }
    }
  };
}

var _api$buildTypes13 = _api2.default.buildTypes('APPEND_TO_TABLE'),
    _api$buildTypes14 = _slicedToArray(_api$buildTypes13, 4);

var APPEND_TO_TABLE = _api$buildTypes14[0],
    APPEND_TO_TABLE_REQUEST = _api$buildTypes14[1],
    APPEND_TO_TABLE_SUCCESS = _api$buildTypes14[2],
    APPEND_TO_TABLE_FAILURE = _api$buildTypes14[3];
exports.APPEND_TO_TABLE = APPEND_TO_TABLE;
exports.APPEND_TO_TABLE_REQUEST = APPEND_TO_TABLE_REQUEST;
exports.APPEND_TO_TABLE_SUCCESS = APPEND_TO_TABLE_SUCCESS;
exports.APPEND_TO_TABLE_FAILURE = APPEND_TO_TABLE_FAILURE;
function appendToTable(_ref7) {
  var teamName = _ref7.teamName,
      tableID = _ref7.tableID,
      body = _ref7.body;

  return {
    type: APPEND_TO_TABLE,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID + '/append',
      schema: _schemas.TABLE,
      options: {
        method: 'POST',
        body: body
      }
    }
  };
}

var _api$buildTypes15 = _api2.default.buildTypes('ADD_TABLE_COLUMN'),
    _api$buildTypes16 = _slicedToArray(_api$buildTypes15, 4);

var ADD_TABLE_COLUMN = _api$buildTypes16[0],
    ADD_TABLE_COLUMN_REQUEST = _api$buildTypes16[1],
    ADD_TABLE_COLUMN_SUCCESS = _api$buildTypes16[2],
    ADD_TABLE_COLUMN_FAILURE = _api$buildTypes16[3];
exports.ADD_TABLE_COLUMN = ADD_TABLE_COLUMN;
exports.ADD_TABLE_COLUMN_REQUEST = ADD_TABLE_COLUMN_REQUEST;
exports.ADD_TABLE_COLUMN_SUCCESS = ADD_TABLE_COLUMN_SUCCESS;
exports.ADD_TABLE_COLUMN_FAILURE = ADD_TABLE_COLUMN_FAILURE;
function addTableColumn(_ref8) {
  var teamName = _ref8.teamName,
      tableID = _ref8.tableID,
      column = _ref8.column;

  return {
    type: ADD_TABLE_COLUMN,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID + '/columns',
      schema: _schemas.FIELD,
      options: {
        method: 'POST',
        body: column
      }
    }
  };
}

var _api$buildTypes17 = _api2.default.buildTypes('GET_TABLE_PROCESSES'),
    _api$buildTypes18 = _slicedToArray(_api$buildTypes17, 4);

var GET_TABLE_PROCESSES = _api$buildTypes18[0],
    GET_TABLE_PROCESSES_REQUEST = _api$buildTypes18[1],
    GET_TABLE_PROCESSES_SUCCESS = _api$buildTypes18[2],
    GET_TABLE_PROCESSES_FAILURE = _api$buildTypes18[3];
exports.GET_TABLE_PROCESSES = GET_TABLE_PROCESSES;
exports.GET_TABLE_PROCESSES_REQUEST = GET_TABLE_PROCESSES_REQUEST;
exports.GET_TABLE_PROCESSES_SUCCESS = GET_TABLE_PROCESSES_SUCCESS;
exports.GET_TABLE_PROCESSES_FAILURE = GET_TABLE_PROCESSES_FAILURE;
function getTableProcesses(_ref9) {
  var teamName = _ref9.teamName,
      tableID = _ref9.tableID;

  return {
    type: GET_TABLE_PROCESSES,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID + '/parentprocesses',
      schema: _schemas.PROCESS_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Add = function (_SvgIcon) {
  _inherits(Add, _SvgIcon);

  function Add() {
    _classCallCheck(this, Add);

    return _possibleConstructorReturn(this, (Add.__proto__ || Object.getPrototypeOf(Add)).apply(this, arguments));
  }

  _createClass(Add, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
        );
      }

      return render;
    }()
  }]);

  return Add;
}(_SvgIcon3['default']);

exports['default'] = Add;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = exports['default'] = undefined;

var _Layout2 = __webpack_require__(1856);

var _Layout3 = _interopRequireDefault(_Layout2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Layout3['default']; /* eslint-disable flowtype/require-valid-file-annotation */

exports.Layout = _Layout3['default'];

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Back = function (_SvgIcon) {
  _inherits(Back, _SvgIcon);

  function Back() {
    _classCallCheck(this, Back);

    return _possibleConstructorReturn(this, (Back.__proto__ || Object.getPrototypeOf(Back)).apply(this, arguments));
  }

  _createClass(Back, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
        );
      }

      return render;
    }()
  }]);

  return Back;
}(_SvgIcon3['default']);

exports['default'] = Back;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1314),
    findIndex = __webpack_require__(1315);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(1351);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavData = (_temp = _class = function (_SvgIcon) {
  _inherits(NavData, _SvgIcon);

  function NavData() {
    _classCallCheck(this, NavData);

    return _possibleConstructorReturn(this, (NavData.__proto__ || Object.getPrototypeOf(NavData)).apply(this, arguments));
  }

  _createClass(NavData, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'defs',
            null,
            _react2['default'].createElement(
              'style',
              null,
              '.cls-4{fill:none;stroke:#2c2f43}.cls-6{stroke-linecap:round;stroke-linejoin:round}.cls-4{stroke-miterlimit:10}.cls-6{stroke:#3f4158;fill:#3f4158}'
            )
          ),
          _react2['default'].createElement('path', {
            d: 'M24.33 35.52l-21.24.15A2.11 2.11 0 0 1 1 33.58L.75 3A2.11 2.11 0 0 1 2.84.87L19.13.75c0 .25 7.11 7.15 7.11 7.15l.18 25.5a2.11 2.11 0 0 1-2.09 2.12z',
            strokeWidth: '1.13',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: '#2c2f43',
            fill: 'none'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.33 35.52l-21.24.15A2.11 2.11 0 0 1 1 33.58L.75 3A2.11 2.11 0 0 1 2.84.87L19.13.75c0 .25 7.11 7.15 7.11 7.15l.18 25.5a2.11 2.11 0 0 1-2.09 2.12z',
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: '#2c2f43',
            fill: 'none'
          }),
          _react2['default'].createElement('path', {
            d: 'M25.9 8.24h-5a2.11 2.11 0 0 1-2.12-2.09v-5.1',
            fill: '#2c2f43',
            strokeWidth: '.94',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: '#2c2f43'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 18.127 11.245)',
            d: 'M13.09 10.45h10.05v1.37H13.09z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 16.72 14.035)',
            d: 'M13.11 13.81h6.53v1.37h-6.53z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-4',
            transform: 'rotate(-.41 6.942 12.602)',
            d: 'M4.8 10.39h4.66v4.66H4.8z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 15.302 19.62)',
            d: 'M13.15 19.05h5.12v1.37h-5.12z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 18.087 22.424)',
            d: 'M13.18 22.4h8.64v1.37h-8.64z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-4',
            transform: 'rotate(-.41 6.912 20.987)',
            d: 'M4.86 18.98h4.66v4.66H4.86z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 18.067 28.014)',
            d: 'M13.21 27.06h8.99v1.37h-8.99z'
          }),
          _react2['default'].createElement('path', {
            transform: 'rotate(-.41 15.262 30.799)',
            d: 'M13.23 30.43h4.06v1.37h-4.06z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-4',
            transform: 'rotate(-.41 6.882 29.371)',
            d: 'M4.92 27h4.66v4.66H4.92z'
          }),
          _react2['default'].createElement('path', {
            stroke: '#3f4158',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            fill: 'none',
            d: 'M33.31 12.95l3.76 14.52-3.83.99-3.76-14.52 1.06-3.52 2.77 2.53z'
          }),
          _react2['default'].createElement('path', {
            className: 'cls-6',
            transform: 'rotate(-14.52 35.428 29.043)',
            d: 'M33.46 27.93h3.95v2.23h-3.95z'
          }),
          _react2['default'].createElement('path', { className: 'cls-6', d: 'M33.52 13.75l-3.83 1' })
        );
      }

      return render;
    }()
  }]);

  return NavData;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 38.13 36.42'
}, _temp);
exports['default'] = NavData;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VISIBILITY_TYPES, _RUN_VISIBILITY_TYPES, _TABLE_VISIBILITY_TYP;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PUBLIC = exports.PUBLIC = 'public';
var INTERNAL = exports.INTERNAL = 'internal';
var CONFIDENTIAL = exports.CONFIDENTIAL = 'confidential';
var HIGHLY_CONFIDENTIAL = exports.HIGHLY_CONFIDENTIAL = 'highlyConfidential';

var VISIBILITY_TYPES = exports.VISIBILITY_TYPES = (_VISIBILITY_TYPES = {}, _defineProperty(_VISIBILITY_TYPES, PUBLIC, 'Public: Anyone interacting with this Process'), _defineProperty(_VISIBILITY_TYPES, INTERNAL, 'Internal: Hidden from non-team members'), _defineProperty(_VISIBILITY_TYPES, CONFIDENTIAL, 'Confidential: Hidden from everyone except for admins and designated users'), _defineProperty(_VISIBILITY_TYPES, HIGHLY_CONFIDENTIAL, 'Highly Confidential: Hidden from everyone except for designated users'), _VISIBILITY_TYPES);

var OPEN = exports.OPEN = 'open';
var RESTRICTED = exports.RESTRICTED = 'restricted';

var RUN_VISIBILITY_TYPES = exports.RUN_VISIBILITY_TYPES = (_RUN_VISIBILITY_TYPES = {}, _defineProperty(_RUN_VISIBILITY_TYPES, OPEN, 'Open: Visible to any user'), _defineProperty(_RUN_VISIBILITY_TYPES, RESTRICTED, 'Restricted: Visible only to run owner and process editors'), _RUN_VISIBILITY_TYPES);

var TABLE_VISIBILITY_TYPES = exports.TABLE_VISIBILITY_TYPES = (_TABLE_VISIBILITY_TYP = {}, _defineProperty(_TABLE_VISIBILITY_TYP, OPEN, 'Open: Visible to any user'), _defineProperty(_TABLE_VISIBILITY_TYP, RESTRICTED, 'Restricted: Visible only to specified users'), _TABLE_VISIBILITY_TYP);

var VISIBILITY_TYPES_ALLOWING_USER_CONFIG = exports.VISIBILITY_TYPES_ALLOWING_USER_CONFIG = [CONFIDENTIAL, HIGHLY_CONFIDENTIAL];

var HIGHLY_CONFIDENTIAL_ERROR_MESSAGE = exports.HIGHLY_CONFIDENTIAL_ERROR_MESSAGE = 'Designate at least one user when Highly Confidential is selected';

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTriggerType = selectTriggerType;
var SELECT_TRIGGER_TYPE = exports.SELECT_TRIGGER_TYPE = 'SELECT_TRIGGER_TYPE';

function selectTriggerType(selectedTriggerType) {
  return {
    type: SELECT_TRIGGER_TYPE,
    selectedTriggerType: selectedTriggerType
  };
}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.page = exports.routeProps = exports.createStoreSelector = exports.createPageSelector = exports.expandSearch = exports.searchText = exports.queryWithDefaults = exports.searchWithDefaults = exports.search = exports.parsedQueryText = exports.parsedQuery = exports.appPageSearch = exports.searchSchema = exports.routeStore = exports.routePage = exports.appStore = exports.appPage = exports.navigate = exports.appName = exports.app = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(33);

var _routing = __webpack_require__(383);

var _url = __webpack_require__(31);

var _isEmpty = __webpack_require__(717);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var app = exports.app = function app() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$app = _ref.app,
      app = _ref$app === undefined ? {} : _ref$app;

  return app;
};

var appName = exports.appName = (0, _reselect.createSelector)(app, function (_ref2) {
  var appName = _ref2.appName;
  return appName;
});

var navigate = exports.navigate = (0, _reselect.createSelector)(app, function (_ref3) {
  var navigate = _ref3.navigate;
  return navigate;
});

var appPage = exports.appPage = (0, _reselect.createSelector)(app, function (_ref4) {
  var _ref4$page = _ref4.page,
      page = _ref4$page === undefined ? {} : _ref4$page;
  return page;
});

var appStore = exports.appStore = (0, _reselect.createSelector)(app, function (_ref5) {
  var _ref5$store = _ref5.store,
      store = _ref5$store === undefined ? {} : _ref5$store;
  return store;
});

var routePage = exports.routePage = (0, _reselect.createSelector)(appPage, _routing.pathname, function (page, path) {
  return page[path] || {};
});

var routeStore = exports.routeStore = (0, _reselect.createSelector)(appStore, _routing.pathname, function (store, path) {
  return store[path] || {};
});

var searchSchema = exports.searchSchema = (0, _reselect.createSelector)(routePage, function (_ref6) {
  var searchSchema = _ref6.searchSchema;
  return searchSchema;
});

var appPageSearch = exports.appPageSearch = (0, _reselect.createSelector)(routePage, function (_ref7) {
  var search = _ref7.search;
  return search;
});

var parsedQuery = exports.parsedQuery = (0, _reselect.createSelector)(_routing.search, searchSchema, function (query, searchSchema) {
  return query ? (0, _url.parseSearch)(query, searchSchema) : null;
});

var parsedQueryText = exports.parsedQueryText = (0, _reselect.createSelector)(parsedQuery, function (query) {
  return query && query.text;
});

var search = exports.search = (0, _reselect.createSelector)(appPageSearch, parsedQuery, function () {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = arguments[1];
  return Object.keys(search).length ? search : query;
});

var searchWithDefaults = exports.searchWithDefaults = function searchWithDefaults() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var container = {}; // Infinite update loop if a new object is returned so use a static reference
  return (0, _reselect.createSelector)(search, function () {
    return defaults;
  }, function (search, defaults) {
    return Object.assign(container, defaults, search);
  });
};

// TODO Remove after common search is complete
var queryWithDefaults = exports.queryWithDefaults = function queryWithDefaults() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _reselect.createSelector)(parsedQuery, function () {
    return defaults;
  }, function (query, defaults) {
    return _extends({}, defaults, query);
  });
};

var searchText = exports.searchText = (0, _reselect.createSelector)(search, function (search) {
  return search && search.text;
});

var expandSearch = exports.expandSearch = (0, _reselect.createSelector)(routePage, searchText, function (_ref8, text) {
  var expandSearch = _ref8.expandSearch;
  return expandSearch !== undefined ? expandSearch : !(0, _isEmpty2.default)(text);
});

var createPageSelector = exports.createPageSelector = function createPageSelector(key) {
  return (0, _reselect.createSelector)(routePage, function (page) {
    return page[key];
  });
};

var createStoreSelector = exports.createStoreSelector = function createStoreSelector(key) {
  return (0, _reselect.createSelector)(routeStore, function (page) {
    return page[key];
  });
};

var routeProps = (0, _reselect.createSelector)(_routing.routes, function () {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return routes.reduce(function (o, _ref9) {
    var childRoutes = _ref9.childRoutes,
        children = _ref9.children,
        component = _ref9.component,
        components = _ref9.components,
        getComponent = _ref9.getComponent,
        getComponents = _ref9.getComponents,
        indexRoute = _ref9.indexRoute,
        onChange = _ref9.onChange,
        onEnter = _ref9.onEnter,
        onLeave = _ref9.onLeave,
        path = _ref9.path,
        props = _objectWithoutProperties(_ref9, ['childRoutes', 'children', 'component', 'components', 'getComponent', 'getComponents', 'indexRoute', 'onChange', 'onEnter', 'onLeave', 'path']);

    return _extends({}, o, props);
  }, {});
});

exports.routeProps = routeProps;
var page = exports.page = (0, _reselect.createSelector)(routePage, appName, navigate, search, expandSearch, routeProps, function (page, appName, navigate, search, expandSearch, props) {
  return _extends({
    appName: appName,
    navigate: navigate
  }, _extends({}, props, page), {
    search: search,
    expandSearch: expandSearch
  });
});

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(556),
    getTag = __webpack_require__(225),
    isArguments = __webpack_require__(219),
    isArray = __webpack_require__(27),
    isArrayLike = __webpack_require__(152),
    isBuffer = __webpack_require__(220),
    isPrototype = __webpack_require__(511),
    isTypedArray = __webpack_require__(316);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _ButtonBase = __webpack_require__(197);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _FullScreen = __webpack_require__(1746);

var _FullScreen2 = _interopRequireDefault(_FullScreen);

var _contains = __webpack_require__(121);

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = __webpack_require__(196);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = __webpack_require__(122);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DIVIDER_WIDTH = '1px';
var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItem', function (theme) {
  return {
    root: {
      alignItems: 'flex-start',
      backgroundColor: theme.palette.background.paper,
      flexFlow: 'column',
      justifyContent: 'initial',
      position: 'relative',
      textDecoration: 'none'
    },
    rootFocus: {
      borderColor: theme.palette.text.lightDivider,
      zIndex: theme.zIndex.baseIndex,
      cursor: 'initial', // Override behavior from the wrapping <ButtonBase> so
      userSelect: 'initial' // content is selectable and the cursor behaves normally
    },
    disabled: {
      opacity: 0.5
    },
    divider: {
      borderBottom: DIVIDER_WIDTH + ' solid ' + theme.palette.text.lightDivider,
      top: 0,
      height: DIVIDER_WIDTH,
      marginLeft: '-' + DIVIDER_WIDTH,
      marginRight: '-' + DIVIDER_WIDTH,
      left: theme.typography.rhythmByUnit(6.5),
      right: theme.typography.rhythmByUnit(2),
      position: 'absolute',
      '$root:first-child > div > &, $rootFocus > div > &, $rootFocus + $root > div > &, :not($root) + $root:last-child > div > &': {
        borderBottomColor: 'transparent'
      }
    },
    button: {
      transition: theme.transitions.create('background-color'),
      '&:hover': {
        textDecoration: 'none',
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    },
    childrenContainer: {
      display: 'flex',
      flex: '0 auto',
      flexFlow: 'column',
      width: '100%'
    },
    invisible: theme.mixins.invisible(),
    highlight: {
      backgroundColor: theme.palette.background.highlight
    }
  };
});

var ActivityListItem = (_temp2 = _class = function (_React$Component) {
  _inherits(ActivityListItem, _React$Component);

  function ActivityListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ActivityListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityListItem.__proto__ || Object.getPrototypeOf(ActivityListItem)).call.apply(_ref, [this].concat(args))), _this), _this.listItem = undefined, _this.focus = function () {
      if (typeof (_this.listItem || {}).focus === 'function') {
        _this.listItem.focus(); // eslint-disable-line flowtype-errors/show-errors
      }
    }, _this.handleFocus = function (e) {
      var onFocus = _this.props.onFocus;

      if (onFocus) onFocus(e);
    }, _this.handleBlur = function (e) {
      if (_this.hasFocus(e.relatedTarget)) return; // eslint-disable-line flowtype-errors/show-errors
      var onBlur = _this.props.onBlur;

      if (onBlur) onBlur(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActivityListItem, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (this.props.autoFocus) {
          this.focus();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'hasFocus',


    // eslint-disable-next-line flowtype-errors/show-errors
    value: function () {
      function hasFocus(el) {
        var currentFocus = el || (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(this))); // eslint-disable-line react/no-find-dom-node
        var node = _reactDom2['default'].findDOMNode(this.listItem); // eslint-disable-line react/no-find-dom-node
        return currentFocus && node && (0, _contains2['default'])(node, currentFocus);
      }

      return hasFocus;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames,
            _this2 = this;

        var _props = this.props,
            button = _props.button,
            childrenProp = _props.children,
            classNameProp = _props.className,
            componentProp = _props.component,
            disabled = _props.disabled,
            divider = _props.divider,
            expand = _props.expand,
            highlight = _props.highlight,
            onBlur = _props.onBlur,
            onFocus = _props.onFocus,
            other = _objectWithoutProperties(_props, ['button', 'children', 'className', 'component', 'disabled', 'divider', 'expand', 'highlight', 'onBlur', 'onFocus']);

        var classes = this.context.styleManager.render(styleSheet);
        var children = _react2['default'].Children.toArray(childrenProp);

        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.button, button), _defineProperty(_classNames, classes.rootFocus, expand), _defineProperty(_classNames, classes.highlight, highlight), _classNames), classNameProp);
        var dividerClassName = (0, _classnames2['default'])(classes.divider, _defineProperty({}, classes.invisible, !divider || expand));

        var listItemProps = Object.assign({
          className: className,
          disabled: disabled,
          expand: expand,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          ref: function () {
            function ref(node) {
              return _this2.listItem = node;
            }

            return ref;
          }()
        }, other);
        var ComponentMain = componentProp;

        if (button) {
          ComponentMain = _ButtonBase2['default'];
          listItemProps.component = componentProp;
          listItemProps.keyboardFocusedClassName = classes.keyboardFocused;
        }

        return _react2['default'].createElement(
          ComponentMain,
          listItemProps,
          _react2['default'].createElement('div', { className: dividerClassName }),
          _react2['default'].createElement(
            'div',
            { className: classes.childrenContainer },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return ActivityListItem;
}(_react2['default'].Component), _class.defaultProps = {
  autoFocus: false,
  button: true,
  component: _FullScreen2['default'],
  disabled: false,
  divider: true
}, _temp2);
exports['default'] = ActivityListItem;


ActivityListItem.displayName = 'ActivityListItem';

ActivityListItem.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var destructure = function destructure(props) {
  var children = _react2['default'].Children.toArray(props.children);
  var rootIconIndex = children.findIndex(function (c) {
    return c.type.displayName === 'ActivityListItemIcon';
  });
  var rootIcon = rootIconIndex !== -1 ? children.splice(rootIconIndex, 1)[0] : null;
  var secondaryIconIndex = children.findIndex(function (c) {
    return c.type.displayName === 'ActivityListItemAvatar';
  });
  var secondaryIcon = secondaryIconIndex !== -1 ? children.splice(secondaryIconIndex, 1)[0] : null;

  return {
    children: children,
    rootIcon: rootIcon,
    secondaryIcon: secondaryIcon
  };
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemHeader', function (theme) {
  var borderBottom = '1px solid ' + theme.palette.text.lightDivider;

  return _defineProperty({
    root: Object.assign({
      display: 'flex',
      flexShrink: 0
    }, theme.mixins.gutters(2)),
    inner: _defineProperty({
      alignItems: 'flex-start',
      display: 'flex',
      flex: 1,
      flexFlow: 'column'
    }, theme.breakpoints.up('sm'), {
      alignItems: 'baseline',
      flexFlow: 'row'
    }),
    main: _defineProperty({
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'row-reverse',
      flex: 1,
      paddingTop: theme.typography.rhythmByUnit(2.5),
      paddingBottom: theme.typography.rhythmByUnit(2.5)
    }, theme.breakpoints.up('sm'), {
      flexFlow: 'row'
    }),
    divider: {
      borderBottom: borderBottom
    },
    fullscreenNoDivider: {
      borderBottom: 'none'
    },
    fullscreenDivider: {
      borderBottom: borderBottom
    },
    rootIconContainer: {
      alignItems: 'center',
      display: 'flex',
      marginRight: theme.typography.rhythmByUnit(2.5),
      height: theme.typography.rhythmByUnit(4),
      marginTop: theme.typography.rhythmByUnit(2.5),
      marginBottom: theme.typography.rhythmByUnit(2.5)
    },
    secondaryIconContainer: {
      alignSelf: 'flex-start'
    }
  }, theme.breakpoints.up('sm'), {
    fullscreenNoDivider: {
      borderBottom: borderBottom
    },
    fullscreenDivider: {
      borderBottom: 'none'
    },
    secondaryIconContainer: {
      paddingRight: theme.typography.rhythmByUnit(1.5)
    }
  });
});

var ActivityListItemHeader = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(ActivityListItemHeader, _React$PureComponent);

  function ActivityListItemHeader() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ActivityListItemHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ActivityListItemHeader.__proto__ || Object.getPrototypeOf(ActivityListItemHeader)).call.apply(_ref2, [this].concat(args))), _this), _this.state = destructure(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActivityListItemHeader, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(props) {
        if (props.children === this.props.children) return;
        this.setState(destructure(props)); // eslint-disable-line flowtype-errors/show-errors
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'render',
    // eslint-disable-line flowtype-errors/show-errors

    value: function () {
      function render() {
        var _props = this.props,
            childrenProp = _props.children,
            classNameProp = _props.className,
            Component = _props.component,
            fullScreen = _props.fullScreen,
            other = _objectWithoutProperties(_props, ['children', 'className', 'component', 'fullScreen']);

        var _state = this.state,
            children = _state.children,
            rootIcon = _state.rootIcon,
            secondaryIcon = _state.secondaryIcon; // eslint-disable-line flowtype-errors/show-errors

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.fullscreenDivider, fullScreen));
        var mainClassName = (0, _classnames2['default'])(classes.main, _defineProperty({}, classes.fullscreenNoDivider, fullScreen), classNameProp);

        return _react2['default'].createElement(
          'div',
          { className: rootClassName },
          rootIcon && _react2['default'].createElement(
            'div',
            { className: classes.rootIconContainer },
            rootIcon
          ),
          _react2['default'].createElement(
            Component,
            _extends({ className: mainClassName }, other),
            secondaryIcon && _react2['default'].createElement(
              'div',
              { className: classes.secondaryIconContainer },
              secondaryIcon
            ),
            _react2['default'].createElement(
              'div',
              { className: classes.inner },
              children
            )
          )
        );
      }

      return render;
    }()
  }]);

  return ActivityListItemHeader;
}(_react2['default'].PureComponent), _class.displayName = 'ActivityListItemHeader', _class.defaultProps = {
  component: 'div',
  fullScreen: false
}, _temp2);
exports['default'] = ActivityListItemHeader;


ActivityListItemHeader.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemIcon', function (theme) {
  return {
    root: {
      fontSize: theme.typography.rhythmByUnit(2.25)
    }
  };
});

var ActivityListItemIcon = (_temp = _class = function (_React$Component) {
  _inherits(ActivityListItemIcon, _React$Component);

  function ActivityListItemIcon() {
    _classCallCheck(this, ActivityListItemIcon);

    return _possibleConstructorReturn(this, (ActivityListItemIcon.__proto__ || Object.getPrototypeOf(ActivityListItemIcon)).apply(this, arguments));
  }

  _createClass(ActivityListItemIcon, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            Component = _props.component,
            props = _objectWithoutProperties(_props, ['className', 'component']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);

        return _react2['default'].createElement(Component, Object.assign({}, props, { className: className }));
      }

      return render;
    }()
  }]);

  return ActivityListItemIcon;
}(_react2['default'].Component), _class.displayName = 'ActivityListItemIcon', _class.defaultProps = {
  component: 'div'
}, _class.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
}, _temp);
exports['default'] = ActivityListItemIcon;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _IconButton = __webpack_require__(90);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _NavigationMoreVert = __webpack_require__(741);

var _NavigationMoreVert2 = _interopRequireDefault(_NavigationMoreVert);

var _ = __webpack_require__(146);

var _2 = _interopRequireDefault(_);

var _typography = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconMenu = (_temp2 = _class = function (_Component) {
  _inherits(IconMenu, _Component);

  function IconMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IconMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconMenu.__proto__ || Object.getPrototypeOf(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.open = function (open) {
      return _this.setState({ open: open });
    }, _this.handleIconButtonClick = function (e) {
      var _this$props$_this$sta = Object.assign({}, _this.props, _this.state),
          open = _this$props$_this$sta.open,
          _this$props$_this$sta2 = _this$props$_this$sta.onClick,
          onClick = _this$props$_this$sta2 === undefined ? function () {} : _this$props$_this$sta2;

      _this.open(!open);
      onClick(e);
    }, _this.handleMenuItemClick = function (e) {
      var value = e.target.getAttribute('value');
      var onChange = _this.props.onChange;
      var currentValue = _this.state.currentValue;


      if (value !== currentValue) {
        _this.setState({ value: value });
      }
      if (onChange) {
        onChange(value);
      }

      _this.handleRequestClose();
    }, _this.handleRequestClose = function () {
      return _this.open(false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconMenu, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props$state = Object.assign({}, this.props, this.state),
            anchorOrigin = _props$state.anchorOrigin,
            iconClass = _props$state.iconClass,
            Icon = _props$state.iconComponent,
            open = _props$state.open,
            options = _props$state.options,
            transformOrigin = _props$state.transformOrigin,
            id = _props$state.id;

        var popoverProps = { anchorOrigin: anchorOrigin, transformOrigin: transformOrigin };

        var menuItems = options.map(function (option, i) {
          return _react2['default'].createElement(
            _.MenuItem,
            {
              property: 'pb:action',
              'typeof': 'ui:MenuItem',
              resource: '#' + option,
              key: i,
              value: option,
              onClick: _this2.handleMenuItemClick
            },
            option
          );
        });

        return _react2['default'].createElement(
          'div',
          {
            id: id,
            'typeof': 'ui:IconMenu',
            ref: function () {
              function ref(rootNode) {
                return _this2.rootNode = rootNode;
              }

              return ref;
            }()
          },
          _react2['default'].createElement(
            _IconButton2['default'],
            { className: iconClass, onClick: this.handleIconButtonClick },
            _react2['default'].createElement(Icon, null)
          ),
          _react2['default'].createElement(
            _2['default'],
            {
              anchorEl: this.rootNode,
              onRequestClose: this.handleRequestClose,
              open: open,
              popoverProps: popoverProps
            },
            menuItems
          )
        );
      }

      return render;
    }()
  }]);

  return IconMenu;
}(_react.Component), _class.propTypes = {
  /**
   * anchorOrigin: The location of the anchor on the `IconMenu` icon
   * vertical: ['top', 'center', 'bottom', x (px), fn(height) -> x (px)]
   * horizontal: ['left', 'center', 'right', x (px), fn(width) -> x (px)]
   */
  anchorOrigin: _PropTypes2['default'].origin,
  /**
   * The CSS class name of the icon button element.
   */
  iconClass: _PropTypes2['default'].string,
  /**
   * Component to be used as the icon button icon element.
   */
  iconComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Function called when menu option is selected.
   */
  onChange: _PropTypes2['default'].func,
  /**
   * Function called when iconComponent is clicked.
   * Can be used to stop propagation of the event if iconMenu is a child of a clickable node (i.e. a list item with `button` prop)
   */
  onClick: _PropTypes2['default'].func,
  /**
   * If `true`, then menu is displayed.
   */
  open: _PropTypes2['default'].bool,
  /**
   * Options to list in dropdown menu.
   */
  options: _PropTypes2['default'].array,
  /**
   * transformOrigin: The location of the anchor on the `Menu` popover
   * vertical: ['top', 'center', 'bottom', x (px), fn(height) -> x (px)]
   * horizontal: ['left', 'center', 'right', x (px), fn(width) -> x (px)]
   */
  transformOrigin: _PropTypes2['default'].origin
}, _class.defaultProps = {
  anchorOrigin: {
    horizontal: 'center',
    vertical: 'bottom'
  },
  open: false,
  iconClass: null,
  iconComponent: _NavigationMoreVert2['default'],
  onChange: function () {
    function onChange() {}

    return onChange;
  }(),
  options: [],
  transformOrigin: {
    horizontal: function () {
      function horizontal(width) {
        return width - parseInt((0, _typography.rhythmByUnit)(2));
      }

      return horizontal;
    }(),
    vertical: 'top'
  }
}, _temp2);
exports['default'] = IconMenu;


IconMenu.displayName = 'IconMenu';

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStepType = exports.appStepParams = undefined;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _field = __webpack_require__(91);

var _field2 = _interopRequireDefault(_field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

var appStepParams = exports.appStepParams = objectOf(oneOfType([string, bool]));

var appStepType = exports.appStepType = oneOfType([shape({
  appID: string.isRequired,
  params: appStepParams
})]);

exports.default = shape({
  appStep: appStepType,
  conditionCode: string,
  conditions: arrayOf(string),
  createdBy: string,
  description: string,
  displayName: string,
  fields: arrayOf(_field2.default),
  isTerminal: bool,
  maximumDuration: string,
  previousSteps: arrayOf(string),
  priority: string,
  processID: string,
  processName: string,
  requiredPreviousSteps: arrayOf(string),
  role: shape({
    users: arrayOf(string),
    fields: arrayOf(string)
  }),
  roleID: string,
  stepName: string,
  stepNumber: number,
  teamName: string
});

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_FIELD_FAILURE = exports.DELETE_FIELD_SUCCESS = exports.DELETE_FIELD_REQUEST = exports.DELETE_FIELD = exports.UPDATE_FIELD_FAILURE = exports.UPDATE_FIELD_SUCCESS = exports.UPDATE_FIELD_REQUEST = exports.UPDATE_FIELD = exports.appendFieldToStepWritableFields = exports.appendFieldToProcessWritableFields = exports.addAndAttachWritableField = exports.ADD_FIELD_FAILURE = exports.ADD_FIELD_SUCCESS = exports.ADD_FIELD_REQUEST = exports.ADD_FIELD = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.addField = addField;
exports.addFieldEntity = addFieldEntity;
exports.updateField = updateField;
exports.deleteField = deleteField;
exports.deleteFieldEntity = deleteFieldEntity;

var _cloneDeep = __webpack_require__(401);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _remove = __webpack_require__(733);

var _remove2 = _interopRequireDefault(_remove);

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _process = __webpack_require__(387);

var _step = __webpack_require__(394);

var _schemas = __webpack_require__(8);

var _fields = __webpack_require__(388);

var _permissions = __webpack_require__(714);

var _url = __webpack_require__(31);

var _toast = __webpack_require__(183);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Add Field
var _api$buildTypes = _api2.default.buildTypes('ADD_FIELD'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var ADD_FIELD = _api$buildTypes2[0],
    ADD_FIELD_REQUEST = _api$buildTypes2[1],
    ADD_FIELD_SUCCESS = _api$buildTypes2[2],
    ADD_FIELD_FAILURE = _api$buildTypes2[3];
exports.ADD_FIELD = ADD_FIELD;
exports.ADD_FIELD_REQUEST = ADD_FIELD_REQUEST;
exports.ADD_FIELD_SUCCESS = ADD_FIELD_SUCCESS;
exports.ADD_FIELD_FAILURE = ADD_FIELD_FAILURE;
var addAndAttachWritableField = exports.addAndAttachWritableField = function addAndAttachWritableField(dispatch) {
  return function (displayName, process, step, fields, allProcessFields, _ref) {
    var processID = _ref.processID,
        teamName = _ref.teamName,
        fieldAddRequestFailure = _ref.fieldAddRequestFailure,
        fieldAddRequestSuccess = _ref.fieldAddRequestSuccess;

    var _ref2 = step || {},
        stepName = _ref2.stepName;

    var _ref3 = process || {},
        processName = _ref3.processName,
        _ref3$fieldVisibility = _ref3.fieldVisibility,
        visibility = _ref3$fieldVisibility === undefined ? _permissions.PUBLIC : _ref3$fieldVisibility,
        _ref3$fieldVisibleToU = _ref3.fieldVisibleToUsers,
        visibleToUsers = _ref3$fieldVisibleToU === undefined ? [] : _ref3$fieldVisibleToU;

    var field = {
      displayName: displayName,
      teamName: teamName,
      processID: processName,
      visibility: visibility,
      visibleToUsers: visibleToUsers
    };

    var existingFieldOnThisEntity = (0, _fields.findFieldByDisplayName)(field, fields);
    if (existingFieldOnThisEntity) {
      return dispatch((0, _toast.toast)({ message: fieldAddRequestSuccess }));
    }

    var action = void 0;
    var existingFieldElsewhereOnProcess = (0, _fields.findFieldByDisplayName)(field, allProcessFields);
    if (existingFieldElsewhereOnProcess) {
      var fieldName = existingFieldElsewhereOnProcess.fieldName;

      if (stepName) {
        action = appendFieldToStepWritableFields(step, process, fieldName);
      } else {
        action = appendFieldToProcessWritableFields(process, fieldName);
      }
    } else {
      action = addField(field, processID, stepName);
    }
    return dispatch(action).then(function () {
      return dispatch((0, _toast.toast)({ message: fieldAddRequestSuccess }));
    }).catch(function (error) {
      return dispatch((0, _toast.toast)({ message: fieldAddRequestFailure, error: error }));
    });
  };
};

function addField(field, processID, stepName) {
  return function (dispatch, getState) {
    var teamName = field.teamName; // eslint-disable-line no-unused-vars

    return dispatch(addFieldEntity(field)).then(function (_ref4) {
      var response = _ref4.response;
      var fieldName = response.entities.fields[response.result].fieldName;

      var state = getState();
      var process = (0, _schemas.getEntityByID)(state.entities.processes, _schemas.PROCESS, {
        processID: processID
      });
      if (stepName) {
        var step = (0, _schemas.getEntityByID)(state.entities.steps, _schemas.STEP, {
          processID: processID,
          stepName: stepName
        });
        dispatch(appendFieldToStepWritableFields(step, process, fieldName));
      } else if (processID) {
        dispatch(appendFieldToProcessWritableFields(process, fieldName));
      }
    });
  };
}

function addFieldEntity(field) {
  return {
    type: ADD_FIELD,
    payload: {
      url: apiPathForField(field),
      schema: _schemas.FIELD,
      options: {
        method: 'POST',
        body: field
      }
    }
  };
}

var appendFieldToProcessWritableFields = exports.appendFieldToProcessWritableFields = function appendFieldToProcessWritableFields(process, fieldName) {
  var teamName = process.teamName,
      processID = process.processID,
      _process$writableFiel = process.writableFields,
      previousWritableFields = _process$writableFiel === undefined ? [] : _process$writableFiel;

  return (0, _process.updateProcess)({
    teamName: teamName,
    processID: processID,
    data: { writableFields: previousWritableFields.concat([fieldName]) }
  });
};

var appendFieldToStepWritableFields = exports.appendFieldToStepWritableFields = function appendFieldToStepWritableFields(step, process, fieldName) {
  var processID = process.processID;
  var teamName = step.teamName,
      stepName = step.stepName,
      _step$writableFields = step.writableFields,
      previousWritableFields = _step$writableFields === undefined ? [] : _step$writableFields;

  return (0, _step.updateStep)({
    teamName: teamName,
    processName: processID,
    stepName: stepName,
    step: { writableFields: previousWritableFields.concat([fieldName]) }
  });
};

// Update Field

var _api$buildTypes3 = _api2.default.buildTypes('UPDATE_FIELD'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var UPDATE_FIELD = _api$buildTypes4[0],
    UPDATE_FIELD_REQUEST = _api$buildTypes4[1],
    UPDATE_FIELD_SUCCESS = _api$buildTypes4[2],
    UPDATE_FIELD_FAILURE = _api$buildTypes4[3];
exports.UPDATE_FIELD = UPDATE_FIELD;
exports.UPDATE_FIELD_REQUEST = UPDATE_FIELD_REQUEST;
exports.UPDATE_FIELD_SUCCESS = UPDATE_FIELD_SUCCESS;
exports.UPDATE_FIELD_FAILURE = UPDATE_FIELD_FAILURE;
function updateField(field) {
  var fieldName = field.fieldName,
      retroactive = field.retroactive;

  var basePath = apiPathForField(field);
  var url = (0, _url.format)({
    pathname: basePath + '/' + fieldName,
    query: { retroactive: retroactive }
  });
  return {
    type: UPDATE_FIELD,
    payload: {
      url: url,
      schema: _schemas.FIELD,
      options: {
        method: 'PUT',
        body: field
      }
    }
  };
}

// Delete Field

var _api$buildTypes5 = _api2.default.buildTypes('DELETE_FIELD'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var DELETE_FIELD = _api$buildTypes6[0],
    DELETE_FIELD_REQUEST = _api$buildTypes6[1],
    DELETE_FIELD_SUCCESS = _api$buildTypes6[2],
    DELETE_FIELD_FAILURE = _api$buildTypes6[3];
exports.DELETE_FIELD = DELETE_FIELD;
exports.DELETE_FIELD_REQUEST = DELETE_FIELD_REQUEST;
exports.DELETE_FIELD_SUCCESS = DELETE_FIELD_SUCCESS;
exports.DELETE_FIELD_FAILURE = DELETE_FIELD_FAILURE;
function deleteField(field, processID, stepName) {
  return function (dispatch, getState) {
    var fieldName = field.fieldName;

    var state = getState();
    var process = (0, _schemas.getEntityByID)(state.entities.processes, _schemas.PROCESS, {
      processID: processID
    });
    if (stepName) {
      var step = (0, _schemas.getEntityByID)(state.entities.steps, _schemas.STEP, {
        processID: processID,
        stepName: stepName
      });
      return dispatch(removeFieldFromStepWritableFields(step, process, fieldName));
    } else if (processID) {
      return dispatch(removeFieldFromProcessWritableFields(process, fieldName));
    }
  };
}

function deleteFieldEntity(field) {
  var fieldName = field.fieldName;

  var basePath = apiPathForField(field);
  return {
    type: DELETE_FIELD,
    payload: {
      url: basePath + '/' + fieldName,
      schema: _schemas.FIELD,
      options: {
        method: 'DELETE'
      }
    }
  };
}

function removeFieldFromProcessWritableFields(process, fieldName) {
  var teamName = process.teamName,
      processID = process.processID,
      _process$writableFiel2 = process.writableFields,
      previousWritableFields = _process$writableFiel2 === undefined ? [] : _process$writableFiel2;

  var writableFields = (0, _cloneDeep2.default)(previousWritableFields);
  (0, _remove2.default)(writableFields, function (thisFieldName) {
    return thisFieldName === fieldName;
  });
  return (0, _process.updateProcess)({
    teamName: teamName,
    processID: processID,
    data: { writableFields: writableFields }
  });
}

function removeFieldFromStepWritableFields(step, process, fieldName) {
  var teamName = step.teamName,
      stepName = step.stepName,
      _step$writableFields2 = step.writableFields,
      previousWritableFields = _step$writableFields2 === undefined ? [] : _step$writableFields2;
  var processID = process.processID;

  var writableFields = (0, _cloneDeep2.default)(previousWritableFields);
  (0, _remove2.default)(writableFields, function (thisFieldName) {
    return thisFieldName === fieldName;
  });
  return (0, _step.updateStep)({
    teamName: teamName,
    processName: processID,
    stepName: stepName,
    step: { writableFields: writableFields }
  });
}

// Shared
function apiPathForField(field) {
  var processID = field.processID,
      stepName = field.stepName,
      rowID = field.rowID,
      runID = field.runID,
      tableID = field.tableID,
      taskName = field.taskName,
      teamName = field.teamName;

  var path = '/teams/' + teamName;
  if (tableID) {
    if (rowID) {
      path += '/tables/' + tableID + '/rows/' + rowID;
    } else {
      path += '/tables/' + tableID + '/rows/' + tableID;
    }
  } else if (runID) {
    path += '/runs/' + runID;
    if (taskName) {
      path += '/tasks/' + taskName;
    }
  } else if (processID) {
    path += '/processes/' + processID;
  }
  path += '/fields';
  return path;
}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var RUNNING = exports.RUNNING = 'running';
var SNOOZED = exports.SNOOZED = 'snoozed';
var DELAYED = exports.DELAYED = 'delayed';
var WAITING = exports.WAITING = 'waiting';

var COMPLETED = exports.COMPLETED = 'completed';
var FAILED = exports.FAILED = 'failed';
var ABORTED = exports.ABORTED = 'aborted';
var REJECTED = exports.REJECTED = 'rejected';
var SKIPPED = exports.SKIPPED = 'skipped';
var EXPIRED = exports.EXPIRED = 'expired';

var ACTIVE_RUN_STATUSES = exports.ACTIVE_RUN_STATUSES = [RUNNING];
var COMPLETE_RUN_STATUSES = exports.COMPLETE_RUN_STATUSES = [COMPLETED, FAILED, ABORTED];

var ACTIVE_TASK_STATUSES = exports.ACTIVE_TASK_STATUSES = [RUNNING, SNOOZED];
var UPCOMING_TASK_STATUSES = exports.UPCOMING_TASK_STATUSES = [WAITING, DELAYED];
var COMPLETE_TASK_STATUSES = exports.COMPLETE_TASK_STATUSES = [COMPLETED, FAILED, ABORTED, REJECTED, SKIPPED, EXPIRED];

var INCOMPLETE_STATUSES = exports.INCOMPLETE_STATUSES = [].concat(_toConsumableArray(new Set([].concat(ACTIVE_RUN_STATUSES, ACTIVE_TASK_STATUSES, UPCOMING_TASK_STATUSES))));

var COMPLETE_STATUSES = exports.COMPLETE_STATUSES = [].concat(_toConsumableArray(new Set([].concat(COMPLETE_RUN_STATUSES, COMPLETE_TASK_STATUSES))));

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(119),
    baseIteratee = __webpack_require__(57),
    baseMap = __webpack_require__(559),
    isArray = __webpack_require__(27);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Display;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(62);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Text = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DISPLAY_NAME = 'Display';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(DISPLAY_NAME, function (theme) {
  return {
    root: theme.mixins.gutters(2)
  };
});

function Display(props, context) {
  var children = props.children,
      classNameProp = props.className,
      other = _objectWithoutProperties(props, ['children', 'className']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2.default)(classes.root, classNameProp);

  return _react2.default.createElement(
    _Text.Display1,
    _extends({ paragraph: true, className: className }, other),
    children
  );
}
Display.displayName = DISPLAY_NAME;
Display.contextTypes = {
  styleManager: _PropTypes2.default.styleManager.isRequired
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.params = undefined;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var any = _propTypes2.default.any,
    arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    object = _propTypes2.default.object,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;
var params = exports.params = objectOf(oneOfType([string, bool, shape({
  default: oneOfType([bool, number, string]),
  description: oneOfType([string, arrayOf(string)]),
  displayName: string,
  example: string,
  paramName: string,
  required: oneOfType([bool, string]),
  type: oneOfType([string, arrayOf(string)]),
  value: any
})]));

exports.default = shape({
  appName: string,
  appID: string,
  displayName: string,
  description: string,
  configuredWithUserDefinedFields: bool,
  authAppIDs: arrayOf(string),
  authRequired: bool,
  params: params
});

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_PREDICTOR_PROCESSES_FAILURE = exports.GET_PREDICTOR_PROCESSES_SUCCESS = exports.GET_PREDICTOR_PROCESSES_REQUEST = exports.GET_PREDICTOR_PROCESSES = exports.DELETE_PREDICTOR_FAILURE = exports.DELETE_PREDICTOR_SUCCESS = exports.DELETE_PREDICTOR_REQUEST = exports.DELETE_PREDICTOR = exports.UPDATE_PREDICTOR_FAILURE = exports.UPDATE_PREDICTOR_SUCCESS = exports.UPDATE_PREDICTOR_REQUEST = exports.UPDATE_PREDICTOR = exports.CREATE_PREDICTOR_FAILURE = exports.CREATE_PREDICTOR_SUCCESS = exports.CREATE_PREDICTOR_REQUEST = exports.CREATE_PREDICTOR = exports.GET_PREDICTOR_FAILURE = exports.GET_PREDICTOR_SUCCESS = exports.GET_PREDICTOR_REQUEST = exports.GET_PREDICTOR = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getPredictor = getPredictor;
exports.createPredictor = createPredictor;
exports.updatePredictor = updatePredictor;
exports.deletePredictor = deletePredictor;
exports.getPredictorProcesses = getPredictorProcesses;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_PREDICTOR'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_PREDICTOR = _api$buildTypes2[0],
    GET_PREDICTOR_REQUEST = _api$buildTypes2[1],
    GET_PREDICTOR_SUCCESS = _api$buildTypes2[2],
    GET_PREDICTOR_FAILURE = _api$buildTypes2[3];
exports.GET_PREDICTOR = GET_PREDICTOR;
exports.GET_PREDICTOR_REQUEST = GET_PREDICTOR_REQUEST;
exports.GET_PREDICTOR_SUCCESS = GET_PREDICTOR_SUCCESS;
exports.GET_PREDICTOR_FAILURE = GET_PREDICTOR_FAILURE;
function getPredictor(_ref) {
  var teamName = _ref.teamName,
      predictorID = _ref.predictorID;

  return {
    type: GET_PREDICTOR,
    payload: {
      url: '/teams/' + teamName + '/predictors/' + predictorID,
      schema: _schemas.PREDICTOR
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('CREATE_PREDICTOR'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var CREATE_PREDICTOR = _api$buildTypes4[0],
    CREATE_PREDICTOR_REQUEST = _api$buildTypes4[1],
    CREATE_PREDICTOR_SUCCESS = _api$buildTypes4[2],
    CREATE_PREDICTOR_FAILURE = _api$buildTypes4[3];
exports.CREATE_PREDICTOR = CREATE_PREDICTOR;
exports.CREATE_PREDICTOR_REQUEST = CREATE_PREDICTOR_REQUEST;
exports.CREATE_PREDICTOR_SUCCESS = CREATE_PREDICTOR_SUCCESS;
exports.CREATE_PREDICTOR_FAILURE = CREATE_PREDICTOR_FAILURE;
function createPredictor(_ref2) {
  var teamName = _ref2.teamName,
      tableID = _ref2.tableID,
      dependentFieldName = _ref2.dependentFieldName,
      displayName = _ref2.displayName,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'binary' : _ref2$type;

  return {
    type: CREATE_PREDICTOR,
    payload: {
      options: {
        method: 'POST',
        body: {
          teamName: teamName,
          tableID: tableID,
          dependentFieldName: dependentFieldName,
          displayName: displayName,
          type: type
        }
      },
      url: '/teams/' + teamName + '/predictors',
      schema: _schemas.PREDICTOR
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_PREDICTOR'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_PREDICTOR = _api$buildTypes6[0],
    UPDATE_PREDICTOR_REQUEST = _api$buildTypes6[1],
    UPDATE_PREDICTOR_SUCCESS = _api$buildTypes6[2],
    UPDATE_PREDICTOR_FAILURE = _api$buildTypes6[3];
exports.UPDATE_PREDICTOR = UPDATE_PREDICTOR;
exports.UPDATE_PREDICTOR_REQUEST = UPDATE_PREDICTOR_REQUEST;
exports.UPDATE_PREDICTOR_SUCCESS = UPDATE_PREDICTOR_SUCCESS;
exports.UPDATE_PREDICTOR_FAILURE = UPDATE_PREDICTOR_FAILURE;
function updatePredictor(_ref3) {
  var teamName = _ref3.teamName,
      predictorID = _ref3.predictorID,
      tableID = _ref3.tableID,
      dependentFieldName = _ref3.dependentFieldName,
      displayName = _ref3.displayName,
      type = _ref3.type;

  return {
    type: UPDATE_PREDICTOR,
    payload: {
      options: {
        method: 'POST',
        body: {
          teamName: teamName,
          tableID: tableID,
          dependentFieldName: dependentFieldName,
          displayName: displayName,
          type: type
        }
      },
      url: '/teams/' + teamName + '/predictors/' + predictorID,
      schema: _schemas.PREDICTOR
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('DELETE_PREDICTOR'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var DELETE_PREDICTOR = _api$buildTypes8[0],
    DELETE_PREDICTOR_REQUEST = _api$buildTypes8[1],
    DELETE_PREDICTOR_SUCCESS = _api$buildTypes8[2],
    DELETE_PREDICTOR_FAILURE = _api$buildTypes8[3];
exports.DELETE_PREDICTOR = DELETE_PREDICTOR;
exports.DELETE_PREDICTOR_REQUEST = DELETE_PREDICTOR_REQUEST;
exports.DELETE_PREDICTOR_SUCCESS = DELETE_PREDICTOR_SUCCESS;
exports.DELETE_PREDICTOR_FAILURE = DELETE_PREDICTOR_FAILURE;
function deletePredictor(_ref4) {
  var teamName = _ref4.teamName,
      predictorID = _ref4.predictorID;

  return {
    type: DELETE_PREDICTOR,
    predictorID: predictorID,
    payload: {
      options: { method: 'DELETE' },
      url: '/teams/' + teamName + '/predictors/' + predictorID,
      schema: _schemas.PREDICTOR
    }
  };
}

var _api$buildTypes9 = _api2.default.buildTypes('GET_PREDICTOR_PROCESSES'),
    _api$buildTypes10 = _slicedToArray(_api$buildTypes9, 4);

var GET_PREDICTOR_PROCESSES = _api$buildTypes10[0],
    GET_PREDICTOR_PROCESSES_REQUEST = _api$buildTypes10[1],
    GET_PREDICTOR_PROCESSES_SUCCESS = _api$buildTypes10[2],
    GET_PREDICTOR_PROCESSES_FAILURE = _api$buildTypes10[3];
exports.GET_PREDICTOR_PROCESSES = GET_PREDICTOR_PROCESSES;
exports.GET_PREDICTOR_PROCESSES_REQUEST = GET_PREDICTOR_PROCESSES_REQUEST;
exports.GET_PREDICTOR_PROCESSES_SUCCESS = GET_PREDICTOR_PROCESSES_SUCCESS;
exports.GET_PREDICTOR_PROCESSES_FAILURE = GET_PREDICTOR_PROCESSES_FAILURE;
function getPredictorProcesses(_ref5) {
  var teamName = _ref5.teamName,
      predictorID = _ref5.predictorID;

  return {
    type: GET_PREDICTOR_PROCESSES,
    payload: {
      url: '/teams/' + teamName + '/predictors/' + predictorID + '/parentprocesses',
      schema: _schemas.PROCESS_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_THREAD_LIST_FAILURE = exports.GET_THREAD_LIST_SUCCESS = exports.GET_THREAD_LIST_REQUEST = exports.GET_THREAD_LIST = exports.GET_THREAD_FAILURE = exports.GET_THREAD_SUCCESS = exports.GET_THREAD_REQUEST = exports.GET_THREAD = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getRunThread = getRunThread;
exports.getThreadList = getThreadList;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_THREAD'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_THREAD = _api$buildTypes2[0],
    GET_THREAD_REQUEST = _api$buildTypes2[1],
    GET_THREAD_SUCCESS = _api$buildTypes2[2],
    GET_THREAD_FAILURE = _api$buildTypes2[3];
exports.GET_THREAD = GET_THREAD;
exports.GET_THREAD_REQUEST = GET_THREAD_REQUEST;
exports.GET_THREAD_SUCCESS = GET_THREAD_SUCCESS;
exports.GET_THREAD_FAILURE = GET_THREAD_FAILURE;
function getRunThread(_ref) {
  var teamName = _ref.teamName,
      runID = _ref.runID,
      _ref$includeChildren = _ref.includeChildren,
      includeChildren = _ref$includeChildren === undefined ? true : _ref$includeChildren;

  return {
    type: GET_THREAD,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/thread?includeChildren=' + includeChildren,
      schema: _schemas.THREAD,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('GET_THREAD'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var GET_THREAD_LIST = _api$buildTypes4[0],
    GET_THREAD_LIST_REQUEST = _api$buildTypes4[1],
    GET_THREAD_LIST_SUCCESS = _api$buildTypes4[2],
    GET_THREAD_LIST_FAILURE = _api$buildTypes4[3];
exports.GET_THREAD_LIST = GET_THREAD_LIST;
exports.GET_THREAD_LIST_REQUEST = GET_THREAD_LIST_REQUEST;
exports.GET_THREAD_LIST_SUCCESS = GET_THREAD_LIST_SUCCESS;
exports.GET_THREAD_LIST_FAILURE = GET_THREAD_LIST_FAILURE;
function getThreadList(_ref2) {
  var teamName = _ref2.teamName,
      _ref2$includeChildren = _ref2.includeChildren,
      includeChildren = _ref2$includeChildren === undefined ? true : _ref2$includeChildren;

  return {
    type: GET_THREAD_LIST,
    payload: {
      url: '/teams/' + teamName + '/threads?includeChildren=' + includeChildren,
      schema: _schemas.THREAD_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = ActivityListItemSecondaryAction;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemSecondaryAction', function (theme) {
  return {
    root: _defineProperty({
      flex: '1 0 auto',
      textAlign: 'left',
      padding: 0,
      minWidth: theme.typography.rhythmByUnit(11)
    }, theme.breakpoints.up('sm'), {
      textAlign: 'right'
    })
  };
});

function ActivityListItemSecondaryAction(props, context) {
  var className = props.className,
      children = props.children,
      other = _objectWithoutProperties(props, ['className', 'children']);

  var classes = context.styleManager.render(styleSheet);

  return _react2['default'].createElement(
    'div',
    _extends({ className: (0, _classnames2['default'])(classes.root, className) }, other),
    children
  );
}

ActivityListItemSecondaryAction.displayName = 'ActivityListItemSecondaryAction';

ActivityListItemSecondaryAction.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(192);

var _curry2 = /*#__PURE__*/__webpack_require__(249);

var _isPlaceholder = /*#__PURE__*/__webpack_require__(260);

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}
module.exports = _curry3;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_PROCESSES_FAILURE = exports.GET_PROCESSES_SUCCESS = exports.GET_PROCESSES_REQUEST = exports.GET_PROCESSES = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getProcessList = getProcessList;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_PROCESSES'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_PROCESSES = _api$buildTypes2[0],
    GET_PROCESSES_REQUEST = _api$buildTypes2[1],
    GET_PROCESSES_SUCCESS = _api$buildTypes2[2],
    GET_PROCESSES_FAILURE = _api$buildTypes2[3];
exports.GET_PROCESSES = GET_PROCESSES;
exports.GET_PROCESSES_REQUEST = GET_PROCESSES_REQUEST;
exports.GET_PROCESSES_SUCCESS = GET_PROCESSES_SUCCESS;
exports.GET_PROCESSES_FAILURE = GET_PROCESSES_FAILURE;
function getProcessList(_ref) {
  var teamName = _ref.teamName,
      _ref$isArchived = _ref.isArchived,
      isArchived = _ref$isArchived === undefined ? null : _ref$isArchived;

  return {
    type: GET_PROCESSES,
    payload: {
      url: '/teams/' + teamName + '/processes' + (isArchived !== null ? '?isArchived=' + isArchived : ''),
      schema: _schemas.PROCESS_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(57),
    basePullAt = __webpack_require__(1308);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = (_temp = _class = function (_SvgIcon) {
  _inherits(Calendar, _SvgIcon);

  function Calendar() {
    _classCallCheck(this, Calendar);

    return _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).apply(this, arguments));
  }

  _createClass(Calendar, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { 'data-name': 'Layer 3' },
            _react2['default'].createElement('path', { d: 'M34.35 28.73V3.86a1.45 1.45 0 0 0-1.45-1.45h-3.82v-1a1.45 1.45 0 1 0-2.9 0v1H19v-1a1.45 1.45 0 1 0-2.9 0v1H8.83v-1a1.45 1.45 0 0 0-2.9 0v1H1.45A1.45 1.45 0 0 0 0 3.86v30a1.45 1.45 0 0 0 1.45 1.45h26.24a1.45 1.45 0 0 0 1-.42l5.22-5.22a2 2 0 0 0 .29-.43.56.56 0 0 1 0-.12 1.86 1.86 0 0 0 .15-.39zm-31.88-17h29.42v15.63H28.1a1.49 1.49 0 0 0-1.49 1.49v3.89H2.47z' }),
            _react2['default'].createElement('path', { d: 'M12 21.15a2.76 2.76 0 0 0 .91-.22 1.72 1.72 0 0 0 .7-.51 1.43 1.43 0 0 0 .27-.91 1.59 1.59 0 0 0-.56-1.3 2 2 0 0 0-1.3-.45 1.82 1.82 0 0 0-1.54.67 2.58 2.58 0 0 0-.5 1.69h-2.5a5.49 5.49 0 0 1 .36-1.86 4.16 4.16 0 0 1 .93-1.44 4 4 0 0 1 1.42-.94 5 5 0 0 1 1.81-.33 5.41 5.41 0 0 1 1.58.24 4.4 4.4 0 0 1 1.42.71 3.66 3.66 0 0 1 1 1.15 3.07 3.07 0 0 1 .4 1.56 3.2 3.2 0 0 1-.46 1.7 2.34 2.34 0 0 1-1.39 1A2.88 2.88 0 0 1 16.33 23a3.07 3.07 0 0 1 .67 1.94 4.09 4.09 0 0 1-.41 1.85 4 4 0 0 1-1.08 1.35 4.55 4.55 0 0 1-1.61.86 6 6 0 0 1-1.84.29 6.18 6.18 0 0 1-2-.32A4.24 4.24 0 0 1 8.48 28a4 4 0 0 1-1-1.5 5.15 5.15 0 0 1-.34-2H9.7a3.75 3.75 0 0 0 .17 1 2.52 2.52 0 0 0 .43.83 2.15 2.15 0 0 0 .71.55 2.43 2.43 0 0 0 2.54-.35 1.93 1.93 0 0 0 .62-1.53 1.86 1.86 0 0 0-.3-1.15 1.62 1.62 0 0 0-.74-.58 3.11 3.11 0 0 0-1-.21h-1v-1.91a4.81 4.81 0 0 0 .87 0zM22 29v-8.55h-3.31v-2a6.59 6.59 0 0 0 1.31-.12 3.49 3.49 0 0 0 1.17-.43 2.83 2.83 0 0 0 .87-.82 3 3 0 0 0 .48-1.26h2.13V29z' })
          )
        );
      }

      return render;
    }()
  }]);

  return Calendar;
}(_SvgIcon3['default']), _class.defaultProps = {
  preserveAspectRatio: 'xMidYMin',
  viewBox: '0 0 34.36 35.33'
}, _temp);
exports['default'] = Calendar;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeBoldSpan = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.transform = transform;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.throttle = throttle;
exports.createChainedFunction = createChainedFunction;

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Text = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var maybeBoldSpan = function maybeBoldSpan(bold) {
  function MaybeBoldSpan(_ref) {
    var spanRef = _ref.spanRef,
        props = _objectWithoutProperties(_ref, ['spanRef']);

    var Span = bold ? _Text.Body2 : _Text.Body1;
    return _react2['default'].createElement(Span, _extends({ component: 'span', componentRef: spanRef }, props));
  }
  MaybeBoldSpan.propTypes = {
    spanRef: _PropTypes2['default'].func
  };
  MaybeBoldSpan.defaultProps = {
    spanRef: function () {
      function spanRef() {}

      return spanRef;
    }()
  };
  MaybeBoldSpan.displayName = 'MaybeBoldSpan';
  return MaybeBoldSpan;
};

exports.maybeBoldSpan = maybeBoldSpan;
function transform(obj, cb, accumulator) {
  Object.keys(obj).forEach(function (key) {
    cb(accumulator, obj[key], key);
  });
  return accumulator;
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : _typeof(pred);
  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

function throttle(fn, limit) {
  var wait = false;
  return function () {
    function throttledFn() {
      if (!wait) {
        fn.call();
        wait = true;
        return setTimeout(function () {
          wait = false;
        }, limit);
      }
      return null;
    }

    return throttledFn;
  }();
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function () {
      function chainedFunction() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        acc.apply(this, args);
        f.apply(this, args);
      }

      return chainedFunction;
    }();
  }, null);
}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SegmentedProgress', function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      height: theme.typography.verticalScaledRhythmByPixel(13).lineHeight,
      color: theme.palette.text.highlight
    },
    error: {
      color: theme.palette.text.error
    },
    segment: {
      marginRight: 1,
      width: '1em',
      height: '1em',
      borderRadius: theme.variables.borderRadius,
      backgroundColor: theme.palette.background['default']
    },
    shaded: {
      backgroundColor: 'currentColor'
    }
  };
});

var SegmentedProgress = (_temp2 = _class = function (_Component) {
  _inherits(SegmentedProgress, _Component);

  function SegmentedProgress() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SegmentedProgress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SegmentedProgress.__proto__ || Object.getPrototypeOf(SegmentedProgress)).call.apply(_ref, [this].concat(args))), _this), _this.getSegments = function (_ref2) {
      var segmentSize = _ref2.segmentSize,
          valuemax = _ref2.valuemax;
      return ' '.repeat(segmentSize).split('').map(function (v, i) {
        return Math.ceil(i === 0 ? i : i * (valuemax / (segmentSize - 1)) - 1);
      });
    }, _this.getTitle = function (_ref3) {
      var value = _ref3.value,
          valuemax = _ref3.valuemax;
      return Math.round(value / valuemax * 100) + '%';
    }, _this.state = {
      segmentSize: _this.getSegments(_this.props),
      title: _this.getTitle(_this.props)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SegmentedProgress, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(props) {
        if (props.segmentSize === this.props.segmentSize && props.value === this.props.value && props.valuemax === this.props.valuemax) {
          return;
        }

        this.setState({
          segmentSize: this.getSegments(props),
          title: this.getTitle(props)
        });
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            error = _props.error,
            segmentSizeProp = _props.segmentSize,
            value = _props.value,
            valuemax = _props.valuemax,
            other = _objectWithoutProperties(_props, ['className', 'error', 'segmentSize', 'value', 'valuemax']);

        var _state = this.state,
            segmentSize = _state.segmentSize,
            title = _state.title;

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.error, error), classNameProp);
        var segmentClassName = function () {
          function segmentClassName(percent) {
            return (0, _classnames2['default'])(classes.segment, _defineProperty({}, classes.shaded, value > percent));
          }

          return segmentClassName;
        }();

        return _react2['default'].createElement(
          'div',
          _extends({
            'aria-valuemax': '' + valuemax // eslint-disable-line jsx-a11y/aria-proptypes
            , 'aria-valuemin': '0',
            'aria-valuenow': '' + value // eslint-disable-line jsx-a11y/aria-proptypes
            , className: rootClassName,
            role: 'progressbar'
          }, Object.assign({ title: title }, other)),
          segmentSize.map(function (percent, i) {
            return _react2['default'].createElement('div', { className: segmentClassName(percent), key: i });
          })
        );
      }

      return render;
    }()
  }]);

  return SegmentedProgress;
}(_react.Component), _class.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, segment elements have 'error' color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * The number of segments.
   */
  segmentSize: _PropTypes2['default'].number,
  /**
   * The value of progress.
   */
  value: _PropTypes2['default'].number,
  /**
   * The max value of progress.
   */
  valuemax: _PropTypes2['default'].number
}, _class.defaultProps = {
  error: false,
  segmentSize: 6,
  value: 0,
  valuemax: 100
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = SegmentedProgress;


SegmentedProgress.displayName = 'SegmentedProgress';

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(368);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(833),
    getTag = __webpack_require__(424),
    isArguments = __webpack_require__(427),
    isArray = __webpack_require__(70),
    isArrayLike = __webpack_require__(266),
    isBuffer = __webpack_require__(425),
    isPrototype = __webpack_require__(835),
    isTypedArray = __webpack_require__(634);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemAvatar', function (theme) {
  return {
    root: {
      alignItems: 'center',
      alignSelf: 'center',
      display: 'flex',
      fontSize: theme.typography.rhythmByUnit(3.5),
      height: theme.typography.rhythmByUnit(4)
    }
  };
});

var ActivityListItemAvatar = (_temp = _class = function (_React$Component) {
  _inherits(ActivityListItemAvatar, _React$Component);

  function ActivityListItemAvatar() {
    _classCallCheck(this, ActivityListItemAvatar);

    return _possibleConstructorReturn(this, (ActivityListItemAvatar.__proto__ || Object.getPrototypeOf(ActivityListItemAvatar)).apply(this, arguments));
  }

  _createClass(ActivityListItemAvatar, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            Component = _props.component,
            props = _objectWithoutProperties(_props, ['className', 'component']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);

        return _react2['default'].createElement(Component, Object.assign({}, props, { className: className }));
      }

      return render;
    }()
  }]);

  return ActivityListItemAvatar;
}(_react2['default'].Component), _class.displayName = 'ActivityListItemAvatar', _class.defaultProps = {
  component: 'div'
}, _class.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
}, _temp);
exports['default'] = ActivityListItemAvatar;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _Text = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListItemText', function (theme) {
  return {
    root: {
      flex: '1 1 auto',
      padding: '0 ' + theme.typography.rhythmByUnit(1),
      '&:first-child': {
        paddingLeft: 0
      },
      '&:last-child': {
        paddingRight: 0
      }
    },
    caption: {
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    flexDisplay: {
      display: 'flex'
    },
    inherit: {
      color: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit'
    },
    inset: {
      '&:first-child': {
        paddingLeft: theme.typography.rhythmByUnit(7)
      }
    },
    noWrap: theme.mixins.truncate({
      minWidth: 0
    }),
    primaryFlex: {
      flex: '1 1 auto'
    },
    selected: {
      fontWeight: theme.typography.fontWeightHeavy
    }
  };
});

var truncate = function truncate(text) {
  return text.length > 500 ? text.substr(0, 500) + '...' : text;
};

var ListItemText = (_temp = _class = function (_PureComponent) {
  _inherits(ListItemText, _PureComponent);

  function ListItemText() {
    _classCallCheck(this, ListItemText);

    return _possibleConstructorReturn(this, (ListItemText.__proto__ || Object.getPrototypeOf(ListItemText)).apply(this, arguments));
  }

  _createClass(ListItemText, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames2;

        var _props = this.props,
            caption = _props.caption,
            classNameProp = _props.className,
            inherit = _props.inherit,
            inset = _props.inset,
            noWrap = _props.noWrap,
            primary = _props.primary,
            primaryClassNameProp = _props.primaryClassName,
            secondary = _props.secondary,
            secondaryClassName = _props.secondaryClassName,
            selected = _props.selected,
            other = _objectWithoutProperties(_props, ['caption', 'className', 'inherit', 'inset', 'noWrap', 'primary', 'primaryClassName', 'secondary', 'secondaryClassName', 'selected']);

        var hasCaption = caption !== undefined;
        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.inset, inset), _defineProperty(_classNames, classes.noWrap, noWrap), _classNames), classNameProp);
        var primaryClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, classes.inherit, inherit), _defineProperty(_classNames2, classes.primaryFlex, hasCaption), _defineProperty(_classNames2, classes.selected, selected), _classNames2), primaryClassNameProp);

        return _react2['default'].createElement(
          'div',
          _extends({ className: className }, other),
          primary && (typeof primary !== 'string' ? primary : caption === undefined ? _react2['default'].createElement(
            _Text.Headline,
            _extends({
              className: primaryClassName
            }, { noWrap: noWrap }, {
              title: primary
            }),
            truncate(primary)
          ) : _react2['default'].createElement(
            'div',
            { className: classes.flexDisplay },
            _react2['default'].createElement(
              _Text.Headline,
              _extends({
                className: primaryClassName
              }, { noWrap: noWrap }, {
                title: primary
              }),
              truncate(primary)
            ),
            typeof caption === 'string' ? _react2['default'].createElement(
              _Text.Caption,
              { className: classes.caption, secondary: true },
              caption
            ) : caption
          )),
          secondary && (typeof secondary === 'string' ? _react2['default'].createElement(
            _Text.Body1,
            _extends({ className: secondaryClassName, secondary: true }, { noWrap: noWrap }),
            secondary
          ) : secondary)
        );
      }

      return render;
    }()
  }]);

  return ListItemText;
}(_react.PureComponent), _class.propTypes = {
  caption: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, the primary element will inherit text styles.
   */
  inherit: _PropTypes2['default'].bool,
  /**
   * If true, the children will be indented by 72px.
   * This is useful if there is no left avatar or left icon.
   */
  inset: _PropTypes2['default'].bool,
  /**
   * If `false`, the text will wrap
   */
  noWrap: _PropTypes2['default'].bool,
  primary: _PropTypes2['default'].node,
  /**
   * The CSS class name of the primary element.
   */
  primaryClassName: _PropTypes2['default'].string,
  secondary: _PropTypes2['default'].node,
  /**
   * The CSS class name of the secondary element.
   */
  secondaryClassName: _PropTypes2['default'].string,
  /**
   * Use to apply selected styling.
   */
  selected: _PropTypes2['default'].bool
}, _class.defaultProps = {
  inherit: false,
  inset: false,
  noWrap: false,
  primary: false,
  secondary: false,
  selected: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = ListItemText;


ListItemText.displayName = 'ListItemText';

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavigationMoreVert = function (_SvgIcon) {
  _inherits(NavigationMoreVert, _SvgIcon);

  function NavigationMoreVert() {
    _classCallCheck(this, NavigationMoreVert);

    return _possibleConstructorReturn(this, (NavigationMoreVert.__proto__ || Object.getPrototypeOf(NavigationMoreVert)).apply(this, arguments));
  }

  _createClass(NavigationMoreVert, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
        );
      }

      return render;
    }()
  }]);

  return NavigationMoreVert;
}(_SvgIcon3['default']);

exports['default'] = NavigationMoreVert;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_COMMENT_FAILURE = exports.ADD_COMMENT_SUCCESS = exports.ADD_COMMENT_REQUEST = exports.ADD_COMMENT = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// comment API still returns old-style messages


exports.addComment = addComment;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('ADD_COMMENT'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var ADD_COMMENT = _api$buildTypes2[0],
    ADD_COMMENT_REQUEST = _api$buildTypes2[1],
    ADD_COMMENT_SUCCESS = _api$buildTypes2[2],
    ADD_COMMENT_FAILURE = _api$buildTypes2[3];
exports.ADD_COMMENT = ADD_COMMENT;
exports.ADD_COMMENT_REQUEST = ADD_COMMENT_REQUEST;
exports.ADD_COMMENT_SUCCESS = ADD_COMMENT_SUCCESS;
exports.ADD_COMMENT_FAILURE = ADD_COMMENT_FAILURE;
function addComment(_ref) {
  var teamName = _ref.teamName,
      runID = _ref.runID,
      body = _ref.body;

  return {
    type: ADD_COMMENT,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/comments',
      schema: _schemas.MESSAGE,
      options: {
        method: 'POST',

        // JSON payload is { body: "content of message" }
        body: {
          body: body
        }
      }
    }
  };
}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isArray = __webpack_require__(27),
    isObjectLike = __webpack_require__(107);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Handlebars = (_temp = _class = function (_SvgIcon) {
  _inherits(Handlebars, _SvgIcon);

  function Handlebars() {
    _classCallCheck(this, Handlebars);

    return _possibleConstructorReturn(this, (Handlebars.__proto__ || Object.getPrototypeOf(Handlebars)).apply(this, arguments));
  }

  _createClass(Handlebars, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M32 0H4a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zM13.92 10.24a2.52 2.52 0 0 0-1.6.41 1.61 1.61 0 0 0-.44 1.24v3.5c0 1.47-.91 2.33-2.74 2.61v.14c1.83.27 2.74 1.13 2.74 2.59v3.5a1.55 1.55 0 0 0 .45 1.24 2.49 2.49 0 0 0 1.59.41v2.65a12.17 12.17 0 0 1-3.05-.3 2.8 2.8 0 0 1-1.59-1 3.32 3.32 0 0 1-.49-2v-3.66A1.77 1.77 0 0 0 8 20a4.22 4.22 0 0 0-2.23-.48v-2.8A4.33 4.33 0 0 0 8 16.2a1.76 1.76 0 0 0 .77-1.61v-3.73a3.37 3.37 0 0 1 .48-2 2.85 2.85 0 0 1 1.58-1 12.11 12.11 0 0 1 3.07-.31zm16.29 9.23A4.22 4.22 0 0 0 28 20a1.77 1.77 0 0 0-.77 1.62v3.69a3.36 3.36 0 0 1-.48 2 2.8 2.8 0 0 1-1.59 1 11.73 11.73 0 0 1-3.06.31v-2.74a2.52 2.52 0 0 0 1.6-.42 1.6 1.6 0 0 0 .44-1.23v-3.5c0-1.46.91-2.32 2.73-2.59V18c-1.82-.28-2.73-1.14-2.73-2.61v-3.5a1.58 1.58 0 0 0-.44-1.22 2.53 2.53 0 0 0-1.6-.43V7.6a11.65 11.65 0 0 1 3.05.31 2.74 2.74 0 0 1 1.59 1 3.28 3.28 0 0 1 .49 2v3.73A1.76 1.76 0 0 0 28 16.2a4.33 4.33 0 0 0 2.23.47z' })
        );
      }

      return render;
    }()
  }]);

  return Handlebars;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 36 36'
}, _temp);
exports['default'] = Handlebars;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TYPE = exports.TYPE = {
  BINARY: 'application/octet-stream',
  GIF: 'image/gif',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  TEXT: 'text/plain'
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_CREDENTIALS_FAILURE = exports.GET_CREDENTIALS_SUCCESS = exports.GET_CREDENTIALS_REQUEST = exports.GET_CREDENTIALS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // TODO this will be deprecated after https://github.com/catalyticlabs/pushbot-api/pull/6643

exports.getCredentials = getCredentials;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_CREDENTIALS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_CREDENTIALS = _api$buildTypes2[0],
    GET_CREDENTIALS_REQUEST = _api$buildTypes2[1],
    GET_CREDENTIALS_SUCCESS = _api$buildTypes2[2],
    GET_CREDENTIALS_FAILURE = _api$buildTypes2[3];
exports.GET_CREDENTIALS = GET_CREDENTIALS;
exports.GET_CREDENTIALS_REQUEST = GET_CREDENTIALS_REQUEST;
exports.GET_CREDENTIALS_SUCCESS = GET_CREDENTIALS_SUCCESS;
exports.GET_CREDENTIALS_FAILURE = GET_CREDENTIALS_FAILURE;
function getCredentials(_ref) {
  var teamName = _ref.teamName;

  return {
    type: GET_CREDENTIALS,
    payload: {
      url: '/teams/' + teamName + '/credentials',
      schema: _schemas.CREDENTIAL_LIST
    }
  };
}

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemContainer', function (theme) {
  return {
    root: Object.assign({}, theme.mixins.gutters(2), _defineProperty({
      paddingTop: theme.typography.rhythmByUnit(2),
      paddingBottom: theme.typography.rhythmByUnit(2)
    }, theme.breakpoints.up('sm'), {
      marginRight: theme.typography.rhythmByUnit(4.75),
      marginLeft: theme.typography.rhythmByUnit(4.75)
    }))
  };
});

var ActivityListItemContainer = (_temp = _class = function (_React$Component) {
  _inherits(ActivityListItemContainer, _React$Component);

  function ActivityListItemContainer() {
    _classCallCheck(this, ActivityListItemContainer);

    return _possibleConstructorReturn(this, (ActivityListItemContainer.__proto__ || Object.getPrototypeOf(ActivityListItemContainer)).apply(this, arguments));
  }

  _createClass(ActivityListItemContainer, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            Component = _props.component,
            props = _objectWithoutProperties(_props, ['className', 'component']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);

        return _react2['default'].createElement(Component, Object.assign({}, props, { className: className }));
      }

      return render;
    }()
  }]);

  return ActivityListItemContainer;
}(_react2['default'].Component), _class.defaultProps = {
  component: 'div'
}, _class.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
}, _temp);
exports['default'] = ActivityListItemContainer;


ActivityListItemContainer.displayName = 'ActivityListItemContainer';

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemFooter', function (theme) {
  return {
    root: Object.assign({
      alignItems: 'center',
      paddingBottom: theme.typography.rhythmByUnit(3)
    }, theme.mixins.gutters(2), _defineProperty({
      flexFlow: 'column'
    }, theme.breakpoints.up('sm'), Object.assign({
      flexFlow: 'row',
      justifyContent: 'flex-end'
    }, theme.mixins.gutters(3)))),
    child: _defineProperty({
      display: 'flex',
      justifyContent: 'flex-end',
      flexFlow: 'column',
      '&>*': {
        marginTop: theme.typography.rhythmByUnit(1),
        width: '100%'
      }
    }, theme.breakpoints.up('sm'), {
      flexFlow: 'row',
      '&>*': {
        width: 'auto',
        marginTop: 0,
        marginLeft: theme.typography.rhythmByUnit(1)
      }
    }),
    rootSingleColumn: Object.assign({
      paddingBottom: theme.typography.rhythmByUnit(2)
    }, theme.mixins.gutters(2)),
    childSingleColumn: {
      display: 'flex',
      justifyContent: 'flex-end',
      flexFlow: 'column',
      '&>*': {
        marginTop: theme.typography.rhythmByUnit(1),
        marginLeft: 0,
        width: '100%'
      }
    }
  };
});

var ActivityListItemFooter = (_temp = _class = function (_React$Component) {
  _inherits(ActivityListItemFooter, _React$Component);

  function ActivityListItemFooter() {
    _classCallCheck(this, ActivityListItemFooter);

    return _possibleConstructorReturn(this, (ActivityListItemFooter.__proto__ || Object.getPrototypeOf(ActivityListItemFooter)).apply(this, arguments));
  }

  _createClass(ActivityListItemFooter, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            childrenProp = _props.children,
            classNameProp = _props.className,
            Component = _props.component,
            singleColumn = _props.singleColumn,
            props = _objectWithoutProperties(_props, ['children', 'className', 'component', 'singleColumn']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.rootSingleColumn, singleColumn), classNameProp);
        var childClassName = (0, _classnames2['default'])(classes.child, _defineProperty({}, classes.childSingleColumn, singleColumn));
        var children = _react2['default'].createElement(
          'div',
          { className: childClassName },
          childrenProp
        );

        return _react2['default'].createElement(Component, Object.assign({}, props, { children: children, className: className }));
      }

      return render;
    }()
  }]);

  return ActivityListItemFooter;
}(_react2['default'].Component), _class.defaultProps = {
  component: 'div'
}, _class.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
}, _temp);
exports['default'] = ActivityListItemFooter;


ActivityListItemFooter.displayName = 'ActivityListItemFooter';

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Menu = (_temp = _class = function (_SvgIcon) {
  _inherits(Menu, _SvgIcon);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('polygon', { points: '13 11.75 0 11.75 0 10 13 10' }),
          _react2['default'].createElement('polygon', { points: '16 6.75 0 6.75 0 5 16 5' }),
          _react2['default'].createElement('polygon', { points: '14 1.75 0 1.75 0 0 14 0' })
        );
      }

      return render;
    }()
  }]);

  return Menu;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 16 12'
}, _temp);
exports['default'] = Menu;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Member = function (_SvgIcon) {
  _inherits(Member, _SvgIcon);

  function Member() {
    _classCallCheck(this, Member);

    return _possibleConstructorReturn(this, (Member.__proto__ || Object.getPrototypeOf(Member)).apply(this, arguments));
  }

  _createClass(Member, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M21.7,21.8a1.43,1.43,0,0,0-.47-1.59,11.21,11.21,0,0,0-2.33-1.31c-0.21-.1-0.58-0.24-0.94-0.38l-0.73-.29a4.69,4.69,0,0,0-.64-0.3,2.48,2.48,0,0,0,.53-0.8,8.18,8.18,0,0,0,.37-1.85,2.76,2.76,0,0,0,.86-1.39,4.11,4.11,0,0,0,.13-2.78c1-3.46.59-5.49-1.22-6.48-1.13-2.45-3.42-2.39-4.55-2.35H12.31a5,5,0,0,0-1.67.33,1.43,1.43,0,0,0-1.37-.17A5.76,5.76,0,0,0,5.93,5.88a8,8,0,0,0,0,4.81l0,0.18c-0.65.92-.3,2.24,0.14,3.42a1.89,1.89,0,0,0,.71.92,9.89,9.89,0,0,0,.4,1.58,5.88,5.88,0,0,0,.59,1.07v0L7.46,18a7.5,7.5,0,0,0-1.16.27l-0.18.06a10.17,10.17,0,0,0-3.82,2,1.43,1.43,0,0,0-.36,1.57,1.4,1.4,0,0,0,.15.27,12.3,12.3,0,0,1,4.48-2.49l0.18-.06c1.36-.45,2.73,0,2.49-2.21a6.27,6.27,0,0,1-.66-1.09,17.19,17.19,0,0,1-.49-2.23,0.45,0.45,0,0,1-.62-0.25c-0.17-.45-0.87-2.38.08-2.23,0-.92-1.06-3.25-0.29-5.16A4.32,4.32,0,0,1,9.8,3.78c-0.74,1.54,1-.06,2.51-0.06,1.26,0,3-.32,3.8,1.91,0.31,0.42,2.59.15,0.76,5.86,0.73,0,.11,2,0.11,2s-0.27,1-.79.76a21,21,0,0,1-.4,2.39,3.86,3.86,0,0,1-.75.84c-0.41,1.72.56,1.49,1.47,2,0.23,0.13,1.36.53,1.79,0.73,0.62,0.28,2.47.89,3.16,2A1.42,1.42,0,0,0,21.7,21.8Z' })
        );
      }

      return render;
    }()
  }]);

  return Member;
}(_SvgIcon3['default']);

exports['default'] = Member;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _field = __webpack_require__(91);

var _field2 = _interopRequireDefault(_field);

var _upcoming = __webpack_require__(691);

var _upcoming2 = _interopRequireDefault(_upcoming);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars
var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;
exports.default = shape({
  adminUsers: arrayOf(string),
  allowPublicEmailTrigger: bool,
  category: string,
  createdBy: string,
  createdDate: string,
  description: string,
  displayName: string,
  fields: arrayOf(_field2.default),
  fieldVisibility: string,
  fieldVisibleToUsers: arrayOf(string),
  maximumDuration: string,
  onStartMenu: bool,
  owner: string,
  priority: string,
  processID: string,
  processName: string,
  published: bool,
  standardUsers: arrayOf(string),
  stepCount: number,
  teamName: string,
  thumbnail: string,
  upcoming: arrayOf(_upcoming2.default)
});

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.teamName = exports.config = undefined;

var _reselect = __webpack_require__(33);

var config = exports.config = function config() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$config = _ref.config,
      config = _ref$config === undefined ? {} : _ref$config;

  return config;
};

var teamName = exports.teamName = (0, _reselect.createSelector)(config, function (_ref2) {
  var teamName = _ref2.teamName;
  return teamName;
});

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(192);

var _has = /*#__PURE__*/__webpack_require__(324);

var _isArguments = /*#__PURE__*/__webpack_require__(1210);

// cover IE < 9 keys issues


var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/function () {
  'use strict';

  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var _keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
} : function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop in obj) {
    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
};
var keys = /*#__PURE__*/_curry1(_keys);
module.exports = keys;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESERVED_NAMES = exports.RESERVED_NAMES = ['pushbot', 'admin', 'owner', 'public', 'me'];
var RESERVED_NAME_PATTERN = new RegExp('^(' + RESERVED_NAMES.join('|') + ')$', 'i');
var CLEAN_EMAIL = /(@.*|[^0-9a-z_]*)/g;

var usernameFromEmail = exports.usernameFromEmail = function usernameFromEmail(email) {
  return email.replace(CLEAN_EMAIL, '');
};
var isReservedName = exports.isReservedName = function isReservedName(value) {
  return RESERVED_NAME_PATTERN.test(value);
};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(57),
    negate = __webpack_require__(1227),
    pickBy = __webpack_require__(1228);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(198),
    createAggregator = __webpack_require__(797);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(507),
    keys = __webpack_require__(154);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_STEPS_FAILURE = exports.UPDATE_STEPS_SUCCESS = exports.UPDATE_STEPS_REQUEST = exports.UPDATE_STEPS = exports.GET_STEPS_FAILURE = exports.GET_STEPS_SUCCESS = exports.GET_STEPS_REQUEST = exports.GET_STEPS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getStepList = getStepList;
exports.updateStepList = updateStepList;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_STEPS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_STEPS = _api$buildTypes2[0],
    GET_STEPS_REQUEST = _api$buildTypes2[1],
    GET_STEPS_SUCCESS = _api$buildTypes2[2],
    GET_STEPS_FAILURE = _api$buildTypes2[3];
exports.GET_STEPS = GET_STEPS;
exports.GET_STEPS_REQUEST = GET_STEPS_REQUEST;
exports.GET_STEPS_SUCCESS = GET_STEPS_SUCCESS;
exports.GET_STEPS_FAILURE = GET_STEPS_FAILURE;
function getStepList(_ref) {
  var teamName = _ref.teamName,
      processName = _ref.processName;

  return {
    type: GET_STEPS,
    payload: {
      processID: processName,
      url: '/teams/' + teamName + '/processes/' + processName + '/steps',
      schema: _schemas.STEP_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('UPDATE_STEPS'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var UPDATE_STEPS = _api$buildTypes4[0],
    UPDATE_STEPS_REQUEST = _api$buildTypes4[1],
    UPDATE_STEPS_SUCCESS = _api$buildTypes4[2],
    UPDATE_STEPS_FAILURE = _api$buildTypes4[3];
exports.UPDATE_STEPS = UPDATE_STEPS;
exports.UPDATE_STEPS_REQUEST = UPDATE_STEPS_REQUEST;
exports.UPDATE_STEPS_SUCCESS = UPDATE_STEPS_SUCCESS;
exports.UPDATE_STEPS_FAILURE = UPDATE_STEPS_FAILURE;
function updateStepList(_ref2) {
  var teamName = _ref2.teamName,
      processName = _ref2.processName,
      _ref2$steps = _ref2.steps,
      steps = _ref2$steps === undefined ? {} : _ref2$steps;

  return {
    type: UPDATE_STEPS,
    payload: {
      processID: processName,
      url: '/teams/' + teamName + '/processes/' + processName + '/steps',
      schema: _schemas.STEP_LIST,
      options: {
        method: 'PUT',
        body: steps
      }
    }
  };
}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1282);


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_GROUP_MEMBERS_FAILURE = exports.GET_GROUP_MEMBERS_SUCCESS = exports.GET_GROUP_MEMBERS_REQUEST = exports.GET_GROUP_MEMBERS = exports.DELETE_GROUP_FAILURE = exports.DELETE_GROUP_SUCCESS = exports.DELETE_GROUP_REQUEST = exports.DELETE_GROUP = exports.UPDATE_GROUP_FAILURE = exports.UPDATE_GROUP_SUCCESS = exports.UPDATE_GROUP_REQUEST = exports.UPDATE_GROUP = exports.CREATE_GROUP_FAILURE = exports.CREATE_GROUP_SUCCESS = exports.CREATE_GROUP_REQUEST = exports.CREATE_GROUP = exports.GET_GROUP_FAILURE = exports.GET_GROUP_SUCCESS = exports.GET_GROUP_REQUEST = exports.GET_GROUP = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getGroup = getGroup;
exports.createGroup = createGroup;
exports.updateGroup = updateGroup;
exports.deleteGroup = deleteGroup;
exports.getGroupMembers = getGroupMembers;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_GROUP'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_GROUP = _api$buildTypes2[0],
    GET_GROUP_REQUEST = _api$buildTypes2[1],
    GET_GROUP_SUCCESS = _api$buildTypes2[2],
    GET_GROUP_FAILURE = _api$buildTypes2[3];

/**
 * GET a specific group
 * @param teamName {string}
 * @param {string} groupName - The `username` of the group.
 */

exports.GET_GROUP = GET_GROUP;
exports.GET_GROUP_REQUEST = GET_GROUP_REQUEST;
exports.GET_GROUP_SUCCESS = GET_GROUP_SUCCESS;
exports.GET_GROUP_FAILURE = GET_GROUP_FAILURE;
function getGroup(_ref) {
  var teamName = _ref.teamName,
      groupName = _ref.groupName;

  return {
    type: GET_GROUP,
    payload: {
      url: '/teams/' + teamName + '/groups/' + groupName,
      schema: _schemas.GROUP,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('CREATE_GROUP'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var CREATE_GROUP = _api$buildTypes4[0],
    CREATE_GROUP_REQUEST = _api$buildTypes4[1],
    CREATE_GROUP_SUCCESS = _api$buildTypes4[2],
    CREATE_GROUP_FAILURE = _api$buildTypes4[3];

/**
 * Create a new group.
 * @param teamName {string}
 * @param {Object} group
 * @param {string} group.username - The name of the group.
 * @param {string} [group.nickname] -  Alternate display name for the group, if the ideal `username` is not available.
 * @param {string[]} [group.members] - Array of team members' `username`s to invite to the group.
 */

exports.CREATE_GROUP = CREATE_GROUP;
exports.CREATE_GROUP_REQUEST = CREATE_GROUP_REQUEST;
exports.CREATE_GROUP_SUCCESS = CREATE_GROUP_SUCCESS;
exports.CREATE_GROUP_FAILURE = CREATE_GROUP_FAILURE;
function createGroup(_ref2) {
  var teamName = _ref2.teamName,
      _ref2$group = _ref2.group,
      group = _ref2$group === undefined ? {} : _ref2$group;

  return {
    type: CREATE_GROUP,
    payload: {
      url: '/teams/' + teamName + '/groups',
      schema: _schemas.GROUP,
      options: {
        method: 'POST',
        body: group
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_GROUP'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_GROUP = _api$buildTypes6[0],
    UPDATE_GROUP_REQUEST = _api$buildTypes6[1],
    UPDATE_GROUP_SUCCESS = _api$buildTypes6[2],
    UPDATE_GROUP_FAILURE = _api$buildTypes6[3];

/**
 * Update an existing group. When updating the list of members in a group (adding or removing members),
 * ensure that the entire new list of users is passed. When adding a member,
 * an invitation notification will automatically be sent.
 *
 * @param {string} teamName - The `username` of the group.
 * @param {Object} group - The updated group object.
 */

exports.UPDATE_GROUP = UPDATE_GROUP;
exports.UPDATE_GROUP_REQUEST = UPDATE_GROUP_REQUEST;
exports.UPDATE_GROUP_SUCCESS = UPDATE_GROUP_SUCCESS;
exports.UPDATE_GROUP_FAILURE = UPDATE_GROUP_FAILURE;
function updateGroup(_ref3) {
  var teamName = _ref3.teamName,
      group = _ref3.group;

  return {
    type: UPDATE_GROUP,
    payload: {
      url: '/teams/' + teamName + '/groups/' + group.username,
      schema: _schemas.GROUP,
      options: {
        method: 'PUT',
        body: group
      }
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('DELETE_GROUP'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var DELETE_GROUP = _api$buildTypes8[0],
    DELETE_GROUP_REQUEST = _api$buildTypes8[1],
    DELETE_GROUP_SUCCESS = _api$buildTypes8[2],
    DELETE_GROUP_FAILURE = _api$buildTypes8[3];

/**
 * Mark a group as archived.
 * @param teamName {string}
 * @param {string} groupName - The `username` of the group to be archived.
 */

exports.DELETE_GROUP = DELETE_GROUP;
exports.DELETE_GROUP_REQUEST = DELETE_GROUP_REQUEST;
exports.DELETE_GROUP_SUCCESS = DELETE_GROUP_SUCCESS;
exports.DELETE_GROUP_FAILURE = DELETE_GROUP_FAILURE;
function deleteGroup(_ref4) {
  var teamName = _ref4.teamName,
      groupName = _ref4.groupName;

  return {
    type: DELETE_GROUP,
    payload: {
      url: '/teams/' + teamName + '/groups/' + groupName,
      schema: _schemas.GROUP,
      options: {
        method: 'DELETE'
      }
    }
  };
}

var _api$buildTypes9 = _api2.default.buildTypes('GET_GROUP_MEMBERS'),
    _api$buildTypes10 = _slicedToArray(_api$buildTypes9, 4);

var GET_GROUP_MEMBERS = _api$buildTypes10[0],
    GET_GROUP_MEMBERS_REQUEST = _api$buildTypes10[1],
    GET_GROUP_MEMBERS_SUCCESS = _api$buildTypes10[2],
    GET_GROUP_MEMBERS_FAILURE = _api$buildTypes10[3];

/**
 * Retrieve the group members as an array of user objects.
 * @param teamName {string}
 * @param {string} groupName - The `username` of the group.
 */

exports.GET_GROUP_MEMBERS = GET_GROUP_MEMBERS;
exports.GET_GROUP_MEMBERS_REQUEST = GET_GROUP_MEMBERS_REQUEST;
exports.GET_GROUP_MEMBERS_SUCCESS = GET_GROUP_MEMBERS_SUCCESS;
exports.GET_GROUP_MEMBERS_FAILURE = GET_GROUP_MEMBERS_FAILURE;
function getGroupMembers(_ref5) {
  var teamName = _ref5.teamName,
      groupName = _ref5.groupName;

  return {
    type: GET_GROUP_MEMBERS,
    payload: {
      url: '/teams/' + teamName + '/groups/' + groupName + '/members',
      schema: _schemas.USER_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_UPCOMING_FAILURE = exports.UPDATE_UPCOMING_SUCCESS = exports.UPDATE_UPCOMING_REQUEST = exports.UPDATE_UPCOMING = exports.DELETE_UPCOMING_FAILURE = exports.DELETE_UPCOMING_SUCCESS = exports.DELETE_UPCOMING_REQUEST = exports.DELETE_UPCOMING = exports.ADD_UPCOMING_FAILURE = exports.ADD_UPCOMING_SUCCESS = exports.ADD_UPCOMING_REQUEST = exports.ADD_UPCOMING = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.addUpcoming = addUpcoming;
exports.deleteUpcoming = deleteUpcoming;
exports.updateUpcoming = updateUpcoming;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line import/named

var _api$buildTypes = _api2.default.buildTypes('ADD_UPCOMING'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var ADD_UPCOMING = _api$buildTypes2[0],
    ADD_UPCOMING_REQUEST = _api$buildTypes2[1],
    ADD_UPCOMING_SUCCESS = _api$buildTypes2[2],
    ADD_UPCOMING_FAILURE = _api$buildTypes2[3];
exports.ADD_UPCOMING = ADD_UPCOMING;
exports.ADD_UPCOMING_REQUEST = ADD_UPCOMING_REQUEST;
exports.ADD_UPCOMING_SUCCESS = ADD_UPCOMING_SUCCESS;
exports.ADD_UPCOMING_FAILURE = ADD_UPCOMING_FAILURE;
function addUpcoming(_ref) {
  var teamName = _ref.teamName,
      upcoming = _ref.upcoming;

  var processID = ((upcoming || {}).eventData || {}).processID;
  return {
    type: ADD_UPCOMING,
    payload: {
      url: 'teams/' + teamName + '/processes/' + processID + '/upcoming',
      schema: _schemas.UPCOMING,
      options: {
        method: 'POST',
        body: upcoming
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('DELETE_UPCOMING'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var DELETE_UPCOMING = _api$buildTypes4[0],
    DELETE_UPCOMING_REQUEST = _api$buildTypes4[1],
    DELETE_UPCOMING_SUCCESS = _api$buildTypes4[2],
    DELETE_UPCOMING_FAILURE = _api$buildTypes4[3];
exports.DELETE_UPCOMING = DELETE_UPCOMING;
exports.DELETE_UPCOMING_REQUEST = DELETE_UPCOMING_REQUEST;
exports.DELETE_UPCOMING_SUCCESS = DELETE_UPCOMING_SUCCESS;
exports.DELETE_UPCOMING_FAILURE = DELETE_UPCOMING_FAILURE;
function deleteUpcoming(_ref2) {
  var teamName = _ref2.teamName,
      upcomingID = _ref2.upcomingID;

  return {
    type: DELETE_UPCOMING,
    payload: {
      url: 'teams/' + teamName + '/upcoming/' + upcomingID,
      schema: _schemas.UPCOMING,
      options: {
        method: 'DELETE'
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_UPCOMING'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_UPCOMING = _api$buildTypes6[0],
    UPDATE_UPCOMING_REQUEST = _api$buildTypes6[1],
    UPDATE_UPCOMING_SUCCESS = _api$buildTypes6[2],
    UPDATE_UPCOMING_FAILURE = _api$buildTypes6[3];
exports.UPDATE_UPCOMING = UPDATE_UPCOMING;
exports.UPDATE_UPCOMING_REQUEST = UPDATE_UPCOMING_REQUEST;
exports.UPDATE_UPCOMING_SUCCESS = UPDATE_UPCOMING_SUCCESS;
exports.UPDATE_UPCOMING_FAILURE = UPDATE_UPCOMING_FAILURE;
function updateUpcoming(_ref3) {
  var teamName = _ref3.teamName,
      upcoming = _ref3.upcoming;

  return {
    type: UPDATE_UPCOMING,
    payload: {
      url: 'teams/' + teamName + '/upcoming/' + upcoming.upcomingID,
      schema: _schemas.UPCOMING,
      options: {
        method: 'PUT',
        body: upcoming
      }
    }
  };
}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_TABLE_ROW_FAILURE = exports.ADD_TABLE_ROW_SUCCESS = exports.ADD_TABLE_ROW_REQUEST = exports.ADD_TABLE_ROW = exports.GET_TABLE_ROWS_FAILURE = exports.GET_TABLE_ROWS_SUCCESS = exports.GET_TABLE_ROWS_REQUEST = exports.GET_TABLE_ROWS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTableRows = getTableRows;
exports.addTableRow = addTableRow;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _url = __webpack_require__(31);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_TABLE_ROWS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TABLE_ROWS = _api$buildTypes2[0],
    GET_TABLE_ROWS_REQUEST = _api$buildTypes2[1],
    GET_TABLE_ROWS_SUCCESS = _api$buildTypes2[2],
    GET_TABLE_ROWS_FAILURE = _api$buildTypes2[3];
exports.GET_TABLE_ROWS = GET_TABLE_ROWS;
exports.GET_TABLE_ROWS_REQUEST = GET_TABLE_ROWS_REQUEST;
exports.GET_TABLE_ROWS_SUCCESS = GET_TABLE_ROWS_SUCCESS;
exports.GET_TABLE_ROWS_FAILURE = GET_TABLE_ROWS_FAILURE;
function getTableRows(_ref) {
  var teamName = _ref.teamName,
      tableID = _ref.tableID,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 10 : _ref$limit,
      _ref$pageToken = _ref.pageToken,
      pageToken = _ref$pageToken === undefined ? 0 : _ref$pageToken;

  var query = {
    limit: limit,
    pageToken: pageToken
  };
  var url = (0, _url.format)({
    pathname: '/teams/' + teamName + '/tables/' + tableID + '/rows',
    query: query
  });
  return {
    type: GET_TABLE_ROWS,
    payload: {
      url: url,
      schema: _schemas.TABLE_ROW_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_TABLE_ROW'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_TABLE_ROW = _api$buildTypes4[0],
    ADD_TABLE_ROW_REQUEST = _api$buildTypes4[1],
    ADD_TABLE_ROW_SUCCESS = _api$buildTypes4[2],
    ADD_TABLE_ROW_FAILURE = _api$buildTypes4[3];
exports.ADD_TABLE_ROW = ADD_TABLE_ROW;
exports.ADD_TABLE_ROW_REQUEST = ADD_TABLE_ROW_REQUEST;
exports.ADD_TABLE_ROW_SUCCESS = ADD_TABLE_ROW_SUCCESS;
exports.ADD_TABLE_ROW_FAILURE = ADD_TABLE_ROW_FAILURE;
function addTableRow(_ref2) {
  var teamName = _ref2.teamName,
      tableID = _ref2.tableID,
      rowData = _ref2.rowData;

  return {
    type: ADD_TABLE_ROW,
    payload: {
      url: '/teams/' + teamName + '/tables/' + tableID + '/rows',
      schema: _schemas.TABLE_ROW,
      options: {
        method: 'POST',
        body: rowData
      }
    }
  };
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(71),
    now = __webpack_require__(1309),
    toNumber = __webpack_require__(1310);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(261),
    arrayIncludes = __webpack_require__(419),
    arrayIncludesWith = __webpack_require__(420),
    arrayMap = __webpack_require__(119),
    baseUnary = __webpack_require__(404),
    cacheHas = __webpack_require__(262);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tasks = (_temp = _class = function (_SvgIcon) {
  _inherits(Tasks, _SvgIcon);

  function Tasks() {
    _classCallCheck(this, Tasks);

    return _possibleConstructorReturn(this, (Tasks.__proto__ || Object.getPrototypeOf(Tasks)).apply(this, arguments));
  }

  _createClass(Tasks, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M31.99957,10.00043a2.00394,2.00394,0,0,0-2-2A2.00424,2.00424,0,0,0,27.99506,6H8.00494A2.00455,2.00455,0,0,0,6,8.00494V27.99506a2.00425,2.00425,0,0,0,2.00043,2.00452,2.00394,2.00394,0,0,0,2,2A2.00424,2.00424,0,0,0,12.00494,34H31.99506A2.00455,2.00455,0,0,0,34,31.99506V12.00494A2.00425,2.00425,0,0,0,31.99957,10.00043ZM8,10.00494V28.999a1.00557,1.00557,0,0,1-1-1.004V8.00494A1.00607,1.00607,0,0,1,8.00494,7H27.99506a1.00557,1.00557,0,0,1,1.004,1H10.00494A2.00455,2.00455,0,0,0,8,10.00494Zm2,2V30.999A1.00509,1.00509,0,0,1,9.001,30L9,29.99506V10.00494A1.00607,1.00607,0,0,1,10.00494,9H29.99506L30,9.001a1.00509,1.00509,0,0,1,.999.999H12.00494A2.00455,2.00455,0,0,0,10,12.00494ZM26.5,13.5a1.25244,1.25244,0,0,1-1.2514,1.25H18.7514a1.25,1.25,0,1,1,0-2.5H25.2486A1.24764,1.24764,0,0,1,26.5,13.5ZM31.99506,32,12,31.99506,12.00372,17H31.99878l-.00323,13.03931c.00031-.01508.00446-.02911.00446-.04425C32,30.01019,31.99506,32,31.99506,32Z' }),
          _react2['default'].createElement('path', { d: 'M20.333,30a1.50334,1.50334,0,0,1-1.00342-.38477l-3.333-3a1.5002,1.5002,0,0,1,2.00684-2.23047l2.17529,1.958,5.66895-6.80322A1.5,1.5,0,0,1,28.15234,21.46l-6.667,8a1.49994,1.49994,0,0,1-1.04492.53613C20.4043,29.999,20.36816,30,20.333,30Z' })
        );
      }

      return render;
    }()
  }]);

  return Tasks;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40 40'
}, _temp);
exports['default'] = Tasks;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typography = __webpack_require__(155);

exports['default'] = {
  borderPaddingRightLeft: _typography.STEP / 2 - 1,
  borderPaddingTopBottom: parseInt((0, _typography.rhythmByUnit)(2)) - _typography.STEP / 2 - 1,
  borderRadius: _typography.RADIUS + 'em',
  borderWidth: 1,
  borderWidthFocused: 1,
  buttonBorderRadius: _typography.RADIUS * 2 + 'em',
  chipHeight: parseInt((0, _typography.rhythmByUnit)(3)) - _typography.STEP / 2,
  codeBorderRadius: _typography.RADIUS * 2 + 'em',
  contentPadding: '1em',
  drawerWidth: 270,
  drawerWidthLarge: 320,
  formControlMarginBottom: _typography.STEP,
  formControlMarginTop: parseInt((0, _typography.rhythmByUnit)(3)),
  iconHeight: '50px',
  inputBorderRadius: _typography.RADIUS * 1.155 + 'em',
  inputHeight: '2em',
  modalSheetHeaderHeight: '4em',
  searchInputHeight: parseInt((0, _typography.rhythmByUnit)(4)),
  skeletonCount: 10,
  tabPadding: (0, _typography.rhythmByUnit)(3),
  textFieldPadding: parseInt((0, _typography.rhythmByUnit)(3))
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1346);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManualStart = (_temp = _class = function (_SvgIcon) {
  _inherits(ManualStart, _SvgIcon);

  function ManualStart() {
    _classCallCheck(this, ManualStart);

    return _possibleConstructorReturn(this, (ManualStart.__proto__ || Object.getPrototypeOf(ManualStart)).apply(this, arguments));
  }

  _createClass(ManualStart, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'svg',
            { width: '64', height: '64' },
            _react2['default'].createElement(
              'defs',
              null,
              _react2['default'].createElement('path', { id: 'a', d: 'M0 .073h8.833v10.78H0z' })
            ),
            _react2['default'].createElement(
              'g',
              { fill: 'none', fillRule: 'evenodd' },
              _react2['default'].createElement('path', {
                fill: '#42E0D0',
                fillRule: 'nonzero',
                d: 'M30 57.971a25.504 25.504 0 0 1-12.153-2.444c-.965-.443-1.9-.948-2.802-1.514-.909-.543-1.742-1.241-2.613-1.862a28.751 28.751 0 0 1-4.543-4.618 31.274 31.274 0 0 1-3.37-5.665 30.293 30.293 0 0 1-2.006-6.364 31.044 31.044 0 0 1-.492-6.752A31.357 31.357 0 0 1 3.08 22l4.58 1.552a25.408 25.408 0 0 0-1.438 5.55 27.516 27.516 0 0 0-.151 5.859 29.882 29.882 0 0 0 1.25 5.743 25.851 25.851 0 0 0 2.536 5.393 29.039 29.039 0 0 0 3.748 4.657c.757.66 1.477 1.397 2.272 1.979a22.003 22.003 0 0 0 2.499 1.707A24.88 24.88 0 0 0 30 57.971'
              }),
              _react2['default'].createElement(
                'g',
                { transform: 'translate(0 15)' },
                _react2['default'].createElement(
                  'mask',
                  { id: 'b', fill: '#fff' },
                  _react2['default'].createElement('use', null)
                ),
                _react2['default'].createElement('path', {
                  fill: '#42E0D0',
                  fillRule: 'nonzero',
                  d: 'M8.833 10.853L8.167.073 0 6.123z',
                  mask: 'url(#b)'
                })
              ),
              _react2['default'].createElement('path', {
                fill: '#FC6666',
                fillRule: 'nonzero',
                d: 'M34 7.003c4.091-.065 8.14.867 11.82 2.718a27.267 27.267 0 0 1 9.57 8.077 30.252 30.252 0 0 1 3.226 5.592 30.703 30.703 0 0 1 1.914 6.33c.377 2.19.527 4.416.45 6.64A33.06 33.06 0 0 1 59.93 43l-4.503-1.553a29.213 29.213 0 0 0 1.426-5.476c.238-1.905.288-3.83.15-5.747a27.004 27.004 0 0 0-1.163-5.708 25.89 25.89 0 0 0-2.402-5.32C49.162 12.206 41.968 7.692 34 7.003'
              }),
              _react2['default'].createElement('path', {
                fill: '#FC6666',
                fillRule: 'nonzero',
                d: 'M55 37l.713 10L64 41.369z'
              }),
              _react2['default'].createElement('path', {
                fill: '#5E6174',
                fillRule: 'nonzero',
                d: 'M30.51 38.397c-3.208-.02-5.793-2.645-5.779-5.865.014-3.22 2.622-5.821 5.83-5.814 3.208.007 5.804 2.62 5.804 5.84-.02 3.231-2.636 5.84-5.855 5.84m17.375-7.838c-.038-.5-.612-.845-1.11-.845a3.942 3.942 0 0 1-3.636-2.42 3.89 3.89 0 0 1 .996-4.342.963.963 0 0 0 .076-1.307 17.334 17.334 0 0 0-2.755-2.804.992.992 0 0 0-1.34.115 4.084 4.084 0 0 1-4.363.999 3.997 3.997 0 0 1-2.373-3.804.96.96 0 0 0-.842-1.037 16.928 16.928 0 0 0-3.942 0 .998.998 0 0 0-.88.999 3.843 3.843 0 0 1-2.373 3.727 4.008 4.008 0 0 1-4.324-1 1.03 1.03 0 0 0-1.34-.114 19.593 19.593 0 0 0-2.832 2.804c-.315.41-.265.994.115 1.345a3.852 3.852 0 0 1 .957 4.38c-.574 1.421-2.067 2.343-3.79 2.343a.916.916 0 0 0-.994.884 17.124 17.124 0 0 0-.039 3.957c.14.522.61.885 1.149.884a3.789 3.789 0 0 1 3.597 2.382 3.93 3.93 0 0 1-.957 4.341.963.963 0 0 0-.115 1.306 17.334 17.334 0 0 0 2.756 2.805.992.992 0 0 0 1.34-.115 4.008 4.008 0 0 1 4.362-.96 3.843 3.843 0 0 1 2.373 3.803.924.924 0 0 0 .842.999c.674.076 1.35.115 2.029.115.64.001 1.278-.037 1.913-.115a.96.96 0 0 0 .88-1 3.92 3.92 0 0 1 2.373-3.726 4.084 4.084 0 0 1 4.363.999.954.954 0 0 0 1.301.115 17.83 17.83 0 0 0 2.833-2.804.963.963 0 0 0-.115-1.345 3.852 3.852 0 0 1-.957-4.341 3.904 3.904 0 0 1 3.56-2.382h.229a.996.996 0 0 0 1.033-.846 17.432 17.432 0 0 0 0-3.995'
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return ManualStart;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = ManualStart;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Web = (_temp = _class = function (_SvgIcon) {
  _inherits(Web, _SvgIcon);

  function Web() {
    _classCallCheck(this, Web);

    return _possibleConstructorReturn(this, (Web.__proto__ || Object.getPrototypeOf(Web)).apply(this, arguments));
  }

  _createClass(Web, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M41.91 14a.6.6 0 0 1 .6.6v.82a.6.6 0 0 1-.6.6h-16.8a.6.6 0 0 1-.6-.6v-.82a.6.6 0 0 1 .6-.6h16.8m0-.8h-16.8a1.4 1.4 0 0 0-1.4 1.4v.82a1.4 1.4 0 0 0 1.4 1.4h16.8a1.4 1.4 0 0 0 1.4-1.4v-.82a1.4 1.4 0 0 0-1.4-1.4z' }),
          _react2['default'].createElement('rect', { x: '12.14', y: '13.26', width: '8.8', height: '1.77', rx: '.89', ry: '.89' }),
          _react2['default'].createElement('rect', { x: '12.14', y: '18.94', width: '8.8', height: '1.77', rx: '.89', ry: '.89' }),
          _react2['default'].createElement('rect', { x: '12.14', y: '24.63', width: '8.8', height: '1.77', rx: '.89', ry: '.89' }),
          _react2['default'].createElement('path', { d: 'M41.91 19.71a.6.6 0 0 1 .6.6v.82a.6.6 0 0 1-.6.6h-16.8a.6.6 0 0 1-.6-.6v-.82a.6.6 0 0 1 .6-.6h16.8m0-.8h-16.8a1.4 1.4 0 0 0-1.4 1.4v.82a1.4 1.4 0 0 0 1.4 1.4h16.8a1.4 1.4 0 0 0 1.4-1.4v-.82a1.4 1.4 0 0 0-1.4-1.4zM41.91 25.4a.6.6 0 0 1 .6.6v4a.6.6 0 0 1-.6.6h-16.8a.6.6 0 0 1-.6-.6v-4a.6.6 0 0 1 .6-.6h16.8m0-.8h-16.8a1.4 1.4 0 0 0-1.4 1.4v4a1.4 1.4 0 0 0 1.4 1.4h16.8a1.4 1.4 0 0 0 1.4-1.4v-4a1.4 1.4 0 0 0-1.4-1.4zM33.51 33.49h9.8v3.07h-9.8z' }),
          _react2['default'].createElement('rect', {
            x: '3',
            y: '9',
            width: '49.45',
            height: '30.11',
            rx: '1.93',
            ry: '1.93',
            fill: 'none'
          }),
          _react2['default'].createElement('path', { d: 'M52.45 0H3a3 3 0 0 0-3 3v36.11a3 3 0 0 0 3 3h49.45a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3zM17.86 2.73a1.69 1.69 0 1 1-1.69 1.68 1.69 1.69 0 0 1 1.69-1.68zm-5.37 0a1.69 1.69 0 0 1 0 3.37 1.69 1.69 0 1 1 0-3.37zm-5.24 0a1.69 1.69 0 1 1-1.68 1.68 1.69 1.69 0 0 1 1.68-1.68zm45.2 34.45a1.93 1.93 0 0 1-1.93 1.93H4.93A1.93 1.93 0 0 1 3 37.18V10.93A1.94 1.94 0 0 1 4.93 9h45.59a1.94 1.94 0 0 1 1.93 1.93z' })
        );
      }

      return render;
    }()
  }]);

  return Web;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 55.45 42.11'
}, _temp);
exports['default'] = Web;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TASK_ITEM_INITIALIZE = exports.TASK_ITEM_INITIALIZE = 'PAGE_TASK_ITEM_INITIALIZE';
var TASK_ITEM_SELECT_UPDATE_OPTION = exports.TASK_ITEM_SELECT_UPDATE_OPTION = 'PAGE_TASK_ITEM_SELECT_UPDATE_OPTION';
var TASK_ITEM_FIELD_UPDATE = exports.TASK_ITEM_FIELD_UPDATE = 'PAGE_TASK_ITEM_FIELD_UPDATE';

var initialize = exports.initialize = function initialize() {
  return {
    type: TASK_ITEM_INITIALIZE
  };
};

var fieldUpdate = exports.fieldUpdate = function fieldUpdate(field) {
  return {
    type: TASK_ITEM_FIELD_UPDATE,
    field: field
  };
};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleSheet = exports.SEARCH_SCHEMA = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(148);

var _browserHistory = __webpack_require__(182);

var _browserHistory2 = _interopRequireDefault(_browserHistory);

var _jssThemeReactor = __webpack_require__(62);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _url = __webpack_require__(83);

var _url2 = _interopRequireDefault(_url);

var _AppStructure = __webpack_require__(1599);

var _AppStructure2 = _interopRequireDefault(_AppStructure);

var _Notifications = __webpack_require__(787);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _NavTasks = __webpack_require__(1867);

var _NavTasks2 = _interopRequireDefault(_NavTasks);

var _NavProcesses = __webpack_require__(1868);

var _NavProcesses2 = _interopRequireDefault(_NavProcesses);

var _NavData = __webpack_require__(846);

var _NavData2 = _interopRequireDefault(_NavData);

var _NavDataMagnetic = __webpack_require__(568);

var _NavDataMagnetic2 = _interopRequireDefault(_NavDataMagnetic);

var _NavStartAProcess = __webpack_require__(1869);

var _NavStartAProcess2 = _interopRequireDefault(_NavStartAProcess);

var _NavTemplates = __webpack_require__(566);

var _NavTemplates2 = _interopRequireDefault(_NavTemplates);

var _NavIntegrations = __webpack_require__(1870);

var _NavIntegrations2 = _interopRequireDefault(_NavIntegrations);

var _NavTriggers = __webpack_require__(1871);

var _NavTriggers2 = _interopRequireDefault(_NavTriggers);

var _Member = __webpack_require__(750);

var _Member2 = _interopRequireDefault(_Member);

var _NavTeam = __webpack_require__(1872);

var _NavTeam2 = _interopRequireDefault(_NavTeam);

var _NavHelp = __webpack_require__(1873);

var _NavHelp2 = _interopRequireDefault(_NavHelp);

var _NavSignOff = __webpack_require__(1874);

var _NavSignOff2 = _interopRequireDefault(_NavSignOff);

var _Badge = __webpack_require__(1875);

var _Badge2 = _interopRequireDefault(_Badge);

var _IconButton = __webpack_require__(90);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _List = __webpack_require__(69);

var _Menu = __webpack_require__(146);

var _Avatar = __webpack_require__(391);

var _fonts = __webpack_require__(1877);

var _fonts2 = _interopRequireDefault(_fonts);

var _FilterListContainer = __webpack_require__(1890);

var _FilterListContainer2 = _interopRequireDefault(_FilterListContainer);

var _UserWatchListContainer = __webpack_require__(693);

var _UserWatchListContainer2 = _interopRequireDefault(_UserWatchListContainer);

var _feature = __webpack_require__(189);

var _feature2 = _interopRequireDefault(_feature);

var _ContentTypes = __webpack_require__(698);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

var _url3 = __webpack_require__(31);

var _users = __webpack_require__(386);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEARCH_SCHEMA = exports.SEARCH_SCHEMA = {
  keywords: ['assignedTo', 'category', 'editableBy', 'group', 'isArchived', 'manuallyStartable', 'order', 'owner', 'pageKey', 'participatingUsers', 'processID', 'sort', 'status', 'tableType', 'viewableBy']
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('xApp', function (theme) {
  return _defineProperty({
    '@global': _extends({}, (0, _fonts2.default)({ dirname: '/' })),
    root: theme.typography.body1,
    signOutLink: {
      color: theme.palette.text.secondary
    }
  }, theme.breakpoints.up('md'), {
    hideAtMedium: theme.mixins.hidden()
  });
});

var handleEvent = void 0;

var App = (_dec = (0, _ContentTypes.content)({
  meta: {
    build: _propTypes2.default.string,
    data: _propTypes2.default.string,
    desktopProfile: _propTypes2.default.string,
    desktopSignOut: _propTypes2.default.string,
    desktopTeam: _propTypes2.default.string,
    integrations: _propTypes2.default.string,
    mobileProfile: _propTypes2.default.string,
    mobileSignOut: _propTypes2.default.string,
    mobileTeam: _propTypes2.default.string,
    models: _propTypes2.default.string,
    notifications: _propTypes2.default.string,
    pushbots: _propTypes2.default.string,
    start: _propTypes2.default.string,
    tasks: _propTypes2.default.string,
    triggers: _propTypes2.default.string
  }
}), _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
  _inherits(App, _PureComponent);

  function App() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      lastQ: null
    }, _this.addEventForChild = function (parent, eventName, childSelector, callback) {
      handleEvent = function handleEvent(event) {
        if (event && event.target && event.target.closest && childSelector) {
          return callback(event, event.target.closest(childSelector));
        }
      };
      parent.addEventListener(eventName, handleEvent);
    }, _this.removeEventForChild = function (parent, eventName, handler) {
      return parent.removeEventListener(eventName, handler);
    }, _this.handleSignOut = function () {
      var _this$props = _this.props,
          teamName = _this$props.teamName,
          username = _this$props.username,
          onSignOut = _this$props.onSignOut;

      if (onSignOut) onSignOut({ teamName: teamName, username: username });
    }, _this.getCurrentPath = function () {
      var pathname = _this.props.location.pathname;

      return pathname;
    }, _this.handleSearchChange = function (e) {
      var text = e.target.value;
      var search = _this.props.search;

      var lastQueryText = (search || {}).text || '';
      if (text !== lastQueryText) {
        _this.onSearchChange(_extends({}, search, { text: text }));
      }
    }, _this.handleSearchExpand = function (e, expandSearch) {
      _this.onSearchExpand({ expandSearch: expandSearch });
      if (expandSearch) _this.handleSearchReset(e);
    }, _this.handleSearchReset = function (e, props) {
      var _ref3 = props || _this.props,
          search = _ref3.search,
          _ref3$location = _ref3.location;

      _ref3$location = _ref3$location === undefined ? {} : _ref3$location;

      var omitSearchString = _ref3$location.search,
          _ref3$location$query = _ref3$location.query,
          q = _ref3$location$query.q,
          query = _objectWithoutProperties(_ref3$location$query, ['q']),
          location = _objectWithoutProperties(_ref3$location, ['search', 'query']),
          onSearchReset = _ref3.onSearchReset;

      var lastQ = _this.state.lastQ;

      var nextSearch = _extends({}, search, { text: '' });
      var nextLocation = _extends({}, location, { query: _extends({}, query, { q: lastQ }) });

      _this.onSearchChange(nextSearch);
      onSearchReset(lastQ, nextSearch, nextLocation);
      _this.setState({ lastQ: null });
    }, _this.handleSearchSubmit = function (e, props) {
      var _ref4 = props || _this.props,
          search = _ref4.search,
          _ref4$location = _ref4.location;

      _ref4$location = _ref4$location === undefined ? {} : _ref4$location;

      var omitSearchString = _ref4$location.search,
          _ref4$location$query = _ref4$location.query,
          q = _ref4$location$query.q,
          query = _objectWithoutProperties(_ref4$location$query, ['q']),
          location = _objectWithoutProperties(_ref4$location, ['search', 'query']),
          onSearchSubmit = _ref4.onSearchSubmit;

      var lastQ = _this.state.lastQ;

      var nextSearch = { text: ((search || {}).text || '').trim() };
      var nextQ = (0, _url3.formatSearch)(nextSearch, false);
      var nextLocation = _extends({}, location, { query: _extends({}, query, { q: nextQ }) });

      _this.onSearchChange(nextSearch);
      onSearchSubmit(nextQ, search, nextLocation);
      if (lastQ === null) {
        _this.setState({ lastQ: q });
      }
    }, _this.onSearchChange = function (search) {
      var _search$text = search.text,
          text = _search$text === undefined ? '' : _search$text;

      var isDirty = typeof text === 'string' && text.length !== 0;
      _this.page.update({ expandSearch: isDirty, search: search }, true);
    }, _this.onSearchExpand = function (_ref5) {
      var expandSearch = _ref5.expandSearch;

      _this.page.update({ expandSearch: !expandSearch }, true);
    }, _this.isActive = function (pathname) {
      return _browserHistory2.default.getCurrentLocation().pathname.startsWith(pathname);
    }, _this.page = undefined, _this.renderAppDrawerChildren = function () {
      var _this$props2 = _this.props,
          aiModelEnabled = _this$props2.aiModelEnabled,
          isTeamAdmin = _this$props2.isTeamAdmin,
          isTeamOwner = _this$props2.isTeamOwner,
          watchListEnabled = _this$props2.watchListEnabled,
          workDoneBetterNavigationEnabled = _this$props2.workDoneBetterNavigationEnabled;

      var contentTypes = _this.constructor.contentTypes;
      var isAdmin = isTeamAdmin || isTeamOwner;
      var classes = {};

      if (_this.context.styleManager.sheetMap.find(function (sheet) {
        return sheet.name === 'AppStructure';
      })) {
        classes = _this.context.styleManager.render(styleSheet);
      }
      /* eslint-disable */
      return [_react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/tasks',
          selected: _this.isActive('/tasks')
        }, contentTypes.props.tasks()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavTasks2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Tasks',
          selected: _this.isActive('/tasks')
        })
      ), _react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/pushbots',
          selected: _this.isActive('/pushbots')
        }, contentTypes.props.pushbots()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavProcesses2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Processes',
          selected: _this.isActive('/pushbots')
        })
      ), _react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/data',
          margin: !aiModelEnabled,
          selected: _this.isActive('/data')
        }, contentTypes.props.data()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavDataMagnetic2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Data',
          selected: _this.isActive('/data')
        })
      )].concat(_toConsumableArray(aiModelEnabled ? [_react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/models',
          margin: true,
          selected: _this.isActive('/models')
        }, contentTypes.props.models()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavData2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Predictive Models',
          selected: _this.isActive('/models')
        })
      )] : []), [_react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/start',
          margin: true,
          selected: _this.isActive('/start')
        }, contentTypes.props.start()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavStartAProcess2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Start a Process',
          selected: _this.isActive('/start')
        })
      ), _react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/build',
          selected: _this.isActive('/build')
        }, contentTypes.props.build()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavTemplates2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Process Templates',
          selected: _this.isActive('/build')
        })
      )], _toConsumableArray(isAdmin ? [_react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/integrations',
          selected: _this.isActive('/integrations')
        }, contentTypes.props.integrations()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavIntegrations2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Integrations',
          selected: _this.isActive('/integrations')
        })
      )] : []), [_react2.default.createElement(
        _List.ListItem,
        _extends({
          href: '/triggers',
          margin: true,
          selected: _this.isActive('/triggers')
        }, contentTypes.props.triggers()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavTriggers2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Triggers',
          selected: _this.isActive('/triggers')
        })
      ), _react2.default.createElement(
        _List.ListItem,
        {
          href: 'https://help.catalytic.com/hc/en-us',
          margin: true,
          target: '_blank'
        },
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavHelp2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, { inherit: true, noWrap: true, primary: 'Help & Support' })
      ), _react2.default.createElement(
        _List.ListItem,
        _extends({
          className: classes.hideAtMedium,
          href: '/profile/me',
          selected: _this.isActive('/profile/me')
        }, contentTypes.props.mobileProfile()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_Member2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'My profile',
          selected: _this.isActive('/profile/me')
        })
      ), _react2.default.createElement(
        _List.ListItem,
        _extends({
          className: classes.hideAtMedium,
          href: '/team',
          margin: true,
          selected: _this.isActive('/team')
        }, contentTypes.props.mobileTeam()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavTeam2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'My team',
          selected: _this.isActive('/team')
        })
      ), _react2.default.createElement(
        _List.ListItem,
        _extends({
          className: (0, _classnames2.default)(classes.signOutLink, classes.hideAtMedium),
          margin: true,
          onClick: _this.handleSignOut
        }, contentTypes.props.mobileSignOut()),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_NavSignOff2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: 'Sign off',
          primaryClassName: classes.signOutLink
        })
      )], _toConsumableArray(watchListEnabled ? [_react2.default.createElement(_UserWatchListContainer2.default, null)] : []), _toConsumableArray(workDoneBetterNavigationEnabled ? [_react2.default.createElement(_FilterListContainer2.default, null)] : [])).map(function (ele, i) {
        return _react2.default.cloneElement(ele, { key: i });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var page = this.page;

      return { page: page };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          storeProp = _props.store,
          updateProp = _props.update;

      var store = function store(payload, merge) {
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this2.getCurrentPath();
        return storeProp(payload, merge, path);
      };
      var update = function update(payload, merge) {
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this2.getCurrentPath();
        return updateProp(payload, merge, path);
      };

      var _App$createDefaultCon = App.createDefaultContext(_extends({}, this.props, { store: store, update: update })),
          page = _App$createDefaultCon.page;

      this.page = page;

      this.page.update({ searchSchema: SEARCH_SCHEMA });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var onDidMount = this.props.onDidMount;

      onDidMount(this.props);

      this.addEventForChild(_context2.default.document, 'click', 'a[href]', function (event, childElement) {
        if (childElement) {
          var href = childElement.getAttribute('href');

          var _url$parse = _url2.default.parse(href),
              hostname = _url$parse.hostname,
              pathname = _url$parse.pathname;

          var modifier = event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;

          if (hostname || !pathname || modifier) return;

          event.preventDefault();

          switch (childElement.getAttribute('target')) {
            case '_blank':
              return _context2.default.open(href, '_blank');
            case '_self':
            default:
              return _browserHistory2.default.push(href);
          }
        }
      });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.page && nextProps.page && nextProps.page !== this.page) {
        this.page = nextProps.page;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          pathname = _props2.location.pathname,
          navigate = _props2.navigate,
          onNavigation = _props2.onNavigation;
      var _nextProps$location = nextProps.location,
          nextPathname = _nextProps$location.pathname,
          action = _nextProps$location.action;

      if (!navigate && nextPathname !== pathname && action === 'PUSH') onNavigation();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEventForChild(_context2.default.document, 'click', handleEvent);
    }
  }, {
    key: 'render',

    /* eslint-enable */

    value: function render() {
      var _props3 = this.props,
          aiModelEnabled = _props3.aiModelEnabled,
          appBarSecondaryComponent = _props3.appBarSecondaryComponent,
          appName = _props3.appName,
          children = _props3.children,
          dialogProp = _props3.dialog,
          fullName = _props3.fullName,
          isTeamAdmin = _props3.isTeamAdmin,
          isTeamOwner = _props3.isTeamOwner,
          queryText = _props3.queryText,
          searchProp = _props3.search,
          splitPaneEnabled = _props3.splitPaneEnabled,
          teamName = _props3.teamName,
          title = _props3.title,
          unreadNotificationsList = _props3.unreadNotificationsList,
          _props3$username = _props3.username,
          username = _props3$username === undefined ? '' : _props3$username,
          userThumbnail = _props3.userThumbnail,
          watchListEnabled = _props3.watchListEnabled,
          workDoneBetterNavigationEnabled = _props3.workDoneBetterNavigationEnabled,
          other = _objectWithoutProperties(_props3, ['aiModelEnabled', 'appBarSecondaryComponent', 'appName', 'children', 'dialog', 'fullName', 'isTeamAdmin', 'isTeamOwner', 'queryText', 'search', 'splitPaneEnabled', 'teamName', 'title', 'unreadNotificationsList', 'username', 'userThumbnail', 'watchListEnabled', 'workDoneBetterNavigationEnabled']);

      var contentTypes = this.constructor.contentTypes;
      var isAdmin = isTeamAdmin || isTeamOwner; // eslint-disable-line no-unused-vars
      var classes = {};

      if (this.context.styleManager.sheetMap.find(function (sheet) {
        return sheet.name === 'AppStructure';
      })) {
        classes = this.context.styleManager.render(styleSheet);
      }

      var _ref6 = searchProp || {},
          _ref6$text = _ref6.text,
          search = _ref6$text === undefined ? '' : _ref6$text;

      var dialog = typeof dialogProp === 'function' ? dialogProp(this.props, this.context) : dialogProp;
      var userThumbnailAltText = (0, _users.getUserThumbnailAltText)({
        fullName: fullName,
        username: username
      });

      return _react2.default.createElement(
        _AppStructure2.default,
        _extends({}, _extends({}, other, { appName: appName, dialog: dialog, search: search, title: title }), {
          onSearchExpand: this.handleSearchExpand,
          onSearchChange: this.handleSearchChange,
          onSearchReset: this.handleSearchReset,
          onSearchSubmit: this.handleSearchSubmit,
          appDrawer: true,
          searchBack: !!queryText,
          appDrawerChildren: this.renderAppDrawerChildren(),
          appBarUserAvatar:
          /* eslint-disable */
          _react2.default.createElement(
            _Avatar.UserAvatar,
            {
              id: 'userAvatar',
              src: userThumbnail,
              menuItems: [_react2.default.createElement(
                _Menu.MenuItem,
                _extends({
                  href: '/profile/me'
                }, contentTypes.props.desktopProfile()),
                'My profile'
              ), _react2.default.createElement(
                _Menu.MenuItem,
                _extends({ href: '/team' }, contentTypes.props.desktopTeam()),
                'My team'
              ), _react2.default.createElement(
                _Menu.MenuItem,
                _extends({
                  className: classes.signOutLink,
                  onClick: this.handleSignOut
                }, contentTypes.props.desktopSignOut()),
                'Sign off'
              )]
            },
            userThumbnailAltText
          )
          /* eslint-enable */
          ,
          appBarSecondary: appBarSecondaryComponent,
          appBarNotifications: _react2.default.createElement(
            _IconButton2.default,
            _extends({
              component: _reactRouter.Link,
              to: '/notifications',
              id: 'notifications'
            }, contentTypes.props.notifications()),
            unreadNotificationsList ? _react2.default.createElement(
              _Badge2.default,
              { accent: true, badgeContent: unreadNotificationsList.length },
              _react2.default.createElement(_Notifications2.default, null)
            ) : _react2.default.createElement(_Notifications2.default, null)
          ),
          prefix: 'pb: http://pushbot.com',
          className: classes.root,
          useCenteredContentColumn: !splitPaneEnabled
        }),
        children
      );
    }
  }], [{
    key: 'createDefaultContext',
    value: function createDefaultContext(_ref7) {
      var _page = _ref7.page,
          update = _ref7.update,
          store = _ref7.store;

      var page = _page || { update: update, store: store };
      return { page: page };
    }
  }]);

  return App;
}(_react.PureComponent), _class2.displayName = 'App', _class2.propTypes = {
  /**
   * Boolean indicating whether AI Model feature flag is enabled
   */
  aiModelEnabled: _propTypes2.default.bool,
  /**
   * If true the App Bar is displayed
   */
  appBar: _propTypes2.default.bool,
  /**
   * The secondary component that should show up on the right side of the App Bar
   */
  appBarSecondaryComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  /**
   * If true the App Drawer is displayed
   */
  appDrawer: _propTypes2.default.bool,
  /**
   * Can be any node or number of nodes.
   */
  appDrawerChildren: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  /**
   * Name of application
   */
  appName: _propTypes2.default.string,
  /**
   * Can be any node or number of nodes.
   */
  children: _propTypes2.default.node.isRequired,
  dialog: _propTypes2.default.func,
  /**
   * Display text used in content body
   */
  display: _propTypes2.default.string,
  fullName: _propTypes2.default.string,
  /**
   * Headline text used in content body
   */
  headline: _propTypes2.default.string,
  isTeamAdmin: _propTypes2.default.bool,
  isTeamOwner: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    action: _propTypes2.default.string,
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.shape({
      q: _propTypes2.default.string
    })
  }),
  navigate: _propTypes2.default.bool,
  /**
   * Called when component will mount
   */
  onDidMount: _propTypes2.default.func.isRequired,
  /**
   * Called when application is navigated
   */
  onNavigation: _propTypes2.default.func,
  /**
   * Called when sign out is clicked
   */
  onSignOut: _propTypes2.default.func,
  /**
   * Search value to be displayed in the App Bar expanded search
   */
  search: _propTypes2.default.shape({
    text: _propTypes2.default.text
  }),
  /**
   * Presence of queryText from url determines bool passed to searchBack
   */
  queryText: _propTypes2.default.string,
  /**
   * Whether pages should use a split-pane layout where supported
   */
  splitPaneEnabled: _propTypes2.default.bool,
  store: _propTypes2.default.func,
  teamName: _propTypes2.default.string,
  /**
   * Title to be displayed in the App Bar
   */
  title: _propTypes2.default.string,
  unreadNotificationsList: _propTypes2.default.arrayOf(_propTypes2.default.string),
  update: _propTypes2.default.func,
  username: _propTypes2.default.string,
  userThumbnail: _propTypes2.default.string,
  watchListEnabled: _feature2.default,
  workDoneBetterNavigationEnabled: _feature2.default
}, _class2.defaultProps = {
  onDidMount: function onDidMount() {},
  onSearchReset: function onSearchReset() {},
  onSearchSubmit: function onSearchSubmit() {},

  homeLink: '/tasks'
}, _class2.childContextTypes = {
  /**
   * Application context
   */
  page: _propTypes2.default.object.isRequired
}, _class2.contextTypes = {
  styleManager: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = App;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(614);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(621);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(613);

var _extends3 = _interopRequireDefault(_extends2);

exports.createStyleSheet = createStyleSheet;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStyleSheet(name, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var styleSheet = {
    name: name,
    options: options,
    createRules: createRules
  };

  function createRules() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var rules = typeof callback === 'function' ? callback(theme) : callback;

    if (!theme.overrides || !theme.overrides[name]) {
      return rules;
    }

    var overrides = theme.overrides[name];
    var rulesWithOverrides = (0, _extends3.default)({}, rules);

    (0, _keys2.default)(overrides).forEach(function (n) {
      rulesWithOverrides[n] = (0, _assign2.default)(rulesWithOverrides[n] || {}, overrides[n]);
    });

    return rulesWithOverrides;
  }

  return styleSheet;
}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = exports.DISPLAY_NAME = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _Modal = __webpack_require__(366);

var _Modal2 = _interopRequireDefault(_Modal);

var _Fade = __webpack_require__(626);

var _Fade2 = _interopRequireDefault(_Fade);

var _transitions = __webpack_require__(120);

var _Paper = __webpack_require__(150);

var _Paper2 = _interopRequireDefault(_Paper);

var _Form = __webpack_require__(186);

var _Form2 = _interopRequireDefault(_Form);

var _Button = __webpack_require__(382);

var _Button2 = _interopRequireDefault(_Button);

var _DialogActions = __webpack_require__(631);

var _DialogActions2 = _interopRequireDefault(_DialogActions);

var _DialogTitle = __webpack_require__(632);

var _DialogTitle2 = _interopRequireDefault(_DialogTitle);

var _Text = __webpack_require__(56);

var _Progress = __webpack_require__(397);

var _Progress2 = _interopRequireDefault(_Progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DISPLAY_NAME = exports.DISPLAY_NAME = 'Dialog';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(DISPLAY_NAME, function (theme) {
  var _ref;

  return _ref = {
    modal: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    dialog: {
      display: 'flex',
      position: 'relative',
      width: '75%',
      maxHeight: parseInt(theme.typography.rhythmByUnit(11)) + 'vh',
      '&:focus': {
        outline: 'none'
      }
    },
    dialogContent: {
      flex: '1 1 auto',
      overflow: 'auto'
    },
    dialogTitle: {
      flex: '0 0 auto'
    },
    overflow: {
      overflow: 'auto'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      flex: 'auto',
      maxHeight: parseInt(theme.typography.rhythmByUnit(11)) + 'vh',
      width: '100%'
    },
    progress: {
      zIndex: theme.zIndex.dialog
    },
    title: theme.mixins.truncate({
      flex: '1'
    }),
    titleCaption: {
      whiteSpace: 'pre-line'
    },
    actionTitle: {
      display: 'none'
    },
    close: {
      margin: '0 ' + theme.typography.rhythmByUnit(0.5)
    },
    'dialogWidth-xs': {
      maxWidth: theme.breakpoints.getWidth('xs')
    },
    'dialogWidth-sm': {
      maxWidth: theme.breakpoints.getWidth('sm')
    },
    'dialogWidth-md': {
      maxWidth: theme.breakpoints.getWidth('md')
    },
    embeddedModal: {
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      top: theme.variables.modalSheetHeaderHeight,
      height: 'calc(100% - ' + theme.variables.modalSheetHeaderHeight + ')',
      backgroundColor: theme.palette.background.paper
    },
    embeddedDialog: {
      width: '100%',
      maxWidth: 'none',
      maxHeight: 'none'
    },
    embeddedForm: {
      margin: '0 auto',
      maxHeight: 'none',
      maxWidth: theme.breakpoints.getWidth('sm')
    },
    embeddedProgress: {
      position: 'fixed',
      top: 0,
      width: '100%'
    }
  }, _defineProperty(_ref, theme.breakpoints.down('sm'), {
    fullScreenActionFooter: {
      display: 'none'
    },
    fullScreen: {
      width: '100%',
      height: '100%',
      minHeight: '100%',
      borderRadius: 0,
      overflowY: 'auto'
    },
    fullScreenDialogTitle: {
      paddingRight: 0
    },
    fullScreenForm: {
      marginTop: theme.typography.rhythmByUnit(10)
    },
    titleCaption: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }), _defineProperty(_ref, theme.breakpoints.up('sm'), {
    fullScreenActionTitle: {
      display: 'none'
    }
  }), _ref;
});

/**
 * Dialogs are overlayed modal paper based components with a backdrop.
 *
 * ```jsx
 * <Dialog>
 *   <DialogContent>...</DialogContent>
 *   <DialogActions>...</DialogActions>
 * </Dialog>
 * ```
 */
var Dialog = (_temp2 = _class = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call.apply(_ref2, [this].concat(args))), _this), _this.handleOnCloseClick = function (event) {
      var _this$props = _this.props,
          onCloseClick = _this$props.onCloseClick,
          onRequestClose = _this$props.onRequestClose,
          hideOnCloseClick = _this$props.hideOnCloseClick;


      if (onCloseClick) {
        onCloseClick(event);
      }

      if (onRequestClose && hideOnCloseClick) {
        onRequestClose(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dialog, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames3, _classNames5;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            bodyClassName = _props.bodyClassName,
            className = _props.className,
            closeClassName = _props.closeClassName,
            closeComponent = _props.closeComponent,
            closeIconComponent = _props.closeIconComponent,
            actions = _props.confirmationActions,
            ConfirmationActions = _props.confirmationActionsComponent,
            confirmationActionsClassName = _props.confirmationActionsClassName,
            contentClassName = _props.contentClassName,
            disableOverflow = _props.disableOverflow,
            embeddedMode = _props.embeddedMode,
            error = _props.error,
            Form = _props.formComponent,
            fullScreenProp = _props.fullScreen,
            hideOnBackdropClick = _props.hideOnBackdropClick,
            hideOnCloseClick = _props.hideOnCloseClick,
            hideOnEscapeKeyUp = _props.hideOnEscapeKeyUp,
            enterTransitionDuration = _props.enterTransitionDuration,
            leaveTransitionDuration = _props.leaveTransitionDuration,
            maxWidth = _props.maxWidth,
            open = _props.open,
            onBackdropClick = _props.onBackdropClick,
            onCloseClick = _props.onCloseClick,
            onEscapeKeyUp = _props.onEscapeKeyUp,
            onEnter = _props.onEnter,
            onEntering = _props.onEntering,
            onEntered = _props.onEntered,
            onExit = _props.onExit,
            onExiting = _props.onExiting,
            onExited = _props.onExited,
            onRequestClose = _props.onRequestClose,
            onSubmit = _props.onSubmit,
            onValidate = _props.onValidate,
            paperClassNameProp = _props.paperClassName,
            progress = _props.progress,
            primary = _props.primary,
            secondary = _props.secondary,
            title = _props.title,
            titleCaption = _props.titleCaption,
            DialogTitle = _props.titleComponent,
            titleClassName = _props.titleClassName,
            transition = _props.transition,
            other = _objectWithoutProperties(_props, ['accent', 'children', 'bodyClassName', 'className', 'closeClassName', 'closeComponent', 'closeIconComponent', 'confirmationActions', 'confirmationActionsComponent', 'confirmationActionsClassName', 'contentClassName', 'disableOverflow', 'embeddedMode', 'error', 'formComponent', 'fullScreen', 'hideOnBackdropClick', 'hideOnCloseClick', 'hideOnEscapeKeyUp', 'enterTransitionDuration', 'leaveTransitionDuration', 'maxWidth', 'open', 'onBackdropClick', 'onCloseClick', 'onEscapeKeyUp', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'onRequestClose', 'onSubmit', 'onValidate', 'paperClassName', 'progress', 'primary', 'secondary', 'title', 'titleCaption', 'titleComponent', 'titleClassName', 'transition']);

        var fullScreen = fullScreenProp && !embeddedMode;

        var confirmationActions = actions;
        var closeConfirmationActions = void 0;

        var classes = this.context.styleManager.render(styleSheet);

        if (!embeddedMode) {
          if (fullScreen && !confirmationActions) {
            closeConfirmationActions = _react2['default'].createElement(
              _Button2['default'],
              {
                accent: true,
                className: classes.close,
                colorInherit: true,
                key: 'close',
                onClick: onRequestClose,
                raised: true,
                type: 'button'
              },
              'Close'
            );
          }

          if (fullScreen && confirmationActions) {
            closeConfirmationActions = _react2['default'].createElement(
              _Button2['default'],
              {
                className: classes.close,
                colorInherit: true,
                key: 'close',
                onClick: onRequestClose,
                raised: true,
                type: 'button'
              },
              'Cancel'
            );
          }
        }

        var formProps = {
          confirmationActionsComponent: ConfirmationActions,
          confirmationActionsClassName: confirmationActionsClassName,
          className: (0, _classnames2['default'])(classes.form, (_classNames = {}, _defineProperty(_classNames, classes.fullScreenForm, fullScreen), _defineProperty(_classNames, classes.embeddedForm, embeddedMode), _classNames), bodyClassName),
          onSubmit: onSubmit,
          onValidate: onValidate
        };

        var modalClassName = (0, _classnames2['default'])(classes.modal, _defineProperty({}, classes.embeddedModal, embeddedMode), className);

        var paperClassName = (0, _classnames2['default'])(classes.dialog, classes['dialogWidth-' + maxWidth], paperClassNameProp, (_classNames3 = {}, _defineProperty(_classNames3, classes.fullScreen, fullScreen), _defineProperty(_classNames3, classes.overflow, !disableOverflow), _defineProperty(_classNames3, classes.embeddedDialog, embeddedMode), _classNames3));

        var progressClassName = (0, _classnames2['default'])(classes.progress, _defineProperty({}, classes.embeddedProgress, embeddedMode));

        var confirmationActionsTitleClassName = (0, _classnames2['default'])((_classNames5 = {}, _defineProperty(_classNames5, classes.actionTitle, !fullScreen), _defineProperty(_classNames5, classes.fullScreenActionTitle, fullScreen), _classNames5), confirmationActionsClassName);

        var confirmationActionsFooterClassName = (0, _classnames2['default'])(_defineProperty({}, classes.fullScreenActionFooter, fullScreen), confirmationActionsClassName);

        var titleProps = {
          accent: accent,
          closeClassName: closeClassName,
          closeComponent: closeComponent,
          closeIconComponent: closeIconComponent,
          error: error,
          onCloseClick: this.handleOnCloseClick,
          primary: primary,
          secondary: secondary,
          paperClassName: classes.dialogTitle,
          className: (0, _classnames2['default'])(_defineProperty({}, classes.fullScreenDialogTitle, confirmationActions && fullScreen), titleClassName),
          fullScreen: fullScreen
        };

        var dialogContent = _react2['default'].createElement(
          _Paper2['default'],
          {
            rounded: false,
            'data-mui-test': DISPLAY_NAME,
            elevation: embeddedMode ? 0 : 24,
            className: paperClassName
          },
          _react2['default'].createElement(
            Form,
            formProps,
            progress && _react2['default'].createElement(_Progress2['default'], { className: progressClassName }),
            (title || fullScreen) && _react2['default'].createElement(
              DialogTitle,
              titleProps,
              _react2['default'].createElement(
                'div',
                { className: classes.title },
                _react2['default'].createElement(
                  _Text.Title,
                  { colorInherit: true },
                  title
                ),
                _react2['default'].createElement(
                  _Text.Caption,
                  {
                    noWrap: false,
                    colorInherit: true,
                    className: classes.titleCaption
                  },
                  titleCaption
                )
              ),
              confirmationActions && fullScreen && _react2['default'].createElement(
                ConfirmationActions,
                {
                  id: 'dialog-title-actions',
                  className: confirmationActionsTitleClassName
                },
                confirmationActions
              )
            ),
            _react2['default'].createElement(
              'div',
              { className: classes.dialogContent },
              children
            ),
            confirmationActions && _react2['default'].createElement(
              ConfirmationActions,
              {
                id: 'dialog-footer-actions',
                className: confirmationActionsFooterClassName,
                closeConfirmation: closeConfirmationActions
              },
              confirmationActions
            )
          )
        );

        var content = void 0;

        if (embeddedMode) {
          content = dialogContent;
        } else {
          var transitionProps = {
            'in': open,
            transitionAppear: true,
            className: contentClassName,
            enterTransitionDuration: enterTransitionDuration,
            leaveTransitionDuration: leaveTransitionDuration,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
          };
          var createTransitionFn = typeof transition === 'function' ? _react2['default'].createElement : _react2['default'].cloneElement;

          content = createTransitionFn(transition, transitionProps, dialogContent);
        }

        return _react2['default'].createElement(
          _Modal2['default'],
          _extends({
            className: modalClassName,
            backdrop: !embeddedMode,
            backdropTransitionDuration: open ? enterTransitionDuration : leaveTransitionDuration,
            hideOnBackdropClick: hideOnBackdropClick,
            hideOnEscapeKeyUp: hideOnEscapeKeyUp,
            onBackdropClick: onBackdropClick,
            onEscapeKeyUp: onEscapeKeyUp,
            onRequestClose: onRequestClose,
            show: open
          }, other),
          content
        );
      }

      return render;
    }()
  }]);

  return Dialog;
}(_react.Component), _class.propTypes = {
  /**
   * If `true`, the text will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * The CSS class name of the body element.
   */
  bodyClassName: _PropTypes2['default'].string,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The CSS class name of the close element.
   */
  closeClassName: _PropTypes2['default'].string,
  /**
   * Component to be used as the close element
   */
  closeComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Component to be used as the close element
   */
  closeIconComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Nodes to be placed in the confirmation action container.
   */
  confirmationActions: _Form2['default'].propTypes.confirmationActions,
  /**
   * Component to be used as the confirmation action node
   */
  confirmationActionsComponent: _Form2['default'].propTypes.confirmationActionsComponent,
  /**
   * The CSS class name of the confirmation action element.
   */
  confirmationActionsClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the content element.
   */
  contentClassName: _PropTypes2['default'].string,
  /**
   * If `true`, removes overflow styling on `Paper` component
   */
  disableOverflow: _PropTypes2['default'].bool,
  /**
   * If `true`, the dialog will have embedded mode styles
   */
  embeddedMode: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * Component to be used as the form
   */
  formComponent: _Form2['default'].propTypes.formComponent,
  /**
   * If `true`, The dialog will be full-screen.
   */
  fullScreen: _PropTypes2['default'].bool,
  /**
   * If `true`, clicking the backdrop will fire the `onRequestClose` callback.
   */
  hideOnBackdropClick: _PropTypes2['default'].bool,
  /**
   * If `true`, hitting escape will fire the `onRequestClose` callback.
   */
  hideOnEscapeKeyUp: _PropTypes2['default'].bool,
  /**
   * If `true`, clicking the close will fire the `onRequestClose` callback.
   */
  hideOnCloseClick: _PropTypes2['default'].bool,
  /**
   * Duration of the animation when the element is entering the screen.
   */
  enterTransitionDuration: _PropTypes2['default'].number, // int-disable-line react/sort-prop-types
  /**
   * Duration of the animation when the element is leaving the screen.
   */
  leaveTransitionDuration: _PropTypes2['default'].number,
  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application.
   */
  maxWidth: _PropTypes2['default'].oneOf(['xs', 'sm', 'md']),
  /**
   * Callback fires when the backdrop is clicked on.
   */
  onBackdropClick: _PropTypes2['default'].func,
  /**
   * Callback fires when the close icon is clicked on.
   */
  onCloseClick: _PropTypes2['default'].func,
  /**
   * Callback fired before the dialog is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fires when the escape key is pressed and the modal is in focus.
   */
  onEscapeKeyUp: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the dialog is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired when the dialog requests to be closed.
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * Callback fired when form is submitted
   */
  onSubmit: _PropTypes2['default'].func,
  /**
   * Callback fired when form is validated
   */
  onValidate: _PropTypes2['default'].func,
  /**
   * Set to true to open the Dialog.
   */
  open: _PropTypes2['default'].bool,
  /**
   * If `true`, Progress will appear in DialogTitle.
   */
  progress: _PropTypes2['default'].bool,
  /**
   * The CSS class name of the paper inner element.
   */
  paperClassName: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Node to be placed in the title container.
   */
  title: _PropTypes2['default'].node,
  /**
   * Node to be placed in the title caption container.
   */
  titleCaption: _PropTypes2['default'].node,
  /**
   * Component to be used as the title node
   */
  titleComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * The CSS class name of the title element.
   */
  titleClassName: _PropTypes2['default'].string,
  /**
   * Transition component.
   */
  transition: _PropTypes2['default'].oneOfType([_PropTypes2['default'].func, _PropTypes2['default'].element])
}, _class.defaultProps = {
  confirmationActionsComponent: _DialogActions2['default'],
  disableOverflow: false,
  embeddedMode: false,
  formComponent: _Form2['default'],
  fullScreen: false,
  hideOnBackdropClick: true,
  hideOnCloseClick: true,
  hideOnEscapeKeyUp: true,
  enterTransitionDuration: _transitions.duration.enteringScreen,
  leaveTransitionDuration: _transitions.duration.leavingScreen,
  maxWidth: 'sm',
  open: false,
  progress: false,
  transition: _Fade2['default'],
  titleComponent: _DialogTitle2['default']
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Dialog;


Dialog.displayName = DISPLAY_NAME;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(70);

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(776);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 776 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.stylesheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _colorManipulator = __webpack_require__(264);

var _Menu = __webpack_require__(146);

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stylesheet = exports.stylesheet = (0, _jssThemeReactor.createStyleSheet)('UserAvatar', function (theme) {
  var palette = theme.palette,
      typography = theme.typography;

  var RELATIVE_CAMERA_SIZE = 0.2;
  var ICON_POSITION = 0.775 - RELATIVE_CAMERA_SIZE / 2;

  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '1em',
      width: '1em',
      borderRadius: theme.variables.borderRadius,
      boxSizing: 'border-box',
      overflow: 'hidden',
      userSelect: 'none'
    },
    container: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.variables.borderRadius,
      boxSizing: 'border-box'
    },
    'default': {
      color: palette.background['default'],
      backgroundColor: (0, _colorManipulator.emphasize)(palette.background['default'], 0.26)
    },
    text: {
      fontSize: '0.6em'
    },
    cursor: {
      cursor: 'pointer'
    },
    img: {
      width: '100%',
      height: 'auto'
    },
    iconBox: {
      height: '.325em',
      width: '.325em',
      color: 'white',
      backgroundColor: typography.highlight.color,
      borderRadius: theme.variables.borderRadius,
      textAlign: 'center',
      left: ICON_POSITION + 'em',
      top: ICON_POSITION + 'em',
      position: 'absolute'
    },
    icon: {
      height: '.2em',
      width: '.2em',
      position: 'absolute',
      top: '.08em',
      left: '.065em'
    }
  };
});

var UserAvatar = (_temp2 = _class = function (_Component) {
  _inherits(UserAvatar, _Component);

  function UserAvatar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserAvatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.open = function (open) {
      return _this.setState({ open: open });
    }, _this.handleUserAvatarClick = function () {
      var _this$props$_this$sta = Object.assign({}, _this.props, _this.state),
          open = _this$props$_this$sta.open;

      _this.open(!open);
    }, _this.handleRequestClose = function () {
      return _this.open(false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserAvatar, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this,
            _classNames;

        var _props$state = Object.assign({}, this.props, this.state),
            alt = _props$state.alt,
            icon = _props$state.icon,
            classNameProp = _props$state.className,
            childrenProp = _props$state.children,
            childrenClassNameProp = _props$state.childrenClassName,
            ComponentProp = _props$state.component,
            open = _props$state.open,
            menuItems = _props$state.menuItems,
            onClick = _props$state.onClick,
            sizes = _props$state.sizes,
            src = _props$state.src,
            srcSet = _props$state.srcSet,
            style = _props$state.style,
            other = _objectWithoutProperties(_props$state, ['alt', 'icon', 'className', 'children', 'childrenClassName', 'component', 'open', 'menuItems', 'onClick', 'sizes', 'src', 'srcSet', 'style']);

        var hasImage = src || srcSet;
        var userAvatarClick = onClick ? function () {
          onClick();
          _this2.handleUserAvatarClick();
        } : menuItems ? this.handleUserAvatarClick : false;
        var Icon = icon;
        var classes = this.context.styleManager.render(stylesheet);
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes['default'], childrenProp && !hasImage), _defineProperty(_classNames, classes.cursor, userAvatarClick), _classNames), classNameProp);
        var iconBoxClassName = (0, _classnames2['default'])(classes.iconBox, _defineProperty({}, classes.cursor, userAvatarClick));
        var containerProps = Object.assign({
          className: className,
          onClick: userAvatarClick
        }, other);
        var iconBoxProps = {
          className: iconBoxClassName,
          onClick: userAvatarClick
        };

        var children = null;

        if (hasImage) {
          var imgProps = {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes,
            className: classes.img
          };
          children = _react2['default'].createElement('img', _extends({ alt: alt }, imgProps));
        } else if (childrenProp) {
          if (childrenClassNameProp && _react2['default'].isValidElement(childrenProp)) {
            var childrenClassName = (0, _classnames2['default'])(childrenClassNameProp, childrenProp.props.className);
            children = _react2['default'].cloneElement(childrenProp, {
              className: childrenClassName
            });
          } else if (typeof childrenProp === 'string') {
            children = childrenProp.substr(childrenProp.search(/[a-zA-Z]/), 1).toUpperCase();
          } else {
            children = childrenProp;
          }
        }

        return _react2['default'].createElement(
          'div',
          {
            className: classes.container,
            style: style,
            ref: function () {
              function ref(rootNode) {
                return _this2.rootNode = rootNode;
              }

              return ref;
            }()
          },
          _react2['default'].createElement(
            ComponentProp,
            containerProps,
            hasImage ? children : _react2['default'].createElement(
              'span',
              { className: classes.text },
              children
            )
          ),
          icon && _react2['default'].createElement(
            'div',
            iconBoxProps,
            _react2['default'].createElement(Icon, { className: classes.icon })
          ),
          menuItems && _react2['default'].createElement(
            _Menu2['default'],
            {
              open: open,
              anchorEl: this.rootNode,
              onRequestClose: this.handleRequestClose
            },
            _react.Children.map(menuItems, function (child) {
              if (!child) return;
              return _react2['default'].cloneElement(child, {
                onClick: function () {
                  function onClick() {
                    if (child.props.onClick) {
                      child.props.onClick();
                    }
                    _this2.handleRequestClose();
                  }

                  return onClick;
                }()
              });
            })
          )
        );
      }

      return render;
    }()
  }]);

  return UserAvatar;
}(_react.Component), _class.propTypes = {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _PropTypes2['default'].string,
  /**
   * SvgIcon to show on Avatar
   */
  icon: _PropTypes2['default'].func,
  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   * If it is a string, a two character initial will be parsed from it.
   */
  children: _PropTypes2['default'].node,
  /**
   * @ignore
   * The className of the child element.
   * Used by Chip to style the Avatar icon.
   */
  childrenClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The component type of the root element.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * If `true`, then menu is displayed
   */
  open: _PropTypes2['default'].bool,
  /**
   * Used to render menu items inside the Avatar.
   */
  menuItems: _PropTypes2['default'].node,
  /**
   * sizes desc
   */
  sizes: _PropTypes2['default'].string,
  /**
   * src desc
   */
  src: _PropTypes2['default'].string,
  /**
   * srcSet desc
   */
  srcSet: _PropTypes2['default'].string
}, _class.defaultProps = {
  alt: '',
  component: 'div',
  open: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = UserAvatar;


UserAvatar.displayName = 'UserAvatar';

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Placeholder = (_temp = _class = function (_SvgIcon) {
  _inherits(Placeholder, _SvgIcon);

  function Placeholder() {
    _classCallCheck(this, Placeholder);

    return _possibleConstructorReturn(this, (Placeholder.__proto__ || Object.getPrototypeOf(Placeholder)).apply(this, arguments));
  }

  _createClass(Placeholder, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(_SvgIcon3['default'], this.props);
      }

      return render;
    }()
  }]);

  return Placeholder;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 18 18'
}, _temp);
exports['default'] = Placeholder;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeyboardArrowLeft = function (_SvgIcon) {
  _inherits(KeyboardArrowLeft, _SvgIcon);

  function KeyboardArrowLeft() {
    _classCallCheck(this, KeyboardArrowLeft);

    return _possibleConstructorReturn(this, (KeyboardArrowLeft.__proto__ || Object.getPrototypeOf(KeyboardArrowLeft)).apply(this, arguments));
  }

  _createClass(KeyboardArrowLeft, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' })
        );
      }

      return render;
    }()
  }]);

  return KeyboardArrowLeft;
}(_SvgIcon3['default']);

exports['default'] = KeyboardArrowLeft;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1847);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArrowDropDown = (_temp = _class = function (_SvgIcon) {
  _inherits(ArrowDropDown, _SvgIcon);

  function ArrowDropDown() {
    _classCallCheck(this, ArrowDropDown);

    return _possibleConstructorReturn(this, (ArrowDropDown.__proto__ || Object.getPrototypeOf(ArrowDropDown)).apply(this, arguments));
  }

  _createClass(ArrowDropDown, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M6.66667,9H1.33333a1.32579,1.32579,0,0,0-1.17556.7394,1.45985,1.45985,0,0,0,.06616,1.43718l2.66667,4.2a1.29882,1.29882,0,0,0,2.2188,0l2.66667-4.2A1.45985,1.45985,0,0,0,7.84223,9.7394,1.32579,1.32579,0,0,0,6.66667,9Zm0,2.8h0Z' })
        );
      }

      return render;
    }()
  }]);

  return ArrowDropDown;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '-8 0 8 24'
}, _temp);
exports['default'] = ArrowDropDown;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArrowDropDown = (_temp = _class = function (_SvgIcon) {
  _inherits(ArrowDropDown, _SvgIcon);

  function ArrowDropDown() {
    _classCallCheck(this, ArrowDropDown);

    return _possibleConstructorReturn(this, (ArrowDropDown.__proto__ || Object.getPrototypeOf(ArrowDropDown)).apply(this, arguments));
  }

  _createClass(ArrowDropDown, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M1.33333,16H6.66667a1.32579,1.32579,0,0,0,1.17556-.7394,1.45985,1.45985,0,0,0-.06616-1.43718l-2.66667-4.2a1.29882,1.29882,0,0,0-2.2188,0l-2.66667,4.2A1.45985,1.45985,0,0,0,.15777,15.2606,1.32579,1.32579,0,0,0,1.33333,16Zm0-2.8h0Z' })
        );
      }

      return render;
    }()
  }]);

  return ArrowDropDown;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '-8 0 16 24'
}, _temp);
exports['default'] = ArrowDropDown;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_SvgIcon) {
  _inherits(Search, _SvgIcon);

  function Search() {
    _classCallCheck(this, Search);

    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
  }

  _createClass(Search, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M24,22,16.94,15a9.17,9.17,0,1,0-2,2L22,24ZM4.37,14.74a7.33,7.33,0,1,1,5.19,2.15A7.29,7.29,0,0,1,4.37,14.74Z' })
        );
      }

      return render;
    }()
  }]);

  return Search;
}(_SvgIcon3['default']);

exports['default'] = Search;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Headline;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(62);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Text = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DISPLAY_NAME = 'Headline';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(DISPLAY_NAME, function (theme) {
  return {
    root: theme.mixins.gutters(2)
  };
});

function Headline(props, context) {
  var children = props.children,
      classNameProp = props.className,
      other = _objectWithoutProperties(props, ['children', 'className']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2.default)(classes.root, classNameProp);

  return _react2.default.createElement(
    _Text.Headline,
    _extends({ paragraph: true, className: className }, other),
    children
  );
}
Headline.displayName = DISPLAY_NAME;
Headline.contextTypes = {
  styleManager: _PropTypes2.default.styleManager.isRequired
};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Material Icon is plural, so we are too.
// See https://material.io/icons/#ic_notifications
var Notifications = function (_SvgIcon) {
  _inherits(Notifications, _SvgIcon);

  function Notifications() {
    _classCallCheck(this, Notifications);

    return _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).apply(this, arguments));
  }

  _createClass(Notifications, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' })
        );
      }

      return render;
    }()
  }]);

  return Notifications;
}(_SvgIcon3['default']);

exports['default'] = Notifications;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  credentialID: string,
  teamName: string,
  displayName: string,
  urls: arrayOf(string),
  identifier: string,
  secret: string,
  appName: string
});

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user = __webpack_require__(393);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eventually we'll be more precise in what props are acceptable on user vs integration,
// but for now they're the same
exports.default = _user2.default;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _field = __webpack_require__(91);

var _field2 = _interopRequireDefault(_field);

var _file = __webpack_require__(381);

var _file2 = _interopRequireDefault(_file);

var _task = __webpack_require__(398);

var _task2 = _interopRequireDefault(_task);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

// eslint-disable-line no-unused-vars

exports.default = shape({
  category: string,
  completedCount: number,
  createdBy: string,
  deadlineWarning: string,
  description: string,
  displayName: string,
  endDate: string,
  eventID: string,
  fields: arrayOf(_field2.default),
  files: arrayOf(_file2.default),
  isOverdue: bool,
  isTest: bool,
  overdueCount: number,
  owner: string,
  ownerEmail: string,
  ownerFullName: string,
  percentComplete: number,
  percentTimeElapsed: number,
  priority: string,
  processDisplayName: string,
  processID: string,
  progressSecret: string,
  runID: string,
  runningCount: number,
  skippedCount: number,
  startDate: string,
  status: string,
  taskCount: number,
  tasks: arrayOf(_task2.default),
  teamName: string,
  waitingCount: number
});

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(159);
var test = {};
test[__webpack_require__(19)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(45)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(279)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(280)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(288);
var getKeys = __webpack_require__(98);
var redefine = __webpack_require__(45);
var global = __webpack_require__(13);
var hide = __webpack_require__(44);
var Iterators = __webpack_require__(125);
var wks = __webpack_require__(19);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 795 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ANALYTICS_TRACK = exports.ANALYTICS_TRACK = 'ANALYTICS_TRACK';

var track = exports.track = function track(_ref) {
  var event = _ref.event,
      properties = _ref.properties;
  return {
    type: ANALYTICS_TRACK,
    payload: {
      event: event,
      properties: properties
    }
  };
};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1271),
    baseAggregator = __webpack_require__(1272),
    baseIteratee = __webpack_require__(57),
    isArray = __webpack_require__(27);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(195);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_TASKS_FAILURE = exports.UPDATE_TASKS_SUCCESS = exports.UPDATE_TASKS_REQUEST = exports.UPDATE_TASKS = exports.GET_USER_TASKS_FAILURE = exports.GET_USER_TASKS_SUCCESS = exports.GET_USER_TASKS_REQUEST = exports.GET_USER_TASKS = exports.GET_TASKS_FAILURE = exports.GET_TASKS_SUCCESS = exports.GET_TASKS_REQUEST = exports.GET_TASKS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTasks = getTasks;
exports.getUserTasks = getUserTasks;
exports.updateTasks = updateTasks;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _url = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_TASKS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TASKS = _api$buildTypes2[0],
    GET_TASKS_REQUEST = _api$buildTypes2[1],
    GET_TASKS_SUCCESS = _api$buildTypes2[2],
    GET_TASKS_FAILURE = _api$buildTypes2[3];
exports.GET_TASKS = GET_TASKS;
exports.GET_TASKS_REQUEST = GET_TASKS_REQUEST;
exports.GET_TASKS_SUCCESS = GET_TASKS_SUCCESS;
exports.GET_TASKS_FAILURE = GET_TASKS_FAILURE;
function getTasks(options) {
  var teamName = options.teamName,
      username = options.username,
      assignedTo = options.assignedTo,
      status = options.status,
      limit = options.limit,
      pageKey = options.pageKey,
      q = options.q,
      sort = options.sort;


  if (!q) {
    var _query = {};
    if (assignedTo) {
      _query.assignedTo = Array.isArray(assignedTo) ? assignedTo.join(',') : assignedTo;
    }
    if (status) {
      _query.status = status;
    }
    if (limit) {
      _query.limit = limit;
    }
    if (pageKey) {
      _query.after = pageKey;
    }
    if (sort) {
      _query.sort = sort;
    }

    return {
      type: GET_TASKS,
      payload: {
        url: (0, _url.format)({
          pathname: '/teams/' + teamName + '/tasks',
          query: _query
        }),
        schema: _schemas.TASK_LIST,
        options: {
          method: 'GET'
        }
      }
    };
  }

  var query = {
    types: 'tasks'
  };
  if (status && status !== 'all') {
    query.status = status;
  }
  if (username) {
    query.assignedTo = Array.isArray(username) ? username.join(',') : username;
  }
  if (limit) {
    query.limit = limit;
  }
  if (pageKey) {
    query.pageToken = pageKey;
  }
  if (q) {
    query.q = q;
  }
  if (sort) {
    query.sort = sort;
  }

  var url = (0, _url.format)({
    pathname: '/teams/' + teamName + '/search',
    query: query
  });

  return {
    type: GET_TASKS,
    payload: {
      url: url,
      schema: _schemas.TASK_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('GET_USER_TASKS'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var GET_USER_TASKS = _api$buildTypes4[0],
    GET_USER_TASKS_REQUEST = _api$buildTypes4[1],
    GET_USER_TASKS_SUCCESS = _api$buildTypes4[2],
    GET_USER_TASKS_FAILURE = _api$buildTypes4[3];
exports.GET_USER_TASKS = GET_USER_TASKS;
exports.GET_USER_TASKS_REQUEST = GET_USER_TASKS_REQUEST;
exports.GET_USER_TASKS_SUCCESS = GET_USER_TASKS_SUCCESS;
exports.GET_USER_TASKS_FAILURE = GET_USER_TASKS_FAILURE;
function getUserTasks(_ref) {
  var teamName = _ref.teamName,
      _ref$username = _ref.username,
      username = _ref$username === undefined ? 'me' : _ref$username,
      _ref$status = _ref.status,
      status = _ref$status === undefined ? 'all' : _ref$status;

  return {
    type: GET_USER_TASKS,
    payload: {
      url: '/teams/' + teamName + '/users/' + username + '/tasks?status=' + status,
      schema: _schemas.TASK_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_TASKS'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_TASKS = _api$buildTypes6[0],
    UPDATE_TASKS_REQUEST = _api$buildTypes6[1],
    UPDATE_TASKS_SUCCESS = _api$buildTypes6[2],
    UPDATE_TASKS_FAILURE = _api$buildTypes6[3];
exports.UPDATE_TASKS = UPDATE_TASKS;
exports.UPDATE_TASKS_REQUEST = UPDATE_TASKS_REQUEST;
exports.UPDATE_TASKS_SUCCESS = UPDATE_TASKS_SUCCESS;
exports.UPDATE_TASKS_FAILURE = UPDATE_TASKS_FAILURE;
function updateTasks(_ref2) {
  var teamName = _ref2.teamName,
      runID = _ref2.runID,
      tasks = _ref2.tasks;

  return {
    type: UPDATE_TASKS,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/tasks',
      schema: _schemas.TASK_LIST,
      options: {
        method: 'PUT',
        body: tasks
      }
    }
  };
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_PREDICTORS_FAILURE = exports.GET_PREDICTORS_SUCCESS = exports.GET_PREDICTORS_REQUEST = exports.GET_PREDICTORS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getPredictors = getPredictors;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_PREDICTORS'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_PREDICTORS = _api$buildTypes2[0],
    GET_PREDICTORS_REQUEST = _api$buildTypes2[1],
    GET_PREDICTORS_SUCCESS = _api$buildTypes2[2],
    GET_PREDICTORS_FAILURE = _api$buildTypes2[3];
exports.GET_PREDICTORS = GET_PREDICTORS;
exports.GET_PREDICTORS_REQUEST = GET_PREDICTORS_REQUEST;
exports.GET_PREDICTORS_SUCCESS = GET_PREDICTORS_SUCCESS;
exports.GET_PREDICTORS_FAILURE = GET_PREDICTORS_FAILURE;
function getPredictors(_ref) {
  var teamName = _ref.teamName;

  return {
    type: GET_PREDICTORS,
    payload: {
      url: '/teams/' + teamName + '/predictors',
      schema: _schemas.PREDICTOR_LIST
    }
  };
}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_TRIGGER_FAILURE = exports.DELETE_TRIGGER_SUCCESS = exports.DELETE_TRIGGER_REQUEST = exports.DELETE_TRIGGER = exports.UPDATE_TRIGGER_FAILURE = exports.UPDATE_TRIGGER_SUCCESS = exports.UPDATE_TRIGGER_REQUEST = exports.UPDATE_TRIGGER = exports.GET_TRIGGER_FAILURE = exports.GET_TRIGGER_SUCCESS = exports.GET_TRIGGER_REQUEST = exports.GET_TRIGGER = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTrigger = getTrigger;
exports.updateTrigger = updateTrigger;
exports.deleteTrigger = deleteTrigger;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

var _webhook = __webpack_require__(250);

var _upcoming = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_TRIGGER'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TRIGGER = _api$buildTypes2[0],
    GET_TRIGGER_REQUEST = _api$buildTypes2[1],
    GET_TRIGGER_SUCCESS = _api$buildTypes2[2],
    GET_TRIGGER_FAILURE = _api$buildTypes2[3];
exports.GET_TRIGGER = GET_TRIGGER;
exports.GET_TRIGGER_REQUEST = GET_TRIGGER_REQUEST;
exports.GET_TRIGGER_SUCCESS = GET_TRIGGER_SUCCESS;
exports.GET_TRIGGER_FAILURE = GET_TRIGGER_FAILURE;
function getTrigger(_ref) {
  var teamName = _ref.teamName,
      triggerID = _ref.triggerID;

  return {
    type: GET_TRIGGER,
    payload: {
      url: '/teams/' + teamName + '/triggers/' + triggerID,
      schema: _schemas.TRIGGER,
      options: {
        method: 'GET'
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('UPDATE_TRIGGER'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var UPDATE_TRIGGER = _api$buildTypes4[0],
    UPDATE_TRIGGER_REQUEST = _api$buildTypes4[1],
    UPDATE_TRIGGER_SUCCESS = _api$buildTypes4[2],
    UPDATE_TRIGGER_FAILURE = _api$buildTypes4[3];
exports.UPDATE_TRIGGER = UPDATE_TRIGGER;
exports.UPDATE_TRIGGER_REQUEST = UPDATE_TRIGGER_REQUEST;
exports.UPDATE_TRIGGER_SUCCESS = UPDATE_TRIGGER_SUCCESS;
exports.UPDATE_TRIGGER_FAILURE = UPDATE_TRIGGER_FAILURE;
function updateTrigger(_ref2) {
  var teamName = _ref2.teamName,
      trigger = _ref2.trigger;

  return {
    type: UPDATE_TRIGGER,
    payload: {
      url: '/teams/' + teamName + '/triggers/' + trigger.triggerID,
      schema: _schemas.TRIGGER,
      options: {
        method: 'PUT',
        body: trigger
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('DELETE_TRIGGER'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var DELETE_TRIGGER = _api$buildTypes6[0],
    DELETE_TRIGGER_REQUEST = _api$buildTypes6[1],
    DELETE_TRIGGER_SUCCESS = _api$buildTypes6[2],
    DELETE_TRIGGER_FAILURE = _api$buildTypes6[3];
exports.DELETE_TRIGGER = DELETE_TRIGGER;
exports.DELETE_TRIGGER_REQUEST = DELETE_TRIGGER_REQUEST;
exports.DELETE_TRIGGER_SUCCESS = DELETE_TRIGGER_SUCCESS;
exports.DELETE_TRIGGER_FAILURE = DELETE_TRIGGER_FAILURE;
function deleteTrigger(_ref3) {
  var teamName = _ref3.teamName,
      _ref3$triggerID = _ref3.triggerID,
      triggerID = _ref3$triggerID === undefined ? '' : _ref3$triggerID;

  if (triggerID.match(/^w_/)) {
    return (0, _webhook.deleteWebhook)({ teamName: teamName, webhookID: triggerID.replace(/^w_/, '') });
  } else if (triggerID.match(/^s_/)) {
    return (0, _upcoming.deleteUpcoming)({
      teamName: teamName,
      upcomingID: triggerID.replace(/^s_/, '')
    });
  } else {
    return {
      type: DELETE_TRIGGER,
      payload: {
        url: '/teams/' + teamName + '/triggers/' + triggerID,
        schema: _schemas.TRIGGER,
        options: {
          method: 'DELETE'
        }
      }
    };
  }
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_MESSAGE_BODY_FAILURE = exports.GET_MESSAGE_BODY_SUCCESS = exports.GET_MESSAGE_BODY_REQUEST = exports.GET_MESSAGE_BODY = exports.ADD_MESSAGE_FAILURE = exports.ADD_MESSAGE_SUCCESS = exports.ADD_MESSAGE_REQUEST = exports.ADD_MESSAGE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.addMessage = addMessage;
exports.getMessageBody = getMessageBody;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('ADD_MESSAGE'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var ADD_MESSAGE = _api$buildTypes2[0],
    ADD_MESSAGE_REQUEST = _api$buildTypes2[1],
    ADD_MESSAGE_SUCCESS = _api$buildTypes2[2],
    ADD_MESSAGE_FAILURE = _api$buildTypes2[3];

// If you want to add a comment to a run, use comment.addComment instead.

exports.ADD_MESSAGE = ADD_MESSAGE;
exports.ADD_MESSAGE_REQUEST = ADD_MESSAGE_REQUEST;
exports.ADD_MESSAGE_SUCCESS = ADD_MESSAGE_SUCCESS;
exports.ADD_MESSAGE_FAILURE = ADD_MESSAGE_FAILURE;
function addMessage(_ref) {
  var teamName = _ref.teamName,
      threadID = _ref.threadID,
      username = _ref.username,
      body = _ref.body;

  return {
    type: ADD_MESSAGE,
    payload: {
      url: '/teams/' + teamName + '/threads/' + threadID + '/messages',
      schema: _schemas.MESSAGE,
      options: {
        method: 'POST',
        body: { username: username, body: body }
      }
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('GET_MESSAGE_BODY'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var GET_MESSAGE_BODY = _api$buildTypes4[0],
    GET_MESSAGE_BODY_REQUEST = _api$buildTypes4[1],
    GET_MESSAGE_BODY_SUCCESS = _api$buildTypes4[2],
    GET_MESSAGE_BODY_FAILURE = _api$buildTypes4[3];
exports.GET_MESSAGE_BODY = GET_MESSAGE_BODY;
exports.GET_MESSAGE_BODY_REQUEST = GET_MESSAGE_BODY_REQUEST;
exports.GET_MESSAGE_BODY_SUCCESS = GET_MESSAGE_BODY_SUCCESS;
exports.GET_MESSAGE_BODY_FAILURE = GET_MESSAGE_BODY_FAILURE;
function getMessageBody(_ref2) {
  var teamName = _ref2.teamName,
      threadID = _ref2.threadID,
      messageID = _ref2.messageID;

  return {
    type: GET_MESSAGE_BODY,
    payload: {
      url: '/teams/' + teamName + '/threads/' + threadID + '/messages/' + messageID + '/body',
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Api = (_temp = _class = function (_SvgIcon) {
  _inherits(Api, _SvgIcon);

  function Api() {
    _classCallCheck(this, Api);

    return _possibleConstructorReturn(this, (Api.__proto__ || Object.getPrototypeOf(Api)).apply(this, arguments));
  }

  _createClass(Api, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M27.17,21.67A1,1,0,0,0,26.88,21L25.82,19.9a1,1,0,0,0-1.41,0l-3.57,3.57-2.05-2.05,3.57-3.57a1,1,0,0,0,0-1.41l-1.06-1.06a1,1,0,0,0-1.41,0l-3.57,3.57-1.63-1.63a1,1,0,0,0-1.41,0L9,21.64a1,1,0,0,0-.27.9L9.5,26.75,7.26,29a1,1,0,0,0,0,1.41L7.75,30.9l-2,2a1,1,0,0,0,0,1.41l2.19,2.19a1,1,0,0,0,1.41,0l2-2L11.85,35a1,1,0,0,0,1.41,0l2.24-2.24,4.22,0.82a1,1,0,0,0,.9-0.27L24.93,29a1,1,0,0,0,0-1.41l-1.63-1.63,3.57-3.57A1,1,0,0,0,27.17,21.67Zm-6.59-5,0.5,0.5-3.29,3.29-0.5-.5Zm-12,18.6L7,33.62l1.73-1.73,1.63,1.63Zm10.95-3.74-4.22-.82a1,1,0,0,0-.9.27l-1.91,1.91L9.38,29.7l1.91-1.91a1,1,0,0,0,.27-0.9l-0.82-4.22L14,19.44l8.84,8.84ZM22.32,25l-0.49-.49,3.29-3.29,0.5,0.49Z' }),
          _react2['default'].createElement('path', { d: 'M39.41,5L37.22,2.85a1,1,0,0,0-1.41,0L33.08,5.57,33.5,6l0.28,0.28,0.28,0.28,2.44-2.44,1.63,1.63L35.7,8.19,36,8.47l0.28,0.28,0.42,0.42,2.72-2.72A1,1,0,0,0,39.41,5Z' }),
          _react2['default'].createElement('path', { d: 'M31.17,22.34A1,1,0,0,1,30.46,22L20.21,11.79a1,1,0,0,1,0-1.41l4.31-4.31a1,1,0,0,1,.9-0.27l4.22,0.82,2.24-2.24a1,1,0,0,1,1.41,0L37.89,9a1,1,0,0,1,0,1.41l-2.24,2.24,0.82,4.22a1,1,0,0,1-.27.9L31.88,22A1,1,0,0,1,31.17,22.34ZM22.33,11.09l8.84,8.84L34.4,16.7l-0.82-4.22a1,1,0,0,1,.27-0.9l1.91-1.91L32.58,6.49,30.68,8.4a1,1,0,0,1-.9.27l-4.22-.82Z' }),
          _react2['default'].createElement('path', { d: 'M34,34.81H31.29l-0.2-1.24H29.31L29.1,34.81H26.36L28.72,25H32Zm-3.24-3.35-0.17-1.14a1.13,1.13,0,0,1,0-.17q0-.14-0.13-1.1l0-.29c0-.12,0-0.28-0.05-0.47l-0.08-.93c0,0.09,0,.19,0,0.3l0,0.36q0,0.39-.06.55c0,0.1,0,.16,0,0.18l-0.18,1.19-0.27,1.54h1.12Z' }),
          _react2['default'].createElement('path', { d: 'M37.44,34.81H34.8V25h2.56a4.34,4.34,0,0,1,2.84.78,3.16,3.16,0,0,1,1.09,2.56A3.12,3.12,0,0,1,40.14,31a3.76,3.76,0,0,1-2.28.59H37.44v3.21Zm0-5.41h0.12a1,1,0,0,0,.77-0.29,1.12,1.12,0,0,0,.29-0.81,1.21,1.21,0,0,0-.28-0.83,0.9,0.9,0,0,0-.71-0.32H37.44V29.4Z' }),
          _react2['default'].createElement('path', { d: 'M44.87,34.81H42.23V25h2.65v9.8Z' })
        );
      }

      return render;
    }()
  }]);

  return Api;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 50 39.88'
}, _temp);
exports['default'] = Api;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Face = function (_SvgIcon) {
  _inherits(Face, _SvgIcon);

  function Face() {
    _classCallCheck(this, Face);

    return _possibleConstructorReturn(this, (Face.__proto__ || Object.getPrototypeOf(Face)).apply(this, arguments));
  }

  _createClass(Face, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z' })
        );
      }

      return render;
    }()
  }]);

  return Face;
}(_SvgIcon3['default']);

exports['default'] = Face;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Github = function (_SvgIcon) {
  _inherits(Github, _SvgIcon);

  function Github() {
    _classCallCheck(this, Github);

    return _possibleConstructorReturn(this, (Github.__proto__ || Object.getPrototypeOf(Github)).apply(this, arguments));
  }

  _createClass(Github, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M12,0A12,12,0,0,0,8.21,23.39c.6.11.82-.26.82-.58s0-1.23,0-2.23c-3.34.73-4-1.41-4-1.41A3.16,3.16,0,0,0,3.64,17.4c-1.09-.75.08-.73.08-.73a2.53,2.53,0,0,1,1.84,1.24,2.55,2.55,0,0,0,3.49,1,2.57,2.57,0,0,1,.76-1.61C7.16,17,4.35,16,4.35,11.37A4.64,4.64,0,0,1,5.58,8.15,4.32,4.32,0,0,1,5.7,5s1-.32,3.3,1.23a11.38,11.38,0,0,1,6,0C17.29,4.65,18.31,5,18.31,5a4.31,4.31,0,0,1,.12,3.18,4.63,4.63,0,0,1,1.23,3.22c0,4.61-2.81,5.62-5.48,5.92A2.86,2.86,0,0,1,15,19.51c0,1.61,0,2.9,0,3.29s.22.69.82.58A12,12,0,0,0,12,0Z' }),
          _react2['default'].createElement('path', { d: 'M4.55,17.23a.14.14,0,0,1-.2,0c-.08,0-.14-.12-.11-.18a.15.15,0,0,1,.2,0c.08,0,.14.12.11.18Z' }),
          _react2['default'].createElement('path', { d: 'M5,17.77c-.06.05-.17,0-.24-.06a.18.18,0,0,1,0-.25c.06-.05.17,0,.25.06S5.09,17.72,5,17.77Z' }),
          _react2['default'].createElement('path', { d: 'M5.51,18.46c-.07.05-.2,0-.27-.1s-.07-.23,0-.29.2,0,.27.1S5.58,18.41,5.51,18.46Z' }),
          _react2['default'].createElement('path', { d: 'M6.16,19.13c-.07.07-.2.05-.31,0a.23.23,0,0,1-.07-.31c.07-.07.2-.05.31,0S6.23,19.06,6.16,19.13Z' }),
          _react2['default'].createElement('path', { d: 'M7.05,19.52c0,.09-.16.14-.3.1s-.22-.15-.2-.25.16-.14.3-.1S7.08,19.42,7.05,19.52Z' }),
          _react2['default'].createElement('path', { d: 'M8,19.59c0,.1-.11.18-.25.18s-.26-.08-.26-.17.11-.18.26-.18.26.08.26.17Z' }),
          _react2['default'].createElement('path', { d: 'M8.95,19.43c0,.1-.08.2-.22.22s-.27,0-.29-.13.08-.2.22-.22.27,0,.29.13Z' })
        );
      }

      return render;
    }()
  }]);

  return Github;
}(_SvgIcon3['default']);

exports['default'] = Github;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormatListBulleted = function (_SvgIcon) {
  _inherits(FormatListBulleted, _SvgIcon);

  function FormatListBulleted() {
    _classCallCheck(this, FormatListBulleted);

    return _possibleConstructorReturn(this, (FormatListBulleted.__proto__ || Object.getPrototypeOf(FormatListBulleted)).apply(this, arguments));
  }

  _createClass(FormatListBulleted, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
        );
      }

      return render;
    }()
  }]);

  return FormatListBulleted;
}(_SvgIcon3['default']);

exports['default'] = FormatListBulleted;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocationOn = function (_SvgIcon) {
  _inherits(LocationOn, _SvgIcon);

  function LocationOn() {
    _classCallCheck(this, LocationOn);

    return _possibleConstructorReturn(this, (LocationOn.__proto__ || Object.getPrototypeOf(LocationOn)).apply(this, arguments));
  }

  _createClass(LocationOn, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
        );
      }

      return render;
    }()
  }]);

  return LocationOn;
}(_SvgIcon3['default']);

exports['default'] = LocationOn;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Mail = function (_SvgIcon) {
  _inherits(Mail, _SvgIcon);

  function Mail() {
    _classCallCheck(this, Mail);

    return _possibleConstructorReturn(this, (Mail.__proto__ || Object.getPrototypeOf(Mail)).apply(this, arguments));
  }

  _createClass(Mail, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0,0H24V24H0V0Z', fill: 'none' }),
          _react2['default'].createElement('path', { d: 'M23.1,19.34a0.75,0.75,0,0,0,0-.07V5.5a0.81,0.81,0,0,0-.81-0.81H1.91a0.81,0.81,0,0,0-.81.81V19.27a0.75,0.75,0,0,0,0,.07,0.8,0.8,0,0,0,0,.23,0.8,0.8,0,0,0,.14.22l0,0h0a0.81,0.81,0,0,0,.57.24H22.31a0.81,0.81,0,0,0,.57-0.24h0l0,0A0.65,0.65,0,0,0,23.1,19.34ZM2.72,8.1l5,4.26-5,5V8.1Zm9.83,5.46a0.83,0.83,0,0,1-.44.22,0.67,0.67,0,0,1-.43-0.2h0l-0.1-.11L3.11,6.31h18ZM9,13.41l1.5,1.27a2.28,2.28,0,0,0,1.62.73,2.39,2.39,0,0,0,1.53-.65l1.6-1.35,5.1,5H3.88Zm7.49-1.05,5-4.26v9.22Z' })
        );
      }

      return render;
    }()
  }]);

  return Mail;
}(_SvgIcon3['default']);

exports['default'] = Mail;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Public = function (_SvgIcon) {
  _inherits(Public, _SvgIcon);

  function Public() {
    _classCallCheck(this, Public);

    return _possibleConstructorReturn(this, (Public.__proto__ || Object.getPrototypeOf(Public)).apply(this, arguments));
  }

  _createClass(Public, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
        );
      }

      return render;
    }()
  }]);

  return Public;
}(_SvgIcon3['default']);

exports['default'] = Public;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Text = function (_SvgIcon) {
  _inherits(Text, _SvgIcon);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }

  _createClass(Text, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'defs',
            null,
            _react2['default'].createElement('path', { d: 'M24 24H0V0h24v24z' })
          ),
          _react2['default'].createElement('path', { d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z' })
        );
      }

      return render;
    }()
  }]);

  return Text;
}(_SvgIcon3['default']);

exports['default'] = Text;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(700);

var _fieldType = __webpack_require__(1420);

var TYPES = _interopRequireWildcard(_fieldType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TASK_COUNT = {
  displayName: 'Task Count',
  fieldName: 'run.taskCount',
  type: TYPES.FIELD_TYPE_NUMBER
};

var RUN_OWNER_EMAIL = {
  displayName: 'Run Owner Email',
  fieldName: 'run.owner.email',
  type: TYPES.FIELD_TYPE_STRING
};

var RUN_OWNER_FULLNAME = {
  displayName: 'Run Owner Full Name',
  fieldName: 'run.owner.fullName',
  type: TYPES.FIELD_TYPE_STRING
};

var RUN_START_DATE = {
  displayName: 'Run Start Date',
  fieldName: 'run.startDate',
  type: TYPES.FIELD_TYPE_DATE
};

var RUN_PERCENT_COMPLETE = {
  displayName: 'Run Percent Complete',
  fieldName: 'run.percentComplete',
  type: TYPES.FIELD_TYPE_NUMBER
};

var RUN_COMPLETED_COUNT = {
  displayName: 'Completed Task Count',
  fieldName: 'run.completedCount',
  type: TYPES.FIELD_TYPE_NUMBER
};

var RUN_IS_OVERDUE = {
  displayName: 'Run is Overdue',
  fieldName: 'run.isOverdue',
  type: TYPES.FIELD_TYPE_BOOL
};

var IMPLICIT_RUN_FIELDS = [TASK_COUNT, RUN_OWNER_EMAIL, RUN_OWNER_FULLNAME, RUN_START_DATE, RUN_PERCENT_COMPLETE, RUN_COMPLETED_COUNT, RUN_IS_OVERDUE];

exports.default = IMPLICIT_RUN_FIELDS;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_CREDENTIAL_FAILURE = exports.DELETE_CREDENTIAL_SUCCESS = exports.DELETE_CREDENTIAL_REQUEST = exports.DELETE_CREDENTIAL = exports.UPDATE_CREDENTIAL_FAILURE = exports.UPDATE_CREDENTIAL_SUCCESS = exports.UPDATE_CREDENTIAL_REQUEST = exports.UPDATE_CREDENTIAL = exports.ADD_CREDENTIAL_FAILURE = exports.ADD_CREDENTIAL_SUCCESS = exports.ADD_CREDENTIAL_REQUEST = exports.ADD_CREDENTIAL = exports.GET_CREDENTIAL_FAILURE = exports.GET_CREDENTIAL_SUCCESS = exports.GET_CREDENTIAL_REQUEST = exports.GET_CREDENTIAL = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// TODO this will be deprecated after https://github.com/catalyticlabs/pushbot-api/pull/6643

exports.getCredential = getCredential;
exports.addCredential = addCredential;
exports.updateCredential = updateCredential;
exports.deleteCredential = deleteCredential;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_CREDENTIAL'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_CREDENTIAL = _api$buildTypes2[0],
    GET_CREDENTIAL_REQUEST = _api$buildTypes2[1],
    GET_CREDENTIAL_SUCCESS = _api$buildTypes2[2],
    GET_CREDENTIAL_FAILURE = _api$buildTypes2[3];
exports.GET_CREDENTIAL = GET_CREDENTIAL;
exports.GET_CREDENTIAL_REQUEST = GET_CREDENTIAL_REQUEST;
exports.GET_CREDENTIAL_SUCCESS = GET_CREDENTIAL_SUCCESS;
exports.GET_CREDENTIAL_FAILURE = GET_CREDENTIAL_FAILURE;
function getCredential(_ref) {
  var teamName = _ref.teamName,
      credentialID = _ref.credentialID;

  return {
    type: GET_CREDENTIAL,
    payload: {
      url: '/teams/' + teamName + '/credentials/' + credentialID,
      schema: _schemas.CREDENTIAL
    }
  };
}

var _api$buildTypes3 = _api2.default.buildTypes('ADD_CREDENTIAL'),
    _api$buildTypes4 = _slicedToArray(_api$buildTypes3, 4);

var ADD_CREDENTIAL = _api$buildTypes4[0],
    ADD_CREDENTIAL_REQUEST = _api$buildTypes4[1],
    ADD_CREDENTIAL_SUCCESS = _api$buildTypes4[2],
    ADD_CREDENTIAL_FAILURE = _api$buildTypes4[3];
exports.ADD_CREDENTIAL = ADD_CREDENTIAL;
exports.ADD_CREDENTIAL_REQUEST = ADD_CREDENTIAL_REQUEST;
exports.ADD_CREDENTIAL_SUCCESS = ADD_CREDENTIAL_SUCCESS;
exports.ADD_CREDENTIAL_FAILURE = ADD_CREDENTIAL_FAILURE;
function addCredential(_ref2) {
  var teamName = _ref2.teamName,
      identifier = _ref2.identifier,
      secret = _ref2.secret,
      displayName = _ref2.displayName,
      urls = _ref2.urls,
      appName = _ref2.appName;

  return {
    type: ADD_CREDENTIAL,
    payload: {
      url: '/teams/' + teamName + '/credentials',
      schema: _schemas.CREDENTIAL,
      options: {
        method: 'POST',
        body: {
          teamName: teamName,
          identifier: identifier,
          secret: secret,
          displayName: displayName,
          urls: urls,
          appName: appName
        }
      }
    }
  };
}

var _api$buildTypes5 = _api2.default.buildTypes('UPDATE_CREDENTIAL'),
    _api$buildTypes6 = _slicedToArray(_api$buildTypes5, 4);

var UPDATE_CREDENTIAL = _api$buildTypes6[0],
    UPDATE_CREDENTIAL_REQUEST = _api$buildTypes6[1],
    UPDATE_CREDENTIAL_SUCCESS = _api$buildTypes6[2],
    UPDATE_CREDENTIAL_FAILURE = _api$buildTypes6[3];
exports.UPDATE_CREDENTIAL = UPDATE_CREDENTIAL;
exports.UPDATE_CREDENTIAL_REQUEST = UPDATE_CREDENTIAL_REQUEST;
exports.UPDATE_CREDENTIAL_SUCCESS = UPDATE_CREDENTIAL_SUCCESS;
exports.UPDATE_CREDENTIAL_FAILURE = UPDATE_CREDENTIAL_FAILURE;
function updateCredential(_ref3) {
  var credentialID = _ref3.credentialID,
      teamName = _ref3.teamName,
      identifier = _ref3.identifier,
      secret = _ref3.secret,
      displayName = _ref3.displayName,
      urls = _ref3.urls;

  var body = {
    identifier: identifier,
    displayName: displayName,
    urls: urls
  };

  if (secret) {
    body.secret = secret;
  }

  return {
    type: UPDATE_CREDENTIAL,
    payload: {
      url: '/teams/' + teamName + '/credentials/' + credentialID,
      schema: _schemas.CREDENTIAL,
      options: {
        method: 'PUT',
        body: body
      }
    }
  };
}

var _api$buildTypes7 = _api2.default.buildTypes('DELETE_CREDENTIAL'),
    _api$buildTypes8 = _slicedToArray(_api$buildTypes7, 4);

var DELETE_CREDENTIAL = _api$buildTypes8[0],
    DELETE_CREDENTIAL_REQUEST = _api$buildTypes8[1],
    DELETE_CREDENTIAL_SUCCESS = _api$buildTypes8[2],
    DELETE_CREDENTIAL_FAILURE = _api$buildTypes8[3];
exports.DELETE_CREDENTIAL = DELETE_CREDENTIAL;
exports.DELETE_CREDENTIAL_REQUEST = DELETE_CREDENTIAL_REQUEST;
exports.DELETE_CREDENTIAL_SUCCESS = DELETE_CREDENTIAL_SUCCESS;
exports.DELETE_CREDENTIAL_FAILURE = DELETE_CREDENTIAL_FAILURE;
function deleteCredential(_ref4) {
  var credentialID = _ref4.credentialID,
      teamName = _ref4.teamName;

  return {
    type: DELETE_CREDENTIAL,
    payload: {
      url: '/teams/' + teamName + '/credentials/' + credentialID,
      schema: _schemas.CREDENTIAL,
      options: {
        method: 'DELETE'
      }
    }
  };
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1422);


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_FEATURES_FAILURE = exports.GET_FEATURES_SUCCESS = exports.GET_FEATURES_REQUEST = exports.GET_FEATURES = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getFeatures = getFeatures;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_FEATURES'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_FEATURES = _api$buildTypes2[0],
    GET_FEATURES_REQUEST = _api$buildTypes2[1],
    GET_FEATURES_SUCCESS = _api$buildTypes2[2],
    GET_FEATURES_FAILURE = _api$buildTypes2[3];
exports.GET_FEATURES = GET_FEATURES;
exports.GET_FEATURES_REQUEST = GET_FEATURES_REQUEST;
exports.GET_FEATURES_SUCCESS = GET_FEATURES_SUCCESS;
exports.GET_FEATURES_FAILURE = GET_FEATURES_FAILURE;
function getFeatures() {
  return {
    type: GET_FEATURES,
    payload: {
      url: '/features',
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.changeEmail = changeEmail;
exports.changePhone = changePhone;
exports.changeMessage = changeMessage;
exports.changePrefs = changePrefs;
exports.changePermissions = changePermissions;
exports.clearSuccess = clearSuccess;
exports.formError = formError;
exports.renderTextField = renderTextField;
exports.addPhone = addPhone;
var ADDTEAM_INITIALIZE = exports.ADDTEAM_INITIALIZE = 'PAGE_ADDTEAM_INITIALIZE';
var ADDTEAM_CHANGE_EMAIL = exports.ADDTEAM_CHANGE_EMAIL = 'PAGE_ADDTEAM_CHANGE_EMAIL';
var ADDTEAM_CLEAR_SUCCESS = exports.ADDTEAM_CLEAR_SUCCESS = 'PAGE_ADDTEAM_CLEAR_SUCCESS';
var ADDTEAM_FORM_ERROR = exports.ADDTEAM_FORM_ERROR = 'PAGE_ADDTEAM_FORM_ERROR';
var ADDTEAM_RENDER_TEXTFIELD = exports.ADDTEAM_RENDER_TEXTFIELD = 'PAGE_ADDTEAM_RENDER_TEXTFIELD';
var ADDTEAM_ADD_PHONE = exports.ADDTEAM_ADD_PHONE = 'PAGE_ADDTEAM_ADD_PHONE';
var ADDTEAM_CHANGE_PHONE = exports.ADDTEAM_CHANGE_PHONE = 'PAGE_ADDTEAM_CHANGE_PHONE';
var ADDTEAM_CHANGE_PREFS = exports.ADDTEAM_CHANGE_PREFS = 'PAGE_ADDTEAM_CHANGE_PREF';
var ADDTEAM_CHANGE_MESSAGE = exports.ADDTEAM_CHANGE_MESSAGE = 'PAGE_ADDTEAM_CHANGE_MESSAGE';
var ADDTEAM_CHANGE_PERMISSIONS = exports.ADDTEAM_CHANGE_PERMISSIONS = 'PAGE_ADDTEAM_CHANGE_PERMISSIONS';

function initialize() {
  return {
    type: ADDTEAM_INITIALIZE
  };
}

function changeEmail(email) {
  return {
    type: ADDTEAM_CHANGE_EMAIL,
    email: email
  };
}

function changePhone(phone) {
  return {
    type: ADDTEAM_CHANGE_PHONE,
    phone: phone
  };
}

function changeMessage(message) {
  return {
    type: ADDTEAM_CHANGE_MESSAGE,
    message: message
  };
}

function changePrefs(prefs) {
  return {
    type: ADDTEAM_CHANGE_PREFS,
    prefs: prefs
  };
}

function changePermissions(permissions) {
  return {
    type: ADDTEAM_CHANGE_PERMISSIONS,
    permissions: permissions
  };
}

function clearSuccess() {
  return {
    type: ADDTEAM_CLEAR_SUCCESS
  };
}

function formError(error) {
  return {
    type: ADDTEAM_FORM_ERROR,
    error: error
  };
}

function renderTextField() {
  return {
    type: ADDTEAM_RENDER_TEXTFIELD
  };
}

function addPhone() {
  return {
    type: ADDTEAM_ADD_PHONE
  };
}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
var JOIN_INITIALIZE = exports.JOIN_INITIALIZE = 'PAGE_JOIN_INITIALIZE';

function initialize() {
  return {
    type: JOIN_INITIALIZE
  };
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.samlConfigInputChange = samlConfigInputChange;
var TEAM_ITEM_INITIALIZE = exports.TEAM_ITEM_INITIALIZE = 'PAGE_TEAM_ITEM_INITIALIZE';
var TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE = exports.TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE = 'PAGE_TEAM_ITEM_FIELD_UPDATE';

function initialize() {
  return {
    type: TEAM_ITEM_INITIALIZE
  };
}

function samlConfigInputChange(field, newData) {
  return {
    type: TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE,
    field: field,
    newData: newData
  };
}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
var TASK_DETAILS_INITIALIZE = exports.TASK_DETAILS_INITIALIZE = 'PAGE_TASK_DETAILS_INITIALIZE';

function initialize() {
  return {
    type: TASK_DETAILS_INITIALIZE
  };
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loading = loading;
var PAGE_INTEGRATION_LIST_LOADING = exports.PAGE_INTEGRATION_LIST_LOADING = 'PAGE_INTEGRATION_LIST_LOADING';

function loading(_ref) {
  var loading = _ref.loading;

  return {
    type: PAGE_INTEGRATION_LIST_LOADING,
    loading: loading
  };
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTeamName = setTeamName;
exports.setUserName = setUserName;
exports.setPassword = setPassword;
exports.setMessage = setMessage;
var SET_TEAM_NAME = exports.SET_TEAM_NAME = 'PAGE_SET_TEAM_NAME';
var SET_USER_NAME = exports.SET_USER_NAME = 'PAGE_SET_USER_NAME';
var SET_PASSWORD = exports.SET_PASSWORD = 'PAGE_SET_PASSWORD';
var SET_MESSAGE = exports.SET_MESSAGE = 'PAGE_SET_MESSAGE';

function setTeamName(teamName) {
  return {
    type: SET_TEAM_NAME,
    teamName: teamName
  };
}

function setUserName(userName) {
  return {
    type: SET_USER_NAME,
    userName: userName
  };
}

function setPassword(password) {
  return {
    type: SET_PASSWORD,
    password: password
  };
}

function setMessage(message) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    type: SET_MESSAGE,
    message: message,
    error: error
  };
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.changePhoto = changePhoto;
exports.changeError = changeError;
var CHANGE_PHOTO_INITIALIZE = exports.CHANGE_PHOTO_INITIALIZE = 'PAGE_CHANGE_PHOTO_INITIALIZE';
var CHANGE_PHOTO_ADD_PHOTO = exports.CHANGE_PHOTO_ADD_PHOTO = 'PAGE_CHANGE_PHOTO_ADD_PHOTO';
var CHANGE_PHOTO_CHANGE_ERROR = exports.CHANGE_PHOTO_CHANGE_ERROR = 'PAGE_CHANGE_PHOTO_CHANGE_ERROR';

function initialize() {
  return {
    type: CHANGE_PHOTO_INITIALIZE
  };
}

function changePhoto(photo) {
  return {
    type: CHANGE_PHOTO_ADD_PHOTO,
    photo: photo
  };
}

function changeError(errorMessage) {
  return {
    type: CHANGE_PHOTO_CHANGE_ERROR,
    errorMessage: errorMessage
  };
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1529)['default'];
exports['default'] = exports;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1562)
var ieee754 = __webpack_require__(1563)
var isArray = __webpack_require__(1564)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; //  weak

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _colors = __webpack_require__(564);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Backdrop', function (theme) {
  return {
    root: {
      zIndex: -1,
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: _colors.lightBlack,
      transition: theme.transitions.create('opacity'),
      willChange: 'opacity',
      opacity: 0
    },
    invisible: {
      backgroundColor: 'rgba(0, 0, 0, 0)'
    }
  };
});

var Backdrop = (_temp = _class = function (_Component) {
  _inherits(Backdrop, _Component);

  function Backdrop() {
    _classCallCheck(this, Backdrop);

    return _possibleConstructorReturn(this, (Backdrop.__proto__ || Object.getPrototypeOf(Backdrop)).apply(this, arguments));
  }

  _createClass(Backdrop, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            className = _props.className,
            visible = _props.visible,
            other = _objectWithoutProperties(_props, ['children', 'className', 'visible']);

        var classes = this.context.styleManager.render(styleSheet);
        var backdropClass = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.invisible, !visible), className);
        return _react2['default'].createElement(
          'div',
          _extends({
            'data-mui-test': 'Backdrop',
            className: backdropClass,
            'aria-hidden': 'true'
          }, other),
          children
        );
      }

      return render;
    }()
  }]);

  return Backdrop;
}(_react.Component), _class.propTypes = {
  /**
   * Can be used, for instance, to render a letter inside the avatar.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  visible: _PropTypes2['default'].bool
}, _class.defaultProps = {
  visible: true
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = Backdrop;


Backdrop.displayName = 'Backdrop';

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; //  weak

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Transition = __webpack_require__(265);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _transitions = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getTranslateValue(props, element) {
  var direction = props.direction;

  var rect = element.getBoundingClientRect();

  if (direction === 'left') {
    return 'translate3d(' + (rect.right + rect.width) + 'px, 0, 0)';
  } else if (direction === 'right') {
    return 'translate3d(' + (0 - (rect.left + rect.width)) + 'px, 0, 0)';
  } else if (direction === 'up') {
    return 'translate3d(0, ' + (rect.bottom + rect.height) + 'px, 0)';
  } else if (direction === 'down') {
    return 'translate3d(0, ' + (0 - (rect.top + rect.height)) + 'px, 0)';
  }

  return 'translate3d(0, 0, 0)';
}

var Slide = (_temp2 = _class = function (_Component) {
  _inherits(Slide, _Component);

  function Slide() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Slide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slide.__proto__ || Object.getPrototypeOf(Slide)).call.apply(_ref, [this].concat(args))), _this), _this.transition = null, _this.handleEnter = function (element) {
      element.style.transform = getTranslateValue(_this.props, element);
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleEntering = function (element) {
      var transitions = _this.context.theme.transitions;

      element.style.transition = transitions.create('transform', {
        duration: _this.props.enterTransitionDuration,
        easing: transitions.easing.easeOut
      });
      element.style.transform = 'translate3d(0, 0, 0)';
      if (_this.props.onEntering) {
        _this.props.onEntering(element);
      }
    }, _this.handleExiting = function (element) {
      var transitions = _this.context.theme.transitions;

      element.style.transition = transitions.create('transform', {
        duration: _this.props.leaveTransitionDuration,
        easing: transitions.easing.sharp
      });
      element.style.transform = getTranslateValue(_this.props, element);
      if (_this.props.onExiting) {
        _this.props.onExiting(element);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Slide, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (!this.props['in']) {
          /* eslint-disable react/no-find-dom-node */
          /* We need to set initial translate values of transition element
           * otherwise component will be shown when in=false.
           * transitions are handled by direct access to element,
           * so we need to access that same element too here.
           */
          var element = _reactDom2['default'].findDOMNode(this.transition);
          /* eslint-enable react/no-find-dom-node */
          if (element)
            // eslint-disable-next-line
            element.style.transform = getTranslateValue(this.props, element);
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            children = _props.children,
            offset = _props.offset,
            onEnter = _props.onEnter,
            onEntering = _props.onEntering,
            onExiting = _props.onExiting,
            enterTransitionDuration = _props.enterTransitionDuration,
            leaveTransitionDuration = _props.leaveTransitionDuration,
            other = _objectWithoutProperties(_props, ['children', 'offset', 'onEnter', 'onEntering', 'onExiting', 'enterTransitionDuration', 'leaveTransitionDuration']);

        return _react2['default'].createElement(
          _Transition2['default'],
          _extends({
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onExiting: this.handleExiting,
            timeout: 500,
            transitionAppear: true
          }, other, {
            ref: function () {
              function ref(_ref2) {
                _this2.transition = _ref2;
              }

              return ref;
            }()
          }),
          children
        );
      }

      return render;
    }()
  }]);

  return Slide;
}(_react.Component), _class.propTypes = {
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Entering direction of the children element.
   */
  direction: _PropTypes2['default'].oneOf(['left', 'right', 'up', 'down']),
  /**
   * Duration of the animation when the element is entering the screen.
   */
  enterTransitionDuration: _PropTypes2['default'].number,
  /**
   * Show the component; triggers the enter or exit animation.
   */
  'in': _PropTypes2['default'].bool,
  /**
   * Duration of the animation when the element is leaving the screen.
   */
  leaveTransitionDuration: _PropTypes2['default'].number,
  /**
   * Set to slide in by a fixed number of pixels or %.
   */
  offset: _PropTypes2['default'].string,
  /**
   * Callback fired before the component is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the component is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the component has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the component is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the component has exited.
   */
  onExited: _PropTypes2['default'].func // eslint-disable-line react/sort-prop-types
}, _class.defaultProps = {
  direction: 'down',
  enterTransitionDuration: _transitions.duration.enteringScreen,
  leaveTransitionDuration: _transitions.duration.leavingScreen
}, _class.contextTypes = {
  theme: _PropTypes2['default'].object
}, _temp2);
exports['default'] = Slide;


Slide.displayName = 'Slide';

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = FormGroup;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } //  weak

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('FormGroup', function () {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap'
    },
    row: {
      flexDirection: 'row'
    }
  };
});

/**
 * FormGroup wraps controls such as Checkbox and Switch.
 * It provides compact row layout and FormLabel awareness.
 * Upon focusing on one of the child controls, it will propagate `focused` to the label.
 */
function FormGroup(props, context) {
  var className = props.className,
      children = props.children,
      row = props.row,
      other = _objectWithoutProperties(props, ['className', 'children', 'row']);

  var classes = context.styleManager.render(styleSheet);
  var rootClassName = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.row, row), className);

  return _react2['default'].createElement(
    'div',
    _extends({ className: rootClassName }, other),
    children
  );
}

FormGroup.displayName = 'FormGroup';

FormGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Display group of elements in a compact row.
   */
  row: _PropTypes2['default'].bool
};

FormGroup.defaultProps = {
  row: false
};

FormGroup.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('FormControl', function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden'
    },
    row: {
      flexDirection: 'row'
    },
    paragraph: {
      marginBottom: theme.typography.rhythmByUnit(3)
    }
  };
});

/**
 * FormControl - provides context such as dirty/focused/error/required for form inputs
 */
var FormControl = (_temp2 = _class = function (_Component) {
  _inherits(FormControl, _Component);

  function FormControl() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormControl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormControl.__proto__ || Object.getPrototypeOf(FormControl)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dirty: false,
      focused: false
    }, _this.handleFocus = function () {
      if (!_this.state.focused) {
        _this.setState({ focused: true });
      }
    }, _this.handleBlur = function () {
      if (_this.state.focused) {
        _this.setState({ focused: false });
      }
    }, _this.handleDirty = function () {
      if (!_this.state.dirty) {
        _this.setState({ dirty: true });
      }
    }, _this.handleClean = function () {
      if (_this.state.dirty) {
        _this.setState({ dirty: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FormControl, [{
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        var _props = this.props,
            error = _props.error,
            errorMessage = _props.errorMessage,
            required = _props.required,
            onValidate = _props.onValidate;
        var _state = this.state,
            dirty = _state.dirty,
            focused = _state.focused;

        return {
          muiFormControl: {
            dirty: dirty,
            error: error,
            errorMessage: errorMessage,
            focused: focused,
            required: required,
            onDirty: this.handleDirty,
            onClean: this.handleClean,
            onValidate: onValidate
          }
        };
      }

      return getChildContext;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            children = _props2.children,
            classNameProp = _props2.className,
            error = _props2.error,
            errorMessage = _props2.errorMessage,
            paragraph = _props2.paragraph,
            onValidate = _props2.onValidate,
            other = _objectWithoutProperties(_props2, ['children', 'className', 'error', 'errorMessage', 'paragraph', 'onValidate']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.paragraph, paragraph), classNameProp);

        return _react2['default'].createElement(
          'div',
          _extends({
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            className: className
          }, other),
          children
        );
      }

      return render;
    }()
  }]);

  return FormControl;
}(_react.Component), _class.propTypes = {
  /**
   * The contents of the `FormControl`.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Whether the label should be displayed in an error state.
   */
  error: _PropTypes2['default'].bool,
  /**
   * Error message displayed in an error state
   */
  errorMessage: _PropTypes2['default'].string,
  /**
   * Called when input is validated
   */
  onValidate: _PropTypes2['default'].func,
  /**
   * If `true`, padding will be added to the bottom of the container
   */
  paragraph: _PropTypes2['default'].bool,
  required: _PropTypes2['default'].bool
}, _class.defaultProps = {
  error: false,
  required: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.childContextTypes = {
  muiFormControl: _PropTypes2['default'].object.isRequired
}, _temp2);
exports['default'] = FormControl;


FormControl.displayName = 'FormControl';

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1642);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEG = 3.6; // 360°
var RAD = 180; // 180°
var DIA = 24; // Diameter
var PI = 3.14; // ~π, because IE

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('PieChart', function () {
  return {
    svgIcon: {
      border: '0.075em solid currentColor',
      borderRadius: '50%',
      padding: '0.055em',
      transform: 'rotate(-90deg)'
    }
  };
});

var PieChart = (_temp = _class = function (_SvgIcon) {
  _inherits(PieChart, _SvgIcon);

  function PieChart() {
    _classCallCheck(this, PieChart);

    return _possibleConstructorReturn(this, (PieChart.__proto__ || Object.getPrototypeOf(PieChart)).apply(this, arguments));
  }

  _createClass(PieChart, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            className = _props.className,
            value = _props.value,
            other = _objectWithoutProperties(_props, ['className', 'value']);

        var deg = value * DEG;
        var rad = deg * PI / RAD;
        var cos = Math.cos(rad) * DIA;
        var sin = Math.sin(rad) * DIA;
        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          _SvgIcon3['default'],
          _extends({ className: (0, _classnames2['default'])(classes.svgIcon, className) }, other),
          _react2['default'].createElement('path', { d: 'M0,0 L' + DIA + ',0 A' + DIA + ',' + DIA + ' 0 1,1 ' + cos + ',' + sin + ' Z' })
        );
      }

      return render;
    }()
  }]);

  return PieChart;
}(_SvgIcon3['default']), _class.defaultProps = {
  value: 0,
  viewBox: DIA / -2 + ' ' + DIA / -2 + ' ' + DIA + ' ' + DIA
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager
}, _temp);
exports['default'] = PieChart;


PieChart.displayName = 'PieChart';

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = DialogContent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('DialogContent', function (theme) {
  var gutter = parseInt(theme.typography.rhythmByUnit(2));
  return {
    root: {
      flex: '1 1 auto',
      padding: '0 0 ' + gutter + 'px'
    },
    overflow: {
      overflowY: 'auto'
    },
    gutters: {
      padding: '0 ' + gutter + 'px ' + gutter + 'px ' + gutter + 'px',
      '&:first-child': {
        paddingTop: gutter
      }
    }
  };
});

function DialogContent(props, context) {
  var _classNames;

  var children = props.children,
      classNameProp = props.className,
      disableOverflow = props.disableOverflow,
      gutters = props.gutters,
      other = _objectWithoutProperties(props, ['children', 'className', 'disableOverflow', 'gutters']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, classes.root, true), _defineProperty(_classNames, classes.overflow, !disableOverflow), _defineProperty(_classNames, classes.gutters, gutters), _classNames), classNameProp);
  return _react2['default'].createElement(
    'div',
    _extends({ className: className }, other),
    children
  );
}

DialogContent.displayName = 'DialogContent';

DialogContent.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the root div's overflow will be removed
   */
  disableOverflow: _PropTypes2['default'].bool,
  /**
   * If `true`, then gutters will persist on all screen sizes
   */
  gutters: _PropTypes2['default'].bool
};

DialogContent.defaultProps = {
  disableOverflow: false,
  gutters: true
};

DialogContent.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(240);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(240);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(636),
    isObject = __webpack_require__(406);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 835 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(240);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Drag = function (_SvgIcon) {
  _inherits(Drag, _SvgIcon);

  function Drag() {
    _classCallCheck(this, Drag);

    return _possibleConstructorReturn(this, (Drag.__proto__ || Object.getPrototypeOf(Drag)).apply(this, arguments));
  }

  _createClass(Drag, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z' })
        );
      }

      return render;
    }()
  }]);

  return Drag;
}(_SvgIcon3['default']);

exports['default'] = Drag;

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(1748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowKeyStepper", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(1779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AutoSizer", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurer", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurerCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(1782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return __WEBPACK_IMPORTED_MODULE_3__Collection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(1789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnSizer", function() { return __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "accessibilityOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_5__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__ = __webpack_require__(1791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteLoader", function() { return __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(1793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_7__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Masonry__ = __webpack_require__(1797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMasonryCellPositioner", function() { return __WEBPACK_IMPORTED_MODULE_8__Masonry__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Masonry", function() { return __WEBPACK_IMPORTED_MODULE_8__Masonry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(1810);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultiGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__MultiGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(1813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollSync", function() { return __WEBPACK_IMPORTED_MODULE_10__ScrollSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(1815);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTableMultiSort", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellDataGetter", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortDirection", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortIndicator", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WindowScroller__ = __webpack_require__(1818);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WindowScroller", function() { return __WEBPACK_IMPORTED_MODULE_12__WindowScroller__["a"]; });














/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(687);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1831);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 841 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 842 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 843 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Fuse.js v3.0.5 - Lightweight fuzzy-search (http://fusejs.io)
 * 
 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Fuse", [], factory);
	else if(typeof exports === 'object')
		exports["Fuse"] = factory();
	else
		root["Fuse"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bitapRegexSearch = __webpack_require__(5);
var bitapSearch = __webpack_require__(7);
var patternAlphabet = __webpack_require__(4);

var Bitap = function () {
  function Bitap(pattern, _ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? 0 : _ref$location,
        _ref$distance = _ref.distance,
        distance = _ref$distance === undefined ? 100 : _ref$distance,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
        _ref$maxPatternLength = _ref.maxPatternLength,
        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
        _ref$isCaseSensitive = _ref.isCaseSensitive,
        isCaseSensitive = _ref$isCaseSensitive === undefined ? false : _ref$isCaseSensitive,
        _ref$tokenSeparator = _ref.tokenSeparator,
        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
        _ref$findAllMatches = _ref.findAllMatches,
        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
        _ref$minMatchCharLeng = _ref.minMatchCharLength,
        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;

    _classCallCheck(this, Bitap);

    this.options = {
      location: location,
      distance: distance,
      threshold: threshold,
      maxPatternLength: maxPatternLength,
      isCaseSensitive: isCaseSensitive,
      tokenSeparator: tokenSeparator,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength
    };

    this.pattern = this.options.isCaseSensitive ? pattern : pattern.toLowerCase();

    if (this.pattern.length <= maxPatternLength) {
      this.patternAlphabet = patternAlphabet(this.pattern);
    }
  }

  _createClass(Bitap, [{
    key: 'search',
    value: function search(text) {
      if (!this.options.isCaseSensitive) {
        text = text.toLowerCase();
      }

      // Exact match
      if (this.pattern === text) {
        return {
          isMatch: true,
          score: 0,
          matchedIndices: [[0, text.length - 1]]
        };
      }

      // When pattern length is greater than the machine word length, just do a a regex comparison
      var _options = this.options,
          maxPatternLength = _options.maxPatternLength,
          tokenSeparator = _options.tokenSeparator;

      if (this.pattern.length > maxPatternLength) {
        return bitapRegexSearch(text, this.pattern, tokenSeparator);
      }

      // Otherwise, use Bitap algorithm
      var _options2 = this.options,
          location = _options2.location,
          distance = _options2.distance,
          threshold = _options2.threshold,
          findAllMatches = _options2.findAllMatches,
          minMatchCharLength = _options2.minMatchCharLength;

      return bitapSearch(text, this.pattern, this.patternAlphabet, {
        location: location,
        distance: distance,
        threshold: threshold,
        findAllMatches: findAllMatches,
        minMatchCharLength: minMatchCharLength
      });
    }
  }]);

  return Bitap;
}();

// let x = new Bitap("od mn war", {})
// let result = x.search("Old Man's War")
// console.log(result)

module.exports = Bitap;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = __webpack_require__(0);

var deepValue = function deepValue(obj, path, list) {
  if (!path) {
    // If there's no path left, we've gotten to the object we care about.
    list.push(obj);
  } else {
    var dotIndex = path.indexOf('.');
    var firstSegment = path;
    var remaining = null;

    if (dotIndex !== -1) {
      firstSegment = path.slice(0, dotIndex);
      remaining = path.slice(dotIndex + 1);
    }

    var value = obj[firstSegment];

    if (value !== null && value !== undefined) {
      if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
        list.push(value);
      } else if (isArray(value)) {
        // Search each item in the array.
        for (var i = 0, len = value.length; i < len; i += 1) {
          deepValue(value[i], remaining, list);
        }
      } else if (remaining) {
        // An object. Recurse further.
        deepValue(value, remaining, list);
      }
    }
  }

  return list;
};

module.exports = function (obj, path) {
  return deepValue(obj, path, []);
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var matchedIndices = [];
  var start = -1;
  var end = -1;
  var i = 0;

  for (var len = matchmask.length; i < len; i += 1) {
    var match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        matchedIndices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    matchedIndices.push([start, i - 1]);
  }

  return matchedIndices;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (pattern) {
  var mask = {};
  var len = pattern.length;

  for (var i = 0; i < len; i += 1) {
    mask[pattern.charAt(i)] = 0;
  }

  for (var _i = 0; _i < len; _i += 1) {
    mask[pattern.charAt(_i)] |= 1 << len - _i - 1;
  }

  return mask;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SPECIAL_CHARS_REGEX = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;

module.exports = function (text, pattern) {
  var tokenSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : / +/g;

  var regex = new RegExp(pattern.replace(SPECIAL_CHARS_REGEX, '\\$&').replace(tokenSeparator, '|'));
  var matches = text.match(regex);
  var isMatch = !!matches;
  var matchedIndices = [];

  if (isMatch) {
    for (var i = 0, matchesLen = matches.length; i < matchesLen; i += 1) {
      var match = matches[i];
      matchedIndices.push([text.indexOf(match), match.length - 1]);
    }
  }

  return {
    // TODO: revisit this score
    score: isMatch ? 0.5 : 1,
    isMatch: isMatch,
    matchedIndices: matchedIndices
  };
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (pattern, _ref) {
  var _ref$errors = _ref.errors,
      errors = _ref$errors === undefined ? 0 : _ref$errors,
      _ref$currentLocation = _ref.currentLocation,
      currentLocation = _ref$currentLocation === undefined ? 0 : _ref$currentLocation,
      _ref$expectedLocation = _ref.expectedLocation,
      expectedLocation = _ref$expectedLocation === undefined ? 0 : _ref$expectedLocation,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 100 : _ref$distance;

  var accuracy = errors / pattern.length;
  var proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
  }

  return accuracy + proximity / distance;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bitapScore = __webpack_require__(6);
var matchedIndices = __webpack_require__(3);

module.exports = function (text, pattern, patternAlphabet, _ref) {
  var _ref$location = _ref.location,
      location = _ref$location === undefined ? 0 : _ref$location,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 100 : _ref$distance,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;

  var expectedLocation = location;
  // Set starting location at beginning text and initialize the alphabet.
  var textLen = text.length;
  // Highest score beyond which we give up.
  var currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  var bestLocation = text.indexOf(pattern, expectedLocation);

  var patternLen = pattern.length;

  // a mask of the matches
  var matchMask = [];
  for (var i = 0; i < textLen; i += 1) {
    matchMask[i] = 0;
  }

  if (bestLocation !== -1) {
    var score = bitapScore(pattern, {
      errors: 0,
      currentLocation: bestLocation,
      expectedLocation: expectedLocation,
      distance: distance
    });
    currentThreshold = Math.min(score, currentThreshold);

    // What about in the other direction? (speed up)
    bestLocation = text.lastIndexOf(pattern, expectedLocation + patternLen);

    if (bestLocation !== -1) {
      var _score = bitapScore(pattern, {
        errors: 0,
        currentLocation: bestLocation,
        expectedLocation: expectedLocation,
        distance: distance
      });
      currentThreshold = Math.min(_score, currentThreshold);
    }
  }

  // Reset the best location
  bestLocation = -1;

  var lastBitArr = [];
  var finalScore = 1;
  var binMax = patternLen + textLen;

  var mask = 1 << patternLen - 1;

  for (var _i = 0; _i < patternLen; _i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    var binMin = 0;
    var binMid = binMax;

    while (binMin < binMid) {
      var _score3 = bitapScore(pattern, {
        errors: _i,
        currentLocation: expectedLocation + binMid,
        expectedLocation: expectedLocation,
        distance: distance
      });

      if (_score3 <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    var start = Math.max(1, expectedLocation - binMid + 1);
    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    var bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << _i) - 1;

    for (var j = finish; j >= start; j -= 1) {
      var currentLocation = j - 1;
      var charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (charMatch) {
        matchMask[currentLocation] = 1;
      }

      // First pass: exact match
      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (_i !== 0) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = bitapScore(pattern, {
          errors: _i,
          currentLocation: currentLocation,
          expectedLocation: expectedLocation,
          distance: distance
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break;
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    var _score2 = bitapScore(pattern, {
      errors: _i + 1,
      currentLocation: expectedLocation,
      expectedLocation: expectedLocation,
      distance: distance
    });

    if (_score2 > currentThreshold) {
      break;
    }

    lastBitArr = bitArr;
  }

  // Count exact matches (those with a score of 0) to be "almost" exact
  return {
    isMatch: bestLocation >= 0,
    score: finalScore === 0 ? 0.001 : finalScore,
    matchedIndices: matchedIndices(matchMask, minMatchCharLength)
  };
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bitap = __webpack_require__(1);
var deepValue = __webpack_require__(2);
var isArray = __webpack_require__(0);

var Fuse = function () {
  function Fuse(list, _ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? 0 : _ref$location,
        _ref$distance = _ref.distance,
        distance = _ref$distance === undefined ? 100 : _ref$distance,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
        _ref$maxPatternLength = _ref.maxPatternLength,
        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
        _ref$caseSensitive = _ref.caseSensitive,
        caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
        _ref$tokenSeparator = _ref.tokenSeparator,
        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
        _ref$findAllMatches = _ref.findAllMatches,
        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
        _ref$minMatchCharLeng = _ref.minMatchCharLength,
        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng,
        _ref$id = _ref.id,
        id = _ref$id === undefined ? null : _ref$id,
        _ref$keys = _ref.keys,
        keys = _ref$keys === undefined ? [] : _ref$keys,
        _ref$shouldSort = _ref.shouldSort,
        shouldSort = _ref$shouldSort === undefined ? true : _ref$shouldSort,
        _ref$getFn = _ref.getFn,
        getFn = _ref$getFn === undefined ? deepValue : _ref$getFn,
        _ref$sortFn = _ref.sortFn,
        sortFn = _ref$sortFn === undefined ? function (a, b) {
      return a.score - b.score;
    } : _ref$sortFn,
        _ref$tokenize = _ref.tokenize,
        tokenize = _ref$tokenize === undefined ? false : _ref$tokenize,
        _ref$matchAllTokens = _ref.matchAllTokens,
        matchAllTokens = _ref$matchAllTokens === undefined ? false : _ref$matchAllTokens,
        _ref$includeMatches = _ref.includeMatches,
        includeMatches = _ref$includeMatches === undefined ? false : _ref$includeMatches,
        _ref$includeScore = _ref.includeScore,
        includeScore = _ref$includeScore === undefined ? false : _ref$includeScore,
        _ref$verbose = _ref.verbose,
        verbose = _ref$verbose === undefined ? false : _ref$verbose;

    _classCallCheck(this, Fuse);

    this.options = {
      location: location,
      distance: distance,
      threshold: threshold,
      maxPatternLength: maxPatternLength,
      isCaseSensitive: caseSensitive,
      tokenSeparator: tokenSeparator,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      id: id,
      keys: keys,
      includeMatches: includeMatches,
      includeScore: includeScore,
      shouldSort: shouldSort,
      getFn: getFn,
      sortFn: sortFn,
      verbose: verbose,
      tokenize: tokenize,
      matchAllTokens: matchAllTokens
    };

    this.setCollection(list);
  }

  _createClass(Fuse, [{
    key: 'setCollection',
    value: function setCollection(list) {
      this.list = list;
      return list;
    }
  }, {
    key: 'search',
    value: function search(pattern) {
      this._log('---------\nSearch pattern: "' + pattern + '"');

      var _prepareSearchers2 = this._prepareSearchers(pattern),
          tokenSearchers = _prepareSearchers2.tokenSearchers,
          fullSearcher = _prepareSearchers2.fullSearcher;

      var _search2 = this._search(tokenSearchers, fullSearcher),
          weights = _search2.weights,
          results = _search2.results;

      this._computeScore(weights, results);

      if (this.options.shouldSort) {
        this._sort(results);
      }

      return this._format(results);
    }
  }, {
    key: '_prepareSearchers',
    value: function _prepareSearchers() {
      var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var tokenSearchers = [];

      if (this.options.tokenize) {
        // Tokenize on the separator
        var tokens = pattern.split(this.options.tokenSeparator);
        for (var i = 0, len = tokens.length; i < len; i += 1) {
          tokenSearchers.push(new Bitap(tokens[i], this.options));
        }
      }

      var fullSearcher = new Bitap(pattern, this.options);

      return { tokenSearchers: tokenSearchers, fullSearcher: fullSearcher };
    }
  }, {
    key: '_search',
    value: function _search() {
      var tokenSearchers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var fullSearcher = arguments[1];

      var list = this.list;
      var resultMap = {};
      var results = [];

      // Check the first item in the list, if it's a string, then we assume
      // that every item in the list is also a string, and thus it's a flattened array.
      if (typeof list[0] === 'string') {
        // Iterate over every item
        for (var i = 0, len = list.length; i < len; i += 1) {
          this._analyze({
            key: '',
            value: list[i],
            record: i,
            index: i
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }

        return { weights: null, results: results };
      }

      // Otherwise, the first item is an Object (hopefully), and thus the searching
      // is done on the values of the keys of each item.
      var weights = {};
      for (var _i = 0, _len = list.length; _i < _len; _i += 1) {
        var item = list[_i];
        // Iterate over every key
        for (var j = 0, keysLen = this.options.keys.length; j < keysLen; j += 1) {
          var key = this.options.keys[j];
          if (typeof key !== 'string') {
            weights[key.name] = {
              weight: 1 - key.weight || 1
            };
            if (key.weight <= 0 || key.weight > 1) {
              throw new Error('Key weight has to be > 0 and <= 1');
            }
            key = key.name;
          } else {
            weights[key] = {
              weight: 1
            };
          }

          this._analyze({
            key: key,
            value: this.options.getFn(item, key),
            record: item,
            index: _i
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }
      }

      return { weights: weights, results: results };
    }
  }, {
    key: '_analyze',
    value: function _analyze(_ref2, _ref3) {
      var key = _ref2.key,
          value = _ref2.value,
          record = _ref2.record,
          index = _ref2.index;
      var _ref3$tokenSearchers = _ref3.tokenSearchers,
          tokenSearchers = _ref3$tokenSearchers === undefined ? [] : _ref3$tokenSearchers,
          _ref3$fullSearcher = _ref3.fullSearcher,
          fullSearcher = _ref3$fullSearcher === undefined ? [] : _ref3$fullSearcher,
          _ref3$resultMap = _ref3.resultMap,
          resultMap = _ref3$resultMap === undefined ? {} : _ref3$resultMap,
          _ref3$results = _ref3.results,
          results = _ref3$results === undefined ? [] : _ref3$results;

      // Check if the texvaluet can be searched
      if (value === undefined || value === null) {
        return;
      }

      var exists = false;
      var averageScore = -1;
      var numTextMatches = 0;

      if (typeof value === 'string') {
        this._log('\nKey: ' + (key === '' ? '-' : key));

        var mainSearchResult = fullSearcher.search(value);
        this._log('Full text: "' + value + '", score: ' + mainSearchResult.score);

        if (this.options.tokenize) {
          var words = value.split(this.options.tokenSeparator);
          var scores = [];

          for (var i = 0; i < tokenSearchers.length; i += 1) {
            var tokenSearcher = tokenSearchers[i];

            this._log('\nPattern: "' + tokenSearcher.pattern + '"');

            // let tokenScores = []
            var hasMatchInText = false;

            for (var j = 0; j < words.length; j += 1) {
              var word = words[j];
              var tokenSearchResult = tokenSearcher.search(word);
              var obj = {};
              if (tokenSearchResult.isMatch) {
                obj[word] = tokenSearchResult.score;
                exists = true;
                hasMatchInText = true;
                scores.push(tokenSearchResult.score);
              } else {
                obj[word] = 1;
                if (!this.options.matchAllTokens) {
                  scores.push(1);
                }
              }
              this._log('Token: "' + word + '", score: ' + obj[word]);
              // tokenScores.push(obj)
            }

            if (hasMatchInText) {
              numTextMatches += 1;
            }
          }

          averageScore = scores[0];
          var scoresLen = scores.length;
          for (var _i2 = 1; _i2 < scoresLen; _i2 += 1) {
            averageScore += scores[_i2];
          }
          averageScore = averageScore / scoresLen;

          this._log('Token score average:', averageScore);
        }

        var finalScore = mainSearchResult.score;
        if (averageScore > -1) {
          finalScore = (finalScore + averageScore) / 2;
        }

        this._log('Score average:', finalScore);

        var checkTextMatches = this.options.tokenize && this.options.matchAllTokens ? numTextMatches >= tokenSearchers.length : true;

        this._log('\nCheck Matches: ' + checkTextMatches);

        // If a match is found, add the item to <rawResults>, including its score
        if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
          // Check if the item already exists in our results
          var existingResult = resultMap[index];

          if (existingResult) {
            // Use the lowest score
            // existingResult.score, bitapResult.score
            existingResult.output.push({
              key: key,
              score: finalScore,
              matchedIndices: mainSearchResult.matchedIndices
            });
          } else {
            // Add it to the raw result list
            resultMap[index] = {
              item: record,
              output: [{
                key: key,
                score: finalScore,
                matchedIndices: mainSearchResult.matchedIndices
              }]
            };

            results.push(resultMap[index]);
          }
        }
      } else if (isArray(value)) {
        for (var _i3 = 0, len = value.length; _i3 < len; _i3 += 1) {
          this._analyze({
            key: key,
            value: value[_i3],
            record: record,
            index: index
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }
      }
    }
  }, {
    key: '_computeScore',
    value: function _computeScore(weights, results) {
      this._log('\n\nComputing score:\n');

      for (var i = 0, len = results.length; i < len; i += 1) {
        var output = results[i].output;
        var scoreLen = output.length;

        var totalScore = 0;
        var bestScore = 1;

        for (var j = 0; j < scoreLen; j += 1) {
          var score = output[j].score;
          var weight = weights ? weights[output[j].key].weight : 1;
          var nScore = score * weight;

          if (weight !== 1) {
            bestScore = Math.min(bestScore, nScore);
          } else {
            output[j].nScore = nScore;
            totalScore += nScore;
          }
        }

        results[i].score = bestScore === 1 ? totalScore / scoreLen : bestScore;

        this._log(results[i]);
      }
    }
  }, {
    key: '_sort',
    value: function _sort(results) {
      this._log('\n\nSorting....');
      results.sort(this.options.sortFn);
    }
  }, {
    key: '_format',
    value: function _format(results) {
      var finalOutput = [];

      this._log('\n\nOutput:\n\n', results);

      var transformers = [];

      if (this.options.includeMatches) {
        transformers.push(function (result, data) {
          var output = result.output;
          data.matches = [];

          for (var i = 0, len = output.length; i < len; i += 1) {
            var item = output[i];
            var obj = {
              indices: item.matchedIndices
            };
            if (item.key) {
              obj.key = item.key;
            }
            data.matches.push(obj);
          }
        });
      }

      if (this.options.includeScore) {
        transformers.push(function (result, data) {
          data.score = result.score;
        });
      }

      for (var i = 0, len = results.length; i < len; i += 1) {
        var result = results[i];

        if (this.options.id) {
          result.item = this.options.getFn(result.item, this.options.id)[0];
        }

        if (!transformers.length) {
          finalOutput.push(result.item);
          continue;
        }

        var data = {
          item: result.item
        };

        for (var j = 0, _len2 = transformers.length; j < _len2; j += 1) {
          transformers[j](result, data);
        }

        finalOutput.push(data);
      }

      return finalOutput;
    }
  }, {
    key: '_log',
    value: function _log() {
      if (this.options.verbose) {
        var _console;

        (_console = console).log.apply(_console, arguments);
      }
    }
  }]);

  return Fuse;
}();

module.exports = Fuse;

/***/ })
/******/ ]);
});
//# sourceMappingURL=fuse.js.map

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SnackbarContainer = __webpack_require__(1858);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SnackbarContainer).default;
  }
});
Object.defineProperty(exports, 'SnackbarContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SnackbarContainer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavData = (_temp = _class = function (_SvgIcon) {
  _inherits(NavData, _SvgIcon);

  function NavData() {
    _classCallCheck(this, NavData);

    return _possibleConstructorReturn(this, (NavData.__proto__ || Object.getPrototypeOf(NavData)).apply(this, arguments));
  }

  _createClass(NavData, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M16.5 2C19.538 2 22 4.462 22 7.5c0 .55-.083 1.08-.233 1.58.237-.05.48-.08.733-.08 1.933 0 3.5 1.567 3.5 3.5S24.433 16 22.5 16H5c-1.657 0-3-1.343-3-3s1.343-3 3-3c.475 0 .918.12 1.317.317C6.12 9.917 6 9.475 6 9c0-1.657 1.343-3 3-3 .794 0 1.51.314 2.047.817C11.384 4.103 13.694 2 16.5 2m0-2c-2.874 0-5.413 1.637-6.667 4.07C9.56 4.024 9.28 4 9 4 6.556 4 4.516 5.763 4.084 8.084 1.764 8.516 0 10.556 0 13c0 2.757 2.243 5 5 5h17.5c3.033 0 5.5-2.467 5.5-5.5 0-2.515-1.697-4.64-4.006-5.294C23.84 3.206 20.537 0 16.5 0z' }),
          _react2['default'].createElement('path', {
            d: 'M20 14.5H8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h12c.276 0 .5.224.5.5s-.224.5-.5.5z',
            opacity: '.4'
          })
        );
      }

      return render;
    }()
  }]);

  return NavData;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 28 18'
}, _temp);
exports['default'] = NavData;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeyboardArrowDown = function (_SvgIcon) {
  _inherits(KeyboardArrowDown, _SvgIcon);

  function KeyboardArrowDown() {
    _classCallCheck(this, KeyboardArrowDown);

    return _possibleConstructorReturn(this, (KeyboardArrowDown.__proto__ || Object.getPrototypeOf(KeyboardArrowDown)).apply(this, arguments));
  }

  _createClass(KeyboardArrowDown, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
        );
      }

      return render;
    }()
  }]);

  return KeyboardArrowDown;
}(_SvgIcon3['default']);

exports['default'] = KeyboardArrowDown;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(195),
    baseOrderBy = __webpack_require__(558),
    baseRest = __webpack_require__(191),
    isIterateeCall = __webpack_require__(416);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayName = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

/***/ }),
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(857);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(875);
__webpack_require__(791);
__webpack_require__(876);
__webpack_require__(877);
__webpack_require__(878);
__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(885);
__webpack_require__(886);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(906);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(912);
__webpack_require__(792);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(922);
__webpack_require__(923);
__webpack_require__(924);
__webpack_require__(925);
__webpack_require__(926);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(929);
__webpack_require__(930);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(938);
__webpack_require__(939);
__webpack_require__(940);
__webpack_require__(941);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
__webpack_require__(947);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(288);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(449);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
__webpack_require__(415);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
__webpack_require__(984);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
__webpack_require__(988);
__webpack_require__(989);
__webpack_require__(990);
__webpack_require__(991);
__webpack_require__(992);
__webpack_require__(993);
__webpack_require__(994);
__webpack_require__(995);
__webpack_require__(996);
__webpack_require__(997);
__webpack_require__(998);
__webpack_require__(999);
__webpack_require__(1000);
__webpack_require__(1001);
__webpack_require__(1002);
__webpack_require__(1003);
__webpack_require__(1004);
__webpack_require__(1005);
__webpack_require__(1006);
__webpack_require__(1007);
__webpack_require__(1008);
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);
__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(1028);
__webpack_require__(1029);
__webpack_require__(1030);
__webpack_require__(1031);
__webpack_require__(793);
__webpack_require__(1032);
module.exports = __webpack_require__(1033);


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(13);
var has = __webpack_require__(43);
var DESCRIPTORS = __webpack_require__(24);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(45);
var META = __webpack_require__(81).KEY;
var $fails = __webpack_require__(14);
var shared = __webpack_require__(201);
var setToStringTag = __webpack_require__(123);
var uid = __webpack_require__(96);
var wks = __webpack_require__(19);
var wksExt = __webpack_require__(433);
var wksDefine = __webpack_require__(268);
var enumKeys = __webpack_require__(858);
var isArray = __webpack_require__(271);
var anObject = __webpack_require__(10);
var toIObject = __webpack_require__(52);
var toPrimitive = __webpack_require__(63);
var createDesc = __webpack_require__(95);
var _create = __webpack_require__(100);
var gOPNExt = __webpack_require__(436);
var $GOPD = __webpack_require__(53);
var $DP = __webpack_require__(25);
var $keys = __webpack_require__(98);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(101).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(158).f = $propertyIsEnumerable;
  __webpack_require__(203).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(97)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(44)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(98);
var gOPS = __webpack_require__(203);
var pIE = __webpack_require__(158);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(100) });


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperty: __webpack_require__(25).f });


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperties: __webpack_require__(435) });


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(52);
var $getOwnPropertyDescriptor = __webpack_require__(53).f;

__webpack_require__(65)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(32);
var $getPrototypeOf = __webpack_require__(54);

__webpack_require__(65)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(32);
var $keys = __webpack_require__(98);

__webpack_require__(65)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(65)('getOwnPropertyNames', function () {
  return __webpack_require__(436).f;
});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(81).onFreeze;

__webpack_require__(65)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(81).onFreeze;

__webpack_require__(65)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(81).onFreeze;

__webpack_require__(65)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(17);

__webpack_require__(65)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(17);

__webpack_require__(65)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(17);

__webpack_require__(65)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(437) });


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(874) });


/***/ }),
/* 874 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(273).set });


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(438) });


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(17);
var getPrototypeOf = __webpack_require__(54);
var HAS_INSTANCE = __webpack_require__(19)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(25).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(440);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(441);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var has = __webpack_require__(43);
var cof = __webpack_require__(58);
var inheritIfRequired = __webpack_require__(275);
var toPrimitive = __webpack_require__(63);
var fails = __webpack_require__(14);
var gOPN = __webpack_require__(101).f;
var gOPD = __webpack_require__(53).f;
var dP = __webpack_require__(25).f;
var $trim = __webpack_require__(124).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(100)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(24) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(45)(global, NUMBER, $Number);
}


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(73);
var aNumberValue = __webpack_require__(442);
var repeat = __webpack_require__(276);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(14)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(14);
var aNumberValue = __webpack_require__(442);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(13).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(443) });


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(443);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(441);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(440);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(444);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(277);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(278);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(900) });


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(277);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(14)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(444) });


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(277) });


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(278);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(14)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(278);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(99);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(52);
var toLength = __webpack_require__(28);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(124)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(279)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(28);
var context = __webpack_require__(282);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(283)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(282);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(283)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(276)
});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(28);
var context = __webpack_require__(282);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(283)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(47)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(47)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(47)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(47)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(47)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(47)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(47)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(47)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(47)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(47)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(47)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(47)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(47)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(63);

$export($export.P + $export.F * __webpack_require__(14)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(934);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(14);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(45)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(19)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(44)(proto, TO_PRIMITIVE, __webpack_require__(937));


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(63);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(271) });


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(72);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(32);
var call = __webpack_require__(445);
var isArrayIter = __webpack_require__(284);
var toLength = __webpack_require__(28);
var createProperty = __webpack_require__(285);
var getIterFn = __webpack_require__(286);

$export($export.S + $export.F * !__webpack_require__(205)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(285);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(14)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(52);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(157) != Object || !__webpack_require__(59)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(272);
var cof = __webpack_require__(58);
var toAbsoluteIndex = __webpack_require__(99);
var toLength = __webpack_require__(28);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(14)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(46);
var toObject = __webpack_require__(32);
var fails = __webpack_require__(14);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(59)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(66)(0);
var STRICT = __webpack_require__(59)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(946);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var isArray = __webpack_require__(271);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(66)(1);

$export($export.P + $export.F * !__webpack_require__(59)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(66)(2);

$export($export.P + $export.F * !__webpack_require__(59)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(66)(3);

$export($export.P + $export.F * !__webpack_require__(59)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(66)(4);

$export($export.P + $export.F * !__webpack_require__(59)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(446);

$export($export.P + $export.F * !__webpack_require__(59)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(446);

$export($export.P + $export.F * !__webpack_require__(59)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(202)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(59)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(52);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(28);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(59)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(447) });

__webpack_require__(126)('copyWithin');


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(287) });

__webpack_require__(126)('fill');


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(66)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(126)(KEY);


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(66)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(126)(KEY);


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(102)('Array');


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var inheritIfRequired = __webpack_require__(275);
var dP = __webpack_require__(25).f;
var gOPN = __webpack_require__(101).f;
var isRegExp = __webpack_require__(204);
var $flags = __webpack_require__(206);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(24) && (!CORRECT_NEW || __webpack_require__(14)(function () {
  re2[__webpack_require__(19)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(45)(global, 'RegExp', $RegExp);
}

__webpack_require__(102)('RegExp');


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(449);
var anObject = __webpack_require__(10);
var $flags = __webpack_require__(206);
var DESCRIPTORS = __webpack_require__(24);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(45)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(14)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(207)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(207)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(207)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(207)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(204);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(97);
var global = __webpack_require__(13);
var ctx = __webpack_require__(72);
var classof = __webpack_require__(159);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(17);
var aFunction = __webpack_require__(46);
var anInstance = __webpack_require__(103);
var forOf = __webpack_require__(127);
var speciesConstructor = __webpack_require__(289);
var task = __webpack_require__(290).set;
var microtask = __webpack_require__(291)();
var newPromiseCapabilityModule = __webpack_require__(450);
var perform = __webpack_require__(967);
var promiseResolve = __webpack_require__(968);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(104)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(123)($Promise, PROMISE);
__webpack_require__(102)(PROMISE);
Wrapper = __webpack_require__(94)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(205)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);
var newPromiseCapability = __webpack_require__(450);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(454);
var validate = __webpack_require__(128);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(208)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(209);
var buffer = __webpack_require__(292);
var anObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(99);
var toLength = __webpack_require__(28);
var isObject = __webpack_require__(17);
var ArrayBuffer = __webpack_require__(13).ArrayBuffer;
var speciesConstructor = __webpack_require__(289);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(14)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(102)(ARRAY_BUFFER);


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(209).ABV, {
  DataView: __webpack_require__(292).DataView
});


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(46);
var anObject = __webpack_require__(10);
var rApply = (__webpack_require__(13).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(14)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(100);
var aFunction = __webpack_require__(46);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(14);
var bind = __webpack_require__(438);
var rConstruct = (__webpack_require__(13).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(25);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(63);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(14)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(53).f;
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(10);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(281)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(54);
var has = __webpack_require__(43);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(10);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(53);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(54);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(10);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(456) });


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(10);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(25);
var gOPD = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(54);
var has = __webpack_require__(43);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(95);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(17);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(273);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(202)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(126)('includes');


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(279)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(457);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(457);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(124)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(124)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(64);
var toLength = __webpack_require__(28);
var isRegExp = __webpack_require__(204);
var getFlags = __webpack_require__(206);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(281)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(268)('asyncIterator');


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(268)('observable');


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(456);
var toIObject = __webpack_require__(52);
var gOPD = __webpack_require__(53);
var createProperty = __webpack_require__(285);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(458)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(458)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(32);
var aFunction = __webpack_require__(46);
var $defineProperty = __webpack_require__(25);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(24) && $export($export.P + __webpack_require__(210), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(32);
var aFunction = __webpack_require__(46);
var $defineProperty = __webpack_require__(25);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(24) && $export($export.P + __webpack_require__(210), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(54);
var getOwnPropertyDescriptor = __webpack_require__(53).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(24) && $export($export.P + __webpack_require__(210), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(54);
var getOwnPropertyDescriptor = __webpack_require__(53).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(24) && $export($export.P + __webpack_require__(210), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(459)('Map') });


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(459)('Set') });


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(13) });


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(58);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(54);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(452);
var from = __webpack_require__(460);
var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(54);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(54);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(75);
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(46);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(291)();
var process = __webpack_require__(13).process;
var isNode = __webpack_require__(58)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(13);
var core = __webpack_require__(94);
var microtask = __webpack_require__(291)();
var OBSERVABLE = __webpack_require__(19)('observable');
var aFunction = __webpack_require__(46);
var anObject = __webpack_require__(10);
var anInstance = __webpack_require__(103);
var redefineAll = __webpack_require__(104);
var hide = __webpack_require__(44);
var forOf = __webpack_require__(127);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(102)('Observable');


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(13);
var $export = __webpack_require__(1);
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(290);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var hasOwn = Object.prototype.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `value instanceof AwaitArgument` to determine if the yielded value is
  // meant to be awaited. Some may consider the name of this method too
  // cutesy, but they are curmudgeons.
  runtime.awrap = function(arg) {
    return new AwaitArgument(arg);
  };

  function AwaitArgument(arg) {
    this.arg = arg;
  }

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value instanceof AwaitArgument) {
          return Promise.resolve(value.arg).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          if (method === "return" ||
              (method === "throw" && delegate.iterator[method] === undefined)) {
            // A return or throw (when the delegate iterator has no throw
            // method) always terminates the yield* loop.
            context.delegate = null;

            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            var returnMethod = delegate.iterator["return"];
            if (returnMethod) {
              var record = tryCatch(returnMethod, delegate.iterator, arg);
              if (record.type === "throw") {
                // If the return method threw an exception, let that
                // exception prevail over the original return or throw.
                method = "throw";
                arg = record.arg;
                continue;
              }
            }

            if (method === "return") {
              // Continue with the outer return, now that the delegate
              // iterator has been terminated.
              continue;
            }
          }

          var record = tryCatch(
            delegate.iterator[method],
            delegate.iterator,
            arg
          );

          if (record.type === "throw") {
            context.delegate = null;

            // Like returning generator.throw(uncaught), but without the
            // overhead of an extra function call.
            method = "throw";
            arg = record.arg;
            continue;
          }

          // Delegate generator ran and handled its own exceptions so
          // regardless of what the method was, we continue as if it is
          // "next" with an undefined arg.
          method = "next";
          arg = undefined;

          var info = record.arg;
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
          } else {
            state = GenStateSuspendedYield;
            return info;
          }

          context.delegate = null;
        }

        if (method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = arg;

        } else if (method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw arg;
          }

          if (context.dispatchException(arg)) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            method = "next";
            arg = undefined;
          }

        } else if (method === "return") {
          context.abrupt("return", arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          var info = {
            value: record.arg,
            done: context.done
          };

          if (record.arg === ContinueSentinel) {
            if (context.delegate && method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              arg = undefined;
            }
          } else {
            return info;
          }

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(arg) call above.
          method = "throw";
          arg = record.arg;
        }
      }
    };
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.next = finallyEntry.finallyLoc;
      } else {
        this.complete(record);
      }

      return ContinueSentinel;
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = record.arg;
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(151)))

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/* globals ENV:true window  __webpack_public_path__:true */ // eslint-disable-line no-unused-vars

// Dynamically define public path
__webpack_require__.p = // eslint-disable-line camelcase
((window || global || {}).__ENV__ || {}).PUSHBOT_WEB_PATH || {"PUSHBOT_EMBEDDED_MODE":false,"PUSHBOT_EMBEDDED_PATHNAME":"^.*$","PUSHBOT_EMBEDDED_REFERRER":"/","PUSHBOT_CONFIGURATION":"local","PUSHBOT_ENV":"staging","PUSHBOT_VERSION":"1.23.901","PUSHBOT_NAME":"@catalytic/pushbot-web-build","PUSHBOT_WEB_PATH":"/@catalytic/pushbot-web/1.23.901/","PUSHBOT_API_PROTOCOL":"https:","PUSHBOT_LAUNCHDARKLY_ID":"5940055cc654e40c83327a43","PUSHBOT_NEWRELIC_KEY":"5c90b51bff","PUSHBOT_NEWRELIC_ID":"54545427","PUSHBOT_OAUTH_REDIRECT_URL":"http://localhost:6150/oauth","PUSHBOT_LOG_LEVEL":"log","PUSHBOT_VERBOSE":1,"PUSHBOT_USER_SESSION_PATH":"session","PUSHBOT_REDUX_DEVTOOLS":1,"PUSHBOT_SLACK_CLIENT_ID":"4056875606.77226325253","PUSHBOT_API_PORT":null}.PUSHBOT_WEB_PATH || '/';

__webpack_require__(1034).default().then(function (polyfills) {
  return __webpack_require__(1035);
}); // eslint-disable-line no-unused-vars
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = load;

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createPolyfill = function createPolyfill(lookup, fn) {
  return function () {
    return !lookup() ? new Promise(function (resolve, reject) {
      return fn(resolve, reject);
    }) : Promise.resolve(lookup());
  };
};

var polyfills = {
  intl: createPolyfill(function () {
    return _context2.default.Intl;
  }, function (done) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
      return done(__webpack_require__(1913));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }),
  /**
   * Element.closest() Polyfill
   * For browsers that do not support Element.closest(), but carry support for document.querySelectorAll()
   * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
   */
  closest: createPolyfill(function () {
    return _context2.default.Element && _context2.default.Element.prototype.closest;
  }, function (done) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
      return done(_context2.default.Element.prototype.closest = function (s) {
        // eslint-disable-next-line one-var
        var matches = (_context2.default.document || _context2.default.ownerDocument).querySelectorAll(s),
            i,
            el = this;
        do {
          i = matches.length;
          while (--i >= 0 && matches.item(i) !== el) {
            /**/
          }
        } while (i < 0 && (el = el.parentElement));
        return el;
      });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }),
  /**
   * EventSource Polyfill
   * https://www.w3.org/TR/eventsource/
   */
  eventsource: createPolyfill(function () {
    var XHR = _context2.default.XMLHttpRequest;
    var XDR = _context2.default.XDomainRequest;
    var isCORSSupported = XHR != undefined && new XHR().withCredentials != undefined; // eslint-disable-line eqeqeq
    var Transport = isCORSSupported || XHR != undefined && XDR == undefined ? XHR : XDR; // eslint-disable-line eqeqeq
    var isEventSourceNotSupported = isCORSSupported && !(_context2.default.EventSource !== undefined && 'withCredentials' in _context2.default.EventSource.prototype);

    return Transport !== undefined && (_context2.default.EventSource === undefined || isEventSourceNotSupported);
  }, function (done) {
    __webpack_require__.e/* require.ensure */(5).then((function () {
      return done(__webpack_require__(1914));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }),
  /**
   * CustomEvent() Polyfill
   * For browsers that do not support CustomEvent() constructor functionality
   * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
   */
  customevent: createPolyfill(function () {
    return typeof _context2.default.CustomEvent === 'function';
  }, function (done) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
      return done(__webpack_require__(1915));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }),
  /**
   * User Timing API Polyfill
   * https://www.w3.org/TR/user-timing/
   */
  usertiming: createPolyfill(function () {
    return !(typeof _context2.default.performance === 'undefined');
  }, function (done) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
      return done(__webpack_require__(1916));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }),
  /**
   * window.fetch polyfill
   * https://github.com/github/fetch
   */
  fetch: createPolyfill(function () {
    return _context2.default.fetch;
  }, function (done) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
      return done(__webpack_require__(1917));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  })
};

function load() {
  var keys = Object.keys(polyfills);
  return Promise.all(keys.map(function (k) {
    return polyfills[k]();
  })).then(function (results) {
    return keys.reduce(function (o, k, i) {
      return _extends({}, o, _defineProperty({}, k, results[i]));
    }, {});
  });
}

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(293);

__webpack_require__(1037);

var _reactDom = __webpack_require__(29);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

var _store = __webpack_require__(313);

var _store2 = _interopRequireDefault(_store);

var _history = __webpack_require__(1478);

var _history2 = _interopRequireDefault(_history);

var _routes = __webpack_require__(1503);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactDom.render)((0, _routes.routes)({ store: _store2.default, history: _history2.default }), _context2.default.document.getElementById('mount')); // initialize rollbar as early as possible so it can catch errors in setup

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var rollbar = __webpack_require__(2);
	
	var options = window && window._rollbarConfig;
	var alias = options && options.globalAlias || 'Rollbar';
	var shimRunning = window && window[alias] && typeof window[alias].shimId === 'function' && window[alias].shimId() !== undefined;
	
	if (window && !window._rollbarStartTime) {
	  window._rollbarStartTime = (new Date()).getTime();
	}
	
	if (!shimRunning && options) {
	  var Rollbar = new rollbar(options);
	  window[alias] = Rollbar;
	} else {
	  window.rollbar = rollbar;
	  window._rollbarDidLoad = true;
	}
	
	module.exports = rollbar;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Client = __webpack_require__(3);
	var _ = __webpack_require__(6);
	var API = __webpack_require__(11);
	var logger = __webpack_require__(13);
	var globals = __webpack_require__(16);
	
	var transport = __webpack_require__(17);
	var urllib = __webpack_require__(18);
	
	var transforms = __webpack_require__(19);
	var sharedTransforms = __webpack_require__(23);
	var predicates = __webpack_require__(24);
	var errorParser = __webpack_require__(20);
	var Instrumenter = __webpack_require__(25);
	
	function Rollbar(options, client) {
	  this.options = _.extend(true, defaultOptions, options);
	  var api = new API(this.options, transport, urllib);
	  this.client = client || new Client(this.options, api, logger, 'browser');
	
	  addTransformsToNotifier(this.client.notifier);
	  addPredicatesToQueue(this.client.queue);
	  if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
	    globals.captureUncaughtExceptions(window, this);
	    globals.wrapGlobals(window, this);
	  }
	  if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
	    globals.captureUnhandledRejections(window, this);
	  }
	
	  this.instrumenter = new Instrumenter(this.options, this.client.telemeter, this, window, document);
	  this.instrumenter.instrument();
	}
	
	var _instance = null;
	Rollbar.init = function(options, client) {
	  if (_instance) {
	    return _instance.global(options).configure(options);
	  }
	  _instance = new Rollbar(options, client);
	  return _instance;
	};
	
	function handleUninitialized(maybeCallback) {
	  var message = 'Rollbar is not initialized';
	  logger.error(message);
	  if (maybeCallback) {
	    maybeCallback(new Error(message));
	  }
	}
	
	Rollbar.prototype.global = function(options) {
	  this.client.global(options);
	  return this;
	};
	Rollbar.global = function(options) {
	  if (_instance) {
	    return _instance.global(options);
	  } else {
	    handleUninitialized();
	  }
	};
	
	Rollbar.prototype.configure = function(options, payloadData) {
	  var oldOptions = this.options;
	  var payload = {};
	  if (payloadData) {
	    payload = {payload: payloadData};
	  }
	  this.options = _.extend(true, {}, oldOptions, options, payload);
	  this.client.configure(options, payloadData);
	  return this;
	};
	Rollbar.configure = function(options, payloadData) {
	  if (_instance) {
	    return _instance.configure(options, payloadData);
	  } else {
	    handleUninitialized();
	  }
	};
	
	Rollbar.prototype.lastError = function() {
	  return this.client.lastError;
	};
	Rollbar.lastError = function() {
	  if (_instance) {
	    return _instance.lastError();
	  } else {
	    handleUninitialized();
	  }
	};
	
	Rollbar.prototype.log = function() {
	  var item = this._createItem(arguments);
	  var uuid = item.uuid;
	  this.client.log(item);
	  return {uuid: uuid};
	};
	Rollbar.log = function() {
	  if (_instance) {
	    return _instance.log.apply(_instance, arguments);
	  } else {
	    var maybeCallback = _getFirstFunction(arguments);
	    handleUninitialized(maybeCallback);
	  }
	};
	
	Rollbar.prototype.debug = function() {
	  var item = this._createItem(arguments);
	  var uuid = item.uuid;
	  this.client.debug(item);
	  return {uuid: uuid};
	};
	Rollbar.debug = function() {
	  if (_instance) {
	    return _instance.debug.apply(_instance, arguments);
	  } else {
	    var maybeCallback = _getFirstFunction(arguments);
	    handleUninitialized(maybeCallback);
	  }
	};
	
	Rollbar.prototype.info = function() {
	  var item = this._createItem(arguments);
	  var uuid = item.uuid;
	  this.client.info(item);
	  return {uuid: uuid};
	};
	Rollbar.info = function() {
	  if (_instance) {
	    return _instance.info.apply(_instance, arguments);
	  } else {
	    var maybeCallback = _getFirstFunction(arguments);
	    handleUninitialized(maybeCallback);
	  }
	};
	
	Rollbar.prototype.warn = function() {
	  var item = this._createItem(arguments);
	  var uuid = item.uuid;
	  this.client.warn(item);
	  return {uuid: uuid};
	};
	Rollbar.warn = function() {
	  if (_instance) {
	    return _instance.warn.apply(_instance, arguments);
	  } else {
	    var maybeCallback = _getFirstFunction(arguments);
	    handleUninitialized(maybeCallback);
	  }
	};
	
	Rollbar.prototype.warning = function() {
	  var item = this._createItem(arguments);
	  var uuid = item.uuid;
	  this.client.warning(item);
	  return {uuid: uuid};
	};
	Rollbar.warning = function() {
	  if (_instance) {
	    return _instance.warning.apply(_instance, arguments);
	  } else {
	    var maybeCallback = _getFirstFunction(arguments);
	    handleUninitialized(maybeCallback);
	  }
	};
	
	Rollbar.prototype.error = function() {
	  var item = this._createItem(arguments);
	  var uuid = item.uuid;
	  this.client.error(item);
	  return {uuid: uuid};
	};
	Rollbar.error = function() {
	  if (_instance) {
	    return _instance.error.apply(_instance, arguments);
	  } else {
	    var maybeCallback = _getFirstFunction(arguments);
	    handleUninitialized(maybeCallback);
	  }
	};
	
	Rollbar.prototype.critical = function() {
	  var item = this._createItem(arguments);
	  var uuid = item.uuid;
	  this.client.critical(item);
	  return {uuid: uuid};
	};
	Rollbar.critical = function() {
	  if (_instance) {
	    return _instance.critical.apply(_instance, arguments);
	  } else {
	    var maybeCallback = _getFirstFunction(arguments);
	    handleUninitialized(maybeCallback);
	  }
	};
	
	Rollbar.prototype.handleUncaughtException = function(message, url, lineno, colno, error, context) {
	  var item;
	  var stackInfo = _.makeUnhandledStackInfo(
	    message,
	    url,
	    lineno,
	    colno,
	    error,
	    'onerror',
	    'uncaught exception',
	    errorParser
	  );
	  if (_.isError(error)) {
	    item = this._createItem([message, error, context]);
	    item._unhandledStackInfo = stackInfo;
	  } else if (_.isError(url)) {
	    item = this._createItem([message, url, context]);
	    item._unhandledStackInfo = stackInfo;
	  } else {
	    item = this._createItem([message, context]);
	    item.stackInfo = stackInfo;
	  }
	  item.level = this.options.uncaughtErrorLevel;
	  item._isUncaught = true;
	  this.client.log(item);
	};
	
	Rollbar.prototype.handleUnhandledRejection = function(reason, promise) {
	  var message = 'unhandled rejection was null or undefined!';
	  message = reason ? (reason.message || String(reason)) : message;
	  var context = (reason && reason._rollbarContext) || (promise && promise._rollbarContext);
	
	  var item;
	  if (_.isError(reason)) {
	    item = this._createItem([message, reason, context]);
	  } else {
	    item = this._createItem([message, reason, context]);
	    item.stackInfo = _.makeUnhandledStackInfo(
	      message,
	      '',
	      0,
	      0,
	      null,
	      'unhandledrejection',
	      '',
	      errorParser
	    );
	  }
	  item.level = this.options.uncaughtErrorLevel;
	  item._isUncaught = true;
	  item._originalArgs = item._originalArgs || [];
	  item._originalArgs.push(promise);
	  this.client.log(item);
	};
	
	Rollbar.prototype.wrap = function(f, context, _before) {
	  try {
	    var ctxFn;
	    if(_.isFunction(context)) {
	      ctxFn = context;
	    } else {
	      ctxFn = function() { return context || {}; };
	    }
	
	    if (!_.isFunction(f)) {
	      return f;
	    }
	
	    if (f._isWrap) {
	      return f;
	    }
	
	    if (!f._rollbar_wrapped) {
	      f._rollbar_wrapped = function () {
	        if (_before && _.isFunction(_before)) {
	          _before.apply(this, arguments);
	        }
	        try {
	          return f.apply(this, arguments);
	        } catch(exc) {
	          var e = exc;
	          if (_.isType(e, 'string')) {
	            e = new String(e);
	          }
	          e._rollbarContext = ctxFn() || {};
	          e._rollbarContext._wrappedSource = f.toString();
	
	          window._rollbarWrappedError = e;
	          throw e;
	        }
	      };
	
	      f._rollbar_wrapped._isWrap = true;
	
	      if (f.hasOwnProperty) {
	        for (var prop in f) {
	          if (f.hasOwnProperty(prop)) {
	            f._rollbar_wrapped[prop] = f[prop];
	          }
	        }
	      }
	    }
	
	    return f._rollbar_wrapped;
	  } catch (e) {
	    // Return the original function if the wrap fails.
	    return f;
	  }
	};
	Rollbar.wrap = function(f, context) {
	  if (_instance) {
	    return _instance.wrap(f, context);
	  } else {
	    handleUninitialized();
	  }
	};
	
	Rollbar.prototype.captureEvent = function(metadata, level) {
	  return this.client.captureEvent(metadata, level);
	};
	Rollbar.captureEvent = function(metadata, level) {
	  if (_instance) {
	    return _instance.captureEvent(metadata, level);
	  } else {
	    handleUninitialized();
	  }
	};
	
	// The following two methods are used internally and are not meant for public use
	Rollbar.prototype.captureDomContentLoaded = function(e, ts) {
	  if (!ts) {
	    ts = new Date();
	  }
	  return this.client.captureDomContentLoaded(ts);
	};
	
	Rollbar.prototype.captureLoad = function(e, ts) {
	  if (!ts) {
	    ts = new Date();
	  }
	  return this.client.captureLoad(ts);
	};
	
	/* Internal */
	
	function addTransformsToNotifier(notifier) {
	  notifier
	    .addTransform(transforms.handleItemWithError)
	    .addTransform(transforms.ensureItemHasSomethingToSay)
	    .addTransform(transforms.addBaseInfo)
	    .addTransform(transforms.addRequestInfo(window))
	    .addTransform(transforms.addClientInfo(window))
	    .addTransform(transforms.addPluginInfo(window))
	    .addTransform(transforms.addBody)
	    .addTransform(sharedTransforms.addMessageWithError)
	    .addTransform(sharedTransforms.addTelemetryData)
	    .addTransform(transforms.scrubPayload)
	    .addTransform(transforms.userTransform)
	    .addTransform(sharedTransforms.itemToPayload);
	}
	
	function addPredicatesToQueue(queue) {
	  queue
	    .addPredicate(predicates.checkIgnore)
	    .addPredicate(predicates.userCheckIgnore)
	    .addPredicate(predicates.urlIsWhitelisted)
	    .addPredicate(predicates.messageIsIgnored);
	}
	
	Rollbar.prototype._createItem = function(args) {
	  return _.createItem(args, logger, this);
	};
	
	function _getFirstFunction(args) {
	  for (var i = 0, len = args.length; i < len; ++i) {
	    if (_.isFunction(args[i])) {
	      return args[i];
	    }
	  }
	  return undefined;
	}
	
	/* global __NOTIFIER_VERSION__:false */
	/* global __DEFAULT_BROWSER_SCRUB_FIELDS__:false */
	/* global __DEFAULT_LOG_LEVEL__:false */
	/* global __DEFAULT_REPORT_LEVEL__:false */
	/* global __DEFAULT_UNCAUGHT_ERROR_LEVEL:false */
	/* global __DEFAULT_ENDPOINT__:false */
	
	var defaultOptions = {
	  version: ("2.2.3"),
	  scrubFields: (["pw","pass","passwd","password","secret","confirm_password","confirmPassword","password_confirmation","passwordConfirmation","access_token","accessToken","secret_key","secretKey","secretToken"]),
	  logLevel: ("debug"),
	  reportLevel: ("debug"),
	  uncaughtErrorLevel: ("error"),
	  endpoint: ("api.rollbar.com/api/1/"),
	  verbose: false,
	  enabled: true
	};
	
	module.exports = Rollbar;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RateLimiter = __webpack_require__(4);
	var Queue = __webpack_require__(5);
	var Notifier = __webpack_require__(9);
	var Telemeter = __webpack_require__(10);
	var _ = __webpack_require__(6);
	
	/*
	 * Rollbar - the interface to Rollbar
	 *
	 * @param options
	 * @param api
	 * @param logger
	 */
	function Rollbar(options, api, logger, platform) {
	  this.options = _.extend(true, {}, options);
	  this.logger = logger;
	  Rollbar.rateLimiter.setPlatformOptions(platform, this.options);
	  this.queue = new Queue(Rollbar.rateLimiter, api, logger, this.options);
	  this.notifier = new Notifier(this.queue, this.options);
	  this.telemeter = new Telemeter(this.options);
	  this.lastError = null;
	}
	
	var defaultOptions = {
	  maxItems: 0,
	  itemsPerMinute: 60
	};
	
	Rollbar.rateLimiter = new RateLimiter(defaultOptions);
	
	Rollbar.prototype.global = function(options) {
	  Rollbar.rateLimiter.configureGlobal(options);
	  return this;
	};
	
	Rollbar.prototype.configure = function(options, payloadData) {
	  this.notifier && this.notifier.configure(options);
	  var oldOptions = this.options;
	  var payload = {};
	  if (payloadData) {
	    payload = {payload: payloadData};
	  }
	  this.options = _.extend(true, {}, oldOptions, options, payload);
	  return this;
	};
	
	Rollbar.prototype.log = function(item) {
	  var level = this._defaultLogLevel();
	  return this._log(level, item);
	};
	
	Rollbar.prototype.debug = function(item) {
	  this._log('debug', item);
	};
	
	Rollbar.prototype.info = function(item) {
	  this._log('info', item);
	};
	
	Rollbar.prototype.warn = function(item) {
	  this._log('warning', item);
	};
	
	Rollbar.prototype.warning = function(item) {
	  this._log('warning', item);
	};
	
	Rollbar.prototype.error = function(item) {
	  this._log('error', item);
	};
	
	Rollbar.prototype.critical = function(item) {
	  this._log('critical', item);
	};
	
	Rollbar.prototype.wait = function(callback) {
	  this.queue.wait(callback);
	};
	
	Rollbar.prototype.captureEvent = function(metadata, level) {
	  return this.telemeter.captureEvent(metadata, level);
	};
	
	Rollbar.prototype.captureDomContentLoaded = function(ts) {
	  return this.telemeter.captureDomContentLoaded(ts);
	};
	
	Rollbar.prototype.captureLoad = function(ts) {
	  return this.telemeter.captureLoad(ts);
	};
	
	/* Internal */
	
	Rollbar.prototype._log = function(defaultLevel, item) {
	  if (this._sameAsLastError(item)) {
	    return;
	  }
	  try {
	    var callback = null;
	    if (item.callback) {
	      callback = item.callback;
	      delete item.callback;
	    }
	    item.level = item.level || defaultLevel;
	    item.telemetryEvents = this.telemeter.copyEvents();
	    this.telemeter._captureRollbarItem(item);
	    this.notifier.log(item, callback);
	  } catch (e) {
	    this.logger.error(e)
	  }
	};
	
	Rollbar.prototype._defaultLogLevel = function() {
	  return this.options.logLevel || 'debug';
	};
	
	Rollbar.prototype._sameAsLastError = function(item) {
	  if (this.lastError && this.lastError === item.err) {
	    return true;
	  }
	  this.lastError = item.err;
	  return false;
	};
	
	module.exports = Rollbar;


/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * RateLimiter - an object that encapsulates the logic for counting items sent to Rollbar
	 *
	 * @param options - the same options that are accepted by configureGlobal offered as a convenience
	 */
	function RateLimiter(options) {
	  this.startTime = (new Date()).getTime();
	  this.counter = 0;
	  this.perMinCounter = 0;
	  this.platform = null;
	  this.platformOptions = {};
	  this.configureGlobal(options);
	}
	
	RateLimiter.globalSettings = {
	  startTime: (new Date()).getTime(),
	  maxItems: undefined,
	  itemsPerMinute: undefined
	};
	
	/*
	 * configureGlobal - set the global rate limiter options
	 *
	 * @param options - Only the following values are recognized:
	 *    startTime: a timestamp of the form returned by (new Date()).getTime()
	 *    maxItems: the maximum items
	 *    itemsPerMinute: the max number of items to send in a given minute
	 */
	RateLimiter.prototype.configureGlobal = function(options) {
	  if (options.startTime !== undefined) {
	    RateLimiter.globalSettings.startTime = options.startTime;
	  }
	  if (options.maxItems !== undefined) {
	    RateLimiter.globalSettings.maxItems = options.maxItems;
	  }
	  if (options.itemsPerMinute !== undefined) {
	    RateLimiter.globalSettings.itemsPerMinute = options.itemsPerMinute;
	  }
	};
	
	/*
	 * shouldSend - determine if we should send a given item based on rate limit settings
	 *
	 * @param item - the item we are about to send
	 * @returns An object with the following structure:
	 *  error: (Error|null)
	 *  shouldSend: bool
	 *  payload: (Object|null)
	 *  If shouldSend is false, the item passed as a parameter should not be sent to Rollbar, and
	 *  exactly one of error or payload will be non-null. If error is non-null, the returned Error will
	 *  describe the situation, but it means that we were already over a rate limit (either globally or
	 *  per minute) when this item was checked. If error is null, and therefore payload is non-null, it
	 *  means this item put us over the global rate limit and the payload should be sent to Rollbar in
	 *  place of the passed in item.
	 */
	RateLimiter.prototype.shouldSend = function(item, now) {
	  now = now || (new Date()).getTime();
	  if (now - this.startTime >= 60000) {
	    this.startTime = now;
	    this.perMinCounter = 0;
	  }
	
	  var globalRateLimit = RateLimiter.globalSettings.maxItems;
	  var globalRateLimitPerMin = RateLimiter.globalSettings.itemsPerMinute;
	
	  if (checkRate(item, globalRateLimit, this.counter)) {
	    return shouldSendValue(this.platform, this.platformOptions, globalRateLimit + ' max items reached', false);
	  } else if (checkRate(item, globalRateLimitPerMin, this.perMinCounter)) {
	    return shouldSendValue(this.platform, this.platformOptions, globalRateLimitPerMin + ' items per minute reached', false);
	  }
	  this.counter++;
	  this.perMinCounter++;
	
	  var shouldSend = !checkRate(item, globalRateLimit, this.counter);
	  return shouldSendValue(this.platform, this.platformOptions, null, shouldSend, globalRateLimit);
	};
	
	RateLimiter.prototype.setPlatformOptions = function(platform, options) {
	  this.platform = platform;
	  this.platformOptions = options;
	};
	
	/* Helpers */
	
	function checkRate(item, limit, counter) {
	  return !item.ignoreRateLimit && limit >= 1 && counter >= limit;
	}
	
	function shouldSendValue(platform, options, error, shouldSend, globalRateLimit) {
	  var payload = null;
	  if (error) {
	    error = new Error(error);
	  }
	  if (!error && !shouldSend) {
	    payload = rateLimitPayload(platform, options, globalRateLimit);
	  }
	  return {error: error, shouldSend: shouldSend, payload: payload};
	}
	
	function rateLimitPayload(platform, options, globalRateLimit) {
	  var environment = options.environment || (options.payload && options.payload.environment);
	  var item = {
	    body: {
	      message: {
	        body: 'maxItems has been hit. Ignoring errors until reset.',
	        extra: {
	          maxItems: globalRateLimit
	        }
	      }
	    },
	    language: 'javascript',
	    environment: environment,
	    notifier: {
	      version: (options.notifier && options.notifier.version) || options.version
	    }
	  };
	  if (platform === 'browser') {
	    item.platform = 'browser';
	    item.framework = 'browser-js';
	    item.notifier.name = 'rollbar-browser-js';
	  } else if (platform === 'server') {
	    item.framework = options.framework || 'node-js';
	    item.notifier.name = options.notifier.name;
	  }
	  return item;
	}
	
	module.exports = RateLimiter;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	
	/*
	 * Queue - an object which handles which handles a queue of items to be sent to Rollbar.
	 *   This object handles rate limiting via a passed in rate limiter, retries based on connection
	 *   errors, and filtering of items based on a set of configurable predicates. The communication to
	 *   the backend is performed via a given API object.
	 *
	 * @param rateLimiter - An object which conforms to the interface
	 *    rateLimiter.shouldSend(item) -> bool
	 * @param api - An object which conforms to the interface
	 *    api.postItem(payload, function(err, response))
	 * @param logger - An object used to log verbose messages if desired
	 * @param options - see Queue.prototype.configure
	 */
	function Queue(rateLimiter, api, logger, options) {
	  this.rateLimiter = rateLimiter;
	  this.api = api;
	  this.logger = logger;
	  this.options = options;
	  this.predicates = [];
	  this.pendingRequests = [];
	  this.retryQueue = [];
	  this.retryHandle = null;
	  this.waitCallback = null;
	  this.waitIntervalID = null;
	}
	
	/*
	 * configure - updates the options this queue uses
	 *
	 * @param options
	 */
	Queue.prototype.configure = function(options) {
	  this.api && this.api.configure(options);
	  var oldOptions = this.options;
	  this.options = _.extend(true, {}, oldOptions, options);
	  return this;
	};
	
	/*
	 * addPredicate - adds a predicate to the end of the list of predicates for this queue
	 *
	 * @param predicate - function(item, options) -> (bool|{err: Error})
	 *  Returning true means that this predicate passes and the item is okay to go on the queue
	 *  Returning false means do not add the item to the queue, but it is not an error
	 *  Returning {err: Error} means do not add the item to the queue, and the given error explains why
	 *  Returning {err: undefined} is equivalent to returning true but don't do that
	 */
	Queue.prototype.addPredicate = function(predicate) {
	  if (_.isFunction(predicate)) {
	    this.predicates.push(predicate);
	  }
	  return this;
	};
	
	/*
	 * addItem - Send an item to the Rollbar API if all of the predicates are satisfied
	 *
	 * @param item - The payload to send to the backend
	 * @param callback - function(error, repsonse) which will be called with the response from the API
	 *  in the case of a success, otherwise response will be null and error will have a value. If both
	 *  error and response are null then the item was stopped by a predicate which did not consider this
	 *  to be an error condition, but nonetheless did not send the item to the API.
	 *  @param originalError - The original error before any transformations that is to be logged if any
	 */
	Queue.prototype.addItem = function(item, callback, originalError) {
	  if (!callback || !_.isFunction(callback)) {
	    callback = function() { return; };
	  }
	  var predicateResult = this._applyPredicates(item);
	  if (predicateResult.stop) {
	    callback(predicateResult.err);
	    return;
	  }
	  if (this.waitCallback) {
	    callback();
	    return;
	  }
	  this._maybeLog(item, originalError);
	  this.pendingRequests.push(item);
	  try {
	    this._makeApiRequest(item, function(err, resp) {
	      this._dequeuePendingRequest(item);
	      callback(err, resp);
	    }.bind(this));
	  } catch (e) {
	    this._dequeuePendingRequest(item);
	    callback(e);
	  }
	};
	
	/*
	 * wait - Stop any further errors from being added to the queue, and get called back when all items
	 *   currently processing have finished sending to the backend.
	 *
	 * @param callback - function() called when all pending items have been sent
	 */
	Queue.prototype.wait = function(callback) {
	  if (!_.isFunction(callback)) {
	    return;
	  }
	  this.waitCallback = callback;
	  if (this._maybeCallWait()) {
	    return;
	  }
	  if (this.waitIntervalID) {
	    this.waitIntervalID = clearInterval(this.waitIntervalID);
	  }
	  this.waitIntervalID = setInterval(function() {
	    this._maybeCallWait();
	  }.bind(this), 500);
	};
	
	/* _applyPredicates - Sequentially applies the predicates that have been added to the queue to the
	 *   given item with the currently configured options.
	 *
	 * @param item - An item in the queue
	 * @returns {stop: bool, err: (Error|null)} - stop being true means do not add item to the queue,
	 *   the error value should be passed up to a callbak if we are stopping.
	 */
	Queue.prototype._applyPredicates = function(item) {
	  var p = null;
	  for (var i = 0, len = this.predicates.length; i < len; i++) {
	    p = this.predicates[i](item, this.options);
	    if (!p || p.err !== undefined) {
	      return {stop: true, err: p.err};
	    }
	  }
	  return {stop: false, err: null};
	};
	
	/*
	 * _makeApiRequest - Send an item to Rollbar, callback when done, if there is an error make an
	 *   effort to retry if we are configured to do so.
	 *
	 * @param item - an item ready to send to the backend
	 * @param callback - function(err, response)
	 */
	Queue.prototype._makeApiRequest = function(item, callback) {
	  var rateLimitResponse = this.rateLimiter.shouldSend(item);
	  if (rateLimitResponse.shouldSend) {
	    this.api.postItem(item, function(err, resp) {
	      if (err) {
	        this._maybeRetry(err, item, callback);
	      } else {
	        callback(err, resp);
	      }
	    }.bind(this));
	  } else if (rateLimitResponse.error) {
	    callback(rateLimitResponse.error);
	  } else {
	    this.api.postItem(rateLimitResponse.payload, callback);
	  }
	};
	
	// These are errors basically mean there is no internet connection
	var RETRIABLE_ERRORS = ['ECONNRESET', 'ENOTFOUND', 'ESOCKETTIMEDOUT', 'ETIMEDOUT', 'ECONNREFUSED', 'EHOSTUNREACH', 'EPIPE', 'EAI_AGAIN'];
	
	/*
	 * _maybeRetry - Given the error returned by the API, decide if we should retry or just callback
	 *   with the error.
	 *
	 * @param err - an error returned by the API transport
	 * @param item - the item that was trying to be sent when this error occured
	 * @param callback - function(err, response)
	 */
	Queue.prototype._maybeRetry = function(err, item, callback) {
	  var shouldRetry = false;
	  if (this.options.retryInterval) {
	    for (var i = 0, len = RETRIABLE_ERRORS.length; i < len; i++) {
	      if (err.code === RETRIABLE_ERRORS[i]) {
	        shouldRetry = true;
	        break;
	      }
	    }
	  }
	  if (shouldRetry) {
	    this._retryApiRequest(item, callback);
	  } else {
	    callback(err);
	  }
	};
	
	/*
	 * _retryApiRequest - Add an item and a callback to a queue and possibly start a timer to process
	 *   that queue based on the retryInterval in the options for this queue.
	 *
	 * @param item - an item that failed to send due to an error we deem retriable
	 * @param callback - function(err, response)
	 */
	Queue.prototype._retryApiRequest = function(item, callback) {
	  this.retryQueue.push({item: item, callback: callback});
	
	  if (!this.retryHandle) {
	    this.retryHandle = setInterval(function() {
	      while (this.retryQueue.length) {
	        var retryObject = this.retryQueue.shift();
	        this._makeApiRequest(retryObject.item, retryObject.callback);
	      }
	    }.bind(this), this.options.retryInterval);
	  }
	};
	
	/*
	 * _dequeuePendingRequest - Removes the item from the pending request queue, this queue is used to
	 *   enable to functionality of providing a callback that clients can pass to `wait` to be notified
	 *   when the pending request queue has been emptied. This must be called when the API finishes
	 *   processing this item. If a `wait` callback is configured, it is called by this function.
	 *
	 * @param item - the item previously added to the pending request queue
	 */
	Queue.prototype._dequeuePendingRequest = function(item) {
	  for (var i = this.pendingRequests.length; i >= 0; i--) {
	    if (this.pendingRequests[i] == item) {
	      this.pendingRequests.splice(i, 1);
	      this._maybeCallWait();
	      return;
	    }
	  }
	};
	
	Queue.prototype._maybeLog = function(data, originalError) {
	  if (this.logger && this.options.verbose) {
	    var message = originalError;
	    message = message || _.get(data, 'body.trace.exception.message');
	    message = message || _.get(data, 'body.trace_chain.0.exception.message');
	    if (message) {
	      this.logger.error(message);
	      return;
	    }
	    message = _.get(data, 'body.message.body');
	    if (message) {
	      this.logger.log(message);
	    }
	  }
	};
	
	Queue.prototype._maybeCallWait = function() {
	  if (_.isFunction(this.waitCallback) && this.pendingRequests.length === 0) {
	    if (this.waitIntervalID) {
	      this.waitIntervalID = clearInterval(this.waitIntervalID);
	    }
	    this.waitCallback();
	    return true;
	  }
	  return false;
	};
	
	module.exports = Queue;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(7);
	
	var RollbarJSON = {};
	var __initRollbarJSON = false;
	function setupJSON() {
	  if (__initRollbarJSON) {
	    return;
	  }
	  __initRollbarJSON = true;
	
	  if (isDefined(JSON)) {
	    if (isFunction(JSON.stringify)) {
	      RollbarJSON.stringify = JSON.stringify;
	    }
	    if (isFunction(JSON.parse)) {
	      RollbarJSON.parse = JSON.parse;
	    }
	  }
	  if (!isFunction(RollbarJSON.stringify) || !isFunction(RollbarJSON.parse)) {
	    var setupCustomJSON = __webpack_require__(8);
	    setupCustomJSON(RollbarJSON);
	  }
	}
	setupJSON();
	
	/*
	 * isType - Given a Javascript value and a string, returns true if the type of the value matches the
	 * given string.
	 *
	 * @param x - any value
	 * @param t - a lowercase string containing one of the following type names:
	 *    - undefined
	 *    - null
	 *    - error
	 *    - number
	 *    - boolean
	 *    - string
	 *    - symbol
	 *    - function
	 *    - object
	 *    - array
	 * @returns true if x is of type t, otherwise false
	 */
	function isType(x, t) {
	  return t === typeName(x);
	}
	
	/*
	 * typeName - Given a Javascript value, returns the type of the object as a string
	 */
	function typeName(x) {
	  var name = typeof x;
	  if (name !== 'object') {
	    return name;
	  }
	  if (!x) {
	    return 'null';
	  }
	  if (x instanceof Error) {
	    return 'error';
	  }
	  return ({}).toString.call(x).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
	}
	
	/* isFunction - a convenience function for checking if a value is a function
	 *
	 * @param f - any value
	 * @returns true if f is a function, otherwise false
	 */
	function isFunction(f) {
	  return isType(f, 'function');
	}
	
	/*
	 * isDefined - a convenience function for checking if a value is not equal to undefined
	 *
	 * @param u - any value
	 * @returns true if u is anything other than undefined
	 */
	function isDefined(u) {
	  return !isType(u, 'undefined');
	}
	
	/*
	 * isIterable - convenience function for checking if a value can be iterated, essentially
	 * whether it is an object or an array.
	 *
	 * @param i - any value
	 * @returns true if i is an object or an array as determined by `typeName`
	 */
	function isIterable(i) {
	  var type = typeName(i);
	  return (type === 'object' || type === 'array');
	}
	
	/*
	 * isError - convenience function for checking if a value is of an error type
	 *
	 * @param e - any value
	 * @returns true if e is an error
	 */
	function isError(e) {
	  return isType(e, 'error');
	}
	
	function traverse(obj, func, seen) {
	  var k, v, i;
	  var isObj = isType(obj, 'object');
	  var isArray = isType(obj, 'array');
	  var keys = [];
	
	  if (isObj && seen.indexOf(obj) !== -1) {
	    return obj;
	  }
	  seen.push(obj);
	
	  if (isObj) {
	    for (k in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, k)) {
	        keys.push(k);
	      }
	    }
	  } else if (isArray) {
	    for (i = 0; i < obj.length; ++i) {
	      keys.push(i);
	    }
	  }
	
	  for (i = 0; i < keys.length; ++i) {
	    k = keys[i];
	    v = obj[k];
	    obj[k] = func(k, v, seen);
	  }
	
	  return obj;
	}
	
	function redact() {
	  return '********';
	}
	
	// from http://stackoverflow.com/a/8809472/1138191
	function uuid4() {
	  var d = now();
	  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	    var r = (d + Math.random() * 16) % 16 | 0;
	    d = Math.floor(d / 16);
	    return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
	  });
	  return uuid;
	}
	
	var LEVELS = {
	  debug: 0,
	  info: 1,
	  warning: 2,
	  error: 3,
	  critical: 4
	};
	
	function sanitizeUrl(url) {
	  var baseUrlParts = parseUri(url);
	  // remove a trailing # if there is no anchor
	  if (baseUrlParts.anchor === '') {
	    baseUrlParts.source = baseUrlParts.source.replace('#', '');
	  }
	
	  url = baseUrlParts.source.replace('?' + baseUrlParts.query, '');
	  return url;
	}
	
	var parseUriOptions = {
	  strictMode: false,
	  key: [
	    'source',
	    'protocol',
	    'authority',
	    'userInfo',
	    'user',
	    'password',
	    'host',
	    'port',
	    'relative',
	    'path',
	    'directory',
	    'file',
	    'query',
	    'anchor'
	  ],
	  q: {
	    name: 'queryKey',
	    parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	  },
	  parser: {
	    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
	    loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	  }
	};
	
	function parseUri(str) {
	  if (!isType(str, 'string')) {
	    throw new Error('received invalid input');
	  }
	
	  var o = parseUriOptions;
	  var m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
	  var uri = {};
	  var i = o.key.length;
	
	  while (i--) {
	    uri[o.key[i]] = m[i] || '';
	  }
	
	  uri[o.q.name] = {};
	  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
	    if ($1) {
	      uri[o.q.name][$1] = $2;
	    }
	  });
	
	  return uri;
	}
	
	function addParamsAndAccessTokenToPath(accessToken, options, params) {
	  params = params || {};
	  params.access_token = accessToken;
	  var paramsArray = [];
	  var k;
	  for (k in params) {
	    if (Object.prototype.hasOwnProperty.call(params, k)) {
	      paramsArray.push([k, params[k]].join('='));
	    }
	  }
	  var query = '?' + paramsArray.sort().join('&');
	
	  options = options || {};
	  options.path = options.path || '';
	  var qs = options.path.indexOf('?');
	  var h = options.path.indexOf('#');
	  var p;
	  if (qs !== -1 && (h === -1 || h > qs)) {
	    p = options.path;
	    options.path = p.substring(0,qs) + query + '&' + p.substring(qs+1);
	  } else {
	    if (h !== -1) {
	      p = options.path;
	      options.path = p.substring(0,h) + query + p.substring(h);
	    } else {
	      options.path = options.path + query;
	    }
	  }
	}
	
	function formatUrl(u, protocol) {
	  protocol = protocol || u.protocol;
	  if (!protocol && u.port) {
	    if (u.port === 80) {
	      protocol = 'http:';
	    } else if (u.port === 443) {
	      protocol = 'https:';
	    }
	  }
	  protocol = protocol || 'https:';
	
	  if (!u.hostname) {
	    return null;
	  }
	  var result = protocol + '//' + u.hostname;
	  if (u.port) {
	    result = result + ':' + u.port;
	  }
	  if (u.path) {
	    result = result + u.path;
	  }
	  return result;
	}
	
	function stringify(obj, backup) {
	  var value, error;
	  try {
	    value = RollbarJSON.stringify(obj);
	  } catch (jsonError) {
	    if (backup && isFunction(backup)) {
	      try {
	        value = backup(obj);
	      } catch (backupError) {
	        error = backupError;
	      }
	    } else {
	      error = jsonError;
	    }
	  }
	  return {error: error, value: value};
	}
	
	function jsonParse(s) {
	  var value, error;
	  try {
	    value = RollbarJSON.parse(s);
	  } catch (e) {
	    error = e;
	  }
	  return {error: error, value: value};
	}
	
	function makeUnhandledStackInfo(
	  message,
	  url,
	  lineno,
	  colno,
	  error,
	  mode,
	  backupMessage,
	  errorParser
	) {
	  var location = {
	    url: url || '',
	    line: lineno,
	    column: colno
	  };
	  location.func = errorParser.guessFunctionName(location.url, location.line);
	  location.context = errorParser.gatherContext(location.url, location.line);
	  var href = document && document.location && document.location.href;
	  var useragent = window && window.navigator && window.navigator.userAgent;
	  return {
	    'mode': mode,
	    'message': error ? String(error) : (message || backupMessage),
	    'url': href,
	    'stack': [location],
	    'useragent': useragent
	  };
	}
	
	function wrapCallback(logger, f) {
	  return function(err, resp) {
	    try {
	      f(err, resp);
	    } catch (e) {
	      logger.error(e);
	    }
	  };
	}
	
	function createItem(args, logger, notifier, requestKeys) {
	  var message, err, custom, callback, request;
	  var arg;
	  var extraArgs = [];
	
	  for (var i = 0, l = args.length; i < l; ++i) {
	    arg = args[i];
	
	    var typ = typeName(arg);
	    switch (typ) {
	      case 'undefined':
	        break;
	      case 'string':
	        message ? extraArgs.push(arg) : message = arg;
	        break;
	      case 'function':
	        callback = wrapCallback(logger, arg);
	        break;
	      case 'date':
	        extraArgs.push(arg);
	        break;
	      case 'error':
	      case 'domexception':
	        err ? extraArgs.push(arg) : err = arg;
	        break;
	      case 'object':
	      case 'array':
	        if (arg instanceof Error || (typeof DOMException !== 'undefined' && arg instanceof DOMException)) {
	          err ? extraArgs.push(arg) : err = arg;
	          break;
	        }
	        if (requestKeys && typ === 'object' && !request) {
	          for (var j = 0, len = requestKeys.length; j < len; ++j) {
	            if (arg[requestKeys[j]] !== undefined) {
	              request = arg;
	              break;
	            }
	          }
	          if (request) {
	            break;
	          }
	        }
	        custom ? extraArgs.push(arg) : custom = arg;
	        break;
	      default:
	        if (arg instanceof Error || (typeof DOMException !== 'undefined' && arg instanceof DOMException)) {
	          err ? extraArgs.push(arg) : err = arg;
	          break;
	        }
	        extraArgs.push(arg);
	    }
	  }
	
	  if (extraArgs.length > 0) {
	    // if custom is an array this turns it into an object with integer keys
	    custom = extend(true, {}, custom);
	    custom.extraArgs = extraArgs;
	  }
	
	  var item = {
	    message: message,
	    err: err,
	    custom: custom,
	    timestamp: now(),
	    callback: callback,
	    uuid: uuid4()
	  };
	  if (custom && custom.level !== undefined) {
	    item.level = custom.level;
	    delete custom.level;
	  }
	  if (requestKeys && request) {
	    item.request = request;
	  }
	  item._originalArgs = args;
	  return item;
	}
	
	/*
	 * get - given an obj/array and a keypath, return the value at that keypath or
	 *       undefined if not possible.
	 *
	 * @param obj - an object or array
	 * @param path - a string of keys separated by '.' such as 'plugin.jquery.0.message'
	 *    which would correspond to 42 in `{plugin: {jquery: [{message: 42}]}}`
	 */
	function get(obj, path) {
	  if (!obj) {
	    return undefined;
	  }
	  var keys = path.split('.');
	  var result = obj;
	  try {
	    for (var i = 0, len = keys.length; i < len; ++i) {
	      result = result[keys[i]];
	    }
	  } catch (e) {
	    result = undefined;
	  }
	  return result;
	}
	
	function set(obj, path, value) {
	  if (!obj) {
	    return;
	  }
	  var keys = path.split('.');
	  var len = keys.length;
	  if (len < 1) {
	    return;
	  }
	  if (len === 1) {
	    obj[keys[0]] = value;
	    return;
	  }
	  try {
	    var temp = obj[keys[0]] || {};
	    var replacement = temp;
	    for (var i = 1; i < len-1; i++) {
	      temp[keys[i]] = temp[keys[i]] || {};
	      temp = temp[keys[i]];
	    }
	    temp[keys[len-1]] = value;
	    obj[keys[0]] = replacement;
	  } catch (e) {
	    return;
	  }
	}
	
	function scrub(data, scrubFields) {
	  scrubFields = scrubFields || [];
	  var paramRes = _getScrubFieldRegexs(scrubFields);
	  var queryRes = _getScrubQueryParamRegexs(scrubFields);
	
	  function redactQueryParam(dummy0, paramPart, dummy1, dummy2, dummy3, valPart) {
	    return paramPart + redact(valPart);
	  }
	
	  function paramScrubber(v) {
	    var i;
	    if (isType(v, 'string')) {
	      for (i = 0; i < queryRes.length; ++i) {
	        v = v.replace(queryRes[i], redactQueryParam);
	      }
	    }
	    return v;
	  }
	
	  function valScrubber(k, v) {
	    var i;
	    for (i = 0; i < paramRes.length; ++i) {
	      if (paramRes[i].test(k)) {
	        v = redact(v);
	        break;
	      }
	    }
	    return v;
	  }
	
	  function scrubber(k, v, seen) {
	    var tmpV = valScrubber(k, v);
	    if (tmpV === v) {
	      if (isType(v, 'object') || isType(v, 'array')) {
	        return traverse(v, scrubber, seen);
	      }
	      return paramScrubber(tmpV);
	    } else {
	      return tmpV;
	    }
	  }
	
	  traverse(data, scrubber, []);
	  return data;
	}
	
	function _getScrubFieldRegexs(scrubFields) {
	  var ret = [];
	  var pat;
	  for (var i = 0; i < scrubFields.length; ++i) {
	    pat = '\\[?(%5[bB])?' + scrubFields[i] + '\\[?(%5[bB])?\\]?(%5[dD])?';
	    ret.push(new RegExp(pat, 'i'));
	  }
	  return ret;
	}
	
	
	function _getScrubQueryParamRegexs(scrubFields) {
	  var ret = [];
	  var pat;
	  for (var i = 0; i < scrubFields.length; ++i) {
	    pat = '\\[?(%5[bB])?' + scrubFields[i] + '\\[?(%5[bB])?\\]?(%5[dD])?';
	    ret.push(new RegExp('(' + pat + '=)([^&\\n]+)', 'igm'));
	  }
	  return ret;
	}
	
	function formatArgsAsString(args) {
	  var i, len, arg;
	  var result = [];
	  for (i = 0, len = args.length; i < len; i++) {
	    arg = args[i];
	    if (typeof arg === 'object') {
	      arg = stringify(arg);
	      arg = arg.error || arg.value;
	      if (arg.length > 500)
	        arg = arg.substr(0,500)+'...';
	    } else if (typeof arg === 'undefined') {
	      arg = 'undefined';
	    }
	    result.push(arg);
	  }
	  return result.join(' ');
	}
	
	function now() {
	  if (Date.now) {
	    return Date.now();
	  }
	  return +new Date();
	}
	
	module.exports = {
	  isType: isType,
	  typeName: typeName,
	  isFunction: isFunction,
	  isIterable: isIterable,
	  isError: isError,
	  extend: extend,
	  traverse: traverse,
	  redact: redact,
	  uuid4: uuid4,
	  LEVELS: LEVELS,
	  sanitizeUrl: sanitizeUrl,
	  addParamsAndAccessTokenToPath: addParamsAndAccessTokenToPath,
	  formatUrl: formatUrl,
	  stringify: stringify,
	  jsonParse: jsonParse,
	  makeUnhandledStackInfo: makeUnhandledStackInfo,
	  createItem: createItem,
	  get: get,
	  set: set,
	  scrub: scrub,
	  formatArgsAsString: formatArgsAsString,
	  now: now
	};


/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) {/**/}
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0],
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		} else if ((typeof target !== 'object' && typeof target !== 'function') || target == null) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	


/***/ },
/* 8 */
/***/ function(module, exports) {

	//  json3.js
	//  2017-02-21
	//  Public Domain.
	//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	//  See http://www.JSON.org/js.html
	//  This code should be minified before deployment.
	//  See http://javascript.crockford.com/jsmin.html
	
	//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
	//  NOT CONTROL.
	
	//  This file creates a global JSON object containing two methods: stringify
	//  and parse. This file provides the ES5 JSON capability to ES3 systems.
	//  If a project might run on IE8 or earlier, then this file should be included.
	//  This file does nothing on ES5 systems.
	
	//      JSON.stringify(value, replacer, space)
	//          value       any JavaScript value, usually an object or array.
	//          replacer    an optional parameter that determines how object
	//                      values are stringified for objects. It can be a
	//                      function or an array of strings.
	//          space       an optional parameter that specifies the indentation
	//                      of nested structures. If it is omitted, the text will
	//                      be packed without extra whitespace. If it is a number,
	//                      it will specify the number of spaces to indent at each
	//                      level. If it is a string (such as "\t" or "&nbsp;"),
	//                      it contains the characters used to indent at each level.
	//          This method produces a JSON text from a JavaScript value.
	//          When an object value is found, if the object contains a toJSON
	//          method, its toJSON method will be called and the result will be
	//          stringified. A toJSON method does not serialize: it returns the
	//          value represented by the name/value pair that should be serialized,
	//          or undefined if nothing should be serialized. The toJSON method
	//          will be passed the key associated with the value, and this will be
	//          bound to the value.
	
	//          For example, this would serialize Dates as ISO strings.
	
	//              Date.prototype.toJSON = function (key) {
	//                  function f(n) {
	//                      // Format integers to have at least two digits.
	//                      return (n < 10)
	//                          ? "0" + n
	//                          : n;
	//                  }
	//                  return this.getUTCFullYear()   + "-" +
	//                       f(this.getUTCMonth() + 1) + "-" +
	//                       f(this.getUTCDate())      + "T" +
	//                       f(this.getUTCHours())     + ":" +
	//                       f(this.getUTCMinutes())   + ":" +
	//                       f(this.getUTCSeconds())   + "Z";
	//              };
	
	//          You can provide an optional replacer method. It will be passed the
	//          key and value of each member, with this bound to the containing
	//          object. The value that is returned from your method will be
	//          serialized. If your method returns undefined, then the member will
	//          be excluded from the serialization.
	
	//          If the replacer parameter is an array of strings, then it will be
	//          used to select the members to be serialized. It filters the results
	//          such that only members with keys listed in the replacer array are
	//          stringified.
	
	//          Values that do not have JSON representations, such as undefined or
	//          functions, will not be serialized. Such values in objects will be
	//          dropped; in arrays they will be replaced with null. You can use
	//          a replacer function to replace those with JSON values.
	
	//          JSON.stringify(undefined) returns undefined.
	
	//          The optional space parameter produces a stringification of the
	//          value that is filled with line breaks and indentation to make it
	//          easier to read.
	
	//          If the space parameter is a non-empty string, then that string will
	//          be used for indentation. If the space parameter is a number, then
	//          the indentation will be that many spaces.
	
	//          Example:
	
	//          text = JSON.stringify(["e", {pluribus: "unum"}]);
	//          // text is '["e",{"pluribus":"unum"}]'
	
	//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
	//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
	
	//          text = JSON.stringify([new Date()], function (key, value) {
	//              return this[key] instanceof Date
	//                  ? "Date(" + this[key] + ")"
	//                  : value;
	//          });
	//          // text is '["Date(---current time---)"]'
	
	//      JSON.parse(text, reviver)
	//          This method parses a JSON text to produce an object or array.
	//          It can throw a SyntaxError exception.
	//          This has been modified to use JSON-js/json_parse_state.js as the
	//          parser instead of the one built around eval found in JSON-js/json2.js
	
	//          The optional reviver parameter is a function that can filter and
	//          transform the results. It receives each of the keys and values,
	//          and its return value is used instead of the original value.
	//          If it returns what it received, then the structure is not modified.
	//          If it returns undefined then the member is deleted.
	
	//          Example:
	
	//          // Parse the text. Values that look like ISO date strings will
	//          // be converted to Date objects.
	
	//          myData = JSON.parse(text, function (key, value) {
	//              var a;
	//              if (typeof value === "string") {
	//                  a =
	//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
	//                  if (a) {
	//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
	//                          +a[5], +a[6]));
	//                  }
	//              }
	//              return value;
	//          });
	
	//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
	//              var d;
	//              if (typeof value === "string" &&
	//                      value.slice(0, 5) === "Date(" &&
	//                      value.slice(-1) === ")") {
	//                  d = new Date(value.slice(5, -1));
	//                  if (d) {
	//                      return d;
	//                  }
	//              }
	//              return value;
	//          });
	
	//  This is a reference implementation. You are free to copy, modify, or
	//  redistribute.
	
	/*jslint
	  for, this
	  */
	
	/*property
	  JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
	  getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
	  lastIndex, length, parse, prototype, push, replace, slice, stringify,
	  test, toJSON, toString, valueOf
	  */
	
	var setupCustomJSON = function(JSON) {
	
	  var rx_one = /^[\],:{}\s]*$/;
	  var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	  var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	  var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
	  var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	  var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	
	  function f(n) {
	    // Format integers to have at least two digits.
	    return n < 10
	      ? "0" + n
	      : n;
	  }
	
	  function this_value() {
	    return this.valueOf();
	  }
	
	  if (typeof Date.prototype.toJSON !== "function") {
	
	    Date.prototype.toJSON = function () {
	
	      return isFinite(this.valueOf())
	        ? this.getUTCFullYear() + "-" +
	        f(this.getUTCMonth() + 1) + "-" +
	        f(this.getUTCDate()) + "T" +
	        f(this.getUTCHours()) + ":" +
	        f(this.getUTCMinutes()) + ":" +
	        f(this.getUTCSeconds()) + "Z"
	        : null;
	    };
	
	    Boolean.prototype.toJSON = this_value;
	    Number.prototype.toJSON = this_value;
	    String.prototype.toJSON = this_value;
	  }
	
	  var gap;
	  var indent;
	  var meta;
	  var rep;
	
	
	  function quote(string) {
	
	    // If the string contains no control characters, no quote characters, and no
	    // backslash characters, then we can safely slap some quotes around it.
	    // Otherwise we must also replace the offending characters with safe escape
	    // sequences.
	
	    rx_escapable.lastIndex = 0;
	    return rx_escapable.test(string)
	      ? "\"" + string.replace(rx_escapable, function (a) {
	        var c = meta[a];
	        return typeof c === "string"
	          ? c
	          : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	      }) + "\""
	    : "\"" + string + "\"";
	  }
	
	
	  function str(key, holder) {
	
	    // Produce a string from holder[key].
	
	    var i;          // The loop counter.
	    var k;          // The member key.
	    var v;          // The member value.
	    var length;
	    var mind = gap;
	    var partial;
	    var value = holder[key];
	
	    // If the value has a toJSON method, call it to obtain a replacement value.
	
	    if (value && typeof value === "object" &&
	        typeof value.toJSON === "function") {
	      value = value.toJSON(key);
	    }
	
	    // If we were called with a replacer function, then call the replacer to
	    // obtain a replacement value.
	
	    if (typeof rep === "function") {
	      value = rep.call(holder, key, value);
	    }
	
	    // What happens next depends on the value's type.
	
	    switch (typeof value) {
	      case "string":
	        return quote(value);
	
	      case "number":
	
	        // JSON numbers must be finite. Encode non-finite numbers as null.
	
	        return isFinite(value)
	          ? String(value)
	          : "null";
	
	      case "boolean":
	      case "null":
	
	        // If the value is a boolean or null, convert it to a string. Note:
	        // typeof null does not produce "null". The case is included here in
	        // the remote chance that this gets fixed someday.
	
	        return String(value);
	
	        // If the type is "object", we might be dealing with an object or an array or
	        // null.
	
	      case "object":
	
	        // Due to a specification blunder in ECMAScript, typeof null is "object",
	        // so watch out for that case.
	
	        if (!value) {
	          return "null";
	        }
	
	        // Make an array to hold the partial results of stringifying this object value.
	
	        gap += indent;
	        partial = [];
	
	        // Is the value an array?
	
	        if (Object.prototype.toString.apply(value) === "[object Array]") {
	
	          // The value is an array. Stringify every element. Use null as a placeholder
	          // for non-JSON values.
	
	          length = value.length;
	          for (i = 0; i < length; i += 1) {
	            partial[i] = str(i, value) || "null";
	          }
	
	          // Join all of the elements together, separated with commas, and wrap them in
	          // brackets.
	
	          v = partial.length === 0
	            ? "[]"
	            : gap
	            ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
	            : "[" + partial.join(",") + "]";
	          gap = mind;
	          return v;
	        }
	
	        // If the replacer is an array, use it to select the members to be stringified.
	
	        if (rep && typeof rep === "object") {
	          length = rep.length;
	          for (i = 0; i < length; i += 1) {
	            if (typeof rep[i] === "string") {
	              k = rep[i];
	              v = str(k, value);
	              if (v) {
	                partial.push(quote(k) + (
	                      gap
	                      ? ": "
	                      : ":"
	                      ) + v);
	              }
	            }
	          }
	        } else {
	
	          // Otherwise, iterate through all of the keys in the object.
	
	          for (k in value) {
	            if (Object.prototype.hasOwnProperty.call(value, k)) {
	              v = str(k, value);
	              if (v) {
	                partial.push(quote(k) + (
	                      gap
	                      ? ": "
	                      : ":"
	                      ) + v);
	              }
	            }
	          }
	        }
	
	        // Join all of the member texts together, separated with commas,
	        // and wrap them in braces.
	
	        v = partial.length === 0
	          ? "{}"
	          : gap
	          ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
	          : "{" + partial.join(",") + "}";
	        gap = mind;
	        return v;
	    }
	  }
	
	  // If the JSON object does not yet have a stringify method, give it one.
	
	  if (typeof JSON.stringify !== "function") {
	    meta = {    // table of character substitutions
	      "\b": "\\b",
	      "\t": "\\t",
	      "\n": "\\n",
	      "\f": "\\f",
	      "\r": "\\r",
	      "\"": "\\\"",
	      "\\": "\\\\"
	    };
	    JSON.stringify = function (value, replacer, space) {
	
	      // The stringify method takes a value and an optional replacer, and an optional
	      // space parameter, and returns a JSON text. The replacer can be a function
	      // that can replace values, or an array of strings that will select the keys.
	      // A default replacer method can be provided. Use of the space parameter can
	      // produce text that is more easily readable.
	
	      var i;
	      gap = "";
	      indent = "";
	
	      // If the space parameter is a number, make an indent string containing that
	      // many spaces.
	
	      if (typeof space === "number") {
	        for (i = 0; i < space; i += 1) {
	          indent += " ";
	        }
	
	        // If the space parameter is a string, it will be used as the indent string.
	
	      } else if (typeof space === "string") {
	        indent = space;
	      }
	
	      // If there is a replacer, it must be a function or an array.
	      // Otherwise, throw an error.
	
	      rep = replacer;
	      if (replacer && typeof replacer !== "function" &&
	          (typeof replacer !== "object" ||
	           typeof replacer.length !== "number")) {
	        throw new Error("JSON.stringify");
	      }
	
	      // Make a fake root object containing our value under the key of "".
	      // Return the result of stringifying the value.
	
	      return str("", {"": value});
	    };
	  }
	
	
	  // If the JSON object does not yet have a parse method, give it one.
	
	  if (typeof JSON.parse !== "function") {
	    JSON.parse = (function () {
	
	      // This function creates a JSON parse function that uses a state machine rather
	      // than the dangerous eval function to parse a JSON text.
	
	      var state;      // The state of the parser, one of
	      // 'go'         The starting state
	      // 'ok'         The final, accepting state
	      // 'firstokey'  Ready for the first key of the object or
	      //              the closing of an empty object
	      // 'okey'       Ready for the next key of the object
	      // 'colon'      Ready for the colon
	      // 'ovalue'     Ready for the value half of a key/value pair
	      // 'ocomma'     Ready for a comma or closing }
	      // 'firstavalue' Ready for the first value of an array or
	      //              an empty array
	      // 'avalue'     Ready for the next value of an array
	      // 'acomma'     Ready for a comma or closing ]
	      var stack;      // The stack, for controlling nesting.
	      var container;  // The current container object or array
	      var key;        // The current key
	      var value;      // The current value
	      var escapes = { // Escapement translation table
	        "\\": "\\",
	        "\"": "\"",
	        "/": "/",
	        "t": "\t",
	        "n": "\n",
	        "r": "\r",
	        "f": "\f",
	        "b": "\b"
	      };
	      var string = {   // The actions for string tokens
	        go: function () {
	          state = "ok";
	        },
	        firstokey: function () {
	          key = value;
	          state = "colon";
	        },
	        okey: function () {
	          key = value;
	          state = "colon";
	        },
	        ovalue: function () {
	          state = "ocomma";
	        },
	        firstavalue: function () {
	          state = "acomma";
	        },
	        avalue: function () {
	          state = "acomma";
	        }
	      };
	      var number = {   // The actions for number tokens
	        go: function () {
	          state = "ok";
	        },
	        ovalue: function () {
	          state = "ocomma";
	        },
	        firstavalue: function () {
	          state = "acomma";
	        },
	        avalue: function () {
	          state = "acomma";
	        }
	      };
	      var action = {
	
	        // The action table describes the behavior of the machine. It contains an
	        // object for each token. Each object contains a method that is called when
	        // a token is matched in a state. An object will lack a method for illegal
	        // states.
	
	        "{": {
	          go: function () {
	            stack.push({state: "ok"});
	            container = {};
	            state = "firstokey";
	          },
	          ovalue: function () {
	            stack.push({container: container, state: "ocomma", key: key});
	            container = {};
	            state = "firstokey";
	          },
	          firstavalue: function () {
	            stack.push({container: container, state: "acomma"});
	            container = {};
	            state = "firstokey";
	          },
	          avalue: function () {
	            stack.push({container: container, state: "acomma"});
	            container = {};
	            state = "firstokey";
	          }
	        },
	        "}": {
	          firstokey: function () {
	            var pop = stack.pop();
	            value = container;
	            container = pop.container;
	            key = pop.key;
	            state = pop.state;
	          },
	          ocomma: function () {
	            var pop = stack.pop();
	            container[key] = value;
	            value = container;
	            container = pop.container;
	            key = pop.key;
	            state = pop.state;
	          }
	        },
	        "[": {
	          go: function () {
	            stack.push({state: "ok"});
	            container = [];
	            state = "firstavalue";
	          },
	          ovalue: function () {
	            stack.push({container: container, state: "ocomma", key: key});
	            container = [];
	            state = "firstavalue";
	          },
	          firstavalue: function () {
	            stack.push({container: container, state: "acomma"});
	            container = [];
	            state = "firstavalue";
	          },
	          avalue: function () {
	            stack.push({container: container, state: "acomma"});
	            container = [];
	            state = "firstavalue";
	          }
	        },
	        "]": {
	          firstavalue: function () {
	            var pop = stack.pop();
	            value = container;
	            container = pop.container;
	            key = pop.key;
	            state = pop.state;
	          },
	          acomma: function () {
	            var pop = stack.pop();
	            container.push(value);
	            value = container;
	            container = pop.container;
	            key = pop.key;
	            state = pop.state;
	          }
	        },
	        ":": {
	          colon: function () {
	            if (Object.hasOwnProperty.call(container, key)) {
	              throw new SyntaxError("Duplicate key '" + key + "\"");
	            }
	            state = "ovalue";
	          }
	        },
	        ",": {
	          ocomma: function () {
	            container[key] = value;
	            state = "okey";
	          },
	          acomma: function () {
	            container.push(value);
	            state = "avalue";
	          }
	        },
	        "true": {
	          go: function () {
	            value = true;
	            state = "ok";
	          },
	          ovalue: function () {
	            value = true;
	            state = "ocomma";
	          },
	          firstavalue: function () {
	            value = true;
	            state = "acomma";
	          },
	          avalue: function () {
	            value = true;
	            state = "acomma";
	          }
	        },
	        "false": {
	          go: function () {
	            value = false;
	            state = "ok";
	          },
	          ovalue: function () {
	            value = false;
	            state = "ocomma";
	          },
	          firstavalue: function () {
	            value = false;
	            state = "acomma";
	          },
	          avalue: function () {
	            value = false;
	            state = "acomma";
	          }
	        },
	        "null": {
	          go: function () {
	            value = null;
	            state = "ok";
	          },
	          ovalue: function () {
	            value = null;
	            state = "ocomma";
	          },
	          firstavalue: function () {
	            value = null;
	            state = "acomma";
	          },
	          avalue: function () {
	            value = null;
	            state = "acomma";
	          }
	        }
	      };
	
	      function debackslashify(text) {
	
	        // Remove and replace any backslash escapement.
	
	        return text.replace(/\\(?:u(.{4})|([^u]))/g, function (ignore, b, c) {
	          return b
	            ? String.fromCharCode(parseInt(b, 16))
	            : escapes[c];
	        });
	      }
	
	      return function (source, reviver) {
	
	        // A regular expression is used to extract tokens from the JSON text.
	        // The extraction process is cautious.
	
	        var result;
	        var tx = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
	
	        // Set the starting state.
	
	        state = "go";
	
	        // The stack records the container, key, and state for each object or array
	        // that contains another object or array while processing nested structures.
	
	        stack = [];
	
	        // If any error occurs, we will catch it and ultimately throw a syntax error.
	
	        try {
	
	          // For each token...
	
	          while (true) {
	            result = tx.exec(source);
	            if (!result) {
	              break;
	            }
	
	            // result is the result array from matching the tokenizing regular expression.
	            //  result[0] contains everything that matched, including any initial whitespace.
	            //  result[1] contains any punctuation that was matched, or true, false, or null.
	            //  result[2] contains a matched number, still in string form.
	            //  result[3] contains a matched string, without quotes but with escapement.
	
	            if (result[1]) {
	
	              // Token: Execute the action for this state and token.
	
	              action[result[1]][state]();
	
	            } else if (result[2]) {
	
	              // Number token: Convert the number string into a number value and execute
	              // the action for this state and number.
	
	              value = +result[2];
	              number[state]();
	            } else {
	
	              // String token: Replace the escapement sequences and execute the action for
	              // this state and string.
	
	              value = debackslashify(result[3]);
	              string[state]();
	            }
	
	            // Remove the token from the string. The loop will continue as long as there
	            // are tokens. This is a slow process, but it allows the use of ^ matching,
	            // which assures that no illegal tokens slip through.
	
	            source = source.slice(result[0].length);
	          }
	
	          // If we find a state/token combination that is illegal, then the action will
	          // cause an error. We handle the error by simply changing the state.
	
	        } catch (e) {
	          state = e;
	        }
	
	        // The parsing is finished. If we are not in the final "ok" state, or if the
	        // remaining source contains anything except whitespace, then we did not have
	        //a well-formed JSON text.
	
	        if (state !== "ok" || (/[^\u0020\t\n\r]/.test(source))) {
	          throw (state instanceof SyntaxError)
	            ? state
	            : new SyntaxError("JSON");
	        }
	
	        // If there is a reviver function, we recursively walk the new structure,
	        // passing each name/value pair to the reviver function for possible
	        // transformation, starting with a temporary root object that holds the current
	        // value in an empty key. If there is not a reviver function, we simply return
	        // that value.
	
	        return (typeof reviver === "function")
	          ? (function walk(holder, key) {
	            var k;
	            var v;
	            var val = holder[key];
	            if (val && typeof val === "object") {
	              for (k in value) {
	                if (Object.prototype.hasOwnProperty.call(val, k)) {
	                  v = walk(val, k);
	                  if (v !== undefined) {
	                    val[k] = v;
	                  } else {
	                    delete val[k];
	                  }
	                }
	              }
	            }
	            return reviver.call(holder, key, val);
	          }({"": value}, ""))
	        : value;
	      };
	    }());
	  }
	}
	
	module.exports = setupCustomJSON;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	
	/*
	 * Notifier - the internal object responsible for delegating between the client exposed API, the
	 * chain of transforms necessary to turn an item into something that can be sent to Rollbar, and the
	 * queue which handles the communcation with the Rollbar API servers.
	 *
	 * @param queue - an object that conforms to the interface: addItem(item, callback)
	 * @param options - an object representing the options to be set for this notifier, this should have
	 * any defaults already set by the caller
	 */
	function Notifier(queue, options) {
	  this.queue = queue;
	  this.options = options;
	  this.transforms = [];
	}
	
	/*
	 * configure - updates the options for this notifier with the passed in object
	 *
	 * @param options - an object which gets merged with the current options set on this notifier
	 * @returns this
	 */
	Notifier.prototype.configure = function(options) {
	  this.queue && this.queue.configure(options);
	  var oldOptions = this.options;
	  this.options = _.extend(true, {}, oldOptions, options);
	  return this;
	};
	
	/*
	 * addTransform - adds a transform onto the end of the queue of transforms for this notifier
	 *
	 * @param transform - a function which takes three arguments:
	 *    * item: An Object representing the data to eventually be sent to Rollbar
	 *    * options: The current value of the options for this notifier
	 *    * callback: function(err: (Null|Error), item: (Null|Object)) the transform must call this
	 *    callback with a null value for error if it wants the processing chain to continue, otherwise
	 *    with an error to terminate the processing. The item should be the updated item after this
	 *    transform is finished modifying it.
	 */
	Notifier.prototype.addTransform = function(transform) {
	  if (_.isFunction(transform)) {
	    this.transforms.push(transform);
	  }
	  return this;
	};
	
	/*
	 * log - the internal log function which applies the configured transforms and then pushes onto the
	 * queue to be sent to the backend.
	 *
	 * @param item - An object with the following structure:
	 *    message [String] - An optional string to be sent to rollbar
	 *    error [Error] - An optional error
	 *
	 * @param callback - A function of type function(err, resp) which will be called with exactly one
	 * null argument and one non-null argument. The callback will be called once, either during the
	 * transform stage if an error occurs inside a transform, or in response to the communication with
	 * the backend. The second argument will be the response from the backend in case of success.
	 */
	Notifier.prototype.log = function(item, callback) {
	  if (!callback || !_.isFunction(callback)) {
	    callback = function() {};
	  }
	
	  if (!this.options.enabled) {
	    return callback(new Error('Rollbar is not enabled'));
	  }
	
	  var originalError = item.err;
	  this._applyTransforms(item, function(err, i) {
	    if (err) {
	      return callback(err, null);
	    }
	    this.queue.addItem(i, callback, originalError);
	  }.bind(this));
	};
	
	/* Internal */
	
	/*
	 * _applyTransforms - Applies the transforms that have been added to this notifier sequentially. See
	 * `addTransform` for more information.
	 *
	 * @param item - An item to be transformed
	 * @param callback - A function of type function(err, item) which will be called with a non-null
	 * error and a null item in the case of a transform failure, or a null error and non-null item after
	 * all transforms have been applied.
	 */
	Notifier.prototype._applyTransforms = function(item, callback) {
	  var transformIndex = -1;
	  var transformsLength = this.transforms.length;
	  var transforms = this.transforms;
	  var options = this.options;
	
	  var cb = function(err, i) {
	    if (err) {
	      callback(err, null);
	      return;
	    }
	
	    transformIndex++;
	
	    if (transformIndex === transformsLength) {
	      callback(null, i);
	      return;
	    }
	
	    transforms[transformIndex](i, options, cb);
	  };
	
	  cb(null, item);
	};
	
	module.exports = Notifier;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	
	var MAX_EVENTS = 100;
	
	function Telemeter(options) {
	  this.queue = [];
	  this.options = _.extend(true, {}, options);
	  var maxTelemetryEvents = this.options.maxTelemetryEvents || MAX_EVENTS;
	  this.maxQueueSize = Math.max(0, Math.min(maxTelemetryEvents, MAX_EVENTS));
	}
	
	Telemeter.prototype.copyEvents = function() {
	  return Array.prototype.slice.call(this.queue, 0);
	};
	
	Telemeter.prototype.capture = function(type, metadata, level, rollbarUUID, timestamp) {
	  var e = {
	    level: getLevel(type, level),
	    type: type,
	    timestamp_ms: timestamp || _.now(),
	    body: metadata,
	    source: 'client'
	  };
	  if (rollbarUUID) {
	    e.uuid = rollbarUUID;
	  }
	  this.push(e);
	  return e;
	};
	
	Telemeter.prototype.captureEvent = function(metadata, level, rollbarUUID) {
	  return this.capture('manual', metadata, level, rollbarUUID);
	};
	
	Telemeter.prototype.captureError = function(err, level, rollbarUUID, timestamp) {
	  var metadata = {
	    message: err.message || String(err)
	  };
	  if (err.stack) {
	    metadata.stack = err.stack;
	  }
	  return this.capture('error', metadata, level, rollbarUUID, timestamp);
	};
	
	Telemeter.prototype.captureLog = function(message, level, rollbarUUID, timestamp) {
	  return this.capture('log', {
	    message: message
	  }, level, rollbarUUID, timestamp);
	};
	
	Telemeter.prototype.captureNetwork = function(metadata, subtype, rollbarUUID) {
	  subtype = subtype || 'xhr';
	  metadata.subtype = metadata.subtype || subtype;
	  var level = this.levelFromStatus(metadata.status_code);
	  return this.capture('network', metadata, level, rollbarUUID);
	};
	
	Telemeter.prototype.levelFromStatus = function(statusCode) {
	  if (statusCode >= 200 && statusCode < 400) {
	    return 'info';
	  }
	  if (statusCode === 0 || statusCode >= 400) {
	    return 'error';
	  }
	  return 'info';
	};
	
	Telemeter.prototype.captureDom = function(subtype, element, value, checked, rollbarUUID) {
	  var metadata = {
	    subtype: subtype,
	    element: element
	  };
	  if (value !== undefined) {
	    metadata.value = value;
	  }
	  if (checked !== undefined) {
	    metadata.checked = checked;
	  }
	  return this.capture('dom', metadata, 'info', rollbarUUID);
	};
	
	Telemeter.prototype.captureNavigation = function(from, to, rollbarUUID) {
	  return this.capture('navigation', {from: from, to: to}, 'info', rollbarUUID);
	};
	
	Telemeter.prototype.captureDomContentLoaded = function(ts) {
	  return this.capture('navigation', {subtype: 'DOMContentLoaded'}, 'info', undefined, ts && ts.getTime());
	  /**
	   * If we decide to make this a dom event instead, then use the line below:
	  return this.capture('dom', {subtype: 'DOMContentLoaded'}, 'info', undefined, ts && ts.getTime());
	  */
	};
	Telemeter.prototype.captureLoad = function(ts) {
	  return this.capture('navigation', {subtype: 'load'}, 'info', undefined, ts && ts.getTime());
	  /**
	   * If we decide to make this a dom event instead, then use the line below:
	  return this.capture('dom', {subtype: 'load'}, 'info', undefined, ts && ts.getTime());
	  */
	};
	
	Telemeter.prototype.captureConnectivityChange = function(type, rollbarUUID) {
	  return this.captureNetwork({change: type}, 'connectivity', rollbarUUID);
	};
	
	// Only intended to be used internally by the notifier
	Telemeter.prototype._captureRollbarItem = function(item) {
	  if (item.err) {
	    return this.captureError(item.err, item.level, item.uuid, item.timestamp);
	  }
	  if (item.message) {
	    return this.captureLog(item.message, item.level, item.uuid, item.timestamp);
	  }
	  if (item.custom) {
	    return this.capture('log', item.custom, item.level, item.uuid, item.timestamp);
	  }
	};
	
	Telemeter.prototype.push = function(e) {
	  this.queue.push(e);
	  if (this.queue.length > this.maxQueueSize) {
	    this.queue.shift();
	  }
	};
	
	function getLevel(type, level) {
	  if (level) {
	    return level;
	  }
	  var defaultLevel = {
	    error: 'error',
	    manual: 'info'
	  };
	  return defaultLevel[type] || 'info';
	}
	
	module.exports = Telemeter;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	var helpers = __webpack_require__(12);
	
	var defaultOptions = {
	  hostname: 'api.rollbar.com',
	  path: '/api/1',
	  search: null,
	  version: '1',
	  protocol: 'https:',
	  port: 443
	};
	
	/**
	 * Api is an object that encapsulates methods of communicating with
	 * the Rollbar API.  It is a standard interface with some parts implemented
	 * differently for server or browser contexts.  It is an object that should
	 * be instantiated when used so it can contain non-global options that may
	 * be different for another instance of RollbarApi.
	 *
	 * @param options {
	 *    accessToken: the accessToken to use for posting items to rollbar
	 *    endpoint: an alternative endpoint to send errors to
	 *        must be a valid, fully qualified URL.
	 *        The default is: https://api.rollbar.com/api/1
	 *    proxy: if you wish to proxy requests provide an object
	 *        with the following keys:
	 *          host or hostname (required): foo.example.com
	 *          port (optional): 123
	 *          protocol (optional): https
	 * }
	 */
	function Api(options, t, u, j) {
	  this.options = options;
	  this.transport = t;
	  this.url = u;
	  this.jsonBackup = j;
	  this.accessToken = options.accessToken;
	  this.transportOptions = _getTransport(options, u);
	}
	
	/**
	 *
	 * @param data
	 * @param callback
	 */
	Api.prototype.postItem = function(data, callback) {
	  var transportOptions = helpers.transportOptions(this.transportOptions, '/item/', 'POST');
	  var payload = helpers.buildPayload(this.accessToken, data, this.jsonBackup);
	  this.transport.post(this.accessToken, transportOptions, payload, callback);
	};
	
	Api.prototype.configure = function(options) {
	  var oldOptions = this.oldOptions;
	  this.options = _.extend(true, {}, oldOptions, options);
	  this.transportOptions = _getTransport(this.options, this.url);
	  if (this.options.accessToken !== undefined) {
	    this.accessToken = this.options.accessToken;
	  }
	  return this;
	};
	
	function _getTransport(options, url) {
	  return helpers.getTransportFromOptions(options, defaultOptions, url);
	}
	
	module.exports = Api;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	
	function buildPayload(accessToken, data, jsonBackup) {
	  if (_.isType(data.context, 'object')) {
	    var contextResult = _.stringify(data.context, jsonBackup);
	    if (contextResult.error) {
	      data.context = 'Error: could not serialize \'context\'';
	    } else {
	      data.context = contextResult.value || '';
	    }
	    if (data.context.length > 255) {
	      data.context = data.context.substr(0, 255);
	    }
	  }
	  return {
	    access_token: accessToken,
	    data: data
	  };
	}
	
	function getTransportFromOptions(options, defaults, url) {
	  var hostname = defaults.hostname;
	  var protocol = defaults.protocol;
	  var port = defaults.port;
	  var path = defaults.path;
	  var search = defaults.search;
	
	  var proxy = options.proxy;
	  if (options.endpoint) {
	    var opts = url.parse(options.endpoint);
	    hostname = opts.hostname;
	    protocol = opts.protocol;
	    port = opts.port;
	    path = opts.pathname;
	    search = opts.search;
	  }
	  return {
	    hostname: hostname,
	    protocol: protocol,
	    port: port,
	    path: path,
	    search: search,
	    proxy: proxy
	  };
	}
	
	function transportOptions(transport, path, method) {
	  var protocol = transport.protocol || 'https:';
	  var port = transport.port || (protocol === 'http:' ? 80 : protocol === 'https:' ? 443 : undefined);
	  var hostname = transport.hostname;
	  path = appendPathToPath(transport.path, path);
	  if (transport.search) {
	    path = path + transport.search;
	  }
	  if (transport.proxy) {
	    path = protocol + '//' + hostname + path;
	    hostname = transport.proxy.host || transport.proxy.hostname;
	    port = transport.proxy.port;
	    protocol = transport.proxy.protocol || protocol;
	  }
	  return {
	    protocol: protocol,
	    hostname: hostname,
	    path: path,
	    port: port,
	    method: method
	  };
	}
	
	function appendPathToPath(base, path) {
	  var baseTrailingSlash = /\/$/.test(base);
	  var pathBeginningSlash = /^\//.test(path);
	
	  if (baseTrailingSlash && pathBeginningSlash) {
	    path = path.substring(1);
	  } else if (!baseTrailingSlash && !pathBeginningSlash) {
	    path = '/' + path;
	  }
	
	  return base + path;
	}
	
	module.exports = {
	  buildPayload: buildPayload,
	  getTransportFromOptions: getTransportFromOptions,
	  transportOptions: transportOptions,
	  appendPathToPath: appendPathToPath
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable no-console */
	__webpack_require__(14);
	var detection = __webpack_require__(15);
	var _ = __webpack_require__(6);
	
	function error() {
	  var args = Array.prototype.slice.call(arguments, 0);
	  args.unshift('Rollbar:');
	  if (detection.ieVersion() <= 8) {
	    console.error(_.formatArgsAsString(args));
	  } else {
	    console.error.apply(console, args);
	  }
	}
	
	function info() {
	  var args = Array.prototype.slice.call(arguments, 0);
	  args.unshift('Rollbar:');
	  if (detection.ieVersion() <= 8) {
	    console.info(_.formatArgsAsString(args));
	  } else {
	    console.info.apply(console, args);
	  }
	}
	
	function log() {
	  var args = Array.prototype.slice.call(arguments, 0);
	  args.unshift('Rollbar:');
	  if (detection.ieVersion() <= 8) {
	    console.log(_.formatArgsAsString(args));
	  } else {
	    console.log.apply(console, args);
	  }
	}
	
	/* eslint-enable no-console */
	
	module.exports = {
	  error: error,
	  info: info,
	  log: log
	};


/***/ },
/* 14 */
/***/ function(module, exports) {

	// Console-polyfill. MIT license.
	// https://github.com/paulmillr/console-polyfill
	// Make it safe to do console.log() always.
	(function(global) {
	  'use strict';
	  if (!global.console) {
	    global.console = {};
	  }
	  var con = global.console;
	  var prop, method;
	  var dummy = function() {};
	  var properties = ['memory'];
	  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
	     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
	     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
	  while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
	  while (method = methods.pop()) if (!con[method]) con[method] = dummy;
	  // Using `this` for web workers & supports Browserify / Webpack.
	})(typeof window === 'undefined' ? this : window);


/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	// This detection.js module is used to encapsulate any ugly browser/feature
	// detection we may need to do.
	
	// Figure out which version of IE we're using, if any.
	// This is gleaned from http://stackoverflow.com/questions/5574842/best-way-to-check-for-ie-less-than-9-in-javascript-without-library
	// Will return an integer on IE (i.e. 8)
	// Will return undefined otherwise
	function getIEVersion() {
		var undef;
		if (!document) {
			return undef;
		}
	
	  var v = 3,
	    div = document.createElement('div'),
	    all = div.getElementsByTagName('i');
	
	  while (
	    div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
	      all[0]
	    );
	
	  return v > 4 ? v : undef;
	}
	
	var Detection = {
	  ieVersion: getIEVersion
	};
	
	module.exports = Detection;


/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	function captureUncaughtExceptions(window, handler, shim) {
	  if (!window) { return; }
	  var oldOnError;
	
	  if (typeof handler._rollbarOldOnError === 'function') {
	    oldOnError = handler._rollbarOldOnError;
	  } else if (window.onerror && !window.onerror.belongsToShim) {
	    oldOnError = window.onerror;
	    handler._rollbarOldOnError = oldOnError;
	  }
	
	  var fn = function() {
	    var args = Array.prototype.slice.call(arguments, 0);
	    _rollbarWindowOnError(window, handler, oldOnError, args);
	  };
	  fn.belongsToShim = shim;
	  window.onerror = fn;
	}
	
	function _rollbarWindowOnError(window, r, old, args) {
	  if (window._rollbarWrappedError) {
	    if (!args[4]) {
	      args[4] = window._rollbarWrappedError;
	    }
	    if (!args[5]) {
	      args[5] = window._rollbarWrappedError._rollbarContext;
	    }
	    window._rollbarWrappedError = null;
	  }
	
	  r.handleUncaughtException.apply(r, args);
	  if (old) {
	    old.apply(window, args);
	  }
	}
	
	function captureUnhandledRejections(window, handler, shim) {
	  if (!window) { return; }
	
	  if (typeof window._rollbarURH === 'function' && window._rollbarURH.belongsToShim) {
	    window.removeEventListener('unhandledrejection', window._rollbarURH);
	  }
	
	  var rejectionHandler = function (event) {
	    var reason = event.reason;
	    var promise = event.promise;
	    var detail = event.detail;
	
	    if (!reason && detail) {
	      reason = detail.reason;
	      promise = detail.promise;
	    }
	
	    if (handler && handler.handleUnhandledRejection) {
	      handler.handleUnhandledRejection(reason, promise);
	    }
	  };
	  rejectionHandler.belongsToShim = shim;
	  window._rollbarURH = rejectionHandler;
	  window.addEventListener('unhandledrejection', rejectionHandler);
	}
	
	function wrapGlobals(window, handler, shim) {
	  if (!window) { return; }
	  // Adapted from https://github.com/bugsnag/bugsnag-js
	  var globals = 'EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload'.split(',');
	  var i, global;
	  for (i = 0; i < globals.length; ++i) {
	    global = globals[i];
	
	    if (window[global] && window[global].prototype) {
	      _extendListenerPrototype(handler, window[global].prototype, shim);
	    }
	  }
	}
	
	function _extendListenerPrototype(handler, prototype, shim) {
	  if (prototype.hasOwnProperty && prototype.hasOwnProperty('addEventListener')) {
	    var oldAddEventListener = prototype.addEventListener;
	    while (oldAddEventListener._rollbarOldAdd && oldAddEventListener.belongsToShim) {
	      oldAddEventListener = oldAddEventListener._rollbarOldAdd;
	    }
	    var addFn = function(event, callback, bubble) {
	      oldAddEventListener.call(this, event, handler.wrap(callback), bubble);
	    };
	    addFn._rollbarOldAdd = oldAddEventListener;
	    addFn.belongsToShim = shim;
	    prototype.addEventListener = addFn;
	
	    var oldRemoveEventListener = prototype.removeEventListener;
	    while (oldRemoveEventListener._rollbarOldRemove && oldRemoveEventListener.belongsToShim) {
	      oldRemoveEventListener = oldRemoveEventListener._rollbarOldRemove;
	    }
	    var removeFn = function(event, callback, bubble) {
	      oldRemoveEventListener.call(this, event, callback && callback._rollbar_wrapped || callback, bubble);
	    };
	    removeFn._rollbarOldRemove = oldRemoveEventListener;
	    removeFn.belongsToShim = shim;
	    prototype.removeEventListener = removeFn;
	  }
	}
	
	module.exports = {
	  captureUncaughtExceptions: captureUncaughtExceptions,
	  captureUnhandledRejections: captureUnhandledRejections,
	  wrapGlobals: wrapGlobals
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	var logger = __webpack_require__(13);
	
	/*
	 * accessToken may be embedded in payload but that should not
	 *   be assumed
	 *
	 * options: {
	 *   hostname
	 *   protocol
	 *   path
	 *   port
	 *   method
	 * }
	 *
	 *  params is an object containing key/value pairs. These
	 *    will be appended to the path as 'key=value&key=value'
	 *
	 * payload is an unserialized object
	 */
	
	function get(accessToken, options, params, callback, requestFactory) {
	  if (!callback || !_.isFunction(callback)) {
	    callback = function() {};
	  }
	  _.addParamsAndAccessTokenToPath(accessToken, options, params);
	
	  var method = 'GET';
	  var url = _.formatUrl(options);
	  _makeRequest(accessToken, url, method, null, callback, requestFactory);
	}
	
	function post(accessToken, options, payload, callback, requestFactory) {
	  if (!callback || !_.isFunction(callback)) {
	    callback = function() {};
	  }
	
	  if (!payload) {
	    return callback(new Error('Cannot send empty request'));
	  }
	
	  var stringifyResult = _.stringify(payload);
	  if (stringifyResult.error) {
	    return callback(stringifyResult.error);
	  }
	
	  var writeData = stringifyResult.value;
	  var method = 'POST';
	  var url = _.formatUrl(options);
	  _makeRequest(accessToken, url, method, writeData, callback, requestFactory);
	}
	
	function _makeRequest(accessToken, url, method, data, callback, requestFactory) {
	  var request;
	  if (requestFactory) {
	    request = requestFactory();
	  } else {
	    request = _createXMLHTTPObject();
	  }
	  if (!request) {
	    // Give up, no way to send requests
	    return callback(new Error('No way to send a request'));
	  }
	  try {
	    try {
	      var onreadystatechange = function() {
	        try {
	          if (onreadystatechange && request.readyState === 4) {
	            onreadystatechange = undefined;
	
	            var parseResponse = _.jsonParse(request.responseText);
	            if (_isSuccess(request)) {
	              callback(parseResponse.error, parseResponse.value);
	              return;
	            } else if (_isNormalFailure(request)) {
	              if (request.status === 403) {
	                // likely caused by using a server access token
	                var message = parseResponse.value && parseResponse.value.message;
	                logger.error(message);
	              }
	              // return valid http status codes
	              callback(new Error(String(request.status)));
	            } else {
	              // IE will return a status 12000+ on some sort of connection failure,
	              // so we return a blank error
	              // http://msdn.microsoft.com/en-us/library/aa383770%28VS.85%29.aspx
	              var msg = 'XHR response had no status code (likely connection failure)';
	              callback(_newRetriableError(msg));
	            }
	          }
	        } catch (ex) {
	          //jquery source mentions firefox may error out while accessing the
	          //request members if there is a network error
	          //https://github.com/jquery/jquery/blob/a938d7b1282fc0e5c52502c225ae8f0cef219f0a/src/ajax/xhr.js#L111
	          var exc;
	          if (ex && ex.stack) {
	            exc = ex;
	          } else {
	            exc = new Error(ex);
	          }
	          callback(exc);
	        }
	      };
	
	      request.open(method, url, true);
	      if (request.setRequestHeader) {
	        request.setRequestHeader('Content-Type', 'application/json');
	        request.setRequestHeader('X-Rollbar-Access-Token', accessToken);
	      }
	      request.onreadystatechange = onreadystatechange;
	      request.send(data);
	    } catch (e1) {
	      // Sending using the normal xmlhttprequest object didn't work, try XDomainRequest
	      if (typeof XDomainRequest !== 'undefined') {
	
	        // Assume we are in a really old browser which has a bunch of limitations:
	        // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	
	        // Extreme paranoia: if we have XDomainRequest then we have a window, but just in case
	        if (!window || !window.location) {
	          return callback(new Error('No window available during request, unknown environment'));
	        }
	
	        // If the current page is http, try and send over http
	        if (window.location.href.substring(0, 5) === 'http:' && url.substring(0, 5) === 'https') {
	          url = 'http' + url.substring(5);
	        }
	
	        var xdomainrequest = new XDomainRequest();
	        xdomainrequest.onprogress = function() {};
	        xdomainrequest.ontimeout = function() {
	          var msg = 'Request timed out';
	          var code = 'ETIMEDOUT';
	          callback(_newRetriableError(msg, code));
	        };
	        xdomainrequest.onerror = function() {
	          callback(new Error('Error during request'));
	        };
	        xdomainrequest.onload = function() {
	          var parseResponse = _.jsonParse(xdomainrequest.responseText);
	          callback(parseResponse.error, parseResponse.value);
	        };
	        xdomainrequest.open(method, url, true);
	        xdomainrequest.send(data);
	      } else {
	        callback(new Error('Cannot find a method to transport a request'));
	      }
	    }
	  } catch (e2) {
	    callback(e2);
	  }
	}
	
	function _createXMLHTTPObject() {
	  /* global ActiveXObject:false */
	
	  var factories = [
	    function () {
	      return new XMLHttpRequest();
	    },
	    function () {
	      return new ActiveXObject('Msxml2.XMLHTTP');
	    },
	    function () {
	      return new ActiveXObject('Msxml3.XMLHTTP');
	    },
	    function () {
	      return new ActiveXObject('Microsoft.XMLHTTP');
	    }
	  ];
	  var xmlhttp;
	  var i;
	  var numFactories = factories.length;
	  for (i = 0; i < numFactories; i++) {
	    /* eslint-disable no-empty */
	    try {
	      xmlhttp = factories[i]();
	      break;
	    } catch (e) {
	      // pass
	    }
	    /* eslint-enable no-empty */
	  }
	  return xmlhttp;
	}
	
	function _isSuccess(r) {
	  return r && r.status && r.status === 200;
	}
	
	function _isNormalFailure(r) {
	  return r && _.isType(r.status, 'number') && r.status >= 400 && r.status < 600;
	}
	
	function _newRetriableError(message, code) {
	  var err = new Error(message);
	  err.code = code || 'ENOTFOUND';
	  return err;
	}
	
	module.exports = {
	  get: get,
	  post: post
	};


/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	// See https://nodejs.org/docs/latest/api/url.html
	function parse(url) {
	  var result = {
	    protocol: null, auth: null, host: null, path: null,
	    hash: null, href: url, hostname: null, port: null,
	    pathname: null, search: null, query: null
	  };
	
	  var i, last;
	  i = url.indexOf('//');
	  if (i !== -1) {
	    result.protocol = url.substring(0,i);
	    last = i+2;
	  } else {
	    last = 0;
	  }
	  
	  i = url.indexOf('@', last);
	  if (i !== -1) {
	    result.auth = url.substring(last, i);
	    last = i+1;
	  }
	
	  i = url.indexOf('/', last);
	  if (i === -1) {
	    i = url.indexOf('?', last);
	    if (i === -1) {
	      i = url.indexOf('#', last);
	      if (i === -1) {
	        result.host = url.substring(last);
	      } else {
	        result.host = url.substring(last, i);
	        result.hash = url.substring(i);
	      }
	      result.hostname = result.host.split(':')[0];
	      result.port = result.host.split(':')[1];
	      if (result.port) {
	        result.port = parseInt(result.port, 10);
	      }
	      return result;
	    } else {
	      result.host = url.substring(last, i);
	      result.hostname = result.host.split(':')[0];
	      result.port = result.host.split(':')[1];
	      if (result.port) {
	        result.port = parseInt(result.port, 10);
	      }
	      last = i;
	    }
	  } else {
	    result.host = url.substring(last, i);
	    result.hostname = result.host.split(':')[0];
	    result.port = result.host.split(':')[1];
	    if (result.port) {
	      result.port = parseInt(result.port, 10);
	    }
	    last = i;
	  }
	
	  i = url.indexOf('#', last);
	  if (i === -1) {
	    result.path = url.substring(last);
	  } else {
	    result.path = url.substring(last, i);
	    result.hash = url.substring(i);
	  }
	
	  if (result.path) {
	    var pathParts = result.path.split('?');
	    result.pathname = pathParts[0];
	    result.query = pathParts[1];
	    result.search = result.query ? '?' + result.query : null;
	  }
	  return result;
	}
	
	module.exports = {
	  parse: parse
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	var errorParser = __webpack_require__(20);
	var logger = __webpack_require__(13);
	
	function handleItemWithError(item, options, callback) {
	  item.data = item.data || {};
	  if (item.err) {
	    try {
	      item.stackInfo = item.err._savedStackTrace || errorParser.parse(item.err);
	    } catch (e)
	    /* istanbul ignore next */
	    {
	      logger.error('Error while parsing the error object.', e);
	      item.message = item.err.message || item.err.description || item.message || String(item.err);
	      delete item.err;
	    }
	  }
	  callback(null, item);
	}
	
	function ensureItemHasSomethingToSay(item, options, callback) {
	  if (!item.message && !item.stackInfo && !item.custom) {
	    callback(new Error('No message, stack info, or custom data'), null);
	  }
	  callback(null, item);
	}
	
	function addBaseInfo(item, options, callback) {
	  var environment = (options.payload && options.payload.environment) || options.environment;
	  item.data = _.extend(true, {}, item.data, {
	    environment: environment,
	    level: item.level,
	    endpoint: options.endpoint,
	    platform: 'browser',
	    framework: 'browser-js',
	    language: 'javascript',
	    server: {},
	    uuid: item.uuid,
	    notifier: {
	      name: 'rollbar-browser-js',
	      version: options.version
	    }
	  });
	  callback(null, item);
	}
	
	function addRequestInfo(window) {
	  return function(item, options, callback) {
	    if (!window || !window.location) {
	      return callback(null, item);
	    }
	    _.set(item, 'data.request', {
	      url: window.location.href,
	      query_string: window.location.search,
	      user_ip: '$remote_ip'
	    });
	    callback(null, item);
	  };
	}
	
	function addClientInfo(window) {
	  return function(item, options, callback) {
	    if (!window) {
	      return callback(null, item);
	    }
	    _.set(item, 'data.client', {
	      runtime_ms: item.timestamp - window._rollbarStartTime,
	      timestamp: Math.round(item.timestamp / 1000),
	      javascript: {
	        browser: window.navigator.userAgent,
	        language: window.navigator.language,
	        cookie_enabled: window.navigator.cookieEnabled,
	        screen: {
	          width: window.screen.width,
	          height: window.screen.height
	        }
	      }
	    });
	    callback(null, item);
	  };
	}
	
	function addPluginInfo(window) {
	  return function(item, options, callback) {
	    if (!window || !window.navigator) {
	      return callback(null, item);
	    }
	    var plugins = [];
	    var navPlugins = window.navigator.plugins || [];
	    var cur;
	    for (var i=0, l=navPlugins.length; i < l; ++i) {
	      cur = navPlugins[i];
	      plugins.push({name: cur.name, description: cur.description});
	    }
	    _.set(item, 'data.client.javascript.plugins', plugins);
	    callback(null, item);
	  };
	}
	
	function addBody(item, options, callback) {
	  if (item.stackInfo) {
	    addBodyTrace(item, options, callback);
	  } else {
	    addBodyMessage(item, options, callback);
	  }
	}
	
	function addBodyMessage(item, options, callback) {
	  var message = item.message;
	  var custom = item.custom;
	
	  if (!message) {
	    if (custom) {
	      var scrubFields = options.scrubFields;
	      var messageResult = _.stringify(_.scrub(custom, scrubFields));
	      message = messageResult.error || messageResult.value || '';
	    } else {
	      message = '';
	    }
	  }
	  var result = {
	    body: message
	  };
	
	  if (custom) {
	    result.extra = _.extend(true, {}, custom);
	  }
	
	  _.set(item, 'data.body', {message: result});
	  callback(null, item);
	}
	
	
	function addBodyTrace(item, options, callback) {
	  var description = item.data.description;
	  var stackInfo = item.stackInfo;
	  var custom = item.custom;
	
	  var guess = errorParser.guessErrorClass(stackInfo.message);
	  var className = stackInfo.name || guess[0];
	  var message = guess[1];
	  var trace = {
	    exception: {
	      'class': className,
	      message: message
	    }
	  };
	
	  if (description) {
	    trace.exception.description = description;
	  }
	
	  // Transform a TraceKit stackInfo object into a Rollbar trace
	  var stack = stackInfo.stack;
	  if (stack && stack.length === 0 && item._unhandledStackInfo && item._unhandledStackInfo.stack) {
	    stack = item._unhandledStackInfo.stack;
	  }
	  if (stack) {
	    var stackFrame;
	    var frame;
	    var code;
	    var pre;
	    var post;
	    var contextLength;
	    var i, mid;
	
	    trace.frames = [];
	    for (i = 0; i < stack.length; ++i) {
	      stackFrame = stack[i];
	      frame = {
	        filename: stackFrame.url ? _.sanitizeUrl(stackFrame.url) : '(unknown)',
	        lineno: stackFrame.line || null,
	        method: (!stackFrame.func || stackFrame.func === '?') ? '[anonymous]' : stackFrame.func,
	        colno: stackFrame.column
	      };
	      if (frame.method && frame.method.endsWith && frame.method.endsWith('._rollbar_wrapped')) {
	        continue;
	      }
	
	      code = pre = post = null;
	      contextLength = stackFrame.context ? stackFrame.context.length : 0;
	      if (contextLength) {
	        mid = Math.floor(contextLength / 2);
	        pre = stackFrame.context.slice(0, mid);
	        code = stackFrame.context[mid];
	        post = stackFrame.context.slice(mid);
	      }
	
	      if (code) {
	        frame.code = code;
	      }
	
	      if (pre || post) {
	        frame.context = {};
	        if (pre && pre.length) {
	          frame.context.pre = pre;
	        }
	        if (post && post.length) {
	          frame.context.post = post;
	        }
	      }
	
	      if (stackFrame.args) {
	        frame.args = stackFrame.args;
	      }
	
	      trace.frames.push(frame);
	    }
	
	    // NOTE(cory): reverse the frames since rollbar.com expects the most recent call last
	    trace.frames.reverse();
	
	    if (custom) {
	      trace.extra = _.extend(true, {}, custom);
	    }
	    _.set(item, 'data.body', {trace: trace});
	    callback(null, item);
	  } else {
	    item.message = className + ': ' + message;
	    addBodyMessage(item, options, callback);
	  }
	}
	
	function scrubPayload(item, options, callback) {
	  var scrubFields = options.scrubFields;
	  _.scrub(item.data, scrubFields);
	  callback(null, item);
	}
	
	function userTransform(item, options, callback) {
	  var newItem = _.extend(true, {}, item);
	  try {
	    if (_.isFunction(options.transform)) {
	      options.transform(newItem.data);
	    }
	  } catch (e) {
	    options.transform = null;
	    logger.error('Error while calling custom transform() function. Removing custom transform().', e);
	    callback(null, item);
	    return;
	  }
	  callback(null, newItem);
	}
	
	module.exports = {
	  handleItemWithError: handleItemWithError,
	  ensureItemHasSomethingToSay: ensureItemHasSomethingToSay,
	  addBaseInfo: addBaseInfo,
	  addRequestInfo: addRequestInfo,
	  addClientInfo: addClientInfo,
	  addPluginInfo: addPluginInfo,
	  addBody: addBody,
	  scrubPayload: scrubPayload,
	  userTransform: userTransform
	};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ErrorStackParser = __webpack_require__(21);
	
	var UNKNOWN_FUNCTION = '?';
	var ERR_CLASS_REGEXP = new RegExp('^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ');
	
	function guessFunctionName() {
	  return UNKNOWN_FUNCTION;
	}
	
	
	function gatherContext() {
	  return null;
	}
	
	
	function Frame(stackFrame) {
	  var data = {};
	
	  data._stackFrame = stackFrame;
	
	  data.url = stackFrame.fileName;
	  data.line = stackFrame.lineNumber;
	  data.func = stackFrame.functionName;
	  data.column = stackFrame.columnNumber;
	  data.args = stackFrame.args;
	
	  data.context = gatherContext(data.url, data.line);
	
	  return data;
	}
	
	
	function Stack(exception) {
	  function getStack() {
	    var parserStack = [];
	
	    try {
	      parserStack = ErrorStackParser.parse(exception);
	    } catch(e) {
	      parserStack = [];
	    }
	
	    var stack = [];
	
	    for (var i = 0; i < parserStack.length; i++) {
	      stack.push(new Frame(parserStack[i]));
	    }
	
	    return stack;
	  }
	
	  return {
	    stack: getStack(),
	    message: exception.message,
	    name: exception.name
	  };
	}
	
	
	function parse(e) {
	  return new Stack(e);
	}
	
	
	function guessErrorClass(errMsg) {
	  if (!errMsg) {
	    return ['Unknown error. There was no error message to display.', ''];
	  }
	  var errClassMatch = errMsg.match(ERR_CLASS_REGEXP);
	  var errClass = '(unknown)';
	
	  if (errClassMatch) {
	    errClass = errClassMatch[errClassMatch.length - 1];
	    errMsg = errMsg.replace((errClassMatch[errClassMatch.length - 2] || '') + errClass + ':', '');
	    errMsg = errMsg.replace(/(^[\s]+|[\s]+$)/g, '');
	  }
	  return [errClass, errMsg];
	}
	
	
	module.exports = {
	  guessFunctionName: guessFunctionName,
	  guessErrorClass: guessErrorClass,
	  gatherContext: gatherContext,
	  parse: parse,
	  Stack: Stack,
	  Frame: Frame
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(22)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('stackframe'));
	    } else {
	        root.ErrorStackParser = factory(root.StackFrame);
	    }
	}(this, function ErrorStackParser(StackFrame) {
	    'use strict';
	
	    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
	    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
	    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
	
	    function _map(array, fn, thisArg) {
	        if (typeof Array.prototype.map === 'function') {
	            return array.map(fn, thisArg);
	        } else {
	            var output = new Array(array.length);
	            for (var i = 0; i < array.length; i++) {
	                output[i] = fn.call(thisArg, array[i]);
	            }
	            return output;
	        }
	    }
	
	    function _filter(array, fn, thisArg) {
	        if (typeof Array.prototype.filter === 'function') {
	            return array.filter(fn, thisArg);
	        } else {
	            var output = [];
	            for (var i = 0; i < array.length; i++) {
	                if (fn.call(thisArg, array[i])) {
	                    output.push(array[i]);
	                }
	            }
	            return output;
	        }
	    }
	
	    return {
	        /**
	         * Given an Error object, extract the most information from it.
	         * @param error {Error}
	         * @return Array[StackFrame]
	         */
	        parse: function ErrorStackParser$$parse(error) {
	            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
	                return this.parseOpera(error);
	            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
	                return this.parseV8OrIE(error);
	            } else if (error.stack) {
	                return this.parseFFOrSafari(error);
	            } else {
	                throw new Error('Cannot parse given Error object');
	            }
	        },
	
	        /**
	         * Separate line and column numbers from a URL-like string.
	         * @param urlLike String
	         * @return Array[String]
	         */
	        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
	            // Fail-fast but return locations like "(native)"
	            if (urlLike.indexOf(':') === -1) {
	                return [urlLike];
	            }
	
	            var locationParts = urlLike.replace(/[\(\)\s]/g, '').split(':');
	            var lastNumber = locationParts.pop();
	            var possibleNumber = locationParts[locationParts.length - 1];
	            if (!isNaN(parseFloat(possibleNumber)) && isFinite(possibleNumber)) {
	                var lineNumber = locationParts.pop();
	                return [locationParts.join(':'), lineNumber, lastNumber];
	            } else {
	                return [locationParts.join(':'), lastNumber, undefined];
	            }
	        },
	
	        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
	            var filtered = _filter(error.stack.split('\n'), function (line) {
	                return !!line.match(CHROME_IE_STACK_REGEXP);
	            }, this);
	
	            return _map(filtered, function (line) {
	                if (line.indexOf('(eval ') > -1) {
	                    // Throw away eval information until we implement stacktrace.js/stackframe#8
	                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
	                }
	                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionName = tokens.join(' ') || undefined;
	                var fileName = locationParts[0] === 'eval' ? undefined : locationParts[0];
	
	                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
	            }, this);
	        },
	
	        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
	            var filtered = _filter(error.stack.split('\n'), function (line) {
	                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
	            }, this);
	
	            return _map(filtered, function (line) {
	                // Throw away eval information until we implement stacktrace.js/stackframe#8
	                if (line.indexOf(' > eval') > -1) {
	                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
	                }
	
	                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
	                    // Safari eval frames only have function names and nothing else
	                    return new StackFrame(line);
	                } else {
	                    var tokens = line.split('@');
	                    var locationParts = this.extractLocation(tokens.pop());
	                    var functionName = tokens.shift() || undefined;
	                    return new StackFrame(functionName, undefined, locationParts[0], locationParts[1], locationParts[2], line);
	                }
	            }, this);
	        },
	
	        parseOpera: function ErrorStackParser$$parseOpera(e) {
	            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
	                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
	                return this.parseOpera9(e);
	            } else if (!e.stack) {
	                return this.parseOpera10(e);
	            } else {
	                return this.parseOpera11(e);
	            }
	        },
	
	        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
	            var lines = e.message.split('\n');
	            var result = [];
	
	            for (var i = 2, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
	                }
	            }
	
	            return result;
	        },
	
	        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
	            var lines = e.stacktrace.split('\n');
	            var result = [];
	
	            for (var i = 0, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(new StackFrame(match[3] || undefined, undefined, match[2], match[1], undefined, lines[i]));
	                }
	            }
	
	            return result;
	        },
	
	        // Opera 10.65+ Error.stack very similar to FF/Safari
	        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
	            var filtered = _filter(error.stack.split('\n'), function (line) {
	                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) &&
	                    !line.match(/^Error created at/);
	            }, this);
	
	            return _map(filtered, function (line) {
	                var tokens = line.split('@');
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionCall = (tokens.shift() || '');
	                var functionName = functionCall
	                        .replace(/<anonymous function(: (\w+))?>/, '$2')
	                        .replace(/\([^\)]*\)/g, '') || undefined;
	                var argsRaw;
	                if (functionCall.match(/\(([^\)]*)\)/)) {
	                    argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
	                }
	                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ? undefined : argsRaw.split(',');
	                return new StackFrame(functionName, args, locationParts[0], locationParts[1], locationParts[2], line);
	            }, this);
	        }
	    };
	}));
	


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.StackFrame = factory();
	    }
	}(this, function () {
	    'use strict';
	    function _isNumber(n) {
	        return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
	        if (functionName !== undefined) {
	            this.setFunctionName(functionName);
	        }
	        if (args !== undefined) {
	            this.setArgs(args);
	        }
	        if (fileName !== undefined) {
	            this.setFileName(fileName);
	        }
	        if (lineNumber !== undefined) {
	            this.setLineNumber(lineNumber);
	        }
	        if (columnNumber !== undefined) {
	            this.setColumnNumber(columnNumber);
	        }
	        if (source !== undefined) {
	            this.setSource(source);
	        }
	    }
	
	    StackFrame.prototype = {
	        getFunctionName: function () {
	            return this.functionName;
	        },
	        setFunctionName: function (v) {
	            this.functionName = String(v);
	        },
	
	        getArgs: function () {
	            return this.args;
	        },
	        setArgs: function (v) {
	            if (Object.prototype.toString.call(v) !== '[object Array]') {
	                throw new TypeError('Args must be an Array');
	            }
	            this.args = v;
	        },
	
	        // NOTE: Property name may be misleading as it includes the path,
	        // but it somewhat mirrors V8's JavaScriptStackTraceApi
	        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
	        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
	        getFileName: function () {
	            return this.fileName;
	        },
	        setFileName: function (v) {
	            this.fileName = String(v);
	        },
	
	        getLineNumber: function () {
	            return this.lineNumber;
	        },
	        setLineNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Line Number must be a Number');
	            }
	            this.lineNumber = Number(v);
	        },
	
	        getColumnNumber: function () {
	            return this.columnNumber;
	        },
	        setColumnNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Column Number must be a Number');
	            }
	            this.columnNumber = Number(v);
	        },
	
	        getSource: function () {
	            return this.source;
	        },
	        setSource: function (v) {
	            this.source = String(v);
	        },
	
	        toString: function() {
	            var functionName = this.getFunctionName() || '{anonymous}';
	            var args = '(' + (this.getArgs() || []).join(',') + ')';
	            var fileName = this.getFileName() ? ('@' + this.getFileName()) : '';
	            var lineNumber = _isNumber(this.getLineNumber()) ? (':' + this.getLineNumber()) : '';
	            var columnNumber = _isNumber(this.getColumnNumber()) ? (':' + this.getColumnNumber()) : '';
	            return functionName + args + fileName + lineNumber + columnNumber;
	        }
	    };
	
	    return StackFrame;
	}));


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	
	function itemToPayload(item, options, callback) {
	  var payloadOptions = options.payload || {};
	  if (payloadOptions.body) {
	    delete payloadOptions.body;
	  }
	
	  var data = _.extend(true, {}, item.data, payloadOptions);
	  if (item._isUncaught) {
	    data._isUncaught = true;
	  }
	  callback(null, data);
	}
	
	function addTelemetryData(item, options, callback) {
	  if (item.telemetryEvents) {
	    _.set(item, 'data.body.telemetry', item.telemetryEvents);
	  }
	  callback(null, item);
	}
	
	function addMessageWithError(item, options, callback) {
	  if (!item.message) {
	    callback(null, item);
	    return;
	  }
	  var tracePath = 'data.body.trace_chain.0';
	  var trace = _.get(item, tracePath);
	  if (!trace) {
	    tracePath = 'data.body.trace';
	    trace = _.get(item, tracePath);
	  }
	  if (trace) {
	    if (!(trace.exception && trace.exception.description)) {
	      _.set(item, tracePath+'.exception.description', item.message);
	      callback(null, item);
	      return;
	    }
	    var extra = _.get(item, tracePath+'.extra') || {};
	    var newExtra =  _.extend(true, {}, extra, {message: item.message});
	    _.set(item, tracePath+'.extra', newExtra);
	  }
	  callback(null, item);
	}
	
	module.exports = {
	  itemToPayload: itemToPayload,
	  addTelemetryData: addTelemetryData,
	  addMessageWithError: addMessageWithError
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	var logger = __webpack_require__(13);
	
	function checkIgnore(item, settings) {
	  var level = item.level;
	  var levelVal = _.LEVELS[level] || 0;
	  var reportLevel = _.LEVELS[settings.reportLevel] || 0;
	
	  if (levelVal < reportLevel) {
	    return false;
	  }
	
	  if (_.get(settings, 'plugins.jquery.ignoreAjaxErrors')) {
	    return !_.get(item, 'body.message.extra.isAjax');
	  }
	  return true;
	}
	
	function userCheckIgnore(item, settings) {
	  var isUncaught = !!item._isUncaught;
	  delete item._isUncaught;
	  var args = item._originalArgs;
	  delete item._originalArgs;
	  try {
	    if (_.isFunction(settings.checkIgnore) && settings.checkIgnore(isUncaught, args, item)) {
	      return false;
	    }
	  } catch (e) {
	    settings.checkIgnore = null;
	    logger.error('Error while calling custom checkIgnore(), removing', e);
	  }
	  return true;
	}
	
	function urlIsBlacklisted(item, settings) {
	  return urlIsOnAList(item, settings, 'blacklist');
	}
	
	function urlIsWhitelisted(item, settings) {
	  return urlIsOnAList(item, settings, 'whitelist');
	}
	
	function urlIsOnAList(item, settings, whiteOrBlack) {
	  // whitelist is the default
	  var black = false;
	  if (whiteOrBlack === 'blacklist') {
	    black = true;
	  }
	  var list, trace, frame, filename, frameLength, url, listLength, urlRegex;
	  var i, j;
	
	  try {
	    list = black ? settings.hostBlackList : settings.hostWhiteList;
	    listLength = list && list.length;
	    trace = _.get(item, 'body.trace');
	
	    // These two checks are important to come first as they are defaults
	    // in case the list is missing or the trace is missing or not well-formed
	    if (!list || listLength === 0) {
	      return true;
	    }
	    if (!trace || !trace.frames) {
	      return true;
	    }
	
	    frameLength = trace.frames.length;
	    for (i = 0; i < frameLength; i++) {
	      frame = trace.frames[i];
	      filename = frame.filename;
	
	      if (!_.isType(filename, 'string')) {
	        return true;
	      }
	
	      for (j = 0; j < listLength; j++) {
	        url = list[j];
	        urlRegex = new RegExp(url);
	
	        if (urlRegex.test(filename)){
	          return !black;
	        }
	      }
	    }
	  } catch (e)
	  /* istanbul ignore next */
	  {
	    if (black) {
	      settings.hostBlackList = null;
	    } else {
	      settings.hostWhiteList = null;
	    }
	    var listName = black ? 'hostBlackList' : 'hostWhiteList';
	    logger.error('Error while reading your configuration\'s ' + listName + ' option. Removing custom ' + listName + '.', e);
	    return true;
	  }
	  return black;
	}
	
	function messageIsIgnored(item, settings) {
	  var exceptionMessage, i, ignoredMessages,
	      len, messageIsIgnored, rIgnoredMessage,
	      body, traceMessage, bodyMessage;
	
	  try {
	    messageIsIgnored = false;
	    ignoredMessages = settings.ignoredMessages;
	
	    if (!ignoredMessages || ignoredMessages.length === 0) {
	      return true;
	    }
	
	    body = item.body;
	    traceMessage = _.get(body, 'trace.exception.message');
	    bodyMessage = _.get(body, 'message.body');
	
	    exceptionMessage = traceMessage || bodyMessage;
	
	    if (!exceptionMessage){
	      return true;
	    }
	
	    len = ignoredMessages.length;
	    for (i = 0; i < len; i++) {
	      rIgnoredMessage = new RegExp(ignoredMessages[i], 'gi');
	      messageIsIgnored = rIgnoredMessage.test(exceptionMessage);
	
	      if (messageIsIgnored) {
	        break;
	      }
	    }
	  } catch(e)
	  /* istanbul ignore next */
	  {
	    settings.ignoredMessages = null;
	    logger.error('Error while reading your configuration\'s ignoredMessages option. Removing custom ignoredMessages.');
	  }
	
	  return !messageIsIgnored;
	}
	
	module.exports = {
	  checkIgnore: checkIgnore,
	  userCheckIgnore: userCheckIgnore,
	  urlIsBlacklisted: urlIsBlacklisted,
	  urlIsWhitelisted: urlIsWhitelisted,
	  messageIsIgnored: messageIsIgnored
	};
	


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	var urlparser = __webpack_require__(18);
	
	var defaults = {
	  network: true,
	  log: true,
	  dom: true,
	  navigation: true,
	  connectivity: true
	};
	
	function replace(obj, name, replacement, replacements) {
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  if (replacements) {
	    replacements.push([obj, name, orig]);
	  }
	}
	
	function restore(replacements) {
	  var b;
	  while (replacements.length) {
	    b = replacements.shift();
	    b[0][b[1]] = b[2];
	  }
	}
	
	function Instrumenter(options, telemeter, rollbar, _window, _document) {
	  var autoInstrument = options.autoInstrument;
	  if (autoInstrument === false) {
	    this.autoInstrument = {};
	    return;
	  }
	  if (!_.isType(autoInstrument, 'object')) {
	    autoInstrument = defaults;
	  }
	  this.autoInstrument = _.extend(true, {}, defaults, autoInstrument);
	  this.telemeter = telemeter;
	  this.rollbar = rollbar;
	  this._window = _window || {};
	  this._document = _document || {};
	  this.replacements = [];
	
	  this._location = this._window.location;
	  this._lastHref = this._location && this._location.href;
	}
	
	Instrumenter.prototype.instrument = function() {
	  if (this.autoInstrument.network) {
	    this.instrumentNetwork();
	  }
	
	  if (this.autoInstrument.log) {
	    this.instrumentConsole();
	  }
	
	  if (this.autoInstrument.dom) {
	    this.instrumentDom();
	  }
	
	  if (this.autoInstrument.navigation) {
	    this.instrumentNavigation();
	  }
	
	  if (this.autoInstrument.connectivity) {
	    this.instrumentConnectivity();
	  }
	};
	
	Instrumenter.prototype.instrumentNetwork = function() {
	  var self = this;
	
	  function wrapProp(prop, xhr) {
	    if (prop in xhr && _.isFunction(xhr[prop])) {
	      replace(xhr, prop, function(orig) {
	        return self.rollbar.wrap(orig);
	      }, self.replacements);
	    }
	  }
	
	  if ('XMLHttpRequest' in this._window) {
	    var xhrp = this._window.XMLHttpRequest.prototype;
	    replace(xhrp, 'open', function(orig) {
	      return function(method, url) {
	        if (_.isType(url, 'string')) {
	          this.__rollbar_xhr = {
	            method: method,
	            url: url,
	            status_code: null,
	            start_time_ms: _.now(),
	            end_time_ms: null
	          };
	        }
	        return orig.apply(this, arguments);
	      };
	    }, this.replacements);
	
	    replace(xhrp, 'send', function(orig) {
	      /* eslint-disable no-unused-vars */
	      return function(data) {
	      /* eslint-enable no-unused-vars */
	        var xhr = this;
	
	        function onreadystatechangeHandler() {
	          if (xhr.__rollbar_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
	            if (xhr.__rollbar_xhr.status_code === null) {
	              xhr.__rollbar_xhr.status_code = 0;
	              xhr.__rollbar_event = self.telemeter.captureNetwork(xhr.__rollbar_xhr, 'xhr');
	            }
	            if (xhr.readyState === 1) {
	              xhr.__rollbar_xhr.start_time_ms = _.now();
	            } else {
	              xhr.__rollbar_xhr.end_time_ms = _.now();
	            }
	            try {
	              var code = xhr.status;
	              code = code === 1223 ? 204 : code;
	              xhr.__rollbar_xhr.status_code = code;
	              xhr.__rollbar_event.level = self.telemeter.levelFromStatus(code);
	            } catch (e) {
	              /* ignore possible exception from xhr.status */
	            }
	          }
	        }
	
	        wrapProp('onload', xhr);
	        wrapProp('onerror', xhr);
	        wrapProp('onprogress', xhr);
	
	        if ('onreadystatechange' in xhr && _.isFunction(xhr.onreadystatechange)) {
	          replace(xhr, 'onreadystatechange', function(orig) {
	            return self.rollbar.wrap(orig, undefined, onreadystatechangeHandler);
	          });
	        } else {
	          xhr.onreadystatechange = onreadystatechangeHandler;
	        }
	        return orig.apply(this, arguments);
	      }
	    }, this.replacements);
	  }
	
	  if ('fetch' in this._window) {
	    replace(this._window, 'fetch', function(orig) {
	      /* eslint-disable no-unused-vars */
	      return function(fn, t) {
	      /* eslint-enable no-unused-vars */
	        var args = new Array(arguments.length);
	        for (var i=0, len=args.length; i < len; i++) {
	          args[i] = arguments[i];
	        }
	        var input = args[0];
	        var method = 'GET';
	        var url;
	        if (_.isType(input, 'string')) {
	          url = input;
	        } else {
	          url = input.url;
	          if (input.method) {
	            method = input.method;
	          }
	        }
	        if (args[1] && args[1].method) {
	          method = args[1].method;
	        }
	        var metadata = {
	          method: method,
	          url: url,
	          status_code: null,
	          start_time_ms: _.now(),
	          end_time_ms: null
	        };
	        self.telemeter.captureNetwork(metadata, 'fetch');
	        return orig.apply(this, args).then(function (resp) {
	          metadata.end_time_ms = _.now();
	          metadata.status_code = resp.status;
	          return resp;
	        });
	      };
	    }, this.replacements);
	  }
	};
	
	Instrumenter.prototype.instrumentConsole = function() {
	  if (!('console' in this._window && this._window.console.log)) {
	    return;
	  }
	
	  var self = this;
	  var c = this._window.console;
	
	  function wrapConsole(method) {
	    var orig = c[method];
	    var origConsole = c;
	    var level = method === 'warn' ? 'warning' : method;
	    c[method] = function() {
	      var args = Array.prototype.slice.call(arguments);
	      var message = _.formatArgsAsString(args);
	      self.telemeter.captureLog(message, level);
	      if (orig) {
	        Function.prototype.apply.call(orig, origConsole, args);
	      }
	    };
	  }
	  var methods = ['debug','info','warn','error','log'];
	  for (var i=0, len=methods.length; i < len; i++) {
	    wrapConsole(methods[i]);
	  }
	};
	
	Instrumenter.prototype.instrumentDom = function() {
	  if (!('addEventListener' in this._window || 'attachEvent' in this._window)) {
	    return;
	  }
	  var clickHandler = this.handleClick.bind(this);
	  var blurHandler = this.handleBlur.bind(this);
	  if (this._window.addEventListener) {
	    this._window.addEventListener('click', clickHandler, true);
	    this._window.addEventListener('blur', blurHandler, true);
	  } else {
	    this._window.attachEvent('click', clickHandler);
	    this._window.attachEvent('onfocusout', blurHandler);
	  }
	};
	
	Instrumenter.prototype.handleClick = function(evt) {
	  try {
	    var e = getElementFromEvent(evt, this._document);
	    var hasTag = e && e.tagName;
	    var anchorOrButton = isDescribedElement(e, 'a') || isDescribedElement(e, 'button');
	    if (hasTag && (anchorOrButton || isDescribedElement(e, 'input', ['button', 'submit']))) {
	        this.captureDomEvent('click', e);
	    } else if (isDescribedElement(e, 'input', ['checkbox', 'radio'])) {
	      this.captureDomEvent('input', e, e.value, e.checked);
	    }
	  } catch (exc) {
	    // TODO: Not sure what to do here
	  }
	};
	
	Instrumenter.prototype.handleBlur = function(evt) {
	  try {
	    var e = getElementFromEvent(evt, this._document);
	    if (e && e.tagName) {
	      if (isDescribedElement(e, 'textarea')) {
	        this.captureDomEvent('input', e, e.value);
	      } else if (isDescribedElement(e, 'select') && e.options && e.options.length) {
	        this.handleSelectInputChanged(e);
	      } else if (isDescribedElement(e, 'input') && !isDescribedElement(e, 'input', ['button', 'submit', 'hidden', 'checkbox', 'radio'])) {
	        this.captureDomEvent('input', e, e.value);
	      }
	    }
	  } catch (exc) {
	    // TODO: Not sure what to do here
	  }
	};
	
	Instrumenter.prototype.handleSelectInputChanged = function(elem) {
	  if (elem.multiple) {
	    for (var i = 0; i < elem.options.length; i++) {
	      if (elem.options[i].selected) {
	        this.captureDomEvent('input', elem, elem.options[i].value);
	      }
	    }
	  } else if (elem.selectedIndex >= 0 && elem.options[elem.selectedIndex]) {
	    this.captureDomEvent('input', elem, elem.options[elem.selectedIndex].value);
	  }
	};
	
	Instrumenter.prototype.captureDomEvent = function(subtype, element, value, isChecked) {
	  if (getElementType(element) === 'password') {
	    value = undefined;
	  }
	  var elementString = elementArrayToString(treeToArray(element));
	  this.telemeter.captureDom(subtype, elementString, value, isChecked);
	};
	
	function getElementType(e) {
	  return (e.getAttribute('type') || '').toLowerCase();
	}
	
	function isDescribedElement(element, type, subtypes) {
	  if (element.tagName.toLowerCase() !== type.toLowerCase()) {
	    return false;
	  }
	  if (!subtypes) {
	    return true;
	  }
	  element = getElementType(element);
	  for (var i = 0; i < subtypes.length; i++) {
	    if (subtypes[i] === element) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function getElementFromEvent(evt, doc) {
	  if (evt.target) {
	    return evt.target;
	  }
	  if (doc && doc.elementFromPoint) {
	    return doc.elementFromPoint(evt.clientX, evt.clientY);
	  }
	  return undefined;
	}
	
	function treeToArray(elem) {
	  var MAX_HEIGHT = 5;
	  var out = [];
	  var nextDescription;
	  for (var height = 0; elem && height < MAX_HEIGHT; height++) {
	    nextDescription = describeElement(elem);
	    if (nextDescription.tagName === 'html') {
	      break;
	    }
	    out.push(nextDescription);
	    elem = elem.parentNode;
	  }
	  return out.reverse();
	}
	
	function elementArrayToString(a) {
	  var MAX_LENGTH = 80;
	  var separator = ' > ', separatorLength = separator.length;
	  var out = [], len = 0, nextStr, totalLength;
	
	  for (var i = 0; i < a.length; i++) {
	    nextStr = descriptionToString(a[i]);
	    totalLength = len + (out.length * separatorLength) + nextStr.length;
	    if (i > 0 && totalLength >= MAX_LENGTH) {
	      break;
	    }
	    out.push(nextStr);
	    len += nextStr.length;
	  }
	  return out.join(separator);
	}
	
	/**
	 * Old implementation
	 * Should be equivalent to: elementArrayToString(treeToArray(elem))
	function treeToString(elem) {
	  var MAX_HEIGHT = 5, MAX_LENGTH = 80;
	  var separator = ' > ', separatorLength = separator.length;
	  var out = [], len = 0, nextStr, totalLength;
	
	  for (var height = 0; elem && height < MAX_HEIGHT; height++) {
	    nextStr = elementToString(elem);
	    if (nextStr === 'html') {
	      break;
	    }
	    totalLength = len + (out.length * separatorLength) + nextStr.length;
	    if (height > 1 && totalLength >= MAX_LENGTH) {
	      break;
	    }
	    out.push(nextStr);
	    len += nextStr.length;
	    elem = elem.parentNode;
	  }
	  return out.reverse().join(separator);
	}
	
	function elementToString(elem) {
	  return descriptionToString(describeElement(elem));
	}
	 */
	
	function descriptionToString(desc) {
	  if (!desc || !desc.tagName) {
	    return '';
	  }
	  var out = [desc.tagName];
	  if (desc.id) {
	    out.push('#' + desc.id);
	  }
	  if (desc.classes) {
	    out.push('.' + desc.classes.join('.'));
	  }
	  for (var i = 0; i < desc.attributes.length; i++) {
	    out.push('[' + desc.attributes[i].key + '="' + desc.attributes[i].value + '"]');
	  }
	
	  return out.join('');
	}
	
	/**
	 * Input: a dom element
	 * Output: null if tagName is falsey or input is falsey, else
	 *  {
	 *    tagName: String,
	 *    id: String | undefined,
	 *    classes: [String] | undefined,
	 *    attributes: [
	 *      {
	 *        key: OneOf(type, name, title, alt),
	 *        value: String
	 *      }
	 *    ]
	 *  }
	 */
	function describeElement(elem) {
	  if (!elem || !elem.tagName) {
	    return null;
	  }
	  var out = {}, className, key, attr, i;
	  out.tagName = elem.tagName.toLowerCase();
	  if (elem.id) {
	    out.id = elem.id;
	  }
	  className = elem.className;
	  if (className && _.isType(className, 'string')) {
	    out.classes = className.split(/\s+/);
	  }
	  var attributes = ['type', 'name', 'title', 'alt'];
	  out.attributes = [];
	  for (i = 0; i < attributes.length; i++) {
	    key = attributes[i];
	    attr = elem.getAttribute(key);
	    if (attr) {
	      out.attributes.push({key: key, value: attr});
	    }
	  }
	  return out;
	}
	
	Instrumenter.prototype.instrumentNavigation = function() {
	  var chrome = this._window.chrome;
	  var chromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	  // See https://github.com/angular/angular.js/pull/13945/files
	  var hasPushState = !chromePackagedApp && this._window.history && this._window.history.pushState;
	  if (!hasPushState) {
	    return;
	  }
	  var self = this;
	  var oldOnPopState = this._window.onpopstate;
	  this._window.onpopstate = function() {
	    var current = self._location.href;
	    self.handleUrlChange(self._lastHref, current);
	    if (oldOnPopState) {
	      oldOnPopState.apply(this, arguments);
	    }
	  };
	
	  replace(this._window.history, 'pushState', function(orig) {
	    return function() {
	      var url = arguments.length > 2 ? arguments[2] : undefined;
	      if (url) {
	        self.handleUrlChange(self._lastHref, url + '');
	      }
	      return orig.apply(this, arguments);
	    };
	  }, this.replacements);
	};
	
	Instrumenter.prototype.handleUrlChange = function(from, to) {
	  var parsedHref = urlparser.parse(this._location.href);
	  var parsedTo = urlparser.parse(to);
	  var parsedFrom = urlparser.parse(from);
	  this._lastHref = to;
	  if (parsedHref.protocol === parsedTo.protocol && parsedHref.host === parsedTo.host) {
	    to = parsedTo.path + (parsedTo.hash || '');
	  }
	  if (parsedHref.protocol === parsedFrom.protocol && parsedHref.host === parsedFrom.host) {
	    from = parsedFrom.path + (parsedFrom.hash || '');
	  }
	  this.telemeter.captureNavigation(from, to);
	};
	
	Instrumenter.prototype.instrumentConnectivity = function() {
	  if (!('addEventListener' in this._window || 'body' in this._document)) {
	    return;
	  }
	  if (this._window.addEventListener) {
	    this._window.addEventListener('online', function() {
	      this.telemeter.captureConnectivityChange('online');
	    }.bind(this), true);
	    this._window.addEventListener('offline', function() {
	      this.telemeter.captureConnectivityChange('offline');
	    }.bind(this), true);
	  } else {
	    this._document.body.ononline = function() {
	      this.telemeter.captureConnectivityChange('online');
	    }.bind(this);
	    this._document.body.onoffline = function() {
	      this.telemeter.captureConnectivityChange('offline');
	    }.bind(this);
	  }
	};
	
	Instrumenter.prototype.restore = function() {
	  restore(this.replacements);
	  this.replacements = [];
	};
	
	module.exports = Instrumenter;


/***/ }
/******/ ])
});
;

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

/*! iNoBounce - v0.1.6
* https://github.com/lazd/iNoBounce/
* Copyright (c) 2013 Larry Davis <lazdnet@gmail.com>; Licensed BSD */
(function(global) {
	// Stores the Y position where the touch started
	var startY = 0;

	// Store enabled status
	var enabled = false;

	var supportsPassiveOption = false;
	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supportsPassiveOption = true;
			}
		});
		window.addEventListener('test', null, opts);
	} catch (e) {}

	var handleTouchmove = function(evt) {
		// Get the element that was scrolled upon
		var el = evt.target;

		// Check all parent elements for scrollability
		while (el !== document.body && el !== document) {
			// Get some style properties
			var style = window.getComputedStyle(el);

			if (!style) {
				// If we've encountered an element we can't compute the style for, get out
				break;
			}

			// Ignore range input element
			if (el.nodeName === 'INPUT' && el.getAttribute('type') === 'range') {
				return;
			}

			var scrolling = style.getPropertyValue('-webkit-overflow-scrolling');
			var overflowY = style.getPropertyValue('overflow-y');
			var height = parseInt(style.getPropertyValue('height'), 10);

			// Determine if the element should scroll
			var isScrollable = scrolling === 'touch' && (overflowY === 'auto' || overflowY === 'scroll');
			var canScroll = el.scrollHeight > el.offsetHeight;

			if (isScrollable && canScroll) {
				// Get the current Y position of the touch
				var curY = evt.touches ? evt.touches[0].screenY : evt.screenY;

				// Determine if the user is trying to scroll past the top or bottom
				// In this case, the window will bounce, so we have to prevent scrolling completely
				var isAtTop = (startY <= curY && el.scrollTop === 0);
				var isAtBottom = (startY >= curY && el.scrollHeight - el.scrollTop === height);

				// Stop a bounce bug when at the bottom or top of the scrollable element
				if (isAtTop || isAtBottom) {
					evt.preventDefault();
				}

				// No need to continue up the DOM, we've done our job
				return;
			}

			// Test the next parent
			el = el.parentNode;
		}

		// Stop the bouncing -- no parents are scrollable
		evt.preventDefault();
	};

	var handleTouchstart = function(evt) {
		// Store the first Y position of the touch
		startY = evt.touches ? evt.touches[0].screenY : evt.screenY;
	};

	var enable = function() {
		// Listen to a couple key touch events
		window.addEventListener('touchstart', handleTouchstart, supportsPassiveOption ? { passive : false } : false);
		window.addEventListener('touchmove', handleTouchmove, supportsPassiveOption ? { passive : false } : false);
		enabled = true;
	};

	var disable = function() {
		// Stop listening
		window.removeEventListener('touchstart', handleTouchstart, false);
		window.removeEventListener('touchmove', handleTouchmove, false);
		enabled = false;
	};

	var isEnabled = function() {
		return enabled;
	};

	// Enable by default if the browser supports -webkit-overflow-scrolling
	// Test this by setting the property with JavaScript on an element that exists in the DOM
	// Then, see if the property is reflected in the computed style
	var testDiv = document.createElement('div');
	document.documentElement.appendChild(testDiv);
	testDiv.style.WebkitOverflowScrolling = 'touch';
	var scrollSupport = 'getComputedStyle' in window && window.getComputedStyle(testDiv)['-webkit-overflow-scrolling'] === 'touch';
	document.documentElement.removeChild(testDiv);

	if (scrollSupport) {
		enable();
	}

	// A module to support enabling/disabling iNoBounce
	var iNoBounce = {
		enable: enable,
		disable: disable,
		isEnabled: isEnabled
	};

	if (typeof module !== 'undefined' && module.exports) {
		// Node.js Support
		module.exports = iNoBounce;
	}
	if (typeof global.define === 'function') {
		// AMD Support
		(function(define) {
			define('iNoBounce', [], function() { return iNoBounce; });
		}(global.define));
	}
	else {
		// Browser support
		global.iNoBounce = iNoBounce;
	}
}(this));


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(21);
var ReactDefaultInjection = __webpack_require__(462);
var ReactMount = __webpack_require__(492);
var ReactReconciler = __webpack_require__(106);
var ReactUpdates = __webpack_require__(60);
var ReactVersion = __webpack_require__(495);

var findDOMNode = __webpack_require__(1118);
var getHostComponentFromComposite = __webpack_require__(496);
var renderSubtreeIntoContainer = __webpack_require__(1119);
var warning = __webpack_require__(16);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(160);
var ExecutionEnvironment = __webpack_require__(40);
var FallbackCompositionState = __webpack_require__(1041);
var SyntheticCompositionEvent = __webpack_require__(1042);
var SyntheticInputEvent = __webpack_require__(1043);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var PooledClass = __webpack_require__(105);

var getTextContentAccessor = __webpack_require__(465);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(161);
var EventPropagators = __webpack_require__(160);
var ExecutionEnvironment = __webpack_require__(40);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(60);
var SyntheticEvent = __webpack_require__(76);

var inputValueTracking = __webpack_require__(468);
var getEventTarget = __webpack_require__(297);
var isEventSupported = __webpack_require__(298);
var isTextInputElement = __webpack_require__(469);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(1046);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(160);
var ReactDOMComponentTree = __webpack_require__(21);
var SyntheticMouseEvent = __webpack_require__(212);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(129);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(300);
var ReactDOMIDOperations = __webpack_require__(1055);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var DOMLazyTree = __webpack_require__(130);
var ExecutionEnvironment = __webpack_require__(40);

var createNodesFromMarkup = __webpack_require__(1052);
var emptyFunction = __webpack_require__(48);
var invariant = __webpack_require__(9);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(40);

var createArrayFromMixed = __webpack_require__(1053);
var getMarkupWrap = __webpack_require__(1054);
var invariant = __webpack_require__(9);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(9);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(40);

var invariant = __webpack_require__(9);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(300);
var ReactDOMComponentTree = __webpack_require__(21);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(18);

var AutoFocusUtils = __webpack_require__(1057);
var CSSPropertyOperations = __webpack_require__(1058);
var DOMLazyTree = __webpack_require__(130);
var DOMNamespaces = __webpack_require__(301);
var DOMProperty = __webpack_require__(129);
var DOMPropertyOperations = __webpack_require__(474);
var EventPluginHub = __webpack_require__(161);
var EventPluginRegistry = __webpack_require__(294);
var ReactBrowserEventEmitter = __webpack_require__(215);
var ReactDOMComponentFlags = __webpack_require__(461);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMInput = __webpack_require__(1068);
var ReactDOMOption = __webpack_require__(1082);
var ReactDOMSelect = __webpack_require__(482);
var ReactDOMTextarea = __webpack_require__(1083);
var ReactInstrumentation = __webpack_require__(55);
var ReactMultiChild = __webpack_require__(1084);
var ReactServerRenderingTransaction = __webpack_require__(487);

var emptyFunction = __webpack_require__(48);
var escapeTextContentForBrowser = __webpack_require__(214);
var invariant = __webpack_require__(9);
var isEventSupported = __webpack_require__(298);
var shallowEqual = __webpack_require__(166);
var inputValueTracking = __webpack_require__(468);
var validateDOMNesting = __webpack_require__(311);
var warning = __webpack_require__(16);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(21);

var focusNode = __webpack_require__(472);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(473);
var ExecutionEnvironment = __webpack_require__(40);
var ReactInstrumentation = __webpack_require__(55);

var camelizeStyleName = __webpack_require__(1059);
var dangerousStyleValue = __webpack_require__(1061);
var hyphenateStyleName = __webpack_require__(1062);
var memoizeStringOnly = __webpack_require__(1064);
var warning = __webpack_require__(16);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(1060);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(473);
var warning = __webpack_require__(16);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1063);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(214);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(161);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(40);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(18);

var DOMPropertyOperations = __webpack_require__(474);
var LinkedValueUtils = __webpack_require__(303);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(60);

var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(48);
var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);
var assign = __webpack_require__(18);

var ReactPropTypesSecret = __webpack_require__(475);
var checkPropTypes = __webpack_require__(1071);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1074);
var ReactElement = __webpack_require__(131);

var emptyFunction = __webpack_require__(48);
var traverseAllChildren = __webpack_require__(480);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(163);

var invariant = __webpack_require__(9);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(131);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(131),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(304);

module.exports = factory(isValidElement);

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(476),
    Component = _require.Component;

var _require2 = __webpack_require__(131),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(477);
var factory = __webpack_require__(1080);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var emptyObject = __webpack_require__(164);
var _invariant = __webpack_require__(9);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(163);

var ReactElement = __webpack_require__(131);

var invariant = __webpack_require__(9);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var React = __webpack_require__(82);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMSelect = __webpack_require__(482);

var warning = __webpack_require__(16);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(18);

var LinkedValueUtils = __webpack_require__(303);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(60);

var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var ReactComponentEnvironment = __webpack_require__(305);
var ReactInstanceMap = __webpack_require__(165);
var ReactInstrumentation = __webpack_require__(55);

var ReactCurrentOwner = __webpack_require__(77);
var ReactReconciler = __webpack_require__(106);
var ReactChildReconciler = __webpack_require__(1085);

var emptyFunction = __webpack_require__(48);
var flattenChildren = __webpack_require__(1090);
var invariant = __webpack_require__(9);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(106);

var instantiateReactComponent = __webpack_require__(306);
var KeyEscapeUtils = __webpack_require__(308);
var shouldUpdateReactComponent = __webpack_require__(307);
var traverseAllChildren = __webpack_require__(486);
var warning = __webpack_require__(16);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(309);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)))

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(18);

var React = __webpack_require__(82);
var ReactComponentEnvironment = __webpack_require__(305);
var ReactCurrentOwner = __webpack_require__(77);
var ReactErrorUtils = __webpack_require__(296);
var ReactInstanceMap = __webpack_require__(165);
var ReactInstrumentation = __webpack_require__(55);
var ReactNodeTypes = __webpack_require__(483);
var ReactReconciler = __webpack_require__(106);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(164);
var invariant = __webpack_require__(9);
var shallowEqual = __webpack_require__(166);
var shouldUpdateReactComponent = __webpack_require__(307);
var warning = __webpack_require__(16);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(308);
var traverseAllChildren = __webpack_require__(486);
var warning = __webpack_require__(16);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(309);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)))

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(310);

var warning = __webpack_require__(16);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var DOMLazyTree = __webpack_require__(130);
var ReactDOMComponentTree = __webpack_require__(21);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(9);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(18);

var DOMChildrenOperations = __webpack_require__(300);
var DOMLazyTree = __webpack_require__(130);
var ReactDOMComponentTree = __webpack_require__(21);

var escapeTextContentForBrowser = __webpack_require__(214);
var invariant = __webpack_require__(9);
var validateDOMNesting = __webpack_require__(311);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var EventListener = __webpack_require__(489);
var ExecutionEnvironment = __webpack_require__(40);
var PooledClass = __webpack_require__(105);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(60);

var getEventTarget = __webpack_require__(297);
var getUnboundedScrollPosition = __webpack_require__(1096);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(129);
var EventPluginHub = __webpack_require__(161);
var EventPluginUtils = __webpack_require__(295);
var ReactComponentEnvironment = __webpack_require__(305);
var ReactEmptyComponent = __webpack_require__(484);
var ReactBrowserEventEmitter = __webpack_require__(215);
var ReactHostComponent = __webpack_require__(485);
var ReactUpdates = __webpack_require__(60);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var CallbackQueue = __webpack_require__(466);
var PooledClass = __webpack_require__(105);
var ReactBrowserEventEmitter = __webpack_require__(215);
var ReactInputSelection = __webpack_require__(490);
var ReactInstrumentation = __webpack_require__(55);
var Transaction = __webpack_require__(211);
var ReactUpdateQueue = __webpack_require__(310);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(40);

var getNodeForCharacterOffset = __webpack_require__(1100);
var getTextContentAccessor = __webpack_require__(465);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1102);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1103);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(160);
var ExecutionEnvironment = __webpack_require__(40);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInputSelection = __webpack_require__(490);
var SyntheticEvent = __webpack_require__(76);

var getActiveElement = __webpack_require__(491);
var isTextInputElement = __webpack_require__(469);
var shallowEqual = __webpack_require__(166);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(15);

var EventListener = __webpack_require__(489);
var EventPropagators = __webpack_require__(160);
var ReactDOMComponentTree = __webpack_require__(21);
var SyntheticAnimationEvent = __webpack_require__(1107);
var SyntheticClipboardEvent = __webpack_require__(1108);
var SyntheticEvent = __webpack_require__(76);
var SyntheticFocusEvent = __webpack_require__(1109);
var SyntheticKeyboardEvent = __webpack_require__(1110);
var SyntheticMouseEvent = __webpack_require__(212);
var SyntheticDragEvent = __webpack_require__(1112);
var SyntheticTouchEvent = __webpack_require__(1113);
var SyntheticTransitionEvent = __webpack_require__(1114);
var SyntheticUIEvent = __webpack_require__(162);
var SyntheticWheelEvent = __webpack_require__(1115);

var emptyFunction = __webpack_require__(48);
var getEventCharCode = __webpack_require__(312);
var invariant = __webpack_require__(9);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(162);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(162);

var getEventCharCode = __webpack_require__(312);
var getEventKey = __webpack_require__(1111);
var getEventModifierState = __webpack_require__(299);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(312);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(212);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(162);

var getEventModifierState = __webpack_require__(299);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(212);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstanceMap = __webpack_require__(165);

var getHostComponentFromComposite = __webpack_require__(496);
var invariant = __webpack_require__(9);
var warning = __webpack_require__(16);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(492);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1122);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1125);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(190)(module)))

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(500);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(501);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(190)(module), __webpack_require__(51)))

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1137),
    createAssigner = __webpack_require__(514);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(217),
    assignMergeValue = __webpack_require__(506),
    baseFor = __webpack_require__(507),
    baseMergeDeep = __webpack_require__(1146),
    isObject = __webpack_require__(71),
    keysIn = __webpack_require__(221),
    safeGet = __webpack_require__(513);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 1138 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(218);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(218);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(218);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(218);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1144);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(506),
    cloneBuffer = __webpack_require__(508),
    cloneTypedArray = __webpack_require__(1148),
    copyArray = __webpack_require__(194),
    initCloneObject = __webpack_require__(509),
    isArguments = __webpack_require__(219),
    isArray = __webpack_require__(27),
    isArrayLikeObject = __webpack_require__(252),
    isBuffer = __webpack_require__(220),
    isFunction = __webpack_require__(315),
    isObject = __webpack_require__(71),
    isPlainObject = __webpack_require__(167),
    isTypedArray = __webpack_require__(316),
    safeGet = __webpack_require__(513),
    toPlainObject = __webpack_require__(1151);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1149);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1150);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    keysIn = __webpack_require__(221);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var detectBrowser = __webpack_require__(1153);

var agent;

if (typeof navigator !== 'undefined' && navigator) {
  agent = navigator.userAgent;
}

module.exports = detectBrowser(agent);


/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports = function detectBrowser(userAgentString) {
  if (!userAgentString) return null;

  var browsers = [
    [ 'edge', /Edge\/([0-9\._]+)/ ],
    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/ ],
    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
    [ 'ie', /MSIE\s(7\.0)/ ],
    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
    [ 'android', /Android\s([0-9\.]+)/ ],
    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
    [ 'safari', /Version\/([0-9\._]+).*Safari/ ]
  ];

  return browsers.map(function (rule) {
      if (rule[1].test(userAgentString)) {
          var match = rule[1].exec(userAgentString);
          var version = match && match[1].split(/[._]/).slice(0,3);

          if (version && version.length < 3) {
              Array.prototype.push.apply(version, (version.length == 1) ? [0, 0] : [0]);
          }

          return {
              name: rule[0],
              version: version.join('.')
          };
      }
  }).filter(Boolean).shift();
};


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ImmutableUtils = __webpack_require__(320);

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getDefaultGetId = function getDefaultGetId(idAttribute) {
  return function (input) {
    return ImmutableUtils.isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
  };
};

var EntitySchema = function () {
  function EntitySchema(key) {
    var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, EntitySchema);

    if (!key || typeof key !== 'string') {
      throw new Error('Expected a string key for Entity, but found ' + key + '.');
    }

    var _options$idAttribute = options.idAttribute,
        idAttribute = _options$idAttribute === undefined ? 'id' : _options$idAttribute,
        _options$mergeStrateg = options.mergeStrategy,
        mergeStrategy = _options$mergeStrateg === undefined ? function (entityA, entityB) {
      return _extends({}, entityA, entityB);
    } : _options$mergeStrateg,
        _options$processStrat = options.processStrategy,
        processStrategy = _options$processStrat === undefined ? function (input) {
      return _extends({}, input);
    } : _options$processStrat;


    this._key = key;
    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
    this._idAttribute = idAttribute;
    this._mergeStrategy = mergeStrategy;
    this._processStrategy = processStrategy;
    this.define(definition);
  }

  _createClass(EntitySchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
        var schema = definition[key];
        return _extends({}, entitySchema, _defineProperty({}, key, schema));
      }, this.schema || {});
    }
  }, {
    key: 'getId',
    value: function getId(input, parent, key) {
      return this._getId(input, parent, key);
    }
  }, {
    key: 'merge',
    value: function merge(entityA, entityB) {
      return this._mergeStrategy(entityA, entityB);
    }
  }, {
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this = this;

      var processedEntity = this._processStrategy(input, parent, key);
      Object.keys(this.schema).forEach(function (key) {
        if (processedEntity.hasOwnProperty(key) && _typeof(processedEntity[key]) === 'object') {
          var schema = _this.schema[key];
          processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity);
        }
      });

      addEntity(this, processedEntity, input, parent, key);
      return this.getId(input, parent, key);
    }
  }, {
    key: 'denormalize',
    value: function denormalize(entity, unvisit) {
      var _this2 = this;

      if (ImmutableUtils.isImmutable(entity)) {
        return ImmutableUtils.denormalizeImmutable(this.schema, entity, unvisit);
      }

      Object.keys(this.schema).forEach(function (key) {
        if (entity.hasOwnProperty(key)) {
          var schema = _this2.schema[key];
          entity[key] = unvisit(entity[key], schema);
        }
      });
      return entity;
    }
  }, {
    key: 'key',
    get: function get() {
      return this._key;
    }
  }, {
    key: 'idAttribute',
    get: function get() {
      return this._idAttribute;
    }
  }]);

  return EntitySchema;
}();

exports.default = EntitySchema;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Polymorphic = __webpack_require__(321);

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnionSchema = function (_PolymorphicSchema) {
  _inherits(UnionSchema, _PolymorphicSchema);

  function UnionSchema(definition, schemaAttribute) {
    _classCallCheck(this, UnionSchema);

    if (!schemaAttribute) {
      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
    }
    return _possibleConstructorReturn(this, (UnionSchema.__proto__ || Object.getPrototypeOf(UnionSchema)).call(this, definition, schemaAttribute));
  }

  _createClass(UnionSchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      return this.normalizeValue(input, parent, key, visit, addEntity);
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      return this.denormalizeValue(input, unvisit);
    }
  }]);

  return UnionSchema;
}(_Polymorphic2.default);

exports.default = UnionSchema;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Polymorphic = __webpack_require__(321);

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ValuesSchema = function (_PolymorphicSchema) {
  _inherits(ValuesSchema, _PolymorphicSchema);

  function ValuesSchema() {
    _classCallCheck(this, ValuesSchema);

    return _possibleConstructorReturn(this, (ValuesSchema.__proto__ || Object.getPrototypeOf(ValuesSchema)).apply(this, arguments));
  }

  _createClass(ValuesSchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this2 = this;

      return Object.keys(input).reduce(function (output, key, index) {
        var value = input[key];
        return value !== undefined && value !== null ? _extends({}, output, _defineProperty({}, key, _this2.normalizeValue(value, input, key, visit, addEntity))) : output;
      }, {});
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      var _this3 = this;

      return Object.keys(input).reduce(function (output, key) {
        var entityOrId = input[key];
        return _extends({}, output, _defineProperty({}, key, _this3.denormalizeValue(entityOrId, unvisit)));
      }, {});
    }
  }]);

  return ValuesSchema;
}(_Polymorphic2.default);

exports.default = ValuesSchema;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Polymorphic = __webpack_require__(321);

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateSchema = function validateSchema(definition) {
  var isArray = Array.isArray(definition);
  if (isArray && definition.length > 1) {
    throw new Error('Expected schema definition to be a single schema, but found ' + definition.length + '.');
  }

  return definition[0];
};

var getValues = function getValues(input) {
  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
    return input[key];
  });
};

var normalize = exports.normalize = function normalize(schema, input, parent, key, visit, addEntity) {
  schema = validateSchema(schema);

  var values = getValues(input);

  // Special case: Arrays pass *their* parent on to their children, since there
  // is not any special information that can be gathered from themselves directly
  return values.map(function (value, index) {
    return visit(value, parent, key, schema, addEntity);
  });
};

var denormalize = exports.denormalize = function denormalize(schema, input, unvisit) {
  schema = validateSchema(schema);
  return input && input.map ? input.map(function (entityOrId) {
    return unvisit(entityOrId, schema);
  }) : input;
};

var ArraySchema = function (_PolymorphicSchema) {
  _inherits(ArraySchema, _PolymorphicSchema);

  function ArraySchema() {
    _classCallCheck(this, ArraySchema);

    return _possibleConstructorReturn(this, (ArraySchema.__proto__ || Object.getPrototypeOf(ArraySchema)).apply(this, arguments));
  }

  _createClass(ArraySchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this2 = this;

      var values = getValues(input);

      return values.map(function (value, index) {
        return _this2.normalizeValue(value, parent, key, visit, addEntity);
      }).filter(function (value) {
        return value !== undefined && value !== null;
      });
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      var _this3 = this;

      return input && input.map ? input.map(function (value) {
        return _this3.denormalizeValue(value, unvisit);
      }) : input;
    }
  }]);

  return ArraySchema;
}(_Polymorphic2.default);

exports.default = ArraySchema;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ImmutableUtils = __webpack_require__(320);

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _normalize = function _normalize(schema, input, parent, key, visit, addEntity) {
  var object = _extends({}, input);
  Object.keys(schema).forEach(function (key) {
    var localSchema = schema[key];
    var value = visit(input[key], input, key, localSchema, addEntity);
    if (value === undefined || value === null) {
      delete object[key];
    } else {
      object[key] = value;
    }
  });
  return object;
};

exports.normalize = _normalize;
var _denormalize = function _denormalize(schema, input, unvisit) {
  if (ImmutableUtils.isImmutable(input)) {
    return ImmutableUtils.denormalizeImmutable(schema, input, unvisit);
  }

  var object = _extends({}, input);
  Object.keys(schema).forEach(function (key) {
    if (object[key]) {
      object[key] = unvisit(object[key], schema[key]);
    }
  });
  return object;
};

exports.denormalize = _denormalize;

var ObjectSchema = function () {
  function ObjectSchema(definition) {
    _classCallCheck(this, ObjectSchema);

    this.define(definition);
  }

  _createClass(ObjectSchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
        var schema = definition[key];
        return _extends({}, entitySchema, _defineProperty({}, key, schema));
      }, this.schema || {});
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _normalize.apply(undefined, [this.schema].concat(args));
    }
  }, {
    key: 'denormalize',
    value: function denormalize() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _denormalize.apply(undefined, [this.schema].concat(args));
    }
  }]);

  return ObjectSchema;
}();

exports.default = ObjectSchema;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _base = __webpack_require__(504);

var _base2 = _interopRequireDefault(_base);

var _jsCookie = __webpack_require__(518);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _cryptoJs = __webpack_require__(407);

var _encr = __webpack_require__(1183);

var _encr2 = _interopRequireDefault(_encr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var subset = function subset(obj, keys) {
  return !keys ? _extends({}, obj) : keys.filter(function (k) {
    return obj.hasOwnProperty(k);
  }).reduce(function (o, k) {
    return _extends({}, o, _defineProperty({}, k, obj[k]));
  }, {});
};

var Cookie = (_temp = _class = function (_Base) {
  _inherits(Cookie, _Base);

  function Cookie(name) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Cookie);

    var _this = _possibleConstructorReturn(this, (Cookie.__proto__ || Object.getPrototypeOf(Cookie)).call(this, defaults, options));

    var paths = options.paths,
        _options$cookies = options.cookies,
        cookies = _options$cookies === undefined ? _jsCookie2.default : _options$cookies;

    _this.name = name;
    _this.paths = paths === undefined ? paths : paths instanceof Array ? paths : [paths];
    _this.cookies = cookies;
    return _this;
  }

  _createClass(Cookie, [{
    key: 'read',
    value: function read(state) {
      var _buildAction = this.buildAction({}),
          _buildAction$payload$ = _buildAction.payload.options;

      _buildAction$payload$ = _buildAction$payload$ === undefined ? {} : _buildAction$payload$;
      var options = _buildAction$payload$.options;

      var data = this.decrypt(this.cookies.get(this.name, options) || '{}');
      return _extends({}, state, subset(data, this.paths));
    }
  }, {
    key: 'write',
    value: function write(state) {
      var _buildAction2 = this.buildAction({}),
          _buildAction2$payload = _buildAction2.payload.options;

      _buildAction2$payload = _buildAction2$payload === undefined ? {} : _buildAction2$payload;
      var options = _buildAction2$payload.options;

      this.cookies.set(this.name, this.encrypt(subset(state, this.paths)), options);
    }
  }, {
    key: 'encrypt',
    value: function encrypt(value) {
      try {
        return _cryptoJs.AES.encrypt(JSON.stringify(value), (0, _encr2.default)()).toString();
      } catch (e) {
        return _cryptoJs.AES.encrypt(JSON.stringify({}), (0, _encr2.default)()).toString();
      }
    }
  }, {
    key: 'decrypt',
    value: function decrypt(value) {
      try {
        return (0, _encr.decr)(value);
      } catch (e) {
        return {};
      }
    }
  }]);

  return Cookie;
}(_base2.default), _class.PREFIX = '@@cookie', _temp);
exports.default = Cookie;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(519));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(223), __webpack_require__(520));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(223));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(322), __webpack_require__(323));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(133), __webpack_require__(134), __webpack_require__(135), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(133), __webpack_require__(134), __webpack_require__(135), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(133), __webpack_require__(134), __webpack_require__(135), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(133), __webpack_require__(134), __webpack_require__(135), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(12), __webpack_require__(133), __webpack_require__(134), __webpack_require__(135), __webpack_require__(30));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = encr;
exports.decr = decr;

var _cryptoJs = __webpack_require__(407);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Encryption key for cookie set/get.
// this is meant to be slightly annoying to decipher once uglified,
// but is NOT meant to be the end-all for user security. The API must do that.
function encr() {
  // USED IN ENCRYPTION FUNCTION
  // inside app.js - meant to be slightly annoyingly elusive
  // but is not a replacement for API security
  var a = 378799200000; // eslint-disable-line no-unused-vars
  var n = 5; // eslint-disable-line no-unused-vars

  return eval('a + n + "pb2016"'); // eslint-disable-line no-eval
}

function decr(cookieData) {
  if (!cookieData || cookieData === 'undefined') return;
  try {
    return JSON.parse(cookieData);
  } catch (e) {
    return JSON.parse(_cryptoJs.AES.decrypt(cookieData, encr()).toString(_cryptoJs2.default.enc.Utf8));
  }
}

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxLogger = __webpack_require__(1185);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _env2.default.PUSHBOT_VERBOSE ? (0, _reduxLogger2.default)({
  level: _env2.default.PUSHBOT_LOG_LEVEL,
  collapsed: true
}) : function (store) {
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
}; // eslint-disable-line no-unused-vars

exports.default = logger;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = __webpack_require__(1186);

var _helpers = __webpack_require__(521);

var _defaults = __webpack_require__(1189);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates logger with following options
 *
 * @namespace
 * @param {object} options - options for logger
 * @param {string | function | object} options.level - console[level]
 * @param {boolean} options.duration - print duration of each action?
 * @param {boolean} options.timestamp - print timestamp with each action?
 * @param {object} options.colors - custom colors
 * @param {object} options.logger - implementation of the `console` API
 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
 * @param {boolean} options.collapsed - is group collapsed?
 * @param {boolean} options.predicate - condition which resolves logger behavior
 * @param {function} options.stateTransformer - transform state before print
 * @param {function} options.actionTransformer - transform action before print
 * @param {function} options.errorTransformer - transform error before print
 *
 * @returns {function} logger middleware
 */
function createLogger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var loggerOptions = _extends({}, _defaults2.default, options);

  var logger = loggerOptions.logger,
      transformer = loggerOptions.transformer,
      stateTransformer = loggerOptions.stateTransformer,
      errorTransformer = loggerOptions.errorTransformer,
      predicate = loggerOptions.predicate,
      logErrors = loggerOptions.logErrors,
      diffPredicate = loggerOptions.diffPredicate;

  // Return if 'console' object is not defined

  if (typeof logger === 'undefined') {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  if (transformer) {
    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
  }

  var logBuffer = [];

  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        // Exit early if predicate function returns 'false'
        if (typeof predicate === 'function' && !predicate(getState, action)) {
          return next(action);
        }

        var logEntry = {};
        logBuffer.push(logEntry);

        logEntry.started = _helpers.timer.now();
        logEntry.startedTime = new Date();
        logEntry.prevState = stateTransformer(getState());
        logEntry.action = action;

        var returnedValue = void 0;
        if (logErrors) {
          try {
            returnedValue = next(action);
          } catch (e) {
            logEntry.error = errorTransformer(e);
          }
        } else {
          returnedValue = next(action);
        }

        logEntry.took = _helpers.timer.now() - logEntry.started;
        logEntry.nextState = stateTransformer(getState());

        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;

        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
        logBuffer.length = 0;

        if (logEntry.error) throw logEntry.error;
        return returnedValue;
      };
    };
  };
}

exports.default = createLogger;
module.exports = exports['default'];

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.printBuffer = printBuffer;

var _helpers = __webpack_require__(521);

var _diff = __webpack_require__(1187);

var _diff2 = _interopRequireDefault(_diff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Get log level string based on supplied params
 *
 * @param {string | function | object} level - console[level]
 * @param {object} action - selected action
 * @param {array} payload - selected payload
 * @param {string} type - log entry type
 *
 * @returns {string} level
 */
function getLogLevel(level, action, payload, type) {
  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
    case 'object':
      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
    case 'function':
      return level(action);
    default:
      return level;
  }
}

function defaultTitleFormatter(options) {
  var timestamp = options.timestamp,
      duration = options.duration;


  return function (action, time, took) {
    var parts = ['action'];

    if (timestamp) parts.push('@ ' + time);
    parts.push(String(action.type));
    if (duration) parts.push('(in ' + took.toFixed(2) + ' ms)');

    return parts.join(' ');
  };
}

function printBuffer(buffer, options) {
  var logger = options.logger,
      actionTransformer = options.actionTransformer,
      _options$titleFormatt = options.titleFormatter,
      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
      collapsed = options.collapsed,
      colors = options.colors,
      level = options.level,
      diff = options.diff;


  buffer.forEach(function (logEntry, key) {
    var started = logEntry.started,
        startedTime = logEntry.startedTime,
        action = logEntry.action,
        prevState = logEntry.prevState,
        error = logEntry.error;
    var took = logEntry.took,
        nextState = logEntry.nextState;

    var nextEntry = buffer[key + 1];

    if (nextEntry) {
      nextState = nextEntry.prevState;
      took = nextEntry.started - started;
    }

    // Message
    var formattedAction = actionTransformer(action);
    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
      return nextState;
    }, action, logEntry) : collapsed;

    var formattedTime = (0, _helpers.formatTime)(startedTime);
    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : null;
    var title = titleFormatter(formattedAction, formattedTime, took);

    // Render
    try {
      if (isCollapsed) {
        if (colors.title) logger.groupCollapsed('%c ' + title, titleCSS);else logger.groupCollapsed(title);
      } else {
        if (colors.title) logger.group('%c ' + title, titleCSS);else logger.group(title);
      }
    } catch (e) {
      logger.log(title);
    }

    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');

    if (prevStateLevel) {
      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
    }

    if (actionLevel) {
      if (colors.action) logger[actionLevel]('%c action', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action', formattedAction);
    }

    if (error && errorLevel) {
      if (colors.error) logger[errorLevel]('%c error', 'color: ' + colors.error(error, prevState) + '; font-weight: bold', error);else logger[errorLevel]('error', error);
    }

    if (nextStateLevel) {
      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
    }

    if (diff) {
      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
    }

    try {
      logger.groupEnd();
    } catch (e) {
      logger.log('\u2014\u2014 log end \u2014\u2014');
    }
  });
}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diffLogger;

var _deepDiff = __webpack_require__(1188);

var _deepDiff2 = _interopRequireDefault(_deepDiff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// https://github.com/flitbit/diff#differences
var dictionary = {
  'E': {
    color: '#2196F3',
    text: 'CHANGED:'
  },
  'N': {
    color: '#4CAF50',
    text: 'ADDED:'
  },
  'D': {
    color: '#F44336',
    text: 'DELETED:'
  },
  'A': {
    color: '#2196F3',
    text: 'ARRAY:'
  }
};

function style(kind) {
  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
}

function render(diff) {
  var kind = diff.kind,
      path = diff.path,
      lhs = diff.lhs,
      rhs = diff.rhs,
      index = diff.index,
      item = diff.item;


  switch (kind) {
    case 'E':
      return [path.join('.'), lhs, '\u2192', rhs];
    case 'N':
      return [path.join('.'), rhs];
    case 'D':
      return [path.join('.')];
    case 'A':
      return [path.join('.') + '[' + index + ']', item];
    default:
      return [];
  }
}

function diffLogger(prevState, newState, logger, isCollapsed) {
  var diff = (0, _deepDiff2.default)(prevState, newState);

  try {
    if (isCollapsed) {
      logger.groupCollapsed('diff');
    } else {
      logger.group('diff');
    }
  } catch (e) {
    logger.log('diff');
  }

  if (diff) {
    diff.forEach(function (elem) {
      var kind = elem.kind;

      var output = render(elem);

      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
    });
  } else {
    logger.log('\u2014\u2014 no diff \u2014\u2014');
  }

  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
  }
}
module.exports = exports['default'];

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * deep-diff.
 * Licensed under the MIT License.
 */
;(function(root, factory) {
  'use strict';
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return factory();
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.DeepDiff = factory();
  }
}(this, function(undefined) {
  'use strict';

  var $scope, conflict, conflictResolution = [];
  if (typeof global === 'object' && global) {
    $scope = global;
  } else if (typeof window !== 'undefined') {
    $scope = window;
  } else {
    $scope = {};
  }
  conflict = $scope.DeepDiff;
  if (conflict) {
    conflictResolution.push(
      function() {
        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
          $scope.DeepDiff = conflict;
          conflict = undefined;
        }
      });
  }

  // nodejs compatible on server side and in the browser.
  function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  }

  function Diff(kind, path) {
    Object.defineProperty(this, 'kind', {
      value: kind,
      enumerable: true
    });
    if (path && path.length) {
      Object.defineProperty(this, 'path', {
        value: path,
        enumerable: true
      });
    }
  }

  function DiffEdit(path, origin, value) {
    DiffEdit.super_.call(this, 'E', path);
    Object.defineProperty(this, 'lhs', {
      value: origin,
      enumerable: true
    });
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffEdit, Diff);

  function DiffNew(path, value) {
    DiffNew.super_.call(this, 'N', path);
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffNew, Diff);

  function DiffDeleted(path, value) {
    DiffDeleted.super_.call(this, 'D', path);
    Object.defineProperty(this, 'lhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffDeleted, Diff);

  function DiffArray(path, index, item) {
    DiffArray.super_.call(this, 'A', path);
    Object.defineProperty(this, 'index', {
      value: index,
      enumerable: true
    });
    Object.defineProperty(this, 'item', {
      value: item,
      enumerable: true
    });
  }
  inherits(DiffArray, Diff);

  function arrayRemove(arr, from, to) {
    var rest = arr.slice((to || from) + 1 || arr.length);
    arr.length = from < 0 ? arr.length + from : from;
    arr.push.apply(arr, rest);
    return arr;
  }

  function realTypeOf(subject) {
    var type = typeof subject;
    if (type !== 'object') {
      return type;
    }

    if (subject === Math) {
      return 'math';
    } else if (subject === null) {
      return 'null';
    } else if (Array.isArray(subject)) {
      return 'array';
    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
      return 'date';
    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
      return 'regexp';
    }
    return 'object';
  }

  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
    path = path || [];
    var currentPath = path.slice(0);
    if (typeof key !== 'undefined') {
      if (prefilter) {
        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
        else if (typeof(prefilter) === 'object') {
          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
          if (prefilter.normalize) {
            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
            if (alt) {
              lhs = alt[0];
              rhs = alt[1];
            }
          }
        }
      }
      currentPath.push(key);
    }

    // Use string comparison for regexes
    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
      lhs = lhs.toString();
      rhs = rhs.toString();
    }

    var ltype = typeof lhs;
    var rtype = typeof rhs;
    if (ltype === 'undefined') {
      if (rtype !== 'undefined') {
        changes(new DiffNew(currentPath, rhs));
      }
    } else if (rtype === 'undefined') {
      changes(new DiffDeleted(currentPath, lhs));
    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
      changes(new DiffEdit(currentPath, lhs, rhs));
    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
      changes(new DiffEdit(currentPath, lhs, rhs));
    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
      stack = stack || [];
      if (stack.indexOf(lhs) < 0) {
        stack.push(lhs);
        if (Array.isArray(lhs)) {
          var i, len = lhs.length;
          for (i = 0; i < lhs.length; i++) {
            if (i >= rhs.length) {
              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
            } else {
              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
            }
          }
          while (i < rhs.length) {
            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
          }
        } else {
          var akeys = Object.keys(lhs);
          var pkeys = Object.keys(rhs);
          akeys.forEach(function(k, i) {
            var other = pkeys.indexOf(k);
            if (other >= 0) {
              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
              pkeys = arrayRemove(pkeys, other);
            } else {
              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
            }
          });
          pkeys.forEach(function(k) {
            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
          });
        }
        stack.length = stack.length - 1;
      }
    } else if (lhs !== rhs) {
      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
        changes(new DiffEdit(currentPath, lhs, rhs));
      }
    }
  }

  function accumulateDiff(lhs, rhs, prefilter, accum) {
    accum = accum || [];
    deepDiff(lhs, rhs,
      function(diff) {
        if (diff) {
          accum.push(diff);
        }
      },
      prefilter);
    return (accum.length) ? accum : undefined;
  }

  function applyArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      var it = arr[index],
          i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          applyArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    } else {
      switch (change.kind) {
        case 'A':
          applyArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr = arrayRemove(arr, index);
          break;
        case 'E':
        case 'N':
          arr[index] = change.rhs;
          break;
      }
    }
    return arr;
  }

  function applyChange(target, source, change) {
    if (target && source && change && change.kind) {
      var it = target,
          i = -1,
          last = change.path ? change.path.length - 1 : 0;
      while (++i < last) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    }
  }

  function revertArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      // the structure of the object at the index has changed...
      var it = arr[index],
          i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          delete it[change.path[i]];
          break;
      }
    } else {
      // the array item is different...
      switch (change.kind) {
        case 'A':
          revertArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr[index] = change.lhs;
          break;
        case 'E':
          arr[index] = change.lhs;
          break;
        case 'N':
          arr = arrayRemove(arr, index);
          break;
      }
    }
    return arr;
  }

  function revertChange(target, source, change) {
    if (target && source && change && change.kind) {
      var it = target,
          i, u;
      u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          // Array was modified...
          // it will be an array...
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          // Item was deleted...
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          // Item was edited...
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          // Item is new...
          delete it[change.path[i]];
          break;
      }
    }
  }

  function applyDiff(target, source, filter) {
    if (target && source) {
      var onChange = function(change) {
        if (!filter || filter(target, source, change)) {
          applyChange(target, source, change);
        }
      };
      deepDiff(target, source, onChange);
    }
  }

  Object.defineProperties(accumulateDiff, {

    diff: {
      value: accumulateDiff,
      enumerable: true
    },
    observableDiff: {
      value: deepDiff,
      enumerable: true
    },
    applyDiff: {
      value: applyDiff,
      enumerable: true
    },
    applyChange: {
      value: applyChange,
      enumerable: true
    },
    revertChange: {
      value: revertChange,
      enumerable: true
    },
    isConflict: {
      value: function() {
        return 'undefined' !== typeof conflict;
      },
      enumerable: true
    },
    noConflict: {
      value: function() {
        if (conflictResolution) {
          conflictResolution.forEach(function(it) {
            it();
          });
          conflictResolution = null;
        }
        return accumulateDiff;
      },
      enumerable: true
    }
  });

  return accumulateDiff;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  level: "log",
  logger: console,
  logErrors: true,
  collapsed: undefined,
  predicate: undefined,
  duration: false,
  timestamp: true,
  stateTransformer: function stateTransformer(state) {
    return state;
  },
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  errorTransformer: function errorTransformer(error) {
    return error;
  },
  colors: {
    title: function title() {
      return "inherit";
    },
    prevState: function prevState() {
      return "#9E9E9E";
    },
    action: function action() {
      return "#03A9F4";
    },
    nextState: function nextState() {
      return "#4CAF50";
    },
    error: function error() {
      return "#F20404";
    }
  },
  diff: false,
  diffPredicate: undefined,

  // Deprecated options
  transformer: undefined
};
module.exports = exports["default"];

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = errorLogger;

var _errorLog = __webpack_require__(259);

var _errorLog2 = _interopRequireDefault(_errorLog);

var _isError = __webpack_require__(522);

var _isError2 = _interopRequireDefault(_isError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
function errorLogger(store) {
  return function (next) {
    return function (action) {
      if (action.error && (0, _isError2.default)(action.error)) {
        var level = action.error.level;
        if (!level) {
          // Use level based on any response status code.
          // 4xx responses are warnings, everything else is an error.
          var status = action.error.status;
          if (status && status >= 400 && status < 500) {
            level = 'warn';
          } else {
            level = 'error';
          }
        }
        if (action.message) {
          _errorLog2.default[level](action.message, action.error);
        } else {
          _errorLog2.default[level](action.error);
        }
      }

      return next(action);
    };
  };
}

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relay = relay;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _performance = __webpack_require__(1192);

var _performance2 = _interopRequireDefault(_performance);

var _segment = __webpack_require__(536);

var _segment2 = _interopRequireDefault(_segment);

var _reactRouterRedux = __webpack_require__(331);

var _auth = __webpack_require__(92);

var _analytics = __webpack_require__(1248);

var _analytics2 = __webpack_require__(796);

var _performance3 = __webpack_require__(524);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function relay(dispatch, state, action) {
  var type = action.type;

  // Track all API calls

  if (_api2.default.isType(type)) dispatch({ type: _segment.TRACK, payload: { event: type } });

  switch (type) {
    case _reactRouterRedux.LOCATION_CHANGE:
      return dispatch({ type: _segment.PAGE });
    case _auth.AUTHENTICATION_INVALIDATE:
      return dispatch({ type: _segment.RESET });
    case _api2.default.INITIALIZE:
    case _auth.AUTHENTICATION_SUCCESS:
      dispatch((0, _analytics.identify)(state));
      dispatch((0, _analytics.group)(state));
      return;
    case _analytics2.ANALYTICS_TRACK:
    case _performance3.PERFORMANCE_MEASURE:
      dispatch({ type: _segment.TRACK, payload: action.payload });

    default:
  }
}

var tracker = (0, _segment2.default)(relay, { config: _performance2.default });

exports.default = tracker;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createMonitor;
exports.handlePerformanceEvent = handlePerformanceEvent;

var _once = __webpack_require__(523);

var _once2 = _interopRequireDefault(_once);

var _querystring = __webpack_require__(193);

var _querystring2 = _interopRequireDefault(_querystring);

var _performance = __webpack_require__(524);

var _performance2 = __webpack_require__(417);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warnOnce = (0, _once2.default)(console.warn);

function createMonitor(store) {
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : handlePerformanceEvent;

  if ((0, _performance2.isMonitoringEnabled)(store)) {
    var observer = new _context2.default.PerformanceObserver(cb(store.dispatch));
    observer.observe({ entryTypes: ['measure'] });
  } else {
    warnOnce('Unable to monitor performance: The performance.measure method from the User Timing API is not available in this context.');
  }
}

function handlePerformanceEvent(dispatch) {
  return function handler(list) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = list.getEntries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var entry = _step.value;

        var measurement = performanceEntryToMeasurement(entry);
        if (shouldReportMeasurement(measurement)) {
          dispatch((0, _performance.reportMeasureEntry)(measurement));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
}

function performanceEntryToMeasurement(_ref) {
  var duration = _ref.duration,
      entryType = _ref.entryType,
      name = _ref.name,
      startTime = _ref.startTime;

  return _extends({}, _querystring2.default.parse(name), {
    duration: duration,
    entryType: entryType,
    name: name,
    startTime: startTime
  });
}

function shouldReportMeasurement(_ref2) {
  var action = _ref2.action,
      component = _ref2.component;

  return action === 'LoadSearchResults' || component === 'App';
}

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(153);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

module.exports = before;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var EventProcessor = __webpack_require__(1195);
var EventEmitter = __webpack_require__(1197);
var GoalTracker = __webpack_require__(1198);
var Stream = __webpack_require__(1200);
var Requestor = __webpack_require__(1201);
var Identity = __webpack_require__(1202);
var utils = __webpack_require__(224);
var messages = __webpack_require__(1203);

var flags = {};
var environment;
var events;
var requestor;
var stream;
var emitter;
var hash;
var ident;
var baseUrl;
var eventsUrl;
var streamUrl;
var goalTracker;
var useLocalStorage;
var goals;

var readyEvent = 'ready';
var changeEvent = 'change';

var flushInterval = 2000;

var seenRequests = {};

function sendIdentifyEvent(user) {
  events.enqueue({
    kind: 'identify',
    key: user.key,
    user: user,
    creationDate: (new Date()).getTime()
  });
}

function sendFlagEvent(key, value, defaultValue) {
  var user = ident.getUser();
  var cacheKey = JSON.stringify(value) + (user && user.key ? user.key : '') + key;
  var now = new Date();
  var cached = seenRequests[cacheKey];

  if (cached && (now - cached) < 300000 /* five minutes, in ms */) {
    return;
  }

  seenRequests[cacheKey] = now;

  events.enqueue({
    kind: 'feature',
    key: key,
    user: user,
    value: value,
    'default': defaultValue,
    creationDate: now.getTime()
  });
}

function sendGoalEvent(kind, goal) {
  var event = {
    kind: kind,
    key: goal.key,
    data: null,
    url: window.location.href,
    creationDate: (new Date()).getTime()
  };

  if (kind === 'click') {
    event.selector = goal.selector;
  }

  return events.enqueue(event);
}

function identify(user, hash, onDone) {
  ident.setUser(user);
  requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
    if (err) {
      console.warn('Error fetching flag settings: ', err);
    }
    if (settings) {
      updateSettings(settings);
    }
    onDone && onDone();
  });
}

function variation(key, defaultValue) {
  var value;

  if (flags && flags.hasOwnProperty(key)) {
    value = flags[key] === null ? defaultValue : flags[key];
  } else {
    value = defaultValue;
  }

  sendFlagEvent(key, value, defaultValue);

  return value;
}

function allFlags() {
  var results = {};

  if (!flags) { return results; }

  for (var key in flags) {
    if (flags.hasOwnProperty(key)) {
      results[key] = variation(key, null);
    }
  }

  return results;
}

function customEventExists(key) {
  if (!goals || goals.length === 0) { return false; }

  for (var i=0 ; i < goals.length ; i++) {
    if (goals[i].kind === 'custom' && goals[i].key === key) {
      return true;
    }
  }

  return false;
}

function track(key, data) {
  if (typeof key !== 'string') {
    throw messages.invalidKey();
  }

  // Validate key if we have goals
  if (!!goals && !customEventExists(key)) {
    console.warn(messages.unknownCustomEventKey(key));
  }

  events.enqueue({
    kind: 'custom',
    key: key,
    data: data,
    url: window.location.href,
    creationDate: (new Date()).getTime()
  });
}

function connectStream() {
  stream.connect(function() {
    requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
      if (err) {
        console.warn('Error fetching flag settings: ', err);
      }      
      updateSettings(settings);
    });
  });
}

function updateSettings(settings) {
  var changes;
  var keys;

  if (!settings) { return; }

  changes = utils.modifications(flags, settings);
  keys = Object.keys(changes);

  flags = settings;

  if (useLocalStorage) {
    localStorage.setItem(lsKey(environment, ident.getUser()), JSON.stringify(flags));
  }

  if (keys.length > 0) {
    keys.forEach(function(key) {
      emitter.emit(changeEvent + ':' + key, changes[key].current, changes[key].previous);
    });

    emitter.emit(changeEvent, changes);

    keys.forEach(function(key) {
      sendFlagEvent(key, changes[key].current);
    });
  }
}

function on(event, handler, context) {
  if (event.substr(0, changeEvent.length) === changeEvent) {
    if (!stream.isConnected()) {
      connectStream();
    }
    emitter.on.apply(emitter, [event, handler, context]);
  } else {
    emitter.on.apply(emitter, Array.prototype.slice.call(arguments));
  }
}

function off() {
  emitter.off.apply(emitter, Array.prototype.slice.call(arguments));
}

function handleMessage(event) {
  if (event.origin !== baseUrl) { return; }
  if (event.data.type === 'SYN') {
    window.editorClientBaseUrl = baseUrl;
    var editorTag = document.createElement('script');
    editorTag.type = 'text/javascript';
    editorTag.async = true;
    editorTag.src = baseUrl + event.data.editorClientUrl;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(editorTag, s);
  }
}

var client = {
  identify: identify,
  variation: variation,
  track: track,
  on: on,
  off: off,
  allFlags: allFlags
};

function lsKey(env, user) {
  var uKey = '';
  if (user && user.key) {
    uKey = user.key;
  }
  return 'ld:' + env + ':' + uKey;
}

function initialize(env, user, options) {
  var localStorageKey;
  options = options || {};
  environment = env;
  flags = typeof(options.bootstrap) === 'object' ? options.bootstrap : {};
  hash = options.hash;
  baseUrl = options.baseUrl || 'https://app.launchdarkly.com';
  eventsUrl = options.eventsUrl || 'https://events.launchdarkly.com';
  streamUrl = options.streamUrl || 'https://clientstream.launchdarkly.com';
  stream = Stream(streamUrl, environment);
  events = EventProcessor(eventsUrl + '/a/' + environment + '.gif');
  emitter = EventEmitter();
  ident = Identity(user, sendIdentifyEvent);
  requestor = Requestor(baseUrl, environment);
  localStorageKey = lsKey(environment, ident.getUser());

  if (typeof options.bootstrap === 'object') {
    // Emitting the event here will happen before the consumer
    // can register a listener, so defer to next tick.
    setTimeout(function() { emitter.emit(readyEvent); }, 0);
  }
  else if (typeof(options.bootstrap) === 'string' && options.bootstrap.toUpperCase() === 'LOCALSTORAGE' && typeof(Storage) !== 'undefined') {
    useLocalStorage = true;
    // check if localstorage data is corrupted, if so clear it
    try {
      flags = JSON.parse(localStorage.getItem(localStorageKey));
    } catch (error) {
      localStorage.setItem(localStorageKey, null);
    }

    if (flags === null) {
      requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
        if (err) {
          console.warn('Error fetching flag settings: ', err);
        }        
        flags = settings;
        settings && localStorage.setItem(localStorageKey, JSON.stringify(flags));
        emitter.emit(readyEvent);
      });
    } else {
      // We're reading the flags from local storage. Signal that we're ready,
      // then update localStorage for the next page load. We won't signal changes or update
      // the in-memory flags unless you subscribe for changes
      setTimeout(function() { emitter.emit(readyEvent); }, 0);
      requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
        if (err) {
          console.warn('Error fetching flag settings: ', err);
        }
        settings && localStorage.setItem(localStorageKey, JSON.stringify(settings));
      });
    }
  }
  else {
    requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
      if (err) {
        console.warn('Error fetching flag settings: ', err);
      }
      
      flags = settings;
      emitter.emit(readyEvent);
    });
  }

  requestor.fetchGoals(function(err, g) {
    if (err) { 
      console.warn('Error fetching goals: ', err);
    }
    if (g && g.length > 0) {
      goals = g;
      goalTracker = GoalTracker(goals, sendGoalEvent);
    }
  });

  function start() {
    setTimeout(function tick() {
      events.flush(ident.getUser());
      setTimeout(tick, flushInterval);
    }, flushInterval);
  }

  if (document.readyState !== 'complete') {
    window.addEventListener('load', start);
  } else {
    start();
  }

  window.addEventListener('beforeunload', function() {
    events.flush(ident.getUser(), true);
  });

  function refreshGoalTracker() {
    if (goalTracker) {
      goalTracker.dispose();
    }
    if (goals && goals.length) {
      goalTracker = GoalTracker(goals, sendGoalEvent);
    }
  }

  if (goals && goals.length > 0) {
    if (!!(window.history && history.pushState)) {
      window.addEventListener('popstate', refreshGoalTracker);
    } else {
      window.addEventListener('hashchange', refreshGoalTracker);
    }
  }

  window.addEventListener('message', handleMessage);

  return client;
}

module.exports = {
  initialize: initialize
};

if(typeof VERSION !== 'undefined') {
  module.exports.version = VERSION;
}


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(224);

function EventProcessor(eventsUrl) {
  var processor = {};
  var queue = [];
  var initialFlush = true;
  
  processor.enqueue = function(event) {
    queue.push(event);
  };
  
  processor.flush = function(user, sync) {
    var maxLength = 2000 - eventsUrl.length;
    var data = [];
    
    if (!user) {
      if (initialFlush) {
        console && console.warn && console.warn('Be sure to call `identify` in the LaunchDarkly client: http://docs.launchdarkly.com/docs/running-an-ab-test#include-the-client-side-snippet');
      }
      return false;
    }
    
    initialFlush = false;
    while (maxLength > 0 && queue.length > 0) {
      var event = queue.pop();
      event.user = user;
      maxLength = maxLength - utils.base64URLEncode(JSON.stringify(event)).length;
      // If we are over the max size, put this one back on the queue
      // to try in the next round, unless this event alone is larger 
      // than the limit, in which case, screw it, and try it anyway.
      if (maxLength < 0 && data.length > 0) {
        queue.push(event);
      } else {
        data.push(event);
      }
    }
    
    if (data.length > 0) {
      var src = eventsUrl + '?d=' + utils.base64URLEncode(JSON.stringify(data));
      //Detect browser support for CORS
      if ('withCredentials' in new XMLHttpRequest()) {
        /* supports cross-domain requests */
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, !sync);
        xhr.send();
      } else {
        var img = new Image();
        img.src = src;
      }
    }

    // if the queue is not empty, call settimeout to flush it again 
    // with a 0 timeout (stack-less recursion)
    // Or, just recursively call flush_queue with the remaining elements
    // if we're doing this on unload
    if (queue.length > 0) {
      if (sync) {
        processor.flush(user, sync);
      }
      else {
        setTimeout(function() {
          processor.flush(user);
        }, 0);
      }
    }
    return false;
  };
  
  return processor;
}

module.exports = EventProcessor;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

;(function () {

  var object =  true ? exports : self; // #8: web workers
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  function InvalidCharacterError(message) {
    this.message = message;
  }
  InvalidCharacterError.prototype = new Error;
  InvalidCharacterError.prototype.name = 'InvalidCharacterError';

  // encoder
  // [https://gist.github.com/999166] by [https://github.com/nignag]
  object.btoa || (
  object.btoa = function (input) {
    var str = String(input);
    for (
      // initialize result and counter
      var block, charCode, idx = 0, map = chars, output = '';
      // if the next str index does not exist:
      //   change the mapping table to "="
      //   check if d has no fractional digits
      str.charAt(idx | 0) || (map = '=', idx % 1);
      // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
      output += map.charAt(63 & block >> 8 - idx % 1 * 8)
    ) {
      charCode = str.charCodeAt(idx += 3/4);
      if (charCode > 0xFF) {
        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
      }
      block = block << 8 | charCode;
    }
    return output;
  });

  // decoder
  // [https://gist.github.com/1020396] by [https://github.com/atk]
  object.atob || (
  object.atob = function (input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) {
      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    }
    for (
      // initialize result and counters
      var bc = 0, bs, buffer, idx = 0, output = '';
      // get next character
      buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  });

}());


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

function EventEmitter() {
  var emitter = {};
  var events = {};
  
  emitter.on = function(event, handler, context) {
    events[event] = events[event] || [];
    events[event] = events[event].concat({handler: handler, context: context});
  };
  
  emitter.off = function(event, handler, context) {
    if (!events[event]) { return; }
    for (var i = 0; i < events[event].length ; i++) {
      if (events[event][i].handler === handler && events[event][i].context === context) {
        events[event] = events[event].slice(0, i).concat(events[event].slice(i + 1));
      }
    }
  };
  
  emitter.emit = function(event) { 
    if (!events[event]) { return; }
    for (var i = 0; i < events[event].length; i++) {
      events[event][i].handler.apply(events[event][i].context, Array.prototype.slice.call(arguments, 1));
    }
  };
  
  return emitter;
}

module.exports = EventEmitter;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var escapeStringRegexp = __webpack_require__(1199);

function doesUrlMatch(matcher, href, search, hash) {
  var canonicalUrl = href.replace(search, '').replace(hash, '');
  var regex;
  var testUrl;
  
  switch (matcher.kind) {
  case 'exact':
    testUrl = href;
    regex = new RegExp('^' + escapeStringRegexp(matcher.url) + '/?$');
    break;
  case 'canonical':
    testUrl = canonicalUrl;
    regex = new RegExp('^' + escapeStringRegexp(matcher.url) + '/?$');
    break;
  case 'substring':
    testUrl = canonicalUrl;
    regex = new RegExp('.*' + escapeStringRegexp(matcher.substring) + '.*$');
    break;
  case 'regex':
    testUrl = canonicalUrl;
    regex = new RegExp(matcher.pattern);
    break;
  default:
    return false;
  }
  return regex.test(testUrl);
}

function findGoalsForClick(event, clickGoals) {
  var matches = [];
  
  for (var i = 0; i < clickGoals.length; i++) {
    var target = event.target;
    var goal = clickGoals[i];
    var selector = goal.selector;
    var elements = document.querySelectorAll(selector);
    while (target && elements.length > 0) {
      for (var j = 0; j < elements.length; j++) {
        if (target === elements[j])
          matches.push(goal);
      }
      target = target.parentNode;
    }
  }
  
  return matches;
}

function GoalTracker(goals, onEvent) {
  var tracker = {};
  var goals = goals;
  var listenerFn = null;
  
  var clickGoals = [];
  
  for (var i = 0; i < goals.length; i++) {
    var goal = goals[i];
    var urls = goal.urls || [];
    
    for (var j = 0; j < urls.length; j++) {
      if (doesUrlMatch(urls[j], location.href, location.search, location.hash)) {
        if (goal.kind === 'pageview') {
          onEvent('pageview', goal);
        } else {
          clickGoals.push(goal);
          onEvent('click_pageview', goal);
        }
        break;
      }
    }
  }
  
  if (clickGoals.length > 0) {
    listenerFn = function(event) {
      var goals = findGoalsForClick(event, clickGoals);
      for (var i = 0; i < goals.length; i++) {
        onEvent('click', goals[i]);
      }
    };

    document.addEventListener('click', listenerFn);
  }

  tracker.dispose = function() {
    document.removeEventListener('click', listenerFn);
  }
  
  return tracker;
}

module.exports = GoalTracker;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

function Stream(url, environment) {
  var stream = {};
  var url = url + '/ping/' + environment;
  var es = null;

  stream.connect = function(onPing) {
    if (typeof EventSource !== 'undefined') {
      es = new window.EventSource(url);
      es.addEventListener('ping', onPing);
    }
  }

  stream.disconnect = function() {
    es && es.close();
  }

  stream.isConnected = function() {
    return es && (es.readyState === EventSource.OPEN || es.readyState === EventSource.CONNECTING);
  }

  return stream;
}

module.exports = Stream;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(224);

var json = 'application/json';

function fetchJSON(endpoint, callback) {
  var xhr = new XMLHttpRequest();
  
  xhr.addEventListener('load', function() {
    if (xhr.status === 200 && xhr.getResponseHeader('Content-type') === json) {
      callback(null, JSON.parse(xhr.responseText));
    } else {
      callback(xhr.statusText);
    }
  });
  
  xhr.addEventListener('error', function() {
    callback(xhr.statusText);
  });
  
  xhr.open('GET', endpoint);
  xhr.send();
  
  return xhr;
}

var flagSettingsRequest;
var lastFlagSettingsCallback;

function Requestor(baseUrl, environment) {
  var requestor = {};
  
  requestor.fetchFlagSettings = function(user, hash, callback) {
    var data = utils.base64URLEncode(JSON.stringify(user));
    var endpoint = [baseUrl, '/sdk/eval/', environment,  '/users/', data, hash ? '?h=' + hash : ''].join('');
    var cb;

    var wrappedCallback = (function(currentCallback) {
      return function() {
        currentCallback.apply(null, arguments);
        flagSettingsRequest = null;
        lastFlagSettingsCallback = null;
      };
    })(callback);
    

    if (flagSettingsRequest) {
      flagSettingsRequest.abort();
      cb = (function(prevCallback) {
        return function() {
          prevCallback && prevCallback.apply(null, arguments);
          wrappedCallback.apply(null, arguments);
        };
      })(lastFlagSettingsCallback);
    } else {
      cb = wrappedCallback;
    }

    lastFlagSettingsCallback = cb;
    flagSettingsRequest = fetchJSON(endpoint, cb);
  };
  
  requestor.fetchGoals = function(callback) {
    var endpoint = [baseUrl, '/sdk/goals/', environment].join('');
    fetchJSON(endpoint, callback);
  };
  
  return requestor;
}

module.exports = Requestor;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(224);

function sanitizeUser(u) {
  var sane = utils.clone(u);
  if (sane.key) {
    sane.key = sane.key.toString();
  }
  return sane;
}

function Identity(initialUser, onChange) {
  var ident = {};
  var user;
  
  ident.setUser = function(u) {
    user = sanitizeUser(u);
    onChange(utils.clone(user));
  };
  
  ident.getUser = function() {
    return utils.clone(user);
  };
  
  if (initialUser) {
    ident.setUser(initialUser);
  }
  
  return ident;
}

module.exports = Identity;


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports ={
  invalidKey: function() {
    return 'Event key must be a string';
  },
  unknownCustomEventKey: function(key) {
    return 'Custom event "' + key + '" does not exist'
  }
};


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPropertyEqualSelector = exports.createDeepEqualSelector = undefined;

var _reselect = __webpack_require__(33);

var _equals = __webpack_require__(408);

var _equals2 = _interopRequireDefault(_equals);

var _eqProps = __webpack_require__(1212);

var _eqProps2 = _interopRequireDefault(_eqProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createDeepEqualSelector = exports.createDeepEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _equals2.default);

var createPropertyEqualSelector = exports.createPropertyEqualSelector = function createPropertyEqualSelector(key) {
  return (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, (0, _eqProps2.default)(key));
};

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var _arrayFromIterator = /*#__PURE__*/__webpack_require__(1206);

var _containsWith = /*#__PURE__*/__webpack_require__(1207);

var _functionName = /*#__PURE__*/__webpack_require__(1208);

var _has = /*#__PURE__*/__webpack_require__(324);

var identical = /*#__PURE__*/__webpack_require__(1209);

var keys = /*#__PURE__*/__webpack_require__(753);

var type = /*#__PURE__*/__webpack_require__(1211);

/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b = _arrayFromIterator(bIterator);

  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }

  // if *a* array contains any element that is not included in *b*
  return !_containsWith(function (b, aItem) {
    return !_containsWith(eq, aItem, b);
  }, b, a);
}

function _equals(a, b, stackA, stackB) {
  if (identical(a, b)) {
    return true;
  }

  var typeA = type(a);

  if (typeA !== type(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!identical(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys(a);
  if (keysA.length !== keys(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);

  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}
module.exports = _equals;

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
module.exports = _arrayFromIterator;

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
module.exports = _containsWith;

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}
module.exports = _functionName;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__(249);

/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */


var identical = /*#__PURE__*/_curry2(function identical(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
});
module.exports = identical;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var _has = /*#__PURE__*/__webpack_require__(324);

var toString = Object.prototype.toString;
var _isArguments = function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
};

module.exports = _isArguments;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__(192);

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */


var type = /*#__PURE__*/_curry1(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
module.exports = type;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = /*#__PURE__*/__webpack_require__(731);

var equals = /*#__PURE__*/__webpack_require__(408);

/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */


var eqProps = /*#__PURE__*/_curry3(function eqProps(prop, obj1, obj2) {
  return equals(obj1[prop], obj2[prop]);
});
module.exports = eqProps;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1214),
    getMatchData = __webpack_require__(1219),
    matchesStrictComparable = __webpack_require__(529);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(217),
    baseIsEqual = __webpack_require__(325);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(217),
    equalArrays = __webpack_require__(1216),
    equalByTag = __webpack_require__(1217),
    equalObjects = __webpack_require__(1218),
    getTag = __webpack_require__(225),
    isArray = __webpack_require__(27),
    isBuffer = __webpack_require__(220),
    isTypedArray = __webpack_require__(316);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(261),
    arraySome = __webpack_require__(794),
    cacheHas = __webpack_require__(262);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(527);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(528),
    keys = __webpack_require__(154);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(325),
    get = __webpack_require__(418),
    hasIn = __webpack_require__(531),
    isKey = __webpack_require__(326),
    isStrictComparable = __webpack_require__(528),
    matchesStrictComparable = __webpack_require__(529),
    toKey = __webpack_require__(109);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1221 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(136),
    isArguments = __webpack_require__(219),
    isArray = __webpack_require__(27),
    isIndex = __webpack_require__(227),
    isLength = __webpack_require__(512),
    toKey = __webpack_require__(109);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1225),
    basePropertyDeep = __webpack_require__(1226),
    isKey = __webpack_require__(326),
    toKey = __webpack_require__(109);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(226);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(119),
    baseIteratee = __webpack_require__(57),
    basePickBy = __webpack_require__(532),
    getAllKeysIn = __webpack_require__(329);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(317),
    castPath = __webpack_require__(136),
    isIndex = __webpack_require__(227),
    isObject = __webpack_require__(71),
    toKey = __webpack_require__(109);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1230 */
/***/ (function(module, exports) {

/*!
 * search-query-parser.js
 * Copyright(c) 2014 Julien Buty <julien@nepsilon.net>
 * MIT Licensed
 */

exports.parse = function (string, options) {

  // Set an empty options object when none provided
  if (!options) {
    options = {};
  }

  if (!string) {
    string = '';
  }

  // When a simple string, return it
  if (-1 === string.indexOf(':')) {
    return string;
  }
  // When no keywords or ranges set, treat as a simple string
  else if (!options.keywords && !options.ranges){
    return string;
  }
  // Otherwise parse the advanced query syntax
  else {
    // Our object to store the query object
    var query = {text: [], offsets: []};
    var exclusion = {};
    var terms = [];
    // Get a list of search terms respecting single and double quotes
    var regex = /(\S+:'(?:[^'\\]|\\.)*')|(\S+:"(?:[^"\\]|\\.)*")|\S+|\S+:\S+/g;
    var match;
    while ((match = regex.exec(string)) !== null) {
      var term = match[0];
      var sepIndex = term.indexOf(':');
      if (sepIndex !== -1) {
        var split = term.split(':'),
            key = term.slice(0, sepIndex),
            val = term.slice(sepIndex + 1);
        // Strip surrounding quotes
        val = val.replace(/^\"|\"$|^\'|\'$/g, '');
        // Strip backslashes respecting escapes
        val = (val + '').replace(/\\(.?)/g, function (s, n1) {
          switch (n1) {
          case '\\':
            return '\\';
          case '0':
            return '\u0000';
          case '':
            return '';
          default:
            return n1;
          }
        });
        terms.push({
          keyword: key,
          value: val,
          offsetStart: match.index,
          offsetEnd: match.index + term.length
        });
      } else {
        terms.push({
          text: term,
          offsetStart: match.index,
          offsetEnd: match.index + term.length
        });
      }
    }
    // Reverse to ensure proper order when pop()'ing.
    terms.reverse();
    // For each search term
    var term;
    while (term = terms.pop()) {
      // When just a simple term
      if (term.text) {
        // We add it as pure text
        query.text.push(term.text);
        query.offsets.push(term);
      }
      // We got an advanced search syntax
      else {
        var key = term.keyword;
        // Check if the key is a registered keyword
        options.keywords = options.keywords || [];
        var isKeyword = false;
        var isExclusion = false;
        if (!/^-/.test(key)) {
            isKeyword = !(-1 === options.keywords.indexOf(key));
        } else  if (key[0] === '-') {
            var _key = key.slice(1);
            isKeyword = !(-1 === options.keywords.indexOf(_key))
            if (isKeyword) {
                key = _key;
                isExclusion = true;
            }
        }

        // Check if the key is a registered range
        options.ranges = options.ranges || [];
        var isRange = !(-1 === options.ranges.indexOf(key));
        // When the key matches a keyword
        if (isKeyword) {
          query.offsets.push({
            keyword: key,
            value: term.value,
            offsetStart: isExclusion ? term.offsetStart + 1 : term.offsetStart,
            offsetEnd: term.offsetEnd
          });

          var value = term.value;
          // When value is a thing
          if (value.length) {
            // Get an array of values when several are there
            var values = value.split(',');
            if (isExclusion) {
              if (exclusion[key]) {
                // ...many times...
                if (exclusion[key] instanceof Array) {
                  // ...and got several values this time...
                  if (values.length > 1) {
                    // ... concatenate both arrays.
                    exclusion[key] = exclusion[key].concat(values);
                  }
                  else {
                    // ... append the current single value.
                    exclusion[key].push(value);
                  }
                }
                // We saw that keyword only once before
                else {
                  // Put both the current value and the new
                  // value in an array
                  exclusion[key] = [exclusion[key]];
                  exclusion[key].push(value);
                }
              }
              // First time we see that keyword
              else {
                // ...and got several values this time...
                if (values.length > 1) {
                  // ...add all values seen.
                  exclusion[key] = values;
                }
                // Got only a single value this time
                else {
                  // Record its value as a string
                  exclusion[key] = value;
                }
              }
            } else {
              // If we already have seen that keyword...
              if (query[key]) {
                // ...many times...
                if (query[key] instanceof Array) {
                  // ...and got several values this time...
                  if (values.length > 1) {
                    // ... concatenate both arrays.
                    query[key] = query[key].concat(values);
                  }
                  else {
                    // ... append the current single value.
                    query[key].push(value);
                  }
                }
                // We saw that keyword only once before
                else {
                  // Put both the current value and the new
                  // value in an array
                  query[key] = [query[key]];
                  query[key].push(value);
                }
              }
              // First time we see that keyword
              else {
                // ...and got several values this time...
                if (values.length > 1) {
                  // ...add all values seen.
                  query[key] = values;
                }
                // Got only a single value this time
                else {
                  // Record its value as a string
                  query[key] = value;
                }
              }
            }
          }
        }
        // The key allows a range
        else if (isRange) {
          query.offsets.push(term);

          var value = term.value;
          // Range are separated with a dash
          var rangeValues = value.split('-');
          // When both end of the range are specified
          // keyword:XXXX-YYYY
          query[key] = {};
          if (2 === rangeValues.length) {
            query[key].from = rangeValues[0];
            query[key].to = rangeValues[1];
          }
          // When pairs of ranges are specified
          // keyword:XXXX-YYYY,AAAA-BBBB
          else if (!rangeValues.length % 2) {
          }
          // When only getting a single value,
          // or an odd number of values
          else {
            query[key].from = value;
          }
        }
        else {
          // We add it as pure text
          var text = term.keyword + ':' + term.value;
          query.text.push(text);

          query.offsets.push({
            text: text,
            offsetStart: term.offsetStart,
            offsetEnd: term.offsetEnd
          });
        }
      }
    }

    // Concatenate all text terms if any
    if (query.text.length) {
      query.text = query.text.join(' ').trim();
    }
    // Just remove the attribute text when it's empty
    else {
      delete query.text;
    }

    // Return forged query object
    query.exclude = exclusion;
    return query;
  }

};


/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g


/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

var noCase = __webpack_require__(78)

/**
 * Dot case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '.')
}


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var upperCase = __webpack_require__(85)
var lowerCase = __webpack_require__(169)

/**
 * Swap the case of a string. Manually iterate over every character and check
 * instead of replacing certain characters for better unicode support.
 *
 * @param  {String} str
 * @param  {String} [locale]
 * @return {String}
 */
module.exports = function (str, locale) {
  if (str == null) {
    return ''
  }

  var result = ''

  for (var i = 0; i < str.length; i++) {
    var c = str[i]
    var u = upperCase(c, locale)

    result += u === c ? lowerCase(c, locale) : u
  }

  return result
}


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var noCase = __webpack_require__(78)

/**
 * Path case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '/')
}


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var noCase = __webpack_require__(78)
var upperCase = __webpack_require__(85)

/**
 * Title case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale).replace(/^.| ./g, function (m) {
    return upperCase(m, locale)
  })
}


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var noCase = __webpack_require__(78)

/**
 * Param case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '-')
}


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var noCase = __webpack_require__(78)
var upperCase = __webpack_require__(85)

/**
 * Header case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '-').replace(/^.|-./g, function (m) {
    return upperCase(m, locale)
  })
}


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var camelCase = __webpack_require__(534)
var upperCaseFirst = __webpack_require__(330)

/**
 * Pascal case a string.
 *
 * @param  {string}  value
 * @param  {string}  [locale]
 * @param  {boolean} [mergeNumbers]
 * @return {string}
 */
module.exports = function (value, locale, mergeNumbers) {
  return upperCaseFirst(camelCase(value, locale, mergeNumbers), locale)
}


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var upperCase = __webpack_require__(85)
var snakeCase = __webpack_require__(535)

/**
 * Constant case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return upperCase(snakeCase(value, locale), locale)
}


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var noCase = __webpack_require__(78)
var upperCaseFirst = __webpack_require__(330)

/**
 * Sentence case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return upperCaseFirst(noCase(value, locale), locale)
}


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var upperCase = __webpack_require__(85)

/**
 * Check if a string is upper case.
 *
 * @param  {String}  string
 * @param  {String}  [locale]
 * @return {Boolean}
 */
module.exports = function (string, locale) {
  return upperCase(string, locale) === string
}


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var lowerCase = __webpack_require__(169)

/**
 * Check if a string is lower case.
 *
 * @param  {String}  string
 * @param  {String}  [locale]
 * @return {Boolean}
 */
module.exports = function (string, locale) {
  return lowerCase(string, locale) === string
}


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

var lowerCase = __webpack_require__(169)

/**
 * Lower case the first character of a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  if (str == null) {
    return ''
  }

  str = String(str)

  return lowerCase(str.charAt(0), locale) + str.substr(1)
}


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(537);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(538);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = exports.group = exports.identify = undefined;

var _reselect = __webpack_require__(33);

var _segment = __webpack_require__(536);

var _session = __webpack_require__(117);

var identify = exports.identify = (0, _reselect.createSelector)(_session.session, function (session) {
  if (!session) return null;
  var userId = session.userID,
      email = session.email,
      username = session.username;

  return {
    type: _segment.IDENTIFY,
    payload: {
      userId: userId,
      traits: {
        email: email,
        username: username
      }
    }
  };
});

var group = exports.group = (0, _reselect.createSelector)(_session.session, function (session) {
  if (!session) return null;
  var groupId = session.teamName;

  return {
    type: _segment.GROUP,
    payload: { groupId: groupId }
  };
});

var reset = exports.reset = (0, _reselect.createSelector)(_session.session, function (session) {
  return session ? null : { type: _segment.RESET };
});

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relay = relay;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _rollbar = __webpack_require__(539);

var _rollbar2 = _interopRequireDefault(_rollbar);

var _auth = __webpack_require__(92);

var _debugging = __webpack_require__(1250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function relay(dispatch, state, action) {
  var type = action.type;

  switch (type) {
    case _auth.AUTHENTICATION_INVALIDATE:
      return dispatch({ type: _rollbar.RESET });
    case _api2.default.INITIALIZE:
    case _auth.AUTHENTICATION_SUCCESS:
      dispatch((0, _debugging.identify)(state));

    default:
  }
}

var tracker = (0, _rollbar2.default)(relay);

exports.default = tracker;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = exports.identify = undefined;

var _reselect = __webpack_require__(33);

var _rollbar = __webpack_require__(539);

var _session = __webpack_require__(117);

var identify = exports.identify = (0, _reselect.createSelector)(_session.session, function (session) {
  if (!session) return null;
  var id = session.userID,
      email = session.email,
      username = session.username;

  return {
    type: _rollbar.IDENTIFY,
    payload: {
      person: {
        id: id,
        email: email,
        username: username
      }
    }
  };
});

var reset = exports.reset = (0, _reselect.createSelector)(_session.session, function (session) {
  return session ? null : { type: _rollbar.RESET };
});

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relay = relay;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _launchdarkly = __webpack_require__(525);

var _launchdarkly2 = _interopRequireDefault(_launchdarkly);

var _auth = __webpack_require__(92);

var _feature = __webpack_require__(145);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function relay(dispatch, state, action) {
  // eslint-disable-next-line no-unused-vars
  var type = action.type,
      payload = action.payload,
      _action$response = action.response,
      response = _action$response === undefined ? {} : _action$response;


  switch (type) {
    case _auth.AUTHENTICATION_INVALIDATE:
      dispatch((0, _feature.reset)(state));
      return;
    case _api2.default.INITIALIZE:
      dispatch((0, _feature.identify)(state));
      return;
    case _auth.AUTHENTICATION_SUCCESS:
      // Session entity doesn't exist, so pull the user out of the
      // response
      var id = response.result,
          _response$entities = response.entities;
      _response$entities = _response$entities === undefined ? {} : _response$entities;
      var _response$entities$us = _response$entities.users,
          users = _response$entities$us === undefined ? {} : _response$entities$us;

      var session = users[id];
      dispatch((0, _feature.identify)({ session: session }));

    default:
  }
}

var tracker = (0, _launchdarkly2.default)(relay, (0, _launchdarkly.createClient)(_env2.default.PUSHBOT_LAUNCHDARKLY_ID));

exports.default = tracker;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(80);

var _reduxLocalstorage = __webpack_require__(1253);

var _reduxLocalstorage2 = _interopRequireDefault(_reduxLocalstorage);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minor_version = _env2.default.PUSHBOT_VERSION.split('.') // eslint-disable-line camelcase
.splice(0, 2).join('.');

var localStore = (0, _redux.compose)((0, _reduxLocalstorage2.default)('storage', {
  key: _env2.default.PUSHBOT_NAME + '@' + minor_version // eslint-disable-line camelcase
}));

exports.default = localStore;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = persistState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createSlicerJs = __webpack_require__(1254);

var _createSlicerJs2 = _interopRequireDefault(_createSlicerJs);

var _utilMergeStateJs = __webpack_require__(1257);

var _utilMergeStateJs2 = _interopRequireDefault(_utilMergeStateJs);

/**
 * @description
 * persistState is a Store Enhancer that syncs (a subset of) store state to localStorage.
 *
 * @param {String|String[]} [paths] Specify keys to sync with localStorage, if left undefined the whole store is persisted
 * @param {Object} [config] Optional config object
 * @param {String} [config.key="redux"] String used as localStorage key
 * @param {Function} [config.slicer] (paths) => (state) => subset. A function that returns a subset
 * of store state that should be persisted to localStorage
 * @param {Function} [config.serialize=JSON.stringify] (subset) => serializedData. Called just before persisting to
 * localStorage. Should transform the subset into a format that can be stored.
 * @param {Function} [config.deserialize=JSON.parse] (persistedData) => subset. Called directly after retrieving
 * persistedState from localStorage. Should transform the data into the format expected by your application
 *
 * @return {Function} An enhanced store
 */

function persistState(paths, config) {
  var cfg = _extends({
    key: 'redux',
    merge: _utilMergeStateJs2['default'],
    slicer: _createSlicerJs2['default'],
    serialize: JSON.stringify,
    deserialize: JSON.parse
  }, config);

  var key = cfg.key;
  var merge = cfg.merge;
  var slicer = cfg.slicer;
  var serialize = cfg.serialize;
  var deserialize = cfg.deserialize;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
        enhancer = initialState;
        initialState = undefined;
      }

      var persistedState = undefined;
      var finalInitialState = undefined;

      try {
        persistedState = deserialize(localStorage.getItem(key));
        finalInitialState = merge(initialState, persistedState);
      } catch (e) {
        console.warn('Failed to retrieve initialize state from localStorage:', e);
      }

      var store = next(reducer, finalInitialState, enhancer);
      var slicerFn = slicer(paths);

      store.subscribe(function () {
        var state = store.getState();
        var subset = slicerFn(state);

        try {
          localStorage.setItem(key, serialize(subset));
        } catch (e) {
          console.warn('Unable to persist state to localStorage:', e);
        }
      });

      return store;
    };
  };
}

module.exports = exports['default'];

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = createSlicer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _getSubsetJs = __webpack_require__(1255);

var _getSubsetJs2 = _interopRequireDefault(_getSubsetJs);

var _utilTypeOfJs = __webpack_require__(1256);

var _utilTypeOfJs2 = _interopRequireDefault(_utilTypeOfJs);

/**
 * @description
 * createSlicer inspects the typeof paths and returns an appropriate slicer function.
 *
 * @param {String|String[]} [paths] The paths argument supplied to persistState.
 *
 * @return {Function} A slicer function, which returns the subset to store when called with Redux's store state.
 */

function createSlicer(paths) {
  switch ((0, _utilTypeOfJs2['default'])(paths)) {
    case 'void':
      return function (state) {
        return state;
      };
    case 'string':
      return function (state) {
        return (0, _getSubsetJs2['default'])(state, [paths]);
      };
    case 'array':
      return function (state) {
        return (0, _getSubsetJs2['default'])(state, paths);
      };
    default:
      return console.error('Invalid paths argument, should be of type String, Array or Void');
  }
}

module.exports = exports['default'];

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @description
 * getSubset returns an object with the same structure as the original object passed in,
 * but contains only the specified keys and only if that key has a truth-y value.
 *
 * @param {Object} obj The object from which to create a subset.
 * @param {String[]} paths An array of (top-level) keys that should be included in the subset.
 *
 * @return {Object} An object that contains the specified keys with truth-y values
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSubset;

function getSubset(obj, paths) {
  var subset = {};

  paths.forEach(function (key) {
    var slice = obj[key];
    if (slice) subset[key] = slice;
  });

  return subset;
}

module.exports = exports["default"];

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = typeOf;
var _isArray = Array.isArray || (Array.isArray = function (a) {
  return '' + a !== a && ({}).toString.call(a) === '[object Array]';
});

/**
 * @description
 * typeof method that
 * 1. groups all false-y & empty values as void
 * 2. distinguishes between object and array
 *
 * @param {*} thing The thing to inspect
 *
 * @return {String} Actionable type classification
 */

function typeOf(thing) {
  if (!thing) return 'void';

  if (_isArray(thing)) {
    if (!thing.length) return 'void';
    return 'array';
  }

  return typeof thing;
}

module.exports = exports['default'];

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = mergeState;

function mergeState(initialState, persistedState) {
  return persistedState ? _extends({}, initialState, persistedState) : initialState;
}

module.exports = exports["default"];

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(80);

var _app = __webpack_require__(1259);

var _app2 = _interopRequireDefault(_app);

var _entities = __webpack_require__(1260);

var _entities2 = _interopRequireDefault(_entities);

var _feature = __webpack_require__(1423);

var _feature2 = _interopRequireDefault(_feature);

var _features = __webpack_require__(1424);

var _features2 = _interopRequireDefault(_features);

var _config = __webpack_require__(1425);

var _config2 = _interopRequireDefault(_config);

var _session = __webpack_require__(1426);

var _session2 = _interopRequireDefault(_session);

var _page = __webpack_require__(1428);

var _page2 = _interopRequireDefault(_page);

var _storage = __webpack_require__(1466);

var _storage2 = _interopRequireDefault(_storage);

var _flash = __webpack_require__(1471);

var _flash2 = _interopRequireDefault(_flash);

var _toast = __webpack_require__(1473);

var _toast2 = _interopRequireDefault(_toast);

var _team = __webpack_require__(1474);

var _team2 = _interopRequireDefault(_team);

var _trigger = __webpack_require__(1475);

var _trigger2 = _interopRequireDefault(_trigger);

var _reactRouterRedux = __webpack_require__(331);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line
exports.default = (0, _redux.combineReducers)({
  app: _app2.default,
  config: _config2.default,
  entities: _entities2.default,
  feature: _feature2.default,
  features: _features2.default,
  flash: _flash2.default,
  page: _page2.default,
  routing: _reactRouterRedux.routerReducer,
  session: _session2.default,
  storage: _storage2.default,
  toast: _toast2.default,
  trigger: _trigger2.default,
  team: _team2.default
});

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STATE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = app;

var _app = __webpack_require__(540);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_STATE = exports.DEFAULT_STATE = {
  appName: 'Catalytic',
  navigate: false,
  page: {},
  store: {}
};

function app() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      merge = _ref.merge,
      path = _ref.path,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  var _payload$appName = payload.appName,
      appName = _payload$appName === undefined ? state.appName : _payload$appName,
      _payload$navigate = payload.navigate,
      navigate = _payload$navigate === undefined ? state.navigate : _payload$navigate,
      search = payload.search,
      other = _objectWithoutProperties(payload, ['appName', 'navigate', 'search']);

  switch (type) {
    case _app.APP_UPDATE:
      {
        if (!path) return state;

        var currentPage = state.page[path] || {};

        var newState = !merge ? _extends({}, state, {
          appName: appName,
          navigate: navigate,
          page: _extends({}, state.page, _defineProperty({}, path, _extends({}, other)))
        }) : _extends({}, state, {
          appName: appName,
          navigate: navigate,
          page: _extends({}, state.page, _defineProperty({}, path, _extends({}, currentPage, other)))
        });

        if (payload.search) {
          var newCurrentPage = newState.page[path];

          newCurrentPage.search = !merge ? payload.search : _extends({}, currentPage.search, payload.search);
        }

        return newState;
      }
    case _app.APP_STORE:
      {
        if (!path) return state;

        return !merge ? _extends({}, state, {
          appName: appName,
          navigate: navigate,
          store: _extends({}, state.store, _defineProperty({}, path, other))
        }) : _extends({}, state, {
          appName: appName,
          navigate: navigate,
          store: _extends({}, state.store, _defineProperty({}, path, _extends({}, state.store[path], other)))
        });
      }
    case _app.APP_NAVIGATE:
      return _extends({}, state, { navigate: true });
    default:
      return state;
  }
}

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entities = __webpack_require__(1261);

var _entities2 = _interopRequireDefault(_entities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _entities2.default;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = entities;

var _clone = __webpack_require__(541);

var _clone2 = _interopRequireDefault(_clone);

var _keyBy = __webpack_require__(756);

var _keyBy2 = _interopRequireDefault(_keyBy);

var _omit = __webpack_require__(1274);

var _omit2 = _interopRequireDefault(_omit);

var _merge = __webpack_require__(546);

var util = _interopRequireWildcard(_merge);

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _reminder = __webpack_require__(1280);

var _user = __webpack_require__(187);

var _users = __webpack_require__(384);

var _team = __webpack_require__(118);

var _integrations = __webpack_require__(395);

var _apps = __webpack_require__(390);

var _contact = __webpack_require__(1281);

var _auth = __webpack_require__(92);

var _task = __webpack_require__(188);

var _step = __webpack_require__(394);

var _steps = __webpack_require__(758);

var _tasks = __webpack_require__(799);

var _filter = __webpack_require__(410);

var _invite = __webpack_require__(257);

var _run = __webpack_require__(185);

var _integration = __webpack_require__(258);

var _webform = __webpack_require__(411);

var _webhook = __webpack_require__(250);

var _webhooks = __webpack_require__(547);

var _predictor = __webpack_require__(728);

var _predictors = __webpack_require__(800);

var _processes = __webpack_require__(732);

var _search = __webpack_require__(389);

var _notifications = __webpack_require__(403);

var _group = __webpack_require__(760);

var _groups = __webpack_require__(701);

var _trigger = __webpack_require__(801);

var _triggers = __webpack_require__(705);

var _file = __webpack_require__(248);

var _fields = __webpack_require__(400);

var _process = __webpack_require__(387);

var _runs = __webpack_require__(557);

var _thread = __webpack_require__(729);

var _message = __webpack_require__(802);

var _comment = __webpack_require__(742);

var _table = __webpack_require__(708);

var _tables = __webpack_require__(1307);

var _tableRows = __webpack_require__(762);

var _field = __webpack_require__(723);

var _credential = __webpack_require__(812);

var _credentials = __webpack_require__(746);

var _schemas = __webpack_require__(8);

var schemas = _interopRequireWildcard(_schemas);

var _fields2 = __webpack_require__(388);

var fieldUtils = _interopRequireWildcard(_fields2);

var _processFields = __webpack_require__(1421);

var processFields = _interopRequireWildcard(_processFields);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GET_TRANSACTION_SUCCESS = _api2.default.GET_TRANSACTION_SUCCESS;


var DEFAULT_STATE = Object.keys(schemas).filter(function (k) {
  return schemas[k].key;
}) // eslint-disable-line import/namespace
.reduce(function (o, k) {
  return _extends({}, o, _defineProperty({}, schemas[k].key, {}));
}, {});

function entities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments[1];

  // eslint-disable-next-line no-unused-vars
  var newState = void 0,
      newProcesses = void 0;

  switch (action.type) {
    case _reminder.ADD_REMINDER_SUCCESS:

    case _team.GET_TEAM_SUCCESS: // eslint-disable-line no-fallthrough
    case _team.UPDATE_TEAM_SUCCESS:

    case _user.GET_USER_SUCCESS: // eslint-disable-line no-fallthrough
    case _user.UPDATE_USER_SUCCESS:
    case _users.GET_USERS_SUCCESS:

    case _apps.GET_APPS_SUCCESS: // eslint-disable-line no-fallthrough
    case _contact.GET_APP_CONTACT_SUCCESS:
    case _integrations.GET_INTEGRATIONS_SUCCESS:
    case _integration.GET_INTEGRATION_SUCCESS:
    case _integration.ADD_INTEGRATION_SUCCESS:

    case _task.GET_TASK_SUCCESS: // eslint-disable-line no-fallthrough
    case _task.ADD_TASK_SUCCESS:
    case _task.UPDATE_TASK_SUCCESS:
    case _task.COMPLETE_TASK_SUCCESS:
    case _tasks.GET_TASKS_SUCCESS:
    case _tasks.GET_USER_TASKS_SUCCESS:
    case GET_TRANSACTION_SUCCESS:

    case _invite.GET_INVITE_SUCCESS: // eslint-disable-line no-fallthrough
    case _invite.ADD_INVITE_SUCCESS:
    case _invite.ACCEPT_INVITE_SUCCESS:

    case _team.GET_AUTH_INFO_SUCCESS: // eslint-disable-line no-fallthrough

    case _auth.AUTHENTICATION_SUCCESS:
    case _webform.GET_WEBFORM_SUCCESS:
    case _webhook.GET_WEBHOOK_SUCCESS:

    case _process.GET_PROCESS_SUCCESS: // eslint-disable-line no-fallthrough
    case _process.ADD_PROCESS_SUCCESS:
    case _process.UPDATE_PROCESS_SUCCESS:
    case _processes.GET_PROCESSES_SUCCESS:

    case _steps.GET_STEPS_SUCCESS: // eslint-disable-line no-fallthrough
    case _step.GET_STEP_SUCCESS:
    case _step.ADD_STEP_SUCCESS:
    case _step.UPDATE_STEP_SUCCESS:

    case _run.GET_RUN_SUCCESS: // eslint-disable-line no-fallthrough
    case _runs.GET_RUNS_SUCCESS:
    case _run.UPDATE_RUN_SUCCESS:

    case _file.GET_FILE_OBJECT_SUCCESS: // eslint-disable-line no-fallthrough
    case _file.GET_FILE_SUCCESS:
    case _file.ADD_FILE_SUCCESS:

    case _thread.GET_THREAD_SUCCESS: // eslint-disable-line no-fallthrough
    case _thread.GET_THREAD_LIST_SUCCESS:

    case _message.ADD_MESSAGE_SUCCESS: // eslint-disable-line no-fallthrough
    case _comment.ADD_COMMENT_SUCCESS:
    case _notifications.GET_NOTIFICATIONS_SUCCESS:
    case _notifications.READ_NOTIFICATION_SUCCESS:
    case _trigger.GET_TRIGGER_SUCCESS:
    case _triggers.GET_TRIGGERS_FOR_PROCESS_SUCCESS:
    case _group.GET_GROUP_SUCCESS:
    case _groups.GET_GROUPS_SUCCESS:

    case _search.GET_SEARCH_RESULTS_SUCCESS: // eslint-disable-line no-fallthrough
    case _steps.UPDATE_STEPS_SUCCESS:

    case _table.GET_TABLE_SUCCESS: // eslint-disable-line no-fallthrough
    case _table.ADD_TABLE_SUCCESS:
    case _table.UPDATE_TABLE_SUCCESS:
    case _table.IMPORT_TABLE_SUCCESS:
    case _tables.GET_TABLES_SUCCESS:

    case _predictors.GET_PREDICTORS_SUCCESS: // eslint-disable-line no-fallthrough
    case _predictor.GET_PREDICTOR_SUCCESS:
    case _predictor.CREATE_PREDICTOR_SUCCESS:
    case _predictor.UPDATE_PREDICTOR_SUCCESS:

    case _filter.GET_FILTERS_SUCCESS: // eslint-disable-line no-fallthrough
    case _filter.ADD_FILTER_SUCCESS:

    case _credential.GET_CREDENTIAL_SUCCESS: // eslint-disable-line no-fallthrough
    case _credentials.GET_CREDENTIALS_SUCCESS:
    case _credential.ADD_CREDENTIAL_SUCCESS:
    case _credential.UPDATE_CREDENTIAL_SUCCESS:

    case _field.ADD_FIELD_SUCCESS: // eslint-disable-line no-fallthrough
    case _field.UPDATE_FIELD_SUCCESS:
      return util.merge(state, action.response.entities);

    case _tableRows.GET_TABLE_ROWS_SUCCESS:
      return _extends({}, state, {
        fields: _extends({}, state.fields, (action.response.entities || {}).fields),
        tableRows: _extends({}, state.tableRows, (action.response.entities || {}).tableRows)
      });
    case _user.DELETE_USER_SUCCESS:
      var newUsers = (0, _omit2.default)(state.users, action.response.result);
      return _extends({}, state, { users: newUsers });
    case _integration.DELETE_INTEGRATION_SUCCESS:
      var newIntegrations = (0, _omit2.default)(state.integrations, action.response.result);
      return _extends({}, state, { integrations: newIntegrations });
    case _step.DELETE_STEP_SUCCESS:
      var stepID = schemas.getIDFromSchema(schemas.STEP, action.payload);
      var newSteps = (0, _omit2.default)(state.steps, stepID);
      return _extends({}, state, { steps: newSteps });
    case _credential.DELETE_CREDENTIAL_SUCCESS:
      var newCredentials = (0, _omit2.default)(state.credentials, action.response.result);
      return _extends({}, state, { credentials: newCredentials });
    case _fields.GET_PROCESS_FIELDS_SUCCESS:
      return processFields.getProcessFieldsSuccess(state, action);
    case _message.GET_MESSAGE_BODY_SUCCESS:
      var splitUrl = action.payload.url.split('/');
      var messageID = splitUrl[splitUrl.length - 2];
      return _extends({}, state, {
        messages: _extends({}, state.messages || {}, _defineProperty({}, messageID, _extends({}, state.messages[messageID] || {}, {
          body: action.response.body
        })))
      });
    case _tasks.UPDATE_TASKS_SUCCESS:
      var newTasks = (0, _clone2.default)(action.response.entities);
      delete newTasks.tasks.undefined;
      return util.merge(state, newTasks);
    case _triggers.GET_TRIGGERS_SUCCESS:
      var newTriggers = (0, _clone2.default)(action.response.entities.triggers);
      return _extends({}, state, { triggers: newTriggers });
    case _webhooks.GET_WEBHOOKS_SUCCESS:
      var newWebhooks = (0, _clone2.default)(action.response.entities.webhooks);
      return _extends({}, state, {
        webhooks: newWebhooks
      });
    case _fields.GET_VISIBLE_FIELDS_SUCCESS:
      var visibleFieldMap = (0, _keyBy2.default)(action.response, 'fieldID');
      var visibleFields = util.merge(state.visibleFields, visibleFieldMap);
      return util.merge(state, { visibleFields: visibleFields });
    case _field.DELETE_FIELD_SUCCESS:
      var deletedField = action.response.entities.fields[action.response.result];
      var allFieldVersions = fieldUtils.getAllFieldVersionsForField(deletedField, state.fields);
      var nextFields = (0, _omit2.default)(state.fields, allFieldVersions.map(function (f) {
        return f.fieldID;
      }));
      return _extends({}, state, { fields: nextFields });
    case _predictor.DELETE_PREDICTOR_SUCCESS:
      var nextPredictors = (0, _omit2.default)(state.predictors, action.predictorID);
      return _extends({}, state, { predictors: nextPredictors });
    default:
      return state;
  }
}

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    keysIn = __webpack_require__(221);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    getSymbols = __webpack_require__(1264);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1264 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    getSymbolsIn = __webpack_require__(1266);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1266 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(409);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(152);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(119),
    baseClone = __webpack_require__(228),
    baseUnset = __webpack_require__(544),
    castPath = __webpack_require__(136),
    copyObject = __webpack_require__(108),
    customOmitClone = __webpack_require__(1276),
    flatRest = __webpack_require__(229),
    getAllKeysIn = __webpack_require__(329);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(226),
    baseSlice = __webpack_require__(545);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(167);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1277 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1279),
    isArguments = __webpack_require__(219),
    isArray = __webpack_require__(27);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_REMINDER_FAILURE = exports.ADD_REMINDER_SUCCESS = exports.ADD_REMINDER_REQUEST = exports.ADD_REMINDER = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.addReminder = addReminder;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('ADD_REMINDER'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var ADD_REMINDER = _api$buildTypes2[0],
    ADD_REMINDER_REQUEST = _api$buildTypes2[1],
    ADD_REMINDER_SUCCESS = _api$buildTypes2[2],
    ADD_REMINDER_FAILURE = _api$buildTypes2[3];
exports.ADD_REMINDER = ADD_REMINDER;
exports.ADD_REMINDER_REQUEST = ADD_REMINDER_REQUEST;
exports.ADD_REMINDER_SUCCESS = ADD_REMINDER_SUCCESS;
exports.ADD_REMINDER_FAILURE = ADD_REMINDER_FAILURE;
function addReminder(_ref) {
  var teamName = _ref.teamName,
      runID = _ref.runID,
      taskName = _ref.taskName,
      date = _ref.date;

  return {
    type: ADD_REMINDER,
    payload: {
      url: '/teams/' + teamName + '/runs/' + runID + '/tasks/' + taskName + '/reminders',
      schema: _schemas.REMINDER,
      options: {
        method: 'POST',
        body: { date: date }
      }
    }
  };
}

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP_NAME = exports.GET_APP_CONTACT_FAILURE = exports.GET_APP_CONTACT_SUCCESS = exports.GET_APP_CONTACT_REQUEST = exports.GET_APP_CONTACT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getContactByEmail = getContactByEmail;
exports.getContactByPhone = getContactByPhone;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _api$buildTypes = _api2.default.buildTypes('GET_APP_CONTACT'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_APP_CONTACT = _api$buildTypes2[0],
    GET_APP_CONTACT_REQUEST = _api$buildTypes2[1],
    GET_APP_CONTACT_SUCCESS = _api$buildTypes2[2],
    GET_APP_CONTACT_FAILURE = _api$buildTypes2[3];
exports.GET_APP_CONTACT = GET_APP_CONTACT;
exports.GET_APP_CONTACT_REQUEST = GET_APP_CONTACT_REQUEST;
exports.GET_APP_CONTACT_SUCCESS = GET_APP_CONTACT_SUCCESS;
exports.GET_APP_CONTACT_FAILURE = GET_APP_CONTACT_FAILURE;
var APP_NAME = exports.APP_NAME = 'contact';

function getContact() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var action = _ref.action,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? APP_NAME : _ref$name,
      _ref$version = _ref.version,
      version = _ref$version === undefined ? 'v1' : _ref$version,
      query = _objectWithoutProperties(_ref, ['action', 'name', 'version']);

  if (!action) throw 'Action type required'; // eslint-disable-line no-throw-literal
  return {
    type: GET_APP_CONTACT,
    payload: {
      url: '/apps/' + name + '/' + action + '/' + version,
      schema: _schemas.CONTACT,
      options: {
        method: 'POST',
        body: query
      }
    }
  };
}

function getContactByEmail() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return getContact(_extends({}, options, { action: 'email' }));
}

function getContactByPhone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return getContact(_extends({}, options, { action: 'phone' }));
}

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(396),
    func = convert('flow', __webpack_require__(1301));

func.placeholder = __webpack_require__(251);
module.exports = func;


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(1284),
    fallbackHolder = __webpack_require__(251);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 1284 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(1286),
  'assign': __webpack_require__(543),
  'clone': __webpack_require__(541),
  'curry': __webpack_require__(1296),
  'forEach': __webpack_require__(542),
  'isArray': __webpack_require__(27),
  'isError': __webpack_require__(522),
  'isFunction': __webpack_require__(315),
  'isWeakMap': __webpack_require__(1297),
  'iteratee': __webpack_require__(1298),
  'keys': __webpack_require__(556),
  'rearg': __webpack_require__(1299),
  'toInteger': __webpack_require__(153),
  'toPath': __webpack_require__(1300)
};


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(332);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 1287 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(230),
    root = __webpack_require__(84);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(319),
    createCtor = __webpack_require__(230),
    createHybrid = __webpack_require__(548),
    createRecurry = __webpack_require__(549),
    getHolder = __webpack_require__(553),
    replaceHolders = __webpack_require__(554),
    root = __webpack_require__(84);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 1291 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 1292 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(194),
    isIndex = __webpack_require__(227);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(319),
    createCtor = __webpack_require__(230),
    root = __webpack_require__(84);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1295 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(332);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(225),
    isObjectLike = __webpack_require__(107);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(228),
    baseIteratee = __webpack_require__(57);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(332),
    flatRest = __webpack_require__(229);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(119),
    copyArray = __webpack_require__(194),
    isArray = __webpack_require__(27),
    isSymbol = __webpack_require__(327),
    stringToPath = __webpack_require__(530),
    toKey = __webpack_require__(109),
    toString = __webpack_require__(328);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(1302);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(1303),
    flatRest = __webpack_require__(229),
    getData = __webpack_require__(555),
    getFuncName = __webpack_require__(1304),
    isArray = __webpack_require__(27),
    isLaziable = __webpack_require__(550);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 1303 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1304 */
/***/ (function(module, exports) {

/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

module.exports = stubString;


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(532),
    hasIn = __webpack_require__(531);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isObjectLike = __webpack_require__(107);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_TABLES_FAILURE = exports.GET_TABLES_SUCCESS = exports.GET_TABLES_REQUEST = exports.GET_TABLES = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getTables = getTables;

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _schemas = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _api$buildTypes = _api2.default.buildTypes('GET_TABLES'),
    _api$buildTypes2 = _slicedToArray(_api$buildTypes, 4);

var GET_TABLES = _api$buildTypes2[0],
    GET_TABLES_REQUEST = _api$buildTypes2[1],
    GET_TABLES_SUCCESS = _api$buildTypes2[2],
    GET_TABLES_FAILURE = _api$buildTypes2[3];
exports.GET_TABLES = GET_TABLES;
exports.GET_TABLES_REQUEST = GET_TABLES_REQUEST;
exports.GET_TABLES_SUCCESS = GET_TABLES_SUCCESS;
exports.GET_TABLES_FAILURE = GET_TABLES_FAILURE;
function getTables(_ref) {
  var teamName = _ref.teamName;

  return {
    type: GET_TABLES,
    payload: {
      url: '/teams/' + teamName + '/tables',
      schema: _schemas.TABLE_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(544),
    isIndex = __webpack_require__(227);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1310 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(195),
    baseIteratee = __webpack_require__(57),
    baseRest = __webpack_require__(191),
    baseUniq = __webpack_require__(421),
    isArrayLikeObject = __webpack_require__(252),
    last = __webpack_require__(263);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),
/* 1312 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1313 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(57),
    isArrayLike = __webpack_require__(152),
    keys = __webpack_require__(154);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1316),
    baseIteratee = __webpack_require__(57),
    toInteger = __webpack_require__(153);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(558),
    isArray = __webpack_require__(27);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1320);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(327);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(48);
var invariant = __webpack_require__(9);
var ReactPropTypesSecret = __webpack_require__(475);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(334);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(1323);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(1325);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(335);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(334);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(1324);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(335);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(334);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.transform = transform;
exports.find = find;
exports.findIndex = findIndex;
exports.contains = contains;

/* eslint-disable no-bitwise, no-plusplus */

function transform(obj, iteratee, accumulator) {
  Object.keys(obj).forEach(function (key) {
    iteratee(accumulator, obj[key], key);
  });
  return accumulator;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : _typeof(pred);
  for (var i = 0; i < arr.length; i++) {
    if (predType === 'function' && pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function contains(obj, pred) {
  for (var _key in pred) {
    if (!obj.hasOwnProperty(_key) || obj[_key] !== pred[_key]) {
      return false;
    }
  }
  return true;
}

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  skeleton: function () {
    function skeleton() {
      return {
        '@keyframes skeleton': {
          '0%': {
            backgroundPosition: '-100vw 0vw'
          },
          '100%': {
            backgroundPosition: '100vw 0vw'
          }
        }
      };
    }

    return skeleton;
  }()
};

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createBreakpoints;


// Sorted ASC by size. That's important.
var keys = exports.keys = ['xs', 'sm', 'md', 'lg', 'xl']; //  weak

function createBreakpoints() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    xs: 360,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  };
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var values = keys.map(function (n) {
    return breakpoints[n];
  });

  function up(name) {
    var value = breakpoints[name] || name;
    return '@media (min-width:' + value + unit + ')';
  }

  function down(name) {
    var value = breakpoints[name] || name;
    return '@media (max-width:' + (value - 1) + unit + ')';
  }

  function between(start, end) {
    var startIndex = keys.indexOf(start);
    var endIndex = keys.indexOf(end);
    return '@media (min-width:' + values[startIndex] + unit + ') and (max-width:' + (values[endIndex + 1] - step) + unit + ')';
  }

  function only(name) {
    var keyIndex = keys.indexOf(name);
    if (keyIndex === keys.length - 1) {
      return up(name);
    }
    return between(name, name);
  }

  function getWidth(name) {
    return breakpoints[name];
  }

  return Object.assign({ keys: keys, values: values, up: up, down: down, only: only, getWidth: getWidth }, breakpoints);
}

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createMixins;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createMixins(breakpoints, palette, typography, variables) {
  var borderWidth = variables.borderWidthFocused - variables.borderWidth;

  return {
    /**
     * Global styles
     */
    global: function () {
      function global() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          html: {
            boxSizing: 'border-box',
            height: '100%'
          },
          '*, *:before, *:after': {
            boxSizing: 'inherit'
          },
          body: {
            margin: 0,
            height: '100%',
            backgroundColor: palette.background['default'],
            fontFamily: typography.fontFamily,
            color: palette.text.primary,
            lineHeight: typography.lineHeight,
            overflowX: 'hidden',
            WebkitFontSmoothing: 'antialiased', // Antialiasing.
            MozOsxFontSmoothing: 'grayscale' // Antialiasing.
          },
          a: {
            color: typography.highlight.color,
            outline: 'none',
            textDecoration: 'none',
            '&:focus, &:hover': {
              outline: 'none',
              textDecoration: 'none'
            }
          },
          /* Internet Explorer 10+ */
          '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
            '*, *:before, *:after': {
              transition: 'none !important'
            }
          }
        });
      }

      return global;
    }(),
    /**
     * Border styles
     */
    border: function () {
      function border() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          padding: variables.borderPaddingTopBottom + borderWidth + 'px ' + (variables.borderPaddingRightLeft + borderWidth) + 'px',
          borderWidth: variables.borderWidth,
          borderStyle: 'solid',
          borderColor: palette.forms.primary,
          borderRadius: variables.borderRadius
        });
      }

      return border;
    }(),
    borderDisabled: function () {
      function borderDisabled() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          borderStyle: 'dotted'
        });
      }

      return borderDisabled;
    }(),
    borderFocused: function () {
      function borderFocused() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          padding: variables.borderPaddingTopBottom + 'px ' + variables.borderPaddingRightLeft + 'px',
          borderWidth: variables.borderWidthFocused,
          borderColor: palette.forms.active
        });
      }

      return borderFocused;
    }(),
    borderError: function () {
      function borderError() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          borderColor: palette.text.error
        });
      }

      return borderError;
    }(),
    /**
     * Placeholder styles
     */
    placeholder: function () {
      function placeholder() {
        var placeholderStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var styles = Object.assign({}, placeholderStyles, {
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        });

        return {
          '&::placeholder': Object.assign({}, styles),
          '&::-webkit-input-placeholder': Object.assign({}, styles),
          '&:-ms-input-placeholder': Object.assign({}, styles),
          '&::-ms-input-placeholder': Object.assign({}, styles),
          '&::-moz-placeholder': Object.assign({}, styles),
          '&:-moz-placeholder': Object.assign({}, styles)
        };
      }

      return placeholder;
    }(),
    /*
     * Gutters
     */
    gutters: function () {
      function gutters(units) {
        var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Object.assign({}, styles, {
          paddingLeft: typography.rhythmByUnit(units),
          paddingRight: typography.rhythmByUnit(units)
        });
      }

      return gutters;
    }(),
    /*
     * Hide visually and from screen readers
     */
    hidden: function () {
      function hidden() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          display: 'none !important'
        });
      }

      return hidden;
    }(),
    /*
     * Hide only visually, but have it available for screen readers:
     * https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
     *
     * 1. For long content, line feeds are not interpreted as spaces and small width
     *    causes content to wrap 1 word per line:
     *    https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
     */
    visuallyhidden: function () {
      function visuallyhidden() {
        var focusable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Object.assign({}, styles, {
          border: 0,
          clip: 'rect(0 0 0 0)',
          clipPath: 'inset(50%)',
          height: 1,
          margin: -1,
          overflow: 'hidden',
          padding: 0,
          position: 'absolute',
          width: 1,
          whiteSpace: 'nowrap' /* 1 */
        }, focusable && {
          '&:active, &:focus': {
            clip: 'auto',
            clipPath: 'none',
            height: 'auto',
            margin: 0,
            overflow: 'visible',
            position: 'static',
            width: 'auto',
            whiteSpace: 'inherit'
          }
        });
      }

      return visuallyhidden;
    }(),
    /*
     * Hide visually and from screen readers, but maintain layout
     */
    invisible: function () {
      function invisible() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          visibility: 'hidden'
        });
      }

      return invisible;
    }(),
    /*
     * Truncate single-line string with ellipsis
     */
    truncate: function () {
      function truncate() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        });
      }

      return truncate;
    }(),
    /*
     * Skeleton styles
     */
    skeleton: function () {
      function skeleton() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          backgroundImage: 'linear-gradient(to right, #eee 8%, #ddd 18%, #eee 33%)',
          backgroundSize: '200vw 100vw',
          animationName: 'skeleton',
          animationDuration: '2s',
          animationTimingFunction: 'linear',
          animationDelay: '0s',
          animationIterationCount: 'infinite',
          animationDirection: 'normal',
          animationFillMode: 'forwards',
          animationPlayState: 'running'
        });
      }

      return skeleton;
    }(),
    skeletonRandom: function () {
      function skeletonRandom() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return [].concat(_toConsumableArray(Array(variables.skeletonCount))).reduce(function (style, value, index) {
          return Object.assign({}, style, _defineProperty({}, '&[data-skeleton="' + index + '"]', {
            '& $skeletonPrimary': {
              marginRight: Math.floor(Math.random() * 10) + 1 + '%' // Random percent between 1% and 10%
            },
            '& $skeletonSecondary': {
              marginRight: Math.floor(Math.random() * 15) + 11 + '%' // Random percent between 11% and 25%
            }
          }));
        }, styles);
      }

      return skeletonRandom;
    }()
  };
}

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var colorString = __webpack_require__(1331);
var convert = __webpack_require__(1335);

var _slice = [].slice;

var skippedModels = [
	// to be honest, I don't really feel like keyword belongs in color convert, but eh.
	'keyword',

	// gray conflicts with some method names, and has its own method defined.
	'gray',

	// shouldn't really be in color-convert either...
	'hex'
];

var hashedModelKeys = {};
Object.keys(convert).forEach(function (model) {
	hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});

var limiters = {};

function Color(obj, model) {
	if (!(this instanceof Color)) {
		return new Color(obj, model);
	}

	if (model && model in skippedModels) {
		model = null;
	}

	if (model && !(model in convert)) {
		throw new Error('Unknown model: ' + model);
	}

	var i;
	var channels;

	if (!obj) {
		this.model = 'rgb';
		this.color = [0, 0, 0];
		this.valpha = 1;
	} else if (obj instanceof Color) {
		this.model = obj.model;
		this.color = obj.color.slice();
		this.valpha = obj.valpha;
	} else if (typeof obj === 'string') {
		var result = colorString.get(obj);
		if (result === null) {
			throw new Error('Unable to parse color from string: ' + obj);
		}

		this.model = result.model;
		channels = convert[this.model].channels;
		this.color = result.value.slice(0, channels);
		this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
	} else if (obj.length) {
		this.model = model || 'rgb';
		channels = convert[this.model].channels;
		var newArr = _slice.call(obj, 0, channels);
		this.color = zeroArray(newArr, channels);
		this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
	} else if (typeof obj === 'number') {
		// this is always RGB - can be converted later on.
		obj &= 0xFFFFFF;
		this.model = 'rgb';
		this.color = [
			(obj >> 16) & 0xFF,
			(obj >> 8) & 0xFF,
			obj & 0xFF
		];
		this.valpha = 1;
	} else {
		this.valpha = 1;

		var keys = Object.keys(obj);
		if ('alpha' in obj) {
			keys.splice(keys.indexOf('alpha'), 1);
			this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
		}

		var hashedKeys = keys.sort().join('');
		if (!(hashedKeys in hashedModelKeys)) {
			throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
		}

		this.model = hashedModelKeys[hashedKeys];

		var labels = convert[this.model].labels;
		var color = [];
		for (i = 0; i < labels.length; i++) {
			color.push(obj[labels[i]]);
		}

		this.color = zeroArray(color);
	}

	// perform limitations (clamping, etc.)
	if (limiters[this.model]) {
		channels = convert[this.model].channels;
		for (i = 0; i < channels; i++) {
			var limit = limiters[this.model][i];
			if (limit) {
				this.color[i] = limit(this.color[i]);
			}
		}
	}

	this.valpha = Math.max(0, Math.min(1, this.valpha));

	if (Object.freeze) {
		Object.freeze(this);
	}
}

Color.prototype = {
	toString: function () {
		return this.string();
	},

	toJSON: function () {
		return this[this.model]();
	},

	string: function (places) {
		var self = this.model in colorString.to ? this : this.rgb();
		self = self.round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to[self.model](args);
	},

	percentString: function (places) {
		var self = this.rgb().round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to.rgb.percent(args);
	},

	array: function () {
		return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
	},

	object: function () {
		var result = {};
		var channels = convert[this.model].channels;
		var labels = convert[this.model].labels;

		for (var i = 0; i < channels; i++) {
			result[labels[i]] = this.color[i];
		}

		if (this.valpha !== 1) {
			result.alpha = this.valpha;
		}

		return result;
	},

	unitArray: function () {
		var rgb = this.rgb().color;
		rgb[0] /= 255;
		rgb[1] /= 255;
		rgb[2] /= 255;

		if (this.valpha !== 1) {
			rgb.push(this.valpha);
		}

		return rgb;
	},

	unitObject: function () {
		var rgb = this.rgb().object();
		rgb.r /= 255;
		rgb.g /= 255;
		rgb.b /= 255;

		if (this.valpha !== 1) {
			rgb.alpha = this.valpha;
		}

		return rgb;
	},

	round: function (places) {
		places = Math.max(places || 0, 0);
		return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
	},

	alpha: function (val) {
		if (arguments.length) {
			return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
		}

		return this.valpha;
	},

	// rgb
	red: getset('rgb', 0, maxfn(255)),
	green: getset('rgb', 1, maxfn(255)),
	blue: getset('rgb', 2, maxfn(255)),

	hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style

	saturationl: getset('hsl', 1, maxfn(100)),
	lightness: getset('hsl', 2, maxfn(100)),

	saturationv: getset('hsv', 1, maxfn(100)),
	value: getset('hsv', 2, maxfn(100)),

	chroma: getset('hcg', 1, maxfn(100)),
	gray: getset('hcg', 2, maxfn(100)),

	white: getset('hwb', 1, maxfn(100)),
	wblack: getset('hwb', 2, maxfn(100)),

	cyan: getset('cmyk', 0, maxfn(100)),
	magenta: getset('cmyk', 1, maxfn(100)),
	yellow: getset('cmyk', 2, maxfn(100)),
	black: getset('cmyk', 3, maxfn(100)),

	x: getset('xyz', 0, maxfn(100)),
	y: getset('xyz', 1, maxfn(100)),
	z: getset('xyz', 2, maxfn(100)),

	l: getset('lab', 0, maxfn(100)),
	a: getset('lab', 1),
	b: getset('lab', 2),

	keyword: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return convert[this.model].keyword(this.color);
	},

	hex: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return colorString.to.hex(this.rgb().round().color);
	},

	rgbNumber: function () {
		var rgb = this.rgb().color;
		return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.rgb().color;

		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}

		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();

		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}

		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.rgb().color;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = this.rgb();
		for (var i = 0; i < 3; i++) {
			rgb.color[i] = 255 - rgb.color[i];
		}
		return rgb;
	},

	lighten: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] += hsl.color[2] * ratio;
		return hsl;
	},

	darken: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] -= hsl.color[2] * ratio;
		return hsl;
	},

	saturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] += hsl.color[1] * ratio;
		return hsl;
	},

	desaturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] -= hsl.color[1] * ratio;
		return hsl;
	},

	whiten: function (ratio) {
		var hwb = this.hwb();
		hwb.color[1] += hwb.color[1] * ratio;
		return hwb;
	},

	blacken: function (ratio) {
		var hwb = this.hwb();
		hwb.color[2] += hwb.color[2] * ratio;
		return hwb;
	},

	grayscale: function () {
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var rgb = this.rgb().color;
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		return Color.rgb(val, val, val);
	},

	fade: function (ratio) {
		return this.alpha(this.valpha - (this.valpha * ratio));
	},

	opaquer: function (ratio) {
		return this.alpha(this.valpha + (this.valpha * ratio));
	},

	rotate: function (degrees) {
		var hsl = this.hsl();
		var hue = hsl.color[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		hsl.color[0] = hue;
		return hsl;
	},

	mix: function (mixinColor, weight) {
		// ported from sass implementation in C
		// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		var color1 = this.rgb();
		var color2 = mixinColor.rgb();
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return Color.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue(),
				color1.alpha() * p + color2.alpha() * (1 - p));
	}
};

// model conversion methods and static constructors
Object.keys(convert).forEach(function (model) {
	if (skippedModels.indexOf(model) !== -1) {
		return;
	}

	var channels = convert[model].channels;

	// conversion methods
	Color.prototype[model] = function () {
		if (this.model === model) {
			return new Color(this);
		}

		if (arguments.length) {
			return new Color(arguments, model);
		}

		var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
		return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
	};

	// 'static' construction methods
	Color[model] = function (color) {
		if (typeof color === 'number') {
			color = zeroArray(_slice.call(arguments), channels);
		}
		return new Color(color, model);
	};
});

function roundTo(num, places) {
	return Number(num.toFixed(places));
}

function roundToPlace(places) {
	return function (num) {
		return roundTo(num, places);
	};
}

function getset(model, channel, modifier) {
	model = Array.isArray(model) ? model : [model];

	model.forEach(function (m) {
		(limiters[m] || (limiters[m] = []))[channel] = modifier;
	});

	model = model[0];

	return function (val) {
		var result;

		if (arguments.length) {
			if (modifier) {
				val = modifier(val);
			}

			result = this[model]();
			result.color[channel] = val;
			return result;
		}

		result = this[model]().color[channel];
		if (modifier) {
			result = modifier(result);
		}

		return result;
	};
}

function maxfn(max) {
	return function (v) {
		return Math.max(0, Math.min(max, v));
	};
}

function assertArray(val) {
	return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
	for (var i = 0; i < length; i++) {
		if (typeof arr[i] !== 'number') {
			arr[i] = 0;
		}
	}

	return arr;
}

module.exports = Color;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(1332);
var swizzle = __webpack_require__(1333);

var reverseNames = {};

// create a list of reverse color names
for (var name in colorNames) {
	if (colorNames.hasOwnProperty(name)) {
		reverseNames[colorNames[name]] = name;
	}
}

var cs = module.exports = {
	to: {}
};

cs.get = function (string) {
	var prefix = string.substring(0, 3).toLowerCase();
	var val;
	var model;
	switch (prefix) {
		case 'hsl':
			val = cs.get.hsl(string);
			model = 'hsl';
			break;
		case 'hwb':
			val = cs.get.hwb(string);
			model = 'hwb';
			break;
		default:
			val = cs.get.rgb(string);
			model = 'rgb';
			break;
	}

	if (!val) {
		return null;
	}

	return {model: model, value: val};
};

cs.get.rgb = function (string) {
	if (!string) {
		return null;
	}

	var abbr = /^#([a-f0-9]{3,4})$/i;
	var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var keyword = /(\D+)/;

	var rgb = [0, 0, 0, 1];
	var match;
	var i;
	var hexAlpha;

	if (match = string.match(hex)) {
		hexAlpha = match[2];
		match = match[1];

		for (i = 0; i < 3; i++) {
			// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
			var i2 = i * 2;
			rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
		}

		if (hexAlpha) {
			rgb[3] = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
		}
	} else if (match = string.match(abbr)) {
		match = match[1];
		hexAlpha = match[3];

		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i] + match[i], 16);
		}

		if (hexAlpha) {
			rgb[3] = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
		}
	} else if (match = string.match(rgba)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i + 1], 0);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(per)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(keyword)) {
		if (match[1] === 'transparent') {
			return [0, 0, 0, 0];
		}

		rgb = colorNames[match[1]];

		if (!rgb) {
			return null;
		}

		rgb[3] = 1;

		return rgb;
	} else {
		return null;
	}

	for (i = 0; i < 3; i++) {
		rgb[i] = clamp(rgb[i], 0, 255);
	}
	rgb[3] = clamp(rgb[3], 0, 1);

	return rgb;
};

cs.get.hsl = function (string) {
	if (!string) {
		return null;
	}

	var hsl = /^hsla?\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hsl);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var s = clamp(parseFloat(match[2]), 0, 100);
		var l = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

		return [h, s, l, a];
	}

	return null;
};

cs.get.hwb = function (string) {
	if (!string) {
		return null;
	}

	var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hwb);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var w = clamp(parseFloat(match[2]), 0, 100);
		var b = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
		return [h, w, b, a];
	}

	return null;
};

cs.to.hex = function () {
	var rgba = swizzle(arguments);

	return (
		'#' +
		hexDouble(rgba[0]) +
		hexDouble(rgba[1]) +
		hexDouble(rgba[2]) +
		(rgba[3] < 1
			? (hexDouble(Math.round(rgba[3] * 255)))
			: '')
	);
};

cs.to.rgb = function () {
	var rgba = swizzle(arguments);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
		: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
	var rgba = swizzle(arguments);

	var r = Math.round(rgba[0] / 255 * 100);
	var g = Math.round(rgba[1] / 255 * 100);
	var b = Math.round(rgba[2] / 255 * 100);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
		: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
	var hsla = swizzle(arguments);
	return hsla.length < 4 || hsla[3] === 1
		? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
		: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function () {
	var hwba = swizzle(arguments);

	var a = '';
	if (hwba.length >= 4 && hwba[3] !== 1) {
		a = ', ' + hwba[3];
	}

	return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
	return reverseNames[rgb.slice(0, 3)];
};

// helpers
function clamp(num, min, max) {
	return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
	var str = num.toString(16).toUpperCase();
	return (str.length < 2) ? '0' + str : str;
}


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArrayish = __webpack_require__(1334);

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle = module.exports = function swizzle(args) {
	var results = [];

	for (var i = 0, len = args.length; i < len; i++) {
		var arg = args[i];

		if (isArrayish(arg)) {
			// http://jsperf.com/javascript-array-concat-vs-push/98
			results = concat.call(results, slice.call(arg));
		} else {
			results.push(arg);
		}
	}

	return results;
};

swizzle.wrap = function (fn) {
	return function () {
		return fn(swizzle(arguments));
	};
};


/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(565);
var route = __webpack_require__(1337);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),
/* 1336 */
/***/ (function(module, exports) {

module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(565);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable flowtype/require-valid-file-annotation */

var SHADOW_OPACITY = 0.1;
var SHADOW_STEP = 0.3;

var createShadow = exports.createShadow = function createShadow() {
  return [(arguments.length <= 0 ? undefined : arguments[0]) + 'px ' + (arguments.length <= 1 ? undefined : arguments[1]) + 'px ' + (arguments.length <= 2 ? undefined : arguments[2]) + 'px ' + (arguments.length <= 3 ? undefined : arguments[3]) + 'px rgba(0, 0, 0, ' + SHADOW_OPACITY + ')', (arguments.length <= 4 ? undefined : arguments[4]) + 'px ' + (arguments.length <= 5 ? undefined : arguments[5]) + 'px ' + (arguments.length <= 6 ? undefined : arguments[6]) + 'px ' + (arguments.length <= 7 ? undefined : arguments[7]) + 'px rgba(0, 0, 0, ' + SHADOW_OPACITY + ')'].join(',');
};

var createShadowLevel = exports.createShadowLevel = function createShadowLevel(level) {
  var step = (level - 1) * SHADOW_STEP;
  var increment = function increment(v) {
    return Math.round(v + step);
  };
  return createShadow(0, 2, increment(10), 0, 0, 0, increment(3), 0);
};

var range = function range(start, end) {
  return ' '.repeat(end - start + 1).split('').map(function (v, i) {
    return i + start;
  });
};

var shadows = ['none'].concat(_toConsumableArray(range(1, 24).map(createShadowLevel)));

exports['default'] = shadows;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = deprecate;
function deprecate(message, fn) {
  return function () {
    if (false) console.warn('Deprecation: ' + message);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return fn.call.apply(fn, [this].concat(args));
  };
}

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable prettier/prettier */
exports["default"] = {
  baseIndex: 100,
  formLabel: 200,
  floatingAction: 300,
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  navDrawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000,
  sortableHelper: 4000
};

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1342);


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDefaultInjection = __webpack_require__(462);
var ReactServerRendering = __webpack_require__(1343);
var ReactVersion = __webpack_require__(495);

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(15);

var React = __webpack_require__(82);
var ReactDOMContainerInfo = __webpack_require__(493);
var ReactDefaultBatchingStrategy = __webpack_require__(488);
var ReactInstrumentation = __webpack_require__(55);
var ReactMarkupChecksum = __webpack_require__(494);
var ReactReconciler = __webpack_require__(106);
var ReactServerBatchingStrategy = __webpack_require__(1344);
var ReactServerRenderingTransaction = __webpack_require__(487);
var ReactUpdates = __webpack_require__(60);

var emptyObject = __webpack_require__(164);
var instantiateReactComponent = __webpack_require__(306);
var invariant = __webpack_require__(9);

var pendingTransactions = 0;

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToStringImpl(element, makeStaticMarkup) {
  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);

    pendingTransactions++;

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, true);
      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
      );
      if (false) {
        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
      }
      if (!makeStaticMarkup) {
        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
      }
      return markup;
    }, null);
  } finally {
    pendingTransactions--;
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    if (!pendingTransactions) {
      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
    }
  }
}

/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
 */
function renderToString(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
  return renderToStringImpl(element, false);
}

/**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
 */
function renderToStaticMarkup(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
  return renderToStringImpl(element, true);
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createStyleSheet = createStyleSheet;
function createStyleSheet(name, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!options.insertionPoint) {
    options.insertionPoint = 'jss-theme-reactor';
  }

  var styleSheet = {
    name: name,
    options: options,
    createRules: createRules
  };

  function createRules() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var rules = typeof callback === 'function' ? callback(theme) : callback;

    if (!theme.overrides || !theme.overrides[name]) {
      return rules;
    }

    var overrides = theme.overrides[name];
    var rulesWithOverrides = _extends({}, rules);

    Object.keys(overrides).forEach(function (n) {
      rulesWithOverrides[n] = Object.assign(rulesWithOverrides[n] || {}, overrides[n]);
    });

    return rulesWithOverrides;
  }

  return styleSheet;
}

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(1347),
    hasUnicode = __webpack_require__(567),
    stringToArray = __webpack_require__(1348),
    toString = __webpack_require__(328);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(545);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1349),
    hasUnicode = __webpack_require__(567),
    unicodeToArray = __webpack_require__(1350);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1350 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SvgIcon = __webpack_require__(2);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_SvgIcon)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Autodesk = (_temp = _class = function (_SvgIcon) {
    _inherits(Autodesk, _SvgIcon);

    function Autodesk() {
        _classCallCheck(this, Autodesk);

        return _possibleConstructorReturn(this, (Autodesk.__proto__ || Object.getPrototypeOf(Autodesk)).apply(this, arguments));
    }

    _createClass(Autodesk, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement(
                        'defs',
                        null,
                        _react2['default'].createElement(
                            'clipPath',
                            { id: 'clip-path' },
                            _react2['default'].createElement('path', { d: 'M19.66,54.32a2.63,2.63,0,0,1-2.57-1.59L11.3,42a2.74,2.74,0,0,1-.4-1.58l9.1.4,2.08,2.08H40.33L25.18,52.29C24.44,52.73,21.63,54.32,19.66,54.32Z', fill: 'none' })
                        ),
                        _react2['default'].createElement(
                            'clipPath',
                            { id: 'clip-path-2' },
                            _react2['default'].createElement('path', { d: 'M22.09,42.9H14.22c-2.38,0-3.32-1.24-3.32-2.48a5.1,5.1,0,0,1,.6-2.09L23,11l.12-.24.16-.24.33-.32.49-.26.7-.16,1.21,0,8,3-2.7,8.49Z', fill: 'none' })
                        ),
                        _react2['default'].createElement(
                            'clipPath',
                            { id: 'clip-path-3' },
                            _react2['default'].createElement('path', { d: 'M45.2,54.32,27.09,11.46A2.24,2.24,0,0,0,25,9.79,2.06,2.06,0,0,0,23,11,2,2,0,0,1,25,9.68H37.52a2,2,0,0,1,2,1.3L57.79,54.32Z', fill: 'none' })
                        )
                    ),
                    _react2['default'].createElement(
                        'title',
                        null,
                        'autodesk'
                    ),
                    _react2['default'].createElement(
                        'g',
                        { id: 'text' },
                        _react2['default'].createElement('path', { d: 'M19.66,54.32a2.63,2.63,0,0,1-2.57-1.59L11.3,42a2.74,2.74,0,0,1-.4-1.58l9.1.4,2.08,2.08H40.33L25.18,52.29C24.44,52.73,21.63,54.32,19.66,54.32Z', fill: '#5cc2b1' }),
                        _react2['default'].createElement('path', { d: 'M22.09,42.9H14.22c-2.38,0-3.32-1.24-3.32-2.48a5.1,5.1,0,0,1,.6-2.09L23,11l.12-.24.16-.24.33-.32.49-.26.7-.16,1.21,0,8,3-2.7,8.49Z', fill: '#86c146' }),
                        _react2['default'].createElement(
                            'g',
                            null,
                            _react2['default'].createElement('polygon', { points: '13.12 40.42 15.89 54.32 10.9 54.32 10.9 40.42 13.12 40.42', fill: '#2b7a77' }),
                            _react2['default'].createElement('polygon', { points: '13.3 40.42 16.07 54.32 15.89 54.32 13.12 40.42 13.3 40.42', fill: '#2b7a77' }),
                            _react2['default'].createElement('polygon', { points: '13.48 40.42 16.25 54.32 16.07 54.32 13.3 40.42 13.48 40.42', fill: '#2d7e7a' }),
                            _react2['default'].createElement('polygon', { points: '13.67 40.42 16.44 54.32 16.25 54.32 13.48 40.42 13.67 40.42', fill: '#30837e' }),
                            _react2['default'].createElement('polygon', { points: '13.85 40.42 16.62 54.32 16.44 54.32 13.67 40.42 13.85 40.42', fill: '#328781' }),
                            _react2['default'].createElement('polygon', { points: '14.04 40.42 16.81 54.32 16.62 54.32 13.85 40.42 14.04 40.42', fill: '#348b84' }),
                            _react2['default'].createElement('polygon', { points: '14.22 40.42 16.99 54.32 16.81 54.32 14.04 40.42 14.22 40.42', fill: '#378f88' }),
                            _react2['default'].createElement('polygon', { points: '14.4 40.42 17.18 54.32 16.99 54.32 14.22 40.42 14.4 40.42', fill: '#39948b' }),
                            _react2['default'].createElement('polygon', { points: '14.59 40.42 17.36 54.32 17.18 54.32 14.4 40.42 14.59 40.42', fill: '#3b988e' }),
                            _react2['default'].createElement('polygon', { points: '14.77 40.42 17.54 54.32 17.36 54.32 14.59 40.42 14.77 40.42', fill: '#3e9c92' }),
                            _react2['default'].createElement('polygon', { points: '14.96 40.42 17.73 54.32 17.54 54.32 14.77 40.42 14.96 40.42', fill: '#40a095' }),
                            _react2['default'].createElement('polygon', { points: '15.14 40.42 17.91 54.32 17.73 54.32 14.96 40.42 15.14 40.42', fill: '#42a598' }),
                            _react2['default'].createElement('polygon', { points: '15.33 40.42 18.1 54.32 17.91 54.32 15.14 40.42 15.33 40.42', fill: '#45a99c' }),
                            _react2['default'].createElement('polygon', { points: '15.51 40.42 18.28 54.32 18.1 54.32 15.33 40.42 15.51 40.42', fill: '#47ad9f' }),
                            _react2['default'].createElement('polygon', { points: '15.69 40.42 18.46 54.32 18.28 54.32 15.51 40.42 15.69 40.42', fill: '#49b1a2' }),
                            _react2['default'].createElement('polygon', { points: '15.88 40.42 18.65 54.32 18.46 54.32 15.69 40.42 15.88 40.42', fill: '#4cb6a6' }),
                            _react2['default'].createElement('polygon', { points: '16.06 40.42 18.83 54.32 18.65 54.32 15.88 40.42 16.06 40.42', fill: '#4ebaa9' }),
                            _react2['default'].createElement('polygon', { points: '16.77 40.42 19.54 54.32 18.83 54.32 16.06 40.42 16.77 40.42', fill: '#4ebaa9' }),
                            _react2['default'].createElement('polygon', { points: '17.48 40.42 20.25 54.32 19.54 54.32 16.77 40.42 17.48 40.42', fill: '#53bdac' }),
                            _react2['default'].createElement('polygon', { points: '18.19 40.42 20.96 54.32 20.25 54.32 17.48 40.42 18.19 40.42', fill: '#57bfae' }),
                            _react2['default'].createElement('polygon', { points: '18.89 40.42 21.66 54.32 20.96 54.32 18.19 40.42 18.89 40.42', fill: '#5cc2b1' }),
                            _react2['default'].createElement('polygon', { points: '40.33 50.78 22.54 54.32 21.66 54.32 18.89 40.42 40.33 40.42 40.33 50.78', fill: '#5cc2b1' })
                        ),
                        _react2['default'].createElement(
                            'g',
                            null,
                            _react2['default'].createElement('polygon', { points: '33.95 15.51 33.85 15.73 22.75 11.01 23.3 9.73 33.95 9.73 33.95 15.51', fill: '#236736' }),
                            _react2['default'].createElement('rect', { x: '28.17', y: '7.43', width: '0.19', height: '12.06', transform: 'translate(4.81 34.19) rotate(-66.94)', fill: '#236736' }),
                            _react2['default'].createElement('rect', { x: '28.09', y: '7.6', width: '0.19', height: '12.06', transform: 'translate(4.6 34.23) rotate(-66.94)', fill: '#276b37' }),
                            _react2['default'].createElement('rect', { x: '28.02', y: '7.78', width: '0.19', height: '12.06', transform: 'translate(4.39 34.27) rotate(-66.94)', fill: '#2b6e38' }),
                            _react2['default'].createElement('rect', { x: '27.94', y: '7.96', width: '0.19', height: '12.06', transform: 'translate(4.18 34.31) rotate(-66.94)', fill: '#307238' }),
                            _react2['default'].createElement('rect', { x: '27.87', y: '8.14', width: '0.19', height: '12.06', transform: 'translate(3.97 34.35) rotate(-66.94)', fill: '#347539' }),
                            _react2['default'].createElement('rect', { x: '27.79', y: '8.31', width: '0.19', height: '12.06', transform: 'translate(3.77 34.38) rotate(-66.94)', fill: '#38793a' }),
                            _react2['default'].createElement('rect', { x: '27.72', y: '8.49', width: '0.19', height: '12.06', transform: 'translate(3.56 34.42) rotate(-66.94)', fill: '#3c7d3b' }),
                            _react2['default'].createElement('rect', { x: '27.64', y: '8.67', width: '0.19', height: '12.06', transform: 'translate(3.35 34.46) rotate(-66.94)', fill: '#41803b' }),
                            _react2['default'].createElement('rect', { x: '27.57', y: '8.84', width: '0.19', height: '12.06', transform: 'translate(3.14 34.5) rotate(-66.94)', fill: '#45843c' }),
                            _react2['default'].createElement('rect', { x: '27.49', y: '9.02', width: '0.19', height: '12.06', transform: 'translate(2.93 34.54) rotate(-66.94)', fill: '#49873d' }),
                            _react2['default'].createElement('rect', { x: '27.41', y: '9.2', width: '0.19', height: '12.06', transform: 'translate(2.72 34.58) rotate(-66.94)', fill: '#4d8b3e' }),
                            _react2['default'].createElement('rect', { x: '27.34', y: '9.38', width: '0.19', height: '12.06', transform: 'matrix(0.39, -0.92, 0.92, 0.39, 2.51, 34.61)', fill: '#528e3e' }),
                            _react2['default'].createElement('rect', { x: '27.26', y: '9.55', width: '0.19', height: '12.06', transform: 'translate(2.3 34.65) rotate(-66.94)', fill: '#56923f' }),
                            _react2['default'].createElement('rect', { x: '27.19', y: '9.73', width: '0.19', height: '12.06', transform: 'translate(2.09 34.69) rotate(-66.94)', fill: '#5a9640' }),
                            _react2['default'].createElement('rect', { x: '27.11', y: '9.91', width: '0.19', height: '12.06', transform: 'translate(1.88 34.73) rotate(-66.94)', fill: '#5e9941' }),
                            _react2['default'].createElement('rect', { x: '27.04', y: '10.09', width: '0.19', height: '12.06', transform: 'translate(1.67 34.77) rotate(-66.94)', fill: '#639d41' }),
                            _react2['default'].createElement('rect', { x: '26.96', y: '10.26', width: '0.19', height: '12.06', transform: 'translate(1.47 34.81) rotate(-66.94)', fill: '#67a042' }),
                            _react2['default'].createElement('rect', { x: '26.89', y: '10.44', width: '0.19', height: '12.06', transform: 'translate(1.26 34.84) rotate(-66.94)', fill: '#6ba443' }),
                            _react2['default'].createElement('rect', { x: '26.59', y: '10.76', width: '0.51', height: '12.06', transform: 'translate(0.87 34.91) rotate(-66.94)', fill: '#6ba443' }),
                            _react2['default'].createElement('rect', { x: '26.39', y: '11.23', width: '0.51', height: '12.06', transform: 'translate(0.32 35.02) rotate(-66.94)', fill: '#70a944' }),
                            _react2['default'].createElement('rect', { x: '26.19', y: '11.7', width: '0.51', height: '12.06', transform: 'translate(-0.23 35.12) rotate(-66.94)', fill: '#74ae44' }),
                            _react2['default'].createElement('rect', { x: '25.99', y: '12.17', width: '0.51', height: '12.06', transform: 'translate(-0.78 35.22) rotate(-66.94)', fill: '#79b345' }),
                            _react2['default'].createElement('rect', { x: '25.79', y: '12.64', width: '0.51', height: '12.06', transform: 'translate(-1.34 35.32) rotate(-66.94)', fill: '#7db745' }),
                            _react2['default'].createElement('rect', { x: '25.59', y: '13.11', width: '0.51', height: '12.06', transform: 'translate(-1.89 35.42) rotate(-66.94)', fill: '#82bc46' }),
                            _react2['default'].createElement('rect', { x: '25.39', y: '13.58', width: '0.51', height: '12.06', transform: 'translate(-2.44 35.52) rotate(-66.94)', fill: '#86c146' }),
                            _react2['default'].createElement('polygon', { points: '31.09 22.21 22.28 42.9 10.9 42.9 10.9 38.85 20 17.48 31.09 22.21', fill: '#86c146' })
                        ),
                        _react2['default'].createElement('path', { d: 'M45.2,54.32,27.09,11.46A2.24,2.24,0,0,0,25,9.79,2.06,2.06,0,0,0,23,11,2,2,0,0,1,25,9.68H37.52a2,2,0,0,1,2,1.3L57.79,54.32Z', fill: '#394da5' }),
                        _react2['default'].createElement(
                            'g',
                            null,
                            _react2['default'].createElement('polygon', { points: '33.06 9.68 23.86 13.54 22.97 11.41 22.97 9.68 33.06 9.68', fill: '#29a5e3' }),
                            _react2['default'].createElement('polygon', { points: '34.05 9.68 24.01 13.89 23.86 13.54 33.06 9.68 34.05 9.68', fill: '#29a5e3' }),
                            _react2['default'].createElement('polygon', { points: '35.05 9.68 24.16 14.25 24.01 13.89 34.05 9.68 35.05 9.68', fill: '#2aa1e0' }),
                            _react2['default'].createElement('polygon', { points: '36.04 9.68 24.31 14.6 24.16 14.25 35.05 9.68 36.04 9.68', fill: '#2b9ddd' }),
                            _react2['default'].createElement('polygon', { points: '37.03 9.68 24.46 14.96 24.31 14.6 36.04 9.68 37.03 9.68', fill: '#2c98d9' }),
                            _react2['default'].createElement('polygon', { points: '38.03 9.68 24.61 15.31 24.46 14.96 37.03 9.68 38.03 9.68', fill: '#2d94d6' }),
                            _react2['default'].createElement('polygon', { points: '39.02 9.68 24.76 15.67 24.61 15.31 38.03 9.68 39.02 9.68', fill: '#2e90d3' }),
                            _react2['default'].createElement('polygon', { points: '39.23 9.68 39.35 9.96 24.91 16.02 24.76 15.67 39.02 9.68 39.23 9.68', fill: '#2f8cd0' }),
                            _react2['default'].createElement('rect', { x: '24.37', y: '12.98', width: '15.67', height: '0.39', transform: 'translate(-2.59 13.49) rotate(-22.78)', fill: '#2f87cc' }),
                            _react2['default'].createElement('rect', { x: '24.52', y: '13.33', width: '15.67', height: '0.39', transform: 'translate(-2.71 13.58) rotate(-22.78)', fill: '#3083c9' }),
                            _react2['default'].createElement('rect', { x: '24.67', y: '13.69', width: '15.67', height: '0.39', transform: 'translate(-2.84 13.67) rotate(-22.78)', fill: '#317fc6' }),
                            _react2['default'].createElement('rect', { x: '24.82', y: '14.04', width: '15.67', height: '0.39', transform: 'translate(-2.96 13.75) rotate(-22.78)', fill: '#327bc3' }),
                            _react2['default'].createElement('rect', { x: '24.97', y: '14.4', width: '15.67', height: '0.39', transform: 'translate(-3.09 13.84) rotate(-22.78)', fill: '#3376bf' }),
                            _react2['default'].createElement('rect', { x: '25.12', y: '14.75', width: '15.67', height: '0.39', transform: 'translate(-3.22 13.92) rotate(-22.78)', fill: '#3472bc' }),
                            _react2['default'].createElement('rect', { x: '25.26', y: '15.11', width: '15.67', height: '0.39', transform: 'translate(-3.34 14.01) rotate(-22.78)', fill: '#356eb9' }),
                            _react2['default'].createElement('rect', { x: '25.46', y: '15.45', width: '15.67', height: '0.63', transform: 'translate(-3.51 14.12) rotate(-22.78)', fill: '#356eb9' }),
                            _react2['default'].createElement('rect', { x: '25.71', y: '16.04', width: '15.67', height: '0.63', transform: 'translate(-3.72 14.26) rotate(-22.78)', fill: '#3669b6' }),
                            _react2['default'].createElement('rect', { x: '25.95', y: '16.62', width: '15.67', height: '0.63', transform: 'translate(-3.92 14.4) rotate(-22.78)', fill: '#3665b3' }),
                            _react2['default'].createElement('rect', { x: '26.2', y: '17.21', width: '15.67', height: '0.63', transform: 'translate(-4.13 14.54) rotate(-22.78)', fill: '#3760b0' }),
                            _react2['default'].createElement('rect', { x: '26.44', y: '17.79', width: '15.67', height: '0.63', transform: 'translate(-4.34 14.68) rotate(-22.78)', fill: '#375bae' }),
                            _react2['default'].createElement('rect', { x: '26.69', y: '18.38', width: '15.67', height: '0.63', transform: 'translate(-4.55 14.82) rotate(-22.78)', fill: '#3856ab' }),
                            _react2['default'].createElement('rect', { x: '26.94', y: '18.96', width: '15.67', height: '0.63', transform: 'translate(-4.75 14.97) rotate(-22.78)', fill: '#3852a8' }),
                            _react2['default'].createElement('rect', { x: '27.18', y: '19.55', width: '15.67', height: '0.63', transform: 'translate(-4.96 15.11) rotate(-22.78)', fill: '#394da5' }),
                            _react2['default'].createElement('polygon', { points: '42.36 17.13 57.79 53.86 57.79 54.32 40.99 54.32 27.92 23.19 42.36 17.13', fill: '#394da5' })
                        )
                    )
                );
            }

            return render;
        }()
    }]);

    return Autodesk;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Autodesk;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutomationAnywhere = (_temp = _class = function (_SvgIcon) {
  _inherits(AutomationAnywhere, _SvgIcon);

  function AutomationAnywhere() {
    _classCallCheck(this, AutomationAnywhere);

    return _possibleConstructorReturn(this, (AutomationAnywhere.__proto__ || Object.getPrototypeOf(AutomationAnywhere)).apply(this, arguments));
  }

  _createClass(AutomationAnywhere, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            {
              id: 'Icons-/-Integrations-/-Automation-Anywhere',
              stroke: 'none',
              strokeWidth: '1',
              fill: 'none',
              fillRule: 'evenodd'
            },
            _react2['default'].createElement(
              'g',
              { id: 'Colors-/-Swatches-/-Transparent' },
              _react2['default'].createElement('rect', { id: 'Swatch', x: '0', y: '0', width: '64', height: '64' })
            ),
            _react2['default'].createElement(
              'g',
              { id: 'Group-34', transform: 'translate(11.000000, 9.000000)' },
              _react2['default'].createElement(
                'g',
                { id: 'Group-33' },
                _react2['default'].createElement(
                  'mask',
                  { id: 'mask-2', fill: 'white' },
                  _react2['default'].createElement('path', {
                    d: 'M18.9310345,-7.10542736e-15 C17.3017241,0.155932203 15.9051724,1.24745763 15.2844828,2.88474576 L0.232758621,44.3619322 C2.77555756e-17,44.9076949 0.310344828,45.6101695 0.931810345,45.7661017 C1.0862069,45.8440678 1.1637931,45.8440678 1.31896552,45.8440678 C1.62931034,45.8440678 2.01724138,45.6881356 2.17241379,45.3770508 C2.17241379,45.2983051 2.25,45.2983051 2.25,45.220339 C4.5,41.4779661 7.60344828,38.2813559 11.4059483,36.0983051 C15.2844828,33.8365085 19.7068966,32.6677966 24.2068966,32.6677966 C26.9224138,32.6677966 29.5603448,33.0568475 32.0431034,33.9152542 L35.2241379,42.4915254 L35.3017241,42.6474576 C36,44.5186441 37.7068966,45.6881356 39.6465517,45.6881356 C42.1797414,45.6881356 44.2582759,43.6259322 44.3017241,41.0896949 L44.3017241,40.9501356 C44.2869828,40.337322 44.0588793,39.5872881 43.7586207,38.9830508 C43.6042241,38.7491525 43.4482759,38.5152542 43.2931034,38.2813559 C43.2155172,38.2033898 43.137931,38.0474576 43.0603448,37.9694915 C40.3448276,35.3966102 37.1637931,33.4474576 33.75,32.2 L33.5172414,31.5762712 L23.0431034,2.88474576 C22.4224138,1.24745763 21.0258621,0.0779661017 19.3965517,-7.10542736e-15 L18.9310345,-7.10542736e-15 Z M17.3017241,3.66440678 C17.612069,2.806 18.3103448,2.26023729 19.0862069,2.18305085 C19.862069,2.18305085 20.5603448,2.806 20.8706897,3.66440678 L30.9568966,31.420339 C28.7844828,30.7966102 26.5344828,30.4847458 24.2068966,30.4847458 C19.3189655,30.4847458 14.5086207,31.8101695 10.3189655,34.2271186 C8.22413793,35.4745763 6.36206897,36.9559322 4.65517241,38.5932203 L17.3017241,3.66440678 Z M37.3189655,41.9457627 L37.3189655,41.8685763 L37.2413793,41.6338983 L34.7586207,35.0847458 C37.0862069,36.1762712 39.1810345,37.5804407 41.1206897,39.2941356 C41.3534483,39.5288136 41.5862069,39.7634915 41.7413793,40.0737966 C41.8965517,40.4644068 42.0517241,40.7762712 42.0517241,41.2440678 C42.0517241,42.4915254 40.9647414,43.5822712 39.6465517,43.5822712 C38.637931,43.5822712 37.7068966,42.8813559 37.3189655,41.9457627 Z',
                    id: 'path-1'
                  })
                ),
                _react2['default'].createElement('g', { id: 'Clip-2' }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-1',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '34.7586207 43.5830508 35.4856034 43.5830508 35.4856034 35.0855254 34.7586207 35.0855254'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-3',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '35.4863793 43.5830508 39.695431 43.5830508 39.695431 35.0855254 35.4863793 35.0855254'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-4',
                  fill: '#F15A29',
                  mask: 'url(#mask-2)',
                  points: '39.695431 43.5822712 42.0525 43.5822712 42.0525 35.0847458 39.695431 35.0847458'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-5',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '4.65517241 38.5932203 6.59637931 38.5932203 6.59637931 2.18305085 4.65517241 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-6',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '6.59637931 38.5932203 9.20094828 38.5932203 9.20094828 2.18305085 6.59637931 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-7',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '9.20094828 38.5932203 11.8055172 38.5932203 11.8055172 2.18305085 9.20094828 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-8',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '11.8055172 38.5932203 14.5031897 38.5932203 14.5031897 2.18305085 11.8055172 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-9',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '14.5024138 38.5932203 17.2000862 38.5932203 17.2000862 2.18305085 14.5024138 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-10',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '17.2000862 38.5932203 20.0257759 38.5932203 20.0257759 2.18305085 17.2000862 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-11',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '20.0257759 38.5932203 22.8514655 38.5932203 22.8514655 2.18305085 20.0257759 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-12',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '22.8506897 38.5932203 25.8571552 38.5932203 25.8571552 2.18305085 22.8506897 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-13',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '25.8571552 38.5932203 28.8636207 38.5932203 28.8636207 2.18305085 25.8571552 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-14',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '28.8636207 38.5932203 30.9568966 38.5932203 30.9568966 2.18305085 28.8636207 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-15',
                  fill: '#FFDE17',
                  mask: 'url(#mask-2)',
                  points: '2.22044605e-16 45.8440678 0.155172414 45.8440678 0.155172414 -7.10542736e-15 2.22044605e-16 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-16',
                  fill: '#FFDE17',
                  mask: 'url(#mask-2)',
                  points: '0.155172414 45.8440678 0.892241379 45.8440678 0.892241379 -7.10542736e-15 0.155172414 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-17',
                  fill: '#FFD31C',
                  mask: 'url(#mask-2)',
                  points: '0.892241379 45.8440678 1.62931034 45.8440678 1.62931034 -7.10542736e-15 0.892241379 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-18',
                  fill: '#FFD31C',
                  mask: 'url(#mask-2)',
                  points: '1.62931034 45.8440678 4.11284483 45.8440678 4.11284483 -7.10542736e-15 1.62931034 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-19',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '4.11284483 45.8440678 6.59637931 45.8440678 6.59637931 -7.10542736e-15 4.11284483 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-20',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '6.59637931 45.8440678 9.20094828 45.8440678 9.20094828 -7.10542736e-15 6.59637931 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-21',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '9.20094828 45.8440678 11.8055172 45.8440678 11.8055172 -7.10542736e-15 9.20094828 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-22',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '11.8055172 45.8440678 14.5031897 45.8440678 14.5031897 -7.10542736e-15 11.8055172 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-23',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '14.5024138 45.8440678 17.2000862 45.8440678 17.2000862 -7.10542736e-15 14.5024138 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-24',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '17.2000862 45.8440678 20.0257759 45.8440678 20.0257759 -7.10542736e-15 17.2000862 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-25',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '20.0257759 45.8440678 22.8514655 45.8440678 22.8514655 -7.10542736e-15 20.0257759 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-26',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '22.8506897 45.8440678 25.8571552 45.8440678 25.8571552 -7.10542736e-15 22.8506897 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-27',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '25.8571552 45.8440678 28.8636207 45.8440678 28.8636207 -7.10542736e-15 25.8571552 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-28',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '28.8636207 45.8440678 32.175 45.8440678 32.175 -7.10542736e-15 28.8636207 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-29',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '32.1742241 45.8440678 35.4856034 45.8440678 35.4856034 -7.10542736e-15 32.1742241 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-30',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '35.4863793 45.8440678 39.695431 45.8440678 39.695431 -7.10542736e-15 35.4863793 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-31',
                  fill: '#F15A29',
                  mask: 'url(#mask-2)',
                  points: '39.695431 45.8440678 43.9044828 45.8440678 43.9044828 -7.10542736e-15 39.695431 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-32',
                  fill: '#F15A29',
                  mask: 'url(#mask-2)',
                  points: '43.9044828 45.8440678 44.3017241 45.8440678 44.3017241 -7.10542736e-15 43.9044828 -7.10542736e-15'
                })
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return AutomationAnywhere;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = AutomationAnywhere;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// An icon of Box the file sharing company, not a box with lowercase b.
var Box = (_temp = _class = function (_SvgIcon) {
  _inherits(Box, _SvgIcon);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#0075C9',
            d: 'M213.4,159.6c-22.6,0-42.3,12.7-52.2,31.4c-9.9-18.7-29.6-31.4-52.2-31.4c-13.3,0-25.6,4.4-35.5,11.8v-49.8h0 C73.3,115.2,68,110,61.6,110s-11.7,5.2-11.8,11.6h0v98.1h0c0.5,32.2,26.8,58.2,59.1,58.2c22.6,0,42.3-12.7,52.2-31.4 c9.9,18.7,29.6,31.4,52.2,31.4c32.7,0,59.1-26.5,59.1-59.1S246,159.6,213.4,159.6z M108.9,254.2c-19.6,0-35.5-15.9-35.5-35.5 s15.9-35.5,35.5-35.5c19.6,0,35.5,15.9,35.5,35.5S128.5,254.2,108.9,254.2z M213.4,254.2c-19.6,0-35.5-15.9-35.5-35.5 s15.9-35.5,35.5-35.5s35.5,15.9,35.5,35.5S232.9,254.2,213.4,254.2z'
          }),
          _react2['default'].createElement('path', {
            fill: '#0075C9',
            d: 'M352,259.2l-30.3-40.5l30.3-40.5l0,0c3.7-5.2,2.7-12.5-2.5-16.4c-5.2-3.9-12.4-2.9-16.4,2.2l0,0L307,199 l-26.1-34.9l0,0c-4-5.1-11.3-6-16.4-2.2c-5.2,3.9-6.2,11.2-2.5,16.4l0,0l30.3,40.5l-30.3,40.5l0,0c-3.7,5.2-2.7,12.5,2.5,16.4 c5.2,3.9,12.4,2.9,16.4-2.2l0,0l26.1-34.9l26.1,34.9l0,0c4,5.1,11.3,6,16.4,2.2C354.7,271.7,355.8,264.5,352,259.2L352,259.2z'
          })
        );
      }

      return render;
    }()
  }]);

  return Box;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Box;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Brain = (_temp = _class = function (_SvgIcon) {
  _inherits(Brain, _SvgIcon);

  function Brain() {
    _classCallCheck(this, Brain);

    return _possibleConstructorReturn(this, (Brain.__proto__ || Object.getPrototypeOf(Brain)).apply(this, arguments));
  }

  _createClass(Brain, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M36.69,12.58v-.72h2.79V9.79H36.69V9.08h-.77V7.28a3.19,3.19,0,0,0-3.15-3.15H31V3.35h-.72V.57H28.18V3.35h-.71v.78h-2.7V3.35h-.72V.57H22V3.35h-.72v.78h-2.7V3.35h-.72V.57H15.77V3.35h-.72v.78H12.36V3.35h-.72V.57H9.57V3.35H8.85v.78H7.05A3.19,3.19,0,0,0,3.9,7.28v1.8H3.31v.71H.52v2.07H3.31v.72h.77v2.7H3.31V16H.52v2.07H3.31v.72h.77v2.7H3.31v.72H.52v2.06H3.31V25h.77v2.7H3.31v.72H.52v2.07H3.31v.72h.77V33a3.18,3.18,0,0,0,3.15,3.14H9v.78h.72v2.6h2.07V36.74h.72V36h2.69v.78H16v2.78H18V36.74h.72V36h2.7v.78h.72v2.78h2.07V36.74H25V36h2.7v.78h.71v2.78h2.07V36.74h.72V36H33a3.18,3.18,0,0,0,3.15-3.14V31h.77V30.3h2.61V28.23H36.69v-.72h-.77v-2.7h.77v-.72h2.79V22H36.69v-.72h-.77v-2.7h.77v-.72h2.79V15.82H36.69V15.1h-.77V12.4h.77Zm-5-5.39a1.09,1.09,0,0,1,1.08,1.08V31.83a1.09,1.09,0,0,1-1.08,1.08H8.22a1.09,1.09,0,0,1-1.08-1.08V8.27A1.09,1.09,0,0,1,8.22,7.19' }),
          _react2['default'].createElement('path', { d: 'M9.3,9.34V30.75H30.7V9.34ZM28.08,22.42a3,3,0,0,1-1,2.25,3,3,0,0,1-2.37,2.7,3,3,0,0,1-2.64,1.57,3,3,0,0,1-2-.77,3,3,0,0,1-4.65-.8A3,3,0,0,1,13,24.67a3,3,0,0,1-1-2.25,3,3,0,0,1,.28-1.25A3,3,0,0,1,12,19.91a3,3,0,0,1,1-2.25,2.28,2.28,0,0,1,0-.26,3,3,0,0,1,1-2.25,3,3,0,0,1,1.11-2.1,3,3,0,0,1,4.9-1.4,3,3,0,0,1,2-.77A3,3,0,0,1,25,13.05a3,3,0,0,1,1.11,2.1,3,3,0,0,1,1,2.25c0,.09,0,.17,0,.26a3,3,0,0,1,1,2.25,3.2,3.2,0,0,1-.27,1.26A3.15,3.15,0,0,1,28.08,22.42Z' }),
          _react2['default'].createElement('path', { d: 'M19.55,20.07A1.73,1.73,0,0,1,18.27,20l-.44.9a2.66,2.66,0,0,0,1.72.24v1.82H18.48a1,1,0,0,1-.9-.55L17,21.19l-.89.45.58,1.17a2,2,0,0,0,1.8,1.11h1.07v2a1.52,1.52,0,0,1-1,1.42v-.8A2,2,0,0,0,18,25.13l-.56-.56-.71.71.56.56a1,1,0,0,1,.3.71v.8a1.53,1.53,0,0,1-1-1.05l-.1-.39-.4,0H16a1.5,1.5,0,0,1-1.5-1.5h0l1.32-1.12-.64-.76-1.19,1a1.49,1.49,0,0,1-.49-1.11,1.46,1.46,0,0,1,.33-.94l.05-.06H15v-1H13.62a1.38,1.38,0,0,1-.08-.5,1.48,1.48,0,0,1,.85-1.35l.41-.2-.16-.43a1.39,1.39,0,0,1-.1-.53,1.51,1.51,0,0,1,.32-.92l1.34,1.68a2.72,2.72,0,0,0,.24.24l-.81,1.23.83.56.89-1.33a1.93,1.93,0,0,0,.42.05h.78v-1h-.78a1,1,0,0,1-.78-.38l-1.41-1.76,0-.18a1.54,1.54,0,0,1,0-.19,1.5,1.5,0,0,1,.77-1.31l.14-.08.74.74L17.9,14l-1-1a1.5,1.5,0,0,1,2.7.9v1.85a2,2,0,0,0-1.12-.34h-.88v1h.88a1,1,0,0,1,.71.29l.41.42Zm6.64,1.35,0,.06a1.47,1.47,0,0,1,.34.94,1.51,1.51,0,0,1-.32.92,2,2,0,0,0-1.69-.92h-1a1,1,0,0,1-1-1h-1a2,2,0,0,0,2,2h1a1,1,0,0,1,1,1,1.51,1.51,0,0,1-1,1.41v-.91h-1v1.18l-.05.19a1.5,1.5,0,0,1-1.46,1.13l-.27,0,.63-.62-.71-.71-.81.8a1.51,1.51,0,0,1-.34-.95v-.69L21,25a1,1,0,0,1,.44-.1h1.15v-1H21.41a1.93,1.93,0,0,0-.85.2V20.73a3.71,3.71,0,0,1,1.5-.32v-1a4.77,4.77,0,0,0-1.5.25v-3.6a2,2,0,0,0,1.12.34h.88v-1h-.88a1,1,0,0,1-.71-.3l-.41-.41v-.8a1.5,1.5,0,0,1,1.5-1.5,1.48,1.48,0,0,1,1.2.6l-1.05,1,.71.71.74-.74.14.08a1.5,1.5,0,0,1,.77,1.31v.06l-.57.72a2,2,0,0,0-.43,1.22h-2v1h2v1h1v-2a1,1,0,0,1,.22-.62l.35-.45a1.53,1.53,0,0,1,.43,1,1.39,1.39,0,0,1-.1.53l-.16.43.42.2a1.49,1.49,0,0,1,.85,1.35,1.39,1.39,0,0,1-.09.5H24.57v1Z' })
        );
      }

      return render;
    }()
  }]);

  return Brain;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40 40'
}, _temp);
exports['default'] = Brain;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CircleCI = (_temp = _class = function (_SvgIcon) {
  _inherits(CircleCI, _SvgIcon);

  function CircleCI() {
    _classCallCheck(this, CircleCI);

    return _possibleConstructorReturn(this, (CircleCI.__proto__ || Object.getPrototypeOf(CircleCI)).apply(this, arguments));
  }

  _createClass(CircleCI, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'circleci', transform: 'translate(5.000000, 10.000000)' },
            _react2['default'].createElement('path', {
              fill: '#054C64',
              transform: 'translate(0.000000, 31.850746)',
              d: 'M45.7638333,12.149254 C47.8985,12.1476119 49.7628333,10.7266418 50.3005264,8.69164179 L50.3005264,8.63910448 C50.3023333,8.52302985 50.2083333,8.42747761 50.0906667,8.42567164 C50.0883333,8.42550746 50.0861667,8.42550746 50.0838333,8.42567164 L48.1938333,8.42567164 C48.109,8.42698507 48.034,8.47985075 48.0055,8.55865672 C47.4348333,9.7671791 45.9776667,10.2912388 44.7508333,9.72908955 C43.524,9.16677612 42.992,7.73135821 43.5626667,6.52267164 C43.9658333,5.6689403 44.8363333,5.12419403 45.7921667,5.12731343 C46.7443333,5.12764179 47.6076667,5.67764179 47.9988333,6.53268657 C48.0273333,6.61149254 48.1023333,6.66435821 48.1871667,6.66567164 L50.0771667,6.66567164 C50.195,6.66747761 50.292,6.5748806 50.2938333,6.45880597 C50.294,6.45667164 50.294,6.45437313 50.2938333,6.45223881 L50.2938333,6.40298507 C49.6551667,3.93767164 47.1083333,2.44938806 44.6058333,3.07868657 C42.1031667,3.70798507 40.5923333,6.21647761 41.2311667,8.68179104 C41.76,10.7223731 43.626,12.1499104 45.7638333,12.149254 L45.7638333,12.149254 Z M53.7755,3.17358209 L53.7755,11.7108955 C53.7773333,11.8269701 53.6835,11.9225224 53.5656667,11.9243592 L53.559,11.9243592 L51.7855,11.9243592 C51.6676667,11.9262985 51.5708333,11.8335373 51.5688333,11.7174627 L51.5688333,11.7108955 L51.5688333,3.17358209 L53.7821667,3.17358209 L53.7755,3.17358209 Z M52.6688333,0.0886567164 C51.938,0.0886567164 51.3455,0.672313433 51.3455,1.39223881 C51.3455,2.11216418 51.938,2.6958209 52.6688333,2.6958209 C53.3996667,2.6958209 53.9921667,2.11216418 53.9921667,1.39223881 C53.977,0.682328358 53.3961667,0.110820896 52.6755,0.0968656716 L52.6688333,0.0886567164 Z M31.8521667,6.68537313 C32.3416667,4.93719403 34.1771667,3.91091045 35.9518333,4.39310448 C37.083,4.70044776 37.9668333,5.57108955 38.2788333,6.68537313 L31.8588333,6.68537313 L31.8521667,6.68537313 Z M35.0656667,2.93552046 C32.4881667,2.93322388 30.397,4.98973134 30.3948314,7.52843284 C30.3925,10.0672985 32.48,12.1272537 35.0575,12.1295543 C36.8171667,12.131194 38.4281667,11.1572836 39.2238333,9.61104478 C39.2485,9.58116418 39.2583333,9.54208955 39.2505,9.50432836 C39.2525,9.38841791 39.1583333,9.29286567 39.0405,9.29089552 L39.0338333,9.29089552 L38.0155,9.29089552 C37.9438333,9.28925373 37.875,9.31864179 37.8271667,9.37134328 C36.784,10.8657015 34.7086667,11.243806 33.1918333,10.216209 C32.42,9.69346269 31.9073333,8.87502985 31.7788333,7.96104478 L39.5271667,7.96104478 C39.645,7.96285075 39.742,7.87041791 39.7438333,7.7541791 L39.7438333,7.74761194 L39.7438333,7.50791045 C39.7263333,4.97938806 37.6391667,2.93929851 35.0723333,2.94208955 L35.0656667,2.93552046 Z M28.8555,0.328332235 L27.9638333,0.328332235 C27.846,0.326552239 27.749,0.419149254 27.7471667,0.535223881 L27.7471667,0.541791045 L27.7471667,11.7059701 C27.7453333,11.8220448 27.8393333,11.917597 27.9571667,11.919403 C27.9593333,11.9195261 27.9616667,11.9195261 27.9638333,11.919403 L28.8555,11.919403 C28.9733333,11.921209 29.0703333,11.8286119 29.0723333,11.7125373 L29.0723333,11.7059701 L29.0723333,0.541791045 C29.074,0.425716418 28.98,0.330164179 28.8623333,0.328332235 L28.8621667,0.328332235 L28.8555,0.328332235 Z M26.1888333,9.29089552 L25.1655,9.29089552 C25.0938333,9.28925373 25.025,9.31864179 24.9771667,9.37134328 C24.3603333,10.2726866 23.3275,10.8116866 22.2238333,10.8079104 C20.3746667,10.8136567 18.8708333,9.34146269 18.865,7.5200597 C18.8591667,5.69832836 20.3535,4.21710448 22.2026667,4.21119403 C23.312,4.20774627 24.351,4.74576119 24.9771667,5.64776119 C25.025,5.70046269 25.0938333,5.72985075 25.1655,5.72820896 L26.1921667,5.72820896 C26.31,5.73001493 26.407,5.63741791 26.4088333,5.52134328 C26.409,5.51920896 26.409,5.51707463 26.4088333,5.51477612 C26.4126667,5.4771791 26.4031667,5.43958209 26.3821667,5.4080597 C25.2191667,3.14238806 22.4118333,2.23431343 20.1118333,3.3801194 C17.8118333,4.52576119 16.8901667,7.29119403 18.0531667,9.55686567 C19.2161667,11.8225373 22.0235,12.7304478 24.3235,11.584806 C25.2116667,11.1423433 25.933,10.4317761 26.3821667,9.55686567 C26.4068333,9.52698507 26.4166667,9.48791045 26.4088333,9.45014925 C26.3731667,9.36067164 26.2865,9.30107463 26.1888333,9.29910448 L26.1888333,9.29089552 Z M17.3055,2.96014925 C16.0548333,2.98625373 14.8958333,3.61210448 14.2005,4.63641791 L14.2005,3.41328358 C14.2023333,3.29720896 14.1083333,3.20165672 13.9905,3.19985075 L13.9838333,3.19985075 L13.0921667,3.19985075 C12.9743333,3.19804478 12.8773333,3.29064179 12.8754736,3.40671642 L12.8754736,3.41328358 L12.8754736,11.738806 C12.8736667,11.8548806 12.9676667,11.9504328 13.0855,11.9522696 L13.0921667,11.9522696 L13.9838333,11.9522696 C14.1016667,11.954209 14.1986667,11.8614478 14.2005,11.7453731 C14.2006667,11.7432388 14.2006667,11.7411045 14.2005,11.738806 L14.2005,7.57029851 C14.2025,5.84543284 15.5588333,4.41625373 17.3055,4.29820896 C17.4233333,4.30001493 17.5203333,4.20741791 17.5221667,4.09134328 L17.5221667,4.08477612 L17.5221667,3.18014925 C17.5393333,3.08 17.471,2.98510448 17.3693333,2.96802985 C17.3481667,2.96458209 17.3266667,2.96474627 17.3055,2.96835821 L17.3055,2.96014925 Z M11.5271667,11.7108955 L11.5271667,3.17358209 L10.2055,3.17358209 L10.2055,11.7108955 C10.2036667,11.8269701 10.2976667,11.9225224 10.4155,11.9243284 L10.4221667,11.9243284 L11.3138333,11.9243284 C11.4298333,11.9243284 11.5245,11.833209 11.5271667,11.7191045 L11.5271667,11.7108955 Z M11.7438333,1.41850746 C11.7438333,1.90365672 11.3446667,2.29686567 10.8521667,2.29686567 C10.3596667,2.29686567 9.9605,1.90365672 9.9605,1.41850746 C9.9605,0.933522388 10.3596667,0.540149254 10.8521667,0.540149254 C11.3391667,0.534567164 11.7383333,0.918910448 11.744,1.39864179 C11.7441667,1.40783582 11.744,1.41735821 11.7438333,1.42671642 L11.7438333,1.41850746 Z M8.63883333,9.29910448 L7.61216667,9.29910448 C7.5405,9.29746269 7.47166667,9.32701493 7.42383333,9.37955224 C6.8055,10.2818806 5.77066667,10.8202239 4.6655,10.8144776 C2.81633333,10.8202239 1.3125,9.34802985 1.30666667,7.52662687 C1.30083333,5.70489552 2.79516667,4.22367164 4.64433333,4.21776119 C5.75366667,4.21431343 6.79266667,4.75232836 7.41883333,5.65432836 C7.46666667,5.70702985 7.5355,5.73625373 7.60716667,5.73477612 L8.63383333,5.73477612 C8.75166667,5.73658209 8.84866667,5.64398507 8.8505,5.52791045 C8.85066667,5.52577612 8.85066667,5.52364179 8.8505,5.52134328 C8.856,5.4858806 8.84966667,5.44943284 8.83216667,5.41791045 C7.66916667,3.15223881 4.86183333,2.24432836 2.56183333,3.38980597 C0.261833333,4.53561194 -0.659833333,7.30104478 0.503166667,9.56671642 C1.66616667,11.8323881 4.4735,12.7404627 6.7735,11.5946567 C7.66166667,11.1523582 8.383,10.441791 8.83216667,9.56671642 C8.857,9.53683582 8.86666667,9.49776119 8.85883333,9.46 C8.8355,9.36067164 8.74233333,9.29253731 8.63883333,9.29910448 L8.63883333,9.29910448 Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#054C64',
              transform: 'translate(12.833333, 0.000000)',
              d: 'M13.9489,-5.70267455e-06 C7.4534,-0.00574626866 1.7824,4.33170149 0.1789,10.5320896 C0.1789,10.5846269 0.152233333,10.6125373 0.152233333,10.6650746 C0.152233333,11.0277463 0.450733333,11.321791 0.8189,11.321791 L6.54223333,11.321791 C6.81123333,11.3212985 7.05473333,11.165 7.1639,10.9228358 C8.87873333,7.23750746 13.3017333,5.61935821 17.0427333,7.30859701 C20.7840667,8.99783582 22.4265667,13.3548209 20.7117333,17.0401493 C18.9969,20.7254776 14.5739,22.3436269 10.8327333,20.6543881 C9.20973333,19.9214925 7.90773333,18.6389254 7.1639,17.0401493 C7.05473333,16.7979851 6.81123333,16.6416866 6.54223333,16.641194 L0.832233333,16.641194 C0.464066667,16.641194 0.165566667,16.9350746 0.1654,17.2979104 C0.1654,17.3005373 0.165566667,17.3033284 0.165566667,17.3061194 C0.161233333,17.3520896 0.170566667,17.3982239 0.192233333,17.4391045 C2.13806667,24.9350299 9.88423333,29.458 17.4939,27.541209 C23.7934,25.9542537 28.1984,20.3606716 28.1922398,13.9552239 C28.1789,6.25522388 21.8070667,-5.70267455e-06 13.9489,-5.70267455e-06 M10.5739,13.9946269 C10.5739,12.1584478 12.0849,10.67 13.9489,10.67 C15.8129,10.67 17.3239,12.1584478 17.3239,13.9946269 C17.3239,15.830806 15.8129,17.3192537 13.9489,17.3192537 C12.0852333,17.3182687 10.5747333,15.8303134 10.5739,13.9946269'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return CircleCI;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = CircleCI;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Coupa = (_temp = _class = function (_SvgIcon) {
  _inherits(Coupa, _SvgIcon);

  function Coupa() {
    _classCallCheck(this, Coupa);

    return _possibleConstructorReturn(this, (Coupa.__proto__ || Object.getPrototypeOf(Coupa)).apply(this, arguments));
  }

  _createClass(Coupa, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: 'none',
            d: 'M192.71,108.23c6.55-1.21,12.56-3.32,15.66-6.96c1.77-2.08,2.52-4.61,2.12-7.13c-1.03-6.39-9.14-10.93-17.99-14.02c3.63-2.6,6.34-5.41,7.54-8.36c1.11-2.72,0.96-5.51-0.42-7.87c-2.75-4.72-10-7.12-21.54-7.12c-0.01,0-0.02,0-0.03,0c2.24-3.57,3.79-7.32,3.71-10.81c-0.07-2.84-1.18-5.24-3.23-6.94c-2.02-1.69-4.8-2.54-8.26-2.54c-3.09,0-6.75,0.68-10.8,1.97c0.34-3.29,0.14-6.2-0.66-8.56c-1.27-3.78-3.71-5.5-5.52-6.28c-1.25-0.54-2.64-0.81-4.11-0.81c-4.2,0-9.3,2.39-14.59,6.61c-2.34-8.2-6.54-13.25-12.01-13.86c-0.36-0.04-0.72-0.06-1.08-0.06c-4.78,0-9.33,3.46-13.07,9.67c-4.45-5.44-9.42-9.02-14.41-9.02c-0.53,0-1.06,0.04-1.57,0.12c-2.03,0.32-4.92,1.43-7.17,4.92c-1.64,2.55-2.65,6.03-3.06,10.18c-6.37-3.88-12.18-6.04-16.64-6.04c-1.93,0-3.66,0.38-5.16,1.12c-2.52,1.25-4.23,3.42-4.96,6.29c-0.8,3.14-0.28,6.77,0.91,10.39c-4.08-0.83-7.84-1.27-11.1-1.27c-5.4,0-9.22,1.18-11.7,3.61c-2.1,2.07-3,4.89-2.52,7.95c0.6,3.85,3.4,7.94,7.48,11.94c-11.16,1.2-23.25,4.14-26.2,11.11c-1.05,2.49-0.88,5.22,0.48,7.7c2.19,3.98,7.33,7.08,13.35,9.45c-11.85,5.69-21.09,12.6-20.88,19.98c0.15,5.09,4.24,11.16,22.81,11.16c1.54,0,3.14-0.04,4.79-0.12C22.53,135.14,13,148.03,18,156.31c1.35,2.23,4.24,4.9,10.35,4.9c5.48,0,13.12-2.23,21.96-6.28c-3.98,10.29-6.04,19.71-4.64,26.18c0.94,4.34,3.26,6.53,5.04,7.61c1.61,0.97,3.46,1.46,5.48,1.46c8.01,0,18.6-8.27,28.96-20.12c0.72,12.48,3.12,23.84,8.19,29.65c2.88,3.3,6,4.12,8.12,4.22c0.16,0.01,0.31-0.04,0.49,0.01c10.33,0,17.25-14.31,21.52-28.16c7.01,12.14,14.94,20.44,22.47,20.44c1.38,0,2.71-0.27,3.96-0.79c9-3.76,10.12-18.77,7.79-35.41c9.27,6.72,17.47,10.46,23.38,10.46l0,0c4.32,0,6.84-1.89,8.19-3.47c5.56-6.52,1.07-18.3-5.11-28.8c3.83,0.76,7.33,1.17,10.36,1.17l0,0c9.56,0,12.72-4.05,13.69-7.45C210.29,124.67,202.78,116.01,192.71,108.23z'
          }),
          _react2['default'].createElement('path', {
            fill: '#40B4E5',
            d: 'M161.95,95.01c-3.38-1.62-6.7-3.09-9.91-4.38c3.23-0.65,6.51-1.43,9.8-2.34c22.79-6.25,37.25-16.06,33.75-22.06c-3.38-5.81-22.65-6.45-44.34-1.33c-3.14,0.74-6.16,1.55-9.07,2.44c1.53-2.23,3-4.56,4.37-6.95c9.17-16.1,10.9-29.92,4.9-32.49c-5.97-2.56-18.32,6.45-28.72,21.62c-1.55,2.26-2.98,4.53-4.28,6.82c-0.69-2.5-1.5-5.04-2.43-7.58c-6.28-17.17-16.2-28.95-22.83-27.89c-6.77,1.06-8.65,15.19-3.62,33.25c0.76,2.68,1.61,5.31,2.56,7.84c-2.69-1.52-5.53-2.99-8.51-4.42c-20.96-10.03-41.51-13.88-46.74-8.75c-5.45,5.35,7.39,18.63,29.65,29.83c3.17,1.6,6.33,3.06,9.48,4.38c-3.65,0.64-7.46,1.41-11.39,2.35C35.15,92.31,9.75,104.96,10,113.44c0.27,8.87,28.15,8.78,59.83,0.09c4.21-1.15,8.24-2.4,12.04-3.69c-2.43,3.1-4.88,6.44-7.34,10.03c-19.37,28.26-30.45,59.36-21.38,64.84c9.23,5.55,33.28-18.76,50.61-49.17c2.18-3.84,4.15-7.57,5.87-11.15c0.77,3.8,1.73,7.76,2.86,11.88c9.01,32.29,25.71,59,35.64,54.84c9.69-4.04,7.15-35.07-3.82-65.07c-1.4-3.84-2.87-7.47-4.38-10.88c3.24,1.93,6.7,3.81,10.32,5.63c26.73,13.47,51.2,17.96,53.51,9.84C205.95,122.89,186.78,106.88,161.95,95.01z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M89.54,104.42c-2.86,0.96-5.9,1.89-9.06,2.74c-9.46,2.55-18.43,4.06-25.87,4.53c-21.75,16.82-36.86,35.17-32.61,42.2c4.23,7.01,25.44-0.55,48.33-15.57c2.87-7.92,7.68-17.29,13.82-26.43C85.94,109.23,87.74,106.74,89.54,104.42z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M84.57,83.86c-2.45-1.03-4.94-2.17-7.42-3.41c-7.2-3.6-13.18-7.5-17.48-11.15c-22.06-0.68-40.4,2.81-43.01,8.97c-2.63,6.21,11.42,12.98,32.75,16.52c7.12-3.43,16.39-6.7,26.44-9.11C78.84,84.97,81.77,84.36,84.57,83.86z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M96.82,67.2c-0.78-2.04-1.49-4.16-2.12-6.33c-1.77-6.11-2.57-11.72-2.53-16.27C79.95,33.82,67.83,27.98,62.51,30.62c-5.28,2.62-2.77,12.94,5.98,25.36c6.33,1.37,13.89,4,21.57,7.68C92.43,64.8,94.69,65.98,96.82,67.2z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M136.43,71.39c2.33-0.72,4.76-1.39,7.27-1.99c7.15-1.72,13.95-2.64,19.69-2.83C174.91,56,179.87,46.21,175.53,42.6c-4.08-3.4-15.62-0.69-28.7,6.52c-0.93,4.66-3.21,10.47-6.81,16.65C138.89,67.71,137.69,69.6,136.43,71.39z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M110.77,115.38c-1.3,2.63-2.76,5.37-4.4,8.18c-4.98,8.54-10.64,16.27-16.09,22.28c-2.51,28.47,1.75,52.95,11.4,53.42c9.25,0.43,18.5-21.43,22.65-48.19c-4.27-7.05-8.36-16.52-11.37-26.93C112.09,121.11,111.37,118.19,110.77,115.38z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M117.63,62.58c1.04-1.86,2.19-3.72,3.43-5.58c3.51-5.21,7.3-9.57,10.89-12.75c-0.36-13.69-4.36-23.43-9.9-24.05c-5.36-0.6-11.26,7.38-14.79,19.89c3.08,4.08,6.09,9.72,8.44,16.32C116.45,58.47,117.09,60.55,117.63,62.58z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M205.87,94.88c-0.94-5.83-15.05-11.83-33.76-15.05c-4.94,2.95-12.04,5.87-20.52,8.15c-2.62,0.71-5.22,1.32-7.77,1.83c2.5,1.02,5.07,2.15,7.69,3.41c7.64,3.67,14.49,7.83,19.86,11.87C192.27,105.36,206.89,101.19,205.87,94.88z'
          }),
          _react2['default'].createElement('path', {
            fill: '#009BDE',
            d: 'M133.99,108.59c1.11,2.56,2.19,5.28,3.22,8.15c3.08,8.64,5.12,17.23,6.06,24.67c18.53,18.37,37.08,28.84,42.45,22.55c4.96-5.81-3.65-23.6-18.56-41.7c-7.17-1.57-16.07-4.78-25.31-9.41C139.09,111.48,136.46,110.05,133.99,108.59z'
          }),
          _react2['default'].createElement('path', {
            fill: '#FFFFFF',
            d: 'M171.37,105.08c-5.37-4.04-12.22-8.19-19.87-11.87c-2.61-1.26-5.19-2.39-7.69-3.41c2.55-0.51,5.15-1.12,7.77-1.83c8.48-2.29,15.58-5.2,20.52-8.15c5.7-3.4,8.54-6.86,7.17-9.46c-1.47-2.79-7.55-4.08-15.89-3.8c-5.74,0.19-12.54,1.11-19.69,2.84c-2.51,0.6-4.94,1.27-7.27,1.99c1.26-1.79,2.46-3.68,3.59-5.63c3.6-6.18,5.89-11.98,6.82-16.65c1.07-5.33,0.37-9.17-2.23-10.31c-2.84-1.25-7.54,0.9-12.65,5.43c-3.59,3.19-7.39,7.54-10.89,12.75c-1.25,1.86-2.4,3.72-3.44,5.59c-0.54-2.03-1.19-4.1-1.92-6.18c-2.35-6.6-5.35-12.24-8.44-16.32c-3.55-4.71-7.21-7.33-10.09-6.82c-3.2,0.57-4.95,4.89-5,11.33c-0.04,4.55,0.76,10.16,2.53,16.27c0.63,2.16,1.34,4.29,2.12,6.33c-2.14-1.21-4.4-2.39-6.76-3.54c-7.67-3.69-15.23-6.31-21.56-7.68c-7.49-1.63-13.26-1.49-15.37,0.78c-2.37,2.56,0.33,7.29,6.54,12.54c4.31,3.65,10.29,7.54,17.48,11.15c2.48,1.24,4.97,2.38,7.42,3.41c-2.8,0.5-5.73,1.11-8.73,1.83c-10.05,2.41-19.32,5.68-26.44,9.11c-8.7,4.2-14.18,8.65-13.84,12.13c0.39,3.92,7.99,5.48,19.05,4.76c7.43-0.48,16.4-1.98,25.86-4.53c3.16-0.85,6.2-1.78,9.06-2.74c-1.8,2.32-3.6,4.81-5.39,7.47C78,121,73.19,130.37,70.32,138.3c-3.57,9.86-4.12,17.48-0.41,19.6c4.11,2.35,11.99-2.83,20.36-12.08c5.46-6.01,11.11-13.74,16.09-22.28c1.64-2.81,3.1-5.54,4.4-8.18c0.59,2.8,1.32,5.73,2.2,8.76c3,10.41,7.1,19.88,11.37,26.93c5.24,8.65,10.73,13.65,14.78,12.13c4.37-1.62,5.6-10.32,4.16-21.79c-0.94-7.44-2.98-16.04-6.06-24.67c-1.02-2.87-2.1-5.59-3.22-8.15c2.46,1.46,5.1,2.89,7.85,4.27c9.24,4.63,18.15,7.84,25.31,9.41c8.51,1.86,14.57,1.4,15.73-1.85C184.13,116.94,179.43,111.15,171.37,105.08z'
          })
        );
      }

      return render;
    }()
  }]);

  return Coupa;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 215 215'
}, _temp);
exports['default'] = Coupa;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Company = (_temp = _class = function (_SvgIcon) {
  _inherits(Company, _SvgIcon);

  function Company() {
    _classCallCheck(this, Company);

    return _possibleConstructorReturn(this, (Company.__proto__ || Object.getPrototypeOf(Company)).apply(this, arguments));
  }

  _createClass(Company, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M23,14h2c0.553,0,1-0.447,1-1v-2c0-0.553-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1v2C22,13.553,22.447,14,23,14z' }),
          _react2['default'].createElement('path', { d: 'M23,20h2c0.553,0,1-0.447,1-1v-2c0-0.553-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1v2C22,19.553,22.447,20,23,20z' }),
          _react2['default'].createElement('path', { d: 'M23,26h2c0.553,0,1-0.447,1-1v-2c0-0.553-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1v2C22,25.553,22.447,26,23,26z' }),
          _react2['default'].createElement('path', { d: 'M16,24h-2c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C17,24.447,16.553,24,16,24z' }),
          _react2['default'].createElement('path', { d: 'M6,24H4c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C7,24.447,6.553,24,6,24z' }),
          _react2['default'].createElement('path', { d: 'M16,19h-2c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C17,19.447,16.553,19,16,19z' }),
          _react2['default'].createElement('path', { d: 'M11,19H9c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C12,19.447,11.553,19,11,19z' }),
          _react2['default'].createElement('path', { d: 'M6,19H4c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C7,19.447,6.553,19,6,19z' }),
          _react2['default'].createElement('path', { d: 'M16,14h-2c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C17,14.447,16.553,14,16,14z' }),
          _react2['default'].createElement('path', { d: 'M11,14H9c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C12,14.447,11.553,14,11,14z' }),
          _react2['default'].createElement('path', { d: 'M6,14H4c-0.553,0-1,0.447-1,1v2c0,0.553,0.447,1,1,1h2c0.553,0,1-0.447,1-1v-2C7,14.447,6.553,14,6,14z' }),
          _react2['default'].createElement('path', { d: 'M17,8h2c0.553,0,1-0.447,1-1V5c0-0.553-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1v2C16,7.553,16.447,8,17,8z' }),
          _react2['default'].createElement('path', { d: 'M23,8h2c0.553,0,1-0.447,1-1V5c0-0.553-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1v2C22,7.553,22.447,8,23,8z' }),
          _react2['default'].createElement('path', { d: 'M13,0c-0.552,0-1,0.448-1,1v10H2H1c-0.552,0-1,0.448-1,1v19h2l0,0h8.5h5.777H30V1c0-0.552-0.447-1-1-1H13z M12,29v-4.252   C12,24.343,11.735,24,11.33,24H8.889C8.484,24,8,24.343,8,24.748V29H2V13h16v16h-1.223H12z M28,29h-8V13v-1c0-0.552-0.447-1-1-1h-1   h-4V2h14V29z' })
        );
      }

      return render;
    }()
  }]);

  return Company;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 30 38.75'
}, _temp);
exports['default'] = Company;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloudDownload = function (_SvgIcon) {
  _inherits(CloudDownload, _SvgIcon);

  function CloudDownload() {
    _classCallCheck(this, CloudDownload);

    return _possibleConstructorReturn(this, (CloudDownload.__proto__ || Object.getPrototypeOf(CloudDownload)).apply(this, arguments));
  }

  _createClass(CloudDownload, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
          _react2['default'].createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z' })
        );
      }

      return render;
    }()
  }]);

  return CloudDownload;
}(_SvgIcon3['default']);

exports['default'] = CloudDownload;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloudUpload = function (_SvgIcon) {
  _inherits(CloudUpload, _SvgIcon);

  function CloudUpload() {
    _classCallCheck(this, CloudUpload);

    return _possibleConstructorReturn(this, (CloudUpload.__proto__ || Object.getPrototypeOf(CloudUpload)).apply(this, arguments));
  }

  _createClass(CloudUpload, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
          _react2['default'].createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
        );
      }

      return render;
    }()
  }]);

  return CloudUpload;
}(_SvgIcon3['default']);

exports['default'] = CloudUpload;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CSV = (_temp = _class = function (_SvgIcon) {
  _inherits(CSV, _SvgIcon);

  function CSV() {
    _classCallCheck(this, CSV);

    return _possibleConstructorReturn(this, (CSV.__proto__ || Object.getPrototypeOf(CSV)).apply(this, arguments));
  }

  _createClass(CSV, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'defs',
            null,
            _react2['default'].createElement('path', { id: 'a', d: 'M0 0h38v43H0z' }),
            _react2['default'].createElement('path', { id: 'c', d: 'M0 43h40.232V0H0z' })
          ),
          _react2['default'].createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2['default'].createElement('path', { d: 'M0 0h64v64H0z' }),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(12.5 10)' },
              _react2['default'].createElement(
                'mask',
                { id: 'b', fill: '#fff' },
                _react2['default'].createElement('use', { xlinkHref: '#a' })
              ),
              _react2['default'].createElement('path', {
                fill: '#E0E0E0',
                d: 'M2.19 0h33.62C37.02 0 38 .98 38 2.19v38.62A2.19 2.19 0 0 1 35.81 43H2.19A2.19 2.19 0 0 1 0 40.81V2.19C0 .98.981 0 2.19 0',
                mask: 'url(#b)'
              }),
              _react2['default'].createElement('path', {
                fill: '#FFF',
                d: 'M4.934 5h28.132C34.134 5 35 5.866 35 6.934v30.132A1.934 1.934 0 0 1 33.066 39H4.934A1.934 1.934 0 0 1 3 37.066V6.934C3 5.866 3.866 5 4.934 5'
              }),
              _react2['default'].createElement(
                'mask',
                { id: 'd', fill: '#fff' },
                _react2['default'].createElement('use', { xlinkHref: '#c' })
              ),
              _react2['default'].createElement('path', {
                fill: '#A9A9A9',
                d: 'M7.125 15.013h6.487v-3.708H7.125zM7.125 21.518h6.487v-3.707H7.125zM7.125 28.024h6.487v-3.707H7.125zM7.125 34.529h6.487v-3.707H7.125zM15.75 34.529h6.487v-3.707H15.75zM24.374 34.529h6.487v-3.707h-6.487z',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#A9A9A9',
                d: 'M7.125 24.317v3.707h6.487v-3.707M15.75 28.024h6.487v-3.707H15.75zM24.374 28.024h6.487v-3.707h-6.487zM15.75 21.518h6.487v-3.707H15.75zM24.374 21.518h6.487v-3.707h-6.487zM15.75 15.013h6.487v-3.708H15.75zM24.374 15.013h6.487v-3.708h-6.487z',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#E0E0E0',
                d: 'M38.93 27.515H19.665a1.31 1.31 0 0 0-1.301 1.311v7.291a1.311 1.311 0 0 0 1.3 1.303H38.93a1.311 1.311 0 0 0 1.302-1.31v-7.293a1.309 1.309 0 0 0-1.302-1.302',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#8FC056',
                d: 'M38.43 27.515H19.167a1.31 1.31 0 0 0-1.301 1.311v7.291a1.31 1.31 0 0 0 1.3 1.303h19.266a1.311 1.311 0 0 0 1.302-1.31v-7.293a1.31 1.31 0 0 0-1.302-1.302',
                mask: 'url(#d)'
              }),
              _react2['default'].createElement('path', {
                fill: '#FFF',
                d: 'M20.479 32.372c0-1.84 1.059-2.914 2.738-2.914 1.425 0 2.508.918 2.55 2.25H24.39c-.07-.664-.543-1.102-1.172-1.102-.781 0-1.277.668-1.277 1.762 0 1.106.491 1.774 1.28 1.774.63 0 1.087-.415 1.177-1.075h1.379c-.067 1.34-1.107 2.223-2.56 2.223-1.687 0-2.738-1.074-2.738-2.918M27.756 33.532c.066.402.5.637 1.05.637.559 0 .923-.25.923-.594 0-.313-.243-.473-.911-.602l-.578-.109c-1.125-.211-1.707-.762-1.707-1.621 0-1.086.942-1.785 2.239-1.785 1.418 0 2.254.695 2.269 1.769h-1.332c-.023-.406-.406-.648-.926-.648s-.828.234-.828.566c0 .297.258.461.87.578l.579.11c1.204.23 1.75.719 1.75 1.605 0 1.133-.886 1.852-2.375 1.852-1.406 0-2.335-.649-2.355-1.758h1.332zM33.459 35.192l-1.798-5.637h1.63l1.086 4.235h.03l1.083-4.235h1.57l-1.797 5.637z',
                mask: 'url(#d)'
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return CSV;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = CSV;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Fieldglass = (_temp = _class = function (_SvgIcon) {
    _inherits(Fieldglass, _SvgIcon);

    function Fieldglass() {
        _classCallCheck(this, Fieldglass);

        return _possibleConstructorReturn(this, (Fieldglass.__proto__ || Object.getPrototypeOf(Fieldglass)).apply(this, arguments));
    }

    _createClass(Fieldglass, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement('path', {
                        fill: '#3067DB',
                        d: 'M28.75,5.73a26.31,26.31,0,0,1,0,52.62H15.07V53.61H28.75a21.58,21.58,0,0,0,0-43.15H15.07V5.73Z'
                    }),
                    _react2['default'].createElement('path', {
                        fill: '#3982E8',
                        d: 'M28.75,10.46a21.58,21.58,0,0,1,0,43.15H15.07V48.88H28.75a16.84,16.84,0,0,0,0-33.68H15.07V10.46Z'
                    })
                );
            }

            return render;
        }()
    }]);

    return Fieldglass;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Fieldglass;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stripe = (_temp = _class = function (_SvgIcon) {
  _inherits(Stripe, _SvgIcon);

  function Stripe() {
    _classCallCheck(this, Stripe);

    return _possibleConstructorReturn(this, (Stripe.__proto__ || Object.getPrototypeOf(Stripe)).apply(this, arguments));
  }

  _createClass(Stripe, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#343032',
            d: 'M27.583,17.4c-0.196,0-0.392,0.196-0.392,0.392c0,0.294,0.196,0.392,0.392,0.392c0.196,0.098,0.392-0.098,0.392-0.294C27.975,17.596,27.779,17.4,27.583,17.4z'
          }),
          _react2['default'].createElement('path', {
            fill: '#1A4BA0',
            d: 'M14.351,22.399c-0.022-0.015-0.042-0.031-0.063-0.046c0.014-0.025,0.016-0.052-0.035-0.052c-0.175-0.175-0.35-0.427-0.594-0.619c-0.004-0.007-0.009-0.01-0.015-0.011c-0.025-0.019-0.05-0.038-0.076-0.056c0-0.098-0.098,0-0.098,0c-0.294,0.294-0.784,0.294-1.176,0c-0.046-0.046-0.086-0.097-0.121-0.153c-0.075-0.161-0.075-0.347-0.075-0.534c0-0.392,0.098-0.686,0.49-0.784c0.294-0.098,0.588-0.098,0.882,0.196c0.098,0,0.098,0,0.098,0c0.196-0.294,0.49-0.49,0.686-0.784l-0.098-0.098c-0.392-0.294-0.784-0.392-1.274-0.392c-0.98,0-1.862,0.686-1.96,1.666c-0.096,0.67,0.09,1.245,0.645,1.637c0.044,0.044,0.089,0.087,0.139,0.127c0.588,0.392,1.176,0.49,1.764,0.392c0.294,0,0.588-0.196,0.882-0.392C14.351,22.497,14.449,22.497,14.351,22.399z'
          }),
          _react2['default'].createElement('path', {
            fill: '#1A4BA0',
            d: 'M10.235,19.752c-0.49-0.49-0.98-0.686-1.666-0.686c-0.087,0-0.175,0-0.262,0c-0.011,0-0.021,0-0.032,0h0c-0.03,0-0.062,0-0.098,0C7.294,19.164,6.608,19.85,6.51,20.83c0,0.588,0.196,1.176,0.686,1.568c0.417,0.347,0.883,0.497,1.363,0.485c0.229,0.005,0.462-0.027,0.695-0.093C10.823,22.399,11.019,20.634,10.235,19.752zM8.569,21.908c-0.588,0-0.882-0.392-0.882-0.98c0-0.49,0.392-0.882,0.882-0.882c0.588,0,0.98,0.294,0.98,0.98C9.549,21.516,9.157,21.908,8.569,21.908z'
          }),
          _react2['default'].createElement('path', {
            fill: '#1A4BA0',
            d: 'M6.314,19.752c0,0,0-0.001,0-0.001c0-0.032,0-0.064,0-0.097c-0.098-0.784-0.49-1.47-1.176-1.862C4.55,17.498,3.962,17.4,3.374,17.4s-1.176,0-1.862,0c-0.098,0-0.098,0-0.098,0.098c0,0.033,0,0.065,0,0.098c0,0.849,0,1.699,0,2.548c0,0.882,0,1.666,0,2.548c0,0.037,0,0.06,0.005,0.074c0.003,0.01,0.009,0.015,0.019,0.019c0.01,0.003,0.023,0.005,0.042,0.005c0.009,0,0.02,0,0.032,0h0c0.588,0,1.274,0,1.862,0c0.392,0,0.882,0,1.274-0.196c0,0,0,0,0,0c0,0,0,0,0,0c0.784-0.294,1.274-0.686,1.568-1.47C6.314,20.732,6.412,20.242,6.314,19.752z M4.55,21.418c-0.294,0.196-0.686,0.294-0.98,0.294s-0.588,0-0.882,0c-0.098,0-0.098,0-0.098-0.098c0-0.49,0-0.98,0-1.47c0-0.49,0-0.98,0-1.372c0-0.098,0-0.098,0.098-0.098c0.392,0,0.686-0.098,1.078,0c0.49,0,0.882,0.294,1.176,0.686C5.236,19.85,5.236,21.026,4.55,21.418z'
          }),
          _react2['default'].createElement('path', {
            fill: '#343032',
            d: 'M31.797,20.046c0-0.294-0.196-0.49-0.49-0.588c-0.294-0.098-0.588-0.098-0.882,0c-0.49,0.196-0.882,0.392-1.274,0.686c-0.114,0.076-0.223,0.152-0.331,0.228c-0.267,0.161-0.518,0.357-0.773,0.557c-0.181,0.131-0.366,0.261-0.562,0.392c-0.043,0.043-0.086,0.081-0.129,0.115c-0.081,0.044-0.162,0.103-0.242,0.163c-0.072,0.041-0.144,0.077-0.216,0.113c-0.196,0.098-0.294,0-0.294-0.196c0-0.098,0.098-0.196,0.098-0.294c0.098-0.294,0.196-0.49,0.294-0.784c0-0.098,0.098-0.294,0-0.392c-0.098-0.392-0.392-0.588-0.784-0.392c-0.392,0.196-0.686,0.49-1.078,0.686c-0.392,0.294-0.686,0.49-1.078,0.686h-0.098c0.098-0.098,0.098-0.294,0.196-0.392c0.098-0.196,0.098-0.392,0.098-0.588c-0.098-0.294-0.294-0.392-0.49-0.588c-0.294-0.196-0.686-0.294-0.98-0.294c-0.588-0.098-1.274-0.196-1.862-0.294c-0.294,0-0.49-0.098-0.784-0.196c-0.294-0.098-0.294-0.294-0.196-0.588c0.089-0.177,0.257-0.275,0.361-0.438c0.664-0.462,1.331-0.748,2.089-1.033c0.686-0.196,1.372-0.392,2.058-0.294c0.392,0,0.686,0.098,0.98,0.196c0.098,0,0.196,0.098,0.294,0.196c0.098,0.098,0.098,0.196,0,0.294c-0.012,0.012-0.025,0.025-0.04,0.04c-0.06,0.06-0.074,0.074-0.156,0.156c-0.098,0.196-0.098,0.392,0.098,0.392c0.256,0.064,0.468,0.001,0.586-0.158c0.124-0.086,0.198-0.233,0.198-0.43c0-0.686-0.294-1.274-0.98-1.47c-0.588-0.196-1.176-0.196-1.764-0.098c-0.686,0.098-1.372,0.294-1.96,0.588c-0.686,0.392-1.372,0.784-1.96,1.372c-0.028,0.028-0.056,0.057-0.084,0.085c-0.004,0.004-0.009,0.008-0.014,0.013c-0.196,0.196-0.392,0.392-0.49,0.686c-0.098,0.294,0,0.49,0.196,0.686c0,0.098,0.098,0.196,0.196,0.196c0.294,0.098,0.588,0.196,0.882,0.294c0.588,0.098,1.078,0.196,1.666,0.392c0.294,0.098,0.588,0.196,0.784,0.392s0.294,0.392,0.196,0.588c-0.098,0.098-0.098,0.196-0.196,0.294c-0.117,0.117-0.234,0.233-0.351,0.33c-0.042,0.023-0.087,0.045-0.139,0.062c-0.686,0.49-1.47,0.784-2.156,1.176v-0.098c0-0.098,0-0.098-0.098-0.098c-0.49,0-0.882,0-1.372,0c-0.294,0-0.294,0-0.294,0.294c0,0.098,0,0.098,0.098,0.098c0.425,0,0.849,0,1.274,0c-0.098,0.098-0.098,0.098-0.196,0.098c-0.196,0.098-0.49,0.196-0.784,0.392c-0.098,0-0.098,0.196,0,0.294c0.098,0.098,0.098,0.098,0.196,0.098c0.062,0,0.125,0,0.187-0.001c0.003,0,0.005,0.001,0.009,0.001c0.294,0,0.588,0,0.882-0.098c0.588-0.196,1.274-0.392,1.862-0.686c0.098,0,0.196-0.098,0.294-0.098c0.196,0,0.49,0,0.686,0c0,0,0.098,0,0.098-0.098c0-0.098,0-0.196,0-0.392c0.023-0.013,0.047-0.026,0.07-0.038c0.574-0.295,1.124-0.597,1.65-0.93c0.374-0.223,0.748-0.458,1.122-0.715c0,0.146,0,0.242,0,0.41c0,0.294-0.098,0.588-0.196,0.882c-0.098,0.392,0.196,0.882,0.49,0.882c0.161,0,0.256-0.066,0.393-0.144c0.004,0.045,0.021,0.046,0.097,0.046c0.49,0,0.882,0,1.372,0c0.098,0,0.196,0,0.294,0c0.066-0.066,0.043-0.132,0.021-0.198c0.282-0.009,0.474-0.197,0.665-0.292c0.588-0.294,1.078-0.686,1.568-1.078c0-0.008,0-0.015,0-0.022c0.033-0.026,0.066-0.051,0.098-0.076v0.098c-0.098,0.488-0.293,0.976-0.585,1.367c-0.031,0.005-0.066,0.005-0.101,0.005c-0.196,0-0.392-0.098-0.588,0h-0.098h-0.098c-0.196,0-0.196,0-0.196,0.196c-0.216,0.162-0.471,0.336-0.644,0.515c-0.179,0.173-0.395,0.29-0.557,0.506c-0.294,0.392-0.456,0.608-0.661,1.233c-0.068,0.208-0.098,0.392-0.098,0.588c0.098,0.294,0.392,0.686,0.882,0.392c0-0.023,0.006-0.04,0.014-0.054c0.027-0.013,0.055-0.027,0.084-0.044c0,0,0.071-0.001,0.092-0.061c0.262-0.176,0.517-0.351,0.692-0.527c0.185-0.159,0.362-0.325,0.531-0.498c0.499-0.493,0.927-1.046,1.233-1.659c0.012-0.024,0.022-0.045,0.032-0.063c0.035-0.001,0.082,0.022,0.164,0.063c0.098,0.098,0.294,0.098,0.392,0.098c0.064,0,0.086-0.042,0.094-0.098c0.001,0,0.003,0,0.004,0c0.098,0,0.196-0.098,0.098-0.196c0-0.098-0.098-0.196-0.196-0.196c-0.098-0.098-0.196-0.098-0.392-0.196c0.392-0.686,0.686-1.47,0.98-2.254C31.797,20.144,31.797,20.046,31.797,20.046zM26.931,22.408c0.25-0.167,0.5-0.333,0.75-0.5c0,0.098,0.098,0.196,0.098,0.294c0.032,0.095,0.075,0.168,0.127,0.222C27.448,22.492,27.184,22.486,26.931,22.408z M29.543,23.575c-0.392,0.49-0.882,0.98-1.372,1.47c-0.098,0.098-0.196,0.196-0.294,0.196c-0.196,0-0.294,0-0.294-0.196s0-0.392,0.098-0.588c0.196-0.392,0.49-0.686,0.784-0.882c0.392-0.294,0.784-0.588,1.176-0.686c0.098,0,0.196,0,0.294,0C29.927,22.904,29.877,23.157,29.543,23.575z M30.621,20.634c-0.49,0.49-1.078,0.882-1.764,1.176c-0.098,0.098-0.098,0.098-0.196,0.098h-0.098V21.81c0-0.098,0.098-0.196,0.196-0.294c0.49-0.49,0.98-0.882,1.568-1.176c0.098,0,0.196-0.098,0.392-0.098C30.719,20.438,30.621,20.536,30.621,20.634z'
          }),
          _react2['default'].createElement('path', {
            fill: '#1A4BA0',
            d: 'M18.174,19.066c-0.294,0-0.686,0-0.98,0c-0.098,0-0.098,0-0.098,0.098c0,0.588,0,1.078,0,1.666c0,0.098,0,0.196,0,0.392c0,0.392-0.196,0.588-0.588,0.588c-0.392,0.098-0.588-0.098-0.686-0.49c0-0.058,0-0.117,0-0.196c0-0.054,0-0.117,0-0.196c0-0.531,0-1.063,0-1.666c0-0.065,0-0.13,0-0.196c0-0.098,0-0.098-0.098-0.098c-0.294,0-0.588,0-0.98,0c-0.098,0-0.098,0-0.098,0.098c0,0.065,0,0.131,0,0.196c0,0.523,0,1.045,0,1.568c0,0.058,0,0.126,0,0.196c0,0.167,0,0.352,0,0.49c0,0.07,0,0.138,0,0.196c0.098,0.196,0.098,0.392,0.196,0.588c0.196,0.392,0.588,0.588,0.98,0.588c0.49,0,0.98-0.098,1.274-0.588c0,0.192,0,0.29,0,0.386c0,0.002,0,0.004,0,0.006c0,0,0,0,0,0c0,0.06,0,0.125,0,0.196c0,0.098,0,0.098,0.098,0.098c0.392,0,0.686,0,0.98,0c0.098,0,0.098,0,0.098-0.098c0-0.065,0-0.131,0-0.196c0-1.111,0-2.222,0-3.332c0-0.065,0-0.131,0-0.196C18.272,19.066,18.272,19.066,18.174,19.066z'
          }),
          _react2['default'].createElement('path', {
            fill: '#343032',
            d: 'M37.678,21.124c0-0.025-0.006-0.049-0.017-0.072c-0.021-0.046-0.061-0.086-0.107-0.107c-0.023-0.011-0.047-0.017-0.072-0.017l0,0l0,0c-0.025,0-0.043,0-0.058,0.002c-0.046,0.005-0.064,0.023-0.138,0.096c-0.294,0.294-0.588,0.49-0.882,0.784c-0.098,0.098-0.294,0.196-0.392,0.294c-0.196,0-0.294,0-0.294-0.196c0-0.196,0.098-0.294,0.098-0.392c0.098-0.294,0.098-0.588,0.098-0.98c-0.025-0.123-0.055-0.227-0.095-0.312c-0.02-0.043-0.042-0.081-0.067-0.115c-0.075-0.101-0.173-0.161-0.307-0.179c-0.089-0.012-0.193-0.006-0.315,0.018c-0.294,0-0.588,0.196-0.784,0.294h0c-0.294,0.196-0.588,0.392-0.882,0.588c0.114-0.172,0.126-0.343,0.039-0.495c-0.06-0.138-0.184-0.239-0.334-0.289c-0.098,0-0.196-0.098-0.294,0c-0.074,0.025-0.147,0.055-0.219,0.09c-0.036,0.018-0.072,0.036-0.107,0.056c-0.14,0.079-0.271,0.173-0.381,0.27c-0.027,0.024-0.053,0.049-0.078,0.073s-0.049,0.049-0.073,0.074c-0.073,0.074-0.144,0.15-0.208,0.233c-0.021,0.028-0.042,0.056-0.062,0.085c-0.059,0.088-0.11,0.184-0.146,0.295l0,0c0,0-0.048,0.098-0.042,0.155c-0.005,0.025,0.003,0.041,0.042,0.041c0.098,0,0.098,0,0.196-0.098l0,0c0.196-0.098,0.294-0.196,0.49-0.294c0.098,0,0.196,0,0.294,0l-0.098,0.098h0c0,0,0,0,0,0c-0.196,0.196-0.392,0.49-0.588,0.784c-0.098,0.098-0.196,0.294-0.098,0.49c0,0,0,0-0.098,0s-0.196,0-0.294,0c0,0.098,0,0.196,0,0.294c0,0.098,0,0.098,0.098,0.098c0.49,0,0.98,0,1.372,0c0.098,0,0.196,0,0.294,0c0.098-0.098,0-0.196,0-0.294c0-0.098,0-0.098-0.098-0.098c-0.112,0-0.257,0-0.396,0c0.034-0.03,0.068-0.064,0.102-0.098c0.392-0.294,0.784-0.784,1.274-1.078c0.196-0.196,0.49-0.294,0.686-0.392c0.088-0.03,0.157-0.039,0.213-0.036c0.028,0.037,0.055,0.081,0.081,0.134c0,0.098,0,0.294,0,0.392c0.028,0.139,0.039,0.261,0.047,0.375c-0.035,0.295,0,0.577,0.149,0.802c-0.294,0-0.588,0-0.882,0s-0.294,0-0.294,0.294c0,0.098,0,0.098,0.098,0.098c0.49,0,0.98,0,1.568,0c0.196,0,0.196,0,0.196-0.196h0c0.49-0.196,0.882-0.392,1.176-0.686c0.196-0.196,0.392-0.294,0.49-0.588C37.678,21.32,37.678,21.222,37.678,21.124L37.678,21.124L37.678,21.124z'
          }),
          _react2['default'].createElement('path', {
            fill: '#7A7A7A',
            d: 'M38.56,22.399c-0.033,0-0.065,0-0.098,0c-0.555,0-1.023,0-1.568,0c-0.033,0-0.065,0-0.098,0c-0.098,0-0.098,0-0.098,0.098c0,0.098,0,0.098,0,0.196c0,0.098,0,0.098,0.098,0.098c0.033,0,0.065,0,0.098,0c0.261,0,0.523,0,0.784,0c0.196,0,0.392,0,0.588,0c0.033,0,0.065,0,0.098,0c0.098,0,0.196,0.098,0.294,0c0-0.098,0-0.196,0-0.294C38.658,22.399,38.658,22.399,38.56,22.399z'
          }),
          _react2['default'].createElement('path', {
            fill: '#7A7A7A',
            d: 'M24.544,22.497c0.294,0,0.588,0,0.784,0c0.098,0,0.098,0,0.098,0.098c0,0.294,0,0.294-0.294,0.294c-0.49,0-0.98,0-1.47,0c-0.098,0-0.098,0-0.098-0.098c0-0.098,0-0.098,0-0.196s0-0.098,0.098-0.098C24.054,22.497,24.25,22.497,24.544,22.497z'
          }),
          _react2['default'].createElement('path', {
            fill: '#7A7A7A',
            d: 'M20.232,22.693c-0.098,0-0.196,0.098-0.294,0.098c-0.49,0-0.98,0-1.47,0c-0.098,0-0.098,0-0.098-0.098c0-0.294,0-0.294,0.294-0.294c0.49,0,0.98,0,1.372,0c0.098,0,0.098,0,0.098,0.098C20.232,22.595,20.232,22.693,20.232,22.693z'
          }),
          _react2['default'].createElement('path', {
            fill: '#7A7A7A',
            d: 'M31.797,22.399c0.098,0.196,0.294,0.196,0.49,0.098c0.098,0,0.098-0.098,0.196-0.098c0.196,0,0.49,0,0.686,0c0.098,0,0.098,0,0.098,0.098c0,0.098,0,0.196,0,0.294c-0.098,0.098-0.196,0-0.294,0c-0.49,0-0.98,0-1.372,0c-0.098,0-0.098,0-0.098-0.098c0-0.098,0-0.196,0-0.294C31.601,22.399,31.699,22.497,31.797,22.399C31.797,22.497,31.797,22.399,31.797,22.399z'
          }),
          _react2['default'].createElement('path', {
            fill: '#7A7A7A',
            d: 'M26.308,22.693c0.196,0,0.392-0.098,0.49-0.196l0.098-0.098c0.294,0,0.588,0,0.882,0c0.098,0,0.098,0,0.196,0h0.098l0,0c0,0.098,0,0.196,0,0.294c-0.098,0.098-0.196,0-0.294,0c-0.49,0-0.882,0-1.372,0C26.308,22.791,26.308,22.791,26.308,22.693z'
          }),
          _react2['default'].createElement('path', {
            fill: '#7A7A7A',
            d: 'M35.227,22.497c0.196,0.196,0.392,0.294,0.686,0.196c0,0.196,0,0.196-0.196,0.196c-0.49,0-0.98,0-1.568,0c-0.098,0-0.098,0-0.098-0.098c0-0.294,0-0.294,0.294-0.294C34.639,22.497,34.933,22.497,35.227,22.497z'
          }),
          _react2['default'].createElement('path', {
            fill: '#7A7A7A',
            d: 'M22.094,22.791c0.098-0.098,0.098-0.098,0.196-0.098c0.196-0.098,0.392-0.196,0.588-0.294c0,0.098,0,0.196,0,0.392c0,0,0,0.098-0.098,0.098C22.584,22.791,22.29,22.791,22.094,22.791z'
          })
        );
      }

      return render;
    }()
  }]);

  return Stripe;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40.2 40'
}, _temp);
exports['default'] = Stripe;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://www.dropbox.com/branding
// Blue glyph from https://www.dropbox.com/sh/eokvcxamvx2u7sv/AABo7i32c5cKCfFoiJA7NaXea/01_Logos/05_Glyphs/Glyph/Blue/SVG?dl=0&preview=dropbox_glyph_blue.svg
var Dropbox = (_temp = _class = function (_SvgIcon) {
  _inherits(Dropbox, _SvgIcon);

  function Dropbox() {
    _classCallCheck(this, Dropbox);

    return _possibleConstructorReturn(this, (Dropbox.__proto__ || Object.getPrototypeOf(Dropbox)).apply(this, arguments));
  }

  _createClass(Dropbox, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '63.387,36.169 32.5,56.336 53.857,73.438 85,54.208'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '32.5,90.542 63.387,110.709 85,92.669 53.857,73.438'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '85,92.669 106.613,110.709 137.5,90.542 116.143,73.438'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '137.5,56.336 106.613,36.169 85,54.208 116.143,73.438'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '85.064,96.55 63.387,114.537 54.112,108.481 54.112,115.27 85.064,133.831 116.015,115.27 116.015,108.481 106.74,114.537 \t'
          })
        );
      }

      return render;
    }()
  }]);

  return Dropbox;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 170 170'
}, _temp);
exports['default'] = Dropbox;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Excel = (_temp = _class = function (_SvgIcon) {
  _inherits(Excel, _SvgIcon);

  function Excel() {
    _classCallCheck(this, Excel);

    return _possibleConstructorReturn(this, (Excel.__proto__ || Object.getPrototypeOf(Excel)).apply(this, arguments));
  }

  _createClass(Excel, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('rect', { fill: '#20744a', x: '0.29', y: '-0.31', width: '399.71', height: '399.9' }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M325.59,84.68H225.76V61.15L61.66,86.48v222l164.1,28.26V301.88h99.82c6.64,0,12-4.84,12-10.8V95.48C337.6,89.52,332.22,84.68,325.59,84.68ZM175.8,246.44l-22.36-1.51-15.1-39.66-15.11,38.15-20.54-1.81,23.87-46-22.05-49.21,21.15-1.21,13.29,36.55,15.71-38.07,21.15-1.21-25.68,51.9Zm151.36,46.44H225.43l-0.17-18.62h24.5V252.58h-24.7L225,239.76h24.81V218.08h-25l-0.11-12.82h25.12V183.58h-25.2V170.77h25.2V149.09h-25.2V136.27h25.2V114.59h-25.2V94.89h102.6v198Z'
          }),
          _react2['default'].createElement('rect', { fill: '#fff', x: '263.56', y: '114.59', width: '42.6', height: '21.68' }),
          _react2['default'].createElement('rect', { fill: '#fff', x: '263.56', y: '149.09', width: '42.6', height: '21.68' }),
          _react2['default'].createElement('rect', { fill: '#fff', x: '263.56', y: '183.58', width: '42.6', height: '21.68' }),
          _react2['default'].createElement('rect', { fill: '#fff', x: '263.56', y: '218.08', width: '42.6', height: '21.68' }),
          _react2['default'].createElement('rect', { fill: '#fff', x: '263.56', y: '252.58', width: '42.6', height: '21.68' })
        );
      }

      return render;
    }()
  }]);

  return Excel;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Excel;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Ephesoft = (_temp = _class = function (_SvgIcon) {
  _inherits(Ephesoft, _SvgIcon);

  function Ephesoft() {
    _classCallCheck(this, Ephesoft);

    return _possibleConstructorReturn(this, (Ephesoft.__proto__ || Object.getPrototypeOf(Ephesoft)).apply(this, arguments));
  }

  _createClass(Ephesoft, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', { fill: '#15B163', 'class': 'st0', d: 'M14.5,32c0,5.4,1.8,9.8,5.4,13.2c3.6,3.5,7.7,5.2,12.4,5.2c5.1,0,9.4-1.8,12.9-5.3c3.5-3.6,5.2-7.9,5.2-13 c0-5.2-1.7-9.5-5.2-13c-3.4-3.5-7.7-5.3-12.7-5.3c-5,0-9.3,1.8-12.8,5.3C16.2,22.6,14.5,26.8,14.5,32 M7.1,31.9 c0-6.8,2.5-12.7,7.5-17.6c5-4.9,11-7.3,18-7.3c6.9,0,12.8,2.5,17.8,7.4c5,4.9,7.4,10.9,7.4,17.8c0,7-2.5,12.9-7.5,17.7 c-5,4.9-11,7.3-18.1,7.3c-6.3,0-11.9-2.2-16.9-6.5C9.8,45.9,7.1,39.6,7.1,31.9' }),
            _react2['default'].createElement('rect', { x: '27.8', y: '23.1', fill: '#1A4684', 'class': 'st1', width: '9.9', height: '2.5' }),
            _react2['default'].createElement('polygon', { 'class': 'st1', points: '37.7,33.3 37.7,30.8 27.8,30.8 27.8,41 37.7,41 37.7,38.5 30.3,38.5 30.3,33.3 \t' })
          )
        );
      }

      return render;
    }()
  }]);

  return Ephesoft;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Ephesoft;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Eye = function (_SvgIcon) {
  _inherits(Eye, _SvgIcon);

  function Eye() {
    _classCallCheck(this, Eye);

    return _possibleConstructorReturn(this, (Eye.__proto__ || Object.getPrototypeOf(Eye)).apply(this, arguments));
  }

  _createClass(Eye, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
          _react2['default'].createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
        );
      }

      return render;
    }()
  }]);

  return Eye;
}(_SvgIcon3['default']);

exports['default'] = Eye;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Fieldglass = (_temp = _class = function (_SvgIcon) {
    _inherits(Fieldglass, _SvgIcon);

    function Fieldglass() {
        _classCallCheck(this, Fieldglass);

        return _possibleConstructorReturn(this, (Fieldglass.__proto__ || Object.getPrototypeOf(Fieldglass)).apply(this, arguments));
    }

    _createClass(Fieldglass, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement('path', {
                        fill: '#EFAB1F',
                        d: 'M19.26,48.19c.56,1.73,1.63,5.54,1.06,7.34s-2.28.7-2.95,0c-.23-.21-.35-.27-.52-.45A25.71,25.71,0,0,1,15.05,53l-1.56-2.34c-.15-.22-.23-.38-.37-.62l-2.35-4.38C10.15,44.22,9.59,43,9,41.51c-.34-1-.66-1.95-.95-2.93-.33-1.26-2-8,1.24-6.61a4.36,4.36,0,0,1,1.13.82,12.93,12.93,0,0,1,1.46,1.5c.34.41,1,1.28,1.26,1.65a20.34,20.34,0,0,1,1.48,2.33l-1-1.26c-1.63-1.95-3.31-2.37-2.85.75a20.93,20.93,0,0,0,.9,3.65l.65,1.66c.2.56.45,1,.67,1.53a20.22,20.22,0,0,0,4.34,6.53c1.8,1.57,2.19.09,1.95-1.73l-.37-1.9a3.6,3.6,0,0,1,.32.69ZM42.68,18.92A8.47,8.47,0,0,0,42,17.69a48.55,48.55,0,0,0-7-9,5.67,5.67,0,0,0-.5-.48,11.2,11.2,0,0,0-3-2.12,3.42,3.42,0,0,0-.95-.25h-.66a2,2,0,0,0-1.37.81,6.25,6.25,0,0,0-.84,3.18,28.37,28.37,0,0,0,.19,3.8,56.44,56.44,0,0,0,1.44,6.59c.43,1.44.95,3.14,1.47,4.56.71,2,1.46,3.8,2.26,5.76.18.51.42,1,.61,1.42.64,1.65,2.46,5.23,3.26,6.79.62,1.24,2.18,3.92,2.9,5.12l1.52,2.47q1.77,2.68,3.8,5.18a27.87,27.87,0,0,0,2.43,2.67c1.13,1.12,4.75,4.22,6.4,1.9a6.67,6.67,0,0,0,.84-3.2,17.15,17.15,0,0,0-.07-1.9,17.19,17.19,0,0,0-.17-1.76c-.13-1-.6-3.4-.81-4.22l-.59-2.5a36.2,36.2,0,0,0-1.51-4.55l.48,1.9c.37,1.58,1.39,7.26-1,7.29A4.21,4.21,0,0,1,48.63,46a16.61,16.61,0,0,1-2-2.08c-.43-.51-1-1.13-1.34-1.67l-.95-1.4a23.38,23.38,0,0,1-1.41-2.15c-.29-.49-.57-1-.89-1.48-.7-1.07-1.79-3.41-2.44-4.69l-1.11-2.44c-.27-.52-1.54-3.8-1.69-4.26L36.18,24a36.27,36.27,0,0,1-1.35-5.74,8,8,0,0,1,.25-4.16,1.57,1.57,0,0,1,.52-.67c1.77-1.09,5,2.75,6.07,4.17a13.28,13.28,0,0,0,1,1.33ZM33.3,43.62l.53,2.8a6.93,6.93,0,0,1-.15,3.07c-.91,1.84-3.55-1-4-1.62s-.9-1.09-1.49-1.9c-.24-.35-.45-.68-.68-1-.46-.67-.84-1.4-1.28-2.13a9.38,9.38,0,0,1-.62-1.12l-1.42-2.85c-.46-1-.87-2-1.27-3a33,33,0,0,1-1.59-5.24c-.28-1.13-.66-3.39,0-4.46s1.66-.42,2.29,0a21.07,21.07,0,0,1,3.24,3.62,3.67,3.67,0,0,0-.49-.89l-1.16-1.79c-.36-.57-1.4-2-1.84-2.5-.72-.95-1-1.07-1.51-1.76-.95-1.19-3.8-3.68-5.16-2.23-.95,1-.81,3.64-.64,4.93a50.18,50.18,0,0,0,3.67,12.35c.9,2,1.34,3,2.31,5s1.84,3.43,3.13,5.59c.36.59.74,1.19,1.12,1.74l1.22,1.71c.41.55,1.48,1.9,2,2.41.95,1,2.85,2.92,4.42,2.85,2.29-.12,1.68-5,1.37-6.65a46.44,46.44,0,0,0-1.54-5.81l-.24-.79a.56.56,0,0,0-.17-.32Zm7.75-18.34c0,2.77,3.92,10.32,5,10.32.83,0-.07-2.91-.2-3.29L45,30c-.13-.27-.24-.44-.35-.71a18.13,18.13,0,0,0-2.43-3.85c-.18-.27-1.11-1.12-1.11-.23Zm-15,9.11c0,1.52,2.45,6.65,3.27,6.65s-.77-3.86-1.08-4.44a8.64,8.64,0,0,0-1.74-2.37C26.33,34.15,26.08,34.2,26.08,34.39Zm-11.9,7.37A7,7,0,0,0,15,44.07a2.94,2.94,0,0,0,.23.51c.13.24.6,1,.83,1.06.8.23-.57-3-1.4-3.8-.12-.11-.45-.36-.45-.08Zm19.18,1.79v-.22h-.18c0,.39,0,.1.14.22ZM26.83,29.76v.1l.1-.1Z'
                    })
                );
            }

            return render;
        }()
    }]);

    return Fieldglass;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Fieldglass;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var File = (_temp = _class = function (_SvgIcon) {
  _inherits(File, _SvgIcon);

  function File() {
    _classCallCheck(this, File);

    return _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).apply(this, arguments));
  }

  _createClass(File, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            d: 'M15.1900452,11 L41.0199486,11 L50.4945632,22.4054042 C50.8211955,22.7985994 51,23.2936636 51,23.80483 L51,51.8099548 C51,53.0194833 50.0194833,54 48.8099548,54 L15.1900452,54 C13.9805167,54 13,53.0194833 13,51.8099548 L13,13.1900452 C13,11.9805167 13.9805167,11 15.1900452,11 Z',
            fill: '#EBEBEB'
          }),
          _react2['default'].createElement('path', {
            d: 'M17.9340659,16 L44.1247654,16 L45.2666177,18.4995403 C45.3461754,18.6736939 45.4511523,18.8350688 45.5781139,18.9783856 L48,21.7122575 L48,48.0659341 C48,49.1340892 47.1340892,50 46.0659341,50 L17.9340659,50 C16.8659108,50 16,49.1340892 16,48.0659341 L16,17.9340659 C16,16.8659108 16.8659108,16 17.9340659,16 Z',
            fill: '#FFFFFF'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#CFD3D4',
            points: '22.2764882 30.1136087 42.5 30.1136087 42.5 26.75 22.2764882 26.75'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#CFD3D4',
            points: '22.2764882 36.9937174 42.5 36.9937174 42.5 33.6301087 22.2764882 33.6301087'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#CFD3D4',
            points: '22.2764882 43.8738261 36 43.8738261 36 40.5102174 22.2764882 40.5102174'
          }),
          _react2['default'].createElement('path', {
            d: 'M51,23 L43.9778824,23 C42.3400891,23 41,21.4233829 41,19.4970112 L41,11 L51,23 Z',
            fill: '#CCCCCC'
          })
        );
      }

      return render;
    }()
  }]);

  return File;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = File;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleAnalytics = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleAnalytics, _SvgIcon);

  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);

    return _possibleConstructorReturn(this, (GoogleAnalytics.__proto__ || Object.getPrototypeOf(GoogleAnalytics)).apply(this, arguments));
  }

  _createClass(GoogleAnalytics, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'gmail', transform: 'translate(6.000000, 12.000000)' },
            _react2['default'].createElement(
              'linearGradient',
              {
                id: 'linear-gradient',
                x1: '17.9921433%',
                y1: '49.9999992%',
                x2: '81.886266%',
                y2: '49.9999992%'
              },
              _react2['default'].createElement('stop', { offset: '0%', stopColor: '#F7F6EF' }),
              _react2['default'].createElement('stop', { offset: '100%', stopColor: '#E6E4D6' })
            ),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(0.000000, 18.670900)' },
              _react2['default'].createElement('polygon', {
                id: 'Fill-10',
                fill: '#000000',
                mask: 'url(#mask-9)',
                points: '0.0151794882 14.6007795 20.5435565 0.0859313639 20.4506317 0.0190865268 0.0151794882 14.2817591'
              })
            ),
            _react2['default'].createElement('path', {
              fill: '#E75A4D',
              transform: 'translate(0.000000, 0.015721)',
              d: 'M48.6316493,0.00578001104 C51.0186625,0.00578001104 52.9718004,1.9905376 52.9718004,4.41624716 L52.9718004,5.69482695 L46.9419644,10.0718717 L26.4135873,24.4420903 L5.88523147,9.92610083 L5.88523147,38.9569385 L4.34013631,38.9569385 C1.9531443,38.9569385 6.35745702e-06,36.972224 6.35745702e-06,34.5465144 L6.35745702e-06,4.41745312 C6.35745702e-06,1.99172203 1.9531443,0.00696443954 4.34013631,0.00696443954 L26.4136085,16.6379987 L48.6304414,0.00696443954 L48.6316493,0.00578001104 Z'
            }),
            _react2['default'].createElement('polygon', {
              fill: 'url(#linear-gradient)',
              transform: 'translate(4.323071, 0.015721)',
              points: '0.0170803679 0.00577139702 22.0905314 16.6368056 44.3085722 0.00577139702'
            }),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(0.000000, 4.220872)' },
              _react2['default'].createElement('polygon', {
                fill: '#E7E4D7',
                transform: 'translate(5.870052, 5.700977)',
                points: '0.0151794882 0.0199651574 0.0151794882 29.0508028 41.0730567 29.0508028 41.0730567 0.165736002 20.5435565 14.5359547'
              })
            ),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(5.870052, 24.100977)' },
              _react2['default'].createElement('polygon', {
                fill: '#B8B7AE',
                points: '0.0151794882 14.6007795 20.5435565 0.0859313639 20.4506317 0.0190865268 0.0151794882 14.2817591'
              })
            ),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(20.534586, 4.371618)' },
              _react2['default'].createElement('polygon', {
                fill: '#B7B6AD',
                transform: 'translate(5.870052, 5.700977)',
                points: '20.5384769 0.0149927112 20.5502382 28.9000595 0.00895553778 14.3852114'
              })
            ),
            _react2['default'].createElement('path', {
              fill: '#B2392F',
              transform: 'translate(5.734586, 5.571618)',
              d: 'M47.10174,0.00957664274 L47.1087968,28.8647959 C47.0053397,32.0720129 45.6378084,33.2167522 41.0848096,33.2705253 L41.0730906,4.38543694 L47.1029267,0.00839221425 L47.1017612,0.00957664274 L47.10174,0.00957664274 Z'
            }),
            _react2['default'].createElement('polygon', {
              fill: '#F7F5ED',
              points: '4.34014266 0.0215006074 26.4135937 16.6525133 48.6316557 0.0215006074'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return GoogleAnalytics;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = GoogleAnalytics;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleAnalytics = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleAnalytics, _SvgIcon);

  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);

    return _possibleConstructorReturn(this, (GoogleAnalytics.__proto__ || Object.getPrototypeOf(GoogleAnalytics)).apply(this, arguments));
  }

  _createClass(GoogleAnalytics, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'google-analytics', transform: 'translate(10.000000, 8.000000)' },
            _react2['default'].createElement('path', {
              fill: '#F9AB00',
              transform: 'translate(30.207692, 0.000000)',
              d: 'M5.86257,-1.6e-05 C8.89141615,-1.6e-05 11.6446777,2.307024 11.6446777,5.999984 L11.6446777,41.726704 C11.6446777,46.090864 8.61583154,47.999664 5.86257,47.999664 C2.88977769,47.999664 0.0804623077,45.754864 0.0804623077,41.726704 L0.0804623077,5.726864 C0.0804623077,2.544784 2.83372385,-1.6e-05 5.86257,-1.6e-05'
            }),
            _react2['default'].createElement('path', {
              fill: '#E37400',
              d: 'M2.79299857e-06,42.296704 C0.00680076923,45.453024 2.59545462,48.006304 5.78196231,47.999744 C5.82622385,47.999984 5.87032385,47.999984 5.91442385,47.999744 C9.10803923,47.963424 11.6672931,45.369824 11.6306238,42.206784 C11.5941162,39.043584 8.97557769,36.508704 5.78196231,36.545024 L5.75773154,36.545024 C2.57122385,36.551584 -0.00676846154,39.115584 2.79299857e-06,42.271904 L2.79299857e-06,42.296704 Z M20.9261931,18.272864 C23.9550392,18.272864 26.7081392,20.579904 26.7081392,24.272864 L26.7081392,41.726624 C26.7081392,46.090944 23.6792931,47.999744 20.9261931,47.999744 C17.9458085,47.999744 15.1440854,45.755584 15.1440854,41.726624 L15.1440854,23.999904 C15.1440854,20.817504 17.8973469,18.272864 20.9261931,18.272864 L20.9261931,18.272864 Z'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return GoogleAnalytics;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = GoogleAnalytics;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BigQuery = (_temp = _class = function (_SvgIcon) {
  _inherits(BigQuery, _SvgIcon);

  function BigQuery() {
    _classCallCheck(this, BigQuery);

    return _possibleConstructorReturn(this, (BigQuery.__proto__ || Object.getPrototypeOf(BigQuery)).apply(this, arguments));
  }

  _createClass(BigQuery, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'Google-Big-Query', transform: 'translate(5.000000, 7.000000)' },
            _react2['default'].createElement(
              'g',
              { transform: 'translate(0.000000, 0.048625)' },
              _react2['default'].createElement('path', { d: 'M15.4322222,0.139114943 C14.2890741,0.139114943 13.3744444,0.602643678 12.6887037,1.52970115 L12.6887037,1.52970115 L0.514259259,22.7371264 C0.174444444,23.3116092 0.00296296296,23.886092 0,24.460387 L0,24.460387 L0,24.490613 C0.00296296296,25.0650958 0.174444444,25.6395785 0.514259259,26.2140613 L0.514259259,26.2140613 L12.6887037,47.4216743 C13.3744444,48.3485441 14.2890741,48.8122605 15.4322222,48.8122605 L15.4322222,48.8122605 L39.4375926,48.8122605 C40.5809259,48.8122605 41.4951852,48.3485441 42.1809259,47.4216743 L42.1809259,47.4216743 L54.3553704,26.2140613 C54.6953704,25.6393908 54.8668519,25.064908 54.8696296,24.4904253 L54.8696296,24.4904253 L54.8696296,24.4605747 C54.8668519,23.886092 54.6953704,23.3116092 54.3553704,22.7371264 L54.3553704,22.7371264 L42.1809259,1.52970115 C41.4951852,0.602643678 40.5809259,0.139114943 39.4375926,0.139114943 L39.4375926,0.139114943 L15.4322222,0.139114943 Z' }),
              _react2['default'].createElement('path', {
                fill: '#1976D2',
                transform: 'translate(0.000000, 0.048625)',
                d: 'M15.4322222,0.139114943 C14.2890741,0.139114943 13.3744444,0.602643678 12.6887037,1.52970115 L12.6887037,1.52970115 L0.514259259,22.7371264 C0.174444444,23.3116092 0.00296296296,23.886092 0,24.460387 L0,24.460387 L0,24.490613 C0.00296296296,25.0650958 0.174444444,25.6395785 0.514259259,26.2140613 L0.514259259,26.2140613 L12.6887037,47.4216743 C13.3744444,48.3485441 14.2890741,48.8122605 15.4322222,48.8122605 L15.4322222,48.8122605 L39.4375926,48.8122605 C40.5809259,48.8122605 41.4951852,48.3485441 42.1809259,47.4216743 L42.1809259,47.4216743 L54.3553704,26.2140613 C54.6953704,25.6393908 54.8668519,25.064908 54.8696296,24.4904253 L54.8696296,24.4904253 L54.8696296,24.4605747 C54.8668519,23.886092 54.6953704,23.3116092 54.3553704,22.7371264 L54.3553704,22.7371264 L42.1809259,1.52970115 C41.4951852,0.602643678 40.5809259,0.139114943 39.4375926,0.139114943 L39.4375926,0.139114943 L15.4322222,0.139114943 Z'
              }),
              _react2['default'].createElement(
                'g',
                { id: 'Group-9', transform: 'translate(17.222222, 13.941345)' },
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-6', transform: 'translate(1.296296, 2.440613)' },
                  _react2['default'].createElement('path', {
                    fill: '#545874',
                    fillOpacity: '0.203562063',
                    d: 'M23.662537,31.0883598 L31.8627222,16.8034517 L15.4321667,0.146080077 L4.45809259,0.146080077 L-5.55555556e-05,6.40399962 L2.05753704,15.4432793 L18.8614259,32.478946 L20.9192037,32.478946 C22.0621667,32.478946 22.9766111,32.0152295 23.662537,31.0883598'
                  })
                ),
                _react2['default'].createElement('path', {
                  fill: '#FFFFFF',
                  d: 'M12.7847222,10.930567 L15.1852778,10.930567 L15.1852778,12.1473065 C14.785463,13.2194866 13.7160185,14.302931 12.7847222,14.9288544 L12.7847222,10.930567 Z M9.1837963,7.45381992 L11.2413889,7.45381992 L11.2413889,15.8714943 C10.9087963,15.9370153 10.5652778,15.9719349 10.2125,15.9719349 C9.86009259,15.9719349 9.51657407,15.9370153 9.1837963,15.8714943 L9.1837963,7.45381992 Z M5.58305556,10.0545747 L7.81194444,10.0545747 L7.81194444,15.2694138 C6.9225,14.7341686 6.03231481,13.8621188 5.58305556,12.9053985 L5.58305556,10.0545747 Z M10.2125,18.0577203 C14.3923148,18.0577203 17.7573148,14.7236552 17.7573148,10.5828736 C17.7573148,6.44227969 14.3923148,3.10802682 10.2125,3.10802682 C6.03287037,3.10802682 2.66805556,6.44152874 2.66805556,10.5828736 C2.66805556,14.7244061 6.03287037,18.0577203 10.2125,18.0577203 L10.2125,18.0577203 Z M22.2984259,20.7465249 C22.5408333,20.9922759 22.5408333,21.2378391 22.2984259,21.48359 L21.0856481,22.7130958 C20.8434259,22.958659 20.6010185,22.958659 20.3586111,22.7130958 L16.6071296,18.9094943 C12.5671296,22.0490613 6.79212963,21.742295 3.0912037,17.9903218 C3.08157407,17.9805594 3.07194444,17.9707969 3.06231481,17.9608467 C-0.939351852,13.8878391 -0.926574074,7.29705747 3.0912037,3.2401954 C3.10083333,3.23043295 3.11046296,3.2206705 3.12027778,3.21090805 C7.13787037,-0.846141762 13.6387963,-0.832812261 17.6406481,3.2401954 C21.3423148,6.99930268 21.6439815,12.8400651 18.5473148,16.9423602 L22.2984259,20.7465249 Z'
                })
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return BigQuery;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = BigQuery;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleCalendar = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleCalendar, _SvgIcon);

  function GoogleCalendar() {
    _classCallCheck(this, GoogleCalendar);

    return _possibleConstructorReturn(this, (GoogleCalendar.__proto__ || Object.getPrototypeOf(GoogleCalendar)).apply(this, arguments));
  }

  _createClass(GoogleCalendar, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'google-calendar', transform: 'translate(9.000000, 9.000000)' },
            _react2['default'].createElement('path', {
              fill: '#C7C7C7',
              d: 'M33.6702049,3.63157895 C33.0508878,3.63157895 32.5482537,3.08926316 32.5482537,2.42105263 C32.5482537,1.75284211 33.0508878,1.21052632 33.6702049,1.21052632 C34.289522,1.21052632 34.7921561,1.75284211 34.7921561,2.42105263 C34.7921561,3.08926316 34.289522,3.63157895 33.6702049,3.63157895 M11.2311805,3.63157895 C10.6118634,3.63157895 10.1092293,3.08926316 10.1092293,2.42105263 C10.1092293,1.75284211 10.6118634,1.21052632 11.2311805,1.21052632 C11.8504976,1.21052632 12.3531317,1.75284211 12.3531317,2.42105263 C12.3531317,3.08926316 11.8504976,3.63157895 11.2311805,3.63157895 M38.1580098,0 L6.74337561,0 C5.50361951,0 4.49947317,1.08342105 4.49947317,2.42105263 L4.49947317,6.05263158 L40.4019122,6.05263158 L40.4019122,2.42105263 C40.4019122,1.08342105 39.3977659,0 38.1580098,0'
            }),
            _react2['default'].createElement('path', {
              fill: '#1976D2',
              transform: 'translate(0.000000, 4.842105)',
              d: 'M44.8897171,2.42105263 C45.005278,1.71652632 43.3088878,0 42.6458146,0 L2.25557073,0 C1.13361951,0 -0.103892683,1.71652632 0.0116682927,2.42105263 C0.935034146,8.06694737 3.37752195,20.5789474 3.37752195,20.5789474 L41.5238634,20.5789474 C41.5238634,20.5789474 43.9663512,8.06694737 44.8897171,2.42105263'
            }),
            _react2['default'].createElement('path', {
              fill: '#1E88E5',
              d: 'M41.5238634,25.4210526 L3.37752195,25.4210526 C3.37752195,25.4210526 0.935034146,37.9330526 0.0116682927,43.5789474 C0.0116682927,44.9662105 0.900253659,46 2.25557073,46 L42.6458146,46 C43.3088878,46 44.8897171,45.3947368 44.8897171,43.5789474 C43.9663512,37.9330526 41.5238634,25.4210526 41.5238634,25.4210526'
            }),
            _react2['default'].createElement('path', {
              fill: '#FAFAFA',
              d: 'M31.0185854,36.1414737 L33.6551707,36.1414737 L33.6551707,25.4210526 L31.0185854,25.4210526 L31.0185854,36.1414737 Z M18.5626829,25.4210526 C19.665561,25.8144737 20.4554146,26.45 20.9243902,27.3058421 C21.4090732,28.1919474 21.6525366,29.1821579 21.6525366,30.2801053 C21.6525366,32.1951579 21.0702439,33.7010526 19.9067805,34.799 C18.7433171,35.8957368 17.2556098,36.4453158 15.4447805,36.4453158 C13.6698537,36.4453158 12.2000976,35.9284211 11.0366341,34.8934211 C9.87092683,33.8584211 9.31219512,32.4554211 9.35595122,30.6856316 L9.39746341,30.5984737 L11.9117561,30.5984737 C11.9117561,31.7048947 12.2270244,32.5861579 12.856439,33.2398421 C13.4836098,33.8947368 14.3475122,34.2215789 15.4447805,34.2215789 C16.56,34.2215789 17.434,33.8947368 18.0667805,33.2398421 C18.7006829,32.5849474 19.0170732,31.6177368 19.0170732,30.3382105 C19.0170732,29.0393158 18.7365854,28.0817895 18.1744878,27.4656316 C17.6123902,26.8494737 16.7249268,26.542 15.5120976,26.542 L13.2109756,26.542 L13.2109756,25.4210526 L18.5626829,25.4210526 Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#E0E0E0',
              d: 'M33.6548341,25.4210526 L31.0182488,25.4210526 L31.0182488,17.894 L27.0319561,17.9521053 L27.0319561,15.9014737 L33.6548341,15.1218947 L33.6548341,25.4210526 Z M12.0471756,20.6225263 L9.51829756,20.6225263 L9.49137073,20.5353684 C9.44649268,18.9471579 9.97829756,17.5974211 11.0901512,16.4861579 C12.199761,15.3748947 13.6526878,14.8192632 15.4455659,14.8192632 C17.2462976,14.8192632 18.6835171,15.3361579 19.7538585,16.3711579 C20.823078,17.4061579 21.3593707,18.8805789 21.3593707,20.7956316 C21.3593707,21.6623684 21.1159073,22.5254737 20.6301024,23.3873684 C20.1442976,24.2492632 19.4150293,24.9053684 18.4411756,25.3581053 L18.5623463,25.4210526 L13.210639,25.4210526 L13.210639,24.3182632 L15.511761,24.3182632 C16.6808341,24.3182632 17.5077122,24.0035263 17.9935171,23.3728421 C18.479322,22.7421579 18.7216634,21.8645263 18.7216634,20.7387368 C18.7216634,19.5354737 18.4467854,18.6215263 17.8936634,17.9956842 C17.3394195,17.3698421 16.523761,17.0575263 15.4455659,17.0575263 C14.4189805,17.0575263 13.5965902,17.3819474 12.9772732,18.032 C12.3781512,18.6590526 12.0684927,19.4870526 12.0471756,20.6225263 L12.0471756,20.6225263 Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#1976D2',
              d: 'M41.5238634,25.4210526 C41.5238634,25.4210526 43.9663512,12.9090526 44.8897171,7.26315789 C44.8897171,5.29605263 43.3088878,4.84210526 42.6458146,4.84210526 M2.25557073,4.84210526 C0.642204878,4.84210526 -0.103892683,6.55863158 0.0116682927,7.26315789 C0.935034146,12.9090526 3.37752195,25.4210526 3.37752195,25.4210526'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return GoogleCalendar;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = GoogleCalendar;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleDrive = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleDrive, _SvgIcon);

  function GoogleDrive() {
    _classCallCheck(this, GoogleDrive);

    return _possibleConstructorReturn(this, (GoogleDrive.__proto__ || Object.getPrototypeOf(GoogleDrive)).apply(this, arguments));
  }

  _createClass(GoogleDrive, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { fill: '#FBCE4B', d: 'M100.257 5h104.5l93 162.5-123.5-38.14' }),
          _react2['default'].createElement('path', { fill: '#DFB53D', d: 'M174.257 129.36l24.75 38.14h98.75' }),
          _react2['default'].createElement('path', {
            fill: '#3476DD',
            d: 'M297.757 167.5l-49.332 86.84h-191l94.332-86.84'
          }),
          _react2['default'].createElement('path', { fill: '#055BD8', d: 'M108.593 167.5l-51.168 86.84 94.332-86.84' }),
          _react2['default'].createElement('path', {
            fill: '#15A864',
            d: 'M57.425 254.34L5.92 167.5 100.256 5l30.495 124.625-22.16 37.875'
          }),
          _react2['default'].createElement('path', { fill: '#129155', d: 'M100.257 5l30.495 124.625 21.005-38.077' })
        );
      }

      return render;
    }()
  }]);

  return GoogleDrive;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 303.572 259.606'
}, _temp);
exports['default'] = GoogleDrive;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleSheets = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleSheets, _SvgIcon);

  function GoogleSheets() {
    _classCallCheck(this, GoogleSheets);

    return _possibleConstructorReturn(this, (GoogleSheets.__proto__ || Object.getPrototypeOf(GoogleSheets)).apply(this, arguments));
  }

  _createClass(GoogleSheets, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#43a047',
            d: 'M294.52,347.84h-183a21.12,21.12,0,0,1-21.12-21.12V73.28a21.12,21.12,0,0,1,21.12-21.12H245.24l70.4,70.4V326.72A21.12,21.12,0,0,1,294.52,347.84Z'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#c8e6c9',
            points: '315.64 122.56 245.24 122.56 245.24 52.16 315.64 122.56'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#2e7d32',
            points: '245.24 122.56 315.64 192.96 315.64 122.56 245.24 122.56'
          }),
          _react2['default'].createElement('path', {
            fill: '#e8f5e9',
            d: 'M252.28,193H139.64v98.56H266.36V193H252.28ZM153.72,207h28.16v14.08H153.72V207Zm0,28.16h28.16v14.08H153.72V235.2Zm0,28.16h28.16v14.08H153.72V263.36Zm98.56,14.08H196V263.36h56.32v14.08Zm0-28.16H196V235.2h56.32v14.08Zm0-28.16H196V207h56.32v14.08Z'
          })
        );
      }

      return render;
    }()
  }]);

  return GoogleSheets;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = GoogleSheets;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Quickbooks = (_temp = _class = function (_SvgIcon) {
  _inherits(Quickbooks, _SvgIcon);

  function Quickbooks() {
    _classCallCheck(this, Quickbooks);

    return _possibleConstructorReturn(this, (Quickbooks.__proto__ || Object.getPrototypeOf(Quickbooks)).apply(this, arguments));
  }

  _createClass(Quickbooks, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2['default'].createElement('path', {
              d: 'M.452 60.712C.452 27.516 27.36.608 60.557.608c33.196 0 60.104 26.908 60.104 60.104 0 33.197-26.908 60.105-60.104 60.105C27.36 120.817.452 93.909.452 60.712',
              fill: '#2B9A47'
            }),
            _react2['default'].createElement('path', {
              d: 'M80.597 37.344h-3.34v8.682h3.34c8.103 0 14.692 6.589 14.692 14.692 0 8.097-6.59 14.687-14.692 14.687h-8.025V29.998a8.679 8.679 0 0 0-8.682-8.682v62.776h16.707c12.911 0 23.374-10.468 23.374-23.374 0-12.911-10.463-23.374-23.374-23.374zM17.142 60.712c0 12.912 10.463 23.374 23.374 23.374h3.34v-8.681h-3.34c-8.103 0-14.692-6.59-14.692-14.693s6.59-14.692 14.692-14.692h8.025v45.412a8.682 8.682 0 0 0 8.682 8.682V37.338H40.516c-12.911 0-23.374 10.463-23.374 23.374z',
              fill: '#FFFFFE'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return Quickbooks;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 121 121'
}, _temp);
exports['default'] = Quickbooks;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var I9Advantage = (_temp = _class = function (_SvgIcon) {
  _inherits(I9Advantage, _SvgIcon);

  function I9Advantage() {
    _classCallCheck(this, I9Advantage);

    return _possibleConstructorReturn(this, (I9Advantage.__proto__ || Object.getPrototypeOf(I9Advantage)).apply(this, arguments));
  }

  _createClass(I9Advantage, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('rect', {
            fill: '#79AF43',
            x: '5.94',
            y: '5.34',
            width: '53.21',
            height: '53.21',
            rx: '7.14'
          }),
          _react2['default'].createElement('rect', { fill: '#FFF', x: '11.68', y: '24.75', width: '7.8', height: '29.99' }),
          _react2['default'].createElement('circle', { fill: '#FFF', cx: '15.5', cy: '14.78', r: '4.77' }),
          _react2['default'].createElement('path', {
            fill: '#FFF',
            d: 'M55.8,24.92C55.8,16.69,48.73,10,40,10S24.23,16.67,24.23,24.9a14.712,14.712,0,0,0,5.85,11.8c2.54,1.93,6.92,2.58,10.53,2.6L30.66,54.74H40.4s12-18.9,13.79-22.11v-.09A14.765,14.765,0,0,0,55.8,24.92ZM40,32.72a7.8,7.8,0,1,1,7.8-7.8h0A7.8,7.8,0,0,1,40,32.72Z'
          })
        );
      }

      return render;
    }()
  }]);

  return I9Advantage;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = I9Advantage;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Jira = function (_SvgIcon) {
  _inherits(Jira, _SvgIcon);

  function Jira() {
    _classCallCheck(this, Jira);

    return _possibleConstructorReturn(this, (Jira.__proto__ || Object.getPrototypeOf(Jira)).apply(this, arguments));
  }

  _createClass(Jira, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            d: 'M7,1.4A1.53,1.53,0,1,0,8.49,2.93,1.53,1.53,0,0,0,7,1.4H7Z',
            fill: '#1f5182'
          }),
          _react2['default'].createElement('path', {
            d: 'M17,1.4a1.53,1.53,0,1,0,1.53,1.53A1.53,1.53,0,0,0,17,1.4h0Z',
            fill: '#1f5182'
          }),
          _react2['default'].createElement('path', {
            d: 'M12,0a1.53,1.53,0,1,0,1.53,1.53A1.53,1.53,0,0,0,12,0h0Z',
            fill: '#1f5182'
          }),
          _react2['default'].createElement('path', {
            d: 'M20.64,5.67a0.48,0.48,0,0,0-.3-0.1l-0.17,0a23.62,23.62,0,0,1-3.06.92,0.59,0.59,0,0,0-.42.37C16,8.79,14.2,10.64,12.33,12.55a0.5,0.5,0,0,1-.34.17,0.48,0.48,0,0,1-.35-0.17C9.76,10.64,8,8.82,7.27,6.9a0.59,0.59,0,0,0-.42-0.37,23.69,23.69,0,0,1-3.06-.93l-0.17,0a0.47,0.47,0,0,0-.28.1,0.48,0.48,0,0,0-.18.42,10,10,0,0,0,1.93,4.79,33.91,33.91,0,0,0,3.81,4.33c2.48,2.54,4.83,4.93,5,7.7a0.48,0.48,0,0,0,.48.44h2.92a0.48,0.48,0,0,0,.48-0.48s0,0,0,0a10.94,10.94,0,0,0-2.14-5.68c-0.28-.41-0.58-0.81-0.91-1.2a0.35,0.35,0,0,1,0-.45l0.3-.3a35.22,35.22,0,0,0,3.81-4.33,10.38,10.38,0,0,0,1.93-4.79,0.5,0.5,0,0,0-.18-0.42h0Z',
            fill: '#1f5182'
          }),
          _react2['default'].createElement('path', {
            d: 'M8.86,17.38a0.44,0.44,0,0,0-.34-0.14,0.48,0.48,0,0,0-.4.23,10.71,10.71,0,0,0-2,5.41,0.48,0.48,0,0,0,.45.51H9.56A0.48,0.48,0,0,0,10,22.93a6.49,6.49,0,0,1,.81-2.62,0.68,0.68,0,0,0-.06-0.72,27,27,0,0,0-1.94-2.21h0Z',
            fill: '#1f5182'
          }),
          _react2['default'].createElement('path', {
            d: 'M12,7.11c0.92,0,1.44-.06,1.63-0.06a0.44,0.44,0,0,1,.44.44,0.48,0.48,0,0,1,0,.18,7.76,7.76,0,0,1-1.7,2.49,0.47,0.47,0,0,1-.34.13h0a0.47,0.47,0,0,1-.34-0.13,7.75,7.75,0,0,1-1.7-2.49,0.47,0.47,0,0,1,0-.18,0.44,0.44,0,0,1,.44-0.44c0.18,0,.72.06,1.63,0.06h0Z',
            fill: '#1f5182'
          })
        );
      }

      return render;
    }()
  }]);

  return Jira;
}(_SvgIcon3['default']);

exports['default'] = Jira;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JobDiva = (_temp = _class = function (_SvgIcon) {
  _inherits(JobDiva, _SvgIcon);

  function JobDiva() {
    _classCallCheck(this, JobDiva);

    return _possibleConstructorReturn(this, (JobDiva.__proto__ || Object.getPrototypeOf(JobDiva)).apply(this, arguments));
  }

  _createClass(JobDiva, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'Layer_1-2', 'data-name': 'Layer 1-2' },
            _react2['default'].createElement('path', {
              fill: '#44baea',
              d: 'M30.25,53.6c2.12-2.23,2.61-4.89,2.84-7.64,0-.48.21-.6.66-.59A32.39,32.39,0,0,0,39.14,45,9.34,9.34,0,0,0,47,39.17a17.65,17.65,0,0,0-.4-15.45c-1.82-3.63-5.08-5.27-8.94-5.9a19,19,0,0,0-3.84-.32c-.45,0-.64-.08-.64-.59,0-2.34,0-4.68,0-7,0-.35,0-.6.49-.58a40.15,40.15,0,0,1,9.75,1.3,16.83,16.83,0,0,1,9.25,6.82,23.53,23.53,0,0,1,4.23,11.92,25.91,25.91,0,0,1-2,13.21,17.71,17.71,0,0,1-10.78,10,22.06,22.06,0,0,1-5.48.86A81.46,81.46,0,0,1,30.25,53.6Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#f9a91f',
              d: 'M30.19,26.39c0,5.19,0,10.38,0,15.57a23.75,23.75,0,0,1-.62,5.24A9.66,9.66,0,0,1,21,54.61c-5.7.57-10.2-1.63-13.83-5.9-.36-.43-.13-.61.14-.87,1.75-1.63,3.5-3.25,5.23-4.91.34-.33.5-.26.79.06a11.43,11.43,0,0,0,3.49,2.88,5.09,5.09,0,0,0,2.23.54,2.15,2.15,0,0,0,2.29-1.71,15.19,15.19,0,0,0,.43-4.3q0-15.1,0-30.21c0-.67.13-.91.85-.89,2.25,0,4.5,0,6.74,0,.68,0,.89.14.89.86,0,5.41,0,10.82,0,16.23Z'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return JobDiva;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = JobDiva;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Images = (_temp = _class = function (_SvgIcon) {
    _inherits(Images, _SvgIcon);

    function Images() {
        _classCallCheck(this, Images);

        return _possibleConstructorReturn(this, (Images.__proto__ || Object.getPrototypeOf(Images)).apply(this, arguments));
    }

    _createClass(Images, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement(
                        'g',
                        { fill: 'none', 'fill-rule': 'evenodd' },
                        _react2['default'].createElement('path', { d: 'M0 0h64v64H0z' }),
                        _react2['default'].createElement('path', { fill: '#00A5F7', d: 'M13.25 50.75h37.5v-37.5h-37.5z' }),
                        _react2['default'].createElement('path', { fill: '#55C7FF', d: 'M13.25 37.788L37.788 13.25H13.25z' }),
                        _react2['default'].createElement('path', { fill: '#417505', d: 'M13.25 50.75l9.375-15.625L32 50.75z' }),
                        _react2['default'].createElement('path', { fill: '#FFF', d: 'M22.625 42.156l2.11-3.515-2.11-3.516-2.11 3.516z' }),
                        _react2['default'].createElement('path', { fill: '#8FC056', d: 'M50.75 45.281l-9.375-16.406-12.5 21.875H50.75z' }),
                        _react2['default'].createElement('path', { fill: '#EBEBEB', d: 'M18.719 25.36a2.734 2.734 0 0 0 2.734 2.734h10.938a2.734 2.734 0 0 0 2.734-2.735 5.859 5.859 0 0 0-5.86-5.859 5.854 5.854 0 0 0-5.074 2.94 3.516 3.516 0 0 0-5.472 2.92' }),
                        _react2['default'].createElement('path', { fill: '#F0F1F1', d: 'M41.375 38.25l2.679-4.688-2.679-4.687-2.679 4.688z' }),
                        _react2['default'].createElement('path', { fill: '#545874', d: 'M16.375 7H7v9.375h2.344V9.344h7.031zM47.625 7H57v9.375h-2.344V9.344h-7.031zM57 47.625V57h-9.375v-2.344h7.031v-7.031zM7 47.625V57h9.375v-2.344H9.344v-7.031z' }),
                        _react2['default'].createElement('path', { fill: '#FFF', d: 'M29.266 19.5a5.854 5.854 0 0 0-5.075 2.94 3.516 3.516 0 0 0-5.472 2.92 2.734 2.734 0 0 0 2.734 2.734h1.492l8.258-8.259a5.832 5.832 0 0 0-1.937-.335' })
                    )
                );
            }

            return render;
        }()
    }]);

    return Images;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Images;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Invoices = (_temp = _class = function (_SvgIcon) {
  _inherits(Invoices, _SvgIcon);

  function Invoices() {
    _classCallCheck(this, Invoices);

    return _possibleConstructorReturn(this, (Invoices.__proto__ || Object.getPrototypeOf(Invoices)).apply(this, arguments));
  }

  _createClass(Invoices, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            {
              id: 'Icons-/-Icon-/-Invoice-Extraction',
              stroke: 'none',
              strokeWidth: '1',
              fill: 'none',
              fillRule: 'evenodd'
            },
            _react2['default'].createElement(
              'g',
              { id: 'Colors-/-Swatches-/-Transparent' },
              _react2['default'].createElement('rect', { id: 'Swatch', x: '0', y: '0', width: '64', height: '64' })
            ),
            _react2['default'].createElement(
              'g',
              { id: 'Group-33', transform: 'translate(8.500000, 9.000000)' },
              _react2['default'].createElement(
                'g',
                { id: 'Group-9', transform: 'translate(7.000000, 0.531200)' },
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-3' },
                  _react2['default'].createElement(
                    'mask',
                    { id: 'mask-2', fill: 'white' },
                    _react2['default'].createElement('polygon', {
                      id: 'path-1',
                      points: '0.7969 0.469 33.7969 0.469 33.7969 44.4689 0.7969 44.4689'
                    })
                  ),
                  _react2['default'].createElement('g', { id: 'Clip-2' }),
                  _react2['default'].createElement('path', {
                    d: 'M0.7969,3.1089 C0.7969,1.6509 1.9789,0.4689 3.4369,0.4689 L22.7969,0.4689 L33.7969,9.7089 L33.7969,41.8289 C33.7969,43.2869 32.6149,44.4689 31.1569,44.4689 L3.4369,44.4689 C1.9789,44.4689 0.7969,43.2869 0.7969,41.8289 L0.7969,3.1089 Z',
                    id: 'Fill-1',
                    fill: '#EBEBEB',
                    mask: 'url(#mask-2)'
                  })
                ),
                _react2['default'].createElement('path', {
                  d: 'M5.7314,6.9644 L28.8634,6.9644 C29.9304,6.9644 30.7964,7.8304 30.7964,8.8984 L30.7964,39.0304 C30.7964,40.0984 29.9304,40.9644 28.8634,40.9644 L5.7314,40.9644 C4.6634,40.9644 3.7964,40.0984 3.7964,39.0304 L3.7964,8.8984 C3.7964,7.8304 4.6634,6.9644 5.7314,6.9644',
                  id: 'Fill-4',
                  fill: '#FFFFFF'
                }),
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-8', transform: 'translate(22.000000, 0.000000)' },
                  _react2['default'].createElement(
                    'mask',
                    { id: 'mask-4', fill: 'white' },
                    _react2['default'].createElement('polygon', {
                      id: 'path-3',
                      points: '0.7969 0.469 11.7969 0.469 11.7969 9.7087 0.7969 9.7087'
                    })
                  ),
                  _react2['default'].createElement('g', { id: 'Clip-7' }),
                  _react2['default'].createElement('path', {
                    d: 'M0.7969,0.4687 L0.7969,7.0687 C0.7969,8.5277 1.9789,9.7087 3.4369,9.7087 L11.7969,9.7087 L0.7969,0.4687 Z',
                    id: 'Fill-6',
                    fill: '#CCCCCC',
                    mask: 'url(#mask-4)'
                  })
                )
              ),
              _react2['default'].createElement(
                'g',
                { id: 'Group-24', transform: 'translate(0.000000, 0.531200)' },
                _react2['default'].createElement('path', {
                  d: 'M32.8066,27.1016 C32.8066,27.6926 32.3276,28.1716 31.7376,28.1716 L28.9206,28.1716 C28.3296,28.1716 27.8506,27.6926 27.8506,27.1016 C27.8506,26.5106 28.3296,26.0316 28.9206,26.0316 L31.7376,26.0316 C32.3276,26.0316 32.8066,26.5106 32.8066,27.1016',
                  id: 'Fill-10',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement('path', {
                  d: 'M25.3164,17.1016 C25.3164,17.6926 24.8374,18.1716 24.2464,18.1716 L16.8574,18.1716 C16.2654,18.1716 15.7874,17.6926 15.7874,17.1016 C15.7874,16.5106 16.2654,16.0316 16.8574,16.0316 L24.2464,16.0316 C24.8374,16.0316 25.3164,16.5106 25.3164,17.1016',
                  id: 'Fill-12',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement('path', {
                  d: 'M26.2109,27.1016 C26.2109,27.6926 25.7319,28.1716 25.1409,28.1716 L16.8569,28.1716 C16.2659,28.1716 15.7869,27.6926 15.7869,27.1016 C15.7869,26.5106 16.2659,26.0316 16.8569,26.0316 L25.1409,26.0316 C25.7319,26.0316 26.2109,26.5106 26.2109,27.1016',
                  id: 'Fill-14',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement('path', {
                  d: 'M32.8066,22.4687 C32.8066,23.0597 32.3276,23.5387 31.7376,23.5387 L16.8576,23.5387 C16.2656,23.5387 15.7866,23.0597 15.7866,22.4687 C15.7866,21.8777 16.2656,21.3987 16.8576,21.3987 L31.7376,21.3987 C32.3276,21.3987 32.8066,21.8777 32.8066,22.4687',
                  id: 'Fill-16',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement(
                  'mask',
                  { id: 'mask-6', fill: 'white' },
                  _react2['default'].createElement('polygon', {
                    id: 'path-5',
                    points: '0 47 40.797 47 40.797 0.469 0 0.469'
                  })
                ),
                _react2['default'].createElement('g', { id: 'Clip-19' }),
                _react2['default'].createElement('path', {
                  d: 'M26.904,19.332 L33.689,19.332 L33.689,14.871 L26.904,14.871 L26.904,19.332 Z M34.189,20.332 L26.404,20.332 C26.128,20.332 25.904,20.108 25.904,19.832 L25.904,14.371 C25.904,14.095 26.128,13.871 26.404,13.871 L34.189,13.871 C34.466,13.871 34.689,14.095 34.689,14.371 L34.689,19.832 C34.689,20.108 34.466,20.332 34.189,20.332 L34.189,20.332 Z',
                  id: 'Fill-18',
                  fill: '#FC6666',
                  mask: 'url(#mask-6)'
                }),
                _react2['default'].createElement('path', {
                  d: 'M14.761,35.332 L23.789,35.332 L23.789,30.871 L14.761,30.871 L14.761,35.332 Z M24.289,36.332 L14.261,36.332 C13.984,36.332 13.761,36.108 13.761,35.832 L13.761,30.371 C13.761,30.095 13.984,29.871 14.261,29.871 L24.289,29.871 C24.565,29.871 24.789,30.095 24.789,30.371 L24.789,35.832 C24.789,36.108 24.565,36.332 24.289,36.332 L24.289,36.332 Z',
                  id: 'Fill-20',
                  fill: '#FC6666',
                  mask: 'url(#mask-6)'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-21',
                  fill: '#CCCCCC',
                  mask: 'url(#mask-6)',
                  points: '6.3311 34.3203 10.7971 45.8633 19.2331 33.5523'
                }),
                _react2['default'].createElement('path', {
                  d: 'M32.8066,17.1016 C32.8066,17.6926 32.3276,18.1716 31.7376,18.1716 L28.8206,18.1716 C28.2296,18.1716 27.7496,17.6926 27.7496,17.1016 C27.7496,16.5106 28.2296,16.0316 28.8206,16.0316 L31.7376,16.0316 C32.3276,16.0316 32.8066,16.5106 32.8066,17.1016',
                  id: 'Fill-22',
                  fill: '#5E6174',
                  mask: 'url(#mask-6)'
                }),
                _react2['default'].createElement('path', {
                  d: 'M22.6807,33.1016 C22.6807,33.6926 22.2017,34.1716 21.6107,34.1716 L16.8577,34.1716 C16.2657,34.1716 15.7867,33.6926 15.7867,33.1016 C15.7867,32.5106 16.2657,32.0316 16.8577,32.0316 L21.6107,32.0316 C22.2017,32.0316 22.6807,32.5106 22.6807,33.1016',
                  id: 'Fill-23',
                  fill: '#5E6174',
                  mask: 'url(#mask-6)'
                })
              ),
              _react2['default'].createElement(
                'g',
                { id: 'Group-32', transform: 'translate(0.000000, 32.531200)' },
                _react2['default'].createElement('path', {
                  d: 'M13.4482,7.9009 C13.4482,11.4069 10.6052,14.2499 7.0982,14.2499 C3.5932,14.2499 0.7502,11.4069 0.7502,7.9009 C0.7502,4.3949 3.5932,1.5519 7.0982,1.5519 C10.6052,1.5519 13.4482,4.3949 13.4482,7.9009',
                  id: 'Fill-25',
                  fill: '#FFFFFF'
                }),
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-29' },
                  _react2['default'].createElement(
                    'mask',
                    { id: 'mask-8', fill: 'white' },
                    _react2['default'].createElement('polygon', {
                      id: 'path-7',
                      points: '0 0.8022 14.1986 0.8022 14.1986 15 0 15'
                    })
                  ),
                  _react2['default'].createElement('g', { id: 'Clip-28' }),
                  _react2['default'].createElement('path', {
                    d: 'M7.0986,2.3022 C4.0116,2.3022 1.4996,4.8142 1.4996,7.9012 C1.4996,10.9882 4.0116,13.5002 7.0986,13.5002 C10.1866,13.5002 12.6986,10.9882 12.6986,7.9012 C12.6986,4.8142 10.1866,2.3022 7.0986,2.3022 M7.0986,15.0002 C3.1846,15.0002 -0.0004,11.8152 -0.0004,7.9012 C-0.0004,3.9872 3.1846,0.8022 7.0986,0.8022 C11.0136,0.8022 14.1986,3.9872 14.1986,7.9012 C14.1986,11.8152 11.0136,15.0002 7.0986,15.0002',
                    id: 'Fill-27',
                    fill: '#112B70',
                    mask: 'url(#mask-8)'
                  })
                ),
                _react2['default'].createElement('path', {
                  d: 'M8.6143,7.4336 C8.3033,7.2946 7.9763,7.1776 7.6383,7.0856 C7.3663,7.0146 7.0993,6.9126 6.8483,6.7836 C6.7683,6.7416 6.7183,6.6556 6.7203,6.5486 C6.7183,6.4966 6.7453,6.4476 6.7813,6.4256 C6.8973,6.3616 7.0183,6.3326 7.1633,6.3356 C7.4183,6.3466 7.6693,6.3936 7.9163,6.4816 C8.2143,6.5766 8.5003,6.7076 8.7663,6.8726 L9.0063,7.0206 L9.6943,5.5316 L9.5203,5.4126 C9.2603,5.2336 8.9763,5.0916 8.6783,4.9896 C8.4373,4.9046 8.1883,4.8406 7.9363,4.7996 L7.9363,3.6986 L6.5263,3.6986 L6.5263,4.8116 C6.1093,4.8976 5.7173,5.0986 5.4013,5.3906 C5.0553,5.7176 4.8643,6.1806 4.8763,6.6406 C4.8593,7.0056 4.9683,7.3696 5.1893,7.6726 C5.3803,7.9106 5.6283,8.1026 5.9123,8.2296 C6.2233,8.3606 6.5483,8.4696 6.8693,8.5536 C7.1213,8.6256 7.3213,8.6896 7.4743,8.7506 C7.5803,8.7866 7.6763,8.8446 7.7573,8.9186 C7.8133,8.9736 7.8423,9.0486 7.8353,9.1236 C7.8273,9.2036 7.7863,9.2726 7.7353,9.3066 C7.5923,9.3866 7.4183,9.4216 7.2613,9.4146 C6.9473,9.4076 6.6433,9.3376 6.3523,9.2066 C6.0233,9.0686 5.7223,8.8766 5.4593,8.6386 L5.2123,8.4156 L4.4823,9.9166 L4.6333,10.0416 C4.9263,10.2876 5.2543,10.4896 5.6053,10.6416 C5.9013,10.7676 6.2123,10.8606 6.5303,10.9176 L6.5303,12.1036 L7.9403,12.1036 L7.9403,10.9216 C8.3693,10.8436 8.7653,10.6506 9.1023,10.3546 C9.4703,10.0136 9.6723,9.5296 9.6533,9.0486 C9.6723,8.6796 9.5613,8.3106 9.3403,8.0096 C9.1513,7.7596 8.9003,7.5606 8.6143,7.4336',
                  id: 'Fill-30',
                  fill: '#00A3F5'
                })
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return Invoices;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Invoices;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Kafka = function (_SvgIcon) {
  _inherits(Kafka, _SvgIcon);

  function Kafka() {
    _classCallCheck(this, Kafka);

    return _possibleConstructorReturn(this, (Kafka.__proto__ || Object.getPrototypeOf(Kafka)).apply(this, arguments));
  }

  _createClass(Kafka, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0,0H24V24H0V0Z', fill: 'none' }),
          _react2['default'].createElement('path', { d: 'M16.27,13.18a2.91,2.91,0,0,0-2.18,1l-1.37-1a3.65,3.65,0,0,0,.23-1.28,3.81,3.81,0,0,0-.22-1.26l1.36-1a2.94,2.94,0,1,0-.61-1.1l-1.37,1A3.78,3.78,0,0,0,9.79,8.22V6.57a2.91,2.91,0,1,0-1.25,0V8.23a3.75,3.75,0,0,0,0,7.4v1.76a2.9,2.9,0,1,0,1.25,0V15.62a3.74,3.74,0,0,0,2.29-1.33l1.38,1a2.87,2.87,0,0,0-.12.82,2.91,2.91,0,1,0,2.91-2.91h0Zm0-6.81a1.41,1.41,0,1,1-1.42,1.41,1.41,1.41,0,0,1,1.42-1.41h0ZM7.78,3.72A1.41,1.41,0,1,1,9.19,5.13,1.41,1.41,0,0,1,7.78,3.72h0Zm2.82,16.5a1.41,1.41,0,1,1-1.41-1.41,1.41,1.41,0,0,1,1.41,1.41h0ZM9.19,13.89a2,2,0,1,1,2-2,2,2,0,0,1-2,2h0Zm7.08,3.61a1.41,1.41,0,1,1,1.41-1.41,1.41,1.41,0,0,1-1.41,1.41h0Z' })
        );
      }

      return render;
    }()
  }]);

  return Kafka;
}(_SvgIcon3['default']);

exports['default'] = Kafka;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Lever = (_temp = _class = function (_SvgIcon) {
  _inherits(Lever, _SvgIcon);

  function Lever() {
    _classCallCheck(this, Lever);

    return _possibleConstructorReturn(this, (Lever.__proto__ || Object.getPrototypeOf(Lever)).apply(this, arguments));
  }

  _createClass(Lever, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'Lever-icon', transform: 'translate(7.000000, 7.000000)' },
            _react2['default'].createElement(
              'g',
              { id: 'Group-3', transform: 'translate(0.000000, 0.941200)' },
              _react2['default'].createElement('path', {
                d: 'M35.9497,38.0849 C35.8877,38.1839 35.7577,38.2499 35.6237,38.2499 C35.5007,38.2499 35.3507,38.3169 35.2917,38.3999 C35.2327,38.4819 35.1187,38.5739 35.0397,38.6039 L25.3057,47.7529 C25.3057,47.8509 25.2727,47.9109 25.2317,47.8859 C25.1097,47.8099 25.0057,48.0259 24.9827,48.4019 C24.9657,48.7039 24.9887,48.7669 25.1337,48.8049 C25.2277,48.8289 25.3057,48.8829 25.3057,48.9229 C25.3057,48.9649 30.1677,48.9959 36.7137,48.9959 L48.1217,48.9959 L48.1217,48.3869 L48.1217,47.7769 L47.7497,47.4349 L38.2697,38.5799 C38.2317,38.5799 38.1277,38.5059 38.0367,38.4149 C37.9447,38.3239 37.7777,38.2499 37.6647,38.2499 C37.5437,38.2499 37.4577,38.2019 37.4577,38.1349 C37.4577,37.8629 36.1167,37.8169 35.9497,38.0849 M33.9027,0.1419 C33.9027,0.1869 33.7687,0.2239 33.6057,0.2239 C33.3787,0.2239 33.2987,0.2629 33.2647,0.3899 C33.2417,0.4809 33.1757,0.5549 33.1187,0.5549 L0.8377,33.3249 C0.8377,33.3969 0.7927,33.4459 0.7377,33.4349 C0.6817,33.4229 0.6337,33.4509 0.6277,33.4969 C0.6027,33.6819 0.4677,33.9159 0.3257,34.0179 C0.2307,34.0859 0.1757,34.2309 0.1757,34.4099 C0.1757,34.5669 0.1377,34.6949 0.0937,34.6949 C-0.0523,34.6949 -0.0173,48.7309 0.1287,48.8779 C0.3327,49.0829 0.4047,49.0269 1.8417,47.5699 C2.6137,46.7849 4.0537,45.3259 5.0417,44.3249 C6.0287,43.3249 9.2337,40.0729 12.1657,37.0989 C15.0957,34.1239 18.1077,31.0709 18.8577,30.3139 C22.0107,27.1349 29.8967,19.1309 29.9347,19.0709 C29.9847,18.9949 37.5767,11.2899 42.4587,6.3609 C45.5847,3.2049 46.1247,2.6299 46.1347429,2.4409 C46.1397,2.3299 45.7057,1.8779 45.5927,1.8779 C45.5277,1.8779 45.4017,1.8039 45.3097,1.7119 C45.1797,1.5809 45.0347,1.5469 44.6207,1.5469 C44.2017,1.5469 44.0667,1.5139 43.9467,1.3819 C43.8207,1.2419 43.6917,1.2159 43.1367,1.2159 C42.6037,1.2159 42.4567,1.1889 42.3717,1.0709 C42.2887,0.9579 42.1007,0.9179 41.4947,0.8859 C41.0057,0.8589 40.7277,0.8119 40.7387,0.7549 C40.7587,0.6439 40.7157,0.6349 39.8827,0.5839 C39.3567,0.5519 39.1767,0.5079 39.0637,0.3829 C38.9427,0.2489 38.8047,0.2239 38.1887,0.2239 C37.7567,0.2239 37.4577,0.1899 37.4577,0.1419 C37.4577,0.0889 36.8097,0.0589 35.6797,0.0589 C34.5507,0.0589 33.9027,0.0889 33.9027,0.1419',
                id: 'Fill-1',
                fill: '#ACACAC'
              })
            ),
            _react2['default'].createElement(
              'g',
              { id: 'Group-6', transform: 'translate(0.000000, 2.941200)' },
              _react2['default'].createElement('path', {
                d: 'M46.0864,0.3525 C46.1624,0.6065 45.9964,0.7895 42.4584,4.3615 C37.5764,9.2905 29.9844,16.9955 29.9354,17.0715 C29.8974,17.1305 22.0104,25.1345 18.8574,28.3145 C18.1074,29.0715 15.0964,32.1235 12.1654,35.0985 C9.2334,38.0735 6.0284,41.3255 5.0414,42.3255 C4.0554,43.3265 2.6304,44.7685 1.8764,45.5325 C1.1224,46.2955 0.5064,46.9385 0.5064,46.9585 C0.5064,47.0365 13.8844,46.9955 13.9114,46.9175 C13.9274,46.8745 14.1104,46.8315 14.3194,46.8205 C14.6074,46.8055 14.6984,46.7695 14.6914,46.6705 C14.6864,46.5755 14.7764,46.5345 15.0344,46.5155 C15.3184,46.4955 15.3864,46.4595 15.3864,46.3305 C15.3864,46.2255 15.4424,46.1685 15.5484,46.1685 C15.6384,46.1685 15.7954,46.0565 15.8974,45.9185 C15.9984,45.7815 16.1254,45.6855 16.1794,45.7065 C16.2424,45.7305 16.2614,45.6835 16.2324,45.5715 C16.2004,45.4555 16.2174,45.4185 16.2824,45.4585 C16.3434,45.4965 16.3784,45.4565 16.3784,45.3475 C16.3784,45.2325 16.4314,45.1775 16.5434,45.1775 L48.1104,13.8535 C48.1164,13.8105 48.1954,13.7525 48.2864,13.7235 C48.3774,13.6945 48.4514,13.6055 48.4514,13.5245 C48.4514,13.4435 48.5254,13.3095 48.6164,13.2275 C48.7114,13.1425 48.7824,12.9725 48.7824,12.8335 C48.7824,12.6545 48.8154,12.6025 48.9014,12.6355 C48.9824,12.6665 49.0074,12.6425 48.9764,12.5605 C48.9494,12.4945 48.9684,12.3935 49.0164,12.3345 C49.1834,12.1345 49.1174,10.0275 48.9404,9.8735 C48.8174,9.7675 48.7834,9.6035 48.7684,9.0535 C48.7584,8.6755 48.7344,8.4095 48.7184,8.4615 C48.7004,8.5145 48.6484,8.5575 48.6014,8.5575 C48.5544,8.5575 48.5384,8.4985 48.5654,8.4285 C48.5934,8.3585 48.5804,8.3215 48.5384,8.3475 C48.4954,8.3735 48.4634,8.3305 48.4654,8.2485 C48.4824,7.4985 48.4214,6.7475 48.3464,6.7935 C48.2914,6.8285 48.2774,6.7975 48.3104,6.7145 C48.3464,6.6205 48.3244,6.5955 48.2374,6.6285 C48.1694,6.6545 48.1194,6.6435 48.1274,6.6045 C48.2134,6.1295 48.1054,5.2305 47.9554,5.1925 C47.8074,5.1535 47.6984,4.2885 47.7834,3.8155 C47.7904,3.7775 47.7534,3.6935 47.7014,3.6305 C47.6494,3.5685 47.6274,3.4625 47.6524,3.3965 C47.6844,3.3145 47.6594,3.2905 47.5794,3.3215 C47.4634,3.3665 47.4234,3.0025 47.4434,2.0805 C47.4484,1.8865 47.4204,1.8525 47.2894,1.8865 C47.1504,1.9225 47.1294,1.8845 47.1294,1.6005 C47.1294,1.1725 47.0234,0.9895 46.7174,0.8825 C46.5564,0.8265 46.4644,0.7355 46.4574,0.6255 C46.4514,0.5325 46.4424,0.4135 46.4374,0.3615 C46.4314,0.3085 46.3404,0.2525 46.2344,0.2365 C46.0844,0.2135 46.0524,0.2385 46.0864,0.3525',
                id: 'Fill-4',
                fill: '#DBDBDB'
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return Lever;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Lever;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaoceanPrisma = (_temp = _class = function (_SvgIcon) {
  _inherits(MediaoceanPrisma, _SvgIcon);

  function MediaoceanPrisma() {
    _classCallCheck(this, MediaoceanPrisma);

    return _possibleConstructorReturn(this, (MediaoceanPrisma.__proto__ || Object.getPrototypeOf(MediaoceanPrisma)).apply(this, arguments));
  }

  _createClass(MediaoceanPrisma, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            d: 'M24.36,21.85l.17,0c1.89-.86,3.61-2,5.43-3a8.2,8.2,0,0,0,2.17-1.37c.17-.1.14-.27.14-.42V9c0-.15,0-.32-.13-.43C27.43,5.89,22.73,3.17,18,.49a2.39,2.39,0,0,0-2.37,0C13.5,1.69,11.4,2.94,9.28,4.17c-.14.08-.13.22-.13.35,0,2.48,0,5,0,7.45V39.54c2.29-1.33,4.47-2.55,6.6-3.85a2.29,2.29,0,0,0,1.07-1.95c0-2.45,0-4.91,0-7.36l.08-.15c1.78-1,3.58-2,5.35-3.05A8,8,0,0,0,24.36,21.85Z',
            fill: '#fefefe'
          }),
          _react2['default'].createElement('path', {
            d: 'M9.17,30.66V22.89a4.1,4.1,0,0,1,2.13-2.28c1.78-1,3.61-1.92,5.29-3.09.11-.06.11-.11,0-.16-1.57-.91-3.12-1.84-4.69-2.74C10.75,14,9.56,13.4,9.17,12c0-2.48,0-5,0-7.45,0-.13,0-.27.13-.35,1.34,1,2.9,1.68,4.31,2.58a16.59,16.59,0,0,1,3.25,2q0,4.29.05,8.58a.15.15,0,0,0,0,.13v8.73l-.08.15c-.29.14-.58.26-.85.41Z',
            fill: '#009387'
          }),
          _react2['default'].createElement('path', {
            d: 'M16.84,8.79a16.59,16.59,0,0,0-3.25-2c-1.41-.9-3-1.56-4.31-2.58C11.4,2.94,13.5,1.69,15.64.5A2.39,2.39,0,0,1,18,.49c4.72,2.68,9.42,5.4,14.13,8.11-1.09.83-2.35,1.38-3.5,2.1-1.31.81-2.73,1.44-4,2.36h-.15l-.15-.12L17.48,9C17.29,8.88,17.1,8.69,16.84,8.79Z',
            fill: '#01b1ad'
          }),
          _react2['default'].createElement('path', {
            d: 'M9.17,30.66,16,26.79c.27-.15.56-.27.85-.41,0,2.45.06,4.91,0,7.36a2.29,2.29,0,0,1-1.07,1.95c-2.13,1.3-4.31,2.52-6.6,3.85Z',
            fill: '#05b1ac'
          }),
          _react2['default'].createElement('path', {
            d: 'M9.17,12c.39,1.43,1.58,2,2.73,2.65,1.57.9,3.12,1.83,4.69,2.74v.16c-1.68,1.17-3.51,2.09-5.29,3.09a4.1,4.1,0,0,0-2.13,2.28Z',
            fill: '#01b1ad'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.51,13.06h.15c.27.16.53.34.8.49l6.67,3.86A8.2,8.2,0,0,1,30,18.78c-1.82,1-3.54,2.17-5.43,3C24.52,18.89,24.52,16,24.51,13.06Z',
            fill: '#d2d3c6'
          }),
          _react2['default'].createElement('path', {
            d: 'M32.13,17.41l-6.67-3.86c-.27-.15-.53-.33-.8-.49,1.25-.92,2.67-1.55,4-2.36,1.15-.72,2.41-1.27,3.5-2.1.17.11.13.28.13.43v8C32.27,17.14,32.3,17.31,32.13,17.41Z',
            fill: '#009387'
          }),
          _react2['default'].createElement('path', {
            d: 'M16.9,26.23q0-4.36,0-8.73c1.38.77,2.77,1.52,4.12,2.33a29.19,29.19,0,0,1,3.35,2,8,8,0,0,1-2.11,1.33C20.48,24.21,18.68,25.21,16.9,26.23Z',
            fill: '#d2d3c6'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.36,21.85a29.19,29.19,0,0,0-3.35-2c-1.35-.81-2.74-1.56-4.12-2.33a.15.15,0,0,1,0-.13c2-1.12,4-2.22,6-3.37.53-.3,1.2-.43,1.51-1.06l.15.12c0,2.91,0,5.83,0,8.75Z',
            fill: '#b0b09b'
          }),
          _react2['default'].createElement('path', {
            d: 'M24.36,12.94c-.31.63-1,.76-1.51,1.06-2,1.15-4,2.25-6,3.37q0-4.29-.05-8.58c.26-.1.45.09.64.2Z',
            fill: '#d2d3c6'
          }),
          _react2['default'].createElement('path', {
            d: 'M16.59,17.52v-.16C16.7,17.41,16.7,17.46,16.59,17.52Z',
            fill: '#05b1ac'
          })
        );
      }

      return render;
    }()
  }]);

  return MediaoceanPrisma;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40.17 40.04'
}, _temp);
exports['default'] = MediaoceanPrisma;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Message = (_temp = _class = function (_SvgIcon) {
  _inherits(Message, _SvgIcon);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
  }

  _createClass(Message, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M40.24,11.23H35.71v9.13a6.61,6.61,0,0,1-6.6,6.6h-7.9L20.13,28a4.59,4.59,0,0,0,4.31,3h6.78l4.84,3.82a3,3,0,0,0,2.08,1,1.69,1.69,0,0,0,.73-0.16c0.48-.22,1.24-0.88,1.09-2.72l0.06-2h0.23a4.61,4.61,0,0,0,4.6-4.6V15.82A4.61,4.61,0,0,0,40.24,11.23Z' }),
          _react2['default'].createElement('path', { d: 'M27.46,19.13H13.29a0.75,0.75,0,0,1,0-1.5H27.46A0.75,0.75,0,0,1,27.46,19.13Z' }),
          _react2['default'].createElement('path', { d: 'M27.46,15.55H13.29a0.75,0.75,0,0,1,0-1.5H27.46A0.75,0.75,0,0,1,27.46,15.55Z' }),
          _react2['default'].createElement('path', { d: 'M19.46,12H13.29a0.75,0.75,0,0,1,0-1.5h6.17A0.75,0.75,0,0,1,19.46,12Z' }),
          _react2['default'].createElement('path', { d: 'M12.92,31.58a2,2,0,0,1-.84-0.18c-0.54-.26-1.42-1-1.23-3l0.29-3.16a4.86,4.86,0,0,1-4.68-4.85V9.7a4.86,4.86,0,0,1,4.85-4.85h17.8A4.86,4.86,0,0,1,34,9.7V20.36a4.86,4.86,0,0,1-4.85,4.85H20.5l-5.29,5.22A3.32,3.32,0,0,1,12.92,31.58ZM11.31,7.35A2.35,2.35,0,0,0,9,9.7V20.36a2.35,2.35,0,0,0,2.35,2.35h1.2a1.25,1.25,0,0,1,1.24,1.37L13.34,28.6c0,0.06,0,.12,0,0.17l0.12-.12,5.66-5.58A1.25,1.25,0,0,1,20,22.71h9.13a2.35,2.35,0,0,0,2.35-2.35V9.7a2.35,2.35,0,0,0-2.35-2.35H11.31Z' })
        );
      }

      return render;
    }()
  }]);

  return Message;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 50 39.88'
}, _temp);
exports['default'] = Message;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Brain = (_temp = _class = function (_SvgIcon) {
  _inherits(Brain, _SvgIcon);

  function Brain() {
    _classCallCheck(this, Brain);

    return _possibleConstructorReturn(this, (Brain.__proto__ || Object.getPrototypeOf(Brain)).apply(this, arguments));
  }

  _createClass(Brain, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('rect', { fill: '#F3F3F3', width: '439', height: '439' }),
          _react2['default'].createElement('rect', { x: '17', y: '17', fill: '#F35325', width: '194', height: '194' }),
          _react2['default'].createElement('rect', { x: '228', y: '17', fill: '#81BC06', width: '194', height: '194' }),
          _react2['default'].createElement('rect', { x: '17', y: '228', fill: '#05A6F0', width: '194', height: '194' }),
          _react2['default'].createElement('rect', { x: '228', y: '228', fill: '#FFBA08', width: '194', height: '194' })
        );
      }

      return render;
    }()
  }]);

  return Brain;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 439 439'
}, _temp);
exports['default'] = Brain;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MicrosoftDynamics = (_temp = _class = function (_SvgIcon) {
  _inherits(MicrosoftDynamics, _SvgIcon);

  function MicrosoftDynamics() {
    _classCallCheck(this, MicrosoftDynamics);

    return _possibleConstructorReturn(this, (MicrosoftDynamics.__proto__ || Object.getPrototypeOf(MicrosoftDynamics)).apply(this, arguments));
  }

  _createClass(MicrosoftDynamics, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            d: 'M15.481,3.682V24.691H36.49A17.018,17.018,0,1,1,15.481,3.682M18.577,0A20.115,20.115,0,1,0,40.172,21.595H18.577V0Z',
            fill: '#05b5c1'
          }),
          _react2['default'].createElement('rect', { x: '21.67', y: '12.322', width: '3.09', height: '6.18', fill: '#05b5c1' }),
          _react2['default'].createElement('rect', { x: '27.85', y: '9.231', width: '3.09', height: '9.27', fill: '#05b5c1' }),
          _react2['default'].createElement('rect', {
            x: '34.031',
            y: '3.051',
            width: '3.09',
            height: '15.451',
            fill: '#05b5c1'
          })
        );
      }

      return render;
    }()
  }]);

  return MicrosoftDynamics;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40.172 40.172',
  preserveAspectRatio: 'xMidYMid'
}, _temp);
exports['default'] = MicrosoftDynamics;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Netsuite = function (_SvgIcon) {
  _inherits(Netsuite, _SvgIcon);

  function Netsuite() {
    _classCallCheck(this, Netsuite);

    return _possibleConstructorReturn(this, (Netsuite.__proto__ || Object.getPrototypeOf(Netsuite)).apply(this, arguments));
  }

  _createClass(Netsuite, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0.68,1.4H14.75V12.84L9.28,6.21H0.68V1.4Z', fill: '#14487e' }),
          _react2['default'].createElement('path', {
            d: 'M9.21,10.58C11,12.7,12.78,15,14.6,17.14h8.68V22H9.21V10.58Z',
            fill: '#14487e'
          }),
          _react2['default'].createElement('path', {
            d: 'M15.62,6.21V2.34h6.63V16.27H17.81V6.21H15.62Z',
            fill: '#b9c7d4'
          }),
          _react2['default'].createElement('path', { d: 'M6.15,7.08v10H8.33V21H1.7V7.08H6.15Z', fill: '#b9c7d4' })
        );
      }

      return render;
    }()
  }]);

  return Netsuite;
}(_SvgIcon3['default']);

exports['default'] = Netsuite;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Numbers = (_temp = _class = function (_SvgIcon) {
    _inherits(Numbers, _SvgIcon);

    function Numbers() {
        _classCallCheck(this, Numbers);

        return _possibleConstructorReturn(this, (Numbers.__proto__ || Object.getPrototypeOf(Numbers)).apply(this, arguments));
    }

    _createClass(Numbers, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement(
                        'defs',
                        null,
                        _react2['default'].createElement('path', { id: 'a', d: 'M0 .4h32.056v44.5998H0z' }),
                        _react2['default'].createElement('path', { id: 'c', d: 'M.0005.4H32.056v44.5998H.0005z' }),
                        _react2['default'].createElement('path', { id: 'e', d: 'M0 45.6003h32.056v-44.6H0z' })
                    ),
                    _react2['default'].createElement(
                        'g',
                        { transform: 'translate(0 -.5)', fill: 'none', 'fill-rule': 'evenodd' },
                        _react2['default'].createElement(
                            'g',
                            { transform: 'translate(0 .6003)' },
                            _react2['default'].createElement(
                                'mask',
                                { id: 'b', fill: '#fff' },
                                _react2['default'].createElement('use', { xlinkHref: '#a' })
                            ),
                            _react2['default'].createElement('path', { d: 'M32.0569 40.8188c0 2.309-1.872 4.181-4.182 4.181H4.1809c-2.309 0-4.181-1.872-4.181-4.181V3.8838c0-2.309 1.175-3.484 3.485-3.484h25.088c2.308 0 3.484 1.175 3.484 3.484v36.935z', fill: '#EBEBEB', mask: 'url(#b)' })
                        ),
                        _react2['default'].createElement(
                            'g',
                            { transform: 'translate(0 .6003)' },
                            _react2['default'].createElement(
                                'mask',
                                { id: 'd', fill: '#fff' },
                                _react2['default'].createElement('use', { xlinkHref: '#c' })
                            ),
                            _react2['default'].createElement('path', { d: 'M28.5725.3998h-.937L.0005 28.0358v12.783c0 2.309 1.872 4.181 4.18 4.181h23.695c2.309 0 4.181-1.872 4.181-4.181V3.8838c0-2.309-1.175-3.484-3.484-3.484', fill: '#E3E3E3', mask: 'url(#d)' })
                        ),
                        _react2['default'].createElement(
                            'mask',
                            { id: 'f', fill: '#fff' },
                            _react2['default'].createElement('use', { xlinkHref: '#e' })
                        ),
                        _react2['default'].createElement('path', { fill: '#5E6174', mask: 'url(#f)', d: 'M2.788 15.0113h26.481V4.9963H2.788z' }),
                        _react2['default'].createElement('path', { d: 'M9.1741 24.5592h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72M18.6487 24.5592h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#CCC', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M28.1233 24.5592h-5.724c-.396 0-.719-.324-.719-.72v-5.377c0-.396.323-.72.719-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#696C82', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M9.1741 33.381h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72M18.6487 33.381h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#CCC', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M28.1233 33.381h-5.724c-.396 0-.719-.324-.719-.72v-5.377c0-.396.323-.72.719-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#696C82', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M9.1741 42.2023h-5.724c-.396 0-.72-.324-.72-.72v-5.377c0-.396.324-.72.72-.72h5.724c.396 0 .72.324.72.72v5.377c0 .396-.324.72-.72.72', fill: '#CCC', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { d: 'M28.1233 35.3849h-15.198c-.397 0-.721.324-.721.72v5.377c0 .396.324.72.721.72H28.1233c.396 0 .72-.324.72-.72v-5.377c0-.396-.324-.72-.72-.72', fill: '#FB6566', mask: 'url(#f)' }),
                        _react2['default'].createElement('path', { fill: '#80839E', mask: 'url(#f)', d: 'M2.7874 4.9967v10.015h14.338l10.015-10.015z' }),
                        _react2['default'].createElement('path', { d: 'M11.343 10.1183c0-1.234-.363-1.836-.957-1.836s-.961.606-.961 1.832c0 1.234.367 1.856.961 1.856.598 0 .957-.622.957-1.852m-3.375 0c0-1.852.937-2.953 2.418-2.953 1.484 0 2.414 1.098 2.414 2.949 0 1.84-.922 2.973-2.414 2.973s-2.418-1.125-2.418-2.969M14.8743 8.5675h-.027l-1.41.945v-1.226l1.433-.977h1.43v5.637h-1.426zM19.5696 7.1691c1.293 0 2.133.695 2.133 1.68 0 .726-.367 1.136-1.281 1.965l-1.102 1.003v.028h2.453v1.101h-4.297v-.976l2-1.801c.696-.625.84-.879.84-1.227 0-.406-.309-.695-.746-.695-.492 0-.863.328-.863.824h-1.313c0-1.14.879-1.902 2.176-1.902M23.929 9.5675h.605c.551 0 .887-.27.887-.68 0-.41-.297-.652-.777-.652-.496 0-.824.266-.856.691h-1.3c.05-1.078.91-1.757 2.156-1.757 1.222 0 2.108.558 2.108 1.515 0 .723-.523 1.184-1.167 1.313v.027c.851.086 1.39.566 1.39 1.328 0 1.055-.91 1.735-2.323 1.735-1.328 0-2.243-.707-2.297-1.79h1.367c.035.383.375.665.93.665.511 0 .867-.282.867-.696 0-.469-.352-.726-.977-.726h-.613v-.973z', fill: '#FFF', mask: 'url(#f)' })
                    )
                );
            }

            return render;
        }()
    }]);

    return Numbers;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '-6 0 33 46',
    xlinkHref: 'http://www.w3.org/1999/xlink'
}, _temp);
exports['default'] = Numbers;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Okta = (_temp = _class = function (_SvgIcon) {
  _inherits(Okta, _SvgIcon);

  function Okta() {
    _classCallCheck(this, Okta);

    return _possibleConstructorReturn(this, (Okta.__proto__ || Object.getPrototypeOf(Okta)).apply(this, arguments));
  }

  _createClass(Okta, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M163.663,516.666c-85.585-0.03-154.99,69.323-155.02,154.907c-0.032,85.582,69.325,154.99,154.909,155.02c85.584,0.032,154.989-69.323,155.02-154.908C318.571,586.114,249.233,516.728,163.663,516.666 M163.663,749.139c-42.808,0-77.51-34.703-77.51-77.51s34.702-77.509,77.51-77.509c42.807,0,77.51,34.702,77.51,77.509c0,0.021,0,0.036,0,0.056C241.142,714.471,206.45,749.139,163.663,749.139'
          }),
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M436.011,723.638c-0.086-7.474,5.9-13.604,13.375-13.691c3.723-0.043,7.303,1.45,9.889,4.129c38.645,39.536,102.732,107.15,103.125,107.54c1.395,1.803,3.371,3.065,5.592,3.579c2.159,0.511,4.378,0.732,6.596,0.672h69.906c7.504-0.175,13.441-6.398,13.267-13.904c-0.065-2.883-1.05-5.672-2.808-7.961L539.246,685.275l-6.038-6.322c-13.31-16.049-11.745-21.921,3.466-37.859l92.049-102.673c4.755-5.926,3.811-14.585-2.113-19.34c-2.447-1.964-5.486-3.033-8.623-3.031h-63.529c-2.05,0.007-4.086,0.328-6.038,0.954c-2.379,0.639-4.517,1.96-6.153,3.801l-82.431,89.143c-5.255,5.526-14,5.749-19.529,0.493c-2.698-2.564-4.246-6.11-4.295-9.833V424.391c0.073-6.979-5.53-12.696-12.508-12.767c-0.27-0.002-0.534,0.002-0.803,0.017h-51.951c-6.815-0.371-12.643,4.853-13.013,11.668c-0.01,0.173-0.017,0.349-0.019,0.522v390.065c-0.128,6.517,5.051,11.902,11.566,12.029c0.489,0.011,0.978-0.01,1.465-0.061h51.841c7.05,0.104,12.947-5.327,13.421-12.358V723.638z'
          }),
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M858.68,811.886l-5.593-51.898c-0.734-6.818-6.857-11.745-13.676-11.011c-0.25,0.029-0.501,0.063-0.75,0.104c-42.285,6.676-81.974-22.196-88.644-64.479c-0.414-2.612-0.691-5.242-0.835-7.884c0-1.379,0-2.776,0-4.195v-63.247c-0.186-8.09,6.222-14.8,14.312-14.983c0.094-0.002,0.189-0.005,0.281-0.005h69.682c7.134-0.241,12.719-6.219,12.475-13.349c0-0.024,0-0.049,0-0.072v-49.045c0.613-7.228-4.693-13.608-11.914-14.318h-69.849c-7.839,0.249-14.395-5.906-14.644-13.748c-0.006-0.114-0.008-0.229-0.008-0.344v-78.685c-0.083-7.01-5.83-12.627-12.842-12.546c-0.19,0.001-0.387,0.008-0.58,0.02h-51.562c-6.595-0.402-12.271,4.619-12.676,11.215c-0.019,0.325-0.026,0.652-0.019,0.976c0,0,0,251.041,0,252.438c2.32,85.585,73.577,153.084,159.159,150.766c5.537-0.151,11.064-0.597,16.554-1.336c6.979-0.931,11.944-7.261,11.183-14.263'
          }),
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M1231.859,746.791c-43.899,0-50.331-15.603-50.331-74.659c0,0,0-0.39,0-0.559V530.031c0.029-7.382-5.93-13.391-13.311-13.421c-0.036,0-0.073,0-0.111,0h-51.675c-7.386,0.089-13.357,6.037-13.477,13.421v6.711c-74.471-42.236-169.083-16.104-211.319,58.37c-42.234,74.469-16.104,169.079,58.368,211.316c56.77,32.194,127.62,25.393,177.221-17.025c14.597,22.372,37.974,36.909,74.489,37.19c6.267,0,39.148,1.119,39.148-14.37v-55.086c0.233-5.266-3.699-9.79-8.947-10.289 M1026.394,749.139c-42.803,0-77.51-34.703-77.51-77.51s34.707-77.509,77.51-77.509c42.808,0,77.511,34.702,77.511,77.509S1069.201,749.139,1026.394,749.139L1026.394,749.139'
          })
        );
      }

      return render;
    }()
  }]);

  return Okta;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 1250 1250'
}, _temp);
exports['default'] = Okta;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OracleSalesCloud = (_temp = _class = function (_SvgIcon) {
    _inherits(OracleSalesCloud, _SvgIcon);

    function OracleSalesCloud() {
        _classCallCheck(this, OracleSalesCloud);

        return _possibleConstructorReturn(this, (OracleSalesCloud.__proto__ || Object.getPrototypeOf(OracleSalesCloud)).apply(this, arguments));
    }

    _createClass(OracleSalesCloud, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement('path', {
                        d: 'M5.531,25.314c0.036,0.068,0.083,0.124,0.141,0.166s0.128,0.073,0.207,0.094s0.161,0.031,0.246,0.031c0.057,0,0.119-0.005,0.184-0.015s0.127-0.028,0.185-0.056c0.057-0.026,0.105-0.064,0.143-0.112s0.058-0.108,0.058-0.182c0-0.079-0.025-0.144-0.076-0.193c-0.05-0.049-0.117-0.09-0.198-0.122c-0.082-0.033-0.175-0.062-0.279-0.086c-0.104-0.025-0.208-0.052-0.315-0.082c-0.109-0.027-0.216-0.061-0.319-0.101c-0.104-0.039-0.197-0.091-0.279-0.153c-0.082-0.062-0.148-0.142-0.198-0.235c-0.051-0.095-0.076-0.208-0.076-0.342c0-0.15,0.032-0.281,0.096-0.392c0.064-0.11,0.148-0.202,0.251-0.276c0.104-0.074,0.221-0.128,0.353-0.164c0.131-0.035,0.262-0.053,0.393-0.053c0.153,0,0.299,0.017,0.44,0.051s0.266,0.09,0.375,0.166c0.109,0.076,0.196,0.174,0.26,0.293c0.064,0.119,0.096,0.263,0.096,0.432H6.595c-0.005-0.087-0.024-0.159-0.055-0.217c-0.031-0.057-0.073-0.102-0.125-0.135s-0.111-0.057-0.178-0.07c-0.067-0.014-0.14-0.02-0.219-0.02c-0.052,0-0.104,0.005-0.156,0.016c-0.052,0.012-0.099,0.03-0.141,0.058s-0.077,0.062-0.104,0.103s-0.041,0.093-0.041,0.155c0,0.058,0.011,0.104,0.033,0.14s0.065,0.068,0.129,0.098c0.064,0.03,0.153,0.061,0.267,0.091c0.113,0.029,0.261,0.067,0.444,0.114c0.055,0.011,0.13,0.03,0.228,0.06c0.097,0.028,0.193,0.074,0.289,0.137c0.096,0.063,0.178,0.146,0.248,0.252c0.07,0.105,0.104,0.239,0.104,0.403c0,0.134-0.026,0.258-0.078,0.373c-0.052,0.114-0.129,0.213-0.231,0.297c-0.103,0.083-0.229,0.147-0.381,0.194c-0.151,0.046-0.327,0.069-0.526,0.069c-0.161,0-0.317-0.02-0.469-0.06c-0.151-0.039-0.285-0.102-0.401-0.186c-0.116-0.085-0.208-0.193-0.276-0.324c-0.068-0.131-0.101-0.286-0.099-0.467h0.623C5.478,25.163,5.495,25.246,5.531,25.314z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M9.195,23.111l1.093,2.924H9.621L9.4,25.384H8.307l-0.229,0.651H7.431l1.105-2.924H9.195z M9.232,24.905l-0.369-1.073H8.855l-0.381,1.073H9.232z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M11.226,23.111v2.384h1.425v0.54h-2.068v-2.924H11.226z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M15.239,23.111v0.54h-1.544v0.627h1.417v0.5h-1.417v0.717h1.577v0.54h-2.219v-2.924H15.239z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M16.238,25.314c0.036,0.068,0.083,0.124,0.141,0.166s0.128,0.073,0.207,0.094s0.161,0.031,0.246,0.031c0.057,0,0.119-0.005,0.184-0.015s0.127-0.028,0.185-0.056c0.057-0.026,0.105-0.064,0.143-0.112s0.058-0.108,0.058-0.182c0-0.079-0.025-0.144-0.076-0.193c-0.05-0.049-0.117-0.09-0.198-0.122c-0.082-0.033-0.175-0.062-0.279-0.086c-0.104-0.025-0.208-0.052-0.315-0.082c-0.109-0.027-0.216-0.061-0.319-0.101c-0.104-0.039-0.197-0.091-0.279-0.153c-0.082-0.062-0.148-0.142-0.198-0.235c-0.051-0.095-0.076-0.208-0.076-0.342c0-0.15,0.032-0.281,0.096-0.392c0.064-0.11,0.148-0.202,0.251-0.276c0.104-0.074,0.221-0.128,0.353-0.164c0.131-0.035,0.262-0.053,0.393-0.053c0.153,0,0.299,0.017,0.44,0.051s0.266,0.09,0.375,0.166c0.109,0.076,0.196,0.174,0.26,0.293c0.064,0.119,0.096,0.263,0.096,0.432h-0.623c-0.005-0.087-0.024-0.159-0.055-0.217c-0.031-0.057-0.073-0.102-0.125-0.135s-0.111-0.057-0.178-0.07c-0.067-0.014-0.14-0.02-0.219-0.02c-0.052,0-0.104,0.005-0.156,0.016c-0.052,0.012-0.099,0.03-0.141,0.058s-0.077,0.062-0.104,0.103s-0.041,0.093-0.041,0.155c0,0.058,0.011,0.104,0.033,0.14s0.065,0.068,0.129,0.098c0.064,0.03,0.153,0.061,0.267,0.091c0.113,0.029,0.261,0.067,0.444,0.114c0.055,0.011,0.13,0.03,0.228,0.06c0.097,0.028,0.193,0.074,0.289,0.137c0.096,0.063,0.178,0.146,0.248,0.252c0.07,0.105,0.104,0.239,0.104,0.403c0,0.134-0.026,0.258-0.078,0.373c-0.052,0.114-0.129,0.213-0.231,0.297c-0.103,0.083-0.229,0.147-0.381,0.194c-0.151,0.046-0.327,0.069-0.526,0.069c-0.161,0-0.317-0.02-0.469-0.06c-0.151-0.039-0.285-0.102-0.401-0.186c-0.116-0.085-0.208-0.193-0.276-0.324c-0.068-0.131-0.101-0.286-0.099-0.467h0.623C16.185,25.163,16.203,25.246,16.238,25.314z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M21.5,23.892c-0.038-0.062-0.086-0.115-0.144-0.162c-0.058-0.046-0.122-0.082-0.194-0.108s-0.148-0.038-0.228-0.038c-0.145,0-0.268,0.027-0.369,0.084c-0.101,0.055-0.183,0.131-0.246,0.225c-0.062,0.094-0.108,0.201-0.137,0.321c-0.028,0.12-0.043,0.244-0.043,0.373c0,0.122,0.015,0.242,0.043,0.358c0.029,0.115,0.075,0.22,0.137,0.312c0.063,0.093,0.145,0.168,0.246,0.224c0.101,0.056,0.224,0.084,0.369,0.084c0.196,0,0.351-0.061,0.461-0.181s0.178-0.278,0.202-0.475h0.623c-0.017,0.183-0.059,0.348-0.127,0.495s-0.158,0.273-0.271,0.377s-0.243,0.183-0.394,0.237s-0.314,0.082-0.495,0.082c-0.224,0-0.425-0.039-0.604-0.116c-0.179-0.078-0.33-0.186-0.452-0.322c-0.123-0.136-0.217-0.297-0.283-0.48c-0.065-0.185-0.098-0.383-0.098-0.596c0-0.219,0.033-0.421,0.098-0.608s0.16-0.35,0.283-0.489c0.123-0.14,0.273-0.249,0.452-0.328s0.38-0.118,0.604-0.118c0.161,0,0.313,0.022,0.457,0.069c0.143,0.047,0.271,0.114,0.385,0.203s0.206,0.198,0.28,0.329c0.073,0.131,0.12,0.281,0.14,0.451h-0.623C21.562,24.021,21.538,23.953,21.5,23.892z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M23.343,23.111v2.384h1.425v0.54h-2.068v-2.924H23.343z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M25.14,23.978c0.065-0.188,0.159-0.35,0.282-0.489s0.273-0.249,0.453-0.328c0.179-0.079,0.38-0.118,0.604-0.118c0.227,0,0.429,0.039,0.606,0.118c0.177,0.079,0.327,0.188,0.45,0.328s0.217,0.302,0.282,0.489s0.099,0.39,0.099,0.608c0,0.213-0.033,0.411-0.099,0.596c-0.065,0.184-0.159,0.345-0.282,0.48c-0.123,0.137-0.273,0.244-0.45,0.322c-0.178,0.077-0.38,0.116-0.606,0.116c-0.224,0-0.425-0.039-0.604-0.116c-0.18-0.078-0.33-0.186-0.453-0.322c-0.123-0.136-0.217-0.297-0.282-0.48c-0.065-0.185-0.099-0.383-0.099-0.596C25.041,24.367,25.074,24.165,25.14,23.978z M25.728,24.944c0.028,0.115,0.074,0.22,0.137,0.312s0.145,0.168,0.246,0.224c0.101,0.056,0.224,0.084,0.368,0.084s0.268-0.028,0.368-0.084c0.102-0.056,0.184-0.131,0.246-0.224s0.108-0.197,0.137-0.312c0.029-0.116,0.044-0.236,0.044-0.358c0-0.129-0.015-0.253-0.044-0.373c-0.028-0.12-0.074-0.228-0.137-0.321s-0.145-0.17-0.246-0.225c-0.101-0.057-0.224-0.084-0.368-0.084s-0.268,0.027-0.368,0.084c-0.102,0.055-0.184,0.131-0.246,0.225s-0.108,0.201-0.137,0.321c-0.029,0.12-0.043,0.244-0.043,0.373C25.685,24.708,25.698,24.828,25.728,24.944z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M30.546,25.812c-0.222,0.193-0.527,0.289-0.918,0.289c-0.396,0-0.702-0.096-0.919-0.286c-0.217-0.191-0.325-0.486-0.325-0.885v-1.818h0.643v1.818c0,0.079,0.007,0.157,0.021,0.233s0.042,0.144,0.086,0.202c0.044,0.06,0.104,0.106,0.183,0.144c0.077,0.037,0.182,0.056,0.312,0.056c0.229,0,0.388-0.052,0.476-0.153c0.087-0.103,0.131-0.263,0.131-0.481v-1.818h0.643v1.818C30.877,25.325,30.767,25.619,30.546,25.812z'
                    }),
                    _react2['default'].createElement('path', {
                        d: 'M32.731,23.111c0.188,0,0.363,0.03,0.526,0.091c0.162,0.06,0.303,0.149,0.421,0.27c0.119,0.12,0.212,0.271,0.279,0.451c0.066,0.18,0.1,0.392,0.1,0.634c0,0.213-0.027,0.41-0.082,0.59c-0.055,0.181-0.137,0.336-0.247,0.467s-0.249,0.234-0.414,0.31s-0.359,0.112-0.583,0.112H31.47v-2.924H32.731z M32.687,25.495c0.093,0,0.183-0.016,0.27-0.046c0.088-0.029,0.165-0.079,0.233-0.149c0.068-0.069,0.123-0.16,0.164-0.271c0.041-0.112,0.062-0.249,0.062-0.41c0-0.147-0.015-0.28-0.043-0.399c-0.028-0.118-0.076-0.22-0.142-0.305s-0.152-0.149-0.26-0.194s-0.241-0.068-0.399-0.068h-0.458v1.844H32.687z'
                    }),
                    _react2['default'].createElement('path', {
                        fill: '#ED1C24',
                        d: 'M17.169,16.618h2.319l-1.225-1.974l-2.248,3.568l-1.025,0.001l2.737-4.285c0.116-0.174,0.317-0.279,0.535-0.279c0.215,0,0.413,0.102,0.529,0.271l2.746,4.292l-1.025-0.001l-0.481-0.798h-2.349L17.169,16.618L17.169,16.618z M27.806,17.415v-3.722h-0.869v4.085c0,0.113,0.046,0.221,0.127,0.302c0.085,0.084,0.197,0.131,0.318,0.131h3.962l0.511-0.797H27.806L27.806,17.415z M13.432,16.749c0.844,0,1.528-0.684,1.528-1.528c0-0.844-0.684-1.528-1.528-1.528H9.629v4.518h0.868V14.49h2.874c0.405,0,0.731,0.327,0.731,0.731c0,0.404-0.326,0.732-0.731,0.732l-2.449-0.001l2.593,2.26h1.262l-1.745-1.464L13.432,16.749L13.432,16.749z M4.282,18.212c-1.247,0-2.259-1.011-2.259-2.259c0-1.248,1.012-2.259,2.259-2.259h2.626c1.248,0,2.259,1.011,2.259,2.259c0,1.248-1.011,2.26-2.259,2.26L4.282,18.212L4.282,18.212z M6.85,17.416c0.808,0,1.463-0.655,1.463-1.463c0-0.808-0.654-1.463-1.463-1.463l-2.509,0c-0.808,0-1.463,0.655-1.463,1.463c0,0.808,0.655,1.463,1.463,1.463H6.85L6.85,17.416z M23.35,18.212c-1.247,0-2.259-1.011-2.259-2.259c0-1.248,1.012-2.259,2.259-2.259h3.121l-0.511,0.797l-2.551,0c-0.808,0-1.463,0.655-1.463,1.463c0,0.808,0.655,1.463,1.463,1.463h3.133l-0.51,0.796H23.35L23.35,18.212z M33.978,17.416c-0.669,0-1.234-0.45-1.407-1.063h3.714l0.512-0.797l-4.227,0c0.173-0.615,0.738-1.066,1.408-1.066l2.549,0l0.512-0.797h-3.121c-1.247,0-2.259,1.011-2.259,2.259c0,1.248,1.012,2.259,2.259,2.259H36.6l0.511-0.796H33.978L33.978,17.416z'
                    }),
                    _react2['default'].createElement('path', {
                        fill: '#ED1C24',
                        d: 'M37.505,14.175c0-0.22,0.178-0.399,0.399-0.399c0.221,0,0.399,0.179,0.399,0.399c0,0.221-0.178,0.4-0.399,0.4C37.683,14.574,37.505,14.396,37.505,14.175L37.505,14.175z M37.904,14.684c0.28,0,0.508-0.227,0.508-0.508c0-0.281-0.228-0.508-0.508-0.508c-0.28,0-0.508,0.227-0.508,0.508C37.397,14.457,37.624,14.684,37.904,14.684L37.904,14.684z M37.856,13.875c0.079,0,0.11,0.001,0.149,0.015c0.1,0.034,0.11,0.126,0.11,0.16c0,0.007-0.001,0.026-0.006,0.047c-0.006,0.021-0.018,0.065-0.071,0.098c-0.006,0.004-0.009,0.007-0.026,0.013l0.132,0.237h-0.128l-0.116-0.217h-0.077v0.217h-0.112v-0.569H37.856L37.856,13.875z M37.896,14.132c0.034-0.001,0.072-0.003,0.095-0.036c0.009-0.014,0.013-0.029,0.013-0.049c0-0.031-0.016-0.056-0.043-0.069c-0.026-0.01-0.052-0.01-0.105-0.01h-0.031v0.163H37.896L37.896,14.132z'
                    })
                );
            }

            return render;
        }()
    }]);

    return OracleSalesCloud;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '0 0 40.17 40.04'
}, _temp);
exports['default'] = OracleSalesCloud;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Oracle = (_temp = _class = function (_SvgIcon) {
  _inherits(Oracle, _SvgIcon);

  function Oracle() {
    _classCallCheck(this, Oracle);

    return _possibleConstructorReturn(this, (Oracle.__proto__ || Object.getPrototypeOf(Oracle)).apply(this, arguments));
  }

  _createClass(Oracle, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('rect', { fill: '#ed1c24', x: '-2', y: '-1', width: '401.1', height: '399.9' }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M175.6,202h21.9l-11.6-18.7L164.6,217h-9.7l25.9-40.5a6.2,6.2,0,0,1,10.1,0l26,40.6h-9.7l-4.5-7.5H180.5l-4.9-7.6h0Zm100.5,7.6V174.4h-8.2V213a4,4,0,0,0,1.2,2.9,4.23,4.23,0,0,0,3,1.2h37.5l4.8-7.5H276.1Zm-135.9-6.3a14.4,14.4,0,0,0,0-28.8H104.3v42.7h8.2V182h27.2a6.9,6.9,0,0,1,0,13.8H116.6l24.5,21.4H153l-16.5-13.8,3.7-.1h0ZM53.7,217.1a21.4,21.4,0,1,1,0-42.8H78.5a21.4,21.4,0,1,1,0,42.8H53.7ZM78,209.6A13.8,13.8,0,1,0,78,182H54.3a13.8,13.8,0,0,0,0,27.6H78Zm156,7.5a21.4,21.4,0,0,1,0-42.8h29.5l-4.8,7.5H234.6a13.8,13.8,0,0,0,0,27.6h29.6l-4.8,7.5H234v0.2Zm100.5-7.5a13.89,13.89,0,0,1-13.3-10h35.1l4.8-7.5h-40A13.86,13.86,0,0,1,334.4,182h24.1l4.8-7.5H333.8a21.4,21.4,0,1,0,0,42.8h25.3l4.8-7.5H334.5v-0.2Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M367.8,178.9a3.8,3.8,0,1,1,3.8,3.8,3.8,3.8,0,0,1-3.8-3.8h0Zm3.8,4.9a4.74,4.74,0,0,0,4.8-4.8,4.8,4.8,0,1,0-4.8,4.8h0Zm-0.5-7.7a5.31,5.31,0,0,1,1.4.1,1.54,1.54,0,0,1,1,1.5,0.76,0.76,0,0,1-.1.4,1.68,1.68,0,0,1-.7.9c-0.1,0-.1.1-0.2,0.1l1.2,2.2h-1.2l-1.1-2.1h-0.7v2.1h-1.1v-5.4h1.5v0.2Zm0.4,2.4a1,1,0,0,0,.9-0.3,0.75,0.75,0,0,0,.1-0.5,1,1,0,0,0-.4-0.7,2.51,2.51,0,0,0-1-.1h-0.3v1.5h0.7v0.1Z'
          })
        );
      }

      return render;
    }()
  }]);

  return Oracle;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Oracle;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Outlook = (_temp = _class = function (_SvgIcon) {
  _inherits(Outlook, _SvgIcon);

  function Outlook() {
    _classCallCheck(this, Outlook);

    return _possibleConstructorReturn(this, (Outlook.__proto__ || Object.getPrototypeOf(Outlook)).apply(this, arguments));
  }

  _createClass(Outlook, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('rect', {
            fill: '#3765af',
            x: '-0.11',
            y: '-0.39',
            width: '400.11',
            height: '400.39'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M267.76,207.4a7,7,0,0,1-4.73,1.48,7.26,7.26,0,0,1-4.43-1.48L240,192.92v82.44H340.75a9.84,9.84,0,0,0,9.75-9.75V141.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M225.21,185.83h0V174.3h0v-52.6h0V64.38L66.53,92.75v208l158.68,27.48V272.11h0V185.83Zm-48.76,21a88.81,88.81,0,0,1-2.07,9.46,34.93,34.93,0,0,1-3.55,8.27,42.28,42.28,0,0,1-4.73,7.09,33.63,33.63,0,0,1-5.61,5.61,29,29,0,0,1-6.5,3.84,32.16,32.16,0,0,1-7.09,2.07,32.83,32.83,0,0,1-7.68.3,55.15,55.15,0,0,1-7.39-1.18,25.08,25.08,0,0,1-6.5-2.66,39.31,39.31,0,0,1-5.61-4.14,45.42,45.42,0,0,1-5-5.61,52,52,0,0,1-4.14-6.8,59.2,59.2,0,0,1-3-7.68,40.08,40.08,0,0,1-1.77-8.57c-0.3-3-.59-6.21-0.59-9.46s0.3-6.5.59-9.75a47.12,47.12,0,0,1,1.77-8.86c0.89-2.66,1.77-5.32,3-8,1.18-2.36,2.36-4.73,3.84-7.09a33.08,33.08,0,0,1,5-5.91,31.78,31.78,0,0,1,12.71-7.39,32.36,32.36,0,0,1,8-1.18,30.34,30.34,0,0,1,7.39.3,25.94,25.94,0,0,1,6.8,2.07,33.25,33.25,0,0,1,6.21,3.55,31.64,31.64,0,0,1,5.61,5.32,28.77,28.77,0,0,1,4.43,7.09,64.29,64.29,0,0,1,3.25,8,75.22,75.22,0,0,1,2.07,9.46c0.3,3.25.59,6.8,0.59,10.34A30,30,0,0,1,176.45,206.81Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M240,177.56l23.34,18,87.17-69.15a9.82,9.82,0,0,0-9.46-8.57H240v59.69Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M157.25,184.35a35.73,35.73,0,0,0-1.48-5.32,32.29,32.29,0,0,0-2.36-4.43,31.4,31.4,0,0,0-2.66-3.25,13.12,13.12,0,0,0-3.25-2.36,16.66,16.66,0,0,0-3.55-1.18,16.85,16.85,0,0,0-3.84-.3,17.44,17.44,0,0,0-4.14.59,10,10,0,0,0-3.55,1.77c-1.18.59-2.07,1.77-3.25,2.66a43.23,43.23,0,0,0-2.66,3.84,20.37,20.37,0,0,0-2.07,4.43,29,29,0,0,0-1.48,4.73l-0.89,5.32a37.68,37.68,0,0,0-.3,5.91,45.75,45.75,0,0,0,.3,6.5c0.3,2.07.59,3.84,0.89,5.61a25,25,0,0,0,1.48,5,32.29,32.29,0,0,0,2.36,4.43,31.4,31.4,0,0,0,2.66,3.25,20.7,20.7,0,0,0,3,2.36,15.84,15.84,0,0,0,3.25,1.48,15,15,0,0,0,3.84.59,15.61,15.61,0,0,0,3.84-.3,16.66,16.66,0,0,0,3.55-1.18,19.88,19.88,0,0,0,3.25-2.07,15.68,15.68,0,0,0,2.66-3.25,18.84,18.84,0,0,0,2.36-4.14c0.59-1.48,1.18-3.25,1.77-5a34.86,34.86,0,0,0,1.18-5.91,50.09,50.09,0,0,0,.3-6.8,50.09,50.09,0,0,0-.3-6.8A19.65,19.65,0,0,0,157.25,184.35Z'
          })
        );
      }

      return render;
    }()
  }]);

  return Outlook;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Outlook;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Paylocity = (_temp = _class = function (_SvgIcon) {
  _inherits(Paylocity, _SvgIcon);

  function Paylocity() {
    _classCallCheck(this, Paylocity);

    return _possibleConstructorReturn(this, (Paylocity.__proto__ || Object.getPrototypeOf(Paylocity)).apply(this, arguments));
  }

  _createClass(Paylocity, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'Paylocity-icon', transform: 'translate(3.000000, 17.000000)' },
            _react2['default'].createElement('path', {
              d: 'M23.5931,8.9787 C23.7591,8.9787 23.8401,8.7847 23.7191,8.6747 C21.5041,6.6697 14.5031,0.7547 9.0041,0.7547 C2.8891,0.7547 0.7041,5.6487 0.0071,8.0027 C-0.0259,8.1157 0.0621,8.2267 0.1841,8.2267 C0.2631,8.2267 0.3321,8.1777 0.3581,8.1067 C0.6911,7.1517 2.7391,3.0397 7.8601,2.6157 C13.7461,2.1277 21.2741,7.5277 23.3241,8.9457 C23.3561,8.9667 23.3931,8.9787 23.4311,8.9787 L23.5931,8.9787',
              id: 'Fill-1',
              fill: '#F47216'
            }),
            _react2['default'].createElement('path', {
              d: 'M34.306,20.6752 C34.147,20.6752 34.069,20.8772 34.185,20.9912 C36.315,23.0802 43.049,29.2452 48.339,29.2452 C54.222,29.2452 56.582,24.1452 57.252,21.6912 C57.285,21.5742 57.2,21.4582 57.082,21.4582 C57.007,21.4582 56.94,21.5092 56.915,21.5832 C56.595,22.5782 54.365,26.8642 49.44,27.3062 C43.778,27.8142 36.536,22.1872 34.564,20.7092 C34.534,20.6872 34.498,20.6752 34.461,20.6752 L34.306,20.6752',
              id: 'Fill-4',
              fill: '#DD1731'
            }),
            _react2['default'].createElement('path', {
              d: 'M1.0159,22.7172 L3.2619,11.9692 L4.4849,11.9692 L4.2569,13.0522 C4.7109,12.5782 5.1179,12.2502 5.4759,12.0682 C5.8339,11.8852 6.2129,11.7932 6.6139,11.7932 C7.3549,11.7932 7.9689,12.0632 8.4569,12.6022 C8.9449,13.1412 9.1889,13.9122 9.1889,14.9172 C9.1889,15.7272 9.0539,16.4652 8.7869,17.1312 C8.5179,17.7962 8.1889,18.3322 7.7979,18.7372 C7.4089,19.1422 7.0129,19.4392 6.6139,19.6292 C6.2129,19.8202 5.8039,19.9142 5.3839,19.9142 C4.4529,19.9142 3.7309,19.4422 3.2179,18.4952 L2.3399,22.7172 L1.0159,22.7172 M3.6349,16.5642 C3.6349,17.1442 3.6769,17.5462 3.7599,17.7712 C3.8819,18.0882 4.0809,18.3442 4.3599,18.5392 C4.6379,18.7352 4.9589,18.8312 5.3259,18.8312 C6.0859,18.8312 6.7019,18.4042 7.1689,17.5482 C7.6379,16.6922 7.8709,15.8182 7.8709,14.9252 C7.8709,14.2662 7.7139,13.7582 7.3999,13.4002 C7.0849,13.0412 6.6939,12.8622 6.2259,12.8622 C5.8889,12.8622 5.5769,12.9502 5.2889,13.1282 C5.0009,13.3072 4.7339,13.5722 4.4879,13.9262 C4.2419,14.2792 4.0369,14.7122 3.8769,15.2252 C3.7159,15.7372 3.6349,16.1832 3.6349,16.5642',
              id: 'Fill-6',
              fill: '#231F20'
            }),
            _react2['default'].createElement('path', {
              d: 'M16.3929,15.3139 L15.5279,19.7349 L14.2539,19.7349 L14.4759,18.5859 C14.1439,19.0199 13.7519,19.3539 13.2999,19.5859 C12.8479,19.8189 12.3689,19.9359 11.8609,19.9359 C11.1549,19.9359 10.5909,19.7429 10.1689,19.3579 C9.7469,18.9729 9.5369,18.4619 9.5369,17.8259 C9.5369,16.9209 9.8919,16.1989 10.6049,15.6569 C11.3179,15.1149 12.2829,14.8429 13.4999,14.8429 L15.2029,14.8429 L15.2859,14.4209 C15.2949,14.3799 15.3019,14.3359 15.3059,14.2909 C15.3109,14.2439 15.3129,14.1789 15.3129,14.0959 C15.3129,13.7049 15.1679,13.4039 14.8769,13.1939 C14.5869,12.9839 14.1709,12.8779 13.6319,12.8779 C13.2359,12.8779 12.8079,12.9369 12.3489,13.0549 C11.8899,13.1719 11.4049,13.3489 10.8919,13.5849 L11.1339,12.3389 C11.6319,12.1599 12.1049,12.0239 12.5529,11.9339 C12.9999,11.8439 13.4289,11.7989 13.8389,11.7989 C14.6979,11.7989 15.3659,11.9889 15.8419,12.3669 C16.3199,12.7449 16.5589,13.2689 16.5589,13.9369 C16.5589,14.0849 16.5449,14.2789 16.5169,14.5179 C16.4899,14.7579 16.4479,15.0239 16.3929,15.3139 L16.3929,15.3139 Z M13.8259,15.8399 C13.2769,15.8399 12.8689,15.8569 12.6009,15.8919 C12.3329,15.9259 12.1009,15.9849 11.9029,16.0679 C11.5879,16.1929 11.3369,16.3969 11.1479,16.6799 C10.9589,16.9639 10.8649,17.2749 10.8649,17.6109 C10.8649,17.9939 10.9829,18.2989 11.2209,18.5279 C11.4579,18.7559 11.7799,18.8709 12.1859,18.8709 C12.8689,18.8709 13.4579,18.6259 13.9539,18.1369 C14.4499,17.6479 14.7859,16.9769 14.9599,16.1239 L15.0159,15.8399 L13.8259,15.8399 Z',
              id: 'Fill-8',
              fill: '#231F20'
            }),
            _react2['default'].createElement('path', {
              d: 'M16.1595,22.7387 L16.2405,21.4947 C16.5135,21.5727 16.7795,21.6117 17.0375,21.6117 C17.3055,21.6117 17.5225,21.5517 17.6885,21.4287 C17.9035,21.2677 18.1385,20.9657 18.3915,20.5217 L18.8155,19.7607 L17.5205,11.9687 L18.8225,11.9687 L19.4085,15.8977 C19.5255,16.6737 19.6255,17.4487 19.7085,18.2237 L23.1835,11.9687 L24.5665,11.9687 L19.6135,20.7707 C19.1355,21.6297 18.7105,22.1977 18.3405,22.4747 C17.9695,22.7537 17.5425,22.8917 17.0595,22.8917 C16.7525,22.8917 16.4525,22.8417 16.1595,22.7387',
              id: 'Fill-10',
              fill: '#231F20'
            }),
            _react2['default'].createElement('polygon', {
              id: 'Fill-12',
              fill: '#231F20',
              points: '23.762 19.7387 26.212 8.0037 27.536 8.0037 25.086 19.7387'
            }),
            _react2['default'].createElement('path', {
              d: 'M34.5745,15.0473 C34.5745,17.4333 32.8775,19.9153 30.2835,19.9153 C28.3455,19.9153 27.2565,18.4743 27.2565,16.7293 C27.2565,14.1823 29.0345,11.8133 31.5485,11.8133 C33.6455,11.8133 34.5745,13.3983 34.5745,15.0473 M28.6345,16.6803 C28.6345,17.9453 29.3225,18.8593 30.4595,18.8593 C32.0285,18.8593 33.2135,16.8403 33.2135,15.0313 C33.2135,14.1343 32.7975,12.8693 31.4035,12.8693 C29.7385,12.8693 28.6175,14.9023 28.6345,16.6803',
              id: 'Fill-14',
              fill: '#231F20'
            }),
            _react2['default'].createElement('path', {
              d: 'M40.9241,19.3832 C40.5881,19.5632 40.2281,19.6992 39.8441,19.7942 C39.4591,19.8882 39.0611,19.9362 38.6471,19.9362 C37.6161,19.9362 36.8361,19.6772 36.3081,19.1592 C35.7781,18.6422 35.5141,17.8772 35.5141,16.8642 C35.5141,16.1802 35.6371,15.5072 35.8831,14.8472 C36.1291,14.1872 36.4611,13.6312 36.8801,13.1802 C37.3081,12.7252 37.7781,12.3842 38.2911,12.1592 C38.8041,11.9342 39.3661,11.8212 39.9791,11.8212 C40.3881,11.8212 40.7831,11.8702 41.1651,11.9692 C41.5471,12.0692 41.9191,12.2162 42.2831,12.4142 L42.0281,13.6702 C41.7241,13.4042 41.4111,13.2082 41.0891,13.0832 C40.7681,12.9592 40.4101,12.8982 40.0201,12.8982 C39.5141,12.8982 39.0661,12.9992 38.6741,13.2042 C38.2831,13.4092 37.9491,13.7162 37.6741,14.1252 C37.4161,14.5032 37.2151,14.9342 37.0701,15.4192 C36.9251,15.9042 36.8531,16.3872 36.8531,16.8642 C36.8531,17.5282 37.0101,18.0262 37.3251,18.3592 C37.6401,18.6932 38.1111,18.8602 38.7361,18.8602 C39.1781,18.8602 39.6031,18.7882 40.0091,18.6452 C40.4161,18.5032 40.8111,18.2862 41.1931,17.9962 L40.9241,19.3842',
              id: 'Fill-16',
              fill: '#231F20'
            }),
            _react2['default'].createElement('path', {
              d: 'M42.2699,19.7387 L43.8939,11.9687 L45.2179,11.9687 L43.5939,19.7387 L42.2699,19.7387 L42.2699,19.7387 Z M44.2019,10.5127 L44.5159,9.0127 L45.8329,9.0127 L45.5179,10.5127 L44.2019,10.5127 Z',
              id: 'Fill-18',
              fill: '#231F20'
            }),
            _react2['default'].createElement('path', {
              d: 'M56.2786,11.9691 L52.8036,18.2251 C52.7206,17.4481 52.6206,16.6731 52.5036,15.8981 L51.9186,11.9691 L48.7096,11.9691 L49.3006,9.1451 L47.7876,10.0601 L47.3846,11.9691 L46.3386,11.9691 L46.1266,12.9931 L47.1726,12.9931 L46.2286,17.5071 C46.1016,18.1221 46.0386,18.5151 46.0386,18.6861 C46.0386,19.0221 46.1556,19.2871 46.3896,19.4831 C46.7016,19.7411 47.1216,19.8701 47.6476,19.8701 C47.9456,19.8701 48.2526,19.8291 48.5696,19.7461 L48.7896,18.6631 C48.5596,18.7221 48.2996,18.7511 48.0066,18.7511 C47.8016,18.7511 47.6536,18.7101 47.5636,18.6271 C47.4736,18.5441 47.4276,18.4241 47.4276,18.2691 C47.4276,18.1611 47.4846,17.8341 47.5966,17.2881 L48.4966,12.9931 L50.7866,12.9931 L51.9116,19.7611 L51.4866,20.5221 C51.2326,20.9651 50.9986,21.2681 50.7846,21.4291 C50.6186,21.5511 50.4016,21.6121 50.1326,21.6121 C49.8746,21.6121 49.6086,21.5731 49.3356,21.4941 L49.2556,22.7391 C49.5486,22.8411 49.8476,22.8921 50.1556,22.8921 C50.6376,22.8921 51.0646,22.7531 51.4356,22.4751 C51.8056,22.1981 52.2306,21.6291 52.7086,20.7711 L57.6616,11.9691 L56.2786,11.9691',
              id: 'Fill-20',
              fill: '#231F20'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return Paylocity;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Paylocity;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pdf = function (_SvgIcon) {
  _inherits(Pdf, _SvgIcon);

  function Pdf() {
    _classCallCheck(this, Pdf);

    return _possibleConstructorReturn(this, (Pdf.__proto__ || Object.getPrototypeOf(Pdf)).apply(this, arguments));
  }

  _createClass(Pdf, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0,0H24V24H0V0Z', fill: 'none' }),
          _react2['default'].createElement('path', {
            d: 'M8.58,12.49A0.77,0.77,0,0,1,7.9,12a1,1,0,0,1,.33-1.31,4.76,4.76,0,0,1,2.14-1.26c0.18-.36.37-0.76,0.57-1.21s0.4-.91.54-1.26a3.78,3.78,0,0,1-.63-2.26,0.92,0.92,0,0,1,.8-1h0a1,1,0,0,1,.83,1.22,5,5,0,0,1-.45,2,12.86,12.86,0,0,0,1.14,1.41l0.47,0.5a4.24,4.24,0,0,1,2.42.4,0.87,0.87,0,0,1,.39,1.07,1,1,0,0,1-1.26.45,3.69,3.69,0,0,1-1.79-1.36,12.73,12.73,0,0,0-1.53.21,11.82,11.82,0,0,0-1.19.29,6.24,6.24,0,0,1-1.8,2.48A0.94,0.94,0,0,1,8.58,12.49Zm1.55-2.1a3.82,3.82,0,0,0-1.37.91c-0.4.4-.26,0.63-0.26,0.63l0,0h0a0.23,0.23,0,0,0,.31.12l0,0A4.51,4.51,0,0,0,10.13,10.38Zm4.08-1a2.48,2.48,0,0,0,1.18.86c0.46,0.12.57-.08,0.59-0.13a0.32,0.32,0,0,0-.16-0.41,3.24,3.24,0,0,0-1.61-.35v0ZM11.85,7.55c-0.12.28-.25,0.59-0.41,0.94l-0.36.77c0.23-.06.49-0.12,0.76-0.17C12.27,9,12.65,9,13,8.91l-0.18-.19A15,15,0,0,1,11.85,7.55ZM11.69,4.27c-0.08,0-.28.08-0.28,0.5a3,3,0,0,0,.33,1.57A3.55,3.55,0,0,0,12,5,0.63,0.63,0,0,0,11.69,4.27Z',
            fill: '#231f20',
            stroke: '#231f20',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '0.15'
          }),
          _react2['default'].createElement('path', {
            d: 'M17.46,5.34a0.76,0.76,0,0,1-.76-0.76h0v-3H4.76V21.8h15V20.12H8.11a0.74,0.74,0,0,1-.74-0.74v-5a0.74,0.74,0,0,1,.74-0.74h11.6v-6L19.67,5.34H17.46Z',
            fill: 'none'
          }),
          _react2['default'].createElement('path', { d: 'M12,16.22a0.41,0.41,0,0,0-.35-0.46H11.49v0.89A0.4,0.4,0,0,0,12,16.22Z' }),
          _react2['default'].createElement('path', { d: 'M21.3,13.65H21.24V4.93L19.61,2.71,18.75,1.56,17.62,0H4A0.76,0.76,0,0,0,3.2.76V22.57a0.76,0.76,0,0,0,.76.76H20.48a0.76,0.76,0,0,0,.76-0.76V20.12H21.3A0.74,0.74,0,0,0,22,19.38v-5A0.74,0.74,0,0,0,21.3,13.65Zm-1.59,0H8.11a0.74,0.74,0,0,0-.74.74h0v5a0.74,0.74,0,0,0,.74.74h11.6v1.69h-15V1.56H16.7v3a0.76,0.76,0,0,0,.76.75h2.2l0.06,2.33v6h0Zm-0.57,2.74v0.92H18.4v1.47h-1V14.92h1.84v0.91H18.4v0.55h0.74Zm-2.67.45c0,1.78-1.12,1.94-1.75,1.94H13.81V14.92h0.86A1.71,1.71,0,0,1,16.47,16.84ZM13,16.21a1.2,1.2,0,0,1-1.52,1.26v1.26h-1V14.92H11.4c0.91,0,1.61.3,1.61,1.31v0Z' }),
          _react2['default'].createElement('path', { d: 'M15.41,16.89c0-.42-0.08-1-0.55-1v2A0.83,0.83,0,0,0,15.41,16.89Z' })
        );
      }

      return render;
    }()
  }]);

  return Pdf;
}(_SvgIcon3['default']);

exports['default'] = Pdf;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pipedrive = (_temp = _class = function (_SvgIcon) {
  _inherits(Pipedrive, _SvgIcon);

  function Pipedrive() {
    _classCallCheck(this, Pipedrive);

    return _possibleConstructorReturn(this, (Pipedrive.__proto__ || Object.getPrototypeOf(Pipedrive)).apply(this, arguments));
  }

  _createClass(Pipedrive, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('polygon', {
            fill: '#3d4145',
            points: '0 0 401.01 0 401.01 400.99 0 400.99 0 0'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M229.83,47.78c-33.52,0-52.87,15.73-62.24,26.12-1.1-8.94-7-19.85-30-19.85H81.45v50.13h26.6c3.47,0,4.73,1.91,4.73,5.38v239h62.66v-96.4c9.28,8.56,24.6,20.33,52.36,20.33,58.28,0,96.33-46.19,96.33-112.34,0-67.2-36.78-112.35-94.3-112.35h0Zm-11.32,52.74c28.15,0,47.06,24.28,47.06,60.42,0,41.18-24,59.6-47.87,59.6-32.05,0-46.66-30.68-46.66-59.2,0-44.84,24.52-60.82,47.47-60.82h0Z'
          })
        );
      }

      return render;
    }()
  }]);

  return Pipedrive;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Pipedrive;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PowerBI = (_temp = _class = function (_SvgIcon) {
  _inherits(PowerBI, _SvgIcon);

  function PowerBI() {
    _classCallCheck(this, PowerBI);

    return _possibleConstructorReturn(this, (PowerBI.__proto__ || Object.getPrototypeOf(PowerBI)).apply(this, arguments));
  }

  _createClass(PowerBI, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { 'class': 'st0', d: 'M8,55.9h47.9V8.1H8V55.9z', fill: '#ECC746' }),
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', { d: 'M45.4,42.7c2.9,0.4,5.1-1.3,5.1-4.1c0.1-5.4,0-10.8,0-16.3c0-2.5-1.8-4.2-4.3-4.2c-3.1,0-6.2,0-9.4,0c-6.2,0-12.4,0-18.6,0c-2.4,0-4.1,2.1-4.1,4.1c0.1,5.6,0,11.1,0,16.7c0,2.5,2.6,4.4,5,3.7c0-0.5,0-1,0-1.6c-0.4,0-0.7,0-1,0c-1.4-0.1-2.4-1-2.4-2.4c0-5.4,0-10.9,0-16.3c0-1.4,1.1-2.3,2.4-2.3c9.4,0,18.8,0,28.2,0c1.4,0,2.5,1,2.5,2.4c0,5.4,0,10.8,0,16.2c0,1.5-1,2.4-2.5,2.5c-0.3,0-0.6,0-0.9,0C45.4,41.6,45.4,42.1,45.4,42.7z M44,36C44,36,44,36,44,36c0-3,0-5.9,0-8.9c0-1.4-0.7-2.1-2.2-2.1c-1.4,0-2,0.6-2,2.1c0,2.3,0,4.5,0,6.8c0,3.6,0,7.3,0,10.9c0,0.7,0.2,1.4,0.9,1.7c1.7,0.9,3.4-0.1,3.4-2C44,41.8,44,38.9,44,36zM31.3,38.5c0-2.1,0-4.2,0-6.3c0-0.8-0.3-1.6-1.1-1.8c-0.9-0.3-1.9-0.4-2.5,0.3c-0.4,0.4-0.6,1.2-0.6,1.8c-0.1,4,0,8,0,12.1c0,0.3,0.1,0.5,0.1,0.8c0.1,0.8,0.5,1.2,1.2,1.4c1.7,0.5,3-0.4,3-2.2C31.3,42.6,31.3,40.6,31.3,38.5z M33.4,40.1c0,1.6,0,3.3,0,4.9c0,1.2,0.7,1.9,1.9,1.9c1.5,0,2.3-0.6,2.3-1.8c0-3.3,0-6.6,0-9.9c0-1.3-0.8-1.8-2.4-1.8c-1.2,0-1.7,0.7-1.7,1.9C33.4,36.8,33.4,38.4,33.4,40.1z M25,42.2C25,42.2,25,42.2,25,42.2c0-0.9,0-1.8,0-2.7c0-1.3-0.7-1.9-2-1.9c-1.4,0-2.2,0.6-2.2,1.9c0,1.8,0,3.7,0,5.5c0,1.2,0.8,1.9,2.2,1.9c1.3,0,2-0.6,2-1.8C25,44.1,25,43.2,25,42.2z' }),
            _react2['default'].createElement('path', { d: 'M45.4,42.7c0-0.5,0-1.1,0-1.6c0.3,0,0.6,0,0.9,0c1.5-0.1,2.5-1,2.5-2.5c0-5.4,0-10.8,0-16.2c0-1.4-1-2.4-2.5-2.4c-9.4,0-18.8,0-28.2,0c-1.4,0-2.4,1-2.4,2.3c0,5.4,0,10.9,0,16.3c0,1.4,1,2.3,2.4,2.4c0.3,0,0.6,0,1,0c0,0.6,0,1.1,0,1.6c-2.4,0.7-5-1.2-5-3.7c0-5.6,0-11.1,0-16.7c0-2,1.7-4.1,4.1-4.1c6.2,0,12.4,0,18.6,0c3.1,0,6.2,0,9.4,0c2.5,0,4.3,1.6,4.3,4.2c0,5.4,0.1,10.8,0,16.3C50.5,41.4,48.4,43.1,45.4,42.7z' }),
            _react2['default'].createElement('path', { d: 'M44,36c0,2.9,0,5.7,0,8.6c0,1.9-1.7,2.9-3.4,2c-0.7-0.4-0.9-1-0.9-1.7c0-3.6,0-7.3,0-10.9c0-2.3,0-4.5,0-6.8c0-1.4,0.6-2.1,2-2.1c1.5,0,2.2,0.6,2.2,2.1C44,30.1,44,33.1,44,36C44,36,44,36,44,36z' }),
            _react2['default'].createElement('path', { d: 'M31.3,38.5c0,2,0,4,0,6.1c0,1.8-1.3,2.7-3,2.2c-0.7-0.2-1.1-0.6-1.2-1.4c0-0.3-0.1-0.5-0.1-0.8c0-4,0-8,0-12.1c0-0.6,0.2-1.4,0.6-1.8c0.7-0.7,1.7-0.6,2.5-0.3c0.8,0.3,1.1,1,1.1,1.8C31.3,34.3,31.3,36.4,31.3,38.5z' }),
            _react2['default'].createElement('path', { d: 'M33.4,40.1c0-1.6,0-3.2,0-4.8c0-1.2,0.6-1.9,1.7-1.9c1.7,0,2.4,0.5,2.4,1.8c0,3.3,0,6.6,0,9.9c0,1.2-0.9,1.8-2.3,1.8c-1.2,0-1.9-0.7-1.9-1.9C33.4,43.3,33.4,41.7,33.4,40.1z' }),
            _react2['default'].createElement('path', { d: 'M25,42.2c0,0.9,0,1.9,0,2.8c0,1.2-0.7,1.8-2,1.8c-1.4,0-2.2-0.6-2.2-1.9c0-1.8,0-3.7,0-5.5c0-1.2,0.8-1.9,2.2-1.9c1.3,0,2,0.6,2,1.9C25,40.4,25,41.3,25,42.2C25,42.2,25,42.2,25,42.2z' })
          )
        );
      }

      return render;
    }()
  }]);

  return PowerBI;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = PowerBI;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PowerPoint = (_temp = _class = function (_SvgIcon) {
  _inherits(PowerPoint, _SvgIcon);

  function PowerPoint() {
    _classCallCheck(this, PowerPoint);

    return _possibleConstructorReturn(this, (PowerPoint.__proto__ || Object.getPrototypeOf(PowerPoint)).apply(this, arguments));
  }

  _createClass(PowerPoint, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { fill: '#cb4a32', d: 'M0 0h40.02v40.04H0z' }),
          _react2['default'].createElement('path', {
            d: 'M22.36 14.21a3.78 3.78 0 0 1 2.93-1.39v3.95h3.84a3.9 3.9 0 0 1-3.84 3.95 3.78 3.78 0 0 1-2.93-1.39v3.11h8.75v1.12h-8.75v1.89h8.75v1.12h-8.75V29h11.23V9.81H22.36zm3.52-2a3.9 3.9 0 0 1 3.85 4h-3.85z',
            fill: 'none'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M13 16.8v2.74c.65.05 1.28.18 1.68-.51a2 2 0 0 0-.08-1.88 1.57 1.57 0 0 0-1.6-.35z'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M33.59 8.85H22.36v-3L6.12 8.73v22l16.24 2.9v-3.7h11.23a1 1 0 0 0 .93-1V9.81a1 1 0 0 0-.93-.96zM16.66 19.08a2.63 2.63 0 0 1-2 2.11 10.14 10.14 0 0 1-1.71.16v3.09h-1.63v-9.33h3.75a1.61 1.61 0 0 1 .94.53 3.51 3.51 0 0 1 .65 3.44zM33.59 29H22.36v-2.4h8.75v-1.15h-8.75v-1.89h8.75v-1.12h-8.75v-3.11a3.78 3.78 0 0 0 2.93 1.39 3.9 3.9 0 0 0 3.84-3.95h-3.84v-3.95a3.78 3.78 0 0 0-2.93 1.39v-4.4h11.23z'
          }),
          _react2['default'].createElement('path', { fill: '#fff', d: 'M25.88 12.26v4h3.85a3.9 3.9 0 0 0-3.85-4z' })
        );
      }

      return render;
    }()
  }]);

  return PowerPoint;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40.02 40.04'
}, _temp);
exports['default'] = PowerPoint;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pushbot = function (_SvgIcon) {
  _inherits(Pushbot, _SvgIcon);

  function Pushbot() {
    _classCallCheck(this, Pushbot);

    return _possibleConstructorReturn(this, (Pushbot.__proto__ || Object.getPrototypeOf(Pushbot)).apply(this, arguments));
  }

  _createClass(Pushbot, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M19.39,5.89l-2.9-.17.13.81L13.52,5.49l2.44.2-.13-.81Zm-5.9-3.65.72.39-1.65,1.8,2.73-1.8-.72-.4L16.47.06ZM7.31.06,9.23,2.25l-.72.4,2.73,1.8L9.58,2.64l.72-.39ZM4.14,5.89,7,5.72l-.13.81L10,5.49l-2.44.2.13-.81Zm17,9.63a3.59,3.59,0,1,1-3.59-3.59A3.59,3.59,0,0,1,21.19,15.52Zm-.91.05a3.07,3.07,0,0,0-3.07-3.07,3.51,3.51,0,0,0-1.94.53,3.3,3.3,0,0,0-.3.28,2.58,2.58,0,0,1,1-.18.63.63,0,1,0,1.13.26,2.59,2.59,0,0,1-1.12,4.92l-.35,0a4.12,4.12,0,0,0,1.64.36A3.07,3.07,0,0,0,20.28,15.58ZM9.93,15.49A3.59,3.59,0,1,1,6.34,11.9,3.59,3.59,0,0,1,9.93,15.49ZM8.31,12.67a4.67,4.67,0,0,0-1.45-.2,3.07,3.07,0,0,0,0,6.13,4.09,4.09,0,0,0,1.69-.38,2.59,2.59,0,1,1-.48-5.13h0a.63.63,0,1,0,1.11.42.62.62,0,0,0,0-.13A3.29,3.29,0,0,0,8.31,12.67ZM17.62,20a4.45,4.45,0,1,1,4.45-4.45A4.46,4.46,0,0,1,17.62,20Zm-11.29,0a4.45,4.45,0,1,1,4.45-4.45A4.46,4.46,0,0,1,6.33,19.94Zm17.44,1.83L22.24,9.56h0l-1.31-1.1h-8.1l-.44-1.9a.74.74,0,1,0-.86,0l-.44,1.9H3L1.73,9.56h0L.23,21.77l2.43,2.17H21.33Z' })
        );
      }

      return render;
    }()
  }]);

  return Pushbot;
}(_SvgIcon3['default']);

exports['default'] = Pushbot;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var S3 = (_temp = _class = function (_SvgIcon) {
  _inherits(S3, _SvgIcon);

  function S3() {
    _classCallCheck(this, S3);

    return _possibleConstructorReturn(this, (S3.__proto__ || Object.getPrototypeOf(S3)).apply(this, arguments));
  }

  _createClass(S3, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'text' },
            _react2['default'].createElement('path', {
              d: 'M19.326 28.367a5.753 5.753 0 0 0 .21 1.7 10.2 10.2 0 0 0 .611 1.375.83.83 0 0 1 .133.439.756.756 0 0 1-.362.572l-1.2.8a.917.917 0 0 1-.5.171.878.878 0 0 1-.573-.267 5.881 5.881 0 0 1-.687-.9c-.19-.324-.381-.687-.591-1.126a7.051 7.051 0 0 1-5.611 2.634 5.23 5.23 0 0 1-3.816-1.371 4.9 4.9 0 0 1-1.412-3.664 4.911 4.911 0 0 1 1.737-3.93 6.944 6.944 0 0 1 4.675-1.49 15.174 15.174 0 0 1 2.023.152c.706.1 1.432.248 2.2.42v-1.393a4.23 4.23 0 0 0-.9-3.054 4.4 4.4 0 0 0-3.111-.877 8.669 8.669 0 0 0-2.061.248 14.993 14.993 0 0 0-2.061.649 5.678 5.678 0 0 1-.668.248 1.178 1.178 0 0 1-.305.057c-.268 0-.4-.191-.4-.592v-.935a1.214 1.214 0 0 1 .133-.668 1.45 1.45 0 0 1 .535-.4 11.012 11.012 0 0 1 2.4-.858 11.54 11.54 0 0 1 2.978-.363c2.271 0 3.931.515 5 1.546a6.317 6.317 0 0 1 1.584 4.7v6.183zm-7.748 2.9a6.186 6.186 0 0 0 1.965-.344 4.255 4.255 0 0 0 1.813-1.223 3.014 3.014 0 0 0 .649-1.222 6.822 6.822 0 0 0 .191-1.66v-.8a15.735 15.735 0 0 0-1.756-.318 14.431 14.431 0 0 0-1.794-.114 4.4 4.4 0 0 0-2.843.763 2.66 2.66 0 0 0-.935 2.2 2.664 2.664 0 0 0 .706 2.023 2.647 2.647 0 0 0 2.004.696zM26.9 33.329a1.064 1.064 0 0 1-.725-.191 1.565 1.565 0 0 1-.4-.744l-4.483-14.752a3.322 3.322 0 0 1-.172-.764.419.419 0 0 1 .458-.477h1.87a1.053 1.053 0 0 1 .744.191 1.553 1.553 0 0 1 .382.744L27.78 29.97l2.978-12.634a1.33 1.33 0 0 1 .362-.744 1.309 1.309 0 0 1 .763-.191h1.527a1.148 1.148 0 0 1 .764.191 1.287 1.287 0 0 1 .362.744l3.016 12.787 3.3-12.787a1.631 1.631 0 0 1 .382-.744 1.242 1.242 0 0 1 .744-.191h1.775a.424.424 0 0 1 .477.477 1.892 1.892 0 0 1-.038.3 2.654 2.654 0 0 1-.134.478l-4.6 14.752a1.452 1.452 0 0 1-.4.744 1.216 1.216 0 0 1-.725.191h-1.64a1.148 1.148 0 0 1-.764-.191 1.354 1.354 0 0 1-.362-.763l-2.958-12.31-2.939 12.296a1.49 1.49 0 0 1-.363.763 1.181 1.181 0 0 1-.763.191zm24.524.515a12.63 12.63 0 0 1-2.939-.343 8.653 8.653 0 0 1-2.2-.764 1.366 1.366 0 0 1-.585-.537 1.338 1.338 0 0 1-.115-.534V30.7c0-.4.153-.591.439-.591a1.088 1.088 0 0 1 .344.057c.114.038.286.114.477.191a10.424 10.424 0 0 0 2.1.668 11.511 11.511 0 0 0 2.271.229A5.145 5.145 0 0 0 54 30.619a2.056 2.056 0 0 0 1-1.813 1.862 1.862 0 0 0-.515-1.336 4.786 4.786 0 0 0-1.928-.992l-2.767-.859a5.824 5.824 0 0 1-3.054-1.947 4.546 4.546 0 0 1-.954-2.767 4.248 4.248 0 0 1 .515-2.118 4.918 4.918 0 0 1 1.374-1.565 6.066 6.066 0 0 1 1.985-.993 8.322 8.322 0 0 1 2.4-.324 9.6 9.6 0 0 1 1.278.076c.439.057.84.134 1.241.21.382.1.744.191 1.088.3a4.174 4.174 0 0 1 .8.344 1.66 1.66 0 0 1 .573.477 1.034 1.034 0 0 1 .172.63v.9c0 .4-.153.611-.439.611a2 2 0 0 1-.726-.229 8.715 8.715 0 0 0-3.664-.745 4.921 4.921 0 0 0-2.538.535 1.841 1.841 0 0 0-.9 1.7 1.8 1.8 0 0 0 .573 1.355 5.691 5.691 0 0 0 2.1 1.05l2.71.859a5.8 5.8 0 0 1 2.958 1.832 4.314 4.314 0 0 1 .878 2.671 4.912 4.912 0 0 1-.5 2.214 5.137 5.137 0 0 1-1.394 1.68 6.14 6.14 0 0 1-2.118 1.068 9.051 9.051 0 0 1-2.722.401z',
              fill: '#252f3e'
            }),
            _react2['default'].createElement('path', {
              d: 'M55.033 43.119c-6.279 4.638-15.4 7.1-23.245 7.1A42.054 42.054 0 0 1 3.409 39.4c-.591-.535-.057-1.26.649-.84a57.23 57.23 0 0 0 28.4 7.538 56.67 56.67 0 0 0 21.661-4.427c1.048-.479 1.945.685.914 1.448z',
              fill: '#f90',
              fillRule: 'evenodd'
            }),
            _react2['default'].createElement('path', {
              d: 'M57.648 40.142c-.8-1.03-5.306-.5-7.348-.248-.611.076-.706-.458-.153-.859 3.588-2.519 9.485-1.794 10.172-.954.687.859-.19 6.756-3.549 9.58-.516.439-1.012.21-.783-.362.764-1.89 2.462-6.145 1.661-7.157z',
              fill: '#f90',
              fillRule: 'evenodd'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return S3;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = S3;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Salesforce = (_temp = _class = function (_SvgIcon) {
  _inherits(Salesforce, _SvgIcon);

  function Salesforce() {
    _classCallCheck(this, Salesforce);

    return _possibleConstructorReturn(this, (Salesforce.__proto__ || Object.getPrototypeOf(Salesforce)).apply(this, arguments));
  }

  _createClass(Salesforce, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', {
              fill: '#00a1e0',
              d: 'M169.4,99.1a64,64,0,0,1,46.3-19.9c24.1,0,45.1,13.4,56.3,33.4a78.48,78.48,0,0,1,31.8-6.8c43.5,0,78.7,35.5,78.7,79.4s-35.2,79.4-78.7,79.4a79.1,79.1,0,0,1-15.5-1.5,57.51,57.51,0,0,1-75.4,23.7,65.61,65.61,0,0,1-122-3,57,57,0,0,1-12.5,1.3c-33.6,0-60.9-27.6-60.9-61.6A61.6,61.6,0,0,1,48,170.2,70.87,70.87,0,0,1,169.4,99.1'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M70.4,203.7a0.57,0.57,0,0,0,.2.8,23.93,23.93,0,0,0,2.1,1.3,21.86,21.86,0,0,0,10.9,2.6c7.5,0,12.1-4,12.1-10.4v-0.1c0-5.9-5.2-8.1-10.2-9.6l-0.6-.2c-3.7-1.2-6.9-2.2-6.9-4.7v-0.1c0-2.1,1.9-3.6,4.8-3.6a22.22,22.22,0,0,1,9.5,2.4,0.64,0.64,0,0,0,1-.2c0.1-.4,1.4-3.7,1.5-4.1a0.63,0.63,0,0,0-.4-0.8,21.28,21.28,0,0,0-10.7-2.9H83c-6.9,0-11.6,4.1-11.6,10.1v0.1c0,6.3,5.3,8.3,10.2,9.7l0.8,0.2c3.6,1.1,6.7,2.1,6.7,4.6v0.1c0,2.3-2,4-5.3,4a17.08,17.08,0,0,1-9.6-2.8,12.49,12.49,0,0,1-1.2-.8,0.62,0.62,0,0,0-1,.3Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M180,203.7a0.57,0.57,0,0,0,.2.8,23.92,23.92,0,0,0,2.1,1.3,21.86,21.86,0,0,0,10.9,2.6c7.5,0,12.1-4,12.1-10.4v-0.1c0-5.9-5.2-8.1-10.2-9.6l-0.6-.2c-3.7-1.2-6.9-2.2-6.9-4.7v-0.1c0-2.1,1.9-3.6,4.8-3.6a22.22,22.22,0,0,1,9.5,2.4,0.64,0.64,0,0,0,1-.2c0.1-.4,1.4-3.7,1.5-4.1a0.63,0.63,0,0,0-.4-0.8,21.28,21.28,0,0,0-10.7-2.9h-0.7c-6.9,0-11.6,4.1-11.6,10.1v0.1c0,6.3,5.3,8.3,10.2,9.7l0.8,0.2c3.6,1.1,6.7,2.1,6.7,4.6v0.1c0,2.3-2,4-5.3,4a17.08,17.08,0,0,1-9.6-2.8,12.49,12.49,0,0,1-1.2-.8,0.67,0.67,0,0,0-1,.3Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M254.8,191.2c0,3.6-.7,6.5-2,8.5a7.7,7.7,0,0,1-12.2,0c-1.3-2-2-4.9-2-8.5s0.7-6.5,2-8.5,3.3-2.9,6.1-2.9a6.87,6.87,0,0,1,6.1,2.9c1.3,2,2,4.9,2,8.5m6.3-6.7a15.39,15.39,0,0,0-2.8-5.4,14.7,14.7,0,0,0-4.8-3.7,15.72,15.72,0,0,0-6.7-1.3,17.39,17.39,0,0,0-6.7,1.3,13.47,13.47,0,0,0-4.8,3.7,14.64,14.64,0,0,0-2.8,5.4,24.11,24.11,0,0,0-.9,6.7,23.6,23.6,0,0,0,.9,6.7,15.38,15.38,0,0,0,2.8,5.4,13.22,13.22,0,0,0,4.8,3.6,17.92,17.92,0,0,0,13.4,0,14.44,14.44,0,0,0,4.8-3.6,14.64,14.64,0,0,0,2.8-5.4,24.11,24.11,0,0,0,.9-6.7,23.6,23.6,0,0,0-.9-6.7'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M312.4,201.7a0.62,0.62,0,0,0-.8-0.4,13.79,13.79,0,0,1-2.9.8,18.3,18.3,0,0,1-3.4.2,9.34,9.34,0,0,1-7.1-2.7c-1.7-1.8-2.7-4.7-2.7-8.5a13.33,13.33,0,0,1,2.4-8.2,8.13,8.13,0,0,1,6.9-3.1,22.42,22.42,0,0,1,6.6.9,0.52,0.52,0,0,0,.7-0.4c0.5-1.5,1-2.6,1.5-4.3a0.47,0.47,0,0,0-.4-0.7,35,35,0,0,0-4.2-1.1,32.77,32.77,0,0,0-4.7-.3,17.14,17.14,0,0,0-7,1.3,14.28,14.28,0,0,0-5,3.6,15,15,0,0,0-3,5.4,20.89,20.89,0,0,0-1,6.7c0,5.2,1.4,9.4,4.2,12.4s6.9,4.6,12.3,4.6a25.59,25.59,0,0,0,8.8-1.6,0.53,0.53,0,0,0,.3-0.7Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M323.3,187.7a13.37,13.37,0,0,1,1.7-5,6.73,6.73,0,0,1,6-3.1,6.45,6.45,0,0,1,5.9,3.1,9.79,9.79,0,0,1,1.4,5h-15Zm21.1-4.4a11.88,11.88,0,0,0-2.7-4.9,13.14,13.14,0,0,0-4-3.1,16.15,16.15,0,0,0-6.1-1.2,15.65,15.65,0,0,0-7,1.4,15.11,15.11,0,0,0-4.9,3.7,14.49,14.49,0,0,0-2.9,5.5,24.83,24.83,0,0,0-.9,6.8,21.52,21.52,0,0,0,1,6.8,13.2,13.2,0,0,0,3.1,5.4,14,14,0,0,0,5.3,3.5,21.85,21.85,0,0,0,7.7,1.2c6.1,0,9.3-1.4,10.7-2.1a0.67,0.67,0,0,0,.2-1l-1.4-3.9a0.62,0.62,0,0,0-.8-0.4,19.89,19.89,0,0,1-8.7,1.6c-3.3,0-5.7-1-7.2-2.5s-2.3-3.8-2.5-7h21.2a0.59,0.59,0,0,0,.6-0.6A28.8,28.8,0,0,0,344.4,183.3Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M153.9,187.7a13.37,13.37,0,0,1,1.7-5,6.73,6.73,0,0,1,6-3.1,6.45,6.45,0,0,1,5.9,3.1,10.88,10.88,0,0,1,1.4,5h-15Zm21-4.4a11.88,11.88,0,0,0-2.7-4.9,13.14,13.14,0,0,0-4-3.1,16.15,16.15,0,0,0-6.1-1.2,15.65,15.65,0,0,0-7,1.4,15.11,15.11,0,0,0-4.9,3.7,14.49,14.49,0,0,0-2.9,5.5,24.83,24.83,0,0,0-.9,6.8,21.52,21.52,0,0,0,1,6.8,13.2,13.2,0,0,0,3.1,5.4,14,14,0,0,0,5.3,3.5,21.85,21.85,0,0,0,7.7,1.2c6.1,0,9.3-1.4,10.7-2.1a0.67,0.67,0,0,0,.2-1l-1.4-3.9a0.62,0.62,0,0,0-.8-0.4,19.89,19.89,0,0,1-8.7,1.6c-3.3,0-5.7-1-7.2-2.5s-2.3-3.8-2.5-7H175a0.59,0.59,0,0,0,.6-0.6A23.42,23.42,0,0,0,174.9,183.3Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M108.1,201.6a4.36,4.36,0,0,1-1.2-1.3,5.3,5.3,0,0,1-.6-2.8,4.54,4.54,0,0,1,1.9-4.1s1.8-1.6,6.1-1.5a35.31,35.31,0,0,1,5.7.5V202h0a42.8,42.8,0,0,1-5.7.8c-4.3.3-6.2-1.2-6.2-1.2m8.5-14.9a32.18,32.18,0,0,0-3.3-.1,17.66,17.66,0,0,0-5.2.7,12.65,12.65,0,0,0-4.4,2,10.46,10.46,0,0,0-3.1,3.5,9.59,9.59,0,0,0-1.1,4.9,10,10,0,0,0,1,4.8,8.85,8.85,0,0,0,2.8,3.3,11.28,11.28,0,0,0,4.3,1.9,24,24,0,0,0,5.6.6,44.82,44.82,0,0,0,6.4-.5c2.1-.4,4.6-0.9,5.3-1s1.5-.4,1.5-0.4a0.71,0.71,0,0,0,.5-0.7V186.4c0-4.2-1.1-7.4-3.4-9.3s-5.5-2.9-9.7-2.9a36.57,36.57,0,0,0-5.7.5s-4.6.9-6.5,2.4a0.68,0.68,0,0,0-.2.8l1.5,4a0.53,0.53,0,0,0,.7.3,1.44,1.44,0,0,0,.3-0.2,21.32,21.32,0,0,1,9.2-2.1,8.48,8.48,0,0,1,5.2,1.4c1.2,0.9,1.7,2.2,1.7,5v0.9c-1.8-.3-3.4-0.5-3.4-0.5'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M287.2,175.8a0.63,0.63,0,0,0-.3-0.8,26.7,26.7,0,0,0-3.5-.6,10.31,10.31,0,0,0-5.5.9,9.54,9.54,0,0,0-3.6,2.6v-2.6a0.58,0.58,0,0,0-.6-0.6h-5.4a0.58,0.58,0,0,0-.6.6v31.6a0.58,0.58,0,0,0,.6.6h5.6a0.58,0.58,0,0,0,.6-0.6V191.1a18.19,18.19,0,0,1,.7-5.6,7.81,7.81,0,0,1,1.9-3.1,8,8,0,0,1,2.6-1.6,10.44,10.44,0,0,1,2.8-.4,11.07,11.07,0,0,1,2.3.3,0.84,0.84,0,0,0,.8-0.6c0.4-.8,1.4-3.7,1.6-4.3'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M235,161.2c-0.7-.2-1.3-0.3-2.1-0.5a23.28,23.28,0,0,0-2.9-.2,12.52,12.52,0,0,0-9,3.2c-2.1,2.1-3.5,5.4-4.3,9.6l-0.3,1.4h-4.8a0.72,0.72,0,0,0-.7.6l-0.8,4.4c-0.1.4,0.1,0.7,0.7,0.7h4.7l-4.7,26.5a32.6,32.6,0,0,1-1.3,5.2,10.42,10.42,0,0,1-1.5,3,4,4,0,0,1-1.9,1.5,9.35,9.35,0,0,1-2.5.4,9.85,9.85,0,0,1-1.7-.2,2.82,2.82,0,0,1-1.1-.4,0.65,0.65,0,0,0-.8.3c-0.2.5-1.4,3.9-1.6,4.3a0.69,0.69,0,0,0,.3.8c0.6,0.2,1.1.4,1.9,0.6a12,12,0,0,0,3.1.3,16.69,16.69,0,0,0,5.2-.8,9.49,9.49,0,0,0,3.9-2.7,14.47,14.47,0,0,0,2.7-4.7,42.07,42.07,0,0,0,1.9-7.1l4.8-27h7a0.72,0.72,0,0,0,.7-0.6l0.8-4.4c0.1-.4-0.1-0.7-0.7-0.7h-6.8a23.1,23.1,0,0,1,1.1-4.8,6.56,6.56,0,0,1,1.5-2.3,4.18,4.18,0,0,1,1.8-1.1,8,8,0,0,1,2.3-.3,7.93,7.93,0,0,1,1.7.2,3,3,0,0,1,1.1.3c0.7,0.2.8,0,.9-0.3l1.6-4.4c0.4-.6,0-0.8-0.2-0.8'
            }),
            _react2['default'].createElement('path', {
              fill: '#fff',
              d: 'M140.5,206.9a0.58,0.58,0,0,1-.6.6h-5.6a0.58,0.58,0,0,1-.6-0.6V161.7a0.53,0.53,0,0,1,.6-0.6h5.6a0.58,0.58,0,0,1,.6.6v45.2Z'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return Salesforce;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Salesforce;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sentiment = (_temp = _class = function (_SvgIcon) {
  _inherits(Sentiment, _SvgIcon);

  function Sentiment() {
    _classCallCheck(this, Sentiment);

    return _possibleConstructorReturn(this, (Sentiment.__proto__ || Object.getPrototypeOf(Sentiment)).apply(this, arguments));
  }

  _createClass(Sentiment, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M35.2,6.72a13,13,0,0,0-3.94.61A18.07,18.07,0,0,1,32.7,9a11.1,11.1,0,1,1,0,21.6,18.07,18.07,0,0,1-1.44,1.69A13.1,13.1,0,1,0,35.2,6.72Z' }),
          _react2['default'].createElement('path', { d: 'M40.42,26.2a0.5,0.5,0,0,0,.43.25,0.5,0.5,0,0,0,.23-0.06,0.5,0.5,0,0,0,.22-0.65,6.77,6.77,0,0,0-5.13-3.58,17.78,17.78,0,0,1-.51,2.5C39.47,24.78,40.41,26.19,40.42,26.2Z' }),
          _react2['default'].createElement('polygon', { points: '37.77 18.95 39.31 17.4 40.86 18.95 41.81 18 40.26 16.46 41.81 14.91 40.86 13.97 39.31 15.51 37.77 13.97 36.82 14.91 38.37 16.46 36.82 18 37.77 18.95' }),
          _react2['default'].createElement('path', { d: 'M18.41,36A16.18,16.18,0,1,1,34.6,19.82,16.2,16.2,0,0,1,18.41,36Zm0-29.87A13.68,13.68,0,1,0,32.1,19.82,13.7,13.7,0,0,0,18.41,6.13Z' }),
          _react2['default'].createElement('path', { d: 'M27.32,15.07c0-2.81-3.47-3.13-3.82-.82-0.35-2.31-3.82-2-3.82.82,0,1.5,2,3.2,3.82,5C25.27,18.26,27.32,16.57,27.32,15.07Z' }),
          _react2['default'].createElement('path', { d: 'M13.4,14.25c-0.35-2.31-3.82-2-3.82.82,0,1.5,2,3.2,3.82,5,1.78-1.8,3.82-3.49,3.82-5C17.23,12.26,13.75,11.93,13.4,14.25Z' }),
          _react2['default'].createElement('path', { d: 'M25.67,23A0.5,0.5,0,0,0,25,23S23.71,24.2,18.4,24.2,11.72,23,11.72,23a0.5,0.5,0,0,0-.83.5,8.13,8.13,0,0,0,7.34,5.39h0.29c5.3-.15,7.31-5.32,7.33-5.37A0.49,0.49,0,0,0,25.67,23Z' })
        );
      }

      return render;
    }()
  }]);

  return Sentiment;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 50 39.88'
}, _temp);
exports['default'] = Sentiment;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ServiceNow = (_temp = _class = function (_SvgIcon) {
  _inherits(ServiceNow, _SvgIcon);

  function ServiceNow() {
    _classCallCheck(this, ServiceNow);

    return _possibleConstructorReturn(this, (ServiceNow.__proto__ || Object.getPrototypeOf(ServiceNow)).apply(this, arguments));
  }

  _createClass(ServiceNow, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'Layer_1-2', 'data-name': 'Layer 1-2' },
            _react2['default'].createElement('path', {
              fill: '#293e40',
              fillRule: 'evenodd',
              d: 'M5.64,39.38V24.67H9.42v1.18a6.44,6.44,0,0,1,4.14-1.48,6.56,6.56,0,0,1,5.07,2.36,7.49,7.49,0,0,1,1.52,5.16v7.49H16.22v-7.8a3.58,3.58,0,0,0-.88-2.75,3.05,3.05,0,0,0-2.2-.82,4.66,4.66,0,0,0-3.57,1.82v9.58Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#81b5a1',
              fillRule: 'evenodd',
              d: 'M30.26,24.37a8.61,8.61,0,0,0-5.94,14.84,1.7,1.7,0,0,0,2.21.12,6.14,6.14,0,0,1,7.33,0,1.69,1.69,0,0,0,2.24-.12,8.61,8.61,0,0,0-5.84-14.84m0,12.9a4.18,4.18,0,0,1-4.31-4,2.09,2.09,0,0,1,0-.25,4.29,4.29,0,0,1,8.57-.28,1.31,1.31,0,0,1,0,.28,4.17,4.17,0,0,1-4.06,4.29h-.22'
            }),
            _react2['default'].createElement('polygon', {
              fill: '#293e40',
              fillRule: 'evenodd',
              points: '46.56 39.38 43.63 39.38 37.79 24.67 41.72 24.67 44.92 33.08 48.05 24.67 51.33 24.67 54.44 33.08 57.67 24.67 61.59 24.67 55.76 39.38 52.83 39.38 49.7 31 46.56 39.38'
            }),
            _react2['default'].createElement('polygon', {
              fill: '#293e40',
              points: '59.44 37.51 59.44 37.84 58.95 37.84 58.95 39.38 58.59 39.38 58.59 37.84 58.09 37.84 58.09 37.51 59.44 37.51'
            }),
            _react2['default'].createElement('polygon', {
              fill: '#293e40',
              points: '60.66 38.63 61.34 37.51 61.59 37.51 61.59 39.38 61.23 39.38 61.23 38.34 60.78 39.08 60.53 39.08 60.09 38.34 60.09 39.38 59.73 39.38 59.73 37.51 59.98 37.51 60.66 38.63'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return ServiceNow;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = ServiceNow;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sharepoint = (_temp = _class = function (_SvgIcon) {
  _inherits(Sharepoint, _SvgIcon);

  function Sharepoint() {
    _classCallCheck(this, Sharepoint);

    return _possibleConstructorReturn(this, (Sharepoint.__proto__ || Object.getPrototypeOf(Sharepoint)).apply(this, arguments));
  }

  _createClass(Sharepoint, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('rect', {
            fill: '#3765af',
            x: '-0.11',
            y: '-0.39',
            width: '400.11',
            height: '400.39'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M327.65,168.84a23.89,23.89,0,0,0-5.31.39,73.75,73.75,0,0,0-37.07-39.79c0-.91.39-2.2,0.39-3.63A26.88,26.88,0,0,0,258.83,99a26,26,0,0,0-16.46,5.83v42a26,26,0,0,0,16.46,5.83c8.94,0,17.37-4.41,21.9-11.66a60.83,60.83,0,0,1,29.94,33,27.3,27.3,0,0,0-9.85,20.48,26.86,26.86,0,0,0,10.24,21,60.94,60.94,0,0,1-30.33,34,26.63,26.63,0,0,0-21.9-11.66,26,26,0,0,0-16.46,5.83v42a26,26,0,0,0,16.46,5.83,26.88,26.88,0,0,0,26.83-26.83,12,12,0,0,0-.39-3.63,72.78,72.78,0,0,0,37.07-40.18,25.07,25.07,0,0,0,5.31.39,26.88,26.88,0,0,0,26.83-26.83C354.35,180.89,342.3,168.84,327.65,168.84Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#fff',
            d: 'M72.34,92.5L71.82,300.9,227.21,329V64.38Zm87.48,156.17c-12.44,9.33-29.42,5.31-42.9,0,0-7.65-.39-15.68-0.39-23.2,8.42,6.22,21.38,15.68,31.23,7.13,8-13.35-7.65-21.9-16.46-28.12-19.18-11.66-20.09-43.8-1.3-55.86,11.15-6.74,24.11-4.92,36.16-3.11,0,7.13.39,14.77,0.39,21.9-10.24-3.11-22.81-9.33-31.23.39-5.83,15.16,12.44,20.48,21.38,28.51C174.08,207.2,175.89,235.84,159.82,248.67Z'
          })
        );
      }

      return render;
    }()
  }]);

  return Sharepoint;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Sharepoint;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://slack.com/brand-guidelines
var SlackMarkWeb = (_temp = _class = function (_SvgIcon) {
  _inherits(SlackMarkWeb, _SvgIcon);

  function SlackMarkWeb() {
    _classCallCheck(this, SlackMarkWeb);

    return _possibleConstructorReturn(this, (SlackMarkWeb.__proto__ || Object.getPrototypeOf(SlackMarkWeb)).apply(this, arguments));
  }

  _createClass(SlackMarkWeb, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#ECB32D',
            d: 'M154.3,87.1c-1.9-5.7-8-8.8-13.7-7c-5.7,1.9-8.8,8-7,13.7l28.1,86.4c1.9,5.3,7.7,8.3,13.2,6.7 c5.8-1.7,9.3-7.8,7.4-13.4C182.3,173.3,154.3,87.1,154.3,87.1z'
          }),
          _react2['default'].createElement('path', {
            fill: '#63C1A0',
            d: 'M110.8,101.2c-1.9-5.7-8-8.8-13.7-7c-5.7,1.9-8.8,8-7,13.7l28.1,86.4c1.9,5.3,7.7,8.3,13.2,6.7 c5.8-1.7,9.3-7.8,7.4-13.4C138.8,187.4,110.8,101.2,110.8,101.2z'
          }),
          _react2['default'].createElement('path', {
            fill: '#E01A59',
            d: 'M189.7,158.6c5.7-1.9,8.8-8,7-13.7c-1.9-5.7-8-8.8-13.7-7l-86.5,28.2c-5.3,1.9-8.3,7.7-6.7,13.2 c1.7,5.8,7.8,9.3,13.4,7.4C103.4,186.7,189.7,158.6,189.7,158.6z'
          }),
          _react2['default'].createElement('path', {
            fill: '#331433',
            d: 'M114.5,183.1c5.6-1.8,12.9-4.2,20.7-6.7c-1.8-5.6-4.2-12.9-6.7-20.7l-20.7,6.7L114.5,183.1z'
          }),
          _react2['default'].createElement('path', {
            fill: '#D62027',
            d: 'M158.1,168.9c7.8-2.5,15.1-4.9,20.7-6.7c-1.8-5.6-4.2-12.9-6.7-20.7l-20.7,6.7L158.1,168.9z'
          }),
          _react2['default'].createElement('path', {
            fill: '#89D3DF',
            d: 'M175.5,115.1c5.7-1.9,8.8-8,7-13.7c-1.9-5.7-8-8.8-13.7-7l-86.4,28.1c-5.3,1.9-8.3,7.7-6.7,13.2 c1.7,5.8,7.8,9.3,13.4,7.4C89.3,143.1,175.5,115.1,175.5,115.1z'
          }),
          _react2['default'].createElement('path', {
            fill: '#258B74',
            d: 'M100.4,139.5c5.6-1.8,12.9-4.2,20.7-6.7c-2.5-7.8-4.9-15.1-6.7-20.7l-20.7,6.7L100.4,139.5z'
          }),
          _react2['default'].createElement('path', {
            fill: '#819C3C',
            d: 'M143.9,125.4c7.8-2.5,15.1-4.9,20.7-6.7c-2.5-7.8-4.9-15.1-6.7-20.7l-20.7,6.7L143.9,125.4z'
          })
        );
      }

      return render;
    }()
  }]);

  return SlackMarkWeb;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 270 270'
}, _temp);
exports['default'] = SlackMarkWeb;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sterling = (_temp = _class = function (_SvgIcon) {
    _inherits(Sterling, _SvgIcon);

    function Sterling() {
        _classCallCheck(this, Sterling);

        return _possibleConstructorReturn(this, (Sterling.__proto__ || Object.getPrototypeOf(Sterling)).apply(this, arguments));
    }

    _createClass(Sterling, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement('path', {
                        fill: '#333F48',
                        d: 'M20,28.9c-4.8-.8-8.4-1.6-8.4-5.1,0-3.1,2.6-5.1,6.7-5.1a6.79,6.79,0,0,1,7,5.1h6.9C31,17.3,25.84,13,18.64,13c-8.3,0-13.9,4.6-13.9,11.3,0,8.3,7.7,9.5,12.9,10.3s9,1.8,9,5.8c0,3.4-3.1,5.6-7.8,5.6a7.82,7.82,0,0,1-7.7-5.1h-7c1.5,6.6,7.1,10.9,14.6,10.9,8.9,0,14.9-4.9,14.9-12.1C33.44,31.8,26.84,30,20,28.9Z'
                    }),
                    _react2['default'].createElement('rect', { fill: '#333F48', x: '36.24', y: '18', width: '6.4', height: '5.9' }),
                    _react2['default'].createElement('path', {
                        fill: '#333F48',
                        d: 'M54.24,40.5a5.5,5.5,0,0,1-5.89,5.1h0c-3.5,0-5.7-2.6-5.7-6V29.5h-6.4V39.8c0,7.4,5,12.3,11.7,12.3,7.1,0,11.8-4.9,12.8-11.6Z'
                    }),
                    _react2['default'].createElement('path', {
                        fill: '#FF4700',
                        d: 'M56.84,23.9v5.5h-5.7V23.9Zm-8.5,0h-5.7v5.5h5.7Z'
                    })
                );
            }

            return render;
        }()
    }]);

    return Sterling;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Sterling;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stripe = (_temp = _class = function (_SvgIcon) {
  _inherits(Stripe, _SvgIcon);

  function Stripe() {
    _classCallCheck(this, Stripe);

    return _possibleConstructorReturn(this, (Stripe.__proto__ || Object.getPrototypeOf(Stripe)).apply(this, arguments));
  }

  _createClass(Stripe, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M375.6,202.3c0-24.8-12-44.4-35-44.4c-23.1,0-37.1,19.6-37.1,44.2c0,29.2,16.5,43.9,40.2,43.9c11.5,0,20.3-2.6,26.9-6.3v-19.4c-6.6,3.3-14.2,5.3-23.8,5.3c-9.4,0-17.8-3.3-18.8-14.7h47.4C375.4,209.7,375.6,204.7,375.6,202.3zM327.7,193.1c0-11,6.7-15.5,12.8-15.5c5.9,0,12.2,4.6,12.2,15.5H327.7z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M266.1,157.9c-9.5,0-15.6,4.5-19,7.6l-1.3-6h-21.3v113.1l24.2-5.1l0.1-27.5c3.5,2.5,8.6,6.1,17.2,6.1c17.4,0,33.2-14,33.2-44.7C299.1,173.2,283.1,157.9,266.1,157.9z M260.3,224.7c-5.7,0-9.1-2-11.4-4.6l-0.1-36c2.5-2.8,6-4.8,11.5-4.8c8.8,0,14.9,9.9,14.9,22.6C275.2,215,269.2,224.7,260.3,224.7z'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#6772E5',
            points: '191.1,152.2 215.5,146.9 215.5,127.2 191.1,132.4 \t'
          }),
          _react2['default'].createElement('rect', { x: '191.1', y: '159.5', fill: '#6772E5', width: '24.3', height: '84.9' }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M165,166.7l-1.6-7.2h-21v84.9h24.2v-57.5c5.7-7.5,15.4-6.1,18.4-5v-22.3C182.1,158.4,170.7,156.2,165,166.7z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M116.5,138.5l-23.7,5l-0.1,77.7c0,14.4,10.8,24.9,25.1,24.9c8,0,13.8-1.5,17-3.2v-19.7c-3.1,1.3-18.4,5.7-18.4-8.6v-34.4h18.4v-20.7h-18.4L116.5,138.5z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M50.9,184.2c0-3.8,3.1-5.2,8.2-5.2c7.4,0,16.7,2.2,24.1,6.2v-22.8c-8.1-3.2-16-4.5-24.1-4.5c-19.7,0-32.8,10.3-32.8,27.5c0,26.8,36.9,22.5,36.9,34c0,4.5-3.9,5.9-9.3,5.9c-8.1,0-18.3-3.3-26.5-7.8v23.1c9,3.9,18.1,5.5,26.5,5.5c20.2,0,34-10,34-27.4C87.9,189.9,50.9,195.1,50.9,184.2z'
          })
        );
      }

      return render;
    }()
  }]);

  return Stripe;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Stripe;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuccessFactors = (_temp = _class = function (_SvgIcon) {
  _inherits(SuccessFactors, _SvgIcon);

  function SuccessFactors() {
    _classCallCheck(this, SuccessFactors);

    return _possibleConstructorReturn(this, (SuccessFactors.__proto__ || Object.getPrototypeOf(SuccessFactors)).apply(this, arguments));
  }

  _createClass(SuccessFactors, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            d: 'M9.31,10.33c.1-2.69,1.07-4.91,3.47-6.23a6.72,6.72,0,0,1,7.14.16c.2.13.35.21.6,0a7,7,0,0,1,8.11.4,7.48,7.48,0,0,1,2.21,7.9,13,13,0,0,1-2.66,4.6c-2.37,2.83-5.1,5.29-7.66,7.94-.2.2-.33.21-.54,0-2.6-2.68-5.39-5.19-7.78-8.07a11.35,11.35,0,0,1-2.79-5.61C9.35,11.08,9.34,10.69,9.31,10.33Zm19.41-.11a4.78,4.78,0,0,0-.21-1.47A4.4,4.4,0,0,0,21.13,7c-.88.88-.89.88-1.74,0a4.32,4.32,0,0,0-4.76-1.07,4.36,4.36,0,0,0-2.86,4.45,7.66,7.66,0,0,0,2,4.68A79.6,79.6,0,0,0,20,21.73c.26.26.37.09.53-.07,1.4-1.42,2.82-2.82,4.2-4.25a20.64,20.64,0,0,0,2.85-3.55A6.51,6.51,0,0,0,28.72,10.22Z',
            fill: '#efab03'
          }),
          _react2['default'].createElement('path', {
            d: 'M16.77,28a1.63,1.63,0,0,1,1.33.58c.1.11.13.19,0,.27a2.92,2.92,0,0,0-.28.21c-.09.08-.14.1-.23,0a1,1,0,0,0-1-.36.33.33,0,0,0-.29.29.34.34,0,0,0,.2.37,3.14,3.14,0,0,0,.61.21,3.89,3.89,0,0,1,.74.28,1,1,0,0,1,.08,1.64A1.87,1.87,0,0,1,15.43,31c-.08-.11-.12-.19.05-.27s.25-.19.39-.21.19.19.3.28a1.08,1.08,0,0,0,1,.25.37.37,0,0,0,.06-.73,4.6,4.6,0,0,0-.74-.25,3,3,0,0,1-.5-.19.87.87,0,0,1-.54-.79,1,1,0,0,1,.48-.92A1.57,1.57,0,0,1,16.77,28Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M3.45,33a1.69,1.69,0,0,1,1.36.62c.08.1.08.16,0,.22s0,0,0,.05-.22.21-.34.24-.18-.17-.29-.24a1,1,0,0,0-.87-.2.34.34,0,0,0-.28.29.35.35,0,0,0,.19.36,2.79,2.79,0,0,0,.61.22,3.39,3.39,0,0,1,.75.28,1,1,0,0,1,.09,1.64A1.87,1.87,0,0,1,2.09,36c-.07-.11-.1-.18,0-.23l.07,0a1.17,1.17,0,0,1,.36-.2c.14,0,.17.19.26.27A1.09,1.09,0,0,0,3.9,36a.37.37,0,0,0,.3-.33A.36.36,0,0,0,4,35.33a2.59,2.59,0,0,0-.66-.23,4.75,4.75,0,0,1-.63-.23.86.86,0,0,1-.52-.8.94.94,0,0,1,.47-.9A1.58,1.58,0,0,1,3.45,33Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M21.34,31.66c-.39,0-.39,0-.51-.36s-.14-.44-.62-.44H19.6a.16.16,0,0,0-.19.12c-.05.2-.13.39-.19.58a.14.14,0,0,1-.15.11,3.09,3.09,0,0,0-.43,0c-.15,0-.2,0-.13-.18.33-.91.64-1.83,1-2.75.07-.19.15-.39.21-.59s.07-.13.17-.12.44-.06.6,0,.16.34.23.53c.34,1,.68,1.92,1,2.88.07.19.07.19-.13.19ZM20.08,29l-.4,1.15c0,.1,0,.09.1.09h.58c.11,0,.13,0,.1-.14C20.33,29.79,20.22,29.44,20.08,29Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M22.16,29.84V28.2c0-.07,0-.16.09-.15a16.07,16.07,0,0,1,1.7,0,1.13,1.13,0,0,1,.86,1.71,1.17,1.17,0,0,1-1.06.57,4.73,4.73,0,0,1-.65,0c-.12,0-.16,0-.16.15,0,.33,0,.66,0,1,0,.12,0,.18-.16.17a3.69,3.69,0,0,0-.47,0c-.13,0-.17,0-.16-.16Zm.8-.62h0c0,.13,0,.27,0,.41s0,.12.12.12h.61a.52.52,0,0,0,0-1h-.23c-.18,0-.41-.08-.5,0S23,29.06,23,29.22Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M21.7,34.83c0-.55,0-1.1,0-1.64,0-.13,0-.17.16-.17h2.08c.12,0,.16,0,.15.15a2.16,2.16,0,0,0,0,.36c0,.14,0,.16-.16.16H22.64c-.11,0-.15,0-.14.14v.59c0,.11,0,.15.14.15h.83c.12,0,.18,0,.17.15s.06.36,0,.45-.29,0-.44,0h-.52c-.11,0-.15,0-.15.14,0,.37,0,.75,0,1.12,0,.13,0,.2-.17.19s-.47.08-.59,0,0-.38,0-.57Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M25.55,36.27a1.22,1.22,0,0,1-.72.4.76.76,0,0,1-.87-.42.79.79,0,0,1,.34-1A2.56,2.56,0,0,1,25.35,35c.07,0,.2.05.2-.1a.26.26,0,0,0-.21-.28,1,1,0,0,0-.38,0,1.46,1.46,0,0,0-.51.23c-.07.05-.12.06-.17,0l-.1-.14c-.17-.23-.18-.23.06-.38A1.88,1.88,0,0,1,25.66,34c.43.08.65.39.66.91s0,.79,0,1.19a2.44,2.44,0,0,0,0,.27c0,.25,0,.25-.21.25h-.2C25.59,36.64,25.59,36.64,25.55,36.27Zm0-.61v-.21s0-.07-.06-.06a1.35,1.35,0,0,0-.73.24.25.25,0,0,0,0,.4.66.66,0,0,0,.61,0A.27.27,0,0,0,25.56,35.66Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M32.82,36.69a1.36,1.36,0,1,1,1.33-1.36A1.24,1.24,0,0,1,32.82,36.69Zm.54-1.33a1.25,1.25,0,0,0-.1-.51.46.46,0,0,0-.44-.29.45.45,0,0,0-.45.28,1.29,1.29,0,0,0,0,1,.49.49,0,0,0,.88,0A1.22,1.22,0,0,0,33.36,35.36Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M7,36.24a1.13,1.13,0,0,1-1,.45A.65.65,0,0,1,5.37,36c0-.63,0-1.26,0-1.89,0-.09,0-.1.12-.1H6c.13,0,.16,0,.15.15v1.47c0,.37.2.5.55.35s.32-.18.32-.48c0-.45,0-.9,0-1.34,0-.12,0-.16.15-.15h.51c.09,0,.12,0,.12.12v2.35c0,.1,0,.14-.13.14H7.18c-.12,0-.18,0-.16-.16A2,2,0,0,0,7,36.24Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M15.19,35.55c-.24,0-.48,0-.72,0s-.14,0-.12.14a.58.58,0,0,0,.74.44,1.18,1.18,0,0,0,.54-.23c.06,0,.1-.06.13,0a1.63,1.63,0,0,1,.11.17c.16.24.16.24-.1.38a1.72,1.72,0,0,1-1.38.15,1.15,1.15,0,0,1-.83-1.07A1.32,1.32,0,0,1,15.24,34a1.16,1.16,0,0,1,.8,1.13c0,.39,0,.39-.36.39Zm-.34-.46c.13,0,.25,0,.38,0s.13,0,.1-.12a.47.47,0,0,0-.42-.42.48.48,0,0,0-.52.36c0,.11-.06.2.12.18S14.74,35.09,14.85,35.09Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M17.46,36.69a1.88,1.88,0,0,1-1.08-.3c-.09-.06-.12-.12,0-.21s.13-.24.22-.28.2.09.31.14a1.31,1.31,0,0,0,.73.14c.14,0,.27-.06.29-.22s-.1-.24-.24-.27-.42-.09-.63-.15c-.45-.13-.64-.36-.64-.74A.77.77,0,0,1,17,34a1.72,1.72,0,0,1,1.36.22c.1.06.15.12.05.23s-.12.23-.22.28-.19-.09-.3-.14a1.11,1.11,0,0,0-.54-.1c-.12,0-.25,0-.27.19s.09.22.21.25l.59.13.24.07a.66.66,0,0,1,.46.53.78.78,0,0,1-.3.77A1.32,1.32,0,0,1,17.46,36.69Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M20.09,36.69A2,2,0,0,1,19,36.38c-.08-.06-.1-.1,0-.19s.13-.24.23-.29.2.09.3.14a1.34,1.34,0,0,0,.68.14c.21,0,.34-.09.35-.23s-.14-.24-.28-.28l-.6-.13c-.44-.13-.64-.36-.63-.74a.77.77,0,0,1,.66-.77,1.7,1.7,0,0,1,1.35.22c.11.06.15.12.05.23s-.12.23-.22.28-.19-.09-.3-.14a1,1,0,0,0-.54-.1c-.12,0-.25,0-.27.19s.1.22.22.25l.58.13.22.07a.63.63,0,0,1,.48.53.77.77,0,0,1-.33.79A1.31,1.31,0,0,1,20.09,36.69Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M37.61,36.69a1.92,1.92,0,0,1-1.11-.31c-.09-.06-.11-.11,0-.2s.13-.24.23-.29.2.11.3.15a1.33,1.33,0,0,0,.67.14c.16,0,.31,0,.35-.22s-.07-.23-.28-.29-.45-.09-.67-.16a.68.68,0,0,1-.53-.49.76.76,0,0,1,.52-1,1.75,1.75,0,0,1,1.49.2c.09.06.12.11,0,.2s-.13.25-.23.29-.2-.09-.31-.13a1.1,1.1,0,0,0-.56-.1c-.12,0-.23.06-.24.21s.08.19.19.22l.6.14.22.07a.64.64,0,0,1,.49.56.78.78,0,0,1-.37.79A1.37,1.37,0,0,1,37.61,36.69Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M29.81,35.39c0-.21,0-.42,0-.63s0-.15-.14-.15c-.3,0-.3,0-.3-.3a.27.27,0,0,0,0-.09c0-.16,0-.19.19-.18s.25,0,.25-.25,0-.34,0-.51,0-.15.16-.14h.48c.11,0,.15,0,.15.14s0,.37,0,.56.06.22.22.2h.07c.12,0,.32-.06.36,0a1.21,1.21,0,0,1,0,.47c0,.08-.05.07-.1.07h-.43c-.11,0-.14,0-.13.14,0,.32,0,.65,0,1s.1.42.41.37.22,0,.21.22c0,.34,0,.34-.34.36a2,2,0,0,1-.54,0,.56.56,0,0,1-.52-.57c0-.23,0-.46,0-.69Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M28,36.69a1.17,1.17,0,0,1-1.22-1.21,1.93,1.93,0,0,1,0-.48,1.32,1.32,0,0,1,1.91-.88,1.12,1.12,0,0,1,.47.58c0,.07,0,.09-.06.11l-.22.07a.94.94,0,0,1-.31.1c-.11,0-.09-.16-.15-.24a.46.46,0,0,0-.75,0,1.36,1.36,0,0,0,0,1.18.44.44,0,0,0,.79-.08c.09-.18.17-.17.31-.11l.33.11c.09,0,.1.07,0,.16A1.17,1.17,0,0,1,28,36.69Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M9,35.39a1.33,1.33,0,0,0,.05.38.47.47,0,0,0,.41.37.44.44,0,0,0,.47-.29c.07-.15.14-.17.28-.11a1.42,1.42,0,0,0,.33.11c.12,0,.11.09.07.18a1.21,1.21,0,0,1-1.32.65,1.14,1.14,0,0,1-1-.91,1.61,1.61,0,0,1,0-.69,1.3,1.3,0,0,1,1.84-1,1.08,1.08,0,0,1,.55.6c0,.08,0,.11-.06.13l-.24.08c-.1,0-.2.1-.29.09s-.09-.16-.15-.23a.45.45,0,0,0-.76,0A1.12,1.12,0,0,0,9,35.39Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M10.94,35.34a1.27,1.27,0,0,1,1.7-1.3,1,1,0,0,1,.69.66c0,.07,0,.1-.05.11l-.23.08a.86.86,0,0,1-.3.09c-.12,0-.1-.16-.16-.24a.45.45,0,0,0-.73,0,1.27,1.27,0,0,0,0,1.2.45.45,0,0,0,.78-.1c.08-.17.16-.17.31-.11a.85.85,0,0,0,.24.09c.17,0,.18.1.1.25a1.24,1.24,0,0,1-1.38.58,1.16,1.16,0,0,1-1-1.09A1.92,1.92,0,0,1,10.94,35.34Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M35.38,34.46a1.07,1.07,0,0,1,.75-.47c.14,0,.17,0,.16.15s0,.07,0,.1a1,1,0,0,1,0,.38c-.06.14-.22,0-.34.06a1.88,1.88,0,0,0-.3.12.44.44,0,0,0-.25.45c0,.41,0,.83,0,1.24,0,.12,0,.16-.16.16h-.5c-.12,0-.14,0-.14-.15V34.17c0-.11,0-.14.13-.13h.49c.15,0,.19,0,.17.18Z',
            fill: '#0478cb'
          }),
          _react2['default'].createElement('path', {
            d: 'M28.72,10.22a6.51,6.51,0,0,1-1.13,3.64,20.64,20.64,0,0,1-2.85,3.55c-1.38,1.43-2.8,2.83-4.2,4.25-.16.16-.27.33-.53.07A79.6,79.6,0,0,1,13.72,15a7.66,7.66,0,0,1-2-4.68,4.36,4.36,0,0,1,2.86-4.45A4.32,4.32,0,0,1,19.39,7c.85.85.86.85,1.74,0a4.4,4.4,0,0,1,7.38,1.8A4.78,4.78,0,0,1,28.72,10.22Z',
            fill: '#fdfdfe'
          }),
          _react2['default'].createElement('path', {
            d: 'M20.08,29c.14.4.25.75.38,1.1,0,.11,0,.15-.1.14h-.58c-.06,0-.13,0-.1-.09Z',
            fill: '#fdfdfe'
          }),
          _react2['default'].createElement('path', {
            d: 'M23,29.22c0-.16-.07-.39,0-.48s.32,0,.5,0h.23a.52.52,0,0,1,0,1h-.61c-.09,0-.12,0-.12-.12s0-.28,0-.41Z',
            fill: '#fdfdfe'
          }),
          _react2['default'].createElement('path', {
            d: 'M25.56,35.66a.27.27,0,0,1-.17.33.66.66,0,0,1-.61,0,.25.25,0,0,1,0-.4,1.35,1.35,0,0,1,.73-.24s.06,0,.06.06Z',
            fill: '#fdfdfe'
          }),
          _react2['default'].createElement('path', {
            d: 'M33.36,35.36a1.22,1.22,0,0,1-.11.5.49.49,0,0,1-.88,0,1.29,1.29,0,0,1,0-1,.45.45,0,0,1,.45-.28.46.46,0,0,1,.44.29A1.25,1.25,0,0,1,33.36,35.36Z',
            fill: '#fdfdfe'
          }),
          _react2['default'].createElement('path', {
            d: 'M14.85,35.09c-.11,0-.23,0-.34,0s-.16-.07-.12-.18a.48.48,0,0,1,.52-.36.47.47,0,0,1,.42.42c0,.11,0,.12-.1.12S15,35.09,14.85,35.09Z',
            fill: '#fdfdfe'
          })
        );
      }

      return render;
    }()
  }]);

  return SuccessFactors;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40.17 40.04'
}, _temp);
exports['default'] = SuccessFactors;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sso = (_temp = _class = function (_SvgIcon) {
  _inherits(Sso, _SvgIcon);

  function Sso() {
    _classCallCheck(this, Sso);

    return _possibleConstructorReturn(this, (Sso.__proto__ || Object.getPrototypeOf(Sso)).apply(this, arguments));
  }

  _createClass(Sso, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', {
              fill: '#5e6174',
              d: 'M90.64,313a13.05,13.05,0,0,0,4,4.67,17.12,17.12,0,0,0,5.82,2.65,27.53,27.53,0,0,0,6.92.86,35.52,35.52,0,0,0,5.19-.4,18,18,0,0,0,5.19-1.55,11.33,11.33,0,0,0,4-3.17,8,8,0,0,0,1.61-5.13,7.21,7.21,0,0,0-2.13-5.42,16.88,16.88,0,0,0-5.59-3.46,56,56,0,0,0-7.84-2.42q-4.38-1-8.88-2.31a77.88,77.88,0,0,1-9-2.82,30.83,30.83,0,0,1-7.84-4.32,20.35,20.35,0,0,1-5.59-6.63,20.14,20.14,0,0,1-2.13-9.63,21.57,21.57,0,0,1,2.71-11,24.5,24.5,0,0,1,7.09-7.78,30.94,30.94,0,0,1,9.91-4.61,42.31,42.31,0,0,1,11.07-1.5,52.33,52.33,0,0,1,12.39,1.44,30.92,30.92,0,0,1,10.55,4.67,23.61,23.61,0,0,1,7.32,8.24,25.3,25.3,0,0,1,2.71,12.16H120.61a14.62,14.62,0,0,0-1.55-6.11,10.23,10.23,0,0,0-3.52-3.8,14.87,14.87,0,0,0-5-2,30.79,30.79,0,0,0-6.17-.58,21.5,21.5,0,0,0-4.38.46,11.84,11.84,0,0,0-4,1.62A10,10,0,0,0,93.06,268a7.73,7.73,0,0,0-1.15,4.38,7.38,7.38,0,0,0,.92,3.92,8.19,8.19,0,0,0,3.63,2.77A46.43,46.43,0,0,0,104,281.6q4.78,1.27,12.51,3.23,2.31,0.46,6.4,1.67a30.7,30.7,0,0,1,8.13,3.86,24.56,24.56,0,0,1,7,7.09q2.94,4.44,2.94,11.36a25.14,25.14,0,0,1-2.19,10.49,22.76,22.76,0,0,1-6.51,8.36,31.29,31.29,0,0,1-10.72,5.47,50.66,50.66,0,0,1-14.82,2,52.08,52.08,0,0,1-13.2-1.67,33.19,33.19,0,0,1-11.3-5.24,25.89,25.89,0,0,1-7.78-9.11,27.15,27.15,0,0,1-2.77-13.14H89.14A15.07,15.07,0,0,0,90.64,313Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#5e6174',
              d: 'M106.66,337.09A54.33,54.33,0,0,1,93,335.36a35.35,35.35,0,0,1-12-5.56,28,28,0,0,1-8.38-9.8,29.25,29.25,0,0,1-3-14.1l0-2H91.14v2A13.18,13.18,0,0,0,92.41,312h0a11,11,0,0,0,3.37,4,15.22,15.22,0,0,0,5.15,2.34,28,28,0,0,0,11.31.42,16,16,0,0,0,4.62-1.38,9.27,9.27,0,0,0,3.34-2.62,6,6,0,0,0,1.17-3.88,5.25,5.25,0,0,0-1.53-4,15,15,0,0,0-4.94-3,54.28,54.28,0,0,0-7.56-2.33c-3-.71-6-1.49-9-2.33a80,80,0,0,1-9.16-2.88,33,33,0,0,1-8.34-4.6,22.41,22.41,0,0,1-6.14-7.27,22.18,22.18,0,0,1-2.37-10.57,23.62,23.62,0,0,1,3-12A26.59,26.59,0,0,1,83,253.45a33.06,33.06,0,0,1,10.55-4.91A44.53,44.53,0,0,1,105.16,247a54.58,54.58,0,0,1,12.86,1.5,33.06,33.06,0,0,1,11.22,5,25.71,25.71,0,0,1,7.94,8.93,27.37,27.37,0,0,1,2.95,13.11v2h-21.4l-0.12-1.87a12.72,12.72,0,0,0-1.31-5.28,8.17,8.17,0,0,0-2.83-3.07,13,13,0,0,0-4.35-1.69,28.94,28.94,0,0,0-5.77-.54,19.65,19.65,0,0,0-4,.42,9.89,9.89,0,0,0-3.3,1.34,8,8,0,0,0-2.36,2.31,5.84,5.84,0,0,0-.81,3.27,5.51,5.51,0,0,0,.62,2.87,6.23,6.23,0,0,0,2.78,2,44.83,44.83,0,0,0,7.16,2.41c3,0.8,7,1.82,12.44,3.21,1.59,0.32,3.72.88,6.52,1.7a32.84,32.84,0,0,1,8.66,4.11,26.66,26.66,0,0,1,7.54,7.66c2.17,3.28,3.27,7.47,3.27,12.46a27.24,27.24,0,0,1-2.37,11.31,24.82,24.82,0,0,1-7.07,9.09,33.39,33.39,0,0,1-11.4,5.83A52.87,52.87,0,0,1,106.66,337.09Zm-33-29.17a23.42,23.42,0,0,0,9.7,18.64A31.35,31.35,0,0,0,94,331.48a50.32,50.32,0,0,0,12.7,1.61,48.93,48.93,0,0,0,14.23-1.87,29.43,29.43,0,0,0,10-5.11,20.87,20.87,0,0,0,6-7.63,23.27,23.27,0,0,0,2-9.67,18.35,18.35,0,0,0-2.61-10.25,22.66,22.66,0,0,0-6.4-6.52,28.83,28.83,0,0,0-7.6-3.62c-2.68-.79-4.77-1.34-6.23-1.63l-0.1,0c-5.51-1.4-9.49-2.43-12.53-3.24a47.86,47.86,0,0,1-7.83-2.65,10,10,0,0,1-4.49-3.54,9.35,9.35,0,0,1-1.22-5,9.72,9.72,0,0,1,1.49-5.49,12.08,12.08,0,0,1,3.52-3.45,13.89,13.89,0,0,1,4.65-1.89,23.61,23.61,0,0,1,4.8-.5,32.94,32.94,0,0,1,6.57.62,16.92,16.92,0,0,1,5.68,2.23,12.26,12.26,0,0,1,4.2,4.53,15.18,15.18,0,0,1,1.6,5.07h13.66a22.1,22.1,0,0,0-2.41-9.21,21.74,21.74,0,0,0-6.71-7.56,29.08,29.08,0,0,0-9.87-4.36A50.59,50.59,0,0,0,105.16,251a40.5,40.5,0,0,0-10.55,1.43,29.09,29.09,0,0,0-9.28,4.31,22.63,22.63,0,0,0-6.52,7.15,19.7,19.7,0,0,0-2.44,10,17.39,17.39,0,0,0,6.94,14.67,29,29,0,0,0,7.33,4,76.29,76.29,0,0,0,8.77,2.75c3,0.84,5.92,1.61,8.85,2.3a58.33,58.33,0,0,1,8.12,2.51,19,19,0,0,1,6.24,3.88,9.17,9.17,0,0,1,2.74,6.85,9.94,9.94,0,0,1-2.05,6.38,13.37,13.37,0,0,1-4.74,3.73,20,20,0,0,1-5.76,1.73,32,32,0,0,1-12.89-.5,19.2,19.2,0,0,1-6.49-3,15.08,15.08,0,0,1-4.58-5.36h0a15.83,15.83,0,0,1-1.64-6H73.64Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#5e6174',
              d: 'M179.29,313a13.05,13.05,0,0,0,4,4.67,17.12,17.12,0,0,0,5.82,2.65,27.53,27.53,0,0,0,6.92.86,35.52,35.52,0,0,0,5.19-.4,18,18,0,0,0,5.19-1.55,11.33,11.33,0,0,0,4-3.17,8,8,0,0,0,1.61-5.13,7.21,7.21,0,0,0-2.13-5.42,16.88,16.88,0,0,0-5.59-3.46,56,56,0,0,0-7.84-2.42q-4.38-1-8.88-2.31a77.88,77.88,0,0,1-9-2.82,30.83,30.83,0,0,1-7.84-4.32,20.35,20.35,0,0,1-5.59-6.63,20.14,20.14,0,0,1-2.13-9.63,21.57,21.57,0,0,1,2.71-11,24.5,24.5,0,0,1,7.09-7.78,30.94,30.94,0,0,1,9.91-4.61,42.31,42.31,0,0,1,11.07-1.5,52.33,52.33,0,0,1,12.39,1.44,30.92,30.92,0,0,1,10.55,4.67,23.61,23.61,0,0,1,7.32,8.24,25.3,25.3,0,0,1,2.71,12.16H209.27a14.62,14.62,0,0,0-1.55-6.11,10.23,10.23,0,0,0-3.52-3.8,14.87,14.87,0,0,0-5-2A30.79,30.79,0,0,0,193,263a21.5,21.5,0,0,0-4.38.46,11.84,11.84,0,0,0-4,1.62,10,10,0,0,0-2.94,2.88,7.73,7.73,0,0,0-1.15,4.38,7.38,7.38,0,0,0,.92,3.92,8.19,8.19,0,0,0,3.63,2.77,46.43,46.43,0,0,0,7.49,2.53q4.78,1.27,12.51,3.23,2.31,0.46,6.4,1.67a30.7,30.7,0,0,1,8.13,3.86,24.56,24.56,0,0,1,7,7.09q2.94,4.44,2.94,11.36a25.14,25.14,0,0,1-2.19,10.49,22.76,22.76,0,0,1-6.51,8.36,31.29,31.29,0,0,1-10.72,5.47,50.66,50.66,0,0,1-14.82,2,52.08,52.08,0,0,1-13.2-1.67,33.19,33.19,0,0,1-11.3-5.24,25.89,25.89,0,0,1-7.78-9.11,27.15,27.15,0,0,1-2.77-13.14H177.8A15.07,15.07,0,0,0,179.29,313Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#5e6174',
              d: 'M195.32,337.09a54.33,54.33,0,0,1-13.71-1.74,35.34,35.34,0,0,1-12-5.56,28,28,0,0,1-8.38-9.8,29.26,29.26,0,0,1-3-14.1l0-2H179.8v2a13.19,13.19,0,0,0,1.27,6.11h0a11,11,0,0,0,3.37,4,15.22,15.22,0,0,0,5.15,2.34,28,28,0,0,0,11.31.42,16,16,0,0,0,4.62-1.38,9.27,9.27,0,0,0,3.34-2.62,6,6,0,0,0,1.17-3.88,5.25,5.25,0,0,0-1.53-4,15,15,0,0,0-4.94-3,54.25,54.25,0,0,0-7.56-2.33c-3-.71-6-1.49-9-2.33a80,80,0,0,1-9.16-2.88,33,33,0,0,1-8.34-4.6,22.42,22.42,0,0,1-6.14-7.27A22.19,22.19,0,0,1,161,273.88a23.62,23.62,0,0,1,3-12,26.6,26.6,0,0,1,7.66-8.41,33.1,33.1,0,0,1,10.55-4.91A44.53,44.53,0,0,1,193.82,247a54.59,54.59,0,0,1,12.87,1.5,33.08,33.08,0,0,1,11.22,5,25.72,25.72,0,0,1,7.94,8.93,27.38,27.38,0,0,1,2.95,13.11v2h-21.4l-0.12-1.87a12.7,12.7,0,0,0-1.31-5.28,8.18,8.18,0,0,0-2.83-3.07,12.94,12.94,0,0,0-4.35-1.69A28.87,28.87,0,0,0,193,265a19.66,19.66,0,0,0-4,.42,9.89,9.89,0,0,0-3.3,1.34,8,8,0,0,0-2.36,2.31,5.84,5.84,0,0,0-.82,3.27,5.5,5.5,0,0,0,.62,2.87,6.22,6.22,0,0,0,2.78,2,44.86,44.86,0,0,0,7.16,2.41c3,0.8,7,1.82,12.44,3.21,1.59,0.32,3.72.88,6.52,1.7a32.82,32.82,0,0,1,8.66,4.11,26.66,26.66,0,0,1,7.54,7.66c2.17,3.28,3.27,7.48,3.27,12.46a27.25,27.25,0,0,1-2.37,11.31,24.83,24.83,0,0,1-7.07,9.09,33.4,33.4,0,0,1-11.4,5.83A52.86,52.86,0,0,1,195.32,337.09Zm-33-29.17a23.42,23.42,0,0,0,9.7,18.64,31.34,31.34,0,0,0,10.62,4.92,50.32,50.32,0,0,0,12.7,1.61,48.92,48.92,0,0,0,14.23-1.87,29.44,29.44,0,0,0,10-5.11,20.86,20.86,0,0,0,6-7.63,23.29,23.29,0,0,0,2-9.67A18.36,18.36,0,0,0,225,298.55a22.67,22.67,0,0,0-6.4-6.52,28.83,28.83,0,0,0-7.6-3.62c-2.68-.79-4.77-1.34-6.23-1.63l-0.1,0c-5.51-1.4-9.49-2.43-12.53-3.24a47.86,47.86,0,0,1-7.83-2.65,10,10,0,0,1-4.49-3.54,9.35,9.35,0,0,1-1.22-5,9.72,9.72,0,0,1,1.49-5.49,12.07,12.07,0,0,1,3.52-3.45,13.89,13.89,0,0,1,4.65-1.89,23.62,23.62,0,0,1,4.8-.5,32.93,32.93,0,0,1,6.57.62,16.91,16.91,0,0,1,5.68,2.23,12.25,12.25,0,0,1,4.2,4.53,15.17,15.17,0,0,1,1.6,5.07h13.66a22.1,22.1,0,0,0-2.41-9.21,21.74,21.74,0,0,0-6.71-7.56,29.08,29.08,0,0,0-9.87-4.36A50.59,50.59,0,0,0,193.82,251a40.5,40.5,0,0,0-10.55,1.43,29.08,29.08,0,0,0-9.28,4.31,22.62,22.62,0,0,0-6.52,7.15,19.7,19.7,0,0,0-2.44,10A17.39,17.39,0,0,0,172,288.54a29,29,0,0,0,7.33,4,76.29,76.29,0,0,0,8.77,2.75c3,0.84,5.92,1.61,8.85,2.3a58.3,58.3,0,0,1,8.12,2.51A19,19,0,0,1,211.3,304a9.17,9.17,0,0,1,2.74,6.85,9.94,9.94,0,0,1-2.05,6.38,13.37,13.37,0,0,1-4.74,3.73,20,20,0,0,1-5.76,1.73,32,32,0,0,1-12.89-.5,19.2,19.2,0,0,1-6.49-3,15.09,15.09,0,0,1-4.58-5.36h0a15.83,15.83,0,0,1-1.64-6H162.3Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#5e6174',
              d: 'M253.31,275.31a41.16,41.16,0,0,1,8-13.77A36.41,36.41,0,0,1,274,252.31a45.07,45.07,0,0,1,34.07,0,36.53,36.53,0,0,1,12.68,9.22,41.12,41.12,0,0,1,8,13.77,51.44,51.44,0,0,1,2.77,17.12,49.71,49.71,0,0,1-2.77,16.78,40,40,0,0,1-8,13.55,36.54,36.54,0,0,1-12.68,9.05,45.79,45.79,0,0,1-34.07,0,36.43,36.43,0,0,1-12.74-9.05,40.06,40.06,0,0,1-8-13.55,49.71,49.71,0,0,1-2.77-16.78A51.44,51.44,0,0,1,253.31,275.31Zm16.54,27.21a27.23,27.23,0,0,0,3.86,8.82,19.72,19.72,0,0,0,6.92,6.28,24,24,0,0,0,20.75,0,19.76,19.76,0,0,0,6.92-6.28,27.22,27.22,0,0,0,3.86-8.82,41.9,41.9,0,0,0,1.21-10.09,45.06,45.06,0,0,0-1.21-10.49,27.8,27.8,0,0,0-3.86-9.05,19.63,19.63,0,0,0-6.92-6.34,24,24,0,0,0-20.75,0,19.59,19.59,0,0,0-6.92,6.34,27.8,27.8,0,0,0-3.86,9.05,45.17,45.17,0,0,0-1.21,10.49A42,42,0,0,0,269.85,302.52Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#5e6174',
              d: 'M291,337.09a44.37,44.37,0,0,1-17.8-3.45,38.57,38.57,0,0,1-13.43-9.55,42.21,42.21,0,0,1-8.35-14.21,51.94,51.94,0,0,1-2.88-17.45,53.68,53.68,0,0,1,2.88-17.78h0a43.34,43.34,0,0,1,8.34-14.44,38.57,38.57,0,0,1,13.43-9.73,47.06,47.06,0,0,1,35.69,0,38.67,38.67,0,0,1,13.37,9.73,43.31,43.31,0,0,1,8.34,14.44,53.72,53.72,0,0,1,2.88,17.78,52,52,0,0,1-2.88,17.45,42.2,42.2,0,0,1-8.36,14.21,38.7,38.7,0,0,1-13.37,9.54A44.26,44.26,0,0,1,291,337.09ZM255.2,276a49.68,49.68,0,0,0-2.65,16.46,47.94,47.94,0,0,0,2.65,16.11,38.24,38.24,0,0,0,7.56,12.88A34.62,34.62,0,0,0,274.8,330a43.79,43.79,0,0,0,32.47,0,34.7,34.7,0,0,0,12-8.55,38.21,38.21,0,0,0,7.56-12.88,48,48,0,0,0,2.65-16.11A49.7,49.7,0,0,0,326.82,276a39.32,39.32,0,0,0-7.57-13.11,34.71,34.71,0,0,0-12-8.72,43.09,43.09,0,0,0-32.44,0,34.6,34.6,0,0,0-12.05,8.72A39.35,39.35,0,0,0,255.2,276h0ZM291,322a23.16,23.16,0,0,1-11.34-2.62,21.77,21.77,0,0,1-7.61-6.91,29.34,29.34,0,0,1-4.15-9.46h0a44.16,44.16,0,0,1-1.27-10.57,47.37,47.37,0,0,1,1.27-11,29.93,29.93,0,0,1,4.14-9.7,21.67,21.67,0,0,1,7.61-7,25.92,25.92,0,0,1,22.69,0,21.71,21.71,0,0,1,7.61,7,29.92,29.92,0,0,1,4.14,9.7,47.27,47.27,0,0,1,1.27,11A44.09,44.09,0,0,1,314.1,303a29.29,29.29,0,0,1-4.15,9.46,21.8,21.8,0,0,1-7.61,6.91A23.19,23.19,0,0,1,291,322ZM271.79,302a25.36,25.36,0,0,0,3.58,8.17,17.82,17.82,0,0,0,6.23,5.65,22,22,0,0,0,18.82,0,17.84,17.84,0,0,0,6.23-5.65,25.32,25.32,0,0,0,3.58-8.17,40.09,40.09,0,0,0,1.16-9.61,43.28,43.28,0,0,0-1.16-10,25.92,25.92,0,0,0-3.58-8.41,17.72,17.72,0,0,0-6.22-5.7,22,22,0,0,0-18.81,0,17.71,17.71,0,0,0-6.22,5.7,26,26,0,0,0-3.58,8.41,43.35,43.35,0,0,0-1.16,10,40.19,40.19,0,0,0,1.15,9.61h0Z'
            })
          ),
          _react2['default'].createElement('path', {
            fill: '#5e6174',
            d: 'M200.31,137.18a4.4,4.4,0,0,1-2.32-3.85A44.78,44.78,0,1,0,132.08,173h0a44.79,44.79,0,0,0,45.82-2.11,4.39,4.39,0,0,1,4.5-.21l26.38,14.12,12.08-8.34a4.39,4.39,0,0,1,6.88,3.69l-0.23,13.17,10.94-7.53a4.38,4.38,0,0,1,4.56-.26h0a4.39,4.39,0,0,1,2.3,4L245,204a23.18,23.18,0,0,0,5.64,2.92L276,199.24l-7.78-25.71Zm-54.9,6.93a18.42,18.42,0,1,1,12.3-23A18.3,18.3,0,0,1,145.41,144.11Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#5e6174',
            d: 'M144.62,118a9.64,9.64,0,1,0,4.68,5.7A9.61,9.61,0,0,0,144.62,118Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#5e6174',
            d: 'M316.07,132.25a49.15,49.15,0,0,0-6.35.45,5.81,5.81,0,0,1-5.83-3c-11.87-22-38.31-36.14-67.36-36.14a88.56,88.56,0,0,0-17.75,1.8,5.81,5.81,0,0,1-6-2.48,73.65,73.65,0,0,0-61.56-33.14c-38.22,0-70.5,29.82-73.49,67.88a5.79,5.79,0,0,1-4.9,5.27,50.45,50.45,0,0,0-42.4,46.74q-0.13,1.26-.14,2.64c0,0.1,0,.23,0,0.35,0,1.38.09,2.73,0.24,4.33,0,0.43.07,0.85,0.07,0.93s0.05,0.33.07,0.5c2.67,22.72,19.12,40.68,39.12,42.71,2.91,0.3,11,.4,17,0.4H311.24c3.46,0,13.12-.2,16.2-0.51,21.78-2.23,38.84-23.56,38.84-48.54A50.27,50.27,0,0,0,316.07,132.25Zm-36.7,75.14-26.84,8.12h-0.07c-4.15,1.25-14.81-4.46-16.07-8.61a5.87,5.87,0,0,1-.21-1.27,4.14,4.14,0,0,1,0-.52l0.18-7.26L230,202.27A4.38,4.38,0,0,1,228,203a8,8,0,0,1-9-5,4.41,4.41,0,0,1-.37-1.82l0.13-7.7-6.35,4.38a4.22,4.22,0,0,1-1.1.55l-0.13,0a7.92,7.92,0,0,1-6.44-.89l-24.3-13a53.61,53.61,0,0,1-52.56,1.12h0a53.59,53.59,0,1,1,78.75-50.1l65.88,35.26a7.58,7.58,0,0,1,3.94,4.72v0.06l8.12,26.83h0A8,8,0,0,1,279.37,207.39Z'
          })
        );
      }

      return render;
    }()
  }]);

  return Sso;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Sso;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trello = (_temp = _class = function (_SvgIcon) {
  _inherits(Trello, _SvgIcon);

  function Trello() {
    _classCallCheck(this, Trello);

    return _possibleConstructorReturn(this, (Trello.__proto__ || Object.getPrototypeOf(Trello)).apply(this, arguments));
  }

  _createClass(Trello, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'trello', transform: 'translate(10.000000, 10.000000)' },
            _react2['default'].createElement('path', {
              fill: '#FEFEFE',
              transform: 'translate(0.000000, 0.040245)',
              d: 'M22.5324639,0.0141519231 C16.9356227,0.0141519231 11.3387274,0.00981538462 5.74188628,0.0158442308 C2.48434116,0.0193346154 0.00777075812,2.41342115 0.00560469314,5.58073365 C-0.00192238267,16.5125654 -0.00181407942,27.4443442 0.00555054152,38.376176 C0.00760830325,41.5293154 2.4743231,43.9395317 5.70262635,43.9416471 C16.8963087,43.9489981 28.0900451,43.9488923 39.2837816,43.9417 C42.5126264,43.9396375 44.98037,41.5307433 44.9825361,38.3779212 C44.9901173,27.4461423 44.985352,16.5143106 44.9858394,5.58247885 C44.9858935,4.96827692 44.8999549,4.36745481 44.6958032,3.78572404 C43.8815253,1.4652 41.7987996,0.0175894231 39.2481498,0.0155269231 C33.6762184,0.0110846154 28.1043953,0.0141519231 22.5324639,0.0141519231'
            }),
            _react2['default'].createElement('path', {
              fill: '#0079BE',
              transform: 'translate(0.000000, 0.040245)',
              d: 'M25.417944,15.3262101 C25.417944,17.5953832 25.4166986,19.8645034 25.4184314,22.1336236 C25.4196769,23.8243447 26.5326011,24.9364553 28.2683231,24.9449168 C30.9414639,24.9579264 33.6148213,24.9579793 36.2880162,24.9448639 C38.0237924,24.9364024 39.1368249,23.8242918 39.1373123,22.1330947 C39.1386661,17.5948014 39.1386661,13.0565611 39.1373123,8.51826779 C39.1367708,6.8393399 37.992926,5.72643606 36.2687383,5.72543125 C33.607944,5.72395048 30.9471498,5.72395048 28.2864097,5.72543125 C26.5617888,5.72643606 25.4196769,6.83875817 25.4184314,8.51879663 C25.4166986,10.7879697 25.417944,13.0570899 25.417944,15.3262101 M5.85036282,20.8169553 C5.85036282,24.9164649 5.84949639,29.0159216 5.85085018,33.1153784 C5.8513917,34.780662 6.92278159,35.901763 8.62503791,35.9211187 C11.3481606,35.9520562 14.0721498,35.9520034 16.7953267,35.9211187 C18.4975289,35.9018159 19.5695686,34.7807678 19.5697852,33.1158014 C19.5707058,24.9168351 19.5707058,16.7178688 19.569731,8.5189024 C19.5695144,6.83812356 18.4272942,5.72643606 16.7020235,5.72543125 C14.0534675,5.72395048 11.4049657,5.72449362 8.7563556,5.7252726 C6.97909928,5.72580144 5.85095848,6.82410913 5.85063357,8.55512837 C5.84987545,12.6424216 5.85036282,16.7297149 5.85036282,20.8169553 M22.5324747,0.0141572115 C28.104352,0.0141572115 33.6762292,0.0110899038 39.2481065,0.0155322115 C41.7988105,0.0175947115 43.8815361,1.46520529 44.6958141,3.78572933 C44.8999657,4.3674601 44.9859043,4.96828221 44.9858502,5.58248413 C44.9853628,16.5143159 44.9901282,27.4461476 44.9825469,38.3779264 C44.9803809,41.5306957 42.5126372,43.9396428 39.2837924,43.9417053 C28.090056,43.9488976 16.8963195,43.9489505 5.70263718,43.9416524 C2.47433394,43.939537 0.00761913357,41.5293207 0.00556137184,38.3761813 C-0.0018032491,27.4443495 -0.00191155235,16.5125707 0.00561552347,5.58073894 C0.00778158845,2.41342644 2.48435199,0.0193399038 5.74184296,0.0158495192 C11.3387383,0.00982067308 16.9355794,0.0141572115 22.5324747,0.0141572115'
            }),
            _react2['default'].createElement('path', {
              fill: '#FEFEFE',
              d: 'M5.85037906,20.8572111 C5.85037906,16.7699178 5.84983755,12.6826774 5.85064982,8.59538413 C5.85097473,6.8643649 6.97911552,5.76605721 8.75637184,5.76547548 C11.4049278,5.76474415 14.0534296,5.76420625 16.7020397,5.76568702 C18.4273105,5.76669183 19.5695307,6.87837933 19.5697473,8.55915817 C19.570722,16.7581245 19.570722,24.9570909 19.5698014,33.1560572 C19.5695848,34.8210236 18.4975451,35.9420716 16.7952888,35.9613745 C14.0721661,35.9922591 11.3481227,35.992312 8.625,35.9613216 C6.92279783,35.9420187 5.85140794,34.8209178 5.85086643,33.1556341 C5.84945848,29.0561774 5.85037906,24.9567207 5.85037906,20.8572111'
            }),
            _react2['default'].createElement('path', {
              fill: '#FEFEFE',
              d: 'M25.417944,15.3664553 C25.417944,13.0973351 25.4166986,10.8282149 25.4184314,8.55904183 C25.4196769,6.87900337 26.5617888,5.76668125 28.2864097,5.76567644 C30.9471498,5.76419567 33.607944,5.76419567 36.2687383,5.76567644 C37.992926,5.76668125 39.1367708,6.8795851 39.1373123,8.55851298 C39.1386661,13.0968062 39.1386661,17.6350466 39.1373123,22.1733399 C39.1368249,23.864537 38.0237924,24.9766476 36.2880162,24.9851091 C33.6148213,24.9982245 30.9414639,24.9981716 28.2683231,24.985162 C26.5326011,24.9767005 25.4196769,23.8645899 25.4184314,22.1738687 C25.4166986,19.9047486 25.417944,17.6356284 25.417944,15.3664553'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return Trello;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Trello;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trigger = (_temp = _class = function (_SvgIcon) {
  _inherits(Trigger, _SvgIcon);

  function Trigger() {
    _classCallCheck(this, Trigger);

    return _possibleConstructorReturn(this, (Trigger.__proto__ || Object.getPrototypeOf(Trigger)).apply(this, arguments));
  }

  _createClass(Trigger, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M22.81 19.62a2.57 2.57 0 0 0-2.2-1.36l-5-.14 4.18-14.86a2.57 2.57 0 0 0-4.63-2.08L.41 24.1a2.54 2.54 0 0 0-.11 2.58 2.57 2.57 0 0 0 2.2 1.37l5 .13-4 14.52a2.58 2.58 0 0 0 1.43 3 2.6 2.6 0 0 0 1 .22 2.55 2.55 0 0 0 2.15-1.17L22.7 22.21a2.58 2.58 0 0 0 .11-2.59zM6 43.38l4.83-17.67-8.31-.23 14.8-22.91-5.08 18 8.3.23z' }),
          _react2['default'].createElement('path', { d: 'M38.85 20.71L27.7 10a.66.66 0 0 0-.45-.19.58.58 0 0 0-.38.14 1.27 1.27 0 0 0-.43 1v5.55H16.06l-.46 1.65 5 .14a2.56 2.56 0 0 1 2.09 3.95l-3 4.67h6.75v5.55a1.27 1.27 0 0 0 .43 1 .6.6 0 0 0 .83-.06l11.15-10.76a1.47 1.47 0 0 0 0-1.93z' })
        );
      }

      return render;
    }()
  }]);

  return Trigger;
}(_SvgIcon3['default']), _class.defaultProps = {
  preserveAspectRatio: 'xMidYMin',
  viewBox: '0 0 39.21 45.94'
}, _temp);
exports['default'] = Trigger;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UiPath = (_temp = _class = function (_SvgIcon) {
  _inherits(UiPath, _SvgIcon);

  function UiPath() {
    _classCallCheck(this, UiPath);

    return _possibleConstructorReturn(this, (UiPath.__proto__ || Object.getPrototypeOf(UiPath)).apply(this, arguments));
  }

  _createClass(UiPath, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2['default'].createElement('path', { d: 'M0 0h64v64H0z' }),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(11 11)' },
              _react2['default'].createElement('path', {
                fill: '#0085CA',
                d: 'M40.188 40.316H1.642V1.706h38.567v38.61h-.021zm1.684.383V1.258C41.872.554 41.318 0 40.614 0H1.258C.554 0 0 .554 0 1.258v39.441c0 .704.554 1.258 1.258 1.258h39.356a1.26 1.26 0 0 0 1.258-1.258z'
              }),
              _react2['default'].createElement('path', {
                fill: '#0085CA',
                d: 'M15.947 34.154c5.778 0 9.402-3.22 9.402-11.448V8.656h-4.221v14.39c0 5.437-2.132 7.228-5.18 7.228-3.007 0-5.032-1.79-5.032-7.227V8.656H6.503v14.05c0 8.229 3.688 11.448 9.444 11.448M33.387 12.067c1.556 0 2.707-1.023 2.707-2.494 0-1.493-1.15-2.516-2.707-2.516s-2.708 1.023-2.708 2.516c0 1.47 1.151 2.494 2.708 2.494'
              }),
              _react2['default'].createElement(
                'mask',
                { id: 'b', fill: '#fff' },
                _react2['default'].createElement('path', { d: 'M0 41.957h41.872V0H0z' })
              ),
              _react2['default'].createElement('path', {
                fill: '#0085CA',
                d: 'M31.17 34.133h4.37V15.35h-4.37z',
                mask: '#b'
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return UiPath;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = UiPath;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Word = function (_SvgIcon) {
  _inherits(Word, _SvgIcon);

  function Word() {
    _classCallCheck(this, Word);

    return _possibleConstructorReturn(this, (Word.__proto__ || Object.getPrototypeOf(Word)).apply(this, arguments));
  }

  _createClass(Word, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M0,0H24V24H0V0Z', fill: 'none' }),
          _react2['default'].createElement('path', {
            d: 'M12.8,2.08h1.37V3.91c2.45,0,4.89,0,7.34,0a0.79,0.79,0,0,1,.88.87c0,4.51,0,9,0,13.52a2.67,2.67,0,0,1-.22,1.38,2.09,2.09,0,0,1-1.16.23H14.17v1.83H12.74c-3.48-.64-7-1.22-10.46-1.83q0-8,0-16C5.78,3.3,9.29,2.7,12.8,2.08Z',
            fill: '#2a5699'
          }),
          _react2['default'].createElement('path', {
            d: 'M14.17,4.59h7.55V19.23H14.17V17.4h5.95V16.49H14.17V15.34h5.95V14.43H14.17V13.29h5.95V12.37H14.17V11.23h5.95V10.31H14.17V9.17h5.95V8.25H14.17V7.11h5.95V6.19H14.17V4.59Z',
            fill: '#fff'
          }),
          _react2['default'].createElement('path', {
            d: 'M7,8.64l1.3-.07c0.3,1.54.62,3.09,0.94,4.62C9.51,11.6,9.8,10,10.07,8.44l1.37-.07c-0.52,2.22-1,4.45-1.54,6.65A4,4,0,0,1,8.5,15c-0.3-1.51-.66-3-0.93-4.54C7.3,12,7,13.45,6.65,14.91l-1.32-.08c-0.38-2-.83-4-1.18-6l1.18,0c0.24,1.46.5,2.91,0.71,4.37C6.35,11.63,6.68,10.13,7,8.64Z',
            fill: '#fff'
          })
        );
      }

      return render;
    }()
  }]);

  return Word;
}(_SvgIcon3['default']);

exports['default'] = Word;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Workday = function (_SvgIcon) {
  _inherits(Workday, _SvgIcon);

  function Workday() {
    _classCallCheck(this, Workday);

    return _possibleConstructorReturn(this, (Workday.__proto__ || Object.getPrototypeOf(Workday)).apply(this, arguments));
  }

  _createClass(Workday, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#005DBE',
            d: 'M7.8,22.8c0.1-0.5,0.2-1.1,0.3-1.6c0.2-0.8,0.4-1.5,0.5-2.2c0.6-2.3,1.2-4.6,1.8-6.8c0.1-0.4,0.3-0.6,0.7-0.6c0.6,0,1.2,0,1.8,0c0.4,0,0.7,0.2,0.8,0.6c0.7,2.7,1.5,5.4,2.2,8.2c0.2,0.8,0.3,1.6,0.4,2.4c0,0,0,0.1,0.1,0.1c0-0.1,0-0.3,0.1-0.4c0.1-1.2,0.4-2.3,0.6-3.5c0.3-1.5,0.7-3,1-4.6c0.2-0.8,0.3-1.6,0.5-2.4c0.1-0.2,0.3-0.4,0.5-0.4c0.6,0,1.1,0,1.7,0c0.3,0,0.4,0.2,0.4,0.4c0,0.3-0.1,0.6-0.2,0.9c-0.7,2.4-1.3,4.9-2,7.3c-0.3,1.1-0.6,2.1-0.8,3.2c-0.1,0.3-0.3,0.5-0.7,0.5c-0.8,0-1.5,0-2.3,0c-0.4,0-0.5-0.1-0.6-0.4c-0.2-0.7-0.4-1.4-0.6-2.1c-0.5-2-1.1-4.1-1.6-6.1c-0.2-0.6-0.2-1.3-0.3-2c0-0.1,0-0.2-0.1-0.4c0,0.3-0.1,0.5-0.1,0.8c-0.1,1.1-0.4,2.1-0.7,3.1c-0.6,2.2-1.2,4.3-1.7,6.5c-0.1,0.3-0.3,0.5-0.6,0.5c-0.8,0-1.7,0-2.5,0c-0.3,0-0.4-0.1-0.5-0.4c-0.4-1.4-0.8-2.9-1.2-4.3c-0.6-2.3-1.3-4.7-1.9-7c-0.1-0.4,0.1-0.7,0.5-0.7c0.5,0,1,0,1.5,0c0.4,0,0.5,0.1,0.6,0.5c0.2,0.8,0.4,1.6,0.6,2.4c0.4,1.8,0.9,3.7,1.3,5.5c0.2,0.7,0.2,1.5,0.3,2.2C7.7,22.3,7.7,22.6,7.8,22.8C7.8,22.8,7.8,22.8,7.8,22.8z'
          }),
          _react2['default'].createElement('path', {
            fill: '#F48800',
            d: 'M21.3,6.9c0,0.7-0.7,1.1-1.4,1c-0.5-0.1-0.8-0.3-1-0.8c-0.4-1-0.9-1.8-1.7-2.6c-1.1-1.1-2.4-1.8-4-2.1c-1.9-0.3-3.6,0-5.2,1C6.8,4.4,5.8,5.6,5.2,7C5.1,7.3,4.9,7.7,4.6,7.8C3.9,8.2,3,7.9,2.8,7.2c0-0.2,0-0.5,0.1-0.7c0.9-2.2,2.4-4,4.5-5.2c1-0.6,2.2-0.9,3.3-1.1c2-0.2,3.8,0.1,5.6,0.9c1.9,0.9,3.3,2.4,4.3,4.2c0.2,0.3,0.3,0.7,0.5,1.1C21.2,6.6,21.3,6.8,21.3,6.9z'
          })
        );
      }

      return render;
    }()
  }]);

  return Workday;
}(_SvgIcon3['default']);

exports['default'] = Workday;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Wrike = (_temp = _class = function (_SvgIcon) {
  _inherits(Wrike, _SvgIcon);

  function Wrike() {
    _classCallCheck(this, Wrike);

    return _possibleConstructorReturn(this, (Wrike.__proto__ || Object.getPrototypeOf(Wrike)).apply(this, arguments));
  }

  _createClass(Wrike, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#647883',
            d: 'M6.3,24.2l-2.9-8.7h2l1.8,5.8l1.9-5.8h1.4l2,5.8l1.8-5.8h1.9l-2.9,8.7h-1.6l-1.9-5.7l-1.9,5.7H6.3z'
          }),
          _react2['default'].createElement('path', {
            fill: '#647883',
            d: 'M16.2,24.2v-6.1h1.7v1.4c0.5-1.6,2.3-1.3,2.3-1.3v1.7c0,0-2.3-0.2-2.3,1.7v2.7L16.2,24.2z'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#647883',
            points: '21.1,24.2 21.1,20.5 22.8,18.8 22.8,24.2'
          }),
          _react2['default'].createElement('path', {
            fill: '#647883',
            d: 'M24.3,24.2v-6.8l1.7-1.7v4.6l2.1-2.3h2.1l-2.7,2.8l3.1,3.4h-2.2L26,21.6v2.6L24.3,24.2z'
          }),
          _react2['default'].createElement('path', {
            fill: '#647883',
            d: 'M31.3,23.4c-0.6-0.6-1-1.4-1-2.3c0-0.8,0.3-1.7,0.9-2.3c0.6-0.6,1.3-0.9,2.3-0.9c0.8,0,1.6,0.3,2.1,0.9c0.5,0.6,0.8,1.4,0.8,2.3v0.4H32c0.2,0.8,1,1.3,2,1.3c0.7,0,1.4-0.2,1.9-0.5v1.4c-0.5,0.4-1.3,0.6-2.3,0.6C32.8,24.3,31.9,24,31.3,23.4z M34.7,20.5c0-0.7-0.6-1.2-1.2-1.2c0,0,0,0,0,0c-0.7,0-1.3,0.5-1.4,1.2H34.7z'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#00A651',
            points: '24.6,13.5 20.7,17.4 21.9,18.6 26.9,13.5'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#A6CE39',
            points: '21.2,15.6 18.9,15.6 21.9,18.6 23,17.4'
          })
        );
      }

      return render;
    }()
  }]);

  return Wrike;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40.2 40'
}, _temp);
exports['default'] = Wrike;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Xml = (_temp = _class = function (_SvgIcon) {
  _inherits(Xml, _SvgIcon);

  function Xml() {
    _classCallCheck(this, Xml);

    return _possibleConstructorReturn(this, (Xml.__proto__ || Object.getPrototypeOf(Xml)).apply(this, arguments));
  }

  _createClass(Xml, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          _extends({}, this.props, { id: 'xml', xmlns: 'http://www.w3.org/2000/svg' }),
          _react2['default'].createElement('path', { d: 'M37.05,1.81H13.5A4.86,4.86,0,0,0,8.65,6.66V33.17A4.86,4.86,0,0,0,13.5,38H37.05a4.86,4.86,0,0,0,4.85-4.85V6.66A4.86,4.86,0,0,0,37.05,1.81ZM13.5,4.31H37.05a2.35,2.35,0,0,1,2.35,2.35v14.5H11.15V6.66A2.35,2.35,0,0,1,13.5,4.31ZM37.05,35.52H13.5a2.35,2.35,0,0,1-2.35-2.35V22.66H39.41V33.17A2.35,2.35,0,0,1,37.05,35.52Z' }),
          _react2['default'].createElement('path', { d: 'M19.85,18.41a0.75,0.75,0,0,1-.6-0.3l-3.6-4.81a0.75,0.75,0,0,1,0-.9l3.6-4.81a0.75,0.75,0,1,1,1.2.9l-3.27,4.36,3.27,4.36A0.75,0.75,0,0,1,19.85,18.41Z' }),
          _react2['default'].createElement('path', { d: 'M30.47,18.41a0.75,0.75,0,0,1-.6-1.2l3.27-4.36L29.87,8.49a0.75,0.75,0,0,1,1.2-.9l3.6,4.81a0.75,0.75,0,0,1,0,.9l-3.6,4.81A0.75,0.75,0,0,1,30.47,18.41Z' }),
          _react2['default'].createElement('path', { d: 'M23.25,19.5a0.75,0.75,0,0,1-.71-1L26.64,7a0.75,0.75,0,1,1,1.41.5L24,19A0.75,0.75,0,0,1,23.25,19.5Z' }),
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', { d: 'M20.69,33.52H18l-0.45-1.29a11,11,0,0,1-.35-1.14,11,11,0,0,1-.39,1.24l-0.45,1.19H13.67l2.2-4.69L13.8,24.47h2.72l0.4,1.22q0.06,0.17.13,0.4t0.13,0.52q0.15-.59.25-0.9l0.38-1.24h2.74l-2.06,4.35Z' }),
            _react2['default'].createElement('path', { d: 'M31.23,33.52H28.67l-0.18-4.12-0.08-1.65q0,0.47-.09.91t-0.13.83l-0.77,4h-2l-0.66-4q-0.06-.35-0.16-1.21l-0.05-.53-0.06,1.67-0.22,4.1h-2.6l1.05-9h3l0.51,3q0.06,0.38.11,0.81t0.09,1a14.59,14.59,0,0,1,.21-1.54l0.62-3.28h3Z' }),
            _react2['default'].createElement('path', { d: 'M37.19,33.52H32.91v-9h2.44v6.87h1.83v2.17Z' })
          )
        );
      }

      return render;
    }()
  }]);

  return Xml;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 50 39.88'
}, _temp);
exports['default'] = Xml;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YouTube = (_temp = _class = function (_SvgIcon) {
  _inherits(YouTube, _SvgIcon);

  function YouTube() {
    _classCallCheck(this, YouTube);

    return _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).apply(this, arguments));
  }

  _createClass(YouTube, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'youtube-icon', transform: 'translate(6.000000, 14.000000)' },
            _react2['default'].createElement('path', {
              fill: '#FF0000',
              transform: 'translate(0.000000, 0.057371)',
              d: 'M0.246460392,10.7192534 C0.577762353,5.57500618 4.56336235,1.41946966 9.68576039,0.870809551 C14.9989584,0.335452809 20.6461604,0.0466241573 26.4999584,0.0466241573 C32.3538604,0.0466241573 38.0009584,0.335452809 43.3142604,0.873511798 C48.4366584,1.41946966 52.4223624,5.57500618 52.7535604,10.7192534 C52.9151584,13.2529219 52.9999584,15.8422983 52.9999584,18.471273 C52.9999584,21.1003517 52.9151584,23.6897281 52.7535604,26.2233966 C52.4223624,31.3675399 48.4366584,35.5232843 43.3142604,36.0718404 C38.0009584,36.6070933 32.3538604,36.8961298 26.4999584,36.8961298 C20.6461604,36.8961298 14.9989584,36.6070933 9.68576039,36.0692421 C4.56336235,35.5232843 0.577762353,31.3675399 0.246460392,26.2233966 C0.0847584314,23.6897281 -4.15686275e-05,21.1003517 -4.15686275e-05,18.471273 C-4.15686275e-05,15.8422983 0.0847584314,13.2529219 0.246460392,10.7192534'
            }),
            _react2['default'].createElement('polygon', {
              fill: '#FFFFFF',
              points: '34.5957292 18.5286854 21.5869312 26.4662247 21.5869312 10.5910421'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return YouTube;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = YouTube;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Zendesk = (_temp = _class = function (_SvgIcon) {
  _inherits(Zendesk, _SvgIcon);

  function Zendesk() {
    _classCallCheck(this, Zendesk);

    return _possibleConstructorReturn(this, (Zendesk.__proto__ || Object.getPrototypeOf(Zendesk)).apply(this, arguments));
  }

  _createClass(Zendesk, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'linearGradient',
            {
              id: 'linear-gradient',
              x1: '268.92',
              y1: '-238.81',
              x2: '291.61',
              y2: '92.03',
              gradientTransform: 'translate(-0.23 360.26)',
              gradientUnits: 'userSpaceOnUse'
            },
            _react2['default'].createElement('stop', { offset: '0', stopColor: '#90b91b' }),
            _react2['default'].createElement('stop', { offset: '0.51', stopColor: '#85b017' }),
            _react2['default'].createElement('stop', { offset: '1', stopColor: '#6f9d10' })
          ),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-2',
            x1: '316.93',
            y1: '-242.08',
            x2: '339.71',
            y2: '90.18',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-3',
            x1: '315.64',
            y1: '-242.01',
            x2: '338.33',
            y2: '88.84',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-4',
            x1: '257.69',
            y1: '-238.04',
            x2: '280.37',
            y2: '92.79',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-5',
            x1: '159.84',
            y1: '-231.34',
            x2: '182.53',
            y2: '99.5',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-6',
            x1: '87.49',
            y1: '-226.37',
            x2: '110.18',
            y2: '104.46',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-7',
            x1: '90.36',
            y1: '-226.57',
            x2: '113.05',
            y2: '104.3',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-8',
            x1: '134.16',
            y1: '-233.4',
            x2: '157.29',
            y2: '103.93',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-9',
            x1: '183.69',
            y1: '-232.96',
            x2: '206.38',
            y2: '97.88',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('linearGradient', {
            id: 'linear-gradient-10',
            x1: '135.52',
            y1: '-229.3',
            x2: '158.16',
            y2: '100.94',
            href: '#linear-gradient'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient)',
            d: 'M334.6,234.8a99.89,99.89,0,0,1-48.7,12.8,83.38,83.38,0,0,1-30.4-5.4,228.38,228.38,0,0,1-43,30,96.74,96.74,0,0,0,58.7,42.5,94.31,94.31,0,0,0,23.4,2.9,101.85,101.85,0,0,0,48.2-12.4A98.69,98.69,0,0,0,334.6,234.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-2)',
            d: 'M318,112.9c-1.2-.3-2.3-0.8-3.4-1.1v0.1A33.74,33.74,0,0,0,318,112.9Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-3)',
            d: 'M314.5,112.8c-2.9,19.5-11.3,36.8-23.1,49.6a64.51,64.51,0,0,1,1,11.1c0,22.8-11.8,42.5-26.5,58.5a106.57,106.57,0,0,0,12.6.8,96.85,96.85,0,0,0,59.8-20.6A98.73,98.73,0,0,0,374.9,150c-13.9-18.3-34.3-31.3-57-37-1.2-.3-2.3-0.7-3.5-0.9Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-4)',
            d: 'M299,96.1A97.63,97.63,0,0,0,272.5,29h-1.4c-23.2,0-43.5,8.2-61.9,24.9,17.6,18.7,23.9,42.4,23.9,66.1,0,1.9-.1,3.8-0.1,5.7a49.12,49.12,0,0,1,11.9-1.5h1c15.1,0.3,30.4,7.8,39.1,22A96,96,0,0,0,299,96.1Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-5)',
            d: 'M124.1,30.7a9.33,9.33,0,0,1-3.3-.3A97,97,0,0,0,95.5,95.8a2.22,2.22,0,0,1-.1.9h3.3a97.26,97.26,0,0,1,68.4,27.7c14.5,1,29.4,8.7,37.2,24,4.2-8.2,10.4-14.2,17-17.3v-3.4a97,97,0,0,0-97-97h-0.2Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-6)',
            d: 'M151.3,125.8a96.9,96.9,0,0,0-48.9-13.3A99.65,99.65,0,0,0,85.3,114a97.87,97.87,0,0,0-61.4,37.9A96.78,96.78,0,0,0,60,212.8c14.6-19.5,35-32.2,56.1-36.2v-3.1C116,147,132.5,130.6,151.3,125.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-7)',
            d: 'M65.9,235a96.43,96.43,0,0,0-11.4,45.4,110.07,110.07,0,0,0,3.3,26.3,97.24,97.24,0,0,0,46.6,11.9,102.41,102.41,0,0,0,23.7-2.9,100,100,0,0,1-3.6-26.4,98.87,98.87,0,0,1,18.3-57.2c-11.3-12.2-20.8-26.5-24.7-42.8A97,97,0,0,0,65.9,235Z'
          }),
          _react2['default'].createElement('path', { fill: 'url(#linear-gradient-8)', d: 'M148.1,325.26h0l-1.1.5h0Z' }),
          _react2['default'].createElement('path', {
            fill: 'url(#linear-gradient-9)',
            d: 'M200.6,375.4A96.67,96.67,0,0,0,251,325.5a97.07,97.07,0,0,1-52.5-51.9c-7.9-4.1-28.5-15.6-47.1-32.8a96.91,96.91,0,0,0-10.8,44.6,94.39,94.39,0,0,0,8.5,39.5A98.64,98.64,0,0,0,200.6,375.4Z'
          }),
          _react2['default'].createElement('path', { fill: 'url(#linear-gradient-10)', d: 'M149.1,324.9l-1,.5h0Z' }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M288,251.9a98.75,98.75,0,0,0,48.5-12.7c-0.7-1.5-1.3-3.1-2.1-4.6a99.89,99.89,0,0,1-48.7,12.8,83.38,83.38,0,0,1-30.4-5.4,228.38,228.38,0,0,1-43,30c0.9,1.4,1.9,2.8,2.9,4.1,9.1-5,26.3-15.2,42.3-29.6A83.92,83.92,0,0,0,288,251.9Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M314.5,111.7v0.1c1.2,0.2,2.3.7,3.5,0.9A29.23,29.23,0,0,1,314.5,111.7Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M293.4,166.8c11.8-12.9,20.2-30.2,23.1-49.6l0.1-.8v-0.14c1.2,0.3,2.3.8,3.4,1.1a103.77,103.77,0,0,1,54.5,34.1l0.3-1.5c-13.9-18.2-34.3-31.3-57-37a35.77,35.77,0,0,0-3.5-.9l-0.1.8c-2.9,19.5-11.3,36.8-23.1,49.6a64.51,64.51,0,0,1,1,11.1c0,22.8-11.8,42.5-26.5,58.5,1.9,0.2,3.9.2,5.8,0.4,12.9-15.2,22.8-33.5,22.9-54.3A50.21,50.21,0,0,0,293.4,166.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M273.2,33.4h1.4a97.81,97.81,0,0,1,14.9,20.86,96.86,96.86,0,0,0-17.1-25.4H271c-23.2,0-43.5,8.2-61.9,24.9,1.1,1.2,2.1,2.5,3.1,3.7C230.4,41.4,250.4,33.4,273.2,33.4Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M224.9,77.8c5.8,13.3,8.2,27.7,8.2,42.1,0,1.9-.1,3.8-0.1,5.7a18.46,18.46,0,0,1,2.3-.4v-0.7C235.2,108.26,232.2,92.26,224.9,77.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M122.9,34.8a9.33,9.33,0,0,0,3.3.3,96.51,96.51,0,0,1,87,54A97,97,0,0,0,124,30.6a9,9,0,0,1-3.3-.3A97,97,0,0,0,95.4,95.7a2.22,2.22,0,0,1-.1.9h2.47A95.91,95.91,0,0,1,122.9,34.8Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M26,156.2a97.83,97.83,0,0,1,78.5-39.4,96.44,96.44,0,0,1,42.6,10.1c1.4-.5,2.7-1,4.1-1.4a96.9,96.9,0,0,0-48.9-13.3,99.65,99.65,0,0,0-17.1,1.5,97.87,97.87,0,0,0-61.43,37.9,95.87,95.87,0,0,0,9.4,28.4A96.44,96.44,0,0,1,26,156.2Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M142.6,232a115.87,115.87,0,0,1-17.7-24.5,109.28,109.28,0,0,0,16.9,25.6A4.44,4.44,0,0,0,142.6,232Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M68,239.4a96.69,96.69,0,0,1,51.3-45.3c-0.5-1.6-1-3.2-1.4-4.8a97.66,97.66,0,0,0-63.5,91.1,110.73,110.73,0,0,0,3.3,26.3c0.4,0.2.9,0.4,1.3,0.6a109.2,109.2,0,0,1-2.5-22.5A96.55,96.55,0,0,1,68,239.4Z'
          }),
          _react2['default'].createElement('path', { fill: '#6f9d10', d: 'M146.9,325.7h0l1.1-.5h0Z' }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M249.6,328.2a24.37,24.37,0,0,0,1.4-2.8A97.29,97.29,0,0,1,202.6,282,96.87,96.87,0,0,0,249.6,328.2Z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6f9d10',
            d: 'M153.5,245.2a227,227,0,0,0,47.1,32.7c-0.7-1.5-1.5-3-2.1-4.5-7.9-4.1-28.5-15.6-47.1-32.8a96.91,96.91,0,0,0-10.8,44.6,94.39,94.39,0,0,0,8.5,39.5c0.6,1.3,1.3,2.5,1.9,3.7A97.68,97.68,0,0,1,153.5,245.2Z'
          }),
          _react2['default'].createElement('path', { fill: '#6f9d10', d: 'M147.9,325.2l1-.5-1,.5h0Z' })
        );
      }

      return render;
    }()
  }]);

  return Zendesk;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 399.75 400.17'
}, _temp);
exports['default'] = Zendesk;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trello = (_temp = _class = function (_SvgIcon) {
  _inherits(Trello, _SvgIcon);

  function Trello() {
    _classCallCheck(this, Trello);

    return _possibleConstructorReturn(this, (Trello.__proto__ || Object.getPrototypeOf(Trello)).apply(this, arguments));
  }

  _createClass(Trello, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'zoom', transform: 'translate(6.000000, 10.000000)' },
            _react2['default'].createElement('path', {
              fill: '#009BFE',
              d: 'M33.6962435,13.5324526 C33.6962435,12.129846 33.69653,10.7271682 33.6955989,9.32456161 C33.6955273,9.22851896 33.7001829,9.12885071 33.6775493,9.03693128 C33.6027008,8.73195498 33.2785245,8.5938981 33.0532628,8.77140995 C31.8156485,9.74640995 30.5816871,10.7258886 29.3424253,11.6988981 C29.2188716,11.795936 29.1755015,11.898519 29.176541,12.0533531 C29.1835603,13.0526659 29.1852077,14.0521919 29.1755015,15.0514336 C29.1737477,15.2310071 29.237351,15.3340877 29.376519,15.4387322 C30.593935,16.3538033 31.8056209,17.2763389 33.0190259,18.1965995 C33.24307,18.3665758 33.4593785,18.3279028 33.6168826,18.0933768 C33.7010424,17.968045 33.6964506,17.828282 33.6963868,17.687737 C33.6961719,16.3026185 33.6962435,14.9175 33.6962435,13.5324526 M23.1232683,18.3512204 C24.6610645,18.3512204 26.1989322,18.3512915 27.7367284,18.3512204 C28.447968,18.3512204 28.702811,18.0947986 28.7028826,17.3791351 C28.7030259,16.5194431 28.7029543,15.6598223 28.7029543,14.8002014 C28.7029543,13.5194431 28.7081829,12.2387559 28.7012353,10.9580687 C28.6956485,9.9468128 28.0707174,9.15558057 27.1057807,8.93150474 C26.9186953,8.88806872 26.7211526,8.87164692 26.5284088,8.87143365 C23.4351251,8.86780806 20.3418413,8.86816351 17.2485576,8.86951422 C16.6165355,8.86979858 16.3463826,9.14264218 16.3463826,9.76802133 C16.3463826,11.9258886 16.3463826,14.083827 16.3463826,16.2416943 C16.3463826,17.4878318 17.2197642,18.3505095 18.4833069,18.3510782 C20.0299846,18.351718 21.5766623,18.3512204 23.1232683,18.3512204 M25.0122435,26.9531161 C17.4528331,26.929372 11.3575879,20.8356754 11.4801388,13.2805806 C11.5983923,5.9882346 17.5723041,0.0288270142 25.1047118,0.0711128198 C32.6727174,0.114063981 38.7369488,6.27764218 38.5553785,13.8450355 C38.3821884,21.060391 32.4675107,26.9295853 25.0122435,26.9531161'
            }),
            _react2['default'].createElement('path', {
              fill: '#009BFE',
              transform: 'translate(35.526171, 32.504431)',
              d: 'M0.0141101928,6.2344763 C0.0141101928,4.41002133 0.0134385779,2.58549526 0.0144683196,0.761040284 C0.0148264463,0.0706848341 0.250258953,-0.0821587678 0.904126722,0.187912322 C1.28001653,0.343172986 1.64179614,0.52921564 1.93739394,0.811940758 C2.05915702,0.928315166 2.14818733,0.945590047 2.30719559,0.87400237 C4.28677686,-0.016471564 6.21557576,0.0848317536 8.08184573,1.19753318 C8.21370799,1.27615877 8.29292562,1.26371801 8.42629201,1.18964218 C11.2461102,-0.375476303 14.2782259,0.180163507 16.2299449,2.30049526 C16.3680386,2.45042417 16.4304242,2.60340995 16.4300676,2.80772275 C16.4251956,5.81689336 16.4276309,8.82613507 16.4259118,11.8353768 C16.4255537,12.4058033 16.1930579,12.5638365 15.6550083,12.3485758 C15.3909972,12.2430071 15.1332176,12.1152583 14.8879008,11.9717986 C14.3316584,11.646846 14.061416,11.1909455 14.0707989,10.5121066 C14.1015262,8.29708294 14.075741,6.08127725 14.0899945,3.8658981 C14.0919284,3.5644763 13.984562,3.39485545 13.7431129,3.23639573 C12.5065014,2.42497393 11.236011,2.27483175 9.89353719,2.97322038 C9.66268871,3.09329147 9.57415978,3.22537678 9.57509091,3.48819668 C9.58511846,6.27229621 9.58153719,9.05646682 9.58110744,11.8405664 C9.58103581,12.396064 9.36601653,12.5506848 8.84401102,12.3632204 C8.52950413,12.2502583 8.23168595,12.1009692 7.9551405,11.9120118 C7.48363085,11.5899028 7.23215427,11.1857559 7.23752617,10.5773673 C7.25779614,8.26765166 7.23129477,5.95750948 7.23516253,3.64765166 C7.23559229,3.40345735 7.15530028,3.26404976 6.95460606,3.13352844 C5.60153168,2.25357583 3.81053994,2.3437891 2.54456198,3.35497393 C2.38032507,3.48620616 2.35604408,3.63051896 2.35633058,3.81556635 C2.3597686,6.04281754 2.33734986,8.27049526 2.37087052,10.4972488 C2.38161433,11.2086469 2.08615978,11.6709455 1.50570799,12.002936 C1.2692011,12.1381493 1.02087603,12.2580782 0.767035813,12.3574621 C0.252837466,12.5587891 0.0164738292,12.3967749 0.015184573,11.8501635 C0.0120330579,10.4877227 0.0141101928,9.12528199 0.0141101928,7.76284123 L0.0141101928,6.2344763 Z'
            }),
            _react2['default'].createElement('path', {
              fill: '#009BFE',
              d: 'M3.68914215,42.2581422 L5.32957741,42.2581422 C6.74990799,42.2581422 8.17038182,42.2691611 9.59056915,42.2519573 C10.0659466,42.246128 10.4196325,42.4271943 10.7046298,42.7785924 C10.9917041,43.1326209 11.2007785,43.5308673 11.3362937,43.9635924 C11.4537592,44.3388057 11.2862275,44.5709147 10.8887069,44.5714834 C7.97634876,44.5753223 5.06406226,44.5792322 2.15177576,44.5691374 C1.45478953,44.5667204 0.558613223,43.898545 0.351687603,43.2356303 C0.210012672,42.7817204 0.359638017,42.359019 0.681379063,42.0265308 C2.83808981,39.7977867 5.00382534,37.5775024 7.16590799,35.3538768 C7.27900441,35.2375735 7.38508154,35.1145877 7.54817245,34.9358673 L7.13926336,34.9358673 C5.40865179,34.9358673 3.6779686,34.9370758 1.9472854,34.9352986 C1.21513113,34.9345166 0.310073278,34.2944929 0.0642550964,33.6103223 C-0.142455647,33.0351327 0.163957576,32.6002038 0.777213774,32.6014098 C3.59373719,32.6072417 6.41026061,32.6211754 9.2267124,32.6136398 C9.74427713,32.612218 10.1205251,32.8109858 10.4192744,33.2026919 C10.4838804,33.2873602 10.5416105,33.3775024 10.5976931,33.4680711 C11.199346,34.439019 11.1737758,34.5717441 10.3907675,35.3728578 C8.17317521,37.64191 5.96432121,39.9194218 3.68914215,42.2581422'
            }),
            _react2['default'].createElement('path', {
              fill: '#009BFE',
              d: 'M28.9477052,42.3406852 C31.031,42.341609 32.7207851,40.6714194 32.7049559,38.6270829 C32.6891983,36.6044289 30.974416,34.9232204 28.9403994,34.9363009 C26.9025152,34.9493815 25.2373691,36.6118223 25.2365092,38.6341919 C25.2355785,40.6970829 26.8804545,42.3397607 28.9477052,42.3406852 M29.0132424,32.6973176 C32.5950826,32.8428412 35.1168678,35.5259218 34.9261295,39.0801398 C34.7605317,42.1658744 32.0765152,44.7380545 28.6420799,44.5914668 C25.367011,44.4517749 22.8094848,41.6332678 22.9847521,38.3046896 C23.150135,35.1640735 25.7577989,32.6945474 29.0132424,32.6973176'
            }),
            _react2['default'].createElement('path', {
              fill: '#009BFE',
              d: 'M16.2311625,42.34069 C18.3212617,42.3440261 19.9751625,40.7253057 19.9785341,38.6730782 C19.9818953,36.6145948 18.3383802,34.9532915 16.2819449,34.9364431 C14.2310964,34.9195948 12.5123747,36.6189313 12.5179479,38.6577938 C12.5234766,40.6824384 14.1920606,42.3373436 16.2311625,42.34069 M16.2526501,44.5928175 C12.9503636,44.5929597 10.2538843,41.921609 10.2572475,38.6533863 C10.2605455,35.377628 12.9370413,32.7145237 16.2430523,32.6975239 C19.5661102,32.6806137 22.2490523,35.3606374 22.2476204,38.695827 C22.246259,41.9380308 19.547416,44.5928175 16.2526501,44.5928175'
            }),
            _react2['default'].createElement('path', {
              fill: '#FDFEFE',
              d: 'M23.1232826,18.3511991 C21.5766766,18.3511991 20.0299989,18.3516967 18.4833212,18.3510569 C17.2197785,18.3504882 16.3463791,17.4878104 16.3463791,16.2417441 C16.3463791,14.0838057 16.3463791,11.9259384 16.3463791,9.768 C16.3463791,9.14262085 16.6165499,8.86977725 17.2485719,8.86949289 C20.3418556,8.86814218 23.4351394,8.86785782 26.5284231,8.87141232 C26.7211669,8.87162559 26.918638,8.88804739 27.105795,8.9315545 C28.0707317,9.15555924 28.6956628,9.94679147 28.701178,10.9580474 C28.7081972,12.2387346 28.702897,13.5194929 28.702897,14.8001801 C28.702897,15.6598009 28.7029686,16.5194218 28.702897,17.3791137 C28.7028253,18.0947773 28.4479824,18.3511991 27.7367427,18.3511991 C26.1988749,18.3512701 24.6610788,18.3511991 23.1232826,18.3511991'
            }),
            _react2['default'].createElement('path', {
              fill: '#FEFEFE',
              d: 'M33.6962435,13.5324526 C33.6962435,14.9175 33.6961719,16.3026185 33.6963868,17.687737 C33.6964506,17.828282 33.7010424,17.968045 33.6168826,18.0933768 C33.4593785,18.3279028 33.24307,18.3665758 33.0190259,18.1965995 C31.8056209,17.2763389 30.593935,16.3538033 29.376519,15.4387322 C29.237351,15.3340877 29.1737477,15.2310071 29.1755015,15.0514336 C29.1852077,14.0521919 29.1835603,13.0526659 29.176541,12.0533531 C29.1755015,11.898519 29.2188716,11.795936 29.3424253,11.6988981 C30.5816871,10.7258886 31.8156485,9.74640995 33.0532628,8.77140995 C33.2785245,8.5938981 33.6027008,8.73195498 33.6775493,9.03693128 C33.7001829,9.12885071 33.6955273,9.22851896 33.6955989,9.32456161 C33.69653,10.7271682 33.6962435,12.129846 33.6962435,13.5324526'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return Trello;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Trello;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIELD_TYPE_BOOL = exports.FIELD_TYPE_BOOL = 'bool';
var FIELD_TYPE_CHOICE = exports.FIELD_TYPE_CHOICE = 'choice';
var FIELD_TYPE_DATE = exports.FIELD_TYPE_DATE = 'date';
var FIELD_TYPE_EMAIL = exports.FIELD_TYPE_EMAIL = 'email';
var FIELD_TYPE_FILE = exports.FIELD_TYPE_FILE = 'file';
var FIELD_TYPE_MANY = exports.FIELD_TYPE_MANY = 'many';
var FIELD_TYPE_NUMBER = exports.FIELD_TYPE_NUMBER = 'number';
var FIELD_TYPE_PHONE = exports.FIELD_TYPE_PHONE = 'phone';
var FIELD_TYPE_PHOTO = exports.FIELD_TYPE_PHOTO = 'photo';
var FIELD_TYPE_STRING = exports.FIELD_TYPE_STRING = 'string';

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getProcessFieldsSuccess = getProcessFieldsSuccess;

var _property = __webpack_require__(813);

var _property2 = _interopRequireDefault(_property);

var _differenceBy = __webpack_require__(402);

var _differenceBy2 = _interopRequireDefault(_differenceBy);

var _merge = __webpack_require__(546);

var _merge2 = _interopRequireDefault(_merge);

var _schemas = __webpack_require__(8);

var schemas = _interopRequireWildcard(_schemas);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getProcessFieldsSuccess(state, action) {
  var processID = action.payload.processID;
  var fields = action.response;
  var processes = (0, _property2.default)('processes', state) || {};
  var process = (0, _property2.default)('processes.' + processID, state) || {};
  var nextState = _extends({}, state, {
    processes: _extends({}, processes, _defineProperty({}, processID, _extends({}, process, {
      fields: fields
    })))
  });
  var nextStateFields = (0, _differenceBy2.default)(Object.values(nextState.fields), fields, 'fieldName');
  var fieldIDAttribute = schemas.FIELD.getIdAttribute();
  nextState.fields = schemas.mapEntitiesByID(nextStateFields, fieldIDAttribute);
  return (0, _merge2.default)(nextState, {
    fields: schemas.mapEntitiesByID(fields, fieldIDAttribute)
  });
}

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(396),
    func = convert('get', __webpack_require__(418));

func.placeholder = __webpack_require__(251);
module.exports = func;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = feature;

var _feature = __webpack_require__(526);

var _auth = __webpack_require__(92);

var _changeCase = __webpack_require__(256);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var normalize = function normalize() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(features).reduce(function (o, k) {
    return _extends({}, o, _defineProperty({}, (0, _changeCase.camelCase)(k), features[k].current || features[k]));
  }, _extends({}, state));
};

function feature() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  switch (type) {
    case _auth.AUTHENTICATION_INVALIDATE:
      return {};
    case _feature.FEATURE_INITIALIZE:
      return normalize(payload);
    case _feature.FEATURE_UPDATE:
      return normalize(payload, state);
    default:
      return state;
  }
}

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = features;

var _features = __webpack_require__(814);

function features() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _features.GET_FEATURES_SUCCESS:
      return _extends({}, state, action.response);
    default:
      return state;
  }
}

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = env;
function env() // eslint-disable-line no-unused-vars
{
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return state;
}

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = session;

var _auth = __webpack_require__(92);

var _session = __webpack_require__(569);

var _api = __webpack_require__(7);

var _api2 = _interopRequireDefault(_api);

var _file = __webpack_require__(222);

var _file2 = _interopRequireDefault(_file);

var _userSessionCookie = __webpack_require__(517);

var _userSessionCookie2 = _interopRequireDefault(_userSessionCookie);

var _invite = __webpack_require__(257);

var _user = __webpack_require__(187);

var _session2 = __webpack_require__(1427);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_SESSION_INTIALIZE = _userSessionCookie2.default.INITIALIZE;

function setUserSession(user) {
  var defaultKey = (0, _session2.getKey)();
  var _user$userKey = user.userKey,
      userKey = _user$userKey === undefined ? defaultKey : _user$userKey,
      teamName = user.teamName; // eslint-disable-line no-unused-vars

  // TODO Pull these out once users are moved over to session auth via catalytic-web

  _api2.default.update({ headers: { 'x-user-key': userKey } });
  _file2.default.update({ headers: { 'x-user-key': userKey } });
  if (userKey && userKey !== defaultKey) (0, _session2.setKey)(userKey);
}

function session() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _auth.AUTHENTICATION_SUCCESS:
      var type = action.type,
          _action$response = action.response;
      _action$response = _action$response === undefined ? {} : _action$response;
      var users = _action$response.entities.users,
          userID = _action$response.result;
      var isWelcome = state.isWelcome;

      var user = users[userID];
      var userKey = user.userKey,
          teamName = user.teamName,
          username = user.username,
          fullName = user.fullName,
          email = user.email,
          isTeamAdmin = user.isTeamAdmin,
          isTeamOwner = user.isTeamOwner,
          userThumbnail = user.userThumbnail,
          experience = user.experience;


      setUserSession(user);

      return {
        userKey: userKey,
        username: username,
        fullName: fullName,
        teamName: teamName,
        userID: userID,
        email: email,
        isTeamAdmin: isTeamAdmin,
        isTeamOwner: isTeamOwner,
        userThumbnail: userThumbnail,
        isWelcome: isWelcome,
        experience: experience,
        newlyAuthenticated: true
      };
    case _invite.ACCEPT_INVITE_SUCCESS:
      return function () {
        var type = action.type,
            _action$response2 = action.response;
        _action$response2 = _action$response2 === undefined ? {} : _action$response2;
        var invites = _action$response2.entities.invites,
            inviteID = _action$response2.result;
        var isWelcome = state.isWelcome;

        var user = invites[inviteID];
        var userKey = user.userKey,
            teamName = user.teamName,
            username = user.username,
            fullName = user.fullName,
            email = user.email,
            isTeamAdmin = user.isTeamAdmin,
            isTeamOwner = user.isTeamOwner,
            userThumbnail = user.userThumbnail,
            userID = user.userID,
            experience = user.experience;


        setUserSession(user);

        return {
          userKey: userKey,
          username: username,
          fullName: fullName,
          teamName: teamName,
          userID: userID,
          email: email,
          isTeamAdmin: isTeamAdmin,
          isTeamOwner: isTeamOwner,
          userThumbnail: userThumbnail,
          isWelcome: isWelcome,
          experience: experience
        };
      }();
    case USER_SESSION_INTIALIZE:
      return function () {
        var userKey = state.userKey,
            teamName = state.teamName,
            username = state.username,
            isWelcome = state.isWelcome; // eslint-disable-line no-unused-vars

        setUserSession(state);
        return _extends({}, state, {
          newlyAuthenticatedSSO: true
        });
      }();

    case _auth.LOGOUT_SUCCESS:
    case _auth.AUTHENTICATION_INVALIDATE:
      return {};

    case _session.SET_WELCOME:
      return _extends({}, state, {
        isWelcome: action.isWelcome
      });

    case _session.RESET_NEWLY_AUTHENTICATED:
      return _extends({}, state, {
        newlyAuthenticated: false,
        newlyAuthenticatedSSO: false
      });

    case _user.GET_USER_SUCCESS:
    case _user.UPDATE_USER_SUCCESS:
    case _user.UNLOCK_USER_SUCCESS:
      return function () {
        var _action$response3 = action.response;
        _action$response3 = _action$response3 === undefined ? {} : _action$response3;
        var users = _action$response3.entities.users,
            userID = _action$response3.result;

        if (state.userID !== userID) {
          return state;
        }
        var user = users[userID];
        var experience = user.experience;


        return _extends({}, state, {
          experience: experience
        });
      }();

    default:
      return state;
  }
}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKEN_KEY = undefined;
exports.getKey = getKey;
exports.setKey = setKey;
exports.invalidateKey = invalidateKey;

var _jsCookie = __webpack_require__(518);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOKEN_KEY = exports.TOKEN_KEY = 'token';

function getKey() {
  return _jsCookie2.default.get(TOKEN_KEY);
}

function setKey(key) {
  return _jsCookie2.default.set(TOKEN_KEY, key);
}

function invalidateKey() {
  _jsCookie2.default.remove(TOKEN_KEY);
}

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(80);

var _AddIntegration = __webpack_require__(1429);

var _AddIntegration2 = _interopRequireDefault(_AddIntegration);

var _AddTeamMember = __webpack_require__(1431);

var _AddTeamMember2 = _interopRequireDefault(_AddTeamMember);

var _IntegrationList = __webpack_require__(1432);

var _IntegrationList2 = _interopRequireDefault(_IntegrationList);

var _Invites = __webpack_require__(1434);

var _Invites2 = _interopRequireDefault(_Invites);

var _Join = __webpack_require__(1436);

var _Join2 = _interopRequireDefault(_Join);

var _Login = __webpack_require__(1437);

var _Login2 = _interopRequireDefault(_Login);

var _PhoneVerification = __webpack_require__(1439);

var _PhoneVerification2 = _interopRequireDefault(_PhoneVerification);

var _ProcessList = __webpack_require__(1440);

var _ProcessList2 = _interopRequireDefault(_ProcessList);

var _Profile = __webpack_require__(1442);

var _Profile2 = _interopRequireDefault(_Profile);

var _RunList = __webpack_require__(1444);

var _RunList2 = _interopRequireDefault(_RunList);

var _Team = __webpack_require__(1446);

var _Team2 = _interopRequireDefault(_Team);

var _SingleIntegration = __webpack_require__(1447);

var _SingleIntegration2 = _interopRequireDefault(_SingleIntegration);

var _StartRun = __webpack_require__(1449);

var _StartRun2 = _interopRequireDefault(_StartRun);

var _tasks = __webpack_require__(1451);

var _tasks2 = _interopRequireDefault(_tasks);

var _TeamList = __webpack_require__(1458);

var _TeamList2 = _interopRequireDefault(_TeamList);

var _Webform = __webpack_require__(1460);

var _Webform2 = _interopRequireDefault(_Webform);

var _XIntegrationList = __webpack_require__(1462);

var _XIntegrationList2 = _interopRequireDefault(_XIntegrationList);

var _XLogin = __webpack_require__(1463);

var _XLogin2 = _interopRequireDefault(_XLogin);

var _XProfile = __webpack_require__(1464);

var _XProfile2 = _interopRequireDefault(_XProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  AddIntegration: _AddIntegration2.default,
  AddTeamMember: _AddTeamMember2.default,
  IntegrationList: _IntegrationList2.default,
  Invites: _Invites2.default,
  Join: _Join2.default,
  Login: _Login2.default,
  PhoneVerification: _PhoneVerification2.default,
  ProcessList: _ProcessList2.default,
  Profile: _Profile2.default,
  RunList: _RunList2.default,
  SingleIntegration: _SingleIntegration2.default,
  StartRun: _StartRun2.default,
  tasks: _tasks2.default,
  Team: _Team2.default,
  TeamList: _TeamList2.default,
  Webform: _Webform2.default,
  XIntegrationList: _XIntegrationList2.default,
  XLogin: _XLogin2.default,
  XProfile: _XProfile2.default
});

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AddIntegration;

var _apps = __webpack_require__(390);

var _integration = __webpack_require__(258);

var _AddIntegration = __webpack_require__(1430);

function AddIntegration() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _AddIntegration.ADDINT_INITIALIZE:
      var defaults = {
        selected: null,
        connectionName: '',
        connected: false,
        saving: false,
        error: false,
        isLoading: true
      };
      return _extends({}, state, defaults);
    case _AddIntegration.ADDINT_SAVE_CONNECTION:
      return _extends({}, state, {
        connected: true,
        saving: true,
        error: false
      });
    case _AddIntegration.ADDINT_SELECT_APP:
      return _extends({}, state, {
        selected: state.selected && state.selected === action.appID ? null : action.appID
      });
    case _AddIntegration.ADDINT_CHANGE_NAME:
      return _extends({}, state, {
        connectionName: action.name
      });
    case _apps.GET_APPS_SUCCESS:
      return _extends({}, state, {
        isLoading: false
      });
    case _integration.ADD_INTEGRATION_FAILURE:
      return _extends({}, state, {
        saving: false,
        connected: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.savingConnection = savingConnection;
exports.selectApp = selectApp;
exports.changeName = changeName;
var ADDINT_INITIALIZE = exports.ADDINT_INITIALIZE = 'PAGE_ADDINT_INITIALIZE';
var ADDINT_SAVE_CONNECTION = exports.ADDINT_SAVE_CONNECTION = 'PAGE_ADDINT_SAVE_CONNECTION';
var ADDINT_SELECT_APP = exports.ADDINT_SELECT_APP = 'PAGE_ADDINT_SELECT_APP';
var ADDINT_CHANGE_NAME = exports.ADDINT_CHANGE_NAME = 'PAGE_ADDINT_CHANGE_NAME';

function initialize() {
  return {
    type: ADDINT_INITIALIZE
  };
}

function savingConnection() {
  return {
    type: ADDINT_SAVE_CONNECTION
  };
}

function selectApp(appID) {
  return {
    type: ADDINT_SELECT_APP,
    appID: appID
  };
}

function changeName(name) {
  return {
    type: ADDINT_CHANGE_NAME,
    name: name
  };
}

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AddTeamMember;

var _invite = __webpack_require__(257);

var _AddTeamMember = __webpack_require__(815);

function AddTeamMember() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _AddTeamMember.ADDTEAM_INITIALIZE:
      var defaults = {
        sending: false,
        email: '',
        message: '',
        phone: '',
        addPhone: false,
        success: false,
        successEmail: '',
        error: false,
        resetTextField: false,
        isAdmin: false,
        isRestricted: false
      };
      return _extends({}, state, defaults);
    case _AddTeamMember.ADDTEAM_CHANGE_EMAIL:
      return _extends({}, state, {
        email: action.email
      });
    case _AddTeamMember.ADDTEAM_CHANGE_PHONE:
      return _extends({}, state, {
        phone: action.phone
      });
    case _AddTeamMember.ADDTEAM_CHANGE_MESSAGE:
      return _extends({}, state, {
        message: action.message
      });

    case _AddTeamMember.ADDTEAM_CLEAR_SUCCESS:
      return _extends({}, state, {
        success: false
      });
    case _AddTeamMember.ADDTEAM_RENDER_TEXTFIELD:
      return _extends({}, state, {
        resetTextField: false
      });
    case _invite.ADD_INVITE_REQUEST:
      return _extends({}, state, {
        sending: true
      });
    case _invite.ADD_INVITE_SUCCESS:
      return _extends({}, state, {
        successEmail: JSON.parse(action.payload.options.body).email,
        success: true,
        sending: false,
        error: false,
        email: '',
        phone: '',
        message: '',
        isAdmin: false,
        isRestricted: false,
        permissions: 'Team member',
        resetTextField: true
      });
    case _invite.ADD_INVITE_FAILURE:
      return _extends({}, state, {
        sending: false,
        error: 'There was a problem sending the invitation: ' + action.error,
        success: false
      });
    case _AddTeamMember.ADDTEAM_FORM_ERROR:
      return _extends({}, state, {
        error: action.error
      });
    case _AddTeamMember.ADDTEAM_ADD_PHONE:
      return _extends({}, state, {
        addPhone: !state.addPhone
      });
    case _AddTeamMember.ADDTEAM_CHANGE_PREFS:
      return _extends({}, state, {
        notificationPreference: action.prefs
      });
    case _AddTeamMember.ADDTEAM_CHANGE_PERMISSIONS:
      return _extends({}, state, {
        isAdmin: action.permissions === 'Admin',
        isRestricted: action.permissions === 'Restricted user',
        permissions: action.permissions
      });
    default:
      return state;
  }
}

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = IntegrationList;

var _integrations = __webpack_require__(395);

var _IntegrationList = __webpack_require__(1433);

function IntegrationList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _IntegrationList.INTLIST_INITIALIZE:
      var defaults = {
        loadingInts: true
      };
      return _extends({}, state, defaults);
    case _integrations.GET_INTEGRATIONS_SUCCESS:
      return _extends({}, state, {
        loadingInts: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
var INTLIST_INITIALIZE = exports.INTLIST_INITIALIZE = 'PAGE_INTLIST_INITIALIZE';

function initialize() {
  return {
    type: INTLIST_INITIALIZE
  };
}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Invites;

var _Invites = __webpack_require__(1435);

function Invites() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _Invites.SET_PENDING_USERNAME:
      return _extends({}, state, { username: action.username });
    case _Invites.SET_PENDING_EMAIL:
      return _extends({}, state, { email: action.email });
    case _Invites.SET_PENDING_FULLNAME:
      return _extends({}, state, { fullName: action.fullName });
    case _Invites.SET_PENDING_PASSWORD:
      return _extends({}, state, { password: action.password });
    case _Invites.SET_PENDING_PASSWORD_CONFIRM:
      return _extends({}, state, { passwordConfirm: action.passwordConfirm });
    case _Invites.SET_ADDUSER_SAVING:
      return _extends({}, state, { saving: action.saving });
    case _Invites.SET_INVITE_ERROR:
      return _extends({}, state, { error: action.error });
    case _Invites.SET_INVITE_LOADING:
      return _extends({}, state, { loading: action.loading });
    default:
      return state;
  }
}

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPendingUsername = setPendingUsername;
exports.setPendingEmail = setPendingEmail;
exports.setPendingFullName = setPendingFullName;
exports.setPendingPassword = setPendingPassword;
exports.setPendingPasswordConfirm = setPendingPasswordConfirm;
exports.setAddUserSaving = setAddUserSaving;
exports.setError = setError;
exports.setLoading = setLoading;
var SET_PENDING_USERNAME = exports.SET_PENDING_USERNAME = 'PAGE_SET_PENDING_USERNAME';
var SET_PENDING_EMAIL = exports.SET_PENDING_EMAIL = 'PAGE_SET_PENDING_EMAIL';
var SET_PENDING_FULLNAME = exports.SET_PENDING_FULLNAME = 'PAGE_SET_PENDING_FULLNAME';
var SET_PENDING_PASSWORD = exports.SET_PENDING_PASSWORD = 'PAGE_SET_PENDING_PASSWORD';
var SET_PENDING_PASSWORD_CONFIRM = exports.SET_PENDING_PASSWORD_CONFIRM = 'PAGE_SET_PENDING_PASSWORD_CONFIRM';
var SET_ADDUSER_SAVING = exports.SET_ADDUSER_SAVING = 'PAGE_SET_ADDUSER_SAVING';
var SET_INVITE_ERROR = exports.SET_INVITE_ERROR = 'PAGE_SET_INVITE_ERROR';
var SET_INVITE_LOADING = exports.SET_INVITE_LOADING = 'PAGE_SET_INVITE_LOADING';

function setPendingUsername(username) {
  return { type: SET_PENDING_USERNAME, username: username };
}

function setPendingEmail(email) {
  return { type: SET_PENDING_EMAIL, email: email };
}

function setPendingFullName(fullName) {
  return { type: SET_PENDING_FULLNAME, fullName: fullName };
}

function setPendingPassword(password) {
  return { type: SET_PENDING_PASSWORD, password: password };
}

function setPendingPasswordConfirm(passwordConfirm) {
  return { type: SET_PENDING_PASSWORD_CONFIRM, passwordConfirm: passwordConfirm };
}

function setAddUserSaving(saving) {
  return { type: SET_ADDUSER_SAVING, saving: saving };
}

function setError(error) {
  return { type: SET_INVITE_ERROR, error: error };
}

function setLoading(loading) {
  return { type: SET_INVITE_LOADING, loading: loading };
}

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Join;

var _team = __webpack_require__(118);

var _Join = __webpack_require__(816);

function Join() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _Join.JOIN_INITIALIZE:
      var defaults = {
        loading: true
      };
      return _extends({}, state, defaults);
    case _team.GET_AUTH_INFO_SUCCESS:
    case _team.GET_AUTH_INFO_FAILURE:
      return _extends({}, state, {
        loading: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Login;

var _Login = __webpack_require__(1438);

function Login() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _Login.SET_TEAM_NAME:
      return _extends({}, state, { teamName: action.teamName });
    case _Login.SET_USER_NAME:
      return _extends({}, state, { userName: action.userName });
    case _Login.SET_PASSWORD:
      return _extends({}, state, { password: action.password });
    case _Login.SET_PENDING_TEAM_NAME:
      return _extends({}, state, { pendingTeamName: action.pendingTeamName });
    case _Login.SET_SAVING:
      return _extends({}, state, { saving: action.saving });
    case _Login.SET_SUCCESS_MESSAGE:
      return _extends({}, state, { successMessage: action.message });
    case _Login.SET_ERROR_MESSAGE:
      return _extends({}, state, { errorMessage: action.message });
    default:
      return state;
  }
}

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTeamName = setTeamName;
exports.setUserName = setUserName;
exports.setPassword = setPassword;
exports.setPendingTeamName = setPendingTeamName;
exports.setSaving = setSaving;
exports.setSuccessMessage = setSuccessMessage;
exports.setErrorMessage = setErrorMessage;
var SET_TEAM_NAME = exports.SET_TEAM_NAME = 'PAGE_SET_TEAM_NAME';
var SET_USER_NAME = exports.SET_USER_NAME = 'PAGE_SET_USER_NAME';
var SET_PASSWORD = exports.SET_PASSWORD = 'PAGE_SET_PASSWORD';
var SET_FORGOT_ENABLED = exports.SET_FORGOT_ENABLED = 'PAGE_SET_FORGOT_ENABLED';
var SET_PENDING_TEAM_NAME = exports.SET_PENDING_TEAM_NAME = 'PAGE_SET_PENDING_TEAM_NAME';
var SET_SAVING = exports.SET_SAVING = 'PAGE_SET_SAVING';
var SET_SUCCESS_MESSAGE = exports.SET_SUCCESS_MESSAGE = 'PAGE_SET_SUCCESS_MESSAGE';
var SET_ERROR_MESSAGE = exports.SET_ERROR_MESSAGE = 'PAGE_SET_ERROR_MESSAGE';

function setTeamName(teamName) {
  return {
    type: SET_TEAM_NAME,
    teamName: teamName
  };
}

function setUserName(userName) {
  return {
    type: SET_USER_NAME,
    userName: userName
  };
}

function setPassword(password) {
  return {
    type: SET_PASSWORD,
    password: password
  };
}

function setPendingTeamName(pendingTeamName) {
  return {
    type: SET_PENDING_TEAM_NAME,
    pendingTeamName: pendingTeamName
  };
}

function setSaving(saving) {
  return {
    type: SET_SAVING,
    saving: saving
  };
}

function setSuccessMessage(message) {
  return {
    type: SET_SUCCESS_MESSAGE,
    message: message
  };
}

function setErrorMessage(message) {
  return {
    type: SET_ERROR_MESSAGE,
    message: message
  };
}

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = PhoneVerification;

var _phone = __webpack_require__(413);

function PhoneVerification() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _phone.POST_PHONE_SUCCESS:
      return _extends({}, state, {
        addCode: true,
        addPhone: false,
        phoneAddSuccess: false,
        deletePhoneSuccess: false,
        error: {
          addPhone: null,
          addCode: null
        }
      });
    case _phone.POST_PHONE_FAILURE:
      return _extends({}, state, {
        error: {
          addPhone: action.error
        }
      });
    case _phone.VERIFY_PHONE_SUCCESS:
      if (!action.response.phone) {
        return _extends({}, state, {
          error: {
            addCode: true
          }
        });
      }
      return _extends({}, state, {
        phoneAddSuccess: true,
        addCode: false,
        addPhone: false,
        error: {
          addCode: null
        }
      });
    case _phone.VERIFY_PHONE_FAILURE:
      return _extends({}, state, {
        error: {
          addCode: action.error
        }
      });
    default:
      return state;
  }
}

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProcessList;

var _ProcessList = __webpack_require__(1441);

var _map = __webpack_require__(725);

var _map2 = _interopRequireDefault(_map);

var _uniq = __webpack_require__(392);

var _uniq2 = _interopRequireDefault(_uniq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProcessList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    loading: true
  };
  var action = arguments[1];

  switch (action.type) {
    case _ProcessList.PAGE_PROCESSLIST_INITIALIZE:
      var filters = [{ value: 'favorites', name: 'Favorite Templates' }, { value: 'all', name: 'All Templates' }];

      return {
        loading: true,
        filters: filters,
        filterByFavorites: false,
        searchValue: '',
        categories: []
      };

    case _ProcessList.PAGE_PROCESSLIST_RECEIVE:
      var categories = (0, _map2.default)(action.processes || [], function (item) {
        return item.category || 'uncategorized';
      });

      return Object.assign({}, state, {
        categories: (0, _uniq2.default)(categories),
        loading: false
      });

    case _ProcessList.PAGE_PROCESSLIST_FILTERFAVORITES:
      return Object.assign({}, state, {
        filterByFavorites: !state.filterByFavorites
      });

    case _ProcessList.PAGE_PROCESSLIST_FILTERCATEGORY:
      return Object.assign({}, state, {
        categoryFilter: action.category
      });

    case _ProcessList.PAGE_PROCESSLIST_SEARCHQUERY:
      return Object.assign({}, state, {
        searchValue: action.query
      });

    default:
      return state;
  }
}

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.requestProcessList = requestProcessList;
exports.receiveProcessList = receiveProcessList;
exports.searchQuery = searchQuery;
exports.filterCategory = filterCategory;
exports.filterFavorites = filterFavorites;
var PAGE_PROCESSLIST_INITIALIZE = exports.PAGE_PROCESSLIST_INITIALIZE = 'PAGE_PROCESSLIST_INITIALIZE';
var PAGE_PROCESSLIST_SEARCHQUERY = exports.PAGE_PROCESSLIST_SEARCHQUERY = 'PAGE_PROCESSLIST_SEARCHQUERY';
var PAGE_PROCESSLIST_FILTERCATEGORY = exports.PAGE_PROCESSLIST_FILTERCATEGORY = 'PAGE_PROCESSLIST_FILTERCATEGORY';
var PAGE_PROCESSLIST_FILTERFAVORITES = exports.PAGE_PROCESSLIST_FILTERFAVORITES = 'PAGE_PROCESSLIST_FILTERFAVORITES';
var PAGE_PROCESSLIST_REQUEST = exports.PAGE_PROCESSLIST_REQUEST = 'PAGE_PROCESSLIST_REQUEST';
var PAGE_PROCESSLIST_RECEIVE = exports.PAGE_PROCESSLIST_RECEIVE = 'PAGE_PROCESSLIST_RECEIVE';

function initialize() {
  return {
    type: PAGE_PROCESSLIST_INITIALIZE
  };
}

function requestProcessList() {
  return {
    type: PAGE_PROCESSLIST_REQUEST
  };
}

function receiveProcessList(processes) {
  return {
    type: PAGE_PROCESSLIST_RECEIVE,
    processes: processes
  };
}

function searchQuery(query) {
  return {
    type: PAGE_PROCESSLIST_SEARCHQUERY,
    query: query
  };
}

function filterCategory(category) {
  return {
    type: PAGE_PROCESSLIST_FILTERCATEGORY,
    category: category
  };
}

function filterFavorites() {
  return {
    type: PAGE_PROCESSLIST_FILTERFAVORITES
  };
}

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Profile;

var _user = __webpack_require__(187);

var _Profile = __webpack_require__(1443);

var _phone = __webpack_require__(413);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Profile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _Profile.PROFILE_INITIALIZE:
      var defaults = {
        loading: true,
        saving: false,
        success: true,
        userID: null,
        isTeamAdmin: false,
        username: '',
        email: '',
        phone: '',
        fullName: '',
        password: '',
        passwordConfirm: '',
        deletePhoneSuccess: false
      };
      return _extends({}, state, defaults);
    case _Profile.PROFILE_INPUT_CHANGE:
      return _extends({}, state, _defineProperty({}, action.field, action.newData));
    case _Profile.PROFILE_ADMIN_CHANGE:
      return _extends({}, state, {
        isTeamAdmin: action.isTeamAdmin
      });
    case _user.GET_USER_SUCCESS:
      var user = action.response.entities.users[action.response.result];
      var notificationPreference = true; // eslint-disable-line no-unused-vars
      try {
        notificationPreference = user.notificationPreference.email.enabled;
      } catch (e) {
        /* this space intentionally blank */
      }
      return _extends({}, state, {
        loading: false,
        userID: action.response.result,
        email: user.email,
        fullName: user.fullName,
        username: user.username,
        isTeamAdmin: user.isTeamAdmin || user.isTeamOwner || false,
        phone: user.phone
      });
    case _user.UPDATE_USER_REQUEST:
      return _extends({}, state, {
        saving: true
      });
    case _user.UPDATE_USER_SUCCESS:
      return _extends({}, state, {
        saving: false,
        success: true,
        password: '',
        passwordConfirm: ''
      });
    case _user.UPDATE_USER_FAILURE:
      return _extends({}, state, {
        saving: false,
        success: false
      });
    case _phone.DELETE_PHONE_SUCCESS:
      return _extends({}, state, {
        deletePhoneSuccess: true,
        phone: ''
      });
    case _phone.DELETE_PHONE_FAILURE:
      return _extends({}, state, {
        deletePhoneSuccess: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.inputChange = inputChange;
exports.adminChange = adminChange;
var PROFILE_INITIALIZE = exports.PROFILE_INITIALIZE = 'PAGE_PROFILE_INITIALIZE';
var PROFILE_INPUT_CHANGE = exports.PROFILE_INPUT_CHANGE = 'PAGE_PROFILE_INPUT_CHANGE';
var PROFILE_ADMIN_CHANGE = exports.PROFILE_ADMIN_CHANGE = 'PAGE_PROFILE_ADMIN_CHANGE';

function initialize() {
  return {
    type: PROFILE_INITIALIZE
  };
}

function inputChange(field, newData) {
  return {
    type: PROFILE_INPUT_CHANGE,
    field: field,
    newData: newData
  };
}

function adminChange(isTeamAdmin) {
  return {
    type: PROFILE_ADMIN_CHANGE,
    isTeamAdmin: isTeamAdmin
  };
}

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = RunList;

var _runs = __webpack_require__(557);

var _RunList = __webpack_require__(1445);

function RunList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fetchedAllRuns: false };
  var action = arguments[1];

  switch (action.type) {
    case _RunList.RUNLIST_INITIALIZE:
      var defaults = {
        activeFilter: { value: 'running', name: 'Active Routines' },
        activeGrouping: { value: '*', name: 'No Grouping' },
        activeSorting: { value: '*', name: 'Sort By' },
        ready: false,
        userIsAdmin: false,
        userOnlyRuns: true
      };
      return _extends({}, state, defaults);
    case _runs.GET_RUNS_REQUEST:
      return _extends({}, state, {
        ready: false
      });
    case _runs.GET_RUNS_SUCCESS:
      var fetchedAllRuns = state.fetchedAllRuns;
      if (action.payload.url.slice(-3) === 'all') {
        fetchedAllRuns = true;
      }
      return _extends({}, state, {
        ready: true,
        fetchedAllRuns: fetchedAllRuns
      });
    case _runs.GET_RUNS_FAILURE:
      return _extends({}, state, {
        ready: true
      });
    case _RunList.SET_ACTIVE_RUNLIST_FILTER:
      return _extends({}, state, {
        activeFilter: action.filter
      });
    case _RunList.SET_ACTIVE_RUNLIST_GROUPING:
      return _extends({}, state, {
        activeGrouping: action.grouping
      });
    case _RunList.SET_ACTIVE_RUNLIST_SORTING:
      return _extends({}, state, {
        activeSorting: action.sorting
      });
    case _RunList.SET_USER_ONLY_RUNS:
      return _extends({}, state, {
        userOnlyRuns: action.setting
      });
    default:
      return state;
  }
}

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.setRunListFilter = setRunListFilter;
exports.setRunListGrouping = setRunListGrouping;
exports.setRunListSorting = setRunListSorting;
exports.setUserOnlyRuns = setUserOnlyRuns;
var RUNLIST_INITIALIZE = exports.RUNLIST_INITIALIZE = 'PAGE_RUNLIST_INITIALIZE';
var SET_ACTIVE_RUNLIST_FILTER = exports.SET_ACTIVE_RUNLIST_FILTER = 'PAGE_SET_ACTIVE_RUNLIST_FILTER';
var SET_ACTIVE_RUNLIST_GROUPING = exports.SET_ACTIVE_RUNLIST_GROUPING = 'PAGE_SET_ACTIVE_RUNLIST_GROUPING';
var SET_ACTIVE_RUNLIST_SORTING = exports.SET_ACTIVE_RUNLIST_SORTING = 'PAGE_SET_ACTIVE_RUNLIST_SORTING';
var SET_USER_IS_ADMIN = exports.SET_USER_IS_ADMIN = 'PAGE_SET_USER_IS_ADMIN';
var SET_USER_ONLY_RUNS = exports.SET_USER_ONLY_RUNS = 'PAGE_SET_USER_ONLY_RUNS';

function initialize() {
  return {
    type: RUNLIST_INITIALIZE
  };
}

function setRunListFilter(filter) {
  return {
    type: SET_ACTIVE_RUNLIST_FILTER,
    filter: filter
  };
}

function setRunListGrouping(grouping) {
  return {
    type: SET_ACTIVE_RUNLIST_GROUPING,
    grouping: grouping
  };
}

function setRunListSorting(sorting) {
  return {
    type: SET_ACTIVE_RUNLIST_SORTING,
    sorting: sorting
  };
}

function setUserOnlyRuns(setting) {
  return {
    type: SET_USER_ONLY_RUNS,
    setting: setting
  };
}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Team;

var _team = __webpack_require__(118);

var _Team = __webpack_require__(817);

function Team() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _Team.TEAM_ITEM_INITIALIZE:
      var defaults = {
        loading: true,
        saving: false,
        success: true,
        teamName: '',
        ownerUsername: '',
        ownerEmail: '',
        samlConfig: {
          enabled: false,
          loginUrl: '',
          logoutUrl: '',
          entityID: '',
          certificate: ''
        }
      };
      return _extends({}, state, defaults);
    case _Team.TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE:
      var out = _extends({}, state);
      if (out.samlConfig == null) {
        out.samlConfig = {};
      }
      out.samlConfig[action.field] = action.newData;
      return out;
    case _team.GET_TEAM_SUCCESS:
      var team = action.response.entities.teams[action.response.result];
      return _extends({}, state, {
        loading: false,
        teamName: team.teamName,
        ownerUsername: team.ownerUsername,
        ownerEmail: team.ownerEmail,
        samlConfig: team.samlConfig
      });
    case _team.UPDATE_TEAM_REQUEST:
      return _extends({}, state, {
        saving: true
      });
    case _team.UPDATE_TEAM_SUCCESS:
      return _extends({}, state, {
        saving: false,
        success: true
      });
    case _team.UPDATE_TEAM_FAILURE:
      return _extends({}, state, {
        saving: false,
        success: false,
        error: true
      });
    case _team.GET_SERVICE_PROVIDER_METADATA_SUCCESS:
      return _extends({}, state, {
        serviceProviderMetadata: action.response
      });
    default:
      return state;
  }
}

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = SingleIntegration;

var _integration = __webpack_require__(258);

var _SingleIntegration = __webpack_require__(1448);

function SingleIntegration() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _SingleIntegration.SINGINT_INITIALIZE:
      var defaults = {
        deleting: false,
        loadingInt: true,
        integrationID: null
      };
      return _extends({}, state, defaults);
    case _integration.GET_INTEGRATION_SUCCESS:
      return _extends({}, state, {
        integrationID: action.response.result,
        loadingInt: false
      });
    case _integration.DELETE_INTEGRATION_REQUEST:
      return _extends({}, state, {
        deleting: true
      });
    case _integration.DELETE_INTEGRATION_FAILURE:
      return _extends({}, state, {
        deleting: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
var SINGINT_INITIALIZE = exports.SINGINT_INITIALIZE = 'PAGE_SINGINT_INITIALIZE';

function initialize() {
  return {
    type: SINGINT_INITIALIZE
  };
}

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NewRoutine;

var _StartRun = __webpack_require__(1450);

function NewRoutine() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    loading: true,
    loadingUsers: true,
    uploadingFiles: false,
    saving: false,
    fields: {}
  };
  var action = arguments[1];

  switch (action.type) {
    case _StartRun.PAGE_STARTRUN_INITIALIZE:
      return {
        loading: true,
        loadingUsers: true,
        uploadingFiles: false,
        saving: false,
        displayName: '',
        description: '',
        maximumDuration: '7 days',
        isTest: false,
        isScheduled: false,
        isRecurring: false,
        isHighPriority: false,
        hasDeadline: false,
        fields: {},
        runOwner: action.defaultRunOwner
      };

    case _StartRun.PAGE_STARTRUN_ONCHANGEVALUE:
      var prop = {};
      var name = action.name;
      var value = action.value;

      switch (name) {
        case 'displayName':
          prop[name] = value.value;
          break;
        case 'runOwner':
          if (!value.values.length) {
            break;
          }
          // runOwner can only be one user,
          // and may be prefaced by an @.
          var username = value.values[0].split('@');
          prop[name] = username.length > 1 ? username[1] : username[0];
          break;

        case 'priority':
          prop[name] = value === true ? 'High' : 'Medium';
          break;

        case 'fields':
          var fieldObj = {};

          fieldObj[value.fieldID] = value;
          prop[name] = Object.assign({}, state.fields, fieldObj);
          break;

        case 'schedule':
        case 'deadline':
          prop[name] = new Date(value.dateTime).toISOString();
          break;

        default:
          prop[name] = value;
      }

      return Object.assign({}, state, prop);

    case _StartRun.PAGE_STARTRUN_ONSAVE_REQUEST:
      return Object.assign({}, state, { saving: true });

    case _StartRun.PAGE_STARTRUN_ONSAVE_SUCCESS:
      return Object.assign({}, state, {
        saving: false,
        error: null
      });

    case _StartRun.PAGE_STARTRUN_ONSAVE_ERROR:
      return Object.assign({}, state, {
        saving: false,
        error: action.error
      });

    case _StartRun.PAGE_STARTRUN_PROCESS_RECEIVE:
      return Object.assign({}, state, {
        processID: action.process.processID,
        loading: false
      });

    case _StartRun.PAGE_STARTRUN_USERS_RECEIVE:
      return Object.assign({}, state, { loadingUsers: false });

    case _StartRun.PAGE_STARTRUN_ONFILEUPLOAD_REQUEST:
      return Object.assign({}, state, { uploadingFiles: true });

    case _StartRun.PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE:
      return Object.assign({}, state, { uploadingFiles: false });

    default:
      return state;
  }
}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.receiveProcess = receiveProcess;
exports.receiveUsers = receiveUsers;
exports.valueChange = valueChange;
exports.saveFormRequest = saveFormRequest;
exports.saveFormResponse = saveFormResponse;
exports.saveFormError = saveFormError;
exports.fileUploadRequest = fileUploadRequest;
exports.fileUploadReceive = fileUploadReceive;
exports.fileUploadError = fileUploadError;
var PAGE_STARTRUN_INITIALIZE = exports.PAGE_STARTRUN_INITIALIZE = 'PAGE_STARTRUN_INITIALIZE';
var PAGE_STARTRUN_ONCHANGEVALUE = exports.PAGE_STARTRUN_ONCHANGEVALUE = 'PAGE_STARTRUN_ONCHANGEVALUE';
var PAGE_STARTRUN_ONSAVE_REQUEST = exports.PAGE_STARTRUN_ONSAVE_REQUEST = 'PAGE_STARTRUN_ONSAVE_REQUEST';
var PAGE_STARTRUN_ONSAVE_SUCCESS = exports.PAGE_STARTRUN_ONSAVE_SUCCESS = 'PAGE_STARTRUN_ONSAVE_SUCCESS';
var PAGE_STARTRUN_PROCESS_RECEIVE = exports.PAGE_STARTRUN_PROCESS_RECEIVE = 'PAGE_STARTRUN_PROCESS_RECEIVE';
var PAGE_STARTRUN_USERS_RECEIVE = exports.PAGE_STARTRUN_USERS_RECEIVE = 'PAGE_STARTRUN_USERS_RECEIVE';
var PAGE_STARTRUN_ONSAVE_ERROR = exports.PAGE_STARTRUN_ONSAVE_ERROR = 'PAGE_STARTRUN_ONSAVE_ERROR';
var PAGE_STARTRUN_ONFILEUPLOAD_REQUEST = exports.PAGE_STARTRUN_ONFILEUPLOAD_REQUEST = 'PAGE_STARTRUN_ONFILEUPLOAD_REQUEST';
var PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE = exports.PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE = 'PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE';
var PAGE_STARTRUN_ONFILEUPLOAD_ERROR = exports.PAGE_STARTRUN_ONFILEUPLOAD_ERROR = 'PAGE_STARTRUN_ONFILEUPLOAD_ERROR';

function initialize(defaultRunOwner) {
  return {
    type: PAGE_STARTRUN_INITIALIZE,
    defaultRunOwner: defaultRunOwner
  };
}

function receiveProcess(process) {
  return {
    type: PAGE_STARTRUN_PROCESS_RECEIVE,
    process: process
  };
}

function receiveUsers() {
  return {
    type: PAGE_STARTRUN_USERS_RECEIVE
  };
}

function valueChange(name, value) {
  return {
    type: PAGE_STARTRUN_ONCHANGEVALUE,
    name: name,
    value: value
  };
}

function saveFormRequest(params) {
  return {
    type: PAGE_STARTRUN_ONSAVE_REQUEST,
    params: params
  };
}

function saveFormResponse(response) {
  return {
    type: PAGE_STARTRUN_ONSAVE_SUCCESS,
    response: response
  };
}

function saveFormError() {
  return {
    type: PAGE_STARTRUN_ONSAVE_ERROR,
    error: arguments
  };
}

function fileUploadRequest() {
  return {
    type: PAGE_STARTRUN_ONFILEUPLOAD_REQUEST
  };
}

function fileUploadReceive() {
  return {
    type: PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE
  };
}

function fileUploadError() {
  return {
    type: PAGE_STARTRUN_ONFILEUPLOAD_ERROR
  };
}

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Tasks;

var _redux = __webpack_require__(80);

var _TaskDetails = __webpack_require__(1452);

var _TaskDetails2 = _interopRequireDefault(_TaskDetails);

var _TaskItem = __webpack_require__(1453);

var _TaskItem2 = _interopRequireDefault(_TaskItem);

var _TaskReassign = __webpack_require__(1454);

var _TaskReassign2 = _interopRequireDefault(_TaskReassign);

var _TaskReopen = __webpack_require__(1455);

var _TaskReopen2 = _interopRequireDefault(_TaskReopen);

var _RunAbort = __webpack_require__(1456);

var _RunAbort2 = _interopRequireDefault(_RunAbort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childReducers = {
  TaskDetails: _TaskDetails2.default,
  TaskItem: _TaskItem2.default,
  TaskReassign: _TaskReassign2.default,
  TaskReopen: _TaskReopen2.default,
  RunAbort: _RunAbort2.default
};

var combinedReducers = (0, _redux.combineReducers)(childReducers);

function Tasks(state, action) {
  if (state && state.combined) {
    delete state.combined;
  }
  var childrenState = combinedReducers(state, action);

  var combined = {};

  Object.keys(childReducers).forEach(function (childReducer) {
    var childState = childrenState[childReducer] || {};
    combined.loading = combined.loading || childState.loading;
    combined.saving = combined.saving || childState.saving;
  });

  return _extends({}, childrenState, {
    combined: combined
  });
}

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TaskDetails;

var _run = __webpack_require__(185);

var _TaskDetails = __webpack_require__(818);

function TaskDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _TaskDetails.TASK_DETAILS_INITIALIZE:
      var defaults = {
        loading: true,
        error: false,
        errorMessage: ''
      };
      return _extends({}, state, defaults);
    case _run.GET_RUN_REQUEST:
      return _extends({}, state, {
        error: false,
        errorMessage: ''
      });
    case _run.GET_RUN_SUCCESS:
      return _extends({}, state, {
        loading: false
      });
    case _run.GET_RUN_FAILURE:
      return _extends({}, state, {
        loading: false,
        error: true,
        errorMessage: action.error
      });
    default:
      return state;
  }
}

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TaskDetail;

var _task = __webpack_require__(188);

var _run = __webpack_require__(185);

var _file = __webpack_require__(248);

var _TaskItem = __webpack_require__(770);

function TaskDetail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loading: true };
  var action = arguments[1];

  switch (action.type) {
    case _TaskItem.TASK_ITEM_INITIALIZE:
      var defaults = {
        loading: true,
        uploadingFiles: false,
        error: false,
        errorMessage: '',
        saving: false
      };
      return _extends({}, state, defaults);

    case _TaskItem.TASK_ITEM_SELECT_UPDATE_OPTION:
      return _extends({}, state);

    case _run.GET_RUN_REQUEST:
      return _extends({}, state, {
        error: false,
        errorMessage: '',
        loading: true
      });

    case _run.GET_RUN_SUCCESS:
      return _extends({}, state, {
        loading: false
      });

    case _run.GET_RUN_FAILURE:
      return _extends({}, state, {
        loading: false,
        error: true,
        errorMessage: action.error
      });

    case _file.ADD_FILE_REQUEST:
      return _extends({}, state, {
        uploadingFiles: true
      });

    case _file.ADD_FILE_SUCCESS:
      return _extends({}, state, {
        uploadingFiles: false
      });

    case _task.UPDATE_TASK_REQUEST:
      return _extends({}, state, {
        error: false,
        errorMessage: '',
        saving: true
      });

    case _task.UPDATE_TASK_SUCCESS:
      return _extends({}, state, {
        saving: false
      });

    case _task.UPDATE_TASK_FAILURE:
      return _extends({}, state, {
        saving: false,
        error: true,
        errorMessage: action.error
      });

    case _TaskItem.TASK_ITEM_FIELD_UPDATE:
      var fields = state.fields || {};
      var updatedField = {};

      // we are saving all field data here in order to
      // know what field is what when saving.
      updatedField[action.field.fieldName] = action.field;

      return _extends({}, state, {
        fields: _extends({}, fields, updatedField)
      });

    default:
      return state;
  }
}

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TaskReassign;

var _TaskReassign = __webpack_require__(422);

var _task = __webpack_require__(188);

function TaskReassign() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _TaskReassign.TASK_REASSIGN_INITIALIZE:
      return _extends({}, state, {
        saving: false,
        error: false,
        reassigned: false
      });
    case _task.UPDATE_TASK_REQUEST:
      return _extends({}, state, {
        saving: true,
        reassigned: false,
        error: false
      });
    case _task.UPDATE_TASK_SUCCESS:
      return _extends({}, state, {
        saving: false,
        reassigned: true,
        error: false
      });
    case _task.UPDATE_TASK_FAILURE:
      return _extends({}, state, {
        saving: false,
        reassigned: false,
        error: action.error
      });
    default:
      return state;
  }
}

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TaskReassign;

var _TaskReassign = __webpack_require__(422);

var _task = __webpack_require__(188);

function TaskReassign() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _TaskReassign.TASK_REASSIGN_INITIALIZE:
      return _extends({}, state, {
        saving: false,
        error: false,
        reassigned: false
      });
    case _task.UPDATE_TASK_REQUEST:
      return _extends({}, state, {
        saving: true,
        reassigned: false,
        error: false
      });
    case _task.UPDATE_TASK_SUCCESS:
      return _extends({}, state, {
        saving: false,
        reassigned: true,
        error: false
      });
    case _task.UPDATE_TASK_FAILURE:
      return _extends({}, state, {
        saving: false,
        reassigned: false,
        error: action.error
      });
    case _task.REOPEN_TASK_REQUEST:
      return _extends({}, state, {
        saving: true,
        reassigned: false,
        error: false
      });
    case _task.REOPEN_TASK_SUCCESS:
      return _extends({}, state, {
        saving: false,
        reassigned: true,
        error: false
      });
    case _task.REOPEN_TASK_FAILURE:
      return _extends({}, state, {
        saving: false,
        reassigned: false,
        error: action.error
      });
    default:
      return state;
  }
}

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = RunAbort;

var _RunAbort = __webpack_require__(1457);

var _run = __webpack_require__(185);

function RunAbort() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _RunAbort.RUN_ABORT_INITIALIZE:
      return _extends({}, state, {
        saving: false,
        error: false,
        saved: false
      });
    case _run.UPDATE_RUN_REQUEST:
      return _extends({}, state, {
        saving: true,
        saved: false,
        error: false
      });
    case _run.UPDATE_RUN_SUCCESS:
      return _extends({}, state, {
        saving: false,
        saved: true,
        error: false
      });
    case _run.UPDATE_RUN_FAILURE:
      return _extends({}, state, {
        saving: false,
        saved: false,
        error: action.error
      });
    default:
      return state;
  }
}

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
var RUN_ABORT_INITIALIZE = exports.RUN_ABORT_INITIALIZE = 'PAGE_TASK_RUN_ABORT_INITIALIZE';

function initialize() {
  return {
    type: RUN_ABORT_INITIALIZE
  };
}

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TeamList;

var _users = __webpack_require__(384);

var _TeamList = __webpack_require__(1459);

function TeamList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _TeamList.TEAMLIST_INITIALIZE:
      var defaults = {
        isLoading: true
      };
      return _extends({}, state, defaults);
    case _users.GET_USERS_SUCCESS:
      return _extends({}, state, {
        isLoading: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
var TEAMLIST_INITIALIZE = exports.TEAMLIST_INITIALIZE = 'PAGE_TEAMLIST_INITIALIZE';

function initialize() {
  return {
    type: TEAMLIST_INITIALIZE
  };
}

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Webform;

var _webform = __webpack_require__(411);

var _webhooks = __webpack_require__(547);

var _webhook = __webpack_require__(250);

var _Webform = __webpack_require__(1461);

var _cloneDeep = __webpack_require__(401);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Webform() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _Webform.WEBFORM_INITIALIZE:
      var defaults = {
        loading: true,
        webhookID: null,
        notFound: false,
        saving: false,
        successMessage: undefined,
        fields: []
      };
      return _extends({}, state, defaults);
    case _Webform.WEBFORM_UPDATE_FIELDS:
      var newFields = state.fields.slice();
      var changedIndex = newFields.findIndex(function (field) {
        return field.fieldName === action.field.fieldName;
      });
      newFields[changedIndex] = action.field;
      return _extends({}, state, {
        fields: newFields
      });
    case _webform.GET_WEBFORM_SUCCESS:
      var webform = ((action.response.entities || {}).webhooks || {})[action.response.result];
      return _extends({}, state, {
        webhookID: webform.webhookID,
        loading: false,
        fields: (0, _cloneDeep2.default)(webform.fields)
      });
    case _webform.GET_WEBFORM_FAILURE:
      return _extends({}, state, {
        loading: false,
        notFound: true
      });
    case _webhooks.GET_WEBHOOKS_FAILURE:
      return _extends({}, state, {
        notFound: true
      });
    case _webhook.GET_WEBHOOK_SUCCESS:
      var webhook = action.response.entities.webhooks[action.response.result];
      return _extends({}, state, {
        loading: false,
        webhookID: webhook.webhookID,
        fields: (0, _cloneDeep2.default)(webhook.fields)
      });
    case _webhook.GET_WEBHOOK_FAILURE:
      return _extends({}, state, {
        loading: false,
        notFound: true
      });
    case _webhook.POST_WEBHOOK_REQUEST:
      return _extends({}, state, {
        saving: true
      });
    case _webhook.POST_WEBHOOK_SUCCESS:
      return _extends({}, state, {
        saving: false,
        successMessage: 'Success! The form has been completed. Thanks!'
      });
    case _webhook.POST_WEBHOOK_FAILURE:
      return _extends({}, state, {
        saving: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.updateFields = updateFields;
var WEBFORM_INITIALIZE = exports.WEBFORM_INITIALIZE = 'PAGE_WEBFORM_INITIALIZE';
var WEBFORM_UPDATE_FIELDS = exports.WEBFORM_UPDATE_FIELDS = 'PAGE_WEBFORM_UPDATE_FIELDS';

function initialize() {
  return {
    type: WEBFORM_INITIALIZE
  };
}

function updateFields(field) {
  return {
    type: WEBFORM_UPDATE_FIELDS,
    field: field
  };
}

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IntegrationList;

var _IntegrationList = __webpack_require__(819);

var initialState = {
  loading: true
};

function IntegrationList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _IntegrationList.PAGE_INTEGRATION_LIST_LOADING:
      return {
        loading: action.loading
      };
    default:
      return state;
  }
}

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = XLogin;

var _XLogin = __webpack_require__(820);

var _team = __webpack_require__(118);

function XLogin() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _XLogin.SET_TEAM_NAME:
      return _extends({}, state, {
        teamName: action.teamName
      });
    case _XLogin.SET_USER_NAME:
      return _extends({}, state, {
        userName: action.userName
      });
    case _XLogin.SET_PASSWORD:
      return _extends({}, state, {
        password: action.password
      });
    case _XLogin.SET_MESSAGE:
      return _extends({}, state, {
        message: action.message,
        error: action.error
      });
    case _team.GET_AUTH_INFO_REQUEST:
      return _extends({}, state, {
        loading: true
      });
    case _team.GET_AUTH_INFO_SUCCESS:
      return _extends({}, state, {
        loading: false
      });
    case _team.GET_AUTH_INFO_FAILURE:
      return _extends({}, state, {
        loading: false,
        message: action.message,
        error: action.error
      });

    default:
      return state;
  }
}

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(80);

var _ChangePhoto = __webpack_require__(1465);

var _ChangePhoto2 = _interopRequireDefault(_ChangePhoto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  ChangePhoto: _ChangePhoto2.default
});

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = ChangePhoto;

var _file = __webpack_require__(248);

var _ChangePhoto = __webpack_require__(821);

function ChangePhoto() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _ChangePhoto.CHANGE_PHOTO_INITIALIZE:
      var defaults = {
        errorMessage: '',
        saving: false
      };
      return _extends({}, state, defaults);
    case _ChangePhoto.CHANGE_PHOTO_ADD_PHOTO:
      return _extends({}, state, {
        photo: action.photo,
        errorMessage: ''
      });
    case _ChangePhoto.CHANGE_PHOTO_CHANGE_ERROR:
      return _extends({}, state, {
        errorMessage: action.errorMessage
      });
    case _file.ADD_FILE_REQUEST:
      return _extends({}, state, {
        saving: true
      });
    case _file.ADD_FILE_FAILURE:
      return _extends({}, state, {
        errorMessage: 'Upload failed: ' + action.error
      });
    default:
      return state;
  }
}

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = storage;

var _indexOf = __webpack_require__(1467);

var _indexOf2 = _interopRequireDefault(_indexOf);

var _extend = __webpack_require__(1468);

var _extend2 = _interopRequireDefault(_extend);

var _storage = __webpack_require__(1470);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function storage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    favorites: {
      processes: []
    }
  };
  var action = arguments[1];

  var favorites = void 0;
  var existsAt = void 0;
  switch (action.type) {
    case _storage.TOGGLE_FAVORITE_PROCESS:
      favorites = state.favorites.processes;
      existsAt = (0, _indexOf2.default)(favorites, action.processID);

      if (existsAt !== -1) {
        favorites.splice(existsAt, 1);
      } else {
        favorites.push(action.processID);
      }

      return Object.assign({}, state, {
        favorites: (0, _extend2.default)(state.favorites, {
          processes: favorites
        })
      });

    default:
      return state;
  }
}

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(254),
    toInteger = __webpack_require__(153);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1469);


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    createAssigner = __webpack_require__(514),
    keysIn = __webpack_require__(221);

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn(source), object);
});

module.exports = assignIn;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleFavoriteProcess = toggleFavoriteProcess;
var TOGGLE_FAVORITE_PROCESS = exports.TOGGLE_FAVORITE_PROCESS = 'TOGGLE_FAVORITE_PROCESS';

function toggleFavoriteProcess(processID) {
  return {
    type: TOGGLE_FAVORITE_PROCESS,
    processID: processID
  };
}

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Flash;

var _flash = __webpack_require__(1472);

function Flash() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { on: false };
  var action = arguments[1];

  switch (action.type) {
    case _flash.START_FLASH:
      return _extends({}, state, {
        status: action.status,
        message: action.message,
        on: true
      });
    case _flash.CLEAR_FLASH:
      return _extends({}, state, {
        status: '',
        message: '',
        on: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flash = flash;
exports.clearFlash = clearFlash;
var START_FLASH = exports.START_FLASH = 'START_FLASH';
var CLEAR_FLASH = exports.CLEAR_FLASH = 'CLEAR_FLASH';

function flash(_ref) {
  var status = _ref.status,
      message = _ref.message;

  return {
    type: START_FLASH,
    status: status,
    message: message
  };
}

function clearFlash() {
  return {
    type: CLEAR_FLASH
  };
}

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Toast;

var _toast = __webpack_require__(183);

function Toast() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { open: false };
  var action = arguments[1];

  switch (action.type) {
    case _toast.START_TOAST:
      return _extends({}, state, {
        action: action.action,
        message: action.message || (action.error || {}).message,
        onActionClick: action.onActionClick,
        open: true,
        error: action.error,
        autoHideDuration: action.autoHideDuration
      });
    case _toast.CLEAR_TOAST:
      return _extends({}, state, {
        open: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = team;

var _team = __webpack_require__(118);

function team() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _team.GET_AUTH_INFO_SUCCESS:
      return _extends({}, state, {
        usesSamlSso: action.response.method === 'saml'
      });
    default:
      return state;
  }
}

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Trigger;

var _trigger = __webpack_require__(715);

var DEFAULT_STATE = {
  triggerValues: {}
};

function Trigger() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _trigger.SELECT_TRIGGER_TYPE:
      return _extends({}, state, {
        selectedTriggerType: action.selectedTriggerType
      });

    default:
      return state;
  }
}

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.composeBuilder = composeBuilder;

var _redux = __webpack_require__(80);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function composeBuilder() // eslint-disable-line no-unused-vars
{
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _context2.default;

  return _env2.default.PUSHBOT_REDUX_DEVTOOLS !== 0 && (typeof _context2.default === 'undefined' ? 'undefined' : _typeof(_context2.default)) === 'object' && _context2.default.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? _context2.default.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;
}

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHistory = createHistory;

var _reactRouterRedux = __webpack_require__(331);

var _store = __webpack_require__(313);

var _store2 = _interopRequireDefault(_store);

var _browserHistory = __webpack_require__(182);

var _browserHistory2 = _interopRequireDefault(_browserHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createHistory(store) {
  return (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory2.default, store);
}

var history = createHistory(_store2.default);

exports.default = history;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;

var _LocationUtils = __webpack_require__(110);

Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _createBrowserHistory = __webpack_require__(571);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createHashHistory2 = __webpack_require__(573);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(574);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

var _useBasename2 = __webpack_require__(340);

var _useBasename3 = _interopRequireDefault(_useBasename2);

var _useBeforeUnload2 = __webpack_require__(1483);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

var _useQueries2 = __webpack_require__(341);

var _useQueries3 = _interopRequireDefault(_useQueries2);

var _Actions2 = __webpack_require__(170);

var _Actions = _interopRequireWildcard(_Actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createHistory = _createBrowserHistory2.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;
exports.useBasename = _useBasename3.default;
exports.useBeforeUnload = _useBeforeUnload3.default;
exports.useQueries = _useQueries3.default;
exports.Actions = _Actions;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(337);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(110);

var _PathUtils = __webpack_require__(86);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(337);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(110);

var _DOMUtils = __webpack_require__(171);

var _DOMStateStorage = __webpack_require__(572);

var _PathUtils = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _DOMUtils = __webpack_require__(171);

var _ExecutionEnvironment = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startListener = function startListener(getPromptMessage) {
  var handleBeforeUnload = function handleBeforeUnload(event) {
    var message = getPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }

    return undefined;
  };

  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
  };
};

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
var useBeforeUnload = function useBeforeUnload(createHistory) {
  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;

  return function (options) {
    var history = createHistory(options);

    var listeners = [];
    var stopListener = void 0;

    var getPromptMessage = function getPromptMessage() {
      var message = void 0;
      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
        message = listeners[i].call();
      }return message;
    };

    var listenBeforeUnload = function listenBeforeUnload(listener) {
      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });

        if (listeners.length === 0 && stopListener) {
          stopListener();
          stopListener = null;
        }
      };
    };

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload
    });
  };
};

exports.default = useBeforeUnload;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1485);
var objectAssign = __webpack_require__(18);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);

				key = key.replace(/\[\]$/, '');

				if (!result || accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createTransitionManager__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouterContext__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouteUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterUtils__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routerWarning__ = __webpack_require__(137);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__["d" /* routes */],
    routes: __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__["d" /* routes */], // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_6__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_2__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_5__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_6__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(138);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = runEnterHooks;
/* harmony export (immutable) */ __webpack_exports__["a"] = runChangeHooks;
/* harmony export (immutable) */ __webpack_exports__["c"] = runLeaveHooks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(342);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

var enterHooks = new PendingHooks();
var changeHooks = new PendingHooks();

function createTransitionHook(hook, route, asyncArity, pendingHooks) {
  var isSync = hook.length < asyncArity;

  var transitionHook = function transitionHook() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (isSync) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };

  pendingHooks.add(transitionHook);

  return transitionHook;
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location) {
    redirectInfo = location;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  enterHooks.clear();
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (enterHooks.has(hooks[index])) {
        next.apply(undefined, arguments);
        enterHooks.remove(hooks[index]);
      }
    };
    hooks[index](nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  changeHooks.clear();
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (changeHooks.has(hooks[index])) {
        next.apply(undefined, arguments);
        changeHooks.remove(hooks[index]);
      }
    };
    hooks[index](state, nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(138);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(576);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(87);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

               false ? warning(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
               false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(138);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(578);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'IndexLink',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextUtils__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(345);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createClass({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_3__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routerWarning__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redirect__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(172);






var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */

var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'IndexRedirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_3__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routerWarning__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(172);






var func = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */

var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'IndexRoute',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__ = __webpack_require__(172);





var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */

var Route = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_2__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: string,
    component: __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__["b" /* components */],
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(577);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(137);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(583);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(583);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = useEmbeddedPathname;

var _url = __webpack_require__(83);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var normalize = function normalize(location) {
  return typeof location === 'string' ? (0, _url.parse)(location) : location;
};

var isEmbeddedPathname = function isEmbeddedPathname(location) {
  var _normalize = normalize(location),
      pathname = _normalize.pathname;

  var pattern = new RegExp(_env2.default.PUSHBOT_EMBEDDED_PATHNAME);
  return pathname && pattern.test(pathname);
};

function useEmbeddedPathname(createHistory, options) {
  var _ref = options || {},
      _ref$context = _ref.context,
      context = _ref$context === undefined ? _context2.default : _ref$context;

  return function (options) {
    var history = createHistory(options);

    try {
      // parse embedded mode variable
      var embeddedMode = JSON.parse(_env2.default.PUSHBOT_EMBEDDED_MODE);

      // return current history if embedded is disabled
      if (!embeddedMode) {
        return history;
      }

      var _push = function _push(location) {
        if (isEmbeddedPathname(location)) {
          return history.push(location);
        }
        context.location.href = (0, _url.format)(normalize(location));
      };

      var _replace = function _replace(location) {
        if (isEmbeddedPathname(location)) {
          return history.replace(location);
        }

        context.location.replace((0, _url.format)(normalize(location)));
      };

      return _extends({}, history, {
        push: _push,
        replace: _replace
      });
    } catch (e) {
      // if parse fials, just return the history object
      return history;
    }
  };
}

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = routes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(89);

var _reactIntl = __webpack_require__(181);

var _ThemeProviderContainer = __webpack_require__(1531);

var _ThemeProviderContainer2 = _interopRequireDefault(_ThemeProviderContainer);

var _VersionRouter = __webpack_require__(1561);

var _VersionRouter2 = _interopRequireDefault(_VersionRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function routes() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      store = _ref.store,
      history = _ref.history;

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _reactIntl.IntlProvider,
      { locale: 'en' },
      _react2.default.createElement(
        _ThemeProviderContainer2.default,
        null,
        _react2.default.createElement(_VersionRouter2.default, { history: history })
      )
    )
  );
}

routes.displayName = 'routes';

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(0);

var _storeShape = __webpack_require__(584);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(585);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _react.PropTypes.element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(0);

var _storeShape = __webpack_require__(584);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(1506);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(1507);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(585);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(1508);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(579);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(80);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1509),
    getPrototype = __webpack_require__(1510),
    isObjectLike = __webpack_require__(1512);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1509 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1511);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1512 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1515), src$en$$ = __webpack_require__(1520);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(587), src$es5$$ = __webpack_require__(1516), src$compiler$$ = __webpack_require__(1517), intl$messageformat$parser$$ = __webpack_require__(1518);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
        return messageFormat._format(pattern, values);
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
            throw new Error('A value must be provided for: ' + id);
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(587);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value) {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1519)['default'];
exports['default'] = exports;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1523)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1528);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1524), src$en$$ = __webpack_require__(1527);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(586), src$diff$$ = __webpack_require__(1525), src$es5$$ = __webpack_require__(1526);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(1530);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(89);

var _ThemeProvider = __webpack_require__(1532);

var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);

var _theme = __webpack_require__(336);

var _theme2 = _interopRequireDefault(_theme);

var _palette = __webpack_require__(563);

var _palette2 = _interopRequireDefault(_palette);

var _feature = __webpack_require__(145);

var _feature2 = __webpack_require__(189);

var _feature3 = _interopRequireDefault(_feature2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemeProviderContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return { watchListEnabled: (0, _feature.watchListEnabled)(state) };
}, function () {
  return {};
}), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  _inherits(ThemeProviderContainer, _PureComponent);

  function ThemeProviderContainer() {
    _classCallCheck(this, ThemeProviderContainer);

    return _possibleConstructorReturn(this, (ThemeProviderContainer.__proto__ || Object.getPrototypeOf(ThemeProviderContainer)).apply(this, arguments));
  }

  _createClass(ThemeProviderContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          watchListEnabled = _props.watchListEnabled;

      var type = watchListEnabled ? 'dark' : 'light';
      var theme = (0, _theme2.default)({ palette: (0, _palette2.default)({ type: type }) });
      return _react2.default.createElement(
        _ThemeProvider2.default,
        _extends({ key: type }, { theme: theme }),
        children
      );
    }
  }]);

  return ThemeProviderContainer;
}(_react.PureComponent), _class2.displayName = 'ThemeProviderContainer', _class2.propTypes = {
  children: _react.PropTypes.node,
  watchListEnabled: _feature3.default
}, _temp)) || _class);
exports.default = ThemeProviderContainer;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.SHEET_ORDER = exports.MUI_STYLE_PREFIX = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jss = __webpack_require__(588);

var _manager = __webpack_require__(560);

var _jssPresetDefault = __webpack_require__(1549);

var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

var _theme = __webpack_require__(336);

var _theme2 = _interopRequireDefault(_theme);

var _normalizeJss = __webpack_require__(1560);

var _normalizeJss2 = _interopRequireDefault(_normalizeJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var MUI_STYLE_PREFIX = exports.MUI_STYLE_PREFIX = 'Mui';

var prefixStyleList = function prefixStyleList(styles) {
  return styles.reduce(function (o, v) {
    return [].concat(_toConsumableArray(o), [v, '' + MUI_STYLE_PREFIX + v]);
  }, []);
};

var SHEET_ORDER = exports.SHEET_ORDER = prefixStyleList(['Layout', 'Grid', 'Collapse', 'Fade', 'Slide', 'Backdrop', 'Modal', 'Ripple', 'TouchRipple', 'ButtonBase', 'FormLabel', 'FormGroup', 'Text', 'Paper', 'Divider', 'Popover', 'Button', 'IconButton', 'SvgIcon', 'Icon', 'SwitchBase', 'Switch', 'Checkbox', 'Radio', 'RadioGroup', 'SwitchLabel', 'CircularProgress', 'LinearProgress', 'DialogActions', 'Dialog', 'DialogContent', 'DialogContentText', 'TabIndicator', 'Tab', 'Tabs', 'BottomNavigationButton', 'BottomNavigation', 'AppBar', 'Drawer', 'Menu', 'MenuItem', 'Avatar', 'CardContent', 'CardMedia', 'CardActions', 'CardHeader', 'Card', 'TextFieldLabel', 'TextFieldInput', 'TextField', 'Input', 'InputLabel', 'ListItem', 'SearchListItem', 'ListItemText', 'ListItemSecondaryAction', 'ListSubheader', 'List', 'SortableListItem', 'SortableDragLayer', 'AppStructure', 'BasicStructure', 'AutoComplete', 'FileField', 'FileInput', 'FilePreview', 'FormControl', 'FormActions', 'Text', 'Chip', 'InlineList', 'Table', 'TableHead', 'TableRow', 'TableCell', 'TableBody', 'TableSortLabel', 'Toolbar', 'DialogTitle', 'Badge', 'Breadcrumb', 'CommonCardHeader'], MUI_STYLE_PREFIX);

var ThemeProvider = (_temp2 = _class = function (_Component) {
  _inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThemeProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.theme = undefined, _this.styleManager = undefined, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThemeProvider, [{
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        var theme = this.theme,
            styleManager = this.styleManager;

        return {
          theme: theme,
          styleManager: styleManager
        };
      }

      return getChildContext;
    }()
  }, {
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        var _ThemeProvider$create = ThemeProvider.createDefaultContext(this.props),
            theme = _ThemeProvider$create.theme,
            styleManager = _ThemeProvider$create.styleManager;

        this.theme = theme;
        this.styleManager = styleManager;

        // Normalize.css makes browsers render all elements more consistently and in line with modern standards.
        styleManager.jss.createStyleSheet(_normalizeJss2['default']).attach();
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(nextProps) {
        if (this.styleManager !== nextProps.styleManager) {
          var _ThemeProvider$create2 = ThemeProvider.createDefaultContext(nextProps),
              theme = _ThemeProvider$create2.theme,
              styleManager = _ThemeProvider$create2.styleManager;

          this.theme = theme;
          this.styleManager = styleManager;
        } else if (this.theme && nextProps.theme && nextProps.theme !== this.theme) {
          this.theme = nextProps.theme;
          this.styleManager.updateTheme(this.theme);
        }
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        return this.props.children;
      }

      return render;
    }()
  }], [{
    key: 'createDefaultContext',
    value: function () {
      function createDefaultContext() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var theme = props.theme || (0, _theme2['default'])();
        var styleManager = props.styleManager || (0, _manager.createStyleManager)({
          theme: theme,
          jss: (0, _jss.create)(Object.assign({}, (0, _jssPresetDefault2['default'])(), { insertionPoint: 'jss-theme-reactor' }))
        });

        if (!styleManager.sheetOrder) {
          styleManager.setSheetOrder(SHEET_ORDER);
        }

        return { theme: theme, styleManager: styleManager };
      }

      return createDefaultContext;
    }()
  }]);

  return ThemeProvider;
}(_react.Component), _class.propTypes = {
  children: _PropTypes2['default'].node.isRequired,
  styleManager: _PropTypes2['default'].styleManager,
  theme: _PropTypes2['default'].object
}, _class.childContextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired,
  theme: _PropTypes2['default'].object.isRequired
}, _temp2);
exports['default'] = ThemeProvider;


ThemeProvider.displayName = 'ThemeProvider';

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StyleSheet = __webpack_require__(1534);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(1540);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _plugins = __webpack_require__(1541);

var _plugins2 = _interopRequireDefault(_plugins);

var _sheets = __webpack_require__(346);

var _sheets2 = _interopRequireDefault(_sheets);

var _generateClassName = __webpack_require__(1547);

var _generateClassName2 = _interopRequireDefault(_generateClassName);

var _createRule2 = __webpack_require__(348);

var _createRule3 = _interopRequireDefault(_createRule2);

var _findRenderer = __webpack_require__(589);

var _findRenderer2 = _interopRequireDefault(_findRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.version = "6.5.0";
    this.plugins = new _PluginsRegistry2['default']();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, _plugins2['default']);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = _extends({
        generateClassName: options.generateClassName || _generateClassName2['default'],
        insertionPoint: options.insertionPoint || 'jss'
      }, options);
      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);
      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles, options) {
      var sheet = new _StyleSheet2['default'](styles, _extends({
        jss: this,
        generateClassName: this.options.generateClassName,
        insertionPoint: this.options.insertionPoint
      }, options));
      this.plugins.onProcessSheet(sheet);
      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      if (!options.classes) options.classes = {};
      if (!options.jss) options.jss = this;
      if (!options.Renderer) options.Renderer = (0, _findRenderer2['default'])(options);
      if (!options.generateClassName) {
        options.generateClassName = this.options.generateClassName || _generateClassName2['default'];
      }

      var rule = (0, _createRule3['default'])(name, style, options);
      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        return _this.plugins.use(plugin);
      });
      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _findRenderer = __webpack_require__(589);

var _findRenderer2 = _interopRequireDefault(_findRenderer);

var _RulesContainer = __webpack_require__(347);

var _RulesContainer2 = _interopRequireDefault(_RulesContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleSheet = function () {
  function StyleSheet(styles, options) {
    _classCallCheck(this, StyleSheet);

    var Renderer = (0, _findRenderer2['default'])(options);
    var index = typeof options.index === 'number' ? options.index : 0;

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = Object.create(null);
    this.options = _extends({
      sheet: this,
      parent: this,
      classes: this.classes,
      index: index,
      Renderer: Renderer
    }, options);
    this.renderer = new Renderer(this);
    this.renderer.createElement();
    this.rules = new _RulesContainer2['default'](this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          var renderable = this.renderer.insertRule(rule);
          if (renderable && this.options.link) rule.renderable = renderable;
          if (this.queue) {
            this.queue.forEach(this.renderer.insertRule, this.renderer);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var name in styles) {
        added.push(this.addRule(name, styles[name], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy(this);
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) {
        for (var i = 0; i < cssRules.length; i++) {
          var CSSStyleRule = cssRules[i];
          var rule = this.rules.get(CSSStyleRule.selectorText);
          if (rule) rule.renderable = CSSStyleRule;
        }
      }
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(data) {
      this.rules.update(data);
      return this;
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

exports.default = isBrowser;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(346);

var _sheets2 = _interopRequireDefault(_sheets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Get a style property.
 */
function getStyle(rule, prop) {
  try {
    return rule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setStyle(rule, prop, value) {
  try {
    rule.style.setProperty(prop, value);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Get the selector.
 */
function getSelector(rule) {
  return rule.selectorText;
}

/**
 * Set the selector.
 */
function setSelector(rule, selectorText) {
  rule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return rule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = function () {
  var head = void 0;
  return function () {
    if (!head) head = document.head || document.getElementsByTagName('head')[0];
    return head;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var comment = findCommentNode(options.insertionPoint);
  if (comment) return comment.nextSibling;
  return null;
}

var DomRenderer = function () {

  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getStyle = getStyle;
    this.setStyle = setStyle;
    this.setSelector = setSelector;
    this.getSelector = getSelector;

    this.sheet = sheet;
    // There is no sheet when the renderer is used from a standalone RegularRule.
    if (sheet) _sheets2['default'].add(sheet);
  }

  /**
   * Create and ref style element.
   */


  _createClass(DomRenderer, [{
    key: 'createElement',
    value: function createElement() {
      var _ref = this.sheet ? this.sheet.options : {},
          media = _ref.media,
          meta = _ref.meta,
          element = _ref.element;

      this.element = element || document.createElement('style');
      this.element.type = 'text/css';
      this.element.setAttribute('data-jss', '');
      if (media) this.element.setAttribute('media', media);
      if (meta) this.element.setAttribute('data-meta', meta);
    }

    /**
     * Insert style element into render tree.
     */

  }, {
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;
      var prevNode = findPrevNode(this.sheet.options);
      getHead().insertBefore(this.element, prevNode);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy(sheet) {
      this.element.textContent = '\n' + sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var index = cssRules.length;
      var str = rule.toString();

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(rule) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (rule === cssRules[_index]) {
          sheet.deleteRule(_index);
          return true;
        }
      }
      return false;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'createElement',
    value: function createElement() {}
  }, {
    key: 'setStyle',
    value: function setStyle() {
      return true;
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      return '';
    }
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getSelector',
    value: function getSelector() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return true;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(349);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(591);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

var _findClassNames = __webpack_require__(1539);

var _findClassNames2 = _interopRequireDefault(_findClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var parse = JSON.parse,
    stringify = JSON.stringify;

var RegularRule = function () {

  /**
   * We expect `style` to be a plain object.
   * To avoid original style object mutations, we clone it and hash it
   * along the way.
   * It is also the fastetst way.
   * http://jsperf.com/lodash-deepclone-vs-jquery-extend-deep/6
   */
  function RegularRule(name, style, options) {
    _classCallCheck(this, RegularRule);

    this.type = 'regular';
    var generateClassName = options.generateClassName,
        sheet = options.sheet,
        Renderer = options.Renderer;

    var styleStr = stringify(style);
    this.style = parse(styleStr);
    this.name = name;
    this.options = options;
    this.originalStyle = style;
    this.className = '';
    if (options.className) this.className = options.className;else if (generateClassName) this.className = generateClassName(styleStr, this, options.sheet);
    this.selectorText = options.selector || '.' + this.className;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }

  /**
   * Set selector string.
   * Attenition: use this with caution. Most browser didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(RegularRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // Its a setter.
      if (value != null) {
        // Don't do anything if the value has not changed.
        if (this.style[name] !== value) {
          this.style[name] = value;
          // Only defined if option linked is true.
          if (this.renderable) this.renderer.setStyle(this.renderable, name, value);
        }
        return this;
      }
      // Its a getter, read the value from the DOM if its not cached.
      if (this.renderable && this.style[name] == null) {
        // Cache the value after we have got it from the DOM once.
        this.style[name] = this.renderer.getStyle(this.renderable, name);
      }
      return this.style[name];
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setStyle(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful as inline style.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = Object.create(null);
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.selector, this.style, options);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      var sheet = this.options.sheet;

      // After we modify a selector, ref by old selector needs to be removed.

      if (sheet) sheet.rules.unregister(this);

      this.selectorText = selector;
      this.className = (0, _findClassNames2['default'])(selector);

      if (!this.renderable) {
        // Register the rule with new selector.
        if (sheet) sheet.rules.register(this);
        return;
      }

      var changed = this.renderer.setSelector(this.renderable, selector);

      if (changed && sheet) {
        sheet.rules.register(this);
        return;
      }

      // If selector setter is not implemented, rerender the sheet.
      // We need to delete renderable from the rule, because when sheet.deploy()
      // calls rule.toString, it will get the old selector.
      delete this.renderable;
      if (sheet) {
        sheet.rules.register(this);
        sheet.deploy().link();
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      if (this.renderable) {
        return this.renderer.getSelector(this.renderable);
      }

      return this.selectorText;
    }
  }]);

  return RegularRule;
}();

exports['default'] = RegularRule;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = findClassNames;
var dotsRegExp = /[.]/g;
var classesRegExp = /[.][^ ,]+/g;

/**
 * Get class names from a selector.
 */
function findClassNames(selector) {
  var classes = selector.match(classesRegExp);

  if (!classes) return '';

  return classes.join(' ').replace(dotsRegExp, '');
}

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.ruleCreators = [];
    this.ruleProcessors = [];
    this.sheetProcessors = [];
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',


    /**
     * Call `onCreateRule` hooks and return an object if returned by a hook.
     */
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.ruleCreators.length; i++) {
        var rule = this.ruleCreators[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      for (var i = 0; i < this.ruleProcessors.length; i++) {
        this.ruleProcessors[i](rule, rule.options.sheet);
      }
      rule.isProcessed = true;
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.sheetProcessors.length; i++) {
        this.sheetProcessors[i](sheet);
      }
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      if (typeof plugin === 'function') {
        this.ruleProcessors.push(plugin);
        return;
      }

      if (plugin.onCreateRule) this.ruleCreators.push(plugin.onCreateRule);
      if (plugin.onProcessRule) this.ruleProcessors.push(plugin.onProcessRule);
      if (plugin.onProcessSheet) this.sheetProcessors.push(plugin.onProcessSheet);
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(1542);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframeRule = __webpack_require__(1543);

var _KeyframeRule2 = _interopRequireDefault(_KeyframeRule);

var _ConditionalRule = __webpack_require__(1544);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(1545);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(1546);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframeRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']
};

/**
 * Generate plugins which will register all rules.
 */

exports['default'] = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new classes[key](name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(name, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';

    this.name = name;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString() {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.name + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.name + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(348);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var toCssOptions = { indent: 1 };

var KeyframeRule = function () {
  function KeyframeRule(selector, frames, options) {
    _classCallCheck(this, KeyframeRule);

    this.type = 'keyframe';

    this.selector = selector;
    this.options = options;
    this.frames = this.formatFrames(frames);
  }

  /**
   * Creates formatted frames where every frame value is a rule instance.
   */


  _createClass(KeyframeRule, [{
    key: 'formatFrames',
    value: function formatFrames(frames) {
      var newFrames = Object.create(null);
      for (var name in frames) {
        var options = _extends({}, this.options, {
          parent: this,
          className: name,
          selector: name
        });
        var rule = (0, _createRule2['default'])(name, frames[name], options);
        options.jss.plugins.onProcessRule(rule);
        newFrames[name] = rule;
      }
      return newFrames;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var str = this.selector + ' {\n';
      for (var name in this.frames) {
        str += this.frames[name].toString(toCssOptions) + '\n';
      }
      str += '}';
      return str;
    }
  }]);

  return KeyframeRule;
}();

exports['default'] = KeyframeRule;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RulesContainer = __webpack_require__(347);

var _RulesContainer2 = _interopRequireDefault(_RulesContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(selector, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';

    this.selector = selector;
    this.options = options;
    this.rules = new _RulesContainer2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var inner = this.rules.toString({ indent: 1 });
      return inner ? this.selector + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(349);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(selector, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';

    this.selector = selector;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString() {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.selector, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.selector, this.style);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(349);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(name, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';

    this.name = name;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString() {
      return (0, _toCss2['default'])(this.name, this.style);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var globalRef = typeof window === 'undefined' ? global : window;

var namespace = '__JSS_VERSION_COUNTER__';
if (globalRef[namespace] == null) globalRef[namespace] = 0;
// In case we have more than one JSS version.
var jssCounter = globalRef[namespace]++;
var ruleCounter = 0;

/**
 * Generates unique class names.
 */

exports['default'] = function (str, rule) {
  return (
    // There is no rule name if `jss.createRule(style)` was used.
    (rule.name || 'jss') + '-' + jssCounter + '-' + ruleCounter++
  );
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Extracts a styles object with only props that contain function values.
 */
exports['default'] = function (styles) {
  var fnValuesCounter = 0;

  // eslint-disable-next-line no-shadow
  function extract(styles) {
    var to = void 0;

    for (var key in styles) {
      var value = styles[key];
      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

      if (type === 'function') {
        if (!to) to = {};
        to[key] = value;
        fnValuesCounter++;
      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
        if (!to) to = {};
        var _extracted = extract(value);
        if (_extracted) to[key] = _extracted;
      }
    }

    return to;
  }

  var extracted = extract(styles);
  return fnValuesCounter ? extracted : null;
};

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jssExtend = __webpack_require__(1550);

var _jssExtend2 = _interopRequireDefault(_jssExtend);

var _jssNested = __webpack_require__(1551);

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssCamelCase = __webpack_require__(1552);

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssDefaultUnit = __webpack_require__(1553);

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssVendorPrefixer = __webpack_require__(333);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _jssPropsSort = __webpack_require__(1555);

var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

var _jssCompose = __webpack_require__(1556);

var _jssCompose2 = _interopRequireDefault(_jssCompose);

var _jssExpand = __webpack_require__(1557);

var _jssExpand2 = _interopRequireDefault(_jssExpand);

var _jssGlobal = __webpack_require__(1559);

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    plugins: [(0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
  };
};

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isObject(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
}

/**
 * Recursively extend styles.
 */
function extend(rule, newStyle, style) {
  if (typeof style.extend == 'string') {
    if (rule.options && rule.options.sheet) {
      var refRule = rule.options.sheet.getRule(style.extend);
      if (refRule) {
        if (refRule === rule) (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);else extend(rule, newStyle, refRule.originalStyle);
      }
    }
  } else if (Array.isArray(style.extend)) {
    for (var index = 0; index < style.extend.length; index++) {
      extend(rule, newStyle, style.extend[index]);
    }
  } else {
    for (var prop in style.extend) {
      if (prop === 'extend') {
        extend(rule, newStyle, style.extend.extend);
      } else if (isObject(style.extend[prop])) {
        if (!newStyle[prop]) newStyle[prop] = {};
        extend(rule, newStyle[prop], style.extend[prop]);
      } else {
        newStyle[prop] = style.extend[prop];
      }
    }
  }
  // Copy base style.
  for (var _prop in style) {
    if (_prop === 'extend') continue;
    if (isObject(newStyle[_prop]) && isObject(style[_prop])) {
      extend(rule, newStyle[_prop], style[_prop]);
    } else if (isObject(style[_prop])) {
      newStyle[_prop] = extend(rule, {}, style[_prop]);
    } else {
      newStyle[_prop] = style[_prop];
    }
  }

  return newStyle;
}

/**
 * Handle `extend` property.
 *
 * @param {Rule} rule
 * @api public
 */

exports['default'] = function () {
  return function (rule) {
    if (!rule.style || !rule.style.extend) return;
    rule.style = extend(rule, {}, rule.style);
  };
};

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, name) {
      var rule = container.getRule(name);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s. \r\n%s', name, rule);
      return name;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  return function (rule) {
    if (rule.type !== 'regular') return;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;

    for (var prop in rule.style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector);
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        if (!replaceRef) replaceRef = getReplaceRef(container);
        // Replace all $refs.
        selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, rule.style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, _defineProperty({}, rule.name, rule.style[prop]), options);
      }

      delete rule.style[prop];
    }
  };
}

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var regExp = /([A-Z])/g;

/**
 * Replace a string passed from String#replace.
 * @param {String} str
 * @return {String}
 */
function replace(str) {
  return "-" + str.toLowerCase();
}

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var value = style[prop];
    prop = prop.replace(regExp, replace);
    converted[prop] = value;
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */

exports["default"] = function () {
  return function (rule) {
    var style = rule.style;

    if (!style) return;

    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return;
    }

    rule.style = convertCase(style);
  };
};

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(1554);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;
  switch (value.constructor) {
    case Object:
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case Array:
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case Number:
      convertedValue = addUnit(prop, value, options);
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Check if default unit must be added
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {String} string with units
 */
function addUnit(prop, value, options) {
  if (typeof value === 'number' && value !== 0) {
    value += options[prop] || units[prop] || '';
  }
  return value;
}

/**
 * Add unit to numeric values.
 *
 * @param {Rule} rule
 * @api public
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);
  return function (rule) {
    var style = rule.style,
        type = rule.type;

    if (!style || type !== 'regular') return;
    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }
  };
}

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 *
 * @param {Rule} rule
 * @api public
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  return function (rule) {
    var style = rule.style,
        type = rule.type;

    if (!style || type !== 'regular') return;
    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    rule.style = newStyle;
  };
}

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jssCompose;

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set class name.
 *
 * @param {Object} original rule
 * @param {String} compostion class string
 * @return {Boolean} flag, indicating function was successfull or not
 */
function setClass(rule, composition) {
  // Skip falsy values
  if (!composition) return true;

  if (Array.isArray(composition)) {
    for (var index = 0; index < composition.length; index++) {
      var isSetted = setClass(rule, composition[index]);

      if (!isSetted) return false;
    }

    return true;
  }

  if (composition.indexOf(' ') > -1) {
    return setClass(rule, composition.split(' '));
  }

  if (composition[0] === '$') {
    var refRule = rule.options.sheet.getRule(composition.substr(1));

    if (!refRule) {
      (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
      return false;
    }
    if (refRule === rule) {
      (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
      return false;
    }
    setClass(rule, refRule.className);
    return true;
  }

  var container = rule.options.parent;
  rule.className += ' ' + composition;
  container.classes[rule.name] = rule.className;
  return true;
}

/**
 * Convert compose property to additional class, remove property from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssCompose() {
  return function (rule) {
    var style = rule.style;


    if (!style || !style.composes) return;

    setClass(rule, style.composes);

    // Remove composes property to prevent infinite loop.
    delete style.composes;
  };
}

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jssExpand;

var _props = __webpack_require__(1558);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */
function mapValuesByProp(value, prop, rule) {
  return value.map(function (item) {
    return objectToString(item, prop, rule);
  });
}

/**
 * Convert array to string.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {Object} sheme, for converting arrays in strings
 * @param {Object} original rule
 * @return {String} converted string
 */
function arrayToString(value, prop, scheme, rule) {
  if (value.length === 0) return '';
  if (value[0].constructor === Object) return mapValuesByProp(value, prop, rule);
  if (scheme[prop] == null) return value.join(',');
  if (Array.isArray(value[0])) return arrayToString(value[0], prop, scheme);
  return value.join(' ');
}

/**
 * Convert object to string.
 *
 * @param {Object} object of values
 * @param {String} original property
 * @param {Object} original rule
 * @param {Boolean} is fallback prop
 * @return {String} converted string
 */
function objectToString(value, prop, rule, isFallback) {
  if (!(_props.propObj[prop] || _props.customPropObj[prop])) return '';

  var result = [];

  // Check if exists any non-standart property
  if (_props.customPropObj[prop]) {
    value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
  }

  // Pass throught all standart props
  if (Object.keys(value).length) {
    for (var baseProp in _props.propObj[prop]) {
      if (value[baseProp]) {
        if (Array.isArray(value[baseProp])) {
          result.push(arrayToString(value[baseProp], baseProp, _props.propArrayInObj));
        } else result.push(value[baseProp]);
        continue;
      }

      // Add default value from props config.
      if (_props.propObj[prop][baseProp] != null) {
        result.push(_props.propObj[prop][baseProp]);
      }
    }
  }

  return result.join(' ');
}

/**
 * Convert custom properties values to styles adding them to rule directly
 *
 * @param {Object} object of values
 * @param {Object} original rule
 * @param {String} property, that contain partial custom properties
 * @param {Boolean} is fallback prop
 * @return {Object} value without custom properties, that was already added to rule
 */
function customPropsToStyle(value, rule, customProps, isFallback) {
  for (var prop in customProps) {
    var propName = customProps[prop];

    // If current property doesn't exist already in rule - add new one
    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
      var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName];

      // Add style directly in rule
      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
    }
    // Delete converted property to avoid double converting
    delete value[prop];
  }

  return value;
}

/**
 * Detect if a style needs to be converted.
 *
 * @param {Object} style
 * @param {Object} rule
 * @param {Boolean} is fallback prop
 * @return {Object} convertedStyle
 */
function styleDetector(style, rule, isFallback) {
  for (var prop in style) {
    var value = style[prop];

    if (value.constructor === Object) {
      if (prop === 'fallbacks') {
        style[prop] = styleDetector(style[prop], rule, true);
        continue;
      }

      style[prop] = objectToString(value, prop, rule, isFallback);
      // Avoid creating properties with empty values
      if (!style[prop]) delete style[prop];
    }

    // Check double arrays to avoid recursion.
    else if (Array.isArray(value) && !Array.isArray(value[0])) {
        if (prop === 'fallbacks') {
          for (var index = 0; index < style[prop].length; index++) {
            style[prop][index] = styleDetector(style[prop][index], rule, true);
          }
          continue;
        }

        style[prop] = arrayToString(value, prop, _props.propArray);
        // Avoid creating properties with empty values
        if (!style[prop]) delete style[prop];
      }

      // Maybe a computed value resulting in an empty string
      else if (style[prop] === '') delete style[prop];
  }
  return style;
}

/**
 * Adds possibility to write expanded styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssExpand() {
  return function (rule) {
    var style = rule.style;
    var type = rule.type;

    if (!style || type !== 'regular') return;

    if (Array.isArray(style)) {
      // Pass rules one by one and reformat them
      for (var index = 0; index < style.length; index++) {
        style[index] = styleDetector(style[index], rule);
      }
      return;
    }

    rule.style = styleDetector(style, rule);
  };
}

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */
var propArray = exports.propArray = {
  'background-size': true,
  'background-position': true,
  border: true,
  'border-bottom': true,
  'border-left': true,
  'border-top': true,
  'border-right': true,
  'border-radius': true,
  'box-shadow': true,
  flex: true,
  margin: true,
  padding: true,
  outline: true,
  'transform-origin': true,
  transform: true,
  transition: true
};

/**
 * A scheme for converting arrays to regular styles inside of objects.
 * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
 */
var propArrayInObj = exports.propArrayInObj = {
  position: true, // background-position
  size: true // background-size
};

/**
 * A scheme for parsing and building correct styles from passed objects.
 */
var propObj = exports.propObj = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  'border-top': {
    width: null,
    style: null,
    color: null
  },
  'border-right': {
    width: null,
    style: null,
    color: null
  },
  'border-bottom': {
    width: null,
    style: null,
    color: null
  },
  'border-left': {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  'list-style': {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed for avoiding comilation issues with jss-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed to avoid compilation issues with jss-camel-case
    delay: null,
    'iteration-count': null,
    iterationCount: null, // Needed to avoid compilation issues with jss-camel-case
    direction: null,
    'fill-mode': null,
    fillMode: null, // Needed to avoid compilation issues with jss-camel-case
    'play-state': null,
    playState: null // Needed to avoid compilation issues with jss-camel-case
  },
  'box-shadow': {
    x: 0,
    y: 0,
    blur: null,
    spread: null,
    color: null,
    inset: null
  },
  'text-shadow': {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }
};

/**
 * A scheme for converting non-standart properties inside object.
 * For e.g.: include 'border-radius' property inside 'border' object.
 */
var customPropObj = exports.customPropObj = {
  border: {
    radius: 'border-radius'
  },
  background: {
    size: 'background-size',
    image: 'background-image'
  },
  font: {
    style: 'font-style',
    variant: 'font-variant',
    weight: 'font-weight',
    stretch: 'font-stretch',
    size: 'font-size',
    family: 'font-family',
    lineHeight: 'line-height', // Needed to avoid compilation issues with jss-camel-case
    'line-height': 'line-height'
  },
  flex: {
    grow: 'flex-grow',
    basis: 'flex-basis',
    direction: 'flex-direction',
    wrap: 'flex-wrap',
    flow: 'flex-flow',
    shrink: 'flex-shrink'
  },
  align: {
    self: 'align-self',
    items: 'align-items',
    content: 'align-content'
  }
};

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(588);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var key = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(name, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.name = name;
    this.options = options;
    this.rules = new _jss.RulesContainer(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], {
        generateClassName: null,
        selector: selector
      });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, _extends({}, options, {
        generateClassName: null
      }));
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector,
      generateClassName: null
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[key];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector),
      generateClassName: null
    }));
  }

  delete style[key];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, key.length) !== key) continue;

    var selector = addScope(prop.substr(key.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector,
      generateClassName: null
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === key) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) {
      options.selector = name;
      options.generateClassName = null;
    }

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'regular' || !rule.style) return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

/**
 * JSS port of normalize.css. Inspired by:
 * https://github.com/necolas/normalize.css
 *
 * NOTE:
 * 1. Dropped support of IE9. So, removed from original normalize rules, writtend specially for IE9
 * 2. Required jss plugins for correct working:
 *    2.1. jss-vendor-preifxer
 *    2.2. jss-camelcase
 * Anyway, you can use a preset (https://github.com/cssinjs/jss-preset-default) for a quick setup with default plugins.
 */

module.exports = {

  '@global': {

    /**
     * 1. Change the default font family in all browsers (opinionated).
     * 2. Correct the line height in all browsers.
     * 3. Prevent adjustments of font size after orientation changes in IE and iOS.
     */
    html: {
      fontFamily: 'sans-serif', /* 1 */
      lineHeight: '1.15', /* 2 */
      textSizeAdjust: '100%', /* 3 */
    },

    /**
     * Remove the margin in all browsers (opinionated).
     */
    body: {
      margin: 0,
    },

    /**
     * Add the correct display in IE9
     */
    'article, aside, footer, header, nav, section, figcaption, figure, main': {
      display: 'block',
    },

    /**
     * Correct the font size and margin on `h1` elements within `section` and
     * `article` contexts in Chrome, Firefox, and Safari.
     */
    h1: {
      fontSize: '2em',
      margin: [['0.67em', 0]],
    },

    /**
     * 1. Add the correct box sizing in Firefox.
     * 2. Show the overflow in Edge and IE.
     */
    hr: {
      boxSizing: 'content-box', /* 1 */
      height: 0, /* 1 */
      overflow: 'visible', /* 2 */
    },

    /**
     * 1. Correct the inheritance and scaling of font size in all browsers.
     * 2. Correct the odd `em` font sizing in all browsers.
     */
    pre: {
      fontFamily: 'monospace, monospace', /* 1 */
      fontSize: '1em', /* 2 */
    },

    /**
     * 1. Remove the gray background on active links in IE 10.
     * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
     * 3. Remove the outline on focused links when they are also
     *    active or hovered in all browsers (opinionated).
     */
    a: {
      background: 'transparent', /* 1 */
      textDecorationSkip: 'objects', /* 2 */
    },
    'a:active, a:hover': {
      outlineWidth: 0, /* 3 */
    },

    /**
     * 1. Remove the bottom border in Firefox 39-.
     * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
     */
    'abbr[title]': {
      borderBottom: 'none', /* 1 */
      textDecoration: 'underline', /* 2 */
    },

    /**
     * Add the correct font weight in Chrome, Edge, and Safari.
     */
    'b, strong': {
      fontWeight: 'bolder',
    },

    /**
     * 1. Correct the inheritance and scaling of font size in all browsers.
     * 2. Correct the odd `em` font sizing in all browsers.
     */
    'code, kbp, samp': {
      fontFamily: 'monospace, monospace', /* 1 */
      fontSize: '1em', /* 2 */
    },

    /**
     * Add the correct font style in Android 4.3-.
     */
    dfn: {
      fontStyle: 'italic',
    },

    /**
     * Add the correct background and color in IE 9-.
     */
    mark: {
      backgroundColor: '#ff0',
      color: '#000',
    },

    /**
     * Add the correct font size in all browsers.
     */
    small: {
      fontSize: '80%',
    },

    /**
     * Prevent `sub` and `sup` elements from affecting the line height in
     * all browsers.
     */
    'sub, sup': {
      fontSize: '75%',
      lineHeight: 0,
      position: 'relative',
      verticalAlign: 'baseline'
    },
    sup: {
      top: '-0.5em'
    },
    sub: {
      bottom: '-0.25em'
    },

    /**
     * Add the correct display in IE 9-.
     */
    'audio, video': {
      display: 'inline-block',
    },

    /**
     * Add the correct display in iOS 4-7.
     */
    'audio:not([controls])': {
      display: 'none',
      height: 0,
    },

    /**
     * 1. Remove the border on images inside links in IE 10-.
     * 2. Remove extra space in all browsers
     */
    img: {
      borderStyle: 'none', /* 1 */
      verticalAlign: 'middle', /* 2 */
    },

    /**
     * Hide the overflow in IE.
     */
    'svg:not(:root)': {
      overflow: 'hidden',
    },

    /**
     * 1. Change the font styles in all browsers (opinionated).
     * 2. Remove the margin in Firefox and Safari.
     */
    'button, input, optgroup, select, textarea': {
      fontFamily: 'sans-serif', /* 1 */
      fontSize: '100%', /* 1 */
      lineHeight: '1.15', /* 1 */
      margin: 0, /* 2 */
    },

    /**
     * Show the overflow in IE & Edge.
     */
    'button, input': {
      overflow: 'visible',
    },

    /**
     * Remove the inheritance of text transform in Edge, Firefox, and IE.
     */
    'button, select': {
      textTransform: 'none',
    },

    /**
     * Correct the inability to style clickable types in iOS and Safari.
     */
    'button, [type=reset], [type=submit]': {
      '-webkit-appearance': 'button',
    },

    /**
     * Remove the inner border and padding in Firefox.
     */
    'button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner': {
      borderStyle: 'none',
      padding: 0,
    },

    /**
     * Restore the focus styles unset by the previous rule.
     */
    'button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring': {
      outline: '1px dotted ButtonText',
    },

    /**
     * Change the border, margin, and padding in all browsers (opinionated).
     */
    fieldset: {
      border: '1px solid #c0c0c0',
      margin: [[0, '2px']],
      padding: [['0.35em', '0.625em', '0.75em']],
    },

    /**
     * 1. Correct the text wrapping in Edge and IE.
     * 2. Correct the color inheritance from `fieldset` elements in IE.
     * 3. Remove the padding so developers are not caught out when they zero out
     *    `fieldset` elements in all browsers.
     */
    legend: {
      boxSizing: 'border-box', /* 1 */
      color: 'inherit', /* 2 */
      display: 'table', /* 1 */
      maxWidth: '100%', /* 1 */
      padding: 0, /* 3 */
      whiteSpace: 'normal', /* 1 */
    },

    /**
     * 1. Add the correct display in IE 9-.
     * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
     */
    progress: {
      display: 'inline-block', /* 1 */
      verticalAlign: 'baseline', /* 2 */
    },

    /**
     * Remove the default vertical scrollbar in IE.
     */
    textarea: {
      overflow: 'auto',
    },

    /**
     * 1. Add the correct box sizing in IE 10-.
     * 2. Remove the padding in IE 10-.
     */
    '[type=checkbox], [type=radio]': {
      boxSizing: 'border-box', /* 1 */
      padding: 0, /* 2 */
    },

    /**
     * Correct the cursor style of increment and decrement buttons in Chrome.
     */
    '[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button': {
      height: 'auto'
    },

    /**
     * 1. Correct the odd appearance in Chrome and Safari.
     * 2. Correct the outline style in Safari.
     */
    '[type=search]': {
      appearance: 'textfield', /* 1 */
      outlineOffset: '-2px', /* 2 */
    },

    /**
     * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.
     */
    '[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration': {
      appearance: 'none',
    },

    /**
     * 1. Correct the inability to style clickable types in iOS and Safari.
     * 2. Change font properties to `inherit` in Safari.
     */
    '::-webkit-file-upload-button': {
      appearance: 'button', /* 1 */
      font: 'inherit', /* 2 */
    },

    /*
     * Add the correct display in Edge, IE, and Firefox.
     */
    'details, menu': {
      display: 'block',
    },

    /*
     * Add the correct display in all browsers.
     */
    summary: {
      display: 'list-item',
    },

    /**
     * Add the correct display in IE 9-.
     */
    canvas: {
      display: 'inline-block',
    },

    /**
     * Add the correct display in IE.
     */
    template: {
      display: 'none',
    },

    /**
     * Add the correct display in IE 10-.
     */
    '[hidden]': {
      display: 'none',
    }

  }
}


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resolvePathname = exports.oauthRedirect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(148);

var _reactRedux = __webpack_require__(89);

var _reselect = __webpack_require__(33);

var _path = __webpack_require__(149);

var _path2 = _interopRequireDefault(_path);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _querystring = __webpack_require__(193);

var _querystring2 = _interopRequireDefault(_querystring);

var _BetaRouter = __webpack_require__(1565);

var _BetaRouter2 = _interopRequireDefault(_BetaRouter);

var _util = __webpack_require__(694);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

var _feature = __webpack_require__(145);

var _routing = __webpack_require__(383);

var _feature2 = __webpack_require__(189);

var _feature3 = _interopRequireDefault(_feature2);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

var _url = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var searchPaths = ['/build', '/data', '/pushbots', '/search', '/start', '/tasks'];

// The below function handles redirecting requests from https://security.pushbot.com/oauth
// to the appropriate experience's oauth redirect handler, maintaining backwards compatibility
// with the legacy experience.

// We are unable to use the session user.experience selector,
// as we are missing the userSession in this context.
var oauthRedirect = exports.oauthRedirect = function oauthRedirect(_ref) {
  var location = _ref.location;

  var qp = _querystring2.default.parse(location.search.slice(1));
  var oauthState = void 0;
  try {
    oauthState = JSON.parse(Buffer.from(qp.state, 'base64').toString());
    if (oauthState.exp === 'beta') {
      var destination = oauthState.origin + location.search;
      _context2.default.location = destination;
      // The below return is for testing purposes.
      return destination;
    }
  } catch (ex) {
    var _destination = _env2.default.PUSHBOT_OAUTH_REDIRECT_URL.replace('oauth', 'legacy/oauth') + location.search;
    _context2.default.location = _destination;
    // Same reasoning as above -- the below return is for testing purposes.
    return _destination;
  }
};

var referrer = (0, _reselect.createSelector)(_routing.pathname, _routing.query, function (pathname, query) {
  return (0, _url.format)({ pathname: pathname, query: query });
});

var resolvePathname = exports.resolvePathname = function resolvePathname(_ref2, replace) {
  var location = _ref2.location;
  var pathname = location.pathname;

  var resolvedPath = _path2.default.resolve(pathname);
  if (pathname !== resolvedPath) {
    return replace(_extends({}, location, {
      pathname: resolvedPath
    }));
  }
};

var resolvePathnameOnChange = function resolvePathnameOnChange(prev, next, replace, done) {
  resolvePathname(next, replace);

  done();
};

var embeddedModeEnabled = function embeddedModeEnabled() {
  try {
    var embeddedMode = JSON.parse(_env2.default.PUSHBOT_EMBEDDED_MODE);
    return embeddedMode;
  } catch (e) {
    return false;
  }
};

var routes = (0, _reselect.createSelector)(embeddedModeEnabled, _feature.manualReportingEnabled, _feature.timelineChartEnabled, _feature.webformsV2Enabled, _feature.workDoneBetterNavigationEnabled, function (embeddedMode, manualReportingEnabled, timelineChart, webformsV2, workDoneBetterNavigation) {
  return [].concat(_toConsumableArray(_util.releasePath ? // eslint-disable-next-line react/jsx-key
  [_react2.default.createElement(_reactRouter.Route, { path: _util.releasePath, onEnter: (0, _util.redirectReferrer)() })] : []), [
  // eslint-disable-next-line react/jsx-key
  _react2.default.createElement(
    _reactRouter.Route,
    { onEnter: resolvePathname, onChange: resolvePathnameOnChange },
    _react2.default.createElement(_reactRouter.Route, { path: 'oauth', onEnter: oauthRedirect }),
    _react2.default.createElement(
      _reactRouter.Route,
      null,
      (0, _BetaRouter2.default)({
        embeddedMode: embeddedMode,
        manualReportingEnabled: manualReportingEnabled,
        timelineChart: timelineChart,
        webformsV2: webformsV2,
        workDoneBetterNavigation: workDoneBetterNavigation
      })
    ),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'forbidden',
      getComponent: function getComponent(next, done) {
        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1910)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
      }
    }),
    ',',
    _react2.default.createElement(_reactRouter.Route, {
      path: '*',
      getComponent: function getComponent(next, done) {
        __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1958)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
      }
    })
  )]);
});

var VersionRouter = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    embeddedModeEnabled: (0, _feature.embeddedModeEnabled)(state),
    manualReportingEnabled: (0, _feature.manualReportingEnabled)(state),
    referrer: referrer(state, props),
    routes: routes(state),
    timelineChart: (0, _feature.timelineChartEnabled)(state),
    webformsV2: (0, _feature.webformsV2Enabled)(state),
    workDoneBetterNavigation: (0, _feature.workDoneBetterNavigationEnabled)(state)
  };
}), _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
  _inherits(VersionRouter, _PureComponent);

  function VersionRouter() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, VersionRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = VersionRouter.__proto__ || Object.getPrototypeOf(VersionRouter)).call.apply(_ref3, [this].concat(args))), _this), _this.createElement = function (Component, props) {
      var pathname = props.location.pathname;
      var key = searchPaths.indexOf(pathname) !== -1 ? pathname : undefined;
      return _react2.default.createElement(Component, _extends({ key: key }, props));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VersionRouter, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          embeddedModeEnabled = _props.embeddedModeEnabled,
          history = _props.history,
          manualReportingEnabled = _props.manualReportingEnabled,
          referrer = _props.referrer,
          timelineChart = _props.timelineChart,
          webformsV2 = _props.webformsV2,
          workDoneBetterNavigation = _props.workDoneBetterNavigation;

      // Force hard refresh when embedded mode feature flag is toggled.

      if (prevProps.embeddedModeEnabled === false && embeddedModeEnabled === true) {
        _context2.default.location.replace(referrer || '/');
        return;
      }

      switch (false) {
        case timelineChart === prevProps.timelineChart:
        case webformsV2 === prevProps.webformsV2:
        case manualReportingEnabled === prevProps.manualReportingEnabled:
        case workDoneBetterNavigation === prevProps.workDoneBetterNavigation:
          history.push(referrer || '/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          history = _props2.history,
          routes = _props2.routes;


      return _react2.default.createElement(_reactRouter.Router, {
        history: history,
        createElement: this.createElement,
        routes: routes
      });
    }
  }]);

  return VersionRouter;
}(_react.PureComponent), _class2.displayName = 'VersionRouter', _class2.propTypes = {
  embeddedModeEnabled: _feature3.default,
  history: _propTypes2.default.objectOf(_propTypes2.default.func).isRequired,
  manualReportingEnabled: _feature3.default,
  referrer: _propTypes2.default.string,
  routes: _propTypes2.default.arrayOf(_propTypes2.default.node),
  timelineChart: _feature3.default,
  webformsV2: _feature3.default,
  workDoneBetterNavigation: _feature3.default
}, _temp2)) || _class);
exports.default = VersionRouter;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(823).Buffer))

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1563 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1564 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectIfNotAdmin = exports.createRedirect = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = BetaRouter;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(148);

var _App = __webpack_require__(1566);

var _App2 = _interopRequireDefault(_App);

var _util = __webpack_require__(694);

var _store = __webpack_require__(313);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createRedirect = function createRedirect(substr, next) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var replace = arguments[1];
    var _ref$location = _ref.location;
    _ref$location = _ref$location === undefined ? {} : _ref$location;

    var _ref$location$pathnam = _ref$location.pathname,
        pathname = _ref$location$pathnam === undefined ? '/' : _ref$location$pathnam,
        others = _objectWithoutProperties(_ref$location, ['pathname']);

    return replace(_extends({}, others, { pathname: pathname.replace(substr, next) }));
  };
};

exports.createRedirect = createRedirect;
var redirectFromBeta = createRedirect(/^\/beta\/?/, '/');
var redirectFromX = createRedirect(/^\/x\/?/, '/');

var redirectLegacyRoutines = function redirectLegacyRoutines() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var replace = arguments[1];
  var _ref2$location = _ref2.location;
  _ref2$location = _ref2$location === undefined ? {} : _ref2$location;

  var _ref2$location$pathna = _ref2$location.pathname,
      pathname = _ref2$location$pathna === undefined ? '/' : _ref2$location$pathna,
      others = _objectWithoutProperties(_ref2$location, ['pathname']),
      _ref2$params = _ref2.params;

  _ref2$params = _ref2$params === undefined ? {} : _ref2$params;
  var runID = _ref2$params.runID;
  return replace(_extends({}, others, { pathname: '/pushbots/' + runID }));
};

var redirectLegacyTasks = function redirectLegacyTasks() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var replace = arguments[1];
  var _ref3$location = _ref3.location;
  _ref3$location = _ref3$location === undefined ? {} : _ref3$location;

  var _ref3$location$pathna = _ref3$location.pathname,
      pathname = _ref3$location$pathna === undefined ? '/' : _ref3$location$pathna,
      others = _objectWithoutProperties(_ref3$location, ['pathname']),
      _ref3$params = _ref3.params;

  _ref3$params = _ref3$params === undefined ? {} : _ref3$params;
  var runID = _ref3$params.runID,
      taskName = _ref3$params.taskName;
  return replace(_extends({}, others, { pathname: '/pushbots/' + runID + '/tasks/' + taskName }));
};

var redirectLegacyTemplates = function redirectLegacyTemplates() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var replace = arguments[1];
  var _ref4$location = _ref4.location;
  _ref4$location = _ref4$location === undefined ? {} : _ref4$location;

  var _ref4$location$pathna = _ref4$location.pathname,
      pathname = _ref4$location$pathna === undefined ? '/' : _ref4$location$pathna,
      others = _objectWithoutProperties(_ref4$location, ['pathname']),
      _ref4$params = _ref4.params;

  _ref4$params = _ref4$params === undefined ? {} : _ref4$params;
  var runID = _ref4$params.runID;
  return replace(_extends({}, others, { pathname: '/build/' + runID }));
};

var redirectIfNotAdmin = function redirectIfNotAdmin() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var replace = arguments[1];
  var _ref5$location = _ref5.location;
  _ref5$location = _ref5$location === undefined ? {} : _ref5$location;

  var _ref5$location$pathna = _ref5$location.pathname,
      pathname = _ref5$location$pathna === undefined ? '/' : _ref5$location$pathna,
      others = _objectWithoutProperties(_ref5$location, ['pathname']),
      _ref5$params = _ref5.params;

  _ref5$params = _ref5$params === undefined ? {} : _ref5$params;
  var runID = _ref5$params.runID;

  var session = _store2.default.getState().session;
  var isTeamOwner = session.isTeamOwner,
      isTeamAdmin = session.isTeamAdmin;

  if (!isTeamOwner && !isTeamAdmin) replace(_extends({}, others, { pathname: '/' }));
};

exports.redirectIfNotAdmin = redirectIfNotAdmin;
function BetaRouter() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var embeddedMode = features.embeddedMode,
      manualReportingEnabled = features.manualReportingEnabled,
      timelineChart = features.timelineChart,
      webformsV2 = features.webformsV2,
      workDoneBetterNavigation = features.workDoneBetterNavigation;


  return _react2.default.createElement(
    _reactRouter.Route,
    null,
    _react2.default.createElement(_reactRouter.Route, { path: 'beta*', onEnter: redirectFromBeta }),
    _react2.default.createElement(_reactRouter.Route, { path: 'x*', onEnter: redirectFromX }),
    _react2.default.createElement(_reactRouter.Route, { path: 'routines/:runID', onEnter: redirectLegacyRoutines }),
    _react2.default.createElement(_reactRouter.Route, { path: 'tasks/:runID/:taskName', onEnter: redirectLegacyTasks }),
    _react2.default.createElement(_reactRouter.Route, { path: 'templates/:runID', onEnter: redirectLegacyTemplates }),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: function onEnter(next, replace, done) {
          return (0, _util.anonymous)(next, replace, done);
        } },
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'login' },
        _react2.default.createElement(_reactRouter.IndexRoute, {
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, 1918)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'forgot',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, 1919)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'sudo',
          onEnter: function onEnter(next, replace, done) {
            return (0, _util.anonymous)(next, replace, done, true);
          },
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, 1920)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        })
      )
    ),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'deadbeef',
      getComponent: function getComponent(next, done) {
        Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, 1921)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'invitation/:id',
      onEnter: function onEnter(_ref6, replace) {
        var location = _ref6.location,
            _ref6$params = _ref6.params;
        _ref6$params = _ref6$params === undefined ? {} : _ref6$params;
        var id = _ref6$params.id;

        replace({
          pathname: '/join',
          query: { invitation: id },
          state: { referrer: location }
        });
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'invites/:id',
      onEnter: function onEnter(_ref7, replace) {
        var location = _ref7.location,
            _ref7$params = _ref7.params;
        _ref7$params = _ref7$params === undefined ? {} : _ref7$params;
        var id = _ref7$params.id;

        replace({
          pathname: '/join',
          query: { invitation: id },
          state: { referrer: location }
        });
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'join',
      getComponent: function getComponent(next, done) {
        Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, 1922)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
      }
    }),
    webformsV2 && _react2.default.createElement(_reactRouter.Redirect, { path: 'forms/:name', to: 'form/:name' }),
    ['webforms/:id', 'forms/:webhookname'].map(function (path, i) {
      return _react2.default.createElement(_reactRouter.Route, _extends({
        getComponent: function getComponent(next, done) {
          Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, 1923)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
        },
        key: i
      }, { path: path }));
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'progress/:runID',
      getComponent: function getComponent(next, done) {
        Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, 1924)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
      }
    }),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _App2.default },
      _react2.default.createElement(
        _reactRouter.Route,
        {
          path: '/',
          onEnter: _util.authenticate,
          onChange: function onChange(prev, next, replace, done) {
            return (0, _util.authenticate)(next, replace, done);
          }
        },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'tasks' }),
        _react2.default.createElement(_reactRouter.Redirect, { from: 'home', to: 'tasks' }),
        !embeddedMode && _react2.default.createElement(_reactRouter.Redirect, { from: 'processes', to: 'pushbots' }),
        _react2.default.createElement(
          _reactRouter.Route,
          {
            searchButton: true,
            path: 'build',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 156)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          },
          _react2.default.createElement(_reactRouter.Route, {
            path: 'new',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, 1925)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          })
        ),
        embeddedMode && _react2.default.createElement(_reactRouter.Route, {
          path: 'build/:processID/test',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, 200)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(
          _reactRouter.Route,
          { detail: true, path: 'build/:processID' },
          _react2.default.createElement(_reactRouter.IndexRoute, {
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 431)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(
            _reactRouter.Route,
            {
              getComponent: function getComponent(next, done) {
                Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 431)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
              }
            },
            _react2.default.createElement(_reactRouter.Route, {
              path: 'start',
              getComponent: function getComponent(next, done) {
                Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, 200)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
              }
            }),
            !embeddedMode && _react2.default.createElement(_reactRouter.Route, {
              path: 'test',
              getComponent: function getComponent(next, done) {
                Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, 200)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
              }
            })
          ),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'fields',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 1926)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'fields/:fieldName',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 1927)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            appDrawer: false,
            detail: false,
            paper: false,
            path: 'flow',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, 1928)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'tasks/:stepName',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 850)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'tasks/:stepName/test',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 850)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'tasks/:stepName/fields',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 1929)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'tasks/:stepName/fields/:fieldName',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 1930)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'tasks/:stepName/action/:actionName',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 1931)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: ':menu',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 431)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          })
        ),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'group/:groupName',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, 1932)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'integrations' },
          _react2.default.createElement(_reactRouter.IndexRoute, {
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, 1933)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            },
            onEnter: redirectIfNotAdmin
          }),
          _react2.default.createElement(_reactRouter.Route, {
            detail: true,
            path: 'add',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, 1934)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            },
            onEnter: redirectIfNotAdmin
          }),
          _react2.default.createElement(_reactRouter.Route, {
            detail: true,
            path: 'add/:appName',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, 851)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            },
            onEnter: redirectIfNotAdmin
          }),
          _react2.default.createElement(_reactRouter.Route, {
            detail: true,
            path: 'edit/:username',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, 851)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            },
            onEnter: redirectIfNotAdmin
          }),
          _react2.default.createElement(_reactRouter.Route, {
            detail: true,
            path: 'app/:appName',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, 1935)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            },
            onEnter: redirectIfNotAdmin
          })
        ),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'notifications',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, 1936)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Redirect, { path: 'profile', to: 'profile/me' }),
        _react2.default.createElement(
          _reactRouter.Route,
          {
            detail: true,
            path: 'profile/:username',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1908)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          },
          _react2.default.createElement(_reactRouter.Route, {
            path: 'password',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1937)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'photo',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1938)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'phone',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1939)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'email',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1940)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'fullname',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1941)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'permissions',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1942)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'notifications',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1943)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'version',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1944)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'slack',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 1945)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          })
        ),
        _react2.default.createElement(_reactRouter.Route, {
          searchButton: true,
          path: 'pushbots',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 156)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(
          _reactRouter.Route,
          {
            path: 'pushbots/:runID',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1912)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          },
          _react2.default.createElement(_reactRouter.Route, {
            path: 'abort',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1911)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'comment',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 852)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: 'tasks/:taskName' },
            _react2.default.createElement(_reactRouter.Route, {
              path: 'reassign',
              getComponent: function getComponent(next, done) {
                Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1946)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
              }
            }),
            _react2.default.createElement(_reactRouter.Route, {
              path: 'reopen',
              getComponent: function getComponent(next, done) {
                Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1947)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
              }
            }),
            _react2.default.createElement(_reactRouter.Route, {
              path: 'snooze',
              getComponent: function getComponent(next, done) {
                Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1948)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
              }
            })
          )
        ),
        _react2.default.createElement(_reactRouter.Route, {
          detail: true,
          path: 'pushbots/:runID/tasks/:taskName/details',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1949)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'pushbots/:runID/tasks/:taskName/comments',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 852)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          detail: true,
          path: 'pushbots/:runID/tasks/:taskName/wait',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1950)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        !manualReportingEnabled && _react2.default.createElement(_reactRouter.Redirect, { path: 'report', to: '/data' }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'report',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, 853)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          detail: true,
          path: 'singleSignOn',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, 1951)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(
          _reactRouter.Route,
          {
            searchButton: true,
            path: 'start',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 156)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          },
          !embeddedMode && _react2.default.createElement(_reactRouter.Route, {
            path: ':processID',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, 200)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          })
        ),
        embeddedMode && _react2.default.createElement(_reactRouter.Route, {
          path: 'start/:processID',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, 200)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          searchButton: true,
          path: 'tasks',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 156)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        !workDoneBetterNavigation && _react2.default.createElement(_reactRouter.Redirect, { path: 'search*', to: 'tasks' }),
        _react2.default.createElement(_reactRouter.Route, {
          searchButton: true,
          path: 'search',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 156)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Redirect, { path: 'team', to: 'team/members' }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'team/:tab(/:action)',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, 1952)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(
          _reactRouter.Route,
          {
            searchButton: true,
            path: 'data',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 156)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          },
          !manualReportingEnabled && _react2.default.createElement(_reactRouter.Redirect, { path: 'report', to: '/data' }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'report',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, 853)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'import',
            getComponent: function getComponent(next, done) {
              __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1909)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          })
        ),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'data/tables/:tableID',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, 854)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'data/tables/:tableID/:menu',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, 854)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(
          _reactRouter.Route,
          {
            path: 'models',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, 1953)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          },
          _react2.default.createElement(_reactRouter.Route, {
            path: ':predictorID',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, 1954)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: ':predictorID/status',
            getComponent: function getComponent(next, done) {
              Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, 1955)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
            }
          })
        ),
        !timelineChart && _react2.default.createElement(_reactRouter.Redirect, { path: 'chart*', to: 'report' }),
        _react2.default.createElement(_reactRouter.Redirect, { path: 'chart', to: 'report' }),
        _react2.default.createElement(_reactRouter.Redirect, { path: 'chart/:tableID', to: 'report' }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'chart/:tableID/:type',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, 1956)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'triggers(/:triggerID)',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, 855)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'build/:processID/triggers/:triggerID',
          getComponent: function getComponent(next, done) {
            Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, 855)).then((0, _util.loadRoute)(done)).catch(_util.errorLoadingRoute);
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'files/:fileID/download',
          getComponent: function getComponent(next, done) {
            return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(23)]).then((function (require) {
              return done(null, __webpack_require__(1957).default);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          }
        })
      )
    )
  );
}

BetaRouter.displayName = 'BetaRouter';

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(89);

var _reactIntl = __webpack_require__(181);

var _browserHistory = __webpack_require__(182);

var _browserHistory2 = _interopRequireDefault(_browserHistory);

var _users = __webpack_require__(386);

var _reselect = __webpack_require__(33);

var _auth = __webpack_require__(92);

var _app = __webpack_require__(540);

var _notifications = __webpack_require__(403);

var _user = __webpack_require__(187);

var _team = __webpack_require__(118);

var _session = __webpack_require__(569);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

var _App = __webpack_require__(771);

var _App2 = _interopRequireDefault(_App);

var _performanceContainer = __webpack_require__(1906);

var _performanceContainer2 = _interopRequireDefault(_performanceContainer);

var _url = __webpack_require__(31);

var _toast = __webpack_require__(183);

var _app2 = __webpack_require__(716);

var _entities = __webpack_require__(184);

var _session2 = __webpack_require__(117);

var _feature = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectUnreadNotifications = (0, _reselect.createSelector)(_entities.notificationsList, function () {
  var notificationsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return notificationsList.filter(function (notification) {
    return notification.read === false;
  });
});

var embeddedMode = JSON.parse(_env2.default.PUSHBOT_EMBEDDED_MODE);

exports.default = (0, _reactRedux.connect)(function (state, props) {
  return _extends({}, (0, _app2.page)(state, props), {
    aiModelEnabled: (0, _feature.aiModelEnabled)(state),
    frontEndPerformanceMonitoringEnabled: (0, _feature.frontEndPerformanceMonitoringEnabled)(state),
    fullName: (0, _session2.fullName)(state),
    isTeamAdmin: (0, _session2.isTeamAdmin)(state),
    isTeamOwner: (0, _session2.isTeamOwner)(state),
    queryText: (0, _app2.parsedQueryText)(state),
    teamName: (0, _session2.teamName)(state),
    unreadNotifications: selectUnreadNotifications(state),
    username: (0, _session2.username)(state),
    userThumbnail: (0, _session2.userThumbnail)(state),
    splitPaneEnabled: (0, _feature.splitPaneEnabled)(state),
    watchListEnabled: (0, _feature.watchListEnabled)(state),
    workDoneBetterNavigationEnabled: (0, _feature.workDoneBetterNavigationEnabled)(state),
    newlyAuthenticated: (0, _session2.newlyAuthenticated)(state),
    newlyAuthenticatedSSO: (0, _session2.newlyAuthenticatedSSO)(state)
  });
}, function (dispatch) {
  return {
    onDidMount: function onDidMount(_ref) {
      var teamName = _ref.teamName,
          username = _ref.username,
          newlyAuthenticated = _ref.newlyAuthenticated,
          newlyAuthenticatedSSO = _ref.newlyAuthenticatedSSO,
          _ref$intl = _ref.intl;
      _ref$intl = _ref$intl === undefined ? {} : _ref$intl;
      var formatMessage = _ref$intl.formatMessage;

      if (username) {
        return Promise.all([dispatch((0, _user.getUser)({ teamName: teamName, username: username })), dispatch((0, _team.getTeam)({ teamName: teamName })), dispatch((0, _notifications.getNotifications)({ teamName: teamName, username: username, read: false }))]).then(function (results) {
          var _results$1$response$e = results[1].response.entities.teams,
              teams = _results$1$response$e === undefined ? {} : _results$1$response$e;

          var team = teams[teamName];
          var ssoEnabled = team && team.samlConfig && team.samlConfig.enabled;
          if (newlyAuthenticated || ssoEnabled && newlyAuthenticatedSSO) {
            var _results$0$response = results[0].response,
                _results$0$response$e = _results$0$response.entities.users,
                users = _results$0$response$e === undefined ? {} : _results$0$response$e,
                userID = _results$0$response.result;
            var lastLogin = users[userID].lastLogin;


            dispatch((0, _session.resetNewlyAuthenticated)());
            if (lastLogin) {
              var message = (0, _users.formattedLastLoginMessage)(lastLogin, formatMessage);
              return dispatch((0, _toast.toast)({ message: message, autoHideDuration: 10000 }));
            }
          }
        });
      } else {
        return Promise.resolve();
      }
    },
    onNavigation: function onNavigation() {
      return dispatch((0, _app.navigate)());
    },
    onSearchReset: function onSearchReset(text, terms, location) {
      return _browserHistory2.default.push((0, _url.format)(location));
    },
    onSearchSubmit: function onSearchSubmit(text, terms, location) {
      return _browserHistory2.default.push((0, _url.format)(location));
    },
    onSignOut: function onSignOut(_ref2) {
      var teamName = _ref2.teamName,
          username = _ref2.username;

      dispatch((0, _auth.logout)({ teamName: teamName, username: username }));
      dispatch((0, _auth.invalidate)());
      dispatch((0, _toast.clearToast)());
      embeddedMode ? _browserHistory2.default.push('/auth') : _browserHistory2.default.push('/login');
    },
    store: function store(nextProps, merge, path) {
      return dispatch((0, _app.store)(nextProps, merge, path));
    },
    update: function update(nextProps, merge, path) {
      return dispatch((0, _app.update)(nextProps, merge, path));
    }
  };
})((0, _performanceContainer2.default)((0, _reactIntl.injectIntl)(_App2.default)));

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": 592,
	"./de-at": 593,
	"./de-at.js": 593,
	"./de-ch": 594,
	"./de-ch.js": 594,
	"./de.js": 592,
	"./en-au": 595,
	"./en-au.js": 595,
	"./en-ca": 596,
	"./en-ca.js": 596,
	"./en-gb": 597,
	"./en-gb.js": 597,
	"./en-ie": 598,
	"./en-ie.js": 598,
	"./en-nz": 599,
	"./en-nz.js": 599,
	"./es": 600,
	"./es-do": 601,
	"./es-do.js": 601,
	"./es-us": 602,
	"./es-us.js": 602,
	"./es.js": 600
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1567;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LastLogin = __webpack_require__(1569);

Object.defineProperty(exports, 'LastLogin', {
  enumerable: true,
  get: function get() {
    return _LastLogin.LastLogin;
  }
});

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastLogin = undefined;

var _reactIntl = __webpack_require__(181);

var LastLogin = exports.LastLogin = (0, _reactIntl.defineMessages)({
  message: {
    currentIP: {
      id: 'login.lastLogin.message.currentIP',
      describe: 'A message showing the user\'s last login when that login was from the same IP address as the current user\'s. Consists of the user-formatted date and time',
      defaultMessage: 'Your last login was on {loginDate} at {loginTime}'
    },
    differentIP: {
      id: 'login.lastLogin.message.differentIP',
      describe: 'A message showing the user\'s last login when that login was from a different IP address than the current user\'s. Consists of the user-formatted date and time and the IP address associated with the login',
      defaultMessage: 'Your last login was on {loginDate} at {loginTime} from IP address {ipAddress}'
    }
  }
});

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(1571);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(1581);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(613);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(616);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.createStyleManager = createStyleManager;

var _jssVendorPrefixer = __webpack_require__(333);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _murmurhash3_gc = __webpack_require__(562);

var _murmurhash3_gc2 = _interopRequireDefault(_murmurhash3_gc);

var _utils = __webpack_require__(1597);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixRule = (0, _jssVendorPrefixer2.default)();

/**
 * Creates a new styleManager
 */

function createStyleManager() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      jss = _ref.jss,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme;

  if (!jss) {
    throw new Error('No JSS instance provided');
  }

  var sheetMap = [];
  var sheetOrder = void 0;

  // Register custom jss generateClassName function
  jss.options.generateClassName = generateClassName;

  function generateClassName(str, rule) {
    var hash = (0, _murmurhash3_gc2.default)(str);
    str = rule.name ? rule.name + '-' + hash : hash;

    // Simplify after next release with new method signature
    if (rule.options.sheet && rule.options.sheet.options.name) {
      return rule.options.sheet.options.name + '-' + str;
    }
    return str;
  }

  /**
   * styleManager
   */
  var styleManager = {
    get sheetMap() {
      return sheetMap;
    },
    get sheetOrder() {
      return sheetOrder;
    },
    setSheetOrder: setSheetOrder,
    jss: jss,
    theme: theme,
    render: render,
    reset: reset,
    rerender: rerender,
    getClasses: getClasses,
    updateTheme: updateTheme,
    prepareInline: prepareInline,
    sheetsToString: sheetsToString
  };

  updateTheme(theme, false);

  function render(styleSheet) {
    var index = getMappingIndex(styleSheet.name);

    if (index === -1) {
      return renderNew(styleSheet);
    }

    var mapping = sheetMap[index];

    if (mapping.styleSheet !== styleSheet) {
      jss.removeStyleSheet(sheetMap[index].jssStyleSheet);
      sheetMap.splice(index, 1);

      return renderNew(styleSheet);
    }

    return mapping.classes;
  }

  /**
   * Get classes for a given styleSheet object
   */
  function getClasses(styleSheet) {
    var mapping = (0, _utils.find)(sheetMap, { styleSheet: styleSheet });
    return mapping ? mapping.classes : null;
  }

  /**
   * @private
   */
  function renderNew(styleSheet) {
    var name = styleSheet.name,
        createRules = styleSheet.createRules,
        options = styleSheet.options;

    var sheetMeta = name + '-' + styleManager.theme.id;

    if ((typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : (0, _typeof3.default)(document)) === 'object') {
      var element = document.querySelector('style[data-jss][data-meta="' + sheetMeta + '"]');
      if (element) {
        options.element = element;
      }
    }

    var rules = createRules(styleManager.theme);
    var jssOptions = (0, _extends3.default)({
      name: name,
      meta: sheetMeta
    }, options);

    if (sheetOrder && !jssOptions.hasOwnProperty('index')) {
      var index = sheetOrder.indexOf(name);
      if (index === -1) {
        jssOptions.index = sheetOrder.length;
      } else {
        jssOptions.index = index;
      }
    }

    var jssStyleSheet = jss.createStyleSheet(rules, jssOptions);

    var _jssStyleSheet$attach = jssStyleSheet.attach(),
        classes = _jssStyleSheet$attach.classes;

    sheetMap.push({ name: name, classes: classes, styleSheet: styleSheet, jssStyleSheet: jssStyleSheet });

    return classes;
  }

  /**
   * @private
   */
  function getMappingIndex(name) {
    var index = (0, _utils.findIndex)(sheetMap, function (obj) {
      if (!obj.hasOwnProperty('name') || obj.name !== name) {
        return false;
      }

      return true;
    });

    return index;
  }

  /**
   * Set DOM rendering order by sheet names.
   */
  function setSheetOrder(sheetNames) {
    sheetOrder = sheetNames;
  }

  /**
   * Replace the current theme with a new theme
   */
  function updateTheme(newTheme) {
    var shouldUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    styleManager.theme = newTheme;
    if (!styleManager.theme.id) {
      styleManager.theme.id = (0, _murmurhash3_gc2.default)((0, _stringify2.default)(styleManager.theme));
    }
    if (shouldUpdate) {
      rerender();
    }
  }

  /**
   * Reset JSS registry, remove sheets and empty the styleManager.
   */
  function reset() {
    sheetMap.forEach(function (_ref2) {
      var jssStyleSheet = _ref2.jssStyleSheet;
      jssStyleSheet.detach();
    });
    sheetMap = [];
  }

  /**
   * Reset and update all existing stylesheets
   *
   * @memberOf module:styleManager~styleManager
   */
  function rerender() {
    var sheets = [].concat((0, _toConsumableArray3.default)(sheetMap));
    reset();
    sheets.forEach(function (n) {
      render(n.styleSheet);
    });
  }

  /**
   * Prepare inline styles using Theme Reactor
   */
  function prepareInline(declaration) {
    if (typeof declaration === 'function') {
      declaration = declaration(theme);
    }

    var rule = {
      type: 'regular',
      style: declaration
    };

    prefixRule(rule);

    return rule.style;
  }

  /**
   * Render sheets to an HTML string
   */
  function sheetsToString() {
    return sheetMap.sort(function (a, b) {
      if (a.jssStyleSheet.options.index < b.jssStyleSheet.options.index) {
        return -1;
      }
      if (a.jssStyleSheet.options.index > b.jssStyleSheet.options.index) {
        return 1;
      }
      return 0;
    }).map(function (sheet) {
      return sheet.jssStyleSheet.toString();
    }).join('\n');
  }

  return styleManager;
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1572);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1573), __esModule: true };

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
__webpack_require__(1579);
module.exports = __webpack_require__(26).Array.from;


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(350);
var defined = __webpack_require__(351);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(354);
var descriptor = __webpack_require__(174);
var setToStringTag = __webpack_require__(235);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(111)(IteratorPrototype, __webpack_require__(41)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(79);
var anObject = __webpack_require__(67);
var getKeys = __webpack_require__(175);

module.exports = __webpack_require__(88) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(114);
var toLength = __webpack_require__(355);
var toAbsoluteIndex = __webpack_require__(1578);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(350);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(139);
var $export = __webpack_require__(61);
var toObject = __webpack_require__(177);
var call = __webpack_require__(610);
var isArrayIter = __webpack_require__(611);
var toLength = __webpack_require__(355);
var createProperty = __webpack_require__(1580);
var getIterFn = __webpack_require__(359);

$export($export.S + $export.F * !__webpack_require__(612)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(79);
var createDesc = __webpack_require__(174);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1582), __esModule: true };

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(26);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(61);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1584) });


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(175);
var gOPS = __webpack_require__(361);
var pIE = __webpack_require__(236);
var toObject = __webpack_require__(177);
var IObject = __webpack_require__(607);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(140)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(617), __esModule: true };

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1587);
var step = __webpack_require__(1588);
var Iterators = __webpack_require__(141);
var toIObject = __webpack_require__(114);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(603)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1587 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(618), __esModule: true };

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(49);
var has = __webpack_require__(113);
var DESCRIPTORS = __webpack_require__(88);
var $export = __webpack_require__(61);
var redefine = __webpack_require__(605);
var META = __webpack_require__(1591).KEY;
var $fails = __webpack_require__(140);
var shared = __webpack_require__(357);
var setToStringTag = __webpack_require__(235);
var uid = __webpack_require__(234);
var wks = __webpack_require__(41);
var wksExt = __webpack_require__(362);
var wksDefine = __webpack_require__(363);
var enumKeys = __webpack_require__(1592);
var isArray = __webpack_require__(1593);
var anObject = __webpack_require__(67);
var toIObject = __webpack_require__(114);
var toPrimitive = __webpack_require__(353);
var createDesc = __webpack_require__(174);
var _create = __webpack_require__(354);
var gOPNExt = __webpack_require__(1594);
var $GOPD = __webpack_require__(364);
var $DP = __webpack_require__(79);
var $keys = __webpack_require__(175);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(619).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(236).f = $propertyIsEnumerable;
  __webpack_require__(361).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(232)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(111)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(234)('meta');
var isObject = __webpack_require__(112);
var has = __webpack_require__(113);
var setDesc = __webpack_require__(79).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(140)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(175);
var gOPS = __webpack_require__(361);
var pIE = __webpack_require__(236);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(176);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(114);
var gOPN = __webpack_require__(619).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(363)('asyncIterator');


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(363)('observable');


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(616);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(621);

var _keys2 = _interopRequireDefault(_keys);

exports.transform = transform;
exports.find = find;
exports.findIndex = findIndex;
exports.contains = contains;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-bitwise, no-plusplus */

function transform(obj, iteratee, accumulator) {
  (0, _keys2.default)(obj).forEach(function (key) {
    iteratee(accumulator, obj[key], key);
  });
  return accumulator;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
  for (var i = 0; i < arr.length; i++) {
    if (predType === 'function' && pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function contains(obj, pred) {
  for (var _key in pred) {
    if (!obj.hasOwnProperty(_key) || obj[_key] !== pred[_key]) {
      return false;
    }
  }
  return true;
}

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(177);
var $keys = __webpack_require__(175);

__webpack_require__(365)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppStructure = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _reactDimensions = __webpack_require__(1600);

var _reactDimensions2 = _interopRequireDefault(_reactDimensions);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(62);

var _reactHelmet = __webpack_require__(697);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _recompose = __webpack_require__(385);

var _AppBar = __webpack_require__(623);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _AppDrawer = __webpack_require__(1618);

var _AppDrawer2 = _interopRequireDefault(_AppDrawer);

var _Dialog = __webpack_require__(696);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Form = __webpack_require__(186);

var _Form2 = _interopRequireDefault(_Form);

var _IconButton = __webpack_require__(90);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Input = __webpack_require__(247);

var _Input2 = _interopRequireDefault(_Input);

var _Layout = __webpack_require__(710);

var _Layout2 = _interopRequireDefault(_Layout);

var _Back = __webpack_require__(711);

var _Back2 = _interopRequireDefault(_Back);

var _Logo = __webpack_require__(629);

var _Logo2 = _interopRequireDefault(_Logo);

var _Menu = __webpack_require__(749);

var _Menu2 = _interopRequireDefault(_Menu);

var _Search = __webpack_require__(785);

var _Search2 = _interopRequireDefault(_Search);

var _Toolbar = __webpack_require__(367);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _ListContent = __webpack_require__(1857);

var _ListContent2 = _interopRequireDefault(_ListContent);

var _Snackbar = __webpack_require__(845);

var _ModalSheet = __webpack_require__(1862);

var _ModalSheet2 = _interopRequireDefault(_ModalSheet);

var _ModalSheetClose = __webpack_require__(1863);

var _ModalSheetClose2 = _interopRequireDefault(_ModalSheetClose);

var _ModalSheetContent = __webpack_require__(1864);

var _ModalSheetContent2 = _interopRequireDefault(_ModalSheetContent);

var _ModalSheetHeader = __webpack_require__(1865);

var _ModalSheetHeader2 = _interopRequireDefault(_ModalSheetHeader);

var _ModalSheetHeaderTitle = __webpack_require__(1866);

var _ModalSheetHeaderTitle2 = _interopRequireDefault(_ModalSheetHeaderTitle);

var _withEmbeddedMode = __webpack_require__(704);

var _withEmbeddedMode2 = _interopRequireDefault(_withEmbeddedMode);

var _env = __webpack_require__(35);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('AppStructure', function (theme) {
  var _ref;

  return _ref = {
    '@global': theme.mixins.global(),
    root: _extends({
      display: 'flex',
      alignItems: 'stretch',
      height: '100%',
      width: '100%',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.leavingScreen,
        easing: theme.transitions.easing.sharp
      })
    }, theme.typography.body1),
    appBar: {
      display: 'flex',
      transition: theme.transitions.create(['width', 'background-color', 'color'])
    },
    buttonBox: {
      display: 'flex'
    },
    content: {
      paddingTop: '0',
      paddingBottom: theme.typography.rhythmByUnit(7),
      flexGrow: 1,
      flex: '1 1 100%',
      maxWidth: '100%',
      margin: '0 auto',
      overflowY: 'auto',
      '-webkitOverflowScrolling': 'touch'
    },
    contentFullWidth: {
      paddingBottom: 0
    },
    contentDetail: {
      paddingTop: 0,
      paddingBottom: 0
    },
    drawer: {
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.leavingScreen,
        easing: theme.transitions.easing.sharp
      })
    },
    drawerOpen: {
      position: 'fixed',
      height: '100vh',
      opacity: 1,
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.enteringScreen,
        easing: theme.transitions.easing.easeOut
      })
    },
    detailAppBar: {
      display: 'none'
    },
    gutters: theme.mixins.gutters(4),
    guttersRoot: {},
    layoutDetail: {
      marginTop: 0
    },
    open: {
      transform: 'translate3d(' + theme.variables.drawerWidth + 'px, 0, 0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.enteringScreen,
        easing: theme.transitions.easing.easeOut
      })
    },
    paper: {
      background: theme.palette.background.paper
    },
    searchForm: {
      flex: 1,
      opacity: 0,
      visibility: 'hidden',
      transition: theme.transitions.create('opacity')
    },
    searchFormFocus: {
      opacity: 1,
      visibility: 'visible'
    },
    searchInput: {
      backgroundColor: theme.palette.background.searchInput,
      color: theme.palette.getContrastText(theme.palette.background.searchInput),
      borderRadius: theme.variables.inputBorderRadius,
      flex: 1,
      width: '100%',
      height: theme.variables.searchInputHeight,
      padding: '0 ' + theme.typography.rhythmByUnit(1),
      boxSizing: 'border-box',
      '&:hover': {
        backgroundColor: theme.palette.background.searchInput
      },
      '& input': _extends({
        color: theme.palette.getContrastText(theme.palette.background.searchInput)
      }, theme.mixins.placeholder({
        color: theme.palette.grey[200]
      }))
    },
    searchInputFocus: {
      '&, &:hover': {
        backgroundColor: theme.palette.background.searchInput
      },
      '& input': _extends({
        color: theme.palette.getContrastText(theme.palette.background.searchInput)
      }, theme.mixins.placeholder({
        color: theme.palette.grey[200]
      }))
    },
    searchInputElement: {
      height: theme.variables.searchInputHeight
    },
    toolbar: {
      justifyContent: 'space-between'
    },
    userAvatar: {
      fontSize: theme.variables.searchInputHeight
    },
    userAvatarHiddenOnMobile: {}
  }, _defineProperty(_ref, theme.breakpoints.up('xs'), {
    searchInput: {
      backgroundImage: _Search2.default.toURL({
        fill: theme.palette.getContrastText(theme.palette.background.searchInput),
        height: '1em',
        width: '1em'
      }),
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: '1em',
      backgroundPositionY: '50%',
      backgroundSize: '1em',
      paddingLeft: theme.typography.rhythmByUnit(4)
    },
    searchInputFocus: {
      backgroundImage: _Search2.default.toURL({
        fill: theme.palette.getContrastText(theme.palette.background.searchInput),
        height: '1em',
        width: '1em',
        opacity: 0.6
      }),
      backgroundColor: theme.palette.background.searchInput
    }
  }), _defineProperty(_ref, theme.breakpoints.up('sm'), {
    content: {
      paddingBottom: theme.variables.contentPadding
    },
    contentFullWidth: {
      paddingBottom: 0
    },
    detailAppBar: {
      display: 'flex'
    },
    guttersRoot: theme.mixins.gutters(1),
    toolbar: _extends({}, theme.mixins.gutters(3), {
      paddingLeft: theme.typography.rhythmByUnit(1.5)
    })
  }), _defineProperty(_ref, theme.breakpoints.down('sm'), {
    content: {
      overflowX: 'hidden'
    },
    userAvatarHiddenOnMobile: theme.mixins.hidden(),
    toolbar: _extends({}, theme.mixins.gutters(1), {
      paddingLeft: theme.typography.rhythmByUnit(0.5)
    })
  }), _defineProperty(_ref, theme.breakpoints.up('md'), {
    buttonBoxMargin: {
      marginLeft: 'auto'
    },
    drawerIcon: {
      opacity: 1,
      visibility: 'visible',
      transition: theme.transitions.create('opacity')
    },
    drawerIconHidden: {
      opacity: 0,
      visibility: 'hidden'
    },
    guttersRoot: theme.mixins.gutters(2),
    layoutMaxWidth: {
      minWidth: 0,
      maxWidth: theme.breakpoints.md,
      width: '100%'
    },
    open: {
      transform: 'translate3d(0, 0, 0)',
      transition: 'none'
    },
    searchForm: {
      flex: '0 1 auto',
      marginLeft: 'auto',
      visibility: 'visible',
      opacity: 1
    },
    searchInput: {
      marginRight: theme.typography.rhythmByUnit(1)
    },
    searchInputFocus: {
      color: theme.palette.getContrastText(theme.palette.background.searchInput)
    }
  }), _defineProperty(_ref, theme.breakpoints.up('xl'), {
    open: {
      transform: 'translate3d(' + theme.variables.drawerWidthLarge + 'px, 0, 0)'
    }
  }), _ref;
});

var AppStructure = (_temp2 = _class = function (_PureComponent) {
  _inherits(AppStructure, _PureComponent);

  function AppStructure() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, AppStructure);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AppStructure.__proto__ || Object.getPrototypeOf(AppStructure)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this.focusSearchInput = function (breakpoint) {
      if (!_this.searchInput || breakpoint) return;
      var _this$searchInput$foc = _this.searchInput.focus,
          focus = _this$searchInput$foc === undefined ? function () {} : _this$searchInput$foc;

      focus();
    }, _this.handleDrawer = function (e, breakpoint) {
      var _this$props$_this$sta = _extends({}, _this.props, _this.state),
          appDrawer = _this$props$_this$sta.appDrawer,
          expandSearch = _this$props$_this$sta.expandSearch;

      switch (true) {
        case (!appDrawer || breakpoint) && !expandSearch:
          return _this.handleDrawerClose();
        case !expandSearch:
          return _this.handleDrawerToggle(e);
        default:
          return _this.handleSearchReset(e);
      }
    }, _this.handleDrawerClose = function () {
      _this.expandDrawer(false);
    }, _this.handleDrawerToggle = function () {
      var _this$props$_this$sta2 = _extends({}, _this.props, _this.state),
          expandDrawer = _this$props$_this$sta2.expandDrawer;

      _this.expandDrawer(!expandDrawer);
    }, _this.handleSearchChange = function (e) {
      var onSearchChange = _this.props.onSearchChange;

      return onSearchChange(e);
    }, _this.handleSearchReset = function (e) {
      var onSearchReset = _this.props.onSearchReset;

      e.preventDefault();
      return onSearchReset(e);
    }, _this.handleSearchSubmit = function (e) {
      var onSearchSubmit = _this.props.onSearchSubmit;

      e.preventDefault();
      return onSearchSubmit(e);
    }, _this.handleSearchBlur = function () {
      _this.searchFocus(false);
    }, _this.handleSearchFocus = function () {
      _this.searchFocus(true);
    }, _this.handleSearchExpand = function (e) {
      var _this$props = _this.props,
          onSearchExpand = _this$props.onSearchExpand,
          expandSearch = _this$props.expandSearch;

      onSearchExpand(e, expandSearch);
    }, _this.handleSearchShow = function () {
      var onSearchShow = _this.props.onSearchShow;

      return onSearchShow();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppStructure, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _createDefaultContext = this.createDefaultContext(this.props),
          appStructure = _createDefaultContext.appStructure;

      this.appStructure = appStructure;
    }
  }, {
    key: 'createDefaultContext',
    value: function createDefaultContext() {
      var _this2 = this;

      return {
        appStructure: {
          contentRef: function contentRef() {
            return _this2.content;
          }
        }
      };
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var appStructure = this.appStructure;

      return { appStructure: appStructure };
    }
  }, {
    key: 'expandDrawer',
    value: function expandDrawer(_expandDrawer) {
      this.setState({ expandDrawer: _expandDrawer });
    }
  }, {
    key: 'searchFocus',
    value: function searchFocus(_searchFocus) {
      this.setState({ searchFocus: _searchFocus });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2,
          _classNames3,
          _classNames7,
          _this3 = this;

      var _props$state = _extends({}, this.props, this.state),
          appBar = _props$state.appBar,
          AppBar = _props$state.appBarComponent,
          appBarNotifications = _props$state.appBarNotifications,
          appBarSecondary = _props$state.appBarSecondary,
          appBarUserAvatar = _props$state.appBarUserAvatar,
          appDrawer = _props$state.appDrawer,
          appDrawerChildren = _props$state.appDrawerChildren,
          appDrawerIcon = _props$state.appDrawerIcon,
          appName = _props$state.appName,
          breadcrumbOnClick = _props$state.breadcrumbOnClick,
          breadcrumbParent = _props$state.breadcrumbParent,
          children = _props$state.children,
          classNameProp = _props$state.className,
          containerWidth = _props$state.containerWidth,
          contentClassNameProp = _props$state.contentClassName,
          detail = _props$state.detail,
          detailHeaderActions = _props$state.detailHeaderActions,
          detailHeaderDense = _props$state.detailHeaderDense,
          detailHeaderDivider = _props$state.detailHeaderDivider,
          detailHeaderDrawer = _props$state.detailHeaderDrawer,
          detailHeaderTruncate = _props$state.detailHeaderTruncate,
          detailHidden = _props$state.detailHidden,
          detailIcon = _props$state.detailIcon,
          detailIconLabel = _props$state.detailIconLabel,
          detailList = _props$state.detailList,
          detailPrimary = _props$state.detailPrimary,
          detailSecondary = _props$state.detailSecondary,
          detailTertiary = _props$state.detailTertiary,
          detailThumbnail = _props$state.detailThumbnail,
          dialog = _props$state.dialog,
          dialogAccent = _props$state.dialogAccent,
          dialogClassName = _props$state.dialogClassName,
          Dialog = _props$state.dialogComponent,
          dialogConfirmationActions = _props$state.dialogConfirmationActions,
          dialogConfirmationActionsClassName = _props$state.dialogConfirmationActionsClassName,
          dialogConfirmationActionsComponent = _props$state.dialogConfirmationActionsComponent,
          dialogError = _props$state.dialogError,
          dialogFullscreen = _props$state.dialogFullscreen,
          dialogPrimary = _props$state.dialogPrimary,
          dialogSecondary = _props$state.dialogSecondary,
          dialogTitle = _props$state.dialogTitle,
          dialogTitleClassName = _props$state.dialogTitleClassName,
          dialogTitleComponent = _props$state.dialogTitleComponent,
          display = _props$state.display,
          embeddedMode = _props$state.embeddedMode,
          expandDrawer = _props$state.expandDrawer,
          expandSearch = _props$state.expandSearch,
          gutters = _props$state.gutters,
          headline = _props$state.headline,
          homeLink = _props$state.homeLink,
          layoutProps = _props$state.layoutProps,
          onDialogRequestClose = _props$state.onDialogRequestClose,
          onDialogSubmit = _props$state.onDialogSubmit,
          paper = _props$state.paper,
          prefix = _props$state.prefix,
          progress = _props$state.progress,
          search = _props$state.search,
          searchBack = _props$state.searchBack,
          searchButton = _props$state.searchButton,
          searchFocus = _props$state.searchFocus,
          searchPlaceholder = _props$state.searchPlaceholder,
          secondaryTitle = _props$state.secondaryTitle,
          title = _props$state.title,
          useCenteredContentColumn = _props$state.useCenteredContentColumn;

      var dialogProps = {
        accent: dialogAccent,
        children: dialog,
        className: dialogClassName,
        confirmationActions: dialogConfirmationActions,
        confirmationActionsComponent: dialogConfirmationActionsComponent,
        confirmationActionsClassName: dialogConfirmationActionsClassName,
        error: dialogError,
        fullScreen: dialogFullscreen,
        primary: dialogPrimary,
        secondary: dialogSecondary,
        title: dialogTitle,
        titleComponent: dialogTitleComponent,
        titleClassName: dialogTitleClassName,
        onRequestClose: onDialogRequestClose,
        onSubmit: onDialogSubmit,
        open: !!dialog
      };

      var detailCardProps = {
        display: display,
        headline: headline,
        breadcrumbOnClick: breadcrumbOnClick,
        breadcrumbParent: breadcrumbParent,
        dense: detailHeaderDense,
        detailHidden: detailHidden,
        detailPrimary: detailPrimary,
        detailSecondary: detailSecondary,
        detailTertiary: detailTertiary,
        divider: detailHeaderDivider,
        drawer: detailHeaderDrawer,
        handleDrawer: this.handleDrawer,
        headerActions: detailHeaderActions,
        icon: detailIcon,
        iconLabel: detailIconLabel,
        list: detailList,
        thumbnail: detailThumbnail,
        progress: progress,
        secondaryTitle: secondaryTitle,
        title: title,
        truncate: detailHeaderTruncate
      };

      var smallBreak = containerWidth >= this.context.styleManager.theme.breakpoints.sm;
      var mediumBreak = containerWidth >= this.context.styleManager.theme.breakpoints.md;
      var AppDrawerIcon = !mediumBreak && !expandSearch && appDrawer ? _Menu2.default : _Back2.default;
      var classes = this.context.styleManager.render(styleSheet);
      var appBarClassName = (0, _classnames2.default)(classes.appBar, _defineProperty({}, classes.detailAppBar, detail));
      var className = (0, _classnames2.default)(classes.root, (_classNames2 = {}, _defineProperty(_classNames2, classes.paper, paper), _defineProperty(_classNames2, classes.open, expandDrawer), _classNames2), classNameProp);
      var contentClassName = (0, _classnames2.default)(classes.content, (_classNames3 = {}, _defineProperty(_classNames3, classes.contentDetail, detail), _defineProperty(_classNames3, classes.contentFullWidth, !useCenteredContentColumn), _classNames3), contentClassNameProp);
      var drawerClassName = (0, _classnames2.default)(classes.drawer, _defineProperty({}, classes.drawerOpen, expandDrawer));
      var drawerIconClassName = (0, _classnames2.default)(classes.drawerIcon, _defineProperty({}, classes.drawerIconHidden, mediumBreak && !searchBack && !(search ? search.length : 0)));
      var guttersClassName = (0, _classnames2.default)(classes.guttersRoot, _defineProperty({}, classes.gutters, gutters));
      var layoutClassName = (0, _classnames2.default)((_classNames7 = {}, _defineProperty(_classNames7, classes.layoutDetail, detail), _defineProperty(_classNames7, classes.layoutMaxWidth, useCenteredContentColumn && mediumBreak), _classNames7));
      var searchFormClassName = (0, _classnames2.default)(classes.searchForm, _defineProperty({}, classes.searchFormFocus, expandSearch));
      var searchInputClassName = (0, _classnames2.default)(classes.searchInput, _defineProperty({}, classes.searchInputFocus, searchFocus));
      var buttonBoxClassName = (0, _classnames2.default)(classes.buttonBox, _defineProperty({}, classes.buttonBoxMargin, !expandSearch && mediumBreak && !searchButton));

      var combinedPrefix = prefix ? 'ui: http://ui.pushbot.io ' + prefix : 'ui: http://ui.pushbot.io';

      var content = _react2.default.createElement(
        _Layout2.default,
        { container: true, gutter: 0, justify: 'center' },
        _react2.default.createElement(
          _Layout2.default,
          _extends({ item: true, className: layoutClassName, xs: 12 }, layoutProps),
          detail ? _react.Children.map(children, function (child) {
            return _react2.default.cloneElement(child, detailCardProps);
          }) : _react2.default.createElement(
            _ListContent2.default,
            _extends({ display: display, headline: embeddedMode ? null : headline }, {
              className: guttersClassName
            }),
            children
          )
        )
      );
      return _react2.default.createElement(
        'div',
        { className: className, prefix: combinedPrefix },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: appName + ' | %s',
          defaultTitle: appName,
          title: title
        }),
        appDrawer && _react2.default.createElement(
          _AppDrawer2.default,
          {
            className: drawerClassName,
            homeLink: homeLink,
            icon: appDrawerIcon,
            onRequestClose: this.handleDrawerClose,
            open: mediumBreak ? false : expandDrawer,
            permanent: mediumBreak
          },
          appDrawerChildren
        ),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            ref: function ref(c) {
              _this3.content = c;
            }
          },
          appBar && _react2.default.createElement(
            AppBar,
            { className: appBarClassName },
            _react2.default.createElement(
              _Toolbar2.default,
              { className: classes.toolbar },
              (appBar && (!mediumBreak || searchButton) || mediumBreak) && _react2.default.createElement(
                _IconButton2.default,
                {
                  className: drawerIconClassName,
                  onClick: function onClick(e) {
                    return _this3.handleDrawer(e, mediumBreak);
                  }
                },
                _react2.default.createElement(AppDrawerIcon, null)
              ),
              (expandSearch || searchButton && mediumBreak) && _react2.default.createElement(
                _Form2.default,
                {
                  className: searchFormClassName,
                  onSubmit: this.handleSearchSubmit
                },
                _react2.default.createElement(_Input2.default, {
                  id: 'search',
                  ref: function ref(c) {
                    _this3.searchInput = c;
                    _this3.handleSearchShow(mediumBreak);
                  },
                  className: searchInputClassName,
                  placeholder: searchPlaceholder,
                  onBlur: this.handleSearchBlur,
                  onChange: this.handleSearchChange,
                  onFocus: this.handleSearchFocus,
                  inputClassName: classes.searchInputElement,
                  fullWidth: true,
                  value: search,
                  underline: false
                })
              ),
              appBar && _react2.default.createElement(
                'div',
                { className: buttonBoxClassName },
                !mediumBreak && !expandSearch && searchButton && _react2.default.createElement(
                  _IconButton2.default,
                  {
                    className: classes.searchButton,
                    onClick: this.handleSearchExpand
                  },
                  _react2.default.createElement(_Search2.default, null)
                ),
                (smallBreak || !expandSearch) && appBarNotifications,
                (smallBreak || !expandSearch) && appBarSecondary,
                (smallBreak || !expandSearch) && appBarUserAvatar && _react2.default.cloneElement(appBarUserAvatar, {
                  className: (0, _classnames2.default)(classes.userAvatar, classes.userAvatarHiddenOnMobile, appBarUserAvatar.props.className)
                })
              )
            )
          ),
          !embeddedMode ? content : _react2.default.createElement(
            _ModalSheet2.default,
            null,
            _react2.default.createElement(
              _ModalSheetHeader2.default,
              null,
              _react2.default.createElement(_ModalSheetClose2.default, { to: _env2.default.PUSHBOT_EMBEDDED_REFERRER }),
              _react2.default.createElement(_ModalSheetHeaderTitle2.default, null)
            ),
            _react2.default.createElement(
              _ModalSheetContent2.default,
              null,
              content
            )
          )
        ),
        _react2.default.createElement(Dialog, dialogProps),
        _react2.default.createElement(_Snackbar.SnackbarContainer, null)
      );
    }
  }]);

  return AppStructure;
}(_react.PureComponent), _class.displayName = 'AppStructure', _class.propTypes = {
  /**
   * If true the app bar is displayed
   */
  appBar: _PropTypes2.default.bool,
  /**
   * Component to be used as the appBar
   */
  appBarComponent: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.func]),
  /**
   * Component to be used for the notifications component
   */
  appBarNotifications: _PropTypes2.default.node,
  /**
   * Component to be used for the secondary component
   */
  appBarSecondary: _PropTypes2.default.node,
  /**
   * Component to be used for the user avatar component
   */
  appBarUserAvatar: _PropTypes2.default.node,
  /**
   * If true the App Drawer is displayed
   */
  appDrawer: _PropTypes2.default.bool,
  /**
   * Can be any node or number of nodes.
   */
  appDrawerChildren: _PropTypes2.default.oneOfType([_PropTypes2.default.node, _PropTypes2.default.arrayOf(_PropTypes2.default.node)]),
  /**
   * Icon for App Drawer logo area
   */
  appDrawerIcon: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.func]),
  /**
   * Name of application
   */
  appName: _PropTypes2.default.string,
  /**
   *  function invoked when parent page title is clicked
   */
  breadcrumbOnClick: _PropTypes2.default.func,
  /**
   *  Title of parent page for Breadcrumb component
   */
  breadcrumbParent: _PropTypes2.default.string,
  /**
   * Can be any node or number of nodes.
   */
  children: _PropTypes2.default.node,
  /**
   * Class name passed app
   */
  className: _PropTypes2.default.string,
  /**
   * Width of the browser window passed in by react-dimensions
   */
  containerWidth: _PropTypes2.default.number,
  /**
   * Height of the browser window passed in by react-dimensions
   */
  containerHeight: _PropTypes2.default.number,
  /**
   * Class name passed app content container
   */
  contentClassName: _PropTypes2.default.string,
  /**
   * Display title and content in DetailContent
   */
  detail: _PropTypes2.default.bool,
  /**
   * Actions to display in top right of DetailContent header
   */
  detailHeaderActions: _PropTypes2.default.oneOfType([_PropTypes2.default.node, _PropTypes2.default.arrayOf(_PropTypes2.default.node)]),
  /**
   * Display DetailContent header with minimized top and bottom gutters
   */
  detailHeaderDense: _PropTypes2.default.bool,
  /**
   * Display divider underneath DetailContent header
   */
  detailHeaderDivider: _PropTypes2.default.bool,
  /**
   * Display drawer icon in DetailContent header
   */
  detailHeaderDrawer: _PropTypes2.default.bool,
  /**
   * Truncate text in DetailContent header
   */
  detailHeaderTruncate: _PropTypes2.default.bool,
  /**
   * Hide text in DetailContent header
   */
  detailHidden: _PropTypes2.default.bool,
  /**
   * Icon/avatar to display in DetailContent header
   */
  detailIcon: _PropTypes2.default.node,
  /**
   * Label to display next to icon in DetailContent header
   */
  detailIconLabel: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.node]),
  /**
   * If true, DetailContent body will display with no gutters so list can bleed to edges
   */
  detailList: _PropTypes2.default.bool,
  /**
   *  DetailContent header primary detail text/node
   */
  detailPrimary: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.node]),
  /**
   *  DetailContent header secondary detail text/node
   */
  detailSecondary: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.node]),
  /**
   *  DetailContent header tertiary detail text/node
   */
  detailTertiary: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.node]),
  /**
   * Thumbnail url for logo to display in DetailContent header
   */
  detailThumbnail: _PropTypes2.default.string,
  /**
   * Nodes to be placed in the dialog.
   */
  dialog: _PropTypes2.default.node,
  /**
   * If `true`, the dialog title will use the theme's accent color.
   */
  dialogAccent: _PropTypes2.default.bool,
  /**
   * The CSS class name of the dialog element.
   */
  dialogClassName: _PropTypes2.default.string,
  /**
   * Component to be used as the dialog node
   */
  dialogComponent: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.func]),
  /**
   * Nodes to be placed in the dialog confirmation action container.
   */
  dialogConfirmationActions: _Form2.default.propTypes.confirmationActions,
  /**
   * Component to be used as the dialog confirmation action node
   */
  dialogConfirmationActionsComponent: _Form2.default.propTypes.confirmationActionsComponent,
  /**
   * The CSS class name of the dialog confirmation action element.
   */
  dialogConfirmationActionsClassName: _PropTypes2.default.string,
  /**
   * If `true`, the dialog title will use the theme's error color.
   */
  dialogError: _PropTypes2.default.bool,
  /**
   * If `true`, The dialog will be full-screen.
   */
  dialogFullscreen: _PropTypes2.default.bool,
  /**
   * If `true`, the dialog title will use the theme's primary color.
   */
  dialogPrimary: _PropTypes2.default.bool,
  /**
   * If `true`, the dialog title will use the theme's secondary color.
   */
  dialogSecondary: _PropTypes2.default.bool,
  /**
   * Node to be placed in the title container.
   */
  dialogTitle: _PropTypes2.default.node,
  /**
   * Component to be used as the title node
   */
  dialogTitleComponent: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.func]),
  /**
   * The CSS class name of the title element.
   */
  dialogTitleClassName: _PropTypes2.default.string,
  /**
   * Display text used in content body
   */
  display: _PropTypes2.default.string,
  /**
   * If `true`, then drawer is displayed
   */
  expandDrawer: _PropTypes2.default.bool,
  /**
   * If `true`, then search input is displayed
   */
  expandSearch: _PropTypes2.default.bool,
  /**
   * If `true`, then gutters will persist on all screen sizes
   */
  gutters: _PropTypes2.default.bool,
  /**
   * Headline text used in content body
   */
  headline: _PropTypes2.default.string,
  /**
   * Href for when pushbot logo area is clicked on medium+
   */
  homeLink: _PropTypes2.default.string,
  /**
   * Callback fired when the dialog requests to be closed.
   */
  onDialogRequestClose: _PropTypes2.default.func,
  /**
   * Callback fired when dialog is submitted
   */
  onDialogSubmit: _PropTypes2.default.func,
  /**
   * Called when App Bar Search has changed
   */
  onSearchChange: _PropTypes2.default.func,
  /**
   * Called when App Bar Search has expansion has changed
   */
  onSearchExpand: _PropTypes2.default.func,
  /**
   * Called after App Bar Search is displayed
   */
  onSearchShow: _PropTypes2.default.func,
  /**
   * Called when App Bar Search is reset
   */
  onSearchReset: _PropTypes2.default.func,
  /**
   * Called when App Bar Search is submitted
   */
  onSearchSubmit: _PropTypes2.default.func,
  /**
   * Background will use paper color
   */
  paper: _PropTypes2.default.bool,
  /**
   * A prefix used for identifying elements inside the AppStructure
   */
  prefix: _PropTypes2.default.string,
  /**
   * Search value to be displayed in the App Bar expanded search
   */
  search: _PropTypes2.default.string,
  /**
   * If `true`, then search back button is displayed in the App Bar even when search length is 0
   */
  searchBack: _PropTypes2.default.bool,
  /**
   * If `true`, then search button is displayed in the App Bar
   */
  searchButton: _PropTypes2.default.bool,
  /**
   * Search placeholder value to be displayed in the App Bar expanded search
   */
  searchPlaceholder: _PropTypes2.default.string,
  /**
   * Secondary title to be displayed in the DetailContent header
   */
  secondaryTitle: _PropTypes2.default.oneOfType([_PropTypes2.default.string, _PropTypes2.default.node]),
  /**
   * A boolean, indicating whether content should be centered at a certain width
   * with additional left/right whitespace padding.
   */
  useCenteredContentColumn: _PropTypes2.default.bool
}, _class.contextTypes = {
  styleManager: _PropTypes2.default.styleManager.isRequired
}, _class.childContextTypes = {
  appStructure: _PropTypes2.default.object.isRequired
}, _class.defaultProps = {
  appBar: true,
  appBarComponent: _AppBar2.default,
  appDrawer: false,
  appDrawerIcon: _Logo2.default,
  dialogComponent: _Dialog2.default,
  expandDrawer: false,
  expandSearch: false,
  onSearchChange: function onSearchChange() {},
  onSearchExpand: function onSearchExpand() {},
  onSearchShow: function onSearchShow() {},
  onSearchReset: function onSearchReset() {},
  onSearchSubmit: function onSearchSubmit() {},
  paper: true,
  searchBack: false,
  searchButton: false,
  searchPlaceholder: 'Search',
  useCenteredContentColumn: true
}, _temp2);
exports.AppStructure = AppStructure;
exports.default = (0, _recompose.compose)((0, _withEmbeddedMode2.default)(function (props) {
  var appBar = props.appBar,
      appDrawer = props.appDrawer,
      detailHeaderDrawer = props.detailHeaderDrawer,
      location = props.location,
      others = _objectWithoutProperties(props, ['appBar', 'appDrawer', 'detailHeaderDrawer', 'location']);

  return _extends({
    appBar: false,
    appDrawer: false,
    detailHeaderDrawer: false,
    embeddedMode: true
  }, others);
}), (0, _reactDimensions2.default)({
  containerStyle: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  elementResize: true
}))(AppStructure);

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var onElementResize = __webpack_require__(1601);

var defaultContainerStyle = {
  width: '100%',
  height: '100%',
  padding: 0,
  border: 0
};

function defaultGetWidth(element) {
  return element.clientWidth;
}

function defaultGetHeight(element) {
  return element.clientHeight;
}

/**
 * Wraps a react component and adds properties `containerHeight` and
 * `containerWidth`. Useful for responsive design. Properties update on
 * window resize. **Note** that the parent element must have either a
 * height or a width, or nothing will be rendered
 *
 * Can be used as a
 * [higher-order component](http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers)
 * or as an [ES7 class decorator](https://github.com/wycats/javascript-decorators)
 * (see examples)
 *
 * @param {object} [options]
 * @param {function} [options.getHeight] A function that is passed an element and returns element
 * height, where element is the wrapper div. Defaults to `(element) => element.clientHeight`
 * @param {function} [options.getWidth]  A function that is passed an element and returns element
 * width, where element is the wrapper div. Defaults to `(element) => element.clientWidth`
 * @param {object} [options.containerStyle] A style object for the `<div>` that will wrap your component.
 * The dimensions of this `div` are what are passed as props to your component. The default style is
 * `{ width: '100%', height: '100%', padding: 0, border: 0 }` which will cause the `div` to fill its
 * parent in most cases. If you are using a flexbox layout you will want to change this default style.
 * @param {string} [options.className] Control the class name set on the wrapper `<div>`
 * @param {boolean} [options.elementResize=false] Set true to watch the wrapper `div` for changes in
 * size which are not a result of window resizing - e.g. changes to the flexbox and other layout.
 * @return {function}                   A higher-order component that can be
 * used to enhance a react component `Dimensions()(MyComponent)`
 *
 * @example
 * // ES2015
 * import React from 'react'
 * import Dimensions from 'react-dimensions'
 *
 * class MyComponent extends React.Component {
 *   render() (
 *     <div
 *       containerWidth={this.props.containerWidth}
 *       containerHeight={this.props.containerHeight}
 *     >
 *     </div>
 *   )
 * }
 *
 * export default Dimensions()(MyComponent) // Enhanced component
 *
 * @example
 * // ES5
 * var React = require('react')
 * var Dimensions = require('react-dimensions')
 *
 * var MyComponent = React.createClass({
 *   render: function() {(
 *     <div
 *       containerWidth={this.props.containerWidth}
 *       containerHeight={this.props.containerHeight}
 *     >
 *     </div>
 *   )}
 * }
 *
 * module.exports = Dimensions()(MyComponent) // Enhanced component
 *
 */
module.exports = function Dimensions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getHeight = _ref.getHeight,
      getHeight = _ref$getHeight === undefined ? defaultGetHeight : _ref$getHeight,
      _ref$getWidth = _ref.getWidth,
      getWidth = _ref$getWidth === undefined ? defaultGetWidth : _ref$getWidth,
      _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === undefined ? defaultContainerStyle : _ref$containerStyle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? null : _ref$className,
      _ref$elementResize = _ref.elementResize,
      elementResize = _ref$elementResize === undefined ? false : _ref$elementResize;

  return function (ComposedComponent) {
    return function (_React$Component) {
      _inherits(DimensionsHOC, _React$Component);

      function DimensionsHOC() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, DimensionsHOC);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = DimensionsHOC.__proto__ || Object.getPrototypeOf(DimensionsHOC)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this.updateDimensions = function () {
          var container = _this.refs.container;
          var containerWidth = getWidth(container);
          var containerHeight = getHeight(container);

          if (containerWidth !== _this.state.containerWidth || containerHeight !== _this.state.containerHeight) {
            _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
          }
        }, _this.onResize = function () {
          if (_this.rqf) return;
          _this.rqf = _this.getWindow().requestAnimationFrame(function () {
            _this.rqf = null;
            _this.updateDimensions();
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      // ES7 Class properties
      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers


      // Using arrow functions and ES7 Class properties to autobind
      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#arrow-functions


      _createClass(DimensionsHOC, [{
        key: 'getWindow',


        // If the component is mounted in a different window to the javascript
        // context, as with https://github.com/JakeGinnivan/react-popout
        // then the `window` global will be different from the `window` that
        // contains the component.
        // Depends on `defaultView` which is not supported <IE9
        value: function getWindow() {
          return this.refs.container ? this.refs.container.ownerDocument.defaultView || window : window;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (!this.refs.container) {
            throw new Error('Cannot find container div');
          }
          this.updateDimensions();
          if (elementResize) {
            // Experimental: `element-resize-event` fires when an element resizes.
            // It attaches its own window resize listener and also uses
            // requestAnimationFrame, so we can just call `this.updateDimensions`.
            onElementResize(this.refs.container, this.updateDimensions);
          } else {
            this.getWindow().addEventListener('resize', this.onResize, false);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.getWindow().removeEventListener('resize', this.onResize);
        }

        /**
         * Returns the underlying wrapped component instance.
         * Useful if you need to access a method or property of the component
         * passed to react-dimensions.
         *
         * @return {object} The rendered React component
         **/

      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          this.refs.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _state = this.state,
              containerWidth = _state.containerWidth,
              containerHeight = _state.containerHeight;

          if (!containerWidth && !containerHeight) {
            console.warn('Wrapper div has no height or width, try overriding style with `containerStyle` option');
          }
          return React.createElement(
            'div',
            { className: className, style: containerStyle, ref: 'container' },
            (containerWidth || containerHeight) && React.createElement(ComposedComponent, _extends({}, this.state, this.props, {
              updateDimensions: this.updateDimensions,
              ref: 'wrappedInstance'
            }))
          );
        }
      }]);

      return DimensionsHOC;
    }(React.Component);
  };
};


/***/ }),
/* 1601 */
/***/ (function(module, exports) {

var requestFrame = (function () {
  var window = this
  var raf = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function fallbackRAF(func) {
      return window.setTimeout(func, 20)
    }
  return function requestFrameFunction(func) {
    return raf(func)
  }
})()

var cancelFrame = (function () {
  var window = this
  var cancel = window.cancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.clearTimeout
  return function cancelFrameFunction(id) {
    return cancel(id)
  }
})()

function resizeListener(e) {
  var win = e.target || e.srcElement
  if (win.__resizeRAF__) {
    cancelFrame(win.__resizeRAF__)
  }
  win.__resizeRAF__ = requestFrame(function () {
    var trigger = win.__resizeTrigger__
    trigger.__resizeListeners__.forEach(function (fn) {
      fn.call(trigger, e)
    })
  })
}

var exports = function exports(element, fn) {
  var window = this
  var document = window.document
  var isIE

  var attachEvent = document.attachEvent
  if (typeof navigator !== 'undefined') {
    isIE = navigator.userAgent.match(/Trident/) ||
      navigator.userAgent.match(/Edge/)
  }

  function objectLoad() {
    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
  }

  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = []
    if (attachEvent) {
      element.__resizeTrigger__ = element
      element.attachEvent('onresize', resizeListener)
    } else {
      if (getComputedStyle(element).position === 'static') {
        element.style.position = 'relative'
      }
      var obj = (element.__resizeTrigger__ = document.createElement('object'))
      obj.setAttribute(
        'style',
        'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;'
      )
      obj.setAttribute('class', 'resize-sensor')
      obj.__resizeElement__ = element
      obj.onload = objectLoad
      obj.type = 'text/html'
      if (isIE) {
        element.appendChild(obj)
      }
      obj.data = 'about:blank'
      if (!isIE) {
        element.appendChild(obj)
      }
    }
  }
  element.__resizeListeners__.push(fn)
}

module.exports = typeof window === 'undefined' ? exports : exports.bind(window)

module.exports.unbind = function (element, fn) {
  var attachEvent = document.attachEvent
  if (fn) {
    element.__resizeListeners__.splice(
      element.__resizeListeners__.indexOf(fn),
      1
    )
  } else {
    element.__resizeListeners__ = []
  }
  if (!element.__resizeListeners__.length) {
    if (attachEvent) {
      element.detachEvent('onresize', resizeListener)
    } else {
      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener(
        'resize',
        resizeListener
      )
      delete element.__resizeTrigger__.contentDocument.defaultView.__resizeTrigger__
      element.__resizeTrigger__ = !element.removeChild(
        element.__resizeTrigger__
      )
    }
    delete element.__resizeListeners__
  }
}


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(1603);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(1604);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = undefined;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = (function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        _Component.apply(this, arguments);
      }

      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !_shallowequal2['default'](nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2['default'].createElement(WrappedComponent, this.props);
      };

      _createClass(SideEffect, null, [{
        key: 'displayName',

        // Try to use displayName of wrapped component
        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',

        // Expose canUseDOM so tests can monkeypatch it
        enumerable: true
      }, {
        key: 'canUseDOM',
        value: _exenv2['default'].canUseDOM,
        enumerable: true
      }]);

      return SideEffect;
    })(_react.Component);

    return SideEffect;
  };
};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(1605);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(1606),
    isArguments = __webpack_require__(1607),
    isArray = __webpack_require__(1608);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 1606 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 1607 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 1608 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(1610);
var isArguments = __webpack_require__(1611);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 1610 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 1611 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 1612 */
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlainComponent = function (_React$Component) {
    _inherits(PlainComponent, _React$Component);

    function PlainComponent() {
        _classCallCheck(this, PlainComponent);

        return _possibleConstructorReturn(this, (PlainComponent.__proto__ || Object.getPrototypeOf(PlainComponent)).apply(this, arguments));
    }

    _createClass(PlainComponent, [{
        key: "render",
        value: function render() {
            return null;
        }
    }]);

    return PlainComponent;
}(_react2.default.Component);

exports.default = PlainComponent;
module.exports = exports["default"];

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _Paper = __webpack_require__(150);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('AppBar', function (theme) {
  return {
    appBar: {
      flexDirection: 'column',
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      zIndex: theme.zIndex.appBar
    },
    primary: {
      backgroundColor: theme.palette.primary[400],
      color: theme.palette.getContrastText(theme.palette.primary[400])
    },
    secondary: {
      backgroundColor: theme.palette.primary[300],
      color: theme.palette.getContrastText(theme.palette.primary[300])
    },
    accent: {
      backgroundColor: theme.palette.accent.A200,
      color: theme.palette.getContrastText(theme.palette.accent.A200)
    },
    error: {
      backgroundColor: theme.palette.error.A200,
      color: theme.palette.getContrastText(theme.palette.error.A200)
    }
  };
});

var AppBar = (_temp = _class = function (_Component) {
  _inherits(AppBar, _Component);

  function AppBar() {
    _classCallCheck(this, AppBar);

    return _possibleConstructorReturn(this, (AppBar.__proto__ || Object.getPrototypeOf(AppBar)).apply(this, arguments));
  }

  _createClass(AppBar, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            classNameProp = _props.className,
            error = _props.error,
            primary = _props.primary,
            secondary = _props.secondary,
            other = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'error', 'primary', 'secondary']);

        var classes = this.context.styleManager.render(styleSheet);

        var className = (0, _classnames2['default'])(classes.appBar, (_classNames = {}, _defineProperty(_classNames, classes.primary, primary && !(secondary || accent || error)), _defineProperty(_classNames, classes.secondary, secondary && !(accent || error)), _defineProperty(_classNames, classes.accent, accent && !error), _defineProperty(_classNames, classes.error, error), _classNames), classNameProp);

        return _react2['default'].createElement(
          _Paper2['default'],
          _extends({
            rounded: false,
            elevation: primary || secondary || accent || error ? 4 : 0,
            className: className
          }, other),
          children
        );
      }

      return render;
    }()
  }]);

  return AppBar;
}(_react.Component), _class.propTypes = {
  /**
   * If `true`, the text will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool
}, _class.defaultProps = {
  accent: false,
  error: false,
  primary: false,
  secondary: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = AppBar;


AppBar.displayName = 'AppBar';

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = Paper;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } //  weak

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Paper', function (theme) {
  var palette = theme.palette;

  var shadows = {};

  theme.shadows.forEach(function (shadow, index) {
    shadows['dp' + index] = {
      boxShadow: shadow,
      /* Internet Explorer 10+ */
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        transform: 'translate3d(0, 0, 0)' // Hardware-Accelerated CSS
      }
    };
  });

  return Object.assign({
    paper: {
      backgroundColor: palette.background.paper
    },
    rounded: {
      borderRadius: theme.variables.borderRadius
    }
  }, shadows);
});

/**
 * A piece of material paper.
 *
 * ```js
 * import Paper from 'pushbot-ui/Paper';
 *
 * const Component = () => <Paper elevation={8}>Hello World</Paper>;
 * ```
 */
function Paper(props, context) {
  var classNameProp = props.className,
      rounded = props.rounded,
      elevation = props.elevation,
      other = _objectWithoutProperties(props, ['className', 'rounded', 'elevation']);

  var classes = context.styleManager.render(styleSheet);

  var classNameElevation = 'dp' + (elevation >= 0 ? elevation : 0);
  var className = (0, _classnames2['default'])(classes.paper, classes[classNameElevation], _defineProperty({}, classes.rounded, rounded), classNameProp);

  return _react2['default'].createElement('div', _extends({ className: className }, other));
}

Paper.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   */
  elevation: _PropTypes2['default'].number,
  /**
   * Set to false to disable rounded corners.
   */
  rounded: _PropTypes2['default'].bool
};

Paper.defaultProps = {
  rounded: true,
  elevation: 0
};

Paper.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

Paper.displayName = 'Paper';

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _Drawer = __webpack_require__(1619);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _AppBar = __webpack_require__(623);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Toolbar = __webpack_require__(367);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Logo = __webpack_require__(629);

var _Logo2 = _interopRequireDefault(_Logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('AppDrawer', function (theme) {
  return _defineProperty({
    root: {
      display: 'flex',
      flex: 'none',
      flexDirection: 'column',
      overflowY: 'auto',
      maxWidth: '100%',
      width: theme.variables.drawerWidth,
      height: '100vh',
      backgroundColor: theme.palette.drawer.background.primary,
      transition: theme.transitions.create('width')
    },
    toolbar: {
      maxWidth: '100%',
      width: theme.variables.drawerWidth,
      backgroundColor: theme.palette.drawer.background.primary,
      backgroundImage: _Logo2['default'].toURL(),
      backgroundRepeat: 'no-repeat',
      backgroundSize: theme.typography.rhythmByUnit(5) + '\n                     ' + theme.typography.rhythmByUnit(5),
      backgroundPosition: theme.typography.rhythmByUnit(2),
      transition: theme.transitions.create('width')
    },
    list: {
      flex: '1 1 100%'
    },
    childRoot: Object.assign({
      height: theme.typography.rhythmByPixel(30),
      color: theme.palette.drawer.text.primary,
      transition: theme.transitions.create(['background-color', 'color'])
    }, theme.mixins.gutters(3), theme.typography.verticalScaledRhythmByPixel(14), {
      '&:focus, &:hover': {
        backgroundColor: theme.palette.drawer.background.active,
        color: theme.palette.drawer.text.active,
        '& svg': {
          color: theme.palette.drawer.icon.active
        }
      },
      '&[target=_blank]': {
        '&:focus': {
          backgroundColor: 'transparent',
          color: theme.palette.drawer.text.primary,
          '& svg': {
            color: theme.palette.drawer.icon.primary
          }
        },
        '&:hover': {
          backgroundColor: theme.palette.drawer.background.active,
          color: theme.palette.drawer.text.active,
          '& svg': {
            color: theme.palette.drawer.icon.active
          }
        }
      },
      '& svg': {
        width: theme.typography.rhythmByUnit(2),
        height: theme.typography.rhythmByUnit(2),
        color: theme.palette.drawer.icon.primary,
        transition: theme.transitions.create('color')
      }
    }),
    selected: {
      '&, &:focus, &:hover': {
        backgroundColor: theme.palette.drawer.background.active,
        color: theme.palette.drawer.text.active,
        '& svg': {
          color: theme.palette.drawer.icon.active
        }
      }
    }
  }, theme.breakpoints.up('lg'), {
    root: {
      width: theme.variables.drawerWidthLarge
    },
    toolbar: {
      width: theme.variables.drawerWidthLarge
    }
  });
});

var AppDrawer = (_temp2 = _class = function (_PureComponent) {
  _inherits(AppDrawer, _PureComponent);

  function AppDrawer() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, AppDrawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AppDrawer.__proto__ || Object.getPrototypeOf(AppDrawer)).call.apply(_ref2, [this].concat(args))), _this), _this.renderList = function (icon) {
      var _this$props = _this.props,
          children = _this$props.children,
          onRequestClose = _this$props.onRequestClose;

      var classes = _this.context.styleManager.render(styleSheet);
      var logo = _this.renderLogo(icon);

      return _react2['default'].createElement(
        'nav',
        null,
        logo,
        _react.Children.map(children, function (child) {
          var _child$props = child.props,
              className = _child$props.className,
              _onClick = _child$props.onClick,
              selected = _child$props.selected;

          var childProps = {
            className: (0, _classnames2['default'])(classes.childRoot, _defineProperty({}, classes.selected, selected), className),
            onClick: function () {
              function onClick(e) {
                if (_onClick) {
                  _onClick(e);
                }
                onRequestClose(e);
              }

              return onClick;
            }()
          };

          return _react2['default'].cloneElement(child, childProps);
        })
      );
    }, _this.renderLogo = function (Icon) {
      var classes = _this.context.styleManager.render(styleSheet);
      var appBar = _react2['default'].createElement(
        _AppBar2['default'],
        null,
        _react2['default'].createElement(_Toolbar2['default'], {
          className: classes.toolbar,
          gutters: false,
          style: { backgroundImage: Icon.toURL() }
        })
      );

      if (_this.props.homeLink) {
        return _react2['default'].createElement(
          'a',
          { href: _this.props.homeLink, property: 'homeLink', 'typeof': 'ui:AppDrawer' },
          appBar
        );
      }

      return appBar;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppDrawer, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            className = _props.className,
            Icon = _props.icon,
            onRequestClose = _props.onRequestClose,
            open = _props.open,
            permanent = _props.permanent;

        var classes = this.context.styleManager.render(styleSheet);

        if (permanent) {
          return _react2['default'].createElement(
            'div',
            { className: classes.root },
            this.renderList(Icon)
          );
        } else {
          return _react2['default'].createElement(
            _Drawer2['default'],
            _extends({
              paperClassName: classes.root
            }, { className: className, onRequestClose: onRequestClose, open: open }),
            this.renderList(Icon)
          );
        }
      }

      return render;
    }()
  }]);

  return AppDrawer;
}(_react.PureComponent), _class.propTypes = {
  /**
   * Can be any node or number of nodes.
   */
  children: _PropTypes2['default'].node,
  className: _PropTypes2['default'].string,
  /**
   * Href for when logo area is clicked on medium+
   */
  homeLink: _PropTypes2['default'].string,
  /**
   * Icon for logo area
   */
  icon: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  onRequestClose: _PropTypes2['default'].func.isRequired,
  open: _PropTypes2['default'].bool.isRequired,
  permanent: _PropTypes2['default'].bool.isRequired
}, _class.defaultProps = {
  icon: _Logo2['default'],
  onRequestClose: function () {
    function onRequestClose() {}

    return onRequestClose;
  }()
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = AppDrawer;


AppDrawer.displayName = 'AppDrawer';

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Drawer = __webpack_require__(1620);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Drawer)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _Modal = __webpack_require__(366);

var _Modal2 = _interopRequireDefault(_Modal);

var _Slide = __webpack_require__(825);

var _Slide2 = _interopRequireDefault(_Slide);

var _Paper = __webpack_require__(150);

var _Paper2 = _interopRequireDefault(_Paper);

var _transitions = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SLIDE_DIRECTIONS = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};

var getSlideDirection = function getSlideDirection() {
  var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
  return SLIDE_DIRECTIONS[anchor];
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Drawer', function (theme) {
  return {
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      flex: '1 0 auto',
      position: 'fixed',
      top: 0,
      zIndex: theme.zIndex.navDrawer,
      willChange: 'transform',
      '&:focus': {
        outline: 'none'
      },
      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
    },
    docked: {
      flex: '0 0 auto',
      '& $paper': {
        borderRight: '1px solid ' + theme.palette.text.divider
      }
    },
    modal: {}
  };
});

/**
 * This is a drawer.
 */
var Drawer = (_temp = _class = function (_Component) {
  _inherits(Drawer, _Component);

  function Drawer() {
    _classCallCheck(this, Drawer);

    return _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).apply(this, arguments));
  }

  _createClass(Drawer, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            anchorProp = _props.anchor,
            children = _props.children,
            className = _props.className,
            docked = _props.docked,
            enterTransitionDuration = _props.enterTransitionDuration,
            leaveTransitionDuration = _props.leaveTransitionDuration,
            open = _props.open,
            paperClassName = _props.paperClassName,
            elevation = _props.elevation,
            other = _objectWithoutProperties(_props, ['anchor', 'children', 'className', 'docked', 'enterTransitionDuration', 'leaveTransitionDuration', 'open', 'paperClassName', 'elevation']);

        var _context$styleManager = this.context.styleManager,
            dir = _context$styleManager.theme.dir,
            render = _context$styleManager.render;

        var classes = render(styleSheet);
        var rtl = dir === 'rtl';
        var anchor = anchorProp || (rtl ? 'right' : 'left');
        var slideDirection = getSlideDirection(anchor);

        var drawer = _react2['default'].createElement(
          _Slide2['default'],
          {
            'in': open,
            direction: slideDirection,
            enterTransitionDuration: enterTransitionDuration,
            leaveTransitionDuration: leaveTransitionDuration,
            transitionAppear: true
          },
          _react2['default'].createElement(
            _Paper2['default'],
            {
              elevation: docked ? 0 : elevation,
              rounded: false,
              className: (0, _classnames2['default'])(classes.paper, paperClassName)
            },
            children
          )
        );

        var containerProps = Object.assign({
          className: (0, _classnames2['default'])(classes.modal, className)
        }, other);

        if (docked) {
          return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(classes.docked, className) },
            drawer
          );
        }

        return _react2['default'].createElement(
          _Modal2['default'],
          _extends({
            backdropTransitionDuration: open ? enterTransitionDuration : leaveTransitionDuration
          }, containerProps, {
            show: open
          }),
          drawer
        );
      }

      return render;
    }()
  }]);

  return Drawer;
}(_react.Component), _class.propTypes = {
  /**
   * Side, which will `Drawer` appears from.
   */
  anchor: _PropTypes2['default'].oneOf(['left', 'top', 'right', 'bottom']),
  /**
   * The contents of the `Drawer`.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If set to true, the drawer will dock itself
   * and will no longer slide in with an overlay.
   */
  docked: _PropTypes2['default'].bool,
  /**
   * The elevation of the `Drawer`.
   */
  elevation: _PropTypes2['default'].number,
  /**
   * Customizes duration of enter animation (ms)
   */
  enterTransitionDuration: _PropTypes2['default'].number,
  /**
   * Customizes duration of leave animation (ms)
   */
  leaveTransitionDuration: _PropTypes2['default'].number,
  /**
   * Callback fired when the internal modal requests to be closed.
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * If true, the `Drawer` is open.
   */
  open: _PropTypes2['default'].bool,
  /**
   * The CSS class name of the paper element.
   */
  paperClassName: _PropTypes2['default'].string
}, _class.defaultProps = {
  docked: false,
  enterTransitionDuration: _transitions.duration.enteringScreen,
  leaveTransitionDuration: _transitions.duration.leavingScreen,
  open: false,
  elevation: 0
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = Drawer;


Drawer.displayName = 'Drawer';

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(115);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModalManager = createModalManager;

var _style = __webpack_require__(1623);

var _style2 = _interopRequireDefault(_style);

var _isWindow = __webpack_require__(1630);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(122);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _inDOM = __webpack_require__(115);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _scrollbarSize = __webpack_require__(238);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _manageAriaHidden = __webpack_require__(1631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Do we have a scroll bar?
 * @private
 */
function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2['default'])(node);
  var win = (0, _isWindow2['default'])(doc);
  return doc.body.clientWidth < win.innerWidth;
}

// The container shouldn't be used on the server.
var defaultContainer = _inDOM2['default'] ? window.document.body : {};

/**
 * State managment helper for modals/layers.
 * Simplified, but inspired by react-overlay's ModalManager class
 *
 * @internal Used by the Modal to ensure proper focus management.
 */
function createModalManager() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$container = _ref.container,
      container = _ref$container === undefined ? defaultContainer : _ref$container,
      _ref$hideSiblingNodes = _ref.hideSiblingNodes,
      hideSiblingNodes = _ref$hideSiblingNodes === undefined ? true : _ref$hideSiblingNodes;

  var modals = [];

  var prevPosition = void 0;
  var prevOverflow = void 0;
  var prevWidth = void 0;
  var prevHeight = void 0;
  var prevPadding = void 0;

  function add(modal) {
    var modalIdx = modals.indexOf(modal);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = modals.length;
    modals.push(modal);

    if (hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    var containerStyle = {
      position: 'fixed',
      overflow: 'hidden',
      width: '100%',
      height: '100%',
      paddingRight: undefined
    };

    // Save our current postiion and overflow so we can revert
    // back to it when all modals are closed!
    prevPosition = container.style.position;
    prevOverflow = container.style.overflow;
    prevWidth = container.style.width;
    prevHeight = container.style.height;

    if (bodyIsOverflowing(container)) {
      prevPadding = container.style.paddingRight;
      containerStyle.paddingRight = parseInt(prevPadding || 0, 10) + (0, _scrollbarSize2['default'])() + 'px';
    }

    (0, _style2['default'])(container, containerStyle);

    return modalIdx;
  }

  function remove(modal) {
    var modalIdx = modals.indexOf(modal);

    if (modalIdx === -1) {
      return modalIdx;
    }

    modals.splice(modalIdx, 1);

    if (modals.length === 0) {
      container.style.position = prevPosition;
      container.style.overflow = prevOverflow;
      container.style.width = prevWidth;
      container.style.height = prevHeight;
      container.style.paddingRight = prevPadding;
      prevPosition = undefined;
      prevOverflow = undefined;
      prevWidth = undefined;
      prevHeight = undefined;
      prevPadding = undefined;
      if (hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
    } else if (hideSiblingNodes) {
      // otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, modals[modals.length - 1].mountNode);
    }

    return modalIdx;
  }

  function isTopModal(modal) {
    return !!modals.length && modals[modals.length - 1] === modal;
  }

  var modalManager = { add: add, remove: remove, isTopModal: isTopModal };

  return modalManager;
}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(628);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(1625);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(1627);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(1628);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(627);

var _isTransform = __webpack_require__(1629);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(1626);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(628);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
//  weak

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; //  weak

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _context = __webpack_require__(93);

var _context2 = _interopRequireDefault(_context);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = (_temp2 = _class = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.layer = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.renderLayer();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        this.renderLayer();
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.unrenderLayer();
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'getLayer',
    value: function () {
      function getLayer() {
        return this.layer;
      }

      return getLayer;
    }()
  }, {
    key: 'unrenderLayer',
    value: function () {
      function unrenderLayer() {
        if (!this.layer) {
          return;
        }
        (0, _reactDom.unmountComponentAtNode)(this.layer);
        if (this.props.container) this.props.container.removeChild(this.layer);
        this.layer = null;
      }

      return unrenderLayer;
    }()
  }, {
    key: 'renderLayer',
    value: function () {
      function renderLayer() {
        var _props = this.props,
            children = _props.children,
            container = _props.container,
            open = _props.open;


        if (open) {
          if (!this.layer) {
            this.layer = document.createElement('div');
            this.layer.setAttribute('data-mui-portal', 'true');
            if (container) container.appendChild(this.layer);
          }

          /**
           * By calling this method in componentDidMount() and
           * componentDidUpdate(), you're effectively creating a "wormhole" that
           * funnels React's hierarchical updates through to a DOM node on an
           * entirely different part of the page.
           */

          var layerElement = _react2['default'].Children.only(children);
          (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
        } else {
          this.unrenderLayer();
        }
      }

      return renderLayer;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        return null;
      }

      return render;
    }()
  }]);

  return Portal;
}(_react.Component), _class.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The container of the portal.
   */
  container: _PropTypes2['default'].object,
  open: _PropTypes2['default'].bool
}, _class.defaultProps = {
  container: _context2['default'].document.body,
  open: false
}, _temp2);
exports['default'] = Portal;


Portal.displayName = 'Portal';

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = Toolbar;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Toolbar', function (theme) {
  return _defineProperty({
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      height: theme.typography.rhythmByPixel(56)
    }
  }, theme.breakpoints.up('md'), {
    gutters: theme.mixins.gutters(4)
  });
});

function Toolbar(props, context) {
  var children = props.children,
      classNameProp = props.className,
      gutters = props.gutters,
      other = _objectWithoutProperties(props, ['children', 'className', 'gutters']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.gutters, gutters), classNameProp);

  return _react2['default'].createElement(
    'div',
    _extends({ className: className }, other),
    children
  );
}

Toolbar.displayName = 'Toolbar';

Toolbar.propTypes = {
  /**
   * Can be a `ToolbarGroup` to render a group of related items.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If set to true, enables gutter padding.
   */
  gutters: _PropTypes2['default'].bool
};

Toolbar.defaultProps = {
  gutters: true
};

Toolbar.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _FormActions = __webpack_require__(1635);

var _FormActions2 = _interopRequireDefault(_FormActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = (_temp2 = _class = function (_PureComponent) {
  _inherits(Form, _PureComponent);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      _this.checkValidity();
      var hasErrors = _this.hasErrors();
      if (hasErrors) {
        e.preventDefault();
        return;
      }

      var _this$props$onSubmit = _this.props.onSubmit,
          onSubmit = _this$props$onSubmit === undefined ? function () {} : _this$props$onSubmit;

      return onSubmit(e);
    }, _this.handleValidate = function (event) {
      var _this$props$onValidat = _this.props.onValidate,
          onValidate = _this$props$onValidat === undefined ? function () {} : _this$props$onValidat;
      var componentID = event.id,
          _event$target = event.target;
      _event$target = _event$target === undefined ? {} : _event$target;
      var targetID = _event$target.id;


      var id = targetID || componentID;

      if (!id) throw new Error('Form > Inputs must be assigned an \'id\' property');

      _this.setValidation(_defineProperty({}, id, event));
      onValidate(event);
    }, _this.hasErrors = function () {
      var errorProp = _this.props.error;

      return _this.hasControlledErrors() ? errorProp : _this.getErrors().length !== 0;
    }, _this.attach = function (node) {
      _this.inputs = Array.from(new Set([].concat(_toConsumableArray(_this.inputs), [node])));
    }, _this.detach = function (node) {
      _this.inputs = _this.inputs.filter(function (input) {
        return input !== node;
      });
    }, _this.validation = {}, _this.inputs = [], _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: 'createDefaultContext',
    value: function () {
      function createDefaultContext() // eslint-disable-line no-unused-vars
      {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _props$muiForm = props.muiForm,
            muiForm = _props$muiForm === undefined ? {
          onValidate: this.handleValidate,
          attach: this.attach,
          detach: this.detach,
          hasErrors: this.hasErrors
        } : _props$muiForm;

        return { muiForm: muiForm };
      }

      return createDefaultContext;
    }()
  }, {
    key: 'checkValidity',
    value: function () {
      function checkValidity() {
        var _props$onValidate = this.props.onValidate,
            onValidate = _props$onValidate === undefined ? function () {} : _props$onValidate;

        this.clearValidation();
        var errors = this.inputs.reduce(function (errors, input) {
          return [].concat(_toConsumableArray(errors), _toConsumableArray(input.checkValidity(undefined, undefined, true)));
        }, []);
        return errors;
      }

      return checkValidity;
    }()
  }, {
    key: 'hasControlledErrors',
    value: function () {
      function hasControlledErrors() {
        return !!this.props.error; // eslint-disable-line react/prop-types
      }

      return hasControlledErrors;
    }()
  }, {
    key: 'clearValidation',
    value: function () {
      function clearValidation() {
        this.validation = {};
      }

      return clearValidation;
    }()
  }, {
    key: 'setValidation',
    value: function () {
      function setValidation() {
        var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.validation = Object.assign({}, this.validation, next);
        var error = this.getErrors().length !== 0;
        if (this.state.error !== error) {
          this.setState({ error: error });
        }
      }

      return setValidation;
    }()
  }, {
    key: 'getErrors',
    value: function () {
      function getErrors() {
        var _this2 = this;

        return Object.keys(this.validation).filter(function (k) {
          return _this2.validation[k].hasErrors;
        }).reduce(function (o, k) {
          return [].concat(_toConsumableArray(o), [_this2.validation[k]]);
        }, []);
      }

      return getErrors;
    }()
  }, {
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        var muiForm = this.muiForm;

        return { muiForm: muiForm };
      }

      return getChildContext;
    }()
  }, {
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        var _createDefaultContext = this.createDefaultContext(this.props),
            muiForm = _createDefaultContext.muiForm;

        this.muiForm = muiForm;
      }

      return componentWillMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            Form = _props.formComponent,
            onSubmit = _props.onSubmit,
            onValidate = _props.onValidate,
            children = _props.children,
            confirmationActions = _props.confirmationActions,
            ConfirmationActions = _props.confirmationActionsComponent,
            confirmationActionsClassName = _props.confirmationActionsClassName,
            others = _objectWithoutProperties(_props, ['formComponent', 'onSubmit', 'onValidate', 'children', 'confirmationActions', 'confirmationActionsComponent', 'confirmationActionsClassName']);

        return _react2['default'].createElement(
          Form,
          _extends({}, others, { onSubmit: this.handleSubmit }),
          children,
          confirmationActions && _react2['default'].createElement(
            ConfirmationActions,
            { className: confirmationActionsClassName },
            confirmationActions
          )
        );
      }

      return render;
    }()
  }]);

  return Form;
}(_react.PureComponent), _class.propTypes = {
  /**
   * The content of the `Form`.
   */
  children: _PropTypes2['default'].node,
  /**
   * Nodes to be placed in the confirmation action container.
   */
  confirmationActions: _PropTypes2['default'].node,
  /**
   * Component to be used as the confirmation action node
   */
  confirmationActionsComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * The CSS class name of the confirmation action element.
   */
  confirmationActionsClassName: _PropTypes2['default'].string,
  /**
   * Component to be used as the form
   */
  formComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Node used for the child context
   */
  muiForm: _PropTypes2['default'].object,
  /**
   * Callback fired when form is submitted
   */
  onSubmit: _PropTypes2['default'].func,
  /**
   * Callback fired when form is validated
   */
  onValidate: _PropTypes2['default'].func
}, _class.defaultProps = {
  confirmationActionsComponent: _FormActions2['default'],
  formComponent: 'form'
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.childContextTypes = {
  muiForm: _PropTypes2['default'].object.isRequired
}, _temp2);
exports['default'] = Form;


Form.displayName = 'Form';

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('FormActions', function (theme) {
  return {
    root: _defineProperty({
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flex: 0,
      flexFlow: 'column'
    }, theme.breakpoints.up('sm'), {
      flexFlow: 'row',
      justifyContent: 'flex-end'
    }),
    child: _defineProperty({
      flex: 1,
      width: '100%',
      '& + &': {
        marginTop: theme.typography.rhythmByUnit(1)
      }
    }, theme.breakpoints.up('sm'), {
      flex: '0 auto',
      width: 'auto',
      '& + &': {
        marginTop: 0,
        marginLeft: theme.typography.rhythmByUnit(1)
      }
    })
  };
});

var FormActions = (_temp = _class = function (_Component) {
  _inherits(FormActions, _Component);

  function FormActions() {
    _classCallCheck(this, FormActions);

    return _possibleConstructorReturn(this, (FormActions.__proto__ || Object.getPrototypeOf(FormActions)).apply(this, arguments));
  }

  _createClass(FormActions, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            childrenProp = _props.children,
            classNameProp = _props.className,
            props = _objectWithoutProperties(_props, ['children', 'className']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);
        var children = childrenProp ? _react2['default'].Children.map(childrenProp, function (child) {
          return _react2['default'].isValidElement(child) ? _react2['default'].cloneElement(child, {
            className: (0, _classnames2['default'])(classes.child, child.props.className)
          }) : child;
        }) : childrenProp;

        return _react2['default'].createElement('div', _extends({ 'data-mui-test': 'FormActions' }, Object.assign({}, props, { children: children, className: className })));
      }

      return render;
    }()
  }]);

  return FormActions;
}(_react.Component), _class.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = FormActions;


FormActions.displayName = 'FormActions';

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = FormLabel;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('FormLabel', function (theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.primary
    },
    asterisk: {
      color: theme.palette.text.error
    },
    labelOuter: {
      display: 'inline',
      maxWidth: '100%'
    },
    labelInner: {
      display: 'inline'
    },
    labelEllipsis: theme.mixins.truncate()
  };
});

function FormLabel(props, context) {
  var children = props.children,
      classNameProp = props.className,
      ellipsize = props.ellipsize,
      errorProp = props.error,
      requiredProp = props.required,
      focusedProp = props.focused,
      requiredAsterisk = props.requiredAsterisk,
      other = _objectWithoutProperties(props, ['children', 'className', 'ellipsize', 'error', 'required', 'focused', 'requiredAsterisk']);

  var muiFormControl = context.muiFormControl,
      styleManager = context.styleManager;

  var classes = styleManager.render(styleSheet);

  var required = requiredProp;
  var focused = focusedProp;
  var error = errorProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }
    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }
    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }
  }

  var className = (0, _classnames2['default'])(classes.root, classNameProp);

  var labelClassName = (0, _classnames2['default'])(classes.labelInner, _defineProperty({}, classes.labelEllipsis, ellipsize));

  return _react2['default'].createElement(
    'label',
    _extends({ htmlFor: 'Form', className: className }, other),
    _react2['default'].createElement(
      'div',
      { className: classes.labelOuter },
      _react2['default'].createElement(
        'div',
        { className: labelClassName },
        children
      )
    ),
    (required || requiredAsterisk) && _react2['default'].createElement(
      'span',
      { className: classes.asterisk, 'data-mui-test': 'FormLabelAsterisk' },
      '\u2009*'
    )
  );
}

FormLabel.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, the label will trunacte with an ellipsis.
   */
  ellipsize: _PropTypes2['default'].bool,
  /**
   * Whether the label should be displayed in an error state.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If true, the input of this label is focused (used by FormGroup components).
   */
  focused: _PropTypes2['default'].bool,
  /**
   * If true, the label will indicate that the input is required.
   */
  required: _PropTypes2['default'].bool,
  /**
   * If true, the label will display an asterisk as if the input is required.
   */
  requiredAsterisk: _PropTypes2['default'].bool,
  /**
   * If true, the label will shrink above the control
   */
  shrink: _PropTypes2['default'].bool
};

FormLabel.defaultProps = {
  ellipsize: false
};

FormLabel.contextTypes = {
  muiFormControl: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

FormLabel.displayName = 'FormLabel';

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonBase = __webpack_require__(197);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Button', function (theme) {
  var typography = theme.typography,
      palette = theme.palette,
      transitions = theme.transitions,
      shadows = theme.shadows;

  return {
    root: Object.assign({}, typography.body1, theme.mixins.gutters(2), {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: typography.rhythmByUnit(11),
      height: typography.rhythmByUnit(4),
      borderRadius: theme.variables.buttonBorderRadius,
      backgroundColor: 'transparent',
      transition: transitions.create(['background-color', 'box-shadow'], {
        duration: transitions.duration.short
      }),
      '&:hover, &:focus': {
        textDecoration: 'none',
        backgroundColor: palette.grey[50],
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    }),
    label: {
      width: '100%',
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },
    primary: {
      color: palette.primary[500]
    },
    accent: {
      color: palette.accent[500]
    },
    active: {
      // this space intentionally blank, for now
    },
    contrast: {
      color: palette.getContrastText(palette.primary[500])
    },
    raised: {
      color: palette.getContrastText(palette.grey[300]),
      backgroundColor: palette.background.paper,
      borderColor: palette.grey[100],
      borderStyle: 'solid',
      borderWidth: 1,
      '&$disabled': {
        backgroundColor: palette.grey[200],
        borderColor: palette.grey[300]
      },
      '&:hover, &:focus': {
        backgroundColor: palette.grey.A100,
        borderColor: palette.grey[200],
        '&$disabled': {
          backgroundColor: palette.text.divider
        }
      }
    },
    keyboardFocused: {},
    raisedPrimary: {
      color: palette.getContrastText(palette.primary[500]),
      fontWeight: typography.fontWeightMedium,
      backgroundColor: palette.success[500],
      '&:hover, &:focus': {
        backgroundColor: palette.success[600]
      },
      border: 'none'
    },
    raisedContrast: {
      color: palette.getContrastText(palette.primary[500])
    },
    disabled: {
      color: palette.action.disabled,
      cursor: 'not-allowed'
    },
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: typography.rhythmByUnit(7),
      height: typography.rhythmByUnit(7),
      border: 'none',
      boxShadow: shadows[6],
      /* Internet Explorer 10+ */
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        transform: 'translate3d(0, 0, 0)' // Hardware-Accelerated CSS
      },
      '&:active': {
        boxShadow: shadows[12]
      }
    },
    fabPrimary: {
      color: palette.getContrastText(palette.primary[500]),
      backgroundColor: palette.primary[500],
      '&:hover, &:focus': {
        backgroundColor: palette.primary[600]
      }
    },
    colorInherit: {
      color: 'inherit',
      '&:hover, &:focus': {
        color: 'initial'
      }
    },
    fullWidth: {
      display: 'flex',
      width: '100%'
    },
    compact: Object.assign({}, theme.mixins.gutters(1), {
      minWidth: typography.rhythmByUnit(8)
    })
  };
});

/**
 * Buttons communicate the action that will occur when the user
 * touches them.
 *
 * ```jsx
 * <Button>Hello World</Button>
 * ```
 */
var Button = (_temp2 = _class = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.isDisabled = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          disabled = _this$props.disabled;

      return typeof disabled === 'boolean' ? disabled : type === 'submit' && _this.hasErrors();
    }, _this.hasErrors = function () {
      var _this$context$muiForm = _this.context.muiForm;
      _this$context$muiForm = _this$context$muiForm === undefined ? {} : _this$context$muiForm;
      var _this$context$muiForm2 = _this$context$muiForm.hasErrors,
          hasErrors = _this$context$muiForm2 === undefined ? function () {
        return false;
      } : _this$context$muiForm2;

      return hasErrors();
    }, _this.handleClick = function (event) {
      var _this$props$onClick = _this.props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick;


      if (_this.isDisabled()) {
        return event && event.preventDefault();
      }

      return onClick(event); // eslint-disable-line flowtype-errors/show-errors
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props = this.props,
            accent = _props.accent,
            active = _props.active,
            children = _props.children,
            classNameProp = _props.className,
            colorInherit = _props.colorInherit,
            compact = _props.compact,
            contrast = _props.contrast,
            disabledProp = _props.disabled,
            fab = _props.fab,
            fullWidth = _props.fullWidth,
            onClick = _props.onClick,
            primary = _props.primary,
            raised = _props.raised,
            other = _objectWithoutProperties(_props, ['accent', 'active', 'children', 'className', 'colorInherit', 'compact', 'contrast', 'disabled', 'fab', 'fullWidth', 'onClick', 'primary', 'raised']);

        var disabled = this.isDisabled();
        var classes = this.context.styleManager.render(styleSheet);
        var flat = !raised && !fab;
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.active, active), _defineProperty(_classNames, classes.raised, raised || fab), _defineProperty(_classNames, classes.fab, fab), _defineProperty(_classNames, classes.primary, flat && primary), _defineProperty(_classNames, classes.accent, flat && accent), _defineProperty(_classNames, classes.contrast, flat && contrast), _defineProperty(_classNames, classes.raisedPrimary, !flat && (primary || accent)), _defineProperty(_classNames, classes.fabPrimary, fab && primary), _defineProperty(_classNames, classes.raisedContrast, !flat && contrast), _defineProperty(_classNames, classes.compact, compact), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.fullWidth, fullWidth), _defineProperty(_classNames, classes.colorInherit, flat && colorInherit), _classNames), classNameProp);

        var fullTypeOf = other['typeof'] ? 'ui:Button ' + other['typeof'] : 'ui:Button';

        return _react2['default'].createElement(
          _ButtonBase2['default'],
          _extends({
            className: className,
            disabled: disabled,
            keyboardFocusedClassName: classes.keyboardFocused
          }, other, {
            onClick: this.handleClick,
            tabIndex: disabled ? '-1' : undefined,
            'typeof': fullTypeOf
          }),
          _react2['default'].createElement(
            'span',
            { className: classes.label },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return Button;
}(_react.Component), _class.propTypes = {
  /**
   * If `true`, the button will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will appear to be selected.
   */
  active: _PropTypes2['default'].bool,
  /**
   * The content of the button.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the parent element's color.
   */
  colorInherit: _PropTypes2['default'].bool,
  /**
   * Uses a smaller minWidth, ideal for things like card actions.
   */
  compact: _PropTypes2['default'].bool,
  /**
   * The element or component used for the root node.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * If true, will use the theme's contrast color.
   */
  contrast: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, will use floating action button styling.
   */
  fab: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will have a keyboard focus ripple.
   * Ripple must also be true.
   */
  focusRipple: _PropTypes2['default'].bool,
  /**
   * If `true`, button will be expanded to full width
   */
  fullWidth: _PropTypes2['default'].bool,
  /**
   * The URL to link to when the button is clicked.
   * If set, an `a` element will be used as the root node.
   */
  href: _PropTypes2['default'].string,
  /**
   * @ignore
   */
  onClick: _PropTypes2['default'].func,
  /**
   * If `true`, the button will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will use raised styling.
   */
  raised: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will have a ripple.
   */
  ripple: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  type: _PropTypes2['default'].string,
  /**
   * The type of the element, appended to the control's own Button type identifier
   */
  'typeof': _PropTypes2['default'].string
}, _class.defaultProps = {
  accent: false,
  colorInherit: false,
  component: 'button',
  compact: false,
  contrast: false,
  disabled: false,
  fab: false,
  focusRipple: false,
  fullWidth: false,
  primary: false,
  raised: false,
  ripple: false,
  type: 'button'
}, _class.contextTypes = {
  muiForm: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Button;


Button.displayName = 'Button';

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectKeyboardFocus = detectKeyboardFocus;
exports.listenForFocusKeys = listenForFocusKeys;
exports.focusKeyPressed = focusKeyPressed;

var _keycode = __webpack_require__(147);

var _keycode2 = _interopRequireDefault(_keycode);

var _contains = __webpack_require__(121);

var _contains2 = _interopRequireDefault(_contains);

var _addEventListener = __webpack_require__(624);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right']; //  weak

var internal = {
  listening: false,
  focusKeyPressed: false
};

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode2['default'])(event)) !== -1;
}

function detectKeyboardFocus(instance, element, cb) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  instance.keyboardFocusTimeout = setTimeout(function () {
    if (focusKeyPressed() && (document.activeElement === element || (0, _contains2['default'])(element, document.activeElement))) {
      cb();
    } else if (attempt < 5) {
      detectKeyboardFocus(instance, element, cb, attempt + 1);
    }
  }, 40);
}

function listenForFocusKeys() {
  if (!internal.listening) {
    (0, _addEventListener2['default'])(window, 'keyup', function (event) {
      if (isFocusKey(event)) {
        internal.focusKeyPressed = true;
      }
    });
    internal.listening = true;
  }
}

function focusKeyPressed(pressed) {
  if (typeof pressed !== 'undefined') {
    internal.focusKeyPressed = Boolean(pressed);
  }

  return internal.focusKeyPressed;
}

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRippleHandler = exports.TouchRipple = exports.Ripple = exports['default'] = undefined;

var _rippleHandler = __webpack_require__(1640);

Object.defineProperty(exports, 'createRippleHandler', {
  enumerable: true,
  get: function () {
    function get() {
      return _rippleHandler.createRippleHandler;
    }

    return get;
  }()
});

var _Ripple2 = __webpack_require__(630);

var _Ripple3 = _interopRequireDefault(_Ripple2);

var _TouchRipple2 = __webpack_require__(1641);

var _TouchRipple3 = _interopRequireDefault(_TouchRipple2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Ripple3['default']; /* eslint-disable flowtype/require-valid-file-annotation */

exports.Ripple = _Ripple3['default'];
exports.TouchRipple = _TouchRipple3['default'];

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRippleHandler = createRippleHandler;
//  weak

function createRippleHandler(instance, eventName, action, cb) {
  return function () {
    function handleEvent(event) {
      if (cb) {
        cb.call(instance, event);
      }

      if (event.defaultPrevented) {
        return false;
      }

      if (instance.ripple) {
        instance.ripple[action](event);
      }

      if (instance.props && typeof instance.props['on' + eventName] === 'function') {
        instance.props['on' + eventName](event);
      }

      return true;
    }

    return handleEvent;
  }();
}

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; //  weak

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsTransitionGroup = __webpack_require__(828);

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _shallowEqual = __webpack_require__(1645);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Ripple = __webpack_require__(630);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('TouchRipple', function () {
  return {
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    }
  };
});

var TouchRipple = (_temp2 = _class = function (_Component) {
  _inherits(TouchRipple, _Component);

  function TouchRipple() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TouchRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchRipple.__proto__ || Object.getPrototypeOf(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nextKey: 0,
      ripples: []
    }, _this.ignoringMouseDown = false, _this.pulsate = function () {
      _this.start({}, { pulsate: true });
    }, _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments[2];
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center;


      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var ripples = _this.state.ripples;

      var element = _reactDom2['default'].findDOMNode(_this); // eslint-disable-line react/no-find-dom-node
      var rect = element ? element.getBoundingClientRect() // eslint-disable-line flowtype-errors/show-errors
      : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      };

      // Get the size of the ripple
      var rippleX = void 0;
      var rippleY = void 0;
      var rippleSize = void 0;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);

        // For some reason the animation is broken on Mobile Chrome if the size if even.
        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth // eslint-disable-line flowtype-errors/show-errors
        : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight // eslint-disable-line flowtype-errors/show-errors
        : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      }

      // Add a ripple to the ripples array
      ripples = [].concat(_toConsumableArray(ripples), [_react2['default'].createElement(_Ripple2['default'], {
        key: _this.state.nextKey,
        center: center,
        event: event,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
      _this.setState(
      // eslint-disable-next-line flowtype-errors/show-errors
      {
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    }, _this.stop = function (event, cb) {
      var ripples = _this.state.ripples;

      if (ripples && ripples.length) {
        _this.setState(
        // eslint-disable-next-line flowtype-errors/show-errors
        {
          ripples: ripples.slice(1)
        }, cb);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TouchRipple, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        // Pre-render the ripple styles
        this.context.styleManager.render(_Ripple.styleSheet);
      }

      return componentWillMount;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState, nextContext) {
        return !(0, _shallowEqual2['default'])(this.props, nextProps) || !(0, _shallowEqual2['default'])(this.state, nextState) || !(0, _shallowEqual2['default'])(this.context.theme, nextContext.theme);
      }

      return shouldComponentUpdate;
    }()

    // Used to filter out mouse emulated events on mobile.

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            center = _props.center,
            className = _props.className,
            other = _objectWithoutProperties(_props, ['center', 'className']);

        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          _reactAddonsTransitionGroup2['default'],
          _extends({
            component: 'span',
            transitionEnterTimeout: 550,
            transitionLeaveTimeout: 550,
            className: (0, _classnames2['default'])(classes.root, className)
          }, other),
          this.state.ripples
        );
      }

      return render;
    }()
  }]);

  return TouchRipple;
}(_react.Component), _class.propTypes = {
  center: _PropTypes2['default'].bool,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
}, _class.defaultProps = {
  center: false
}, _class.contextTypes = {
  theme: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = TouchRipple;


TouchRipple.displayName = 'TouchRipple';

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(82);
var ReactTransitionChildMapping = __webpack_require__(1643);

var propTypesFactory = __webpack_require__(304);
var PropTypes = propTypesFactory(React.isValidElement);

var emptyFunction = __webpack_require__(48);

/**
 * A basis for animations. When children are declaratively added or removed,
 * special lifecycle hooks are called.
 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
 */

var ReactTransitionGroup = function (_React$Component) {
  _inherits(ReactTransitionGroup, _React$Component);

  function ReactTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReactTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      // TODO: can we get useful debug information to show at this point?
      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
    }, _this.performAppear = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.refs[key];

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
      } else {
        _this._handleDoneAppearing(key);
      }
    }, _this._handleDoneAppearing = function (key) {
      var component = _this.refs[key];
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key);
      }
    }, _this.performEnter = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.refs[key];

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
      } else {
        _this._handleDoneEntering(key);
      }
    }, _this._handleDoneEntering = function (key) {
      var component = _this.refs[key];
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key);
      }
    }, _this.performLeave = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.refs[key];
      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key);
      }
    }, _this._handleDoneLeaving = function (key) {
      var component = _this.refs[key];

      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.performEnter(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _assign({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key);
      }
    }
  };

  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
    });

    var key;

    for (key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
        this.keysToLeave.push(key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(this.performEnter);

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  };

  ReactTransitionGroup.prototype.render = function render() {
    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];
    for (var key in this.state.children) {
      var child = this.state.children[key];
      if (child) {
        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(React.cloneElement(this.props.childFactory(child), {
          ref: key,
          key: key
        }));
      }
    }

    // Do not forward ReactTransitionGroup props to primitive DOM nodes
    var props = _assign({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return React.createElement(this.props.component, props, childrenToRender);
  };

  return ReactTransitionGroup;
}(React.Component);

ReactTransitionGroup.displayName = 'ReactTransitionGroup';
ReactTransitionGroup.propTypes = {
  component: PropTypes.any,
  childFactory: PropTypes.func
};
ReactTransitionGroup.defaultProps = {
  component: 'span',
  childFactory: emptyFunction.thatReturnsArgument
};


module.exports = ReactTransitionGroup;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var flattenChildren = __webpack_require__(1644);

var ReactTransitionChildMapping = {
  /**
   * Given `this.props.children`, return an object mapping key to child. Just
   * simple syntactic sugar around flattenChildren().
   *
   * @param {*} children `this.props.children`
   * @param {number=} selfDebugID Optional debugID of the current internal instance.
   * @return {object} Mapping of key to child
   */
  getChildMapping: function (children, selfDebugID) {
    if (!children) {
      return children;
    }

    if (false) {
      return flattenChildren(children, selfDebugID);
    }

    return flattenChildren(children);
  },

  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */
  mergeChildMappings: function (prev, next) {
    prev = prev || {};
    next = next || {};

    function getValueForKey(key) {
      if (next.hasOwnProperty(key)) {
        return next[key];
      } else {
        return prev[key];
      }
    }

    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = {};

    var pendingKeys = [];
    for (var prevKey in prev) {
      if (next.hasOwnProperty(prevKey)) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }

    var i;
    var childMapping = {};
    for (var nextKey in next) {
      if (nextKeysPending.hasOwnProperty(nextKey)) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }
      childMapping[nextKey] = getValueForKey(nextKey);
    }

    // Finally, add the keys which didn't appear before any key in `next`
    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }

    return childMapping;
  }
};

module.exports = ReactTransitionChildMapping;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(481);
var traverseAllChildren = __webpack_require__(480);
var warning = __webpack_require__(16);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(309);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('./ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)))

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(166);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonBase = __webpack_require__(197);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('IconButton', function (theme) {
  var palette = theme.palette,
      transitions = theme.transitions,
      typography = theme.typography;


  return {
    iconButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: typography.rhythmByUnit(3),
      width: theme.variables.inputHeight,
      height: theme.variables.inputHeight,
      padding: 0,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      color: palette.action.active,
      zIndex: theme.zIndex.baseIndex,
      transition: transitions.create('background-color', {
        duration: transitions.duration.short
      })
    },
    disabled: {
      color: palette.action.disabled
    },
    accent: typography.highlight,
    error: typography.error,
    secondary: typography.secondary,
    primary: typography.primary,
    colorInherit: {
      color: 'inherit'
    },
    heightInherit: {
      height: 'inherit'
    },
    sizeInherit: {
      fontSize: '1em'
    },
    contrast: {
      color: palette.getContrastText(palette.primary[500])
    },
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit',
      '& .material-icons': {
        width: '1em',
        height: '1em'
      }
    },
    keyboardFocused: {
      backgroundColor: palette.text.divider
    }
  };
});

/**
 * @see https://material.google.com/components/buttons.html
 *
 * ```js
 * import IconButton from 'pushbot-ui/IconButton';
 *
 * const Component = () => <IconButton>delete</IconButton>;
 * ```
 */
var IconButton = (_temp = _class = function (_PureComponent) {
  _inherits(IconButton, _PureComponent);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
  }

  _createClass(IconButton, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props = this.props,
            accent = _props.accent,
            buttonRef = _props.buttonRef,
            children = _props.children,
            className = _props.className,
            colorInherit = _props.colorInherit,
            contrast = _props.contrast,
            disabled = _props.disabled,
            error = _props.error,
            heightInherit = _props.heightInherit,
            primary = _props.primary,
            ripple = _props.ripple,
            secondary = _props.secondary,
            sizeInherit = _props.sizeInherit,
            other = _objectWithoutProperties(_props, ['accent', 'buttonRef', 'children', 'className', 'colorInherit', 'contrast', 'disabled', 'error', 'heightInherit', 'primary', 'ripple', 'secondary', 'sizeInherit']);

        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          _ButtonBase2['default'],
          _extends({
            className: (0, _classnames2['default'])(classes.iconButton, (_classNames = {}, _defineProperty(_classNames, classes.colorInherit, colorInherit && !(primary || contrast || secondary || accent || error || disabled)), _defineProperty(_classNames, classes.primary, primary && !(contrast || secondary || accent || error || disabled)), _defineProperty(_classNames, classes.contrast, contrast && !(secondary || accent || error || disabled)), _defineProperty(_classNames, classes.secondary, secondary && !(accent || error || disabled)), _defineProperty(_classNames, classes.accent, accent && !(error || disabled)), _defineProperty(_classNames, classes.error, error && !disabled), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.sizeInherit, sizeInherit), _defineProperty(_classNames, classes.heightInherit, heightInherit), _classNames), className),
            centerRipple: ripple,
            keyboardFocusedClassName: classes.keyboardFocused,
            ref: buttonRef
          }, Object.assign({ disabled: disabled, ripple: ripple }, other)),
          _react2['default'].createElement(
            'span',
            { className: (0, _classnames2['default'])(classes.label) },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return IconButton;
}(_react.PureComponent), _class.propTypes = {
  /**
   * If true, will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  buttonRef: _PropTypes2['default'].func,
  /**
   * The icon element. If a string is passed,
   * it will be used as a material icon font ligature.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the parent element's color.
   */
  colorInherit: _PropTypes2['default'].bool,
  /**
   * If true, will use the theme's contrast color.
   */
  contrast: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If false, the ripple effect will be disabled.
   */
  ripple: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the parent element's font size.
   */
  sizeInherit: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the parent element's height.
   */
  heightInherit: _PropTypes2['default'].bool
}, _class.defaultProps = {
  accent: false,
  error: false,
  colorInherit: true,
  contrast: false,
  disabled: false,
  heightInherit: false,
  primary: false,
  ripple: false,
  secondary: false,
  sizeInherit: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = IconButton;


IconButton.displayName = 'IconButton';

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('LinearProgress', function (theme) {
  var palette = theme.palette;

  var transitionDuration = 4; // 400ms

  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 2,
      backgroundColor: palette.accent[200]
    },
    rootBuffer: {
      backgroundColor: 'transparent'
    },
    rootQuery: {
      transform: 'rotate(180deg)'
    },
    rootDeterminate: {
      backgroundColor: palette.background['default']
    },
    bar: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      backgroundColor: palette.text.highlight
    },
    error: {
      backgroundColor: palette.text.error
    },
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      background: 'radial-gradient(' + palette.primary[100] + ' 0%, ' + palette.primary[100] + ' 16%, transparent 42%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px',
      animation: 'buffer 3s infinite linear'
    },
    indeterminateBar1: {
      willChange: 'left, right',
      animation: 'indeterminate-1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },
    indeterminateBar2: {
      willChange: 'left, right',
      animation: 'indeterminate-2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },
    determinateBar1: {
      willChange: 'width',
      transition: 'width .' + transitionDuration + 's linear'
    },
    determinateBar2: {
      display: 'none'
    },
    bufferBar1: {
      transition: 'width .' + transitionDuration + 's linear',
      backgroundColor: palette.primary[100]
    },
    bufferBar2: {
      transition: 'width .' + transitionDuration + 's linear'
    },
    '@keyframes indeterminate-1': {
      '0%': {
        left: '-35%',
        right: '100%'
      },
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate-2': {
      '0%': {
        left: '-200%',
        right: '100%'
      },
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    },
    '@keyframes query': {
      '0%': {
        opacity: 1,
        transform: 'translateX(35%) scale(.3, 1)'
      },
      '100%': {
        opacity: 0,
        transform: 'translateX(-50%) scale(0, 1)'
      }
    }
  };
});

var LinearProgress = (_temp = _class = function (_Component) {
  _inherits(LinearProgress, _Component);

  function LinearProgress() {
    _classCallCheck(this, LinearProgress);

    return _possibleConstructorReturn(this, (LinearProgress.__proto__ || Object.getPrototypeOf(LinearProgress)).apply(this, arguments));
  }

  _createClass(LinearProgress, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames3, _classNames4;

        var _props = this.props,
            className = _props.className,
            mode = _props.mode,
            value = _props.value,
            valueBuffer = _props.valueBuffer,
            error = _props.error,
            other = _objectWithoutProperties(_props, ['className', 'mode', 'value', 'valueBuffer', 'error']);

        var classes = this.context.styleManager.render(styleSheet);
        var rootClasses = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.rootDeterminate, mode === 'determinate'), _defineProperty(_classNames, classes.rootBuffer, mode === 'buffer'), _defineProperty(_classNames, classes.rootQuery, mode === 'query'), _classNames), className);
        var dashedClasses = (0, _classnames2['default'])(_defineProperty({}, classes.dashed, mode === 'buffer'));
        var bar1Classes = (0, _classnames2['default'])(classes.bar, (_classNames3 = {}, _defineProperty(_classNames3, classes.indeterminateBar1, mode === 'indeterminate' || mode === 'query'), _defineProperty(_classNames3, classes.determinateBar1, mode === 'determinate'), _defineProperty(_classNames3, classes.error, error), _classNames3));
        var bar2Classes = (0, _classnames2['default'])(classes.bar, (_classNames4 = {}, _defineProperty(_classNames4, classes.indeterminateBar2, mode === 'indeterminate' || mode === 'query'), _defineProperty(_classNames4, classes.determinateBar2, mode === 'determinate'), _defineProperty(_classNames4, classes.bufferBar2, mode === 'buffer'), _classNames4));
        var styles = { bar1: {}, bar2: {} };

        if (mode === 'determinate') {
          styles.bar1.width = value + '%';
        } else if (mode === 'buffer') {
          styles.bar1.width = valueBuffer + '%';
          styles.bar2.width = value + '%';
        }

        return _react2['default'].createElement(
          'div',
          _extends({ className: rootClasses }, other),
          _react2['default'].createElement('div', { className: dashedClasses }),
          _react2['default'].createElement('div', { className: bar1Classes, style: styles.bar1 }),
          _react2['default'].createElement('div', { className: bar2Classes, style: styles.bar2 })
        );
      }

      return render;
    }()
  }]);

  return LinearProgress;
}(_react.Component), _class.propTypes = {
  className: _PropTypes2['default'].string,
  /**
   * The mode of show your progress, indeterminate
   * for when there is no value for progress.
   */
  mode: _PropTypes2['default'].oneOf(['determinate', 'indeterminate', 'buffer', 'query']),
  /**
   * The value of progress, only works in determinate and buffer mode.
   */
  value: _PropTypes2['default'].number,
  /**
   * The value of buffer, only works in buffer mode.
   */
  valueBuffer: _PropTypes2['default'].number,
  /**
   * If true, bar1 has 'error' backgroundColor.
   */
  error: _PropTypes2['default'].bool
}, _class.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  error: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = LinearProgress;


LinearProgress.displayName = 'LinearProgress';

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var THICKNESS = 3.6;
var PI = 3.1415; // Simple version of Math.PI for the css generated.

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('CircularProgress', function (theme) {
  return {
    root: {
      display: 'inline-block',
      color: theme.palette.primary[500]
    },
    center: {
      display: 'block',
      margin: '0 auto'
    },
    svg: {
      // The main animation is loop 4 times (4 / 3 * 1300).
      animation: 'rotate-progress-circle 1733ms linear infinite'
    },
    circle: {
      strokeDasharray: '1, calc((100% - 3px) * 3.141)',
      strokeDashoffset: '0%',
      stroke: 'currentColor',
      strokeLinecap: 'square',
      transition: theme.transitions.create('all', { duration: 1300 }),
      animation: 'scale-progress-circle 1300ms ' + theme.transitions.easing.easeInOut + ' infinite'
    },
    '@keyframes rotate-progress-circle': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes scale-progress-circle': {
      '8%': {
        strokeDasharray: '1, calc((100% - ' + THICKNESS + 'px) * ' + PI + ')',
        strokeDashoffset: 0
      },
      '50%, 58%': {
        strokeDasharray: 'calc((65% - ' + THICKNESS + 'px) * ' + PI + '), calc((100% - ' + THICKNESS + 'px) * ' + PI + ')',
        strokeDashoffset: 'calc((25% - ' + THICKNESS + 'px) * -' + PI + ')'
      },
      '100%': {
        strokeDasharray: 'calc((65% - ' + THICKNESS + 'px) * ' + PI + '), calc((100% - ' + THICKNESS + 'px) * ' + PI + ')',
        strokeDashoffset: 'calc((99% - ' + THICKNESS + 'px) * -' + PI + ')'
      }
    }
  };
});

var CircularProgress = (_temp = _class = function (_Component) {
  _inherits(CircularProgress, _Component);

  function CircularProgress() {
    _classCallCheck(this, CircularProgress);

    return _possibleConstructorReturn(this, (CircularProgress.__proto__ || Object.getPrototypeOf(CircularProgress)).apply(this, arguments));
  }

  _createClass(CircularProgress, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            className = _props.className,
            mode = _props.mode,
            size = _props.size,
            center = _props.center,
            other = _objectWithoutProperties(_props, ['className', 'mode', 'size', 'center']);

        var classes = this.context.styleManager.render(styleSheet);
        var radius = size / 2;

        return _react2['default'].createElement(
          'div',
          _extends({
            className: center ? (0, _classnames2['default'])(classes.root, classes.center, className) : (0, _classnames2['default'])(classes.root, className),
            style: { width: size, height: size }
          }, other),
          _react2['default'].createElement(
            'svg',
            { className: classes.svg, viewBox: '0 0 ' + size + ' ' + size },
            _react2['default'].createElement('circle', {
              className: classes.circle,
              cx: radius,
              cy: radius,
              r: radius - THICKNESS / 2,
              fill: 'none',
              strokeWidth: THICKNESS,
              strokeMiterlimit: '20'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return CircularProgress;
}(_react.Component), _class.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The mode of show your progress, indeterminate
   * for when there is no value for progress.
   */
  mode: _PropTypes2['default'].oneOf(['determinate', 'indeterminate']),
  /**
   * The size of the circle.
   */
  size: _PropTypes2['default'].number,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _PropTypes2['default'].number,
  /**
   * If `true`, the circle will be centered
   */
  center: _PropTypes2['default'].bool
}, _class.defaultProps = {
  mode: 'indeterminate',
  size: 40,
  center: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = CircularProgress;


CircularProgress.displayName = 'CircularProgress';

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = DialogContentText;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('DialogContentText', function (theme) {
  return {
    root: Object.assign({}, theme.typography.subheading, {
      color: theme.palette.text.secondary,
      margin: 0
    })
  };
});

function DialogContentText(props, context) {
  var children = props.children,
      className = props.className,
      other = _objectWithoutProperties(props, ['children', 'className']);

  var classes = context.styleManager.render(styleSheet);

  return _react2['default'].createElement(
    'p',
    _extends({ className: (0, _classnames2['default'])(classes.root, className) }, other),
    children
  );
}

DialogContentText.displayName = 'DialogContentText';

DialogContentText.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
};

DialogContentText.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = exports.ValidationEvent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(147);

var _keycode2 = _interopRequireDefault(_keycode);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _isEqual = __webpack_require__(737);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _contains = __webpack_require__(121);

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = __webpack_require__(196);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = __webpack_require__(122);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _validators = __webpack_require__(699);

var _context3 = __webpack_require__(93);

var _context4 = _interopRequireDefault(_context3);

var _InputDataList = __webpack_require__(638);

var _InputDataList2 = _interopRequireDefault(_InputDataList);

var _ArrowDropDown = __webpack_require__(783);

var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);

var _ArrowDropUp = __webpack_require__(784);

var _ArrowDropUp2 = _interopRequireDefault(_ArrowDropUp);

var _IconButton = __webpack_require__(90);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ValidationEvent = exports.ValidationEvent = function () {
  function ValidationEvent(target) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var options = arguments[2];

    _classCallCheck(this, ValidationEvent);

    Object.assign(this, Object.assign({}, options, {
      type: 'validation',
      target: target,
      errors: errors,
      hasErrors: errors.length !== 0
    }));
  }

  return ValidationEvent;
}();

function normalizeErrors(errorMessage) {
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return (errors instanceof Array ? errors : [errors]).map(function (error) {
    return typeof error === 'boolean' ? errorMessage : (typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object' ? error.errorMessage : error;
  });
}

var nextID = function () {
  var next = 0;
  return function () {
    return 'input-' + ++next;
  };
}();

var defaultValidators = (0, _validators.createValidators)(function (validators) {
  return {
    exactMatch: validators.exactMatch,
    email: validators.email,
    length: validators.length,
    required: validators.required
  };
});

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Input', function (theme) {
  return {
    wrapper: {
      position: 'relative',
      minWidth: 0,
      width: theme.typography.rhythmByPixel(176),
      padding: theme.variables.borderWidthFocused,
      backgroundColor: theme.palette.background.paper
    },
    formControl: {
      marginTop: theme.variables.formControlMarginTop,
      marginBottom: theme.variables.formControlMarginBottom
    },
    inkbar: {
      '&:after': {
        backgroundColor: theme.palette.accent.A200,
        left: 0,
        bottom: -1,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        width: '100%',
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.shorter,
          easing: theme.transitions.easing.easeOut
        })
      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      }
    },
    focused: {},
    fullWidth: {
      width: '100%',
      boxSizing: 'border-box'
    },
    error: {
      backgroundColor: theme.palette.grey[50],
      '&:after': {
        backgroundColor: theme.palette.error[500],
        transform: 'scaleX(1)' // Error is always underlined in red
      }
    },
    input: Object.assign({
      font: 'inherit',
      padding: 0,
      border: 0,
      display: 'block',
      width: '100%',
      verticalAlign: 'middle',
      whiteSpace: 'normal',
      background: 'none',
      minWidth: 0,
      minHeight: theme.variables.inputHeight,
      appearance: 'textfield', // Improve type search style.
      color: theme.palette.text.primary,
      cursor: 'text',
      '&:focus': {
        outline: 0
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        appearance: 'none'
      }
    }, theme.mixins.placeholder({
      color: theme.palette.text.secondary
    })),
    inputBold: Object.assign({}, theme.typography.body2, {
      lineHeight: theme.variables.inputHeight
    }),
    inputCenter: {
      textAlign: 'center'
    },
    inputContent: {
      display: 'flex',
      position: 'relative'
    },
    inputPadding: {
      paddingRight: theme.typography.rhythmByUnit(1),
      paddingLeft: theme.typography.rhythmByUnit(1)
    },
    readOnly: {
      cursor: 'default'
    },
    disabled: {
      color: theme.palette.text.disabled,
      cursor: 'not-allowed'
    },
    border: Object.assign({}, theme.mixins.border({
      '&$disabled': theme.mixins.borderDisabled(),
      '&$error, &$focused': theme.mixins.borderFocused(),
      '&$error': theme.mixins.borderError()
    }), {
      borderRadius: theme.variables.inputBorderRadius
    }),
    inlineActionContainer: {
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'flex-end',
      position: 'relative',
      height: theme.variables.inputHeight,
      cursor: 'pointer'
    },
    inlineAction: {
      height: '100%',
      width: '1em',
      borderRadius: 0,
      fontSize: '1.3em'
    },
    inlineActionBlur: {
      color: theme.palette.text.divider,
      '&:hover': {
        color: 'inherit'
      }
    },
    datalist: {
      top: '100%'
    },
    shadow: {
      resize: 'none',
      // Visibility needed to hide the extra text area on ipads
      visibility: 'hidden',
      position: 'absolute',
      whiteSpace: 'nowrap',
      minWidth: theme.variables.inputHeight,
      maxWidth: '100%',
      width: 'auto',
      paddingRight: theme.variables.borderFocusedWidth, // Offset border-right for IE11
      paddingLeft: theme.variables.borderFocusedWidth // Offset border-left for IE11
    },
    shadowNumber: {
      paddingRight: theme.typography.rhythmByUnit(1),
      paddingLeft: theme.typography.rhythmByUnit(1)
    },
    shadowNumberPlaceholder: {
      paddingRight: theme.typography.rhythmByUnit(2),
      paddingLeft: theme.typography.rhythmByUnit(2)
    },
    shadowTextArea: {
      // Overflow also needed to here to remove the extra row
      // added to textareas in Firefox.
      overflow: 'hidden'
    },
    resize: {
      width: 'auto',
      backgroundColor: 'transparent'
    },
    resizeInput: {
      width: '1em',
      textOverflow: 'ellipsis',
      maxWidth: theme.typography.rhythmByPixel(320),
      boxSizing: 'content-box'
    }
  };
});
/**
 * Input
 */
var Input = (_temp2 = _class = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      updated: false
    }, _this.input = null, _this.focus = function () {
      return _this.input.focus();
    }, _this.selection = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$start = _ref2.start,
          start = _ref2$start === undefined ? 0 : _ref2$start,
          end = _ref2.end;

      _this.input.selectionStart = start;
      _this.input.selectionEnd = end || start;
    }, _this.handleFocus = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.setState({ focused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleBlur = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (_this.hasFocus(event.relatedTarget)) return;
      var isDirty = _this.props.isDirty;

      var updated = _this.state.updated || isDirty(_this.props) || isDirty(_this.input || {});
      _this.setState({ datalist: false, focused: false, updated: updated });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      var onKeyDown = _this.props.onKeyDown;

      if (_this.state.datalist) {
        switch ((0, _keycode2['default'])(event)) {
          case 'down':
            _this.datalist.selectItem();
            return;
        }
      }

      if (onKeyDown) onKeyDown(event);
    }, _this.isDirty = function () {
      var isDirty = _this.props.isDirty;

      return isDirty(_this.props) || isDirty(_this.input || {});
    }, _this.setValue = function (value) {
      if (!_this.isControlled() && _this.input) {
        _this.input.value = value;
      }
      _this.handleChange({ target: { value: value } });
    }, _this.getValue = function (props) {
      return _this.isControlled(props) ? (props || _this.props).value : (_this.input || { value: '' }).value;
    }, _this.getStyle = function () {
      var _this$props = _this.props,
          resize = _this$props.resize,
          inputStyle = _this$props.inputStyle;

      if (!resize) return inputStyle || {};
      var width = _this.state.width;

      return { width: width };
    }, _this.handleResize = function () {
      var _this$props2 = _this.props,
          resize = _this$props2.resize,
          placeholder = _this$props2.placeholder;


      if (!resize) return;

      var value = _this.getValue() || placeholder;

      if (value !== undefined) _this.shadow.innerText = value + '.';

      _this.setState({
        width: _this.shadow.scrollWidth
      });
    }, _this.handleChange = function (event) {
      _this.handleResize(event);
      if (!_this.isControlled()) {
        _this.checkDirty(_this.input);
      }
      var getInputValue = _this.props.getInputValue;

      _this.checkValidity(Object.assign({}, _this.props, { value: getInputValue(_this.input) }));
      _this.checkDatalist();

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _this.id = nextID(), _this.handleDatalistShow = function () {
      _this.setState({ datalist: true, filter: false });
      _this.focus();
      var onDatalistShow = _this.props.onDatalistShow;

      onDatalistShow();
    }, _this.handleDatalistClose = function () {
      _this.setState({ datalist: false });
      _this.focus();
      var onDatalistClose = _this.props.onDatalistClose;

      onDatalistClose();
    }, _this.handleSelectItem = function (e) {
      _this.setValue(e);
      _this.setState({ datalist: false, selected: true, value: e });
      _this.focus();
      var onDatalistSelectItem = _this.props.onDatalistSelectItem;

      onDatalistSelectItem(e);
    }, _this.state = {
      datalist: false,
      filter: true,
      focused: false,
      selected: false,
      updated: false,
      width: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        if (this.isControlled()) {
          this.checkDirty(this.props);
        }
        this.checkValidity();
        this.attach();
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        _context4['default'].clearInterval(this.inputPoller);
        this.detach();
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!this.isControlled()) {
          this.checkDirty(this.input);
        }
        this.checkValidity();

        // React on IE11 has a lot of issues with not firing onChange, including issues
        // with pasting into fields, browser autofill, and password fields.
        // This solution comes from https://github.com/facebook/react/issues/1159#issuecomment-264225754
        var _props = this.props,
            getInputValue = _props.getInputValue,
            component = _props.component; // Used by `FileInput` to provide special `input.value`

        var isFileField = component && component.displayName === 'FileInput';
        this.inputPoller = _context4['default'].setInterval(function () {
          if (!_this2.input || (0, _isEqual2['default'])(_this2._previousValue, getInputValue(_this2.input))) {
            return;
          }
          _this2._previousValue = getInputValue(_this2.input);

          var event = void 0;
          if (typeof _context4['default'].Event === 'function') {
            // eslint-disable-next-line no-undef
            event = new Event('input', {
              bubbles: true,
              cancelable: true
            });
            _this2.input.dispatchEvent(event);
          } else if (typeof _context4['default'].CustomEvent === 'function') {
            _this2.input.addEventListener('inputPoller', _this2.handleChange);
            // eslint-disable-next-line no-undef
            var _event = new CustomEvent('inputPoller', {
              bubbles: true,
              cancelable: true
            });
            if (isFileField) return;
            _this2.input.dispatchEvent(_event);
          } else {
            event = _context4['default'].document.createEvent('Events');
            event.initEvent('input', true, true);
            _this2.input.dispatchEvent(event);
          }
        }, 20);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.isControlled(nextProps)) {
          this.checkDirty(nextProps);
        }
        var getInputValue = this.props.getInputValue;

        this.checkValidity(Object.assign({}, nextProps, { value: getInputValue(this.input) }), nextContext);
      }

      return componentWillUpdate;
    }()

    // Holds the input reference

  }, {
    key: 'attach',
    value: function () {
      function attach() {
        var _context$muiForm = this.context.muiForm;
        _context$muiForm = _context$muiForm === undefined ? {} : _context$muiForm;
        var _context$muiForm$atta = _context$muiForm.attach,
            attach = _context$muiForm$atta === undefined ? function () {} : _context$muiForm$atta;

        return attach(this);
      }

      return attach;
    }()
  }, {
    key: 'detach',
    value: function () {
      function detach() {
        var _context$muiForm2 = this.context.muiForm;
        _context$muiForm2 = _context$muiForm2 === undefined ? {} : _context$muiForm2;
        var _context$muiForm2$det = _context$muiForm2.detach,
            detach = _context$muiForm2$det === undefined ? function () {} : _context$muiForm2$det;

        return detach(this);
      }

      return detach;
    }()
  }, {
    key: 'hasFocus',
    value: function () {
      function hasFocus(el) {
        var currentFocus = el || (0, _activeElement2['default'])((0, _ownerDocument2['default'])(_reactDom2['default'].findDOMNode(this.wrapper))); // eslint-disable-line react/no-find-dom-node
        return currentFocus && this.wrapper && (0, _contains2['default'])(this.wrapper, currentFocus);
      }

      return hasFocus;
    }()
  }, {
    key: 'isControlled',
    value: function () {
      function isControlled(props) {
        return typeof (props || this.props).value === 'string';
      }

      return isControlled;
    }()
  }, {
    key: 'hasControlledErrors',
    value: function () {
      function hasControlledErrors(props, context) {
        var _getPropsWithContext = this.getPropsWithContext(props, context),
            errorProp = _getPropsWithContext.error;

        return !!errorProp;
      }

      return hasControlledErrors;
    }()
  }, {
    key: 'getControlledErrors',
    value: function () {
      function getControlledErrors(props, context) {
        var _getPropsWithContext2 = this.getPropsWithContext(props, context),
            errorProp = _getPropsWithContext2.error,
            errorMessageProp = _getPropsWithContext2.errorMessage;

        return normalizeErrors(errorMessageProp, errorProp);
      }

      return getControlledErrors;
    }()
  }, {
    key: 'getPropsWithContext',
    value: function () {
      function getPropsWithContext(nextProps, nextContext) {
        var props = nextProps || this.props;
        var context = nextContext || this.context;
        var _context$muiFormContr = context.muiFormControl,
            muiFormControl = _context$muiFormContr === undefined ? {} : _context$muiFormContr;

        var value = props.value || (this.input || {}).value;
        return Object.assign({}, muiFormControl, props, { value: value });
      }

      return getPropsWithContext;
    }()
  }, {
    key: 'getErrors',
    value: function () {
      function getErrors(props, context) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var validate = _validators.selectValidators.apply(undefined, args);
        var errors = validate(this.getPropsWithContext(props, context));
        return errors;
      }

      return getErrors;
    }()
  }, {
    key: 'hasError',
    value: function () {
      function hasError() {
        var errorProp = this.props.error;
        var errorState = this.state.error;

        return this.hasControlledErrors() ? errorProp : errorState;
      }

      return hasError;
    }()
  }, {
    key: 'isUpdated',
    value: function () {
      function isUpdated() {
        return this.state.updated;
      }

      return isUpdated;
    }()
  }, {
    key: 'checkValidity',
    value: function () {
      function checkValidity(nextProps, nextContext) {
        var forceDirty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isDirty = this.props.isDirty;

        var props = this.getPropsWithContext(nextProps, nextContext);
        var isUpdated = this.isUpdated();
        var dirty = forceDirty || props.forceDirty || isDirty(props) || isDirty(this.input || {}) || isUpdated;
        // Empty and hasn't been updated
        if (!dirty) return [];

        if (!isUpdated) this.setState({ updated: true });

        var _props$id = props.id,
            id = _props$id === undefined ? this.id : _props$id,
            exactMatch = props.exactMatch,
            required = props.required,
            validator = props.validator,
            type = props.type,
            min = props.min,
            max = props.max;
        var _context = this.context,
            _context$muiFormContr2 = _context.muiFormControl,
            muiFormControl = _context$muiFormContr2 === undefined ? { onValidate: function () {
            function onValidate() {}

            return onValidate;
          }() } : _context$muiFormContr2,
            _context$muiForm3 = _context.muiForm,
            muiForm = _context$muiForm3 === undefined ? { onValidate: function () {
            function onValidate() {}

            return onValidate;
          }() } : _context$muiForm3;


        var email = type === 'email';
        var length = min !== undefined || max !== undefined;

        var controlled = this.hasControlledErrors(nextProps, nextContext);
        var errors = controlled ? this.getControlledErrors(nextProps, nextContext) : this.getErrors(nextProps, nextContext, defaultValidators, {
          required: required,
          email: email,
          exactMatch: exactMatch,
          length: length
        }, validator);

        if (!controlled) {
          var hasErrors = errors.length !== 0;
          if (this.state.error !== hasErrors) {
            this.setState({ error: hasErrors });
          }
        }

        var _props$onValidate = props.onValidate,
            onValidate = _props$onValidate === undefined ? function () {} : _props$onValidate;


        if (this.input) {
          var event = new ValidationEvent(this.input, errors, { id: id });
          onValidate(event);
          if (muiFormControl && muiFormControl.onValidate) {
            muiFormControl.onValidate(event);
          }
          if (muiForm && muiForm.onValidate) {
            muiForm.onValidate(event);
          }
        }

        return errors;
      }

      return checkValidity;
    }()
  }, {
    key: 'checkDirty',
    value: function () {
      function checkDirty(obj) {
        var muiFormControl = this.context.muiFormControl;
        var isDirty = this.props.isDirty;


        if (isDirty(obj)) {
          if (muiFormControl && muiFormControl.onDirty) {
            muiFormControl.onDirty();
          }
          if (this.props.onDirty) {
            this.props.onDirty();
          }
          return;
        }

        if (muiFormControl && muiFormControl.onClean) {
          muiFormControl.onClean();
        }
        if (this.props.onClean) {
          this.props.onClean();
        }
      }

      return checkDirty;
    }()
  }, {
    key: 'isAutoComplete',
    value: function () {
      function isAutoComplete(props) {
        return !!(props || this.props).autoComplete;
      }

      return isAutoComplete;
    }()
  }, {
    key: 'shouldShowDatalist',
    value: function () {
      function shouldShowDatalist(props, state) {
        var _ref3 = props || this.props,
            children = _ref3.children;

        var _ref4 = state || this.state || {},
            focused = _ref4.focused,
            selected = _ref4.selected;

        return !!(this.isAutoComplete(props) && !selected && focused && children);
      }

      return shouldShowDatalist;
    }()
  }, {
    key: 'checkDatalist',
    value: function () {
      function checkDatalist(props) {
        var _this3 = this;

        var value = this.getValue(props);
        var selected = false;
        var filter = true;
        var datalist = this.shouldShowDatalist(props);
        var nextState = { datalist: datalist, selected: selected, value: value, filter: filter };
        var keys = ['datalist', 'filter', 'selected', 'value'];

        if (!keys.every(function (k) {
          return nextState[k] === _this3.state[k];
        })) {
          this.setState(nextState);
        }
      }

      return checkDatalist;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames,
            _classNames2,
            _classNames4,
            _this4 = this;

        var _props2 = this.props,
            children = _props2.children,
            bold = _props2.bold,
            classNameProp = _props2.className,
            ComponentProp = _props2.component,
            center = _props2.center,
            autoCompleteProp = _props2.autoComplete,
            inkbar = _props2.inkbar,
            inlineActionProp = _props2.inlineAction,
            inlineActionContainerClassName = _props2.inlineActionContainerClassName,
            inlineActionClassNameProp = _props2.inlineActionClassName,
            inputClassNameProp = _props2.inputClassName,
            disabled = _props2.disabled,
            errorProp = _props2.error,
            errorMessageProp = _props2.errorMessage,
            exactMatch = _props2.exactMatch,
            findInputNode = _props2.findInputNode,
            focusedProp = _props2.focused,
            fullWidth = _props2.fullWidth,
            forceDirty = _props2.forceDirty,
            placeholder = _props2.placeholder,
            getInputValue = _props2.getInputValue,
            inputStyle = _props2.inputStyle,
            isDirty = _props2.isDirty,
            readOnly = _props2.readOnly,
            requiredProp = _props2.required,
            resize = _props2.resize,
            onDatalistClose = _props2.onDatalistClose,
            onDatalistSelectItem = _props2.onDatalistSelectItem,
            onDatalistShow = _props2.onDatalistShow,
            margin = _props2.margin,
            onBlur = _props2.onBlur,
            onFocus = _props2.onFocus,
            onChange = _props2.onChange,
            onClean = _props2.onClean,
            onDirty = _props2.onDirty,
            onInput = _props2.onInput,
            onKeyDown = _props2.onKeyDown,
            onValidate = _props2.onValidate,
            overlay = _props2.overlay,
            textEntry = _props2.textEntry,
            type = _props2.type,
            underline = _props2.underline,
            validator = _props2.validator,
            value = _props2.value,
            wrapperStyle = _props2.wrapperStyle,
            other = _objectWithoutProperties(_props2, ['children', 'bold', 'className', 'component', 'center', 'autoComplete', 'inkbar', 'inlineAction', 'inlineActionContainerClassName', 'inlineActionClassName', 'inputClassName', 'disabled', 'error', 'errorMessage', 'exactMatch', 'findInputNode', 'focused', 'fullWidth', 'forceDirty', 'placeholder', 'getInputValue', 'inputStyle', 'isDirty', 'readOnly', 'required', 'resize', 'onDatalistClose', 'onDatalistSelectItem', 'onDatalistShow', 'margin', 'onBlur', 'onFocus', 'onChange', 'onClean', 'onDirty', 'onInput', 'onKeyDown', 'onValidate', 'overlay', 'textEntry', 'type', 'underline', 'validator', 'value', 'wrapperStyle']);

        var _context2 = this.context,
            muiFormControl = _context2.muiFormControl,
            muiForm = _context2.muiForm,
            styleManager = _context2.styleManager;
        var _state = this.state,
            datalist = _state.datalist,
            filter = _state.filter,
            focused = _state.focused;

        // Only a literal true should turn on autoComplete

        var autoComplete = autoCompleteProp === true;

        // Turn off system autoComplete if prop is boolean
        var componentAutoComplete = typeof autoCompleteProp === 'boolean' ? 'off' : autoCompleteProp;

        var border = muiForm && underline === undefined || underline;
        var required = requiredProp || muiFormControl && muiFormControl.required === true;
        var isFocused = focused || focusedProp;
        var classes = styleManager.render(styleSheet);
        var wrapperClassName = (0, _classnames2['default'])(classes.wrapper, (_classNames = {}, _defineProperty(_classNames, classes.formControl, muiFormControl && margin), _defineProperty(_classNames, classes.inkbar, inkbar), _defineProperty(_classNames, classes.focused, isFocused), _defineProperty(_classNames, classes.error, this.hasError()), _defineProperty(_classNames, classes.fullWidth, fullWidth), _defineProperty(_classNames, classes.border, border), _defineProperty(_classNames, classes.resize, resize), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.readOnly, readOnly), _classNames), classNameProp);
        var rootInputClassName = (0, _classnames2['default'])(classes.input, (_classNames2 = {}, _defineProperty(_classNames2, classes.inputCenter, center), _defineProperty(_classNames2, classes.inputPadding, border), _defineProperty(_classNames2, classes.inputBold, bold), _defineProperty(_classNames2, classes.disabled, disabled), _defineProperty(_classNames2, classes.readOnly, readOnly), _classNames2), inputClassNameProp);
        var inputClassName = (0, _classnames2['default'])(rootInputClassName, _defineProperty({}, classes.resizeInput, resize));
        var shadowClassName = (0, _classnames2['default'])(classes.shadow, (_classNames4 = {}, _defineProperty(_classNames4, classes.shadowNumber, type === 'number'), _defineProperty(_classNames4, classes.shadowNumberPlaceholder, type === 'number' && placeholder && this.getValue() === ''), _defineProperty(_classNames4, classes.shadowTextArea, ComponentProp === 'textarea'), _classNames4));
        var inlineActionClassName = (0, _classnames2['default'])(classes.inlineAction, _defineProperty({}, classes.inlineActionBlur, !isFocused));
        var inlineAction = _react2['default'].isValidElement(inlineActionProp) && _react2['default'].cloneElement(inlineActionProp, {
          className: (0, _classnames2['default'])(inlineActionClassName, inlineActionClassNameProp, inlineActionProp.props.className)
        });
        var style = this.getStyle();
        var datalistValue = filter ? this.getValue() : '';
        var isEditable = !disabled && !readOnly;

        return _react2['default'].createElement(
          'div',
          {
            className: wrapperClassName,
            ref: function () {
              function ref(c) {
                return _this4.wrapper = c;
              }

              return ref;
            }(),
            style: wrapperStyle
          },
          _react2['default'].createElement(
            'div',
            { className: classes.inputContent },
            _react2['default'].createElement(ComponentProp, _extends({
              'aria-required': required ? true : undefined,
              autoComplete: componentAutoComplete,
              className: inputClassName,
              onBlur: this.handleBlur,
              onChange: this.handleChange,
              onInput: onInput || this.handleChange,
              onFocus: this.handleFocus,
              onKeyDown: this.handleKeyDown,
              readOnly: readOnly || !textEntry,
              ref: function () {
                function ref(c) {
                  return _this4.input = findInputNode(c);
                }

                return ref;
              }()
            }, Object.assign({
              disabled: disabled,
              placeholder: placeholder,
              style: style,
              type: type,
              value: value
            }, other))),
            _react2['default'].createElement(
              'div',
              {
                className: (0, _classnames2['default'])(classes.inlineActionContainer, inlineActionContainerClassName)
              },
              isEditable && inlineAction,
              isEditable && !!children && !datalist && autoComplete && _react2['default'].createElement(
                _IconButton2['default'],
                {
                  className: inlineActionClassName,
                  onClick: this.handleDatalistShow,
                  tabIndex: '-1'
                },
                _react2['default'].createElement(_ArrowDropDown2['default'], null)
              ),
              isEditable && !!children && datalist && autoComplete && _react2['default'].createElement(
                _IconButton2['default'],
                {
                  className: inlineActionClassName,
                  onClick: this.handleDatalistClose,
                  tabIndex: '-1'
                },
                _react2['default'].createElement(_ArrowDropUp2['default'], null)
              )
            ),
            overlay,
            _react2['default'].createElement('span', { ref: function () {
                function ref(el) {
                  return _this4.shadow = el;
                }

                return ref;
              }(), className: shadowClassName })
          ),
          _react2['default'].createElement(
            _InputDataList2['default'],
            {
              ref: function () {
                function ref(c) {
                  return _this4.datalist = c;
                }

                return ref;
              }(),
              anchorEl: this.wrapper,
              className: classes.datalist,
              open: datalist,
              value: datalistValue,
              onSelectItem: this.handleSelectItem
            },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return Input;
}(_react.Component), _class.displayName = 'Input', _class.propTypes = {
  /**
   * If 'true', input text will show autoComplete list
   */
  autoComplete: _PropTypes2['default'].oneOfType([_PropTypes2['default'].bool, _PropTypes2['default'].string]),
  bold: _PropTypes2['default'].bool,
  /**
   * If 'true', input text will be centered in input area
   */
  center: _PropTypes2['default'].bool,
  /**
   * Datalist children for autocompletion.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the wrapper element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The element or component used for the root node.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  disabled: _PropTypes2['default'].bool,
  error: _PropTypes2['default'].oneOfType([_PropTypes2['default'].bool, _PropTypes2['default'].string, _PropTypes2['default'].arrayOf(_PropTypes2['default'].string)]),
  errorMessage: _PropTypes2['default'].string,
  /**
   * If 'true', input must match value of datalist item. Only valid
   * if datalist values have been specified
   */
  exactMatch: _PropTypes2['default'].bool,
  /**
   * findInputNode: The func used to select an `input` node from the ref func
   */
  findInputNode: _PropTypes2['default'].func,
  /**
   * Whether the input should be displayed in a focused state.
   */
  focused: _PropTypes2['default'].bool,
  forceDirty: _PropTypes2['default'].bool,
  /**
   * If 'true', input will be expanded to full width
   */
  fullWidth: _PropTypes2['default'].bool,
  getInputValue: _PropTypes2['default'].func,
  inputStyle: _PropTypes2['default'].shape({ width: _PropTypes2['default'].number }),
  /**
   * If set to true, the input will have an inkbar.
   */
  inkbar: _PropTypes2['default'].bool,
  /**
   * A component representing one or more actions shown to the right of the field
   */
  inlineAction: _PropTypes2['default'].node,
  /**
   * The CSS class name of the inline action.
   */
  inlineActionClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the inline action container.
   */
  inlineActionContainerClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the input element.
   */
  inputClassName: _PropTypes2['default'].string,
  /**
   * isDirty: A func used to determine, based on `this.props`, if an `input` is dirty
   */
  isDirty: _PropTypes2['default'].func,
  /**
   * If true and context is muiFormControl then vertical margin applied
   */
  margin: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  onBlur: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onChange: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onClean: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onDirty: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onFocus: _PropTypes2['default'].func,
  /**
   * Called when datalist should be closed
   */
  onDatalistClose: _PropTypes2['default'].func,
  /**
   * Called when datalist should be shown
   */
  onDatalistShow: _PropTypes2['default'].func,
  /**
   * Called when datalist item has been selected
   */
  onDatalistSelectItem: _PropTypes2['default'].func,
  onKeyDown: _PropTypes2['default'].func,
  onInput: _PropTypes2['default'].func,
  /**
   * Called when input is validated
   */
  onValidate: _PropTypes2['default'].func,
  /**
   * Component used to represent the input value
   */
  overlay: _PropTypes2['default'].node,
  placeholder: _PropTypes2['default'].string,
  readOnly: _PropTypes2['default'].bool,
  /**
   * Dynamically resize input.
   */
  resize: _PropTypes2['default'].bool,
  required: _PropTypes2['default'].bool,
  /**
   * Whether text entry is permitted
   */
  textEntry: _PropTypes2['default'].bool,
  /**
   * Input type.
   */
  type: _PropTypes2['default'].string,
  /**
   * If set to true, the input will have a border.
   */
  underline: _PropTypes2['default'].bool,
  /**
   * Function that validates the current value
   */
  validator: _PropTypes2['default'].func,
  /**
   * The input value, required for a controlled component.
   */
  value: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].array]),
  wrapperStyle: _PropTypes2['default'].object
}, _class.defaultProps = {
  autoComplete: true,
  component: 'input',
  exactMatch: false,
  findInputNode: function () {
    function findInputNode(c) {
      return c;
    }

    return findInputNode;
  }(),
  getInputValue: function () {
    function getInputValue(i) {
      return i ? i.value : null;
    }

    return getInputValue;
  }(),
  isDirty: function () {
    function isDirty(obj) {
      return obj && obj.value && obj.value.length > 0;
    }

    return isDirty;
  }(),
  onDatalistClose: function () {
    function onDatalistClose() {}

    return onDatalistClose;
  }(),
  onDatalistSelectItem: function () {
    function onDatalistSelectItem() {}

    return onDatalistSelectItem;
  }(),
  onDatalistShow: function () {
    function onDatalistShow() {}

    return onDatalistShow;
  }(),
  margin: true,
  textEntry: true,
  type: 'text',
  inkbar: false
}, _class.contextTypes = {
  muiFormControl: _PropTypes2['default'].object,
  muiForm: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Input;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(423),
    equalArrays = __webpack_require__(1657),
    equalByTag = __webpack_require__(1659),
    equalObjects = __webpack_require__(1660),
    getTag = __webpack_require__(424),
    isArray = __webpack_require__(70),
    isBuffer = __webpack_require__(425),
    isTypedArray = __webpack_require__(634);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1652 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(239);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(239);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(239);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(239);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(774),
    arraySome = __webpack_require__(1658),
    cacheHas = __webpack_require__(775);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1658 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1659 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(832);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBoolean;

var _assertString = __webpack_require__(142);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBoolean(str) {
  (0, _assertString2.default)(str);
  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
}
module.exports = exports['default'];

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__(142);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(635);

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__(1663);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__(1664);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__(142);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;

var _assertString = __webpack_require__(142);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(635);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isLength;

var _assertString = __webpack_require__(142);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  var len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(636),
    getPrototype = __webpack_require__(836),
    isObjectLike = __webpack_require__(426);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matches;

var _assertString = __webpack_require__(142);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matches(str, pattern, modifiers) {
  (0, _assertString2.default)(str);
  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
    pattern = new RegExp(pattern, modifiers);
  }
  return pattern.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _scrollbarSize = __webpack_require__(238);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _Popover = __webpack_require__(1669);

var _Popover2 = _interopRequireDefault(_Popover);

var _ = __webpack_require__(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Menu', function (theme) {
  return {
    popover: {
      maxHeight: theme.typography.rhythmByUnit(9 * 4.75)
    },
    noScrollbar: {
      '-ms-overflow-style': 'none'
    }
  };
});

var Menu = (_temp2 = _class = function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.menuList = undefined, _this.focusMenuList = function () {
      var list = (0, _reactDom.findDOMNode)(_this.menuList); // eslint-disable-line react/no-find-dom-node

      if (_this.menuList && _this.menuList.selectedItem) {
        (0, _reactDom.findDOMNode)(_this.menuList.selectedItem).focus(); // eslint-disable-line react/no-find-dom-node
      } else if (list && list.firstChild) {
        list.firstChild.focus();
      }
    }, _this.handleEnter = function (element) {
      var autoFocus = _this.props.autoFocus;


      if (autoFocus) {
        _this.focusMenuList();
      }

      var list = (0, _reactDom.findDOMNode)(_this.menuList); // eslint-disable-line react/no-find-dom-node

      if (list && element.clientHeight < list.clientHeight) {
        var size = (0, _scrollbarSize2['default'])() + 'px';
        list.style.paddingTop = 0;
        list.style.paddingRight = size;
        list.style.paddingBottom = 0;
        list.style.width = 'calc(100% + ' + size + ')';
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleListKeyDown = function (event, key) {
      if (key === 'tab' || key === 'esc') {
        return _this.props.onRequestClose();
      }

      return false;
    }, _this.getContentAnchorEl = function () {
      if (!_this.menuList || !_this.menuList.selectedItem) {
        return (0, _reactDom.findDOMNode)(_this.menuList).firstChild; // eslint-disable-line react/no-find-dom-node
      }

      return (0, _reactDom.findDOMNode)(_this.menuList.selectedItem); // eslint-disable-line react/no-find-dom-node
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Menu, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames,
            _this2 = this;

        var _props = this.props,
            anchorEl = _props.anchorEl,
            autoComplete = _props.autoComplete,
            children = _props.children,
            className = _props.className,
            disableMaxHeight = _props.disableMaxHeight,
            fullWidth = _props.fullWidth,
            anchorInnerElement = _props.anchorInnerElement,
            listProps = _props.listProps,
            modal = _props.modal,
            open = _props.open,
            onEnter = _props.onEnter,
            onEntering = _props.onEntering,
            onEntered = _props.onEntered,
            onExit = _props.onExit,
            onExiting = _props.onExiting,
            onExited = _props.onExited,
            onRequestClose = _props.onRequestClose,
            onSelectItem = _props.onSelectItem,
            popoverClassNameProp = _props.popoverClassName,
            popoverProps = _props.popoverProps,
            scrollbar = _props.scrollbar,
            transitionDuration = _props.transitionDuration,
            other = _objectWithoutProperties(_props, ['anchorEl', 'autoComplete', 'children', 'className', 'disableMaxHeight', 'fullWidth', 'anchorInnerElement', 'listProps', 'modal', 'open', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'onRequestClose', 'onSelectItem', 'popoverClassName', 'popoverProps', 'scrollbar', 'transitionDuration']);

        var classes = this.context.styleManager.render(styleSheet);
        var popoverClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, classes.popover, !disableMaxHeight), _defineProperty(_classNames, classes.noScrollbar, !scrollbar), _classNames), popoverClassNameProp);

        var allListProps = Object.assign({}, listProps, other);

        return _react2['default'].createElement(
          _Popover2['default'],
          _extends({
            anchorEl: anchorEl,
            autoComplete: autoComplete,
            className: popoverClassName,
            getContentAnchorEl: anchorInnerElement ? this.getContentAnchorEl : null,
            open: open,
            modal: modal,
            enteredClassName: classes.entered,
            fullWidth: fullWidth,
            onEnter: this.handleEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExiting: onExiting,
            onExit: onExit,
            onExited: onExited,
            onMouseDown: function () {
              function onMouseDown(e) {
                return e.preventDefault();
              }

              return onMouseDown;
            }(),
            onRequestClose: onRequestClose,
            ref: function () {
              function ref(c) {
                _this2.Popover = c;
              }

              return ref;
            }(),
            transitionDuration: transitionDuration
          }, popoverProps),
          _react2['default'].createElement(
            _.MenuList,
            _extends({
              'data-mui-test': 'Menu',
              role: 'menu',
              ref: function () {
                function ref(c) {
                  _this2.menuList = c;
                }

                return ref;
              }(),
              onKeyDown: this.handleListKeyDown,
              onSelectItem: onSelectItem,
              className: className
            }, allListProps),
            children
          )
        );
      }

      return render;
    }()
  }]);

  return Menu;
}(_react.Component), _class.propTypes = {
  /**
   * This is the DOM element that will be
   * used to set the position of the menu.
   */
  anchorEl: _PropTypes2['default'].object,
  /**
   * If false, `Menu` won't pass `this.getContentAnchorEl` to `Popover`
   */
  anchorInnerElement: _PropTypes2['default'].bool,
  /**
   * If `true`, the menu is part of an AutoComplete component
   */
  autoComplete: _PropTypes2['default'].bool,
  /**
   * If `true`, the menu will autofocus its contents upon entering
   */
  autoFocus: _PropTypes2['default'].bool,
  /**
   * Menu contents, should be menu items.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, there will be no maxHeight applied
   */
  disableMaxHeight: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  fullWidth: _PropTypes2['default'].bool,
  /**
   * The list element props
   */
  listProps: _PropTypes2['default'].object,
  /**
   * Callback fired before the Menu is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the Menu is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback function fired when the menu is requested to be closed.
   *
   * @param {event} event The event that triggered the close request
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onSelectItem: _PropTypes2['default'].func,
  /**
   * If `true`, the menu is visible.
   */
  open: _PropTypes2['default'].bool,
  /**
   * The CSS class name of the root element.
   */
  popoverClassName: _PropTypes2['default'].string,
  /**
   * The root element props
   */
  popoverProps: _PropTypes2['default'].object,
  /**
   * Boolean toggling the use of a modal for the menu's popover
   */
  modal: _PropTypes2['default'].bool,
  /**
   * If `true`, there will be scrollbars
   */
  scrollbar: _PropTypes2['default'].bool,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _PropTypes2['default'].oneOfType([_PropTypes2['default'].number, _PropTypes2['default'].string])
}, _class.defaultProps = {
  anchorInnerElement: false,
  autoFocus: true,
  disableMaxHeight: false,
  modal: true,
  onRequestClose: function () {
    function onRequestClose() {}

    return onRequestClose;
  }(),
  open: false,
  transitionDuration: 'auto',
  scrollbar: true
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager
}, _temp2);
exports['default'] = Menu;


Menu.displayName = 'Menu';

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _contains = __webpack_require__(121);

var _contains2 = _interopRequireDefault(_contains);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _context = __webpack_require__(93);

var _context2 = _interopRequireDefault(_context);

var _jssThemeReactor = __webpack_require__(6);

var _Modal = __webpack_require__(366);

var _Modal2 = _interopRequireDefault(_Modal);

var _Paper = __webpack_require__(150);

var _Paper2 = _interopRequireDefault(_Paper);

var _Transition = __webpack_require__(265);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getOffsetTop(_ref, vertical) {
  var height = _ref.height;

  if (vertical instanceof Function) {
    return vertical(height);
  }

  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = height / 2;
  } else if (vertical === 'bottom') {
    offset = height;
  }

  return offset;
}

function getOffsetLeft(_ref2, horizontal) {
  var width = _ref2.width;

  if (horizontal instanceof Function) {
    return horizontal(width);
  }

  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = width / 2;
  } else if (horizontal === 'right') {
    offset = width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? n + 'px' : n;
  }).join(' ');
}

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Popover', function (theme) {
  return {
    popover: {
      position: 'absolute',
      overflowY: 'auto',
      overflowX: 'hidden',
      zIndex: theme.zIndex.popover,
      '&:focus': {
        outline: 'none'
      }
    },
    fullWidth: {
      width: '100%',
      left: '0px'
    }
  };
});

var Popover = (_temp2 = _class = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref3, [this].concat(args))), _this), _this.autoTransitionDuration = undefined, _this.handleEnter = function (element) {
      element.style.opacity = 0;
      element.style.transform = Popover.getScale(0.75);

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      var positioning = _this.getPositioningStyle(element);

      element.style.top = positioning.top;
      element.style.left = positioning.left;
      element.style.transformOrigin = positioning.transformOrigin;

      _this.element = element;

      var transitionDuration = _this.props.transitionDuration;
      var transitions = _this.context.styleManager.theme.transitions;


      if (transitionDuration === 'auto') {
        transitionDuration = transitions.getAutoHeightDuration(element.clientHeight);
        _this.autoTransitionDuration = transitionDuration;
      }

      element.style.transition = [transitions.create('opacity', {
        duration: transitionDuration
      }), transitions.create('transform', {
        duration: transitionDuration * 0.666
      })].join(',');
    }, _this.handleEntering = function (element) {
      element.style.opacity = 1;
      element.style.transform = Popover.getScale(1);

      if (_this.props.onEntering) {
        _this.props.onEntering();
      }
    }, _this.handleExit = function (element) {
      var transitionDuration = _this.props.transitionDuration;
      var transitions = _this.context.styleManager.theme.transitions;


      if (transitionDuration === 'auto') {
        transitionDuration = transitions.getAutoHeightDuration(element.clientHeight);
        _this.autoTransitionDuration = transitionDuration;
      }

      element.style.transition = [transitions.create('opacity', {
        duration: transitionDuration
      }), transitions.create('transform', {
        duration: transitionDuration * 0.666,
        delay: transitionDuration * 0.333
      })].join(',');

      element.style.opacity = 0;
      element.style.transform = Popover.getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit();
      }
    }, _this.handleRequestTimeout = function () {
      if (_this.props.transitionDuration === 'auto') {
        return (_this.autoTransitionDuration || 0) + 20;
      }
      return _this.props.transitionDuration + 20;
    }, _this.setStyleForAutoComplete = function (element, style, anchor) {
      var offSetWidths = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      var ANCHOR_TO_POPOVER_GUTTER = 5;
      var POPOVER_TO_SCREEN_EDGE_GUTTER = 20;
      var MIN_CONSTRAINED_HEIGHT_BEFORE_OPEN_UP = 100;

      // add 4 * spacing unit to account for padding on menuItems
      var maxWidth = Math.max.apply(Math, _toConsumableArray(offSetWidths)) + (!_this.props.fullWidth ? _this.context.styleManager.theme.spacing.unit * 4 : 0);

      var anchorRect = anchor ? anchor.getBoundingClientRect() : {};
      var bodyRect = _context2['default'].document.body.getBoundingClientRect();
      var popoverHeight = void 0,
          popoverWidth = void 0,
          popoverTop = void 0,
          popoverBottom = void 0,
          popoverLeft = void 0;
      popoverWidth = Math.max(maxWidth, anchorRect.width);
      popoverTop = anchorRect.top + anchorRect.height + ANCHOR_TO_POPOVER_GUTTER;
      popoverLeft = anchorRect.left;
      if (anchorRect.bottom + element.clientHeight + POPOVER_TO_SCREEN_EDGE_GUTTER !== bodyRect.height) {
        popoverHeight = bodyRect.height - anchorRect.bottom - POPOVER_TO_SCREEN_EDGE_GUTTER;
        if (popoverHeight < MIN_CONSTRAINED_HEIGHT_BEFORE_OPEN_UP) {
          if (anchorRect.top <= element.clientHeight) {
            popoverHeight = anchorRect.top - POPOVER_TO_SCREEN_EDGE_GUTTER;
          } else {
            popoverHeight = element.clientHeight;
          }
          popoverTop = null;
          popoverBottom = bodyRect.height - anchorRect.top + ANCHOR_TO_POPOVER_GUTTER;
        }
      } else {
        popoverHeight = element.clientHeight;
      }

      if (popoverWidth > bodyRect.width) {
        popoverWidth = bodyRect.width;
        popoverLeft = 0;
      } else if (popoverLeft + popoverWidth > bodyRect.width) {
        popoverLeft = bodyRect.width - popoverWidth;
      }

      style.position = 'fixed';
      style.top = popoverTop ? popoverTop + 'px' : null;
      style.bottom = popoverBottom ? popoverBottom + 'px' : null;
      style.left = popoverLeft + 'px';
      style.width = popoverWidth + 'px';
      style.maxHeight = popoverHeight + 'px';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.handleAutoComplete();
      }

      return componentDidMount;
    }()
  }, {
    key: 'handleAutoComplete',
    value: function () {
      function handleAutoComplete() {
        var _props = this.props,
            anchorEl = _props.anchorEl,
            autoComplete = _props.autoComplete;

        if (autoComplete && this.element) {
          var menuItemSpanWidths = [].concat(_toConsumableArray(this.element.querySelectorAll('span'))).map(function (ele) {
            return parseFloat(_context2['default'].getComputedStyle(ele, null).getPropertyValue('width'));
          });
          this.setStyleForAutoComplete(this.element, this.element.style, anchorEl, menuItemSpanWidths);
        }
      }

      return handleAutoComplete;
    }()
  }, {
    key: 'getPositioningStyle',
    value: function () {
      function getPositioningStyle(element) {
        var fullWidth = this.props.fullWidth;

        // Check if the parent has requested anchoring on an inner content node

        var contentAnchorOffset = this.getContentAnchorOffset(element);
        // Get the offset of of the anchoring element
        var anchorOffset = this.getAnchorOffset(contentAnchorOffset);

        var elemRect = {
          width: element.clientWidth,
          height: element.clientHeight
        };
        // Get the transform origin point on the element itself
        var transformOrigin = this.getTransformOrigin(elemRect, contentAnchorOffset);

        // Calculate element positioning
        var top = anchorOffset.top - transformOrigin.vertical;
        var left = anchorOffset.left - transformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width;

        // Window (context) thresholds taking required margin into account
        var marginThreshold = 16;
        var heightThreshold = _context2['default'].innerHeight - marginThreshold;
        var widthThreshold = _context2['default'].innerWidth - marginThreshold;

        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
          var diff = top - marginThreshold;
          top -= diff;
          transformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
          var _diff = bottom - heightThreshold;
          top -= _diff;
          transformOrigin.vertical += _diff;
        }

        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
          var _diff2 = left - marginThreshold;
          left -= _diff2;
          transformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
          var _diff3 = right - widthThreshold;
          left -= _diff3;
          transformOrigin.horizontal += _diff3;
        }

        return {
          top: top + 'px',
          left: (fullWidth ? 0 : left) + 'px',
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      }

      return getPositioningStyle;
    }()
  }, {
    key: 'getAnchorOffset',


    /**
     * Returns the top/left offset of the position
     * to attach to on the anchor element (or body if none is provided)
     */
    value: function () {
      function getAnchorOffset(contentAnchorOffset) {
        var _props2 = this.props,
            anchorElProp = _props2.anchorEl,
            anchorOrigin = _props2.anchorOrigin,
            parentEl = _props2.parentEl;


        var anchorEl = anchorElProp || document.body;
        var anchorRect = anchorEl.getBoundingClientRect();
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';

        /**
         * Top anchorOffset needs to be defined relative to top of content window, not viewport
         * Without this adjustment, popover will erroneously anchor its content when inside of a modal
         */
        var topToParent = parentEl ? parentEl.getBoundingClientRect().top - 8 : 0;

        return {
          top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical) - topToParent,
          left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
      }

      return getAnchorOffset;
    }()

    /**
     * Returns the vertical offset of inner
     * content to anchor the transform on if provided
     */

  }, {
    key: 'getContentAnchorOffset',
    value: function () {
      function getContentAnchorOffset(element) {
        var contentAnchorOffset = 0;

        if (this.props.getContentAnchorEl) {
          var contentAnchorEl = this.props.getContentAnchorEl(element);
          if (contentAnchorEl && (0, _contains2['default'])(element, contentAnchorEl)) {
            contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 || 0;
          }
        }

        return contentAnchorOffset;
      }

      return getContentAnchorOffset;
    }()

    /**
     * Return the base transform origin using the element
     * and taking the content anchor offset into account if in use
     */

  }, {
    key: 'getTransformOrigin',
    value: function () {
      function getTransformOrigin(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var transformOrigin = this.props.transformOrigin;

        return {
          vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
          horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
      }

      return getTransformOrigin;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props3 = this.props,
            anchorEl = _props3.anchorEl,
            anchorOrigin = _props3.anchorOrigin,
            autoComplete = _props3.autoComplete,
            children = _props3.children,
            className = _props3.className,
            elevation = _props3.elevation,
            enteredClassName = _props3.enteredClassName,
            enteringClassName = _props3.enteringClassName,
            exitedClassName = _props3.exitedClassName,
            exitingClassName = _props3.exitingClassName,
            getContentAnchorEl = _props3.getContentAnchorEl,
            fullWidth = _props3.fullWidth,
            modal = _props3.modal,
            onRequestClose = _props3.onRequestClose,
            open = _props3.open,
            onEnter = _props3.onEnter,
            onEntering = _props3.onEntering,
            onEntered = _props3.onEntered,
            onExit = _props3.onExit,
            onExiting = _props3.onExiting,
            onExited = _props3.onExited,
            parentEl = _props3.parentEl,
            role = _props3.role,
            transformOrigin = _props3.transformOrigin,
            transitionDuration = _props3.transitionDuration,
            other = _objectWithoutProperties(_props3, ['anchorEl', 'anchorOrigin', 'autoComplete', 'children', 'className', 'elevation', 'enteredClassName', 'enteringClassName', 'exitedClassName', 'exitingClassName', 'getContentAnchorEl', 'fullWidth', 'modal', 'onRequestClose', 'open', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'parentEl', 'role', 'transformOrigin', 'transitionDuration']);

        var classes = this.context.styleManager.render(styleSheet);
        var popoverClasses = (0, _classnames2['default'])(classes.popover, className, fullWidth ? classes.fullWidth : null);

        var popoverComponent = _react2['default'].createElement(
          _Transition2['default'],
          {
            'in': open,
            enteredClassName: enteredClassName,
            enteringClassName: enteringClassName,
            exitedClassName: exitedClassName,
            exitingClassName: exitingClassName,
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: onEntered,
            onExit: this.handleExit,
            onExiting: onExiting,
            onExited: onExited,
            role: role,
            onRequestTimeout: this.handleRequestTimeout,
            transitionAppear: true
          },
          _react2['default'].createElement(
            _Paper2['default'],
            _extends({
              'data-mui-test': 'Popover',
              className: popoverClasses,
              elevation: elevation
            }, other),
            children
          )
        );

        var componentToRender = modal ? _react2['default'].createElement(
          _Modal2['default'],
          {
            show: open,
            backdropVisible: false,
            onRequestClose: onRequestClose
          },
          popoverComponent
        ) : popoverComponent;

        return componentToRender;
      }

      return render;
    }()
  }], [{
    key: 'getScale',
    value: function () {
      function getScale(value) {
        return 'scale(' + value + ', ' + Math.pow(value, 2) + ')';
      }

      return getScale;
    }()
  }]);

  return Popover;
}(_react.Component), _class.propTypes = {
  /**
   * This is the DOM element that will be used
   * to set the position of the popover.
   */
  anchorEl: _PropTypes2['default'].object,
  /**
   * This is the point on the anchor where the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: ['top', 'center', 'bottom', x (px), fn(height) -> x (px)]
   * horizontal: ['left', 'center', 'right', x (px), fn(width) -> x (px)]
   */
  anchorOrigin: _PropTypes2['default'].origin,
  /**
   * If `true`, the popover is part of an AutoComplete component
   */
  autoComplete: _PropTypes2['default'].bool,
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * CSS class or classes applied when the component is entered
   */
  elevation: _PropTypes2['default'].number,
  enteredClassName: _PropTypes2['default'].string,
  /**
   * CSS class or classes applied while the component is entering
   */
  enteringClassName: _PropTypes2['default'].string,
  /**
   * CSS class or classes applied when the component is exited
   */
  exitedClassName: _PropTypes2['default'].string,
  /**
   * CSS class or classes applied while the component is exiting
   */
  exitingClassName: _PropTypes2['default'].string,
  /**
   * If `true`, the Popover will be full anchor width
   */
  fullWidth: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  getContentAnchorEl: _PropTypes2['default'].func,
  /**
   * If `true`, the Popover will be rendered as a modal with
   * scroll locking, focus trapping and a clickaway layer beneath
   */
  modal: _PropTypes2['default'].bool,
  /**
   * Callback fired before the component is entering
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the component is entering
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the component has entered
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the component is exiting
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the component is exiting
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the component has exited
   */
  onExited: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback function fired when the popover is requested to be closed.
   *
   * @param {event} event The event that triggered the close request
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * If `true`, the popover is visible.
   */
  open: _PropTypes2['default'].bool,
  /**
   * Reference to a parent element (used when anchorEl needs to be considered relative to a parentEl)
   */
  parentEl: _PropTypes2['default'].object,
  role: _PropTypes2['default'].string,
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: ['top', 'center', 'bottom', x (px), fn(height) -> x (px)]
   * horizontal: ['left', 'center', 'right', x (px), fn(width) -> x (px)]
   */
  transformOrigin: _PropTypes2['default'].origin,
  /**
   * Set to 'auto' to automatically calculate transition time based on height
   */
  transitionDuration: _PropTypes2['default'].oneOfType([_PropTypes2['default'].number, _PropTypes2['default'].string])
}, _class.defaultProps = {
  anchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  elevation: 8,
  fullWidth: false,
  modal: true,
  open: false,
  parentEl: null,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  transitionDuration: 'auto'
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Popover;


Popover.displayName = 'Popover';

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _ListItem = __webpack_require__(369);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('MenuItem', function (theme) {
  var palette = theme.palette,
      typography = theme.typography,
      transitions = theme.transitions;

  return {
    root: theme.mixins.truncate(Object.assign({}, typography.body1, {
      paddingTop: 0,
      paddingBottom: 0,
      height: typography.rhythmByUnit(5),
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      transition: transitions.create('background-color', {
        duration: transitions.duration.short
      }),
      '&:focus, &:hover': {
        backgroundColor: palette.accent['200']
      }
    })),
    selected: {
      backgroundColor: palette.text.divider
    }
  };
});

var MenuItem = (_temp = _class = function (_PureComponent) {
  _inherits(MenuItem, _PureComponent);

  function MenuItem() {
    _classCallCheck(this, MenuItem);

    return _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));
  }

  _createClass(MenuItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            component = _props.component,
            selected = _props.selected,
            role = _props.role,
            other = _objectWithoutProperties(_props, ['className', 'component', 'selected', 'role']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.selected, selected), classNameProp);
        var listItemProps = {};

        if (!component) {
          listItemProps.ripple = false;
        }

        return _react2['default'].createElement(_ListItem2['default'], _extends({
          button: true,
          selected: true,
          tabIndex: '-1'
        }, Object.assign({ className: className, component: component, role: role }, listItemProps, other)));
      }

      return render;
    }()
  }]);

  return MenuItem;
}(_react.PureComponent), _class.muiName = 'MenuItem', _class.propTypes = {
  /**
   * Menu item contents.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * @ignore
   */
  role: _PropTypes2['default'].string,
  /**
   * Use to apply selected styling.
   */
  selected: _PropTypes2['default'].bool
}, _class.defaultProps = {
  role: 'menuitem',
  selected: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = MenuItem;


MenuItem.displayName = 'MenuItem';

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _activeElement = __webpack_require__(196);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = __webpack_require__(122);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _contains = __webpack_require__(121);

var _contains2 = _interopRequireDefault(_contains);

var _keycode = __webpack_require__(147);

var _keycode2 = _interopRequireDefault(_keycode);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _List = __webpack_require__(69);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuList = (_temp2 = _class = function (_Component) {
  _inherits(MenuList, _Component);

  function MenuList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuList.__proto__ || Object.getPrototypeOf(MenuList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTabIndex: undefined
    }, _this.list = undefined, _this.selectedItem = undefined, _this.blurTimer = undefined, _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.list) {
          var list = (0, _reactDom.findDOMNode)(_this.list); // eslint-disable-line react/no-find-dom-node
          var currentFocus = (0, _activeElement2['default'])((0, _ownerDocument2['default'])(list));
          if (!(0, _contains2['default'])(list, currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      if (!_this.list) {
        return;
      }

      var list = (0, _reactDom.findDOMNode)(_this.list); // eslint-disable-line react/no-find-dom-node
      if (!list) {
        return;
      }

      var key = (0, _keycode2['default'])(event);
      var currentFocus = (0, _activeElement2['default'])((0, _ownerDocument2['default'])(list));
      event.preventDefault();

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !(0, _contains2['default'])(list, currentFocus))) {
        if (_this.selectedItem) {
          (0, _reactDom.findDOMNode)(_this.selectedItem).focus(); // eslint-disable-line react/no-find-dom-node
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();
        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();
        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key, currentFocus);
      }
    }, _this.handleItemFocus = function (event) {
      if (!_this.list) {
        return;
      }

      var list = (0, _reactDom.findDOMNode)(_this.list); // eslint-disable-line react/no-find-dom-node
      if (list && list.children) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);
            break;
          }
        }
      }
    }, _this.setTabIndex = function (n) {
      var tabIndex = _this.props.tabIndex;

      if (tabIndex < 0) return;
      _this.setState({ currentTabIndex: n });
    }, _this.makeChildProps = function (child, index) {
      var currentTabIndex = _this.state.currentTabIndex;
      var onSelectItem = _this.props.onSelectItem;


      var childProps = {
        tabIndex: index === currentTabIndex ? '0' : '-1',
        ref: child.props.selected ? function (c) {
          _this.selectedItem = c;
        } : undefined,
        onFocus: function () {
          function onFocus(e) {
            return _this.handleItemFocus(e);
          }

          return onFocus;
        }()
      };

      if (onSelectItem) {
        childProps.onClick = onSelectItem;
      }

      return childProps;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuList, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.resetTabIndex();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        clearTimeout(this.blurTimer);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'focus',
    value: function () {
      function focus() {
        var currentTabIndex = this.state.currentTabIndex;


        if (!this.list) {
          return;
        }

        var list = (0, _reactDom.findDOMNode)(this.list); // eslint-disable-line react/no-find-dom-node
        if (!list || !list.children) {
          return;
        }

        if (currentTabIndex && currentTabIndex >= 0) {
          list.children[currentTabIndex].focus();
        } else {
          list.firstChild.focus();
        }
      }

      return focus;
    }()
  }, {
    key: 'resetTabIndex',
    value: function () {
      function resetTabIndex() {
        if (!this.list) {
          return;
        }

        var list = (0, _reactDom.findDOMNode)(this.list); // eslint-disable-line react/no-find-dom-node
        if (!list || !list.children) {
          return;
        }

        var currentFocus = (0, _activeElement2['default'])((0, _ownerDocument2['default'])(list));
        var items = [].concat(_toConsumableArray(list.children));
        var currentFocusIndex = items.indexOf(currentFocus);

        if (currentFocusIndex !== -1) {
          return this.setTabIndex(currentFocusIndex);
        }

        if (this.selectedItem) {
          return this.setTabIndex(items.indexOf((0, _reactDom.findDOMNode)(this.selectedItem))); // eslint-disable-line react/no-find-dom-node
        }

        return this.setTabIndex(0);
      }

      return resetTabIndex;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            children = _props.children,
            className = _props.className,
            onBlur = _props.onBlur,
            onKeyDown = _props.onKeyDown,
            onSelectItem = _props.onSelectItem,
            other = _objectWithoutProperties(_props, ['children', 'className', 'onBlur', 'onKeyDown', 'onSelectItem']);

        return _react2['default'].createElement(
          _List2['default'],
          _extends({
            'data-mui-test': 'MenuList',
            role: 'menu',
            rootRef: function () {
              function rootRef(c) {
                _this2.list = c;
              }

              return rootRef;
            }(),
            className: className,
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleBlur
          }, other),
          _react2['default'].Children.map(children, function (child, index) {
            return _react2['default'].cloneElement(child, _this2.makeChildProps(child, index));
          })
        );
      }

      return render;
    }()
  }]);

  return MenuList;
}(_react.Component), _class.propTypes = {
  /**
   * MenuList contents, should be menu items.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * @ignore
   */
  onBlur: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onKeyDown: _PropTypes2['default'].func,
  /**
   * Callback fired when the `MenuList` selects an item
   */
  onSelectItem: _PropTypes2['default'].func,
  tabIndex: _PropTypes2['default'].number
}, _temp2);
exports['default'] = MenuList;


MenuList.displayName = 'MenuList';

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _CollapsedListItem = __webpack_require__(641);

var _CollapsedListItem2 = _interopRequireDefault(_CollapsedListItem);

var _SearchListItem = __webpack_require__(255);

var _SearchListItem2 = _interopRequireDefault(_SearchListItem);

var _Input = __webpack_require__(247);

var _Input2 = _interopRequireDefault(_Input);

var _IconButton = __webpack_require__(90);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Add = __webpack_require__(709);

var _Add2 = _interopRequireDefault(_Add);

var _Text = __webpack_require__(56);

var _Text2 = _interopRequireDefault(_Text);

var _makeSortable = __webpack_require__(642);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('List', function (theme) {
  return {
    root: {
      flex: '1 1 auto',
      listStyle: 'none',
      margin: 0,
      padding: 0
    },
    divider: {
      borderTop: '1px solid ' + theme.palette.text.lightDivider
    },
    add: {
      backgroundColor: 'inherit'
    },
    padding: {
      paddingTop: theme.typography.rhythmByUnit(1),
      paddingBottom: theme.typography.rhythmByUnit(1)
    },
    subheader: {
      paddingTop: 0
    },
    icon: {
      width: '1em'
    }
  };
});

/**
 * A simple list component.
 */
var List = (_temp2 = _class = function (_Component) {
  _inherits(List, _Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = Object.assign({
      displayChildren: _this.getDisplayChildren(_react.Children.toArray(_this.props.children), _this.props.collapse)
    }, _this.props.add && { add: '' }), _this.handleAddSubmit = function (e) {
      if (e.key === 'Enter' || e.currentTarget.type === 'submit' && e.type === 'click') {
        var onAddRequest = _this.props.onAddRequest;
        var value = _this.state.add;
        var error = _this.addInput.state.error;


        if (value && !error) {
          onAddRequest(value);
          _this.setState({ add: '', addError: false });
        } else {
          _this.setState({ addError: true });
        }
      }
    }, _this.handleAddInputChange = function (e) {
      var value = e.target.value;

      _this.setState(function (state) {
        return state.addError ? { add: value, addError: !value } : { add: value };
      });
    }, _this.renderChildren = function () {
      return _react.Children.map(_this.state.displayChildren, function (child) {
        var _child$type = child.type;
        _child$type = _child$type === undefined ? {} : _child$type;
        var _child$type$propTypes = _child$type.propTypes;
        _child$type$propTypes = _child$type$propTypes === undefined ? {} : _child$type$propTypes;
        var dividerPropType = _child$type$propTypes.divider;


        return _react2['default'].cloneElement(child, Object.assign({}, dividerPropType !== undefined && { divider: _this.props.divider }));
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var children = nextProps.children,
            collapse = nextProps.collapse,
            add = nextProps.add;


        this.setState(Object.assign({
          displayChildren: this.getDisplayChildren(_react.Children.toArray(children), collapse)
        }, add && { add: '' }));
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'getDisplayChildren',
    value: function () {
      function getDisplayChildren(children, collapse) {
        var _this2 = this;

        if (!collapse) {
          return children;
        }

        var shouldCollapse = children.map(function (child) {
          return collapse(child.props);
        });
        var newChildren = [];
        var count = 0;

        shouldCollapse.forEach(function (collapse, i) {
          if (collapse) {
            count++;

            if (i === children.length - 1) {
              newChildren.push(_this2.renderCollapsedListItem(children, count, i, i - count + 1));
            }
          } else {
            if (count > 0) {
              newChildren.push(_this2.renderCollapsedListItem(children, count, i, i - count));
              count = 0;
            }

            newChildren.push(children[i]);
          }
        });

        return newChildren;
      }

      return getDisplayChildren;
    }()
  }, {
    key: 'renderCollapsedListItem',
    value: function () {
      function renderCollapsedListItem(children, count, i, startIdx) {
        var _this3 = this;

        var collapsedLabel = this.props.collapsedLabel;

        var replacementItems = children.slice(startIdx, startIdx + count);
        var label = collapsedLabel && collapsedLabel(replacementItems.map(function (c) {
          return c.props;
        }));

        return _react2['default'].createElement(_CollapsedListItem2['default'], _extends({
          id: i,
          key: i,
          onClick: function () {
            function onClick(e, _ref2) {
              var id = _ref2.id,
                  onExpand = _ref2.onExpand;

              var displayChildren = _this3.state.displayChildren.slice();
              var idxToReplace = displayChildren.findIndex(function (el) {
                return el.props.id === id;
              });

              displayChildren.splice.apply(displayChildren, [idxToReplace, 1].concat(_toConsumableArray(replacementItems)));

              _this3.setState({ displayChildren: displayChildren });

              if (onExpand) {
                replacementItems.map(function (i) {
                  return onExpand(i.props);
                });
              }
            }

            return onClick;
          }()
        }, { count: count, label: label, startIdx: startIdx }));
      }

      return renderCollapsedListItem;
    }()
  }, {
    key: 'renderAdd',
    value: function () {
      function renderAdd(classes) {
        var _this4 = this;

        var _props = this.props,
            placeholder = _props.addPlaceholder,
            Component = _props.addComponent,
            errorMessage = _props.addErrorMessage,
            validator = _props.validator;
        var _state = this.state,
            value = _state.add,
            error = _state.addError;

        var detailPrimaryComponent = !error ? null : _react2['default'].createElement(
          _Text2['default'],
          { component: 'div', error: true },
          errorMessage
        );

        return _react2['default'].createElement(Component, {
          primary: _react2['default'].createElement(_Input2['default'], _extends({
            id: 'add',
            fullWidth: true,
            forceDirty: true,
            className: classes.add,
            onChange: this.handleAddInputChange,
            onKeyPress: this.handleAddSubmit,
            ref: function () {
              function ref(c) {
                return _this4.addInput = c;
              }

              return ref;
            }()
          }, { error: error, errorMessage: errorMessage, placeholder: placeholder, validator: validator, value: value })),
          detailPrimary: detailPrimaryComponent,
          icon: _react2['default'].createElement(
            _IconButton2['default'],
            {
              type: 'submit',
              sizeInherit: true,
              className: classes.icon,
              onClick: this.handleAddSubmit,
              ripple: false
            },
            _react2['default'].createElement(_Add2['default'], null)
          )
        });
      }

      return renderAdd;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props2 = this.props,
            add = _props2.add,
            addComponent = _props2.addComponent,
            addErrorMessage = _props2.addErrorMessage,
            addPlaceholder = _props2.addPlaceholder,
            childrenProp = _props2.children,
            classNameProp = _props2.className,
            collapse = _props2.collapse,
            collapsedLabel = _props2.collapsedLabel,
            ComponentProp = _props2.component,
            divider = _props2.divider,
            getContainer = _props2.getContainer,
            onAddRequest = _props2.onAddRequest,
            onExpand = _props2.onExpand,
            onSort = _props2.onSort,
            padding = _props2.padding,
            rootRef = _props2.rootRef,
            sortable = _props2.sortable,
            subheader = _props2.subheader,
            useWindowAsScrollContainer = _props2.useWindowAsScrollContainer,
            validator = _props2.validator,
            other = _objectWithoutProperties(_props2, ['add', 'addComponent', 'addErrorMessage', 'addPlaceholder', 'children', 'className', 'collapse', 'collapsedLabel', 'component', 'divider', 'getContainer', 'onAddRequest', 'onExpand', 'onSort', 'padding', 'rootRef', 'sortable', 'subheader', 'useWindowAsScrollContainer', 'validator']);

        var children = this.renderChildren();
        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.divider, divider && _react.Children.count(children)), _defineProperty(_classNames, classes.padding, padding), _defineProperty(_classNames, classes.subheader, subheader), _classNames), classNameProp);

        return _react2['default'].createElement(
          ComponentProp,
          _extends({ ref: rootRef }, Object.assign({ className: className }, other)),
          subheader,
          sortable ? _react2['default'].createElement(
            _makeSortable.SortableList,
            {
              getContainer: getContainer,
              onSort: onSort,
              useWindowAsScrollContainer: useWindowAsScrollContainer
            },
            children
          ) : children,
          add && this.renderAdd(classes)
        );
      }

      return render;
    }()
  }]);

  return List;
}(_react.Component), _class.propTypes = {
  /**
   * If true, add node appears as last list item
   */
  add: _PropTypes2['default'].bool,
  /**
   * The component used for the add node.
   * Either a string to use a DOM element or a ReactComponent.
   */
  addComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Error message displayed by add input
   */
  addErrorMessage: _PropTypes2['default'].string,
  /**
   * Text used as add list item input placeholder text
   */
  addPlaceholder: _PropTypes2['default'].string,
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Function that takes a list item's props as argument and collapses item if it returns true.
   */
  collapse: _PropTypes2['default'].func,
  /**
   * Function callback that is called once for each collapsed section of the list with the props of the collapsed
   * components in that secion. Returns a string is shown as the label of the collapsed secion.
   */
  collapsedLabel: _PropTypes2['default'].func,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a ReactComponent.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Children inherit this prop.  Also, if true and children exist, Divider is presented at top and bottom of list.
   */
  divider: _PropTypes2['default'].bool,
  /**
   * Optional function to return the scrollable container element.
   */
  getContainer: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  id: _PropTypes2['default'].string,
  /**
   * Callback fired when add is requested.
   */
  onAddRequest: _PropTypes2['default'].func,
  /**
   * Function callback when a collapsed list item is expanded, which is passed the properties of the expaned item.
   */
  onExpand: _PropTypes2['default'].func,
  /**
   * Callback fired list is sorted.
   */
  onSort: _PropTypes2['default'].func,
  padding: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  rootRef: _PropTypes2['default'].func,
  /**
   * If true, user can sort list.
   */
  sortable: _PropTypes2['default'].bool,
  subheader: _PropTypes2['default'].node,
  /**
   * If true, set the window as the scrolling container.
   */
  useWindowAsScrollContainer: _PropTypes2['default'].bool,
  /**
   * Function that validates the added value
   */
  validator: _PropTypes2['default'].func
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.defaultProps = {
  add: false,
  addComponent: _SearchListItem2['default'],
  addErrorMessage: 'Please enter a valid value',
  addPlaceholder: 'Add to list',
  component: 'div',
  onAddRequest: function () {
    function onAddRequest() {}

    return onAddRequest;
  }(),
  onSort: function () {
    function onSort(v) {
      return v;
    }

    return onSort;
  }(),
  padding: true,
  sortable: false
}, _temp2);
exports['default'] = List;


List.displayName = 'List';

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;
exports['default'] = Avatar;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _colorManipulator = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Avatar', function (theme) {
  var palette = theme.palette;

  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '1em',
      width: '1em',
      borderRadius: theme.variables.borderRadius,
      overflow: 'hidden',
      userSelect: 'none'
    },
    defaultColor: {
      color: palette.background['default'],
      backgroundColor: (0, _colorManipulator.emphasize)(palette.background['default'], 0.26)
    },
    text: {
      fontSize: '0.6em'
    },
    img: {
      maxWidth: '100%',
      width: '100%',
      height: 'auto'
    }
  };
});

function Avatar(props, context) {
  var alt = props.alt,
      classNameProp = props.className,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      ComponentProp = props.component,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = _objectWithoutProperties(props, ['alt', 'className', 'children', 'childrenClassName', 'component', 'sizes', 'src', 'srcSet']);

  var hasImage = src || srcSet;
  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.defaultColor, childrenProp && !hasImage), classNameProp);
  var containerProps = Object.assign({
    className: className
  }, other);

  var children = null;

  if (childrenProp) {
    if (childrenClassNameProp && _react2['default'].isValidElement(childrenProp)) {
      var childrenClassName = (0, _classnames2['default'])(childrenClassNameProp, classes.text, childrenProp.props.className);
      children = _react2['default'].cloneElement(childrenProp, {
        className: childrenClassName
      });
    } else {
      children = _react2['default'].createElement(
        'span',
        { className: classes.text },
        childrenProp
      );
    }
  } else if (hasImage) {
    var imgProps = {
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    };
    children = _react2['default'].createElement('img', imgProps);
  }

  return _react2['default'].createElement(
    ComponentProp,
    containerProps,
    children
  );
}

Avatar.muiName = 'Avatar';

Avatar.displayName = 'Avatar';

Avatar.propTypes = {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _PropTypes2['default'].string,
  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   */
  children: _PropTypes2['default'].node,
  /**
   * @ignore
   * The className of the child element.
   * Used by Chip to style the Avatar icon.
   */
  childrenClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a ReactElement.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * sizes desc
   */
  sizes: _PropTypes2['default'].string,
  /**
   * src desc
   */
  src: _PropTypes2['default'].string,
  /**
   * srcSet desc
   */
  srcSet: _PropTypes2['default'].string
};

Avatar.defaultProps = {
  alt: '',
  component: 'div'
};

Avatar.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = __webpack_require__(6);

var _reactSortableHoc = __webpack_require__(241);

var _SortableContainer = __webpack_require__(655);

var _SortableContainer2 = _interopRequireDefault(_SortableContainer);

var _context = __webpack_require__(93);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PRESS_DELAY = 300;

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SortableList', function (theme) {
  return {
    '@global': {
      '*': {
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)'
      }
    },
    sortableHelper: {
      backgroundColor: theme.palette.text.lightDivider,
      pointerEvents: 'auto !important',
      zIndex: theme.zIndex.sortableHelper,
      '&, & .cursorGrabbing': {
        cursor: 'grabbing',
        fallbacks: {
          cursor: 'move'
        }
      }
    }
  };
});

var SortableList = (_temp2 = _class = function (_PureComponent) {
  _inherits(SortableList, _PureComponent);

  function SortableList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SortableList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortableList.__proto__ || Object.getPrototypeOf(SortableList)).call.apply(_ref, [this].concat(args))), _this), _this.initState = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          children = _ref2.children;

      return function (state // eslint-disable-line no-unused-vars
      ) {
        return {
          items: children,
          userIsTouching: false
        };
      };
    }, _this.state = _this.initState(_this.props)(), _this.onFirstTouch = function () {
      return _this.setState({ userIsTouching: true }, function () {
        return _context2['default'].removeEventListener('touchstart', _this.onFirstTouch, false);
      });
    }, _this.onSortEnd = function (_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;

      _this.setState({
        items: (0, _reactSortableHoc.arrayMove)(_this.state.items, oldIndex, newIndex)
      }, function () {
        return _this.props.onSort(_this.state.items);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SortableList, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        _context2['default'].addEventListener('touchstart', this.onFirstTouch, false);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        if (nextProps.children === this.props.children) return;
        this.setState(this.initState(nextProps));
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        _context2['default'].removeEventListener('touchstart', this.onFirstTouch, false);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            component = _props.component,
            onSort = _props.onSort,
            other = _objectWithoutProperties(_props, ['children', 'component', 'onSort']);

        var _state = this.state,
            items = _state.items,
            userIsTouching = _state.userIsTouching;

        var classes = this.context.styleManager.render(styleSheet);
        var pressDelay = userIsTouching ? PRESS_DELAY : 0;

        return _react2['default'].createElement(_SortableContainer2['default'], _extends({
          helperClass: classes.sortableHelper,
          onSortEnd: this.onSortEnd
        }, Object.assign({ component: component, items: items, pressDelay: pressDelay }, other)));
      }

      return render;
    }()
  }]);

  return SortableList;
}(_react.PureComponent), _class.propTypes = {
  children: _PropTypes2['default'].node,
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  getContainer: _PropTypes2['default'].func,
  onSort: _PropTypes2['default'].func
}, _class.defaultProps = {
  component: 'div',
  lockAxis: 'y',
  onSort: function () {
    function onSort() {}

    return onSort;
  }(),

  transitionDuration: 0
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = SortableList;


SortableList.displayName = 'SortableList';

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(643);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(29);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(1678);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (e) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (e.button === 2 || shouldCancelStart(e)) {
          return false;
        }

        _this._touched = true;
        _this._pos = {
          x: e.pageX,
          y: e.pageY
        };

        var node = (0, _utils.closest)(e.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (e.target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(e);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(e);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (e) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          _this._delta = {
            x: _this._pos.x - e.pageX,
            y: _this._pos.y - e.pageY
          };
          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);

          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && delta >= distance && _this.manager.isActive()) {
            _this.handlePress(e);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (e) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = _this.getEdgeOffset(node);
          _this.initialOffset = _this.getOffset(e);
          _this.initialScroll = {
            top: _this.scrollContainer.scrollTop,
            left: _this.scrollContainer.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = e.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
        }
      };

      _this.handleSortMove = function (e) {
        var onSortMove = _this.props.onSortMove;

        e.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(e);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) onSortMove(e);
      };

      _this.handleSortEnd = function (e) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, e);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            getContainer = _props.getContainer,
            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var contentWindow = this.props.contentWindow || window;

        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
        this.document = this.container.ownerDocument || document;
        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;

        var _loop = function _loop(key) {
          if (_this2.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          }
        };

        for (var key in this.events) {
          _loop(key);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var _loop2 = function _loop2(key) {
          if (_this3.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this3.container.removeEventListener(eventName, _this3.events[key]);
            });
          }
        };

        for (var key in this.events) {
          _loop2(key);
        }
      }
    }, {
      key: 'getEdgeOffset',
      value: function getEdgeOffset(node) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
        if (node) {
          var nodeOffset = {
            top: offset.top + node.offsetTop,
            left: offset.left + node.offsetLeft
          };
          if (node.parentNode !== this.container) {
            return this.getEdgeOffset(node.parentNode, nodeOffset);
          } else {
            return nodeOffset;
          }
        }
      }
    }, {
      key: 'getOffset',
      value: function getOffset(e) {
        return {
          x: e.touches ? e.touches[0].pageX : e.pageX,
          y: e.touches ? e.touches[0].pageY : e.pageY
        };
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var lockOffset = this.props.lockOffset;


        if (!Array.isArray(lockOffset)) {
          lockOffset = [lockOffset, lockOffset];
        }

        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _lockOffset = lockOffset,
            _lockOffset2 = _slicedToArray(_lockOffset, 2),
            minLockOffset = _lockOffset2[0],
            maxLockOffset = _lockOffset2[1];

        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
      }
    }, {
      key: 'getLockPixelOffset',
      value: function getLockPixelOffset(lockOffset) {
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';

        if (typeof lockOffset === 'string') {
          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

          offsetX = offsetY = parseFloat(lockOffset);
          unit = match[1];
        }

        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

        if (unit === '%') {
          offsetX = offsetX * this.width / 100;
          offsetY = offsetY * this.height / 100;
        }

        return {
          x: offsetX,
          y: offsetY
        };
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(e) {
        var _props2 = this.props,
            lockAxis = _props2.lockAxis,
            lockToContainerEdges = _props2.lockToContainerEdges;


        var offset = this.getOffset(e);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props3 = this.props,
            transitionDuration = _props3.transitionDuration,
            hideSortableGhost = _props3.hideSortableGhost;

        var nodes = this.manager.getOrderedRefs();
        var deltaScroll = {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
        };
        var scrollDifference = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1677);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(1679);

var _find2 = _interopRequireDefault(_find);

var _sortBy = __webpack_require__(1720);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: 'add',
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: 'remove',
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.active;
    }
  }, {
    key: 'getActive',
    value: function getActive() {
      var _this = this;

      return (0, _find2.default)(this.refs[this.active.collection],
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: 'getIndex',
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: 'getOrderedRefs',
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
        var node = _ref2.node;
        return node.sortableInfo.index;
      });
    }
  }]);

  return Manager;
}();

exports.default = Manager;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1680),
    findIndex = __webpack_require__(1717);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(370),
    isArrayLike = __webpack_require__(374),
    keys = __webpack_require__(371);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1682),
    getMatchData = __webpack_require__(1702),
    matchesStrictComparable = __webpack_require__(649);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(644),
    baseIsEqual = __webpack_require__(645);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1683 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(243);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1685 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(243);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(243);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(243);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(644),
    equalArrays = __webpack_require__(1690),
    equalByTag = __webpack_require__(1695),
    equalObjects = __webpack_require__(1696),
    getTag = __webpack_require__(1698),
    isArray = __webpack_require__(116),
    isBuffer = __webpack_require__(1699),
    isTypedArray = __webpack_require__(1700);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1691),
    arraySome = __webpack_require__(1692),
    cacheHas = __webpack_require__(1693);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(116);

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),
/* 1692 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1694);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1694 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1695 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1697);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(646);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1698 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1699 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1700 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1701 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(647),
    keys = __webpack_require__(371);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(645),
    get = __webpack_require__(1704),
    hasIn = __webpack_require__(1708),
    isKey = __webpack_require__(372),
    isStrictComparable = __webpack_require__(647),
    matchesStrictComparable = __webpack_require__(649),
    toKey = __webpack_require__(244);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(650);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1706);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1706 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1707 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1709),
    hasPath = __webpack_require__(1710);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1709 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(651),
    isArguments = __webpack_require__(653),
    isArray = __webpack_require__(116),
    isIndex = __webpack_require__(1711),
    isLength = __webpack_require__(654),
    toKey = __webpack_require__(244);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1711 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1713),
    basePropertyDeep = __webpack_require__(1714),
    isKey = __webpack_require__(372),
    toKey = __webpack_require__(244);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1713 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(650);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1716),
    isObject = __webpack_require__(648);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 1716 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1718),
    baseIteratee = __webpack_require__(370),
    toInteger = __webpack_require__(1719);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1718 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1721),
    baseOrderBy = __webpack_require__(1727),
    baseRest = __webpack_require__(1739),
    isIterateeCall = __webpack_require__(1743);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1722),
    isFlattenable = __webpack_require__(1723);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1724),
    isArguments = __webpack_require__(653),
    isArray = __webpack_require__(116);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(1725);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1726);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(1728),
    baseIteratee = __webpack_require__(370),
    baseMap = __webpack_require__(1729),
    baseSortBy = __webpack_require__(1735),
    baseUnary = __webpack_require__(1736),
    compareMultiple = __webpack_require__(1737),
    identity = __webpack_require__(373);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1728 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1730),
    isArrayLike = __webpack_require__(374);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1731),
    createBaseEach = __webpack_require__(1734);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1732),
    keys = __webpack_require__(371);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1733);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1733 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(374);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1735 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1736 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1738);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(652);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(373),
    overRest = __webpack_require__(1740),
    setToString = __webpack_require__(1742);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1741);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1741 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1742 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1743 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(643);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(29);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _KeyboardArrowLeft = __webpack_require__(780);

var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);

var _Text = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('FullScreen', function (theme) {
  var fullScreen = {
    width: '100% !important',
    top: '0px !important',
    bottom: '0px  !important',
    position: 'fixed !important',
    zIndex: theme.zIndex.dialog + ' !important',
    overflow: 'auto !important',
    display: 'flex !important',
    flexFlow: 'column !important',
    left: '0px !important', // unset InfiniteList inline style
    height: 'unset !important' // unset InfiniteList inline style
  };

  var childContainer = {
    width: '100%',
    overflow: 'auto'
  };

  var showBack = {
    display: 'inline-flex',
    cursor: 'pointer',
    alignItems: 'center',
    marginTop: theme.typography.rhythmByUnit(2),
    marginRight: theme.typography.rhythmByUnit(1),
    marginLeft: theme.typography.rhythmByUnit(1)
  };

  return theme.breakpoints.keys.reduce(function (styles, breakpoint) {
    var _theme$breakpoints$do;

    return Object.assign({}, styles, _defineProperty({}, theme.breakpoints.down(breakpoint), (_theme$breakpoints$do = {}, _defineProperty(_theme$breakpoints$do, 'root-' + breakpoint, fullScreen), _defineProperty(_theme$breakpoints$do, 'child-' + breakpoint, childContainer), _defineProperty(_theme$breakpoints$do, 'back-' + breakpoint, showBack), _theme$breakpoints$do)));
  }, {
    back: {
      display: 'none'
    },
    icon: {
      height: theme.spacing.unit * 3,
      width: theme.spacing.unit * 3
    }
  });
});

var FullScreen = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(FullScreen, _React$PureComponent);

  function FullScreen() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FullScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FullScreen.__proto__ || Object.getPrototypeOf(FullScreen)).call.apply(_ref, [this].concat(args))), _this), _this.component = undefined, _this.focus = function () {
      if (_this.component && typeof _this.component.focus === 'function') {
        _this.component.focus();
      }
    }, _this.handleBackClick = function (e) {
      var onBackClick = _this.props.onBackClick;

      if (onBackClick) onBackClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FullScreen, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            backTextProp = _props.backText,
            BackIcon = _props.backIcon,
            breakpoint = _props.breakpoint,
            Component = _props.component,
            classNameProp = _props.className,
            expand = _props.expand,
            children = _props.children,
            onBackClick = _props.onBackClick,
            other = _objectWithoutProperties(_props, ['backText', 'backIcon', 'breakpoint', 'component', 'className', 'expand', 'children', 'onBackClick']);

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(_defineProperty({}, classes['root-' + breakpoint], expand), classNameProp);
        var childClassName = (0, _classnames2['default'])(_defineProperty({}, classes['child-' + breakpoint], expand));
        var backClassName = (0, _classnames2['default'])(classes.back, _defineProperty({}, classes['back-' + breakpoint], expand));
        var backText = typeof backTextProp === 'string' ? _react2['default'].createElement(
          _Text.Headline,
          { component: 'span' },
          backTextProp
        ) : backTextProp;
        /* eslint-disable */
        return _react2['default'].createElement(
          Component,
          _extends({
            className: rootClassName,
            ref: function () {
              function ref(node) {
                return _this2.component = node;
              }

              return ref;
            }()
          }, other),
          _react2['default'].createElement(
            'div',
            { className: childClassName },
            Boolean(expand && backTextProp) && _react2['default'].createElement(
              'div',
              {
                className: backClassName,
                role: 'button',
                onClick: this.handleBackClick
              },
              _react2['default'].createElement(BackIcon, { className: classes.icon }),
              backText
            ),
            children
          )
        );
        /* eslint-enable */
      }

      return render;
    }()
  }]);

  return FullScreen;
}(_react2['default'].PureComponent), _class.defaultProps = {
  backText: 'Back',
  backIcon: _KeyboardArrowLeft2['default'],
  breakpoint: 'sm',
  component: 'div',
  expand: false
}, _temp2);
exports['default'] = FullScreen;


FullScreen.displayName = 'FullScreen';

FullScreen.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
};

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _context = __webpack_require__(93);

var _context2 = _interopRequireDefault(_context);

var _reactVirtualized = __webpack_require__(838);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteList = (_temp2 = _class = function (_PureComponent) {
  _inherits(InfiniteList, _PureComponent);

  function InfiniteList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InfiniteList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfiniteList.__proto__ || Object.getPrototypeOf(InfiniteList)).call.apply(_ref, [this].concat(args))), _this), _this.handeRef = function (c, callback) {
      _this.List = c;
      return callback(c);
    }, _this.recomputeRowHeights = function () {
      if (_this.List && _this.List.recomputeRowHeights) _this.List.recomputeRowHeights();
    }, _this.List = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InfiniteList, [{
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var prevRowCount = prevProps.rowCount;
        var _props = this.props,
            thisRowCount = _props.rowCount,
            rowHeight = _props.rowHeight;


        if (rowHeight instanceof Function && prevRowCount !== thisRowCount) {
          this.recomputeRowHeights();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            isRowLoaded = _props2.isRowLoaded,
            loadMoreRows = _props2.loadMoreRows,
            maxHeight = _props2.maxHeight,
            minHeight = _props2.minHeight,
            minimumBatchSize = _props2.minimumBatchSize,
            rowCount = _props2.rowCount,
            threshold = _props2.threshold,
            totalRowCount = _props2.totalRowCount,
            scrollElement = _props2.scrollElement;


        return _react2['default'].createElement(
          _reactVirtualized.InfiniteLoader,
          {
            isRowLoaded: isRowLoaded,
            loadMoreRows: loadMoreRows,
            minimumBatchSize: minimumBatchSize,
            threshold: threshold,
            rowCount: totalRowCount || rowCount
          },
          function (_ref2) {
            var onRowsRendered = _ref2.onRowsRendered,
                registerChild = _ref2.registerChild;
            return _react2['default'].createElement(
              _reactVirtualized.WindowScroller,
              { scrollElement: scrollElement },
              function (_ref3) {
                var height = _ref3.height,
                    isScrolling = _ref3.isScrolling,
                    onChildScroll = _ref3.onChildScroll,
                    scrollTop = _ref3.scrollTop;
                return _react2['default'].createElement(
                  _reactVirtualized.AutoSizer,
                  { disableHeight: true },
                  function (_ref4) {
                    var width = _ref4.width;
                    return _react2['default'].createElement(_reactVirtualized.List, _extends({
                      ref: function () {
                        function ref(c) {
                          return _this2.handeRef(c, registerChild);
                        }

                        return ref;
                      }(),
                      autoHeight: true,
                      onRowsRendered: onRowsRendered,
                      width: width,
                      height: Math.max(minHeight, Math.min(maxHeight, height)),
                      scrollTop: scrollTop,
                      onScroll: onChildScroll,
                      isScrolling: isScrolling
                    }, _this2.props));
                  }
                );
              }
            );
          }
        );
      }

      return render;
    }()
  }]);

  return InfiniteList;
}(_react.PureComponent), _class.propTypes = {
  /*
   * The maximum list height to render in pixels
   */
  maxHeight: _PropTypes2['default'].number,
  /*
   * The minimum list height to render in pixels
   */
  minHeight: _PropTypes2['default'].number,
  /*
   * The total number of rows in the list
   */
  totalRowCount: _PropTypes2['default'].number,

  // <InfiniteLoader> Props:

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: _PropTypes2['default'].func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: _PropTypes2['default'].func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: _PropTypes2['default'].number,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: _PropTypes2['default'].number,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: _PropTypes2['default'].number,

  // <List> Props:

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: _PropTypes2['default'].bool,

  /** Optional CSS class name */
  className: _PropTypes2['default'].string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _PropTypes2['default'].number,

  /** Height constraint for list (determines how many actual rows are rendered) */
  height: _PropTypes2['default'].number,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: _PropTypes2['default'].func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: _PropTypes2['default'].func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: _PropTypes2['default'].func,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: _PropTypes2['default'].func,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: _PropTypes2['default'].number,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: _PropTypes2['default'].oneOfType([_PropTypes2['default'].number, _PropTypes2['default'].func]).isRequired,

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: _PropTypes2['default'].func.isRequired,

  /** Element to use when triggering scroll events. Uses `window` by default */
  scrollElement: _PropTypes2['default'].object.isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: _PropTypes2['default'].oneOf(['auto', 'end', 'start', 'center']),

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: _PropTypes2['default'].number,

  /** Vertical offset. */
  scrollTop: _PropTypes2['default'].number,

  /** Tab index for focus */
  tabIndex: _PropTypes2['default'].number,

  /** Width of list */
  width: _PropTypes2['default'].number
}, _class.defaultProps = {
  minHeight: 0,
  scrollElement: _context2['default']
}, _temp2);
exports['default'] = InfiniteList;


InfiniteList.displayName = 'InfiniteList';

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(658);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(670);
/* unused harmony reexport bpfrpt_proptype_ScrollIndices */








/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1750);
module.exports = __webpack_require__(26).Object.getPrototypeOf;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(177);
var $getPrototypeOf = __webpack_require__(609);

__webpack_require__(365)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1752);
var $Object = __webpack_require__(26).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(61);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(88), 'Object', { defineProperty: __webpack_require__(79).f });


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(617), __esModule: true };

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(618), __esModule: true };

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1756), __esModule: true };

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1757);
module.exports = __webpack_require__(26).Object.setPrototypeOf;


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(61);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1758).set });


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(112);
var anObject = __webpack_require__(67);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(139)(Function.call, __webpack_require__(364).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1760), __esModule: true };

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1761);
var $Object = __webpack_require__(26).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(61);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(354) });


/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;


function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(11);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Used in deferred mode to track which cells have been queued for measurement.

  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeAndPositionData = {};
    this._lastMeasuredIndex = -1;
    this._lastBatchedIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (_currentOffset === offset) {
          return middle;
        } else if (_currentOffset < offset) {
          low = middle + 1;
        } else if (_currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);




/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome && !!window.chrome.webstore;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(11);




/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}



/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1767), __esModule: true };

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(620);
__webpack_require__(173);
__webpack_require__(237);
__webpack_require__(1768);
__webpack_require__(1775);
__webpack_require__(1776);
module.exports = __webpack_require__(26).Promise;


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(232);
var global = __webpack_require__(49);
var ctx = __webpack_require__(139);
var classof = __webpack_require__(360);
var $export = __webpack_require__(61);
var isObject = __webpack_require__(112);
var aFunction = __webpack_require__(233);
var anInstance = __webpack_require__(1769);
var forOf = __webpack_require__(1770);
var speciesConstructor = __webpack_require__(666);
var task = __webpack_require__(667).set;
var microtask = __webpack_require__(1772)();
var newPromiseCapabilityModule = __webpack_require__(378);
var perform = __webpack_require__(668);
var promiseResolve = __webpack_require__(669);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(41)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1773)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(235)($Promise, PROMISE);
__webpack_require__(1774)(PROMISE);
Wrapper = __webpack_require__(26)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(612)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1769 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(139);
var call = __webpack_require__(610);
var isArrayIter = __webpack_require__(611);
var anObject = __webpack_require__(67);
var toLength = __webpack_require__(355);
var getIterFn = __webpack_require__(359);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 1771 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49);
var macrotask = __webpack_require__(667).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(176)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(111);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(49);
var core = __webpack_require__(26);
var dP = __webpack_require__(79);
var DESCRIPTORS = __webpack_require__(88);
var SPECIES = __webpack_require__(41)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(61);
var core = __webpack_require__(26);
var global = __webpack_require__(49);
var speciesConstructor = __webpack_require__(666);
var promiseResolve = __webpack_require__(669);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(61);
var newPromiseCapability = __webpack_require__(378);
var perform = __webpack_require__(668);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(11);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}



/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(671);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);








/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return typeof children === 'function' ? children({ measure: this._measure }) : children;
    }
  }, {
    key: '_getCellMeasurements',
    value: function _getCellMeasurements() {
      var cache = this.props.cache;


      var node = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this);

      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height;

        // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }
        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth);

        // Reset after measuring to avoid breaking styles; see #660
        if (styleWidth) {
          node.style.width = styleWidth;
        }
        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return { height: height, width: width };
      } else {
        return { height: 0, width: 0 };
      }
    }
  }, {
    key: '_maybeMeasureCell',
    value: function _maybeMeasureCell() {
      var _props = this.props,
          cache = _props.cache,
          _props$columnIndex = _props.columnIndex,
          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
          parent = _props.parent,
          _props$rowIndex = _props.rowIndex,
          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;


      if (!cache.has(rowIndex, columnIndex)) {
        var _getCellMeasurements2 = this._getCellMeasurements(),
            height = _getCellMeasurements2.height,
            width = _getCellMeasurements2.width;

        cache.set(rowIndex, columnIndex, width, height);

        // If size has changed, let Grid know to re-render.
        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

// Used for DEV mode warning check


CellMeasurer.__internalCellMeasurerFlag = false;
CellMeasurer.propTypes =  true ? null : {
  cache: function cache() {
    return (typeof bpfrpt_proptype_CellMeasureCache === 'function' ? bpfrpt_proptype_CellMeasureCache.isRequired ? bpfrpt_proptype_CellMeasureCache.isRequired : bpfrpt_proptype_CellMeasureCache : PropTypes.shape(bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
  },
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  columnIndex: PropTypes.number,
  index: PropTypes.number,
  parent: PropTypes.shape({
    invalidateCellSizeAfterRender: PropTypes.func,
    recomputeGridSize: PropTypes.func
  }).isRequired,
  rowIndex: PropTypes.number
};
/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
if (false) {
  CellMeasurer.__internalCellMeasurerFlag = true;
}



/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_HEIGHT */
/* unused harmony export DEFAULT_WIDTH */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(674);




var DEFAULT_HEIGHT = 30;

var DEFAULT_WIDTH = 100;

// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache = function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCache);

    this._cellHeightCache = {};
    this._cellWidthCache = {};
    this._columnWidthCache = {};
    this._rowHeightCache = {};
    this._columnCount = 0;
    this._rowCount = 0;

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
    };

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;


    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;

    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCache, [{
    key: 'clear',
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache.hasOwnProperty(key);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }
      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      }

      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: '_updateCachedColumnAndRowSizes',
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;
        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }
        var columnKey = this._keyMapper(0, columnIndex);
        this._columnWidthCache[columnKey] = columnWidth;
      }
      if (!this._hasFixedHeight) {
        var rowHeight = 0;
        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }
        var rowKey = this._keyMapper(rowIndex, 0);
        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCache);


function defaultKeyMapper(rowIndex, columnIndex) {
  return rowIndex + '-' + columnIndex;
}


/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(1783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collection__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);


/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionView__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types__ = __webpack_require__(144);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _React$PureComponent);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'forceUpdate',
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }

    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props,
          cellCount = _props.cellCount,
          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
          sectionSize = _props.sectionSize;


      var data = Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _props2 = this.props,
          cellGroupRenderer = _props2.cellGroupRenderer,
          cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: '_setCollectionViewRef',
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
Collection.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};


function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize__);













// @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()
    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };
    _this._calculateSizeAndPositionDataOnNextUpdate = false;
    _this._onSectionRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);

    _this._invokeOnSectionRenderedHelper = function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;


      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._updateScrollPositionForScrollToCell = function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;

      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    };

    _this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default()();
    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          cellLayoutManager = _props.cellLayoutManager,
          scrollLeft = _props.scrollLeft,
          scrollToCell = _props.scrollToCell,
          scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width;

      // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          height = _props2.height,
          scrollToAlignment = _props2.scrollToAlignment,
          scrollToCell = _props2.scrollToCell,
          width = _props2.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          autoHeight = _props3.autoHeight,
          cellCount = _props3.cellCount,
          cellLayoutManager = _props3.cellLayoutManager,
          className = _props3.className,
          height = _props3.height,
          horizontalOverscanSize = _props3.horizontalOverscanSize,
          id = _props3.id,
          noContentRenderer = _props3.noContentRenderer,
          style = _props3.style,
          verticalOverscanSize = _props3.verticalOverscanSize,
          width = _props3.width;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;

      // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;

        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width;

      // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0 },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            } },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;


        isScrollingChange(false);

        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref2) {
      var _this3 = this;

      var scrollLeft = _ref2.scrollLeft,
          scrollTop = _ref2.scrollTop,
          totalHeight = _ref2.totalHeight,
          totalWidth = _ref2.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref3) {
          var scrollLeft = _ref3.scrollLeft,
              scrollTop = _ref3.scrollTop;
          var _props4 = _this3.props,
              height = _props4.height,
              onScroll = _props4.onScroll,
              width = _props4.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref4) {
      var scrollLeft = _ref4.scrollLeft,
          scrollTop = _ref4.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
};
CollectionView.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["a" /* polyfill */])(CollectionView);

/* harmony default export */ __webpack_exports__["a"] = (CollectionView);

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(1786);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(144);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */



var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);



/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(144);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);



/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === undefined ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(1790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a" /* default */]);


/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          columnMaxWidth = _props.columnMaxWidth,
          columnMinWidth = _props.columnMinWidth,
          columnCount = _props.columnCount,
          width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnMaxWidth = _props2.columnMaxWidth,
          columnMinWidth = _props2.columnMinWidth,
          columnCount = _props2.columnCount,
          width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
ColumnSizer.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(1792);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a" /* default */]);


/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__ = __webpack_require__(377);









/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'resetLoadMoreRowsCache',
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;

      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: '_doStuff',
    value: function _doStuff(startIndex, stopIndex) {
      var _this3 = this;

      var _props = this.props,
          isRowLoaded = _props.isRowLoaded,
          minimumBatchSize = _props.minimumBatchSize,
          rowCount = _props.rowCount,
          threshold = _props.threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
      }, []);

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
InfiniteLoader.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref2) {
  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref2.lastRenderedStopIndex,
      startIndex = _ref2.startIndex,
      stopIndex = _ref2.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref3) {
  var isRowLoaded = _ref3.isRowLoaded,
      minimumBatchSize = _ref3.minimumBatchSize,
      rowCount = _ref3.rowCount,
      startIndex = _ref3.startIndex,
      stopIndex = _ref3.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(675);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(245);
/* unused harmony reexport bpfrpt_proptype_RowRendererParams */








/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1795), __esModule: true };

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1796);
var $Object = __webpack_require__(26).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(114);
var $getOwnPropertyDescriptor = __webpack_require__(364).f;

__webpack_require__(365)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Masonry__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Masonry__["a"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Masonry__["a" /* default */]);


/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCellPositioner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Masonry__ = __webpack_require__(379);


function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;

  var columnHeights = void 0;

  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;
    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;

    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;

    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];
    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;

    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;

  return cellPositioner;
}



/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(659);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__ = __webpack_require__(1808);





// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache = function () {
  function PositionCache() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PositionCache);

    this._columnSizeMap = {};
    this._intervalTree = Object(__WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__["a" /* default */])();
    this._leftMap = {};
  }
  // Tracks the height of each column


  // Store tops and bottoms of each cell for fast intersection lookup.


  // Maps cell index to x coordinates for quick lookup.


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PositionCache, [{
    key: 'estimateTotalHeight',
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }

    // Render all cells visible within the viewport range defined.

  }, {
    key: 'range',
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: 'setPosition',
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);
      this._leftMap[index] = left;

      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];
      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: 'count',
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: 'shortestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: 'tallestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (PositionCache);

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1802);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1805);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1803), __esModule: true };

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237);
__webpack_require__(173);
module.exports = __webpack_require__(1804);


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(360);
var ITERATOR = __webpack_require__(41)('iterator');
var Iterators = __webpack_require__(141);
module.exports = __webpack_require__(26).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1806), __esModule: true };

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237);
__webpack_require__(173);
module.exports = __webpack_require__(1807);


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(67);
var get = __webpack_require__(359);
module.exports = __webpack_require__(26).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__ = __webpack_require__(1809);
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/



var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin);
    var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.left.remove(interval);
    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.right.remove(interval);
    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS;
    }
    for (var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);

  var mid = pts[pts.length >> 1];

  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }

  //Split center intervals
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);

  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}

//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);
    if (r === EMPTY) {
      this.root = null;
    }
    return r !== NOT_FOUND;
  }
  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});

Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});

function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }
  return new IntervalTree(createIntervalTree(intervals));
}

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(1811);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a" /* default */]);


/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(42);













var SCROLLBAR_SIZE_BUFFER = 20;

/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _initialiseProps.call(_this);

    var deferredMeasurementCache = props.deferredMeasurementCache,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount;


    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'forceUpdateGrids',
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }

    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$columnIndex = _ref2.columnIndex,
          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
          _ref2$rowIndex = _ref2.rowIndex,
          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;

      var _props = this.props,
          fixedColumnCount = _props.fixedColumnCount,
          fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          scrollLeft = _props2.scrollLeft,
          scrollTop = _props2.scrollTop;


      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          onScroll = _props3.onScroll,
          onSectionRendered = _props3.onSectionRendered,
          onScrollbarPresenceChange = _props3.onScrollbarPresenceChange,
          scrollLeftProp = _props3.scrollLeft,
          scrollToColumn = _props3.scrollToColumn,
          scrollTopProp = _props3.scrollTop,
          scrollToRow = _props3.scrollToRow,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      this._prepareForRender();

      // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }

      // scrollTop and scrollLeft props are explicitly filtered out and ignored

      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _props4 = this.props,
          columnWidth = _props4.columnWidth,
          enableFixedColumnScroll = _props4.enableFixedColumnScroll,
          enableFixedRowScroll = _props4.enableFixedRowScroll,
          height = _props4.height,
          fixedColumnCount = _props4.fixedColumnCount,
          fixedRowCount = _props4.fixedRowCount,
          rowHeight = _props4.rowHeight,
          style = _props4.style,
          styleBottomLeftGrid = _props4.styleBottomLeftGrid,
          styleBottomRightGrid = _props4.styleBottomRightGrid,
          styleTopLeftGrid = _props4.styleTopLeftGrid,
          styleTopRightGrid = _props4.styleTopRightGrid,
          width = _props4.width;


      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          overflow: 'visible', // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible', // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: '_prepareForRender',
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;


      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'BottomLeftGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._bottomLeftGridStyle, {
              height: height,
              width: width,
              overflowY: 'hidden'
            }) },
          bottomLeftGrid
        );
      }
      return bottomLeftGrid;
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _state2 = this.state,
          showHorizontalScrollbar = _state2.showHorizontalScrollbar,
          scrollbarSize = _state2.scrollbarSize;


      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'TopRightGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
              height: height,
              width: width,
              overflowX: 'hidden'
            }) },
          topRightGrid
        );
      }
      return topRightGrid;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

MultiGrid.defaultProps = {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = {
    scrollLeft: 0,
    scrollTop: 0,
    scrollbarSize: 0,
    showHorizontalScrollbar: false,
    showVerticalScrollbar: false
  };
  this._deferredInvalidateColumnIndex = null;
  this._deferredInvalidateRowIndex = null;

  this._bottomLeftGridRef = function (ref) {
    _this2._bottomLeftGrid = ref;
  };

  this._bottomRightGridRef = function (ref) {
    _this2._bottomRightGrid = ref;
  };

  this._cellRendererBottomLeftGrid = function (_ref3) {
    var rowIndex = _ref3.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['rowIndex']);

    var _props5 = _this2.props,
        cellRenderer = _props5.cellRenderer,
        fixedRowCount = _props5.fixedRowCount,
        rowCount = _props5.rowCount;


    if (rowIndex === rowCount - fixedRowCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          height: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        parent: _this2,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  };

  this._cellRendererBottomRightGrid = function (_ref4) {
    var columnIndex = _ref4.columnIndex,
        rowIndex = _ref4.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex', 'rowIndex']);

    var _props6 = _this2.props,
        cellRenderer = _props6.cellRenderer,
        fixedColumnCount = _props6.fixedColumnCount,
        fixedRowCount = _props6.fixedRowCount;


    return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
      columnIndex: columnIndex + fixedColumnCount,
      parent: _this2,
      rowIndex: rowIndex + fixedRowCount
    }));
  };

  this._cellRendererTopRightGrid = function (_ref5) {
    var columnIndex = _ref5.columnIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['columnIndex']);

    var _props7 = _this2.props,
        cellRenderer = _props7.cellRenderer,
        columnCount = _props7.columnCount,
        fixedColumnCount = _props7.fixedColumnCount;


    if (columnIndex === columnCount - fixedColumnCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          width: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _this2
      }));
    }
  };

  this._columnWidthRightGrid = function (_ref6) {
    var index = _ref6.index;
    var _props8 = _this2.props,
        columnCount = _props8.columnCount,
        fixedColumnCount = _props8.fixedColumnCount,
        columnWidth = _props8.columnWidth;
    var _state3 = _this2.state,
        scrollbarSize = _state3.scrollbarSize,
        showHorizontalScrollbar = _state3.showHorizontalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
      return scrollbarSize;
    }

    return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
  };

  this._onScroll = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft,
        scrollTop = scrollInfo.scrollTop;

    _this2.setState({
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    });
    var onScroll = _this2.props.onScroll;
    if (onScroll) {
      onScroll(scrollInfo);
    }
  };

  this._onScrollbarPresenceChange = function (_ref7) {
    var horizontal = _ref7.horizontal,
        size = _ref7.size,
        vertical = _ref7.vertical;
    var _state4 = _this2.state,
        showHorizontalScrollbar = _state4.showHorizontalScrollbar,
        showVerticalScrollbar = _state4.showVerticalScrollbar;


    if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
      _this2.setState({
        scrollbarSize: size,
        showHorizontalScrollbar: horizontal,
        showVerticalScrollbar: vertical
      });

      var onScrollbarPresenceChange = _this2.props.onScrollbarPresenceChange;

      if (typeof onScrollbarPresenceChange === 'function') {
        onScrollbarPresenceChange({
          horizontal: horizontal,
          size: size,
          vertical: vertical
        });
      }
    }
  };

  this._onScrollLeft = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft;

    _this2._onScroll({
      scrollLeft: scrollLeft,
      scrollTop: _this2.state.scrollTop
    });
  };

  this._onScrollTop = function (scrollInfo) {
    var scrollTop = scrollInfo.scrollTop;

    _this2._onScroll({
      scrollTop: scrollTop,
      scrollLeft: _this2.state.scrollLeft
    });
  };

  this._rowHeightBottomGrid = function (_ref8) {
    var index = _ref8.index;
    var _props9 = _this2.props,
        fixedRowCount = _props9.fixedRowCount,
        rowCount = _props9.rowCount,
        rowHeight = _props9.rowHeight;
    var _state5 = _this2.state,
        scrollbarSize = _state5.scrollbarSize,
        showVerticalScrollbar = _state5.showVerticalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
      return scrollbarSize;
    }

    return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
  };

  this._topLeftGridRef = function (ref) {
    _this2._topLeftGrid = ref;
  };

  this._topRightGridRef = function (ref) {
    _this2._topRightGrid = ref;
  };
};

MultiGrid.propTypes =  false ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["a" /* polyfill */])(MultiGrid);

/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(673);




/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator = function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCacheDecorator);

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    };

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;


    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCacheDecorator, [{
    key: 'clear',
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCacheDecorator);

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(1814);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          clientHeight = _state.clientHeight,
          clientWidth = _state.clientWidth,
          scrollHeight = _state.scrollHeight,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop,
          scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;

      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMultiSort__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Column__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortDirection__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortIndicator__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(1817);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createMultiSort__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__SortDirection__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__SortIndicator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__Table__["a"]; });











/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */]);


/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMultiSort;


function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error('Required parameter "sortCallback" not specified');
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};

  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);
      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      sortBy.length = 0;
      sortBy.push(dataKey);

      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    }

    // Notify application code
    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SortDirection__ = __webpack_require__(246);




















/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _React$PureComponent);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _Grid$getOffsetForCel.scrollTop;

        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeader = _props.disableHeader,
          gridClassName = _props.gridClassName,
          gridStyle = _props.gridStyle,
          headerHeight = _props.headerHeight,
          headerRowRenderer = _props.headerRowRenderer,
          height = _props.height,
          id = _props.id,
          noRowsRenderer = _props.noRowsRenderer,
          rowClassName = _props.rowClassName,
          rowStyle = _props.rowStyle,
          scrollToIndex = _props.scrollToIndex,
          style = _props.style,
          width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flexStyles, {
          overflow: 'hidden'
        });
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table', className),
          id: id,
          role: 'grid',
          style: style },
        !disableHeader && headerRowRenderer({
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerRow', rowClass),
          columns: this._getHeaderColumns(),
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rowStyleObject, {
            height: headerHeight,
            overflow: 'hidden',
            paddingRight: scrollbarWidth,
            width: width
          })
        }),
        __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          autoContainerWidth: true,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: this._setRef,
          role: 'rowgroup',
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-describedby': id,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__rowColumn', className),
          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
          role: 'gridcell',
          style: style,
          title: title },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _props2 = this.props,
          headerClassName = _props2.headerClassName,
          headerStyle = _props2.headerStyle,
          onHeaderClick = _props2.onHeaderClick,
          sort = _props2.sort,
          sortBy = _props2.sortBy,
          sortDirection = _props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;

      var sortEnabled = !disableSort && sort;

      var classNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headerStyle, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var headerOnClick = void 0,
          headerOnKeyDown = void 0,
          headerTabIndex = void 0,
          headerAriaSort = void 0,
          headerAriaLabel = void 0;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey;

        // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC ? 'ascending' : 'descending';
      }

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': headerAriaLabel,
          'aria-sort': headerAriaSort,
          className: classNames,
          id: id,
          key: 'Header-Col' + index,
          onClick: headerOnClick,
          onKeyDown: headerOnKeyDown,
          role: 'columnheader',
          style: style,
          tabIndex: headerTabIndex },
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _props3 = this.props,
          children = _props3.children,
          onRowClick = _props3.onRowClick,
          onRowDoubleClick = _props3.onRowDoubleClick,
          onRowRightClick = _props3.onRowRightClick,
          onRowMouseOver = _props3.onRowMouseOver,
          onRowMouseOut = _props3.onRowMouseOut,
          rowClassName = _props3.rowClassName,
          rowGetter = _props3.rowGetter,
          rowRenderer = _props3.rowRenderer,
          rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, rowStyleObject, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      });

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getHeaderColumns',
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _props4 = this.props,
          children = _props4.children,
          disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(this.Grid);
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        var scrollbarWidth = offsetWidth - clientWidth;

        this.setState({ scrollbarWidth: scrollbarWidth });
      }
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  headerRowRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
Table.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : {};


/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a"]; });
/* unused harmony reexport IS_SCROLLING_TIMEOUT */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a" /* default */]);


/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowScroller_js__ = __webpack_require__(683);



var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });

  disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}


/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollOffset;


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */

var isWindow = function isWindow(element) {
  return element === window;
};

// TODO Move this into WindowScroller and import from there


var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;

    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}

/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */
function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}

/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.once = once;
exports.on = on;
exports.off = off;
exports.isKeyboard = isKeyboard;
exports.createEventBinding = createEventBinding;

var _context = __webpack_require__(93);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function once(el, type, callback) {
  var typeArray = type ? type.split(' ') : [];
  var recursiveFunction = function recursiveFunction(event) {
    event.target.removeEventListener(event.type, recursiveFunction);
    return callback(event);
  };

  for (var i = typeArray.length - 1; i >= 0; i--) {
    this.on(el, typeArray[i], recursiveFunction);
  }
}

function on(el, type, callback, options) {
  if (el.addEventListener) {
    el.addEventListener(type, callback, options);
  } else {
    // IE8+ Support
    el.attachEvent('on' + type, callback);
  }
}

function off(el, type, callback, options) {
  if (el.removeEventListener) {
    el.removeEventListener(type, callback, options);
  } else {
    // IE8+ Support
    el.detachEvent('on' + type, callback);
  }
}

function isKeyboard(event) {
  return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
}

function createEventBinding() {
  for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  return function () {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _context2['default'].document;
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var options = arguments[2];

    names.forEach(function (event) {
      return on(el, event, cb, options);
    });
    return function () {
      return names.forEach(function (event) {
        return off(el, event, cb, options);
      });
    };
  };
}

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = deprecateComponent;
function deprecateComponent(MyComponent, message) {
  var warning = message || (MyComponent && MyComponent.name ? MyComponent.name + ' will be removed.' : (typeof MyComponent === 'undefined' ? 'undefined' : _typeof(MyComponent)) + ' will be removed.');

  if (false) {
    console.warn('Deprecation: ' + warning);
  }

  return MyComponent;
}

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Input = __webpack_require__(247);

var _Input2 = _interopRequireDefault(_Input);

var _Form = __webpack_require__(186);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputListItem', function (theme) {
  return _defineProperty({
    root: {
      marginLeft: theme.typography.rhythmByUnit(6),
      marginRight: theme.typography.rhythmByUnit(4),
      marginTop: theme.typography.rhythmByUnit(4),
      backgroundColor: theme.palette.background.paper
    },
    form: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid ' + theme.palette.text.lightDivider,
      padding: theme.typography.rhythmByUnit(1)
    },
    input: {
      flexGrow: 1,
      marginLeft: theme.typography.rhythmByUnit(1),
      marginRight: theme.typography.rhythmByUnit(1)
    }
  }, theme.breakpoints.down('sm'), {
    button: {
      display: 'none'
    },
    root: {
      marginLeft: 0,
      marginRight: 0
    },
    form: {
      border: 'none',
      borderTop: '1px solid ' + theme.palette.text.lightDivider,
      borderRadius: 0,
      flex: 1
    }
  });
});

var InputListItem = (_temp = _class = function (_PureComponent) {
  _inherits(InputListItem, _PureComponent);

  function InputListItem() {
    _classCallCheck(this, InputListItem);

    return _possibleConstructorReturn(this, (InputListItem.__proto__ || Object.getPrototypeOf(InputListItem)).apply(this, arguments));
  }

  _createClass(InputListItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            formClassNameProp = _props.formClassName,
            inputClassNameProp = _props.inputClassName,
            onSubmit = _props.onSubmit,
            icon = _props.icon,
            buttonProp = _props.button,
            other = _objectWithoutProperties(_props, ['className', 'formClassName', 'inputClassName', 'onSubmit', 'icon', 'button']);

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(classes.root, classNameProp);
        var formClassName = (0, _classnames2['default'])(classes.form, formClassNameProp);
        var inputClassName = (0, _classnames2['default'])(classes.input, inputClassNameProp);

        var button = (0, _react.isValidElement)(buttonProp) ? _react2['default'].cloneElement(buttonProp, {
          className: (0, _classnames2['default'])(classes.button, buttonProp.props.className)
        }) : buttonProp;

        return _react2['default'].createElement(
          'div',
          { className: rootClassName },
          _react2['default'].createElement(
            _Form2['default'],
            { className: formClassName, onSubmit: onSubmit },
            icon,
            _react2['default'].createElement(_Input2['default'], _extends({ className: inputClassName, underline: false }, other)),
            button
          )
        );
      }

      return render;
    }()
  }]);

  return InputListItem;
}(_react.PureComponent), _class.displayName = 'InputListItem', _class.propTypes = {
  /**
   * Classname applied to the root element
   */
  className: _PropTypes2['default'].string,
  /**
   * Classname applied to the form element
   */
  formClassName: _PropTypes2['default'].string,
  /**
   * Classname applied to the input element
   */
  inputClassName: _PropTypes2['default'].string,
  /**
   * Function called when form submission occurs
   */
  onSubmit: _PropTypes2['default'].func,
  /**
   * Optional icon to be displayed on the left side of the input
   */
  icon: _PropTypes2['default'].node,
  /**
   * Optional button to be displayed on the right side of the input
   */
  button: _PropTypes2['default'].node
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
}, _temp);
exports['default'] = InputListItem;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ = __webpack_require__(69);

var _2 = _interopRequireDefault(_);

var _jssThemeReactor = __webpack_require__(6);

var _InfiniteScroll = __webpack_require__(684);

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _orderBy2 = __webpack_require__(1825);

var _orderBy3 = _interopRequireDefault(_orderBy2);

var _groupBy2 = __webpack_require__(1846);

var _groupBy3 = _interopRequireDefault(_groupBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var passthrough = function passthrough(v) {
  return v;
};

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListGroup', function (theme) {
  var _ref;

  return _ref = {
    root: {
      backgroundColor: theme.palette.background.paper
    },
    expandItemHeight: {
      marginTop: theme.typography.rhythmByUnit(2),
      marginBottom: theme.typography.rhythmByUnit(2)
    },
    firstExpandItemHeight: {
      marginTop: 0
    },
    lastExpandItemHeight: {
      marginBottom: 0
    }
  }, _defineProperty(_ref, theme.breakpoints.up('sm'), {
    expandableList: {
      paddingLeft: theme.typography.rhythmByUnit(2),
      paddingRight: theme.typography.rhythmByUnit(2)
    },
    expandItemWidth: {
      marginRight: theme.typography.rhythmByUnit(-2),
      marginLeft: theme.typography.rhythmByUnit(-2)
    }
  }), _defineProperty(_ref, 'progress', {
    paddingTop: theme.typography.rhythmByUnit(2),
    paddingBottom: theme.typography.rhythmByUnit(2)
  }), _ref;
});

var ListGroup = (_temp2 = _class = function (_PureComponent) {
  _inherits(ListGroup, _PureComponent);

  function ListGroup() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ListGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ListGroup.__proto__ || Object.getPrototypeOf(ListGroup)).call.apply(_ref2, [this].concat(args))), _this), _this.renderListItemText = function (value) {
      return typeof value === 'string' ? _react2['default'].createElement(_.ListItemText, { primary: value }) : _react2['default'].createElement(_.ListItemText, value);
    }, _this.renderListItem = function (value, className, key, index, length) {
      var expandable = _this.props.expandable;


      if ((0, _react.isValidElement)(value)) {
        var expand = value.props.expand;


        return _react2['default'].createElement(
          'div',
          { key: key + '.' + index },
          _react2['default'].cloneElement(value, expandable ? { className: className, divider: index !== length } : // Don't pass an expand prop through to the
          // item if it was provided and the ListGroup is
          // not expandable
          Object.assign({
            divider: index !== length
          }, expand !== undefined && { expand: false }))
        );
      }

      var props = typeof value === 'string' ? { primary: value } : value;

      var _props = Object.assign({}, props.onClick || props.href ? { button: true, ripple: false } : {}, props),
          onClick = _props.onClick,
          href = _props.href,
          button = _props.button,
          ripple = _props.ripple,
          _props$divider = _props.divider,
          divider = _props$divider === undefined ? true : _props$divider,
          _props$dense = _props.dense,
          dense = _props$dense === undefined ? true : _props$dense,
          others = _objectWithoutProperties(_props, ['onClick', 'href', 'button', 'ripple', 'divider', 'dense']);

      return _react2['default'].createElement(
        'div',
        { key: key + '.' + index, className: className },
        _react2['default'].createElement(
          _.ListItem,
          {
            onClick: onClick,
            href: href,
            button: button,
            ripple: ripple,
            dense: dense,
            divider: index !== length
          },
          _this.renderListItemText(others)
        )
      );
    }, _this.renderList = function (values, key) {
      var _classNames2;

      var _this$props = _this.props,
          mapListItem = _this$props.mapListItem,
          maxLength = _this$props.maxLength,
          elevation = _this$props.elevation,
          collapseBy = _this$props.collapseBy,
          expandable = _this$props.expandable,
          loadMore = _this$props.loadMore,
          hasMore = _this$props.hasMore,
          threshold = _this$props.threshold,
          scrollEl = _this$props.scrollEl,
          waitingForLoad = _this$props.waitingForLoad,
          children = _this$props.children;


      var valuesLength = values.length - 1;
      var classes = _this.context.styleManager.render(styleSheet);
      var listClassName = (0, _classnames2['default'])(_defineProperty({}, classes.expandableList, expandable));
      var listItemClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, classes.expandItemHeight, expandable), _defineProperty(_classNames2, classes.expandItemWidth, expandable), _classNames2));

      var items = values;
      if (maxLength != null) {
        items = items.slice(0, maxLength);
      }
      items = items.map(function (v, i) {
        var _classNames3;

        var itemClasses = (0, _classnames2['default'])(listItemClassName, (_classNames3 = {}, _defineProperty(_classNames3, classes.firstExpandItemHeight, expandable && i === 0), _defineProperty(_classNames3, classes.lastExpandItemHeight, expandable && i === valuesLength), _classNames3));
        return _this.renderListItem(mapListItem(v), itemClasses, key, i, valuesLength);
      });

      var Content = function () {
        function Content() {
          return _react2['default'].createElement(
            _2['default'],
            { collapse: collapseBy, padding: false, className: listClassName },
            items,
            children
          );
        }

        return Content;
      }();

      // disable infinite scroll on this element when in grouped mode since we have it on our parent
      var infiniteSort = key === 'list' && loadMore;
      if (infiniteSort) {
        return _react2['default'].createElement(
          _InfiniteScroll2['default'],
          {
            waitingForLoad: waitingForLoad,
            threshold: threshold,
            scrollEl: scrollEl,
            loadMore: loadMore,
            hasMore: hasMore
          },
          _react2['default'].createElement(Content, null)
        );
      }

      return _react2['default'].createElement(Content, null);
    }, _this.renderListGroup = function (value) {
      var _this$props2 = _this.props,
          groupOrder = _this$props2.groupOrder,
          containerHeight = _this$props2.containerHeight,
          className = _this$props2.className,
          scrollEl = _this$props2.scrollEl,
          loadMore = _this$props2.loadMore,
          threshold = _this$props2.threshold,
          waitingForLoad = _this$props2.waitingForLoad,
          hasMore = _this$props2.hasMore;


      var keys = groupOrder || Object.keys(value).sort();

      var items = keys.filter(function (k) {
        return value[k];
      }).map(function (k) {
        return _react2['default'].createElement(
          'div',
          { key: k },
          _this.renderHeading(_this.props.mapHeading(k)),
          _this.renderList(value[k], k + '.list')
        );
      });

      return _react2['default'].createElement(
        'div',
        { className: className },
        loadMore ? _react2['default'].createElement(
          _InfiniteScroll2['default'],
          {
            waitingForLoad: waitingForLoad,
            threshold: threshold,
            scrollEl: scrollEl,
            loadMore: loadMore,
            hasMore: hasMore
          },
          items
        ) : items
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ListGroup, [{
    key: 'renderHeading',
    value: function () {
      function renderHeading(value) {
        return typeof value === 'string' ? _react2['default'].createElement(
          _.ListSubheader,
          null,
          value
        ) : _react2['default'].createElement(_.ListSubheader, value);
      }

      return renderHeading;
    }()
  }, {
    key: 'groupBy',
    value: function () {
      function groupBy(data, key) {
        return (0, _groupBy3['default'])(data, key);
      }

      return groupBy;
    }()
  }, {
    key: 'orderBy',
    value: function () {
      function orderBy(data, keys, orders) {
        return (0, _orderBy3['default'])(data, keys, orders);
      }

      return orderBy;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            value = _props2.value,
            classNameProp = _props2.classNameProp,
            groupBy = _props2.groupBy,
            sortByProp = _props2.sortBy,
            orderByProp = _props2.orderBy;

        var sortBy = sortByProp === undefined || sortByProp instanceof Array ? sortByProp : [sortByProp];
        var orderBy = orderByProp === undefined ? [] : orderByProp instanceof Array ? orderByProp : [orderByProp];
        var data = (value || []).slice();
        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);

        if (sortBy) {
          data = this.orderBy(data, sortBy, orderBy);
        }
        if (groupBy) {
          data = this.groupBy(data, groupBy);
        }

        return _react2['default'].createElement(
          'div',
          { className: className },
          data instanceof Array ? this.renderList(data, 'list') : this.renderListGroup(data)
        );
      }

      return render;
    }()
  }]);

  return ListGroup;
}(_react.PureComponent), _class.propTypes = {
  /**
   * List elements to be displayed
   */
  value: _PropTypes2['default'].array,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  classNameProp: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].array]),
  containerHeight: _PropTypes2['default'].number,
  /**
   * Function that takes a list item's props as argument and collapses item if it returns true.
   */
  collapseBy: _PropTypes2['default'].func,
  /**
   * If true, expansion styling applied to list and items
   */
  expandable: _PropTypes2['default'].bool,
  /**
   * Key or function to sort items by
   */
  sortBy: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func, _PropTypes2['default'].arrayOf(_PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]))]),
  /**
   * Key or function to order items by
   */
  orderBy: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func, _PropTypes2['default'].arrayOf(_PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]))]),
  /**
   * Key or function to group items by
   */
  groupBy: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Ordered list of group headers
   */
  groupOrder: _PropTypes2['default'].arrayOf(_PropTypes2['default'].string),
  /**
   * Map the group heading value
   */
  mapHeading: _PropTypes2['default'].func,
  /**
   * Formats the value item to ListItem properties
   */
  mapListItem: _PropTypes2['default'].func,
  /**
   * Length of elements to be displayed
   */
  maxLength: _PropTypes2['default'].number,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   */
  elevation: _PropTypes2['default'].number,

  /**
   * A callback when more items are requested by react-infinite-scroller.
   */
  loadMore: _PropTypes2['default'].func,

  /**
   * the distance from the bottom of the container (in px) at which to call `loadMore`
   */
  threshold: _PropTypes2['default'].number,

  /**
   * Whether there are more items to be loaded by react-infinite-scroller.
   */
  hasMore: _PropTypes2['default'].bool,

  /**
   * The element to be used for infinite scrolling calculations.
   */
  scrollEl: _PropTypes2['default'].object,

  /**
   * Element to render while loading more data. Defaults to a CircularProgress indicator,
   * which is recommended by Material UI.
   */
  loader: _PropTypes2['default'].element,

  /**
   * boolean indicating whether or not `loadMore` should be called
   */
  waitingForLoad: _PropTypes2['default'].bool,

  /**
   * Can be any node or number of nodes.
   */
  children: _PropTypes2['default'].node
}, _class.defaultProps = {
  mapHeading: passthrough,
  mapListItem: passthrough,
  expandable: false,
  elevation: 2
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = ListGroup;


ListGroup.displayName = 'ListGroup';

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(1826),
    isArray = __webpack_require__(70);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(781),
    baseIteratee = __webpack_require__(428),
    baseMap = __webpack_require__(1838),
    baseSortBy = __webpack_require__(1843),
    baseUnary = __webpack_require__(843),
    compareMultiple = __webpack_require__(1844),
    identity = __webpack_require__(430);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1828),
    getMatchData = __webpack_require__(1829),
    matchesStrictComparable = __webpack_require__(686);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(423),
    baseIsEqual = __webpack_require__(368);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(685),
    keys = __webpack_require__(414);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(368),
    get = __webpack_require__(839),
    hasIn = __webpack_require__(1832),
    isKey = __webpack_require__(380),
    isStrictComparable = __webpack_require__(685),
    matchesStrictComparable = __webpack_require__(686),
    toKey = __webpack_require__(199);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1831 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1833),
    hasPath = __webpack_require__(1834);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1833 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(688),
    isArguments = __webpack_require__(427),
    isArray = __webpack_require__(70),
    isIndex = __webpack_require__(842),
    isLength = __webpack_require__(637),
    toKey = __webpack_require__(199);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1836),
    basePropertyDeep = __webpack_require__(1837),
    isKey = __webpack_require__(380),
    toKey = __webpack_require__(199);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1836 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(687);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(689),
    isArrayLike = __webpack_require__(266);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1840),
    keys = __webpack_require__(414);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1841);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1841 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(266);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1843 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1845);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(429);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(782),
    createAggregator = __webpack_require__(1849);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1848);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1848 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1850),
    baseAggregator = __webpack_require__(1851),
    baseIteratee = __webpack_require__(428),
    isArray = __webpack_require__(70);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 1850 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(689);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListItemIcon', function (theme) {
  return {
    root: {
      flex: 'none',
      height: theme.typography.rhythmByUnit(3),
      width: theme.typography.rhythmByUnit(3)
    }
  };
});

var ListItemIcon = function (_Component) {
  _inherits(ListItemIcon, _Component);

  function ListItemIcon() {
    _classCallCheck(this, ListItemIcon);

    return _possibleConstructorReturn(this, (ListItemIcon.__proto__ || Object.getPrototypeOf(ListItemIcon)).apply(this, arguments));
  }

  _createClass(ListItemIcon, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            classNameProp = _props.className,
            other = _objectWithoutProperties(_props, ['children', 'className']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp, children.props.className);

        return (0, _react.cloneElement)(children, Object.assign({
          className: className
        }, other));
      }

      return render;
    }()
  }]);

  return ListItemIcon;
}(_react.Component);

exports['default'] = ListItemIcon;

ListItemIcon.displayName = 'ListItemIcon';

ListItemIcon.muiName = 'ListItemIcon';

ListItemIcon.propTypes = {
  children: _PropTypes2['default'].element.isRequired,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
};

ListItemIcon.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectable = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _ListItem = __webpack_require__(369);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _SearchListItem = __webpack_require__(255);

var _SearchListItem2 = _interopRequireDefault(_SearchListItem);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SelectableList', function (theme) {
  return {
    selected: {
      backgroundColor: theme.palette.text.divider
    }
  };
});

var makeSelectable = function makeSelectable(MyComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.extendChild = function (child) {
        var _ref2 = child || {},
            _ref2$type = _ref2.type;

        _ref2$type = _ref2$type === undefined ? {} : _ref2$type;
        var muiName = _ref2$type.muiName;


        if (!(muiName === _ListItem2['default'].muiName || muiName === _SearchListItem2['default'].muiName)) {
          return;
        }

        var selectedItemStyle = _this.props.selectedItemStyle;

        var childIsSelected = _this.isChildSelected(child, _this.props);

        var classes = _this.context.styleManager.render(styleSheet);
        var selectedClass = (0, _classnames2['default'])(classes.selected);

        var mergedChildrenStyles = Object.assign({}, child.props.style, childIsSelected ? selectedItemStyle : {});
        var mergedChildrenClasses = (0, _classnames2['default'])(child.props.className, _defineProperty({}, selectedClass, childIsSelected && !selectedItemStyle));

        return _react2['default'].cloneElement(child, {
          onClick: function () {
            function onClick(event) {
              _this.handleItemClick(event, child);
              if (child.props.onClick) {
                child.props.onClick(event);
              }
            }

            return onClick;
          }(),
          style: mergedChildrenStyles,
          className: mergedChildrenClasses
        });
      }, _this.handleItemClick = function (event, item) {
        var itemValue = item.props.value;

        if (itemValue !== _this.props.value) {
          if (_this.props.onChange) {
            _this.props.onChange(event, itemValue);
          }
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'isChildSelected',
      value: function () {
        function isChildSelected(child, props) {
          return props.value === child.props.value;
        }

        return isChildSelected;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var _this2 = this;

          var _props = this.props,
              children = _props.children,
              selectedItemStyle = _props.selectedItemStyle,
              other = _objectWithoutProperties(_props, ['children', 'selectedItemStyle']);

          return _react2['default'].createElement(
            MyComponent,
            _extends({}, other, this.state),
            _react.Children.map(children, function (child) {
              return _this2.extendChild(child);
            })
          );
        }

        return render;
      }()
    }]);

    return _class;
  }(_react.Component), _class.propTypes = {
    children: _PropTypes2['default'].node,
    onChange: _PropTypes2['default'].func,
    selectedItemStyle: _PropTypes2['default'].object,
    value: _PropTypes2['default'].any
  }, _class.contextTypes = {
    styleManager: _PropTypes2['default'].styleManager.isRequired
  }, _class.displayName = 'makeSelectable', _temp2;
};

exports.makeSelectable = makeSelectable;
exports['default'] = makeSelectable;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = InputLabel;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _Form = __webpack_require__(186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputLabel', function (theme) {
  var transitions = theme.transitions,
      typography = theme.typography,
      variables = theme.variables;

  return {
    root: theme.mixins.truncate({
      transformOrigin: 'top left',
      width: '100%',
      maxWidth: '100%',
      textAlign: 'left',
      zIndex: theme.zIndex.formLabel
    }),
    rootInlineAction: {
      width: 'calc(100% - ' + variables.textFieldPadding + 'px)'
    },
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      transform: 'translate(0, ' + (variables.formControlMarginTop + 4) + 'px) scale(1)', // Offset padding and border: 4px
      fontSize: typography.verticalRhythmByPixel(14).fontSize,
      lineHeight: typography.verticalRhythmByPixel(parseInt(typography.rhythmByUnit(2))).lineHeight
    },
    formControlDescription: {
      transform: 'translate(0, ' + (variables.formControlMarginTop * 2 + 4) + 'px) scale(1)' // Offset description, padding and border: 4px
    },
    formControlPadding: theme.mixins.gutters(1),
    shrink: {
      transform: 'translate(0, 0) scale(0.75)',
      transformOrigin: 'top left',
      width: '133%', // 133% <= 100% / .75 (scale ratio when shrunk)
      maxWidth: '133%', // Override Bootstap's maxWidth property on labels
      fontSize: typography.verticalRhythmByPixel(15 * 1.25).fontSize,
      lineHeight: typography.verticalRhythmByPixel(parseInt(typography.rhythmByUnit(2)) * 1.25).lineHeight
    },
    shrinkPadding: {
      paddingLeft: 0
    },
    floatingLabelFixed: Object.assign({
      position: 'static',
      overflow: 'visible',
      whiteSpace: 'normal',
      textOverflow: 'clip',
      marginBottom: typography.rhythmByUnit(-2),
      transform: 'none',
      transformOrigin: '50% 50% 0',
      width: '100%',
      maxWidth: '100%'
    }, typography.verticalRhythmByPixel(14)),
    animated: {
      transition: transitions.create(['transform', 'width', 'max-width', 'padding-left', 'font-size', 'line-height'], {
        duration: transitions.duration.shorter,
        easing: transitions.easing.easeOut
      })
    }
  };
});

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classNameProp = props.className,
      description = props.description,
      disableAnimation = props.disableAnimation,
      floatingLabelFixed = props.floatingLabelFixed,
      inlineAction = props.inlineAction,
      shrinkProp = props.shrink,
      underline = props.underline,
      other = _objectWithoutProperties(props, ['children', 'className', 'description', 'disableAnimation', 'floatingLabelFixed', 'inlineAction', 'shrink', 'underline']);

  var muiFormControl = context.muiFormControl,
      muiForm = context.muiForm,
      styleManager = context.styleManager;

  var classes = styleManager.render(styleSheet);
  var hasBorder = muiForm && underline === undefined || underline;

  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.dirty || muiFormControl.focused;
  }

  var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.rootInlineAction, inlineAction), _defineProperty(_classNames, classes.formControl, muiFormControl), _defineProperty(_classNames, classes.formControlDescription, muiFormControl && description), _defineProperty(_classNames, classes.formControlPadding, muiFormControl && hasBorder), _defineProperty(_classNames, classes.animated, !disableAnimation), _defineProperty(_classNames, classes.shrink, shrink), _defineProperty(_classNames, classes.shrinkPadding, shrink && hasBorder), _defineProperty(_classNames, classes.floatingLabelFixed, floatingLabelFixed), _classNames), classNameProp);

  return _react2['default'].createElement(
    _Form.FormLabel,
    _extends({ className: className, ellipsize: !floatingLabelFixed }, other),
    children
  );
}

InputLabel.displayName = 'InputLabel';

InputLabel.propTypes = {
  /**
   * The contents of the InputLabel.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, the input of this label has a description.
   */
  description: _PropTypes2['default'].bool,
  /**
   * If true, the transition animation is disabled.
   */
  disableAnimation: _PropTypes2['default'].bool,
  /**
   * If true, the label will be displayed in an error state.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If 'true', floating label will float even when there is no value
   */
  floatingLabelFixed: _PropTypes2['default'].bool,
  /**
   * If true, the input of this label is focused.
   */
  focused: _PropTypes2['default'].bool,
  /**
   * A component representing one or more actions shown to the right of the field
   */
  inlineAction: _PropTypes2['default'].node,
  /**
   * If true, the label will indicate that the input is required.
   */
  required: _PropTypes2['default'].bool,
  /**
   * If true, the label will display an asterisk as if the input is required.
   */
  requiredAsterisk: _PropTypes2['default'].bool,
  /**
   * If true, the label is shrunk.
   */
  shrink: _PropTypes2['default'].bool,
  /**
   * If set to true, the label will have additional padding.
   */
  underline: _PropTypes2['default'].bool
};

InputLabel.defaultProps = {
  disableAnimation: false
};

InputLabel.contextTypes = {
  muiForm: _PropTypes2['default'].object,
  muiFormControl: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = InputDescription;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _Text = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputDescription', function (theme) {
  var mixins = theme.mixins,
      typography = theme.typography,
      variables = theme.variables;

  return {
    root: Object.assign({
      width: '100%',
      maxWidth: '100%',
      textAlign: 'left',
      margin: variables.formControlMarginTop + 'px 0 ' + typography.rhythmByUnit(-2)
    }, typography.description),
    ellipsize: mixins.truncate()
  };
});

function InputDescription(props, context) {
  var children = props.children,
      classNameProp = props.className,
      floatingLabelFixed = props.floatingLabelFixed,
      label = props.label,
      other = _objectWithoutProperties(props, ['children', 'className', 'floatingLabelFixed', 'label']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.ellipsize, !floatingLabelFixed && label), classNameProp);

  return _react2['default'].createElement(
    _Text.Body1,
    _extends({ className: className }, other),
    children
  );
}

InputDescription.displayName = 'InputDescription';

InputDescription.propTypes = {
  /**
   * The contents of the InputDescription.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If 'true', floating label will float even when there is no value
   */
  floatingLabelFixed: _PropTypes2['default'].bool,
  /**
   * If true, the input of this description has a label.
   */
  label: _PropTypes2['default'].bool
};

InputDescription.defaultProps = {
  floatingLabelFixed: true,
  label: false
};

InputDescription.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //  weak

/**
 * A layout component using the following libs as inspiration.
 *
 * For the implementation:
 * - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
 * - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
 * - https://github.com/roylee0704/react-flexbox-grid
 * - https://material.angularjs.org/latest/layout/introduction
 *
 * Follow this flexbox Guide to better understand the underlying model:
 * - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
 */


var GUTTERS = [0, 8, 16, 24, 40];
var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  // For the auto layouting
  var styles = _defineProperty({}, 'grid-' + breakpoint, {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  });

  GRID_SIZES.forEach(function (size, index) {
    if (index === 0) {
      // Skip the first one as handle above.
      return;
    }

    // Only keep 6 significant numbers.
    var width = Math.round(size / 12 * Math.pow(10, 6)) / Math.pow(10, 4) + '%';

    /* eslint-disable max-len */
    // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/b0508a975d711d6b24c01f57dd5445c22699fac4/scss/mixins/_grid.scss#L69
    /* eslint-enable max-len */
    styles['grid-' + breakpoint + '-' + size] = {
      flexBasis: width,
      maxWidth: width
    };
  });

  // No need for a media query for the first size.
  if (breakpoint === 'xs') {
    Object.assign(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};

  GUTTERS.forEach(function (gutter, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles['gutter-' + breakpoint + '-' + gutter] = {
      margin: -gutter / 2,
      '& > $typeItem': {
        padding: gutter / 2
      }
    };
  });

  return styles;
}

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Layout', function (theme) {
  // Default CSS values
  // flex: '0 1 auto',
  // flexDirection: 'row',
  // alignItems: 'flex-start',
  // flexWrap: 'nowrap',
  // justifyContent: 'flex-start',

  return Object.assign({
    typeContainer: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap'
    },
    typeItem: {
      boxSizing: 'border-box',
      flex: '0 0 auto'
    },
    'direction-xs-column': {
      flexDirection: 'column'
    },
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },
    'align-xs-center': {
      alignItems: 'center'
    },
    'align-xs-flex-end': {
      alignItems: 'flex-end'
    },
    'align-xs-stretch': {
      alignItems: 'stretch'
    },
    'justify-xs-center': {
      justifyContent: 'center'
    },
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    }
  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (styles, key) {
    // Use side effect for performance.
    generateGrid(styles, theme, key);

    return styles;
  }, {}));
});

function Layout(props, context) {
  var _classNames;

  var children = props.children,
      className = props.className,
      ComponentProp = props.component,
      container = props.container,
      item = props.item,
      align = props.align,
      direction = props.direction,
      xs = props.xs,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      xl = props.xl,
      gutter = props.gutter,
      justify = props.justify,
      wrap = props.wrap,
      other = _objectWithoutProperties(props, ['children', 'className', 'component', 'container', 'item', 'align', 'direction', 'xs', 'sm', 'md', 'lg', 'xl', 'gutter', 'justify', 'wrap']);

  var classes = context.styleManager.render(styleSheet);

  return _react2['default'].createElement(
    ComponentProp,
    _extends({
      className: (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, classes.typeContainer, container), _defineProperty(_classNames, classes.typeItem, item), _defineProperty(_classNames, classes['gutter-xs-' + gutter], container && gutter !== 0), _defineProperty(_classNames, classes['direction-xs-' + direction], direction !== Layout.defaultProps.direction), _defineProperty(_classNames, classes['wrap-xs-' + wrap], wrap !== Layout.defaultProps.wrap), _defineProperty(_classNames, classes['align-xs-' + align], align !== Layout.defaultProps.align), _defineProperty(_classNames, classes['justify-xs-' + justify], justify !== Layout.defaultProps.justify), _defineProperty(_classNames, classes['grid-xs'], xs === true), _defineProperty(_classNames, classes['grid-xs-' + xs], xs && xs !== true), _defineProperty(_classNames, classes['grid-sm'], sm === true), _defineProperty(_classNames, classes['grid-sm-' + sm], sm && sm !== true), _defineProperty(_classNames, classes['grid-md'], md === true), _defineProperty(_classNames, classes['grid-md-' + md], md && md !== true), _defineProperty(_classNames, classes['grid-lg'], lg === true), _defineProperty(_classNames, classes['grid-lg-' + lg], lg && lg !== true), _defineProperty(_classNames, classes['grid-xl'], xl === true), _defineProperty(_classNames, classes['grid-xl-' + xl], xl && xl !== true), _classNames), className)
    }, other),
    children
  );
}

Layout.displayName = 'Layout';

Layout.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a ReactElement.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * It true, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _PropTypes2['default'].bool,
  /**
   * It true, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _PropTypes2['default'].bool,
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _PropTypes2['default'].oneOf(GRID_SIZES),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _PropTypes2['default'].oneOf(GRID_SIZES), // eslint-disable-line react/sort-prop-types
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _PropTypes2['default'].oneOf(GRID_SIZES), // eslint-disable-line react/sort-prop-types
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _PropTypes2['default'].oneOf(GRID_SIZES), // eslint-disable-line react/sort-prop-types
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _PropTypes2['default'].oneOf(GRID_SIZES), // eslint-disable-line react/sort-prop-types
  /**
   * Defines the `align-items` style property.
   * It's applied for all the screen sizes.
   */
  align: _PropTypes2['default'].oneOf([
  // eslint-disable-line react/sort-prop-types
  'flex-start', 'center', 'flex-end', 'stretch']),
  /**
   * Defines the `flex-direction` style property.
   * It's applied for all the screen sizes.
   */
  direction: _PropTypes2['default'].oneOf([
  // eslint-disable-line react/sort-prop-types
  'row', 'row-reverse', 'column', 'column-reverse']),
  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  gutter: _PropTypes2['default'].oneOf(GUTTERS), // eslint-disable-line react/sort-prop-types
  /**
   * Defines the `justify-content` style property.
   * It's applied for all the screen sizes.
   */
  justify: _PropTypes2['default'].oneOf([
  // eslint-disable-line react/sort-prop-types
  'flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all the screen sizes.
   */
  wrap: _PropTypes2['default'].oneOf([
  // eslint-disable-line react/sort-prop-types
  'nowrap', 'wrap', 'wrap-reverse'])
};

Layout.defaultProps = {
  component: 'div',
  container: false,
  item: false,
  align: 'flex-start',
  direction: 'row',
  gutter: 16,
  justify: 'flex-start',
  wrap: 'wrap'
};

Layout.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/**
 * Add a wrapper component to generate some helper messages in the development
 * environment.
 */
var LayoutWrapper = Layout; // eslint-disable-line import/no-mutable-exports

if (false) {
  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error('The property `' + propFullNameSafe + '` of ' + ('`Layout` must be used on `' + requiredProp + '`.'));
      }

      return null;
    };
  };

  LayoutWrapper = function LayoutWrapper(props) {
    return _react2['default'].createElement(Layout, props);
  }; // eslint-disable-line react/display-name

  LayoutWrapper.displayName = 'LayoutWrapper';

  LayoutWrapper.propTypes = {
    align: requireProp('container'),
    direction: requireProp('container'),
    gutter: requireProp('container'),
    justify: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    sm: requireProp('item'),
    md: requireProp('item'),
    lg: requireProp('item'),
    xl: requireProp('item')
  };
}

exports['default'] = LayoutWrapper;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ListContent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Display = __webpack_require__(726);

var _Display2 = _interopRequireDefault(_Display);

var _Headline = __webpack_require__(786);

var _Headline2 = _interopRequireDefault(_Headline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DISPLAY_NAME = 'ListContent';

function ListContent(props) {
  var children = props.children,
      display = props.display,
      headline = props.headline,
      other = _objectWithoutProperties(props, ['children', 'display', 'headline']);

  return _react2.default.createElement(
    'div',
    other,
    display && _react2.default.createElement(
      _Display2.default,
      null,
      display
    ),
    headline && _react2.default.createElement(
      _Headline2.default,
      null,
      headline
    ),
    children
  );
}
ListContent.displayName = DISPLAY_NAME;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarContainer = exports.toastMessage = exports.toastError = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _reactRedux = __webpack_require__(89);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reselect = __webpack_require__(33);

var _toast = __webpack_require__(183);

var _Snackbar = __webpack_require__(1859);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toast = (0, _reselect.createSelector)(function (state) {
  return state.toast || {};
}, function (toast) {
  return toast || {};
});

var toastError = exports.toastError = (0, _reselect.createSelector)(toast, function (_ref) {
  var error = _ref.error;
  return !!error;
});

var toastMessage = exports.toastMessage = (0, _reselect.createSelector)(toast, function (_ref2) {
  var message = _ref2.message;
  return message || '';
});

var SnackbarContainer = exports.SnackbarContainer = (_temp = _class = function (_PureComponent) {
  _inherits(SnackbarContainer, _PureComponent);

  function SnackbarContainer() {
    _classCallCheck(this, SnackbarContainer);

    return _possibleConstructorReturn(this, (SnackbarContainer.__proto__ || Object.getPrototypeOf(SnackbarContainer)).apply(this, arguments));
  }

  _createClass(SnackbarContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          errorProp = _props.error,
          _props$toast = _props.toast,
          toast = _props$toast === undefined ? {} : _props$toast,
          onRequestClose = _props.onRequestClose;
      var action = toast.action,
          errorToast = toast.error,
          _toast$message = toast.message,
          message = _toast$message === undefined ? '' : _toast$message,
          onActionClick = toast.onActionClick,
          _toast$open = toast.open,
          open = _toast$open === undefined ? false : _toast$open,
          autoHideDuration = toast.autoHideDuration;

      var error = errorProp || errorToast;
      return _react2.default.createElement(_Snackbar2.default, {
        action: action,
        error: error,
        message: message,
        onActionClick: onActionClick,
        open: open,
        onRequestClose: onRequestClose,
        autoHideDuration: autoHideDuration
      });
    }
  }]);

  return SnackbarContainer;
}(_react.PureComponent), _class.displayName = 'SnackbarContainer', _class.propTypes = {
  /**
   * Indicates the snackbar body should use the error color scheme
   */
  error: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
  /**
   * Toast settings for what to show in the snackbar
   */
  toast: _propTypes2.default.shape({
    action: _propTypes2.default.string,
    error: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
    message: _propTypes2.default.string,
    onActionClick: _propTypes2.default.func,
    open: _propTypes2.default.bool,
    autoHideDuration: _propTypes2.default.number
  }),
  /**
   * Fired when the Snackbar is requested to be closed
   */
  onRequestClose: _propTypes2.default.func
}, _temp);
exports.default = (0, _reactRedux.connect)(
// eslint-disable-next-line no-unused-vars
function (state, props) {
  return {
    toast: state.toast,
    error: toastError(state),
    message: toastMessage(state)
  };
}, function (dispatch) {
  return {
    onRequestClose: function onRequestClose(nextProps) {
      return dispatch((0, _toast.clearToast)(nextProps));
    }
  };
})(SnackbarContainer);

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _Snackbar = __webpack_require__(1860);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Snackbar2['default'];

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _SnackbarBody = __webpack_require__(1861);

var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('Snackbar', function (theme) {
  return {
    root: {
      position: 'fixed',
      left: '50%',
      display: 'flex',
      bottom: 0,
      zIndex: theme.zIndex.snackbar,
      visibility: 'hidden',
      transform: 'translate(-50%, 100%)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar
      }) + ', ' + theme.transitions.create('visibility', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar
      })
    },
    open: {
      visibility: 'visible',
      transform: 'translate(-50%, 0)'
    }
  };
});

var Snackbar = (_temp2 = _class = function (_Component) {
  _inherits(Snackbar, _Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.clickAway = function () {
      if (_this.timerTransitionId) {
        // If transitioning, don't close the snackbar.
        return;
      }

      if (_this.props.open !== null && _this.props.onRequestClose) {
        _this.props.onRequestClose('clickaway');
      } else {
        _this.setState({ open: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Snackbar, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        this.setState({
          open: this.props.open,
          message: this.props.message,
          action: this.props.action
        });
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (this.state.open) {
          this.setAutoHideTimer();
          this.setTransitionTimer();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
          this.setState({
            open: false
          });

          clearTimeout(this.timerOneAtTheTimeId);
          this.timerOneAtTheTimeId = setTimeout(function () {
            _this2.setState({
              message: nextProps.message,
              action: nextProps.action,
              open: true
            });
          }, this.context.styleManager.theme.transitions.duration.snackbar);
        } else {
          var open = nextProps.open;

          this.setState({
            open: open !== null ? open : this.state.open,
            message: nextProps.message,
            action: nextProps.action
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        if (prevState.open !== this.state.open) {
          if (this.state.open) {
            this.setAutoHideTimer();
            this.setTransitionTimer();
          } else {
            clearTimeout(this.timerAutoHideId);
          }
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        clearTimeout(this.timerAutoHideId);
        clearTimeout(this.timerTransitionId);
        clearTimeout(this.timerOneAtTheTimeId);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'setAutoHideTimer',


    // Timer that controls delay before snackbar auto hides
    value: function () {
      function setAutoHideTimer() {
        var _this3 = this;

        var autoHideDuration = this.props.autoHideDuration;

        if (autoHideDuration > 0) {
          clearTimeout(this.timerAutoHideId);
          this.timerAutoHideId = setTimeout(function () {
            if (_this3.props.open !== null && _this3.props.onRequestClose) {
              _this3.props.onRequestClose('timeout');
            } else {
              _this3.setState({ open: false });
            }
          }, autoHideDuration);
        }
      }

      return setAutoHideTimer;
    }()

    // Timer that controls delay before click-away events are captured (based on when animation completes)

  }, {
    key: 'setTransitionTimer',
    value: function () {
      function setTransitionTimer() {
        var _this4 = this;

        this.timerTransitionId = setTimeout(function () {
          _this4.timerTransitionId = undefined;
        }, 400);
      }

      return setTransitionTimer;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            autoHideDuration = _props.autoHideDuration,
            contentClassName = _props.contentClassName,
            bodyClassName = _props.bodyClassName,
            classNameProp = _props.className,
            messageProp = _props.message,
            onRequestClose = _props.onRequestClose,
            onActionClick = _props.onActionClick,
            error = _props.error,
            other = _objectWithoutProperties(_props, ['autoHideDuration', 'contentClassName', 'bodyClassName', 'className', 'message', 'onRequestClose', 'onActionClick', 'error']);

        var _state = this.state,
            action = _state.action,
            message = _state.message,
            open = _state.open;


        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.open, open), classNameProp);
        /* eslint-disable */
        return _react2['default'].createElement(
          'div',
          _extends({}, other, {
            className: className,
            onClick: this.clickAway,
            'typeof': 'ui:Snackbar',
            role: 'button'
          }),
          _react2['default'].createElement(_SnackbarBody2['default'], {
            action: action,
            contentClass: contentClassName,
            message: message,
            open: open,
            onActionClick: onActionClick,
            className: bodyClassName,
            error: error
          })
        );
        /* eslint-enable */
      }

      return render;
    }()
  }]);

  return Snackbar;
}(_react.Component), _class.propTypes = {
  /**
   * The label for the action on the snackbar.
   */
  action: _PropTypes2['default'].node,
  /**
   * The number of milliseconds to wait before automatically dismissing.
   * If no value is specified the snackbar will dismiss normally.
   * If a value is provided the snackbar can still be dismissed normally.
   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
   */
  autoHideDuration: _PropTypes2['default'].number,
  /**
   * The css class name of the body element.
   */
  bodyClassName: _PropTypes2['default'].string,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The css class name of the content element.
   */
  contentClassName: _PropTypes2['default'].string,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _PropTypes2['default'].node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _PropTypes2['default'].func,
  /**
   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
   * `autoHideDuration` timer expires.
   *
   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
   * `open` prop.
   *
   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
   * for example ignoring `clickaway`.
   *
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _PropTypes2['default'].bool.isRequired,
  /**
   * Indicates the snackbar body should use the error color scheme
   */
  error: _PropTypes2['default'].bool
}, _class.defaultProps = {
  autoHideDuration: 4000
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
}, _temp2);


Snackbar.displayName = 'Snackbar';

exports['default'] = Snackbar;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(6);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Button = __webpack_require__(382);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('SnackbarBody', function (theme) {
  return _defineProperty({
    root: {
      fontFamily: theme.typography.body1.fontFamily,
      paddingTop: theme.typography.rhythmByUnit(1),
      paddingBottom: theme.typography.rhythmByUnit(1),
      padding: '0 ' + theme.typography.rhythmByUnit(3),
      borderRadius: 0,
      minHeight: theme.typography.rhythmByUnit(6),
      display: 'flex',
      maxWidth: 'inherit',
      minWidth: 'inherit',
      width: '100vw',
      flexGrow: 1,
      backgroundColor: theme.typography.primary.color
    },
    content: {
      fontSize: theme.typography.body1.fontSize,
      color: theme.palette.background.paper,
      opacity: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar
      })
    },
    action: {
      color: theme.palette.background.paper,
      float: 'right',
      backgroundColor: 'transparent',
      lineHeight: 'normal',
      '&:hover, &:focus': {
        backgroundColor: 'transparent'
      }
    },
    openContent: {
      opacity: 1,
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar,
        delay: 100
      })
    },
    error: {
      backgroundColor: theme.typography.error.color
    },
    centered: {
      justifyContent: 'center'
    }
  }, theme.breakpoints.up('md'), {
    root: {
      borderRadius: 5,
      maxWidth: 568,
      minWidth: 100,
      width: 'auto',
      flexGrow: 0
    }
  });
});

var SnackbarBody = (_temp = _class = function (_Component) {
  _inherits(SnackbarBody, _Component);

  function SnackbarBody() {
    _classCallCheck(this, SnackbarBody);

    return _possibleConstructorReturn(this, (SnackbarBody.__proto__ || Object.getPrototypeOf(SnackbarBody)).apply(this, arguments));
  }

  _createClass(SnackbarBody, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames2;

        var _props = this.props,
            action = _props.action,
            contentClass = _props.contentClass,
            message = _props.message,
            open = _props.open,
            onActionClick = _props.onActionClick,
            classNameProp = _props.className,
            error = _props.error,
            other = _objectWithoutProperties(_props, ['action', 'contentClass', 'message', 'open', 'onActionClick', 'className', 'error']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.error, error), classNameProp);
        var contentClassName = (0, _classnames2['default'])(classes.content, (_classNames2 = {}, _defineProperty(_classNames2, classes.openContent, open), _defineProperty(_classNames2, classes.centered, !action), _classNames2), contentClass);

        var actionButton = action && _react2['default'].createElement(
          _Button2['default'],
          {
            accent: true,
            compact: true,
            className: classes.action,
            onClick: onActionClick,
            raised: true
          },
          action
        );

        return _react2['default'].createElement(
          'div',
          _extends({}, other, { className: className }),
          _react2['default'].createElement(
            'div',
            { className: contentClassName },
            _react2['default'].createElement(
              'span',
              null,
              message
            ),
            actionButton
          )
        );
      }

      return render;
    }()
  }]);

  return SnackbarBody;
}(_react.Component), _class.propTypes = {
  /**
   * The label for the action on the snackbar.
   */
  action: _PropTypes2['default'].node,
  /**
   * The css class name of the content element.
   */
  contentClass: _PropTypes2['default'].string,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _PropTypes2['default'].node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _PropTypes2['default'].func,
  /**
   * @ignore
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _PropTypes2['default'].bool.isRequired,
  /**
   * The css class name of the body element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Indicates the snackbar body should use the error color scheme
   */
  error: _PropTypes2['default'].bool
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
}, _temp);


SnackbarBody.displayName = 'SnackbarBody';

exports['default'] = SnackbarBody;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleSheet = exports.displayName = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jssThemeReactor = __webpack_require__(62);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = exports.displayName = 'ModalSheet';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(displayName, function () {
  return {
    root: {
      fontSize: '16px'
    }
  };
});

var ModalSheet = (_temp = _class = function (_PureComponent) {
  _inherits(ModalSheet, _PureComponent);

  function ModalSheet() {
    _classCallCheck(this, ModalSheet);

    return _possibleConstructorReturn(this, (ModalSheet.__proto__ || Object.getPrototypeOf(ModalSheet)).apply(this, arguments));
  }

  _createClass(ModalSheet, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;

      var classes = this.context.styleManager.render(styleSheet);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(classes.root, className) },
        children
      );
    }
  }]);

  return ModalSheet;
}(_react.PureComponent), _class.displayName = displayName, _class.contextTypes = {
  styleManager: _propTypes2.default.object.isRequired
}, _temp);
exports.default = ModalSheet;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleSheet = exports.displayName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(148);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jssThemeReactor = __webpack_require__(62);

var _Clear = __webpack_require__(399);

var _Clear2 = _interopRequireDefault(_Clear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = exports.displayName = 'ModalSheetClose';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(displayName, function () {
  return {
    root: {
      width: '1.75em',
      height: '1.75em',
      color: 'black'
    },
    icon: {
      height: '100%',
      width: '100%'
    }
  };
});

var ModalSheetClose = (_temp = _class = function (_PureComponent) {
  _inherits(ModalSheetClose, _PureComponent);

  function ModalSheetClose() {
    _classCallCheck(this, ModalSheetClose);

    return _possibleConstructorReturn(this, (ModalSheetClose.__proto__ || Object.getPrototypeOf(ModalSheetClose)).apply(this, arguments));
  }

  _createClass(ModalSheetClose, [{
    key: 'render',
    value: function render() {
      var classes = this.context.styleManager.render(styleSheet);

      return _react2.default.createElement(
        _reactRouter.Link,
        _extends({}, this.props, { className: classes.root }),
        _react2.default.createElement(_Clear2.default, { className: classes.icon })
      );
    }
  }]);

  return ModalSheetClose;
}(_react.PureComponent), _class.displayName = displayName, _class.contextTypes = {
  styleManager: _propTypes2.default.object.isRequired
}, _temp);
exports.default = ModalSheetClose;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleSheet = exports.displayName = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jssThemeReactor = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = exports.displayName = 'ModalSheetContent';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(displayName, function (theme) {
  return {
    root: {
      marginTop: theme.variables.modalSheetHeaderHeight,
      padding: '1em 2em 0',
      zIndex: theme.zIndex.baseIndex
    }
  };
});

var ModalSheetContent = (_temp = _class = function (_PureComponent) {
  _inherits(ModalSheetContent, _PureComponent);

  function ModalSheetContent() {
    _classCallCheck(this, ModalSheetContent);

    return _possibleConstructorReturn(this, (ModalSheetContent.__proto__ || Object.getPrototypeOf(ModalSheetContent)).apply(this, arguments));
  }

  _createClass(ModalSheetContent, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var classes = this.context.styleManager.render(styleSheet);

      return _react2.default.createElement(
        'section',
        { className: classes.root },
        children
      );
    }
  }]);

  return ModalSheetContent;
}(_react.PureComponent), _class.displayName = displayName, _class.contextTypes = {
  styleManager: _propTypes2.default.object.isRequired
}, _temp);
exports.default = ModalSheetContent;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleSheet = exports.displayName = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jssThemeReactor = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = exports.displayName = 'ModalSheetHeader';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(displayName, function (theme) {
  return {
    root: {
      position: 'fixed',
      width: '100%',
      top: 0,
      height: theme.variables.modalSheetHeaderHeight,
      display: 'flex',
      alignItems: 'center',
      flexFlow: 'row wrap',
      borderBottom: '1px solid #ddd',
      backgroundColor: 'white',
      paddingRight: '1em',
      paddingLeft: '1em',
      zIndex: theme.zIndex.floatingAction
    }
  };
});

var ModalSheetHeader = (_temp = _class = function (_PureComponent) {
  _inherits(ModalSheetHeader, _PureComponent);

  function ModalSheetHeader() {
    _classCallCheck(this, ModalSheetHeader);

    return _possibleConstructorReturn(this, (ModalSheetHeader.__proto__ || Object.getPrototypeOf(ModalSheetHeader)).apply(this, arguments));
  }

  _createClass(ModalSheetHeader, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var classes = this.context.styleManager.render(styleSheet);

      return _react2.default.createElement(
        'header',
        { className: classes.root },
        children
      );
    }
  }]);

  return ModalSheetHeader;
}(_react.PureComponent), _class.displayName = displayName, _class.contextTypes = {
  styleManager: _propTypes2.default.object.isRequired
}, _temp);
exports.default = ModalSheetHeader;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleSheet = exports.displayName = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jssThemeReactor = __webpack_require__(62);

var _context = __webpack_require__(34);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = exports.displayName = 'ModalSheetHeaderTitle';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(displayName, function () {
  return {
    root: {
      flex: 1,
      color: 'black',
      textAlign: 'center',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      textRendering: 'optimizeLegibility',
      display: 'box',
      lineClamp: 2,
      boxOrient: 'vertical',
      overflow: 'hidden'
    }
  };
});

var parseMinorTitle = function parseMinorTitle(title) {
  return title.split(/\s+\|\s+/).pop();
};

var ModalSheetHeaderTitle = (_temp2 = _class = function (_Component) {
  _inherits(ModalSheetHeaderTitle, _Component);

  function ModalSheetHeaderTitle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalSheetHeaderTitle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalSheetHeaderTitle.__proto__ || Object.getPrototypeOf(ModalSheetHeaderTitle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.observer = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalSheetHeaderTitle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var document = _context2.default.document,
          MutationObserver = _context2.default.MutationObserver;


      if (!document) return;

      var head = document.querySelector('head');
      var title = document.querySelector('title');

      if (!head || !title) return;

      this.setState({
        title: parseMinorTitle(title.innerText || title.innerHTML || '')
      });

      if (!MutationObserver) return;

      this.observer = new MutationObserver(function (mutations) {
        var _mutations = _slicedToArray(mutations, 1),
            target = _mutations[0];

        var node = document.querySelector('title');
        if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object') {
          _this2.setState({
            title: parseMinorTitle(node.innerText || node.innerHTML || '')
          });
        }
      });
      this.observer.observe(head, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.observer && typeof this.observer.disconnect === 'function') {
        this.observer.disconnect();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = this.state.title;

      var classes = this.context.styleManager.render(styleSheet);

      return _react2.default.createElement(
        'h1',
        { className: classes.root },
        title
      );
    }
  }]);

  return ModalSheetHeaderTitle;
}(_react.Component), _class.displayName = displayName, _class.contextTypes = {
  styleManager: _propTypes2.default.object.isRequired
}, _temp2);
exports.default = ModalSheetHeaderTitle;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTasks = (_temp = _class = function (_SvgIcon) {
  _inherits(NavTasks, _SvgIcon);

  function NavTasks() {
    _classCallCheck(this, NavTasks);

    return _possibleConstructorReturn(this, (NavTasks.__proto__ || Object.getPrototypeOf(NavTasks)).apply(this, arguments));
  }

  _createClass(NavTasks, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M26 4c-.003-1.104-.897-1.997-2-2-.003-1.105-.9-2-2.005-2H2.005C.897 0 0 .898 0 2.005v19.99C0 23.1.895 23.997 2 24c.003 1.104.897 1.997 2 2 .003 1.105.9 2 2.005 2h19.99C27.103 28 28 27.102 28 25.995V6.005C28 4.9 27.105 4.003 26 4zM2 4.005V23c-.552-.004-1-.453-1-1.005V2.005C1 1.45 1.45 1 2.005 1h19.99c.552 0 1 .448 1.004 1H4.004C2.897 2 2 2.898 2 4.005zm2 2V25c-.55-.004-.996-.45-1-1V4.005C3 3.45 3.45 3 4.005 3H24c.55.004.996.45 1 1H6.004C4.897 4 4 4.898 4 6.005zM20.5 7.5c0 .69-.563 1.25-1.25 1.25h-6.5c-.69 0-1.25-.555-1.25-1.25 0-.69.563-1.25 1.25-1.25h6.5c.69 0 1.25.555 1.25 1.25zM25.995 26L6 25.995 6.004 11H26l-.004 13.04c0-.016.004-.03.004-.045L25.995 26z' }),
          _react2['default'].createElement('path', { d: 'M14.333 24c-.37 0-.727-.137-1.003-.385l-3.333-3c-.616-.554-.666-1.503-.112-2.12.555-.614 1.504-.663 2.118-.11l2.176 1.958 5.668-6.803c.53-.637 1.476-.723 2.112-.192.637.53.723 1.476.192 2.112l-6.667 8c-.26.313-.638.507-1.045.536-.036.003-.072.004-.107.004z' })
        );
      }

      return render;
    }()
  }]);

  return NavTasks;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 28 28'
}, _temp);
exports['default'] = NavTasks;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavProcesses = (_temp = _class = function (_SvgIcon) {
  _inherits(NavProcesses, _SvgIcon);

  function NavProcesses() {
    _classCallCheck(this, NavProcesses);

    return _possibleConstructorReturn(this, (NavProcesses.__proto__ || Object.getPrototypeOf(NavProcesses)).apply(this, arguments));
  }

  _createClass(NavProcesses, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M26 4c-.003-1.104-.897-1.997-2-2-.003-1.105-.9-2-2.005-2H2.005C.897 0 0 .898 0 2.005v19.99C0 23.1.895 23.997 2 24c.003 1.104.897 1.997 2 2 .003 1.105.9 2 2.005 2h19.99C27.103 28 28 27.102 28 25.995V6.005C28 4.9 27.105 4.003 26 4zM2 4.005V23c-.552-.004-1-.453-1-1.005V2.005C1 1.45 1.45 1 2.005 1h19.99c.552 0 1 .448 1.004 1H4.004C2.897 2 2 2.898 2 4.005zm2 2V25c-.55-.004-.996-.45-1-1V4.005C3 3.45 3.45 3 4.005 3H24c.55.004.996.45 1 1H6.004C4.897 4 4 4.898 4 6.005zM25.995 26L6 25.993l.004-20.118H26l-.004 17.494c0-.02.004-.04.004-.06L25.995 26z' }),
          _react2['default'].createElement('path', { d: 'M10 5h1v22.023h-1z', opacity: '.4' }),
          _react2['default'].createElement('path', { d: 'M20.52 11.5H14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6.52c.276 0 .5.224.5.5s-.224.5-.5.5zm-1.993 5H14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4.527c.277 0 .5.224.5.5s-.223.5-.5.5zm3.988 5H14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8.515c.276 0 .5.224.5.5s-.224.5-.5.5z' }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '21',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '16',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '11',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          })
        );
      }

      return render;
    }()
  }]);

  return NavProcesses;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 28 28'
}, _temp);
exports['default'] = NavProcesses;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavStartAProcess = (_temp = _class = function (_SvgIcon) {
  _inherits(NavStartAProcess, _SvgIcon);

  function NavStartAProcess() {
    _classCallCheck(this, NavStartAProcess);

    return _possibleConstructorReturn(this, (NavStartAProcess.__proto__ || Object.getPrototypeOf(NavStartAProcess)).apply(this, arguments));
  }

  _createClass(NavStartAProcess, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M6 1h1v22.023H6z', opacity: '.4' }),
          _react2['default'].createElement('circle', {
            cx: '6.5',
            cy: '17',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', {
            cx: '6.5',
            cy: '12',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', { cx: '6.5', cy: '7', r: '1.5', fillRule: 'evenodd', clipRule: 'evenodd' }),
          _react2['default'].createElement('path', { d: 'M23.027 17h-3v-3c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5v3h-3c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h3v3c0 .828.672 1.5 1.5 1.5s1.5-.672 1.5-1.5v-3h3c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5zM10 7.5h6.52c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H10c-.276 0-.5.224-.5.5s.224.5.5.5z' }),
          _react2['default'].createElement('circle', { cx: '18.528', cy: '18.5', r: '7.5', fill: 'none' }),
          _react2['default'].createElement('path', { d: 'M24 10.743V2.005C24 .9 23.105.003 22 0H2.005C.897 0 0 .898 0 2.005V22l.002-.004L0 22c.003 1.105.9 2 2.005 2h8.786c1.723 2.418 4.543 4 7.738 4 5.246 0 9.5-4.253 9.5-9.5 0-3.207-1.594-6.037-4.028-7.757zM9.7 21.996L2 21.993l.004-20.118H22l-.003 7.788C20.92 9.24 19.754 9 18.527 9c-2.472 0-4.716.952-6.406 2.5H10c-.276 0-.5.224-.5.5s.224.5.5.5h1.165c-1.335 1.636-2.137 3.724-2.137 6 0 1.236.243 2.413.672 3.496zM18.528 26c-4.136 0-7.5-3.365-7.5-7.5 0-4.136 3.364-7.5 7.5-7.5 4.135 0 7.5 3.365 7.5 7.5 0 4.136-3.365 7.5-7.5 7.5z' })
        );
      }

      return render;
    }()
  }]);

  return NavStartAProcess;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 28.0277 28'
}, _temp);
exports['default'] = NavStartAProcess;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavIntegrations = (_temp = _class = function (_SvgIcon) {
  _inherits(NavIntegrations, _SvgIcon);

  function NavIntegrations() {
    _classCallCheck(this, NavIntegrations);

    return _possibleConstructorReturn(this, (NavIntegrations.__proto__ || Object.getPrototypeOf(NavIntegrations)).apply(this, arguments));
  }

  _createClass(NavIntegrations, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M18.447 6c1.83 1.15 3.052 3.183 3.052 5.5 0 3.584-2.917 6.5-6.5 6.5H3.41l1.293-1.293c.39-.39.39-1.023 0-1.414-.39-.39-1.024-.39-1.414 0l-3 3c-.092.09-.165.202-.216.325-.1.244-.1.52 0 .764.05.123.124.234.217.326l3 3c.194.194.45.292.706.292.255 0 .51-.098.706-.293.39-.39.39-1.023 0-1.414L3.413 20H15c4.685 0 8.5-3.813 8.5-8.5 0-2.1-.778-4.016-2.045-5.5z' }),
          _react2['default'].createElement('path', { d: 'M29.922 3.618c-.05-.123-.124-.233-.217-.326l-3-3c-.39-.39-1.023-.39-1.413 0-.39.392-.39 1.024 0 1.415L26.585 3H15c-4.688 0-8.5 3.813-8.5 8.5 0 2.1.775 4.016 2.043 5.5h3.008c-1.83-1.15-3.05-3.183-3.05-5.5C8.5 7.916 11.414 5 15 5h11.584l-1.293 1.293c-.39.39-.39 1.023 0 1.414.195.195.45.293.707.293.255 0 .51-.098.706-.293l3-3c.092-.092.165-.202.216-.325.1-.244.1-.52 0-.764z' }),
          _react2['default'].createElement('circle', { cx: '14.999', cy: '11.5', r: '2.5' })
        );
      }

      return render;
    }()
  }]);

  return NavIntegrations;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 29.997427 23.000006'
}, _temp);
exports['default'] = NavIntegrations;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTriggers = (_temp = _class = function (_SvgIcon) {
  _inherits(NavTriggers, _SvgIcon);

  function NavTriggers() {
    _classCallCheck(this, NavTriggers);

    return _possibleConstructorReturn(this, (NavTriggers.__proto__ || Object.getPrototypeOf(NavTriggers)).apply(this, arguments));
  }

  _createClass(NavTriggers, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M4.154 23c-.056 0-.112-.01-.166-.032-.214-.086-.334-.32-.285-.55l1.72-8.043H.464c-.166 0-.318-.09-.4-.238-.083-.148-.084-.33-.002-.48L7.446.243c.114-.207.353-.295.568-.21.213.086.334.32.284.55L6.575 8.626h4.964c.164 0 .315.09.398.24.082.147.083.33.002.477L4.555 22.76c-.085.152-.24.24-.4.24z' })
        );
      }

      return render;
    }()
  }]);

  return NavTriggers;
}(_SvgIcon3['default']), _class.defaultProps = {
  preserveAspectRatio: 'xMidYMin',
  viewBox: '0 0 11.999998 22.999994'
}, _temp);
exports['default'] = NavTriggers;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTeam = (_temp = _class = function (_SvgIcon) {
  _inherits(NavTeam, _SvgIcon);

  function NavTeam() {
    _classCallCheck(this, NavTeam);

    return _possibleConstructorReturn(this, (NavTeam.__proto__ || Object.getPrototypeOf(NavTeam)).apply(this, arguments));
  }

  _createClass(NavTeam, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M33.168 15.275c-.602-.602-1.324-.933-1.96-1.226-.16-.074-.313-.145-.456-.216-1.425-.712-1.146-1.986-.233-3.81.46-.925.93-3.286-.015-4.817-.393-.635-1.203-1.393-2.833-1.393-1.63 0-2.442.758-2.834 1.393-.946 1.53-.476 3.892-.014 4.816.405.81.602 1.525.584 2.12-.022.748-.396 1.293-1.144 1.667-.133.066-.276.132-.424.202-.623.29-1.398.652-2.008 1.263-.18.18-.314.358-.425.53-.843-1.035-.6-2.617.73-5.277.78-1.56 1.572-5.55-.03-8.14C21.435 1.297 20.05 0 17.27 0c-2.778 0-4.164 1.298-4.837 2.387-1.602 2.59-.81 6.58-.03 8.14.66 1.318.977 2.47.95 3.426-.024.757-.268 1.368-.75 1.867-.112-.177-.25-.36-.435-.545-.602-.602-1.324-.934-1.96-1.226-.16-.074-.313-.145-.456-.216-.722-.36-1.034-.88-.982-1.63.05-.698.39-1.46.75-2.18.46-.924.932-3.285-.015-4.816-.392-.636-1.202-1.394-2.834-1.394-1.63 0-2.44.758-2.832 1.393-.946 1.53-.476 3.892-.014 4.816 1.403 2.806-.074 3.544-.56 3.787-.133.066-.276.132-.424.202-.622.29-1.397.652-2.008 1.263C.022 16.085 0 16.908 0 17l1 .008c0-.02.023-.51.54-1.026.486-.487 1.143-.794 1.723-1.064.156-.073.307-.144.448-.214 1.844-.92 2.2-2.742 1.01-5.128-.307-.612-.766-2.655-.032-3.844.382-.617 1.03-.918 1.983-.918.954 0 1.603.3 1.985.92.734 1.188.276 3.23-.03 3.842-.407.813-.792 1.686-.853 2.56-.08 1.154.45 2.05 1.533 2.593.152.075.315.15.484.227.56.258 1.195.55 1.67 1.025.158.157.26.306.337.445-.08.046-.157.094-.245.137-.22.11-.456.22-.702.336-1.04.486-2.336 1.09-3.37 2.122-1.386 1.39-1.426 2.82-1.426 2.978l2 .02c0-.03.043-.784.842-1.583.783-.783 1.854-1.284 2.8-1.725.263-.122.516-.24.75-.358 1.843-.92 2.847-2.422 2.905-4.34.04-1.29-.35-2.764-1.158-4.38-.495-.99-1.238-4.286-.058-6.196C14.732 2.47 15.758 2 17.27 2c1.512 0 2.54.47 3.136 1.438 1.18 1.91.438 5.206-.057 6.196-.894 1.785-3.263 6.527 1.203 8.76.254.127.525.252.807.38.96.443 1.953.9 2.717 1.663.8.8.84 1.552.842 1.563h2c0-.158-.04-1.59-1.43-2.978-1.017-1.017-2.28-1.597-3.295-2.064-.26-.12-.513-.235-.748-.353-.096-.048-.167-.106-.254-.157.08-.146.18-.3.346-.466.485-.487 1.143-.794 1.723-1.064.156-.073.307-.144.448-.214 1.077-.538 1.664-1.413 1.698-2.532.023-.76-.21-1.635-.69-2.596-.306-.612-.764-2.655-.03-3.843.382-.618 1.032-.92 1.984-.92s1.6.302 1.982.92c.735 1.188.277 3.23-.03 3.843-.576 1.152-1.924 3.85.68 5.153.153.075.316.15.485.227.56.258 1.196.55 1.67 1.025.517.516.54 1.005.54 1.018h1c0-.092-.023-.916-.832-1.725z' })
        );
      }

      return render;
    }()
  }]);

  return NavTeam;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 34 22.02051'
}, _temp);
exports['default'] = NavTeam;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavHelp = (_temp = _class = function (_SvgIcon) {
  _inherits(NavHelp, _SvgIcon);

  function NavHelp() {
    _classCallCheck(this, NavHelp);

    return _possibleConstructorReturn(this, (NavHelp.__proto__ || Object.getPrototypeOf(NavHelp)).apply(this, arguments));
  }

  _createClass(NavHelp, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M3.164 11.704v-.867a3.845 3.845 0 0 1 .48-1.957 6.295 6.295 0 0 1 1.758-1.77 7.355 7.355 0 0 0 1.623-1.43 2.07 2.07 0 0 0 .393-1.23 1.333 1.333 0 0 0-.563-1.16 2.682 2.682 0 0 0-1.57-.4 9.017 9.017 0 0 0-4.008 1.15L0 1.473A11.165 11.165 0 0 1 5.543.008a5.896 5.896 0 0 1 3.838 1.16 3.788 3.788 0 0 1 1.425 3.094 4.115 4.115 0 0 1-.586 2.227A8.35 8.35 0 0 1 7.99 8.597a6.874 6.874 0 0 0-1.424 1.266A1.965 1.965 0 0 0 6.27 11v.704zm-.375 4.008a1.965 1.965 0 0 1 .526-1.49 2.14 2.14 0 0 1 1.536-.503 2.078 2.078 0 0 1 1.505.515 2.277 2.277 0 0 1-.005 2.935 2.04 2.04 0 0 1-1.5.534 2.1 2.1 0 0 1-1.524-.522 1.95 1.95 0 0 1-.54-1.47z' })
        );
      }

      return render;
    }()
  }]);

  return NavHelp;
}(_SvgIcon3['default']), _class.defaultProps = {
  preserveAspectRatio: 'xMidYMin',
  viewBox: '0 0 10.807025 17.707918'
}, _temp);
exports['default'] = NavHelp;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = __webpack_require__(2);

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavSignOff = (_temp = _class = function (_SvgIcon) {
  _inherits(NavSignOff, _SvgIcon);

  function NavSignOff() {
    _classCallCheck(this, NavSignOff);

    return _possibleConstructorReturn(this, (NavSignOff.__proto__ || Object.getPrototypeOf(NavSignOff)).apply(this, arguments));
  }

  _createClass(NavSignOff, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M11.996 13.5l-.002 4.5L2 18.01 2.006 2h9.988L12 1.99l-.002 4.51H14V1.99C14 .9 13.102 0 11.994 0H2.006C.896 0 0 .89 0 1.99v16.02C0 19.1.898 20 2.006 20h9.988c1.11 0 2.006-.892 2.006-1.99V13.5z' }),
          _react2['default'].createElement('path', { d: 'M19.16 8.5H7.5C6.67 8.5 6 9.17 6 10c0 .828.67 1.5 1.5 1.5h11.66l-2.263 2.492c-.556.613-.51 1.562.103 2.118.613.558 1.562.51 2.12-.102l4.534-4.996c.122-.134.22-.29.288-.462.137-.36.137-.74.007-1.082-.075-.19-.174-.346-.296-.48L19.12 3.992c-.558-.614-1.507-.66-2.12-.103-.613.556-.66 1.505-.103 2.118z' })
        );
      }

      return render;
    }()
  }]);

  return NavSignOff;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 24.045792 20'
}, _temp);
exports['default'] = NavSignOff;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = __webpack_require__(1876);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Badge)['default'];
    }

    return get;
  }()
});
Object.defineProperty(exports, 'Badge', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_Badge)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = Badge;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(3);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var radius = 12;
var radius2x = 2 * radius;

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Badge', function (theme) {
  var typography = theme.typography,
      palette = theme.palette;


  return {
    root: {
      position: 'relative',
      display: 'inline-block'
    },
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: -radius,
      right: -radius,
      fontWeight: typography.fontWeight,
      fontSize: radius,
      width: radius2x,
      height: radius2x,
      borderRadius: '50%',
      backgroundColor: palette.color,
      color: palette.textColor
    },
    primary: {
      backgroundColor: palette.primary[500],
      color: palette.getContrastText(palette.primary[500])
    },
    accent: {
      backgroundColor: palette.accent.A200,
      color: palette.getContrastText(palette.accent.A200)
    }
  };
});

/**
 *
 * ```jsx
 * <Badge badgeContent={4}>
 *   <Icon>folder</Icon>
 * </Badge>
 * ```
 */
function Badge(props, context) {
  var _classNames2;

  var badgeClassNameProp = props.badgeClassName,
      badgeContent = props.badgeContent,
      classNameProp = props.className,
      children = props.children,
      primary = props.primary,
      accent = props.accent,
      other = _objectWithoutProperties(props, ['badgeClassName', 'badgeContent', 'className', 'children', 'primary', 'accent']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(_defineProperty({}, classes.root, true), classNameProp);
  var badgeClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, classes.badge, true), _defineProperty(_classNames2, classes.primary, primary), _defineProperty(_classNames2, classes.accent, accent), _classNames2), badgeClassNameProp);

  return _react2['default'].createElement(
    'div',
    _extends({ className: className }, other),
    children,
    badgeContent ? _react2['default'].createElement(
      'span',
      { className: badgeClassName },
      badgeContent
    ) : null
  );
}

Badge.propTypes = {
  /**
   * If true, the badge will use the accent badge colors.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * The css class name of the badge element.
   */
  badgeClassName: _PropTypes2['default'].string,
  /**
   * This is the content rendered within the badge.
   */
  badgeContent: _PropTypes2['default'].node,
  /**
   * The badge will be added relativelty to this node.
   */
  children: _PropTypes2['default'].node.isRequired,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, the badge will use the primary badge colors.
   */
  primary: _PropTypes2['default'].bool
};
Badge.displayName = 'Badge';

Badge.defaultProps = {
  primary: false,
  accent: false
};

Badge.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NotoSansUIBold = __webpack_require__(1878);

var _NotoSansUIBold2 = _interopRequireDefault(_NotoSansUIBold);

var _NotoSansUIBold3 = __webpack_require__(1879);

var _NotoSansUIBold4 = _interopRequireDefault(_NotoSansUIBold3);

var _NotoSansUIBold5 = __webpack_require__(1880);

var _NotoSansUIBold6 = _interopRequireDefault(_NotoSansUIBold5);

var _NotoSansUIBoldItalic = __webpack_require__(1881);

var _NotoSansUIBoldItalic2 = _interopRequireDefault(_NotoSansUIBoldItalic);

var _NotoSansUIBoldItalic3 = __webpack_require__(1882);

var _NotoSansUIBoldItalic4 = _interopRequireDefault(_NotoSansUIBoldItalic3);

var _NotoSansUIBoldItalic5 = __webpack_require__(1883);

var _NotoSansUIBoldItalic6 = _interopRequireDefault(_NotoSansUIBoldItalic5);

var _NotoSansUIItalic = __webpack_require__(1884);

var _NotoSansUIItalic2 = _interopRequireDefault(_NotoSansUIItalic);

var _NotoSansUIItalic3 = __webpack_require__(1885);

var _NotoSansUIItalic4 = _interopRequireDefault(_NotoSansUIItalic3);

var _NotoSansUIItalic5 = __webpack_require__(1886);

var _NotoSansUIItalic6 = _interopRequireDefault(_NotoSansUIItalic5);

var _NotoSansUIRegular = __webpack_require__(1887);

var _NotoSansUIRegular2 = _interopRequireDefault(_NotoSansUIRegular);

var _NotoSansUIRegular3 = __webpack_require__(1888);

var _NotoSansUIRegular4 = _interopRequireDefault(_NotoSansUIRegular3);

var _NotoSansUIRegular5 = __webpack_require__(1889);

var _NotoSansUIRegular6 = _interopRequireDefault(_NotoSansUIRegular5);

var _path = __webpack_require__(149);

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderSrc = function renderSrc(eot, woff, ttf) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$dirname = options.dirname,
      dirname = _options$dirname === undefined ? '' : _options$dirname;


  return 'url("' + _path2.default.join(dirname, eot) + '") format("eot"),\n      url("' + _path2.default.join(dirname, eot) + '?#iefix") format("embedded-opentype"),\n      url("' + _path2.default.join(dirname, woff) + '") format("woff"),\n      url("' + _path2.default.join(dirname, ttf) + '") format("truetype")';
};

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    '@font-face': [{
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIRegular2.default, _NotoSansUIRegular6.default, _NotoSansUIRegular4.default, options)
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBold2.default, _NotoSansUIBold6.default, _NotoSansUIBold4.default, options),
      fontWeight: 500
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBold2.default, _NotoSansUIBold6.default, _NotoSansUIBold4.default, options),
      fontWeight: 700
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIItalic2.default, _NotoSansUIItalic6.default, _NotoSansUIItalic4.default, options),
      fontStyle: 'italic'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBoldItalic2.default, _NotoSansUIBoldItalic6.default, _NotoSansUIBoldItalic4.default, options),
      fontWeight: 500,
      fontStyle: 'italic'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBoldItalic2.default, _NotoSansUIBoldItalic6.default, _NotoSansUIBoldItalic4.default, options),
      fontWeight: 700,
      fontStyle: 'italic'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIItalic2.default, _NotoSansUIItalic6.default, _NotoSansUIItalic4.default, options),
      fontWeight: 500,
      fontStyle: 'oblique'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBoldItalic2.default, _NotoSansUIBoldItalic6.default, _NotoSansUIBoldItalic4.default, options),
      fontWeight: 700,
      fontStyle: 'oblique'
    }]
  };
};

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Bold.eot?6f65250d3676c8bde0e1a92e31791869]";

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Bold.ttf?8132eb1c298deb8297aa3f344f9b3183]";

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Bold.woff?feebb35df70e880afc63dbc034a8f305]";

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.eot?5a1bea7c7d256a5f6f8a55cbfa81c86b]";

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.ttf?11240b3672286420f295746b22127460]";

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.woff?d8a9bb51a88bc56333be65a347eadbfa]";

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Italic.eot?44ef958b213ea8fe0fc9e2dc169226de]";

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Italic.ttf?5df1c4e39d04d3e0068b91a95f377ade]";

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Italic.woff?d892793b2f8bbe029be7db615a19045c]";

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Regular.eot?aa2229b6f9a5b0a0c8e2752a2a6ce697]";

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Regular.ttf?c03630b84c352f16fc8fde796518287b]";

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Regular.woff?6ffaa042b52de9fdbb29262b774756c5]";

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterListContainer = exports.createFilterListItemSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reselect = __webpack_require__(33);

var _reactRedux = __webpack_require__(89);

var _List = __webpack_require__(69);

var _filter = __webpack_require__(410);

var _entities = __webpack_require__(184);

var _session = __webpack_require__(117);

var _api = __webpack_require__(695);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Takes a list of filter shapes and renders them as FilterListItems
 */
var createFilterListItemSelector = exports.createFilterListItemSelector = function createFilterListItemSelector(filterListSelector) {
  return (0, _reselect.createSelector)(filterListSelector, function (state) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return props.className;
  }, function (state) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return props.onClick;
  }, function () {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var className = arguments[1];
    var onClick = arguments[2];
    return _react.Children.map(filters.map(function (filter, i) {
      var name = filter.name,
          query = filter.query;

      var href = '/search?q=' + encodeURIComponent(query);
      return (
        // eslint-disable-next-line react/jsx-key
        _react2.default.createElement(
          _List.ListItem,
          _extends({
            margin: i === filters.length - 1
          }, { href: href, className: className, onClick: onClick }),
          _react2.default.createElement(_List.ListItemText, { inherit: true, noWrap: true, primary: name })
        )
      );
    }), _react2.default.cloneElement);
  });
};

var FilterListContainer = exports.FilterListContainer = (_temp = _class = function (_PureComponent) {
  _inherits(FilterListContainer, _PureComponent);

  function FilterListContainer() {
    _classCallCheck(this, FilterListContainer);

    return _possibleConstructorReturn(this, (FilterListContainer.__proto__ || Object.getPrototypeOf(FilterListContainer)).apply(this, arguments));
  }

  _createClass(FilterListContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          getFilters = _props.getFilters,
          teamName = _props.teamName,
          username = _props.username;

      getFilters({ teamName: teamName, username: username });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.filterListItems
      );
    }
  }]);

  return FilterListContainer;
}(_react.PureComponent), _class.displayName = 'FilterListContainer', _class.propTypes = {
  /**
   * Class to apply to the menu items in the filter list
   */
  className: _react.PropTypes.string,
  /**
   * Action to delete a filter via the API.
   */
  deleteFilter: _react.PropTypes.func,
  /**
   * A list of filters in the system, populates the menu items in the filter list
   */
  filters: _react.PropTypes.arrayOf(_api.filter),
  /**
   * Action to list filters via the API.
   */
  getFilters: _react.PropTypes.func,
  /**
   * Current team name.
   */
  teamName: _react.PropTypes.string,
  /**
   * Current authed user's username.
   */
  username: _react.PropTypes.string,
  /**
   * ListItem child nodes
   */
  filterListItems: _react.PropTypes.node
}, _temp);


var mapStateToProps = function mapStateToProps(state, props) {
  return {
    filterListItems: createFilterListItemSelector(_entities.filtersList)(state, props),
    teamName: (0, _session.teamName)(state),
    username: (0, _session.username)(state)
  };
};

var mapDispatchToProps = {
  getFilters: _filter.getFilters,
  deleteFilter: _filter.deleteFilter
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FilterListContainer);

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  lastModified: number,
  name: string,
  size: number,
  type: string,
  webkitRelativePath: string
});

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var shape = _react.PropTypes.shape,
    string = _react.PropTypes.string;
exports.default = shape({
  filterID: string,
  userID: string,
  name: string,
  createdAt: string,
  updatedAt: string,
  query: string,
  deletedAt: string
});

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  teamName: string,
  threadID: string,
  messageID: string,
  username: string,
  medium: string,
  mediumAddress: string,
  mediumMessageID: string,
  subject: string,
  timestamp: string,
  participants: arrayOf(string),
  shortBody: string,
  shortBodyTruncated: bool,
  notificationID: string,
  body: string
});

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _field = __webpack_require__(91);

var _field2 = _interopRequireDefault(_field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    oneOf = _propTypes2.default.oneOf,
    oneOfType = _propTypes2.default.oneOfType; // eslint-disable-line no-unused-vars

// eslint-disable-line no-unused-vars

exports.default = shape({
  teamName: string,
  tableID: string,
  displayName: string,
  tableType: oneOf(['application', 'userDefined', 'process', 'team', 'user']),
  createdBy: string,
  createdDate: string,
  modifiedBy: string,
  modifiedDate: string,
  isArchived: bool,
  columns: arrayOf(oneOfType([_field2.default, string])),
  visibility: string,
  visibleToUsers: arrayOf(string)
});

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _field = __webpack_require__(91);

var _field2 = _interopRequireDefault(_field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    number = _propTypes2.default.number,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  rowID: string,
  tableID: string,
  rowNumber: oneOfType([number, string]),
  fields: arrayOf(_field2.default)
});

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  teamName: string,
  displayName: string,
  description: string,
  thumbnailUrl: string,
  accentColor: string,
  allowedCIDRs: arrayOf(string),
  ownerUsername: string,
  ownerEmail: string,
  slackToken: string,
  samlConfig: shape({
    loginUrl: string,
    logoutUrl: string,
    entityId: string,
    certificate: string,
    enabled: bool
  }),
  slackIntegration: shape({
    slackToken: string,
    slackTeam: string,
    slackTeamID: string,
    integrationUser: string
  })
});

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

exports.default = shape({
  createdBy: string,
  createdDate: string,
  isArchived: bool,
  isGroup: bool,
  members: arrayOf(string),
  nickname: string,
  teamName: string,
  userID: string,
  userKey: string,
  username: string
});

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _training = __webpack_require__(692);

var _training2 = _interopRequireDefault(_training);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    objectOf = _propTypes2.default.objectOf,
    oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string; // eslint-disable-line no-unused-vars

// eslint-disable-line no-unused-vars

exports.default = shape({
  predictorID: string,
  teamName: string,
  tableID: string,
  displayName: string,
  type: string,
  dependentFieldName: string,
  training: _training2.default
});

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserWatchListContainer = __webpack_require__(693);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserWatchListContainer).default;
  }
});

var _UserWatchListMoreItem = __webpack_require__(1900);

Object.defineProperty(exports, 'UserWatchListMoreItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserWatchListMoreItem).default;
  }
});

var _UserWatchListProcessItem = __webpack_require__(1901);

Object.defineProperty(exports, 'UserWatchListProcessItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserWatchListProcessItem).default;
  }
});

var _UserWatchListRunItem = __webpack_require__(1902);

Object.defineProperty(exports, 'UserWatchListRunItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserWatchListRunItem).default;
  }
});

var _UserWatchList = __webpack_require__(1903);

Object.defineProperty(exports, 'UserWatchList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserWatchList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(181);

var _List = __webpack_require__(69);

var _KeyboardArrowDown = __webpack_require__(847);

var _KeyboardArrowDown2 = _interopRequireDefault(_KeyboardArrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserWatchListMoreItem = (_temp = _class = function (_PureComponent) {
  _inherits(UserWatchListMoreItem, _PureComponent);

  function UserWatchListMoreItem() {
    _classCallCheck(this, UserWatchListMoreItem);

    return _possibleConstructorReturn(this, (UserWatchListMoreItem.__proto__ || Object.getPrototypeOf(UserWatchListMoreItem)).apply(this, arguments));
  }

  _createClass(UserWatchListMoreItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          href = _props.href,
          onClick = _props.onClick;


      return _react2.default.createElement(
        _List.ListItem,
        _extends({ margin: true }, { className: className, href: href, onClick: onClick }),
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_KeyboardArrowDown2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'UserWatchListMoreItem.primary',
            defaultMessage: 'More'
          })
        })
      );
    }
  }]);

  return UserWatchListMoreItem;
}(_react.PureComponent), _class.displayName = 'UserWatchListMoreItem', _class.propTypes = {
  /**
   * Class to apply to the list items in the filter list
   */
  className: _react.PropTypes.string,
  /**
   * Location of search page for more items when a user clicks on this item
   */
  href: _react.PropTypes.string,
  /**
   * Click event to apply to the list items in the filter list
   */
  onClick: _react.PropTypes.func
}, _temp);
exports.default = UserWatchListMoreItem;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = __webpack_require__(62);

var _List = __webpack_require__(69);

var _ProcessOutline = __webpack_require__(405);

var _ProcessOutline2 = _interopRequireDefault(_ProcessOutline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('UserWatchListProcessItem', function (theme) {
  return {
    primary: {
      fontWeight: theme.typography.fontWeightHeavy
    }
  };
});

var UserWatchListProcessItem = (_temp = _class = function (_PureComponent) {
  _inherits(UserWatchListProcessItem, _PureComponent);

  function UserWatchListProcessItem() {
    _classCallCheck(this, UserWatchListProcessItem);

    return _possibleConstructorReturn(this, (UserWatchListProcessItem.__proto__ || Object.getPrototypeOf(UserWatchListProcessItem)).apply(this, arguments));
  }

  _createClass(UserWatchListProcessItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          href = _props.href,
          onClick = _props.onClick,
          processDisplayName = _props.processDisplayName;

      var classes = this.context.styleManager.render(styleSheet);

      return _react2.default.createElement(
        _List.ListItem,
        { className: className, href: href, onClick: onClick },
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_ProcessOutline2.default, null)
        ),
        _react2.default.createElement(_List.ListItemText, {
          inherit: true,
          noWrap: true,
          primary: processDisplayName,
          primaryClassName: classes.primary
        })
      );
    }
  }]);

  return UserWatchListProcessItem;
}(_react.PureComponent), _class.displayName = 'UserWatchListProcessItem', _class.propTypes = {
  /**
   * Class to apply to the list items in the filter list
   */
  className: _react.PropTypes.string,
  /**
   * Location of search page for more items when a user clicks on this item
   */
  href: _react.PropTypes.string,
  /**
   * Click event to apply to the list items in the filter list
   */
  onClick: _react.PropTypes.func,
  /**
   * Name of the process that is to be displayed for the item
   */
  processDisplayName: _react.PropTypes.string
}, _class.contextTypes = {
  styleManager: _react.PropTypes.object.isRequired
}, _temp);
exports.default = UserWatchListProcessItem;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(69);

var _PieProgress = __webpack_require__(633);

var _PieProgress2 = _interopRequireDefault(_PieProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserWatchListRunItem = (_temp = _class = function (_PureComponent) {
  _inherits(UserWatchListRunItem, _PureComponent);

  function UserWatchListRunItem() {
    _classCallCheck(this, UserWatchListRunItem);

    return _possibleConstructorReturn(this, (UserWatchListRunItem.__proto__ || Object.getPrototypeOf(UserWatchListRunItem)).apply(this, arguments));
  }

  _createClass(UserWatchListRunItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          href = _props.href,
          margin = _props.margin,
          onClick = _props.onClick,
          percentComplete = _props.percentComplete,
          runDisplayName = _props.runDisplayName;


      return _react2.default.createElement(
        _List.ListItem,
        { className: className, href: href, margin: margin, onClick: onClick },
        _react2.default.createElement(
          _List.ListItemIcon,
          null,
          _react2.default.createElement(_PieProgress2.default, { value: percentComplete })
        ),
        _react2.default.createElement(_List.ListItemText, { inherit: true, noWrap: true, primary: runDisplayName })
      );
    }
  }]);

  return UserWatchListRunItem;
}(_react.PureComponent), _class.displayName = 'UserWatchListRunItem', _class.propTypes = {
  /**
   * Class to apply to the list items in the filter list
   */
  className: _react.PropTypes.string,
  /**
   * Location of search page for more items when a user clicks on this item
   */
  href: _react.PropTypes.string,
  /**
   * If true, the list item will have a bottom margin
   */
  margin: _react.PropTypes.bool,
  /**
   * Click event to apply to the list items in the filter list
   */
  onClick: _react.PropTypes.func,
  /**
   * Value that represents the percentage of the run that is done, to be displayed as a pie status
   */
  percentComplete: _react.PropTypes.number,
  /**
   * Name of the run that is to be displayed for the item
   */
  runDisplayName: _react.PropTypes.string
}, _temp);
exports.default = UserWatchListRunItem;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserWatchList = (_temp = _class = function (_PureComponent) {
  _inherits(UserWatchList, _PureComponent);

  function UserWatchList() {
    _classCallCheck(this, UserWatchList);

    return _possibleConstructorReturn(this, (UserWatchList.__proto__ || Object.getPrototypeOf(UserWatchList)).apply(this, arguments));
  }

  _createClass(UserWatchList, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return UserWatchList;
}(_react.PureComponent), _class.displayName = 'UserWatchList', _class.propTypes = {
  /**
   * A list of watch list groupings
   */
  children: _react.PropTypes.node
}, _temp);
exports.default = UserWatchList;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userWatchListItemsSelector = undefined;

var _sortBy = __webpack_require__(848);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _entities = __webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Remove this once the real problem of remounting/rerendering is solved
var cachedUserWatchList = void 0;

var userWatchListItemsSelector = exports.userWatchListItemsSelector = function userWatchListItemsSelector(state) {
  var userWatchList = state.entities.searches.userWatchList;

  if (cachedUserWatchList) {
    return cachedUserWatchList;
  }

  if (userWatchList) {
    cachedUserWatchList = getUserWatchListItems(state, userWatchList);
    return cachedUserWatchList;
  }
};

var getUserWatchListItems = function getUserWatchListItems(state, userWatchList) {
  var searchEntities = (0, _entities.searchesDeep)(state);
  if (!searchEntities.runs) {
    return [];
  }

  var taskAndRunEntities = userWatchList.results.filter(function (entity) {
    return (entity.schema === 'tasks' || entity.schema === 'runs') && searchEntities['runs'][entity.id];
  });
  var list = taskAndRunEntities.reduce(function (watchList, _ref) {
    var id = _ref.id,
        type = _ref.schema;

    var entity = searchEntities[type][id];
    if (entity.runID && searchEntities.runs[entity.runID]) {
      var run = searchEntities.runs[entity.runID];
      var process = searchEntities.processes[entity.runID];
      addRunToWatchlist(watchList, run, process && process.displayName || run.processDisplayName);
    }
    return watchList;
  }, {});

  return (0, _sortBy2.default)(list, [function (o) {
    return o.processDisplayName;
  }]);

  function addRunToWatchlist(watchList, run, processDisplayName) {
    if (!watchList[run.processID]) {
      watchList[run.processID] = {
        processID: run.processID,
        processDisplayName: processDisplayName,
        runs: {}
      };
    }
    watchList[run.processID].runs[run.runID] = {
      displayName: run.displayName,
      percentComplete: run.percentComplete,
      runID: run.runID
    };
  }
};

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterExcludeContent = exports.filterByContent = exports.filterExcludeProperty = exports.filterByProperty = exports.filterExcludeTypeOf = exports.filterByTypeOf = exports.filterExcludeAbout = exports.filterByAbout = exports.filterExcludeResource = exports.filterByResource = exports.filterByAny = exports.filterByObject = exports.filterByPredicate = exports.filterBySubject = exports.filterExcludeType = exports.filterExclude = exports.filterByType = exports.ReverseRelationship = exports.Relationship = exports.Content = exports.Property = exports.TypeOf = exports.About = exports.ResourcePredicate = exports.Resource = exports.StaticPredicate = exports.Subject = exports.Predicate = exports.Term = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp3, _class3, _temp5, _class4, _temp6, _class5, _temp7, _class6, _temp8, _class7, _temp9, _class8, _temp10, _class9, _temp11, _class10, _temp12;

var _changeCase = __webpack_require__(256);

var _isEqual = __webpack_require__(707);

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REACT_ATTRIBUTES = {
  typeof: 'typeof'
};

var toReactProp = function toReactProp(name) {
  return (0, _changeCase.camelCase)(REACT_ATTRIBUTES[name] || name);
};
var _toSelector = function _toSelector(p, o) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return '[' + p + (options.loose ? '*' : '') + '="' + o.join(' ') + '"]';
};
var all = function all(v) {
  return true;
}; // eslint-disable-line no-unused-vars

var Term = exports.Term = (_temp = _class = function () {
  function Term() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Term);

    var _options$name = options.name,
        name = _options$name === undefined ? this.constructor.defaultName : _options$name,
        _options$namespace = options.namespace,
        namespace = _options$namespace === undefined ? this.constructor.defaultNamespace : _options$namespace;

    this.name = name;
    this.namespace = namespace;
    this.equal = this.equal.bind(this);
    this.notEqual = this.notEqual.bind(this);
    this.equalType = this.equalType.bind(this);
    this.notEqualType = this.notEqualType.bind(this);
  }

  _createClass(Term, [{
    key: 'getName',
    value: function getName() {
      return this.namespace ? this.namespace + ':' + this.name : this.name;
    }
  }, {
    key: 'toString',
    value: function toString() {
      return this.getName();
    }
  }, {
    key: 'clone',
    value: function clone() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var options = _extends({
        name: this.name,
        namespace: this.namespace
      }, args.pop() || {});
      return new (Function.prototype.bind.apply(this.constructor, [null].concat([].concat(args, [options]))))();
    }
  }, {
    key: 'equalType',
    value: function equalType(v) {
      return v instanceof this.constructor;
    }
  }, {
    key: 'notEqualType',
    value: function notEqualType(v) {
      return !this.equalType(v);
    }
  }, {
    key: 'equal',
    value: function equal(v) {
      return this.equalType(v) && (0, _isEqual2.default)(v.toString(), this.toString());
    }
  }, {
    key: 'notEqual',
    value: function notEqual(v) {
      return !this.equal(v);
    }
  }, {
    key: 'filter',
    value: function filter(options) {
      return this.constructor.filter(options);
    }
  }], [{
    key: 'filter',
    value: function filter() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$o = options.o,
          o = _options$o === undefined ? all : _options$o;

      return o;
    }
  }]);

  return Term;
}(), _class.defaultNamespace = false, _class.defaultName = 'term', _temp);
var Predicate = exports.Predicate = (_temp3 = _class2 = function (_Term) {
  _inherits(Predicate, _Term);

  function Predicate() {
    var _ref;

    var _temp2, _this, _ret;

    _classCallCheck(this, Predicate);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp2 = (_this = _possibleConstructorReturn(this, (_ref = Predicate.__proto__ || Object.getPrototypeOf(Predicate)).call.apply(_ref, [this].concat(args))), _this), _this.objects = [], _temp2), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Predicate, [{
    key: 'is',
    value: function is() {
      for (var _len3 = arguments.length, objects = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        objects[_key3] = arguments[_key3];
      }

      this.objects = Array.from(new Set([].concat(_toConsumableArray(this.objects), objects)));
      return this;
    }
  }, {
    key: 'toDouble',
    value: function toDouble() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : all;

      return [this.getName(), this.objects.slice().filter(filter).map(function (v) {
        return v.toString();
      })];
    }
  }, {
    key: 'toSelector',
    value: function toSelector(filter) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var fn = filter;
      var opt = options;

      if ((typeof fn === 'undefined' ? 'undefined' : _typeof(fn)) === 'object') {
        opt = fn;
        fn = undefined;
      }

      var _opt = opt,
          _opt$loose = _opt.loose,
          loose = _opt$loose === undefined ? false : _opt$loose; // eslint-disable-line no-unused-vars

      var _toDouble = this.toDouble(fn),
          _toDouble2 = _slicedToArray(_toDouble, 2),
          p = _toDouble2[0],
          o = _toDouble2[1];

      return _toSelector(p, o, options);
    }
  }, {
    key: 'toProps',
    value: function toProps(filter) {
      var _toDouble3 = this.toDouble(filter),
          _toDouble4 = _slicedToArray(_toDouble3, 2),
          p = _toDouble4[0],
          o = _toDouble4[1];

      return _defineProperty({}, toReactProp(p), o.join(' '));
    }
  }, {
    key: 'clone',
    value: function clone() {
      var _get2;

      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      var clone = (_get2 = _get(Predicate.prototype.__proto__ || Object.getPrototypeOf(Predicate.prototype), 'clone', this)).call.apply(_get2, [this].concat(args));
      clone.objects = this.objects.slice();
      return clone;
    }
  }, {
    key: 'equal',
    value: function equal(v) {
      return _get(Predicate.prototype.__proto__ || Object.getPrototypeOf(Predicate.prototype), 'equal', this).call(this, v) && (0, _isEqual2.default)(this.toDouble(), v.toDouble());
    }
  }]);

  return Predicate;
}(Term), _class2.defaultName = 'predicate', _temp3);
var Subject = exports.Subject = (_temp5 = _class3 = function (_Term2) {
  _inherits(Subject, _Term2);

  function Subject() {
    var _ref3;

    var _temp4, _this2, _ret2;

    _classCallCheck(this, Subject);

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _ret2 = (_temp4 = (_this2 = _possibleConstructorReturn(this, (_ref3 = Subject.__proto__ || Object.getPrototypeOf(Subject)).call.apply(_ref3, [this].concat(args))), _this2), _this2.predicates = {}, _temp4), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(Subject, [{
    key: 'has',
    value: function has() {
      for (var _len6 = arguments.length, predicates = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        predicates[_key6] = arguments[_key6];
      }

      var notPredicate = predicates.find(function (p) {
        return !(p instanceof Predicate);
      });

      if (notPredicate) {
        throw new TypeError('Only predicate instances are allowed, not ' + notPredicate);
      }

      this.predicates = predicates.reduce(function (predicates, p) {
        var name = p.getName();
        var predicate = predicates[p.getName()];

        if (!predicate) return _extends({}, predicates, _defineProperty({}, name, p));

        predicate.is.apply(predicate, _toConsumableArray(p.objects));

        return predicates;
      }, this.predicates);

      return this;
    }
  }, {
    key: 'toTriple',
    value: function toTriple() {
      var _this3 = this;

      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : all;

      var s = this.getName();
      var predicates = Object.keys(this.predicates).reduce(function (results, k) {
        var predicate = _this3.predicates[k];
        var objects = predicate.objects.slice();
        var p = predicate.getName();
        var o = objects.filter(function (o) {
          return filter(_this3, predicate, o);
        }).map(function (o) {
          return o.toString();
        });

        if (!o.length) return results;

        results[p] = o;
        return results;
      }, {});

      return Object.keys(predicates).map(function (p) {
        return [s, p, predicates[p]];
      });
    }
  }, {
    key: 'toSelector',
    value: function toSelector(filter) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var fn = filter;
      var opt = options;

      if ((typeof fn === 'undefined' ? 'undefined' : _typeof(fn)) === 'object') {
        opt = fn;
        fn = undefined;
      }

      var _opt2 = opt,
          _opt2$loose = _opt2.loose,
          loose = _opt2$loose === undefined ? false : _opt2$loose; // eslint-disable-line no-unused-vars

      return this.toTriple(fn)
      // eslint-disable-next-line no-unused-vars
      .map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 3),
            s = _ref5[0],
            p = _ref5[1],
            o = _ref5[2];

        return _toSelector(p, o, opt);
      }).join('');
    }
  }, {
    key: 'toProps',
    value: function toProps(filter) {
      return this.toTriple(filter).reduce(
      // eslint-disable-next-line no-unused-vars
      function (props, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 3),
            s = _ref7[0],
            p = _ref7[1],
            o = _ref7[2];

        return _extends({}, props, _defineProperty({}, toReactProp(p), o.join(' ')));
      }, {});
    }
  }, {
    key: 'clone',
    value: function clone() {
      var _get3,
          _this4 = this;

      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      var clone = (_get3 = _get(Subject.prototype.__proto__ || Object.getPrototypeOf(Subject.prototype), 'clone', this)).call.apply(_get3, [this].concat(args));
      clone.predicates = Object.keys(this.predicates).reduce(function (o, k) {
        return _extends({}, o, _defineProperty({}, k, _this4.predicates[k]));
      }, {});
      return clone;
    }
  }, {
    key: 'equal',
    value: function equal(s) {
      return _get(Subject.prototype.__proto__ || Object.getPrototypeOf(Subject.prototype), 'equal', this).call(this, s) && (0, _isEqual2.default)(this.toTriple(), s.toTriple());
    }
  }], [{
    key: 'filter',
    value: function filter() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$s = options.s,
          s = _options$s === undefined ? all : _options$s,
          _options$p = options.p,
          p = _options$p === undefined ? all : _options$p,
          _options$o2 = options.o,
          o = _options$o2 === undefined ? all : _options$o2;

      return s === all && p === all && o === all ? all : function (subject, predicate, object) {
        return s(subject) && p(predicate) && o(object);
      };
    }
  }]);

  return Subject;
}(Term), _class3.defaultName = 'subject', _temp5);

var StaticPredicate = exports.StaticPredicate = function (_Predicate) {
  _inherits(StaticPredicate, _Predicate);

  function StaticPredicate() {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var name = _ref8.name,
        namespace = _ref8.namespace,
        options = _objectWithoutProperties(_ref8, ['name', 'namespace']);

    _classCallCheck(this, StaticPredicate);

    return _possibleConstructorReturn(this, (StaticPredicate.__proto__ || Object.getPrototypeOf(StaticPredicate)).call(this, options));
  }

  return StaticPredicate;
}(Predicate);

var Resource = (_temp6 = _class4 = function (_Subject) {
  _inherits(Resource, _Subject);

  function Resource(name, options) {
    _classCallCheck(this, Resource);

    var nameType = typeof name === 'undefined' ? 'undefined' : _typeof(name);
    if (nameType !== 'string') {
      throw new TypeError('expected a string, but received ' + nameType);
    }

    var _this6 = _possibleConstructorReturn(this, (Resource.__proto__ || Object.getPrototypeOf(Resource)).call(this, _extends({}, options, { name: name })));

    _this6.hasType(About, _this6);
    return _this6;
  }

  _createClass(Resource, [{
    key: 'hasType',
    value: function hasType(P) {
      var predicate = new P();
      if (!(predicate instanceof Predicate)) {
        throw new TypeError('expected a Predicate, but received ' + (typeof P === 'undefined' ? 'undefined' : _typeof(P)));
      }

      for (var _len8 = arguments.length, values = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        values[_key8 - 1] = arguments[_key8];
      }

      return this.has(predicate.is.apply(predicate, _toConsumableArray(values.filter(function (v) {
        return v !== undefined;
      }))));
    }
  }, {
    key: 'getName',
    value: function getName() {
      return this.name;
    }
  }, {
    key: 'property',
    value: function property() {
      for (var _len9 = arguments.length, properties = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        properties[_key9] = arguments[_key9];
      }

      return this.hasType.apply(this, [Property].concat(properties));
    }
  }, {
    key: 'content',
    value: function content() {
      for (var _len10 = arguments.length, _content = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        _content[_key10] = arguments[_key10];
      }

      return this.hasType.apply(this, [Content].concat(_content));
    }
  }, {
    key: 'typeOf',
    value: function typeOf() {
      for (var _len11 = arguments.length, types = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        types[_key11] = arguments[_key11];
      }

      return this.hasType.apply(this, [TypeOf].concat(types));
    }
  }, {
    key: 'child',
    value: function child() {
      for (var _len12 = arguments.length, resources = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        resources[_key12] = arguments[_key12];
      }

      return this.hasType.apply(this, [Relationship].concat(_toConsumableArray(resources.map(function (r) {
        return r instanceof Resource ? r : new Resource(r);
      }))));
    }
  }, {
    key: 'parent',
    value: function parent() {
      for (var _len13 = arguments.length, resources = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        resources[_key13] = arguments[_key13];
      }

      return this.hasType.apply(this, [ReverseRelationship].concat(_toConsumableArray(resources.map(function (r) {
        return r instanceof Resource ? r : new Resource(r);
      }))));
    }
  }, {
    key: 'clone',
    value: function clone(name, options) {
      return _get(Resource.prototype.__proto__ || Object.getPrototypeOf(Resource.prototype), 'clone', this).call(this, name || this.name, options);
    }
  }]);

  return Resource;
}(Subject), _class4.defaultName = 'resource', _temp6);
exports.Resource = Resource;

var ResourcePredicate = exports.ResourcePredicate = function (_StaticPredicate) {
  _inherits(ResourcePredicate, _StaticPredicate);

  function ResourcePredicate() {
    _classCallCheck(this, ResourcePredicate);

    return _possibleConstructorReturn(this, (ResourcePredicate.__proto__ || Object.getPrototypeOf(ResourcePredicate)).apply(this, arguments));
  }

  _createClass(ResourcePredicate, [{
    key: 'is',
    value: function is() {
      var _get4;

      for (var _len14 = arguments.length, objects = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        objects[_key14] = arguments[_key14];
      }

      var notResource = objects.find(function (o) {
        return !(o instanceof Resource);
      });

      if (notResource) {
        throw new TypeError('Only Resource instances are allowed, not ' + notResource);
      }

      return (_get4 = _get(ResourcePredicate.prototype.__proto__ || Object.getPrototypeOf(ResourcePredicate.prototype), 'is', this)).call.apply(_get4, [this].concat(objects));
    }
  }]);

  return ResourcePredicate;
}(StaticPredicate);

var About = exports.About = (_temp7 = _class5 = function (_ResourcePredicate) {
  _inherits(About, _ResourcePredicate);

  function About() {
    _classCallCheck(this, About);

    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
  }

  return About;
}(ResourcePredicate), _class5.defaultName = 'about', _temp7);
var TypeOf = exports.TypeOf = (_temp8 = _class6 = function (_StaticPredicate2) {
  _inherits(TypeOf, _StaticPredicate2);

  function TypeOf() {
    _classCallCheck(this, TypeOf);

    return _possibleConstructorReturn(this, (TypeOf.__proto__ || Object.getPrototypeOf(TypeOf)).apply(this, arguments));
  }

  return TypeOf;
}(StaticPredicate), _class6.defaultName = 'typeof', _temp8);
var Property = exports.Property = (_temp9 = _class7 = function (_StaticPredicate3) {
  _inherits(Property, _StaticPredicate3);

  function Property() {
    _classCallCheck(this, Property);

    return _possibleConstructorReturn(this, (Property.__proto__ || Object.getPrototypeOf(Property)).apply(this, arguments));
  }

  return Property;
}(StaticPredicate), _class7.defaultName = 'property', _temp9);
var Content = exports.Content = (_temp10 = _class8 = function (_StaticPredicate4) {
  _inherits(Content, _StaticPredicate4);

  function Content() {
    _classCallCheck(this, Content);

    return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
  }

  return Content;
}(StaticPredicate), _class8.defaultName = 'content', _temp10);
var Relationship = exports.Relationship = (_temp11 = _class9 = function (_ResourcePredicate2) {
  _inherits(Relationship, _ResourcePredicate2);

  function Relationship() {
    _classCallCheck(this, Relationship);

    return _possibleConstructorReturn(this, (Relationship.__proto__ || Object.getPrototypeOf(Relationship)).apply(this, arguments));
  }

  return Relationship;
}(ResourcePredicate), _class9.defaultName = 'rel', _temp11);
var ReverseRelationship = exports.ReverseRelationship = (_temp12 = _class10 = function (_ResourcePredicate3) {
  _inherits(ReverseRelationship, _ResourcePredicate3);

  function ReverseRelationship() {
    _classCallCheck(this, ReverseRelationship);

    return _possibleConstructorReturn(this, (ReverseRelationship.__proto__ || Object.getPrototypeOf(ReverseRelationship)).apply(this, arguments));
  }

  return ReverseRelationship;
}(ResourcePredicate), _class10.defaultName = 'rev', _temp12);
var filterByType = exports.filterByType = function filterByType(type) {
  return function (v) {
    return v instanceof type;
  };
};
var filterExclude = exports.filterExclude = function filterExclude(filter) {
  return function (v) {
    return !filter(v);
  };
};
var filterExcludeType = exports.filterExcludeType = function filterExcludeType(type) {
  return filterExclude(filterExcludeType(type));
};
var filterBySubject = exports.filterBySubject = function filterBySubject(filter) {
  return function (s, p, o) {
    return filter(s);
  };
}; // eslint-disable-line no-unused-vars
var filterByPredicate = exports.filterByPredicate = function filterByPredicate(filter) {
  return function (s, p, o) {
    return filter(p);
  };
}; // eslint-disable-line no-unused-vars
var filterByObject = exports.filterByObject = function filterByObject(filter) {
  return function (s, p, o) {
    return filter(o);
  };
};
var filterByAny = exports.filterByAny = function filterByAny() {
  for (var _len15 = arguments.length, filters = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    filters[_key15] = arguments[_key15];
  }

  return function (s, p, o) {
    return !!filters.find(function (filter) {
      return filter(s, p, o);
    });
  };
};

var filterByResource = exports.filterByResource = filterBySubject(filterByType(Resource));
var filterExcludeResource = exports.filterExcludeResource = filterBySubject(filterExclude(filterByType(Resource)));

var filterByAbout = exports.filterByAbout = filterByPredicate(filterByType(About));
var filterExcludeAbout = exports.filterExcludeAbout = filterByPredicate(filterExclude(filterByType(About)));

var filterByTypeOf = exports.filterByTypeOf = filterByPredicate(filterByType(TypeOf));
var filterExcludeTypeOf = exports.filterExcludeTypeOf = filterByPredicate(filterExclude(filterByType(TypeOf)));

var filterByProperty = exports.filterByProperty = filterByPredicate(filterByType(Property));
var filterExcludeProperty = exports.filterExcludeProperty = filterByPredicate(filterExclude(filterByType(Property)));

var filterByContent = exports.filterByContent = filterByPredicate(filterByType(Content));
var filterExcludeContent = exports.filterExcludeContent = filterByPredicate(filterExclude(filterByType(Content)));

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _performanceContainer = __webpack_require__(1907);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_performanceContainer).default;
  }
});
Object.defineProperty(exports, 'performanceContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_performanceContainer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _feature = __webpack_require__(189);

var _feature2 = _interopRequireDefault(_feature);

var _performance = __webpack_require__(417);

var _react3 = __webpack_require__(849);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    performanceMark: _performance.performanceMark, // eslint-disable-line no-use-before-define
    performanceMeasure: _performance.performanceMeasure, // eslint-disable-line no-use-before-define
    performanceClearMarks: _performance.performanceClearMarks, // eslint-disable-line no-use-before-define
    performanceClearMeasures: _performance.performanceClearMeasures // eslint-disable-line no-use-before-define
  };
  return function () {
    var _class, _temp;

    var performanceMark = options.performanceMark,
        performanceMeasure = options.performanceMeasure,
        performanceClearMarks = options.performanceClearMarks,
        performanceClearMeasures = options.performanceClearMeasures;

    var displayName = (0, _react3.getDisplayName)(WrappedComponent);
    var marks = [];
    var measures = [];
    var count = 0;

    return _temp = _class = function (_PureComponent) {
      _inherits(PerformanceContainer, _PureComponent);

      function PerformanceContainer() {
        _classCallCheck(this, PerformanceContainer);

        return _possibleConstructorReturn(this, (PerformanceContainer.__proto__ || Object.getPrototypeOf(PerformanceContainer)).apply(this, arguments));
      }

      _createClass(PerformanceContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          if (this.props.frontEndPerformanceMonitoringEnabled) {
            performanceMark('Mount-start');
            marks.push('Mount-start');
          }
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _props = this.props,
              frontEndPerformanceMonitoringEnabled = _props.frontEndPerformanceMonitoringEnabled,
              _props$location = _props.location;
          _props$location = _props$location === undefined ? {} : _props$location;
          var pathname = _props$location.pathname;


          if (frontEndPerformanceMonitoringEnabled) {
            performanceMark('Mount-end');
            marks.push('Mount-end');
            performanceMeasure('action=Mount&component=' + displayName + '&pathname=' + pathname, 'Mount-start', 'Mount-end');
            measures.push('action=Mount&component=' + displayName + '&pathname=' + pathname);
          }
        }
      }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate() {
          if (this.props.frontEndPerformanceMonitoringEnabled) {
            count++;
            performanceMark('Update-start-' + count);
            marks.push('Update-start-' + count);
          }
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          var _props2 = this.props,
              frontEndPerformanceMonitoringEnabled = _props2.frontEndPerformanceMonitoringEnabled,
              _props2$location = _props2.location;
          _props2$location = _props2$location === undefined ? {} : _props2$location;
          var pathname = _props2$location.pathname;


          if (frontEndPerformanceMonitoringEnabled) {
            performanceMark('Update-end-' + count);
            marks.push('Update-end-' + count);
            performanceMeasure('action=Update&component=' + displayName + '&pathname=' + pathname + '&id=' + count, 'Update-start-' + count, 'Update-end-' + count);
            measures.push('action=Update&component=' + displayName + '&pathname=' + pathname + '&id=' + count);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.props.frontEndPerformanceMonitoringEnabled) {
            marks.forEach(function (mark) {
              return performanceClearMarks(mark);
            });
            measures.forEach(function (measure) {
              return performanceClearMeasures(measure);
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, this.props);
        }
      }]);

      return PerformanceContainer;
    }(_react.PureComponent), _class.displayName = 'PerformanceContainer(' + displayName + ')', _class.propTypes = {
      frontEndPerformanceMonitoringEnabled: _feature2.default,
      location: _propTypes2.default.shape({
        pathname: _propTypes2.default.string
      })
    }, _temp;
  }();
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.ab01c84a4291907f41a4.js